"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3079],{

/***/ 92043:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ accommodation_entity; }
});

;// CONCATENATED MODULE: ./src/entities/accommodation/graphql.ts
// language=GraphQL
var ALL_ACCOMMODATIONS_QUERY = "query Query($withRoomTypes: Boolean = false, $withRoomTypesGallery: Boolean = false, $withRoomTypesGalleryImages: Boolean = false, $withAvailableAddons: Boolean = false, $withAvailableAddonsIcon: Boolean = false, $withGallery: Boolean = false, $withGalleryImages: Boolean = false) {\n  accommodations: accommodations {\n    id\n    label\n    name\n    stars\n    description\n    roomTypes @include(if: $withRoomTypes) {\n      id\n      name\n      description\n      gallery @include(if: $withRoomTypesGallery) {\n        id\n        images @include(if: $withRoomTypesGalleryImages) {\n          id\n          assetId\n          publicId\n          url\n          resourceType\n          format\n          width\n          height\n          caption\n          title\n          description\n        }\n      }\n    }\n    availableAddons @include(if: $withAvailableAddons) {\n      id\n      name\n      description\n      icon @include(if: $withAvailableAddonsIcon) {\n        id\n        assetId\n        publicId\n        url\n        resourceType\n        format\n        width\n        height\n        caption\n        title\n        description\n      }\n    }\n    gallery @include(if: $withGallery) {\n      id\n      images @include(if: $withGalleryImages) {\n        id\n        assetId\n        publicId\n        url\n        resourceType\n        format\n        width\n        height\n        caption\n        title\n        description\n      }\n    }\n  }\n}";
// language=GraphQL
var SINGLE_ACCOMMODATION_QUERY = "query Query($id: ID!, $withRoomTypes: Boolean = false, $withRoomTypesGallery: Boolean = false, $withRoomTypesGalleryImages: Boolean = false, $withAvailableAddons: Boolean = false, $withAvailableAddonsIcon: Boolean = false, $withGallery: Boolean = false, $withGalleryImages: Boolean = false) {\n  accommodation: accommodation(id: $id) {\n    id\n    label\n    name\n    stars\n    description\n    roomTypes @include(if: $withRoomTypes) {\n      id\n      name\n      description\n      gallery @include(if: $withRoomTypesGallery) {\n        id\n        images @include(if: $withRoomTypesGalleryImages) {\n          id\n          assetId\n          publicId\n          url\n          resourceType\n          format\n          width\n          height\n          caption\n          title\n          description\n        }\n      }\n    }\n    availableAddons @include(if: $withAvailableAddons) {\n      id\n      name\n      description\n      icon @include(if: $withAvailableAddonsIcon) {\n        id\n        assetId\n        publicId\n        url\n        resourceType\n        format\n        width\n        height\n        caption\n        title\n        description\n      }\n    }\n    gallery @include(if: $withGallery) {\n      id\n      images @include(if: $withGalleryImages) {\n        id\n        assetId\n        publicId\n        url\n        resourceType\n        format\n        width\n        height\n        caption\n        title\n        description\n      }\n    }\n  }\n}";
// language=GraphQL
var CREATE_ACCOMMODATION_MUTATION = "\n  mutation Mutation($input: CreateAccommodationInput, $withRoomTypes: Boolean = false, $withRoomTypesGallery: Boolean = false, $withRoomTypesGalleryImages: Boolean = false, $withAvailableAddons: Boolean = false, $withAvailableAddonsIcon: Boolean = false, $withGallery: Boolean = false, $withGalleryImages: Boolean = false) {\n    accommodation: createAccommodation(input: $input) {\n      id\n      label\n      name\n      stars\n      description\n      roomTypes @include(if: $withRoomTypes) {\n        id\n        name\n        description\n        gallery @include(if: $withRoomTypesGallery) {\n          id\n          images @include(if: $withRoomTypesGalleryImages) {\n            id\n            assetId\n            publicId\n            url\n            resourceType\n            format\n            width\n            height\n            caption\n            title\n            description\n          }\n        }\n      }\n      availableAddons @include(if: $withAvailableAddons) {\n        id\n        name\n        description\n        icon @include(if: $withAvailableAddonsIcon) {\n          id\n          assetId\n          publicId\n          url\n          resourceType\n          format\n          width\n          height\n          caption\n          title\n          description\n        }\n      }\n      gallery @include(if: $withGallery) {\n        id\n        images @include(if: $withGalleryImages) {\n          id\n          assetId\n          publicId\n          url\n          resourceType\n          format\n          width\n          height\n          caption\n          title\n          description\n        }\n      }\n    }\n  }";
// language=GraphQL
var UPDATE_ACCOMMODATION_MUTATION = "\n  mutation Mutation($input: UpdateAccommodationInput, $withRoomTypes: Boolean = false, $withRoomTypesGallery: Boolean = false, $withRoomTypesGalleryImages: Boolean = false, $withAvailableAddons: Boolean = false, $withAvailableAddonsIcon: Boolean = false, $withGallery: Boolean = false, $withGalleryImages: Boolean = false) {\n    accommodation: updateAccommodation(input: $input) {\n      id\n      label\n      name\n      stars\n      description\n      roomTypes @include(if: $withRoomTypes) {\n        id\n        name\n        description\n        gallery @include(if: $withRoomTypesGallery) {\n          id\n          images @include(if: $withRoomTypesGalleryImages) {\n            id\n            assetId\n            publicId\n            url\n            resourceType\n            format\n            width\n            height\n            caption\n            title\n            description\n          }\n        }\n      }\n      availableAddons @include(if: $withAvailableAddons) {\n        id\n        name\n        description\n        icon @include(if: $withAvailableAddonsIcon) {\n          id\n          assetId\n          publicId\n          url\n          resourceType\n          format\n          width\n          height\n          caption\n          title\n          description\n        }\n      }\n      gallery @include(if: $withGallery) {\n        id\n        images @include(if: $withGalleryImages) {\n          id\n          assetId\n          publicId\n          url\n          resourceType\n          format\n          width\n          height\n          caption\n          title\n          description\n        }\n      }\n    }\n  }";
// language=GraphQL
var DELETE_ACCOMMODATION_MUTATION = "\n  mutation Mutation($input: DeleteAccommodationInput) {\n    deleteAccommodation(input: $input) {\n      success\n    }\n  }";
// language=GraphQL
var FORCE_DELETE_ACCOMMODATION_MUTATION = "\n  mutation Mutation($input: DeleteAccommodationInput) {\n    forceDeleteAccommodation(input: $input) {\n      success\n    }\n  }";
// language=GraphQL
var ADD_ACCOMMODATION_ROOM_TYPES_MUTATION = "\n  mutation Mutation($input: addAccommodationRoomTypesInput) {\n    addAccommodationRoomTypes(input: $input) {\n      id\n      roomTypeIds\n    }\n  }";
// language=GraphQL
var REMOVE_ACCOMMODATION_ROOM_TYPES_MUTATION = "\n  mutation Mutation($input: removeAccommodationRoomTypesInput) {\n    removeAccommodationRoomTypes(input: $input) {\n      id\n      roomTypeIds\n    }\n  }";
// language=GraphQL
var CREATE_ACCOMMODATION_ROOM_TYPES_MUTATION = "\n  mutation Mutation($input: createAccommodationRoomTypesInput) {\n    createAccommodationRoomTypes(input: $input) {\n      id\n      roomTypeIds\n    }\n  }";
// language=GraphQL
var DELETE_ACCOMMODATION_ROOM_TYPES_MUTATION = "\n  mutation Mutation($input: deleteAccommodationRoomTypesInput) {\n    deleteAccommodationRoomTypes(input: $input) {\n      id\n      roomTypeIds\n    }\n  }";
// language=GraphQL
var UPDATE_ACCOMMODATION_ROOM_TYPES_ORDER_MUTATION = "\n  mutation Mutation($input: updateAccommodationRoomTypesOrderInput) {\n    updateAccommodationRoomTypesOrder(input: $input) {\n      id\n      roomTypeIds\n    }\n  }";
// language=GraphQL
var ADD_ACCOMMODATION_AVAILABLE_ADDONS_MUTATION = "\n  mutation Mutation($input: addAccommodationAvailableAddonsInput) {\n    addAccommodationAvailableAddons(input: $input) {\n      id\n      availableAddonIds\n    }\n  }";
// language=GraphQL
var REMOVE_ACCOMMODATION_AVAILABLE_ADDONS_MUTATION = "\n  mutation Mutation($input: removeAccommodationAvailableAddonsInput) {\n    removeAccommodationAvailableAddons(input: $input) {\n      id\n      availableAddonIds\n    }\n  }";
// language=GraphQL
var CREATE_ACCOMMODATION_AVAILABLE_ADDONS_MUTATION = "\n  mutation Mutation($input: createAccommodationAvailableAddonsInput) {\n    createAccommodationAvailableAddons(input: $input) {\n      id\n      availableAddonIds\n    }\n  }";
// language=GraphQL
var DELETE_ACCOMMODATION_AVAILABLE_ADDONS_MUTATION = "\n  mutation Mutation($input: deleteAccommodationAvailableAddonsInput) {\n    deleteAccommodationAvailableAddons(input: $input) {\n      id\n      availableAddonIds\n    }\n  }";
// language=GraphQL
var UPDATE_ACCOMMODATION_AVAILABLE_ADDONS_ORDER_MUTATION = "\n  mutation Mutation($input: updateAccommodationAvailableAddonsOrderInput) {\n    updateAccommodationAvailableAddonsOrder(input: $input) {\n      id\n      availableAddonIds\n    }\n  }";
// language=GraphQL
var ACCOMMODATIONS_DEPENDENTS_QUERY = "query Query($id: ID!, $withTravelAccommodationAssignments: Boolean = false, $withTravels: Boolean = false) {\n  groupedDependents: accommodationDependents(id: $id) {\n    travelAccommodationAssignments @include(if: $withTravelAccommodationAssignments) {\n      id\n      useCustomRoomTypeSelection    }\n    travels @include(if: $withTravels) {\n      id\n      name\n      isBestseller\n      startDate\n      endDate\n      executionStatus\n      title\n      description\n      includedServices\n      excludedServices\n      pricingTable\n      priceCalculationInfo\n      programType\n      programText\n      minPrice\n      minPriceManualOverride\n      currency    }\n  }\n}";

// EXTERNAL MODULE: ./src/entities/accommodationRoomType/entity.ts + 3 modules
var entity = __webpack_require__(94529);
// EXTERNAL MODULE: ./src/entities/accommodationAvailableAddon/entity.ts + 3 modules
var accommodationAvailableAddon_entity = __webpack_require__(97806);
// EXTERNAL MODULE: ./src/entities/imageGallery/entity.ts + 3 modules
var imageGallery_entity = __webpack_require__(41);
;// CONCATENATED MODULE: ./src/entities/accommodation/model.ts




var accommodationModel = {
    name: "accommodation",
    namePlural: "accommodations",
    uniqueName: "accommodation",
    uniqueNamePlural: "accommodations",
    path: "travel/accommodation/accommodation",
    baseUrl: "/travel/accommodations",
    translationPrefix: "entities:accommodation.",
    getDisplayName: function(values) {
        return values.label;
    },
    gql: {
        getAll: ALL_ACCOMMODATIONS_QUERY,
        getSingle: SINGLE_ACCOMMODATION_QUERY,
        create: CREATE_ACCOMMODATION_MUTATION,
        update: UPDATE_ACCOMMODATION_MUTATION,
        delete: DELETE_ACCOMMODATION_MUTATION,
        forceDelete: FORCE_DELETE_ACCOMMODATION_MUTATION
    },
    attributes: {
        label: {
            name: "label",
            label: "entities:accommodation.attributes.label.label",
            type: "value",
            dataType: "string",
            defaultInput: true,
            inputType: "text",
            validationType: "string",
            validations: [
                {
                    type: "required"
                }, 
            ]
        },
        name: {
            name: "name",
            label: "entities:accommodation.attributes.name.label",
            type: "value",
            dataType: "string",
            defaultInput: true,
            inputType: "text",
            validationType: "string",
            validations: [
                {
                    type: "required"
                }, 
            ]
        },
        stars: {
            name: "stars",
            label: "entities:accommodation.attributes.stars.label",
            type: "value",
            dataType: "string",
            defaultInput: true,
            inputType: "select",
            selectOptions: [
                {
                    label: "entities:accommodation.attributes.stars.selectOptions.0.label",
                    value: "0"
                },
                {
                    label: "entities:accommodation.attributes.stars.selectOptions.1.label",
                    value: "1"
                },
                {
                    label: "entities:accommodation.attributes.stars.selectOptions.2.label",
                    value: "2"
                },
                {
                    label: "entities:accommodation.attributes.stars.selectOptions.3.label",
                    value: "3"
                },
                {
                    label: "entities:accommodation.attributes.stars.selectOptions.4.label",
                    value: "4"
                },
                {
                    label: "entities:accommodation.attributes.stars.selectOptions.5.label",
                    value: "5"
                }, 
            ],
            validationType: "string",
            validations: []
        },
        description: {
            name: "description",
            label: "entities:accommodation.attributes.description.label",
            type: "value",
            dataType: "string",
            defaultInput: true,
            inputType: "wysiwyg",
            validationType: "string",
            validations: [
                {
                    type: "required"
                }, 
            ]
        },
        roomTypes: {
            name: "roomTypes",
            label: "entities:accommodation.attributes.roomTypes.label",
            type: "entityCollection",
            dataType: "[any]",
            getEntity: function() {
                return entity/* default */.Z;
            },
            defaultInput: false,
            inputType: "text",
            validationType: "string",
            validations: []
        },
        availableAddons: {
            name: "availableAddons",
            label: "entities:accommodation.attributes.availableAddons.label",
            type: "entityCollection",
            dataType: "[any]",
            getEntity: function() {
                return accommodationAvailableAddon_entity/* default */.Z;
            },
            defaultInput: false,
            inputType: "text",
            validationType: "string",
            validations: []
        },
        gallery: {
            name: "gallery",
            label: "entities:accommodation.attributes.gallery.label",
            type: "entityObject",
            dataType: "any",
            getEntity: function() {
                return imageGallery_entity/* default */.Z;
            },
            defaultInput: false,
            inputType: "select",
            validationType: "string",
            validations: []
        }
    }
};
/* harmony default export */ var model = (accommodationModel);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(20414);
// EXTERNAL MODULE: ./src/entities/lib.ts
var lib = __webpack_require__(23480);
// EXTERNAL MODULE: ./src/lib/api/graphQLClient.ts
var graphQLClient = __webpack_require__(40112);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/swr/dist/index.mjs
var dist = __webpack_require__(8100);
// EXTERNAL MODULE: ./src/lib/helpers/helpers.ts
var helpers = __webpack_require__(15778);
;// CONCATENATED MODULE: ./src/entities/accommodation/repository.ts










var hydrateObjects = function(objects) {
    return objects.map(function(object) {
        return (0,lib/* hydrateEntityObject */.b)(model, object);
    });
};
var hydrateObject = function(object) {
    return (0,lib/* hydrateEntityObject */.b)(model, object);
};
var accommodationRepository = {
    getObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    id: id
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(SINGLE_ACCOMMODATION_QUERY, variables).then(function(data) {
                        return hydrateObject(data.accommodation);
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }(),
    getObjects: /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        var includes;
        var _arguments = arguments;
        return (0,tslib_es6.__generator)(this, function(_state) {
            includes = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : {};
            return [
                2,
                graphQLClient/* default.request */.Z.request(ALL_ACCOMMODATIONS_QUERY, includes).then(function(data) {
                    return hydrateObjects(data.accommodations);
                })
            ];
        });
    }),
    useObject: function(id) {
        var includes = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        // eslint-disable-next-line react-hooks/exhaustive-deps
        var variables = (0,react.useMemo)(function() {
            return (0,_object_spread/* default */.Z)({
                id: id
            }, includes);
        }, [
            id
        ]);
        var ref = (0,dist/* default */.ZP)([
            SINGLE_ACCOMMODATION_QUERY,
            variables
        ], {
            revalidateOnFocus: false
        }), data = ref.data, error = ref.error, mutate = ref.mutate;
        return {
            object: !data ? data : hydrateObject(data.accommodation),
            isLoading: !error && !data,
            isError: error,
            mutate: mutate
        };
    },
    useObjects: function() {
        var includes = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        // eslint-disable-next-line react-hooks/exhaustive-deps
        var variables = (0,react.useMemo)(function() {
            return includes;
        }, []);
        var ref = (0,dist/* default */.ZP)([
            ALL_ACCOMMODATIONS_QUERY,
            variables
        ]), data = ref.data, error = ref.error, mutate = ref.mutate;
        return {
            objects: !data ? data : hydrateObjects(data.accommodations),
            isLoading: !error && !data,
            isError: error,
            mutate: mutate
        };
    },
    getDependents: function(id, includes) {
        var includeVars = {};
        includes.forEach(function(include) {
            includeVars["with".concat((0,helpers/* uppercaseFirst */.AB)(include))] = true;
        });
        var variables = (0,_object_spread/* default */.Z)({
            id: id
        }, includeVars);
        return graphQLClient/* default.request */.Z.request(ACCOMMODATIONS_DEPENDENTS_QUERY, variables).then(function(data) {
            return data.groupedDependents;
        });
    },
    useDependents: function(id, includes) {
        var includeVars = {};
        includes.forEach(function(include) {
            includeVars["with".concat((0,helpers/* uppercaseFirst */.AB)(include))] = true;
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
        var variables = (0,react.useMemo)(function() {
            return (0,_object_spread/* default */.Z)({
                id: id
            }, includeVars);
        }, [
            id
        ]);
        var ref = (0,dist/* default */.ZP)([
            ACCOMMODATIONS_DEPENDENTS_QUERY,
            variables
        ], {
            revalidateOnFocus: false
        }), data = ref.data, error = ref.error, mutate = ref.mutate;
        return {
            data: !data ? data : data.groupedDependents,
            isLoading: !error && !data,
            isError: error,
            mutate: mutate
        };
    },
    createObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(data) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    input: data
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(CREATE_ACCOMMODATION_MUTATION, variables).then(function(data) {
                        return hydrateObject(data.accommodation);
                    })
                ];
            });
        });
        return function(data) {
            return _ref.apply(this, arguments);
        };
    }(),
    updateObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(data) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    input: data
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(UPDATE_ACCOMMODATION_MUTATION, variables).then(function(data) {
                        return hydrateObject(data.accommodation);
                    })
                ];
            });
        });
        return function(data) {
            return _ref.apply(this, arguments);
        };
    }(),
    deleteObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(DELETE_ACCOMMODATION_MUTATION, variables).then(function(data) {
                        return data.deleteAccommodation;
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }(),
    forceDeleteObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(FORCE_DELETE_ACCOMMODATION_MUTATION, variables).then(function(data) {
                        return data.forceDeleteAccommodation;
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }(),
    assignRoomTypes: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, itemIds) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        roomTypeIds: itemIds
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(ADD_ACCOMMODATION_ROOM_TYPES_MUTATION, variables)
                ];
            });
        });
        return function(id, itemIds) {
            return _ref.apply(this, arguments);
        };
    }(),
    unassignRoomTypes: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, itemIds) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        roomTypeIds: itemIds
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(REMOVE_ACCOMMODATION_ROOM_TYPES_MUTATION, variables)
                ];
            });
        });
        return function(id, itemIds) {
            return _ref.apply(this, arguments);
        };
    }(),
    createRoomTypes: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, items) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        roomTypes: items
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(CREATE_ACCOMMODATION_ROOM_TYPES_MUTATION, variables)
                ];
            });
        });
        return function(id, items) {
            return _ref.apply(this, arguments);
        };
    }(),
    deleteRoomTypes: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, itemIds) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        roomTypeIds: itemIds
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(DELETE_ACCOMMODATION_ROOM_TYPES_MUTATION, variables)
                ];
            });
        });
        return function(id, itemIds) {
            return _ref.apply(this, arguments);
        };
    }(),
    updateRoomTypesOrder: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, itemIds) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        roomTypeIds: itemIds
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(UPDATE_ACCOMMODATION_ROOM_TYPES_ORDER_MUTATION, variables)
                ];
            });
        });
        return function(id, itemIds) {
            return _ref.apply(this, arguments);
        };
    }(),
    assignAvailableAddons: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, itemIds) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        availableAddonIds: itemIds
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(ADD_ACCOMMODATION_AVAILABLE_ADDONS_MUTATION, variables)
                ];
            });
        });
        return function(id, itemIds) {
            return _ref.apply(this, arguments);
        };
    }(),
    unassignAvailableAddons: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, itemIds) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        availableAddonIds: itemIds
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(REMOVE_ACCOMMODATION_AVAILABLE_ADDONS_MUTATION, variables)
                ];
            });
        });
        return function(id, itemIds) {
            return _ref.apply(this, arguments);
        };
    }(),
    createAvailableAddons: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, items) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        availableAddons: items
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(CREATE_ACCOMMODATION_AVAILABLE_ADDONS_MUTATION, variables)
                ];
            });
        });
        return function(id, items) {
            return _ref.apply(this, arguments);
        };
    }(),
    deleteAvailableAddons: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, itemIds) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        availableAddonIds: itemIds
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(DELETE_ACCOMMODATION_AVAILABLE_ADDONS_MUTATION, variables)
                ];
            });
        });
        return function(id, itemIds) {
            return _ref.apply(this, arguments);
        };
    }(),
    updateAvailableAddonsOrder: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, itemIds) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        availableAddonIds: itemIds
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(UPDATE_ACCOMMODATION_AVAILABLE_ADDONS_ORDER_MUTATION, variables)
                ];
            });
        });
        return function(id, itemIds) {
            return _ref.apply(this, arguments);
        };
    }()
};
/* harmony default export */ var repository = (accommodationRepository);

;// CONCATENATED MODULE: ./src/entities/accommodation/entity.ts


var accommodationEntity = {
    model: model,
    repository: repository
};
/* harmony default export */ var accommodation_entity = (accommodationEntity);


/***/ }),

/***/ 76276:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ accommodationAgeGroupCapacity_entity; }
});

;// CONCATENATED MODULE: ./src/entities/accommodationAgeGroupCapacity/graphql.ts
// language=GraphQL
var ALL_AGE_GROUP_CAPACITIES_QUERY = "query Query($withAgeGroup: Boolean = false) {\n  ageGroupCapacities: accommodationAgeGroupCapacities {\n    id\n    ageGroup @include(if: $withAgeGroup) {\n      id\n      name\n      type\n      icon\n      minAge\n      maxAge\n    }\n    minCapacity\n    maxCapacity\n  }\n}";
// language=GraphQL
var SINGLE_AGE_GROUP_CAPACITY_QUERY = "query Query($id: ID!, $withAgeGroup: Boolean = false) {\n  ageGroupCapacity: accommodationAgeGroupCapacity(id: $id) {\n    id\n    ageGroup @include(if: $withAgeGroup) {\n      id\n      name\n      type\n      icon\n      minAge\n      maxAge\n    }\n    minCapacity\n    maxCapacity\n  }\n}";
// language=GraphQL
var CREATE_AGE_GROUP_CAPACITY_MUTATION = "\n  mutation Mutation($input: CreateAccommodationAgeGroupCapacityInput, $withAgeGroup: Boolean = false) {\n    ageGroupCapacity: createAccommodationAgeGroupCapacity(input: $input) {\n      id\n      ageGroup @include(if: $withAgeGroup) {\n        id\n        name\n        type\n        icon\n        minAge\n        maxAge\n      }\n      minCapacity\n      maxCapacity\n    }\n  }";
// language=GraphQL
var UPDATE_AGE_GROUP_CAPACITY_MUTATION = "\n  mutation Mutation($input: UpdateAccommodationAgeGroupCapacityInput, $withAgeGroup: Boolean = false) {\n    ageGroupCapacity: updateAccommodationAgeGroupCapacity(input: $input) {\n      id\n      ageGroup @include(if: $withAgeGroup) {\n        id\n        name\n        type\n        icon\n        minAge\n        maxAge\n      }\n      minCapacity\n      maxCapacity\n    }\n  }";
// language=GraphQL
var DELETE_AGE_GROUP_CAPACITY_MUTATION = "\n  mutation Mutation($input: DeleteAccommodationAgeGroupCapacityInput) {\n    deleteAccommodationAgeGroupCapacity(input: $input) {\n      success\n    }\n  }";
// language=GraphQL
var FORCE_DELETE_AGE_GROUP_CAPACITY_MUTATION = "\n  mutation Mutation($input: DeleteAccommodationAgeGroupCapacityInput) {\n    forceDeleteAccommodationAgeGroupCapacity(input: $input) {\n      success\n    }\n  }";
// language=GraphQL
var AGE_GROUP_CAPACITIES_DEPENDENTS_QUERY = "query Query($id: ID!, $withAccommodationCapacitySettings: Boolean = false) {\n  groupedDependents: accommodationAgeGroupCapacityDependents(id: $id) {\n    accommodationCapacitySettings @include(if: $withAccommodationCapacitySettings) {\n      id\n      totalCapacity\n      rangesAllowed\n      partialOccupancyAllowed\n    }\n  }\n}";

// EXTERNAL MODULE: ./src/entities/travelPricingAgeGroup/entity.ts + 3 modules
var entity = __webpack_require__(65966);
;// CONCATENATED MODULE: ./src/entities/accommodationAgeGroupCapacity/model.ts


var accommodationAgeGroupCapacityModel = {
    name: "ageGroupCapacity",
    namePlural: "ageGroupCapacities",
    uniqueName: "accommodationAgeGroupCapacity",
    uniqueNamePlural: "accommodationAgeGroupCapacities",
    path: "travel/pricing/accommodation/age_group_capacity",
    baseUrl: "/travel/pricing/accommodation/age_group_capacities",
    translationPrefix: "entities:accommodationAgeGroupCapacity.",
    getDisplayName: function(values) {
        return "Age Group Capacity";
    },
    gql: {
        getAll: ALL_AGE_GROUP_CAPACITIES_QUERY,
        getSingle: SINGLE_AGE_GROUP_CAPACITY_QUERY,
        create: CREATE_AGE_GROUP_CAPACITY_MUTATION,
        update: UPDATE_AGE_GROUP_CAPACITY_MUTATION,
        delete: DELETE_AGE_GROUP_CAPACITY_MUTATION,
        forceDelete: FORCE_DELETE_AGE_GROUP_CAPACITY_MUTATION
    },
    attributes: {
        ageGroup: {
            name: "ageGroup",
            label: "entities:accommodationAgeGroupCapacity.attributes.ageGroup.label",
            type: "entityObject",
            dataType: "any",
            getEntity: function() {
                return entity/* default */.Z;
            },
            defaultInput: false,
            inputType: "select",
            validationType: "string",
            validations: []
        },
        minCapacity: {
            name: "minCapacity",
            label: "entities:accommodationAgeGroupCapacity.attributes.minCapacity.label",
            type: "value",
            dataType: "number",
            defaultInput: true,
            inputType: "text",
            validationType: "string",
            validations: [
                {
                    type: "required"
                },
                {
                    type: "number"
                }, 
            ]
        },
        maxCapacity: {
            name: "maxCapacity",
            label: "entities:accommodationAgeGroupCapacity.attributes.maxCapacity.label",
            type: "value",
            dataType: "number",
            defaultInput: false,
            inputType: "text",
            validationType: "string",
            validations: [
                {
                    type: "required"
                },
                {
                    type: "number"
                }, 
            ]
        }
    }
};
/* harmony default export */ var model = (accommodationAgeGroupCapacityModel);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(20414);
// EXTERNAL MODULE: ./src/entities/lib.ts
var lib = __webpack_require__(23480);
// EXTERNAL MODULE: ./src/lib/api/graphQLClient.ts
var graphQLClient = __webpack_require__(40112);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/swr/dist/index.mjs
var dist = __webpack_require__(8100);
// EXTERNAL MODULE: ./src/lib/helpers/helpers.ts
var helpers = __webpack_require__(15778);
;// CONCATENATED MODULE: ./src/entities/accommodationAgeGroupCapacity/repository.ts










var hydrateObjects = function(objects) {
    return objects.map(function(object) {
        return (0,lib/* hydrateEntityObject */.b)(model, object);
    });
};
var hydrateObject = function(object) {
    return (0,lib/* hydrateEntityObject */.b)(model, object);
};
var accommodationAgeGroupCapacityRepository = {
    getObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    id: id
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(SINGLE_AGE_GROUP_CAPACITY_QUERY, variables).then(function(data) {
                        return hydrateObject(data.ageGroupCapacity);
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }(),
    getObjects: /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        var includes;
        var _arguments = arguments;
        return (0,tslib_es6.__generator)(this, function(_state) {
            includes = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : {};
            return [
                2,
                graphQLClient/* default.request */.Z.request(ALL_AGE_GROUP_CAPACITIES_QUERY, includes).then(function(data) {
                    return hydrateObjects(data.ageGroupCapacities);
                })
            ];
        });
    }),
    useObject: function(id) {
        var includes = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        // eslint-disable-next-line react-hooks/exhaustive-deps
        var variables = (0,react.useMemo)(function() {
            return (0,_object_spread/* default */.Z)({
                id: id
            }, includes);
        }, [
            id
        ]);
        var ref = (0,dist/* default */.ZP)([
            SINGLE_AGE_GROUP_CAPACITY_QUERY,
            variables
        ], {
            revalidateOnFocus: false
        }), data = ref.data, error = ref.error, mutate = ref.mutate;
        return {
            object: !data ? data : hydrateObject(data.ageGroupCapacity),
            isLoading: !error && !data,
            isError: error,
            mutate: mutate
        };
    },
    useObjects: function() {
        var includes = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        // eslint-disable-next-line react-hooks/exhaustive-deps
        var variables = (0,react.useMemo)(function() {
            return includes;
        }, []);
        var ref = (0,dist/* default */.ZP)([
            ALL_AGE_GROUP_CAPACITIES_QUERY,
            variables
        ]), data = ref.data, error = ref.error, mutate = ref.mutate;
        return {
            objects: !data ? data : hydrateObjects(data.ageGroupCapacities),
            isLoading: !error && !data,
            isError: error,
            mutate: mutate
        };
    },
    getDependents: function(id, includes) {
        var includeVars = {};
        includes.forEach(function(include) {
            includeVars["with".concat((0,helpers/* uppercaseFirst */.AB)(include))] = true;
        });
        var variables = (0,_object_spread/* default */.Z)({
            id: id
        }, includeVars);
        return graphQLClient/* default.request */.Z.request(AGE_GROUP_CAPACITIES_DEPENDENTS_QUERY, variables).then(function(data) {
            return data.groupedDependents;
        });
    },
    useDependents: function(id, includes) {
        var includeVars = {};
        includes.forEach(function(include) {
            includeVars["with".concat((0,helpers/* uppercaseFirst */.AB)(include))] = true;
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
        var variables = (0,react.useMemo)(function() {
            return (0,_object_spread/* default */.Z)({
                id: id
            }, includeVars);
        }, [
            id
        ]);
        var ref = (0,dist/* default */.ZP)([
            AGE_GROUP_CAPACITIES_DEPENDENTS_QUERY,
            variables
        ], {
            revalidateOnFocus: false
        }), data = ref.data, error = ref.error, mutate = ref.mutate;
        return {
            data: !data ? data : data.groupedDependents,
            isLoading: !error && !data,
            isError: error,
            mutate: mutate
        };
    },
    createObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(data) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    input: data
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(CREATE_AGE_GROUP_CAPACITY_MUTATION, variables).then(function(data) {
                        return hydrateObject(data.ageGroupCapacity);
                    })
                ];
            });
        });
        return function(data) {
            return _ref.apply(this, arguments);
        };
    }(),
    updateObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(data) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    input: data
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(UPDATE_AGE_GROUP_CAPACITY_MUTATION, variables).then(function(data) {
                        return hydrateObject(data.ageGroupCapacity);
                    })
                ];
            });
        });
        return function(data) {
            return _ref.apply(this, arguments);
        };
    }(),
    deleteObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(DELETE_AGE_GROUP_CAPACITY_MUTATION, variables).then(function(data) {
                        return data.deleteAccommodationAgeGroupCapacity;
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }(),
    forceDeleteObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(FORCE_DELETE_AGE_GROUP_CAPACITY_MUTATION, variables).then(function(data) {
                        return data.forceDeleteAccommodationAgeGroupCapacity;
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }()
};
/* harmony default export */ var repository = (accommodationAgeGroupCapacityRepository);

;// CONCATENATED MODULE: ./src/entities/accommodationAgeGroupCapacity/entity.ts


var accommodationAgeGroupCapacityEntity = {
    model: model,
    repository: repository
};
/* harmony default export */ var accommodationAgeGroupCapacity_entity = (accommodationAgeGroupCapacityEntity);


/***/ }),

/***/ 97896:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ accommodationAgeGroupedTotalCapacity_entity; }
});

;// CONCATENATED MODULE: ./src/entities/accommodationAgeGroupedTotalCapacity/graphql.ts
// language=GraphQL
var ALL_AGE_GROUPED_TOTAL_CAPACITIES_QUERY = "query Query($withAgeGroups: Boolean = false) {\n  ageGroupedTotalCapacities: accommodationAgeGroupedTotalCapacities {\n    id\n    ageGroups @include(if: $withAgeGroups) {\n      id\n      name\n      type\n      icon\n      minAge\n      maxAge\n    }\n    capacity\n  }\n}";
// language=GraphQL
var SINGLE_AGE_GROUPED_TOTAL_CAPACITY_QUERY = "query Query($id: ID!, $withAgeGroups: Boolean = false) {\n  ageGroupedTotalCapacity: accommodationAgeGroupedTotalCapacity(id: $id) {\n    id\n    ageGroups @include(if: $withAgeGroups) {\n      id\n      name\n      type\n      icon\n      minAge\n      maxAge\n    }\n    capacity\n  }\n}";
// language=GraphQL
var CREATE_AGE_GROUPED_TOTAL_CAPACITY_MUTATION = "\n  mutation Mutation($input: CreateAccommodationAgeGroupedTotalCapacityInput, $withAgeGroups: Boolean = false) {\n    ageGroupedTotalCapacity: createAccommodationAgeGroupedTotalCapacity(input: $input) {\n      id\n      ageGroups @include(if: $withAgeGroups) {\n        id\n        name\n        type\n        icon\n        minAge\n        maxAge\n      }\n      capacity\n    }\n  }";
// language=GraphQL
var UPDATE_AGE_GROUPED_TOTAL_CAPACITY_MUTATION = "\n  mutation Mutation($input: UpdateAccommodationAgeGroupedTotalCapacityInput, $withAgeGroups: Boolean = false) {\n    ageGroupedTotalCapacity: updateAccommodationAgeGroupedTotalCapacity(input: $input) {\n      id\n      ageGroups @include(if: $withAgeGroups) {\n        id\n        name\n        type\n        icon\n        minAge\n        maxAge\n      }\n      capacity\n    }\n  }";
// language=GraphQL
var DELETE_AGE_GROUPED_TOTAL_CAPACITY_MUTATION = "\n  mutation Mutation($input: DeleteAccommodationAgeGroupedTotalCapacityInput) {\n    deleteAccommodationAgeGroupedTotalCapacity(input: $input) {\n      success\n    }\n  }";
// language=GraphQL
var FORCE_DELETE_AGE_GROUPED_TOTAL_CAPACITY_MUTATION = "\n  mutation Mutation($input: DeleteAccommodationAgeGroupedTotalCapacityInput) {\n    forceDeleteAccommodationAgeGroupedTotalCapacity(input: $input) {\n      success\n    }\n  }";
// language=GraphQL
var ADD_AGE_GROUPED_TOTAL_CAPACITY_AGE_GROUPS_MUTATION = "\n  mutation Mutation($input: addAccommodationAgeGroupedTotalCapacityAgeGroupsInput) {\n    addAccommodationAgeGroupedTotalCapacityAgeGroups(input: $input) {\n      id\n      ageGroupIds\n    }\n  }";
// language=GraphQL
var REMOVE_AGE_GROUPED_TOTAL_CAPACITY_AGE_GROUPS_MUTATION = "\n  mutation Mutation($input: removeAccommodationAgeGroupedTotalCapacityAgeGroupsInput) {\n    removeAccommodationAgeGroupedTotalCapacityAgeGroups(input: $input) {\n      id\n      ageGroupIds\n    }\n  }";
// language=GraphQL
var CREATE_AGE_GROUPED_TOTAL_CAPACITY_AGE_GROUPS_MUTATION = "\n  mutation Mutation($input: createAccommodationAgeGroupedTotalCapacityAgeGroupsInput) {\n    createAccommodationAgeGroupedTotalCapacityAgeGroups(input: $input) {\n      id\n      ageGroupIds\n    }\n  }";
// language=GraphQL
var DELETE_AGE_GROUPED_TOTAL_CAPACITY_AGE_GROUPS_MUTATION = "\n  mutation Mutation($input: deleteAccommodationAgeGroupedTotalCapacityAgeGroupsInput) {\n    deleteAccommodationAgeGroupedTotalCapacityAgeGroups(input: $input) {\n      id\n      ageGroupIds\n    }\n  }";
// language=GraphQL
var UPDATE_AGE_GROUPED_TOTAL_CAPACITY_AGE_GROUPS_ORDER_MUTATION = "\n  mutation Mutation($input: updateAccommodationAgeGroupedTotalCapacityAgeGroupsOrderInput) {\n    updateAccommodationAgeGroupedTotalCapacityAgeGroupsOrder(input: $input) {\n      id\n      ageGroupIds\n    }\n  }";
// language=GraphQL
var AGE_GROUPED_TOTAL_CAPACITIES_DEPENDENTS_QUERY = "query Query($id: ID!, $withAccommodationCapacitySettings: Boolean = false) {\n  groupedDependents: accommodationAgeGroupedTotalCapacityDependents(id: $id) {\n    accommodationCapacitySettings @include(if: $withAccommodationCapacitySettings) {\n      id\n      totalCapacity\n      rangesAllowed\n      partialOccupancyAllowed\n    }\n  }\n}";

// EXTERNAL MODULE: ./src/entities/travelPricingAgeGroup/entity.ts + 3 modules
var entity = __webpack_require__(65966);
;// CONCATENATED MODULE: ./src/entities/accommodationAgeGroupedTotalCapacity/model.ts


var accommodationAgeGroupedTotalCapacityModel = {
    name: "ageGroupedTotalCapacity",
    namePlural: "ageGroupedTotalCapacities",
    uniqueName: "accommodationAgeGroupedTotalCapacity",
    uniqueNamePlural: "accommodationAgeGroupedTotalCapacities",
    path: "travel/pricing/accommodation/age_grouped_total_capacity",
    baseUrl: "/travel/pricing/accommodation/age_grouped_total_capacities",
    translationPrefix: "entities:accommodationAgeGroupedTotalCapacity.",
    getDisplayName: function(values) {
        return "Age Grouped Total Capacity";
    },
    gql: {
        getAll: ALL_AGE_GROUPED_TOTAL_CAPACITIES_QUERY,
        getSingle: SINGLE_AGE_GROUPED_TOTAL_CAPACITY_QUERY,
        create: CREATE_AGE_GROUPED_TOTAL_CAPACITY_MUTATION,
        update: UPDATE_AGE_GROUPED_TOTAL_CAPACITY_MUTATION,
        delete: DELETE_AGE_GROUPED_TOTAL_CAPACITY_MUTATION,
        forceDelete: FORCE_DELETE_AGE_GROUPED_TOTAL_CAPACITY_MUTATION
    },
    attributes: {
        ageGroups: {
            name: "ageGroups",
            label: "entities:accommodationAgeGroupedTotalCapacity.attributes.ageGroups.label",
            type: "entityCollection",
            dataType: "[any]",
            getEntity: function() {
                return entity/* default */.Z;
            },
            defaultInput: false,
            inputType: "text",
            validationType: "string",
            validations: []
        },
        capacity: {
            name: "capacity",
            label: "entities:accommodationAgeGroupedTotalCapacity.attributes.capacity.label",
            type: "value",
            dataType: "number",
            defaultInput: true,
            inputType: "text",
            validationType: "string",
            validations: [
                {
                    type: "required"
                },
                {
                    type: "number"
                }, 
            ]
        }
    }
};
/* harmony default export */ var model = (accommodationAgeGroupedTotalCapacityModel);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(20414);
// EXTERNAL MODULE: ./src/entities/lib.ts
var lib = __webpack_require__(23480);
// EXTERNAL MODULE: ./src/lib/api/graphQLClient.ts
var graphQLClient = __webpack_require__(40112);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/swr/dist/index.mjs
var dist = __webpack_require__(8100);
// EXTERNAL MODULE: ./src/lib/helpers/helpers.ts
var helpers = __webpack_require__(15778);
;// CONCATENATED MODULE: ./src/entities/accommodationAgeGroupedTotalCapacity/repository.ts










var hydrateObjects = function(objects) {
    return objects.map(function(object) {
        return (0,lib/* hydrateEntityObject */.b)(model, object);
    });
};
var hydrateObject = function(object) {
    return (0,lib/* hydrateEntityObject */.b)(model, object);
};
var accommodationAgeGroupedTotalCapacityRepository = {
    getObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    id: id
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(SINGLE_AGE_GROUPED_TOTAL_CAPACITY_QUERY, variables).then(function(data) {
                        return hydrateObject(data.ageGroupedTotalCapacity);
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }(),
    getObjects: /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        var includes;
        var _arguments = arguments;
        return (0,tslib_es6.__generator)(this, function(_state) {
            includes = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : {};
            return [
                2,
                graphQLClient/* default.request */.Z.request(ALL_AGE_GROUPED_TOTAL_CAPACITIES_QUERY, includes).then(function(data) {
                    return hydrateObjects(data.ageGroupedTotalCapacities);
                })
            ];
        });
    }),
    useObject: function(id) {
        var includes = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        // eslint-disable-next-line react-hooks/exhaustive-deps
        var variables = (0,react.useMemo)(function() {
            return (0,_object_spread/* default */.Z)({
                id: id
            }, includes);
        }, [
            id
        ]);
        var ref = (0,dist/* default */.ZP)([
            SINGLE_AGE_GROUPED_TOTAL_CAPACITY_QUERY,
            variables
        ], {
            revalidateOnFocus: false
        }), data = ref.data, error = ref.error, mutate = ref.mutate;
        return {
            object: !data ? data : hydrateObject(data.ageGroupedTotalCapacity),
            isLoading: !error && !data,
            isError: error,
            mutate: mutate
        };
    },
    useObjects: function() {
        var includes = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        // eslint-disable-next-line react-hooks/exhaustive-deps
        var variables = (0,react.useMemo)(function() {
            return includes;
        }, []);
        var ref = (0,dist/* default */.ZP)([
            ALL_AGE_GROUPED_TOTAL_CAPACITIES_QUERY,
            variables
        ]), data = ref.data, error = ref.error, mutate = ref.mutate;
        return {
            objects: !data ? data : hydrateObjects(data.ageGroupedTotalCapacities),
            isLoading: !error && !data,
            isError: error,
            mutate: mutate
        };
    },
    getDependents: function(id, includes) {
        var includeVars = {};
        includes.forEach(function(include) {
            includeVars["with".concat((0,helpers/* uppercaseFirst */.AB)(include))] = true;
        });
        var variables = (0,_object_spread/* default */.Z)({
            id: id
        }, includeVars);
        return graphQLClient/* default.request */.Z.request(AGE_GROUPED_TOTAL_CAPACITIES_DEPENDENTS_QUERY, variables).then(function(data) {
            return data.groupedDependents;
        });
    },
    useDependents: function(id, includes) {
        var includeVars = {};
        includes.forEach(function(include) {
            includeVars["with".concat((0,helpers/* uppercaseFirst */.AB)(include))] = true;
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
        var variables = (0,react.useMemo)(function() {
            return (0,_object_spread/* default */.Z)({
                id: id
            }, includeVars);
        }, [
            id
        ]);
        var ref = (0,dist/* default */.ZP)([
            AGE_GROUPED_TOTAL_CAPACITIES_DEPENDENTS_QUERY,
            variables
        ], {
            revalidateOnFocus: false
        }), data = ref.data, error = ref.error, mutate = ref.mutate;
        return {
            data: !data ? data : data.groupedDependents,
            isLoading: !error && !data,
            isError: error,
            mutate: mutate
        };
    },
    createObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(data) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    input: data
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(CREATE_AGE_GROUPED_TOTAL_CAPACITY_MUTATION, variables).then(function(data) {
                        return hydrateObject(data.ageGroupedTotalCapacity);
                    })
                ];
            });
        });
        return function(data) {
            return _ref.apply(this, arguments);
        };
    }(),
    updateObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(data) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    input: data
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(UPDATE_AGE_GROUPED_TOTAL_CAPACITY_MUTATION, variables).then(function(data) {
                        return hydrateObject(data.ageGroupedTotalCapacity);
                    })
                ];
            });
        });
        return function(data) {
            return _ref.apply(this, arguments);
        };
    }(),
    deleteObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(DELETE_AGE_GROUPED_TOTAL_CAPACITY_MUTATION, variables).then(function(data) {
                        return data.deleteAccommodationAgeGroupedTotalCapacity;
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }(),
    forceDeleteObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(FORCE_DELETE_AGE_GROUPED_TOTAL_CAPACITY_MUTATION, variables).then(function(data) {
                        return data.forceDeleteAccommodationAgeGroupedTotalCapacity;
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }(),
    assignAgeGroups: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, itemIds) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        ageGroupIds: itemIds
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(ADD_AGE_GROUPED_TOTAL_CAPACITY_AGE_GROUPS_MUTATION, variables)
                ];
            });
        });
        return function(id, itemIds) {
            return _ref.apply(this, arguments);
        };
    }(),
    unassignAgeGroups: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, itemIds) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        ageGroupIds: itemIds
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(REMOVE_AGE_GROUPED_TOTAL_CAPACITY_AGE_GROUPS_MUTATION, variables)
                ];
            });
        });
        return function(id, itemIds) {
            return _ref.apply(this, arguments);
        };
    }(),
    createAgeGroups: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, items) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        ageGroups: items
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(CREATE_AGE_GROUPED_TOTAL_CAPACITY_AGE_GROUPS_MUTATION, variables)
                ];
            });
        });
        return function(id, items) {
            return _ref.apply(this, arguments);
        };
    }(),
    deleteAgeGroups: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, itemIds) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        ageGroupIds: itemIds
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(DELETE_AGE_GROUPED_TOTAL_CAPACITY_AGE_GROUPS_MUTATION, variables)
                ];
            });
        });
        return function(id, itemIds) {
            return _ref.apply(this, arguments);
        };
    }(),
    updateAgeGroupsOrder: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, itemIds) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        ageGroupIds: itemIds
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(UPDATE_AGE_GROUPED_TOTAL_CAPACITY_AGE_GROUPS_ORDER_MUTATION, variables)
                ];
            });
        });
        return function(id, itemIds) {
            return _ref.apply(this, arguments);
        };
    }()
};
/* harmony default export */ var repository = (accommodationAgeGroupedTotalCapacityRepository);

;// CONCATENATED MODULE: ./src/entities/accommodationAgeGroupedTotalCapacity/entity.ts


var accommodationAgeGroupedTotalCapacityEntity = {
    model: model,
    repository: repository
};
/* harmony default export */ var accommodationAgeGroupedTotalCapacity_entity = (accommodationAgeGroupedTotalCapacityEntity);


/***/ }),

/***/ 97806:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ accommodationAvailableAddon_entity; }
});

;// CONCATENATED MODULE: ./src/entities/accommodationAvailableAddon/graphql.ts
// language=GraphQL
var ALL_AVAILABLE_ADDONS_QUERY = "query Query($withIcon: Boolean = false) {\n  availableAddons: accommodationAvailableAddons {\n    id\n    name\n    description\n    icon @include(if: $withIcon) {\n      id\n      assetId\n      publicId\n      url\n      resourceType\n      format\n      width\n      height\n      caption\n      title\n      description\n    }\n  }\n}";
// language=GraphQL
var SINGLE_AVAILABLE_ADDON_QUERY = "query Query($id: ID!, $withIcon: Boolean = false) {\n  availableAddon: accommodationAvailableAddon(id: $id) {\n    id\n    name\n    description\n    icon @include(if: $withIcon) {\n      id\n      assetId\n      publicId\n      url\n      resourceType\n      format\n      width\n      height\n      caption\n      title\n      description\n    }\n  }\n}";
// language=GraphQL
var CREATE_AVAILABLE_ADDON_MUTATION = "\n  mutation Mutation($input: CreateAccommodationAvailableAddonInput, $withIcon: Boolean = false) {\n    availableAddon: createAccommodationAvailableAddon(input: $input) {\n      id\n      name\n      description\n      icon @include(if: $withIcon) {\n        id\n        assetId\n        publicId\n        url\n        resourceType\n        format\n        width\n        height\n        caption\n        title\n        description\n      }\n    }\n  }";
// language=GraphQL
var UPDATE_AVAILABLE_ADDON_MUTATION = "\n  mutation Mutation($input: UpdateAccommodationAvailableAddonInput, $withIcon: Boolean = false) {\n    availableAddon: updateAccommodationAvailableAddon(input: $input) {\n      id\n      name\n      description\n      icon @include(if: $withIcon) {\n        id\n        assetId\n        publicId\n        url\n        resourceType\n        format\n        width\n        height\n        caption\n        title\n        description\n      }\n    }\n  }";
// language=GraphQL
var DELETE_AVAILABLE_ADDON_MUTATION = "\n  mutation Mutation($input: DeleteAccommodationAvailableAddonInput) {\n    deleteAccommodationAvailableAddon(input: $input) {\n      success\n    }\n  }";
// language=GraphQL
var FORCE_DELETE_AVAILABLE_ADDON_MUTATION = "\n  mutation Mutation($input: DeleteAccommodationAvailableAddonInput) {\n    forceDeleteAccommodationAvailableAddon(input: $input) {\n      success\n    }\n  }";
// language=GraphQL
var AVAILABLE_ADDONS_DEPENDENTS_QUERY = "query Query($id: ID!, $withAccommodations: Boolean = false) {\n  groupedDependents: accommodationAvailableAddonDependents(id: $id) {\n    accommodations @include(if: $withAccommodations) {\n      id\n      label\n      name\n      stars\n      description\n    }\n  }\n}";

// EXTERNAL MODULE: ./src/entities/mediaFile/entity.ts + 3 modules
var entity = __webpack_require__(24180);
;// CONCATENATED MODULE: ./src/entities/accommodationAvailableAddon/model.ts


var accommodationAvailableAddonModel = {
    name: "availableAddon",
    namePlural: "availableAddons",
    uniqueName: "accommodationAvailableAddon",
    uniqueNamePlural: "accommodationAvailableAddons",
    path: "travel/accommodation/available_addon",
    baseUrl: "/travel/accommodation/available_addons",
    translationPrefix: "entities:accommodationAvailableAddon.",
    getDisplayName: function(values) {
        return values.name;
    },
    gql: {
        getAll: ALL_AVAILABLE_ADDONS_QUERY,
        getSingle: SINGLE_AVAILABLE_ADDON_QUERY,
        create: CREATE_AVAILABLE_ADDON_MUTATION,
        update: UPDATE_AVAILABLE_ADDON_MUTATION,
        delete: DELETE_AVAILABLE_ADDON_MUTATION,
        forceDelete: FORCE_DELETE_AVAILABLE_ADDON_MUTATION
    },
    attributes: {
        name: {
            name: "name",
            label: "entities:accommodationAvailableAddon.attributes.name.label",
            type: "value",
            dataType: "string",
            defaultInput: true,
            inputType: "text",
            validationType: "string",
            validations: [
                {
                    type: "required"
                }, 
            ]
        },
        description: {
            name: "description",
            label: "entities:accommodationAvailableAddon.attributes.description.label",
            type: "value",
            dataType: "string",
            defaultInput: true,
            inputType: "wysiwyg",
            validationType: "string",
            validations: [
                {
                    type: "required"
                }, 
            ]
        },
        icon: {
            name: "icon",
            label: "entities:accommodationAvailableAddon.attributes.icon.label",
            type: "entityObject",
            dataType: "any",
            getEntity: function() {
                return entity/* default */.Z;
            },
            defaultInput: false,
            inputType: "select",
            validationType: "string",
            validations: []
        }
    }
};
/* harmony default export */ var model = (accommodationAvailableAddonModel);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(20414);
// EXTERNAL MODULE: ./src/entities/lib.ts
var lib = __webpack_require__(23480);
// EXTERNAL MODULE: ./src/lib/api/graphQLClient.ts
var graphQLClient = __webpack_require__(40112);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/swr/dist/index.mjs
var dist = __webpack_require__(8100);
// EXTERNAL MODULE: ./src/lib/helpers/helpers.ts
var helpers = __webpack_require__(15778);
;// CONCATENATED MODULE: ./src/entities/accommodationAvailableAddon/repository.ts










var hydrateObjects = function(objects) {
    return objects.map(function(object) {
        return (0,lib/* hydrateEntityObject */.b)(model, object);
    });
};
var hydrateObject = function(object) {
    return (0,lib/* hydrateEntityObject */.b)(model, object);
};
var accommodationAvailableAddonRepository = {
    getObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    id: id
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(SINGLE_AVAILABLE_ADDON_QUERY, variables).then(function(data) {
                        return hydrateObject(data.availableAddon);
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }(),
    getObjects: /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        var includes;
        var _arguments = arguments;
        return (0,tslib_es6.__generator)(this, function(_state) {
            includes = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : {};
            return [
                2,
                graphQLClient/* default.request */.Z.request(ALL_AVAILABLE_ADDONS_QUERY, includes).then(function(data) {
                    return hydrateObjects(data.availableAddons);
                })
            ];
        });
    }),
    useObject: function(id) {
        var includes = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        // eslint-disable-next-line react-hooks/exhaustive-deps
        var variables = (0,react.useMemo)(function() {
            return (0,_object_spread/* default */.Z)({
                id: id
            }, includes);
        }, [
            id
        ]);
        var ref = (0,dist/* default */.ZP)([
            SINGLE_AVAILABLE_ADDON_QUERY,
            variables
        ], {
            revalidateOnFocus: false
        }), data = ref.data, error = ref.error, mutate = ref.mutate;
        return {
            object: !data ? data : hydrateObject(data.availableAddon),
            isLoading: !error && !data,
            isError: error,
            mutate: mutate
        };
    },
    useObjects: function() {
        var includes = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        // eslint-disable-next-line react-hooks/exhaustive-deps
        var variables = (0,react.useMemo)(function() {
            return includes;
        }, []);
        var ref = (0,dist/* default */.ZP)([
            ALL_AVAILABLE_ADDONS_QUERY,
            variables
        ]), data = ref.data, error = ref.error, mutate = ref.mutate;
        return {
            objects: !data ? data : hydrateObjects(data.availableAddons),
            isLoading: !error && !data,
            isError: error,
            mutate: mutate
        };
    },
    getDependents: function(id, includes) {
        var includeVars = {};
        includes.forEach(function(include) {
            includeVars["with".concat((0,helpers/* uppercaseFirst */.AB)(include))] = true;
        });
        var variables = (0,_object_spread/* default */.Z)({
            id: id
        }, includeVars);
        return graphQLClient/* default.request */.Z.request(AVAILABLE_ADDONS_DEPENDENTS_QUERY, variables).then(function(data) {
            return data.groupedDependents;
        });
    },
    useDependents: function(id, includes) {
        var includeVars = {};
        includes.forEach(function(include) {
            includeVars["with".concat((0,helpers/* uppercaseFirst */.AB)(include))] = true;
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
        var variables = (0,react.useMemo)(function() {
            return (0,_object_spread/* default */.Z)({
                id: id
            }, includeVars);
        }, [
            id
        ]);
        var ref = (0,dist/* default */.ZP)([
            AVAILABLE_ADDONS_DEPENDENTS_QUERY,
            variables
        ], {
            revalidateOnFocus: false
        }), data = ref.data, error = ref.error, mutate = ref.mutate;
        return {
            data: !data ? data : data.groupedDependents,
            isLoading: !error && !data,
            isError: error,
            mutate: mutate
        };
    },
    createObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(data) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    input: data
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(CREATE_AVAILABLE_ADDON_MUTATION, variables).then(function(data) {
                        return hydrateObject(data.availableAddon);
                    })
                ];
            });
        });
        return function(data) {
            return _ref.apply(this, arguments);
        };
    }(),
    updateObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(data) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    input: data
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(UPDATE_AVAILABLE_ADDON_MUTATION, variables).then(function(data) {
                        return hydrateObject(data.availableAddon);
                    })
                ];
            });
        });
        return function(data) {
            return _ref.apply(this, arguments);
        };
    }(),
    deleteObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(DELETE_AVAILABLE_ADDON_MUTATION, variables).then(function(data) {
                        return data.deleteAccommodationAvailableAddon;
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }(),
    forceDeleteObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(FORCE_DELETE_AVAILABLE_ADDON_MUTATION, variables).then(function(data) {
                        return data.forceDeleteAccommodationAvailableAddon;
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }()
};
/* harmony default export */ var repository = (accommodationAvailableAddonRepository);

;// CONCATENATED MODULE: ./src/entities/accommodationAvailableAddon/entity.ts


var accommodationAvailableAddonEntity = {
    model: model,
    repository: repository
};
/* harmony default export */ var accommodationAvailableAddon_entity = (accommodationAvailableAddonEntity);


/***/ }),

/***/ 11844:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ accommodationCapacitySettings_entity; }
});

;// CONCATENATED MODULE: ./src/entities/accommodationCapacitySettings/graphql.ts
// language=GraphQL
var ALL_CAPACITY_SETTINGS_QUERY = "query Query($withAgeGroupCapacities: Boolean = false, $withAgeGroupCapacitiesAgeGroup: Boolean = false, $withAgeGroupedTotalCapacities: Boolean = false, $withAgeGroupedTotalCapacitiesAgeGroups: Boolean = false, $withPartialOccupancyAllowedAgeGroups: Boolean = false) {\n  capacitySettings: allAccommodationCapacitySettings {\n    id\n    totalCapacity\n    rangesAllowed\n    ageGroupCapacities @include(if: $withAgeGroupCapacities) {\n      id\n      ageGroup @include(if: $withAgeGroupCapacitiesAgeGroup) {\n        id\n        name\n        type\n        icon\n        minAge\n        maxAge\n      }\n      minCapacity\n      maxCapacity\n    }\n    ageGroupedTotalCapacities @include(if: $withAgeGroupedTotalCapacities) {\n      id\n      ageGroups @include(if: $withAgeGroupedTotalCapacitiesAgeGroups) {\n        id\n        name\n        type\n        icon\n        minAge\n        maxAge\n      }\n      capacity\n    }\n    partialOccupancyAllowed\n    partialOccupancyAllowedAgeGroups @include(if: $withPartialOccupancyAllowedAgeGroups) {\n      id\n      name\n      type\n      icon\n      minAge\n      maxAge\n    }\n  }\n}";
// language=GraphQL
var SINGLE_CAPACITY_SETTINGS_QUERY = "query Query($id: ID!, $withAgeGroupCapacities: Boolean = false, $withAgeGroupCapacitiesAgeGroup: Boolean = false, $withAgeGroupedTotalCapacities: Boolean = false, $withAgeGroupedTotalCapacitiesAgeGroups: Boolean = false, $withPartialOccupancyAllowedAgeGroups: Boolean = false) {\n  capacitySettings: accommodationCapacitySettings(id: $id) {\n    id\n    totalCapacity\n    rangesAllowed\n    ageGroupCapacities @include(if: $withAgeGroupCapacities) {\n      id\n      ageGroup @include(if: $withAgeGroupCapacitiesAgeGroup) {\n        id\n        name\n        type\n        icon\n        minAge\n        maxAge\n      }\n      minCapacity\n      maxCapacity\n    }\n    ageGroupedTotalCapacities @include(if: $withAgeGroupedTotalCapacities) {\n      id\n      ageGroups @include(if: $withAgeGroupedTotalCapacitiesAgeGroups) {\n        id\n        name\n        type\n        icon\n        minAge\n        maxAge\n      }\n      capacity\n    }\n    partialOccupancyAllowed\n    partialOccupancyAllowedAgeGroups @include(if: $withPartialOccupancyAllowedAgeGroups) {\n      id\n      name\n      type\n      icon\n      minAge\n      maxAge\n    }\n  }\n}";
// language=GraphQL
var CREATE_CAPACITY_SETTINGS_MUTATION = "\n  mutation Mutation($input: CreateAccommodationCapacitySettingsInput, $withAgeGroupCapacities: Boolean = false, $withAgeGroupCapacitiesAgeGroup: Boolean = false, $withAgeGroupedTotalCapacities: Boolean = false, $withAgeGroupedTotalCapacitiesAgeGroups: Boolean = false, $withPartialOccupancyAllowedAgeGroups: Boolean = false) {\n    capacitySettings: createAccommodationCapacitySettings(input: $input) {\n      id\n      totalCapacity\n      rangesAllowed\n      ageGroupCapacities @include(if: $withAgeGroupCapacities) {\n        id\n        ageGroup @include(if: $withAgeGroupCapacitiesAgeGroup) {\n          id\n          name\n          type\n          icon\n          minAge\n          maxAge\n        }\n        minCapacity\n        maxCapacity\n      }\n      ageGroupedTotalCapacities @include(if: $withAgeGroupedTotalCapacities) {\n        id\n        ageGroups @include(if: $withAgeGroupedTotalCapacitiesAgeGroups) {\n          id\n          name\n          type\n          icon\n          minAge\n          maxAge\n        }\n        capacity\n      }\n      partialOccupancyAllowed\n      partialOccupancyAllowedAgeGroups @include(if: $withPartialOccupancyAllowedAgeGroups) {\n        id\n        name\n        type\n        icon\n        minAge\n        maxAge\n      }\n    }\n  }";
// language=GraphQL
var UPDATE_CAPACITY_SETTINGS_MUTATION = "\n  mutation Mutation($input: UpdateAccommodationCapacitySettingsInput, $withAgeGroupCapacities: Boolean = false, $withAgeGroupCapacitiesAgeGroup: Boolean = false, $withAgeGroupedTotalCapacities: Boolean = false, $withAgeGroupedTotalCapacitiesAgeGroups: Boolean = false, $withPartialOccupancyAllowedAgeGroups: Boolean = false) {\n    capacitySettings: updateAccommodationCapacitySettings(input: $input) {\n      id\n      totalCapacity\n      rangesAllowed\n      ageGroupCapacities @include(if: $withAgeGroupCapacities) {\n        id\n        ageGroup @include(if: $withAgeGroupCapacitiesAgeGroup) {\n          id\n          name\n          type\n          icon\n          minAge\n          maxAge\n        }\n        minCapacity\n        maxCapacity\n      }\n      ageGroupedTotalCapacities @include(if: $withAgeGroupedTotalCapacities) {\n        id\n        ageGroups @include(if: $withAgeGroupedTotalCapacitiesAgeGroups) {\n          id\n          name\n          type\n          icon\n          minAge\n          maxAge\n        }\n        capacity\n      }\n      partialOccupancyAllowed\n      partialOccupancyAllowedAgeGroups @include(if: $withPartialOccupancyAllowedAgeGroups) {\n        id\n        name\n        type\n        icon\n        minAge\n        maxAge\n      }\n    }\n  }";
// language=GraphQL
var DELETE_CAPACITY_SETTINGS_MUTATION = "\n  mutation Mutation($input: DeleteAccommodationCapacitySettingsInput) {\n    deleteAccommodationCapacitySettings(input: $input) {\n      success\n    }\n  }";
// language=GraphQL
var FORCE_DELETE_CAPACITY_SETTINGS_MUTATION = "\n  mutation Mutation($input: DeleteAccommodationCapacitySettingsInput) {\n    forceDeleteAccommodationCapacitySettings(input: $input) {\n      success\n    }\n  }";
// language=GraphQL
var ADD_CAPACITY_SETTINGS_AGE_GROUP_CAPACITIES_MUTATION = "\n  mutation Mutation($input: addAccommodationCapacitySettingsAgeGroupCapacitiesInput) {\n    addAccommodationCapacitySettingsAgeGroupCapacities(input: $input) {\n      id\n      ageGroupCapacityIds\n    }\n  }";
// language=GraphQL
var REMOVE_CAPACITY_SETTINGS_AGE_GROUP_CAPACITIES_MUTATION = "\n  mutation Mutation($input: removeAccommodationCapacitySettingsAgeGroupCapacitiesInput) {\n    removeAccommodationCapacitySettingsAgeGroupCapacities(input: $input) {\n      id\n      ageGroupCapacityIds\n    }\n  }";
// language=GraphQL
var CREATE_CAPACITY_SETTINGS_AGE_GROUP_CAPACITIES_MUTATION = "\n  mutation Mutation($input: createAccommodationCapacitySettingsAgeGroupCapacitiesInput) {\n    createAccommodationCapacitySettingsAgeGroupCapacities(input: $input) {\n      id\n      ageGroupCapacityIds\n    }\n  }";
// language=GraphQL
var DELETE_CAPACITY_SETTINGS_AGE_GROUP_CAPACITIES_MUTATION = "\n  mutation Mutation($input: deleteAccommodationCapacitySettingsAgeGroupCapacitiesInput) {\n    deleteAccommodationCapacitySettingsAgeGroupCapacities(input: $input) {\n      id\n      ageGroupCapacityIds\n    }\n  }";
// language=GraphQL
var UPDATE_CAPACITY_SETTINGS_AGE_GROUP_CAPACITIES_ORDER_MUTATION = "\n  mutation Mutation($input: updateAccommodationCapacitySettingsAgeGroupCapacitiesOrderInput) {\n    updateAccommodationCapacitySettingsAgeGroupCapacitiesOrder(input: $input) {\n      id\n      ageGroupCapacityIds\n    }\n  }";
// language=GraphQL
var ADD_CAPACITY_SETTINGS_AGE_GROUPED_TOTAL_CAPACITIES_MUTATION = "\n  mutation Mutation($input: addAccommodationCapacitySettingsAgeGroupedTotalCapacitiesInput) {\n    addAccommodationCapacitySettingsAgeGroupedTotalCapacities(input: $input) {\n      id\n      ageGroupedTotalCapacityIds\n    }\n  }";
// language=GraphQL
var REMOVE_CAPACITY_SETTINGS_AGE_GROUPED_TOTAL_CAPACITIES_MUTATION = "\n  mutation Mutation($input: removeAccommodationCapacitySettingsAgeGroupedTotalCapacitiesInput) {\n    removeAccommodationCapacitySettingsAgeGroupedTotalCapacities(input: $input) {\n      id\n      ageGroupedTotalCapacityIds\n    }\n  }";
// language=GraphQL
var CREATE_CAPACITY_SETTINGS_AGE_GROUPED_TOTAL_CAPACITIES_MUTATION = "\n  mutation Mutation($input: createAccommodationCapacitySettingsAgeGroupedTotalCapacitiesInput) {\n    createAccommodationCapacitySettingsAgeGroupedTotalCapacities(input: $input) {\n      id\n      ageGroupedTotalCapacityIds\n    }\n  }";
// language=GraphQL
var DELETE_CAPACITY_SETTINGS_AGE_GROUPED_TOTAL_CAPACITIES_MUTATION = "\n  mutation Mutation($input: deleteAccommodationCapacitySettingsAgeGroupedTotalCapacitiesInput) {\n    deleteAccommodationCapacitySettingsAgeGroupedTotalCapacities(input: $input) {\n      id\n      ageGroupedTotalCapacityIds\n    }\n  }";
// language=GraphQL
var UPDATE_CAPACITY_SETTINGS_AGE_GROUPED_TOTAL_CAPACITIES_ORDER_MUTATION = "\n  mutation Mutation($input: updateAccommodationCapacitySettingsAgeGroupedTotalCapacitiesOrderInput) {\n    updateAccommodationCapacitySettingsAgeGroupedTotalCapacitiesOrder(input: $input) {\n      id\n      ageGroupedTotalCapacityIds\n    }\n  }";
// language=GraphQL
var ADD_CAPACITY_SETTINGS_PARTIAL_OCCUPANCY_ALLOWED_AGE_GROUPS_MUTATION = "\n  mutation Mutation($input: addAccommodationCapacitySettingsPartialOccupancyAllowedAgeGroupsInput) {\n    addAccommodationCapacitySettingsPartialOccupancyAllowedAgeGroups(input: $input) {\n      id\n      partialOccupancyAllowedAgeGroupIds\n    }\n  }";
// language=GraphQL
var REMOVE_CAPACITY_SETTINGS_PARTIAL_OCCUPANCY_ALLOWED_AGE_GROUPS_MUTATION = "\n  mutation Mutation($input: removeAccommodationCapacitySettingsPartialOccupancyAllowedAgeGroupsInput) {\n    removeAccommodationCapacitySettingsPartialOccupancyAllowedAgeGroups(input: $input) {\n      id\n      partialOccupancyAllowedAgeGroupIds\n    }\n  }";
// language=GraphQL
var CREATE_CAPACITY_SETTINGS_PARTIAL_OCCUPANCY_ALLOWED_AGE_GROUPS_MUTATION = "\n  mutation Mutation($input: createAccommodationCapacitySettingsPartialOccupancyAllowedAgeGroupsInput) {\n    createAccommodationCapacitySettingsPartialOccupancyAllowedAgeGroups(input: $input) {\n      id\n      partialOccupancyAllowedAgeGroupIds\n    }\n  }";
// language=GraphQL
var DELETE_CAPACITY_SETTINGS_PARTIAL_OCCUPANCY_ALLOWED_AGE_GROUPS_MUTATION = "\n  mutation Mutation($input: deleteAccommodationCapacitySettingsPartialOccupancyAllowedAgeGroupsInput) {\n    deleteAccommodationCapacitySettingsPartialOccupancyAllowedAgeGroups(input: $input) {\n      id\n      partialOccupancyAllowedAgeGroupIds\n    }\n  }";
// language=GraphQL
var UPDATE_CAPACITY_SETTINGS_PARTIAL_OCCUPANCY_ALLOWED_AGE_GROUPS_ORDER_MUTATION = "\n  mutation Mutation($input: updateAccommodationCapacitySettingsPartialOccupancyAllowedAgeGroupsOrderInput) {\n    updateAccommodationCapacitySettingsPartialOccupancyAllowedAgeGroupsOrder(input: $input) {\n      id\n      partialOccupancyAllowedAgeGroupIds\n    }\n  }";
// language=GraphQL
var CAPACITY_SETTINGS_DEPENDENTS_QUERY = "query Query($id: ID!, $withRatioFamilyPackages: Boolean = false, $withRatioAccommodations: Boolean = false) {\n  groupedDependents: accommodationCapacitySettingsDependents(id: $id) {\n    ratioFamilyPackages @include(if: $withRatioFamilyPackages) {\n      id\n      ratioServiceNo\n      name\n      label\n      info\n    }\n    ratioAccommodations @include(if: $withRatioAccommodations) {\n      id\n      ratioPackageNo\n      name\n      label\n      info\n      isFamilyPackageAccommodation\n      isBabyPackage\n    }\n  }\n}";

// EXTERNAL MODULE: ./src/entities/accommodationAgeGroupCapacity/entity.ts + 3 modules
var entity = __webpack_require__(76276);
// EXTERNAL MODULE: ./src/entities/accommodationAgeGroupedTotalCapacity/entity.ts + 3 modules
var accommodationAgeGroupedTotalCapacity_entity = __webpack_require__(97896);
// EXTERNAL MODULE: ./src/entities/travelPricingAgeGroup/entity.ts + 3 modules
var travelPricingAgeGroup_entity = __webpack_require__(65966);
;// CONCATENATED MODULE: ./src/entities/accommodationCapacitySettings/model.ts




var accommodationCapacitySettingsModel = {
    name: "capacitySettings",
    namePlural: "capacitySettings",
    uniqueName: "accommodationCapacitySettings",
    uniqueNamePlural: "accommodationCapacitySettings",
    path: "travel/pricing/accommodation/capacity_settings",
    baseUrl: "/travel/pricing/accommodation/capacity_settings",
    translationPrefix: "entities:accommodationCapacitySettings.",
    getDisplayName: function(values) {
        return "Capacity Settings";
    },
    gql: {
        getAll: ALL_CAPACITY_SETTINGS_QUERY,
        getSingle: SINGLE_CAPACITY_SETTINGS_QUERY,
        create: CREATE_CAPACITY_SETTINGS_MUTATION,
        update: UPDATE_CAPACITY_SETTINGS_MUTATION,
        delete: DELETE_CAPACITY_SETTINGS_MUTATION,
        forceDelete: FORCE_DELETE_CAPACITY_SETTINGS_MUTATION
    },
    attributes: {
        totalCapacity: {
            name: "totalCapacity",
            label: "entities:accommodationCapacitySettings.attributes.totalCapacity.label",
            type: "value",
            dataType: "number",
            defaultInput: false,
            inputType: "text",
            validationType: "string",
            validations: [
                {
                    type: "required"
                },
                {
                    type: "number"
                }, 
            ]
        },
        rangesAllowed: {
            name: "rangesAllowed",
            label: "entities:accommodationCapacitySettings.attributes.rangesAllowed.label",
            type: "value",
            dataType: "boolean",
            defaultInput: true,
            inputType: "switch",
            validationType: "string",
            validations: []
        },
        ageGroupCapacities: {
            name: "ageGroupCapacities",
            label: "entities:accommodationCapacitySettings.attributes.ageGroupCapacities.label",
            type: "entityCollection",
            dataType: "[any]",
            getEntity: function() {
                return entity/* default */.Z;
            },
            defaultInput: false,
            inputType: "text",
            validationType: "string",
            validations: []
        },
        ageGroupedTotalCapacities: {
            name: "ageGroupedTotalCapacities",
            label: "entities:accommodationCapacitySettings.attributes.ageGroupedTotalCapacities.label",
            type: "entityCollection",
            dataType: "[any]",
            getEntity: function() {
                return accommodationAgeGroupedTotalCapacity_entity/* default */.Z;
            },
            defaultInput: false,
            inputType: "text",
            validationType: "string",
            validations: []
        },
        partialOccupancyAllowed: {
            name: "partialOccupancyAllowed",
            label: "entities:accommodationCapacitySettings.attributes.partialOccupancyAllowed.label",
            type: "value",
            dataType: "boolean",
            defaultInput: true,
            inputType: "switch",
            validationType: "string",
            validations: []
        },
        partialOccupancyAllowedAgeGroups: {
            name: "partialOccupancyAllowedAgeGroups",
            label: "entities:accommodationCapacitySettings.attributes.partialOccupancyAllowedAgeGroups.label",
            type: "entityCollection",
            dataType: "[any]",
            getEntity: function() {
                return travelPricingAgeGroup_entity/* default */.Z;
            },
            defaultInput: false,
            inputType: "text",
            validationType: "string",
            validations: []
        }
    }
};
/* harmony default export */ var model = (accommodationCapacitySettingsModel);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(20414);
// EXTERNAL MODULE: ./src/entities/lib.ts
var lib = __webpack_require__(23480);
// EXTERNAL MODULE: ./src/lib/api/graphQLClient.ts
var graphQLClient = __webpack_require__(40112);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/swr/dist/index.mjs
var dist = __webpack_require__(8100);
// EXTERNAL MODULE: ./src/lib/helpers/helpers.ts
var helpers = __webpack_require__(15778);
;// CONCATENATED MODULE: ./src/entities/accommodationCapacitySettings/repository.ts










var hydrateObjects = function(objects) {
    return objects.map(function(object) {
        return (0,lib/* hydrateEntityObject */.b)(model, object);
    });
};
var hydrateObject = function(object) {
    return (0,lib/* hydrateEntityObject */.b)(model, object);
};
var accommodationCapacitySettingsRepository = {
    getObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    id: id
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(SINGLE_CAPACITY_SETTINGS_QUERY, variables).then(function(data) {
                        return hydrateObject(data.capacitySettings);
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }(),
    getObjects: /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        var includes;
        var _arguments = arguments;
        return (0,tslib_es6.__generator)(this, function(_state) {
            includes = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : {};
            return [
                2,
                graphQLClient/* default.request */.Z.request(ALL_CAPACITY_SETTINGS_QUERY, includes).then(function(data) {
                    return hydrateObjects(data.capacitySettings);
                })
            ];
        });
    }),
    useObject: function(id) {
        var includes = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        // eslint-disable-next-line react-hooks/exhaustive-deps
        var variables = (0,react.useMemo)(function() {
            return (0,_object_spread/* default */.Z)({
                id: id
            }, includes);
        }, [
            id
        ]);
        var ref = (0,dist/* default */.ZP)([
            SINGLE_CAPACITY_SETTINGS_QUERY,
            variables
        ], {
            revalidateOnFocus: false
        }), data = ref.data, error = ref.error, mutate = ref.mutate;
        return {
            object: !data ? data : hydrateObject(data.capacitySettings),
            isLoading: !error && !data,
            isError: error,
            mutate: mutate
        };
    },
    useObjects: function() {
        var includes = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        // eslint-disable-next-line react-hooks/exhaustive-deps
        var variables = (0,react.useMemo)(function() {
            return includes;
        }, []);
        var ref = (0,dist/* default */.ZP)([
            ALL_CAPACITY_SETTINGS_QUERY,
            variables
        ]), data = ref.data, error = ref.error, mutate = ref.mutate;
        return {
            objects: !data ? data : hydrateObjects(data.capacitySettings),
            isLoading: !error && !data,
            isError: error,
            mutate: mutate
        };
    },
    getDependents: function(id, includes) {
        var includeVars = {};
        includes.forEach(function(include) {
            includeVars["with".concat((0,helpers/* uppercaseFirst */.AB)(include))] = true;
        });
        var variables = (0,_object_spread/* default */.Z)({
            id: id
        }, includeVars);
        return graphQLClient/* default.request */.Z.request(CAPACITY_SETTINGS_DEPENDENTS_QUERY, variables).then(function(data) {
            return data.groupedDependents;
        });
    },
    useDependents: function(id, includes) {
        var includeVars = {};
        includes.forEach(function(include) {
            includeVars["with".concat((0,helpers/* uppercaseFirst */.AB)(include))] = true;
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
        var variables = (0,react.useMemo)(function() {
            return (0,_object_spread/* default */.Z)({
                id: id
            }, includeVars);
        }, [
            id
        ]);
        var ref = (0,dist/* default */.ZP)([
            CAPACITY_SETTINGS_DEPENDENTS_QUERY,
            variables
        ], {
            revalidateOnFocus: false
        }), data = ref.data, error = ref.error, mutate = ref.mutate;
        return {
            data: !data ? data : data.groupedDependents,
            isLoading: !error && !data,
            isError: error,
            mutate: mutate
        };
    },
    createObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(data) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    input: data
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(CREATE_CAPACITY_SETTINGS_MUTATION, variables).then(function(data) {
                        return hydrateObject(data.capacitySettings);
                    })
                ];
            });
        });
        return function(data) {
            return _ref.apply(this, arguments);
        };
    }(),
    updateObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(data) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    input: data
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(UPDATE_CAPACITY_SETTINGS_MUTATION, variables).then(function(data) {
                        return hydrateObject(data.capacitySettings);
                    })
                ];
            });
        });
        return function(data) {
            return _ref.apply(this, arguments);
        };
    }(),
    deleteObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(DELETE_CAPACITY_SETTINGS_MUTATION, variables).then(function(data) {
                        return data.deleteAccommodationCapacitySettings;
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }(),
    forceDeleteObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(FORCE_DELETE_CAPACITY_SETTINGS_MUTATION, variables).then(function(data) {
                        return data.forceDeleteAccommodationCapacitySettings;
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }(),
    assignAgeGroupCapacities: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, itemIds) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        ageGroupCapacityIds: itemIds
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(ADD_CAPACITY_SETTINGS_AGE_GROUP_CAPACITIES_MUTATION, variables)
                ];
            });
        });
        return function(id, itemIds) {
            return _ref.apply(this, arguments);
        };
    }(),
    unassignAgeGroupCapacities: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, itemIds) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        ageGroupCapacityIds: itemIds
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(REMOVE_CAPACITY_SETTINGS_AGE_GROUP_CAPACITIES_MUTATION, variables)
                ];
            });
        });
        return function(id, itemIds) {
            return _ref.apply(this, arguments);
        };
    }(),
    createAgeGroupCapacities: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, items) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        ageGroupCapacities: items
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(CREATE_CAPACITY_SETTINGS_AGE_GROUP_CAPACITIES_MUTATION, variables)
                ];
            });
        });
        return function(id, items) {
            return _ref.apply(this, arguments);
        };
    }(),
    deleteAgeGroupCapacities: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, itemIds) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        ageGroupCapacityIds: itemIds
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(DELETE_CAPACITY_SETTINGS_AGE_GROUP_CAPACITIES_MUTATION, variables)
                ];
            });
        });
        return function(id, itemIds) {
            return _ref.apply(this, arguments);
        };
    }(),
    updateAgeGroupCapacitiesOrder: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, itemIds) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        ageGroupCapacityIds: itemIds
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(UPDATE_CAPACITY_SETTINGS_AGE_GROUP_CAPACITIES_ORDER_MUTATION, variables)
                ];
            });
        });
        return function(id, itemIds) {
            return _ref.apply(this, arguments);
        };
    }(),
    assignAgeGroupedTotalCapacities: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, itemIds) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        ageGroupedTotalCapacityIds: itemIds
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(ADD_CAPACITY_SETTINGS_AGE_GROUPED_TOTAL_CAPACITIES_MUTATION, variables)
                ];
            });
        });
        return function(id, itemIds) {
            return _ref.apply(this, arguments);
        };
    }(),
    unassignAgeGroupedTotalCapacities: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, itemIds) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        ageGroupedTotalCapacityIds: itemIds
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(REMOVE_CAPACITY_SETTINGS_AGE_GROUPED_TOTAL_CAPACITIES_MUTATION, variables)
                ];
            });
        });
        return function(id, itemIds) {
            return _ref.apply(this, arguments);
        };
    }(),
    createAgeGroupedTotalCapacities: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, items) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        ageGroupedTotalCapacities: items
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(CREATE_CAPACITY_SETTINGS_AGE_GROUPED_TOTAL_CAPACITIES_MUTATION, variables)
                ];
            });
        });
        return function(id, items) {
            return _ref.apply(this, arguments);
        };
    }(),
    deleteAgeGroupedTotalCapacities: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, itemIds) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        ageGroupedTotalCapacityIds: itemIds
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(DELETE_CAPACITY_SETTINGS_AGE_GROUPED_TOTAL_CAPACITIES_MUTATION, variables)
                ];
            });
        });
        return function(id, itemIds) {
            return _ref.apply(this, arguments);
        };
    }(),
    updateAgeGroupedTotalCapacitiesOrder: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, itemIds) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        ageGroupedTotalCapacityIds: itemIds
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(UPDATE_CAPACITY_SETTINGS_AGE_GROUPED_TOTAL_CAPACITIES_ORDER_MUTATION, variables)
                ];
            });
        });
        return function(id, itemIds) {
            return _ref.apply(this, arguments);
        };
    }(),
    assignPartialOccupancyAllowedAgeGroups: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, itemIds) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        partialOccupancyAllowedAgeGroupIds: itemIds
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(ADD_CAPACITY_SETTINGS_PARTIAL_OCCUPANCY_ALLOWED_AGE_GROUPS_MUTATION, variables)
                ];
            });
        });
        return function(id, itemIds) {
            return _ref.apply(this, arguments);
        };
    }(),
    unassignPartialOccupancyAllowedAgeGroups: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, itemIds) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        partialOccupancyAllowedAgeGroupIds: itemIds
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(REMOVE_CAPACITY_SETTINGS_PARTIAL_OCCUPANCY_ALLOWED_AGE_GROUPS_MUTATION, variables)
                ];
            });
        });
        return function(id, itemIds) {
            return _ref.apply(this, arguments);
        };
    }(),
    createPartialOccupancyAllowedAgeGroups: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, items) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        partialOccupancyAllowedAgeGroups: items
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(CREATE_CAPACITY_SETTINGS_PARTIAL_OCCUPANCY_ALLOWED_AGE_GROUPS_MUTATION, variables)
                ];
            });
        });
        return function(id, items) {
            return _ref.apply(this, arguments);
        };
    }(),
    deletePartialOccupancyAllowedAgeGroups: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, itemIds) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        partialOccupancyAllowedAgeGroupIds: itemIds
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(DELETE_CAPACITY_SETTINGS_PARTIAL_OCCUPANCY_ALLOWED_AGE_GROUPS_MUTATION, variables)
                ];
            });
        });
        return function(id, itemIds) {
            return _ref.apply(this, arguments);
        };
    }(),
    updatePartialOccupancyAllowedAgeGroupsOrder: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, itemIds) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        partialOccupancyAllowedAgeGroupIds: itemIds
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(UPDATE_CAPACITY_SETTINGS_PARTIAL_OCCUPANCY_ALLOWED_AGE_GROUPS_ORDER_MUTATION, variables)
                ];
            });
        });
        return function(id, itemIds) {
            return _ref.apply(this, arguments);
        };
    }()
};
/* harmony default export */ var repository = (accommodationCapacitySettingsRepository);

;// CONCATENATED MODULE: ./src/entities/accommodationCapacitySettings/entity.ts


var accommodationCapacitySettingsEntity = {
    model: model,
    repository: repository
};
/* harmony default export */ var accommodationCapacitySettings_entity = (accommodationCapacitySettingsEntity);


/***/ }),

/***/ 94529:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ accommodationRoomType_entity; }
});

;// CONCATENATED MODULE: ./src/entities/accommodationRoomType/graphql.ts
// language=GraphQL
var ALL_ROOM_TYPES_QUERY = "query Query($withGallery: Boolean = false, $withGalleryImages: Boolean = false) {\n  roomTypes: accommodationRoomTypes {\n    id\n    name\n    description\n    gallery @include(if: $withGallery) {\n      id\n      images @include(if: $withGalleryImages) {\n        id\n        assetId\n        publicId\n        url\n        resourceType\n        format\n        width\n        height\n        caption\n        title\n        description\n      }\n    }\n  }\n}";
// language=GraphQL
var SINGLE_ROOM_TYPE_QUERY = "query Query($id: ID!, $withGallery: Boolean = false, $withGalleryImages: Boolean = false) {\n  roomType: accommodationRoomType(id: $id) {\n    id\n    name\n    description\n    gallery @include(if: $withGallery) {\n      id\n      images @include(if: $withGalleryImages) {\n        id\n        assetId\n        publicId\n        url\n        resourceType\n        format\n        width\n        height\n        caption\n        title\n        description\n      }\n    }\n  }\n}";
// language=GraphQL
var CREATE_ROOM_TYPE_MUTATION = "\n  mutation Mutation($input: CreateAccommodationRoomTypeInput, $withGallery: Boolean = false, $withGalleryImages: Boolean = false) {\n    roomType: createAccommodationRoomType(input: $input) {\n      id\n      name\n      description\n      gallery @include(if: $withGallery) {\n        id\n        images @include(if: $withGalleryImages) {\n          id\n          assetId\n          publicId\n          url\n          resourceType\n          format\n          width\n          height\n          caption\n          title\n          description\n        }\n      }\n    }\n  }";
// language=GraphQL
var UPDATE_ROOM_TYPE_MUTATION = "\n  mutation Mutation($input: UpdateAccommodationRoomTypeInput, $withGallery: Boolean = false, $withGalleryImages: Boolean = false) {\n    roomType: updateAccommodationRoomType(input: $input) {\n      id\n      name\n      description\n      gallery @include(if: $withGallery) {\n        id\n        images @include(if: $withGalleryImages) {\n          id\n          assetId\n          publicId\n          url\n          resourceType\n          format\n          width\n          height\n          caption\n          title\n          description\n        }\n      }\n    }\n  }";
// language=GraphQL
var DELETE_ROOM_TYPE_MUTATION = "\n  mutation Mutation($input: DeleteAccommodationRoomTypeInput) {\n    deleteAccommodationRoomType(input: $input) {\n      success\n    }\n  }";
// language=GraphQL
var FORCE_DELETE_ROOM_TYPE_MUTATION = "\n  mutation Mutation($input: DeleteAccommodationRoomTypeInput) {\n    forceDeleteAccommodationRoomType(input: $input) {\n      success\n    }\n  }";
// language=GraphQL
var ROOM_TYPES_DEPENDENTS_QUERY = "query Query($id: ID!, $withTravelAccommodationAssignments: Boolean = false, $withAccommodations: Boolean = false) {\n  groupedDependents: accommodationRoomTypeDependents(id: $id) {\n    travelAccommodationAssignments @include(if: $withTravelAccommodationAssignments) {\n      id\n      useCustomRoomTypeSelection    }\n    accommodations @include(if: $withAccommodations) {\n      id\n      label\n      name\n      stars\n      description\n    }\n  }\n}";

// EXTERNAL MODULE: ./src/entities/imageGallery/entity.ts + 3 modules
var entity = __webpack_require__(41);
;// CONCATENATED MODULE: ./src/entities/accommodationRoomType/model.ts


var accommodationRoomTypeModel = {
    name: "roomType",
    namePlural: "roomTypes",
    uniqueName: "accommodationRoomType",
    uniqueNamePlural: "accommodationRoomTypes",
    path: "travel/accommodation/room_type",
    baseUrl: "/travel/accommodation/room_types",
    translationPrefix: "entities:accommodationRoomType.",
    getDisplayName: function(values) {
        return values.name;
    },
    gql: {
        getAll: ALL_ROOM_TYPES_QUERY,
        getSingle: SINGLE_ROOM_TYPE_QUERY,
        create: CREATE_ROOM_TYPE_MUTATION,
        update: UPDATE_ROOM_TYPE_MUTATION,
        delete: DELETE_ROOM_TYPE_MUTATION,
        forceDelete: FORCE_DELETE_ROOM_TYPE_MUTATION
    },
    attributes: {
        name: {
            name: "name",
            label: "entities:accommodationRoomType.attributes.name.label",
            type: "value",
            dataType: "string",
            defaultInput: true,
            inputType: "text",
            validationType: "string",
            validations: [
                {
                    type: "required"
                }, 
            ]
        },
        description: {
            name: "description",
            label: "entities:accommodationRoomType.attributes.description.label",
            type: "value",
            dataType: "string",
            defaultInput: true,
            inputType: "wysiwyg",
            validationType: "string",
            validations: [
                {
                    type: "required"
                }, 
            ]
        },
        gallery: {
            name: "gallery",
            label: "entities:accommodationRoomType.attributes.gallery.label",
            type: "entityObject",
            dataType: "any",
            getEntity: function() {
                return entity/* default */.Z;
            },
            defaultInput: false,
            inputType: "select",
            validationType: "string",
            validations: []
        }
    }
};
/* harmony default export */ var model = (accommodationRoomTypeModel);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(20414);
// EXTERNAL MODULE: ./src/entities/lib.ts
var lib = __webpack_require__(23480);
// EXTERNAL MODULE: ./src/lib/api/graphQLClient.ts
var graphQLClient = __webpack_require__(40112);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/swr/dist/index.mjs
var dist = __webpack_require__(8100);
// EXTERNAL MODULE: ./src/lib/helpers/helpers.ts
var helpers = __webpack_require__(15778);
;// CONCATENATED MODULE: ./src/entities/accommodationRoomType/repository.ts










var hydrateObjects = function(objects) {
    return objects.map(function(object) {
        return (0,lib/* hydrateEntityObject */.b)(model, object);
    });
};
var hydrateObject = function(object) {
    return (0,lib/* hydrateEntityObject */.b)(model, object);
};
var accommodationRoomTypeRepository = {
    getObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    id: id
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(SINGLE_ROOM_TYPE_QUERY, variables).then(function(data) {
                        return hydrateObject(data.roomType);
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }(),
    getObjects: /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        var includes;
        var _arguments = arguments;
        return (0,tslib_es6.__generator)(this, function(_state) {
            includes = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : {};
            return [
                2,
                graphQLClient/* default.request */.Z.request(ALL_ROOM_TYPES_QUERY, includes).then(function(data) {
                    return hydrateObjects(data.roomTypes);
                })
            ];
        });
    }),
    useObject: function(id) {
        var includes = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        // eslint-disable-next-line react-hooks/exhaustive-deps
        var variables = (0,react.useMemo)(function() {
            return (0,_object_spread/* default */.Z)({
                id: id
            }, includes);
        }, [
            id
        ]);
        var ref = (0,dist/* default */.ZP)([
            SINGLE_ROOM_TYPE_QUERY,
            variables
        ], {
            revalidateOnFocus: false
        }), data = ref.data, error = ref.error, mutate = ref.mutate;
        return {
            object: !data ? data : hydrateObject(data.roomType),
            isLoading: !error && !data,
            isError: error,
            mutate: mutate
        };
    },
    useObjects: function() {
        var includes = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        // eslint-disable-next-line react-hooks/exhaustive-deps
        var variables = (0,react.useMemo)(function() {
            return includes;
        }, []);
        var ref = (0,dist/* default */.ZP)([
            ALL_ROOM_TYPES_QUERY,
            variables
        ]), data = ref.data, error = ref.error, mutate = ref.mutate;
        return {
            objects: !data ? data : hydrateObjects(data.roomTypes),
            isLoading: !error && !data,
            isError: error,
            mutate: mutate
        };
    },
    getDependents: function(id, includes) {
        var includeVars = {};
        includes.forEach(function(include) {
            includeVars["with".concat((0,helpers/* uppercaseFirst */.AB)(include))] = true;
        });
        var variables = (0,_object_spread/* default */.Z)({
            id: id
        }, includeVars);
        return graphQLClient/* default.request */.Z.request(ROOM_TYPES_DEPENDENTS_QUERY, variables).then(function(data) {
            return data.groupedDependents;
        });
    },
    useDependents: function(id, includes) {
        var includeVars = {};
        includes.forEach(function(include) {
            includeVars["with".concat((0,helpers/* uppercaseFirst */.AB)(include))] = true;
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
        var variables = (0,react.useMemo)(function() {
            return (0,_object_spread/* default */.Z)({
                id: id
            }, includeVars);
        }, [
            id
        ]);
        var ref = (0,dist/* default */.ZP)([
            ROOM_TYPES_DEPENDENTS_QUERY,
            variables
        ], {
            revalidateOnFocus: false
        }), data = ref.data, error = ref.error, mutate = ref.mutate;
        return {
            data: !data ? data : data.groupedDependents,
            isLoading: !error && !data,
            isError: error,
            mutate: mutate
        };
    },
    createObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(data) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    input: data
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(CREATE_ROOM_TYPE_MUTATION, variables).then(function(data) {
                        return hydrateObject(data.roomType);
                    })
                ];
            });
        });
        return function(data) {
            return _ref.apply(this, arguments);
        };
    }(),
    updateObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(data) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    input: data
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(UPDATE_ROOM_TYPE_MUTATION, variables).then(function(data) {
                        return hydrateObject(data.roomType);
                    })
                ];
            });
        });
        return function(data) {
            return _ref.apply(this, arguments);
        };
    }(),
    deleteObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(DELETE_ROOM_TYPE_MUTATION, variables).then(function(data) {
                        return data.deleteAccommodationRoomType;
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }(),
    forceDeleteObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(FORCE_DELETE_ROOM_TYPE_MUTATION, variables).then(function(data) {
                        return data.forceDeleteAccommodationRoomType;
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }()
};
/* harmony default export */ var repository = (accommodationRoomTypeRepository);

;// CONCATENATED MODULE: ./src/entities/accommodationRoomType/entity.ts


var accommodationRoomTypeEntity = {
    model: model,
    repository: repository
};
/* harmony default export */ var accommodationRoomType_entity = (accommodationRoomTypeEntity);


/***/ }),

/***/ 18334:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ availabilityStatusTenantSettings_entity; }
});

;// CONCATENATED MODULE: ./src/entities/availabilityStatusTenantSettings/graphql.ts
// language=GraphQL
var ALL_AVAILABILITY_STATUS_TENANT_SETTINGS_QUERY = "query Query($withTenant: Boolean = false, $withTenantCms: Boolean = false, $withTenantCmsHomepage: Boolean = false, $withTenantCmsCategories: Boolean = false, $withTenantCmsPages: Boolean = false, $withTenantCmsErrorPage404: Boolean = false, $withTenantCmsErrorPage500: Boolean = false, $withTenantCmsConfig: Boolean = false, $withTenantTravelTypes: Boolean = false, $withTenantTravelTypesImage: Boolean = false, $withTenantEmployees: Boolean = false, $withTenantEmployeesImage: Boolean = false, $withTenantEmailConfig: Boolean = false, $withTenantNewsletterProvider: Boolean = false, $withTenantNewsletterProviderConfig: Boolean = false, $withTenantRedirects: Boolean = false, $withTenantRedirectsFromPage: Boolean = false, $withTenantRedirectsFromTravel: Boolean = false, $withTenantRedirectsToPage: Boolean = false, $withTenantRedirectsToTravel: Boolean = false, $withTenantOnlinePaymentConfig: Boolean = false, $withTenantRatioConfig: Boolean = false, $withTenantContent: Boolean = false, $withTenantPartnerTenants: Boolean = false, $withTenantPartnerTenantsTenant: Boolean = false) {\n  availabilityStatusTenantSettings: allAvailabilityStatusTenantSettings {\n    id\n    tenant @include(if: $withTenant) {\n      id\n      name\n      slug\n      domain\n      externalReference\n      cms @include(if: $withTenantCms) {\n        id\n        homepage @include(if: $withTenantCmsHomepage) {\n          id\n          name\n          onlineStatus\n        }\n        categories @include(if: $withTenantCmsCategories) {\n          id\n          name\n        }\n        pages @include(if: $withTenantCmsPages) {\n          id\n          name\n          onlineStatus\n        }\n        errorPage404 @include(if: $withTenantCmsErrorPage404) {\n          id\n          name\n          onlineStatus\n        }\n        errorPage500 @include(if: $withTenantCmsErrorPage500) {\n          id\n          name\n          onlineStatus\n        }\n        config @include(if: $withTenantCmsConfig) {\n          id\n        }\n      }\n      travelTypes @include(if: $withTenantTravelTypes) {\n        id\n        name\n        description\n        image @include(if: $withTenantTravelTypesImage) {\n          id\n          assetId\n          publicId\n          url\n          resourceType\n          format\n          width\n          height\n          caption\n          title\n          description\n        }\n      }\n      employees @include(if: $withTenantEmployees) {\n        id\n        firstName\n        lastName\n        jobTitle\n        description\n        email\n        image @include(if: $withTenantEmployeesImage) {\n          id\n          assetId\n          publicId\n          url\n          resourceType\n          format\n          width\n          height\n          caption\n          title\n          description\n        }\n        phone\n      }\n      emailConfig @include(if: $withTenantEmailConfig) {\n        id\n        defaultInternalRecipientEmail\n        internalBookingRecipientEmails\n        bookingConfirmationTemplateId\n        bookingConfirmationInternalTemplateId\n        bookingRequestConfirmationTemplateId\n        bookingWaitlistConfirmationTemplateId\n        bookingWaitlistContingentCheckConfirmationTemplateId\n        bookingCustomRequestTemplateId\n        bookingPassportDataReminderTemplateId\n        contactFormTemplateId\n        esimInstallationInfoTemplateId\n      }\n      newsletterProvider @include(if: $withTenantNewsletterProvider) {\n        id\n        provider\n        config @include(if: $withTenantNewsletterProviderConfig) {\n          __typename\n          ... on MailchimpConfig {\n            id\n            apiKey\n            serverPrefix\n            listId\n\n          }\n        }\n      }\n      redirects @include(if: $withTenantRedirects) {\n        id\n        fromType\n        fromUrl\n        fromPage @include(if: $withTenantRedirectsFromPage) {\n          id\n          name\n          onlineStatus\n        }\n        fromTravel @include(if: $withTenantRedirectsFromTravel) {\n          id\n          name\n          isBestseller\n          startDate\n          endDate\n          executionStatus\n          title\n          description\n          includedServices\n          excludedServices\n          pricingTable\n          priceCalculationInfo\n          programType\n          programText\n          minPrice\n          minPriceManualOverride\n          currency\n        }\n        toType\n        toUrl\n        toPage @include(if: $withTenantRedirectsToPage) {\n          id\n          name\n          onlineStatus\n        }\n        toTravel @include(if: $withTenantRedirectsToTravel) {\n          id\n          name\n          isBestseller\n          startDate\n          endDate\n          executionStatus\n          title\n          description\n          includedServices\n          excludedServices\n          pricingTable\n          priceCalculationInfo\n          programType\n          programText\n          minPrice\n          minPriceManualOverride\n          currency\n        }\n      }\n      onlinePaymentConfig @include(if: $withTenantOnlinePaymentConfig) {\n        id\n        enabled\n        ratioFibuAccountNo\n        infoText\n        datatransThemeConfig\n      }\n      ratioConfig @include(if: $withTenantRatioConfig) {\n        id\n        adressgruppe\n      }\n      content @include(if: $withTenantContent) {\n        id\n        bookingInsuranceInfo\n      }\n      partnerTenants @include(if: $withTenantPartnerTenants) {\n        id\n        tenant @include(if: $withTenantPartnerTenantsTenant) {\n          id\n          name\n          slug\n          domain\n          externalReference\n        }\n        filterCrossLinking\n      }\n    }\n    label\n    info\n    switchToStatusInfo\n    submitButtonLabel\n  }\n}";
// language=GraphQL
var SINGLE_AVAILABILITY_STATUS_TENANT_SETTINGS_QUERY = "query Query($id: ID!, $withTenant: Boolean = false, $withTenantCms: Boolean = false, $withTenantCmsHomepage: Boolean = false, $withTenantCmsCategories: Boolean = false, $withTenantCmsPages: Boolean = false, $withTenantCmsErrorPage404: Boolean = false, $withTenantCmsErrorPage500: Boolean = false, $withTenantCmsConfig: Boolean = false, $withTenantTravelTypes: Boolean = false, $withTenantTravelTypesImage: Boolean = false, $withTenantEmployees: Boolean = false, $withTenantEmployeesImage: Boolean = false, $withTenantEmailConfig: Boolean = false, $withTenantNewsletterProvider: Boolean = false, $withTenantNewsletterProviderConfig: Boolean = false, $withTenantRedirects: Boolean = false, $withTenantRedirectsFromPage: Boolean = false, $withTenantRedirectsFromTravel: Boolean = false, $withTenantRedirectsToPage: Boolean = false, $withTenantRedirectsToTravel: Boolean = false, $withTenantOnlinePaymentConfig: Boolean = false, $withTenantRatioConfig: Boolean = false, $withTenantContent: Boolean = false, $withTenantPartnerTenants: Boolean = false, $withTenantPartnerTenantsTenant: Boolean = false) {\n  availabilityStatusTenantSettings: availabilityStatusTenantSettings(id: $id) {\n    id\n    tenant @include(if: $withTenant) {\n      id\n      name\n      slug\n      domain\n      externalReference\n      cms @include(if: $withTenantCms) {\n        id\n        homepage @include(if: $withTenantCmsHomepage) {\n          id\n          name\n          onlineStatus\n        }\n        categories @include(if: $withTenantCmsCategories) {\n          id\n          name\n        }\n        pages @include(if: $withTenantCmsPages) {\n          id\n          name\n          onlineStatus\n        }\n        errorPage404 @include(if: $withTenantCmsErrorPage404) {\n          id\n          name\n          onlineStatus\n        }\n        errorPage500 @include(if: $withTenantCmsErrorPage500) {\n          id\n          name\n          onlineStatus\n        }\n        config @include(if: $withTenantCmsConfig) {\n          id\n        }\n      }\n      travelTypes @include(if: $withTenantTravelTypes) {\n        id\n        name\n        description\n        image @include(if: $withTenantTravelTypesImage) {\n          id\n          assetId\n          publicId\n          url\n          resourceType\n          format\n          width\n          height\n          caption\n          title\n          description\n        }\n      }\n      employees @include(if: $withTenantEmployees) {\n        id\n        firstName\n        lastName\n        jobTitle\n        description\n        email\n        image @include(if: $withTenantEmployeesImage) {\n          id\n          assetId\n          publicId\n          url\n          resourceType\n          format\n          width\n          height\n          caption\n          title\n          description\n        }\n        phone\n      }\n      emailConfig @include(if: $withTenantEmailConfig) {\n        id\n        defaultInternalRecipientEmail\n        internalBookingRecipientEmails\n        bookingConfirmationTemplateId\n        bookingConfirmationInternalTemplateId\n        bookingRequestConfirmationTemplateId\n        bookingWaitlistConfirmationTemplateId\n        bookingWaitlistContingentCheckConfirmationTemplateId\n        bookingCustomRequestTemplateId\n        bookingPassportDataReminderTemplateId\n        contactFormTemplateId\n        esimInstallationInfoTemplateId\n      }\n      newsletterProvider @include(if: $withTenantNewsletterProvider) {\n        id\n        provider\n        config @include(if: $withTenantNewsletterProviderConfig) {\n          __typename\n          ... on MailchimpConfig {\n            id\n            apiKey\n            serverPrefix\n            listId\n\n          }\n        }\n      }\n      redirects @include(if: $withTenantRedirects) {\n        id\n        fromType\n        fromUrl\n        fromPage @include(if: $withTenantRedirectsFromPage) {\n          id\n          name\n          onlineStatus\n        }\n        fromTravel @include(if: $withTenantRedirectsFromTravel) {\n          id\n          name\n          isBestseller\n          startDate\n          endDate\n          executionStatus\n          title\n          description\n          includedServices\n          excludedServices\n          pricingTable\n          priceCalculationInfo\n          programType\n          programText\n          minPrice\n          minPriceManualOverride\n          currency\n        }\n        toType\n        toUrl\n        toPage @include(if: $withTenantRedirectsToPage) {\n          id\n          name\n          onlineStatus\n        }\n        toTravel @include(if: $withTenantRedirectsToTravel) {\n          id\n          name\n          isBestseller\n          startDate\n          endDate\n          executionStatus\n          title\n          description\n          includedServices\n          excludedServices\n          pricingTable\n          priceCalculationInfo\n          programType\n          programText\n          minPrice\n          minPriceManualOverride\n          currency\n        }\n      }\n      onlinePaymentConfig @include(if: $withTenantOnlinePaymentConfig) {\n        id\n        enabled\n        ratioFibuAccountNo\n        infoText\n        datatransThemeConfig\n      }\n      ratioConfig @include(if: $withTenantRatioConfig) {\n        id\n        adressgruppe\n      }\n      content @include(if: $withTenantContent) {\n        id\n        bookingInsuranceInfo\n      }\n      partnerTenants @include(if: $withTenantPartnerTenants) {\n        id\n        tenant @include(if: $withTenantPartnerTenantsTenant) {\n          id\n          name\n          slug\n          domain\n          externalReference\n        }\n        filterCrossLinking\n      }\n    }\n    label\n    info\n    switchToStatusInfo\n    submitButtonLabel\n  }\n}";
// language=GraphQL
var CREATE_AVAILABILITY_STATUS_TENANT_SETTINGS_MUTATION = "\n  mutation Mutation($input: CreateAvailabilityStatusTenantSettingsInput, $withTenant: Boolean = false, $withTenantCms: Boolean = false, $withTenantCmsHomepage: Boolean = false, $withTenantCmsCategories: Boolean = false, $withTenantCmsPages: Boolean = false, $withTenantCmsErrorPage404: Boolean = false, $withTenantCmsErrorPage500: Boolean = false, $withTenantCmsConfig: Boolean = false, $withTenantTravelTypes: Boolean = false, $withTenantTravelTypesImage: Boolean = false, $withTenantEmployees: Boolean = false, $withTenantEmployeesImage: Boolean = false, $withTenantEmailConfig: Boolean = false, $withTenantNewsletterProvider: Boolean = false, $withTenantNewsletterProviderConfig: Boolean = false, $withTenantRedirects: Boolean = false, $withTenantRedirectsFromPage: Boolean = false, $withTenantRedirectsFromTravel: Boolean = false, $withTenantRedirectsToPage: Boolean = false, $withTenantRedirectsToTravel: Boolean = false, $withTenantOnlinePaymentConfig: Boolean = false, $withTenantRatioConfig: Boolean = false, $withTenantContent: Boolean = false, $withTenantPartnerTenants: Boolean = false, $withTenantPartnerTenantsTenant: Boolean = false) {\n    availabilityStatusTenantSettings: createAvailabilityStatusTenantSettings(input: $input) {\n      id\n      tenant @include(if: $withTenant) {\n        id\n        name\n        slug\n        domain\n        externalReference\n        cms @include(if: $withTenantCms) {\n          id\n          homepage @include(if: $withTenantCmsHomepage) {\n            id\n            name\n            onlineStatus\n          }\n          categories @include(if: $withTenantCmsCategories) {\n            id\n            name\n          }\n          pages @include(if: $withTenantCmsPages) {\n            id\n            name\n            onlineStatus\n          }\n          errorPage404 @include(if: $withTenantCmsErrorPage404) {\n            id\n            name\n            onlineStatus\n          }\n          errorPage500 @include(if: $withTenantCmsErrorPage500) {\n            id\n            name\n            onlineStatus\n          }\n          config @include(if: $withTenantCmsConfig) {\n            id\n          }\n        }\n        travelTypes @include(if: $withTenantTravelTypes) {\n          id\n          name\n          description\n          image @include(if: $withTenantTravelTypesImage) {\n            id\n            assetId\n            publicId\n            url\n            resourceType\n            format\n            width\n            height\n            caption\n            title\n            description\n          }\n        }\n        employees @include(if: $withTenantEmployees) {\n          id\n          firstName\n          lastName\n          jobTitle\n          description\n          email\n          image @include(if: $withTenantEmployeesImage) {\n            id\n            assetId\n            publicId\n            url\n            resourceType\n            format\n            width\n            height\n            caption\n            title\n            description\n          }\n          phone\n        }\n        emailConfig @include(if: $withTenantEmailConfig) {\n          id\n          defaultInternalRecipientEmail\n          internalBookingRecipientEmails\n          bookingConfirmationTemplateId\n          bookingConfirmationInternalTemplateId\n          bookingRequestConfirmationTemplateId\n          bookingWaitlistConfirmationTemplateId\n          bookingWaitlistContingentCheckConfirmationTemplateId\n          bookingCustomRequestTemplateId\n          bookingPassportDataReminderTemplateId\n          contactFormTemplateId\n          esimInstallationInfoTemplateId\n        }\n        newsletterProvider @include(if: $withTenantNewsletterProvider) {\n          id\n          provider\n          config @include(if: $withTenantNewsletterProviderConfig) {\n            __typename\n            ... on MailchimpConfig {\n              id\n              apiKey\n              serverPrefix\n              listId\n\n            }\n          }\n        }\n        redirects @include(if: $withTenantRedirects) {\n          id\n          fromType\n          fromUrl\n          fromPage @include(if: $withTenantRedirectsFromPage) {\n            id\n            name\n            onlineStatus\n          }\n          fromTravel @include(if: $withTenantRedirectsFromTravel) {\n            id\n            name\n            isBestseller\n            startDate\n            endDate\n            executionStatus\n            title\n            description\n            includedServices\n            excludedServices\n            pricingTable\n            priceCalculationInfo\n            programType\n            programText\n            minPrice\n            minPriceManualOverride\n            currency\n          }\n          toType\n          toUrl\n          toPage @include(if: $withTenantRedirectsToPage) {\n            id\n            name\n            onlineStatus\n          }\n          toTravel @include(if: $withTenantRedirectsToTravel) {\n            id\n            name\n            isBestseller\n            startDate\n            endDate\n            executionStatus\n            title\n            description\n            includedServices\n            excludedServices\n            pricingTable\n            priceCalculationInfo\n            programType\n            programText\n            minPrice\n            minPriceManualOverride\n            currency\n          }\n        }\n        onlinePaymentConfig @include(if: $withTenantOnlinePaymentConfig) {\n          id\n          enabled\n          ratioFibuAccountNo\n          infoText\n          datatransThemeConfig\n        }\n        ratioConfig @include(if: $withTenantRatioConfig) {\n          id\n          adressgruppe\n        }\n        content @include(if: $withTenantContent) {\n          id\n          bookingInsuranceInfo\n        }\n        partnerTenants @include(if: $withTenantPartnerTenants) {\n          id\n          tenant @include(if: $withTenantPartnerTenantsTenant) {\n            id\n            name\n            slug\n            domain\n            externalReference\n          }\n          filterCrossLinking\n        }\n      }\n      label\n      info\n      switchToStatusInfo\n      submitButtonLabel\n    }\n  }";
// language=GraphQL
var UPDATE_AVAILABILITY_STATUS_TENANT_SETTINGS_MUTATION = "\n  mutation Mutation($input: UpdateAvailabilityStatusTenantSettingsInput, $withTenant: Boolean = false, $withTenantCms: Boolean = false, $withTenantCmsHomepage: Boolean = false, $withTenantCmsCategories: Boolean = false, $withTenantCmsPages: Boolean = false, $withTenantCmsErrorPage404: Boolean = false, $withTenantCmsErrorPage500: Boolean = false, $withTenantCmsConfig: Boolean = false, $withTenantTravelTypes: Boolean = false, $withTenantTravelTypesImage: Boolean = false, $withTenantEmployees: Boolean = false, $withTenantEmployeesImage: Boolean = false, $withTenantEmailConfig: Boolean = false, $withTenantNewsletterProvider: Boolean = false, $withTenantNewsletterProviderConfig: Boolean = false, $withTenantRedirects: Boolean = false, $withTenantRedirectsFromPage: Boolean = false, $withTenantRedirectsFromTravel: Boolean = false, $withTenantRedirectsToPage: Boolean = false, $withTenantRedirectsToTravel: Boolean = false, $withTenantOnlinePaymentConfig: Boolean = false, $withTenantRatioConfig: Boolean = false, $withTenantContent: Boolean = false, $withTenantPartnerTenants: Boolean = false, $withTenantPartnerTenantsTenant: Boolean = false) {\n    availabilityStatusTenantSettings: updateAvailabilityStatusTenantSettings(input: $input) {\n      id\n      tenant @include(if: $withTenant) {\n        id\n        name\n        slug\n        domain\n        externalReference\n        cms @include(if: $withTenantCms) {\n          id\n          homepage @include(if: $withTenantCmsHomepage) {\n            id\n            name\n            onlineStatus\n          }\n          categories @include(if: $withTenantCmsCategories) {\n            id\n            name\n          }\n          pages @include(if: $withTenantCmsPages) {\n            id\n            name\n            onlineStatus\n          }\n          errorPage404 @include(if: $withTenantCmsErrorPage404) {\n            id\n            name\n            onlineStatus\n          }\n          errorPage500 @include(if: $withTenantCmsErrorPage500) {\n            id\n            name\n            onlineStatus\n          }\n          config @include(if: $withTenantCmsConfig) {\n            id\n          }\n        }\n        travelTypes @include(if: $withTenantTravelTypes) {\n          id\n          name\n          description\n          image @include(if: $withTenantTravelTypesImage) {\n            id\n            assetId\n            publicId\n            url\n            resourceType\n            format\n            width\n            height\n            caption\n            title\n            description\n          }\n        }\n        employees @include(if: $withTenantEmployees) {\n          id\n          firstName\n          lastName\n          jobTitle\n          description\n          email\n          image @include(if: $withTenantEmployeesImage) {\n            id\n            assetId\n            publicId\n            url\n            resourceType\n            format\n            width\n            height\n            caption\n            title\n            description\n          }\n          phone\n        }\n        emailConfig @include(if: $withTenantEmailConfig) {\n          id\n          defaultInternalRecipientEmail\n          internalBookingRecipientEmails\n          bookingConfirmationTemplateId\n          bookingConfirmationInternalTemplateId\n          bookingRequestConfirmationTemplateId\n          bookingWaitlistConfirmationTemplateId\n          bookingWaitlistContingentCheckConfirmationTemplateId\n          bookingCustomRequestTemplateId\n          bookingPassportDataReminderTemplateId\n          contactFormTemplateId\n          esimInstallationInfoTemplateId\n        }\n        newsletterProvider @include(if: $withTenantNewsletterProvider) {\n          id\n          provider\n          config @include(if: $withTenantNewsletterProviderConfig) {\n            __typename\n            ... on MailchimpConfig {\n              id\n              apiKey\n              serverPrefix\n              listId\n\n            }\n          }\n        }\n        redirects @include(if: $withTenantRedirects) {\n          id\n          fromType\n          fromUrl\n          fromPage @include(if: $withTenantRedirectsFromPage) {\n            id\n            name\n            onlineStatus\n          }\n          fromTravel @include(if: $withTenantRedirectsFromTravel) {\n            id\n            name\n            isBestseller\n            startDate\n            endDate\n            executionStatus\n            title\n            description\n            includedServices\n            excludedServices\n            pricingTable\n            priceCalculationInfo\n            programType\n            programText\n            minPrice\n            minPriceManualOverride\n            currency\n          }\n          toType\n          toUrl\n          toPage @include(if: $withTenantRedirectsToPage) {\n            id\n            name\n            onlineStatus\n          }\n          toTravel @include(if: $withTenantRedirectsToTravel) {\n            id\n            name\n            isBestseller\n            startDate\n            endDate\n            executionStatus\n            title\n            description\n            includedServices\n            excludedServices\n            pricingTable\n            priceCalculationInfo\n            programType\n            programText\n            minPrice\n            minPriceManualOverride\n            currency\n          }\n        }\n        onlinePaymentConfig @include(if: $withTenantOnlinePaymentConfig) {\n          id\n          enabled\n          ratioFibuAccountNo\n          infoText\n          datatransThemeConfig\n        }\n        ratioConfig @include(if: $withTenantRatioConfig) {\n          id\n          adressgruppe\n        }\n        content @include(if: $withTenantContent) {\n          id\n          bookingInsuranceInfo\n        }\n        partnerTenants @include(if: $withTenantPartnerTenants) {\n          id\n          tenant @include(if: $withTenantPartnerTenantsTenant) {\n            id\n            name\n            slug\n            domain\n            externalReference\n          }\n          filterCrossLinking\n        }\n      }\n      label\n      info\n      switchToStatusInfo\n      submitButtonLabel\n    }\n  }";
// language=GraphQL
var DELETE_AVAILABILITY_STATUS_TENANT_SETTINGS_MUTATION = "\n  mutation Mutation($input: DeleteAvailabilityStatusTenantSettingsInput) {\n    deleteAvailabilityStatusTenantSettings(input: $input) {\n      success\n    }\n  }";
// language=GraphQL
var FORCE_DELETE_AVAILABILITY_STATUS_TENANT_SETTINGS_MUTATION = "\n  mutation Mutation($input: DeleteAvailabilityStatusTenantSettingsInput) {\n    forceDeleteAvailabilityStatusTenantSettings(input: $input) {\n      success\n    }\n  }";
// language=GraphQL
var AVAILABILITY_STATUS_TENANT_SETTINGS_DEPENDENTS_QUERY = "query Query($id: ID!, $withTravelAvailabilityStatus: Boolean = false) {\n  groupedDependents: availabilityStatusTenantSettingsDependents(id: $id) {\n    travelAvailabilityStatus @include(if: $withTravelAvailabilityStatus) {\n      id\n      label\n      status\n      isDefaultStatus\n      isDefaultWaitlistFallback\n    }\n  }\n}";

// EXTERNAL MODULE: ./src/entities/tenant/entity.ts + 3 modules
var entity = __webpack_require__(57850);
;// CONCATENATED MODULE: ./src/entities/availabilityStatusTenantSettings/model.ts


var availabilityStatusTenantSettingsModel = {
    name: "availabilityStatusTenantSettings",
    namePlural: "availabilityStatusTenantSettings",
    uniqueName: "availabilityStatusTenantSettings",
    uniqueNamePlural: "availabilityStatusTenantSettings",
    path: "travel/availability_status_tenant_settings",
    baseUrl: "/travel/availability_status_tenant_settings",
    translationPrefix: "entities:availabilityStatusTenantSettings.",
    getDisplayName: function(values) {
        return values.label;
    },
    gql: {
        getAll: ALL_AVAILABILITY_STATUS_TENANT_SETTINGS_QUERY,
        getSingle: SINGLE_AVAILABILITY_STATUS_TENANT_SETTINGS_QUERY,
        create: CREATE_AVAILABILITY_STATUS_TENANT_SETTINGS_MUTATION,
        update: UPDATE_AVAILABILITY_STATUS_TENANT_SETTINGS_MUTATION,
        delete: DELETE_AVAILABILITY_STATUS_TENANT_SETTINGS_MUTATION,
        forceDelete: FORCE_DELETE_AVAILABILITY_STATUS_TENANT_SETTINGS_MUTATION
    },
    attributes: {
        tenant: {
            name: "tenant",
            label: "entities:availabilityStatusTenantSettings.attributes.tenant.label",
            type: "entityObject",
            dataType: "any",
            getEntity: function() {
                return entity/* default */.Z;
            },
            defaultInput: false,
            inputType: "select",
            validationType: "string",
            validations: [
                {
                    type: "required"
                }, 
            ]
        },
        label: {
            name: "label",
            label: "entities:availabilityStatusTenantSettings.attributes.label.label",
            type: "value",
            dataType: "string",
            defaultInput: true,
            inputType: "text",
            validationType: "string",
            validations: []
        },
        info: {
            name: "info",
            label: "entities:availabilityStatusTenantSettings.attributes.info.label",
            type: "value",
            dataType: "string",
            defaultInput: true,
            inputType: "textarea",
            validationType: "string",
            validations: []
        },
        switchToStatusInfo: {
            name: "switchToStatusInfo",
            label: "entities:availabilityStatusTenantSettings.attributes.switchToStatusInfo.label",
            type: "value",
            dataType: "string",
            defaultInput: true,
            inputType: "textarea",
            validationType: "string",
            validations: []
        },
        submitButtonLabel: {
            name: "submitButtonLabel",
            label: "entities:availabilityStatusTenantSettings.attributes.submitButtonLabel.label",
            type: "value",
            dataType: "string",
            defaultInput: true,
            inputType: "text",
            maxLength: 15,
            validationType: "string",
            validations: []
        }
    }
};
/* harmony default export */ var model = (availabilityStatusTenantSettingsModel);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(20414);
// EXTERNAL MODULE: ./src/entities/lib.ts
var lib = __webpack_require__(23480);
// EXTERNAL MODULE: ./src/lib/api/graphQLClient.ts
var graphQLClient = __webpack_require__(40112);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/swr/dist/index.mjs
var dist = __webpack_require__(8100);
// EXTERNAL MODULE: ./src/lib/helpers/helpers.ts
var helpers = __webpack_require__(15778);
;// CONCATENATED MODULE: ./src/entities/availabilityStatusTenantSettings/repository.ts










var hydrateObjects = function(objects) {
    return objects.map(function(object) {
        return (0,lib/* hydrateEntityObject */.b)(model, object);
    });
};
var hydrateObject = function(object) {
    return (0,lib/* hydrateEntityObject */.b)(model, object);
};
var availabilityStatusTenantSettingsRepository = {
    getObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    id: id
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(SINGLE_AVAILABILITY_STATUS_TENANT_SETTINGS_QUERY, variables).then(function(data) {
                        return hydrateObject(data.availabilityStatusTenantSettings);
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }(),
    getObjects: /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        var includes;
        var _arguments = arguments;
        return (0,tslib_es6.__generator)(this, function(_state) {
            includes = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : {};
            return [
                2,
                graphQLClient/* default.request */.Z.request(ALL_AVAILABILITY_STATUS_TENANT_SETTINGS_QUERY, includes).then(function(data) {
                    return hydrateObjects(data.availabilityStatusTenantSettings);
                })
            ];
        });
    }),
    useObject: function(id) {
        var includes = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        // eslint-disable-next-line react-hooks/exhaustive-deps
        var variables = (0,react.useMemo)(function() {
            return (0,_object_spread/* default */.Z)({
                id: id
            }, includes);
        }, [
            id
        ]);
        var ref = (0,dist/* default */.ZP)([
            SINGLE_AVAILABILITY_STATUS_TENANT_SETTINGS_QUERY,
            variables
        ], {
            revalidateOnFocus: false
        }), data = ref.data, error = ref.error, mutate = ref.mutate;
        return {
            object: !data ? data : hydrateObject(data.availabilityStatusTenantSettings),
            isLoading: !error && !data,
            isError: error,
            mutate: mutate
        };
    },
    useObjects: function() {
        var includes = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        // eslint-disable-next-line react-hooks/exhaustive-deps
        var variables = (0,react.useMemo)(function() {
            return includes;
        }, []);
        var ref = (0,dist/* default */.ZP)([
            ALL_AVAILABILITY_STATUS_TENANT_SETTINGS_QUERY,
            variables
        ]), data = ref.data, error = ref.error, mutate = ref.mutate;
        return {
            objects: !data ? data : hydrateObjects(data.availabilityStatusTenantSettings),
            isLoading: !error && !data,
            isError: error,
            mutate: mutate
        };
    },
    getDependents: function(id, includes) {
        var includeVars = {};
        includes.forEach(function(include) {
            includeVars["with".concat((0,helpers/* uppercaseFirst */.AB)(include))] = true;
        });
        var variables = (0,_object_spread/* default */.Z)({
            id: id
        }, includeVars);
        return graphQLClient/* default.request */.Z.request(AVAILABILITY_STATUS_TENANT_SETTINGS_DEPENDENTS_QUERY, variables).then(function(data) {
            return data.groupedDependents;
        });
    },
    useDependents: function(id, includes) {
        var includeVars = {};
        includes.forEach(function(include) {
            includeVars["with".concat((0,helpers/* uppercaseFirst */.AB)(include))] = true;
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
        var variables = (0,react.useMemo)(function() {
            return (0,_object_spread/* default */.Z)({
                id: id
            }, includeVars);
        }, [
            id
        ]);
        var ref = (0,dist/* default */.ZP)([
            AVAILABILITY_STATUS_TENANT_SETTINGS_DEPENDENTS_QUERY,
            variables
        ], {
            revalidateOnFocus: false
        }), data = ref.data, error = ref.error, mutate = ref.mutate;
        return {
            data: !data ? data : data.groupedDependents,
            isLoading: !error && !data,
            isError: error,
            mutate: mutate
        };
    },
    createObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(data) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    input: data
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(CREATE_AVAILABILITY_STATUS_TENANT_SETTINGS_MUTATION, variables).then(function(data) {
                        return hydrateObject(data.availabilityStatusTenantSettings);
                    })
                ];
            });
        });
        return function(data) {
            return _ref.apply(this, arguments);
        };
    }(),
    updateObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(data) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    input: data
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(UPDATE_AVAILABILITY_STATUS_TENANT_SETTINGS_MUTATION, variables).then(function(data) {
                        return hydrateObject(data.availabilityStatusTenantSettings);
                    })
                ];
            });
        });
        return function(data) {
            return _ref.apply(this, arguments);
        };
    }(),
    deleteObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(DELETE_AVAILABILITY_STATUS_TENANT_SETTINGS_MUTATION, variables).then(function(data) {
                        return data.deleteAvailabilityStatusTenantSettings;
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }(),
    forceDeleteObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(FORCE_DELETE_AVAILABILITY_STATUS_TENANT_SETTINGS_MUTATION, variables).then(function(data) {
                        return data.forceDeleteAvailabilityStatusTenantSettings;
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }()
};
/* harmony default export */ var repository = (availabilityStatusTenantSettingsRepository);

;// CONCATENATED MODULE: ./src/entities/availabilityStatusTenantSettings/entity.ts


var availabilityStatusTenantSettingsEntity = {
    model: model,
    repository: repository
};
/* harmony default export */ var availabilityStatusTenantSettings_entity = (availabilityStatusTenantSettingsEntity);


/***/ }),

/***/ 90101:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ entity; }
});

;// CONCATENATED MODULE: ./src/entities/bargainTier/graphql.ts
// language=GraphQL
var ALL_TIERS_QUERY = "query Query {\n  tiers: bargainTiers {\n    id\n    fromPrice\n    discount\n  }\n}";
// language=GraphQL
var SINGLE_TIER_QUERY = "query Query($id: ID!) {\n  tier: bargainTier(id: $id) {\n    id\n    fromPrice\n    discount\n  }\n}";
// language=GraphQL
var CREATE_TIER_MUTATION = "\n  mutation Mutation($input: CreateBargainTierInput) {\n    tier: createBargainTier(input: $input) {\n      id\n      fromPrice\n      discount\n    }\n  }";
// language=GraphQL
var UPDATE_TIER_MUTATION = "\n  mutation Mutation($input: UpdateBargainTierInput) {\n    tier: updateBargainTier(input: $input) {\n      id\n      fromPrice\n      discount\n    }\n  }";
// language=GraphQL
var DELETE_TIER_MUTATION = "\n  mutation Mutation($input: DeleteBargainTierInput) {\n    deleteBargainTier(input: $input) {\n      success\n    }\n  }";
// language=GraphQL
var FORCE_DELETE_TIER_MUTATION = "\n  mutation Mutation($input: DeleteBargainTierInput) {\n    forceDeleteBargainTier(input: $input) {\n      success\n    }\n  }";
// language=GraphQL
var TIERS_DEPENDENTS_QUERY = "query Query($id: ID!, $withTravelBargainSettings: Boolean = false, $withRatioBargainConfigs: Boolean = false) {\n  groupedDependents: bargainTierDependents(id: $id) {\n    travelBargainSettings @include(if: $withTravelBargainSettings) {\n      id\n      active\n      untilDaysBeforeStart\n    }\n    ratioBargainConfigs @include(if: $withRatioBargainConfigs) {\n      id\n      active\n      priceCap\n      serviceCodePrefix    }\n  }\n}";

;// CONCATENATED MODULE: ./src/entities/bargainTier/model.ts

var bargainTierModel = {
    name: "tier",
    namePlural: "tiers",
    uniqueName: "bargainTier",
    uniqueNamePlural: "bargainTiers",
    path: "config/ratio/bargain/tier",
    baseUrl: "/config/ratio/bargain/tiers",
    translationPrefix: "entities:bargainTier.",
    getDisplayName: function(values) {
        return "".concat(values.fromPrice, ".- | ").concat(values.discount, ".-");
    },
    gql: {
        getAll: ALL_TIERS_QUERY,
        getSingle: SINGLE_TIER_QUERY,
        create: CREATE_TIER_MUTATION,
        update: UPDATE_TIER_MUTATION,
        delete: DELETE_TIER_MUTATION,
        forceDelete: FORCE_DELETE_TIER_MUTATION
    },
    attributes: {
        fromPrice: {
            name: "fromPrice",
            label: "entities:bargainTier.attributes.fromPrice.label",
            type: "value",
            dataType: "number",
            defaultInput: true,
            inputType: "number",
            validationType: "string",
            validations: [
                {
                    type: "required"
                },
                {
                    type: "number"
                }, 
            ]
        },
        discount: {
            name: "discount",
            label: "entities:bargainTier.attributes.discount.label",
            type: "value",
            dataType: "number",
            defaultInput: true,
            inputType: "number",
            validationType: "string",
            validations: [
                {
                    type: "required"
                },
                {
                    type: "number"
                }, 
            ]
        }
    }
};
/* harmony default export */ var model = (bargainTierModel);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(20414);
// EXTERNAL MODULE: ./src/entities/lib.ts
var lib = __webpack_require__(23480);
// EXTERNAL MODULE: ./src/lib/api/graphQLClient.ts
var graphQLClient = __webpack_require__(40112);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/swr/dist/index.mjs
var dist = __webpack_require__(8100);
// EXTERNAL MODULE: ./src/lib/helpers/helpers.ts
var helpers = __webpack_require__(15778);
;// CONCATENATED MODULE: ./src/entities/bargainTier/repository.ts










var hydrateObjects = function(objects) {
    return objects.map(function(object) {
        return (0,lib/* hydrateEntityObject */.b)(model, object);
    });
};
var hydrateObject = function(object) {
    return (0,lib/* hydrateEntityObject */.b)(model, object);
};
var bargainTierRepository = {
    getObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    id: id
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(SINGLE_TIER_QUERY, variables).then(function(data) {
                        return hydrateObject(data.tier);
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }(),
    getObjects: /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        var includes;
        var _arguments = arguments;
        return (0,tslib_es6.__generator)(this, function(_state) {
            includes = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : {};
            return [
                2,
                graphQLClient/* default.request */.Z.request(ALL_TIERS_QUERY, includes).then(function(data) {
                    return hydrateObjects(data.tiers);
                })
            ];
        });
    }),
    useObject: function(id) {
        var includes = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        // eslint-disable-next-line react-hooks/exhaustive-deps
        var variables = (0,react.useMemo)(function() {
            return (0,_object_spread/* default */.Z)({
                id: id
            }, includes);
        }, [
            id
        ]);
        var ref = (0,dist/* default */.ZP)([
            SINGLE_TIER_QUERY,
            variables
        ], {
            revalidateOnFocus: false
        }), data = ref.data, error = ref.error, mutate = ref.mutate;
        return {
            object: !data ? data : hydrateObject(data.tier),
            isLoading: !error && !data,
            isError: error,
            mutate: mutate
        };
    },
    useObjects: function() {
        var includes = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        // eslint-disable-next-line react-hooks/exhaustive-deps
        var variables = (0,react.useMemo)(function() {
            return includes;
        }, []);
        var ref = (0,dist/* default */.ZP)([
            ALL_TIERS_QUERY,
            variables
        ]), data = ref.data, error = ref.error, mutate = ref.mutate;
        return {
            objects: !data ? data : hydrateObjects(data.tiers),
            isLoading: !error && !data,
            isError: error,
            mutate: mutate
        };
    },
    getDependents: function(id, includes) {
        var includeVars = {};
        includes.forEach(function(include) {
            includeVars["with".concat((0,helpers/* uppercaseFirst */.AB)(include))] = true;
        });
        var variables = (0,_object_spread/* default */.Z)({
            id: id
        }, includeVars);
        return graphQLClient/* default.request */.Z.request(TIERS_DEPENDENTS_QUERY, variables).then(function(data) {
            return data.groupedDependents;
        });
    },
    useDependents: function(id, includes) {
        var includeVars = {};
        includes.forEach(function(include) {
            includeVars["with".concat((0,helpers/* uppercaseFirst */.AB)(include))] = true;
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
        var variables = (0,react.useMemo)(function() {
            return (0,_object_spread/* default */.Z)({
                id: id
            }, includeVars);
        }, [
            id
        ]);
        var ref = (0,dist/* default */.ZP)([
            TIERS_DEPENDENTS_QUERY,
            variables
        ], {
            revalidateOnFocus: false
        }), data = ref.data, error = ref.error, mutate = ref.mutate;
        return {
            data: !data ? data : data.groupedDependents,
            isLoading: !error && !data,
            isError: error,
            mutate: mutate
        };
    },
    createObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(data) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    input: data
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(CREATE_TIER_MUTATION, variables).then(function(data) {
                        return hydrateObject(data.tier);
                    })
                ];
            });
        });
        return function(data) {
            return _ref.apply(this, arguments);
        };
    }(),
    updateObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(data) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    input: data
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(UPDATE_TIER_MUTATION, variables).then(function(data) {
                        return hydrateObject(data.tier);
                    })
                ];
            });
        });
        return function(data) {
            return _ref.apply(this, arguments);
        };
    }(),
    deleteObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(DELETE_TIER_MUTATION, variables).then(function(data) {
                        return data.deleteBargainTier;
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }(),
    forceDeleteObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(FORCE_DELETE_TIER_MUTATION, variables).then(function(data) {
                        return data.forceDeleteBargainTier;
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }()
};
/* harmony default export */ var repository = (bargainTierRepository);

;// CONCATENATED MODULE: ./src/entities/bargainTier/entity.ts


var bargainTierEntity = {
    model: model,
    repository: repository
};
/* harmony default export */ var entity = (bargainTierEntity);


/***/ }),

/***/ 4377:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ cmsCategory_entity; }
});

;// CONCATENATED MODULE: ./src/entities/cmsCategory/graphql.ts
// language=GraphQL
var ALL_CATEGORIES_QUERY = "query Query($withPages: Boolean = false, $withPagesSeoSettings: Boolean = false, $withPagesSeoSettingsOgImage: Boolean = false, $withPagesContentBlockAssignments: Boolean = false, $withPagesContentBlockAssignmentsBlock: Boolean = false, $withSeoSettings: Boolean = false, $withSeoSettingsOgImage: Boolean = false) {\n  categories: cmsCategories {\n    id\n    name\n    pages @include(if: $withPages) {\n      id\n      name\n      onlineStatus\n      seoSettings @include(if: $withPagesSeoSettings) {\n        id\n        urlSlug\n        metaTitle\n        metaDescription\n        ogTitle\n        ogDescription\n        ogImage @include(if: $withPagesSeoSettingsOgImage) {\n          id\n          assetId\n          publicId\n          url\n          resourceType\n          format\n          width\n          height\n          caption\n          title\n          description\n        }\n      }\n      contentBlockAssignments @include(if: $withPagesContentBlockAssignments) {\n        id\n        type\n        block @include(if: $withPagesContentBlockAssignmentsBlock) {\n          __typename\n          ... on CmsTextBlock {\n            id\n            text\n\n          }\n          ... on CmsTextWithImageBlock {\n            id\n            title\n            subtitle\n            text\n            imagePosition\n            imageFixedAspectRatio\n\n          }\n          ... on CmsPageHeaderBlock {\n            id\n            title\n            text\n\n          }\n          ... on CmsWysiwygBlock {\n            id\n            html\n\n          }\n          ... on CmsHeadingBlock {\n            id\n            importance\n            heading\n            addon\n            decoration\n\n          }\n          ... on CmsTextWithIconBlock {\n            id\n            title\n            text\n            imagePosition\n\n          }\n          ... on CmsAccordionBlock {\n            id\n\n          }\n          ... on CmsGridBlock {\n            id\n\n          }\n          ... on CmsImageBlock {\n            id\n            text\n            fluid\n\n          }\n          ... on CmsEmployeesBlock {\n            id\n\n          }\n          ... on CmsContactBannerBlock {\n            id\n            phone\n            email\n\n          }\n          ... on CmsNewsletterRegisterBlock {\n            id\n            fluid\n\n          }\n          ... on CmsIssuuCatalogBlock {\n            id\n            publicationCode\n            accountName\n\n          }\n          ... on CmsFormBlock {\n            id\n            formName\n\n          }\n          ... on CmsHeaderSliderBlock {\n            id\n\n          }\n          ... on CmsBestsellerSliderBlock {\n            id\n            fluid\n\n          }\n          ... on CmsFilterLeadBlock {\n            id\n            layout\n\n          }\n          ... on CmsTravelTypesBlock {\n            id\n            layout\n\n          }\n          ... on CmsPrefilteredTravelsBlock {\n            id\n            maxResults\n\n          }\n          ... on CmsDividerBlock {\n            id\n            fluid\n\n          }\n          ... on CmsTravelSelectionBlock {\n            id\n\n          }\n          ... on CmsIframeBlock {\n            id\n            url\n            minHeight\n\n          }\n          ... on CmsSliderBlock {\n            id\n            fluid\n            size\n            showDots\n            showArrows\n            showLightbox\n            autoplay\n\n          }\n          ... on CmsDestinationsBlock {\n            id\n\n          }\n          ... on CmsTravelGuidesBlock {\n            id\n\n          }\n          ... on CmsBusfinderBlock {\n            id\n            title\n\n          }\n          ... on CmsBackgroundBlock {\n            id\n            backgroundVariant\n\n          }\n        }\n      }\n    }\n    seoSettings @include(if: $withSeoSettings) {\n      id\n      urlSlug\n      metaTitle\n      metaDescription\n      ogTitle\n      ogDescription\n      ogImage @include(if: $withSeoSettingsOgImage) {\n        id\n        assetId\n        publicId\n        url\n        resourceType\n        format\n        width\n        height\n        caption\n        title\n        description\n      }\n    }\n  }\n}";
// language=GraphQL
var SINGLE_CATEGORY_QUERY = "query Query($id: ID!, $withPages: Boolean = false, $withPagesSeoSettings: Boolean = false, $withPagesSeoSettingsOgImage: Boolean = false, $withPagesContentBlockAssignments: Boolean = false, $withPagesContentBlockAssignmentsBlock: Boolean = false, $withSeoSettings: Boolean = false, $withSeoSettingsOgImage: Boolean = false) {\n  category: cmsCategory(id: $id) {\n    id\n    name\n    pages @include(if: $withPages) {\n      id\n      name\n      onlineStatus\n      seoSettings @include(if: $withPagesSeoSettings) {\n        id\n        urlSlug\n        metaTitle\n        metaDescription\n        ogTitle\n        ogDescription\n        ogImage @include(if: $withPagesSeoSettingsOgImage) {\n          id\n          assetId\n          publicId\n          url\n          resourceType\n          format\n          width\n          height\n          caption\n          title\n          description\n        }\n      }\n      contentBlockAssignments @include(if: $withPagesContentBlockAssignments) {\n        id\n        type\n        block @include(if: $withPagesContentBlockAssignmentsBlock) {\n          __typename\n          ... on CmsTextBlock {\n            id\n            text\n\n          }\n          ... on CmsTextWithImageBlock {\n            id\n            title\n            subtitle\n            text\n            imagePosition\n            imageFixedAspectRatio\n\n          }\n          ... on CmsPageHeaderBlock {\n            id\n            title\n            text\n\n          }\n          ... on CmsWysiwygBlock {\n            id\n            html\n\n          }\n          ... on CmsHeadingBlock {\n            id\n            importance\n            heading\n            addon\n            decoration\n\n          }\n          ... on CmsTextWithIconBlock {\n            id\n            title\n            text\n            imagePosition\n\n          }\n          ... on CmsAccordionBlock {\n            id\n\n          }\n          ... on CmsGridBlock {\n            id\n\n          }\n          ... on CmsImageBlock {\n            id\n            text\n            fluid\n\n          }\n          ... on CmsEmployeesBlock {\n            id\n\n          }\n          ... on CmsContactBannerBlock {\n            id\n            phone\n            email\n\n          }\n          ... on CmsNewsletterRegisterBlock {\n            id\n            fluid\n\n          }\n          ... on CmsIssuuCatalogBlock {\n            id\n            publicationCode\n            accountName\n\n          }\n          ... on CmsFormBlock {\n            id\n            formName\n\n          }\n          ... on CmsHeaderSliderBlock {\n            id\n\n          }\n          ... on CmsBestsellerSliderBlock {\n            id\n            fluid\n\n          }\n          ... on CmsFilterLeadBlock {\n            id\n            layout\n\n          }\n          ... on CmsTravelTypesBlock {\n            id\n            layout\n\n          }\n          ... on CmsPrefilteredTravelsBlock {\n            id\n            maxResults\n\n          }\n          ... on CmsDividerBlock {\n            id\n            fluid\n\n          }\n          ... on CmsTravelSelectionBlock {\n            id\n\n          }\n          ... on CmsIframeBlock {\n            id\n            url\n            minHeight\n\n          }\n          ... on CmsSliderBlock {\n            id\n            fluid\n            size\n            showDots\n            showArrows\n            showLightbox\n            autoplay\n\n          }\n          ... on CmsDestinationsBlock {\n            id\n\n          }\n          ... on CmsTravelGuidesBlock {\n            id\n\n          }\n          ... on CmsBusfinderBlock {\n            id\n            title\n\n          }\n          ... on CmsBackgroundBlock {\n            id\n            backgroundVariant\n\n          }\n        }\n      }\n    }\n    seoSettings @include(if: $withSeoSettings) {\n      id\n      urlSlug\n      metaTitle\n      metaDescription\n      ogTitle\n      ogDescription\n      ogImage @include(if: $withSeoSettingsOgImage) {\n        id\n        assetId\n        publicId\n        url\n        resourceType\n        format\n        width\n        height\n        caption\n        title\n        description\n      }\n    }\n  }\n}";
// language=GraphQL
var CREATE_CATEGORY_MUTATION = "\n  mutation Mutation($input: CreateCmsCategoryInput, $withPages: Boolean = false, $withPagesSeoSettings: Boolean = false, $withPagesSeoSettingsOgImage: Boolean = false, $withPagesContentBlockAssignments: Boolean = false, $withPagesContentBlockAssignmentsBlock: Boolean = false, $withSeoSettings: Boolean = false, $withSeoSettingsOgImage: Boolean = false) {\n    category: createCmsCategory(input: $input) {\n      id\n      name\n      pages @include(if: $withPages) {\n        id\n        name\n        onlineStatus\n        seoSettings @include(if: $withPagesSeoSettings) {\n          id\n          urlSlug\n          metaTitle\n          metaDescription\n          ogTitle\n          ogDescription\n          ogImage @include(if: $withPagesSeoSettingsOgImage) {\n            id\n            assetId\n            publicId\n            url\n            resourceType\n            format\n            width\n            height\n            caption\n            title\n            description\n          }\n        }\n        contentBlockAssignments @include(if: $withPagesContentBlockAssignments) {\n          id\n          type\n          block @include(if: $withPagesContentBlockAssignmentsBlock) {\n            __typename\n            ... on CmsTextBlock {\n              id\n              text\n\n            }\n            ... on CmsTextWithImageBlock {\n              id\n              title\n              subtitle\n              text\n              imagePosition\n              imageFixedAspectRatio\n\n            }\n            ... on CmsPageHeaderBlock {\n              id\n              title\n              text\n\n            }\n            ... on CmsWysiwygBlock {\n              id\n              html\n\n            }\n            ... on CmsHeadingBlock {\n              id\n              importance\n              heading\n              addon\n              decoration\n\n            }\n            ... on CmsTextWithIconBlock {\n              id\n              title\n              text\n              imagePosition\n\n            }\n            ... on CmsAccordionBlock {\n              id\n\n            }\n            ... on CmsGridBlock {\n              id\n\n            }\n            ... on CmsImageBlock {\n              id\n              text\n              fluid\n\n            }\n            ... on CmsEmployeesBlock {\n              id\n\n            }\n            ... on CmsContactBannerBlock {\n              id\n              phone\n              email\n\n            }\n            ... on CmsNewsletterRegisterBlock {\n              id\n              fluid\n\n            }\n            ... on CmsIssuuCatalogBlock {\n              id\n              publicationCode\n              accountName\n\n            }\n            ... on CmsFormBlock {\n              id\n              formName\n\n            }\n            ... on CmsHeaderSliderBlock {\n              id\n\n            }\n            ... on CmsBestsellerSliderBlock {\n              id\n              fluid\n\n            }\n            ... on CmsFilterLeadBlock {\n              id\n              layout\n\n            }\n            ... on CmsTravelTypesBlock {\n              id\n              layout\n\n            }\n            ... on CmsPrefilteredTravelsBlock {\n              id\n              maxResults\n\n            }\n            ... on CmsDividerBlock {\n              id\n              fluid\n\n            }\n            ... on CmsTravelSelectionBlock {\n              id\n\n            }\n            ... on CmsIframeBlock {\n              id\n              url\n              minHeight\n\n            }\n            ... on CmsSliderBlock {\n              id\n              fluid\n              size\n              showDots\n              showArrows\n              showLightbox\n              autoplay\n\n            }\n            ... on CmsDestinationsBlock {\n              id\n\n            }\n            ... on CmsTravelGuidesBlock {\n              id\n\n            }\n            ... on CmsBusfinderBlock {\n              id\n              title\n\n            }\n            ... on CmsBackgroundBlock {\n              id\n              backgroundVariant\n\n            }\n          }\n        }\n      }\n      seoSettings @include(if: $withSeoSettings) {\n        id\n        urlSlug\n        metaTitle\n        metaDescription\n        ogTitle\n        ogDescription\n        ogImage @include(if: $withSeoSettingsOgImage) {\n          id\n          assetId\n          publicId\n          url\n          resourceType\n          format\n          width\n          height\n          caption\n          title\n          description\n        }\n      }\n    }\n  }";
// language=GraphQL
var UPDATE_CATEGORY_MUTATION = "\n  mutation Mutation($input: UpdateCmsCategoryInput, $withPages: Boolean = false, $withPagesSeoSettings: Boolean = false, $withPagesSeoSettingsOgImage: Boolean = false, $withPagesContentBlockAssignments: Boolean = false, $withPagesContentBlockAssignmentsBlock: Boolean = false, $withSeoSettings: Boolean = false, $withSeoSettingsOgImage: Boolean = false) {\n    category: updateCmsCategory(input: $input) {\n      id\n      name\n      pages @include(if: $withPages) {\n        id\n        name\n        onlineStatus\n        seoSettings @include(if: $withPagesSeoSettings) {\n          id\n          urlSlug\n          metaTitle\n          metaDescription\n          ogTitle\n          ogDescription\n          ogImage @include(if: $withPagesSeoSettingsOgImage) {\n            id\n            assetId\n            publicId\n            url\n            resourceType\n            format\n            width\n            height\n            caption\n            title\n            description\n          }\n        }\n        contentBlockAssignments @include(if: $withPagesContentBlockAssignments) {\n          id\n          type\n          block @include(if: $withPagesContentBlockAssignmentsBlock) {\n            __typename\n            ... on CmsTextBlock {\n              id\n              text\n\n            }\n            ... on CmsTextWithImageBlock {\n              id\n              title\n              subtitle\n              text\n              imagePosition\n              imageFixedAspectRatio\n\n            }\n            ... on CmsPageHeaderBlock {\n              id\n              title\n              text\n\n            }\n            ... on CmsWysiwygBlock {\n              id\n              html\n\n            }\n            ... on CmsHeadingBlock {\n              id\n              importance\n              heading\n              addon\n              decoration\n\n            }\n            ... on CmsTextWithIconBlock {\n              id\n              title\n              text\n              imagePosition\n\n            }\n            ... on CmsAccordionBlock {\n              id\n\n            }\n            ... on CmsGridBlock {\n              id\n\n            }\n            ... on CmsImageBlock {\n              id\n              text\n              fluid\n\n            }\n            ... on CmsEmployeesBlock {\n              id\n\n            }\n            ... on CmsContactBannerBlock {\n              id\n              phone\n              email\n\n            }\n            ... on CmsNewsletterRegisterBlock {\n              id\n              fluid\n\n            }\n            ... on CmsIssuuCatalogBlock {\n              id\n              publicationCode\n              accountName\n\n            }\n            ... on CmsFormBlock {\n              id\n              formName\n\n            }\n            ... on CmsHeaderSliderBlock {\n              id\n\n            }\n            ... on CmsBestsellerSliderBlock {\n              id\n              fluid\n\n            }\n            ... on CmsFilterLeadBlock {\n              id\n              layout\n\n            }\n            ... on CmsTravelTypesBlock {\n              id\n              layout\n\n            }\n            ... on CmsPrefilteredTravelsBlock {\n              id\n              maxResults\n\n            }\n            ... on CmsDividerBlock {\n              id\n              fluid\n\n            }\n            ... on CmsTravelSelectionBlock {\n              id\n\n            }\n            ... on CmsIframeBlock {\n              id\n              url\n              minHeight\n\n            }\n            ... on CmsSliderBlock {\n              id\n              fluid\n              size\n              showDots\n              showArrows\n              showLightbox\n              autoplay\n\n            }\n            ... on CmsDestinationsBlock {\n              id\n\n            }\n            ... on CmsTravelGuidesBlock {\n              id\n\n            }\n            ... on CmsBusfinderBlock {\n              id\n              title\n\n            }\n            ... on CmsBackgroundBlock {\n              id\n              backgroundVariant\n\n            }\n          }\n        }\n      }\n      seoSettings @include(if: $withSeoSettings) {\n        id\n        urlSlug\n        metaTitle\n        metaDescription\n        ogTitle\n        ogDescription\n        ogImage @include(if: $withSeoSettingsOgImage) {\n          id\n          assetId\n          publicId\n          url\n          resourceType\n          format\n          width\n          height\n          caption\n          title\n          description\n        }\n      }\n    }\n  }";
// language=GraphQL
var DELETE_CATEGORY_MUTATION = "\n  mutation Mutation($input: DeleteCmsCategoryInput) {\n    deleteCmsCategory(input: $input) {\n      success\n    }\n  }";
// language=GraphQL
var FORCE_DELETE_CATEGORY_MUTATION = "\n  mutation Mutation($input: DeleteCmsCategoryInput) {\n    forceDeleteCmsCategory(input: $input) {\n      success\n    }\n  }";
// language=GraphQL
var ADD_CATEGORY_PAGES_MUTATION = "\n  mutation Mutation($input: addCmsCategoryPagesInput) {\n    addCmsCategoryPages(input: $input) {\n      id\n      pageIds\n    }\n  }";
// language=GraphQL
var REMOVE_CATEGORY_PAGES_MUTATION = "\n  mutation Mutation($input: removeCmsCategoryPagesInput) {\n    removeCmsCategoryPages(input: $input) {\n      id\n      pageIds\n    }\n  }";
// language=GraphQL
var CREATE_CATEGORY_PAGES_MUTATION = "\n  mutation Mutation($input: createCmsCategoryPagesInput) {\n    createCmsCategoryPages(input: $input) {\n      id\n      pageIds\n    }\n  }";
// language=GraphQL
var DELETE_CATEGORY_PAGES_MUTATION = "\n  mutation Mutation($input: deleteCmsCategoryPagesInput) {\n    deleteCmsCategoryPages(input: $input) {\n      id\n      pageIds\n    }\n  }";
// language=GraphQL
var UPDATE_CATEGORY_PAGES_ORDER_MUTATION = "\n  mutation Mutation($input: updateCmsCategoryPagesOrderInput) {\n    updateCmsCategoryPagesOrder(input: $input) {\n      id\n      pageIds\n    }\n  }";
// language=GraphQL
var CATEGORIES_DEPENDENTS_QUERY = "query Query($id: ID!, $withTenantCms: Boolean = false) {\n  groupedDependents: cmsCategoryDependents(id: $id) {\n    tenantCms @include(if: $withTenantCms) {\n      id\n    }\n  }\n}";

// EXTERNAL MODULE: ./src/entities/cmsPage/entity.ts + 3 modules
var entity = __webpack_require__(49647);
// EXTERNAL MODULE: ./src/entities/elementSeoSettings/entity.ts + 3 modules
var elementSeoSettings_entity = __webpack_require__(64750);
;// CONCATENATED MODULE: ./src/entities/cmsCategory/model.ts



var cmsCategoryModel = {
    name: "category",
    namePlural: "categories",
    uniqueName: "cmsCategory",
    uniqueNamePlural: "cmsCategories",
    path: "cms/category",
    baseUrl: "/cms/categories",
    translationPrefix: "entities:cmsCategory.",
    getDisplayName: function(values) {
        return values.name;
    },
    gql: {
        getAll: ALL_CATEGORIES_QUERY,
        getSingle: SINGLE_CATEGORY_QUERY,
        create: CREATE_CATEGORY_MUTATION,
        update: UPDATE_CATEGORY_MUTATION,
        delete: DELETE_CATEGORY_MUTATION,
        forceDelete: FORCE_DELETE_CATEGORY_MUTATION
    },
    attributes: {
        name: {
            name: "name",
            label: "entities:cmsCategory.attributes.name.label",
            type: "value",
            dataType: "string",
            defaultInput: true,
            inputType: "text",
            validationType: "string",
            validations: [
                {
                    type: "required"
                }, 
            ]
        },
        pages: {
            name: "pages",
            label: "entities:cmsCategory.attributes.pages.label",
            type: "entityCollection",
            dataType: "[any]",
            getEntity: function() {
                return entity/* default */.Z;
            },
            defaultInput: false,
            inputType: "text",
            validationType: "string",
            validations: []
        },
        seoSettings: {
            name: "seoSettings",
            label: "entities:cmsCategory.attributes.seoSettings.label",
            type: "entityObject",
            dataType: "any",
            getEntity: function() {
                return elementSeoSettings_entity/* default */.Z;
            },
            defaultInput: false,
            inputType: "select",
            validationType: "string",
            validations: []
        }
    }
};
/* harmony default export */ var model = (cmsCategoryModel);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(20414);
// EXTERNAL MODULE: ./src/entities/lib.ts
var lib = __webpack_require__(23480);
// EXTERNAL MODULE: ./src/lib/api/graphQLClient.ts
var graphQLClient = __webpack_require__(40112);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/swr/dist/index.mjs
var dist = __webpack_require__(8100);
// EXTERNAL MODULE: ./src/lib/helpers/helpers.ts
var helpers = __webpack_require__(15778);
;// CONCATENATED MODULE: ./src/entities/cmsCategory/repository.ts










var hydrateObjects = function(objects) {
    return objects.map(function(object) {
        return (0,lib/* hydrateEntityObject */.b)(model, object);
    });
};
var hydrateObject = function(object) {
    return (0,lib/* hydrateEntityObject */.b)(model, object);
};
var cmsCategoryRepository = {
    getObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    id: id
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(SINGLE_CATEGORY_QUERY, variables).then(function(data) {
                        return hydrateObject(data.category);
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }(),
    getObjects: /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        var includes;
        var _arguments = arguments;
        return (0,tslib_es6.__generator)(this, function(_state) {
            includes = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : {};
            return [
                2,
                graphQLClient/* default.request */.Z.request(ALL_CATEGORIES_QUERY, includes).then(function(data) {
                    return hydrateObjects(data.categories);
                })
            ];
        });
    }),
    useObject: function(id) {
        var includes = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        // eslint-disable-next-line react-hooks/exhaustive-deps
        var variables = (0,react.useMemo)(function() {
            return (0,_object_spread/* default */.Z)({
                id: id
            }, includes);
        }, [
            id
        ]);
        var ref = (0,dist/* default */.ZP)([
            SINGLE_CATEGORY_QUERY,
            variables
        ], {
            revalidateOnFocus: false
        }), data = ref.data, error = ref.error, mutate = ref.mutate;
        return {
            object: !data ? data : hydrateObject(data.category),
            isLoading: !error && !data,
            isError: error,
            mutate: mutate
        };
    },
    useObjects: function() {
        var includes = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        // eslint-disable-next-line react-hooks/exhaustive-deps
        var variables = (0,react.useMemo)(function() {
            return includes;
        }, []);
        var ref = (0,dist/* default */.ZP)([
            ALL_CATEGORIES_QUERY,
            variables
        ]), data = ref.data, error = ref.error, mutate = ref.mutate;
        return {
            objects: !data ? data : hydrateObjects(data.categories),
            isLoading: !error && !data,
            isError: error,
            mutate: mutate
        };
    },
    getDependents: function(id, includes) {
        var includeVars = {};
        includes.forEach(function(include) {
            includeVars["with".concat((0,helpers/* uppercaseFirst */.AB)(include))] = true;
        });
        var variables = (0,_object_spread/* default */.Z)({
            id: id
        }, includeVars);
        return graphQLClient/* default.request */.Z.request(CATEGORIES_DEPENDENTS_QUERY, variables).then(function(data) {
            return data.groupedDependents;
        });
    },
    useDependents: function(id, includes) {
        var includeVars = {};
        includes.forEach(function(include) {
            includeVars["with".concat((0,helpers/* uppercaseFirst */.AB)(include))] = true;
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
        var variables = (0,react.useMemo)(function() {
            return (0,_object_spread/* default */.Z)({
                id: id
            }, includeVars);
        }, [
            id
        ]);
        var ref = (0,dist/* default */.ZP)([
            CATEGORIES_DEPENDENTS_QUERY,
            variables
        ], {
            revalidateOnFocus: false
        }), data = ref.data, error = ref.error, mutate = ref.mutate;
        return {
            data: !data ? data : data.groupedDependents,
            isLoading: !error && !data,
            isError: error,
            mutate: mutate
        };
    },
    createObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(data) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    input: data
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(CREATE_CATEGORY_MUTATION, variables).then(function(data) {
                        return hydrateObject(data.category);
                    })
                ];
            });
        });
        return function(data) {
            return _ref.apply(this, arguments);
        };
    }(),
    updateObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(data) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    input: data
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(UPDATE_CATEGORY_MUTATION, variables).then(function(data) {
                        return hydrateObject(data.category);
                    })
                ];
            });
        });
        return function(data) {
            return _ref.apply(this, arguments);
        };
    }(),
    deleteObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(DELETE_CATEGORY_MUTATION, variables).then(function(data) {
                        return data.deleteCmsCategory;
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }(),
    forceDeleteObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(FORCE_DELETE_CATEGORY_MUTATION, variables).then(function(data) {
                        return data.forceDeleteCmsCategory;
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }(),
    assignPages: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, itemIds) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        pageIds: itemIds
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(ADD_CATEGORY_PAGES_MUTATION, variables)
                ];
            });
        });
        return function(id, itemIds) {
            return _ref.apply(this, arguments);
        };
    }(),
    unassignPages: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, itemIds) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        pageIds: itemIds
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(REMOVE_CATEGORY_PAGES_MUTATION, variables)
                ];
            });
        });
        return function(id, itemIds) {
            return _ref.apply(this, arguments);
        };
    }(),
    createPages: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, items) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        pages: items
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(CREATE_CATEGORY_PAGES_MUTATION, variables)
                ];
            });
        });
        return function(id, items) {
            return _ref.apply(this, arguments);
        };
    }(),
    deletePages: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, itemIds) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        pageIds: itemIds
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(DELETE_CATEGORY_PAGES_MUTATION, variables)
                ];
            });
        });
        return function(id, itemIds) {
            return _ref.apply(this, arguments);
        };
    }(),
    updatePagesOrder: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, itemIds) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        pageIds: itemIds
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(UPDATE_CATEGORY_PAGES_ORDER_MUTATION, variables)
                ];
            });
        });
        return function(id, itemIds) {
            return _ref.apply(this, arguments);
        };
    }()
};
/* harmony default export */ var repository = (cmsCategoryRepository);

;// CONCATENATED MODULE: ./src/entities/cmsCategory/entity.ts


var cmsCategoryEntity = {
    model: model,
    repository: repository
};
/* harmony default export */ var cmsCategory_entity = (cmsCategoryEntity);


/***/ }),

/***/ 78069:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ cmsConfig_entity; }
});

;// CONCATENATED MODULE: ./src/entities/cmsConfig/graphql.ts
// language=GraphQL
var ALL_CMS_CONFIGS_QUERY = "query Query($withContactBlockSettings: Boolean = false, $withSocialMediaSettings: Boolean = false, $withPrivacyPolicyPage: Boolean = false, $withPrivacyPolicyPageSeoSettings: Boolean = false, $withPrivacyPolicyPageSeoSettingsOgImage: Boolean = false, $withPrivacyPolicyPageContentBlockAssignments: Boolean = false, $withPrivacyPolicyPageContentBlockAssignmentsBlock: Boolean = false, $withGtcPage: Boolean = false, $withGtcPageSeoSettings: Boolean = false, $withGtcPageSeoSettingsOgImage: Boolean = false, $withGtcPageContentBlockAssignments: Boolean = false, $withGtcPageContentBlockAssignmentsBlock: Boolean = false) {\n  cmsConfigs: cmsConfigs {\n    id\n    contactBlockSettings @include(if: $withContactBlockSettings) {\n      id\n      slogan\n      title\n      text\n      phonePrefix\n      phone\n      phone2Prefix\n      phone2\n      openingHours1\n      openingHours2\n      email\n    }\n    socialMediaSettings @include(if: $withSocialMediaSettings) {\n      id\n      facebookUrl\n      instagramUrl\n    }\n    privacyPolicyPage @include(if: $withPrivacyPolicyPage) {\n      id\n      name\n      onlineStatus\n      seoSettings @include(if: $withPrivacyPolicyPageSeoSettings) {\n        id\n        urlSlug\n        metaTitle\n        metaDescription\n        ogTitle\n        ogDescription\n        ogImage @include(if: $withPrivacyPolicyPageSeoSettingsOgImage) {\n          id\n          assetId\n          publicId\n          url\n          resourceType\n          format\n          width\n          height\n          caption\n          title\n          description\n        }\n      }\n      contentBlockAssignments @include(if: $withPrivacyPolicyPageContentBlockAssignments) {\n        id\n        type\n        block @include(if: $withPrivacyPolicyPageContentBlockAssignmentsBlock) {\n          __typename\n          ... on CmsTextBlock {\n            id\n            text\n\n          }\n          ... on CmsTextWithImageBlock {\n            id\n            title\n            subtitle\n            text\n            imagePosition\n            imageFixedAspectRatio\n\n          }\n          ... on CmsPageHeaderBlock {\n            id\n            title\n            text\n\n          }\n          ... on CmsWysiwygBlock {\n            id\n            html\n\n          }\n          ... on CmsHeadingBlock {\n            id\n            importance\n            heading\n            addon\n            decoration\n\n          }\n          ... on CmsTextWithIconBlock {\n            id\n            title\n            text\n            imagePosition\n\n          }\n          ... on CmsAccordionBlock {\n            id\n\n          }\n          ... on CmsGridBlock {\n            id\n\n          }\n          ... on CmsImageBlock {\n            id\n            text\n            fluid\n\n          }\n          ... on CmsEmployeesBlock {\n            id\n\n          }\n          ... on CmsContactBannerBlock {\n            id\n            phone\n            email\n\n          }\n          ... on CmsNewsletterRegisterBlock {\n            id\n            fluid\n\n          }\n          ... on CmsIssuuCatalogBlock {\n            id\n            publicationCode\n            accountName\n\n          }\n          ... on CmsFormBlock {\n            id\n            formName\n\n          }\n          ... on CmsHeaderSliderBlock {\n            id\n\n          }\n          ... on CmsBestsellerSliderBlock {\n            id\n            fluid\n\n          }\n          ... on CmsFilterLeadBlock {\n            id\n            layout\n\n          }\n          ... on CmsTravelTypesBlock {\n            id\n            layout\n\n          }\n          ... on CmsPrefilteredTravelsBlock {\n            id\n            maxResults\n\n          }\n          ... on CmsDividerBlock {\n            id\n            fluid\n\n          }\n          ... on CmsTravelSelectionBlock {\n            id\n\n          }\n          ... on CmsIframeBlock {\n            id\n            url\n            minHeight\n\n          }\n          ... on CmsSliderBlock {\n            id\n            fluid\n            size\n            showDots\n            showArrows\n            showLightbox\n            autoplay\n\n          }\n          ... on CmsDestinationsBlock {\n            id\n\n          }\n          ... on CmsTravelGuidesBlock {\n            id\n\n          }\n          ... on CmsBusfinderBlock {\n            id\n            title\n\n          }\n          ... on CmsBackgroundBlock {\n            id\n            backgroundVariant\n\n          }\n        }\n      }\n    }\n    gtcPage @include(if: $withGtcPage) {\n      id\n      name\n      onlineStatus\n      seoSettings @include(if: $withGtcPageSeoSettings) {\n        id\n        urlSlug\n        metaTitle\n        metaDescription\n        ogTitle\n        ogDescription\n        ogImage @include(if: $withGtcPageSeoSettingsOgImage) {\n          id\n          assetId\n          publicId\n          url\n          resourceType\n          format\n          width\n          height\n          caption\n          title\n          description\n        }\n      }\n      contentBlockAssignments @include(if: $withGtcPageContentBlockAssignments) {\n        id\n        type\n        block @include(if: $withGtcPageContentBlockAssignmentsBlock) {\n          __typename\n          ... on CmsTextBlock {\n            id\n            text\n\n          }\n          ... on CmsTextWithImageBlock {\n            id\n            title\n            subtitle\n            text\n            imagePosition\n            imageFixedAspectRatio\n\n          }\n          ... on CmsPageHeaderBlock {\n            id\n            title\n            text\n\n          }\n          ... on CmsWysiwygBlock {\n            id\n            html\n\n          }\n          ... on CmsHeadingBlock {\n            id\n            importance\n            heading\n            addon\n            decoration\n\n          }\n          ... on CmsTextWithIconBlock {\n            id\n            title\n            text\n            imagePosition\n\n          }\n          ... on CmsAccordionBlock {\n            id\n\n          }\n          ... on CmsGridBlock {\n            id\n\n          }\n          ... on CmsImageBlock {\n            id\n            text\n            fluid\n\n          }\n          ... on CmsEmployeesBlock {\n            id\n\n          }\n          ... on CmsContactBannerBlock {\n            id\n            phone\n            email\n\n          }\n          ... on CmsNewsletterRegisterBlock {\n            id\n            fluid\n\n          }\n          ... on CmsIssuuCatalogBlock {\n            id\n            publicationCode\n            accountName\n\n          }\n          ... on CmsFormBlock {\n            id\n            formName\n\n          }\n          ... on CmsHeaderSliderBlock {\n            id\n\n          }\n          ... on CmsBestsellerSliderBlock {\n            id\n            fluid\n\n          }\n          ... on CmsFilterLeadBlock {\n            id\n            layout\n\n          }\n          ... on CmsTravelTypesBlock {\n            id\n            layout\n\n          }\n          ... on CmsPrefilteredTravelsBlock {\n            id\n            maxResults\n\n          }\n          ... on CmsDividerBlock {\n            id\n            fluid\n\n          }\n          ... on CmsTravelSelectionBlock {\n            id\n\n          }\n          ... on CmsIframeBlock {\n            id\n            url\n            minHeight\n\n          }\n          ... on CmsSliderBlock {\n            id\n            fluid\n            size\n            showDots\n            showArrows\n            showLightbox\n            autoplay\n\n          }\n          ... on CmsDestinationsBlock {\n            id\n\n          }\n          ... on CmsTravelGuidesBlock {\n            id\n\n          }\n          ... on CmsBusfinderBlock {\n            id\n            title\n\n          }\n          ... on CmsBackgroundBlock {\n            id\n            backgroundVariant\n\n          }\n        }\n      }\n    }\n  }\n}";
// language=GraphQL
var SINGLE_CMS_CONFIG_QUERY = "query Query($id: ID!, $withContactBlockSettings: Boolean = false, $withSocialMediaSettings: Boolean = false, $withPrivacyPolicyPage: Boolean = false, $withPrivacyPolicyPageSeoSettings: Boolean = false, $withPrivacyPolicyPageSeoSettingsOgImage: Boolean = false, $withPrivacyPolicyPageContentBlockAssignments: Boolean = false, $withPrivacyPolicyPageContentBlockAssignmentsBlock: Boolean = false, $withGtcPage: Boolean = false, $withGtcPageSeoSettings: Boolean = false, $withGtcPageSeoSettingsOgImage: Boolean = false, $withGtcPageContentBlockAssignments: Boolean = false, $withGtcPageContentBlockAssignmentsBlock: Boolean = false) {\n  cmsConfig: cmsConfig(id: $id) {\n    id\n    contactBlockSettings @include(if: $withContactBlockSettings) {\n      id\n      slogan\n      title\n      text\n      phonePrefix\n      phone\n      phone2Prefix\n      phone2\n      openingHours1\n      openingHours2\n      email\n    }\n    socialMediaSettings @include(if: $withSocialMediaSettings) {\n      id\n      facebookUrl\n      instagramUrl\n    }\n    privacyPolicyPage @include(if: $withPrivacyPolicyPage) {\n      id\n      name\n      onlineStatus\n      seoSettings @include(if: $withPrivacyPolicyPageSeoSettings) {\n        id\n        urlSlug\n        metaTitle\n        metaDescription\n        ogTitle\n        ogDescription\n        ogImage @include(if: $withPrivacyPolicyPageSeoSettingsOgImage) {\n          id\n          assetId\n          publicId\n          url\n          resourceType\n          format\n          width\n          height\n          caption\n          title\n          description\n        }\n      }\n      contentBlockAssignments @include(if: $withPrivacyPolicyPageContentBlockAssignments) {\n        id\n        type\n        block @include(if: $withPrivacyPolicyPageContentBlockAssignmentsBlock) {\n          __typename\n          ... on CmsTextBlock {\n            id\n            text\n\n          }\n          ... on CmsTextWithImageBlock {\n            id\n            title\n            subtitle\n            text\n            imagePosition\n            imageFixedAspectRatio\n\n          }\n          ... on CmsPageHeaderBlock {\n            id\n            title\n            text\n\n          }\n          ... on CmsWysiwygBlock {\n            id\n            html\n\n          }\n          ... on CmsHeadingBlock {\n            id\n            importance\n            heading\n            addon\n            decoration\n\n          }\n          ... on CmsTextWithIconBlock {\n            id\n            title\n            text\n            imagePosition\n\n          }\n          ... on CmsAccordionBlock {\n            id\n\n          }\n          ... on CmsGridBlock {\n            id\n\n          }\n          ... on CmsImageBlock {\n            id\n            text\n            fluid\n\n          }\n          ... on CmsEmployeesBlock {\n            id\n\n          }\n          ... on CmsContactBannerBlock {\n            id\n            phone\n            email\n\n          }\n          ... on CmsNewsletterRegisterBlock {\n            id\n            fluid\n\n          }\n          ... on CmsIssuuCatalogBlock {\n            id\n            publicationCode\n            accountName\n\n          }\n          ... on CmsFormBlock {\n            id\n            formName\n\n          }\n          ... on CmsHeaderSliderBlock {\n            id\n\n          }\n          ... on CmsBestsellerSliderBlock {\n            id\n            fluid\n\n          }\n          ... on CmsFilterLeadBlock {\n            id\n            layout\n\n          }\n          ... on CmsTravelTypesBlock {\n            id\n            layout\n\n          }\n          ... on CmsPrefilteredTravelsBlock {\n            id\n            maxResults\n\n          }\n          ... on CmsDividerBlock {\n            id\n            fluid\n\n          }\n          ... on CmsTravelSelectionBlock {\n            id\n\n          }\n          ... on CmsIframeBlock {\n            id\n            url\n            minHeight\n\n          }\n          ... on CmsSliderBlock {\n            id\n            fluid\n            size\n            showDots\n            showArrows\n            showLightbox\n            autoplay\n\n          }\n          ... on CmsDestinationsBlock {\n            id\n\n          }\n          ... on CmsTravelGuidesBlock {\n            id\n\n          }\n          ... on CmsBusfinderBlock {\n            id\n            title\n\n          }\n          ... on CmsBackgroundBlock {\n            id\n            backgroundVariant\n\n          }\n        }\n      }\n    }\n    gtcPage @include(if: $withGtcPage) {\n      id\n      name\n      onlineStatus\n      seoSettings @include(if: $withGtcPageSeoSettings) {\n        id\n        urlSlug\n        metaTitle\n        metaDescription\n        ogTitle\n        ogDescription\n        ogImage @include(if: $withGtcPageSeoSettingsOgImage) {\n          id\n          assetId\n          publicId\n          url\n          resourceType\n          format\n          width\n          height\n          caption\n          title\n          description\n        }\n      }\n      contentBlockAssignments @include(if: $withGtcPageContentBlockAssignments) {\n        id\n        type\n        block @include(if: $withGtcPageContentBlockAssignmentsBlock) {\n          __typename\n          ... on CmsTextBlock {\n            id\n            text\n\n          }\n          ... on CmsTextWithImageBlock {\n            id\n            title\n            subtitle\n            text\n            imagePosition\n            imageFixedAspectRatio\n\n          }\n          ... on CmsPageHeaderBlock {\n            id\n            title\n            text\n\n          }\n          ... on CmsWysiwygBlock {\n            id\n            html\n\n          }\n          ... on CmsHeadingBlock {\n            id\n            importance\n            heading\n            addon\n            decoration\n\n          }\n          ... on CmsTextWithIconBlock {\n            id\n            title\n            text\n            imagePosition\n\n          }\n          ... on CmsAccordionBlock {\n            id\n\n          }\n          ... on CmsGridBlock {\n            id\n\n          }\n          ... on CmsImageBlock {\n            id\n            text\n            fluid\n\n          }\n          ... on CmsEmployeesBlock {\n            id\n\n          }\n          ... on CmsContactBannerBlock {\n            id\n            phone\n            email\n\n          }\n          ... on CmsNewsletterRegisterBlock {\n            id\n            fluid\n\n          }\n          ... on CmsIssuuCatalogBlock {\n            id\n            publicationCode\n            accountName\n\n          }\n          ... on CmsFormBlock {\n            id\n            formName\n\n          }\n          ... on CmsHeaderSliderBlock {\n            id\n\n          }\n          ... on CmsBestsellerSliderBlock {\n            id\n            fluid\n\n          }\n          ... on CmsFilterLeadBlock {\n            id\n            layout\n\n          }\n          ... on CmsTravelTypesBlock {\n            id\n            layout\n\n          }\n          ... on CmsPrefilteredTravelsBlock {\n            id\n            maxResults\n\n          }\n          ... on CmsDividerBlock {\n            id\n            fluid\n\n          }\n          ... on CmsTravelSelectionBlock {\n            id\n\n          }\n          ... on CmsIframeBlock {\n            id\n            url\n            minHeight\n\n          }\n          ... on CmsSliderBlock {\n            id\n            fluid\n            size\n            showDots\n            showArrows\n            showLightbox\n            autoplay\n\n          }\n          ... on CmsDestinationsBlock {\n            id\n\n          }\n          ... on CmsTravelGuidesBlock {\n            id\n\n          }\n          ... on CmsBusfinderBlock {\n            id\n            title\n\n          }\n          ... on CmsBackgroundBlock {\n            id\n            backgroundVariant\n\n          }\n        }\n      }\n    }\n  }\n}";
// language=GraphQL
var CREATE_CMS_CONFIG_MUTATION = "\n  mutation Mutation($input: CreateCmsConfigInput, $withContactBlockSettings: Boolean = false, $withSocialMediaSettings: Boolean = false, $withPrivacyPolicyPage: Boolean = false, $withPrivacyPolicyPageSeoSettings: Boolean = false, $withPrivacyPolicyPageSeoSettingsOgImage: Boolean = false, $withPrivacyPolicyPageContentBlockAssignments: Boolean = false, $withPrivacyPolicyPageContentBlockAssignmentsBlock: Boolean = false, $withGtcPage: Boolean = false, $withGtcPageSeoSettings: Boolean = false, $withGtcPageSeoSettingsOgImage: Boolean = false, $withGtcPageContentBlockAssignments: Boolean = false, $withGtcPageContentBlockAssignmentsBlock: Boolean = false) {\n    cmsConfig: createCmsConfig(input: $input) {\n      id\n      contactBlockSettings @include(if: $withContactBlockSettings) {\n        id\n        slogan\n        title\n        text\n        phonePrefix\n        phone\n        phone2Prefix\n        phone2\n        openingHours1\n        openingHours2\n        email\n      }\n      socialMediaSettings @include(if: $withSocialMediaSettings) {\n        id\n        facebookUrl\n        instagramUrl\n      }\n      privacyPolicyPage @include(if: $withPrivacyPolicyPage) {\n        id\n        name\n        onlineStatus\n        seoSettings @include(if: $withPrivacyPolicyPageSeoSettings) {\n          id\n          urlSlug\n          metaTitle\n          metaDescription\n          ogTitle\n          ogDescription\n          ogImage @include(if: $withPrivacyPolicyPageSeoSettingsOgImage) {\n            id\n            assetId\n            publicId\n            url\n            resourceType\n            format\n            width\n            height\n            caption\n            title\n            description\n          }\n        }\n        contentBlockAssignments @include(if: $withPrivacyPolicyPageContentBlockAssignments) {\n          id\n          type\n          block @include(if: $withPrivacyPolicyPageContentBlockAssignmentsBlock) {\n            __typename\n            ... on CmsTextBlock {\n              id\n              text\n\n            }\n            ... on CmsTextWithImageBlock {\n              id\n              title\n              subtitle\n              text\n              imagePosition\n              imageFixedAspectRatio\n\n            }\n            ... on CmsPageHeaderBlock {\n              id\n              title\n              text\n\n            }\n            ... on CmsWysiwygBlock {\n              id\n              html\n\n            }\n            ... on CmsHeadingBlock {\n              id\n              importance\n              heading\n              addon\n              decoration\n\n            }\n            ... on CmsTextWithIconBlock {\n              id\n              title\n              text\n              imagePosition\n\n            }\n            ... on CmsAccordionBlock {\n              id\n\n            }\n            ... on CmsGridBlock {\n              id\n\n            }\n            ... on CmsImageBlock {\n              id\n              text\n              fluid\n\n            }\n            ... on CmsEmployeesBlock {\n              id\n\n            }\n            ... on CmsContactBannerBlock {\n              id\n              phone\n              email\n\n            }\n            ... on CmsNewsletterRegisterBlock {\n              id\n              fluid\n\n            }\n            ... on CmsIssuuCatalogBlock {\n              id\n              publicationCode\n              accountName\n\n            }\n            ... on CmsFormBlock {\n              id\n              formName\n\n            }\n            ... on CmsHeaderSliderBlock {\n              id\n\n            }\n            ... on CmsBestsellerSliderBlock {\n              id\n              fluid\n\n            }\n            ... on CmsFilterLeadBlock {\n              id\n              layout\n\n            }\n            ... on CmsTravelTypesBlock {\n              id\n              layout\n\n            }\n            ... on CmsPrefilteredTravelsBlock {\n              id\n              maxResults\n\n            }\n            ... on CmsDividerBlock {\n              id\n              fluid\n\n            }\n            ... on CmsTravelSelectionBlock {\n              id\n\n            }\n            ... on CmsIframeBlock {\n              id\n              url\n              minHeight\n\n            }\n            ... on CmsSliderBlock {\n              id\n              fluid\n              size\n              showDots\n              showArrows\n              showLightbox\n              autoplay\n\n            }\n            ... on CmsDestinationsBlock {\n              id\n\n            }\n            ... on CmsTravelGuidesBlock {\n              id\n\n            }\n            ... on CmsBusfinderBlock {\n              id\n              title\n\n            }\n            ... on CmsBackgroundBlock {\n              id\n              backgroundVariant\n\n            }\n          }\n        }\n      }\n      gtcPage @include(if: $withGtcPage) {\n        id\n        name\n        onlineStatus\n        seoSettings @include(if: $withGtcPageSeoSettings) {\n          id\n          urlSlug\n          metaTitle\n          metaDescription\n          ogTitle\n          ogDescription\n          ogImage @include(if: $withGtcPageSeoSettingsOgImage) {\n            id\n            assetId\n            publicId\n            url\n            resourceType\n            format\n            width\n            height\n            caption\n            title\n            description\n          }\n        }\n        contentBlockAssignments @include(if: $withGtcPageContentBlockAssignments) {\n          id\n          type\n          block @include(if: $withGtcPageContentBlockAssignmentsBlock) {\n            __typename\n            ... on CmsTextBlock {\n              id\n              text\n\n            }\n            ... on CmsTextWithImageBlock {\n              id\n              title\n              subtitle\n              text\n              imagePosition\n              imageFixedAspectRatio\n\n            }\n            ... on CmsPageHeaderBlock {\n              id\n              title\n              text\n\n            }\n            ... on CmsWysiwygBlock {\n              id\n              html\n\n            }\n            ... on CmsHeadingBlock {\n              id\n              importance\n              heading\n              addon\n              decoration\n\n            }\n            ... on CmsTextWithIconBlock {\n              id\n              title\n              text\n              imagePosition\n\n            }\n            ... on CmsAccordionBlock {\n              id\n\n            }\n            ... on CmsGridBlock {\n              id\n\n            }\n            ... on CmsImageBlock {\n              id\n              text\n              fluid\n\n            }\n            ... on CmsEmployeesBlock {\n              id\n\n            }\n            ... on CmsContactBannerBlock {\n              id\n              phone\n              email\n\n            }\n            ... on CmsNewsletterRegisterBlock {\n              id\n              fluid\n\n            }\n            ... on CmsIssuuCatalogBlock {\n              id\n              publicationCode\n              accountName\n\n            }\n            ... on CmsFormBlock {\n              id\n              formName\n\n            }\n            ... on CmsHeaderSliderBlock {\n              id\n\n            }\n            ... on CmsBestsellerSliderBlock {\n              id\n              fluid\n\n            }\n            ... on CmsFilterLeadBlock {\n              id\n              layout\n\n            }\n            ... on CmsTravelTypesBlock {\n              id\n              layout\n\n            }\n            ... on CmsPrefilteredTravelsBlock {\n              id\n              maxResults\n\n            }\n            ... on CmsDividerBlock {\n              id\n              fluid\n\n            }\n            ... on CmsTravelSelectionBlock {\n              id\n\n            }\n            ... on CmsIframeBlock {\n              id\n              url\n              minHeight\n\n            }\n            ... on CmsSliderBlock {\n              id\n              fluid\n              size\n              showDots\n              showArrows\n              showLightbox\n              autoplay\n\n            }\n            ... on CmsDestinationsBlock {\n              id\n\n            }\n            ... on CmsTravelGuidesBlock {\n              id\n\n            }\n            ... on CmsBusfinderBlock {\n              id\n              title\n\n            }\n            ... on CmsBackgroundBlock {\n              id\n              backgroundVariant\n\n            }\n          }\n        }\n      }\n    }\n  }";
// language=GraphQL
var UPDATE_CMS_CONFIG_MUTATION = "\n  mutation Mutation($input: UpdateCmsConfigInput, $withContactBlockSettings: Boolean = false, $withSocialMediaSettings: Boolean = false, $withPrivacyPolicyPage: Boolean = false, $withPrivacyPolicyPageSeoSettings: Boolean = false, $withPrivacyPolicyPageSeoSettingsOgImage: Boolean = false, $withPrivacyPolicyPageContentBlockAssignments: Boolean = false, $withPrivacyPolicyPageContentBlockAssignmentsBlock: Boolean = false, $withGtcPage: Boolean = false, $withGtcPageSeoSettings: Boolean = false, $withGtcPageSeoSettingsOgImage: Boolean = false, $withGtcPageContentBlockAssignments: Boolean = false, $withGtcPageContentBlockAssignmentsBlock: Boolean = false) {\n    cmsConfig: updateCmsConfig(input: $input) {\n      id\n      contactBlockSettings @include(if: $withContactBlockSettings) {\n        id\n        slogan\n        title\n        text\n        phonePrefix\n        phone\n        phone2Prefix\n        phone2\n        openingHours1\n        openingHours2\n        email\n      }\n      socialMediaSettings @include(if: $withSocialMediaSettings) {\n        id\n        facebookUrl\n        instagramUrl\n      }\n      privacyPolicyPage @include(if: $withPrivacyPolicyPage) {\n        id\n        name\n        onlineStatus\n        seoSettings @include(if: $withPrivacyPolicyPageSeoSettings) {\n          id\n          urlSlug\n          metaTitle\n          metaDescription\n          ogTitle\n          ogDescription\n          ogImage @include(if: $withPrivacyPolicyPageSeoSettingsOgImage) {\n            id\n            assetId\n            publicId\n            url\n            resourceType\n            format\n            width\n            height\n            caption\n            title\n            description\n          }\n        }\n        contentBlockAssignments @include(if: $withPrivacyPolicyPageContentBlockAssignments) {\n          id\n          type\n          block @include(if: $withPrivacyPolicyPageContentBlockAssignmentsBlock) {\n            __typename\n            ... on CmsTextBlock {\n              id\n              text\n\n            }\n            ... on CmsTextWithImageBlock {\n              id\n              title\n              subtitle\n              text\n              imagePosition\n              imageFixedAspectRatio\n\n            }\n            ... on CmsPageHeaderBlock {\n              id\n              title\n              text\n\n            }\n            ... on CmsWysiwygBlock {\n              id\n              html\n\n            }\n            ... on CmsHeadingBlock {\n              id\n              importance\n              heading\n              addon\n              decoration\n\n            }\n            ... on CmsTextWithIconBlock {\n              id\n              title\n              text\n              imagePosition\n\n            }\n            ... on CmsAccordionBlock {\n              id\n\n            }\n            ... on CmsGridBlock {\n              id\n\n            }\n            ... on CmsImageBlock {\n              id\n              text\n              fluid\n\n            }\n            ... on CmsEmployeesBlock {\n              id\n\n            }\n            ... on CmsContactBannerBlock {\n              id\n              phone\n              email\n\n            }\n            ... on CmsNewsletterRegisterBlock {\n              id\n              fluid\n\n            }\n            ... on CmsIssuuCatalogBlock {\n              id\n              publicationCode\n              accountName\n\n            }\n            ... on CmsFormBlock {\n              id\n              formName\n\n            }\n            ... on CmsHeaderSliderBlock {\n              id\n\n            }\n            ... on CmsBestsellerSliderBlock {\n              id\n              fluid\n\n            }\n            ... on CmsFilterLeadBlock {\n              id\n              layout\n\n            }\n            ... on CmsTravelTypesBlock {\n              id\n              layout\n\n            }\n            ... on CmsPrefilteredTravelsBlock {\n              id\n              maxResults\n\n            }\n            ... on CmsDividerBlock {\n              id\n              fluid\n\n            }\n            ... on CmsTravelSelectionBlock {\n              id\n\n            }\n            ... on CmsIframeBlock {\n              id\n              url\n              minHeight\n\n            }\n            ... on CmsSliderBlock {\n              id\n              fluid\n              size\n              showDots\n              showArrows\n              showLightbox\n              autoplay\n\n            }\n            ... on CmsDestinationsBlock {\n              id\n\n            }\n            ... on CmsTravelGuidesBlock {\n              id\n\n            }\n            ... on CmsBusfinderBlock {\n              id\n              title\n\n            }\n            ... on CmsBackgroundBlock {\n              id\n              backgroundVariant\n\n            }\n          }\n        }\n      }\n      gtcPage @include(if: $withGtcPage) {\n        id\n        name\n        onlineStatus\n        seoSettings @include(if: $withGtcPageSeoSettings) {\n          id\n          urlSlug\n          metaTitle\n          metaDescription\n          ogTitle\n          ogDescription\n          ogImage @include(if: $withGtcPageSeoSettingsOgImage) {\n            id\n            assetId\n            publicId\n            url\n            resourceType\n            format\n            width\n            height\n            caption\n            title\n            description\n          }\n        }\n        contentBlockAssignments @include(if: $withGtcPageContentBlockAssignments) {\n          id\n          type\n          block @include(if: $withGtcPageContentBlockAssignmentsBlock) {\n            __typename\n            ... on CmsTextBlock {\n              id\n              text\n\n            }\n            ... on CmsTextWithImageBlock {\n              id\n              title\n              subtitle\n              text\n              imagePosition\n              imageFixedAspectRatio\n\n            }\n            ... on CmsPageHeaderBlock {\n              id\n              title\n              text\n\n            }\n            ... on CmsWysiwygBlock {\n              id\n              html\n\n            }\n            ... on CmsHeadingBlock {\n              id\n              importance\n              heading\n              addon\n              decoration\n\n            }\n            ... on CmsTextWithIconBlock {\n              id\n              title\n              text\n              imagePosition\n\n            }\n            ... on CmsAccordionBlock {\n              id\n\n            }\n            ... on CmsGridBlock {\n              id\n\n            }\n            ... on CmsImageBlock {\n              id\n              text\n              fluid\n\n            }\n            ... on CmsEmployeesBlock {\n              id\n\n            }\n            ... on CmsContactBannerBlock {\n              id\n              phone\n              email\n\n            }\n            ... on CmsNewsletterRegisterBlock {\n              id\n              fluid\n\n            }\n            ... on CmsIssuuCatalogBlock {\n              id\n              publicationCode\n              accountName\n\n            }\n            ... on CmsFormBlock {\n              id\n              formName\n\n            }\n            ... on CmsHeaderSliderBlock {\n              id\n\n            }\n            ... on CmsBestsellerSliderBlock {\n              id\n              fluid\n\n            }\n            ... on CmsFilterLeadBlock {\n              id\n              layout\n\n            }\n            ... on CmsTravelTypesBlock {\n              id\n              layout\n\n            }\n            ... on CmsPrefilteredTravelsBlock {\n              id\n              maxResults\n\n            }\n            ... on CmsDividerBlock {\n              id\n              fluid\n\n            }\n            ... on CmsTravelSelectionBlock {\n              id\n\n            }\n            ... on CmsIframeBlock {\n              id\n              url\n              minHeight\n\n            }\n            ... on CmsSliderBlock {\n              id\n              fluid\n              size\n              showDots\n              showArrows\n              showLightbox\n              autoplay\n\n            }\n            ... on CmsDestinationsBlock {\n              id\n\n            }\n            ... on CmsTravelGuidesBlock {\n              id\n\n            }\n            ... on CmsBusfinderBlock {\n              id\n              title\n\n            }\n            ... on CmsBackgroundBlock {\n              id\n              backgroundVariant\n\n            }\n          }\n        }\n      }\n    }\n  }";
// language=GraphQL
var DELETE_CMS_CONFIG_MUTATION = "\n  mutation Mutation($input: DeleteCmsConfigInput) {\n    deleteCmsConfig(input: $input) {\n      success\n    }\n  }";
// language=GraphQL
var FORCE_DELETE_CMS_CONFIG_MUTATION = "\n  mutation Mutation($input: DeleteCmsConfigInput) {\n    forceDeleteCmsConfig(input: $input) {\n      success\n    }\n  }";
// language=GraphQL
var CMS_CONFIGS_DEPENDENTS_QUERY = "query Query($id: ID!, $withTenantCms: Boolean = false) {\n  groupedDependents: cmsConfigDependents(id: $id) {\n    tenantCms @include(if: $withTenantCms) {\n      id\n    }\n  }\n}";

// EXTERNAL MODULE: ./src/entities/cmsContactBlockSettings/entity.ts + 3 modules
var entity = __webpack_require__(14214);
// EXTERNAL MODULE: ./src/entities/cmsSocialMediaSettings/entity.ts + 3 modules
var cmsSocialMediaSettings_entity = __webpack_require__(75780);
// EXTERNAL MODULE: ./src/entities/cmsPage/entity.ts + 3 modules
var cmsPage_entity = __webpack_require__(49647);
;// CONCATENATED MODULE: ./src/entities/cmsConfig/model.ts




var cmsConfigModel = {
    name: "cmsConfig",
    namePlural: "cmsConfigs",
    uniqueName: "cmsConfig",
    uniqueNamePlural: "cmsConfigs",
    path: "cms/config/cms_config",
    baseUrl: "/cms/config/cms_configs",
    translationPrefix: "entities:cmsConfig.",
    getDisplayName: function(values) {
        return "CMS Config";
    },
    gql: {
        getAll: ALL_CMS_CONFIGS_QUERY,
        getSingle: SINGLE_CMS_CONFIG_QUERY,
        create: CREATE_CMS_CONFIG_MUTATION,
        update: UPDATE_CMS_CONFIG_MUTATION,
        delete: DELETE_CMS_CONFIG_MUTATION,
        forceDelete: FORCE_DELETE_CMS_CONFIG_MUTATION
    },
    attributes: {
        contactBlockSettings: {
            name: "contactBlockSettings",
            label: "entities:cmsConfig.attributes.contactBlockSettings.label",
            type: "entityObject",
            dataType: "any",
            getEntity: function() {
                return entity/* default */.Z;
            },
            defaultInput: false,
            inputType: "select",
            validationType: "string",
            validations: []
        },
        socialMediaSettings: {
            name: "socialMediaSettings",
            label: "entities:cmsConfig.attributes.socialMediaSettings.label",
            type: "entityObject",
            dataType: "any",
            getEntity: function() {
                return cmsSocialMediaSettings_entity/* default */.Z;
            },
            defaultInput: false,
            inputType: "select",
            validationType: "string",
            validations: []
        },
        privacyPolicyPage: {
            name: "privacyPolicyPage",
            label: "entities:cmsConfig.attributes.privacyPolicyPage.label",
            type: "entityObject",
            dataType: "any",
            getEntity: function() {
                return cmsPage_entity/* default */.Z;
            },
            defaultInput: true,
            inputType: "select",
            validationType: "string",
            validations: [
                {
                    type: "required"
                }, 
            ]
        },
        gtcPage: {
            name: "gtcPage",
            label: "entities:cmsConfig.attributes.gtcPage.label",
            type: "entityObject",
            dataType: "any",
            getEntity: function() {
                return cmsPage_entity/* default */.Z;
            },
            defaultInput: true,
            inputType: "select",
            validationType: "string",
            validations: []
        }
    }
};
/* harmony default export */ var model = (cmsConfigModel);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(20414);
// EXTERNAL MODULE: ./src/entities/lib.ts
var lib = __webpack_require__(23480);
// EXTERNAL MODULE: ./src/lib/api/graphQLClient.ts
var graphQLClient = __webpack_require__(40112);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/swr/dist/index.mjs
var dist = __webpack_require__(8100);
// EXTERNAL MODULE: ./src/lib/helpers/helpers.ts
var helpers = __webpack_require__(15778);
;// CONCATENATED MODULE: ./src/entities/cmsConfig/repository.ts










var hydrateObjects = function(objects) {
    return objects.map(function(object) {
        return (0,lib/* hydrateEntityObject */.b)(model, object);
    });
};
var hydrateObject = function(object) {
    return (0,lib/* hydrateEntityObject */.b)(model, object);
};
var cmsConfigRepository = {
    getObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    id: id
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(SINGLE_CMS_CONFIG_QUERY, variables).then(function(data) {
                        return hydrateObject(data.cmsConfig);
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }(),
    getObjects: /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        var includes;
        var _arguments = arguments;
        return (0,tslib_es6.__generator)(this, function(_state) {
            includes = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : {};
            return [
                2,
                graphQLClient/* default.request */.Z.request(ALL_CMS_CONFIGS_QUERY, includes).then(function(data) {
                    return hydrateObjects(data.cmsConfigs);
                })
            ];
        });
    }),
    useObject: function(id) {
        var includes = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        // eslint-disable-next-line react-hooks/exhaustive-deps
        var variables = (0,react.useMemo)(function() {
            return (0,_object_spread/* default */.Z)({
                id: id
            }, includes);
        }, [
            id
        ]);
        var ref = (0,dist/* default */.ZP)([
            SINGLE_CMS_CONFIG_QUERY,
            variables
        ], {
            revalidateOnFocus: false
        }), data = ref.data, error = ref.error, mutate = ref.mutate;
        return {
            object: !data ? data : hydrateObject(data.cmsConfig),
            isLoading: !error && !data,
            isError: error,
            mutate: mutate
        };
    },
    useObjects: function() {
        var includes = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        // eslint-disable-next-line react-hooks/exhaustive-deps
        var variables = (0,react.useMemo)(function() {
            return includes;
        }, []);
        var ref = (0,dist/* default */.ZP)([
            ALL_CMS_CONFIGS_QUERY,
            variables
        ]), data = ref.data, error = ref.error, mutate = ref.mutate;
        return {
            objects: !data ? data : hydrateObjects(data.cmsConfigs),
            isLoading: !error && !data,
            isError: error,
            mutate: mutate
        };
    },
    getDependents: function(id, includes) {
        var includeVars = {};
        includes.forEach(function(include) {
            includeVars["with".concat((0,helpers/* uppercaseFirst */.AB)(include))] = true;
        });
        var variables = (0,_object_spread/* default */.Z)({
            id: id
        }, includeVars);
        return graphQLClient/* default.request */.Z.request(CMS_CONFIGS_DEPENDENTS_QUERY, variables).then(function(data) {
            return data.groupedDependents;
        });
    },
    useDependents: function(id, includes) {
        var includeVars = {};
        includes.forEach(function(include) {
            includeVars["with".concat((0,helpers/* uppercaseFirst */.AB)(include))] = true;
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
        var variables = (0,react.useMemo)(function() {
            return (0,_object_spread/* default */.Z)({
                id: id
            }, includeVars);
        }, [
            id
        ]);
        var ref = (0,dist/* default */.ZP)([
            CMS_CONFIGS_DEPENDENTS_QUERY,
            variables
        ], {
            revalidateOnFocus: false
        }), data = ref.data, error = ref.error, mutate = ref.mutate;
        return {
            data: !data ? data : data.groupedDependents,
            isLoading: !error && !data,
            isError: error,
            mutate: mutate
        };
    },
    createObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(data) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    input: data
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(CREATE_CMS_CONFIG_MUTATION, variables).then(function(data) {
                        return hydrateObject(data.cmsConfig);
                    })
                ];
            });
        });
        return function(data) {
            return _ref.apply(this, arguments);
        };
    }(),
    updateObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(data) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    input: data
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(UPDATE_CMS_CONFIG_MUTATION, variables).then(function(data) {
                        return hydrateObject(data.cmsConfig);
                    })
                ];
            });
        });
        return function(data) {
            return _ref.apply(this, arguments);
        };
    }(),
    deleteObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(DELETE_CMS_CONFIG_MUTATION, variables).then(function(data) {
                        return data.deleteCmsConfig;
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }(),
    forceDeleteObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(FORCE_DELETE_CMS_CONFIG_MUTATION, variables).then(function(data) {
                        return data.forceDeleteCmsConfig;
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }()
};
/* harmony default export */ var repository = (cmsConfigRepository);

;// CONCATENATED MODULE: ./src/entities/cmsConfig/entity.ts


var cmsConfigEntity = {
    model: model,
    repository: repository
};
/* harmony default export */ var cmsConfig_entity = (cmsConfigEntity);


/***/ }),

/***/ 14214:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ entity; }
});

;// CONCATENATED MODULE: ./src/entities/cmsContactBlockSettings/graphql.ts
// language=GraphQL
var ALL_CONTACT_BLOCK_SETTINGS_QUERY = "query Query {\n  contactBlockSettings: allCmsContactBlockSettings {\n    id\n    slogan\n    title\n    text\n    phonePrefix\n    phone\n    phone2Prefix\n    phone2\n    openingHours1\n    openingHours2\n    email\n  }\n}";
// language=GraphQL
var SINGLE_CONTACT_BLOCK_SETTINGS_QUERY = "query Query($id: ID!) {\n  contactBlockSettings: cmsContactBlockSettings(id: $id) {\n    id\n    slogan\n    title\n    text\n    phonePrefix\n    phone\n    phone2Prefix\n    phone2\n    openingHours1\n    openingHours2\n    email\n  }\n}";
// language=GraphQL
var CREATE_CONTACT_BLOCK_SETTINGS_MUTATION = "\n  mutation Mutation($input: CreateCmsContactBlockSettingsInput) {\n    contactBlockSettings: createCmsContactBlockSettings(input: $input) {\n      id\n      slogan\n      title\n      text\n      phonePrefix\n      phone\n      phone2Prefix\n      phone2\n      openingHours1\n      openingHours2\n      email\n    }\n  }";
// language=GraphQL
var UPDATE_CONTACT_BLOCK_SETTINGS_MUTATION = "\n  mutation Mutation($input: UpdateCmsContactBlockSettingsInput) {\n    contactBlockSettings: updateCmsContactBlockSettings(input: $input) {\n      id\n      slogan\n      title\n      text\n      phonePrefix\n      phone\n      phone2Prefix\n      phone2\n      openingHours1\n      openingHours2\n      email\n    }\n  }";
// language=GraphQL
var DELETE_CONTACT_BLOCK_SETTINGS_MUTATION = "\n  mutation Mutation($input: DeleteCmsContactBlockSettingsInput) {\n    deleteCmsContactBlockSettings(input: $input) {\n      success\n    }\n  }";
// language=GraphQL
var FORCE_DELETE_CONTACT_BLOCK_SETTINGS_MUTATION = "\n  mutation Mutation($input: DeleteCmsContactBlockSettingsInput) {\n    forceDeleteCmsContactBlockSettings(input: $input) {\n      success\n    }\n  }";
// language=GraphQL
var CONTACT_BLOCK_SETTINGS_DEPENDENTS_QUERY = "query Query($id: ID!, $withCmsConfigs: Boolean = false) {\n  groupedDependents: cmsContactBlockSettingsDependents(id: $id) {\n    cmsConfigs @include(if: $withCmsConfigs) {\n      id\n    }\n  }\n}";

;// CONCATENATED MODULE: ./src/entities/cmsContactBlockSettings/model.ts

var cmsContactBlockSettingsModel = {
    name: "contactBlockSettings",
    namePlural: "contactBlockSettings",
    uniqueName: "cmsContactBlockSettings",
    uniqueNamePlural: "cmsContactBlockSettings",
    path: "cms/config/contact_block_settings",
    baseUrl: "/cms/config/contact_block_settings",
    translationPrefix: "entities:cmsContactBlockSettings.",
    getDisplayName: function(values) {
        return "CMS Contact Block Settings";
    },
    gql: {
        getAll: ALL_CONTACT_BLOCK_SETTINGS_QUERY,
        getSingle: SINGLE_CONTACT_BLOCK_SETTINGS_QUERY,
        create: CREATE_CONTACT_BLOCK_SETTINGS_MUTATION,
        update: UPDATE_CONTACT_BLOCK_SETTINGS_MUTATION,
        delete: DELETE_CONTACT_BLOCK_SETTINGS_MUTATION,
        forceDelete: FORCE_DELETE_CONTACT_BLOCK_SETTINGS_MUTATION
    },
    attributes: {
        slogan: {
            name: "slogan",
            label: "entities:cmsContactBlockSettings.attributes.slogan.label",
            type: "value",
            dataType: "string",
            defaultInput: true,
            inputType: "text",
            validationType: "string",
            validations: [
                {
                    type: "required"
                }, 
            ]
        },
        title: {
            name: "title",
            label: "entities:cmsContactBlockSettings.attributes.title.label",
            type: "value",
            dataType: "string",
            defaultInput: true,
            inputType: "text",
            validationType: "string",
            validations: [
                {
                    type: "required"
                }, 
            ]
        },
        text: {
            name: "text",
            label: "entities:cmsContactBlockSettings.attributes.text.label",
            type: "value",
            dataType: "string",
            defaultInput: true,
            inputType: "textarea",
            validationType: "string",
            validations: [
                {
                    type: "required"
                }, 
            ]
        },
        phonePrefix: {
            name: "phonePrefix",
            label: "entities:cmsContactBlockSettings.attributes.phonePrefix.label",
            type: "value",
            dataType: "string",
            defaultInput: true,
            inputType: "text",
            validationType: "string",
            validations: []
        },
        phone: {
            name: "phone",
            label: "entities:cmsContactBlockSettings.attributes.phone.label",
            type: "value",
            dataType: "string",
            defaultInput: true,
            inputType: "text",
            validationType: "string",
            validations: [
                {
                    type: "required"
                }, 
            ]
        },
        phone2Prefix: {
            name: "phone2Prefix",
            label: "entities:cmsContactBlockSettings.attributes.phone2Prefix.label",
            type: "value",
            dataType: "string",
            defaultInput: true,
            inputType: "text",
            validationType: "string",
            validations: []
        },
        phone2: {
            name: "phone2",
            label: "entities:cmsContactBlockSettings.attributes.phone2.label",
            type: "value",
            dataType: "string",
            defaultInput: true,
            inputType: "text",
            validationType: "string",
            validations: []
        },
        openingHours1: {
            name: "openingHours1",
            label: "entities:cmsContactBlockSettings.attributes.openingHours1.label",
            type: "value",
            dataType: "string",
            defaultInput: true,
            inputType: "text",
            validationType: "string",
            validations: [
                {
                    type: "required"
                }, 
            ]
        },
        openingHours2: {
            name: "openingHours2",
            label: "entities:cmsContactBlockSettings.attributes.openingHours2.label",
            type: "value",
            dataType: "string",
            defaultInput: true,
            inputType: "text",
            validationType: "string",
            validations: []
        },
        email: {
            name: "email",
            label: "entities:cmsContactBlockSettings.attributes.email.label",
            type: "value",
            dataType: "string",
            defaultInput: true,
            inputType: "text",
            validationType: "string",
            validations: [
                {
                    type: "required"
                },
                {
                    type: "email"
                }, 
            ]
        }
    }
};
/* harmony default export */ var model = (cmsContactBlockSettingsModel);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(20414);
// EXTERNAL MODULE: ./src/entities/lib.ts
var lib = __webpack_require__(23480);
// EXTERNAL MODULE: ./src/lib/api/graphQLClient.ts
var graphQLClient = __webpack_require__(40112);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/swr/dist/index.mjs
var dist = __webpack_require__(8100);
// EXTERNAL MODULE: ./src/lib/helpers/helpers.ts
var helpers = __webpack_require__(15778);
;// CONCATENATED MODULE: ./src/entities/cmsContactBlockSettings/repository.ts










var hydrateObjects = function(objects) {
    return objects.map(function(object) {
        return (0,lib/* hydrateEntityObject */.b)(model, object);
    });
};
var hydrateObject = function(object) {
    return (0,lib/* hydrateEntityObject */.b)(model, object);
};
var cmsContactBlockSettingsRepository = {
    getObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    id: id
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(SINGLE_CONTACT_BLOCK_SETTINGS_QUERY, variables).then(function(data) {
                        return hydrateObject(data.contactBlockSettings);
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }(),
    getObjects: /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        var includes;
        var _arguments = arguments;
        return (0,tslib_es6.__generator)(this, function(_state) {
            includes = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : {};
            return [
                2,
                graphQLClient/* default.request */.Z.request(ALL_CONTACT_BLOCK_SETTINGS_QUERY, includes).then(function(data) {
                    return hydrateObjects(data.contactBlockSettings);
                })
            ];
        });
    }),
    useObject: function(id) {
        var includes = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        // eslint-disable-next-line react-hooks/exhaustive-deps
        var variables = (0,react.useMemo)(function() {
            return (0,_object_spread/* default */.Z)({
                id: id
            }, includes);
        }, [
            id
        ]);
        var ref = (0,dist/* default */.ZP)([
            SINGLE_CONTACT_BLOCK_SETTINGS_QUERY,
            variables
        ], {
            revalidateOnFocus: false
        }), data = ref.data, error = ref.error, mutate = ref.mutate;
        return {
            object: !data ? data : hydrateObject(data.contactBlockSettings),
            isLoading: !error && !data,
            isError: error,
            mutate: mutate
        };
    },
    useObjects: function() {
        var includes = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        // eslint-disable-next-line react-hooks/exhaustive-deps
        var variables = (0,react.useMemo)(function() {
            return includes;
        }, []);
        var ref = (0,dist/* default */.ZP)([
            ALL_CONTACT_BLOCK_SETTINGS_QUERY,
            variables
        ]), data = ref.data, error = ref.error, mutate = ref.mutate;
        return {
            objects: !data ? data : hydrateObjects(data.contactBlockSettings),
            isLoading: !error && !data,
            isError: error,
            mutate: mutate
        };
    },
    getDependents: function(id, includes) {
        var includeVars = {};
        includes.forEach(function(include) {
            includeVars["with".concat((0,helpers/* uppercaseFirst */.AB)(include))] = true;
        });
        var variables = (0,_object_spread/* default */.Z)({
            id: id
        }, includeVars);
        return graphQLClient/* default.request */.Z.request(CONTACT_BLOCK_SETTINGS_DEPENDENTS_QUERY, variables).then(function(data) {
            return data.groupedDependents;
        });
    },
    useDependents: function(id, includes) {
        var includeVars = {};
        includes.forEach(function(include) {
            includeVars["with".concat((0,helpers/* uppercaseFirst */.AB)(include))] = true;
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
        var variables = (0,react.useMemo)(function() {
            return (0,_object_spread/* default */.Z)({
                id: id
            }, includeVars);
        }, [
            id
        ]);
        var ref = (0,dist/* default */.ZP)([
            CONTACT_BLOCK_SETTINGS_DEPENDENTS_QUERY,
            variables
        ], {
            revalidateOnFocus: false
        }), data = ref.data, error = ref.error, mutate = ref.mutate;
        return {
            data: !data ? data : data.groupedDependents,
            isLoading: !error && !data,
            isError: error,
            mutate: mutate
        };
    },
    createObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(data) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    input: data
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(CREATE_CONTACT_BLOCK_SETTINGS_MUTATION, variables).then(function(data) {
                        return hydrateObject(data.contactBlockSettings);
                    })
                ];
            });
        });
        return function(data) {
            return _ref.apply(this, arguments);
        };
    }(),
    updateObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(data) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    input: data
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(UPDATE_CONTACT_BLOCK_SETTINGS_MUTATION, variables).then(function(data) {
                        return hydrateObject(data.contactBlockSettings);
                    })
                ];
            });
        });
        return function(data) {
            return _ref.apply(this, arguments);
        };
    }(),
    deleteObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(DELETE_CONTACT_BLOCK_SETTINGS_MUTATION, variables).then(function(data) {
                        return data.deleteCmsContactBlockSettings;
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }(),
    forceDeleteObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(FORCE_DELETE_CONTACT_BLOCK_SETTINGS_MUTATION, variables).then(function(data) {
                        return data.forceDeleteCmsContactBlockSettings;
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }()
};
/* harmony default export */ var repository = (cmsContactBlockSettingsRepository);

;// CONCATENATED MODULE: ./src/entities/cmsContactBlockSettings/entity.ts


var cmsContactBlockSettingsEntity = {
    model: model,
    repository: repository
};
/* harmony default export */ var entity = (cmsContactBlockSettingsEntity);


/***/ }),

/***/ 94850:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ cmsContentBlockAssignment_entity; }
});

;// CONCATENATED MODULE: ./src/entities/cmsContentBlockAssignment/graphql.ts
// language=GraphQL
var ALL_CONTENT_BLOCK_ASSIGNMENTS_QUERY = "query Query($withBlock: Boolean = false, $withBlockDeep: Boolean = false) {\n  contentBlockAssignments: cmsContentBlockAssignments {\n    id\n    type\n    block @include(if: $withBlock) {\n      __typename\n      ... on CmsTextBlock {\n        id\n        text\n\n      }\n      ... on CmsTextWithImageBlock {\n        id\n        title\n        subtitle\n        text\n        imagePosition\n        image @include(if: $withBlockDeep) {\n          id\n          assetId\n          publicId\n          url\n          resourceType\n          format\n          width\n          height\n          caption\n          title\n          description\n        }\n        imageFixedAspectRatio\n        gallery @include(if: $withBlockDeep) {\n          id\n          images  {\n            id\n            assetId\n            publicId\n            url\n            resourceType\n            format\n            width\n            height\n            caption\n            title\n            description\n          }\n        }\n        link @include(if: $withBlockDeep) {\n          id\n          label\n          targetBlank\n          type\n          url\n          page  {\n            id\n            name\n            onlineStatus\n          }\n          travel  {\n            id\n            name\n            isBestseller\n            startDate\n            endDate\n            executionStatus\n            title\n            description\n            includedServices\n            excludedServices\n            pricingTable\n            priceCalculationInfo\n            programType\n            programText\n            minPrice\n            minPriceManualOverride\n            currency\n          }\n        }\n\n      }\n      ... on CmsPageHeaderBlock {\n        id\n        title\n        text\n        image @include(if: $withBlockDeep) {\n          id\n          assetId\n          publicId\n          url\n          resourceType\n          format\n          width\n          height\n          caption\n          title\n          description\n        }\n\n      }\n      ... on CmsWysiwygBlock {\n        id\n        html\n\n      }\n      ... on CmsHeadingBlock {\n        id\n        importance\n        heading\n        addon\n        decoration\n\n      }\n      ... on CmsTextWithIconBlock {\n        id\n        title\n        text\n        image @include(if: $withBlockDeep) {\n          id\n          assetId\n          publicId\n          url\n          resourceType\n          format\n          width\n          height\n          caption\n          title\n          description\n        }\n        imagePosition\n\n      }\n      ... on CmsAccordionBlock {\n        id\n        items @include(if: $withBlockDeep) {\n          id\n          title\n          content\n        }\n\n      }\n      ... on CmsGridBlock {\n        id\n        columns @include(if: $withBlockDeep) {\n          id\n          contentBlockAssignments  {\n            id\n            type\n          }\n        }\n\n      }\n      ... on CmsImageBlock {\n        id\n        image @include(if: $withBlockDeep) {\n          id\n          assetId\n          publicId\n          url\n          resourceType\n          format\n          width\n          height\n          caption\n          title\n          description\n        }\n        text\n        fluid\n\n      }\n      ... on CmsEmployeesBlock {\n        id\n        employees @include(if: $withBlockDeep) {\n          id\n          firstName\n          lastName\n          jobTitle\n          description\n          email\n          image  {\n            id\n            assetId\n            publicId\n            url\n            resourceType\n            format\n            width\n            height\n            caption\n            title\n            description\n          }\n          phone\n        }\n\n      }\n      ... on CmsContactBannerBlock {\n        id\n        employee @include(if: $withBlockDeep) {\n          id\n          firstName\n          lastName\n          jobTitle\n          description\n          email\n          image  {\n            id\n            assetId\n            publicId\n            url\n            resourceType\n            format\n            width\n            height\n            caption\n            title\n            description\n          }\n          phone\n        }\n        phone\n        email\n\n      }\n      ... on CmsNewsletterRegisterBlock {\n        id\n        fluid\n\n      }\n      ... on CmsIssuuCatalogBlock {\n        id\n        publicationCode\n        accountName\n\n      }\n      ... on CmsFormBlock {\n        id\n        formName\n\n      }\n      ... on CmsHeaderSliderBlock {\n        id\n        travels @include(if: $withBlockDeep) {\n          id\n          name\n          isBestseller\n          startDate\n          endDate\n          availabilityStatus  {\n            id\n            label\n            status\n            isDefaultStatus\n            isDefaultWaitlistFallback\n          }\n          executionStatus\n          travelConsultant  {\n            id\n            firstName\n            lastName\n            jobTitle\n            description\n            email\n            phone\n          }\n          label  {\n            id\n            label\n          }\n          title\n          description\n          includedServices\n          excludedServices\n          pricingTable\n          priceCalculationInfo\n          seoSettings  {\n            id\n            urlSlug\n            metaTitle\n            metaDescription\n            ogTitle\n            ogDescription\n          }\n          tenantSettings  {\n            id\n            onlineStatus\n            redirectToBooking\n            useTiming\n            startDate\n            endDate\n          }\n          highlights  {\n            id\n            text\n          }\n          partners  {\n            id\n            name\n            url\n            logoWidth\n          }\n          travelGuides  {\n            id\n            firstName\n            lastName\n            description\n          }\n          teams  {\n            id\n            name\n          }\n          accommodationAssignments  {\n            id\n            useCustomRoomTypeSelection\n          }\n          accommodations  {\n            id\n            label\n            name\n            stars\n            description\n          }\n          destinations  {\n            id\n            name\n            entryRequirements\n            medicalInformation\n            language\n            timeShift\n            climate\n            currency\n          }\n          testimonials  {\n            id\n          }\n          mainImage  {\n            id\n            assetId\n            publicId\n            url\n            resourceType\n            format\n            width\n            height\n            caption\n            title\n            description\n          }\n          mainVideo  {\n            id\n            assetId\n            publicId\n            url\n            resourceType\n            format\n            width\n            height\n            caption\n            title\n            description\n          }\n          gallery  {\n            id\n          }\n          travelPdf  {\n            id\n            assetId\n            publicId\n            url\n            resourceType\n            format\n            width\n            height\n            caption\n            title\n            description\n          }\n          travelExtensions  {\n            id\n            duration\n            name\n            description\n          }\n          programType\n          itinerary  {\n            id\n          }\n          programText\n          pricing  {\n            id\n            isTravelDocumentationAvailable\n          }\n          minPrice\n          minPriceManualOverride\n          currency\n        }\n        slides @include(if: $withBlockDeep) {\n          id\n          image  {\n            id\n            assetId\n            publicId\n            url\n            resourceType\n            format\n            width\n            height\n            caption\n            title\n            description\n          }\n          title\n          text\n          link  {\n            id\n            label\n            targetBlank\n            type\n            url\n          }\n        }\n\n      }\n      ... on CmsBestsellerSliderBlock {\n        id\n        fluid\n\n      }\n      ... on CmsFilterLeadBlock {\n        id\n        layout\n\n      }\n      ... on CmsTravelTypesBlock {\n        id\n        layout\n\n      }\n      ... on CmsPrefilteredTravelsBlock {\n        id\n        destinations @include(if: $withBlockDeep) {\n          id\n          name\n          entryRequirements\n          medicalInformation\n          language\n          timeShift\n          climate\n          currency\n        }\n        travelTypes @include(if: $withBlockDeep) {\n          id\n          name\n          description\n          image  {\n            id\n            assetId\n            publicId\n            url\n            resourceType\n            format\n            width\n            height\n            caption\n            title\n            description\n          }\n        }\n        maxResults\n\n      }\n      ... on CmsDividerBlock {\n        id\n        fluid\n\n      }\n      ... on CmsTravelSelectionBlock {\n        id\n        travels @include(if: $withBlockDeep) {\n          id\n          name\n          isBestseller\n          startDate\n          endDate\n          availabilityStatus  {\n            id\n            label\n            status\n            isDefaultStatus\n            isDefaultWaitlistFallback\n          }\n          executionStatus\n          travelConsultant  {\n            id\n            firstName\n            lastName\n            jobTitle\n            description\n            email\n            phone\n          }\n          label  {\n            id\n            label\n          }\n          title\n          description\n          includedServices\n          excludedServices\n          pricingTable\n          priceCalculationInfo\n          seoSettings  {\n            id\n            urlSlug\n            metaTitle\n            metaDescription\n            ogTitle\n            ogDescription\n          }\n          tenantSettings  {\n            id\n            onlineStatus\n            redirectToBooking\n            useTiming\n            startDate\n            endDate\n          }\n          highlights  {\n            id\n            text\n          }\n          partners  {\n            id\n            name\n            url\n            logoWidth\n          }\n          travelGuides  {\n            id\n            firstName\n            lastName\n            description\n          }\n          teams  {\n            id\n            name\n          }\n          accommodationAssignments  {\n            id\n            useCustomRoomTypeSelection\n          }\n          accommodations  {\n            id\n            label\n            name\n            stars\n            description\n          }\n          destinations  {\n            id\n            name\n            entryRequirements\n            medicalInformation\n            language\n            timeShift\n            climate\n            currency\n          }\n          testimonials  {\n            id\n          }\n          mainImage  {\n            id\n            assetId\n            publicId\n            url\n            resourceType\n            format\n            width\n            height\n            caption\n            title\n            description\n          }\n          mainVideo  {\n            id\n            assetId\n            publicId\n            url\n            resourceType\n            format\n            width\n            height\n            caption\n            title\n            description\n          }\n          gallery  {\n            id\n          }\n          travelPdf  {\n            id\n            assetId\n            publicId\n            url\n            resourceType\n            format\n            width\n            height\n            caption\n            title\n            description\n          }\n          travelExtensions  {\n            id\n            duration\n            name\n            description\n          }\n          programType\n          itinerary  {\n            id\n          }\n          programText\n          pricing  {\n            id\n            isTravelDocumentationAvailable\n          }\n          minPrice\n          minPriceManualOverride\n          currency\n        }\n\n      }\n      ... on CmsIframeBlock {\n        id\n        url\n        minHeight\n\n      }\n      ... on CmsSliderBlock {\n        id\n        fluid\n        gallery @include(if: $withBlockDeep) {\n          id\n          images  {\n            id\n            assetId\n            publicId\n            url\n            resourceType\n            format\n            width\n            height\n            caption\n            title\n            description\n          }\n        }\n        size\n        showDots\n        showArrows\n        showLightbox\n        autoplay\n\n      }\n      ... on CmsDestinationsBlock {\n        id\n        destinations @include(if: $withBlockDeep) {\n          id\n          name\n          entryRequirements\n          medicalInformation\n          language\n          timeShift\n          climate\n          currency\n        }\n\n      }\n      ... on CmsTravelGuidesBlock {\n        id\n        travelGuides @include(if: $withBlockDeep) {\n          id\n          firstName\n          lastName\n          description\n          image  {\n            id\n            assetId\n            publicId\n            url\n            resourceType\n            format\n            width\n            height\n            caption\n            title\n            description\n          }\n        }\n\n      }\n      ... on CmsBusfinderBlock {\n        id\n        title\n\n      }\n      ... on CmsBackgroundBlock {\n        id\n        backgroundVariant\n        contentBlockAssignments @include(if: $withBlockDeep) {\n          id\n          type\n          block  {\n            __typename\n            ... on CmsTextBlock {\n              id\n              text\n\n            }\n            ... on CmsTextWithImageBlock {\n              id\n              title\n              subtitle\n              text\n              imagePosition\n              imageFixedAspectRatio\n\n            }\n            ... on CmsPageHeaderBlock {\n              id\n              title\n              text\n\n            }\n            ... on CmsWysiwygBlock {\n              id\n              html\n\n            }\n            ... on CmsHeadingBlock {\n              id\n              importance\n              heading\n              addon\n              decoration\n\n            }\n            ... on CmsTextWithIconBlock {\n              id\n              title\n              text\n              imagePosition\n\n            }\n            ... on CmsAccordionBlock {\n              id\n\n            }\n            ... on CmsGridBlock {\n              id\n\n            }\n            ... on CmsImageBlock {\n              id\n              text\n              fluid\n\n            }\n            ... on CmsEmployeesBlock {\n              id\n\n            }\n            ... on CmsContactBannerBlock {\n              id\n              phone\n              email\n\n            }\n            ... on CmsNewsletterRegisterBlock {\n              id\n              fluid\n\n            }\n            ... on CmsIssuuCatalogBlock {\n              id\n              publicationCode\n              accountName\n\n            }\n            ... on CmsFormBlock {\n              id\n              formName\n\n            }\n            ... on CmsHeaderSliderBlock {\n              id\n\n            }\n            ... on CmsBestsellerSliderBlock {\n              id\n              fluid\n\n            }\n            ... on CmsFilterLeadBlock {\n              id\n              layout\n\n            }\n            ... on CmsTravelTypesBlock {\n              id\n              layout\n\n            }\n            ... on CmsPrefilteredTravelsBlock {\n              id\n              maxResults\n\n            }\n            ... on CmsDividerBlock {\n              id\n              fluid\n\n            }\n            ... on CmsTravelSelectionBlock {\n              id\n\n            }\n            ... on CmsIframeBlock {\n              id\n              url\n              minHeight\n\n            }\n            ... on CmsSliderBlock {\n              id\n              fluid\n              size\n              showDots\n              showArrows\n              showLightbox\n              autoplay\n\n            }\n            ... on CmsDestinationsBlock {\n              id\n\n            }\n            ... on CmsTravelGuidesBlock {\n              id\n\n            }\n            ... on CmsBusfinderBlock {\n              id\n              title\n\n            }\n            ... on CmsBackgroundBlock {\n              id\n              backgroundVariant\n\n            }\n          }\n        }\n\n      }\n    }\n  }\n}";
// language=GraphQL
var SINGLE_CONTENT_BLOCK_ASSIGNMENT_QUERY = "query Query($id: ID!, $withBlock: Boolean = false, $withBlockDeep: Boolean = false) {\n  contentBlockAssignment: cmsContentBlockAssignment(id: $id) {\n    id\n    type\n    block @include(if: $withBlock) {\n      __typename\n      ... on CmsTextBlock {\n        id\n        text\n\n      }\n      ... on CmsTextWithImageBlock {\n        id\n        title\n        subtitle\n        text\n        imagePosition\n        image @include(if: $withBlockDeep) {\n          id\n          assetId\n          publicId\n          url\n          resourceType\n          format\n          width\n          height\n          caption\n          title\n          description\n        }\n        imageFixedAspectRatio\n        gallery @include(if: $withBlockDeep) {\n          id\n          images  {\n            id\n            assetId\n            publicId\n            url\n            resourceType\n            format\n            width\n            height\n            caption\n            title\n            description\n          }\n        }\n        link @include(if: $withBlockDeep) {\n          id\n          label\n          targetBlank\n          type\n          url\n          page  {\n            id\n            name\n            onlineStatus\n          }\n          travel  {\n            id\n            name\n            isBestseller\n            startDate\n            endDate\n            executionStatus\n            title\n            description\n            includedServices\n            excludedServices\n            pricingTable\n            priceCalculationInfo\n            programType\n            programText\n            minPrice\n            minPriceManualOverride\n            currency\n          }\n        }\n\n      }\n      ... on CmsPageHeaderBlock {\n        id\n        title\n        text\n        image @include(if: $withBlockDeep) {\n          id\n          assetId\n          publicId\n          url\n          resourceType\n          format\n          width\n          height\n          caption\n          title\n          description\n        }\n\n      }\n      ... on CmsWysiwygBlock {\n        id\n        html\n\n      }\n      ... on CmsHeadingBlock {\n        id\n        importance\n        heading\n        addon\n        decoration\n\n      }\n      ... on CmsTextWithIconBlock {\n        id\n        title\n        text\n        image @include(if: $withBlockDeep) {\n          id\n          assetId\n          publicId\n          url\n          resourceType\n          format\n          width\n          height\n          caption\n          title\n          description\n        }\n        imagePosition\n\n      }\n      ... on CmsAccordionBlock {\n        id\n        items @include(if: $withBlockDeep) {\n          id\n          title\n          content\n        }\n\n      }\n      ... on CmsGridBlock {\n        id\n        columns @include(if: $withBlockDeep) {\n          id\n          contentBlockAssignments  {\n            id\n            type\n          }\n        }\n\n      }\n      ... on CmsImageBlock {\n        id\n        image @include(if: $withBlockDeep) {\n          id\n          assetId\n          publicId\n          url\n          resourceType\n          format\n          width\n          height\n          caption\n          title\n          description\n        }\n        text\n        fluid\n\n      }\n      ... on CmsEmployeesBlock {\n        id\n        employees @include(if: $withBlockDeep) {\n          id\n          firstName\n          lastName\n          jobTitle\n          description\n          email\n          image  {\n            id\n            assetId\n            publicId\n            url\n            resourceType\n            format\n            width\n            height\n            caption\n            title\n            description\n          }\n          phone\n        }\n\n      }\n      ... on CmsContactBannerBlock {\n        id\n        employee @include(if: $withBlockDeep) {\n          id\n          firstName\n          lastName\n          jobTitle\n          description\n          email\n          image  {\n            id\n            assetId\n            publicId\n            url\n            resourceType\n            format\n            width\n            height\n            caption\n            title\n            description\n          }\n          phone\n        }\n        phone\n        email\n\n      }\n      ... on CmsNewsletterRegisterBlock {\n        id\n        fluid\n\n      }\n      ... on CmsIssuuCatalogBlock {\n        id\n        publicationCode\n        accountName\n\n      }\n      ... on CmsFormBlock {\n        id\n        formName\n\n      }\n      ... on CmsHeaderSliderBlock {\n        id\n        travels @include(if: $withBlockDeep) {\n          id\n          name\n          isBestseller\n          startDate\n          endDate\n          availabilityStatus  {\n            id\n            label\n            status\n            isDefaultStatus\n            isDefaultWaitlistFallback\n          }\n          executionStatus\n          travelConsultant  {\n            id\n            firstName\n            lastName\n            jobTitle\n            description\n            email\n            phone\n          }\n          label  {\n            id\n            label\n          }\n          title\n          description\n          includedServices\n          excludedServices\n          pricingTable\n          priceCalculationInfo\n          seoSettings  {\n            id\n            urlSlug\n            metaTitle\n            metaDescription\n            ogTitle\n            ogDescription\n          }\n          tenantSettings  {\n            id\n            onlineStatus\n            redirectToBooking\n            useTiming\n            startDate\n            endDate\n          }\n          highlights  {\n            id\n            text\n          }\n          partners  {\n            id\n            name\n            url\n            logoWidth\n          }\n          travelGuides  {\n            id\n            firstName\n            lastName\n            description\n          }\n          teams  {\n            id\n            name\n          }\n          accommodationAssignments  {\n            id\n            useCustomRoomTypeSelection\n          }\n          accommodations  {\n            id\n            label\n            name\n            stars\n            description\n          }\n          destinations  {\n            id\n            name\n            entryRequirements\n            medicalInformation\n            language\n            timeShift\n            climate\n            currency\n          }\n          testimonials  {\n            id\n          }\n          mainImage  {\n            id\n            assetId\n            publicId\n            url\n            resourceType\n            format\n            width\n            height\n            caption\n            title\n            description\n          }\n          mainVideo  {\n            id\n            assetId\n            publicId\n            url\n            resourceType\n            format\n            width\n            height\n            caption\n            title\n            description\n          }\n          gallery  {\n            id\n          }\n          travelPdf  {\n            id\n            assetId\n            publicId\n            url\n            resourceType\n            format\n            width\n            height\n            caption\n            title\n            description\n          }\n          travelExtensions  {\n            id\n            duration\n            name\n            description\n          }\n          programType\n          itinerary  {\n            id\n          }\n          programText\n          pricing  {\n            id\n            isTravelDocumentationAvailable\n          }\n          minPrice\n          minPriceManualOverride\n          currency\n        }\n        slides @include(if: $withBlockDeep) {\n          id\n          image  {\n            id\n            assetId\n            publicId\n            url\n            resourceType\n            format\n            width\n            height\n            caption\n            title\n            description\n          }\n          title\n          text\n          link  {\n            id\n            label\n            targetBlank\n            type\n            url\n          }\n        }\n\n      }\n      ... on CmsBestsellerSliderBlock {\n        id\n        fluid\n\n      }\n      ... on CmsFilterLeadBlock {\n        id\n        layout\n\n      }\n      ... on CmsTravelTypesBlock {\n        id\n        layout\n\n      }\n      ... on CmsPrefilteredTravelsBlock {\n        id\n        destinations @include(if: $withBlockDeep) {\n          id\n          name\n          entryRequirements\n          medicalInformation\n          language\n          timeShift\n          climate\n          currency\n        }\n        travelTypes @include(if: $withBlockDeep) {\n          id\n          name\n          description\n          image  {\n            id\n            assetId\n            publicId\n            url\n            resourceType\n            format\n            width\n            height\n            caption\n            title\n            description\n          }\n        }\n        maxResults\n\n      }\n      ... on CmsDividerBlock {\n        id\n        fluid\n\n      }\n      ... on CmsTravelSelectionBlock {\n        id\n        travels @include(if: $withBlockDeep) {\n          id\n          name\n          isBestseller\n          startDate\n          endDate\n          availabilityStatus  {\n            id\n            label\n            status\n            isDefaultStatus\n            isDefaultWaitlistFallback\n          }\n          executionStatus\n          travelConsultant  {\n            id\n            firstName\n            lastName\n            jobTitle\n            description\n            email\n            phone\n          }\n          label  {\n            id\n            label\n          }\n          title\n          description\n          includedServices\n          excludedServices\n          pricingTable\n          priceCalculationInfo\n          seoSettings  {\n            id\n            urlSlug\n            metaTitle\n            metaDescription\n            ogTitle\n            ogDescription\n          }\n          tenantSettings  {\n            id\n            onlineStatus\n            redirectToBooking\n            useTiming\n            startDate\n            endDate\n          }\n          highlights  {\n            id\n            text\n          }\n          partners  {\n            id\n            name\n            url\n            logoWidth\n          }\n          travelGuides  {\n            id\n            firstName\n            lastName\n            description\n          }\n          teams  {\n            id\n            name\n          }\n          accommodationAssignments  {\n            id\n            useCustomRoomTypeSelection\n          }\n          accommodations  {\n            id\n            label\n            name\n            stars\n            description\n          }\n          destinations  {\n            id\n            name\n            entryRequirements\n            medicalInformation\n            language\n            timeShift\n            climate\n            currency\n          }\n          testimonials  {\n            id\n          }\n          mainImage  {\n            id\n            assetId\n            publicId\n            url\n            resourceType\n            format\n            width\n            height\n            caption\n            title\n            description\n          }\n          mainVideo  {\n            id\n            assetId\n            publicId\n            url\n            resourceType\n            format\n            width\n            height\n            caption\n            title\n            description\n          }\n          gallery  {\n            id\n          }\n          travelPdf  {\n            id\n            assetId\n            publicId\n            url\n            resourceType\n            format\n            width\n            height\n            caption\n            title\n            description\n          }\n          travelExtensions  {\n            id\n            duration\n            name\n            description\n          }\n          programType\n          itinerary  {\n            id\n          }\n          programText\n          pricing  {\n            id\n            isTravelDocumentationAvailable\n          }\n          minPrice\n          minPriceManualOverride\n          currency\n        }\n\n      }\n      ... on CmsIframeBlock {\n        id\n        url\n        minHeight\n\n      }\n      ... on CmsSliderBlock {\n        id\n        fluid\n        gallery @include(if: $withBlockDeep) {\n          id\n          images  {\n            id\n            assetId\n            publicId\n            url\n            resourceType\n            format\n            width\n            height\n            caption\n            title\n            description\n          }\n        }\n        size\n        showDots\n        showArrows\n        showLightbox\n        autoplay\n\n      }\n      ... on CmsDestinationsBlock {\n        id\n        destinations @include(if: $withBlockDeep) {\n          id\n          name\n          entryRequirements\n          medicalInformation\n          language\n          timeShift\n          climate\n          currency\n        }\n\n      }\n      ... on CmsTravelGuidesBlock {\n        id\n        travelGuides @include(if: $withBlockDeep) {\n          id\n          firstName\n          lastName\n          description\n          image  {\n            id\n            assetId\n            publicId\n            url\n            resourceType\n            format\n            width\n            height\n            caption\n            title\n            description\n          }\n        }\n\n      }\n      ... on CmsBusfinderBlock {\n        id\n        title\n\n      }\n      ... on CmsBackgroundBlock {\n        id\n        backgroundVariant\n        contentBlockAssignments @include(if: $withBlockDeep) {\n          id\n          type\n          block  {\n            __typename\n            ... on CmsTextBlock {\n              id\n              text\n\n            }\n            ... on CmsTextWithImageBlock {\n              id\n              title\n              subtitle\n              text\n              imagePosition\n              imageFixedAspectRatio\n\n            }\n            ... on CmsPageHeaderBlock {\n              id\n              title\n              text\n\n            }\n            ... on CmsWysiwygBlock {\n              id\n              html\n\n            }\n            ... on CmsHeadingBlock {\n              id\n              importance\n              heading\n              addon\n              decoration\n\n            }\n            ... on CmsTextWithIconBlock {\n              id\n              title\n              text\n              imagePosition\n\n            }\n            ... on CmsAccordionBlock {\n              id\n\n            }\n            ... on CmsGridBlock {\n              id\n\n            }\n            ... on CmsImageBlock {\n              id\n              text\n              fluid\n\n            }\n            ... on CmsEmployeesBlock {\n              id\n\n            }\n            ... on CmsContactBannerBlock {\n              id\n              phone\n              email\n\n            }\n            ... on CmsNewsletterRegisterBlock {\n              id\n              fluid\n\n            }\n            ... on CmsIssuuCatalogBlock {\n              id\n              publicationCode\n              accountName\n\n            }\n            ... on CmsFormBlock {\n              id\n              formName\n\n            }\n            ... on CmsHeaderSliderBlock {\n              id\n\n            }\n            ... on CmsBestsellerSliderBlock {\n              id\n              fluid\n\n            }\n            ... on CmsFilterLeadBlock {\n              id\n              layout\n\n            }\n            ... on CmsTravelTypesBlock {\n              id\n              layout\n\n            }\n            ... on CmsPrefilteredTravelsBlock {\n              id\n              maxResults\n\n            }\n            ... on CmsDividerBlock {\n              id\n              fluid\n\n            }\n            ... on CmsTravelSelectionBlock {\n              id\n\n            }\n            ... on CmsIframeBlock {\n              id\n              url\n              minHeight\n\n            }\n            ... on CmsSliderBlock {\n              id\n              fluid\n              size\n              showDots\n              showArrows\n              showLightbox\n              autoplay\n\n            }\n            ... on CmsDestinationsBlock {\n              id\n\n            }\n            ... on CmsTravelGuidesBlock {\n              id\n\n            }\n            ... on CmsBusfinderBlock {\n              id\n              title\n\n            }\n            ... on CmsBackgroundBlock {\n              id\n              backgroundVariant\n\n            }\n          }\n        }\n\n      }\n    }\n  }\n}";
// language=GraphQL
var CREATE_CONTENT_BLOCK_ASSIGNMENT_MUTATION = "\n  mutation Mutation($input: CreateCmsContentBlockAssignmentInput, $withBlock: Boolean = false, $withBlockDeep: Boolean = false) {\n    contentBlockAssignment: createCmsContentBlockAssignment(input: $input) {\n      id\n      type\n      block @include(if: $withBlock) {\n        __typename\n        ... on CmsTextBlock {\n          id\n          text\n\n        }\n        ... on CmsTextWithImageBlock {\n          id\n          title\n          subtitle\n          text\n          imagePosition\n          image @include(if: $withBlockDeep) {\n            id\n            assetId\n            publicId\n            url\n            resourceType\n            format\n            width\n            height\n            caption\n            title\n            description\n          }\n          imageFixedAspectRatio\n          gallery @include(if: $withBlockDeep) {\n            id\n            images  {\n              id\n              assetId\n              publicId\n              url\n              resourceType\n              format\n              width\n              height\n              caption\n              title\n              description\n            }\n          }\n          link @include(if: $withBlockDeep) {\n            id\n            label\n            targetBlank\n            type\n            url\n            page  {\n              id\n              name\n              onlineStatus\n            }\n            travel  {\n              id\n              name\n              isBestseller\n              startDate\n              endDate\n              executionStatus\n              title\n              description\n              includedServices\n              excludedServices\n              pricingTable\n              priceCalculationInfo\n              programType\n              programText\n              minPrice\n              minPriceManualOverride\n              currency\n            }\n          }\n\n        }\n        ... on CmsPageHeaderBlock {\n          id\n          title\n          text\n          image @include(if: $withBlockDeep) {\n            id\n            assetId\n            publicId\n            url\n            resourceType\n            format\n            width\n            height\n            caption\n            title\n            description\n          }\n\n        }\n        ... on CmsWysiwygBlock {\n          id\n          html\n\n        }\n        ... on CmsHeadingBlock {\n          id\n          importance\n          heading\n          addon\n          decoration\n\n        }\n        ... on CmsTextWithIconBlock {\n          id\n          title\n          text\n          image @include(if: $withBlockDeep) {\n            id\n            assetId\n            publicId\n            url\n            resourceType\n            format\n            width\n            height\n            caption\n            title\n            description\n          }\n          imagePosition\n\n        }\n        ... on CmsAccordionBlock {\n          id\n          items @include(if: $withBlockDeep) {\n            id\n            title\n            content\n          }\n\n        }\n        ... on CmsGridBlock {\n          id\n          columns @include(if: $withBlockDeep) {\n            id\n            contentBlockAssignments  {\n              id\n              type\n            }\n          }\n\n        }\n        ... on CmsImageBlock {\n          id\n          image @include(if: $withBlockDeep) {\n            id\n            assetId\n            publicId\n            url\n            resourceType\n            format\n            width\n            height\n            caption\n            title\n            description\n          }\n          text\n          fluid\n\n        }\n        ... on CmsEmployeesBlock {\n          id\n          employees @include(if: $withBlockDeep) {\n            id\n            firstName\n            lastName\n            jobTitle\n            description\n            email\n            image  {\n              id\n              assetId\n              publicId\n              url\n              resourceType\n              format\n              width\n              height\n              caption\n              title\n              description\n            }\n            phone\n          }\n\n        }\n        ... on CmsContactBannerBlock {\n          id\n          employee @include(if: $withBlockDeep) {\n            id\n            firstName\n            lastName\n            jobTitle\n            description\n            email\n            image  {\n              id\n              assetId\n              publicId\n              url\n              resourceType\n              format\n              width\n              height\n              caption\n              title\n              description\n            }\n            phone\n          }\n          phone\n          email\n\n        }\n        ... on CmsNewsletterRegisterBlock {\n          id\n          fluid\n\n        }\n        ... on CmsIssuuCatalogBlock {\n          id\n          publicationCode\n          accountName\n\n        }\n        ... on CmsFormBlock {\n          id\n          formName\n\n        }\n        ... on CmsHeaderSliderBlock {\n          id\n          travels @include(if: $withBlockDeep) {\n            id\n            name\n            isBestseller\n            startDate\n            endDate\n            availabilityStatus  {\n              id\n              label\n              status\n              isDefaultStatus\n              isDefaultWaitlistFallback\n            }\n            executionStatus\n            travelConsultant  {\n              id\n              firstName\n              lastName\n              jobTitle\n              description\n              email\n              phone\n            }\n            label  {\n              id\n              label\n            }\n            title\n            description\n            includedServices\n            excludedServices\n            pricingTable\n            priceCalculationInfo\n            seoSettings  {\n              id\n              urlSlug\n              metaTitle\n              metaDescription\n              ogTitle\n              ogDescription\n            }\n            tenantSettings  {\n              id\n              onlineStatus\n              redirectToBooking\n              useTiming\n              startDate\n              endDate\n            }\n            highlights  {\n              id\n              text\n            }\n            partners  {\n              id\n              name\n              url\n              logoWidth\n            }\n            travelGuides  {\n              id\n              firstName\n              lastName\n              description\n            }\n            teams  {\n              id\n              name\n            }\n            accommodationAssignments  {\n              id\n              useCustomRoomTypeSelection\n            }\n            accommodations  {\n              id\n              label\n              name\n              stars\n              description\n            }\n            destinations  {\n              id\n              name\n              entryRequirements\n              medicalInformation\n              language\n              timeShift\n              climate\n              currency\n            }\n            testimonials  {\n              id\n            }\n            mainImage  {\n              id\n              assetId\n              publicId\n              url\n              resourceType\n              format\n              width\n              height\n              caption\n              title\n              description\n            }\n            mainVideo  {\n              id\n              assetId\n              publicId\n              url\n              resourceType\n              format\n              width\n              height\n              caption\n              title\n              description\n            }\n            gallery  {\n              id\n            }\n            travelPdf  {\n              id\n              assetId\n              publicId\n              url\n              resourceType\n              format\n              width\n              height\n              caption\n              title\n              description\n            }\n            travelExtensions  {\n              id\n              duration\n              name\n              description\n            }\n            programType\n            itinerary  {\n              id\n            }\n            programText\n            pricing  {\n              id\n              isTravelDocumentationAvailable\n            }\n            minPrice\n            minPriceManualOverride\n            currency\n          }\n          slides @include(if: $withBlockDeep) {\n            id\n            image  {\n              id\n              assetId\n              publicId\n              url\n              resourceType\n              format\n              width\n              height\n              caption\n              title\n              description\n            }\n            title\n            text\n            link  {\n              id\n              label\n              targetBlank\n              type\n              url\n            }\n          }\n\n        }\n        ... on CmsBestsellerSliderBlock {\n          id\n          fluid\n\n        }\n        ... on CmsFilterLeadBlock {\n          id\n          layout\n\n        }\n        ... on CmsTravelTypesBlock {\n          id\n          layout\n\n        }\n        ... on CmsPrefilteredTravelsBlock {\n          id\n          destinations @include(if: $withBlockDeep) {\n            id\n            name\n            entryRequirements\n            medicalInformation\n            language\n            timeShift\n            climate\n            currency\n          }\n          travelTypes @include(if: $withBlockDeep) {\n            id\n            name\n            description\n            image  {\n              id\n              assetId\n              publicId\n              url\n              resourceType\n              format\n              width\n              height\n              caption\n              title\n              description\n            }\n          }\n          maxResults\n\n        }\n        ... on CmsDividerBlock {\n          id\n          fluid\n\n        }\n        ... on CmsTravelSelectionBlock {\n          id\n          travels @include(if: $withBlockDeep) {\n            id\n            name\n            isBestseller\n            startDate\n            endDate\n            availabilityStatus  {\n              id\n              label\n              status\n              isDefaultStatus\n              isDefaultWaitlistFallback\n            }\n            executionStatus\n            travelConsultant  {\n              id\n              firstName\n              lastName\n              jobTitle\n              description\n              email\n              phone\n            }\n            label  {\n              id\n              label\n            }\n            title\n            description\n            includedServices\n            excludedServices\n            pricingTable\n            priceCalculationInfo\n            seoSettings  {\n              id\n              urlSlug\n              metaTitle\n              metaDescription\n              ogTitle\n              ogDescription\n            }\n            tenantSettings  {\n              id\n              onlineStatus\n              redirectToBooking\n              useTiming\n              startDate\n              endDate\n            }\n            highlights  {\n              id\n              text\n            }\n            partners  {\n              id\n              name\n              url\n              logoWidth\n            }\n            travelGuides  {\n              id\n              firstName\n              lastName\n              description\n            }\n            teams  {\n              id\n              name\n            }\n            accommodationAssignments  {\n              id\n              useCustomRoomTypeSelection\n            }\n            accommodations  {\n              id\n              label\n              name\n              stars\n              description\n            }\n            destinations  {\n              id\n              name\n              entryRequirements\n              medicalInformation\n              language\n              timeShift\n              climate\n              currency\n            }\n            testimonials  {\n              id\n            }\n            mainImage  {\n              id\n              assetId\n              publicId\n              url\n              resourceType\n              format\n              width\n              height\n              caption\n              title\n              description\n            }\n            mainVideo  {\n              id\n              assetId\n              publicId\n              url\n              resourceType\n              format\n              width\n              height\n              caption\n              title\n              description\n            }\n            gallery  {\n              id\n            }\n            travelPdf  {\n              id\n              assetId\n              publicId\n              url\n              resourceType\n              format\n              width\n              height\n              caption\n              title\n              description\n            }\n            travelExtensions  {\n              id\n              duration\n              name\n              description\n            }\n            programType\n            itinerary  {\n              id\n            }\n            programText\n            pricing  {\n              id\n              isTravelDocumentationAvailable\n            }\n            minPrice\n            minPriceManualOverride\n            currency\n          }\n\n        }\n        ... on CmsIframeBlock {\n          id\n          url\n          minHeight\n\n        }\n        ... on CmsSliderBlock {\n          id\n          fluid\n          gallery @include(if: $withBlockDeep) {\n            id\n            images  {\n              id\n              assetId\n              publicId\n              url\n              resourceType\n              format\n              width\n              height\n              caption\n              title\n              description\n            }\n          }\n          size\n          showDots\n          showArrows\n          showLightbox\n          autoplay\n\n        }\n        ... on CmsDestinationsBlock {\n          id\n          destinations @include(if: $withBlockDeep) {\n            id\n            name\n            entryRequirements\n            medicalInformation\n            language\n            timeShift\n            climate\n            currency\n          }\n\n        }\n        ... on CmsTravelGuidesBlock {\n          id\n          travelGuides @include(if: $withBlockDeep) {\n            id\n            firstName\n            lastName\n            description\n            image  {\n              id\n              assetId\n              publicId\n              url\n              resourceType\n              format\n              width\n              height\n              caption\n              title\n              description\n            }\n          }\n\n        }\n        ... on CmsBusfinderBlock {\n          id\n          title\n\n        }\n        ... on CmsBackgroundBlock {\n          id\n          backgroundVariant\n          contentBlockAssignments @include(if: $withBlockDeep) {\n            id\n            type\n            block  {\n              __typename\n              ... on CmsTextBlock {\n                id\n                text\n\n              }\n              ... on CmsTextWithImageBlock {\n                id\n                title\n                subtitle\n                text\n                imagePosition\n                imageFixedAspectRatio\n\n              }\n              ... on CmsPageHeaderBlock {\n                id\n                title\n                text\n\n              }\n              ... on CmsWysiwygBlock {\n                id\n                html\n\n              }\n              ... on CmsHeadingBlock {\n                id\n                importance\n                heading\n                addon\n                decoration\n\n              }\n              ... on CmsTextWithIconBlock {\n                id\n                title\n                text\n                imagePosition\n\n              }\n              ... on CmsAccordionBlock {\n                id\n\n              }\n              ... on CmsGridBlock {\n                id\n\n              }\n              ... on CmsImageBlock {\n                id\n                text\n                fluid\n\n              }\n              ... on CmsEmployeesBlock {\n                id\n\n              }\n              ... on CmsContactBannerBlock {\n                id\n                phone\n                email\n\n              }\n              ... on CmsNewsletterRegisterBlock {\n                id\n                fluid\n\n              }\n              ... on CmsIssuuCatalogBlock {\n                id\n                publicationCode\n                accountName\n\n              }\n              ... on CmsFormBlock {\n                id\n                formName\n\n              }\n              ... on CmsHeaderSliderBlock {\n                id\n\n              }\n              ... on CmsBestsellerSliderBlock {\n                id\n                fluid\n\n              }\n              ... on CmsFilterLeadBlock {\n                id\n                layout\n\n              }\n              ... on CmsTravelTypesBlock {\n                id\n                layout\n\n              }\n              ... on CmsPrefilteredTravelsBlock {\n                id\n                maxResults\n\n              }\n              ... on CmsDividerBlock {\n                id\n                fluid\n\n              }\n              ... on CmsTravelSelectionBlock {\n                id\n\n              }\n              ... on CmsIframeBlock {\n                id\n                url\n                minHeight\n\n              }\n              ... on CmsSliderBlock {\n                id\n                fluid\n                size\n                showDots\n                showArrows\n                showLightbox\n                autoplay\n\n              }\n              ... on CmsDestinationsBlock {\n                id\n\n              }\n              ... on CmsTravelGuidesBlock {\n                id\n\n              }\n              ... on CmsBusfinderBlock {\n                id\n                title\n\n              }\n              ... on CmsBackgroundBlock {\n                id\n                backgroundVariant\n\n              }\n            }\n          }\n\n        }\n      }\n    }\n  }";
// language=GraphQL
var UPDATE_CONTENT_BLOCK_ASSIGNMENT_MUTATION = "\n  mutation Mutation($input: UpdateCmsContentBlockAssignmentInput, $withBlock: Boolean = false, $withBlockDeep: Boolean = false) {\n    contentBlockAssignment: updateCmsContentBlockAssignment(input: $input) {\n      id\n      type\n      block @include(if: $withBlock) {\n        __typename\n        ... on CmsTextBlock {\n          id\n          text\n\n        }\n        ... on CmsTextWithImageBlock {\n          id\n          title\n          subtitle\n          text\n          imagePosition\n          image @include(if: $withBlockDeep) {\n            id\n            assetId\n            publicId\n            url\n            resourceType\n            format\n            width\n            height\n            caption\n            title\n            description\n          }\n          imageFixedAspectRatio\n          gallery @include(if: $withBlockDeep) {\n            id\n            images  {\n              id\n              assetId\n              publicId\n              url\n              resourceType\n              format\n              width\n              height\n              caption\n              title\n              description\n            }\n          }\n          link @include(if: $withBlockDeep) {\n            id\n            label\n            targetBlank\n            type\n            url\n            page  {\n              id\n              name\n              onlineStatus\n            }\n            travel  {\n              id\n              name\n              isBestseller\n              startDate\n              endDate\n              executionStatus\n              title\n              description\n              includedServices\n              excludedServices\n              pricingTable\n              priceCalculationInfo\n              programType\n              programText\n              minPrice\n              minPriceManualOverride\n              currency\n            }\n          }\n\n        }\n        ... on CmsPageHeaderBlock {\n          id\n          title\n          text\n          image @include(if: $withBlockDeep) {\n            id\n            assetId\n            publicId\n            url\n            resourceType\n            format\n            width\n            height\n            caption\n            title\n            description\n          }\n\n        }\n        ... on CmsWysiwygBlock {\n          id\n          html\n\n        }\n        ... on CmsHeadingBlock {\n          id\n          importance\n          heading\n          addon\n          decoration\n\n        }\n        ... on CmsTextWithIconBlock {\n          id\n          title\n          text\n          image @include(if: $withBlockDeep) {\n            id\n            assetId\n            publicId\n            url\n            resourceType\n            format\n            width\n            height\n            caption\n            title\n            description\n          }\n          imagePosition\n\n        }\n        ... on CmsAccordionBlock {\n          id\n          items @include(if: $withBlockDeep) {\n            id\n            title\n            content\n          }\n\n        }\n        ... on CmsGridBlock {\n          id\n          columns @include(if: $withBlockDeep) {\n            id\n            contentBlockAssignments  {\n              id\n              type\n            }\n          }\n\n        }\n        ... on CmsImageBlock {\n          id\n          image @include(if: $withBlockDeep) {\n            id\n            assetId\n            publicId\n            url\n            resourceType\n            format\n            width\n            height\n            caption\n            title\n            description\n          }\n          text\n          fluid\n\n        }\n        ... on CmsEmployeesBlock {\n          id\n          employees @include(if: $withBlockDeep) {\n            id\n            firstName\n            lastName\n            jobTitle\n            description\n            email\n            image  {\n              id\n              assetId\n              publicId\n              url\n              resourceType\n              format\n              width\n              height\n              caption\n              title\n              description\n            }\n            phone\n          }\n\n        }\n        ... on CmsContactBannerBlock {\n          id\n          employee @include(if: $withBlockDeep) {\n            id\n            firstName\n            lastName\n            jobTitle\n            description\n            email\n            image  {\n              id\n              assetId\n              publicId\n              url\n              resourceType\n              format\n              width\n              height\n              caption\n              title\n              description\n            }\n            phone\n          }\n          phone\n          email\n\n        }\n        ... on CmsNewsletterRegisterBlock {\n          id\n          fluid\n\n        }\n        ... on CmsIssuuCatalogBlock {\n          id\n          publicationCode\n          accountName\n\n        }\n        ... on CmsFormBlock {\n          id\n          formName\n\n        }\n        ... on CmsHeaderSliderBlock {\n          id\n          travels @include(if: $withBlockDeep) {\n            id\n            name\n            isBestseller\n            startDate\n            endDate\n            availabilityStatus  {\n              id\n              label\n              status\n              isDefaultStatus\n              isDefaultWaitlistFallback\n            }\n            executionStatus\n            travelConsultant  {\n              id\n              firstName\n              lastName\n              jobTitle\n              description\n              email\n              phone\n            }\n            label  {\n              id\n              label\n            }\n            title\n            description\n            includedServices\n            excludedServices\n            pricingTable\n            priceCalculationInfo\n            seoSettings  {\n              id\n              urlSlug\n              metaTitle\n              metaDescription\n              ogTitle\n              ogDescription\n            }\n            tenantSettings  {\n              id\n              onlineStatus\n              redirectToBooking\n              useTiming\n              startDate\n              endDate\n            }\n            highlights  {\n              id\n              text\n            }\n            partners  {\n              id\n              name\n              url\n              logoWidth\n            }\n            travelGuides  {\n              id\n              firstName\n              lastName\n              description\n            }\n            teams  {\n              id\n              name\n            }\n            accommodationAssignments  {\n              id\n              useCustomRoomTypeSelection\n            }\n            accommodations  {\n              id\n              label\n              name\n              stars\n              description\n            }\n            destinations  {\n              id\n              name\n              entryRequirements\n              medicalInformation\n              language\n              timeShift\n              climate\n              currency\n            }\n            testimonials  {\n              id\n            }\n            mainImage  {\n              id\n              assetId\n              publicId\n              url\n              resourceType\n              format\n              width\n              height\n              caption\n              title\n              description\n            }\n            mainVideo  {\n              id\n              assetId\n              publicId\n              url\n              resourceType\n              format\n              width\n              height\n              caption\n              title\n              description\n            }\n            gallery  {\n              id\n            }\n            travelPdf  {\n              id\n              assetId\n              publicId\n              url\n              resourceType\n              format\n              width\n              height\n              caption\n              title\n              description\n            }\n            travelExtensions  {\n              id\n              duration\n              name\n              description\n            }\n            programType\n            itinerary  {\n              id\n            }\n            programText\n            pricing  {\n              id\n              isTravelDocumentationAvailable\n            }\n            minPrice\n            minPriceManualOverride\n            currency\n          }\n          slides @include(if: $withBlockDeep) {\n            id\n            image  {\n              id\n              assetId\n              publicId\n              url\n              resourceType\n              format\n              width\n              height\n              caption\n              title\n              description\n            }\n            title\n            text\n            link  {\n              id\n              label\n              targetBlank\n              type\n              url\n            }\n          }\n\n        }\n        ... on CmsBestsellerSliderBlock {\n          id\n          fluid\n\n        }\n        ... on CmsFilterLeadBlock {\n          id\n          layout\n\n        }\n        ... on CmsTravelTypesBlock {\n          id\n          layout\n\n        }\n        ... on CmsPrefilteredTravelsBlock {\n          id\n          destinations @include(if: $withBlockDeep) {\n            id\n            name\n            entryRequirements\n            medicalInformation\n            language\n            timeShift\n            climate\n            currency\n          }\n          travelTypes @include(if: $withBlockDeep) {\n            id\n            name\n            description\n            image  {\n              id\n              assetId\n              publicId\n              url\n              resourceType\n              format\n              width\n              height\n              caption\n              title\n              description\n            }\n          }\n          maxResults\n\n        }\n        ... on CmsDividerBlock {\n          id\n          fluid\n\n        }\n        ... on CmsTravelSelectionBlock {\n          id\n          travels @include(if: $withBlockDeep) {\n            id\n            name\n            isBestseller\n            startDate\n            endDate\n            availabilityStatus  {\n              id\n              label\n              status\n              isDefaultStatus\n              isDefaultWaitlistFallback\n            }\n            executionStatus\n            travelConsultant  {\n              id\n              firstName\n              lastName\n              jobTitle\n              description\n              email\n              phone\n            }\n            label  {\n              id\n              label\n            }\n            title\n            description\n            includedServices\n            excludedServices\n            pricingTable\n            priceCalculationInfo\n            seoSettings  {\n              id\n              urlSlug\n              metaTitle\n              metaDescription\n              ogTitle\n              ogDescription\n            }\n            tenantSettings  {\n              id\n              onlineStatus\n              redirectToBooking\n              useTiming\n              startDate\n              endDate\n            }\n            highlights  {\n              id\n              text\n            }\n            partners  {\n              id\n              name\n              url\n              logoWidth\n            }\n            travelGuides  {\n              id\n              firstName\n              lastName\n              description\n            }\n            teams  {\n              id\n              name\n            }\n            accommodationAssignments  {\n              id\n              useCustomRoomTypeSelection\n            }\n            accommodations  {\n              id\n              label\n              name\n              stars\n              description\n            }\n            destinations  {\n              id\n              name\n              entryRequirements\n              medicalInformation\n              language\n              timeShift\n              climate\n              currency\n            }\n            testimonials  {\n              id\n            }\n            mainImage  {\n              id\n              assetId\n              publicId\n              url\n              resourceType\n              format\n              width\n              height\n              caption\n              title\n              description\n            }\n            mainVideo  {\n              id\n              assetId\n              publicId\n              url\n              resourceType\n              format\n              width\n              height\n              caption\n              title\n              description\n            }\n            gallery  {\n              id\n            }\n            travelPdf  {\n              id\n              assetId\n              publicId\n              url\n              resourceType\n              format\n              width\n              height\n              caption\n              title\n              description\n            }\n            travelExtensions  {\n              id\n              duration\n              name\n              description\n            }\n            programType\n            itinerary  {\n              id\n            }\n            programText\n            pricing  {\n              id\n              isTravelDocumentationAvailable\n            }\n            minPrice\n            minPriceManualOverride\n            currency\n          }\n\n        }\n        ... on CmsIframeBlock {\n          id\n          url\n          minHeight\n\n        }\n        ... on CmsSliderBlock {\n          id\n          fluid\n          gallery @include(if: $withBlockDeep) {\n            id\n            images  {\n              id\n              assetId\n              publicId\n              url\n              resourceType\n              format\n              width\n              height\n              caption\n              title\n              description\n            }\n          }\n          size\n          showDots\n          showArrows\n          showLightbox\n          autoplay\n\n        }\n        ... on CmsDestinationsBlock {\n          id\n          destinations @include(if: $withBlockDeep) {\n            id\n            name\n            entryRequirements\n            medicalInformation\n            language\n            timeShift\n            climate\n            currency\n          }\n\n        }\n        ... on CmsTravelGuidesBlock {\n          id\n          travelGuides @include(if: $withBlockDeep) {\n            id\n            firstName\n            lastName\n            description\n            image  {\n              id\n              assetId\n              publicId\n              url\n              resourceType\n              format\n              width\n              height\n              caption\n              title\n              description\n            }\n          }\n\n        }\n        ... on CmsBusfinderBlock {\n          id\n          title\n\n        }\n        ... on CmsBackgroundBlock {\n          id\n          backgroundVariant\n          contentBlockAssignments @include(if: $withBlockDeep) {\n            id\n            type\n            block  {\n              __typename\n              ... on CmsTextBlock {\n                id\n                text\n\n              }\n              ... on CmsTextWithImageBlock {\n                id\n                title\n                subtitle\n                text\n                imagePosition\n                imageFixedAspectRatio\n\n              }\n              ... on CmsPageHeaderBlock {\n                id\n                title\n                text\n\n              }\n              ... on CmsWysiwygBlock {\n                id\n                html\n\n              }\n              ... on CmsHeadingBlock {\n                id\n                importance\n                heading\n                addon\n                decoration\n\n              }\n              ... on CmsTextWithIconBlock {\n                id\n                title\n                text\n                imagePosition\n\n              }\n              ... on CmsAccordionBlock {\n                id\n\n              }\n              ... on CmsGridBlock {\n                id\n\n              }\n              ... on CmsImageBlock {\n                id\n                text\n                fluid\n\n              }\n              ... on CmsEmployeesBlock {\n                id\n\n              }\n              ... on CmsContactBannerBlock {\n                id\n                phone\n                email\n\n              }\n              ... on CmsNewsletterRegisterBlock {\n                id\n                fluid\n\n              }\n              ... on CmsIssuuCatalogBlock {\n                id\n                publicationCode\n                accountName\n\n              }\n              ... on CmsFormBlock {\n                id\n                formName\n\n              }\n              ... on CmsHeaderSliderBlock {\n                id\n\n              }\n              ... on CmsBestsellerSliderBlock {\n                id\n                fluid\n\n              }\n              ... on CmsFilterLeadBlock {\n                id\n                layout\n\n              }\n              ... on CmsTravelTypesBlock {\n                id\n                layout\n\n              }\n              ... on CmsPrefilteredTravelsBlock {\n                id\n                maxResults\n\n              }\n              ... on CmsDividerBlock {\n                id\n                fluid\n\n              }\n              ... on CmsTravelSelectionBlock {\n                id\n\n              }\n              ... on CmsIframeBlock {\n                id\n                url\n                minHeight\n\n              }\n              ... on CmsSliderBlock {\n                id\n                fluid\n                size\n                showDots\n                showArrows\n                showLightbox\n                autoplay\n\n              }\n              ... on CmsDestinationsBlock {\n                id\n\n              }\n              ... on CmsTravelGuidesBlock {\n                id\n\n              }\n              ... on CmsBusfinderBlock {\n                id\n                title\n\n              }\n              ... on CmsBackgroundBlock {\n                id\n                backgroundVariant\n\n              }\n            }\n          }\n\n        }\n      }\n    }\n  }";
// language=GraphQL
var DELETE_CONTENT_BLOCK_ASSIGNMENT_MUTATION = "\n  mutation Mutation($input: DeleteCmsContentBlockAssignmentInput) {\n    deleteCmsContentBlockAssignment(input: $input) {\n      success\n    }\n  }";
// language=GraphQL
var FORCE_DELETE_CONTENT_BLOCK_ASSIGNMENT_MUTATION = "\n  mutation Mutation($input: DeleteCmsContentBlockAssignmentInput) {\n    forceDeleteCmsContentBlockAssignment(input: $input) {\n      success\n    }\n  }";
// language=GraphQL
var CONTENT_BLOCK_ASSIGNMENTS_DEPENDENTS_QUERY = "query Query($id: ID!, $withCmsPages: Boolean = false, $withCmsGridBlockColumns: Boolean = false, $withCmsBackgroundBlocks: Boolean = false) {\n  groupedDependents: cmsContentBlockAssignmentDependents(id: $id) {\n    cmsPages @include(if: $withCmsPages) {\n      id\n      name\n      onlineStatus\n    }\n    cmsGridBlockColumns @include(if: $withCmsGridBlockColumns) {\n      id\n    }\n    cmsBackgroundBlocks @include(if: $withCmsBackgroundBlocks) {\n      id\n      backgroundVariant\n    }\n  }\n}";

// EXTERNAL MODULE: ./src/entities/cmsTextWithImageBlock/entity.ts + 3 modules
var entity = __webpack_require__(63409);
;// CONCATENATED MODULE: ./src/entities/cmsContentBlockAssignment/model.ts


var cmsContentBlockAssignmentModel = {
    name: "contentBlockAssignment",
    namePlural: "contentBlockAssignments",
    uniqueName: "cmsContentBlockAssignment",
    uniqueNamePlural: "cmsContentBlockAssignments",
    path: "cms/blocks/content_block_assignment",
    baseUrl: "/cms/blocks/content_block_assignments",
    translationPrefix: "entities:cmsContentBlockAssignment.",
    getDisplayName: function(values) {
        return "Content Block Assignment";
    },
    gql: {
        getAll: ALL_CONTENT_BLOCK_ASSIGNMENTS_QUERY,
        getSingle: SINGLE_CONTENT_BLOCK_ASSIGNMENT_QUERY,
        create: CREATE_CONTENT_BLOCK_ASSIGNMENT_MUTATION,
        update: UPDATE_CONTENT_BLOCK_ASSIGNMENT_MUTATION,
        delete: DELETE_CONTENT_BLOCK_ASSIGNMENT_MUTATION,
        forceDelete: FORCE_DELETE_CONTENT_BLOCK_ASSIGNMENT_MUTATION
    },
    attributes: {
        type: {
            name: "type",
            label: "entities:cmsContentBlockAssignment.attributes.type.label",
            type: "value",
            dataType: "string",
            defaultInput: true,
            inputType: "select",
            selectOptions: [
                {
                    label: "entities:cmsContentBlockAssignment.attributes.type.selectOptions.GRID.label",
                    value: "GRID"
                },
                {
                    label: "entities:cmsContentBlockAssignment.attributes.type.selectOptions.BACKGROUND.label",
                    value: "BACKGROUND"
                },
                {
                    label: "entities:cmsContentBlockAssignment.attributes.type.selectOptions.PAGE_HEADER.label",
                    value: "PAGE_HEADER"
                },
                {
                    label: "entities:cmsContentBlockAssignment.attributes.type.selectOptions.IMAGE.label",
                    value: "IMAGE"
                },
                {
                    label: "entities:cmsContentBlockAssignment.attributes.type.selectOptions.SLIDER.label",
                    value: "SLIDER"
                },
                {
                    label: "entities:cmsContentBlockAssignment.attributes.type.selectOptions.HEADING.label",
                    value: "HEADING"
                },
                {
                    label: "entities:cmsContentBlockAssignment.attributes.type.selectOptions.TEXT.label",
                    value: "TEXT"
                },
                {
                    label: "entities:cmsContentBlockAssignment.attributes.type.selectOptions.WYSIWYG.label",
                    value: "WYSIWYG"
                },
                {
                    label: "entities:cmsContentBlockAssignment.attributes.type.selectOptions.TEXT_WITH_IMAGE.label",
                    value: "TEXT_WITH_IMAGE"
                },
                {
                    label: "entities:cmsContentBlockAssignment.attributes.type.selectOptions.TEXT_WITH_ICON.label",
                    value: "TEXT_WITH_ICON"
                },
                {
                    label: "entities:cmsContentBlockAssignment.attributes.type.selectOptions.ACCORDION.label",
                    value: "ACCORDION"
                },
                {
                    label: "entities:cmsContentBlockAssignment.attributes.type.selectOptions.DIVIDER.label",
                    value: "DIVIDER"
                },
                {
                    label: "entities:cmsContentBlockAssignment.attributes.type.selectOptions.IFRAME.label",
                    value: "IFRAME"
                },
                {
                    label: "entities:cmsContentBlockAssignment.attributes.type.selectOptions.HEADER_SLIDER.label",
                    value: "HEADER_SLIDER"
                },
                {
                    label: "entities:cmsContentBlockAssignment.attributes.type.selectOptions.BESTSELLER_SLIDER.label",
                    value: "BESTSELLER_SLIDER"
                },
                {
                    label: "entities:cmsContentBlockAssignment.attributes.type.selectOptions.DESTINATIONS.label",
                    value: "DESTINATIONS"
                },
                {
                    label: "entities:cmsContentBlockAssignment.attributes.type.selectOptions.TRAVEL_GUIDES.label",
                    value: "TRAVEL_GUIDES"
                },
                {
                    label: "entities:cmsContentBlockAssignment.attributes.type.selectOptions.EMPLOYEES.label",
                    value: "EMPLOYEES"
                },
                {
                    label: "entities:cmsContentBlockAssignment.attributes.type.selectOptions.CONTACT_BANNER.label",
                    value: "CONTACT_BANNER"
                },
                {
                    label: "entities:cmsContentBlockAssignment.attributes.type.selectOptions.FORM.label",
                    value: "FORM"
                },
                {
                    label: "entities:cmsContentBlockAssignment.attributes.type.selectOptions.NEWSLETTER_REGISTRATION.label",
                    value: "NEWSLETTER_REGISTRATION"
                },
                {
                    label: "entities:cmsContentBlockAssignment.attributes.type.selectOptions.ISSUU_CATALOG.label",
                    value: "ISSUU_CATALOG"
                },
                {
                    label: "entities:cmsContentBlockAssignment.attributes.type.selectOptions.FILTER_LEAD_FORM.label",
                    value: "FILTER_LEAD_FORM"
                },
                {
                    label: "entities:cmsContentBlockAssignment.attributes.type.selectOptions.PREFILTERED_TRAVELS.label",
                    value: "PREFILTERED_TRAVELS"
                },
                {
                    label: "entities:cmsContentBlockAssignment.attributes.type.selectOptions.TRAVEL_SELECTION.label",
                    value: "TRAVEL_SELECTION"
                },
                {
                    label: "entities:cmsContentBlockAssignment.attributes.type.selectOptions.TRAVEL_TYPES.label",
                    value: "TRAVEL_TYPES"
                },
                {
                    label: "entities:cmsContentBlockAssignment.attributes.type.selectOptions.BUSFINDER_WIDGET.label",
                    value: "BUSFINDER_WIDGET"
                }, 
            ],
            validationType: "string",
            validations: [
                {
                    type: "required"
                }, 
            ]
        },
        block: {
            name: "block",
            label: "entities:cmsContentBlockAssignment.attributes.block.label",
            type: "entityObject",
            dataType: "any",
            getEntity: function() {
                return entity/* default */.Z;
            },
            defaultInput: false,
            inputType: "select",
            validationType: "string",
            validations: []
        }
    }
};
/* harmony default export */ var model = (cmsContentBlockAssignmentModel);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(20414);
// EXTERNAL MODULE: ./src/entities/lib.ts
var lib = __webpack_require__(23480);
// EXTERNAL MODULE: ./src/lib/api/graphQLClient.ts
var graphQLClient = __webpack_require__(40112);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/swr/dist/index.mjs
var dist = __webpack_require__(8100);
// EXTERNAL MODULE: ./src/lib/helpers/helpers.ts
var helpers = __webpack_require__(15778);
;// CONCATENATED MODULE: ./src/entities/cmsContentBlockAssignment/repository.ts










var hydrateObjects = function(objects) {
    return objects.map(function(object) {
        return (0,lib/* hydrateEntityObject */.b)(model, object);
    });
};
var hydrateObject = function(object) {
    return (0,lib/* hydrateEntityObject */.b)(model, object);
};
var cmsContentBlockAssignmentRepository = {
    getObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    id: id
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(SINGLE_CONTENT_BLOCK_ASSIGNMENT_QUERY, variables).then(function(data) {
                        return hydrateObject(data.contentBlockAssignment);
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }(),
    getObjects: /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        var includes;
        var _arguments = arguments;
        return (0,tslib_es6.__generator)(this, function(_state) {
            includes = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : {};
            return [
                2,
                graphQLClient/* default.request */.Z.request(ALL_CONTENT_BLOCK_ASSIGNMENTS_QUERY, includes).then(function(data) {
                    return hydrateObjects(data.contentBlockAssignments);
                })
            ];
        });
    }),
    useObject: function(id) {
        var includes = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        // eslint-disable-next-line react-hooks/exhaustive-deps
        var variables = (0,react.useMemo)(function() {
            return (0,_object_spread/* default */.Z)({
                id: id
            }, includes);
        }, [
            id
        ]);
        var ref = (0,dist/* default */.ZP)([
            SINGLE_CONTENT_BLOCK_ASSIGNMENT_QUERY,
            variables
        ], {
            revalidateOnFocus: false
        }), data = ref.data, error = ref.error, mutate = ref.mutate;
        return {
            object: !data ? data : hydrateObject(data.contentBlockAssignment),
            isLoading: !error && !data,
            isError: error,
            mutate: mutate
        };
    },
    useObjects: function() {
        var includes = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        // eslint-disable-next-line react-hooks/exhaustive-deps
        var variables = (0,react.useMemo)(function() {
            return includes;
        }, []);
        var ref = (0,dist/* default */.ZP)([
            ALL_CONTENT_BLOCK_ASSIGNMENTS_QUERY,
            variables
        ]), data = ref.data, error = ref.error, mutate = ref.mutate;
        return {
            objects: !data ? data : hydrateObjects(data.contentBlockAssignments),
            isLoading: !error && !data,
            isError: error,
            mutate: mutate
        };
    },
    getDependents: function(id, includes) {
        var includeVars = {};
        includes.forEach(function(include) {
            includeVars["with".concat((0,helpers/* uppercaseFirst */.AB)(include))] = true;
        });
        var variables = (0,_object_spread/* default */.Z)({
            id: id
        }, includeVars);
        return graphQLClient/* default.request */.Z.request(CONTENT_BLOCK_ASSIGNMENTS_DEPENDENTS_QUERY, variables).then(function(data) {
            return data.groupedDependents;
        });
    },
    useDependents: function(id, includes) {
        var includeVars = {};
        includes.forEach(function(include) {
            includeVars["with".concat((0,helpers/* uppercaseFirst */.AB)(include))] = true;
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
        var variables = (0,react.useMemo)(function() {
            return (0,_object_spread/* default */.Z)({
                id: id
            }, includeVars);
        }, [
            id
        ]);
        var ref = (0,dist/* default */.ZP)([
            CONTENT_BLOCK_ASSIGNMENTS_DEPENDENTS_QUERY,
            variables
        ], {
            revalidateOnFocus: false
        }), data = ref.data, error = ref.error, mutate = ref.mutate;
        return {
            data: !data ? data : data.groupedDependents,
            isLoading: !error && !data,
            isError: error,
            mutate: mutate
        };
    },
    createObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(data) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    input: data
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(CREATE_CONTENT_BLOCK_ASSIGNMENT_MUTATION, variables).then(function(data) {
                        return hydrateObject(data.contentBlockAssignment);
                    })
                ];
            });
        });
        return function(data) {
            return _ref.apply(this, arguments);
        };
    }(),
    updateObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(data) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    input: data
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(UPDATE_CONTENT_BLOCK_ASSIGNMENT_MUTATION, variables).then(function(data) {
                        return hydrateObject(data.contentBlockAssignment);
                    })
                ];
            });
        });
        return function(data) {
            return _ref.apply(this, arguments);
        };
    }(),
    deleteObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(DELETE_CONTENT_BLOCK_ASSIGNMENT_MUTATION, variables).then(function(data) {
                        return data.deleteCmsContentBlockAssignment;
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }(),
    forceDeleteObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(FORCE_DELETE_CONTENT_BLOCK_ASSIGNMENT_MUTATION, variables).then(function(data) {
                        return data.forceDeleteCmsContentBlockAssignment;
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }()
};
/* harmony default export */ var repository = (cmsContentBlockAssignmentRepository);

;// CONCATENATED MODULE: ./src/entities/cmsContentBlockAssignment/entity.ts


var cmsContentBlockAssignmentEntity = {
    model: model,
    repository: repository
};
/* harmony default export */ var cmsContentBlockAssignment_entity = (cmsContentBlockAssignmentEntity);


/***/ }),

/***/ 49647:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ cmsPage_entity; }
});

;// CONCATENATED MODULE: ./src/entities/cmsPage/graphql.ts
// language=GraphQL
var ALL_PAGES_QUERY = "query Query($withSeoSettings: Boolean = false, $withSeoSettingsOgImage: Boolean = false, $withContentBlockAssignments: Boolean = false, $withContentBlockAssignmentsBlock: Boolean = false, $withContentBlockAssignmentsBlockDeep: Boolean = false) {\n  pages: cmsPages {\n    id\n    name\n    onlineStatus\n    seoSettings @include(if: $withSeoSettings) {\n      id\n      urlSlug\n      metaTitle\n      metaDescription\n      ogTitle\n      ogDescription\n      ogImage @include(if: $withSeoSettingsOgImage) {\n        id\n        assetId\n        publicId\n        url\n        resourceType\n        format\n        width\n        height\n        caption\n        title\n        description\n      }\n    }\n    contentBlockAssignments @include(if: $withContentBlockAssignments) {\n      id\n      type\n      block @include(if: $withContentBlockAssignmentsBlock) {\n        __typename\n        ... on CmsTextBlock {\n          id\n          text\n\n        }\n        ... on CmsTextWithImageBlock {\n          id\n          title\n          subtitle\n          text\n          imagePosition\n          image @include(if: $withContentBlockAssignmentsBlockDeep) {\n            id\n            assetId\n            publicId\n            url\n            resourceType\n            format\n            width\n            height\n            caption\n            title\n            description\n          }\n          imageFixedAspectRatio\n          gallery @include(if: $withContentBlockAssignmentsBlockDeep) {\n            id\n          }\n          link @include(if: $withContentBlockAssignmentsBlockDeep) {\n            id\n            label\n            targetBlank\n            type\n            url\n          }\n\n        }\n        ... on CmsPageHeaderBlock {\n          id\n          title\n          text\n          image @include(if: $withContentBlockAssignmentsBlockDeep) {\n            id\n            assetId\n            publicId\n            url\n            resourceType\n            format\n            width\n            height\n            caption\n            title\n            description\n          }\n\n        }\n        ... on CmsWysiwygBlock {\n          id\n          html\n\n        }\n        ... on CmsHeadingBlock {\n          id\n          importance\n          heading\n          addon\n          decoration\n\n        }\n        ... on CmsTextWithIconBlock {\n          id\n          title\n          text\n          image @include(if: $withContentBlockAssignmentsBlockDeep) {\n            id\n            assetId\n            publicId\n            url\n            resourceType\n            format\n            width\n            height\n            caption\n            title\n            description\n          }\n          imagePosition\n\n        }\n        ... on CmsAccordionBlock {\n          id\n          items @include(if: $withContentBlockAssignmentsBlockDeep) {\n            id\n            title\n            content\n          }\n\n        }\n        ... on CmsGridBlock {\n          id\n          columns @include(if: $withContentBlockAssignmentsBlockDeep) {\n            id\n          }\n\n        }\n        ... on CmsImageBlock {\n          id\n          image @include(if: $withContentBlockAssignmentsBlockDeep) {\n            id\n            assetId\n            publicId\n            url\n            resourceType\n            format\n            width\n            height\n            caption\n            title\n            description\n          }\n          text\n          fluid\n\n        }\n        ... on CmsEmployeesBlock {\n          id\n          employees @include(if: $withContentBlockAssignmentsBlockDeep) {\n            id\n            firstName\n            lastName\n            jobTitle\n            description\n            email\n            phone\n          }\n\n        }\n        ... on CmsContactBannerBlock {\n          id\n          employee @include(if: $withContentBlockAssignmentsBlockDeep) {\n            id\n            firstName\n            lastName\n            jobTitle\n            description\n            email\n            phone\n          }\n          phone\n          email\n\n        }\n        ... on CmsNewsletterRegisterBlock {\n          id\n          fluid\n\n        }\n        ... on CmsIssuuCatalogBlock {\n          id\n          publicationCode\n          accountName\n\n        }\n        ... on CmsFormBlock {\n          id\n          formName\n\n        }\n        ... on CmsHeaderSliderBlock {\n          id\n          travels @include(if: $withContentBlockAssignmentsBlockDeep) {\n            id\n            name\n            isBestseller\n            startDate\n            endDate\n            executionStatus\n            title\n            description\n            includedServices\n            excludedServices\n            pricingTable\n            priceCalculationInfo\n            programType\n            programText\n            minPrice\n            minPriceManualOverride\n            currency\n          }\n          slides @include(if: $withContentBlockAssignmentsBlockDeep) {\n            id\n            title\n            text\n          }\n\n        }\n        ... on CmsBestsellerSliderBlock {\n          id\n          fluid\n\n        }\n        ... on CmsFilterLeadBlock {\n          id\n          layout\n\n        }\n        ... on CmsTravelTypesBlock {\n          id\n          layout\n\n        }\n        ... on CmsPrefilteredTravelsBlock {\n          id\n          destinations @include(if: $withContentBlockAssignmentsBlockDeep) {\n            id\n            name\n            entryRequirements\n            medicalInformation\n            language\n            timeShift\n            climate\n            currency\n          }\n          travelTypes @include(if: $withContentBlockAssignmentsBlockDeep) {\n            id\n            name\n            description\n          }\n          maxResults\n\n        }\n        ... on CmsDividerBlock {\n          id\n          fluid\n\n        }\n        ... on CmsTravelSelectionBlock {\n          id\n          travels @include(if: $withContentBlockAssignmentsBlockDeep) {\n            id\n            name\n            isBestseller\n            startDate\n            endDate\n            executionStatus\n            title\n            description\n            includedServices\n            excludedServices\n            pricingTable\n            priceCalculationInfo\n            programType\n            programText\n            minPrice\n            minPriceManualOverride\n            currency\n          }\n\n        }\n        ... on CmsIframeBlock {\n          id\n          url\n          minHeight\n\n        }\n        ... on CmsSliderBlock {\n          id\n          fluid\n          gallery @include(if: $withContentBlockAssignmentsBlockDeep) {\n            id\n          }\n          size\n          showDots\n          showArrows\n          showLightbox\n          autoplay\n\n        }\n        ... on CmsDestinationsBlock {\n          id\n          destinations @include(if: $withContentBlockAssignmentsBlockDeep) {\n            id\n            name\n            entryRequirements\n            medicalInformation\n            language\n            timeShift\n            climate\n            currency\n          }\n\n        }\n        ... on CmsTravelGuidesBlock {\n          id\n          travelGuides @include(if: $withContentBlockAssignmentsBlockDeep) {\n            id\n            firstName\n            lastName\n            description\n          }\n\n        }\n        ... on CmsBusfinderBlock {\n          id\n          title\n\n        }\n        ... on CmsBackgroundBlock {\n          id\n          backgroundVariant\n          contentBlockAssignments @include(if: $withContentBlockAssignmentsBlockDeep) {\n            id\n            type\n          }\n\n        }\n      }\n    }\n  }\n}";
// language=GraphQL
var SINGLE_PAGE_QUERY = "query Query($id: ID!, $withSeoSettings: Boolean = false, $withSeoSettingsOgImage: Boolean = false, $withContentBlockAssignments: Boolean = false, $withContentBlockAssignmentsBlock: Boolean = false, $withContentBlockAssignmentsBlockDeep: Boolean = false) {\n  page: cmsPage(id: $id) {\n    id\n    name\n    onlineStatus\n    seoSettings @include(if: $withSeoSettings) {\n      id\n      urlSlug\n      metaTitle\n      metaDescription\n      ogTitle\n      ogDescription\n      ogImage @include(if: $withSeoSettingsOgImage) {\n        id\n        assetId\n        publicId\n        url\n        resourceType\n        format\n        width\n        height\n        caption\n        title\n        description\n      }\n    }\n    contentBlockAssignments @include(if: $withContentBlockAssignments) {\n      id\n      type\n      block @include(if: $withContentBlockAssignmentsBlock) {\n        __typename\n        ... on CmsTextBlock {\n          id\n          text\n\n        }\n        ... on CmsTextWithImageBlock {\n          id\n          title\n          subtitle\n          text\n          imagePosition\n          image @include(if: $withContentBlockAssignmentsBlockDeep) {\n            id\n            assetId\n            publicId\n            url\n            resourceType\n            format\n            width\n            height\n            caption\n            title\n            description\n          }\n          imageFixedAspectRatio\n          gallery @include(if: $withContentBlockAssignmentsBlockDeep) {\n            id\n          }\n          link @include(if: $withContentBlockAssignmentsBlockDeep) {\n            id\n            label\n            targetBlank\n            type\n            url\n          }\n\n        }\n        ... on CmsPageHeaderBlock {\n          id\n          title\n          text\n          image @include(if: $withContentBlockAssignmentsBlockDeep) {\n            id\n            assetId\n            publicId\n            url\n            resourceType\n            format\n            width\n            height\n            caption\n            title\n            description\n          }\n\n        }\n        ... on CmsWysiwygBlock {\n          id\n          html\n\n        }\n        ... on CmsHeadingBlock {\n          id\n          importance\n          heading\n          addon\n          decoration\n\n        }\n        ... on CmsTextWithIconBlock {\n          id\n          title\n          text\n          image @include(if: $withContentBlockAssignmentsBlockDeep) {\n            id\n            assetId\n            publicId\n            url\n            resourceType\n            format\n            width\n            height\n            caption\n            title\n            description\n          }\n          imagePosition\n\n        }\n        ... on CmsAccordionBlock {\n          id\n          items @include(if: $withContentBlockAssignmentsBlockDeep) {\n            id\n            title\n            content\n          }\n\n        }\n        ... on CmsGridBlock {\n          id\n          columns @include(if: $withContentBlockAssignmentsBlockDeep) {\n            id\n          }\n\n        }\n        ... on CmsImageBlock {\n          id\n          image @include(if: $withContentBlockAssignmentsBlockDeep) {\n            id\n            assetId\n            publicId\n            url\n            resourceType\n            format\n            width\n            height\n            caption\n            title\n            description\n          }\n          text\n          fluid\n\n        }\n        ... on CmsEmployeesBlock {\n          id\n          employees @include(if: $withContentBlockAssignmentsBlockDeep) {\n            id\n            firstName\n            lastName\n            jobTitle\n            description\n            email\n            phone\n          }\n\n        }\n        ... on CmsContactBannerBlock {\n          id\n          employee @include(if: $withContentBlockAssignmentsBlockDeep) {\n            id\n            firstName\n            lastName\n            jobTitle\n            description\n            email\n            phone\n          }\n          phone\n          email\n\n        }\n        ... on CmsNewsletterRegisterBlock {\n          id\n          fluid\n\n        }\n        ... on CmsIssuuCatalogBlock {\n          id\n          publicationCode\n          accountName\n\n        }\n        ... on CmsFormBlock {\n          id\n          formName\n\n        }\n        ... on CmsHeaderSliderBlock {\n          id\n          travels @include(if: $withContentBlockAssignmentsBlockDeep) {\n            id\n            name\n            isBestseller\n            startDate\n            endDate\n            executionStatus\n            title\n            description\n            includedServices\n            excludedServices\n            pricingTable\n            priceCalculationInfo\n            programType\n            programText\n            minPrice\n            minPriceManualOverride\n            currency\n          }\n          slides @include(if: $withContentBlockAssignmentsBlockDeep) {\n            id\n            title\n            text\n          }\n\n        }\n        ... on CmsBestsellerSliderBlock {\n          id\n          fluid\n\n        }\n        ... on CmsFilterLeadBlock {\n          id\n          layout\n\n        }\n        ... on CmsTravelTypesBlock {\n          id\n          layout\n\n        }\n        ... on CmsPrefilteredTravelsBlock {\n          id\n          destinations @include(if: $withContentBlockAssignmentsBlockDeep) {\n            id\n            name\n            entryRequirements\n            medicalInformation\n            language\n            timeShift\n            climate\n            currency\n          }\n          travelTypes @include(if: $withContentBlockAssignmentsBlockDeep) {\n            id\n            name\n            description\n          }\n          maxResults\n\n        }\n        ... on CmsDividerBlock {\n          id\n          fluid\n\n        }\n        ... on CmsTravelSelectionBlock {\n          id\n          travels @include(if: $withContentBlockAssignmentsBlockDeep) {\n            id\n            name\n            isBestseller\n            startDate\n            endDate\n            executionStatus\n            title\n            description\n            includedServices\n            excludedServices\n            pricingTable\n            priceCalculationInfo\n            programType\n            programText\n            minPrice\n            minPriceManualOverride\n            currency\n          }\n\n        }\n        ... on CmsIframeBlock {\n          id\n          url\n          minHeight\n\n        }\n        ... on CmsSliderBlock {\n          id\n          fluid\n          gallery @include(if: $withContentBlockAssignmentsBlockDeep) {\n            id\n          }\n          size\n          showDots\n          showArrows\n          showLightbox\n          autoplay\n\n        }\n        ... on CmsDestinationsBlock {\n          id\n          destinations @include(if: $withContentBlockAssignmentsBlockDeep) {\n            id\n            name\n            entryRequirements\n            medicalInformation\n            language\n            timeShift\n            climate\n            currency\n          }\n\n        }\n        ... on CmsTravelGuidesBlock {\n          id\n          travelGuides @include(if: $withContentBlockAssignmentsBlockDeep) {\n            id\n            firstName\n            lastName\n            description\n          }\n\n        }\n        ... on CmsBusfinderBlock {\n          id\n          title\n\n        }\n        ... on CmsBackgroundBlock {\n          id\n          backgroundVariant\n          contentBlockAssignments @include(if: $withContentBlockAssignmentsBlockDeep) {\n            id\n            type\n          }\n\n        }\n      }\n    }\n  }\n}";
// language=GraphQL
var CREATE_PAGE_MUTATION = "\n  mutation Mutation($input: CreateCmsPageInput, $withSeoSettings: Boolean = false, $withSeoSettingsOgImage: Boolean = false, $withContentBlockAssignments: Boolean = false, $withContentBlockAssignmentsBlock: Boolean = false, $withContentBlockAssignmentsBlockDeep: Boolean = false) {\n    page: createCmsPage(input: $input) {\n      id\n      name\n      onlineStatus\n      seoSettings @include(if: $withSeoSettings) {\n        id\n        urlSlug\n        metaTitle\n        metaDescription\n        ogTitle\n        ogDescription\n        ogImage @include(if: $withSeoSettingsOgImage) {\n          id\n          assetId\n          publicId\n          url\n          resourceType\n          format\n          width\n          height\n          caption\n          title\n          description\n        }\n      }\n      contentBlockAssignments @include(if: $withContentBlockAssignments) {\n        id\n        type\n        block @include(if: $withContentBlockAssignmentsBlock) {\n          __typename\n          ... on CmsTextBlock {\n            id\n            text\n\n          }\n          ... on CmsTextWithImageBlock {\n            id\n            title\n            subtitle\n            text\n            imagePosition\n            image @include(if: $withContentBlockAssignmentsBlockDeep) {\n              id\n              assetId\n              publicId\n              url\n              resourceType\n              format\n              width\n              height\n              caption\n              title\n              description\n            }\n            imageFixedAspectRatio\n            gallery @include(if: $withContentBlockAssignmentsBlockDeep) {\n              id\n            }\n            link @include(if: $withContentBlockAssignmentsBlockDeep) {\n              id\n              label\n              targetBlank\n              type\n              url\n            }\n\n          }\n          ... on CmsPageHeaderBlock {\n            id\n            title\n            text\n            image @include(if: $withContentBlockAssignmentsBlockDeep) {\n              id\n              assetId\n              publicId\n              url\n              resourceType\n              format\n              width\n              height\n              caption\n              title\n              description\n            }\n\n          }\n          ... on CmsWysiwygBlock {\n            id\n            html\n\n          }\n          ... on CmsHeadingBlock {\n            id\n            importance\n            heading\n            addon\n            decoration\n\n          }\n          ... on CmsTextWithIconBlock {\n            id\n            title\n            text\n            image @include(if: $withContentBlockAssignmentsBlockDeep) {\n              id\n              assetId\n              publicId\n              url\n              resourceType\n              format\n              width\n              height\n              caption\n              title\n              description\n            }\n            imagePosition\n\n          }\n          ... on CmsAccordionBlock {\n            id\n            items @include(if: $withContentBlockAssignmentsBlockDeep) {\n              id\n              title\n              content\n            }\n\n          }\n          ... on CmsGridBlock {\n            id\n            columns @include(if: $withContentBlockAssignmentsBlockDeep) {\n              id\n            }\n\n          }\n          ... on CmsImageBlock {\n            id\n            image @include(if: $withContentBlockAssignmentsBlockDeep) {\n              id\n              assetId\n              publicId\n              url\n              resourceType\n              format\n              width\n              height\n              caption\n              title\n              description\n            }\n            text\n            fluid\n\n          }\n          ... on CmsEmployeesBlock {\n            id\n            employees @include(if: $withContentBlockAssignmentsBlockDeep) {\n              id\n              firstName\n              lastName\n              jobTitle\n              description\n              email\n              phone\n            }\n\n          }\n          ... on CmsContactBannerBlock {\n            id\n            employee @include(if: $withContentBlockAssignmentsBlockDeep) {\n              id\n              firstName\n              lastName\n              jobTitle\n              description\n              email\n              phone\n            }\n            phone\n            email\n\n          }\n          ... on CmsNewsletterRegisterBlock {\n            id\n            fluid\n\n          }\n          ... on CmsIssuuCatalogBlock {\n            id\n            publicationCode\n            accountName\n\n          }\n          ... on CmsFormBlock {\n            id\n            formName\n\n          }\n          ... on CmsHeaderSliderBlock {\n            id\n            travels @include(if: $withContentBlockAssignmentsBlockDeep) {\n              id\n              name\n              isBestseller\n              startDate\n              endDate\n              executionStatus\n              title\n              description\n              includedServices\n              excludedServices\n              pricingTable\n              priceCalculationInfo\n              programType\n              programText\n              minPrice\n              minPriceManualOverride\n              currency\n            }\n            slides @include(if: $withContentBlockAssignmentsBlockDeep) {\n              id\n              title\n              text\n            }\n\n          }\n          ... on CmsBestsellerSliderBlock {\n            id\n            fluid\n\n          }\n          ... on CmsFilterLeadBlock {\n            id\n            layout\n\n          }\n          ... on CmsTravelTypesBlock {\n            id\n            layout\n\n          }\n          ... on CmsPrefilteredTravelsBlock {\n            id\n            destinations @include(if: $withContentBlockAssignmentsBlockDeep) {\n              id\n              name\n              entryRequirements\n              medicalInformation\n              language\n              timeShift\n              climate\n              currency\n            }\n            travelTypes @include(if: $withContentBlockAssignmentsBlockDeep) {\n              id\n              name\n              description\n            }\n            maxResults\n\n          }\n          ... on CmsDividerBlock {\n            id\n            fluid\n\n          }\n          ... on CmsTravelSelectionBlock {\n            id\n            travels @include(if: $withContentBlockAssignmentsBlockDeep) {\n              id\n              name\n              isBestseller\n              startDate\n              endDate\n              executionStatus\n              title\n              description\n              includedServices\n              excludedServices\n              pricingTable\n              priceCalculationInfo\n              programType\n              programText\n              minPrice\n              minPriceManualOverride\n              currency\n            }\n\n          }\n          ... on CmsIframeBlock {\n            id\n            url\n            minHeight\n\n          }\n          ... on CmsSliderBlock {\n            id\n            fluid\n            gallery @include(if: $withContentBlockAssignmentsBlockDeep) {\n              id\n            }\n            size\n            showDots\n            showArrows\n            showLightbox\n            autoplay\n\n          }\n          ... on CmsDestinationsBlock {\n            id\n            destinations @include(if: $withContentBlockAssignmentsBlockDeep) {\n              id\n              name\n              entryRequirements\n              medicalInformation\n              language\n              timeShift\n              climate\n              currency\n            }\n\n          }\n          ... on CmsTravelGuidesBlock {\n            id\n            travelGuides @include(if: $withContentBlockAssignmentsBlockDeep) {\n              id\n              firstName\n              lastName\n              description\n            }\n\n          }\n          ... on CmsBusfinderBlock {\n            id\n            title\n\n          }\n          ... on CmsBackgroundBlock {\n            id\n            backgroundVariant\n            contentBlockAssignments @include(if: $withContentBlockAssignmentsBlockDeep) {\n              id\n              type\n            }\n\n          }\n        }\n      }\n    }\n  }";
// language=GraphQL
var UPDATE_PAGE_MUTATION = "\n  mutation Mutation($input: UpdateCmsPageInput, $withSeoSettings: Boolean = false, $withSeoSettingsOgImage: Boolean = false, $withContentBlockAssignments: Boolean = false, $withContentBlockAssignmentsBlock: Boolean = false, $withContentBlockAssignmentsBlockDeep: Boolean = false) {\n    page: updateCmsPage(input: $input) {\n      id\n      name\n      onlineStatus\n      seoSettings @include(if: $withSeoSettings) {\n        id\n        urlSlug\n        metaTitle\n        metaDescription\n        ogTitle\n        ogDescription\n        ogImage @include(if: $withSeoSettingsOgImage) {\n          id\n          assetId\n          publicId\n          url\n          resourceType\n          format\n          width\n          height\n          caption\n          title\n          description\n        }\n      }\n      contentBlockAssignments @include(if: $withContentBlockAssignments) {\n        id\n        type\n        block @include(if: $withContentBlockAssignmentsBlock) {\n          __typename\n          ... on CmsTextBlock {\n            id\n            text\n\n          }\n          ... on CmsTextWithImageBlock {\n            id\n            title\n            subtitle\n            text\n            imagePosition\n            image @include(if: $withContentBlockAssignmentsBlockDeep) {\n              id\n              assetId\n              publicId\n              url\n              resourceType\n              format\n              width\n              height\n              caption\n              title\n              description\n            }\n            imageFixedAspectRatio\n            gallery @include(if: $withContentBlockAssignmentsBlockDeep) {\n              id\n            }\n            link @include(if: $withContentBlockAssignmentsBlockDeep) {\n              id\n              label\n              targetBlank\n              type\n              url\n            }\n\n          }\n          ... on CmsPageHeaderBlock {\n            id\n            title\n            text\n            image @include(if: $withContentBlockAssignmentsBlockDeep) {\n              id\n              assetId\n              publicId\n              url\n              resourceType\n              format\n              width\n              height\n              caption\n              title\n              description\n            }\n\n          }\n          ... on CmsWysiwygBlock {\n            id\n            html\n\n          }\n          ... on CmsHeadingBlock {\n            id\n            importance\n            heading\n            addon\n            decoration\n\n          }\n          ... on CmsTextWithIconBlock {\n            id\n            title\n            text\n            image @include(if: $withContentBlockAssignmentsBlockDeep) {\n              id\n              assetId\n              publicId\n              url\n              resourceType\n              format\n              width\n              height\n              caption\n              title\n              description\n            }\n            imagePosition\n\n          }\n          ... on CmsAccordionBlock {\n            id\n            items @include(if: $withContentBlockAssignmentsBlockDeep) {\n              id\n              title\n              content\n            }\n\n          }\n          ... on CmsGridBlock {\n            id\n            columns @include(if: $withContentBlockAssignmentsBlockDeep) {\n              id\n            }\n\n          }\n          ... on CmsImageBlock {\n            id\n            image @include(if: $withContentBlockAssignmentsBlockDeep) {\n              id\n              assetId\n              publicId\n              url\n              resourceType\n              format\n              width\n              height\n              caption\n              title\n              description\n            }\n            text\n            fluid\n\n          }\n          ... on CmsEmployeesBlock {\n            id\n            employees @include(if: $withContentBlockAssignmentsBlockDeep) {\n              id\n              firstName\n              lastName\n              jobTitle\n              description\n              email\n              phone\n            }\n\n          }\n          ... on CmsContactBannerBlock {\n            id\n            employee @include(if: $withContentBlockAssignmentsBlockDeep) {\n              id\n              firstName\n              lastName\n              jobTitle\n              description\n              email\n              phone\n            }\n            phone\n            email\n\n          }\n          ... on CmsNewsletterRegisterBlock {\n            id\n            fluid\n\n          }\n          ... on CmsIssuuCatalogBlock {\n            id\n            publicationCode\n            accountName\n\n          }\n          ... on CmsFormBlock {\n            id\n            formName\n\n          }\n          ... on CmsHeaderSliderBlock {\n            id\n            travels @include(if: $withContentBlockAssignmentsBlockDeep) {\n              id\n              name\n              isBestseller\n              startDate\n              endDate\n              executionStatus\n              title\n              description\n              includedServices\n              excludedServices\n              pricingTable\n              priceCalculationInfo\n              programType\n              programText\n              minPrice\n              minPriceManualOverride\n              currency\n            }\n            slides @include(if: $withContentBlockAssignmentsBlockDeep) {\n              id\n              title\n              text\n            }\n\n          }\n          ... on CmsBestsellerSliderBlock {\n            id\n            fluid\n\n          }\n          ... on CmsFilterLeadBlock {\n            id\n            layout\n\n          }\n          ... on CmsTravelTypesBlock {\n            id\n            layout\n\n          }\n          ... on CmsPrefilteredTravelsBlock {\n            id\n            destinations @include(if: $withContentBlockAssignmentsBlockDeep) {\n              id\n              name\n              entryRequirements\n              medicalInformation\n              language\n              timeShift\n              climate\n              currency\n            }\n            travelTypes @include(if: $withContentBlockAssignmentsBlockDeep) {\n              id\n              name\n              description\n            }\n            maxResults\n\n          }\n          ... on CmsDividerBlock {\n            id\n            fluid\n\n          }\n          ... on CmsTravelSelectionBlock {\n            id\n            travels @include(if: $withContentBlockAssignmentsBlockDeep) {\n              id\n              name\n              isBestseller\n              startDate\n              endDate\n              executionStatus\n              title\n              description\n              includedServices\n              excludedServices\n              pricingTable\n              priceCalculationInfo\n              programType\n              programText\n              minPrice\n              minPriceManualOverride\n              currency\n            }\n\n          }\n          ... on CmsIframeBlock {\n            id\n            url\n            minHeight\n\n          }\n          ... on CmsSliderBlock {\n            id\n            fluid\n            gallery @include(if: $withContentBlockAssignmentsBlockDeep) {\n              id\n            }\n            size\n            showDots\n            showArrows\n            showLightbox\n            autoplay\n\n          }\n          ... on CmsDestinationsBlock {\n            id\n            destinations @include(if: $withContentBlockAssignmentsBlockDeep) {\n              id\n              name\n              entryRequirements\n              medicalInformation\n              language\n              timeShift\n              climate\n              currency\n            }\n\n          }\n          ... on CmsTravelGuidesBlock {\n            id\n            travelGuides @include(if: $withContentBlockAssignmentsBlockDeep) {\n              id\n              firstName\n              lastName\n              description\n            }\n\n          }\n          ... on CmsBusfinderBlock {\n            id\n            title\n\n          }\n          ... on CmsBackgroundBlock {\n            id\n            backgroundVariant\n            contentBlockAssignments @include(if: $withContentBlockAssignmentsBlockDeep) {\n              id\n              type\n            }\n\n          }\n        }\n      }\n    }\n  }";
// language=GraphQL
var DELETE_PAGE_MUTATION = "\n  mutation Mutation($input: DeleteCmsPageInput) {\n    deleteCmsPage(input: $input) {\n      success\n    }\n  }";
// language=GraphQL
var FORCE_DELETE_PAGE_MUTATION = "\n  mutation Mutation($input: DeleteCmsPageInput) {\n    forceDeleteCmsPage(input: $input) {\n      success\n    }\n  }";
// language=GraphQL
var ADD_PAGE_CONTENT_BLOCK_ASSIGNMENTS_MUTATION = "\n  mutation Mutation($input: addCmsPageContentBlockAssignmentsInput) {\n    addCmsPageContentBlockAssignments(input: $input) {\n      id\n      contentBlockAssignmentIds\n    }\n  }";
// language=GraphQL
var REMOVE_PAGE_CONTENT_BLOCK_ASSIGNMENTS_MUTATION = "\n  mutation Mutation($input: removeCmsPageContentBlockAssignmentsInput) {\n    removeCmsPageContentBlockAssignments(input: $input) {\n      id\n      contentBlockAssignmentIds\n    }\n  }";
// language=GraphQL
var CREATE_PAGE_CONTENT_BLOCK_ASSIGNMENTS_MUTATION = "\n  mutation Mutation($input: createCmsPageContentBlockAssignmentsInput) {\n    createCmsPageContentBlockAssignments(input: $input) {\n      id\n      contentBlockAssignmentIds\n    }\n  }";
// language=GraphQL
var DELETE_PAGE_CONTENT_BLOCK_ASSIGNMENTS_MUTATION = "\n  mutation Mutation($input: deleteCmsPageContentBlockAssignmentsInput) {\n    deleteCmsPageContentBlockAssignments(input: $input) {\n      id\n      contentBlockAssignmentIds\n    }\n  }";
// language=GraphQL
var UPDATE_PAGE_CONTENT_BLOCK_ASSIGNMENTS_ORDER_MUTATION = "\n  mutation Mutation($input: updateCmsPageContentBlockAssignmentsOrderInput) {\n    updateCmsPageContentBlockAssignmentsOrder(input: $input) {\n      id\n      contentBlockAssignmentIds\n    }\n  }";
// language=GraphQL
var PAGES_DEPENDENTS_QUERY = "query Query($id: ID!, $withTenantCms: Boolean = false, $withRedirects: Boolean = false, $withCmsConfigs: Boolean = false, $withLinks: Boolean = false, $withCmsCategories: Boolean = false) {\n  groupedDependents: cmsPageDependents(id: $id) {\n    tenantCms @include(if: $withTenantCms) {\n      id\n    }\n    redirects @include(if: $withRedirects) {\n      id\n      fromType\n      fromUrl\n      toType\n      toUrl\n    }\n    cmsConfigs @include(if: $withCmsConfigs) {\n      id\n    }\n    links @include(if: $withLinks) {\n      id\n      label\n      targetBlank\n      type\n      url\n    }\n    cmsCategories @include(if: $withCmsCategories) {\n      id\n      name\n    }\n  }\n}";

// EXTERNAL MODULE: ./src/entities/elementSeoSettings/entity.ts + 3 modules
var entity = __webpack_require__(64750);
// EXTERNAL MODULE: ./src/entities/cmsContentBlockAssignment/entity.ts + 3 modules
var cmsContentBlockAssignment_entity = __webpack_require__(94850);
;// CONCATENATED MODULE: ./src/entities/cmsPage/model.ts



var cmsPageModel = {
    name: "page",
    namePlural: "pages",
    uniqueName: "cmsPage",
    uniqueNamePlural: "cmsPages",
    path: "cms/page",
    baseUrl: "/cms/pages",
    translationPrefix: "entities:cmsPage.",
    getDisplayName: function(values) {
        return values.name;
    },
    gql: {
        getAll: ALL_PAGES_QUERY,
        getSingle: SINGLE_PAGE_QUERY,
        create: CREATE_PAGE_MUTATION,
        update: UPDATE_PAGE_MUTATION,
        delete: DELETE_PAGE_MUTATION,
        forceDelete: FORCE_DELETE_PAGE_MUTATION
    },
    attributes: {
        name: {
            name: "name",
            label: "entities:cmsPage.attributes.name.label",
            type: "value",
            dataType: "string",
            defaultInput: true,
            inputType: "text",
            validationType: "string",
            validations: []
        },
        onlineStatus: {
            name: "onlineStatus",
            label: "entities:cmsPage.attributes.onlineStatus.label",
            type: "value",
            dataType: "string",
            defaultValue: "ONLINE",
            defaultInput: true,
            inputType: "select",
            selectOptions: [
                {
                    label: "entities:cmsPage.attributes.onlineStatus.selectOptions.ONLINE.label",
                    value: "ONLINE"
                },
                {
                    label: "entities:cmsPage.attributes.onlineStatus.selectOptions.HIDDEN.label",
                    value: "HIDDEN"
                },
                {
                    label: "entities:cmsPage.attributes.onlineStatus.selectOptions.OFFLINE.label",
                    value: "OFFLINE"
                }, 
            ],
            validationType: "string",
            validations: []
        },
        seoSettings: {
            name: "seoSettings",
            label: "entities:cmsPage.attributes.seoSettings.label",
            type: "entityObject",
            dataType: "any",
            getEntity: function() {
                return entity/* default */.Z;
            },
            defaultInput: false,
            inputType: "select",
            validationType: "string",
            validations: []
        },
        contentBlockAssignments: {
            name: "contentBlockAssignments",
            label: "entities:cmsPage.attributes.contentBlockAssignments.label",
            type: "entityCollection",
            dataType: "[any]",
            getEntity: function() {
                return cmsContentBlockAssignment_entity/* default */.Z;
            },
            defaultInput: false,
            inputType: "text",
            validationType: "string",
            validations: []
        }
    }
};
/* harmony default export */ var model = (cmsPageModel);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(20414);
// EXTERNAL MODULE: ./src/entities/lib.ts
var lib = __webpack_require__(23480);
// EXTERNAL MODULE: ./src/lib/api/graphQLClient.ts
var graphQLClient = __webpack_require__(40112);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/swr/dist/index.mjs
var dist = __webpack_require__(8100);
// EXTERNAL MODULE: ./src/lib/helpers/helpers.ts
var helpers = __webpack_require__(15778);
;// CONCATENATED MODULE: ./src/entities/cmsPage/repository.ts










var hydrateObjects = function(objects) {
    return objects.map(function(object) {
        return (0,lib/* hydrateEntityObject */.b)(model, object);
    });
};
var hydrateObject = function(object) {
    return (0,lib/* hydrateEntityObject */.b)(model, object);
};
var cmsPageRepository = {
    getObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    id: id
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(SINGLE_PAGE_QUERY, variables).then(function(data) {
                        return hydrateObject(data.page);
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }(),
    getObjects: /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        var includes;
        var _arguments = arguments;
        return (0,tslib_es6.__generator)(this, function(_state) {
            includes = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : {};
            return [
                2,
                graphQLClient/* default.request */.Z.request(ALL_PAGES_QUERY, includes).then(function(data) {
                    return hydrateObjects(data.pages);
                })
            ];
        });
    }),
    useObject: function(id) {
        var includes = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        // eslint-disable-next-line react-hooks/exhaustive-deps
        var variables = (0,react.useMemo)(function() {
            return (0,_object_spread/* default */.Z)({
                id: id
            }, includes);
        }, [
            id
        ]);
        var ref = (0,dist/* default */.ZP)([
            SINGLE_PAGE_QUERY,
            variables
        ], {
            revalidateOnFocus: false
        }), data = ref.data, error = ref.error, mutate = ref.mutate;
        return {
            object: !data ? data : hydrateObject(data.page),
            isLoading: !error && !data,
            isError: error,
            mutate: mutate
        };
    },
    useObjects: function() {
        var includes = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        // eslint-disable-next-line react-hooks/exhaustive-deps
        var variables = (0,react.useMemo)(function() {
            return includes;
        }, []);
        var ref = (0,dist/* default */.ZP)([
            ALL_PAGES_QUERY,
            variables
        ]), data = ref.data, error = ref.error, mutate = ref.mutate;
        return {
            objects: !data ? data : hydrateObjects(data.pages),
            isLoading: !error && !data,
            isError: error,
            mutate: mutate
        };
    },
    getDependents: function(id, includes) {
        var includeVars = {};
        includes.forEach(function(include) {
            includeVars["with".concat((0,helpers/* uppercaseFirst */.AB)(include))] = true;
        });
        var variables = (0,_object_spread/* default */.Z)({
            id: id
        }, includeVars);
        return graphQLClient/* default.request */.Z.request(PAGES_DEPENDENTS_QUERY, variables).then(function(data) {
            return data.groupedDependents;
        });
    },
    useDependents: function(id, includes) {
        var includeVars = {};
        includes.forEach(function(include) {
            includeVars["with".concat((0,helpers/* uppercaseFirst */.AB)(include))] = true;
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
        var variables = (0,react.useMemo)(function() {
            return (0,_object_spread/* default */.Z)({
                id: id
            }, includeVars);
        }, [
            id
        ]);
        var ref = (0,dist/* default */.ZP)([
            PAGES_DEPENDENTS_QUERY,
            variables
        ], {
            revalidateOnFocus: false
        }), data = ref.data, error = ref.error, mutate = ref.mutate;
        return {
            data: !data ? data : data.groupedDependents,
            isLoading: !error && !data,
            isError: error,
            mutate: mutate
        };
    },
    createObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(data) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    input: data
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(CREATE_PAGE_MUTATION, variables).then(function(data) {
                        return hydrateObject(data.page);
                    })
                ];
            });
        });
        return function(data) {
            return _ref.apply(this, arguments);
        };
    }(),
    updateObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(data) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    input: data
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(UPDATE_PAGE_MUTATION, variables).then(function(data) {
                        return hydrateObject(data.page);
                    })
                ];
            });
        });
        return function(data) {
            return _ref.apply(this, arguments);
        };
    }(),
    deleteObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(DELETE_PAGE_MUTATION, variables).then(function(data) {
                        return data.deleteCmsPage;
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }(),
    forceDeleteObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(FORCE_DELETE_PAGE_MUTATION, variables).then(function(data) {
                        return data.forceDeleteCmsPage;
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }(),
    assignContentBlockAssignments: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, itemIds) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        contentBlockAssignmentIds: itemIds
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(ADD_PAGE_CONTENT_BLOCK_ASSIGNMENTS_MUTATION, variables)
                ];
            });
        });
        return function(id, itemIds) {
            return _ref.apply(this, arguments);
        };
    }(),
    unassignContentBlockAssignments: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, itemIds) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        contentBlockAssignmentIds: itemIds
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(REMOVE_PAGE_CONTENT_BLOCK_ASSIGNMENTS_MUTATION, variables)
                ];
            });
        });
        return function(id, itemIds) {
            return _ref.apply(this, arguments);
        };
    }(),
    createContentBlockAssignments: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, items) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        contentBlockAssignments: items
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(CREATE_PAGE_CONTENT_BLOCK_ASSIGNMENTS_MUTATION, variables)
                ];
            });
        });
        return function(id, items) {
            return _ref.apply(this, arguments);
        };
    }(),
    deleteContentBlockAssignments: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, itemIds) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        contentBlockAssignmentIds: itemIds
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(DELETE_PAGE_CONTENT_BLOCK_ASSIGNMENTS_MUTATION, variables)
                ];
            });
        });
        return function(id, itemIds) {
            return _ref.apply(this, arguments);
        };
    }(),
    updateContentBlockAssignmentsOrder: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, itemIds) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        contentBlockAssignmentIds: itemIds
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(UPDATE_PAGE_CONTENT_BLOCK_ASSIGNMENTS_ORDER_MUTATION, variables)
                ];
            });
        });
        return function(id, itemIds) {
            return _ref.apply(this, arguments);
        };
    }()
};
/* harmony default export */ var repository = (cmsPageRepository);

;// CONCATENATED MODULE: ./src/entities/cmsPage/entity.ts


var cmsPageEntity = {
    model: model,
    repository: repository
};
/* harmony default export */ var cmsPage_entity = (cmsPageEntity);


/***/ }),

/***/ 75780:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ entity; }
});

;// CONCATENATED MODULE: ./src/entities/cmsSocialMediaSettings/graphql.ts
// language=GraphQL
var ALL_SOCIAL_MEDIA_SETTINGS_QUERY = "query Query {\n  socialMediaSettings: allCmsSocialMediaSettings {\n    id\n    facebookUrl\n    instagramUrl\n  }\n}";
// language=GraphQL
var SINGLE_SOCIAL_MEDIA_SETTINGS_QUERY = "query Query($id: ID!) {\n  socialMediaSettings: cmsSocialMediaSettings(id: $id) {\n    id\n    facebookUrl\n    instagramUrl\n  }\n}";
// language=GraphQL
var CREATE_SOCIAL_MEDIA_SETTINGS_MUTATION = "\n  mutation Mutation($input: CreateCmsSocialMediaSettingsInput) {\n    socialMediaSettings: createCmsSocialMediaSettings(input: $input) {\n      id\n      facebookUrl\n      instagramUrl\n    }\n  }";
// language=GraphQL
var UPDATE_SOCIAL_MEDIA_SETTINGS_MUTATION = "\n  mutation Mutation($input: UpdateCmsSocialMediaSettingsInput) {\n    socialMediaSettings: updateCmsSocialMediaSettings(input: $input) {\n      id\n      facebookUrl\n      instagramUrl\n    }\n  }";
// language=GraphQL
var DELETE_SOCIAL_MEDIA_SETTINGS_MUTATION = "\n  mutation Mutation($input: DeleteCmsSocialMediaSettingsInput) {\n    deleteCmsSocialMediaSettings(input: $input) {\n      success\n    }\n  }";
// language=GraphQL
var FORCE_DELETE_SOCIAL_MEDIA_SETTINGS_MUTATION = "\n  mutation Mutation($input: DeleteCmsSocialMediaSettingsInput) {\n    forceDeleteCmsSocialMediaSettings(input: $input) {\n      success\n    }\n  }";
// language=GraphQL
var SOCIAL_MEDIA_SETTINGS_DEPENDENTS_QUERY = "query Query($id: ID!, $withCmsConfigs: Boolean = false) {\n  groupedDependents: cmsSocialMediaSettingsDependents(id: $id) {\n    cmsConfigs @include(if: $withCmsConfigs) {\n      id\n    }\n  }\n}";

;// CONCATENATED MODULE: ./src/entities/cmsSocialMediaSettings/model.ts

var cmsSocialMediaSettingsModel = {
    name: "socialMediaSettings",
    namePlural: "socialMediaSettings",
    uniqueName: "cmsSocialMediaSettings",
    uniqueNamePlural: "cmsSocialMediaSettings",
    path: "cms/config/social_media_settings",
    baseUrl: "/cms/config/social_media_settings",
    translationPrefix: "entities:cmsSocialMediaSettings.",
    getDisplayName: function(values) {
        return "CMS Social Media Settings";
    },
    gql: {
        getAll: ALL_SOCIAL_MEDIA_SETTINGS_QUERY,
        getSingle: SINGLE_SOCIAL_MEDIA_SETTINGS_QUERY,
        create: CREATE_SOCIAL_MEDIA_SETTINGS_MUTATION,
        update: UPDATE_SOCIAL_MEDIA_SETTINGS_MUTATION,
        delete: DELETE_SOCIAL_MEDIA_SETTINGS_MUTATION,
        forceDelete: FORCE_DELETE_SOCIAL_MEDIA_SETTINGS_MUTATION
    },
    attributes: {
        facebookUrl: {
            name: "facebookUrl",
            label: "entities:cmsSocialMediaSettings.attributes.facebookUrl.label",
            type: "value",
            dataType: "string",
            defaultInput: true,
            inputType: "text",
            validationType: "string",
            validations: [
                {
                    type: "url"
                }, 
            ]
        },
        instagramUrl: {
            name: "instagramUrl",
            label: "entities:cmsSocialMediaSettings.attributes.instagramUrl.label",
            type: "value",
            dataType: "string",
            defaultInput: true,
            inputType: "text",
            validationType: "string",
            validations: [
                {
                    type: "url"
                }, 
            ]
        }
    }
};
/* harmony default export */ var model = (cmsSocialMediaSettingsModel);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(20414);
// EXTERNAL MODULE: ./src/entities/lib.ts
var lib = __webpack_require__(23480);
// EXTERNAL MODULE: ./src/lib/api/graphQLClient.ts
var graphQLClient = __webpack_require__(40112);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/swr/dist/index.mjs
var dist = __webpack_require__(8100);
// EXTERNAL MODULE: ./src/lib/helpers/helpers.ts
var helpers = __webpack_require__(15778);
;// CONCATENATED MODULE: ./src/entities/cmsSocialMediaSettings/repository.ts










var hydrateObjects = function(objects) {
    return objects.map(function(object) {
        return (0,lib/* hydrateEntityObject */.b)(model, object);
    });
};
var hydrateObject = function(object) {
    return (0,lib/* hydrateEntityObject */.b)(model, object);
};
var cmsSocialMediaSettingsRepository = {
    getObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    id: id
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(SINGLE_SOCIAL_MEDIA_SETTINGS_QUERY, variables).then(function(data) {
                        return hydrateObject(data.socialMediaSettings);
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }(),
    getObjects: /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        var includes;
        var _arguments = arguments;
        return (0,tslib_es6.__generator)(this, function(_state) {
            includes = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : {};
            return [
                2,
                graphQLClient/* default.request */.Z.request(ALL_SOCIAL_MEDIA_SETTINGS_QUERY, includes).then(function(data) {
                    return hydrateObjects(data.socialMediaSettings);
                })
            ];
        });
    }),
    useObject: function(id) {
        var includes = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        // eslint-disable-next-line react-hooks/exhaustive-deps
        var variables = (0,react.useMemo)(function() {
            return (0,_object_spread/* default */.Z)({
                id: id
            }, includes);
        }, [
            id
        ]);
        var ref = (0,dist/* default */.ZP)([
            SINGLE_SOCIAL_MEDIA_SETTINGS_QUERY,
            variables
        ], {
            revalidateOnFocus: false
        }), data = ref.data, error = ref.error, mutate = ref.mutate;
        return {
            object: !data ? data : hydrateObject(data.socialMediaSettings),
            isLoading: !error && !data,
            isError: error,
            mutate: mutate
        };
    },
    useObjects: function() {
        var includes = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        // eslint-disable-next-line react-hooks/exhaustive-deps
        var variables = (0,react.useMemo)(function() {
            return includes;
        }, []);
        var ref = (0,dist/* default */.ZP)([
            ALL_SOCIAL_MEDIA_SETTINGS_QUERY,
            variables
        ]), data = ref.data, error = ref.error, mutate = ref.mutate;
        return {
            objects: !data ? data : hydrateObjects(data.socialMediaSettings),
            isLoading: !error && !data,
            isError: error,
            mutate: mutate
        };
    },
    getDependents: function(id, includes) {
        var includeVars = {};
        includes.forEach(function(include) {
            includeVars["with".concat((0,helpers/* uppercaseFirst */.AB)(include))] = true;
        });
        var variables = (0,_object_spread/* default */.Z)({
            id: id
        }, includeVars);
        return graphQLClient/* default.request */.Z.request(SOCIAL_MEDIA_SETTINGS_DEPENDENTS_QUERY, variables).then(function(data) {
            return data.groupedDependents;
        });
    },
    useDependents: function(id, includes) {
        var includeVars = {};
        includes.forEach(function(include) {
            includeVars["with".concat((0,helpers/* uppercaseFirst */.AB)(include))] = true;
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
        var variables = (0,react.useMemo)(function() {
            return (0,_object_spread/* default */.Z)({
                id: id
            }, includeVars);
        }, [
            id
        ]);
        var ref = (0,dist/* default */.ZP)([
            SOCIAL_MEDIA_SETTINGS_DEPENDENTS_QUERY,
            variables
        ], {
            revalidateOnFocus: false
        }), data = ref.data, error = ref.error, mutate = ref.mutate;
        return {
            data: !data ? data : data.groupedDependents,
            isLoading: !error && !data,
            isError: error,
            mutate: mutate
        };
    },
    createObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(data) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    input: data
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(CREATE_SOCIAL_MEDIA_SETTINGS_MUTATION, variables).then(function(data) {
                        return hydrateObject(data.socialMediaSettings);
                    })
                ];
            });
        });
        return function(data) {
            return _ref.apply(this, arguments);
        };
    }(),
    updateObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(data) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    input: data
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(UPDATE_SOCIAL_MEDIA_SETTINGS_MUTATION, variables).then(function(data) {
                        return hydrateObject(data.socialMediaSettings);
                    })
                ];
            });
        });
        return function(data) {
            return _ref.apply(this, arguments);
        };
    }(),
    deleteObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(DELETE_SOCIAL_MEDIA_SETTINGS_MUTATION, variables).then(function(data) {
                        return data.deleteCmsSocialMediaSettings;
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }(),
    forceDeleteObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(FORCE_DELETE_SOCIAL_MEDIA_SETTINGS_MUTATION, variables).then(function(data) {
                        return data.forceDeleteCmsSocialMediaSettings;
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }()
};
/* harmony default export */ var repository = (cmsSocialMediaSettingsRepository);

;// CONCATENATED MODULE: ./src/entities/cmsSocialMediaSettings/entity.ts


var cmsSocialMediaSettingsEntity = {
    model: model,
    repository: repository
};
/* harmony default export */ var entity = (cmsSocialMediaSettingsEntity);


/***/ }),

/***/ 3572:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ cmsTextWithIconBlock_entity; }
});

;// CONCATENATED MODULE: ./src/entities/cmsTextWithIconBlock/graphql.ts
// language=GraphQL
var ALL_TEXT_WITH_ICON_BLOCKS_QUERY = "query Query($withImage: Boolean = false) {\n  textWithIconBlocks: cmsTextWithIconBlocks {\n    id\n    title\n    text\n    image @include(if: $withImage) {\n      id\n      assetId\n      publicId\n      url\n      resourceType\n      format\n      width\n      height\n      caption\n      title\n      description\n    }\n    imagePosition\n  }\n}";
// language=GraphQL
var SINGLE_TEXT_WITH_ICON_BLOCK_QUERY = "query Query($id: ID!, $withImage: Boolean = false) {\n  textWithIconBlock: cmsTextWithIconBlock(id: $id) {\n    id\n    title\n    text\n    image @include(if: $withImage) {\n      id\n      assetId\n      publicId\n      url\n      resourceType\n      format\n      width\n      height\n      caption\n      title\n      description\n    }\n    imagePosition\n  }\n}";
// language=GraphQL
var CREATE_TEXT_WITH_ICON_BLOCK_MUTATION = "\n  mutation Mutation($input: CreateCmsTextWithIconBlockInput, $withImage: Boolean = false) {\n    textWithIconBlock: createCmsTextWithIconBlock(input: $input) {\n      id\n      title\n      text\n      image @include(if: $withImage) {\n        id\n        assetId\n        publicId\n        url\n        resourceType\n        format\n        width\n        height\n        caption\n        title\n        description\n      }\n      imagePosition\n    }\n  }";
// language=GraphQL
var UPDATE_TEXT_WITH_ICON_BLOCK_MUTATION = "\n  mutation Mutation($input: UpdateCmsTextWithIconBlockInput, $withImage: Boolean = false) {\n    textWithIconBlock: updateCmsTextWithIconBlock(input: $input) {\n      id\n      title\n      text\n      image @include(if: $withImage) {\n        id\n        assetId\n        publicId\n        url\n        resourceType\n        format\n        width\n        height\n        caption\n        title\n        description\n      }\n      imagePosition\n    }\n  }";
// language=GraphQL
var DELETE_TEXT_WITH_ICON_BLOCK_MUTATION = "\n  mutation Mutation($input: DeleteCmsTextWithIconBlockInput) {\n    deleteCmsTextWithIconBlock(input: $input) {\n      success\n    }\n  }";
// language=GraphQL
var FORCE_DELETE_TEXT_WITH_ICON_BLOCK_MUTATION = "\n  mutation Mutation($input: DeleteCmsTextWithIconBlockInput) {\n    forceDeleteCmsTextWithIconBlock(input: $input) {\n      success\n    }\n  }";
// language=GraphQL
var TEXT_WITH_ICON_BLOCKS_DEPENDENTS_QUERY = "query Query($id: ID!, $withTravelTestimonials: Boolean = false) {\n  groupedDependents: cmsTextWithIconBlockDependents(id: $id) {\n    travelTestimonials @include(if: $withTravelTestimonials) {\n      id\n    }\n  }\n}";

// EXTERNAL MODULE: ./src/entities/mediaFile/entity.ts + 3 modules
var entity = __webpack_require__(24180);
;// CONCATENATED MODULE: ./src/entities/cmsTextWithIconBlock/model.ts


var cmsTextWithIconBlockModel = {
    name: "textWithIconBlock",
    namePlural: "textWithIconBlocks",
    uniqueName: "cmsTextWithIconBlock",
    uniqueNamePlural: "cmsTextWithIconBlocks",
    path: "cms/blocks/text_with_icon_block",
    baseUrl: "/cms/blocks/text_with_icon_blocks",
    translationPrefix: "entities:cmsTextWithIconBlock.",
    getDisplayName: function(values) {
        return "Text with icon";
    },
    gql: {
        getAll: ALL_TEXT_WITH_ICON_BLOCKS_QUERY,
        getSingle: SINGLE_TEXT_WITH_ICON_BLOCK_QUERY,
        create: CREATE_TEXT_WITH_ICON_BLOCK_MUTATION,
        update: UPDATE_TEXT_WITH_ICON_BLOCK_MUTATION,
        delete: DELETE_TEXT_WITH_ICON_BLOCK_MUTATION,
        forceDelete: FORCE_DELETE_TEXT_WITH_ICON_BLOCK_MUTATION
    },
    attributes: {
        title: {
            name: "title",
            label: "entities:cmsTextWithIconBlock.attributes.title.label",
            type: "value",
            dataType: "string",
            defaultInput: true,
            inputType: "text",
            validationType: "string",
            validations: []
        },
        text: {
            name: "text",
            label: "entities:cmsTextWithIconBlock.attributes.text.label",
            type: "value",
            dataType: "string",
            defaultInput: true,
            inputType: "wysiwyg",
            validationType: "string",
            validations: [
                {
                    type: "required"
                }, 
            ]
        },
        image: {
            name: "image",
            label: "entities:cmsTextWithIconBlock.attributes.image.label",
            type: "entityObject",
            dataType: "any",
            getEntity: function() {
                return entity/* default */.Z;
            },
            defaultInput: false,
            inputType: "select",
            validationType: "string",
            validations: []
        },
        imagePosition: {
            name: "imagePosition",
            label: "entities:cmsTextWithIconBlock.attributes.imagePosition.label",
            type: "value",
            dataType: "string",
            defaultInput: false,
            inputType: "select",
            selectOptions: [
                {
                    label: "entities:cmsTextWithIconBlock.attributes.imagePosition.selectOptions.left.label",
                    value: "left"
                },
                {
                    label: "entities:cmsTextWithIconBlock.attributes.imagePosition.selectOptions.right.label",
                    value: "right"
                }, 
            ],
            validationType: "string",
            validations: []
        }
    }
};
/* harmony default export */ var model = (cmsTextWithIconBlockModel);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(20414);
// EXTERNAL MODULE: ./src/entities/lib.ts
var lib = __webpack_require__(23480);
// EXTERNAL MODULE: ./src/lib/api/graphQLClient.ts
var graphQLClient = __webpack_require__(40112);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/swr/dist/index.mjs
var dist = __webpack_require__(8100);
// EXTERNAL MODULE: ./src/lib/helpers/helpers.ts
var helpers = __webpack_require__(15778);
;// CONCATENATED MODULE: ./src/entities/cmsTextWithIconBlock/repository.ts










var hydrateObjects = function(objects) {
    return objects.map(function(object) {
        return (0,lib/* hydrateEntityObject */.b)(model, object);
    });
};
var hydrateObject = function(object) {
    return (0,lib/* hydrateEntityObject */.b)(model, object);
};
var cmsTextWithIconBlockRepository = {
    getObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    id: id
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(SINGLE_TEXT_WITH_ICON_BLOCK_QUERY, variables).then(function(data) {
                        return hydrateObject(data.textWithIconBlock);
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }(),
    getObjects: /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        var includes;
        var _arguments = arguments;
        return (0,tslib_es6.__generator)(this, function(_state) {
            includes = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : {};
            return [
                2,
                graphQLClient/* default.request */.Z.request(ALL_TEXT_WITH_ICON_BLOCKS_QUERY, includes).then(function(data) {
                    return hydrateObjects(data.textWithIconBlocks);
                })
            ];
        });
    }),
    useObject: function(id) {
        var includes = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        // eslint-disable-next-line react-hooks/exhaustive-deps
        var variables = (0,react.useMemo)(function() {
            return (0,_object_spread/* default */.Z)({
                id: id
            }, includes);
        }, [
            id
        ]);
        var ref = (0,dist/* default */.ZP)([
            SINGLE_TEXT_WITH_ICON_BLOCK_QUERY,
            variables
        ], {
            revalidateOnFocus: false
        }), data = ref.data, error = ref.error, mutate = ref.mutate;
        return {
            object: !data ? data : hydrateObject(data.textWithIconBlock),
            isLoading: !error && !data,
            isError: error,
            mutate: mutate
        };
    },
    useObjects: function() {
        var includes = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        // eslint-disable-next-line react-hooks/exhaustive-deps
        var variables = (0,react.useMemo)(function() {
            return includes;
        }, []);
        var ref = (0,dist/* default */.ZP)([
            ALL_TEXT_WITH_ICON_BLOCKS_QUERY,
            variables
        ]), data = ref.data, error = ref.error, mutate = ref.mutate;
        return {
            objects: !data ? data : hydrateObjects(data.textWithIconBlocks),
            isLoading: !error && !data,
            isError: error,
            mutate: mutate
        };
    },
    getDependents: function(id, includes) {
        var includeVars = {};
        includes.forEach(function(include) {
            includeVars["with".concat((0,helpers/* uppercaseFirst */.AB)(include))] = true;
        });
        var variables = (0,_object_spread/* default */.Z)({
            id: id
        }, includeVars);
        return graphQLClient/* default.request */.Z.request(TEXT_WITH_ICON_BLOCKS_DEPENDENTS_QUERY, variables).then(function(data) {
            return data.groupedDependents;
        });
    },
    useDependents: function(id, includes) {
        var includeVars = {};
        includes.forEach(function(include) {
            includeVars["with".concat((0,helpers/* uppercaseFirst */.AB)(include))] = true;
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
        var variables = (0,react.useMemo)(function() {
            return (0,_object_spread/* default */.Z)({
                id: id
            }, includeVars);
        }, [
            id
        ]);
        var ref = (0,dist/* default */.ZP)([
            TEXT_WITH_ICON_BLOCKS_DEPENDENTS_QUERY,
            variables
        ], {
            revalidateOnFocus: false
        }), data = ref.data, error = ref.error, mutate = ref.mutate;
        return {
            data: !data ? data : data.groupedDependents,
            isLoading: !error && !data,
            isError: error,
            mutate: mutate
        };
    },
    createObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(data) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    input: data
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(CREATE_TEXT_WITH_ICON_BLOCK_MUTATION, variables).then(function(data) {
                        return hydrateObject(data.textWithIconBlock);
                    })
                ];
            });
        });
        return function(data) {
            return _ref.apply(this, arguments);
        };
    }(),
    updateObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(data) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    input: data
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(UPDATE_TEXT_WITH_ICON_BLOCK_MUTATION, variables).then(function(data) {
                        return hydrateObject(data.textWithIconBlock);
                    })
                ];
            });
        });
        return function(data) {
            return _ref.apply(this, arguments);
        };
    }(),
    deleteObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(DELETE_TEXT_WITH_ICON_BLOCK_MUTATION, variables).then(function(data) {
                        return data.deleteCmsTextWithIconBlock;
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }(),
    forceDeleteObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(FORCE_DELETE_TEXT_WITH_ICON_BLOCK_MUTATION, variables).then(function(data) {
                        return data.forceDeleteCmsTextWithIconBlock;
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }()
};
/* harmony default export */ var repository = (cmsTextWithIconBlockRepository);

;// CONCATENATED MODULE: ./src/entities/cmsTextWithIconBlock/entity.ts


var cmsTextWithIconBlockEntity = {
    model: model,
    repository: repository
};
/* harmony default export */ var cmsTextWithIconBlock_entity = (cmsTextWithIconBlockEntity);


/***/ }),

/***/ 63409:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ cmsTextWithImageBlock_entity; }
});

;// CONCATENATED MODULE: ./src/entities/cmsTextWithImageBlock/graphql.ts
// language=GraphQL
var ALL_TEXT_WITH_IMAGE_BLOCKS_QUERY = "query Query($withImage: Boolean = false, $withGallery: Boolean = false, $withGalleryImages: Boolean = false, $withLink: Boolean = false, $withLinkPage: Boolean = false, $withLinkPageSeoSettings: Boolean = false, $withLinkPageContentBlockAssignments: Boolean = false, $withLinkTravel: Boolean = false, $withLinkTravelAvailabilityStatus: Boolean = false, $withLinkTravelTravelConsultant: Boolean = false, $withLinkTravelLabel: Boolean = false, $withLinkTravelSeoSettings: Boolean = false, $withLinkTravelTenantSettings: Boolean = false, $withLinkTravelHighlights: Boolean = false, $withLinkTravelPartners: Boolean = false, $withLinkTravelTravelGuides: Boolean = false, $withLinkTravelTeams: Boolean = false, $withLinkTravelAccommodationAssignments: Boolean = false, $withLinkTravelAccommodations: Boolean = false, $withLinkTravelDestinations: Boolean = false, $withLinkTravelTestimonials: Boolean = false, $withLinkTravelMainImage: Boolean = false, $withLinkTravelMainVideo: Boolean = false, $withLinkTravelGallery: Boolean = false, $withLinkTravelTravelPdf: Boolean = false, $withLinkTravelTravelExtensions: Boolean = false, $withLinkTravelItinerary: Boolean = false, $withLinkTravelPricing: Boolean = false) {\n  textWithImageBlocks: cmsTextWithImageBlocks {\n    id\n    title\n    subtitle\n    text\n    imagePosition\n    image @include(if: $withImage) {\n      id\n      assetId\n      publicId\n      url\n      resourceType\n      format\n      width\n      height\n      caption\n      title\n      description\n    }\n    imageFixedAspectRatio\n    gallery @include(if: $withGallery) {\n      id\n      images @include(if: $withGalleryImages) {\n        id\n        assetId\n        publicId\n        url\n        resourceType\n        format\n        width\n        height\n        caption\n        title\n        description\n      }\n    }\n    link @include(if: $withLink) {\n      id\n      label\n      targetBlank\n      type\n      url\n      page @include(if: $withLinkPage) {\n        id\n        name\n        onlineStatus\n        seoSettings @include(if: $withLinkPageSeoSettings) {\n          id\n          urlSlug\n          metaTitle\n          metaDescription\n          ogTitle\n          ogDescription\n        }\n        contentBlockAssignments @include(if: $withLinkPageContentBlockAssignments) {\n          id\n          type\n        }\n      }\n      travel @include(if: $withLinkTravel) {\n        id\n        name\n        isBestseller\n        startDate\n        endDate\n        availabilityStatus @include(if: $withLinkTravelAvailabilityStatus) {\n          id\n          label\n          status\n          isDefaultStatus\n          isDefaultWaitlistFallback\n        }\n        executionStatus\n        travelConsultant @include(if: $withLinkTravelTravelConsultant) {\n          id\n          firstName\n          lastName\n          jobTitle\n          description\n          email\n          phone\n        }\n        label @include(if: $withLinkTravelLabel) {\n          id\n          label\n        }\n        title\n        description\n        includedServices\n        excludedServices\n        pricingTable\n        priceCalculationInfo\n        seoSettings @include(if: $withLinkTravelSeoSettings) {\n          id\n          urlSlug\n          metaTitle\n          metaDescription\n          ogTitle\n          ogDescription\n        }\n        tenantSettings @include(if: $withLinkTravelTenantSettings) {\n          id\n          onlineStatus\n          redirectToBooking\n          useTiming\n          startDate\n          endDate\n        }\n        highlights @include(if: $withLinkTravelHighlights) {\n          id\n          text\n        }\n        partners @include(if: $withLinkTravelPartners) {\n          id\n          name\n          url\n          logoWidth\n        }\n        travelGuides @include(if: $withLinkTravelTravelGuides) {\n          id\n          firstName\n          lastName\n          description\n        }\n        teams @include(if: $withLinkTravelTeams) {\n          id\n          name\n        }\n        accommodationAssignments @include(if: $withLinkTravelAccommodationAssignments) {\n          id\n          useCustomRoomTypeSelection\n        }\n        accommodations @include(if: $withLinkTravelAccommodations) {\n          id\n          label\n          name\n          stars\n          description\n        }\n        destinations @include(if: $withLinkTravelDestinations) {\n          id\n          name\n          entryRequirements\n          medicalInformation\n          language\n          timeShift\n          climate\n          currency\n        }\n        testimonials @include(if: $withLinkTravelTestimonials) {\n          id\n        }\n        mainImage @include(if: $withLinkTravelMainImage) {\n          id\n          assetId\n          publicId\n          url\n          resourceType\n          format\n          width\n          height\n          caption\n          title\n          description\n        }\n        mainVideo @include(if: $withLinkTravelMainVideo) {\n          id\n          assetId\n          publicId\n          url\n          resourceType\n          format\n          width\n          height\n          caption\n          title\n          description\n        }\n        gallery @include(if: $withLinkTravelGallery) {\n          id\n        }\n        travelPdf @include(if: $withLinkTravelTravelPdf) {\n          id\n          assetId\n          publicId\n          url\n          resourceType\n          format\n          width\n          height\n          caption\n          title\n          description\n        }\n        travelExtensions @include(if: $withLinkTravelTravelExtensions) {\n          id\n          duration\n          name\n          description\n        }\n        programType\n        itinerary @include(if: $withLinkTravelItinerary) {\n          id\n        }\n        programText\n        pricing @include(if: $withLinkTravelPricing) {\n          id\n          isTravelDocumentationAvailable\n        }\n        minPrice\n        minPriceManualOverride\n        currency\n      }\n    }\n  }\n}";
// language=GraphQL
var SINGLE_TEXT_WITH_IMAGE_BLOCK_QUERY = "query Query($id: ID!, $withImage: Boolean = false, $withGallery: Boolean = false, $withGalleryImages: Boolean = false, $withLink: Boolean = false, $withLinkPage: Boolean = false, $withLinkPageSeoSettings: Boolean = false, $withLinkPageContentBlockAssignments: Boolean = false, $withLinkTravel: Boolean = false, $withLinkTravelAvailabilityStatus: Boolean = false, $withLinkTravelTravelConsultant: Boolean = false, $withLinkTravelLabel: Boolean = false, $withLinkTravelSeoSettings: Boolean = false, $withLinkTravelTenantSettings: Boolean = false, $withLinkTravelHighlights: Boolean = false, $withLinkTravelPartners: Boolean = false, $withLinkTravelTravelGuides: Boolean = false, $withLinkTravelTeams: Boolean = false, $withLinkTravelAccommodationAssignments: Boolean = false, $withLinkTravelAccommodations: Boolean = false, $withLinkTravelDestinations: Boolean = false, $withLinkTravelTestimonials: Boolean = false, $withLinkTravelMainImage: Boolean = false, $withLinkTravelMainVideo: Boolean = false, $withLinkTravelGallery: Boolean = false, $withLinkTravelTravelPdf: Boolean = false, $withLinkTravelTravelExtensions: Boolean = false, $withLinkTravelItinerary: Boolean = false, $withLinkTravelPricing: Boolean = false) {\n  textWithImageBlock: cmsTextWithImageBlock(id: $id) {\n    id\n    title\n    subtitle\n    text\n    imagePosition\n    image @include(if: $withImage) {\n      id\n      assetId\n      publicId\n      url\n      resourceType\n      format\n      width\n      height\n      caption\n      title\n      description\n    }\n    imageFixedAspectRatio\n    gallery @include(if: $withGallery) {\n      id\n      images @include(if: $withGalleryImages) {\n        id\n        assetId\n        publicId\n        url\n        resourceType\n        format\n        width\n        height\n        caption\n        title\n        description\n      }\n    }\n    link @include(if: $withLink) {\n      id\n      label\n      targetBlank\n      type\n      url\n      page @include(if: $withLinkPage) {\n        id\n        name\n        onlineStatus\n        seoSettings @include(if: $withLinkPageSeoSettings) {\n          id\n          urlSlug\n          metaTitle\n          metaDescription\n          ogTitle\n          ogDescription\n        }\n        contentBlockAssignments @include(if: $withLinkPageContentBlockAssignments) {\n          id\n          type\n        }\n      }\n      travel @include(if: $withLinkTravel) {\n        id\n        name\n        isBestseller\n        startDate\n        endDate\n        availabilityStatus @include(if: $withLinkTravelAvailabilityStatus) {\n          id\n          label\n          status\n          isDefaultStatus\n          isDefaultWaitlistFallback\n        }\n        executionStatus\n        travelConsultant @include(if: $withLinkTravelTravelConsultant) {\n          id\n          firstName\n          lastName\n          jobTitle\n          description\n          email\n          phone\n        }\n        label @include(if: $withLinkTravelLabel) {\n          id\n          label\n        }\n        title\n        description\n        includedServices\n        excludedServices\n        pricingTable\n        priceCalculationInfo\n        seoSettings @include(if: $withLinkTravelSeoSettings) {\n          id\n          urlSlug\n          metaTitle\n          metaDescription\n          ogTitle\n          ogDescription\n        }\n        tenantSettings @include(if: $withLinkTravelTenantSettings) {\n          id\n          onlineStatus\n          redirectToBooking\n          useTiming\n          startDate\n          endDate\n        }\n        highlights @include(if: $withLinkTravelHighlights) {\n          id\n          text\n        }\n        partners @include(if: $withLinkTravelPartners) {\n          id\n          name\n          url\n          logoWidth\n        }\n        travelGuides @include(if: $withLinkTravelTravelGuides) {\n          id\n          firstName\n          lastName\n          description\n        }\n        teams @include(if: $withLinkTravelTeams) {\n          id\n          name\n        }\n        accommodationAssignments @include(if: $withLinkTravelAccommodationAssignments) {\n          id\n          useCustomRoomTypeSelection\n        }\n        accommodations @include(if: $withLinkTravelAccommodations) {\n          id\n          label\n          name\n          stars\n          description\n        }\n        destinations @include(if: $withLinkTravelDestinations) {\n          id\n          name\n          entryRequirements\n          medicalInformation\n          language\n          timeShift\n          climate\n          currency\n        }\n        testimonials @include(if: $withLinkTravelTestimonials) {\n          id\n        }\n        mainImage @include(if: $withLinkTravelMainImage) {\n          id\n          assetId\n          publicId\n          url\n          resourceType\n          format\n          width\n          height\n          caption\n          title\n          description\n        }\n        mainVideo @include(if: $withLinkTravelMainVideo) {\n          id\n          assetId\n          publicId\n          url\n          resourceType\n          format\n          width\n          height\n          caption\n          title\n          description\n        }\n        gallery @include(if: $withLinkTravelGallery) {\n          id\n        }\n        travelPdf @include(if: $withLinkTravelTravelPdf) {\n          id\n          assetId\n          publicId\n          url\n          resourceType\n          format\n          width\n          height\n          caption\n          title\n          description\n        }\n        travelExtensions @include(if: $withLinkTravelTravelExtensions) {\n          id\n          duration\n          name\n          description\n        }\n        programType\n        itinerary @include(if: $withLinkTravelItinerary) {\n          id\n        }\n        programText\n        pricing @include(if: $withLinkTravelPricing) {\n          id\n          isTravelDocumentationAvailable\n        }\n        minPrice\n        minPriceManualOverride\n        currency\n      }\n    }\n  }\n}";
// language=GraphQL
var CREATE_TEXT_WITH_IMAGE_BLOCK_MUTATION = "\n  mutation Mutation($input: CreateCmsTextWithImageBlockInput, $withImage: Boolean = false, $withGallery: Boolean = false, $withGalleryImages: Boolean = false, $withLink: Boolean = false, $withLinkPage: Boolean = false, $withLinkPageSeoSettings: Boolean = false, $withLinkPageContentBlockAssignments: Boolean = false, $withLinkTravel: Boolean = false, $withLinkTravelAvailabilityStatus: Boolean = false, $withLinkTravelTravelConsultant: Boolean = false, $withLinkTravelLabel: Boolean = false, $withLinkTravelSeoSettings: Boolean = false, $withLinkTravelTenantSettings: Boolean = false, $withLinkTravelHighlights: Boolean = false, $withLinkTravelPartners: Boolean = false, $withLinkTravelTravelGuides: Boolean = false, $withLinkTravelTeams: Boolean = false, $withLinkTravelAccommodationAssignments: Boolean = false, $withLinkTravelAccommodations: Boolean = false, $withLinkTravelDestinations: Boolean = false, $withLinkTravelTestimonials: Boolean = false, $withLinkTravelMainImage: Boolean = false, $withLinkTravelMainVideo: Boolean = false, $withLinkTravelGallery: Boolean = false, $withLinkTravelTravelPdf: Boolean = false, $withLinkTravelTravelExtensions: Boolean = false, $withLinkTravelItinerary: Boolean = false, $withLinkTravelPricing: Boolean = false) {\n    textWithImageBlock: createCmsTextWithImageBlock(input: $input) {\n      id\n      title\n      subtitle\n      text\n      imagePosition\n      image @include(if: $withImage) {\n        id\n        assetId\n        publicId\n        url\n        resourceType\n        format\n        width\n        height\n        caption\n        title\n        description\n      }\n      imageFixedAspectRatio\n      gallery @include(if: $withGallery) {\n        id\n        images @include(if: $withGalleryImages) {\n          id\n          assetId\n          publicId\n          url\n          resourceType\n          format\n          width\n          height\n          caption\n          title\n          description\n        }\n      }\n      link @include(if: $withLink) {\n        id\n        label\n        targetBlank\n        type\n        url\n        page @include(if: $withLinkPage) {\n          id\n          name\n          onlineStatus\n          seoSettings @include(if: $withLinkPageSeoSettings) {\n            id\n            urlSlug\n            metaTitle\n            metaDescription\n            ogTitle\n            ogDescription\n          }\n          contentBlockAssignments @include(if: $withLinkPageContentBlockAssignments) {\n            id\n            type\n          }\n        }\n        travel @include(if: $withLinkTravel) {\n          id\n          name\n          isBestseller\n          startDate\n          endDate\n          availabilityStatus @include(if: $withLinkTravelAvailabilityStatus) {\n            id\n            label\n            status\n            isDefaultStatus\n            isDefaultWaitlistFallback\n          }\n          executionStatus\n          travelConsultant @include(if: $withLinkTravelTravelConsultant) {\n            id\n            firstName\n            lastName\n            jobTitle\n            description\n            email\n            phone\n          }\n          label @include(if: $withLinkTravelLabel) {\n            id\n            label\n          }\n          title\n          description\n          includedServices\n          excludedServices\n          pricingTable\n          priceCalculationInfo\n          seoSettings @include(if: $withLinkTravelSeoSettings) {\n            id\n            urlSlug\n            metaTitle\n            metaDescription\n            ogTitle\n            ogDescription\n          }\n          tenantSettings @include(if: $withLinkTravelTenantSettings) {\n            id\n            onlineStatus\n            redirectToBooking\n            useTiming\n            startDate\n            endDate\n          }\n          highlights @include(if: $withLinkTravelHighlights) {\n            id\n            text\n          }\n          partners @include(if: $withLinkTravelPartners) {\n            id\n            name\n            url\n            logoWidth\n          }\n          travelGuides @include(if: $withLinkTravelTravelGuides) {\n            id\n            firstName\n            lastName\n            description\n          }\n          teams @include(if: $withLinkTravelTeams) {\n            id\n            name\n          }\n          accommodationAssignments @include(if: $withLinkTravelAccommodationAssignments) {\n            id\n            useCustomRoomTypeSelection\n          }\n          accommodations @include(if: $withLinkTravelAccommodations) {\n            id\n            label\n            name\n            stars\n            description\n          }\n          destinations @include(if: $withLinkTravelDestinations) {\n            id\n            name\n            entryRequirements\n            medicalInformation\n            language\n            timeShift\n            climate\n            currency\n          }\n          testimonials @include(if: $withLinkTravelTestimonials) {\n            id\n          }\n          mainImage @include(if: $withLinkTravelMainImage) {\n            id\n            assetId\n            publicId\n            url\n            resourceType\n            format\n            width\n            height\n            caption\n            title\n            description\n          }\n          mainVideo @include(if: $withLinkTravelMainVideo) {\n            id\n            assetId\n            publicId\n            url\n            resourceType\n            format\n            width\n            height\n            caption\n            title\n            description\n          }\n          gallery @include(if: $withLinkTravelGallery) {\n            id\n          }\n          travelPdf @include(if: $withLinkTravelTravelPdf) {\n            id\n            assetId\n            publicId\n            url\n            resourceType\n            format\n            width\n            height\n            caption\n            title\n            description\n          }\n          travelExtensions @include(if: $withLinkTravelTravelExtensions) {\n            id\n            duration\n            name\n            description\n          }\n          programType\n          itinerary @include(if: $withLinkTravelItinerary) {\n            id\n          }\n          programText\n          pricing @include(if: $withLinkTravelPricing) {\n            id\n            isTravelDocumentationAvailable\n          }\n          minPrice\n          minPriceManualOverride\n          currency\n        }\n      }\n    }\n  }";
// language=GraphQL
var UPDATE_TEXT_WITH_IMAGE_BLOCK_MUTATION = "\n  mutation Mutation($input: UpdateCmsTextWithImageBlockInput, $withImage: Boolean = false, $withGallery: Boolean = false, $withGalleryImages: Boolean = false, $withLink: Boolean = false, $withLinkPage: Boolean = false, $withLinkPageSeoSettings: Boolean = false, $withLinkPageContentBlockAssignments: Boolean = false, $withLinkTravel: Boolean = false, $withLinkTravelAvailabilityStatus: Boolean = false, $withLinkTravelTravelConsultant: Boolean = false, $withLinkTravelLabel: Boolean = false, $withLinkTravelSeoSettings: Boolean = false, $withLinkTravelTenantSettings: Boolean = false, $withLinkTravelHighlights: Boolean = false, $withLinkTravelPartners: Boolean = false, $withLinkTravelTravelGuides: Boolean = false, $withLinkTravelTeams: Boolean = false, $withLinkTravelAccommodationAssignments: Boolean = false, $withLinkTravelAccommodations: Boolean = false, $withLinkTravelDestinations: Boolean = false, $withLinkTravelTestimonials: Boolean = false, $withLinkTravelMainImage: Boolean = false, $withLinkTravelMainVideo: Boolean = false, $withLinkTravelGallery: Boolean = false, $withLinkTravelTravelPdf: Boolean = false, $withLinkTravelTravelExtensions: Boolean = false, $withLinkTravelItinerary: Boolean = false, $withLinkTravelPricing: Boolean = false) {\n    textWithImageBlock: updateCmsTextWithImageBlock(input: $input) {\n      id\n      title\n      subtitle\n      text\n      imagePosition\n      image @include(if: $withImage) {\n        id\n        assetId\n        publicId\n        url\n        resourceType\n        format\n        width\n        height\n        caption\n        title\n        description\n      }\n      imageFixedAspectRatio\n      gallery @include(if: $withGallery) {\n        id\n        images @include(if: $withGalleryImages) {\n          id\n          assetId\n          publicId\n          url\n          resourceType\n          format\n          width\n          height\n          caption\n          title\n          description\n        }\n      }\n      link @include(if: $withLink) {\n        id\n        label\n        targetBlank\n        type\n        url\n        page @include(if: $withLinkPage) {\n          id\n          name\n          onlineStatus\n          seoSettings @include(if: $withLinkPageSeoSettings) {\n            id\n            urlSlug\n            metaTitle\n            metaDescription\n            ogTitle\n            ogDescription\n          }\n          contentBlockAssignments @include(if: $withLinkPageContentBlockAssignments) {\n            id\n            type\n          }\n        }\n        travel @include(if: $withLinkTravel) {\n          id\n          name\n          isBestseller\n          startDate\n          endDate\n          availabilityStatus @include(if: $withLinkTravelAvailabilityStatus) {\n            id\n            label\n            status\n            isDefaultStatus\n            isDefaultWaitlistFallback\n          }\n          executionStatus\n          travelConsultant @include(if: $withLinkTravelTravelConsultant) {\n            id\n            firstName\n            lastName\n            jobTitle\n            description\n            email\n            phone\n          }\n          label @include(if: $withLinkTravelLabel) {\n            id\n            label\n          }\n          title\n          description\n          includedServices\n          excludedServices\n          pricingTable\n          priceCalculationInfo\n          seoSettings @include(if: $withLinkTravelSeoSettings) {\n            id\n            urlSlug\n            metaTitle\n            metaDescription\n            ogTitle\n            ogDescription\n          }\n          tenantSettings @include(if: $withLinkTravelTenantSettings) {\n            id\n            onlineStatus\n            redirectToBooking\n            useTiming\n            startDate\n            endDate\n          }\n          highlights @include(if: $withLinkTravelHighlights) {\n            id\n            text\n          }\n          partners @include(if: $withLinkTravelPartners) {\n            id\n            name\n            url\n            logoWidth\n          }\n          travelGuides @include(if: $withLinkTravelTravelGuides) {\n            id\n            firstName\n            lastName\n            description\n          }\n          teams @include(if: $withLinkTravelTeams) {\n            id\n            name\n          }\n          accommodationAssignments @include(if: $withLinkTravelAccommodationAssignments) {\n            id\n            useCustomRoomTypeSelection\n          }\n          accommodations @include(if: $withLinkTravelAccommodations) {\n            id\n            label\n            name\n            stars\n            description\n          }\n          destinations @include(if: $withLinkTravelDestinations) {\n            id\n            name\n            entryRequirements\n            medicalInformation\n            language\n            timeShift\n            climate\n            currency\n          }\n          testimonials @include(if: $withLinkTravelTestimonials) {\n            id\n          }\n          mainImage @include(if: $withLinkTravelMainImage) {\n            id\n            assetId\n            publicId\n            url\n            resourceType\n            format\n            width\n            height\n            caption\n            title\n            description\n          }\n          mainVideo @include(if: $withLinkTravelMainVideo) {\n            id\n            assetId\n            publicId\n            url\n            resourceType\n            format\n            width\n            height\n            caption\n            title\n            description\n          }\n          gallery @include(if: $withLinkTravelGallery) {\n            id\n          }\n          travelPdf @include(if: $withLinkTravelTravelPdf) {\n            id\n            assetId\n            publicId\n            url\n            resourceType\n            format\n            width\n            height\n            caption\n            title\n            description\n          }\n          travelExtensions @include(if: $withLinkTravelTravelExtensions) {\n            id\n            duration\n            name\n            description\n          }\n          programType\n          itinerary @include(if: $withLinkTravelItinerary) {\n            id\n          }\n          programText\n          pricing @include(if: $withLinkTravelPricing) {\n            id\n            isTravelDocumentationAvailable\n          }\n          minPrice\n          minPriceManualOverride\n          currency\n        }\n      }\n    }\n  }";
// language=GraphQL
var DELETE_TEXT_WITH_IMAGE_BLOCK_MUTATION = "\n  mutation Mutation($input: DeleteCmsTextWithImageBlockInput) {\n    deleteCmsTextWithImageBlock(input: $input) {\n      success\n    }\n  }";
// language=GraphQL
var FORCE_DELETE_TEXT_WITH_IMAGE_BLOCK_MUTATION = "\n  mutation Mutation($input: DeleteCmsTextWithImageBlockInput) {\n    forceDeleteCmsTextWithImageBlock(input: $input) {\n      success\n    }\n  }";
// language=GraphQL
var TEXT_WITH_IMAGE_BLOCKS_DEPENDENTS_QUERY = "query Query($id: ID!, $withCmsContentBlockAssignments: Boolean = false) {\n  groupedDependents: cmsTextWithImageBlockDependents(id: $id) {\n    cmsContentBlockAssignments @include(if: $withCmsContentBlockAssignments) {\n      id\n      type\n    }\n  }\n}";

// EXTERNAL MODULE: ./src/entities/mediaFile/entity.ts + 3 modules
var entity = __webpack_require__(24180);
// EXTERNAL MODULE: ./src/entities/imageGallery/entity.ts + 3 modules
var imageGallery_entity = __webpack_require__(41);
// EXTERNAL MODULE: ./src/entities/link/entity.ts + 3 modules
var link_entity = __webpack_require__(90576);
;// CONCATENATED MODULE: ./src/entities/cmsTextWithImageBlock/model.ts




var cmsTextWithImageBlockModel = {
    name: "textWithImageBlock",
    namePlural: "textWithImageBlocks",
    uniqueName: "cmsTextWithImageBlock",
    uniqueNamePlural: "cmsTextWithImageBlocks",
    path: "cms/blocks/text_with_image_block",
    baseUrl: "/cms/blocks/text_with_image_blocks",
    translationPrefix: "entities:cmsTextWithImageBlock.",
    getDisplayName: function(values) {
        return "Text with image block";
    },
    gql: {
        getAll: ALL_TEXT_WITH_IMAGE_BLOCKS_QUERY,
        getSingle: SINGLE_TEXT_WITH_IMAGE_BLOCK_QUERY,
        create: CREATE_TEXT_WITH_IMAGE_BLOCK_MUTATION,
        update: UPDATE_TEXT_WITH_IMAGE_BLOCK_MUTATION,
        delete: DELETE_TEXT_WITH_IMAGE_BLOCK_MUTATION,
        forceDelete: FORCE_DELETE_TEXT_WITH_IMAGE_BLOCK_MUTATION
    },
    attributes: {
        title: {
            name: "title",
            label: "entities:cmsTextWithImageBlock.attributes.title.label",
            type: "value",
            dataType: "string",
            defaultInput: true,
            inputType: "text",
            validationType: "string",
            validations: []
        },
        subtitle: {
            name: "subtitle",
            label: "entities:cmsTextWithImageBlock.attributes.subtitle.label",
            type: "value",
            dataType: "string",
            defaultInput: true,
            inputType: "text",
            validationType: "string",
            validations: []
        },
        text: {
            name: "text",
            label: "entities:cmsTextWithImageBlock.attributes.text.label",
            type: "value",
            dataType: "string",
            defaultInput: true,
            inputType: "wysiwyg",
            validationType: "string",
            validations: [
                {
                    type: "required"
                }, 
            ]
        },
        imagePosition: {
            name: "imagePosition",
            label: "entities:cmsTextWithImageBlock.attributes.imagePosition.label",
            type: "value",
            dataType: "string",
            defaultValue: "right",
            defaultInput: true,
            inputType: "select",
            selectOptions: [
                {
                    label: "entities:cmsTextWithImageBlock.attributes.imagePosition.selectOptions.left.label",
                    value: "left"
                },
                {
                    label: "entities:cmsTextWithImageBlock.attributes.imagePosition.selectOptions.right.label",
                    value: "right"
                }, 
            ],
            validationType: "string",
            validations: [
                {
                    type: "required"
                }, 
            ]
        },
        image: {
            name: "image",
            label: "entities:cmsTextWithImageBlock.attributes.image.label",
            type: "entityObject",
            dataType: "any",
            getEntity: function() {
                return entity/* default */.Z;
            },
            defaultInput: false,
            inputType: "select",
            validationType: "string",
            validations: []
        },
        imageFixedAspectRatio: {
            name: "imageFixedAspectRatio",
            label: "entities:cmsTextWithImageBlock.attributes.imageFixedAspectRatio.label",
            type: "value",
            dataType: "boolean",
            defaultInput: true,
            inputType: "switch",
            validationType: "string",
            validations: []
        },
        gallery: {
            name: "gallery",
            label: "entities:cmsTextWithImageBlock.attributes.gallery.label",
            type: "entityObject",
            dataType: "any",
            getEntity: function() {
                return imageGallery_entity/* default */.Z;
            },
            defaultInput: false,
            inputType: "select",
            validationType: "string",
            validations: []
        },
        link: {
            name: "link",
            label: "entities:cmsTextWithImageBlock.attributes.link.label",
            type: "entityObject",
            dataType: "any",
            getEntity: function() {
                return link_entity/* default */.Z;
            },
            defaultInput: false,
            inputType: "select",
            validationType: "string",
            validations: []
        }
    }
};
/* harmony default export */ var model = (cmsTextWithImageBlockModel);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(20414);
// EXTERNAL MODULE: ./src/entities/lib.ts
var lib = __webpack_require__(23480);
// EXTERNAL MODULE: ./src/lib/api/graphQLClient.ts
var graphQLClient = __webpack_require__(40112);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/swr/dist/index.mjs
var dist = __webpack_require__(8100);
// EXTERNAL MODULE: ./src/lib/helpers/helpers.ts
var helpers = __webpack_require__(15778);
;// CONCATENATED MODULE: ./src/entities/cmsTextWithImageBlock/repository.ts










var hydrateObjects = function(objects) {
    return objects.map(function(object) {
        return (0,lib/* hydrateEntityObject */.b)(model, object);
    });
};
var hydrateObject = function(object) {
    return (0,lib/* hydrateEntityObject */.b)(model, object);
};
var cmsTextWithImageBlockRepository = {
    getObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    id: id
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(SINGLE_TEXT_WITH_IMAGE_BLOCK_QUERY, variables).then(function(data) {
                        return hydrateObject(data.textWithImageBlock);
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }(),
    getObjects: /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        var includes;
        var _arguments = arguments;
        return (0,tslib_es6.__generator)(this, function(_state) {
            includes = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : {};
            return [
                2,
                graphQLClient/* default.request */.Z.request(ALL_TEXT_WITH_IMAGE_BLOCKS_QUERY, includes).then(function(data) {
                    return hydrateObjects(data.textWithImageBlocks);
                })
            ];
        });
    }),
    useObject: function(id) {
        var includes = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        // eslint-disable-next-line react-hooks/exhaustive-deps
        var variables = (0,react.useMemo)(function() {
            return (0,_object_spread/* default */.Z)({
                id: id
            }, includes);
        }, [
            id
        ]);
        var ref = (0,dist/* default */.ZP)([
            SINGLE_TEXT_WITH_IMAGE_BLOCK_QUERY,
            variables
        ], {
            revalidateOnFocus: false
        }), data = ref.data, error = ref.error, mutate = ref.mutate;
        return {
            object: !data ? data : hydrateObject(data.textWithImageBlock),
            isLoading: !error && !data,
            isError: error,
            mutate: mutate
        };
    },
    useObjects: function() {
        var includes = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        // eslint-disable-next-line react-hooks/exhaustive-deps
        var variables = (0,react.useMemo)(function() {
            return includes;
        }, []);
        var ref = (0,dist/* default */.ZP)([
            ALL_TEXT_WITH_IMAGE_BLOCKS_QUERY,
            variables
        ]), data = ref.data, error = ref.error, mutate = ref.mutate;
        return {
            objects: !data ? data : hydrateObjects(data.textWithImageBlocks),
            isLoading: !error && !data,
            isError: error,
            mutate: mutate
        };
    },
    getDependents: function(id, includes) {
        var includeVars = {};
        includes.forEach(function(include) {
            includeVars["with".concat((0,helpers/* uppercaseFirst */.AB)(include))] = true;
        });
        var variables = (0,_object_spread/* default */.Z)({
            id: id
        }, includeVars);
        return graphQLClient/* default.request */.Z.request(TEXT_WITH_IMAGE_BLOCKS_DEPENDENTS_QUERY, variables).then(function(data) {
            return data.groupedDependents;
        });
    },
    useDependents: function(id, includes) {
        var includeVars = {};
        includes.forEach(function(include) {
            includeVars["with".concat((0,helpers/* uppercaseFirst */.AB)(include))] = true;
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
        var variables = (0,react.useMemo)(function() {
            return (0,_object_spread/* default */.Z)({
                id: id
            }, includeVars);
        }, [
            id
        ]);
        var ref = (0,dist/* default */.ZP)([
            TEXT_WITH_IMAGE_BLOCKS_DEPENDENTS_QUERY,
            variables
        ], {
            revalidateOnFocus: false
        }), data = ref.data, error = ref.error, mutate = ref.mutate;
        return {
            data: !data ? data : data.groupedDependents,
            isLoading: !error && !data,
            isError: error,
            mutate: mutate
        };
    },
    createObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(data) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    input: data
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(CREATE_TEXT_WITH_IMAGE_BLOCK_MUTATION, variables).then(function(data) {
                        return hydrateObject(data.textWithImageBlock);
                    })
                ];
            });
        });
        return function(data) {
            return _ref.apply(this, arguments);
        };
    }(),
    updateObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(data) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    input: data
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(UPDATE_TEXT_WITH_IMAGE_BLOCK_MUTATION, variables).then(function(data) {
                        return hydrateObject(data.textWithImageBlock);
                    })
                ];
            });
        });
        return function(data) {
            return _ref.apply(this, arguments);
        };
    }(),
    deleteObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(DELETE_TEXT_WITH_IMAGE_BLOCK_MUTATION, variables).then(function(data) {
                        return data.deleteCmsTextWithImageBlock;
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }(),
    forceDeleteObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(FORCE_DELETE_TEXT_WITH_IMAGE_BLOCK_MUTATION, variables).then(function(data) {
                        return data.forceDeleteCmsTextWithImageBlock;
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }()
};
/* harmony default export */ var repository = (cmsTextWithImageBlockRepository);

;// CONCATENATED MODULE: ./src/entities/cmsTextWithImageBlock/entity.ts


var cmsTextWithImageBlockEntity = {
    model: model,
    repository: repository
};
/* harmony default export */ var cmsTextWithImageBlock_entity = (cmsTextWithImageBlockEntity);


/***/ }),

/***/ 26584:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ customBookingForm_entity; }
});

;// CONCATENATED MODULE: ./src/entities/customBookingForm/graphql.ts
// language=GraphQL
var ALL_FORMS_QUERY = "query Query($withFields: Boolean = false, $withFieldsOptions: Boolean = false, $withFieldsVisibilityConfig: Boolean = false, $withFieldsVisibilityConfigPricingTravels: Boolean = false) {\n  forms: allCustomBookingForm {\n    id\n    fields @include(if: $withFields) {\n      id\n      inputType\n      name\n      label\n      info\n      value\n      required\n      options @include(if: $withFieldsOptions) {\n        id\n        value\n        label\n      }\n      visibilityConfig @include(if: $withFieldsVisibilityConfig) {\n        id\n        pricingTravels @include(if: $withFieldsVisibilityConfigPricingTravels) {\n          id\n          catalogCode\n          travelCode\n          destination\n          name\n          transportType\n          transportTypeLabel\n          importDateTime\n          importStatus\n        }\n      }\n    }\n  }\n}";
// language=GraphQL
var SINGLE_FORM_QUERY = "query Query($id: ID!, $withFields: Boolean = false, $withFieldsOptions: Boolean = false, $withFieldsVisibilityConfig: Boolean = false, $withFieldsVisibilityConfigPricingTravels: Boolean = false) {\n  form: customBookingForm(id: $id) {\n    id\n    fields @include(if: $withFields) {\n      id\n      inputType\n      name\n      label\n      info\n      value\n      required\n      options @include(if: $withFieldsOptions) {\n        id\n        value\n        label\n      }\n      visibilityConfig @include(if: $withFieldsVisibilityConfig) {\n        id\n        pricingTravels @include(if: $withFieldsVisibilityConfigPricingTravels) {\n          id\n          catalogCode\n          travelCode\n          destination\n          name\n          transportType\n          transportTypeLabel\n          importDateTime\n          importStatus\n        }\n      }\n    }\n  }\n}";
// language=GraphQL
var CREATE_FORM_MUTATION = "\n  mutation Mutation($input: CreateCustomBookingFormInput, $withFields: Boolean = false, $withFieldsOptions: Boolean = false, $withFieldsVisibilityConfig: Boolean = false, $withFieldsVisibilityConfigPricingTravels: Boolean = false) {\n    form: createCustomBookingForm(input: $input) {\n      id\n      fields @include(if: $withFields) {\n        id\n        inputType\n        name\n        label\n        info\n        value\n        required\n        options @include(if: $withFieldsOptions) {\n          id\n          value\n          label\n        }\n        visibilityConfig @include(if: $withFieldsVisibilityConfig) {\n          id\n          pricingTravels @include(if: $withFieldsVisibilityConfigPricingTravels) {\n            id\n            catalogCode\n            travelCode\n            destination\n            name\n            transportType\n            transportTypeLabel\n            importDateTime\n            importStatus\n          }\n        }\n      }\n    }\n  }";
// language=GraphQL
var UPDATE_FORM_MUTATION = "\n  mutation Mutation($input: UpdateCustomBookingFormInput, $withFields: Boolean = false, $withFieldsOptions: Boolean = false, $withFieldsVisibilityConfig: Boolean = false, $withFieldsVisibilityConfigPricingTravels: Boolean = false) {\n    form: updateCustomBookingForm(input: $input) {\n      id\n      fields @include(if: $withFields) {\n        id\n        inputType\n        name\n        label\n        info\n        value\n        required\n        options @include(if: $withFieldsOptions) {\n          id\n          value\n          label\n        }\n        visibilityConfig @include(if: $withFieldsVisibilityConfig) {\n          id\n          pricingTravels @include(if: $withFieldsVisibilityConfigPricingTravels) {\n            id\n            catalogCode\n            travelCode\n            destination\n            name\n            transportType\n            transportTypeLabel\n            importDateTime\n            importStatus\n          }\n        }\n      }\n    }\n  }";
// language=GraphQL
var DELETE_FORM_MUTATION = "\n  mutation Mutation($input: DeleteCustomBookingFormInput) {\n    deleteCustomBookingForm(input: $input) {\n      success\n    }\n  }";
// language=GraphQL
var FORCE_DELETE_FORM_MUTATION = "\n  mutation Mutation($input: DeleteCustomBookingFormInput) {\n    forceDeleteCustomBookingForm(input: $input) {\n      success\n    }\n  }";
// language=GraphQL
var ADD_FORM_FIELDS_MUTATION = "\n  mutation Mutation($input: addCustomBookingFormFieldsInput) {\n    addCustomBookingFormFields(input: $input) {\n      id\n      fieldIds\n    }\n  }";
// language=GraphQL
var REMOVE_FORM_FIELDS_MUTATION = "\n  mutation Mutation($input: removeCustomBookingFormFieldsInput) {\n    removeCustomBookingFormFields(input: $input) {\n      id\n      fieldIds\n    }\n  }";
// language=GraphQL
var CREATE_FORM_FIELDS_MUTATION = "\n  mutation Mutation($input: createCustomBookingFormFieldsInput) {\n    createCustomBookingFormFields(input: $input) {\n      id\n      fieldIds\n    }\n  }";
// language=GraphQL
var DELETE_FORM_FIELDS_MUTATION = "\n  mutation Mutation($input: deleteCustomBookingFormFieldsInput) {\n    deleteCustomBookingFormFields(input: $input) {\n      id\n      fieldIds\n    }\n  }";
// language=GraphQL
var UPDATE_FORM_FIELDS_ORDER_MUTATION = "\n  mutation Mutation($input: updateCustomBookingFormFieldsOrderInput) {\n    updateCustomBookingFormFieldsOrder(input: $input) {\n      id\n      fieldIds\n    }\n  }";
// language=GraphQL
var FORMS_DEPENDENTS_QUERY = "query Query($id: ID!, $withTravelPricingCustomDataConfigs: Boolean = false) {\n  groupedDependents: customBookingFormDependents(id: $id) {\n    travelPricingCustomDataConfigs @include(if: $withTravelPricingCustomDataConfigs) {\n      id\n      useTravellerForm\n      useBookingForm\n    }\n  }\n}";

// EXTERNAL MODULE: ./src/entities/customBookingFormField/entity.ts + 3 modules
var entity = __webpack_require__(42195);
;// CONCATENATED MODULE: ./src/entities/customBookingForm/model.ts


var customBookingFormModel = {
    name: "form",
    namePlural: "forms",
    uniqueName: "customBookingForm",
    uniqueNamePlural: "customBookingForm",
    path: "travel/booking/custom_data/form",
    baseUrl: "/travel/booking/custom_data/forms",
    translationPrefix: "entities:customBookingForm.",
    getDisplayName: function(values) {
        return "CUSTOM BOOKING FORM";
    },
    gql: {
        getAll: ALL_FORMS_QUERY,
        getSingle: SINGLE_FORM_QUERY,
        create: CREATE_FORM_MUTATION,
        update: UPDATE_FORM_MUTATION,
        delete: DELETE_FORM_MUTATION,
        forceDelete: FORCE_DELETE_FORM_MUTATION
    },
    attributes: {
        fields: {
            name: "fields",
            label: "entities:customBookingForm.attributes.fields.label",
            type: "entityCollection",
            dataType: "[any]",
            getEntity: function() {
                return entity/* default */.Z;
            },
            defaultInput: false,
            inputType: "text",
            validationType: "string",
            validations: []
        }
    }
};
/* harmony default export */ var model = (customBookingFormModel);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(20414);
// EXTERNAL MODULE: ./src/entities/lib.ts
var lib = __webpack_require__(23480);
// EXTERNAL MODULE: ./src/lib/api/graphQLClient.ts
var graphQLClient = __webpack_require__(40112);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/swr/dist/index.mjs
var dist = __webpack_require__(8100);
// EXTERNAL MODULE: ./src/lib/helpers/helpers.ts
var helpers = __webpack_require__(15778);
;// CONCATENATED MODULE: ./src/entities/customBookingForm/repository.ts










var hydrateObjects = function(objects) {
    return objects.map(function(object) {
        return (0,lib/* hydrateEntityObject */.b)(model, object);
    });
};
var hydrateObject = function(object) {
    return (0,lib/* hydrateEntityObject */.b)(model, object);
};
var customBookingFormRepository = {
    getObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    id: id
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(SINGLE_FORM_QUERY, variables).then(function(data) {
                        return hydrateObject(data.form);
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }(),
    getObjects: /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        var includes;
        var _arguments = arguments;
        return (0,tslib_es6.__generator)(this, function(_state) {
            includes = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : {};
            return [
                2,
                graphQLClient/* default.request */.Z.request(ALL_FORMS_QUERY, includes).then(function(data) {
                    return hydrateObjects(data.forms);
                })
            ];
        });
    }),
    useObject: function(id) {
        var includes = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        // eslint-disable-next-line react-hooks/exhaustive-deps
        var variables = (0,react.useMemo)(function() {
            return (0,_object_spread/* default */.Z)({
                id: id
            }, includes);
        }, [
            id
        ]);
        var ref = (0,dist/* default */.ZP)([
            SINGLE_FORM_QUERY,
            variables
        ], {
            revalidateOnFocus: false
        }), data = ref.data, error = ref.error, mutate = ref.mutate;
        return {
            object: !data ? data : hydrateObject(data.form),
            isLoading: !error && !data,
            isError: error,
            mutate: mutate
        };
    },
    useObjects: function() {
        var includes = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        // eslint-disable-next-line react-hooks/exhaustive-deps
        var variables = (0,react.useMemo)(function() {
            return includes;
        }, []);
        var ref = (0,dist/* default */.ZP)([
            ALL_FORMS_QUERY,
            variables
        ]), data = ref.data, error = ref.error, mutate = ref.mutate;
        return {
            objects: !data ? data : hydrateObjects(data.forms),
            isLoading: !error && !data,
            isError: error,
            mutate: mutate
        };
    },
    getDependents: function(id, includes) {
        var includeVars = {};
        includes.forEach(function(include) {
            includeVars["with".concat((0,helpers/* uppercaseFirst */.AB)(include))] = true;
        });
        var variables = (0,_object_spread/* default */.Z)({
            id: id
        }, includeVars);
        return graphQLClient/* default.request */.Z.request(FORMS_DEPENDENTS_QUERY, variables).then(function(data) {
            return data.groupedDependents;
        });
    },
    useDependents: function(id, includes) {
        var includeVars = {};
        includes.forEach(function(include) {
            includeVars["with".concat((0,helpers/* uppercaseFirst */.AB)(include))] = true;
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
        var variables = (0,react.useMemo)(function() {
            return (0,_object_spread/* default */.Z)({
                id: id
            }, includeVars);
        }, [
            id
        ]);
        var ref = (0,dist/* default */.ZP)([
            FORMS_DEPENDENTS_QUERY,
            variables
        ], {
            revalidateOnFocus: false
        }), data = ref.data, error = ref.error, mutate = ref.mutate;
        return {
            data: !data ? data : data.groupedDependents,
            isLoading: !error && !data,
            isError: error,
            mutate: mutate
        };
    },
    createObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(data) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    input: data
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(CREATE_FORM_MUTATION, variables).then(function(data) {
                        return hydrateObject(data.form);
                    })
                ];
            });
        });
        return function(data) {
            return _ref.apply(this, arguments);
        };
    }(),
    updateObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(data) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    input: data
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(UPDATE_FORM_MUTATION, variables).then(function(data) {
                        return hydrateObject(data.form);
                    })
                ];
            });
        });
        return function(data) {
            return _ref.apply(this, arguments);
        };
    }(),
    deleteObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(DELETE_FORM_MUTATION, variables).then(function(data) {
                        return data.deleteCustomBookingForm;
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }(),
    forceDeleteObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(FORCE_DELETE_FORM_MUTATION, variables).then(function(data) {
                        return data.forceDeleteCustomBookingForm;
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }(),
    assignFields: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, itemIds) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        fieldIds: itemIds
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(ADD_FORM_FIELDS_MUTATION, variables)
                ];
            });
        });
        return function(id, itemIds) {
            return _ref.apply(this, arguments);
        };
    }(),
    unassignFields: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, itemIds) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        fieldIds: itemIds
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(REMOVE_FORM_FIELDS_MUTATION, variables)
                ];
            });
        });
        return function(id, itemIds) {
            return _ref.apply(this, arguments);
        };
    }(),
    createFields: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, items) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        fields: items
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(CREATE_FORM_FIELDS_MUTATION, variables)
                ];
            });
        });
        return function(id, items) {
            return _ref.apply(this, arguments);
        };
    }(),
    deleteFields: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, itemIds) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        fieldIds: itemIds
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(DELETE_FORM_FIELDS_MUTATION, variables)
                ];
            });
        });
        return function(id, itemIds) {
            return _ref.apply(this, arguments);
        };
    }(),
    updateFieldsOrder: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, itemIds) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        fieldIds: itemIds
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(UPDATE_FORM_FIELDS_ORDER_MUTATION, variables)
                ];
            });
        });
        return function(id, itemIds) {
            return _ref.apply(this, arguments);
        };
    }()
};
/* harmony default export */ var repository = (customBookingFormRepository);

;// CONCATENATED MODULE: ./src/entities/customBookingForm/entity.ts


var customBookingFormEntity = {
    model: model,
    repository: repository
};
/* harmony default export */ var customBookingForm_entity = (customBookingFormEntity);


/***/ }),

/***/ 42195:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ customBookingFormField_entity; }
});

;// CONCATENATED MODULE: ./src/entities/customBookingFormField/graphql.ts
// language=GraphQL
var ALL_FIELDS_QUERY = "query Query($withOptions: Boolean = false, $withVisibilityConfig: Boolean = false, $withVisibilityConfigPricingTravels: Boolean = false, $withVisibilityConfigPricingTravelsRatioCatalogBundle: Boolean = false, $withVisibilityConfigPricingTravelsDates: Boolean = false, $withVisibilityConfigPricingTravelsAccommodations: Boolean = false, $withVisibilityConfigPricingTravelsExtensionAccommodations: Boolean = false, $withVisibilityConfigPricingTravelsFamilyPackages: Boolean = false, $withVisibilityConfigPricingTravelsPersonalAddons: Boolean = false, $withVisibilityConfigPricingTravelsAccommodationAddons: Boolean = false, $withVisibilityConfigPricingTravelsBookingAddons: Boolean = false, $withVisibilityConfigPricingTravelsCollectiveAddons: Boolean = false, $withVisibilityConfigPricingTravelsExtensions: Boolean = false, $withVisibilityConfigPricingTravelsPersonalDiscounts: Boolean = false) {\n  fields: customBookingFormFields {\n    id\n    inputType\n    name\n    label\n    info\n    value\n    required\n    options @include(if: $withOptions) {\n      id\n      value\n      label\n    }\n    visibilityConfig @include(if: $withVisibilityConfig) {\n      id\n      pricingTravels @include(if: $withVisibilityConfigPricingTravels) {\n        id\n        ratioCatalogBundle @include(if: $withVisibilityConfigPricingTravelsRatioCatalogBundle) {\n          id\n          catalogCode\n          travelCode\n          json\n        }\n        catalogCode\n        travelCode\n        destination\n        name\n        transportType\n        transportTypeLabel\n        dates @include(if: $withVisibilityConfigPricingTravelsDates) {\n          id\n          dateNo\n          startDate\n          endDate\n          includesExtension\n          json\n        }\n        accommodations @include(if: $withVisibilityConfigPricingTravelsAccommodations) {\n          id\n          ratioPackageNo\n          name\n          label\n          info\n          isFamilyPackageAccommodation\n          isBabyPackage\n        }\n        extensionAccommodations @include(if: $withVisibilityConfigPricingTravelsExtensionAccommodations) {\n          id\n          ratioPackageNo\n          name\n          label\n          info\n          extensionAccommodationServiceNo\n        }\n        familyPackages @include(if: $withVisibilityConfigPricingTravelsFamilyPackages) {\n          id\n          ratioServiceNo\n          name\n          label\n          info\n        }\n        personalAddons @include(if: $withVisibilityConfigPricingTravelsPersonalAddons) {\n          id\n          ratioServiceNo\n          name\n          label\n          info\n        }\n        accommodationAddons @include(if: $withVisibilityConfigPricingTravelsAccommodationAddons) {\n          id\n          ratioServiceNo\n          name\n          label\n          info\n        }\n        bookingAddons @include(if: $withVisibilityConfigPricingTravelsBookingAddons) {\n          id\n          ratioServiceNo\n          name\n          label\n          info\n        }\n        collectiveAddons @include(if: $withVisibilityConfigPricingTravelsCollectiveAddons) {\n          id\n          label\n          info\n        }\n        extensions @include(if: $withVisibilityConfigPricingTravelsExtensions) {\n          id\n          label\n          info\n        }\n        personalDiscounts @include(if: $withVisibilityConfigPricingTravelsPersonalDiscounts) {\n          id\n          ratioServiceNo\n          name\n          label\n          info\n        }\n        importDateTime\n        importStatus\n      }\n    }\n  }\n}";
// language=GraphQL
var SINGLE_FIELD_QUERY = "query Query($id: ID!, $withOptions: Boolean = false, $withVisibilityConfig: Boolean = false, $withVisibilityConfigPricingTravels: Boolean = false, $withVisibilityConfigPricingTravelsRatioCatalogBundle: Boolean = false, $withVisibilityConfigPricingTravelsDates: Boolean = false, $withVisibilityConfigPricingTravelsAccommodations: Boolean = false, $withVisibilityConfigPricingTravelsExtensionAccommodations: Boolean = false, $withVisibilityConfigPricingTravelsFamilyPackages: Boolean = false, $withVisibilityConfigPricingTravelsPersonalAddons: Boolean = false, $withVisibilityConfigPricingTravelsAccommodationAddons: Boolean = false, $withVisibilityConfigPricingTravelsBookingAddons: Boolean = false, $withVisibilityConfigPricingTravelsCollectiveAddons: Boolean = false, $withVisibilityConfigPricingTravelsExtensions: Boolean = false, $withVisibilityConfigPricingTravelsPersonalDiscounts: Boolean = false) {\n  field: customBookingFormField(id: $id) {\n    id\n    inputType\n    name\n    label\n    info\n    value\n    required\n    options @include(if: $withOptions) {\n      id\n      value\n      label\n    }\n    visibilityConfig @include(if: $withVisibilityConfig) {\n      id\n      pricingTravels @include(if: $withVisibilityConfigPricingTravels) {\n        id\n        ratioCatalogBundle @include(if: $withVisibilityConfigPricingTravelsRatioCatalogBundle) {\n          id\n          catalogCode\n          travelCode\n          json\n        }\n        catalogCode\n        travelCode\n        destination\n        name\n        transportType\n        transportTypeLabel\n        dates @include(if: $withVisibilityConfigPricingTravelsDates) {\n          id\n          dateNo\n          startDate\n          endDate\n          includesExtension\n          json\n        }\n        accommodations @include(if: $withVisibilityConfigPricingTravelsAccommodations) {\n          id\n          ratioPackageNo\n          name\n          label\n          info\n          isFamilyPackageAccommodation\n          isBabyPackage\n        }\n        extensionAccommodations @include(if: $withVisibilityConfigPricingTravelsExtensionAccommodations) {\n          id\n          ratioPackageNo\n          name\n          label\n          info\n          extensionAccommodationServiceNo\n        }\n        familyPackages @include(if: $withVisibilityConfigPricingTravelsFamilyPackages) {\n          id\n          ratioServiceNo\n          name\n          label\n          info\n        }\n        personalAddons @include(if: $withVisibilityConfigPricingTravelsPersonalAddons) {\n          id\n          ratioServiceNo\n          name\n          label\n          info\n        }\n        accommodationAddons @include(if: $withVisibilityConfigPricingTravelsAccommodationAddons) {\n          id\n          ratioServiceNo\n          name\n          label\n          info\n        }\n        bookingAddons @include(if: $withVisibilityConfigPricingTravelsBookingAddons) {\n          id\n          ratioServiceNo\n          name\n          label\n          info\n        }\n        collectiveAddons @include(if: $withVisibilityConfigPricingTravelsCollectiveAddons) {\n          id\n          label\n          info\n        }\n        extensions @include(if: $withVisibilityConfigPricingTravelsExtensions) {\n          id\n          label\n          info\n        }\n        personalDiscounts @include(if: $withVisibilityConfigPricingTravelsPersonalDiscounts) {\n          id\n          ratioServiceNo\n          name\n          label\n          info\n        }\n        importDateTime\n        importStatus\n      }\n    }\n  }\n}";
// language=GraphQL
var CREATE_FIELD_MUTATION = "\n  mutation Mutation($input: CreateCustomBookingFormFieldInput, $withOptions: Boolean = false, $withVisibilityConfig: Boolean = false, $withVisibilityConfigPricingTravels: Boolean = false, $withVisibilityConfigPricingTravelsRatioCatalogBundle: Boolean = false, $withVisibilityConfigPricingTravelsDates: Boolean = false, $withVisibilityConfigPricingTravelsAccommodations: Boolean = false, $withVisibilityConfigPricingTravelsExtensionAccommodations: Boolean = false, $withVisibilityConfigPricingTravelsFamilyPackages: Boolean = false, $withVisibilityConfigPricingTravelsPersonalAddons: Boolean = false, $withVisibilityConfigPricingTravelsAccommodationAddons: Boolean = false, $withVisibilityConfigPricingTravelsBookingAddons: Boolean = false, $withVisibilityConfigPricingTravelsCollectiveAddons: Boolean = false, $withVisibilityConfigPricingTravelsExtensions: Boolean = false, $withVisibilityConfigPricingTravelsPersonalDiscounts: Boolean = false) {\n    field: createCustomBookingFormField(input: $input) {\n      id\n      inputType\n      name\n      label\n      info\n      value\n      required\n      options @include(if: $withOptions) {\n        id\n        value\n        label\n      }\n      visibilityConfig @include(if: $withVisibilityConfig) {\n        id\n        pricingTravels @include(if: $withVisibilityConfigPricingTravels) {\n          id\n          ratioCatalogBundle @include(if: $withVisibilityConfigPricingTravelsRatioCatalogBundle) {\n            id\n            catalogCode\n            travelCode\n            json\n          }\n          catalogCode\n          travelCode\n          destination\n          name\n          transportType\n          transportTypeLabel\n          dates @include(if: $withVisibilityConfigPricingTravelsDates) {\n            id\n            dateNo\n            startDate\n            endDate\n            includesExtension\n            json\n          }\n          accommodations @include(if: $withVisibilityConfigPricingTravelsAccommodations) {\n            id\n            ratioPackageNo\n            name\n            label\n            info\n            isFamilyPackageAccommodation\n            isBabyPackage\n          }\n          extensionAccommodations @include(if: $withVisibilityConfigPricingTravelsExtensionAccommodations) {\n            id\n            ratioPackageNo\n            name\n            label\n            info\n            extensionAccommodationServiceNo\n          }\n          familyPackages @include(if: $withVisibilityConfigPricingTravelsFamilyPackages) {\n            id\n            ratioServiceNo\n            name\n            label\n            info\n          }\n          personalAddons @include(if: $withVisibilityConfigPricingTravelsPersonalAddons) {\n            id\n            ratioServiceNo\n            name\n            label\n            info\n          }\n          accommodationAddons @include(if: $withVisibilityConfigPricingTravelsAccommodationAddons) {\n            id\n            ratioServiceNo\n            name\n            label\n            info\n          }\n          bookingAddons @include(if: $withVisibilityConfigPricingTravelsBookingAddons) {\n            id\n            ratioServiceNo\n            name\n            label\n            info\n          }\n          collectiveAddons @include(if: $withVisibilityConfigPricingTravelsCollectiveAddons) {\n            id\n            label\n            info\n          }\n          extensions @include(if: $withVisibilityConfigPricingTravelsExtensions) {\n            id\n            label\n            info\n          }\n          personalDiscounts @include(if: $withVisibilityConfigPricingTravelsPersonalDiscounts) {\n            id\n            ratioServiceNo\n            name\n            label\n            info\n          }\n          importDateTime\n          importStatus\n        }\n      }\n    }\n  }";
// language=GraphQL
var UPDATE_FIELD_MUTATION = "\n  mutation Mutation($input: UpdateCustomBookingFormFieldInput, $withOptions: Boolean = false, $withVisibilityConfig: Boolean = false, $withVisibilityConfigPricingTravels: Boolean = false, $withVisibilityConfigPricingTravelsRatioCatalogBundle: Boolean = false, $withVisibilityConfigPricingTravelsDates: Boolean = false, $withVisibilityConfigPricingTravelsAccommodations: Boolean = false, $withVisibilityConfigPricingTravelsExtensionAccommodations: Boolean = false, $withVisibilityConfigPricingTravelsFamilyPackages: Boolean = false, $withVisibilityConfigPricingTravelsPersonalAddons: Boolean = false, $withVisibilityConfigPricingTravelsAccommodationAddons: Boolean = false, $withVisibilityConfigPricingTravelsBookingAddons: Boolean = false, $withVisibilityConfigPricingTravelsCollectiveAddons: Boolean = false, $withVisibilityConfigPricingTravelsExtensions: Boolean = false, $withVisibilityConfigPricingTravelsPersonalDiscounts: Boolean = false) {\n    field: updateCustomBookingFormField(input: $input) {\n      id\n      inputType\n      name\n      label\n      info\n      value\n      required\n      options @include(if: $withOptions) {\n        id\n        value\n        label\n      }\n      visibilityConfig @include(if: $withVisibilityConfig) {\n        id\n        pricingTravels @include(if: $withVisibilityConfigPricingTravels) {\n          id\n          ratioCatalogBundle @include(if: $withVisibilityConfigPricingTravelsRatioCatalogBundle) {\n            id\n            catalogCode\n            travelCode\n            json\n          }\n          catalogCode\n          travelCode\n          destination\n          name\n          transportType\n          transportTypeLabel\n          dates @include(if: $withVisibilityConfigPricingTravelsDates) {\n            id\n            dateNo\n            startDate\n            endDate\n            includesExtension\n            json\n          }\n          accommodations @include(if: $withVisibilityConfigPricingTravelsAccommodations) {\n            id\n            ratioPackageNo\n            name\n            label\n            info\n            isFamilyPackageAccommodation\n            isBabyPackage\n          }\n          extensionAccommodations @include(if: $withVisibilityConfigPricingTravelsExtensionAccommodations) {\n            id\n            ratioPackageNo\n            name\n            label\n            info\n            extensionAccommodationServiceNo\n          }\n          familyPackages @include(if: $withVisibilityConfigPricingTravelsFamilyPackages) {\n            id\n            ratioServiceNo\n            name\n            label\n            info\n          }\n          personalAddons @include(if: $withVisibilityConfigPricingTravelsPersonalAddons) {\n            id\n            ratioServiceNo\n            name\n            label\n            info\n          }\n          accommodationAddons @include(if: $withVisibilityConfigPricingTravelsAccommodationAddons) {\n            id\n            ratioServiceNo\n            name\n            label\n            info\n          }\n          bookingAddons @include(if: $withVisibilityConfigPricingTravelsBookingAddons) {\n            id\n            ratioServiceNo\n            name\n            label\n            info\n          }\n          collectiveAddons @include(if: $withVisibilityConfigPricingTravelsCollectiveAddons) {\n            id\n            label\n            info\n          }\n          extensions @include(if: $withVisibilityConfigPricingTravelsExtensions) {\n            id\n            label\n            info\n          }\n          personalDiscounts @include(if: $withVisibilityConfigPricingTravelsPersonalDiscounts) {\n            id\n            ratioServiceNo\n            name\n            label\n            info\n          }\n          importDateTime\n          importStatus\n        }\n      }\n    }\n  }";
// language=GraphQL
var DELETE_FIELD_MUTATION = "\n  mutation Mutation($input: DeleteCustomBookingFormFieldInput) {\n    deleteCustomBookingFormField(input: $input) {\n      success\n    }\n  }";
// language=GraphQL
var FORCE_DELETE_FIELD_MUTATION = "\n  mutation Mutation($input: DeleteCustomBookingFormFieldInput) {\n    forceDeleteCustomBookingFormField(input: $input) {\n      success\n    }\n  }";
// language=GraphQL
var ADD_FIELD_OPTIONS_MUTATION = "\n  mutation Mutation($input: addCustomBookingFormFieldOptionsInput) {\n    addCustomBookingFormFieldOptions(input: $input) {\n      id\n      optionIds\n    }\n  }";
// language=GraphQL
var REMOVE_FIELD_OPTIONS_MUTATION = "\n  mutation Mutation($input: removeCustomBookingFormFieldOptionsInput) {\n    removeCustomBookingFormFieldOptions(input: $input) {\n      id\n      optionIds\n    }\n  }";
// language=GraphQL
var CREATE_FIELD_OPTIONS_MUTATION = "\n  mutation Mutation($input: createCustomBookingFormFieldOptionsInput) {\n    createCustomBookingFormFieldOptions(input: $input) {\n      id\n      optionIds\n    }\n  }";
// language=GraphQL
var DELETE_FIELD_OPTIONS_MUTATION = "\n  mutation Mutation($input: deleteCustomBookingFormFieldOptionsInput) {\n    deleteCustomBookingFormFieldOptions(input: $input) {\n      id\n      optionIds\n    }\n  }";
// language=GraphQL
var UPDATE_FIELD_OPTIONS_ORDER_MUTATION = "\n  mutation Mutation($input: updateCustomBookingFormFieldOptionsOrderInput) {\n    updateCustomBookingFormFieldOptionsOrder(input: $input) {\n      id\n      optionIds\n    }\n  }";
// language=GraphQL
var FIELDS_DEPENDENTS_QUERY = "query Query($id: ID!, $withCustomBookingForm: Boolean = false) {\n  groupedDependents: customBookingFormFieldDependents(id: $id) {\n    customBookingForm @include(if: $withCustomBookingForm) {\n      id\n    }\n  }\n}";

// EXTERNAL MODULE: ./src/entities/customBookingFormFieldOption/entity.ts + 3 modules
var entity = __webpack_require__(55150);
// EXTERNAL MODULE: ./src/entities/customBookingFormFieldVisibilityConfig/entity.ts + 3 modules
var customBookingFormFieldVisibilityConfig_entity = __webpack_require__(73734);
;// CONCATENATED MODULE: ./src/entities/customBookingFormField/model.ts



var customBookingFormFieldModel = {
    name: "field",
    namePlural: "fields",
    uniqueName: "customBookingFormField",
    uniqueNamePlural: "customBookingFormFields",
    path: "travel/booking/custom_data/field",
    baseUrl: "/travel/booking/custom_data/fields",
    translationPrefix: "entities:customBookingFormField.",
    getDisplayName: function(values) {
        return values.name;
    },
    gql: {
        getAll: ALL_FIELDS_QUERY,
        getSingle: SINGLE_FIELD_QUERY,
        create: CREATE_FIELD_MUTATION,
        update: UPDATE_FIELD_MUTATION,
        delete: DELETE_FIELD_MUTATION,
        forceDelete: FORCE_DELETE_FIELD_MUTATION
    },
    attributes: {
        inputType: {
            name: "inputType",
            label: "entities:customBookingFormField.attributes.inputType.label",
            type: "value",
            dataType: "string",
            defaultValue: "TEXT",
            defaultInput: true,
            inputType: "select",
            selectOptions: [
                {
                    label: "entities:customBookingFormField.attributes.inputType.selectOptions.TEXT.label",
                    value: "TEXT"
                },
                {
                    label: "entities:customBookingFormField.attributes.inputType.selectOptions.TEXTAREA.label",
                    value: "TEXTAREA"
                },
                {
                    label: "entities:customBookingFormField.attributes.inputType.selectOptions.SWITCH.label",
                    value: "SWITCH"
                },
                {
                    label: "entities:customBookingFormField.attributes.inputType.selectOptions.CHECKBOX.label",
                    value: "CHECKBOX"
                },
                {
                    label: "entities:customBookingFormField.attributes.inputType.selectOptions.RADIO.label",
                    value: "RADIO"
                },
                {
                    label: "entities:customBookingFormField.attributes.inputType.selectOptions.SELECT.label",
                    value: "SELECT"
                }, 
            ],
            validationType: "string",
            validations: [
                {
                    type: "required"
                }, 
            ]
        },
        name: {
            name: "name",
            label: "entities:customBookingFormField.attributes.name.label",
            type: "value",
            dataType: "string",
            defaultInput: true,
            inputType: "text",
            validationType: "string",
            validations: [
                {
                    type: "required"
                }, 
            ]
        },
        label: {
            name: "label",
            label: "entities:customBookingFormField.attributes.label.label",
            type: "value",
            dataType: "string",
            defaultInput: true,
            inputType: "text",
            validationType: "string",
            validations: [
                {
                    type: "required"
                }, 
            ]
        },
        info: {
            name: "info",
            label: "entities:customBookingFormField.attributes.info.label",
            type: "value",
            dataType: "string",
            defaultInput: false,
            inputType: "textarea",
            validationType: "string",
            validations: []
        },
        value: {
            name: "value",
            label: "entities:customBookingFormField.attributes.value.label",
            type: "value",
            dataType: "string",
            defaultInput: true,
            inputType: "text",
            validationType: "string",
            validations: []
        },
        required: {
            name: "required",
            label: "entities:customBookingFormField.attributes.required.label",
            type: "value",
            dataType: "boolean",
            defaultInput: true,
            inputType: "switch",
            validationType: "string",
            validations: []
        },
        options: {
            name: "options",
            label: "entities:customBookingFormField.attributes.options.label",
            type: "entityCollection",
            dataType: "[any]",
            getEntity: function() {
                return entity/* default */.Z;
            },
            defaultInput: false,
            inputType: "text",
            validationType: "string",
            validations: []
        },
        visibilityConfig: {
            name: "visibilityConfig",
            label: "entities:customBookingFormField.attributes.visibilityConfig.label",
            type: "entityObject",
            dataType: "any",
            getEntity: function() {
                return customBookingFormFieldVisibilityConfig_entity/* default */.Z;
            },
            defaultInput: false,
            inputType: "select",
            validationType: "string",
            validations: []
        }
    }
};
/* harmony default export */ var model = (customBookingFormFieldModel);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(20414);
// EXTERNAL MODULE: ./src/entities/lib.ts
var lib = __webpack_require__(23480);
// EXTERNAL MODULE: ./src/lib/api/graphQLClient.ts
var graphQLClient = __webpack_require__(40112);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/swr/dist/index.mjs
var dist = __webpack_require__(8100);
// EXTERNAL MODULE: ./src/lib/helpers/helpers.ts
var helpers = __webpack_require__(15778);
;// CONCATENATED MODULE: ./src/entities/customBookingFormField/repository.ts










var hydrateObjects = function(objects) {
    return objects.map(function(object) {
        return (0,lib/* hydrateEntityObject */.b)(model, object);
    });
};
var hydrateObject = function(object) {
    return (0,lib/* hydrateEntityObject */.b)(model, object);
};
var customBookingFormFieldRepository = {
    getObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    id: id
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(SINGLE_FIELD_QUERY, variables).then(function(data) {
                        return hydrateObject(data.field);
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }(),
    getObjects: /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        var includes;
        var _arguments = arguments;
        return (0,tslib_es6.__generator)(this, function(_state) {
            includes = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : {};
            return [
                2,
                graphQLClient/* default.request */.Z.request(ALL_FIELDS_QUERY, includes).then(function(data) {
                    return hydrateObjects(data.fields);
                })
            ];
        });
    }),
    useObject: function(id) {
        var includes = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        // eslint-disable-next-line react-hooks/exhaustive-deps
        var variables = (0,react.useMemo)(function() {
            return (0,_object_spread/* default */.Z)({
                id: id
            }, includes);
        }, [
            id
        ]);
        var ref = (0,dist/* default */.ZP)([
            SINGLE_FIELD_QUERY,
            variables
        ], {
            revalidateOnFocus: false
        }), data = ref.data, error = ref.error, mutate = ref.mutate;
        return {
            object: !data ? data : hydrateObject(data.field),
            isLoading: !error && !data,
            isError: error,
            mutate: mutate
        };
    },
    useObjects: function() {
        var includes = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        // eslint-disable-next-line react-hooks/exhaustive-deps
        var variables = (0,react.useMemo)(function() {
            return includes;
        }, []);
        var ref = (0,dist/* default */.ZP)([
            ALL_FIELDS_QUERY,
            variables
        ]), data = ref.data, error = ref.error, mutate = ref.mutate;
        return {
            objects: !data ? data : hydrateObjects(data.fields),
            isLoading: !error && !data,
            isError: error,
            mutate: mutate
        };
    },
    getDependents: function(id, includes) {
        var includeVars = {};
        includes.forEach(function(include) {
            includeVars["with".concat((0,helpers/* uppercaseFirst */.AB)(include))] = true;
        });
        var variables = (0,_object_spread/* default */.Z)({
            id: id
        }, includeVars);
        return graphQLClient/* default.request */.Z.request(FIELDS_DEPENDENTS_QUERY, variables).then(function(data) {
            return data.groupedDependents;
        });
    },
    useDependents: function(id, includes) {
        var includeVars = {};
        includes.forEach(function(include) {
            includeVars["with".concat((0,helpers/* uppercaseFirst */.AB)(include))] = true;
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
        var variables = (0,react.useMemo)(function() {
            return (0,_object_spread/* default */.Z)({
                id: id
            }, includeVars);
        }, [
            id
        ]);
        var ref = (0,dist/* default */.ZP)([
            FIELDS_DEPENDENTS_QUERY,
            variables
        ], {
            revalidateOnFocus: false
        }), data = ref.data, error = ref.error, mutate = ref.mutate;
        return {
            data: !data ? data : data.groupedDependents,
            isLoading: !error && !data,
            isError: error,
            mutate: mutate
        };
    },
    createObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(data) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    input: data
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(CREATE_FIELD_MUTATION, variables).then(function(data) {
                        return hydrateObject(data.field);
                    })
                ];
            });
        });
        return function(data) {
            return _ref.apply(this, arguments);
        };
    }(),
    updateObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(data) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    input: data
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(UPDATE_FIELD_MUTATION, variables).then(function(data) {
                        return hydrateObject(data.field);
                    })
                ];
            });
        });
        return function(data) {
            return _ref.apply(this, arguments);
        };
    }(),
    deleteObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(DELETE_FIELD_MUTATION, variables).then(function(data) {
                        return data.deleteCustomBookingFormField;
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }(),
    forceDeleteObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(FORCE_DELETE_FIELD_MUTATION, variables).then(function(data) {
                        return data.forceDeleteCustomBookingFormField;
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }(),
    assignOptions: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, itemIds) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        optionIds: itemIds
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(ADD_FIELD_OPTIONS_MUTATION, variables)
                ];
            });
        });
        return function(id, itemIds) {
            return _ref.apply(this, arguments);
        };
    }(),
    unassignOptions: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, itemIds) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        optionIds: itemIds
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(REMOVE_FIELD_OPTIONS_MUTATION, variables)
                ];
            });
        });
        return function(id, itemIds) {
            return _ref.apply(this, arguments);
        };
    }(),
    createOptions: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, items) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        options: items
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(CREATE_FIELD_OPTIONS_MUTATION, variables)
                ];
            });
        });
        return function(id, items) {
            return _ref.apply(this, arguments);
        };
    }(),
    deleteOptions: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, itemIds) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        optionIds: itemIds
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(DELETE_FIELD_OPTIONS_MUTATION, variables)
                ];
            });
        });
        return function(id, itemIds) {
            return _ref.apply(this, arguments);
        };
    }(),
    updateOptionsOrder: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, itemIds) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        optionIds: itemIds
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(UPDATE_FIELD_OPTIONS_ORDER_MUTATION, variables)
                ];
            });
        });
        return function(id, itemIds) {
            return _ref.apply(this, arguments);
        };
    }()
};
/* harmony default export */ var repository = (customBookingFormFieldRepository);

;// CONCATENATED MODULE: ./src/entities/customBookingFormField/entity.ts


var customBookingFormFieldEntity = {
    model: model,
    repository: repository
};
/* harmony default export */ var customBookingFormField_entity = (customBookingFormFieldEntity);


/***/ }),

/***/ 55150:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ entity; }
});

;// CONCATENATED MODULE: ./src/entities/customBookingFormFieldOption/graphql.ts
// language=GraphQL
var ALL_FIELD_OPTIONS_QUERY = "query Query {\n  fieldOptions: customBookingFormFieldOptions {\n    id\n    value\n    label\n  }\n}";
// language=GraphQL
var SINGLE_FIELD_OPTION_QUERY = "query Query($id: ID!) {\n  fieldOption: customBookingFormFieldOption(id: $id) {\n    id\n    value\n    label\n  }\n}";
// language=GraphQL
var CREATE_FIELD_OPTION_MUTATION = "\n  mutation Mutation($input: CreateCustomBookingFormFieldOptionInput) {\n    fieldOption: createCustomBookingFormFieldOption(input: $input) {\n      id\n      value\n      label\n    }\n  }";
// language=GraphQL
var UPDATE_FIELD_OPTION_MUTATION = "\n  mutation Mutation($input: UpdateCustomBookingFormFieldOptionInput) {\n    fieldOption: updateCustomBookingFormFieldOption(input: $input) {\n      id\n      value\n      label\n    }\n  }";
// language=GraphQL
var DELETE_FIELD_OPTION_MUTATION = "\n  mutation Mutation($input: DeleteCustomBookingFormFieldOptionInput) {\n    deleteCustomBookingFormFieldOption(input: $input) {\n      success\n    }\n  }";
// language=GraphQL
var FORCE_DELETE_FIELD_OPTION_MUTATION = "\n  mutation Mutation($input: DeleteCustomBookingFormFieldOptionInput) {\n    forceDeleteCustomBookingFormFieldOption(input: $input) {\n      success\n    }\n  }";
// language=GraphQL
var FIELD_OPTIONS_DEPENDENTS_QUERY = "query Query($id: ID!, $withCustomBookingFormFields: Boolean = false) {\n  groupedDependents: customBookingFormFieldOptionDependents(id: $id) {\n    customBookingFormFields @include(if: $withCustomBookingFormFields) {\n      id\n      inputType\n      name\n      label\n      info\n      value\n      required\n    }\n  }\n}";

;// CONCATENATED MODULE: ./src/entities/customBookingFormFieldOption/model.ts

var customBookingFormFieldOptionModel = {
    name: "fieldOption",
    namePlural: "fieldOptions",
    uniqueName: "customBookingFormFieldOption",
    uniqueNamePlural: "customBookingFormFieldOptions",
    path: "travel/booking/custom_data/field_option",
    baseUrl: "/travel/booking/custom_data/field_options",
    translationPrefix: "entities:customBookingFormFieldOption.",
    getDisplayName: function(values) {
        return values.label;
    },
    gql: {
        getAll: ALL_FIELD_OPTIONS_QUERY,
        getSingle: SINGLE_FIELD_OPTION_QUERY,
        create: CREATE_FIELD_OPTION_MUTATION,
        update: UPDATE_FIELD_OPTION_MUTATION,
        delete: DELETE_FIELD_OPTION_MUTATION,
        forceDelete: FORCE_DELETE_FIELD_OPTION_MUTATION
    },
    attributes: {
        value: {
            name: "value",
            label: "entities:customBookingFormFieldOption.attributes.value.label",
            type: "value",
            dataType: "string",
            defaultInput: true,
            inputType: "text",
            validationType: "string",
            validations: [
                {
                    type: "required"
                }, 
            ]
        },
        label: {
            name: "label",
            label: "entities:customBookingFormFieldOption.attributes.label.label",
            type: "value",
            dataType: "string",
            defaultInput: true,
            inputType: "text",
            validationType: "string",
            validations: [
                {
                    type: "required"
                }, 
            ]
        }
    }
};
/* harmony default export */ var model = (customBookingFormFieldOptionModel);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(20414);
// EXTERNAL MODULE: ./src/entities/lib.ts
var lib = __webpack_require__(23480);
// EXTERNAL MODULE: ./src/lib/api/graphQLClient.ts
var graphQLClient = __webpack_require__(40112);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/swr/dist/index.mjs
var dist = __webpack_require__(8100);
// EXTERNAL MODULE: ./src/lib/helpers/helpers.ts
var helpers = __webpack_require__(15778);
;// CONCATENATED MODULE: ./src/entities/customBookingFormFieldOption/repository.ts










var hydrateObjects = function(objects) {
    return objects.map(function(object) {
        return (0,lib/* hydrateEntityObject */.b)(model, object);
    });
};
var hydrateObject = function(object) {
    return (0,lib/* hydrateEntityObject */.b)(model, object);
};
var customBookingFormFieldOptionRepository = {
    getObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    id: id
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(SINGLE_FIELD_OPTION_QUERY, variables).then(function(data) {
                        return hydrateObject(data.fieldOption);
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }(),
    getObjects: /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        var includes;
        var _arguments = arguments;
        return (0,tslib_es6.__generator)(this, function(_state) {
            includes = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : {};
            return [
                2,
                graphQLClient/* default.request */.Z.request(ALL_FIELD_OPTIONS_QUERY, includes).then(function(data) {
                    return hydrateObjects(data.fieldOptions);
                })
            ];
        });
    }),
    useObject: function(id) {
        var includes = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        // eslint-disable-next-line react-hooks/exhaustive-deps
        var variables = (0,react.useMemo)(function() {
            return (0,_object_spread/* default */.Z)({
                id: id
            }, includes);
        }, [
            id
        ]);
        var ref = (0,dist/* default */.ZP)([
            SINGLE_FIELD_OPTION_QUERY,
            variables
        ], {
            revalidateOnFocus: false
        }), data = ref.data, error = ref.error, mutate = ref.mutate;
        return {
            object: !data ? data : hydrateObject(data.fieldOption),
            isLoading: !error && !data,
            isError: error,
            mutate: mutate
        };
    },
    useObjects: function() {
        var includes = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        // eslint-disable-next-line react-hooks/exhaustive-deps
        var variables = (0,react.useMemo)(function() {
            return includes;
        }, []);
        var ref = (0,dist/* default */.ZP)([
            ALL_FIELD_OPTIONS_QUERY,
            variables
        ]), data = ref.data, error = ref.error, mutate = ref.mutate;
        return {
            objects: !data ? data : hydrateObjects(data.fieldOptions),
            isLoading: !error && !data,
            isError: error,
            mutate: mutate
        };
    },
    getDependents: function(id, includes) {
        var includeVars = {};
        includes.forEach(function(include) {
            includeVars["with".concat((0,helpers/* uppercaseFirst */.AB)(include))] = true;
        });
        var variables = (0,_object_spread/* default */.Z)({
            id: id
        }, includeVars);
        return graphQLClient/* default.request */.Z.request(FIELD_OPTIONS_DEPENDENTS_QUERY, variables).then(function(data) {
            return data.groupedDependents;
        });
    },
    useDependents: function(id, includes) {
        var includeVars = {};
        includes.forEach(function(include) {
            includeVars["with".concat((0,helpers/* uppercaseFirst */.AB)(include))] = true;
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
        var variables = (0,react.useMemo)(function() {
            return (0,_object_spread/* default */.Z)({
                id: id
            }, includeVars);
        }, [
            id
        ]);
        var ref = (0,dist/* default */.ZP)([
            FIELD_OPTIONS_DEPENDENTS_QUERY,
            variables
        ], {
            revalidateOnFocus: false
        }), data = ref.data, error = ref.error, mutate = ref.mutate;
        return {
            data: !data ? data : data.groupedDependents,
            isLoading: !error && !data,
            isError: error,
            mutate: mutate
        };
    },
    createObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(data) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    input: data
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(CREATE_FIELD_OPTION_MUTATION, variables).then(function(data) {
                        return hydrateObject(data.fieldOption);
                    })
                ];
            });
        });
        return function(data) {
            return _ref.apply(this, arguments);
        };
    }(),
    updateObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(data) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    input: data
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(UPDATE_FIELD_OPTION_MUTATION, variables).then(function(data) {
                        return hydrateObject(data.fieldOption);
                    })
                ];
            });
        });
        return function(data) {
            return _ref.apply(this, arguments);
        };
    }(),
    deleteObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(DELETE_FIELD_OPTION_MUTATION, variables).then(function(data) {
                        return data.deleteCustomBookingFormFieldOption;
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }(),
    forceDeleteObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(FORCE_DELETE_FIELD_OPTION_MUTATION, variables).then(function(data) {
                        return data.forceDeleteCustomBookingFormFieldOption;
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }()
};
/* harmony default export */ var repository = (customBookingFormFieldOptionRepository);

;// CONCATENATED MODULE: ./src/entities/customBookingFormFieldOption/entity.ts


var customBookingFormFieldOptionEntity = {
    model: model,
    repository: repository
};
/* harmony default export */ var entity = (customBookingFormFieldOptionEntity);


/***/ }),

/***/ 73734:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ customBookingFormFieldVisibilityConfig_entity; }
});

;// CONCATENATED MODULE: ./src/entities/customBookingFormFieldVisibilityConfig/graphql.ts
// language=GraphQL
var ALL_FIELD_VISIBILITY_CONFIGS_QUERY = "query Query($withPricingTravels: Boolean = false, $withPricingTravelsRatioCatalogBundle: Boolean = false, $withPricingTravelsDates: Boolean = false, $withPricingTravelsDatesAvailabilityStatus: Boolean = false, $withPricingTravelsDatesExtensionBaseDate: Boolean = false, $withPricingTravelsDatesExtension: Boolean = false, $withPricingTravelsDatesPackageSettings: Boolean = false, $withPricingTravelsDatesExtensions: Boolean = false, $withPricingTravelsAccommodations: Boolean = false, $withPricingTravelsAccommodationsCapacitySettings: Boolean = false, $withPricingTravelsAccommodationsAddons: Boolean = false, $withPricingTravelsExtensionAccommodations: Boolean = false, $withPricingTravelsFamilyPackages: Boolean = false, $withPricingTravelsFamilyPackagesAccommodation: Boolean = false, $withPricingTravelsFamilyPackagesCapacitySettings: Boolean = false, $withPricingTravelsFamilyPackagesAddons: Boolean = false, $withPricingTravelsPersonalAddons: Boolean = false, $withPricingTravelsPersonalAddonsAllowedAgeGroups: Boolean = false, $withPricingTravelsPersonalAddonsCalculationSettings: Boolean = false, $withPricingTravelsPersonalAddonsMandatorySettings: Boolean = false, $withPricingTravelsAccommodationAddons: Boolean = false, $withPricingTravelsAccommodationAddonsCalculationSettings: Boolean = false, $withPricingTravelsAccommodationAddonsMandatorySettings: Boolean = false, $withPricingTravelsBookingAddons: Boolean = false, $withPricingTravelsBookingAddonsCalculationSettings: Boolean = false, $withPricingTravelsBookingAddonsMandatorySettings: Boolean = false, $withPricingTravelsCollectiveAddons: Boolean = false, $withPricingTravelsCollectiveAddonsAgeGroupServices: Boolean = false, $withPricingTravelsCollectiveAddonsCalculationSettings: Boolean = false, $withPricingTravelsCollectiveAddonsMandatorySettings: Boolean = false, $withPricingTravelsExtensions: Boolean = false, $withPricingTravelsExtensionsTravelExtension: Boolean = false, $withPricingTravelsExtensionsAccommodationMapItems: Boolean = false, $withPricingTravelsPersonalDiscounts: Boolean = false, $withPricingTravelsPersonalDiscountsMandatorySettings: Boolean = false) {\n  fieldVisibilityConfigs: customBookingFormFieldVisibilityConfigs {\n    id\n    pricingTravels @include(if: $withPricingTravels) {\n      id\n      ratioCatalogBundle @include(if: $withPricingTravelsRatioCatalogBundle) {\n        id\n        catalogCode\n        travelCode\n        json\n      }\n      catalogCode\n      travelCode\n      destination\n      name\n      transportType\n      transportTypeLabel\n      dates @include(if: $withPricingTravelsDates) {\n        id\n        dateNo\n        startDate\n        endDate\n        availabilityStatus @include(if: $withPricingTravelsDatesAvailabilityStatus) {\n          id\n          label\n          status\n          isDefaultStatus\n          isDefaultWaitlistFallback\n        }\n        includesExtension\n        extensionBaseDate @include(if: $withPricingTravelsDatesExtensionBaseDate) {\n          id\n          dateNo\n          startDate\n          endDate\n          includesExtension\n          json\n        }\n        extension @include(if: $withPricingTravelsDatesExtension) {\n          id\n          label\n          info\n        }\n        packageSettings @include(if: $withPricingTravelsDatesPackageSettings) {\n          id\n          ratioPackageNo\n          price\n          availabilityStatus\n        }\n        json\n        extensions @include(if: $withPricingTravelsDatesExtensions) {\n          id\n          label\n          info\n        }\n      }\n      accommodations @include(if: $withPricingTravelsAccommodations) {\n        id\n        ratioPackageNo\n        name\n        label\n        info\n        isFamilyPackageAccommodation\n        isBabyPackage\n        capacitySettings @include(if: $withPricingTravelsAccommodationsCapacitySettings) {\n          id\n          totalCapacity\n          rangesAllowed\n          partialOccupancyAllowed\n        }\n        addons @include(if: $withPricingTravelsAccommodationsAddons) {\n          id\n          ratioServiceNo\n          name\n          label\n          info\n        }\n      }\n      extensionAccommodations @include(if: $withPricingTravelsExtensionAccommodations) {\n        id\n        ratioPackageNo\n        name\n        label\n        info\n        extensionAccommodationServiceNo\n      }\n      familyPackages @include(if: $withPricingTravelsFamilyPackages) {\n        id\n        ratioServiceNo\n        accommodation @include(if: $withPricingTravelsFamilyPackagesAccommodation) {\n          id\n          ratioPackageNo\n          name\n          label\n          info\n          isFamilyPackageAccommodation\n          isBabyPackage\n        }\n        name\n        label\n        info\n        capacitySettings @include(if: $withPricingTravelsFamilyPackagesCapacitySettings) {\n          id\n          totalCapacity\n          rangesAllowed\n          partialOccupancyAllowed\n        }\n        addons @include(if: $withPricingTravelsFamilyPackagesAddons) {\n          id\n          ratioServiceNo\n          name\n          label\n          info\n        }\n      }\n      personalAddons @include(if: $withPricingTravelsPersonalAddons) {\n        id\n        ratioServiceNo\n        name\n        label\n        info\n        allowedAgeGroups @include(if: $withPricingTravelsPersonalAddonsAllowedAgeGroups) {\n          id\n          name\n          type\n          icon\n          minAge\n          maxAge\n        }\n        calculationSettings @include(if: $withPricingTravelsPersonalAddonsCalculationSettings) {\n          id\n          type\n          considerHotelNights\n        }\n        mandatorySettings @include(if: $withPricingTravelsPersonalAddonsMandatorySettings) {\n          id\n          isMandatory\n          useRules\n        }\n      }\n      accommodationAddons @include(if: $withPricingTravelsAccommodationAddons) {\n        id\n        ratioServiceNo\n        name\n        label\n        info\n        calculationSettings @include(if: $withPricingTravelsAccommodationAddonsCalculationSettings) {\n          id\n          type\n          considerHotelNights\n        }\n        mandatorySettings @include(if: $withPricingTravelsAccommodationAddonsMandatorySettings) {\n          id\n          isMandatory\n          useRules\n        }\n      }\n      bookingAddons @include(if: $withPricingTravelsBookingAddons) {\n        id\n        ratioServiceNo\n        name\n        label\n        info\n        calculationSettings @include(if: $withPricingTravelsBookingAddonsCalculationSettings) {\n          id\n          type\n          considerHotelNights\n        }\n        mandatorySettings @include(if: $withPricingTravelsBookingAddonsMandatorySettings) {\n          id\n          isMandatory\n          useRules\n        }\n      }\n      collectiveAddons @include(if: $withPricingTravelsCollectiveAddons) {\n        id\n        label\n        info\n        ageGroupServices @include(if: $withPricingTravelsCollectiveAddonsAgeGroupServices) {\n          id\n          ratioServiceNo\n        }\n        calculationSettings @include(if: $withPricingTravelsCollectiveAddonsCalculationSettings) {\n          id\n          type\n          considerHotelNights\n        }\n        mandatorySettings @include(if: $withPricingTravelsCollectiveAddonsMandatorySettings) {\n          id\n          isMandatory\n          useRules\n        }\n      }\n      extensions @include(if: $withPricingTravelsExtensions) {\n        id\n        label\n        info\n        travelExtension @include(if: $withPricingTravelsExtensionsTravelExtension) {\n          id\n          duration\n          name\n          description\n        }\n        accommodationMapItems @include(if: $withPricingTravelsExtensionsAccommodationMapItems) {\n          id\n        }\n      }\n      personalDiscounts @include(if: $withPricingTravelsPersonalDiscounts) {\n        id\n        ratioServiceNo\n        name\n        label\n        info\n        mandatorySettings @include(if: $withPricingTravelsPersonalDiscountsMandatorySettings) {\n          id\n          isMandatory\n          useRules\n        }\n      }\n      importDateTime\n      importStatus\n    }\n  }\n}";
// language=GraphQL
var SINGLE_FIELD_VISIBILITY_CONFIG_QUERY = "query Query($id: ID!, $withPricingTravels: Boolean = false, $withPricingTravelsRatioCatalogBundle: Boolean = false, $withPricingTravelsDates: Boolean = false, $withPricingTravelsDatesAvailabilityStatus: Boolean = false, $withPricingTravelsDatesExtensionBaseDate: Boolean = false, $withPricingTravelsDatesExtension: Boolean = false, $withPricingTravelsDatesPackageSettings: Boolean = false, $withPricingTravelsDatesExtensions: Boolean = false, $withPricingTravelsAccommodations: Boolean = false, $withPricingTravelsAccommodationsCapacitySettings: Boolean = false, $withPricingTravelsAccommodationsAddons: Boolean = false, $withPricingTravelsExtensionAccommodations: Boolean = false, $withPricingTravelsFamilyPackages: Boolean = false, $withPricingTravelsFamilyPackagesAccommodation: Boolean = false, $withPricingTravelsFamilyPackagesCapacitySettings: Boolean = false, $withPricingTravelsFamilyPackagesAddons: Boolean = false, $withPricingTravelsPersonalAddons: Boolean = false, $withPricingTravelsPersonalAddonsAllowedAgeGroups: Boolean = false, $withPricingTravelsPersonalAddonsCalculationSettings: Boolean = false, $withPricingTravelsPersonalAddonsMandatorySettings: Boolean = false, $withPricingTravelsAccommodationAddons: Boolean = false, $withPricingTravelsAccommodationAddonsCalculationSettings: Boolean = false, $withPricingTravelsAccommodationAddonsMandatorySettings: Boolean = false, $withPricingTravelsBookingAddons: Boolean = false, $withPricingTravelsBookingAddonsCalculationSettings: Boolean = false, $withPricingTravelsBookingAddonsMandatorySettings: Boolean = false, $withPricingTravelsCollectiveAddons: Boolean = false, $withPricingTravelsCollectiveAddonsAgeGroupServices: Boolean = false, $withPricingTravelsCollectiveAddonsCalculationSettings: Boolean = false, $withPricingTravelsCollectiveAddonsMandatorySettings: Boolean = false, $withPricingTravelsExtensions: Boolean = false, $withPricingTravelsExtensionsTravelExtension: Boolean = false, $withPricingTravelsExtensionsAccommodationMapItems: Boolean = false, $withPricingTravelsPersonalDiscounts: Boolean = false, $withPricingTravelsPersonalDiscountsMandatorySettings: Boolean = false) {\n  fieldVisibilityConfig: customBookingFormFieldVisibilityConfig(id: $id) {\n    id\n    pricingTravels @include(if: $withPricingTravels) {\n      id\n      ratioCatalogBundle @include(if: $withPricingTravelsRatioCatalogBundle) {\n        id\n        catalogCode\n        travelCode\n        json\n      }\n      catalogCode\n      travelCode\n      destination\n      name\n      transportType\n      transportTypeLabel\n      dates @include(if: $withPricingTravelsDates) {\n        id\n        dateNo\n        startDate\n        endDate\n        availabilityStatus @include(if: $withPricingTravelsDatesAvailabilityStatus) {\n          id\n          label\n          status\n          isDefaultStatus\n          isDefaultWaitlistFallback\n        }\n        includesExtension\n        extensionBaseDate @include(if: $withPricingTravelsDatesExtensionBaseDate) {\n          id\n          dateNo\n          startDate\n          endDate\n          includesExtension\n          json\n        }\n        extension @include(if: $withPricingTravelsDatesExtension) {\n          id\n          label\n          info\n        }\n        packageSettings @include(if: $withPricingTravelsDatesPackageSettings) {\n          id\n          ratioPackageNo\n          price\n          availabilityStatus\n        }\n        json\n        extensions @include(if: $withPricingTravelsDatesExtensions) {\n          id\n          label\n          info\n        }\n      }\n      accommodations @include(if: $withPricingTravelsAccommodations) {\n        id\n        ratioPackageNo\n        name\n        label\n        info\n        isFamilyPackageAccommodation\n        isBabyPackage\n        capacitySettings @include(if: $withPricingTravelsAccommodationsCapacitySettings) {\n          id\n          totalCapacity\n          rangesAllowed\n          partialOccupancyAllowed\n        }\n        addons @include(if: $withPricingTravelsAccommodationsAddons) {\n          id\n          ratioServiceNo\n          name\n          label\n          info\n        }\n      }\n      extensionAccommodations @include(if: $withPricingTravelsExtensionAccommodations) {\n        id\n        ratioPackageNo\n        name\n        label\n        info\n        extensionAccommodationServiceNo\n      }\n      familyPackages @include(if: $withPricingTravelsFamilyPackages) {\n        id\n        ratioServiceNo\n        accommodation @include(if: $withPricingTravelsFamilyPackagesAccommodation) {\n          id\n          ratioPackageNo\n          name\n          label\n          info\n          isFamilyPackageAccommodation\n          isBabyPackage\n        }\n        name\n        label\n        info\n        capacitySettings @include(if: $withPricingTravelsFamilyPackagesCapacitySettings) {\n          id\n          totalCapacity\n          rangesAllowed\n          partialOccupancyAllowed\n        }\n        addons @include(if: $withPricingTravelsFamilyPackagesAddons) {\n          id\n          ratioServiceNo\n          name\n          label\n          info\n        }\n      }\n      personalAddons @include(if: $withPricingTravelsPersonalAddons) {\n        id\n        ratioServiceNo\n        name\n        label\n        info\n        allowedAgeGroups @include(if: $withPricingTravelsPersonalAddonsAllowedAgeGroups) {\n          id\n          name\n          type\n          icon\n          minAge\n          maxAge\n        }\n        calculationSettings @include(if: $withPricingTravelsPersonalAddonsCalculationSettings) {\n          id\n          type\n          considerHotelNights\n        }\n        mandatorySettings @include(if: $withPricingTravelsPersonalAddonsMandatorySettings) {\n          id\n          isMandatory\n          useRules\n        }\n      }\n      accommodationAddons @include(if: $withPricingTravelsAccommodationAddons) {\n        id\n        ratioServiceNo\n        name\n        label\n        info\n        calculationSettings @include(if: $withPricingTravelsAccommodationAddonsCalculationSettings) {\n          id\n          type\n          considerHotelNights\n        }\n        mandatorySettings @include(if: $withPricingTravelsAccommodationAddonsMandatorySettings) {\n          id\n          isMandatory\n          useRules\n        }\n      }\n      bookingAddons @include(if: $withPricingTravelsBookingAddons) {\n        id\n        ratioServiceNo\n        name\n        label\n        info\n        calculationSettings @include(if: $withPricingTravelsBookingAddonsCalculationSettings) {\n          id\n          type\n          considerHotelNights\n        }\n        mandatorySettings @include(if: $withPricingTravelsBookingAddonsMandatorySettings) {\n          id\n          isMandatory\n          useRules\n        }\n      }\n      collectiveAddons @include(if: $withPricingTravelsCollectiveAddons) {\n        id\n        label\n        info\n        ageGroupServices @include(if: $withPricingTravelsCollectiveAddonsAgeGroupServices) {\n          id\n          ratioServiceNo\n        }\n        calculationSettings @include(if: $withPricingTravelsCollectiveAddonsCalculationSettings) {\n          id\n          type\n          considerHotelNights\n        }\n        mandatorySettings @include(if: $withPricingTravelsCollectiveAddonsMandatorySettings) {\n          id\n          isMandatory\n          useRules\n        }\n      }\n      extensions @include(if: $withPricingTravelsExtensions) {\n        id\n        label\n        info\n        travelExtension @include(if: $withPricingTravelsExtensionsTravelExtension) {\n          id\n          duration\n          name\n          description\n        }\n        accommodationMapItems @include(if: $withPricingTravelsExtensionsAccommodationMapItems) {\n          id\n        }\n      }\n      personalDiscounts @include(if: $withPricingTravelsPersonalDiscounts) {\n        id\n        ratioServiceNo\n        name\n        label\n        info\n        mandatorySettings @include(if: $withPricingTravelsPersonalDiscountsMandatorySettings) {\n          id\n          isMandatory\n          useRules\n        }\n      }\n      importDateTime\n      importStatus\n    }\n  }\n}";
// language=GraphQL
var CREATE_FIELD_VISIBILITY_CONFIG_MUTATION = "\n  mutation Mutation($input: CreateCustomBookingFormFieldVisibilityConfigInput, $withPricingTravels: Boolean = false, $withPricingTravelsRatioCatalogBundle: Boolean = false, $withPricingTravelsDates: Boolean = false, $withPricingTravelsDatesAvailabilityStatus: Boolean = false, $withPricingTravelsDatesExtensionBaseDate: Boolean = false, $withPricingTravelsDatesExtension: Boolean = false, $withPricingTravelsDatesPackageSettings: Boolean = false, $withPricingTravelsDatesExtensions: Boolean = false, $withPricingTravelsAccommodations: Boolean = false, $withPricingTravelsAccommodationsCapacitySettings: Boolean = false, $withPricingTravelsAccommodationsAddons: Boolean = false, $withPricingTravelsExtensionAccommodations: Boolean = false, $withPricingTravelsFamilyPackages: Boolean = false, $withPricingTravelsFamilyPackagesAccommodation: Boolean = false, $withPricingTravelsFamilyPackagesCapacitySettings: Boolean = false, $withPricingTravelsFamilyPackagesAddons: Boolean = false, $withPricingTravelsPersonalAddons: Boolean = false, $withPricingTravelsPersonalAddonsAllowedAgeGroups: Boolean = false, $withPricingTravelsPersonalAddonsCalculationSettings: Boolean = false, $withPricingTravelsPersonalAddonsMandatorySettings: Boolean = false, $withPricingTravelsAccommodationAddons: Boolean = false, $withPricingTravelsAccommodationAddonsCalculationSettings: Boolean = false, $withPricingTravelsAccommodationAddonsMandatorySettings: Boolean = false, $withPricingTravelsBookingAddons: Boolean = false, $withPricingTravelsBookingAddonsCalculationSettings: Boolean = false, $withPricingTravelsBookingAddonsMandatorySettings: Boolean = false, $withPricingTravelsCollectiveAddons: Boolean = false, $withPricingTravelsCollectiveAddonsAgeGroupServices: Boolean = false, $withPricingTravelsCollectiveAddonsCalculationSettings: Boolean = false, $withPricingTravelsCollectiveAddonsMandatorySettings: Boolean = false, $withPricingTravelsExtensions: Boolean = false, $withPricingTravelsExtensionsTravelExtension: Boolean = false, $withPricingTravelsExtensionsAccommodationMapItems: Boolean = false, $withPricingTravelsPersonalDiscounts: Boolean = false, $withPricingTravelsPersonalDiscountsMandatorySettings: Boolean = false) {\n    fieldVisibilityConfig: createCustomBookingFormFieldVisibilityConfig(input: $input) {\n      id\n      pricingTravels @include(if: $withPricingTravels) {\n        id\n        ratioCatalogBundle @include(if: $withPricingTravelsRatioCatalogBundle) {\n          id\n          catalogCode\n          travelCode\n          json\n        }\n        catalogCode\n        travelCode\n        destination\n        name\n        transportType\n        transportTypeLabel\n        dates @include(if: $withPricingTravelsDates) {\n          id\n          dateNo\n          startDate\n          endDate\n          availabilityStatus @include(if: $withPricingTravelsDatesAvailabilityStatus) {\n            id\n            label\n            status\n            isDefaultStatus\n            isDefaultWaitlistFallback\n          }\n          includesExtension\n          extensionBaseDate @include(if: $withPricingTravelsDatesExtensionBaseDate) {\n            id\n            dateNo\n            startDate\n            endDate\n            includesExtension\n            json\n          }\n          extension @include(if: $withPricingTravelsDatesExtension) {\n            id\n            label\n            info\n          }\n          packageSettings @include(if: $withPricingTravelsDatesPackageSettings) {\n            id\n            ratioPackageNo\n            price\n            availabilityStatus\n          }\n          json\n          extensions @include(if: $withPricingTravelsDatesExtensions) {\n            id\n            label\n            info\n          }\n        }\n        accommodations @include(if: $withPricingTravelsAccommodations) {\n          id\n          ratioPackageNo\n          name\n          label\n          info\n          isFamilyPackageAccommodation\n          isBabyPackage\n          capacitySettings @include(if: $withPricingTravelsAccommodationsCapacitySettings) {\n            id\n            totalCapacity\n            rangesAllowed\n            partialOccupancyAllowed\n          }\n          addons @include(if: $withPricingTravelsAccommodationsAddons) {\n            id\n            ratioServiceNo\n            name\n            label\n            info\n          }\n        }\n        extensionAccommodations @include(if: $withPricingTravelsExtensionAccommodations) {\n          id\n          ratioPackageNo\n          name\n          label\n          info\n          extensionAccommodationServiceNo\n        }\n        familyPackages @include(if: $withPricingTravelsFamilyPackages) {\n          id\n          ratioServiceNo\n          accommodation @include(if: $withPricingTravelsFamilyPackagesAccommodation) {\n            id\n            ratioPackageNo\n            name\n            label\n            info\n            isFamilyPackageAccommodation\n            isBabyPackage\n          }\n          name\n          label\n          info\n          capacitySettings @include(if: $withPricingTravelsFamilyPackagesCapacitySettings) {\n            id\n            totalCapacity\n            rangesAllowed\n            partialOccupancyAllowed\n          }\n          addons @include(if: $withPricingTravelsFamilyPackagesAddons) {\n            id\n            ratioServiceNo\n            name\n            label\n            info\n          }\n        }\n        personalAddons @include(if: $withPricingTravelsPersonalAddons) {\n          id\n          ratioServiceNo\n          name\n          label\n          info\n          allowedAgeGroups @include(if: $withPricingTravelsPersonalAddonsAllowedAgeGroups) {\n            id\n            name\n            type\n            icon\n            minAge\n            maxAge\n          }\n          calculationSettings @include(if: $withPricingTravelsPersonalAddonsCalculationSettings) {\n            id\n            type\n            considerHotelNights\n          }\n          mandatorySettings @include(if: $withPricingTravelsPersonalAddonsMandatorySettings) {\n            id\n            isMandatory\n            useRules\n          }\n        }\n        accommodationAddons @include(if: $withPricingTravelsAccommodationAddons) {\n          id\n          ratioServiceNo\n          name\n          label\n          info\n          calculationSettings @include(if: $withPricingTravelsAccommodationAddonsCalculationSettings) {\n            id\n            type\n            considerHotelNights\n          }\n          mandatorySettings @include(if: $withPricingTravelsAccommodationAddonsMandatorySettings) {\n            id\n            isMandatory\n            useRules\n          }\n        }\n        bookingAddons @include(if: $withPricingTravelsBookingAddons) {\n          id\n          ratioServiceNo\n          name\n          label\n          info\n          calculationSettings @include(if: $withPricingTravelsBookingAddonsCalculationSettings) {\n            id\n            type\n            considerHotelNights\n          }\n          mandatorySettings @include(if: $withPricingTravelsBookingAddonsMandatorySettings) {\n            id\n            isMandatory\n            useRules\n          }\n        }\n        collectiveAddons @include(if: $withPricingTravelsCollectiveAddons) {\n          id\n          label\n          info\n          ageGroupServices @include(if: $withPricingTravelsCollectiveAddonsAgeGroupServices) {\n            id\n            ratioServiceNo\n          }\n          calculationSettings @include(if: $withPricingTravelsCollectiveAddonsCalculationSettings) {\n            id\n            type\n            considerHotelNights\n          }\n          mandatorySettings @include(if: $withPricingTravelsCollectiveAddonsMandatorySettings) {\n            id\n            isMandatory\n            useRules\n          }\n        }\n        extensions @include(if: $withPricingTravelsExtensions) {\n          id\n          label\n          info\n          travelExtension @include(if: $withPricingTravelsExtensionsTravelExtension) {\n            id\n            duration\n            name\n            description\n          }\n          accommodationMapItems @include(if: $withPricingTravelsExtensionsAccommodationMapItems) {\n            id\n          }\n        }\n        personalDiscounts @include(if: $withPricingTravelsPersonalDiscounts) {\n          id\n          ratioServiceNo\n          name\n          label\n          info\n          mandatorySettings @include(if: $withPricingTravelsPersonalDiscountsMandatorySettings) {\n            id\n            isMandatory\n            useRules\n          }\n        }\n        importDateTime\n        importStatus\n      }\n    }\n  }";
// language=GraphQL
var UPDATE_FIELD_VISIBILITY_CONFIG_MUTATION = "\n  mutation Mutation($input: UpdateCustomBookingFormFieldVisibilityConfigInput, $withPricingTravels: Boolean = false, $withPricingTravelsRatioCatalogBundle: Boolean = false, $withPricingTravelsDates: Boolean = false, $withPricingTravelsDatesAvailabilityStatus: Boolean = false, $withPricingTravelsDatesExtensionBaseDate: Boolean = false, $withPricingTravelsDatesExtension: Boolean = false, $withPricingTravelsDatesPackageSettings: Boolean = false, $withPricingTravelsDatesExtensions: Boolean = false, $withPricingTravelsAccommodations: Boolean = false, $withPricingTravelsAccommodationsCapacitySettings: Boolean = false, $withPricingTravelsAccommodationsAddons: Boolean = false, $withPricingTravelsExtensionAccommodations: Boolean = false, $withPricingTravelsFamilyPackages: Boolean = false, $withPricingTravelsFamilyPackagesAccommodation: Boolean = false, $withPricingTravelsFamilyPackagesCapacitySettings: Boolean = false, $withPricingTravelsFamilyPackagesAddons: Boolean = false, $withPricingTravelsPersonalAddons: Boolean = false, $withPricingTravelsPersonalAddonsAllowedAgeGroups: Boolean = false, $withPricingTravelsPersonalAddonsCalculationSettings: Boolean = false, $withPricingTravelsPersonalAddonsMandatorySettings: Boolean = false, $withPricingTravelsAccommodationAddons: Boolean = false, $withPricingTravelsAccommodationAddonsCalculationSettings: Boolean = false, $withPricingTravelsAccommodationAddonsMandatorySettings: Boolean = false, $withPricingTravelsBookingAddons: Boolean = false, $withPricingTravelsBookingAddonsCalculationSettings: Boolean = false, $withPricingTravelsBookingAddonsMandatorySettings: Boolean = false, $withPricingTravelsCollectiveAddons: Boolean = false, $withPricingTravelsCollectiveAddonsAgeGroupServices: Boolean = false, $withPricingTravelsCollectiveAddonsCalculationSettings: Boolean = false, $withPricingTravelsCollectiveAddonsMandatorySettings: Boolean = false, $withPricingTravelsExtensions: Boolean = false, $withPricingTravelsExtensionsTravelExtension: Boolean = false, $withPricingTravelsExtensionsAccommodationMapItems: Boolean = false, $withPricingTravelsPersonalDiscounts: Boolean = false, $withPricingTravelsPersonalDiscountsMandatorySettings: Boolean = false) {\n    fieldVisibilityConfig: updateCustomBookingFormFieldVisibilityConfig(input: $input) {\n      id\n      pricingTravels @include(if: $withPricingTravels) {\n        id\n        ratioCatalogBundle @include(if: $withPricingTravelsRatioCatalogBundle) {\n          id\n          catalogCode\n          travelCode\n          json\n        }\n        catalogCode\n        travelCode\n        destination\n        name\n        transportType\n        transportTypeLabel\n        dates @include(if: $withPricingTravelsDates) {\n          id\n          dateNo\n          startDate\n          endDate\n          availabilityStatus @include(if: $withPricingTravelsDatesAvailabilityStatus) {\n            id\n            label\n            status\n            isDefaultStatus\n            isDefaultWaitlistFallback\n          }\n          includesExtension\n          extensionBaseDate @include(if: $withPricingTravelsDatesExtensionBaseDate) {\n            id\n            dateNo\n            startDate\n            endDate\n            includesExtension\n            json\n          }\n          extension @include(if: $withPricingTravelsDatesExtension) {\n            id\n            label\n            info\n          }\n          packageSettings @include(if: $withPricingTravelsDatesPackageSettings) {\n            id\n            ratioPackageNo\n            price\n            availabilityStatus\n          }\n          json\n          extensions @include(if: $withPricingTravelsDatesExtensions) {\n            id\n            label\n            info\n          }\n        }\n        accommodations @include(if: $withPricingTravelsAccommodations) {\n          id\n          ratioPackageNo\n          name\n          label\n          info\n          isFamilyPackageAccommodation\n          isBabyPackage\n          capacitySettings @include(if: $withPricingTravelsAccommodationsCapacitySettings) {\n            id\n            totalCapacity\n            rangesAllowed\n            partialOccupancyAllowed\n          }\n          addons @include(if: $withPricingTravelsAccommodationsAddons) {\n            id\n            ratioServiceNo\n            name\n            label\n            info\n          }\n        }\n        extensionAccommodations @include(if: $withPricingTravelsExtensionAccommodations) {\n          id\n          ratioPackageNo\n          name\n          label\n          info\n          extensionAccommodationServiceNo\n        }\n        familyPackages @include(if: $withPricingTravelsFamilyPackages) {\n          id\n          ratioServiceNo\n          accommodation @include(if: $withPricingTravelsFamilyPackagesAccommodation) {\n            id\n            ratioPackageNo\n            name\n            label\n            info\n            isFamilyPackageAccommodation\n            isBabyPackage\n          }\n          name\n          label\n          info\n          capacitySettings @include(if: $withPricingTravelsFamilyPackagesCapacitySettings) {\n            id\n            totalCapacity\n            rangesAllowed\n            partialOccupancyAllowed\n          }\n          addons @include(if: $withPricingTravelsFamilyPackagesAddons) {\n            id\n            ratioServiceNo\n            name\n            label\n            info\n          }\n        }\n        personalAddons @include(if: $withPricingTravelsPersonalAddons) {\n          id\n          ratioServiceNo\n          name\n          label\n          info\n          allowedAgeGroups @include(if: $withPricingTravelsPersonalAddonsAllowedAgeGroups) {\n            id\n            name\n            type\n            icon\n            minAge\n            maxAge\n          }\n          calculationSettings @include(if: $withPricingTravelsPersonalAddonsCalculationSettings) {\n            id\n            type\n            considerHotelNights\n          }\n          mandatorySettings @include(if: $withPricingTravelsPersonalAddonsMandatorySettings) {\n            id\n            isMandatory\n            useRules\n          }\n        }\n        accommodationAddons @include(if: $withPricingTravelsAccommodationAddons) {\n          id\n          ratioServiceNo\n          name\n          label\n          info\n          calculationSettings @include(if: $withPricingTravelsAccommodationAddonsCalculationSettings) {\n            id\n            type\n            considerHotelNights\n          }\n          mandatorySettings @include(if: $withPricingTravelsAccommodationAddonsMandatorySettings) {\n            id\n            isMandatory\n            useRules\n          }\n        }\n        bookingAddons @include(if: $withPricingTravelsBookingAddons) {\n          id\n          ratioServiceNo\n          name\n          label\n          info\n          calculationSettings @include(if: $withPricingTravelsBookingAddonsCalculationSettings) {\n            id\n            type\n            considerHotelNights\n          }\n          mandatorySettings @include(if: $withPricingTravelsBookingAddonsMandatorySettings) {\n            id\n            isMandatory\n            useRules\n          }\n        }\n        collectiveAddons @include(if: $withPricingTravelsCollectiveAddons) {\n          id\n          label\n          info\n          ageGroupServices @include(if: $withPricingTravelsCollectiveAddonsAgeGroupServices) {\n            id\n            ratioServiceNo\n          }\n          calculationSettings @include(if: $withPricingTravelsCollectiveAddonsCalculationSettings) {\n            id\n            type\n            considerHotelNights\n          }\n          mandatorySettings @include(if: $withPricingTravelsCollectiveAddonsMandatorySettings) {\n            id\n            isMandatory\n            useRules\n          }\n        }\n        extensions @include(if: $withPricingTravelsExtensions) {\n          id\n          label\n          info\n          travelExtension @include(if: $withPricingTravelsExtensionsTravelExtension) {\n            id\n            duration\n            name\n            description\n          }\n          accommodationMapItems @include(if: $withPricingTravelsExtensionsAccommodationMapItems) {\n            id\n          }\n        }\n        personalDiscounts @include(if: $withPricingTravelsPersonalDiscounts) {\n          id\n          ratioServiceNo\n          name\n          label\n          info\n          mandatorySettings @include(if: $withPricingTravelsPersonalDiscountsMandatorySettings) {\n            id\n            isMandatory\n            useRules\n          }\n        }\n        importDateTime\n        importStatus\n      }\n    }\n  }";
// language=GraphQL
var DELETE_FIELD_VISIBILITY_CONFIG_MUTATION = "\n  mutation Mutation($input: DeleteCustomBookingFormFieldVisibilityConfigInput) {\n    deleteCustomBookingFormFieldVisibilityConfig(input: $input) {\n      success\n    }\n  }";
// language=GraphQL
var FORCE_DELETE_FIELD_VISIBILITY_CONFIG_MUTATION = "\n  mutation Mutation($input: DeleteCustomBookingFormFieldVisibilityConfigInput) {\n    forceDeleteCustomBookingFormFieldVisibilityConfig(input: $input) {\n      success\n    }\n  }";
// language=GraphQL
var ADD_FIELD_VISIBILITY_CONFIG_PRICING_TRAVELS_MUTATION = "\n  mutation Mutation($input: addCustomBookingFormFieldVisibilityConfigPricingTravelsInput) {\n    addCustomBookingFormFieldVisibilityConfigPricingTravels(input: $input) {\n      id\n      pricingTravelIds\n    }\n  }";
// language=GraphQL
var REMOVE_FIELD_VISIBILITY_CONFIG_PRICING_TRAVELS_MUTATION = "\n  mutation Mutation($input: removeCustomBookingFormFieldVisibilityConfigPricingTravelsInput) {\n    removeCustomBookingFormFieldVisibilityConfigPricingTravels(input: $input) {\n      id\n      pricingTravelIds\n    }\n  }";
// language=GraphQL
var CREATE_FIELD_VISIBILITY_CONFIG_PRICING_TRAVELS_MUTATION = "\n  mutation Mutation($input: createCustomBookingFormFieldVisibilityConfigPricingTravelsInput) {\n    createCustomBookingFormFieldVisibilityConfigPricingTravels(input: $input) {\n      id\n      pricingTravelIds\n    }\n  }";
// language=GraphQL
var DELETE_FIELD_VISIBILITY_CONFIG_PRICING_TRAVELS_MUTATION = "\n  mutation Mutation($input: deleteCustomBookingFormFieldVisibilityConfigPricingTravelsInput) {\n    deleteCustomBookingFormFieldVisibilityConfigPricingTravels(input: $input) {\n      id\n      pricingTravelIds\n    }\n  }";
// language=GraphQL
var FIELD_VISIBILITY_CONFIGS_DEPENDENTS_QUERY = "query Query($id: ID!, $withCustomBookingFormFields: Boolean = false) {\n  groupedDependents: customBookingFormFieldVisibilityConfigDependents(id: $id) {\n    customBookingFormFields @include(if: $withCustomBookingFormFields) {\n      id\n      inputType\n      name\n      label\n      info\n      value\n      required\n    }\n  }\n}";

// EXTERNAL MODULE: ./src/entities/ratioTravel/entity.ts + 3 modules
var entity = __webpack_require__(81065);
;// CONCATENATED MODULE: ./src/entities/customBookingFormFieldVisibilityConfig/model.ts


var customBookingFormFieldVisibilityConfigModel = {
    name: "fieldVisibilityConfig",
    namePlural: "fieldVisibilityConfigs",
    uniqueName: "customBookingFormFieldVisibilityConfig",
    uniqueNamePlural: "customBookingFormFieldVisibilityConfigs",
    path: "travel/booking/custom_data/field_visibility_config",
    baseUrl: "/travel/booking/custom_data/field_visibility_configs",
    translationPrefix: "entities:customBookingFormFieldVisibilityConfig.",
    getDisplayName: function(values) {
        return "FIELD VISIBILITY CONFIG";
    },
    gql: {
        getAll: ALL_FIELD_VISIBILITY_CONFIGS_QUERY,
        getSingle: SINGLE_FIELD_VISIBILITY_CONFIG_QUERY,
        create: CREATE_FIELD_VISIBILITY_CONFIG_MUTATION,
        update: UPDATE_FIELD_VISIBILITY_CONFIG_MUTATION,
        delete: DELETE_FIELD_VISIBILITY_CONFIG_MUTATION,
        forceDelete: FORCE_DELETE_FIELD_VISIBILITY_CONFIG_MUTATION
    },
    attributes: {
        pricingTravels: {
            name: "pricingTravels",
            label: "entities:customBookingFormFieldVisibilityConfig.attributes.pricingTravels.label",
            type: "entityCollection",
            dataType: "[any]",
            getEntity: function() {
                return entity/* default */.Z;
            },
            defaultInput: false,
            inputType: "text",
            validationType: "string",
            validations: []
        }
    }
};
/* harmony default export */ var model = (customBookingFormFieldVisibilityConfigModel);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(20414);
// EXTERNAL MODULE: ./src/entities/lib.ts
var lib = __webpack_require__(23480);
// EXTERNAL MODULE: ./src/lib/api/graphQLClient.ts
var graphQLClient = __webpack_require__(40112);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/swr/dist/index.mjs
var dist = __webpack_require__(8100);
// EXTERNAL MODULE: ./src/lib/helpers/helpers.ts
var helpers = __webpack_require__(15778);
;// CONCATENATED MODULE: ./src/entities/customBookingFormFieldVisibilityConfig/repository.ts










var hydrateObjects = function(objects) {
    return objects.map(function(object) {
        return (0,lib/* hydrateEntityObject */.b)(model, object);
    });
};
var hydrateObject = function(object) {
    return (0,lib/* hydrateEntityObject */.b)(model, object);
};
var customBookingFormFieldVisibilityConfigRepository = {
    getObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    id: id
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(SINGLE_FIELD_VISIBILITY_CONFIG_QUERY, variables).then(function(data) {
                        return hydrateObject(data.fieldVisibilityConfig);
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }(),
    getObjects: /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        var includes;
        var _arguments = arguments;
        return (0,tslib_es6.__generator)(this, function(_state) {
            includes = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : {};
            return [
                2,
                graphQLClient/* default.request */.Z.request(ALL_FIELD_VISIBILITY_CONFIGS_QUERY, includes).then(function(data) {
                    return hydrateObjects(data.fieldVisibilityConfigs);
                })
            ];
        });
    }),
    useObject: function(id) {
        var includes = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        // eslint-disable-next-line react-hooks/exhaustive-deps
        var variables = (0,react.useMemo)(function() {
            return (0,_object_spread/* default */.Z)({
                id: id
            }, includes);
        }, [
            id
        ]);
        var ref = (0,dist/* default */.ZP)([
            SINGLE_FIELD_VISIBILITY_CONFIG_QUERY,
            variables
        ], {
            revalidateOnFocus: false
        }), data = ref.data, error = ref.error, mutate = ref.mutate;
        return {
            object: !data ? data : hydrateObject(data.fieldVisibilityConfig),
            isLoading: !error && !data,
            isError: error,
            mutate: mutate
        };
    },
    useObjects: function() {
        var includes = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        // eslint-disable-next-line react-hooks/exhaustive-deps
        var variables = (0,react.useMemo)(function() {
            return includes;
        }, []);
        var ref = (0,dist/* default */.ZP)([
            ALL_FIELD_VISIBILITY_CONFIGS_QUERY,
            variables
        ]), data = ref.data, error = ref.error, mutate = ref.mutate;
        return {
            objects: !data ? data : hydrateObjects(data.fieldVisibilityConfigs),
            isLoading: !error && !data,
            isError: error,
            mutate: mutate
        };
    },
    getDependents: function(id, includes) {
        var includeVars = {};
        includes.forEach(function(include) {
            includeVars["with".concat((0,helpers/* uppercaseFirst */.AB)(include))] = true;
        });
        var variables = (0,_object_spread/* default */.Z)({
            id: id
        }, includeVars);
        return graphQLClient/* default.request */.Z.request(FIELD_VISIBILITY_CONFIGS_DEPENDENTS_QUERY, variables).then(function(data) {
            return data.groupedDependents;
        });
    },
    useDependents: function(id, includes) {
        var includeVars = {};
        includes.forEach(function(include) {
            includeVars["with".concat((0,helpers/* uppercaseFirst */.AB)(include))] = true;
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
        var variables = (0,react.useMemo)(function() {
            return (0,_object_spread/* default */.Z)({
                id: id
            }, includeVars);
        }, [
            id
        ]);
        var ref = (0,dist/* default */.ZP)([
            FIELD_VISIBILITY_CONFIGS_DEPENDENTS_QUERY,
            variables
        ], {
            revalidateOnFocus: false
        }), data = ref.data, error = ref.error, mutate = ref.mutate;
        return {
            data: !data ? data : data.groupedDependents,
            isLoading: !error && !data,
            isError: error,
            mutate: mutate
        };
    },
    createObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(data) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    input: data
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(CREATE_FIELD_VISIBILITY_CONFIG_MUTATION, variables).then(function(data) {
                        return hydrateObject(data.fieldVisibilityConfig);
                    })
                ];
            });
        });
        return function(data) {
            return _ref.apply(this, arguments);
        };
    }(),
    updateObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(data) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    input: data
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(UPDATE_FIELD_VISIBILITY_CONFIG_MUTATION, variables).then(function(data) {
                        return hydrateObject(data.fieldVisibilityConfig);
                    })
                ];
            });
        });
        return function(data) {
            return _ref.apply(this, arguments);
        };
    }(),
    deleteObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(DELETE_FIELD_VISIBILITY_CONFIG_MUTATION, variables).then(function(data) {
                        return data.deleteCustomBookingFormFieldVisibilityConfig;
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }(),
    forceDeleteObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(FORCE_DELETE_FIELD_VISIBILITY_CONFIG_MUTATION, variables).then(function(data) {
                        return data.forceDeleteCustomBookingFormFieldVisibilityConfig;
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }(),
    assignPricingTravels: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, itemIds) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        pricingTravelIds: itemIds
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(ADD_FIELD_VISIBILITY_CONFIG_PRICING_TRAVELS_MUTATION, variables)
                ];
            });
        });
        return function(id, itemIds) {
            return _ref.apply(this, arguments);
        };
    }(),
    unassignPricingTravels: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, itemIds) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        pricingTravelIds: itemIds
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(REMOVE_FIELD_VISIBILITY_CONFIG_PRICING_TRAVELS_MUTATION, variables)
                ];
            });
        });
        return function(id, itemIds) {
            return _ref.apply(this, arguments);
        };
    }(),
    createPricingTravels: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, items) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        pricingTravels: items
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(CREATE_FIELD_VISIBILITY_CONFIG_PRICING_TRAVELS_MUTATION, variables)
                ];
            });
        });
        return function(id, items) {
            return _ref.apply(this, arguments);
        };
    }(),
    deletePricingTravels: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, itemIds) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        pricingTravelIds: itemIds
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(DELETE_FIELD_VISIBILITY_CONFIG_PRICING_TRAVELS_MUTATION, variables)
                ];
            });
        });
        return function(id, itemIds) {
            return _ref.apply(this, arguments);
        };
    }()
};
/* harmony default export */ var repository = (customBookingFormFieldVisibilityConfigRepository);

;// CONCATENATED MODULE: ./src/entities/customBookingFormFieldVisibilityConfig/entity.ts


var customBookingFormFieldVisibilityConfigEntity = {
    model: model,
    repository: repository
};
/* harmony default export */ var customBookingFormFieldVisibilityConfig_entity = (customBookingFormFieldVisibilityConfigEntity);


/***/ }),

/***/ 64750:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ elementSeoSettings_entity; }
});

;// CONCATENATED MODULE: ./src/entities/elementSeoSettings/graphql.ts
// language=GraphQL
var ALL_ELEMENT_SEO_SETTINGS_QUERY = "query Query($withOgImage: Boolean = false) {\n  elementSeoSettings: allElementSeoSettings {\n    id\n    urlSlug\n    metaTitle\n    metaDescription\n    ogTitle\n    ogDescription\n    ogImage @include(if: $withOgImage) {\n      id\n      assetId\n      publicId\n      url\n      resourceType\n      format\n      width\n      height\n      caption\n      title\n      description\n    }\n  }\n}";
// language=GraphQL
var SINGLE_ELEMENT_SEO_SETTINGS_QUERY = "query Query($id: ID!, $withOgImage: Boolean = false) {\n  elementSeoSettings: elementSeoSettings(id: $id) {\n    id\n    urlSlug\n    metaTitle\n    metaDescription\n    ogTitle\n    ogDescription\n    ogImage @include(if: $withOgImage) {\n      id\n      assetId\n      publicId\n      url\n      resourceType\n      format\n      width\n      height\n      caption\n      title\n      description\n    }\n  }\n}";
// language=GraphQL
var CREATE_ELEMENT_SEO_SETTINGS_MUTATION = "\n  mutation Mutation($input: CreateElementSeoSettingsInput, $withOgImage: Boolean = false) {\n    elementSeoSettings: createElementSeoSettings(input: $input) {\n      id\n      urlSlug\n      metaTitle\n      metaDescription\n      ogTitle\n      ogDescription\n      ogImage @include(if: $withOgImage) {\n        id\n        assetId\n        publicId\n        url\n        resourceType\n        format\n        width\n        height\n        caption\n        title\n        description\n      }\n    }\n  }";
// language=GraphQL
var UPDATE_ELEMENT_SEO_SETTINGS_MUTATION = "\n  mutation Mutation($input: UpdateElementSeoSettingsInput, $withOgImage: Boolean = false) {\n    elementSeoSettings: updateElementSeoSettings(input: $input) {\n      id\n      urlSlug\n      metaTitle\n      metaDescription\n      ogTitle\n      ogDescription\n      ogImage @include(if: $withOgImage) {\n        id\n        assetId\n        publicId\n        url\n        resourceType\n        format\n        width\n        height\n        caption\n        title\n        description\n      }\n    }\n  }";
// language=GraphQL
var DELETE_ELEMENT_SEO_SETTINGS_MUTATION = "\n  mutation Mutation($input: DeleteElementSeoSettingsInput) {\n    deleteElementSeoSettings(input: $input) {\n      success\n    }\n  }";
// language=GraphQL
var FORCE_DELETE_ELEMENT_SEO_SETTINGS_MUTATION = "\n  mutation Mutation($input: DeleteElementSeoSettingsInput) {\n    forceDeleteElementSeoSettings(input: $input) {\n      success\n    }\n  }";
// language=GraphQL
var ELEMENT_SEO_SETTINGS_DEPENDENTS_QUERY = "query Query($id: ID!, $withCmsPages: Boolean = false, $withCmsCategories: Boolean = false, $withTravels: Boolean = false) {\n  groupedDependents: elementSeoSettingsDependents(id: $id) {\n    cmsPages @include(if: $withCmsPages) {\n      id\n      name\n      onlineStatus\n    }\n    cmsCategories @include(if: $withCmsCategories) {\n      id\n      name\n    }\n    travels @include(if: $withTravels) {\n      id\n      name\n      isBestseller\n      startDate\n      endDate\n      executionStatus\n      title\n      description\n      includedServices\n      excludedServices\n      pricingTable\n      priceCalculationInfo\n      programType\n      programText\n      minPrice\n      minPriceManualOverride\n      currency    }\n  }\n}";

// EXTERNAL MODULE: ./src/entities/mediaFile/entity.ts + 3 modules
var entity = __webpack_require__(24180);
;// CONCATENATED MODULE: ./src/entities/elementSeoSettings/model.ts


var elementSeoSettingsModel = {
    name: "elementSeoSettings",
    namePlural: "elementSeoSettings",
    uniqueName: "elementSeoSettings",
    uniqueNamePlural: "elementSeoSettings",
    path: "seo/element_seo_settings",
    baseUrl: "/seo/element_seo_settings",
    translationPrefix: "entities:elementSeoSettings.",
    getDisplayName: function(values) {
        return values.metaTitle;
    },
    gql: {
        getAll: ALL_ELEMENT_SEO_SETTINGS_QUERY,
        getSingle: SINGLE_ELEMENT_SEO_SETTINGS_QUERY,
        create: CREATE_ELEMENT_SEO_SETTINGS_MUTATION,
        update: UPDATE_ELEMENT_SEO_SETTINGS_MUTATION,
        delete: DELETE_ELEMENT_SEO_SETTINGS_MUTATION,
        forceDelete: FORCE_DELETE_ELEMENT_SEO_SETTINGS_MUTATION
    },
    attributes: {
        urlSlug: {
            name: "urlSlug",
            label: "entities:elementSeoSettings.attributes.urlSlug.label",
            type: "value",
            dataType: "string",
            defaultInput: true,
            inputType: "text",
            validationType: "string",
            validations: [
                {
                    type: "required"
                },
                {
                    type: "regex",
                    pattern: /^[a-z0-9]+(?:-[a-z0-9]+)*$/
                }, 
            ]
        },
        metaTitle: {
            name: "metaTitle",
            label: "entities:elementSeoSettings.attributes.metaTitle.label",
            type: "value",
            dataType: "string",
            defaultInput: true,
            inputType: "text",
            maxLength: 70,
            validationType: "string",
            validations: [
                {
                    type: "required"
                }, 
            ]
        },
        metaDescription: {
            name: "metaDescription",
            label: "entities:elementSeoSettings.attributes.metaDescription.label",
            type: "value",
            dataType: "string",
            defaultInput: true,
            inputType: "textarea",
            maxLength: 160,
            validationType: "string",
            validations: [
                {
                    type: "required"
                }, 
            ]
        },
        ogTitle: {
            name: "ogTitle",
            label: "entities:elementSeoSettings.attributes.ogTitle.label",
            type: "value",
            dataType: "string",
            defaultInput: true,
            inputType: "text",
            maxLength: 35,
            validationType: "string",
            validations: [
                {
                    type: "required"
                }, 
            ]
        },
        ogDescription: {
            name: "ogDescription",
            label: "entities:elementSeoSettings.attributes.ogDescription.label",
            type: "value",
            dataType: "string",
            defaultInput: true,
            inputType: "textarea",
            maxLength: 155,
            validationType: "string",
            validations: [
                {
                    type: "required"
                }, 
            ]
        },
        ogImage: {
            name: "ogImage",
            label: "entities:elementSeoSettings.attributes.ogImage.label",
            type: "entityObject",
            dataType: "any",
            getEntity: function() {
                return entity/* default */.Z;
            },
            defaultInput: false,
            inputType: "select",
            validationType: "string",
            validations: []
        }
    }
};
/* harmony default export */ var model = (elementSeoSettingsModel);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(20414);
// EXTERNAL MODULE: ./src/entities/lib.ts
var lib = __webpack_require__(23480);
// EXTERNAL MODULE: ./src/lib/api/graphQLClient.ts
var graphQLClient = __webpack_require__(40112);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/swr/dist/index.mjs
var dist = __webpack_require__(8100);
// EXTERNAL MODULE: ./src/lib/helpers/helpers.ts
var helpers = __webpack_require__(15778);
;// CONCATENATED MODULE: ./src/entities/elementSeoSettings/repository.ts










var hydrateObjects = function(objects) {
    return objects.map(function(object) {
        return (0,lib/* hydrateEntityObject */.b)(model, object);
    });
};
var hydrateObject = function(object) {
    return (0,lib/* hydrateEntityObject */.b)(model, object);
};
var elementSeoSettingsRepository = {
    getObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    id: id
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(SINGLE_ELEMENT_SEO_SETTINGS_QUERY, variables).then(function(data) {
                        return hydrateObject(data.elementSeoSettings);
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }(),
    getObjects: /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        var includes;
        var _arguments = arguments;
        return (0,tslib_es6.__generator)(this, function(_state) {
            includes = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : {};
            return [
                2,
                graphQLClient/* default.request */.Z.request(ALL_ELEMENT_SEO_SETTINGS_QUERY, includes).then(function(data) {
                    return hydrateObjects(data.elementSeoSettings);
                })
            ];
        });
    }),
    useObject: function(id) {
        var includes = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        // eslint-disable-next-line react-hooks/exhaustive-deps
        var variables = (0,react.useMemo)(function() {
            return (0,_object_spread/* default */.Z)({
                id: id
            }, includes);
        }, [
            id
        ]);
        var ref = (0,dist/* default */.ZP)([
            SINGLE_ELEMENT_SEO_SETTINGS_QUERY,
            variables
        ], {
            revalidateOnFocus: false
        }), data = ref.data, error = ref.error, mutate = ref.mutate;
        return {
            object: !data ? data : hydrateObject(data.elementSeoSettings),
            isLoading: !error && !data,
            isError: error,
            mutate: mutate
        };
    },
    useObjects: function() {
        var includes = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        // eslint-disable-next-line react-hooks/exhaustive-deps
        var variables = (0,react.useMemo)(function() {
            return includes;
        }, []);
        var ref = (0,dist/* default */.ZP)([
            ALL_ELEMENT_SEO_SETTINGS_QUERY,
            variables
        ]), data = ref.data, error = ref.error, mutate = ref.mutate;
        return {
            objects: !data ? data : hydrateObjects(data.elementSeoSettings),
            isLoading: !error && !data,
            isError: error,
            mutate: mutate
        };
    },
    getDependents: function(id, includes) {
        var includeVars = {};
        includes.forEach(function(include) {
            includeVars["with".concat((0,helpers/* uppercaseFirst */.AB)(include))] = true;
        });
        var variables = (0,_object_spread/* default */.Z)({
            id: id
        }, includeVars);
        return graphQLClient/* default.request */.Z.request(ELEMENT_SEO_SETTINGS_DEPENDENTS_QUERY, variables).then(function(data) {
            return data.groupedDependents;
        });
    },
    useDependents: function(id, includes) {
        var includeVars = {};
        includes.forEach(function(include) {
            includeVars["with".concat((0,helpers/* uppercaseFirst */.AB)(include))] = true;
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
        var variables = (0,react.useMemo)(function() {
            return (0,_object_spread/* default */.Z)({
                id: id
            }, includeVars);
        }, [
            id
        ]);
        var ref = (0,dist/* default */.ZP)([
            ELEMENT_SEO_SETTINGS_DEPENDENTS_QUERY,
            variables
        ], {
            revalidateOnFocus: false
        }), data = ref.data, error = ref.error, mutate = ref.mutate;
        return {
            data: !data ? data : data.groupedDependents,
            isLoading: !error && !data,
            isError: error,
            mutate: mutate
        };
    },
    createObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(data) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    input: data
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(CREATE_ELEMENT_SEO_SETTINGS_MUTATION, variables).then(function(data) {
                        return hydrateObject(data.elementSeoSettings);
                    })
                ];
            });
        });
        return function(data) {
            return _ref.apply(this, arguments);
        };
    }(),
    updateObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(data) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    input: data
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(UPDATE_ELEMENT_SEO_SETTINGS_MUTATION, variables).then(function(data) {
                        return hydrateObject(data.elementSeoSettings);
                    })
                ];
            });
        });
        return function(data) {
            return _ref.apply(this, arguments);
        };
    }(),
    deleteObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(DELETE_ELEMENT_SEO_SETTINGS_MUTATION, variables).then(function(data) {
                        return data.deleteElementSeoSettings;
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }(),
    forceDeleteObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(FORCE_DELETE_ELEMENT_SEO_SETTINGS_MUTATION, variables).then(function(data) {
                        return data.forceDeleteElementSeoSettings;
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }()
};
/* harmony default export */ var repository = (elementSeoSettingsRepository);

;// CONCATENATED MODULE: ./src/entities/elementSeoSettings/entity.ts


var elementSeoSettingsEntity = {
    model: model,
    repository: repository
};
/* harmony default export */ var elementSeoSettings_entity = (elementSeoSettingsEntity);


/***/ }),

/***/ 4383:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ employee_entity; }
});

;// CONCATENATED MODULE: ./src/entities/employee/graphql.ts
// language=GraphQL
var ALL_EMPLOYEES_QUERY = "query Query($withImage: Boolean = false) {\n  employees: employees {\n    id\n    firstName\n    lastName\n    jobTitle\n    description\n    email\n    image @include(if: $withImage) {\n      id\n      assetId\n      publicId\n      url\n      resourceType\n      format\n      width\n      height\n      caption\n      title\n      description\n    }\n    phone\n  }\n}";
// language=GraphQL
var SINGLE_EMPLOYEE_QUERY = "query Query($id: ID!, $withImage: Boolean = false) {\n  employee: employee(id: $id) {\n    id\n    firstName\n    lastName\n    jobTitle\n    description\n    email\n    image @include(if: $withImage) {\n      id\n      assetId\n      publicId\n      url\n      resourceType\n      format\n      width\n      height\n      caption\n      title\n      description\n    }\n    phone\n  }\n}";
// language=GraphQL
var CREATE_EMPLOYEE_MUTATION = "\n  mutation Mutation($input: CreateEmployeeInput, $withImage: Boolean = false) {\n    employee: createEmployee(input: $input) {\n      id\n      firstName\n      lastName\n      jobTitle\n      description\n      email\n      image @include(if: $withImage) {\n        id\n        assetId\n        publicId\n        url\n        resourceType\n        format\n        width\n        height\n        caption\n        title\n        description\n      }\n      phone\n    }\n  }";
// language=GraphQL
var UPDATE_EMPLOYEE_MUTATION = "\n  mutation Mutation($input: UpdateEmployeeInput, $withImage: Boolean = false) {\n    employee: updateEmployee(input: $input) {\n      id\n      firstName\n      lastName\n      jobTitle\n      description\n      email\n      image @include(if: $withImage) {\n        id\n        assetId\n        publicId\n        url\n        resourceType\n        format\n        width\n        height\n        caption\n        title\n        description\n      }\n      phone\n    }\n  }";
// language=GraphQL
var DELETE_EMPLOYEE_MUTATION = "\n  mutation Mutation($input: DeleteEmployeeInput) {\n    deleteEmployee(input: $input) {\n      success\n    }\n  }";
// language=GraphQL
var FORCE_DELETE_EMPLOYEE_MUTATION = "\n  mutation Mutation($input: DeleteEmployeeInput) {\n    forceDeleteEmployee(input: $input) {\n      success\n    }\n  }";
// language=GraphQL
var EMPLOYEES_DEPENDENTS_QUERY = "query Query($id: ID!, $withCmsContactBannerBlocks: Boolean = false, $withTravels: Boolean = false, $withTenants: Boolean = false, $withCmsEmployeesBlocks: Boolean = false) {\n  groupedDependents: employeeDependents(id: $id) {\n    cmsContactBannerBlocks @include(if: $withCmsContactBannerBlocks) {\n      id\n      phone\n      email    }\n    travels @include(if: $withTravels) {\n      id\n      name\n      isBestseller\n      startDate\n      endDate\n      executionStatus\n      title\n      description\n      includedServices\n      excludedServices\n      pricingTable\n      priceCalculationInfo\n      programType\n      programText\n      minPrice\n      minPriceManualOverride\n      currency    }\n    tenants @include(if: $withTenants) {\n      id\n      name\n      slug\n      domain\n      externalReference\n    }\n    cmsEmployeesBlocks @include(if: $withCmsEmployeesBlocks) {\n      id\n    }\n  }\n}";

// EXTERNAL MODULE: ./src/entities/mediaFile/entity.ts + 3 modules
var entity = __webpack_require__(24180);
;// CONCATENATED MODULE: ./src/entities/employee/model.ts


var employeeModel = {
    name: "employee",
    namePlural: "employees",
    uniqueName: "employee",
    uniqueNamePlural: "employees",
    path: "cms/employee",
    baseUrl: "/cms/employees",
    translationPrefix: "entities:employee.",
    getDisplayName: function(values) {
        return "".concat(values.firstName, " ").concat(values.lastName);
    },
    gql: {
        getAll: ALL_EMPLOYEES_QUERY,
        getSingle: SINGLE_EMPLOYEE_QUERY,
        create: CREATE_EMPLOYEE_MUTATION,
        update: UPDATE_EMPLOYEE_MUTATION,
        delete: DELETE_EMPLOYEE_MUTATION,
        forceDelete: FORCE_DELETE_EMPLOYEE_MUTATION
    },
    attributes: {
        firstName: {
            name: "firstName",
            label: "entities:employee.attributes.firstName.label",
            type: "value",
            dataType: "string",
            defaultInput: true,
            inputType: "text",
            validationType: "string",
            validations: [
                {
                    type: "required"
                }, 
            ]
        },
        lastName: {
            name: "lastName",
            label: "entities:employee.attributes.lastName.label",
            type: "value",
            dataType: "string",
            defaultInput: true,
            inputType: "text",
            validationType: "string",
            validations: [
                {
                    type: "required"
                }, 
            ]
        },
        jobTitle: {
            name: "jobTitle",
            label: "entities:employee.attributes.jobTitle.label",
            type: "value",
            dataType: "string",
            defaultInput: true,
            inputType: "text",
            validationType: "string",
            validations: [
                {
                    type: "required"
                }, 
            ]
        },
        description: {
            name: "description",
            label: "entities:employee.attributes.description.label",
            type: "value",
            dataType: "string",
            defaultInput: true,
            inputType: "textarea",
            validationType: "string",
            validations: [
                {
                    type: "required"
                }, 
            ]
        },
        email: {
            name: "email",
            label: "entities:employee.attributes.email.label",
            type: "value",
            dataType: "string",
            defaultInput: true,
            inputType: "text",
            validationType: "string",
            validations: [
                {
                    type: "email"
                }, 
            ]
        },
        image: {
            name: "image",
            label: "entities:employee.attributes.image.label",
            type: "entityObject",
            dataType: "any",
            getEntity: function() {
                return entity/* default */.Z;
            },
            defaultInput: false,
            inputType: "select",
            validationType: "string",
            validations: []
        },
        phone: {
            name: "phone",
            label: "entities:employee.attributes.phone.label",
            type: "value",
            dataType: "string",
            defaultInput: true,
            inputType: "text",
            validationType: "string",
            validations: []
        }
    }
};
/* harmony default export */ var model = (employeeModel);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(20414);
// EXTERNAL MODULE: ./src/entities/lib.ts
var lib = __webpack_require__(23480);
// EXTERNAL MODULE: ./src/lib/api/graphQLClient.ts
var graphQLClient = __webpack_require__(40112);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/swr/dist/index.mjs
var dist = __webpack_require__(8100);
// EXTERNAL MODULE: ./src/lib/helpers/helpers.ts
var helpers = __webpack_require__(15778);
;// CONCATENATED MODULE: ./src/entities/employee/repository.ts










var hydrateObjects = function(objects) {
    return objects.map(function(object) {
        return (0,lib/* hydrateEntityObject */.b)(model, object);
    });
};
var hydrateObject = function(object) {
    return (0,lib/* hydrateEntityObject */.b)(model, object);
};
var employeeRepository = {
    getObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    id: id
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(SINGLE_EMPLOYEE_QUERY, variables).then(function(data) {
                        return hydrateObject(data.employee);
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }(),
    getObjects: /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        var includes;
        var _arguments = arguments;
        return (0,tslib_es6.__generator)(this, function(_state) {
            includes = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : {};
            return [
                2,
                graphQLClient/* default.request */.Z.request(ALL_EMPLOYEES_QUERY, includes).then(function(data) {
                    return hydrateObjects(data.employees);
                })
            ];
        });
    }),
    useObject: function(id) {
        var includes = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        // eslint-disable-next-line react-hooks/exhaustive-deps
        var variables = (0,react.useMemo)(function() {
            return (0,_object_spread/* default */.Z)({
                id: id
            }, includes);
        }, [
            id
        ]);
        var ref = (0,dist/* default */.ZP)([
            SINGLE_EMPLOYEE_QUERY,
            variables
        ], {
            revalidateOnFocus: false
        }), data = ref.data, error = ref.error, mutate = ref.mutate;
        return {
            object: !data ? data : hydrateObject(data.employee),
            isLoading: !error && !data,
            isError: error,
            mutate: mutate
        };
    },
    useObjects: function() {
        var includes = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        // eslint-disable-next-line react-hooks/exhaustive-deps
        var variables = (0,react.useMemo)(function() {
            return includes;
        }, []);
        var ref = (0,dist/* default */.ZP)([
            ALL_EMPLOYEES_QUERY,
            variables
        ]), data = ref.data, error = ref.error, mutate = ref.mutate;
        return {
            objects: !data ? data : hydrateObjects(data.employees),
            isLoading: !error && !data,
            isError: error,
            mutate: mutate
        };
    },
    getDependents: function(id, includes) {
        var includeVars = {};
        includes.forEach(function(include) {
            includeVars["with".concat((0,helpers/* uppercaseFirst */.AB)(include))] = true;
        });
        var variables = (0,_object_spread/* default */.Z)({
            id: id
        }, includeVars);
        return graphQLClient/* default.request */.Z.request(EMPLOYEES_DEPENDENTS_QUERY, variables).then(function(data) {
            return data.groupedDependents;
        });
    },
    useDependents: function(id, includes) {
        var includeVars = {};
        includes.forEach(function(include) {
            includeVars["with".concat((0,helpers/* uppercaseFirst */.AB)(include))] = true;
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
        var variables = (0,react.useMemo)(function() {
            return (0,_object_spread/* default */.Z)({
                id: id
            }, includeVars);
        }, [
            id
        ]);
        var ref = (0,dist/* default */.ZP)([
            EMPLOYEES_DEPENDENTS_QUERY,
            variables
        ], {
            revalidateOnFocus: false
        }), data = ref.data, error = ref.error, mutate = ref.mutate;
        return {
            data: !data ? data : data.groupedDependents,
            isLoading: !error && !data,
            isError: error,
            mutate: mutate
        };
    },
    createObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(data) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    input: data
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(CREATE_EMPLOYEE_MUTATION, variables).then(function(data) {
                        return hydrateObject(data.employee);
                    })
                ];
            });
        });
        return function(data) {
            return _ref.apply(this, arguments);
        };
    }(),
    updateObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(data) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    input: data
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(UPDATE_EMPLOYEE_MUTATION, variables).then(function(data) {
                        return hydrateObject(data.employee);
                    })
                ];
            });
        });
        return function(data) {
            return _ref.apply(this, arguments);
        };
    }(),
    deleteObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(DELETE_EMPLOYEE_MUTATION, variables).then(function(data) {
                        return data.deleteEmployee;
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }(),
    forceDeleteObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(FORCE_DELETE_EMPLOYEE_MUTATION, variables).then(function(data) {
                        return data.forceDeleteEmployee;
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }()
};
/* harmony default export */ var repository = (employeeRepository);

;// CONCATENATED MODULE: ./src/entities/employee/entity.ts


var employeeEntity = {
    model: model,
    repository: repository
};
/* harmony default export */ var employee_entity = (employeeEntity);


/***/ }),

/***/ 41:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ imageGallery_entity; }
});

;// CONCATENATED MODULE: ./src/entities/imageGallery/graphql.ts
// language=GraphQL
var ALL_IMAGE_GALLERIES_QUERY = "query Query($withImages: Boolean = false) {\n  imageGalleries: imageGalleries {\n    id\n    images @include(if: $withImages) {\n      id\n      assetId\n      publicId\n      url\n      resourceType\n      format\n      width\n      height\n      caption\n      title\n      description\n    }\n  }\n}";
// language=GraphQL
var SINGLE_IMAGE_GALLERY_QUERY = "query Query($id: ID!, $withImages: Boolean = false) {\n  imageGallery: imageGallery(id: $id) {\n    id\n    images @include(if: $withImages) {\n      id\n      assetId\n      publicId\n      url\n      resourceType\n      format\n      width\n      height\n      caption\n      title\n      description\n    }\n  }\n}";
// language=GraphQL
var CREATE_IMAGE_GALLERY_MUTATION = "\n  mutation Mutation($input: CreateImageGalleryInput, $withImages: Boolean = false) {\n    imageGallery: createImageGallery(input: $input) {\n      id\n      images @include(if: $withImages) {\n        id\n        assetId\n        publicId\n        url\n        resourceType\n        format\n        width\n        height\n        caption\n        title\n        description\n      }\n    }\n  }";
// language=GraphQL
var UPDATE_IMAGE_GALLERY_MUTATION = "\n  mutation Mutation($input: UpdateImageGalleryInput, $withImages: Boolean = false) {\n    imageGallery: updateImageGallery(input: $input) {\n      id\n      images @include(if: $withImages) {\n        id\n        assetId\n        publicId\n        url\n        resourceType\n        format\n        width\n        height\n        caption\n        title\n        description\n      }\n    }\n  }";
// language=GraphQL
var DELETE_IMAGE_GALLERY_MUTATION = "\n  mutation Mutation($input: DeleteImageGalleryInput) {\n    deleteImageGallery(input: $input) {\n      success\n    }\n  }";
// language=GraphQL
var FORCE_DELETE_IMAGE_GALLERY_MUTATION = "\n  mutation Mutation($input: DeleteImageGalleryInput) {\n    forceDeleteImageGallery(input: $input) {\n      success\n    }\n  }";
// language=GraphQL
var ADD_IMAGE_GALLERY_IMAGES_MUTATION = "\n  mutation Mutation($input: addImageGalleryImagesInput) {\n    addImageGalleryImages(input: $input) {\n      id\n      imageIds\n    }\n  }";
// language=GraphQL
var REMOVE_IMAGE_GALLERY_IMAGES_MUTATION = "\n  mutation Mutation($input: removeImageGalleryImagesInput) {\n    removeImageGalleryImages(input: $input) {\n      id\n      imageIds\n    }\n  }";
// language=GraphQL
var CREATE_IMAGE_GALLERY_IMAGES_MUTATION = "\n  mutation Mutation($input: createImageGalleryImagesInput) {\n    createImageGalleryImages(input: $input) {\n      id\n      imageIds\n    }\n  }";
// language=GraphQL
var DELETE_IMAGE_GALLERY_IMAGES_MUTATION = "\n  mutation Mutation($input: deleteImageGalleryImagesInput) {\n    deleteImageGalleryImages(input: $input) {\n      id\n      imageIds\n    }\n  }";
// language=GraphQL
var UPDATE_IMAGE_GALLERY_IMAGES_ORDER_MUTATION = "\n  mutation Mutation($input: updateImageGalleryImagesOrderInput) {\n    updateImageGalleryImagesOrder(input: $input) {\n      id\n      imageIds\n    }\n  }";
// language=GraphQL
var IMAGE_GALLERIES_DEPENDENTS_QUERY = "query Query($id: ID!, $withAccommodations: Boolean = false, $withTravels: Boolean = false, $withCmsTextWithImageBlocks: Boolean = false, $withCmsSliderBlocks: Boolean = false, $withAccommodationRoomTypes: Boolean = false) {\n  groupedDependents: imageGalleryDependents(id: $id) {\n    accommodations @include(if: $withAccommodations) {\n      id\n      label\n      name\n      stars\n      description\n    }\n    travels @include(if: $withTravels) {\n      id\n      name\n      isBestseller\n      startDate\n      endDate\n      executionStatus\n      title\n      description\n      includedServices\n      excludedServices\n      pricingTable\n      priceCalculationInfo\n      programType\n      programText\n      minPrice\n      minPriceManualOverride\n      currency    }\n    cmsTextWithImageBlocks @include(if: $withCmsTextWithImageBlocks) {\n      id\n      title\n      subtitle\n      text\n      imagePosition\n      imageFixedAspectRatio\n    }\n    cmsSliderBlocks @include(if: $withCmsSliderBlocks) {\n      id\n      fluid\n      size\n      showDots\n      showArrows\n      showLightbox\n      autoplay    }\n    accommodationRoomTypes @include(if: $withAccommodationRoomTypes) {\n      id\n      name\n      description\n    }\n  }\n}";

// EXTERNAL MODULE: ./src/entities/mediaFile/entity.ts + 3 modules
var entity = __webpack_require__(24180);
;// CONCATENATED MODULE: ./src/entities/imageGallery/model.ts


var imageGalleryModel = {
    name: "imageGallery",
    namePlural: "imageGalleries",
    uniqueName: "imageGallery",
    uniqueNamePlural: "imageGalleries",
    path: "media/image_gallery",
    baseUrl: "/media/image_galleries",
    translationPrefix: "entities:imageGallery.",
    getDisplayName: function(values) {
        return "";
    },
    gql: {
        getAll: ALL_IMAGE_GALLERIES_QUERY,
        getSingle: SINGLE_IMAGE_GALLERY_QUERY,
        create: CREATE_IMAGE_GALLERY_MUTATION,
        update: UPDATE_IMAGE_GALLERY_MUTATION,
        delete: DELETE_IMAGE_GALLERY_MUTATION,
        forceDelete: FORCE_DELETE_IMAGE_GALLERY_MUTATION
    },
    attributes: {
        images: {
            name: "images",
            label: "entities:imageGallery.attributes.images.label",
            type: "entityCollection",
            dataType: "[any]",
            getEntity: function() {
                return entity/* default */.Z;
            },
            defaultInput: false,
            inputType: "text",
            validationType: "string",
            validations: []
        }
    }
};
/* harmony default export */ var model = (imageGalleryModel);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(20414);
// EXTERNAL MODULE: ./src/entities/lib.ts
var lib = __webpack_require__(23480);
// EXTERNAL MODULE: ./src/lib/api/graphQLClient.ts
var graphQLClient = __webpack_require__(40112);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/swr/dist/index.mjs
var dist = __webpack_require__(8100);
// EXTERNAL MODULE: ./src/lib/helpers/helpers.ts
var helpers = __webpack_require__(15778);
;// CONCATENATED MODULE: ./src/entities/imageGallery/repository.ts










var hydrateObjects = function(objects) {
    return objects.map(function(object) {
        return (0,lib/* hydrateEntityObject */.b)(model, object);
    });
};
var hydrateObject = function(object) {
    return (0,lib/* hydrateEntityObject */.b)(model, object);
};
var imageGalleryRepository = {
    getObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    id: id
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(SINGLE_IMAGE_GALLERY_QUERY, variables).then(function(data) {
                        return hydrateObject(data.imageGallery);
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }(),
    getObjects: /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        var includes;
        var _arguments = arguments;
        return (0,tslib_es6.__generator)(this, function(_state) {
            includes = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : {};
            return [
                2,
                graphQLClient/* default.request */.Z.request(ALL_IMAGE_GALLERIES_QUERY, includes).then(function(data) {
                    return hydrateObjects(data.imageGalleries);
                })
            ];
        });
    }),
    useObject: function(id) {
        var includes = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        // eslint-disable-next-line react-hooks/exhaustive-deps
        var variables = (0,react.useMemo)(function() {
            return (0,_object_spread/* default */.Z)({
                id: id
            }, includes);
        }, [
            id
        ]);
        var ref = (0,dist/* default */.ZP)([
            SINGLE_IMAGE_GALLERY_QUERY,
            variables
        ], {
            revalidateOnFocus: false
        }), data = ref.data, error = ref.error, mutate = ref.mutate;
        return {
            object: !data ? data : hydrateObject(data.imageGallery),
            isLoading: !error && !data,
            isError: error,
            mutate: mutate
        };
    },
    useObjects: function() {
        var includes = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        // eslint-disable-next-line react-hooks/exhaustive-deps
        var variables = (0,react.useMemo)(function() {
            return includes;
        }, []);
        var ref = (0,dist/* default */.ZP)([
            ALL_IMAGE_GALLERIES_QUERY,
            variables
        ]), data = ref.data, error = ref.error, mutate = ref.mutate;
        return {
            objects: !data ? data : hydrateObjects(data.imageGalleries),
            isLoading: !error && !data,
            isError: error,
            mutate: mutate
        };
    },
    getDependents: function(id, includes) {
        var includeVars = {};
        includes.forEach(function(include) {
            includeVars["with".concat((0,helpers/* uppercaseFirst */.AB)(include))] = true;
        });
        var variables = (0,_object_spread/* default */.Z)({
            id: id
        }, includeVars);
        return graphQLClient/* default.request */.Z.request(IMAGE_GALLERIES_DEPENDENTS_QUERY, variables).then(function(data) {
            return data.groupedDependents;
        });
    },
    useDependents: function(id, includes) {
        var includeVars = {};
        includes.forEach(function(include) {
            includeVars["with".concat((0,helpers/* uppercaseFirst */.AB)(include))] = true;
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
        var variables = (0,react.useMemo)(function() {
            return (0,_object_spread/* default */.Z)({
                id: id
            }, includeVars);
        }, [
            id
        ]);
        var ref = (0,dist/* default */.ZP)([
            IMAGE_GALLERIES_DEPENDENTS_QUERY,
            variables
        ], {
            revalidateOnFocus: false
        }), data = ref.data, error = ref.error, mutate = ref.mutate;
        return {
            data: !data ? data : data.groupedDependents,
            isLoading: !error && !data,
            isError: error,
            mutate: mutate
        };
    },
    createObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(data) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    input: data
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(CREATE_IMAGE_GALLERY_MUTATION, variables).then(function(data) {
                        return hydrateObject(data.imageGallery);
                    })
                ];
            });
        });
        return function(data) {
            return _ref.apply(this, arguments);
        };
    }(),
    updateObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(data) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    input: data
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(UPDATE_IMAGE_GALLERY_MUTATION, variables).then(function(data) {
                        return hydrateObject(data.imageGallery);
                    })
                ];
            });
        });
        return function(data) {
            return _ref.apply(this, arguments);
        };
    }(),
    deleteObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(DELETE_IMAGE_GALLERY_MUTATION, variables).then(function(data) {
                        return data.deleteImageGallery;
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }(),
    forceDeleteObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(FORCE_DELETE_IMAGE_GALLERY_MUTATION, variables).then(function(data) {
                        return data.forceDeleteImageGallery;
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }(),
    assignImages: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, itemIds) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        imageIds: itemIds
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(ADD_IMAGE_GALLERY_IMAGES_MUTATION, variables)
                ];
            });
        });
        return function(id, itemIds) {
            return _ref.apply(this, arguments);
        };
    }(),
    unassignImages: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, itemIds) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        imageIds: itemIds
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(REMOVE_IMAGE_GALLERY_IMAGES_MUTATION, variables)
                ];
            });
        });
        return function(id, itemIds) {
            return _ref.apply(this, arguments);
        };
    }(),
    createImages: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, items) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        images: items
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(CREATE_IMAGE_GALLERY_IMAGES_MUTATION, variables)
                ];
            });
        });
        return function(id, items) {
            return _ref.apply(this, arguments);
        };
    }(),
    deleteImages: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, itemIds) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        imageIds: itemIds
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(DELETE_IMAGE_GALLERY_IMAGES_MUTATION, variables)
                ];
            });
        });
        return function(id, itemIds) {
            return _ref.apply(this, arguments);
        };
    }(),
    updateImagesOrder: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, itemIds) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        imageIds: itemIds
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(UPDATE_IMAGE_GALLERY_IMAGES_ORDER_MUTATION, variables)
                ];
            });
        });
        return function(id, itemIds) {
            return _ref.apply(this, arguments);
        };
    }()
};
/* harmony default export */ var repository = (imageGalleryRepository);

;// CONCATENATED MODULE: ./src/entities/imageGallery/entity.ts


var imageGalleryEntity = {
    model: model,
    repository: repository
};
/* harmony default export */ var imageGallery_entity = (imageGalleryEntity);


/***/ }),

/***/ 80231:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ itinerary_entity; }
});

;// CONCATENATED MODULE: ./src/entities/itinerary/graphql.ts
// language=GraphQL
var ALL_ITINERARIES_QUERY = "query Query($withItems: Boolean = false, $withItemsImage: Boolean = false, $withItemsMapMarkers: Boolean = false) {\n  itineraries: itineraries {\n    id\n    items @include(if: $withItems) {\n      id\n      duration\n      title\n      text\n      image @include(if: $withItemsImage) {\n        id\n        assetId\n        publicId\n        url\n        resourceType\n        format\n        width\n        height\n        caption\n        title\n        description\n      }\n      mapMarkers @include(if: $withItemsMapMarkers) {\n        id\n        lat\n        lng\n      }\n    }\n  }\n}";
// language=GraphQL
var SINGLE_ITINERARY_QUERY = "query Query($id: ID!, $withItems: Boolean = false, $withItemsImage: Boolean = false, $withItemsMapMarkers: Boolean = false) {\n  itinerary: itinerary(id: $id) {\n    id\n    items @include(if: $withItems) {\n      id\n      duration\n      title\n      text\n      image @include(if: $withItemsImage) {\n        id\n        assetId\n        publicId\n        url\n        resourceType\n        format\n        width\n        height\n        caption\n        title\n        description\n      }\n      mapMarkers @include(if: $withItemsMapMarkers) {\n        id\n        lat\n        lng\n      }\n    }\n  }\n}";
// language=GraphQL
var CREATE_ITINERARY_MUTATION = "\n  mutation Mutation($input: CreateItineraryInput, $withItems: Boolean = false, $withItemsImage: Boolean = false, $withItemsMapMarkers: Boolean = false) {\n    itinerary: createItinerary(input: $input) {\n      id\n      items @include(if: $withItems) {\n        id\n        duration\n        title\n        text\n        image @include(if: $withItemsImage) {\n          id\n          assetId\n          publicId\n          url\n          resourceType\n          format\n          width\n          height\n          caption\n          title\n          description\n        }\n        mapMarkers @include(if: $withItemsMapMarkers) {\n          id\n          lat\n          lng\n        }\n      }\n    }\n  }";
// language=GraphQL
var UPDATE_ITINERARY_MUTATION = "\n  mutation Mutation($input: UpdateItineraryInput, $withItems: Boolean = false, $withItemsImage: Boolean = false, $withItemsMapMarkers: Boolean = false) {\n    itinerary: updateItinerary(input: $input) {\n      id\n      items @include(if: $withItems) {\n        id\n        duration\n        title\n        text\n        image @include(if: $withItemsImage) {\n          id\n          assetId\n          publicId\n          url\n          resourceType\n          format\n          width\n          height\n          caption\n          title\n          description\n        }\n        mapMarkers @include(if: $withItemsMapMarkers) {\n          id\n          lat\n          lng\n        }\n      }\n    }\n  }";
// language=GraphQL
var DELETE_ITINERARY_MUTATION = "\n  mutation Mutation($input: DeleteItineraryInput) {\n    deleteItinerary(input: $input) {\n      success\n    }\n  }";
// language=GraphQL
var FORCE_DELETE_ITINERARY_MUTATION = "\n  mutation Mutation($input: DeleteItineraryInput) {\n    forceDeleteItinerary(input: $input) {\n      success\n    }\n  }";
// language=GraphQL
var ADD_ITINERARY_ITEMS_MUTATION = "\n  mutation Mutation($input: addItineraryItemsInput) {\n    addItineraryItems(input: $input) {\n      id\n      itemIds\n    }\n  }";
// language=GraphQL
var REMOVE_ITINERARY_ITEMS_MUTATION = "\n  mutation Mutation($input: removeItineraryItemsInput) {\n    removeItineraryItems(input: $input) {\n      id\n      itemIds\n    }\n  }";
// language=GraphQL
var CREATE_ITINERARY_ITEMS_MUTATION = "\n  mutation Mutation($input: createItineraryItemsInput) {\n    createItineraryItems(input: $input) {\n      id\n      itemIds\n    }\n  }";
// language=GraphQL
var DELETE_ITINERARY_ITEMS_MUTATION = "\n  mutation Mutation($input: deleteItineraryItemsInput) {\n    deleteItineraryItems(input: $input) {\n      id\n      itemIds\n    }\n  }";
// language=GraphQL
var UPDATE_ITINERARY_ITEMS_ORDER_MUTATION = "\n  mutation Mutation($input: updateItineraryItemsOrderInput) {\n    updateItineraryItemsOrder(input: $input) {\n      id\n      itemIds\n    }\n  }";
// language=GraphQL
var ITINERARIES_DEPENDENTS_QUERY = "query Query($id: ID!, $withTravels: Boolean = false) {\n  groupedDependents: itineraryDependents(id: $id) {\n    travels @include(if: $withTravels) {\n      id\n      name\n      isBestseller\n      startDate\n      endDate\n      executionStatus\n      title\n      description\n      includedServices\n      excludedServices\n      pricingTable\n      priceCalculationInfo\n      programType\n      programText\n      minPrice\n      minPriceManualOverride\n      currency    }\n  }\n}";

// EXTERNAL MODULE: ./src/entities/itineraryItem/entity.ts + 3 modules
var entity = __webpack_require__(12540);
;// CONCATENATED MODULE: ./src/entities/itinerary/model.ts


var itineraryModel = {
    name: "itinerary",
    namePlural: "itineraries",
    uniqueName: "itinerary",
    uniqueNamePlural: "itineraries",
    path: "travel/itinerary/itinerary",
    baseUrl: "/travel/itinerary/itineraries",
    translationPrefix: "entities:itinerary.",
    getDisplayName: function(values) {
        return "Itinerary";
    },
    gql: {
        getAll: ALL_ITINERARIES_QUERY,
        getSingle: SINGLE_ITINERARY_QUERY,
        create: CREATE_ITINERARY_MUTATION,
        update: UPDATE_ITINERARY_MUTATION,
        delete: DELETE_ITINERARY_MUTATION,
        forceDelete: FORCE_DELETE_ITINERARY_MUTATION
    },
    attributes: {
        items: {
            name: "items",
            label: "entities:itinerary.attributes.items.label",
            type: "entityCollection",
            dataType: "[any]",
            getEntity: function() {
                return entity/* default */.Z;
            },
            defaultInput: false,
            inputType: "text",
            validationType: "string",
            validations: []
        }
    }
};
/* harmony default export */ var model = (itineraryModel);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(20414);
// EXTERNAL MODULE: ./src/entities/lib.ts
var lib = __webpack_require__(23480);
// EXTERNAL MODULE: ./src/lib/api/graphQLClient.ts
var graphQLClient = __webpack_require__(40112);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/swr/dist/index.mjs
var dist = __webpack_require__(8100);
// EXTERNAL MODULE: ./src/lib/helpers/helpers.ts
var helpers = __webpack_require__(15778);
;// CONCATENATED MODULE: ./src/entities/itinerary/repository.ts










var hydrateObjects = function(objects) {
    return objects.map(function(object) {
        return (0,lib/* hydrateEntityObject */.b)(model, object);
    });
};
var hydrateObject = function(object) {
    return (0,lib/* hydrateEntityObject */.b)(model, object);
};
var itineraryRepository = {
    getObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    id: id
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(SINGLE_ITINERARY_QUERY, variables).then(function(data) {
                        return hydrateObject(data.itinerary);
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }(),
    getObjects: /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        var includes;
        var _arguments = arguments;
        return (0,tslib_es6.__generator)(this, function(_state) {
            includes = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : {};
            return [
                2,
                graphQLClient/* default.request */.Z.request(ALL_ITINERARIES_QUERY, includes).then(function(data) {
                    return hydrateObjects(data.itineraries);
                })
            ];
        });
    }),
    useObject: function(id) {
        var includes = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        // eslint-disable-next-line react-hooks/exhaustive-deps
        var variables = (0,react.useMemo)(function() {
            return (0,_object_spread/* default */.Z)({
                id: id
            }, includes);
        }, [
            id
        ]);
        var ref = (0,dist/* default */.ZP)([
            SINGLE_ITINERARY_QUERY,
            variables
        ], {
            revalidateOnFocus: false
        }), data = ref.data, error = ref.error, mutate = ref.mutate;
        return {
            object: !data ? data : hydrateObject(data.itinerary),
            isLoading: !error && !data,
            isError: error,
            mutate: mutate
        };
    },
    useObjects: function() {
        var includes = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        // eslint-disable-next-line react-hooks/exhaustive-deps
        var variables = (0,react.useMemo)(function() {
            return includes;
        }, []);
        var ref = (0,dist/* default */.ZP)([
            ALL_ITINERARIES_QUERY,
            variables
        ]), data = ref.data, error = ref.error, mutate = ref.mutate;
        return {
            objects: !data ? data : hydrateObjects(data.itineraries),
            isLoading: !error && !data,
            isError: error,
            mutate: mutate
        };
    },
    getDependents: function(id, includes) {
        var includeVars = {};
        includes.forEach(function(include) {
            includeVars["with".concat((0,helpers/* uppercaseFirst */.AB)(include))] = true;
        });
        var variables = (0,_object_spread/* default */.Z)({
            id: id
        }, includeVars);
        return graphQLClient/* default.request */.Z.request(ITINERARIES_DEPENDENTS_QUERY, variables).then(function(data) {
            return data.groupedDependents;
        });
    },
    useDependents: function(id, includes) {
        var includeVars = {};
        includes.forEach(function(include) {
            includeVars["with".concat((0,helpers/* uppercaseFirst */.AB)(include))] = true;
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
        var variables = (0,react.useMemo)(function() {
            return (0,_object_spread/* default */.Z)({
                id: id
            }, includeVars);
        }, [
            id
        ]);
        var ref = (0,dist/* default */.ZP)([
            ITINERARIES_DEPENDENTS_QUERY,
            variables
        ], {
            revalidateOnFocus: false
        }), data = ref.data, error = ref.error, mutate = ref.mutate;
        return {
            data: !data ? data : data.groupedDependents,
            isLoading: !error && !data,
            isError: error,
            mutate: mutate
        };
    },
    createObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(data) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    input: data
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(CREATE_ITINERARY_MUTATION, variables).then(function(data) {
                        return hydrateObject(data.itinerary);
                    })
                ];
            });
        });
        return function(data) {
            return _ref.apply(this, arguments);
        };
    }(),
    updateObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(data) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    input: data
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(UPDATE_ITINERARY_MUTATION, variables).then(function(data) {
                        return hydrateObject(data.itinerary);
                    })
                ];
            });
        });
        return function(data) {
            return _ref.apply(this, arguments);
        };
    }(),
    deleteObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(DELETE_ITINERARY_MUTATION, variables).then(function(data) {
                        return data.deleteItinerary;
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }(),
    forceDeleteObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(FORCE_DELETE_ITINERARY_MUTATION, variables).then(function(data) {
                        return data.forceDeleteItinerary;
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }(),
    assignItems: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, itemIds) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        itemIds: itemIds
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(ADD_ITINERARY_ITEMS_MUTATION, variables)
                ];
            });
        });
        return function(id, itemIds) {
            return _ref.apply(this, arguments);
        };
    }(),
    unassignItems: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, itemIds) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        itemIds: itemIds
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(REMOVE_ITINERARY_ITEMS_MUTATION, variables)
                ];
            });
        });
        return function(id, itemIds) {
            return _ref.apply(this, arguments);
        };
    }(),
    createItems: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, items) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        items: items
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(CREATE_ITINERARY_ITEMS_MUTATION, variables)
                ];
            });
        });
        return function(id, items) {
            return _ref.apply(this, arguments);
        };
    }(),
    deleteItems: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, itemIds) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        itemIds: itemIds
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(DELETE_ITINERARY_ITEMS_MUTATION, variables)
                ];
            });
        });
        return function(id, itemIds) {
            return _ref.apply(this, arguments);
        };
    }(),
    updateItemsOrder: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, itemIds) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        itemIds: itemIds
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(UPDATE_ITINERARY_ITEMS_ORDER_MUTATION, variables)
                ];
            });
        });
        return function(id, itemIds) {
            return _ref.apply(this, arguments);
        };
    }()
};
/* harmony default export */ var repository = (itineraryRepository);

;// CONCATENATED MODULE: ./src/entities/itinerary/entity.ts


var itineraryEntity = {
    model: model,
    repository: repository
};
/* harmony default export */ var itinerary_entity = (itineraryEntity);


/***/ }),

/***/ 12540:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ itineraryItem_entity; }
});

;// CONCATENATED MODULE: ./src/entities/itineraryItem/graphql.ts
// language=GraphQL
var ALL_ITEMS_QUERY = "query Query($withImage: Boolean = false, $withMapMarkers: Boolean = false) {\n  items: itineraryItems {\n    id\n    duration\n    title\n    text\n    image @include(if: $withImage) {\n      id\n      assetId\n      publicId\n      url\n      resourceType\n      format\n      width\n      height\n      caption\n      title\n      description\n    }\n    mapMarkers @include(if: $withMapMarkers) {\n      id\n      lat\n      lng\n    }\n  }\n}";
// language=GraphQL
var SINGLE_ITEM_QUERY = "query Query($id: ID!, $withImage: Boolean = false, $withMapMarkers: Boolean = false) {\n  item: itineraryItem(id: $id) {\n    id\n    duration\n    title\n    text\n    image @include(if: $withImage) {\n      id\n      assetId\n      publicId\n      url\n      resourceType\n      format\n      width\n      height\n      caption\n      title\n      description\n    }\n    mapMarkers @include(if: $withMapMarkers) {\n      id\n      lat\n      lng\n    }\n  }\n}";
// language=GraphQL
var CREATE_ITEM_MUTATION = "\n  mutation Mutation($input: CreateItineraryItemInput, $withImage: Boolean = false, $withMapMarkers: Boolean = false) {\n    item: createItineraryItem(input: $input) {\n      id\n      duration\n      title\n      text\n      image @include(if: $withImage) {\n        id\n        assetId\n        publicId\n        url\n        resourceType\n        format\n        width\n        height\n        caption\n        title\n        description\n      }\n      mapMarkers @include(if: $withMapMarkers) {\n        id\n        lat\n        lng\n      }\n    }\n  }";
// language=GraphQL
var UPDATE_ITEM_MUTATION = "\n  mutation Mutation($input: UpdateItineraryItemInput, $withImage: Boolean = false, $withMapMarkers: Boolean = false) {\n    item: updateItineraryItem(input: $input) {\n      id\n      duration\n      title\n      text\n      image @include(if: $withImage) {\n        id\n        assetId\n        publicId\n        url\n        resourceType\n        format\n        width\n        height\n        caption\n        title\n        description\n      }\n      mapMarkers @include(if: $withMapMarkers) {\n        id\n        lat\n        lng\n      }\n    }\n  }";
// language=GraphQL
var DELETE_ITEM_MUTATION = "\n  mutation Mutation($input: DeleteItineraryItemInput) {\n    deleteItineraryItem(input: $input) {\n      success\n    }\n  }";
// language=GraphQL
var FORCE_DELETE_ITEM_MUTATION = "\n  mutation Mutation($input: DeleteItineraryItemInput) {\n    forceDeleteItineraryItem(input: $input) {\n      success\n    }\n  }";
// language=GraphQL
var ADD_ITEM_MAP_MARKERS_MUTATION = "\n  mutation Mutation($input: addItineraryItemMapMarkersInput) {\n    addItineraryItemMapMarkers(input: $input) {\n      id\n      mapMarkerIds\n    }\n  }";
// language=GraphQL
var REMOVE_ITEM_MAP_MARKERS_MUTATION = "\n  mutation Mutation($input: removeItineraryItemMapMarkersInput) {\n    removeItineraryItemMapMarkers(input: $input) {\n      id\n      mapMarkerIds\n    }\n  }";
// language=GraphQL
var CREATE_ITEM_MAP_MARKERS_MUTATION = "\n  mutation Mutation($input: createItineraryItemMapMarkersInput) {\n    createItineraryItemMapMarkers(input: $input) {\n      id\n      mapMarkerIds\n    }\n  }";
// language=GraphQL
var DELETE_ITEM_MAP_MARKERS_MUTATION = "\n  mutation Mutation($input: deleteItineraryItemMapMarkersInput) {\n    deleteItineraryItemMapMarkers(input: $input) {\n      id\n      mapMarkerIds\n    }\n  }";
// language=GraphQL
var UPDATE_ITEM_MAP_MARKERS_ORDER_MUTATION = "\n  mutation Mutation($input: updateItineraryItemMapMarkersOrderInput) {\n    updateItineraryItemMapMarkersOrder(input: $input) {\n      id\n      mapMarkerIds\n    }\n  }";
// language=GraphQL
var ITEMS_DEPENDENTS_QUERY = "query Query($id: ID!, $withItineraries: Boolean = false) {\n  groupedDependents: itineraryItemDependents(id: $id) {\n    itineraries @include(if: $withItineraries) {\n      id\n    }\n  }\n}";

// EXTERNAL MODULE: ./src/entities/mediaFile/entity.ts + 3 modules
var entity = __webpack_require__(24180);
// EXTERNAL MODULE: ./src/entities/itineraryMapMarker/entity.ts + 3 modules
var itineraryMapMarker_entity = __webpack_require__(89232);
;// CONCATENATED MODULE: ./src/entities/itineraryItem/model.ts



var itineraryItemModel = {
    name: "item",
    namePlural: "items",
    uniqueName: "itineraryItem",
    uniqueNamePlural: "itineraryItems",
    path: "travel/itinerary/item",
    baseUrl: "/travel/itinerary/items",
    translationPrefix: "entities:itineraryItem.",
    getDisplayName: function(values) {
        return values.title;
    },
    gql: {
        getAll: ALL_ITEMS_QUERY,
        getSingle: SINGLE_ITEM_QUERY,
        create: CREATE_ITEM_MUTATION,
        update: UPDATE_ITEM_MUTATION,
        delete: DELETE_ITEM_MUTATION,
        forceDelete: FORCE_DELETE_ITEM_MUTATION
    },
    attributes: {
        duration: {
            name: "duration",
            label: "entities:itineraryItem.attributes.duration.label",
            type: "value",
            dataType: "number",
            defaultValue: 1,
            defaultInput: true,
            inputType: "text",
            validationType: "string",
            validations: [
                {
                    type: "required"
                }, 
            ]
        },
        title: {
            name: "title",
            label: "entities:itineraryItem.attributes.title.label",
            type: "value",
            dataType: "string",
            defaultInput: true,
            inputType: "text",
            validationType: "string",
            validations: [
                {
                    type: "required"
                }, 
            ]
        },
        text: {
            name: "text",
            label: "entities:itineraryItem.attributes.text.label",
            type: "value",
            dataType: "string",
            defaultInput: true,
            inputType: "textarea",
            validationType: "string",
            validations: [
                {
                    type: "required"
                }, 
            ]
        },
        image: {
            name: "image",
            label: "entities:itineraryItem.attributes.image.label",
            type: "entityObject",
            dataType: "any",
            getEntity: function() {
                return entity/* default */.Z;
            },
            defaultInput: false,
            inputType: "select",
            validationType: "string",
            validations: []
        },
        mapMarkers: {
            name: "mapMarkers",
            label: "entities:itineraryItem.attributes.mapMarkers.label",
            type: "entityCollection",
            dataType: "[any]",
            getEntity: function() {
                return itineraryMapMarker_entity/* default */.Z;
            },
            defaultInput: false,
            inputType: "text",
            validationType: "string",
            validations: []
        }
    }
};
/* harmony default export */ var model = (itineraryItemModel);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(20414);
// EXTERNAL MODULE: ./src/entities/lib.ts
var lib = __webpack_require__(23480);
// EXTERNAL MODULE: ./src/lib/api/graphQLClient.ts
var graphQLClient = __webpack_require__(40112);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/swr/dist/index.mjs
var dist = __webpack_require__(8100);
// EXTERNAL MODULE: ./src/lib/helpers/helpers.ts
var helpers = __webpack_require__(15778);
;// CONCATENATED MODULE: ./src/entities/itineraryItem/repository.ts










var hydrateObjects = function(objects) {
    return objects.map(function(object) {
        return (0,lib/* hydrateEntityObject */.b)(model, object);
    });
};
var hydrateObject = function(object) {
    return (0,lib/* hydrateEntityObject */.b)(model, object);
};
var itineraryItemRepository = {
    getObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    id: id
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(SINGLE_ITEM_QUERY, variables).then(function(data) {
                        return hydrateObject(data.item);
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }(),
    getObjects: /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        var includes;
        var _arguments = arguments;
        return (0,tslib_es6.__generator)(this, function(_state) {
            includes = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : {};
            return [
                2,
                graphQLClient/* default.request */.Z.request(ALL_ITEMS_QUERY, includes).then(function(data) {
                    return hydrateObjects(data.items);
                })
            ];
        });
    }),
    useObject: function(id) {
        var includes = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        // eslint-disable-next-line react-hooks/exhaustive-deps
        var variables = (0,react.useMemo)(function() {
            return (0,_object_spread/* default */.Z)({
                id: id
            }, includes);
        }, [
            id
        ]);
        var ref = (0,dist/* default */.ZP)([
            SINGLE_ITEM_QUERY,
            variables
        ], {
            revalidateOnFocus: false
        }), data = ref.data, error = ref.error, mutate = ref.mutate;
        return {
            object: !data ? data : hydrateObject(data.item),
            isLoading: !error && !data,
            isError: error,
            mutate: mutate
        };
    },
    useObjects: function() {
        var includes = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        // eslint-disable-next-line react-hooks/exhaustive-deps
        var variables = (0,react.useMemo)(function() {
            return includes;
        }, []);
        var ref = (0,dist/* default */.ZP)([
            ALL_ITEMS_QUERY,
            variables
        ]), data = ref.data, error = ref.error, mutate = ref.mutate;
        return {
            objects: !data ? data : hydrateObjects(data.items),
            isLoading: !error && !data,
            isError: error,
            mutate: mutate
        };
    },
    getDependents: function(id, includes) {
        var includeVars = {};
        includes.forEach(function(include) {
            includeVars["with".concat((0,helpers/* uppercaseFirst */.AB)(include))] = true;
        });
        var variables = (0,_object_spread/* default */.Z)({
            id: id
        }, includeVars);
        return graphQLClient/* default.request */.Z.request(ITEMS_DEPENDENTS_QUERY, variables).then(function(data) {
            return data.groupedDependents;
        });
    },
    useDependents: function(id, includes) {
        var includeVars = {};
        includes.forEach(function(include) {
            includeVars["with".concat((0,helpers/* uppercaseFirst */.AB)(include))] = true;
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
        var variables = (0,react.useMemo)(function() {
            return (0,_object_spread/* default */.Z)({
                id: id
            }, includeVars);
        }, [
            id
        ]);
        var ref = (0,dist/* default */.ZP)([
            ITEMS_DEPENDENTS_QUERY,
            variables
        ], {
            revalidateOnFocus: false
        }), data = ref.data, error = ref.error, mutate = ref.mutate;
        return {
            data: !data ? data : data.groupedDependents,
            isLoading: !error && !data,
            isError: error,
            mutate: mutate
        };
    },
    createObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(data) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    input: data
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(CREATE_ITEM_MUTATION, variables).then(function(data) {
                        return hydrateObject(data.item);
                    })
                ];
            });
        });
        return function(data) {
            return _ref.apply(this, arguments);
        };
    }(),
    updateObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(data) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    input: data
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(UPDATE_ITEM_MUTATION, variables).then(function(data) {
                        return hydrateObject(data.item);
                    })
                ];
            });
        });
        return function(data) {
            return _ref.apply(this, arguments);
        };
    }(),
    deleteObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(DELETE_ITEM_MUTATION, variables).then(function(data) {
                        return data.deleteItineraryItem;
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }(),
    forceDeleteObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(FORCE_DELETE_ITEM_MUTATION, variables).then(function(data) {
                        return data.forceDeleteItineraryItem;
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }(),
    assignMapMarkers: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, itemIds) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        mapMarkerIds: itemIds
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(ADD_ITEM_MAP_MARKERS_MUTATION, variables)
                ];
            });
        });
        return function(id, itemIds) {
            return _ref.apply(this, arguments);
        };
    }(),
    unassignMapMarkers: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, itemIds) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        mapMarkerIds: itemIds
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(REMOVE_ITEM_MAP_MARKERS_MUTATION, variables)
                ];
            });
        });
        return function(id, itemIds) {
            return _ref.apply(this, arguments);
        };
    }(),
    createMapMarkers: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, items) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        mapMarkers: items
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(CREATE_ITEM_MAP_MARKERS_MUTATION, variables)
                ];
            });
        });
        return function(id, items) {
            return _ref.apply(this, arguments);
        };
    }(),
    deleteMapMarkers: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, itemIds) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        mapMarkerIds: itemIds
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(DELETE_ITEM_MAP_MARKERS_MUTATION, variables)
                ];
            });
        });
        return function(id, itemIds) {
            return _ref.apply(this, arguments);
        };
    }(),
    updateMapMarkersOrder: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, itemIds) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        mapMarkerIds: itemIds
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(UPDATE_ITEM_MAP_MARKERS_ORDER_MUTATION, variables)
                ];
            });
        });
        return function(id, itemIds) {
            return _ref.apply(this, arguments);
        };
    }()
};
/* harmony default export */ var repository = (itineraryItemRepository);

;// CONCATENATED MODULE: ./src/entities/itineraryItem/entity.ts


var itineraryItemEntity = {
    model: model,
    repository: repository
};
/* harmony default export */ var itineraryItem_entity = (itineraryItemEntity);


/***/ }),

/***/ 89232:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ entity; }
});

;// CONCATENATED MODULE: ./src/entities/itineraryMapMarker/graphql.ts
// language=GraphQL
var ALL_MAP_MARKERS_QUERY = "query Query {\n  mapMarkers: itineraryMapMarkers {\n    id\n    lat\n    lng\n  }\n}";
// language=GraphQL
var SINGLE_MAP_MARKER_QUERY = "query Query($id: ID!) {\n  mapMarker: itineraryMapMarker(id: $id) {\n    id\n    lat\n    lng\n  }\n}";
// language=GraphQL
var CREATE_MAP_MARKER_MUTATION = "\n  mutation Mutation($input: CreateItineraryMapMarkerInput) {\n    mapMarker: createItineraryMapMarker(input: $input) {\n      id\n      lat\n      lng\n    }\n  }";
// language=GraphQL
var UPDATE_MAP_MARKER_MUTATION = "\n  mutation Mutation($input: UpdateItineraryMapMarkerInput) {\n    mapMarker: updateItineraryMapMarker(input: $input) {\n      id\n      lat\n      lng\n    }\n  }";
// language=GraphQL
var DELETE_MAP_MARKER_MUTATION = "\n  mutation Mutation($input: DeleteItineraryMapMarkerInput) {\n    deleteItineraryMapMarker(input: $input) {\n      success\n    }\n  }";
// language=GraphQL
var FORCE_DELETE_MAP_MARKER_MUTATION = "\n  mutation Mutation($input: DeleteItineraryMapMarkerInput) {\n    forceDeleteItineraryMapMarker(input: $input) {\n      success\n    }\n  }";
// language=GraphQL
var MAP_MARKERS_DEPENDENTS_QUERY = "query Query($id: ID!, $withItineraryItems: Boolean = false) {\n  groupedDependents: itineraryMapMarkerDependents(id: $id) {\n    itineraryItems @include(if: $withItineraryItems) {\n      id\n      duration\n      title\n      text\n    }\n  }\n}";

;// CONCATENATED MODULE: ./src/entities/itineraryMapMarker/model.ts

var itineraryMapMarkerModel = {
    name: "mapMarker",
    namePlural: "mapMarkers",
    uniqueName: "itineraryMapMarker",
    uniqueNamePlural: "itineraryMapMarkers",
    path: "travel/itinerary/map_marker",
    baseUrl: "/travel/itinerary/map_markers",
    translationPrefix: "entities:itineraryMapMarker.",
    getDisplayName: function(values) {
        return "Map Marker";
    },
    gql: {
        getAll: ALL_MAP_MARKERS_QUERY,
        getSingle: SINGLE_MAP_MARKER_QUERY,
        create: CREATE_MAP_MARKER_MUTATION,
        update: UPDATE_MAP_MARKER_MUTATION,
        delete: DELETE_MAP_MARKER_MUTATION,
        forceDelete: FORCE_DELETE_MAP_MARKER_MUTATION
    },
    attributes: {
        lat: {
            name: "lat",
            label: "entities:itineraryMapMarker.attributes.lat.label",
            type: "value",
            dataType: "string",
            defaultInput: true,
            inputType: "text",
            validationType: "string",
            validations: [
                {
                    type: "required"
                },
                {
                    type: "regex",
                    pattern: /^[-+]?([1-8]?\d(\.\d+)?|90(\.0+)?)$/
                }, 
            ]
        },
        lng: {
            name: "lng",
            label: "entities:itineraryMapMarker.attributes.lng.label",
            type: "value",
            dataType: "string",
            defaultInput: true,
            inputType: "text",
            validationType: "string",
            validations: [
                {
                    type: "required"
                },
                {
                    type: "regex",
                    pattern: /^[-+]?(180(\.0+)?|((1[0-7]\d)|([1-9]?\d))(\.\d+)?)$/
                }, 
            ]
        }
    }
};
/* harmony default export */ var model = (itineraryMapMarkerModel);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(20414);
// EXTERNAL MODULE: ./src/entities/lib.ts
var lib = __webpack_require__(23480);
// EXTERNAL MODULE: ./src/lib/api/graphQLClient.ts
var graphQLClient = __webpack_require__(40112);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/swr/dist/index.mjs
var dist = __webpack_require__(8100);
// EXTERNAL MODULE: ./src/lib/helpers/helpers.ts
var helpers = __webpack_require__(15778);
;// CONCATENATED MODULE: ./src/entities/itineraryMapMarker/repository.ts










var hydrateObjects = function(objects) {
    return objects.map(function(object) {
        return (0,lib/* hydrateEntityObject */.b)(model, object);
    });
};
var hydrateObject = function(object) {
    return (0,lib/* hydrateEntityObject */.b)(model, object);
};
var itineraryMapMarkerRepository = {
    getObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    id: id
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(SINGLE_MAP_MARKER_QUERY, variables).then(function(data) {
                        return hydrateObject(data.mapMarker);
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }(),
    getObjects: /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        var includes;
        var _arguments = arguments;
        return (0,tslib_es6.__generator)(this, function(_state) {
            includes = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : {};
            return [
                2,
                graphQLClient/* default.request */.Z.request(ALL_MAP_MARKERS_QUERY, includes).then(function(data) {
                    return hydrateObjects(data.mapMarkers);
                })
            ];
        });
    }),
    useObject: function(id) {
        var includes = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        // eslint-disable-next-line react-hooks/exhaustive-deps
        var variables = (0,react.useMemo)(function() {
            return (0,_object_spread/* default */.Z)({
                id: id
            }, includes);
        }, [
            id
        ]);
        var ref = (0,dist/* default */.ZP)([
            SINGLE_MAP_MARKER_QUERY,
            variables
        ], {
            revalidateOnFocus: false
        }), data = ref.data, error = ref.error, mutate = ref.mutate;
        return {
            object: !data ? data : hydrateObject(data.mapMarker),
            isLoading: !error && !data,
            isError: error,
            mutate: mutate
        };
    },
    useObjects: function() {
        var includes = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        // eslint-disable-next-line react-hooks/exhaustive-deps
        var variables = (0,react.useMemo)(function() {
            return includes;
        }, []);
        var ref = (0,dist/* default */.ZP)([
            ALL_MAP_MARKERS_QUERY,
            variables
        ]), data = ref.data, error = ref.error, mutate = ref.mutate;
        return {
            objects: !data ? data : hydrateObjects(data.mapMarkers),
            isLoading: !error && !data,
            isError: error,
            mutate: mutate
        };
    },
    getDependents: function(id, includes) {
        var includeVars = {};
        includes.forEach(function(include) {
            includeVars["with".concat((0,helpers/* uppercaseFirst */.AB)(include))] = true;
        });
        var variables = (0,_object_spread/* default */.Z)({
            id: id
        }, includeVars);
        return graphQLClient/* default.request */.Z.request(MAP_MARKERS_DEPENDENTS_QUERY, variables).then(function(data) {
            return data.groupedDependents;
        });
    },
    useDependents: function(id, includes) {
        var includeVars = {};
        includes.forEach(function(include) {
            includeVars["with".concat((0,helpers/* uppercaseFirst */.AB)(include))] = true;
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
        var variables = (0,react.useMemo)(function() {
            return (0,_object_spread/* default */.Z)({
                id: id
            }, includeVars);
        }, [
            id
        ]);
        var ref = (0,dist/* default */.ZP)([
            MAP_MARKERS_DEPENDENTS_QUERY,
            variables
        ], {
            revalidateOnFocus: false
        }), data = ref.data, error = ref.error, mutate = ref.mutate;
        return {
            data: !data ? data : data.groupedDependents,
            isLoading: !error && !data,
            isError: error,
            mutate: mutate
        };
    },
    createObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(data) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    input: data
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(CREATE_MAP_MARKER_MUTATION, variables).then(function(data) {
                        return hydrateObject(data.mapMarker);
                    })
                ];
            });
        });
        return function(data) {
            return _ref.apply(this, arguments);
        };
    }(),
    updateObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(data) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    input: data
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(UPDATE_MAP_MARKER_MUTATION, variables).then(function(data) {
                        return hydrateObject(data.mapMarker);
                    })
                ];
            });
        });
        return function(data) {
            return _ref.apply(this, arguments);
        };
    }(),
    deleteObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(DELETE_MAP_MARKER_MUTATION, variables).then(function(data) {
                        return data.deleteItineraryMapMarker;
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }(),
    forceDeleteObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(FORCE_DELETE_MAP_MARKER_MUTATION, variables).then(function(data) {
                        return data.forceDeleteItineraryMapMarker;
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }()
};
/* harmony default export */ var repository = (itineraryMapMarkerRepository);

;// CONCATENATED MODULE: ./src/entities/itineraryMapMarker/entity.ts


var itineraryMapMarkerEntity = {
    model: model,
    repository: repository
};
/* harmony default export */ var entity = (itineraryMapMarkerEntity);


/***/ }),

/***/ 23480:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "b": function() { return /* binding */ hydrateEntityObject; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(828);
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(32912);

// import { TFunction } from 'next-i18next'

var hydrateEntityObject = function(model, object) {
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        // const t = i18n?.t
        for(var _iterator = Object.entries(model.attributes)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _value = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_step.value, 2), name = _value[0], attribute = _value[1];
            switch(attribute.dataType){
                case "date":
                    // set Date object
                    // object[name] = new Date(object[name])
                    object["_".concat(name, "DateObject")] = new Date(object[name]);
                    // set formatted date
                    object["_".concat(name, "Formatted")] = (0,date_fns__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(object["_".concat(name, "DateObject")], "dd.MM.y");
                    break;
            }
            if (attribute.type === "entityObject") {
                if (object[name]) {
                    // set object id
                    object["".concat(name, "Id")] = object[name].id;
                // hydrate child object
                // if (attribute.getEntity) {
                //   const model = attribute.getEntity().model
                //   object[name] = hydrateEntityObject(attribute.getEntity().model, object[`${name}`])
                //   object[`_${name}Label`] = model.getDisplayName(object[name])
                // }
                }
            }
        // select labels
        // if (attribute.inputType === 'select' && attribute.selectOptions) {
        //   const index = attribute.selectOptions.findIndex((selectOption) => selectOption.value === object[name])
        //   if (index >= 0) {
        //     // @ts-ignore
        //     object[`_${name}Label`] = t(attribute.selectOptions[index].label)
        //   }
        // }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return object;
};


/***/ }),

/***/ 90576:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ link_entity; }
});

;// CONCATENATED MODULE: ./src/entities/link/graphql.ts
// language=GraphQL
var ALL_LINKS_QUERY = "query Query($withPage: Boolean = false, $withPageSeoSettings: Boolean = false, $withPageSeoSettingsOgImage: Boolean = false, $withPageContentBlockAssignments: Boolean = false, $withPageContentBlockAssignmentsBlock: Boolean = false, $withTravel: Boolean = false, $withTravelAvailabilityStatus: Boolean = false, $withTravelAvailabilityStatusTenantSettings: Boolean = false, $withTravelTravelConsultant: Boolean = false, $withTravelTravelConsultantImage: Boolean = false, $withTravelLabel: Boolean = false, $withTravelSeoSettings: Boolean = false, $withTravelSeoSettingsOgImage: Boolean = false, $withTravelTenantSettings: Boolean = false, $withTravelTenantSettingsTenant: Boolean = false, $withTravelTenantSettingsTravelTypes: Boolean = false, $withTravelHighlights: Boolean = false, $withTravelPartners: Boolean = false, $withTravelPartnersLogo: Boolean = false, $withTravelPartnersGtcPdf: Boolean = false, $withTravelTravelGuides: Boolean = false, $withTravelTravelGuidesImage: Boolean = false, $withTravelTeams: Boolean = false, $withTravelTeamsMembers: Boolean = false, $withTravelAccommodationAssignments: Boolean = false, $withTravelAccommodationAssignmentsAccommodation: Boolean = false, $withTravelAccommodationAssignmentsRoomTypes: Boolean = false, $withTravelAccommodations: Boolean = false, $withTravelAccommodationsRoomTypes: Boolean = false, $withTravelAccommodationsAvailableAddons: Boolean = false, $withTravelAccommodationsGallery: Boolean = false, $withTravelDestinations: Boolean = false, $withTravelTestimonials: Boolean = false, $withTravelTestimonialsContentBlock: Boolean = false, $withTravelMainImage: Boolean = false, $withTravelMainVideo: Boolean = false, $withTravelGallery: Boolean = false, $withTravelGalleryImages: Boolean = false, $withTravelTravelPdf: Boolean = false, $withTravelTravelExtensions: Boolean = false, $withTravelTravelExtensionsHighlights: Boolean = false, $withTravelTravelExtensionsImage: Boolean = false, $withTravelItinerary: Boolean = false, $withTravelItineraryItems: Boolean = false, $withTravelPricing: Boolean = false, $withTravelPricingAgeGroupSettings: Boolean = false, $withTravelPricingCustomDataConfig: Boolean = false, $withTravelPricingTravels: Boolean = false, $withTravelPricingWebhookConfig: Boolean = false, $withTravelPricingBranding: Boolean = false, $withTravelPricingBargainSettings: Boolean = false, $withTravelPricingEsimSettings: Boolean = false, $withTravelPricingPassportConfig: Boolean = false, $withTravelPricingTourOperator: Boolean = false) {\n  links: links {\n    id\n    label\n    targetBlank\n    type\n    url\n    page @include(if: $withPage) {\n      id\n      name\n      onlineStatus\n      seoSettings @include(if: $withPageSeoSettings) {\n        id\n        urlSlug\n        metaTitle\n        metaDescription\n        ogTitle\n        ogDescription\n        ogImage @include(if: $withPageSeoSettingsOgImage) {\n          id\n          assetId\n          publicId\n          url\n          resourceType\n          format\n          width\n          height\n          caption\n          title\n          description\n        }\n      }\n      contentBlockAssignments @include(if: $withPageContentBlockAssignments) {\n        id\n        type\n        block @include(if: $withPageContentBlockAssignmentsBlock) {\n          __typename\n          ... on CmsTextBlock {\n            id\n            text\n\n          }\n          ... on CmsTextWithImageBlock {\n            id\n            title\n            subtitle\n            text\n            imagePosition\n            imageFixedAspectRatio\n\n          }\n          ... on CmsPageHeaderBlock {\n            id\n            title\n            text\n\n          }\n          ... on CmsWysiwygBlock {\n            id\n            html\n\n          }\n          ... on CmsHeadingBlock {\n            id\n            importance\n            heading\n            addon\n            decoration\n\n          }\n          ... on CmsTextWithIconBlock {\n            id\n            title\n            text\n            imagePosition\n\n          }\n          ... on CmsAccordionBlock {\n            id\n\n          }\n          ... on CmsGridBlock {\n            id\n\n          }\n          ... on CmsImageBlock {\n            id\n            text\n            fluid\n\n          }\n          ... on CmsEmployeesBlock {\n            id\n\n          }\n          ... on CmsContactBannerBlock {\n            id\n            phone\n            email\n\n          }\n          ... on CmsNewsletterRegisterBlock {\n            id\n            fluid\n\n          }\n          ... on CmsIssuuCatalogBlock {\n            id\n            publicationCode\n            accountName\n\n          }\n          ... on CmsFormBlock {\n            id\n            formName\n\n          }\n          ... on CmsHeaderSliderBlock {\n            id\n\n          }\n          ... on CmsBestsellerSliderBlock {\n            id\n            fluid\n\n          }\n          ... on CmsFilterLeadBlock {\n            id\n            layout\n\n          }\n          ... on CmsTravelTypesBlock {\n            id\n            layout\n\n          }\n          ... on CmsPrefilteredTravelsBlock {\n            id\n            maxResults\n\n          }\n          ... on CmsDividerBlock {\n            id\n            fluid\n\n          }\n          ... on CmsTravelSelectionBlock {\n            id\n\n          }\n          ... on CmsIframeBlock {\n            id\n            url\n            minHeight\n\n          }\n          ... on CmsSliderBlock {\n            id\n            fluid\n            size\n            showDots\n            showArrows\n            showLightbox\n            autoplay\n\n          }\n          ... on CmsDestinationsBlock {\n            id\n\n          }\n          ... on CmsTravelGuidesBlock {\n            id\n\n          }\n          ... on CmsBusfinderBlock {\n            id\n            title\n\n          }\n          ... on CmsBackgroundBlock {\n            id\n            backgroundVariant\n\n          }\n        }\n      }\n    }\n    travel @include(if: $withTravel) {\n      id\n      name\n      isBestseller\n      startDate\n      endDate\n      availabilityStatus @include(if: $withTravelAvailabilityStatus) {\n        id\n        label\n        status\n        isDefaultStatus\n        isDefaultWaitlistFallback\n        tenantSettings @include(if: $withTravelAvailabilityStatusTenantSettings) {\n          id\n          label\n          info\n          switchToStatusInfo\n          submitButtonLabel\n        }\n      }\n      executionStatus\n      travelConsultant @include(if: $withTravelTravelConsultant) {\n        id\n        firstName\n        lastName\n        jobTitle\n        description\n        email\n        image @include(if: $withTravelTravelConsultantImage) {\n          id\n          assetId\n          publicId\n          url\n          resourceType\n          format\n          width\n          height\n          caption\n          title\n          description\n        }\n        phone\n      }\n      label @include(if: $withTravelLabel) {\n        id\n        label\n      }\n      title\n      description\n      includedServices\n      excludedServices\n      pricingTable\n      priceCalculationInfo\n      seoSettings @include(if: $withTravelSeoSettings) {\n        id\n        urlSlug\n        metaTitle\n        metaDescription\n        ogTitle\n        ogDescription\n        ogImage @include(if: $withTravelSeoSettingsOgImage) {\n          id\n          assetId\n          publicId\n          url\n          resourceType\n          format\n          width\n          height\n          caption\n          title\n          description\n        }\n      }\n      tenantSettings @include(if: $withTravelTenantSettings) {\n        id\n        tenant @include(if: $withTravelTenantSettingsTenant) {\n          id\n          name\n          slug\n          domain\n          externalReference\n        }\n        onlineStatus\n        redirectToBooking\n        useTiming\n        startDate\n        endDate\n        travelTypes @include(if: $withTravelTenantSettingsTravelTypes) {\n          id\n          name\n          description\n        }\n      }\n      highlights @include(if: $withTravelHighlights) {\n        id\n        text\n      }\n      partners @include(if: $withTravelPartners) {\n        id\n        name\n        url\n        logo @include(if: $withTravelPartnersLogo) {\n          id\n          assetId\n          publicId\n          url\n          resourceType\n          format\n          width\n          height\n          caption\n          title\n          description\n        }\n        logoWidth\n        gtcPdf @include(if: $withTravelPartnersGtcPdf) {\n          id\n          assetId\n          publicId\n          url\n          resourceType\n          format\n          width\n          height\n          caption\n          title\n          description\n        }\n      }\n      travelGuides @include(if: $withTravelTravelGuides) {\n        id\n        firstName\n        lastName\n        description\n        image @include(if: $withTravelTravelGuidesImage) {\n          id\n          assetId\n          publicId\n          url\n          resourceType\n          format\n          width\n          height\n          caption\n          title\n          description\n        }\n      }\n      teams @include(if: $withTravelTeams) {\n        id\n        name\n        members @include(if: $withTravelTeamsMembers) {\n          id\n          firstName\n          lastName\n          description\n        }\n      }\n      accommodationAssignments @include(if: $withTravelAccommodationAssignments) {\n        id\n        accommodation @include(if: $withTravelAccommodationAssignmentsAccommodation) {\n          id\n          label\n          name\n          stars\n          description\n        }\n        roomTypes @include(if: $withTravelAccommodationAssignmentsRoomTypes) {\n          id\n          name\n          description\n        }\n        useCustomRoomTypeSelection\n      }\n      accommodations @include(if: $withTravelAccommodations) {\n        id\n        label\n        name\n        stars\n        description\n        roomTypes @include(if: $withTravelAccommodationsRoomTypes) {\n          id\n          name\n          description\n        }\n        availableAddons @include(if: $withTravelAccommodationsAvailableAddons) {\n          id\n          name\n          description\n        }\n        gallery @include(if: $withTravelAccommodationsGallery) {\n          id\n        }\n      }\n      destinations @include(if: $withTravelDestinations) {\n        id\n        name\n        entryRequirements\n        medicalInformation\n        language\n        timeShift\n        climate\n        currency\n      }\n      testimonials @include(if: $withTravelTestimonials) {\n        id\n        contentBlock @include(if: $withTravelTestimonialsContentBlock) {\n          id\n          title\n          text\n          imagePosition\n        }\n      }\n      mainImage @include(if: $withTravelMainImage) {\n        id\n        assetId\n        publicId\n        url\n        resourceType\n        format\n        width\n        height\n        caption\n        title\n        description\n      }\n      mainVideo @include(if: $withTravelMainVideo) {\n        id\n        assetId\n        publicId\n        url\n        resourceType\n        format\n        width\n        height\n        caption\n        title\n        description\n      }\n      gallery @include(if: $withTravelGallery) {\n        id\n        images @include(if: $withTravelGalleryImages) {\n          id\n          assetId\n          publicId\n          url\n          resourceType\n          format\n          width\n          height\n          caption\n          title\n          description\n        }\n      }\n      travelPdf @include(if: $withTravelTravelPdf) {\n        id\n        assetId\n        publicId\n        url\n        resourceType\n        format\n        width\n        height\n        caption\n        title\n        description\n      }\n      travelExtensions @include(if: $withTravelTravelExtensions) {\n        id\n        duration\n        name\n        description\n        highlights @include(if: $withTravelTravelExtensionsHighlights) {\n          id\n          text\n        }\n        image @include(if: $withTravelTravelExtensionsImage) {\n          id\n          assetId\n          publicId\n          url\n          resourceType\n          format\n          width\n          height\n          caption\n          title\n          description\n        }\n      }\n      programType\n      itinerary @include(if: $withTravelItinerary) {\n        id\n        items @include(if: $withTravelItineraryItems) {\n          id\n          duration\n          title\n          text\n        }\n      }\n      programText\n      pricing @include(if: $withTravelPricing) {\n        id\n        ageGroupSettings @include(if: $withTravelPricingAgeGroupSettings) {\n          id\n          freeUntilAge\n        }\n        isTravelDocumentationAvailable\n        customDataConfig @include(if: $withTravelPricingCustomDataConfig) {\n          id\n          useTravellerForm\n          useBookingForm\n        }\n        travels @include(if: $withTravelPricingTravels) {\n          id\n          catalogCode\n          travelCode\n          destination\n          name\n          transportType\n          transportTypeLabel\n          importDateTime\n          importStatus\n        }\n        webhookConfig @include(if: $withTravelPricingWebhookConfig) {\n          id\n          enabled\n          url\n        }\n        branding @include(if: $withTravelPricingBranding) {\n          id\n          logoWidth\n        }\n        bargainSettings @include(if: $withTravelPricingBargainSettings) {\n          id\n          active\n          untilDaysBeforeStart\n        }\n        esimSettings @include(if: $withTravelPricingEsimSettings) {\n          id\n          enabled\n        }\n        passportConfig @include(if: $withTravelPricingPassportConfig) {\n          id\n          passportOnly\n        }\n        tourOperator @include(if: $withTravelPricingTourOperator) {\n          id\n          name\n          url\n          logoWidth\n        }\n      }\n      minPrice\n      minPriceManualOverride\n      currency\n    }\n  }\n}";
// language=GraphQL
var SINGLE_LINK_QUERY = "query Query($id: ID!, $withPage: Boolean = false, $withPageSeoSettings: Boolean = false, $withPageSeoSettingsOgImage: Boolean = false, $withPageContentBlockAssignments: Boolean = false, $withPageContentBlockAssignmentsBlock: Boolean = false, $withTravel: Boolean = false, $withTravelAvailabilityStatus: Boolean = false, $withTravelAvailabilityStatusTenantSettings: Boolean = false, $withTravelTravelConsultant: Boolean = false, $withTravelTravelConsultantImage: Boolean = false, $withTravelLabel: Boolean = false, $withTravelSeoSettings: Boolean = false, $withTravelSeoSettingsOgImage: Boolean = false, $withTravelTenantSettings: Boolean = false, $withTravelTenantSettingsTenant: Boolean = false, $withTravelTenantSettingsTravelTypes: Boolean = false, $withTravelHighlights: Boolean = false, $withTravelPartners: Boolean = false, $withTravelPartnersLogo: Boolean = false, $withTravelPartnersGtcPdf: Boolean = false, $withTravelTravelGuides: Boolean = false, $withTravelTravelGuidesImage: Boolean = false, $withTravelTeams: Boolean = false, $withTravelTeamsMembers: Boolean = false, $withTravelAccommodationAssignments: Boolean = false, $withTravelAccommodationAssignmentsAccommodation: Boolean = false, $withTravelAccommodationAssignmentsRoomTypes: Boolean = false, $withTravelAccommodations: Boolean = false, $withTravelAccommodationsRoomTypes: Boolean = false, $withTravelAccommodationsAvailableAddons: Boolean = false, $withTravelAccommodationsGallery: Boolean = false, $withTravelDestinations: Boolean = false, $withTravelTestimonials: Boolean = false, $withTravelTestimonialsContentBlock: Boolean = false, $withTravelMainImage: Boolean = false, $withTravelMainVideo: Boolean = false, $withTravelGallery: Boolean = false, $withTravelGalleryImages: Boolean = false, $withTravelTravelPdf: Boolean = false, $withTravelTravelExtensions: Boolean = false, $withTravelTravelExtensionsHighlights: Boolean = false, $withTravelTravelExtensionsImage: Boolean = false, $withTravelItinerary: Boolean = false, $withTravelItineraryItems: Boolean = false, $withTravelPricing: Boolean = false, $withTravelPricingAgeGroupSettings: Boolean = false, $withTravelPricingCustomDataConfig: Boolean = false, $withTravelPricingTravels: Boolean = false, $withTravelPricingWebhookConfig: Boolean = false, $withTravelPricingBranding: Boolean = false, $withTravelPricingBargainSettings: Boolean = false, $withTravelPricingEsimSettings: Boolean = false, $withTravelPricingPassportConfig: Boolean = false, $withTravelPricingTourOperator: Boolean = false) {\n  link: link(id: $id) {\n    id\n    label\n    targetBlank\n    type\n    url\n    page @include(if: $withPage) {\n      id\n      name\n      onlineStatus\n      seoSettings @include(if: $withPageSeoSettings) {\n        id\n        urlSlug\n        metaTitle\n        metaDescription\n        ogTitle\n        ogDescription\n        ogImage @include(if: $withPageSeoSettingsOgImage) {\n          id\n          assetId\n          publicId\n          url\n          resourceType\n          format\n          width\n          height\n          caption\n          title\n          description\n        }\n      }\n      contentBlockAssignments @include(if: $withPageContentBlockAssignments) {\n        id\n        type\n        block @include(if: $withPageContentBlockAssignmentsBlock) {\n          __typename\n          ... on CmsTextBlock {\n            id\n            text\n\n          }\n          ... on CmsTextWithImageBlock {\n            id\n            title\n            subtitle\n            text\n            imagePosition\n            imageFixedAspectRatio\n\n          }\n          ... on CmsPageHeaderBlock {\n            id\n            title\n            text\n\n          }\n          ... on CmsWysiwygBlock {\n            id\n            html\n\n          }\n          ... on CmsHeadingBlock {\n            id\n            importance\n            heading\n            addon\n            decoration\n\n          }\n          ... on CmsTextWithIconBlock {\n            id\n            title\n            text\n            imagePosition\n\n          }\n          ... on CmsAccordionBlock {\n            id\n\n          }\n          ... on CmsGridBlock {\n            id\n\n          }\n          ... on CmsImageBlock {\n            id\n            text\n            fluid\n\n          }\n          ... on CmsEmployeesBlock {\n            id\n\n          }\n          ... on CmsContactBannerBlock {\n            id\n            phone\n            email\n\n          }\n          ... on CmsNewsletterRegisterBlock {\n            id\n            fluid\n\n          }\n          ... on CmsIssuuCatalogBlock {\n            id\n            publicationCode\n            accountName\n\n          }\n          ... on CmsFormBlock {\n            id\n            formName\n\n          }\n          ... on CmsHeaderSliderBlock {\n            id\n\n          }\n          ... on CmsBestsellerSliderBlock {\n            id\n            fluid\n\n          }\n          ... on CmsFilterLeadBlock {\n            id\n            layout\n\n          }\n          ... on CmsTravelTypesBlock {\n            id\n            layout\n\n          }\n          ... on CmsPrefilteredTravelsBlock {\n            id\n            maxResults\n\n          }\n          ... on CmsDividerBlock {\n            id\n            fluid\n\n          }\n          ... on CmsTravelSelectionBlock {\n            id\n\n          }\n          ... on CmsIframeBlock {\n            id\n            url\n            minHeight\n\n          }\n          ... on CmsSliderBlock {\n            id\n            fluid\n            size\n            showDots\n            showArrows\n            showLightbox\n            autoplay\n\n          }\n          ... on CmsDestinationsBlock {\n            id\n\n          }\n          ... on CmsTravelGuidesBlock {\n            id\n\n          }\n          ... on CmsBusfinderBlock {\n            id\n            title\n\n          }\n          ... on CmsBackgroundBlock {\n            id\n            backgroundVariant\n\n          }\n        }\n      }\n    }\n    travel @include(if: $withTravel) {\n      id\n      name\n      isBestseller\n      startDate\n      endDate\n      availabilityStatus @include(if: $withTravelAvailabilityStatus) {\n        id\n        label\n        status\n        isDefaultStatus\n        isDefaultWaitlistFallback\n        tenantSettings @include(if: $withTravelAvailabilityStatusTenantSettings) {\n          id\n          label\n          info\n          switchToStatusInfo\n          submitButtonLabel\n        }\n      }\n      executionStatus\n      travelConsultant @include(if: $withTravelTravelConsultant) {\n        id\n        firstName\n        lastName\n        jobTitle\n        description\n        email\n        image @include(if: $withTravelTravelConsultantImage) {\n          id\n          assetId\n          publicId\n          url\n          resourceType\n          format\n          width\n          height\n          caption\n          title\n          description\n        }\n        phone\n      }\n      label @include(if: $withTravelLabel) {\n        id\n        label\n      }\n      title\n      description\n      includedServices\n      excludedServices\n      pricingTable\n      priceCalculationInfo\n      seoSettings @include(if: $withTravelSeoSettings) {\n        id\n        urlSlug\n        metaTitle\n        metaDescription\n        ogTitle\n        ogDescription\n        ogImage @include(if: $withTravelSeoSettingsOgImage) {\n          id\n          assetId\n          publicId\n          url\n          resourceType\n          format\n          width\n          height\n          caption\n          title\n          description\n        }\n      }\n      tenantSettings @include(if: $withTravelTenantSettings) {\n        id\n        tenant @include(if: $withTravelTenantSettingsTenant) {\n          id\n          name\n          slug\n          domain\n          externalReference\n        }\n        onlineStatus\n        redirectToBooking\n        useTiming\n        startDate\n        endDate\n        travelTypes @include(if: $withTravelTenantSettingsTravelTypes) {\n          id\n          name\n          description\n        }\n      }\n      highlights @include(if: $withTravelHighlights) {\n        id\n        text\n      }\n      partners @include(if: $withTravelPartners) {\n        id\n        name\n        url\n        logo @include(if: $withTravelPartnersLogo) {\n          id\n          assetId\n          publicId\n          url\n          resourceType\n          format\n          width\n          height\n          caption\n          title\n          description\n        }\n        logoWidth\n        gtcPdf @include(if: $withTravelPartnersGtcPdf) {\n          id\n          assetId\n          publicId\n          url\n          resourceType\n          format\n          width\n          height\n          caption\n          title\n          description\n        }\n      }\n      travelGuides @include(if: $withTravelTravelGuides) {\n        id\n        firstName\n        lastName\n        description\n        image @include(if: $withTravelTravelGuidesImage) {\n          id\n          assetId\n          publicId\n          url\n          resourceType\n          format\n          width\n          height\n          caption\n          title\n          description\n        }\n      }\n      teams @include(if: $withTravelTeams) {\n        id\n        name\n        members @include(if: $withTravelTeamsMembers) {\n          id\n          firstName\n          lastName\n          description\n        }\n      }\n      accommodationAssignments @include(if: $withTravelAccommodationAssignments) {\n        id\n        accommodation @include(if: $withTravelAccommodationAssignmentsAccommodation) {\n          id\n          label\n          name\n          stars\n          description\n        }\n        roomTypes @include(if: $withTravelAccommodationAssignmentsRoomTypes) {\n          id\n          name\n          description\n        }\n        useCustomRoomTypeSelection\n      }\n      accommodations @include(if: $withTravelAccommodations) {\n        id\n        label\n        name\n        stars\n        description\n        roomTypes @include(if: $withTravelAccommodationsRoomTypes) {\n          id\n          name\n          description\n        }\n        availableAddons @include(if: $withTravelAccommodationsAvailableAddons) {\n          id\n          name\n          description\n        }\n        gallery @include(if: $withTravelAccommodationsGallery) {\n          id\n        }\n      }\n      destinations @include(if: $withTravelDestinations) {\n        id\n        name\n        entryRequirements\n        medicalInformation\n        language\n        timeShift\n        climate\n        currency\n      }\n      testimonials @include(if: $withTravelTestimonials) {\n        id\n        contentBlock @include(if: $withTravelTestimonialsContentBlock) {\n          id\n          title\n          text\n          imagePosition\n        }\n      }\n      mainImage @include(if: $withTravelMainImage) {\n        id\n        assetId\n        publicId\n        url\n        resourceType\n        format\n        width\n        height\n        caption\n        title\n        description\n      }\n      mainVideo @include(if: $withTravelMainVideo) {\n        id\n        assetId\n        publicId\n        url\n        resourceType\n        format\n        width\n        height\n        caption\n        title\n        description\n      }\n      gallery @include(if: $withTravelGallery) {\n        id\n        images @include(if: $withTravelGalleryImages) {\n          id\n          assetId\n          publicId\n          url\n          resourceType\n          format\n          width\n          height\n          caption\n          title\n          description\n        }\n      }\n      travelPdf @include(if: $withTravelTravelPdf) {\n        id\n        assetId\n        publicId\n        url\n        resourceType\n        format\n        width\n        height\n        caption\n        title\n        description\n      }\n      travelExtensions @include(if: $withTravelTravelExtensions) {\n        id\n        duration\n        name\n        description\n        highlights @include(if: $withTravelTravelExtensionsHighlights) {\n          id\n          text\n        }\n        image @include(if: $withTravelTravelExtensionsImage) {\n          id\n          assetId\n          publicId\n          url\n          resourceType\n          format\n          width\n          height\n          caption\n          title\n          description\n        }\n      }\n      programType\n      itinerary @include(if: $withTravelItinerary) {\n        id\n        items @include(if: $withTravelItineraryItems) {\n          id\n          duration\n          title\n          text\n        }\n      }\n      programText\n      pricing @include(if: $withTravelPricing) {\n        id\n        ageGroupSettings @include(if: $withTravelPricingAgeGroupSettings) {\n          id\n          freeUntilAge\n        }\n        isTravelDocumentationAvailable\n        customDataConfig @include(if: $withTravelPricingCustomDataConfig) {\n          id\n          useTravellerForm\n          useBookingForm\n        }\n        travels @include(if: $withTravelPricingTravels) {\n          id\n          catalogCode\n          travelCode\n          destination\n          name\n          transportType\n          transportTypeLabel\n          importDateTime\n          importStatus\n        }\n        webhookConfig @include(if: $withTravelPricingWebhookConfig) {\n          id\n          enabled\n          url\n        }\n        branding @include(if: $withTravelPricingBranding) {\n          id\n          logoWidth\n        }\n        bargainSettings @include(if: $withTravelPricingBargainSettings) {\n          id\n          active\n          untilDaysBeforeStart\n        }\n        esimSettings @include(if: $withTravelPricingEsimSettings) {\n          id\n          enabled\n        }\n        passportConfig @include(if: $withTravelPricingPassportConfig) {\n          id\n          passportOnly\n        }\n        tourOperator @include(if: $withTravelPricingTourOperator) {\n          id\n          name\n          url\n          logoWidth\n        }\n      }\n      minPrice\n      minPriceManualOverride\n      currency\n    }\n  }\n}";
// language=GraphQL
var CREATE_LINK_MUTATION = "\n  mutation Mutation($input: CreateLinkInput, $withPage: Boolean = false, $withPageSeoSettings: Boolean = false, $withPageSeoSettingsOgImage: Boolean = false, $withPageContentBlockAssignments: Boolean = false, $withPageContentBlockAssignmentsBlock: Boolean = false, $withTravel: Boolean = false, $withTravelAvailabilityStatus: Boolean = false, $withTravelAvailabilityStatusTenantSettings: Boolean = false, $withTravelTravelConsultant: Boolean = false, $withTravelTravelConsultantImage: Boolean = false, $withTravelLabel: Boolean = false, $withTravelSeoSettings: Boolean = false, $withTravelSeoSettingsOgImage: Boolean = false, $withTravelTenantSettings: Boolean = false, $withTravelTenantSettingsTenant: Boolean = false, $withTravelTenantSettingsTravelTypes: Boolean = false, $withTravelHighlights: Boolean = false, $withTravelPartners: Boolean = false, $withTravelPartnersLogo: Boolean = false, $withTravelPartnersGtcPdf: Boolean = false, $withTravelTravelGuides: Boolean = false, $withTravelTravelGuidesImage: Boolean = false, $withTravelTeams: Boolean = false, $withTravelTeamsMembers: Boolean = false, $withTravelAccommodationAssignments: Boolean = false, $withTravelAccommodationAssignmentsAccommodation: Boolean = false, $withTravelAccommodationAssignmentsRoomTypes: Boolean = false, $withTravelAccommodations: Boolean = false, $withTravelAccommodationsRoomTypes: Boolean = false, $withTravelAccommodationsAvailableAddons: Boolean = false, $withTravelAccommodationsGallery: Boolean = false, $withTravelDestinations: Boolean = false, $withTravelTestimonials: Boolean = false, $withTravelTestimonialsContentBlock: Boolean = false, $withTravelMainImage: Boolean = false, $withTravelMainVideo: Boolean = false, $withTravelGallery: Boolean = false, $withTravelGalleryImages: Boolean = false, $withTravelTravelPdf: Boolean = false, $withTravelTravelExtensions: Boolean = false, $withTravelTravelExtensionsHighlights: Boolean = false, $withTravelTravelExtensionsImage: Boolean = false, $withTravelItinerary: Boolean = false, $withTravelItineraryItems: Boolean = false, $withTravelPricing: Boolean = false, $withTravelPricingAgeGroupSettings: Boolean = false, $withTravelPricingCustomDataConfig: Boolean = false, $withTravelPricingTravels: Boolean = false, $withTravelPricingWebhookConfig: Boolean = false, $withTravelPricingBranding: Boolean = false, $withTravelPricingBargainSettings: Boolean = false, $withTravelPricingEsimSettings: Boolean = false, $withTravelPricingPassportConfig: Boolean = false, $withTravelPricingTourOperator: Boolean = false) {\n    link: createLink(input: $input) {\n      id\n      label\n      targetBlank\n      type\n      url\n      page @include(if: $withPage) {\n        id\n        name\n        onlineStatus\n        seoSettings @include(if: $withPageSeoSettings) {\n          id\n          urlSlug\n          metaTitle\n          metaDescription\n          ogTitle\n          ogDescription\n          ogImage @include(if: $withPageSeoSettingsOgImage) {\n            id\n            assetId\n            publicId\n            url\n            resourceType\n            format\n            width\n            height\n            caption\n            title\n            description\n          }\n        }\n        contentBlockAssignments @include(if: $withPageContentBlockAssignments) {\n          id\n          type\n          block @include(if: $withPageContentBlockAssignmentsBlock) {\n            __typename\n            ... on CmsTextBlock {\n              id\n              text\n\n            }\n            ... on CmsTextWithImageBlock {\n              id\n              title\n              subtitle\n              text\n              imagePosition\n              imageFixedAspectRatio\n\n            }\n            ... on CmsPageHeaderBlock {\n              id\n              title\n              text\n\n            }\n            ... on CmsWysiwygBlock {\n              id\n              html\n\n            }\n            ... on CmsHeadingBlock {\n              id\n              importance\n              heading\n              addon\n              decoration\n\n            }\n            ... on CmsTextWithIconBlock {\n              id\n              title\n              text\n              imagePosition\n\n            }\n            ... on CmsAccordionBlock {\n              id\n\n            }\n            ... on CmsGridBlock {\n              id\n\n            }\n            ... on CmsImageBlock {\n              id\n              text\n              fluid\n\n            }\n            ... on CmsEmployeesBlock {\n              id\n\n            }\n            ... on CmsContactBannerBlock {\n              id\n              phone\n              email\n\n            }\n            ... on CmsNewsletterRegisterBlock {\n              id\n              fluid\n\n            }\n            ... on CmsIssuuCatalogBlock {\n              id\n              publicationCode\n              accountName\n\n            }\n            ... on CmsFormBlock {\n              id\n              formName\n\n            }\n            ... on CmsHeaderSliderBlock {\n              id\n\n            }\n            ... on CmsBestsellerSliderBlock {\n              id\n              fluid\n\n            }\n            ... on CmsFilterLeadBlock {\n              id\n              layout\n\n            }\n            ... on CmsTravelTypesBlock {\n              id\n              layout\n\n            }\n            ... on CmsPrefilteredTravelsBlock {\n              id\n              maxResults\n\n            }\n            ... on CmsDividerBlock {\n              id\n              fluid\n\n            }\n            ... on CmsTravelSelectionBlock {\n              id\n\n            }\n            ... on CmsIframeBlock {\n              id\n              url\n              minHeight\n\n            }\n            ... on CmsSliderBlock {\n              id\n              fluid\n              size\n              showDots\n              showArrows\n              showLightbox\n              autoplay\n\n            }\n            ... on CmsDestinationsBlock {\n              id\n\n            }\n            ... on CmsTravelGuidesBlock {\n              id\n\n            }\n            ... on CmsBusfinderBlock {\n              id\n              title\n\n            }\n            ... on CmsBackgroundBlock {\n              id\n              backgroundVariant\n\n            }\n          }\n        }\n      }\n      travel @include(if: $withTravel) {\n        id\n        name\n        isBestseller\n        startDate\n        endDate\n        availabilityStatus @include(if: $withTravelAvailabilityStatus) {\n          id\n          label\n          status\n          isDefaultStatus\n          isDefaultWaitlistFallback\n          tenantSettings @include(if: $withTravelAvailabilityStatusTenantSettings) {\n            id\n            label\n            info\n            switchToStatusInfo\n            submitButtonLabel\n          }\n        }\n        executionStatus\n        travelConsultant @include(if: $withTravelTravelConsultant) {\n          id\n          firstName\n          lastName\n          jobTitle\n          description\n          email\n          image @include(if: $withTravelTravelConsultantImage) {\n            id\n            assetId\n            publicId\n            url\n            resourceType\n            format\n            width\n            height\n            caption\n            title\n            description\n          }\n          phone\n        }\n        label @include(if: $withTravelLabel) {\n          id\n          label\n        }\n        title\n        description\n        includedServices\n        excludedServices\n        pricingTable\n        priceCalculationInfo\n        seoSettings @include(if: $withTravelSeoSettings) {\n          id\n          urlSlug\n          metaTitle\n          metaDescription\n          ogTitle\n          ogDescription\n          ogImage @include(if: $withTravelSeoSettingsOgImage) {\n            id\n            assetId\n            publicId\n            url\n            resourceType\n            format\n            width\n            height\n            caption\n            title\n            description\n          }\n        }\n        tenantSettings @include(if: $withTravelTenantSettings) {\n          id\n          tenant @include(if: $withTravelTenantSettingsTenant) {\n            id\n            name\n            slug\n            domain\n            externalReference\n          }\n          onlineStatus\n          redirectToBooking\n          useTiming\n          startDate\n          endDate\n          travelTypes @include(if: $withTravelTenantSettingsTravelTypes) {\n            id\n            name\n            description\n          }\n        }\n        highlights @include(if: $withTravelHighlights) {\n          id\n          text\n        }\n        partners @include(if: $withTravelPartners) {\n          id\n          name\n          url\n          logo @include(if: $withTravelPartnersLogo) {\n            id\n            assetId\n            publicId\n            url\n            resourceType\n            format\n            width\n            height\n            caption\n            title\n            description\n          }\n          logoWidth\n          gtcPdf @include(if: $withTravelPartnersGtcPdf) {\n            id\n            assetId\n            publicId\n            url\n            resourceType\n            format\n            width\n            height\n            caption\n            title\n            description\n          }\n        }\n        travelGuides @include(if: $withTravelTravelGuides) {\n          id\n          firstName\n          lastName\n          description\n          image @include(if: $withTravelTravelGuidesImage) {\n            id\n            assetId\n            publicId\n            url\n            resourceType\n            format\n            width\n            height\n            caption\n            title\n            description\n          }\n        }\n        teams @include(if: $withTravelTeams) {\n          id\n          name\n          members @include(if: $withTravelTeamsMembers) {\n            id\n            firstName\n            lastName\n            description\n          }\n        }\n        accommodationAssignments @include(if: $withTravelAccommodationAssignments) {\n          id\n          accommodation @include(if: $withTravelAccommodationAssignmentsAccommodation) {\n            id\n            label\n            name\n            stars\n            description\n          }\n          roomTypes @include(if: $withTravelAccommodationAssignmentsRoomTypes) {\n            id\n            name\n            description\n          }\n          useCustomRoomTypeSelection\n        }\n        accommodations @include(if: $withTravelAccommodations) {\n          id\n          label\n          name\n          stars\n          description\n          roomTypes @include(if: $withTravelAccommodationsRoomTypes) {\n            id\n            name\n            description\n          }\n          availableAddons @include(if: $withTravelAccommodationsAvailableAddons) {\n            id\n            name\n            description\n          }\n          gallery @include(if: $withTravelAccommodationsGallery) {\n            id\n          }\n        }\n        destinations @include(if: $withTravelDestinations) {\n          id\n          name\n          entryRequirements\n          medicalInformation\n          language\n          timeShift\n          climate\n          currency\n        }\n        testimonials @include(if: $withTravelTestimonials) {\n          id\n          contentBlock @include(if: $withTravelTestimonialsContentBlock) {\n            id\n            title\n            text\n            imagePosition\n          }\n        }\n        mainImage @include(if: $withTravelMainImage) {\n          id\n          assetId\n          publicId\n          url\n          resourceType\n          format\n          width\n          height\n          caption\n          title\n          description\n        }\n        mainVideo @include(if: $withTravelMainVideo) {\n          id\n          assetId\n          publicId\n          url\n          resourceType\n          format\n          width\n          height\n          caption\n          title\n          description\n        }\n        gallery @include(if: $withTravelGallery) {\n          id\n          images @include(if: $withTravelGalleryImages) {\n            id\n            assetId\n            publicId\n            url\n            resourceType\n            format\n            width\n            height\n            caption\n            title\n            description\n          }\n        }\n        travelPdf @include(if: $withTravelTravelPdf) {\n          id\n          assetId\n          publicId\n          url\n          resourceType\n          format\n          width\n          height\n          caption\n          title\n          description\n        }\n        travelExtensions @include(if: $withTravelTravelExtensions) {\n          id\n          duration\n          name\n          description\n          highlights @include(if: $withTravelTravelExtensionsHighlights) {\n            id\n            text\n          }\n          image @include(if: $withTravelTravelExtensionsImage) {\n            id\n            assetId\n            publicId\n            url\n            resourceType\n            format\n            width\n            height\n            caption\n            title\n            description\n          }\n        }\n        programType\n        itinerary @include(if: $withTravelItinerary) {\n          id\n          items @include(if: $withTravelItineraryItems) {\n            id\n            duration\n            title\n            text\n          }\n        }\n        programText\n        pricing @include(if: $withTravelPricing) {\n          id\n          ageGroupSettings @include(if: $withTravelPricingAgeGroupSettings) {\n            id\n            freeUntilAge\n          }\n          isTravelDocumentationAvailable\n          customDataConfig @include(if: $withTravelPricingCustomDataConfig) {\n            id\n            useTravellerForm\n            useBookingForm\n          }\n          travels @include(if: $withTravelPricingTravels) {\n            id\n            catalogCode\n            travelCode\n            destination\n            name\n            transportType\n            transportTypeLabel\n            importDateTime\n            importStatus\n          }\n          webhookConfig @include(if: $withTravelPricingWebhookConfig) {\n            id\n            enabled\n            url\n          }\n          branding @include(if: $withTravelPricingBranding) {\n            id\n            logoWidth\n          }\n          bargainSettings @include(if: $withTravelPricingBargainSettings) {\n            id\n            active\n            untilDaysBeforeStart\n          }\n          esimSettings @include(if: $withTravelPricingEsimSettings) {\n            id\n            enabled\n          }\n          passportConfig @include(if: $withTravelPricingPassportConfig) {\n            id\n            passportOnly\n          }\n          tourOperator @include(if: $withTravelPricingTourOperator) {\n            id\n            name\n            url\n            logoWidth\n          }\n        }\n        minPrice\n        minPriceManualOverride\n        currency\n      }\n    }\n  }";
// language=GraphQL
var UPDATE_LINK_MUTATION = "\n  mutation Mutation($input: UpdateLinkInput, $withPage: Boolean = false, $withPageSeoSettings: Boolean = false, $withPageSeoSettingsOgImage: Boolean = false, $withPageContentBlockAssignments: Boolean = false, $withPageContentBlockAssignmentsBlock: Boolean = false, $withTravel: Boolean = false, $withTravelAvailabilityStatus: Boolean = false, $withTravelAvailabilityStatusTenantSettings: Boolean = false, $withTravelTravelConsultant: Boolean = false, $withTravelTravelConsultantImage: Boolean = false, $withTravelLabel: Boolean = false, $withTravelSeoSettings: Boolean = false, $withTravelSeoSettingsOgImage: Boolean = false, $withTravelTenantSettings: Boolean = false, $withTravelTenantSettingsTenant: Boolean = false, $withTravelTenantSettingsTravelTypes: Boolean = false, $withTravelHighlights: Boolean = false, $withTravelPartners: Boolean = false, $withTravelPartnersLogo: Boolean = false, $withTravelPartnersGtcPdf: Boolean = false, $withTravelTravelGuides: Boolean = false, $withTravelTravelGuidesImage: Boolean = false, $withTravelTeams: Boolean = false, $withTravelTeamsMembers: Boolean = false, $withTravelAccommodationAssignments: Boolean = false, $withTravelAccommodationAssignmentsAccommodation: Boolean = false, $withTravelAccommodationAssignmentsRoomTypes: Boolean = false, $withTravelAccommodations: Boolean = false, $withTravelAccommodationsRoomTypes: Boolean = false, $withTravelAccommodationsAvailableAddons: Boolean = false, $withTravelAccommodationsGallery: Boolean = false, $withTravelDestinations: Boolean = false, $withTravelTestimonials: Boolean = false, $withTravelTestimonialsContentBlock: Boolean = false, $withTravelMainImage: Boolean = false, $withTravelMainVideo: Boolean = false, $withTravelGallery: Boolean = false, $withTravelGalleryImages: Boolean = false, $withTravelTravelPdf: Boolean = false, $withTravelTravelExtensions: Boolean = false, $withTravelTravelExtensionsHighlights: Boolean = false, $withTravelTravelExtensionsImage: Boolean = false, $withTravelItinerary: Boolean = false, $withTravelItineraryItems: Boolean = false, $withTravelPricing: Boolean = false, $withTravelPricingAgeGroupSettings: Boolean = false, $withTravelPricingCustomDataConfig: Boolean = false, $withTravelPricingTravels: Boolean = false, $withTravelPricingWebhookConfig: Boolean = false, $withTravelPricingBranding: Boolean = false, $withTravelPricingBargainSettings: Boolean = false, $withTravelPricingEsimSettings: Boolean = false, $withTravelPricingPassportConfig: Boolean = false, $withTravelPricingTourOperator: Boolean = false) {\n    link: updateLink(input: $input) {\n      id\n      label\n      targetBlank\n      type\n      url\n      page @include(if: $withPage) {\n        id\n        name\n        onlineStatus\n        seoSettings @include(if: $withPageSeoSettings) {\n          id\n          urlSlug\n          metaTitle\n          metaDescription\n          ogTitle\n          ogDescription\n          ogImage @include(if: $withPageSeoSettingsOgImage) {\n            id\n            assetId\n            publicId\n            url\n            resourceType\n            format\n            width\n            height\n            caption\n            title\n            description\n          }\n        }\n        contentBlockAssignments @include(if: $withPageContentBlockAssignments) {\n          id\n          type\n          block @include(if: $withPageContentBlockAssignmentsBlock) {\n            __typename\n            ... on CmsTextBlock {\n              id\n              text\n\n            }\n            ... on CmsTextWithImageBlock {\n              id\n              title\n              subtitle\n              text\n              imagePosition\n              imageFixedAspectRatio\n\n            }\n            ... on CmsPageHeaderBlock {\n              id\n              title\n              text\n\n            }\n            ... on CmsWysiwygBlock {\n              id\n              html\n\n            }\n            ... on CmsHeadingBlock {\n              id\n              importance\n              heading\n              addon\n              decoration\n\n            }\n            ... on CmsTextWithIconBlock {\n              id\n              title\n              text\n              imagePosition\n\n            }\n            ... on CmsAccordionBlock {\n              id\n\n            }\n            ... on CmsGridBlock {\n              id\n\n            }\n            ... on CmsImageBlock {\n              id\n              text\n              fluid\n\n            }\n            ... on CmsEmployeesBlock {\n              id\n\n            }\n            ... on CmsContactBannerBlock {\n              id\n              phone\n              email\n\n            }\n            ... on CmsNewsletterRegisterBlock {\n              id\n              fluid\n\n            }\n            ... on CmsIssuuCatalogBlock {\n              id\n              publicationCode\n              accountName\n\n            }\n            ... on CmsFormBlock {\n              id\n              formName\n\n            }\n            ... on CmsHeaderSliderBlock {\n              id\n\n            }\n            ... on CmsBestsellerSliderBlock {\n              id\n              fluid\n\n            }\n            ... on CmsFilterLeadBlock {\n              id\n              layout\n\n            }\n            ... on CmsTravelTypesBlock {\n              id\n              layout\n\n            }\n            ... on CmsPrefilteredTravelsBlock {\n              id\n              maxResults\n\n            }\n            ... on CmsDividerBlock {\n              id\n              fluid\n\n            }\n            ... on CmsTravelSelectionBlock {\n              id\n\n            }\n            ... on CmsIframeBlock {\n              id\n              url\n              minHeight\n\n            }\n            ... on CmsSliderBlock {\n              id\n              fluid\n              size\n              showDots\n              showArrows\n              showLightbox\n              autoplay\n\n            }\n            ... on CmsDestinationsBlock {\n              id\n\n            }\n            ... on CmsTravelGuidesBlock {\n              id\n\n            }\n            ... on CmsBusfinderBlock {\n              id\n              title\n\n            }\n            ... on CmsBackgroundBlock {\n              id\n              backgroundVariant\n\n            }\n          }\n        }\n      }\n      travel @include(if: $withTravel) {\n        id\n        name\n        isBestseller\n        startDate\n        endDate\n        availabilityStatus @include(if: $withTravelAvailabilityStatus) {\n          id\n          label\n          status\n          isDefaultStatus\n          isDefaultWaitlistFallback\n          tenantSettings @include(if: $withTravelAvailabilityStatusTenantSettings) {\n            id\n            label\n            info\n            switchToStatusInfo\n            submitButtonLabel\n          }\n        }\n        executionStatus\n        travelConsultant @include(if: $withTravelTravelConsultant) {\n          id\n          firstName\n          lastName\n          jobTitle\n          description\n          email\n          image @include(if: $withTravelTravelConsultantImage) {\n            id\n            assetId\n            publicId\n            url\n            resourceType\n            format\n            width\n            height\n            caption\n            title\n            description\n          }\n          phone\n        }\n        label @include(if: $withTravelLabel) {\n          id\n          label\n        }\n        title\n        description\n        includedServices\n        excludedServices\n        pricingTable\n        priceCalculationInfo\n        seoSettings @include(if: $withTravelSeoSettings) {\n          id\n          urlSlug\n          metaTitle\n          metaDescription\n          ogTitle\n          ogDescription\n          ogImage @include(if: $withTravelSeoSettingsOgImage) {\n            id\n            assetId\n            publicId\n            url\n            resourceType\n            format\n            width\n            height\n            caption\n            title\n            description\n          }\n        }\n        tenantSettings @include(if: $withTravelTenantSettings) {\n          id\n          tenant @include(if: $withTravelTenantSettingsTenant) {\n            id\n            name\n            slug\n            domain\n            externalReference\n          }\n          onlineStatus\n          redirectToBooking\n          useTiming\n          startDate\n          endDate\n          travelTypes @include(if: $withTravelTenantSettingsTravelTypes) {\n            id\n            name\n            description\n          }\n        }\n        highlights @include(if: $withTravelHighlights) {\n          id\n          text\n        }\n        partners @include(if: $withTravelPartners) {\n          id\n          name\n          url\n          logo @include(if: $withTravelPartnersLogo) {\n            id\n            assetId\n            publicId\n            url\n            resourceType\n            format\n            width\n            height\n            caption\n            title\n            description\n          }\n          logoWidth\n          gtcPdf @include(if: $withTravelPartnersGtcPdf) {\n            id\n            assetId\n            publicId\n            url\n            resourceType\n            format\n            width\n            height\n            caption\n            title\n            description\n          }\n        }\n        travelGuides @include(if: $withTravelTravelGuides) {\n          id\n          firstName\n          lastName\n          description\n          image @include(if: $withTravelTravelGuidesImage) {\n            id\n            assetId\n            publicId\n            url\n            resourceType\n            format\n            width\n            height\n            caption\n            title\n            description\n          }\n        }\n        teams @include(if: $withTravelTeams) {\n          id\n          name\n          members @include(if: $withTravelTeamsMembers) {\n            id\n            firstName\n            lastName\n            description\n          }\n        }\n        accommodationAssignments @include(if: $withTravelAccommodationAssignments) {\n          id\n          accommodation @include(if: $withTravelAccommodationAssignmentsAccommodation) {\n            id\n            label\n            name\n            stars\n            description\n          }\n          roomTypes @include(if: $withTravelAccommodationAssignmentsRoomTypes) {\n            id\n            name\n            description\n          }\n          useCustomRoomTypeSelection\n        }\n        accommodations @include(if: $withTravelAccommodations) {\n          id\n          label\n          name\n          stars\n          description\n          roomTypes @include(if: $withTravelAccommodationsRoomTypes) {\n            id\n            name\n            description\n          }\n          availableAddons @include(if: $withTravelAccommodationsAvailableAddons) {\n            id\n            name\n            description\n          }\n          gallery @include(if: $withTravelAccommodationsGallery) {\n            id\n          }\n        }\n        destinations @include(if: $withTravelDestinations) {\n          id\n          name\n          entryRequirements\n          medicalInformation\n          language\n          timeShift\n          climate\n          currency\n        }\n        testimonials @include(if: $withTravelTestimonials) {\n          id\n          contentBlock @include(if: $withTravelTestimonialsContentBlock) {\n            id\n            title\n            text\n            imagePosition\n          }\n        }\n        mainImage @include(if: $withTravelMainImage) {\n          id\n          assetId\n          publicId\n          url\n          resourceType\n          format\n          width\n          height\n          caption\n          title\n          description\n        }\n        mainVideo @include(if: $withTravelMainVideo) {\n          id\n          assetId\n          publicId\n          url\n          resourceType\n          format\n          width\n          height\n          caption\n          title\n          description\n        }\n        gallery @include(if: $withTravelGallery) {\n          id\n          images @include(if: $withTravelGalleryImages) {\n            id\n            assetId\n            publicId\n            url\n            resourceType\n            format\n            width\n            height\n            caption\n            title\n            description\n          }\n        }\n        travelPdf @include(if: $withTravelTravelPdf) {\n          id\n          assetId\n          publicId\n          url\n          resourceType\n          format\n          width\n          height\n          caption\n          title\n          description\n        }\n        travelExtensions @include(if: $withTravelTravelExtensions) {\n          id\n          duration\n          name\n          description\n          highlights @include(if: $withTravelTravelExtensionsHighlights) {\n            id\n            text\n          }\n          image @include(if: $withTravelTravelExtensionsImage) {\n            id\n            assetId\n            publicId\n            url\n            resourceType\n            format\n            width\n            height\n            caption\n            title\n            description\n          }\n        }\n        programType\n        itinerary @include(if: $withTravelItinerary) {\n          id\n          items @include(if: $withTravelItineraryItems) {\n            id\n            duration\n            title\n            text\n          }\n        }\n        programText\n        pricing @include(if: $withTravelPricing) {\n          id\n          ageGroupSettings @include(if: $withTravelPricingAgeGroupSettings) {\n            id\n            freeUntilAge\n          }\n          isTravelDocumentationAvailable\n          customDataConfig @include(if: $withTravelPricingCustomDataConfig) {\n            id\n            useTravellerForm\n            useBookingForm\n          }\n          travels @include(if: $withTravelPricingTravels) {\n            id\n            catalogCode\n            travelCode\n            destination\n            name\n            transportType\n            transportTypeLabel\n            importDateTime\n            importStatus\n          }\n          webhookConfig @include(if: $withTravelPricingWebhookConfig) {\n            id\n            enabled\n            url\n          }\n          branding @include(if: $withTravelPricingBranding) {\n            id\n            logoWidth\n          }\n          bargainSettings @include(if: $withTravelPricingBargainSettings) {\n            id\n            active\n            untilDaysBeforeStart\n          }\n          esimSettings @include(if: $withTravelPricingEsimSettings) {\n            id\n            enabled\n          }\n          passportConfig @include(if: $withTravelPricingPassportConfig) {\n            id\n            passportOnly\n          }\n          tourOperator @include(if: $withTravelPricingTourOperator) {\n            id\n            name\n            url\n            logoWidth\n          }\n        }\n        minPrice\n        minPriceManualOverride\n        currency\n      }\n    }\n  }";
// language=GraphQL
var DELETE_LINK_MUTATION = "\n  mutation Mutation($input: DeleteLinkInput) {\n    deleteLink(input: $input) {\n      success\n    }\n  }";
// language=GraphQL
var FORCE_DELETE_LINK_MUTATION = "\n  mutation Mutation($input: DeleteLinkInput) {\n    forceDeleteLink(input: $input) {\n      success\n    }\n  }";
// language=GraphQL
var LINKS_DEPENDENTS_QUERY = "query Query($id: ID!, $withCmsTextWithImageBlocks: Boolean = false, $withCmsHeaderSliderBlockSlides: Boolean = false) {\n  groupedDependents: linkDependents(id: $id) {\n    cmsTextWithImageBlocks @include(if: $withCmsTextWithImageBlocks) {\n      id\n      title\n      subtitle\n      text\n      imagePosition\n      imageFixedAspectRatio\n    }\n    cmsHeaderSliderBlockSlides @include(if: $withCmsHeaderSliderBlockSlides) {\n      id\n      title\n      text\n    }\n  }\n}";

// EXTERNAL MODULE: ./src/entities/cmsPage/entity.ts + 3 modules
var entity = __webpack_require__(49647);
// EXTERNAL MODULE: ./src/entities/travel/entity.ts + 3 modules
var travel_entity = __webpack_require__(82327);
;// CONCATENATED MODULE: ./src/entities/link/model.ts



var linkModel = {
    name: "link",
    namePlural: "links",
    uniqueName: "link",
    uniqueNamePlural: "links",
    path: "cms/partials/link",
    baseUrl: "/cms/partials/links",
    translationPrefix: "entities:link.",
    getDisplayName: function(values) {
        return values.url;
    },
    gql: {
        getAll: ALL_LINKS_QUERY,
        getSingle: SINGLE_LINK_QUERY,
        create: CREATE_LINK_MUTATION,
        update: UPDATE_LINK_MUTATION,
        delete: DELETE_LINK_MUTATION,
        forceDelete: FORCE_DELETE_LINK_MUTATION
    },
    attributes: {
        label: {
            name: "label",
            label: "entities:link.attributes.label.label",
            type: "value",
            dataType: "string",
            defaultInput: true,
            inputType: "text",
            validationType: "string",
            validations: [
                {
                    type: "required"
                }, 
            ]
        },
        targetBlank: {
            name: "targetBlank",
            label: "entities:link.attributes.targetBlank.label",
            type: "value",
            dataType: "boolean",
            defaultInput: true,
            inputType: "switch",
            validationType: "string",
            validations: []
        },
        type: {
            name: "type",
            label: "entities:link.attributes.type.label",
            type: "value",
            dataType: "string",
            defaultValue: "url",
            defaultInput: true,
            inputType: "select",
            selectOptions: [
                {
                    label: "entities:link.attributes.type.selectOptions.url.label",
                    value: "url"
                },
                {
                    label: "entities:link.attributes.type.selectOptions.page.label",
                    value: "page"
                },
                {
                    label: "entities:link.attributes.type.selectOptions.travel.label",
                    value: "travel"
                }, 
            ],
            validationType: "string",
            validations: []
        },
        url: {
            name: "url",
            label: "entities:link.attributes.url.label",
            type: "value",
            dataType: "string",
            defaultInput: true,
            inputType: "text",
            validationType: "string",
            validations: []
        },
        page: {
            name: "page",
            label: "entities:link.attributes.page.label",
            type: "entityObject",
            dataType: "any",
            getEntity: function() {
                return entity/* default */.Z;
            },
            defaultInput: true,
            inputType: "select",
            validationType: "string",
            validations: []
        },
        travel: {
            name: "travel",
            label: "entities:link.attributes.travel.label",
            type: "entityObject",
            dataType: "any",
            getEntity: function() {
                return travel_entity/* default */.Z;
            },
            defaultInput: true,
            inputType: "select",
            validationType: "string",
            validations: []
        }
    }
};
/* harmony default export */ var model = (linkModel);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(20414);
// EXTERNAL MODULE: ./src/entities/lib.ts
var lib = __webpack_require__(23480);
// EXTERNAL MODULE: ./src/lib/api/graphQLClient.ts
var graphQLClient = __webpack_require__(40112);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/swr/dist/index.mjs
var dist = __webpack_require__(8100);
// EXTERNAL MODULE: ./src/lib/helpers/helpers.ts
var helpers = __webpack_require__(15778);
;// CONCATENATED MODULE: ./src/entities/link/repository.ts










var hydrateObjects = function(objects) {
    return objects.map(function(object) {
        return (0,lib/* hydrateEntityObject */.b)(model, object);
    });
};
var hydrateObject = function(object) {
    return (0,lib/* hydrateEntityObject */.b)(model, object);
};
var linkRepository = {
    getObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    id: id
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(SINGLE_LINK_QUERY, variables).then(function(data) {
                        return hydrateObject(data.link);
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }(),
    getObjects: /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        var includes;
        var _arguments = arguments;
        return (0,tslib_es6.__generator)(this, function(_state) {
            includes = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : {};
            return [
                2,
                graphQLClient/* default.request */.Z.request(ALL_LINKS_QUERY, includes).then(function(data) {
                    return hydrateObjects(data.links);
                })
            ];
        });
    }),
    useObject: function(id) {
        var includes = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        // eslint-disable-next-line react-hooks/exhaustive-deps
        var variables = (0,react.useMemo)(function() {
            return (0,_object_spread/* default */.Z)({
                id: id
            }, includes);
        }, [
            id
        ]);
        var ref = (0,dist/* default */.ZP)([
            SINGLE_LINK_QUERY,
            variables
        ], {
            revalidateOnFocus: false
        }), data = ref.data, error = ref.error, mutate = ref.mutate;
        return {
            object: !data ? data : hydrateObject(data.link),
            isLoading: !error && !data,
            isError: error,
            mutate: mutate
        };
    },
    useObjects: function() {
        var includes = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        // eslint-disable-next-line react-hooks/exhaustive-deps
        var variables = (0,react.useMemo)(function() {
            return includes;
        }, []);
        var ref = (0,dist/* default */.ZP)([
            ALL_LINKS_QUERY,
            variables
        ]), data = ref.data, error = ref.error, mutate = ref.mutate;
        return {
            objects: !data ? data : hydrateObjects(data.links),
            isLoading: !error && !data,
            isError: error,
            mutate: mutate
        };
    },
    getDependents: function(id, includes) {
        var includeVars = {};
        includes.forEach(function(include) {
            includeVars["with".concat((0,helpers/* uppercaseFirst */.AB)(include))] = true;
        });
        var variables = (0,_object_spread/* default */.Z)({
            id: id
        }, includeVars);
        return graphQLClient/* default.request */.Z.request(LINKS_DEPENDENTS_QUERY, variables).then(function(data) {
            return data.groupedDependents;
        });
    },
    useDependents: function(id, includes) {
        var includeVars = {};
        includes.forEach(function(include) {
            includeVars["with".concat((0,helpers/* uppercaseFirst */.AB)(include))] = true;
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
        var variables = (0,react.useMemo)(function() {
            return (0,_object_spread/* default */.Z)({
                id: id
            }, includeVars);
        }, [
            id
        ]);
        var ref = (0,dist/* default */.ZP)([
            LINKS_DEPENDENTS_QUERY,
            variables
        ], {
            revalidateOnFocus: false
        }), data = ref.data, error = ref.error, mutate = ref.mutate;
        return {
            data: !data ? data : data.groupedDependents,
            isLoading: !error && !data,
            isError: error,
            mutate: mutate
        };
    },
    createObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(data) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    input: data
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(CREATE_LINK_MUTATION, variables).then(function(data) {
                        return hydrateObject(data.link);
                    })
                ];
            });
        });
        return function(data) {
            return _ref.apply(this, arguments);
        };
    }(),
    updateObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(data) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    input: data
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(UPDATE_LINK_MUTATION, variables).then(function(data) {
                        return hydrateObject(data.link);
                    })
                ];
            });
        });
        return function(data) {
            return _ref.apply(this, arguments);
        };
    }(),
    deleteObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(DELETE_LINK_MUTATION, variables).then(function(data) {
                        return data.deleteLink;
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }(),
    forceDeleteObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(FORCE_DELETE_LINK_MUTATION, variables).then(function(data) {
                        return data.forceDeleteLink;
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }()
};
/* harmony default export */ var repository = (linkRepository);

;// CONCATENATED MODULE: ./src/entities/link/entity.ts


var linkEntity = {
    model: model,
    repository: repository
};
/* harmony default export */ var link_entity = (linkEntity);


/***/ }),

/***/ 26729:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ entity; }
});

;// CONCATENATED MODULE: ./src/entities/mailchimpConfig/graphql.ts
// language=GraphQL
var ALL_MAILCHIMP_CONFIGS_QUERY = "query Query {\n  mailchimpConfigs: mailchimpConfigs {\n    id\n    apiKey\n    serverPrefix\n    listId\n  }\n}";
// language=GraphQL
var SINGLE_MAILCHIMP_CONFIG_QUERY = "query Query($id: ID!) {\n  mailchimpConfig: mailchimpConfig(id: $id) {\n    id\n    apiKey\n    serverPrefix\n    listId\n  }\n}";
// language=GraphQL
var CREATE_MAILCHIMP_CONFIG_MUTATION = "\n  mutation Mutation($input: CreateMailchimpConfigInput) {\n    mailchimpConfig: createMailchimpConfig(input: $input) {\n      id\n      apiKey\n      serverPrefix\n      listId\n    }\n  }";
// language=GraphQL
var UPDATE_MAILCHIMP_CONFIG_MUTATION = "\n  mutation Mutation($input: UpdateMailchimpConfigInput) {\n    mailchimpConfig: updateMailchimpConfig(input: $input) {\n      id\n      apiKey\n      serverPrefix\n      listId\n    }\n  }";
// language=GraphQL
var DELETE_MAILCHIMP_CONFIG_MUTATION = "\n  mutation Mutation($input: DeleteMailchimpConfigInput) {\n    deleteMailchimpConfig(input: $input) {\n      success\n    }\n  }";
// language=GraphQL
var FORCE_DELETE_MAILCHIMP_CONFIG_MUTATION = "\n  mutation Mutation($input: DeleteMailchimpConfigInput) {\n    forceDeleteMailchimpConfig(input: $input) {\n      success\n    }\n  }";
// language=GraphQL
var MAILCHIMP_CONFIGS_DEPENDENTS_QUERY = "query Query($id: ID!, $withNewsletterProviders: Boolean = false) {\n  groupedDependents: mailchimpConfigDependents(id: $id) {\n    newsletterProviders @include(if: $withNewsletterProviders) {\n      id\n      provider\n    }\n  }\n}";

;// CONCATENATED MODULE: ./src/entities/mailchimpConfig/model.ts

var mailchimpConfigModel = {
    name: "mailchimpConfig",
    namePlural: "mailchimpConfigs",
    uniqueName: "mailchimpConfig",
    uniqueNamePlural: "mailchimpConfigs",
    path: "config/providers/newsletter/mailchimp_config",
    baseUrl: "/config/providers/newsletter/mailchimp_configs",
    translationPrefix: "entities:mailchimpConfig.",
    getDisplayName: function(values) {
        return "MAILCHIMP CONFIG";
    },
    gql: {
        getAll: ALL_MAILCHIMP_CONFIGS_QUERY,
        getSingle: SINGLE_MAILCHIMP_CONFIG_QUERY,
        create: CREATE_MAILCHIMP_CONFIG_MUTATION,
        update: UPDATE_MAILCHIMP_CONFIG_MUTATION,
        delete: DELETE_MAILCHIMP_CONFIG_MUTATION,
        forceDelete: FORCE_DELETE_MAILCHIMP_CONFIG_MUTATION
    },
    attributes: {
        apiKey: {
            name: "apiKey",
            label: "entities:mailchimpConfig.attributes.apiKey.label",
            type: "value",
            dataType: "string",
            defaultInput: true,
            inputType: "password",
            validationType: "string",
            validations: [
                {
                    type: "required"
                }, 
            ]
        },
        serverPrefix: {
            name: "serverPrefix",
            label: "entities:mailchimpConfig.attributes.serverPrefix.label",
            type: "value",
            dataType: "string",
            defaultInput: true,
            inputType: "text",
            validationType: "string",
            validations: [
                {
                    type: "required"
                }, 
            ]
        },
        listId: {
            name: "listId",
            label: "entities:mailchimpConfig.attributes.listId.label",
            type: "value",
            dataType: "string",
            defaultInput: true,
            inputType: "text",
            validationType: "string",
            validations: [
                {
                    type: "required"
                }, 
            ]
        }
    }
};
/* harmony default export */ var model = (mailchimpConfigModel);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(20414);
// EXTERNAL MODULE: ./src/entities/lib.ts
var lib = __webpack_require__(23480);
// EXTERNAL MODULE: ./src/lib/api/graphQLClient.ts
var graphQLClient = __webpack_require__(40112);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/swr/dist/index.mjs
var dist = __webpack_require__(8100);
// EXTERNAL MODULE: ./src/lib/helpers/helpers.ts
var helpers = __webpack_require__(15778);
;// CONCATENATED MODULE: ./src/entities/mailchimpConfig/repository.ts










var hydrateObjects = function(objects) {
    return objects.map(function(object) {
        return (0,lib/* hydrateEntityObject */.b)(model, object);
    });
};
var hydrateObject = function(object) {
    return (0,lib/* hydrateEntityObject */.b)(model, object);
};
var mailchimpConfigRepository = {
    getObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    id: id
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(SINGLE_MAILCHIMP_CONFIG_QUERY, variables).then(function(data) {
                        return hydrateObject(data.mailchimpConfig);
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }(),
    getObjects: /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        var includes;
        var _arguments = arguments;
        return (0,tslib_es6.__generator)(this, function(_state) {
            includes = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : {};
            return [
                2,
                graphQLClient/* default.request */.Z.request(ALL_MAILCHIMP_CONFIGS_QUERY, includes).then(function(data) {
                    return hydrateObjects(data.mailchimpConfigs);
                })
            ];
        });
    }),
    useObject: function(id) {
        var includes = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        // eslint-disable-next-line react-hooks/exhaustive-deps
        var variables = (0,react.useMemo)(function() {
            return (0,_object_spread/* default */.Z)({
                id: id
            }, includes);
        }, [
            id
        ]);
        var ref = (0,dist/* default */.ZP)([
            SINGLE_MAILCHIMP_CONFIG_QUERY,
            variables
        ], {
            revalidateOnFocus: false
        }), data = ref.data, error = ref.error, mutate = ref.mutate;
        return {
            object: !data ? data : hydrateObject(data.mailchimpConfig),
            isLoading: !error && !data,
            isError: error,
            mutate: mutate
        };
    },
    useObjects: function() {
        var includes = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        // eslint-disable-next-line react-hooks/exhaustive-deps
        var variables = (0,react.useMemo)(function() {
            return includes;
        }, []);
        var ref = (0,dist/* default */.ZP)([
            ALL_MAILCHIMP_CONFIGS_QUERY,
            variables
        ]), data = ref.data, error = ref.error, mutate = ref.mutate;
        return {
            objects: !data ? data : hydrateObjects(data.mailchimpConfigs),
            isLoading: !error && !data,
            isError: error,
            mutate: mutate
        };
    },
    getDependents: function(id, includes) {
        var includeVars = {};
        includes.forEach(function(include) {
            includeVars["with".concat((0,helpers/* uppercaseFirst */.AB)(include))] = true;
        });
        var variables = (0,_object_spread/* default */.Z)({
            id: id
        }, includeVars);
        return graphQLClient/* default.request */.Z.request(MAILCHIMP_CONFIGS_DEPENDENTS_QUERY, variables).then(function(data) {
            return data.groupedDependents;
        });
    },
    useDependents: function(id, includes) {
        var includeVars = {};
        includes.forEach(function(include) {
            includeVars["with".concat((0,helpers/* uppercaseFirst */.AB)(include))] = true;
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
        var variables = (0,react.useMemo)(function() {
            return (0,_object_spread/* default */.Z)({
                id: id
            }, includeVars);
        }, [
            id
        ]);
        var ref = (0,dist/* default */.ZP)([
            MAILCHIMP_CONFIGS_DEPENDENTS_QUERY,
            variables
        ], {
            revalidateOnFocus: false
        }), data = ref.data, error = ref.error, mutate = ref.mutate;
        return {
            data: !data ? data : data.groupedDependents,
            isLoading: !error && !data,
            isError: error,
            mutate: mutate
        };
    },
    createObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(data) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    input: data
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(CREATE_MAILCHIMP_CONFIG_MUTATION, variables).then(function(data) {
                        return hydrateObject(data.mailchimpConfig);
                    })
                ];
            });
        });
        return function(data) {
            return _ref.apply(this, arguments);
        };
    }(),
    updateObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(data) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    input: data
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(UPDATE_MAILCHIMP_CONFIG_MUTATION, variables).then(function(data) {
                        return hydrateObject(data.mailchimpConfig);
                    })
                ];
            });
        });
        return function(data) {
            return _ref.apply(this, arguments);
        };
    }(),
    deleteObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(DELETE_MAILCHIMP_CONFIG_MUTATION, variables).then(function(data) {
                        return data.deleteMailchimpConfig;
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }(),
    forceDeleteObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(FORCE_DELETE_MAILCHIMP_CONFIG_MUTATION, variables).then(function(data) {
                        return data.forceDeleteMailchimpConfig;
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }()
};
/* harmony default export */ var repository = (mailchimpConfigRepository);

;// CONCATENATED MODULE: ./src/entities/mailchimpConfig/entity.ts


var mailchimpConfigEntity = {
    model: model,
    repository: repository
};
/* harmony default export */ var entity = (mailchimpConfigEntity);


/***/ }),

/***/ 24180:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ entity; }
});

;// CONCATENATED MODULE: ./src/entities/mediaFile/graphql.ts
// language=GraphQL
var ALL_FILES_QUERY = "query Query {\n  files: mediaFiles {\n    id\n    assetId\n    publicId\n    url\n    resourceType\n    format\n    width\n    height\n    caption\n    title\n    description\n  }\n}";
// language=GraphQL
var SINGLE_FILE_QUERY = "query Query($id: ID!) {\n  file: mediaFile(id: $id) {\n    id\n    assetId\n    publicId\n    url\n    resourceType\n    format\n    width\n    height\n    caption\n    title\n    description\n  }\n}";
// language=GraphQL
var CREATE_FILE_MUTATION = "\n  mutation Mutation($input: CreateMediaFileInput) {\n    file: createMediaFile(input: $input) {\n      id\n      assetId\n      publicId\n      url\n      resourceType\n      format\n      width\n      height\n      caption\n      title\n      description\n    }\n  }";
// language=GraphQL
var UPDATE_FILE_MUTATION = "\n  mutation Mutation($input: UpdateMediaFileInput) {\n    file: updateMediaFile(input: $input) {\n      id\n      assetId\n      publicId\n      url\n      resourceType\n      format\n      width\n      height\n      caption\n      title\n      description\n    }\n  }";
// language=GraphQL
var DELETE_FILE_MUTATION = "\n  mutation Mutation($input: DeleteMediaFileInput) {\n    deleteMediaFile(input: $input) {\n      success\n    }\n  }";
// language=GraphQL
var FORCE_DELETE_FILE_MUTATION = "\n  mutation Mutation($input: DeleteMediaFileInput) {\n    forceDeleteMediaFile(input: $input) {\n      success\n    }\n  }";
// language=GraphQL
var FILES_DEPENDENTS_QUERY = "query Query($id: ID!, $withCmsTextWithImageBlocks: Boolean = false, $withCmsTextWithIconBlocks: Boolean = false, $withCmsPageHeaderBlocks: Boolean = false, $withElementSeoSettings: Boolean = false, $withAccommodationAvailableAddons: Boolean = false, $withTravelPartners: Boolean = false, $withTravelGuides: Boolean = false, $withEmployees: Boolean = false, $withTravels: Boolean = false, $withTravelExtensions: Boolean = false, $withCmsImageBlocks: Boolean = false, $withTravelTypes: Boolean = false, $withTravelPricingBrandings: Boolean = false, $withItineraryItems: Boolean = false, $withCmsHeaderSliderBlockSlides: Boolean = false, $withImageGalleries: Boolean = false) {\n  groupedDependents: mediaFileDependents(id: $id) {\n    cmsTextWithImageBlocks @include(if: $withCmsTextWithImageBlocks) {\n      id\n      title\n      subtitle\n      text\n      imagePosition\n      imageFixedAspectRatio\n    }\n    cmsTextWithIconBlocks @include(if: $withCmsTextWithIconBlocks) {\n      id\n      title\n      text\n      imagePosition    }\n    cmsPageHeaderBlocks @include(if: $withCmsPageHeaderBlocks) {\n      id\n      title\n      text\n    }\n    elementSeoSettings @include(if: $withElementSeoSettings) {\n      id\n      urlSlug\n      metaTitle\n      metaDescription\n      ogTitle\n      ogDescription\n    }\n    accommodationAvailableAddons @include(if: $withAccommodationAvailableAddons) {\n      id\n      name\n      description\n    }\n    travelPartners @include(if: $withTravelPartners) {\n      id\n      name\n      url\n      logoWidth\n    }\n    travelGuides @include(if: $withTravelGuides) {\n      id\n      firstName\n      lastName\n      description\n    }\n    employees @include(if: $withEmployees) {\n      id\n      firstName\n      lastName\n      jobTitle\n      description\n      email\n      phone    }\n    travels @include(if: $withTravels) {\n      id\n      name\n      isBestseller\n      startDate\n      endDate\n      executionStatus\n      title\n      description\n      includedServices\n      excludedServices\n      pricingTable\n      priceCalculationInfo\n      programType\n      programText\n      minPrice\n      minPriceManualOverride\n      currency    }\n    travelExtensions @include(if: $withTravelExtensions) {\n      id\n      duration\n      name\n      description\n    }\n    cmsImageBlocks @include(if: $withCmsImageBlocks) {\n      id\n      text\n      fluid    }\n    travelTypes @include(if: $withTravelTypes) {\n      id\n      name\n      description\n    }\n    travelPricingBrandings @include(if: $withTravelPricingBrandings) {\n      id\n      logoWidth    }\n    itineraryItems @include(if: $withItineraryItems) {\n      id\n      duration\n      title\n      text\n    }\n    cmsHeaderSliderBlockSlides @include(if: $withCmsHeaderSliderBlockSlides) {\n      id\n      title\n      text\n    }\n    imageGalleries @include(if: $withImageGalleries) {\n      id\n    }\n  }\n}";

;// CONCATENATED MODULE: ./src/entities/mediaFile/model.ts

var mediaFileModel = {
    name: "file",
    namePlural: "files",
    uniqueName: "mediaFile",
    uniqueNamePlural: "mediaFiles",
    path: "media/file",
    baseUrl: "/media/files",
    translationPrefix: "entities:mediaFile.",
    getDisplayName: function(values) {
        return values.title;
    },
    gql: {
        getAll: ALL_FILES_QUERY,
        getSingle: SINGLE_FILE_QUERY,
        create: CREATE_FILE_MUTATION,
        update: UPDATE_FILE_MUTATION,
        delete: DELETE_FILE_MUTATION,
        forceDelete: FORCE_DELETE_FILE_MUTATION
    },
    attributes: {
        assetId: {
            name: "assetId",
            label: "entities:mediaFile.attributes.assetId.label",
            type: "value",
            dataType: "string",
            defaultInput: false,
            inputType: "text",
            validationType: "string",
            validations: [
                {
                    type: "required"
                }, 
            ]
        },
        publicId: {
            name: "publicId",
            label: "entities:mediaFile.attributes.publicId.label",
            type: "value",
            dataType: "string",
            defaultInput: false,
            inputType: "text",
            validationType: "string",
            validations: []
        },
        url: {
            name: "url",
            label: "entities:mediaFile.attributes.url.label",
            type: "value",
            dataType: "string",
            defaultInput: false,
            inputType: "text",
            validationType: "string",
            validations: []
        },
        resourceType: {
            name: "resourceType",
            label: "entities:mediaFile.attributes.resourceType.label",
            type: "value",
            dataType: "string",
            defaultInput: false,
            inputType: "text",
            validationType: "string",
            validations: []
        },
        format: {
            name: "format",
            label: "entities:mediaFile.attributes.format.label",
            type: "value",
            dataType: "string",
            defaultInput: false,
            inputType: "text",
            validationType: "string",
            validations: []
        },
        width: {
            name: "width",
            label: "entities:mediaFile.attributes.width.label",
            type: "value",
            dataType: "number",
            defaultInput: false,
            inputType: "text",
            validationType: "string",
            validations: []
        },
        height: {
            name: "height",
            label: "entities:mediaFile.attributes.height.label",
            type: "value",
            dataType: "number",
            defaultInput: false,
            inputType: "text",
            validationType: "string",
            validations: []
        },
        caption: {
            name: "caption",
            label: "entities:mediaFile.attributes.caption.label",
            type: "value",
            dataType: "string",
            defaultInput: true,
            inputType: "text",
            validationType: "string",
            validations: []
        },
        title: {
            name: "title",
            label: "entities:mediaFile.attributes.title.label",
            type: "value",
            dataType: "string",
            defaultInput: true,
            inputType: "text",
            validationType: "string",
            validations: []
        },
        description: {
            name: "description",
            label: "entities:mediaFile.attributes.description.label",
            type: "value",
            dataType: "string",
            defaultInput: true,
            inputType: "text",
            validationType: "string",
            validations: []
        }
    }
};
/* harmony default export */ var model = (mediaFileModel);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(20414);
// EXTERNAL MODULE: ./src/entities/lib.ts
var lib = __webpack_require__(23480);
// EXTERNAL MODULE: ./src/lib/api/graphQLClient.ts
var graphQLClient = __webpack_require__(40112);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/swr/dist/index.mjs
var dist = __webpack_require__(8100);
// EXTERNAL MODULE: ./src/lib/helpers/helpers.ts
var helpers = __webpack_require__(15778);
;// CONCATENATED MODULE: ./src/entities/mediaFile/repository.ts










var hydrateObjects = function(objects) {
    return objects.map(function(object) {
        return (0,lib/* hydrateEntityObject */.b)(model, object);
    });
};
var hydrateObject = function(object) {
    return (0,lib/* hydrateEntityObject */.b)(model, object);
};
var mediaFileRepository = {
    getObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    id: id
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(SINGLE_FILE_QUERY, variables).then(function(data) {
                        return hydrateObject(data.file);
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }(),
    getObjects: /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        var includes;
        var _arguments = arguments;
        return (0,tslib_es6.__generator)(this, function(_state) {
            includes = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : {};
            return [
                2,
                graphQLClient/* default.request */.Z.request(ALL_FILES_QUERY, includes).then(function(data) {
                    return hydrateObjects(data.files);
                })
            ];
        });
    }),
    useObject: function(id) {
        var includes = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        // eslint-disable-next-line react-hooks/exhaustive-deps
        var variables = (0,react.useMemo)(function() {
            return (0,_object_spread/* default */.Z)({
                id: id
            }, includes);
        }, [
            id
        ]);
        var ref = (0,dist/* default */.ZP)([
            SINGLE_FILE_QUERY,
            variables
        ], {
            revalidateOnFocus: false
        }), data = ref.data, error = ref.error, mutate = ref.mutate;
        return {
            object: !data ? data : hydrateObject(data.file),
            isLoading: !error && !data,
            isError: error,
            mutate: mutate
        };
    },
    useObjects: function() {
        var includes = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        // eslint-disable-next-line react-hooks/exhaustive-deps
        var variables = (0,react.useMemo)(function() {
            return includes;
        }, []);
        var ref = (0,dist/* default */.ZP)([
            ALL_FILES_QUERY,
            variables
        ]), data = ref.data, error = ref.error, mutate = ref.mutate;
        return {
            objects: !data ? data : hydrateObjects(data.files),
            isLoading: !error && !data,
            isError: error,
            mutate: mutate
        };
    },
    getDependents: function(id, includes) {
        var includeVars = {};
        includes.forEach(function(include) {
            includeVars["with".concat((0,helpers/* uppercaseFirst */.AB)(include))] = true;
        });
        var variables = (0,_object_spread/* default */.Z)({
            id: id
        }, includeVars);
        return graphQLClient/* default.request */.Z.request(FILES_DEPENDENTS_QUERY, variables).then(function(data) {
            return data.groupedDependents;
        });
    },
    useDependents: function(id, includes) {
        var includeVars = {};
        includes.forEach(function(include) {
            includeVars["with".concat((0,helpers/* uppercaseFirst */.AB)(include))] = true;
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
        var variables = (0,react.useMemo)(function() {
            return (0,_object_spread/* default */.Z)({
                id: id
            }, includeVars);
        }, [
            id
        ]);
        var ref = (0,dist/* default */.ZP)([
            FILES_DEPENDENTS_QUERY,
            variables
        ], {
            revalidateOnFocus: false
        }), data = ref.data, error = ref.error, mutate = ref.mutate;
        return {
            data: !data ? data : data.groupedDependents,
            isLoading: !error && !data,
            isError: error,
            mutate: mutate
        };
    },
    createObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(data) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    input: data
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(CREATE_FILE_MUTATION, variables).then(function(data) {
                        return hydrateObject(data.file);
                    })
                ];
            });
        });
        return function(data) {
            return _ref.apply(this, arguments);
        };
    }(),
    updateObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(data) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    input: data
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(UPDATE_FILE_MUTATION, variables).then(function(data) {
                        return hydrateObject(data.file);
                    })
                ];
            });
        });
        return function(data) {
            return _ref.apply(this, arguments);
        };
    }(),
    deleteObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(DELETE_FILE_MUTATION, variables).then(function(data) {
                        return data.deleteMediaFile;
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }(),
    forceDeleteObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(FORCE_DELETE_FILE_MUTATION, variables).then(function(data) {
                        return data.forceDeleteMediaFile;
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }()
};
/* harmony default export */ var repository = (mediaFileRepository);

;// CONCATENATED MODULE: ./src/entities/mediaFile/entity.ts


var mediaFileEntity = {
    model: model,
    repository: repository
};
/* harmony default export */ var entity = (mediaFileEntity);


/***/ }),

/***/ 5433:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ newsletterProvider_entity; }
});

;// CONCATENATED MODULE: ./src/entities/newsletterProvider/graphql.ts
// language=GraphQL
var ALL_NEWSLETTER_PROVIDERS_QUERY = "query Query($withConfig: Boolean = false) {\n  newsletterProviders: newsletterProviders {\n    id\n    provider\n    config @include(if: $withConfig) {\n      __typename\n      ... on MailchimpConfig {\n        id\n        apiKey\n        serverPrefix\n        listId\n\n      }\n    }\n  }\n}";
// language=GraphQL
var SINGLE_NEWSLETTER_PROVIDER_QUERY = "query Query($id: ID!, $withConfig: Boolean = false) {\n  newsletterProvider: newsletterProvider(id: $id) {\n    id\n    provider\n    config @include(if: $withConfig) {\n      __typename\n      ... on MailchimpConfig {\n        id\n        apiKey\n        serverPrefix\n        listId\n\n      }\n    }\n  }\n}";
// language=GraphQL
var CREATE_NEWSLETTER_PROVIDER_MUTATION = "\n  mutation Mutation($input: CreateNewsletterProviderInput, $withConfig: Boolean = false) {\n    newsletterProvider: createNewsletterProvider(input: $input) {\n      id\n      provider\n      config @include(if: $withConfig) {\n        __typename\n        ... on MailchimpConfig {\n          id\n          apiKey\n          serverPrefix\n          listId\n\n        }\n      }\n    }\n  }";
// language=GraphQL
var UPDATE_NEWSLETTER_PROVIDER_MUTATION = "\n  mutation Mutation($input: UpdateNewsletterProviderInput, $withConfig: Boolean = false) {\n    newsletterProvider: updateNewsletterProvider(input: $input) {\n      id\n      provider\n      config @include(if: $withConfig) {\n        __typename\n        ... on MailchimpConfig {\n          id\n          apiKey\n          serverPrefix\n          listId\n\n        }\n      }\n    }\n  }";
// language=GraphQL
var DELETE_NEWSLETTER_PROVIDER_MUTATION = "\n  mutation Mutation($input: DeleteNewsletterProviderInput) {\n    deleteNewsletterProvider(input: $input) {\n      success\n    }\n  }";
// language=GraphQL
var FORCE_DELETE_NEWSLETTER_PROVIDER_MUTATION = "\n  mutation Mutation($input: DeleteNewsletterProviderInput) {\n    forceDeleteNewsletterProvider(input: $input) {\n      success\n    }\n  }";
// language=GraphQL
var NEWSLETTER_PROVIDERS_DEPENDENTS_QUERY = "query Query($id: ID!, $withTenants: Boolean = false) {\n  groupedDependents: newsletterProviderDependents(id: $id) {\n    tenants @include(if: $withTenants) {\n      id\n      name\n      slug\n      domain\n      externalReference\n    }\n  }\n}";

// EXTERNAL MODULE: ./src/entities/mailchimpConfig/entity.ts + 3 modules
var entity = __webpack_require__(26729);
;// CONCATENATED MODULE: ./src/entities/newsletterProvider/model.ts


var newsletterProviderModel = {
    name: "newsletterProvider",
    namePlural: "newsletterProviders",
    uniqueName: "newsletterProvider",
    uniqueNamePlural: "newsletterProviders",
    path: "config/tenant/newsletter_provider",
    baseUrl: "/config/tenant/newsletter_providers",
    translationPrefix: "entities:newsletterProvider.",
    getDisplayName: function(values) {
        return "NEWSLETTER PROVIDER";
    },
    gql: {
        getAll: ALL_NEWSLETTER_PROVIDERS_QUERY,
        getSingle: SINGLE_NEWSLETTER_PROVIDER_QUERY,
        create: CREATE_NEWSLETTER_PROVIDER_MUTATION,
        update: UPDATE_NEWSLETTER_PROVIDER_MUTATION,
        delete: DELETE_NEWSLETTER_PROVIDER_MUTATION,
        forceDelete: FORCE_DELETE_NEWSLETTER_PROVIDER_MUTATION
    },
    attributes: {
        provider: {
            name: "provider",
            label: "entities:newsletterProvider.attributes.provider.label",
            type: "value",
            dataType: "string",
            defaultValue: "MAILCHIMP",
            defaultInput: true,
            inputType: "select",
            selectOptions: [
                {
                    label: "entities:newsletterProvider.attributes.provider.selectOptions.MAILCHIMP.label",
                    value: "MAILCHIMP"
                }, 
            ],
            validationType: "string",
            validations: [
                {
                    type: "required"
                }, 
            ]
        },
        config: {
            name: "config",
            label: "entities:newsletterProvider.attributes.config.label",
            type: "entityObject",
            dataType: "any",
            getEntity: function() {
                return entity/* default */.Z;
            },
            defaultInput: false,
            inputType: "select",
            validationType: "string",
            validations: []
        }
    }
};
/* harmony default export */ var model = (newsletterProviderModel);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(20414);
// EXTERNAL MODULE: ./src/entities/lib.ts
var lib = __webpack_require__(23480);
// EXTERNAL MODULE: ./src/lib/api/graphQLClient.ts
var graphQLClient = __webpack_require__(40112);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/swr/dist/index.mjs
var dist = __webpack_require__(8100);
// EXTERNAL MODULE: ./src/lib/helpers/helpers.ts
var helpers = __webpack_require__(15778);
;// CONCATENATED MODULE: ./src/entities/newsletterProvider/repository.ts










var hydrateObjects = function(objects) {
    return objects.map(function(object) {
        return (0,lib/* hydrateEntityObject */.b)(model, object);
    });
};
var hydrateObject = function(object) {
    return (0,lib/* hydrateEntityObject */.b)(model, object);
};
var newsletterProviderRepository = {
    getObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    id: id
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(SINGLE_NEWSLETTER_PROVIDER_QUERY, variables).then(function(data) {
                        return hydrateObject(data.newsletterProvider);
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }(),
    getObjects: /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        var includes;
        var _arguments = arguments;
        return (0,tslib_es6.__generator)(this, function(_state) {
            includes = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : {};
            return [
                2,
                graphQLClient/* default.request */.Z.request(ALL_NEWSLETTER_PROVIDERS_QUERY, includes).then(function(data) {
                    return hydrateObjects(data.newsletterProviders);
                })
            ];
        });
    }),
    useObject: function(id) {
        var includes = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        // eslint-disable-next-line react-hooks/exhaustive-deps
        var variables = (0,react.useMemo)(function() {
            return (0,_object_spread/* default */.Z)({
                id: id
            }, includes);
        }, [
            id
        ]);
        var ref = (0,dist/* default */.ZP)([
            SINGLE_NEWSLETTER_PROVIDER_QUERY,
            variables
        ], {
            revalidateOnFocus: false
        }), data = ref.data, error = ref.error, mutate = ref.mutate;
        return {
            object: !data ? data : hydrateObject(data.newsletterProvider),
            isLoading: !error && !data,
            isError: error,
            mutate: mutate
        };
    },
    useObjects: function() {
        var includes = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        // eslint-disable-next-line react-hooks/exhaustive-deps
        var variables = (0,react.useMemo)(function() {
            return includes;
        }, []);
        var ref = (0,dist/* default */.ZP)([
            ALL_NEWSLETTER_PROVIDERS_QUERY,
            variables
        ]), data = ref.data, error = ref.error, mutate = ref.mutate;
        return {
            objects: !data ? data : hydrateObjects(data.newsletterProviders),
            isLoading: !error && !data,
            isError: error,
            mutate: mutate
        };
    },
    getDependents: function(id, includes) {
        var includeVars = {};
        includes.forEach(function(include) {
            includeVars["with".concat((0,helpers/* uppercaseFirst */.AB)(include))] = true;
        });
        var variables = (0,_object_spread/* default */.Z)({
            id: id
        }, includeVars);
        return graphQLClient/* default.request */.Z.request(NEWSLETTER_PROVIDERS_DEPENDENTS_QUERY, variables).then(function(data) {
            return data.groupedDependents;
        });
    },
    useDependents: function(id, includes) {
        var includeVars = {};
        includes.forEach(function(include) {
            includeVars["with".concat((0,helpers/* uppercaseFirst */.AB)(include))] = true;
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
        var variables = (0,react.useMemo)(function() {
            return (0,_object_spread/* default */.Z)({
                id: id
            }, includeVars);
        }, [
            id
        ]);
        var ref = (0,dist/* default */.ZP)([
            NEWSLETTER_PROVIDERS_DEPENDENTS_QUERY,
            variables
        ], {
            revalidateOnFocus: false
        }), data = ref.data, error = ref.error, mutate = ref.mutate;
        return {
            data: !data ? data : data.groupedDependents,
            isLoading: !error && !data,
            isError: error,
            mutate: mutate
        };
    },
    createObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(data) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    input: data
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(CREATE_NEWSLETTER_PROVIDER_MUTATION, variables).then(function(data) {
                        return hydrateObject(data.newsletterProvider);
                    })
                ];
            });
        });
        return function(data) {
            return _ref.apply(this, arguments);
        };
    }(),
    updateObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(data) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    input: data
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(UPDATE_NEWSLETTER_PROVIDER_MUTATION, variables).then(function(data) {
                        return hydrateObject(data.newsletterProvider);
                    })
                ];
            });
        });
        return function(data) {
            return _ref.apply(this, arguments);
        };
    }(),
    deleteObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(DELETE_NEWSLETTER_PROVIDER_MUTATION, variables).then(function(data) {
                        return data.deleteNewsletterProvider;
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }(),
    forceDeleteObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(FORCE_DELETE_NEWSLETTER_PROVIDER_MUTATION, variables).then(function(data) {
                        return data.forceDeleteNewsletterProvider;
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }()
};
/* harmony default export */ var repository = (newsletterProviderRepository);

;// CONCATENATED MODULE: ./src/entities/newsletterProvider/entity.ts


var newsletterProviderEntity = {
    model: model,
    repository: repository
};
/* harmony default export */ var newsletterProvider_entity = (newsletterProviderEntity);


/***/ }),

/***/ 67566:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ partnerTenant_entity; }
});

;// CONCATENATED MODULE: ./src/entities/partnerTenant/graphql.ts
// language=GraphQL
var ALL_PARTNER_TENANTS_QUERY = "query Query($withTenant: Boolean = false, $withTenantCms: Boolean = false, $withTenantCmsHomepage: Boolean = false, $withTenantCmsCategories: Boolean = false, $withTenantCmsPages: Boolean = false, $withTenantCmsErrorPage404: Boolean = false, $withTenantCmsErrorPage500: Boolean = false, $withTenantCmsConfig: Boolean = false, $withTenantTravelTypes: Boolean = false, $withTenantTravelTypesImage: Boolean = false, $withTenantEmployees: Boolean = false, $withTenantEmployeesImage: Boolean = false, $withTenantEmailConfig: Boolean = false, $withTenantNewsletterProvider: Boolean = false, $withTenantNewsletterProviderConfig: Boolean = false, $withTenantRedirects: Boolean = false, $withTenantRedirectsFromPage: Boolean = false, $withTenantRedirectsFromTravel: Boolean = false, $withTenantRedirectsToPage: Boolean = false, $withTenantRedirectsToTravel: Boolean = false, $withTenantOnlinePaymentConfig: Boolean = false, $withTenantRatioConfig: Boolean = false, $withTenantContent: Boolean = false, $withTenantPartnerTenants: Boolean = false, $withTenantPartnerTenantsTenant: Boolean = false) {\n  partnerTenants: partnerTenants {\n    id\n    tenant @include(if: $withTenant) {\n      id\n      name\n      slug\n      domain\n      externalReference\n      cms @include(if: $withTenantCms) {\n        id\n        homepage @include(if: $withTenantCmsHomepage) {\n          id\n          name\n          onlineStatus\n        }\n        categories @include(if: $withTenantCmsCategories) {\n          id\n          name\n        }\n        pages @include(if: $withTenantCmsPages) {\n          id\n          name\n          onlineStatus\n        }\n        errorPage404 @include(if: $withTenantCmsErrorPage404) {\n          id\n          name\n          onlineStatus\n        }\n        errorPage500 @include(if: $withTenantCmsErrorPage500) {\n          id\n          name\n          onlineStatus\n        }\n        config @include(if: $withTenantCmsConfig) {\n          id\n        }\n      }\n      travelTypes @include(if: $withTenantTravelTypes) {\n        id\n        name\n        description\n        image @include(if: $withTenantTravelTypesImage) {\n          id\n          assetId\n          publicId\n          url\n          resourceType\n          format\n          width\n          height\n          caption\n          title\n          description\n        }\n      }\n      employees @include(if: $withTenantEmployees) {\n        id\n        firstName\n        lastName\n        jobTitle\n        description\n        email\n        image @include(if: $withTenantEmployeesImage) {\n          id\n          assetId\n          publicId\n          url\n          resourceType\n          format\n          width\n          height\n          caption\n          title\n          description\n        }\n        phone\n      }\n      emailConfig @include(if: $withTenantEmailConfig) {\n        id\n        defaultInternalRecipientEmail\n        internalBookingRecipientEmails\n        bookingConfirmationTemplateId\n        bookingConfirmationInternalTemplateId\n        bookingRequestConfirmationTemplateId\n        bookingWaitlistConfirmationTemplateId\n        bookingWaitlistContingentCheckConfirmationTemplateId\n        bookingCustomRequestTemplateId\n        bookingPassportDataReminderTemplateId\n        contactFormTemplateId\n        esimInstallationInfoTemplateId\n      }\n      newsletterProvider @include(if: $withTenantNewsletterProvider) {\n        id\n        provider\n        config @include(if: $withTenantNewsletterProviderConfig) {\n          __typename\n          ... on MailchimpConfig {\n            id\n            apiKey\n            serverPrefix\n            listId\n\n          }\n        }\n      }\n      redirects @include(if: $withTenantRedirects) {\n        id\n        fromType\n        fromUrl\n        fromPage @include(if: $withTenantRedirectsFromPage) {\n          id\n          name\n          onlineStatus\n        }\n        fromTravel @include(if: $withTenantRedirectsFromTravel) {\n          id\n          name\n          isBestseller\n          startDate\n          endDate\n          executionStatus\n          title\n          description\n          includedServices\n          excludedServices\n          pricingTable\n          priceCalculationInfo\n          programType\n          programText\n          minPrice\n          minPriceManualOverride\n          currency\n        }\n        toType\n        toUrl\n        toPage @include(if: $withTenantRedirectsToPage) {\n          id\n          name\n          onlineStatus\n        }\n        toTravel @include(if: $withTenantRedirectsToTravel) {\n          id\n          name\n          isBestseller\n          startDate\n          endDate\n          executionStatus\n          title\n          description\n          includedServices\n          excludedServices\n          pricingTable\n          priceCalculationInfo\n          programType\n          programText\n          minPrice\n          minPriceManualOverride\n          currency\n        }\n      }\n      onlinePaymentConfig @include(if: $withTenantOnlinePaymentConfig) {\n        id\n        enabled\n        ratioFibuAccountNo\n        infoText\n        datatransThemeConfig\n      }\n      ratioConfig @include(if: $withTenantRatioConfig) {\n        id\n        adressgruppe\n      }\n      content @include(if: $withTenantContent) {\n        id\n        bookingInsuranceInfo\n      }\n      partnerTenants @include(if: $withTenantPartnerTenants) {\n        id\n        tenant @include(if: $withTenantPartnerTenantsTenant) {\n          id\n          name\n          slug\n          domain\n          externalReference\n        }\n        filterCrossLinking\n      }\n    }\n    filterCrossLinking\n  }\n}";
// language=GraphQL
var SINGLE_PARTNER_TENANT_QUERY = "query Query($id: ID!, $withTenant: Boolean = false, $withTenantCms: Boolean = false, $withTenantCmsHomepage: Boolean = false, $withTenantCmsCategories: Boolean = false, $withTenantCmsPages: Boolean = false, $withTenantCmsErrorPage404: Boolean = false, $withTenantCmsErrorPage500: Boolean = false, $withTenantCmsConfig: Boolean = false, $withTenantTravelTypes: Boolean = false, $withTenantTravelTypesImage: Boolean = false, $withTenantEmployees: Boolean = false, $withTenantEmployeesImage: Boolean = false, $withTenantEmailConfig: Boolean = false, $withTenantNewsletterProvider: Boolean = false, $withTenantNewsletterProviderConfig: Boolean = false, $withTenantRedirects: Boolean = false, $withTenantRedirectsFromPage: Boolean = false, $withTenantRedirectsFromTravel: Boolean = false, $withTenantRedirectsToPage: Boolean = false, $withTenantRedirectsToTravel: Boolean = false, $withTenantOnlinePaymentConfig: Boolean = false, $withTenantRatioConfig: Boolean = false, $withTenantContent: Boolean = false, $withTenantPartnerTenants: Boolean = false, $withTenantPartnerTenantsTenant: Boolean = false) {\n  partnerTenant: partnerTenant(id: $id) {\n    id\n    tenant @include(if: $withTenant) {\n      id\n      name\n      slug\n      domain\n      externalReference\n      cms @include(if: $withTenantCms) {\n        id\n        homepage @include(if: $withTenantCmsHomepage) {\n          id\n          name\n          onlineStatus\n        }\n        categories @include(if: $withTenantCmsCategories) {\n          id\n          name\n        }\n        pages @include(if: $withTenantCmsPages) {\n          id\n          name\n          onlineStatus\n        }\n        errorPage404 @include(if: $withTenantCmsErrorPage404) {\n          id\n          name\n          onlineStatus\n        }\n        errorPage500 @include(if: $withTenantCmsErrorPage500) {\n          id\n          name\n          onlineStatus\n        }\n        config @include(if: $withTenantCmsConfig) {\n          id\n        }\n      }\n      travelTypes @include(if: $withTenantTravelTypes) {\n        id\n        name\n        description\n        image @include(if: $withTenantTravelTypesImage) {\n          id\n          assetId\n          publicId\n          url\n          resourceType\n          format\n          width\n          height\n          caption\n          title\n          description\n        }\n      }\n      employees @include(if: $withTenantEmployees) {\n        id\n        firstName\n        lastName\n        jobTitle\n        description\n        email\n        image @include(if: $withTenantEmployeesImage) {\n          id\n          assetId\n          publicId\n          url\n          resourceType\n          format\n          width\n          height\n          caption\n          title\n          description\n        }\n        phone\n      }\n      emailConfig @include(if: $withTenantEmailConfig) {\n        id\n        defaultInternalRecipientEmail\n        internalBookingRecipientEmails\n        bookingConfirmationTemplateId\n        bookingConfirmationInternalTemplateId\n        bookingRequestConfirmationTemplateId\n        bookingWaitlistConfirmationTemplateId\n        bookingWaitlistContingentCheckConfirmationTemplateId\n        bookingCustomRequestTemplateId\n        bookingPassportDataReminderTemplateId\n        contactFormTemplateId\n        esimInstallationInfoTemplateId\n      }\n      newsletterProvider @include(if: $withTenantNewsletterProvider) {\n        id\n        provider\n        config @include(if: $withTenantNewsletterProviderConfig) {\n          __typename\n          ... on MailchimpConfig {\n            id\n            apiKey\n            serverPrefix\n            listId\n\n          }\n        }\n      }\n      redirects @include(if: $withTenantRedirects) {\n        id\n        fromType\n        fromUrl\n        fromPage @include(if: $withTenantRedirectsFromPage) {\n          id\n          name\n          onlineStatus\n        }\n        fromTravel @include(if: $withTenantRedirectsFromTravel) {\n          id\n          name\n          isBestseller\n          startDate\n          endDate\n          executionStatus\n          title\n          description\n          includedServices\n          excludedServices\n          pricingTable\n          priceCalculationInfo\n          programType\n          programText\n          minPrice\n          minPriceManualOverride\n          currency\n        }\n        toType\n        toUrl\n        toPage @include(if: $withTenantRedirectsToPage) {\n          id\n          name\n          onlineStatus\n        }\n        toTravel @include(if: $withTenantRedirectsToTravel) {\n          id\n          name\n          isBestseller\n          startDate\n          endDate\n          executionStatus\n          title\n          description\n          includedServices\n          excludedServices\n          pricingTable\n          priceCalculationInfo\n          programType\n          programText\n          minPrice\n          minPriceManualOverride\n          currency\n        }\n      }\n      onlinePaymentConfig @include(if: $withTenantOnlinePaymentConfig) {\n        id\n        enabled\n        ratioFibuAccountNo\n        infoText\n        datatransThemeConfig\n      }\n      ratioConfig @include(if: $withTenantRatioConfig) {\n        id\n        adressgruppe\n      }\n      content @include(if: $withTenantContent) {\n        id\n        bookingInsuranceInfo\n      }\n      partnerTenants @include(if: $withTenantPartnerTenants) {\n        id\n        tenant @include(if: $withTenantPartnerTenantsTenant) {\n          id\n          name\n          slug\n          domain\n          externalReference\n        }\n        filterCrossLinking\n      }\n    }\n    filterCrossLinking\n  }\n}";
// language=GraphQL
var CREATE_PARTNER_TENANT_MUTATION = "\n  mutation Mutation($input: CreatePartnerTenantInput, $withTenant: Boolean = false, $withTenantCms: Boolean = false, $withTenantCmsHomepage: Boolean = false, $withTenantCmsCategories: Boolean = false, $withTenantCmsPages: Boolean = false, $withTenantCmsErrorPage404: Boolean = false, $withTenantCmsErrorPage500: Boolean = false, $withTenantCmsConfig: Boolean = false, $withTenantTravelTypes: Boolean = false, $withTenantTravelTypesImage: Boolean = false, $withTenantEmployees: Boolean = false, $withTenantEmployeesImage: Boolean = false, $withTenantEmailConfig: Boolean = false, $withTenantNewsletterProvider: Boolean = false, $withTenantNewsletterProviderConfig: Boolean = false, $withTenantRedirects: Boolean = false, $withTenantRedirectsFromPage: Boolean = false, $withTenantRedirectsFromTravel: Boolean = false, $withTenantRedirectsToPage: Boolean = false, $withTenantRedirectsToTravel: Boolean = false, $withTenantOnlinePaymentConfig: Boolean = false, $withTenantRatioConfig: Boolean = false, $withTenantContent: Boolean = false, $withTenantPartnerTenants: Boolean = false, $withTenantPartnerTenantsTenant: Boolean = false) {\n    partnerTenant: createPartnerTenant(input: $input) {\n      id\n      tenant @include(if: $withTenant) {\n        id\n        name\n        slug\n        domain\n        externalReference\n        cms @include(if: $withTenantCms) {\n          id\n          homepage @include(if: $withTenantCmsHomepage) {\n            id\n            name\n            onlineStatus\n          }\n          categories @include(if: $withTenantCmsCategories) {\n            id\n            name\n          }\n          pages @include(if: $withTenantCmsPages) {\n            id\n            name\n            onlineStatus\n          }\n          errorPage404 @include(if: $withTenantCmsErrorPage404) {\n            id\n            name\n            onlineStatus\n          }\n          errorPage500 @include(if: $withTenantCmsErrorPage500) {\n            id\n            name\n            onlineStatus\n          }\n          config @include(if: $withTenantCmsConfig) {\n            id\n          }\n        }\n        travelTypes @include(if: $withTenantTravelTypes) {\n          id\n          name\n          description\n          image @include(if: $withTenantTravelTypesImage) {\n            id\n            assetId\n            publicId\n            url\n            resourceType\n            format\n            width\n            height\n            caption\n            title\n            description\n          }\n        }\n        employees @include(if: $withTenantEmployees) {\n          id\n          firstName\n          lastName\n          jobTitle\n          description\n          email\n          image @include(if: $withTenantEmployeesImage) {\n            id\n            assetId\n            publicId\n            url\n            resourceType\n            format\n            width\n            height\n            caption\n            title\n            description\n          }\n          phone\n        }\n        emailConfig @include(if: $withTenantEmailConfig) {\n          id\n          defaultInternalRecipientEmail\n          internalBookingRecipientEmails\n          bookingConfirmationTemplateId\n          bookingConfirmationInternalTemplateId\n          bookingRequestConfirmationTemplateId\n          bookingWaitlistConfirmationTemplateId\n          bookingWaitlistContingentCheckConfirmationTemplateId\n          bookingCustomRequestTemplateId\n          bookingPassportDataReminderTemplateId\n          contactFormTemplateId\n          esimInstallationInfoTemplateId\n        }\n        newsletterProvider @include(if: $withTenantNewsletterProvider) {\n          id\n          provider\n          config @include(if: $withTenantNewsletterProviderConfig) {\n            __typename\n            ... on MailchimpConfig {\n              id\n              apiKey\n              serverPrefix\n              listId\n\n            }\n          }\n        }\n        redirects @include(if: $withTenantRedirects) {\n          id\n          fromType\n          fromUrl\n          fromPage @include(if: $withTenantRedirectsFromPage) {\n            id\n            name\n            onlineStatus\n          }\n          fromTravel @include(if: $withTenantRedirectsFromTravel) {\n            id\n            name\n            isBestseller\n            startDate\n            endDate\n            executionStatus\n            title\n            description\n            includedServices\n            excludedServices\n            pricingTable\n            priceCalculationInfo\n            programType\n            programText\n            minPrice\n            minPriceManualOverride\n            currency\n          }\n          toType\n          toUrl\n          toPage @include(if: $withTenantRedirectsToPage) {\n            id\n            name\n            onlineStatus\n          }\n          toTravel @include(if: $withTenantRedirectsToTravel) {\n            id\n            name\n            isBestseller\n            startDate\n            endDate\n            executionStatus\n            title\n            description\n            includedServices\n            excludedServices\n            pricingTable\n            priceCalculationInfo\n            programType\n            programText\n            minPrice\n            minPriceManualOverride\n            currency\n          }\n        }\n        onlinePaymentConfig @include(if: $withTenantOnlinePaymentConfig) {\n          id\n          enabled\n          ratioFibuAccountNo\n          infoText\n          datatransThemeConfig\n        }\n        ratioConfig @include(if: $withTenantRatioConfig) {\n          id\n          adressgruppe\n        }\n        content @include(if: $withTenantContent) {\n          id\n          bookingInsuranceInfo\n        }\n        partnerTenants @include(if: $withTenantPartnerTenants) {\n          id\n          tenant @include(if: $withTenantPartnerTenantsTenant) {\n            id\n            name\n            slug\n            domain\n            externalReference\n          }\n          filterCrossLinking\n        }\n      }\n      filterCrossLinking\n    }\n  }";
// language=GraphQL
var UPDATE_PARTNER_TENANT_MUTATION = "\n  mutation Mutation($input: UpdatePartnerTenantInput, $withTenant: Boolean = false, $withTenantCms: Boolean = false, $withTenantCmsHomepage: Boolean = false, $withTenantCmsCategories: Boolean = false, $withTenantCmsPages: Boolean = false, $withTenantCmsErrorPage404: Boolean = false, $withTenantCmsErrorPage500: Boolean = false, $withTenantCmsConfig: Boolean = false, $withTenantTravelTypes: Boolean = false, $withTenantTravelTypesImage: Boolean = false, $withTenantEmployees: Boolean = false, $withTenantEmployeesImage: Boolean = false, $withTenantEmailConfig: Boolean = false, $withTenantNewsletterProvider: Boolean = false, $withTenantNewsletterProviderConfig: Boolean = false, $withTenantRedirects: Boolean = false, $withTenantRedirectsFromPage: Boolean = false, $withTenantRedirectsFromTravel: Boolean = false, $withTenantRedirectsToPage: Boolean = false, $withTenantRedirectsToTravel: Boolean = false, $withTenantOnlinePaymentConfig: Boolean = false, $withTenantRatioConfig: Boolean = false, $withTenantContent: Boolean = false, $withTenantPartnerTenants: Boolean = false, $withTenantPartnerTenantsTenant: Boolean = false) {\n    partnerTenant: updatePartnerTenant(input: $input) {\n      id\n      tenant @include(if: $withTenant) {\n        id\n        name\n        slug\n        domain\n        externalReference\n        cms @include(if: $withTenantCms) {\n          id\n          homepage @include(if: $withTenantCmsHomepage) {\n            id\n            name\n            onlineStatus\n          }\n          categories @include(if: $withTenantCmsCategories) {\n            id\n            name\n          }\n          pages @include(if: $withTenantCmsPages) {\n            id\n            name\n            onlineStatus\n          }\n          errorPage404 @include(if: $withTenantCmsErrorPage404) {\n            id\n            name\n            onlineStatus\n          }\n          errorPage500 @include(if: $withTenantCmsErrorPage500) {\n            id\n            name\n            onlineStatus\n          }\n          config @include(if: $withTenantCmsConfig) {\n            id\n          }\n        }\n        travelTypes @include(if: $withTenantTravelTypes) {\n          id\n          name\n          description\n          image @include(if: $withTenantTravelTypesImage) {\n            id\n            assetId\n            publicId\n            url\n            resourceType\n            format\n            width\n            height\n            caption\n            title\n            description\n          }\n        }\n        employees @include(if: $withTenantEmployees) {\n          id\n          firstName\n          lastName\n          jobTitle\n          description\n          email\n          image @include(if: $withTenantEmployeesImage) {\n            id\n            assetId\n            publicId\n            url\n            resourceType\n            format\n            width\n            height\n            caption\n            title\n            description\n          }\n          phone\n        }\n        emailConfig @include(if: $withTenantEmailConfig) {\n          id\n          defaultInternalRecipientEmail\n          internalBookingRecipientEmails\n          bookingConfirmationTemplateId\n          bookingConfirmationInternalTemplateId\n          bookingRequestConfirmationTemplateId\n          bookingWaitlistConfirmationTemplateId\n          bookingWaitlistContingentCheckConfirmationTemplateId\n          bookingCustomRequestTemplateId\n          bookingPassportDataReminderTemplateId\n          contactFormTemplateId\n          esimInstallationInfoTemplateId\n        }\n        newsletterProvider @include(if: $withTenantNewsletterProvider) {\n          id\n          provider\n          config @include(if: $withTenantNewsletterProviderConfig) {\n            __typename\n            ... on MailchimpConfig {\n              id\n              apiKey\n              serverPrefix\n              listId\n\n            }\n          }\n        }\n        redirects @include(if: $withTenantRedirects) {\n          id\n          fromType\n          fromUrl\n          fromPage @include(if: $withTenantRedirectsFromPage) {\n            id\n            name\n            onlineStatus\n          }\n          fromTravel @include(if: $withTenantRedirectsFromTravel) {\n            id\n            name\n            isBestseller\n            startDate\n            endDate\n            executionStatus\n            title\n            description\n            includedServices\n            excludedServices\n            pricingTable\n            priceCalculationInfo\n            programType\n            programText\n            minPrice\n            minPriceManualOverride\n            currency\n          }\n          toType\n          toUrl\n          toPage @include(if: $withTenantRedirectsToPage) {\n            id\n            name\n            onlineStatus\n          }\n          toTravel @include(if: $withTenantRedirectsToTravel) {\n            id\n            name\n            isBestseller\n            startDate\n            endDate\n            executionStatus\n            title\n            description\n            includedServices\n            excludedServices\n            pricingTable\n            priceCalculationInfo\n            programType\n            programText\n            minPrice\n            minPriceManualOverride\n            currency\n          }\n        }\n        onlinePaymentConfig @include(if: $withTenantOnlinePaymentConfig) {\n          id\n          enabled\n          ratioFibuAccountNo\n          infoText\n          datatransThemeConfig\n        }\n        ratioConfig @include(if: $withTenantRatioConfig) {\n          id\n          adressgruppe\n        }\n        content @include(if: $withTenantContent) {\n          id\n          bookingInsuranceInfo\n        }\n        partnerTenants @include(if: $withTenantPartnerTenants) {\n          id\n          tenant @include(if: $withTenantPartnerTenantsTenant) {\n            id\n            name\n            slug\n            domain\n            externalReference\n          }\n          filterCrossLinking\n        }\n      }\n      filterCrossLinking\n    }\n  }";
// language=GraphQL
var DELETE_PARTNER_TENANT_MUTATION = "\n  mutation Mutation($input: DeletePartnerTenantInput) {\n    deletePartnerTenant(input: $input) {\n      success\n    }\n  }";
// language=GraphQL
var FORCE_DELETE_PARTNER_TENANT_MUTATION = "\n  mutation Mutation($input: DeletePartnerTenantInput) {\n    forceDeletePartnerTenant(input: $input) {\n      success\n    }\n  }";
// language=GraphQL
var PARTNER_TENANTS_DEPENDENTS_QUERY = "query Query($id: ID!, $withTenants: Boolean = false) {\n  groupedDependents: partnerTenantDependents(id: $id) {\n    tenants @include(if: $withTenants) {\n      id\n      name\n      slug\n      domain\n      externalReference\n    }\n  }\n}";

// EXTERNAL MODULE: ./src/entities/tenant/entity.ts + 3 modules
var entity = __webpack_require__(57850);
;// CONCATENATED MODULE: ./src/entities/partnerTenant/model.ts


var partnerTenantModel = {
    name: "partnerTenant",
    namePlural: "partnerTenants",
    uniqueName: "partnerTenant",
    uniqueNamePlural: "partnerTenants",
    path: "config/tenant/partner_tenant",
    baseUrl: "/config/tenant/partner_tenants",
    translationPrefix: "entities:partnerTenant.",
    getDisplayName: function(values) {
        return "";
    },
    gql: {
        getAll: ALL_PARTNER_TENANTS_QUERY,
        getSingle: SINGLE_PARTNER_TENANT_QUERY,
        create: CREATE_PARTNER_TENANT_MUTATION,
        update: UPDATE_PARTNER_TENANT_MUTATION,
        delete: DELETE_PARTNER_TENANT_MUTATION,
        forceDelete: FORCE_DELETE_PARTNER_TENANT_MUTATION
    },
    attributes: {
        tenant: {
            name: "tenant",
            label: "entities:partnerTenant.attributes.tenant.label",
            type: "entityObject",
            dataType: "any",
            getEntity: function() {
                return entity/* default */.Z;
            },
            defaultInput: true,
            inputType: "select",
            validationType: "string",
            validations: [
                {
                    type: "required"
                }, 
            ]
        },
        filterCrossLinking: {
            name: "filterCrossLinking",
            label: "entities:partnerTenant.attributes.filterCrossLinking.label",
            type: "value",
            dataType: "boolean",
            defaultInput: true,
            inputType: "switch",
            validationType: "string",
            validations: []
        }
    }
};
/* harmony default export */ var model = (partnerTenantModel);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(20414);
// EXTERNAL MODULE: ./src/entities/lib.ts
var lib = __webpack_require__(23480);
// EXTERNAL MODULE: ./src/lib/api/graphQLClient.ts
var graphQLClient = __webpack_require__(40112);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/swr/dist/index.mjs
var dist = __webpack_require__(8100);
// EXTERNAL MODULE: ./src/lib/helpers/helpers.ts
var helpers = __webpack_require__(15778);
;// CONCATENATED MODULE: ./src/entities/partnerTenant/repository.ts










var hydrateObjects = function(objects) {
    return objects.map(function(object) {
        return (0,lib/* hydrateEntityObject */.b)(model, object);
    });
};
var hydrateObject = function(object) {
    return (0,lib/* hydrateEntityObject */.b)(model, object);
};
var partnerTenantRepository = {
    getObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    id: id
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(SINGLE_PARTNER_TENANT_QUERY, variables).then(function(data) {
                        return hydrateObject(data.partnerTenant);
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }(),
    getObjects: /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        var includes;
        var _arguments = arguments;
        return (0,tslib_es6.__generator)(this, function(_state) {
            includes = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : {};
            return [
                2,
                graphQLClient/* default.request */.Z.request(ALL_PARTNER_TENANTS_QUERY, includes).then(function(data) {
                    return hydrateObjects(data.partnerTenants);
                })
            ];
        });
    }),
    useObject: function(id) {
        var includes = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        // eslint-disable-next-line react-hooks/exhaustive-deps
        var variables = (0,react.useMemo)(function() {
            return (0,_object_spread/* default */.Z)({
                id: id
            }, includes);
        }, [
            id
        ]);
        var ref = (0,dist/* default */.ZP)([
            SINGLE_PARTNER_TENANT_QUERY,
            variables
        ], {
            revalidateOnFocus: false
        }), data = ref.data, error = ref.error, mutate = ref.mutate;
        return {
            object: !data ? data : hydrateObject(data.partnerTenant),
            isLoading: !error && !data,
            isError: error,
            mutate: mutate
        };
    },
    useObjects: function() {
        var includes = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        // eslint-disable-next-line react-hooks/exhaustive-deps
        var variables = (0,react.useMemo)(function() {
            return includes;
        }, []);
        var ref = (0,dist/* default */.ZP)([
            ALL_PARTNER_TENANTS_QUERY,
            variables
        ]), data = ref.data, error = ref.error, mutate = ref.mutate;
        return {
            objects: !data ? data : hydrateObjects(data.partnerTenants),
            isLoading: !error && !data,
            isError: error,
            mutate: mutate
        };
    },
    getDependents: function(id, includes) {
        var includeVars = {};
        includes.forEach(function(include) {
            includeVars["with".concat((0,helpers/* uppercaseFirst */.AB)(include))] = true;
        });
        var variables = (0,_object_spread/* default */.Z)({
            id: id
        }, includeVars);
        return graphQLClient/* default.request */.Z.request(PARTNER_TENANTS_DEPENDENTS_QUERY, variables).then(function(data) {
            return data.groupedDependents;
        });
    },
    useDependents: function(id, includes) {
        var includeVars = {};
        includes.forEach(function(include) {
            includeVars["with".concat((0,helpers/* uppercaseFirst */.AB)(include))] = true;
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
        var variables = (0,react.useMemo)(function() {
            return (0,_object_spread/* default */.Z)({
                id: id
            }, includeVars);
        }, [
            id
        ]);
        var ref = (0,dist/* default */.ZP)([
            PARTNER_TENANTS_DEPENDENTS_QUERY,
            variables
        ], {
            revalidateOnFocus: false
        }), data = ref.data, error = ref.error, mutate = ref.mutate;
        return {
            data: !data ? data : data.groupedDependents,
            isLoading: !error && !data,
            isError: error,
            mutate: mutate
        };
    },
    createObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(data) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    input: data
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(CREATE_PARTNER_TENANT_MUTATION, variables).then(function(data) {
                        return hydrateObject(data.partnerTenant);
                    })
                ];
            });
        });
        return function(data) {
            return _ref.apply(this, arguments);
        };
    }(),
    updateObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(data) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    input: data
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(UPDATE_PARTNER_TENANT_MUTATION, variables).then(function(data) {
                        return hydrateObject(data.partnerTenant);
                    })
                ];
            });
        });
        return function(data) {
            return _ref.apply(this, arguments);
        };
    }(),
    deleteObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(DELETE_PARTNER_TENANT_MUTATION, variables).then(function(data) {
                        return data.deletePartnerTenant;
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }(),
    forceDeleteObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(FORCE_DELETE_PARTNER_TENANT_MUTATION, variables).then(function(data) {
                        return data.forceDeletePartnerTenant;
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }()
};
/* harmony default export */ var repository = (partnerTenantRepository);

;// CONCATENATED MODULE: ./src/entities/partnerTenant/entity.ts


var partnerTenantEntity = {
    model: model,
    repository: repository
};
/* harmony default export */ var partnerTenant_entity = (partnerTenantEntity);


/***/ }),

/***/ 41953:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ entity; }
});

;// CONCATENATED MODULE: ./src/entities/passportData/graphql.ts
// language=GraphQL
var ALL_PASSPORTS_DATA_QUERY = "query Query {\n  passportsData: passportsData {\n    id\n    type\n    number\n    birthPlace\n    issuePlace\n    issueDate\n    validUntil\n  }\n}";
// language=GraphQL
var SINGLE_PASSPORT_DATA_QUERY = "query Query($id: ID!) {\n  passportData: passportData(id: $id) {\n    id\n    type\n    number\n    birthPlace\n    issuePlace\n    issueDate\n    validUntil\n  }\n}";
// language=GraphQL
var CREATE_PASSPORT_DATA_MUTATION = "\n  mutation Mutation($input: CreatePassportDataInput) {\n    passportData: createPassportData(input: $input) {\n      id\n      type\n      number\n      birthPlace\n      issuePlace\n      issueDate\n      validUntil\n    }\n  }";
// language=GraphQL
var UPDATE_PASSPORT_DATA_MUTATION = "\n  mutation Mutation($input: UpdatePassportDataInput) {\n    passportData: updatePassportData(input: $input) {\n      id\n      type\n      number\n      birthPlace\n      issuePlace\n      issueDate\n      validUntil\n    }\n  }";
// language=GraphQL
var DELETE_PASSPORT_DATA_MUTATION = "\n  mutation Mutation($input: DeletePassportDataInput) {\n    deletePassportData(input: $input) {\n      success\n    }\n  }";
// language=GraphQL
var FORCE_DELETE_PASSPORT_DATA_MUTATION = "\n  mutation Mutation($input: DeletePassportDataInput) {\n    forceDeletePassportData(input: $input) {\n      success\n    }\n  }";
// language=GraphQL
var PASSPORTS_DATA_DEPENDENTS_QUERY = "query Query($id: ID!, $withTravellers: Boolean = false) {\n  groupedDependents: passportDataDependents(id: $id) {\n    travellers @include(if: $withTravellers) {\n      id\n      salutation\n      firstName\n      lastName\n      birthday\n      nationality\n      email\n      phone\n      address\n      addressNumber\n      addressAddition\n      zip\n      city\n      country\n    }\n  }\n}";

;// CONCATENATED MODULE: ./src/entities/passportData/model.ts

var passportDataModel = {
    name: "passportData",
    namePlural: "passportsData",
    uniqueName: "passportData",
    uniqueNamePlural: "passportsData",
    path: "travel/booking/passport_data",
    baseUrl: "/travel/booking/passports_data",
    translationPrefix: "entities:passportData.",
    getDisplayName: function(values) {
        return values.number;
    },
    gql: {
        getAll: ALL_PASSPORTS_DATA_QUERY,
        getSingle: SINGLE_PASSPORT_DATA_QUERY,
        create: CREATE_PASSPORT_DATA_MUTATION,
        update: UPDATE_PASSPORT_DATA_MUTATION,
        delete: DELETE_PASSPORT_DATA_MUTATION,
        forceDelete: FORCE_DELETE_PASSPORT_DATA_MUTATION
    },
    attributes: {
        type: {
            name: "type",
            label: "entities:passportData.attributes.type.label",
            type: "value",
            dataType: "string",
            defaultInput: true,
            inputType: "select",
            selectOptions: [
                {
                    label: "entities:passportData.attributes.type.selectOptions.PASSPORT.label",
                    value: "PASSPORT"
                },
                {
                    label: "entities:passportData.attributes.type.selectOptions.IDCARD.label",
                    value: "IDCARD"
                }, 
            ],
            validationType: "string",
            validations: [
                {
                    type: "required"
                }, 
            ]
        },
        number: {
            name: "number",
            label: "entities:passportData.attributes.number.label",
            type: "value",
            dataType: "string",
            defaultInput: true,
            inputType: "text",
            validationType: "string",
            validations: [
                {
                    type: "required"
                }, 
            ]
        },
        birthPlace: {
            name: "birthPlace",
            label: "entities:passportData.attributes.birthPlace.label",
            type: "value",
            dataType: "string",
            defaultInput: true,
            inputType: "text",
            validationType: "string",
            validations: [
                {
                    type: "required"
                }, 
            ]
        },
        issuePlace: {
            name: "issuePlace",
            label: "entities:passportData.attributes.issuePlace.label",
            type: "value",
            dataType: "string",
            defaultInput: true,
            inputType: "text",
            validationType: "string",
            validations: [
                {
                    type: "required"
                }, 
            ]
        },
        issueDate: {
            name: "issueDate",
            label: "entities:passportData.attributes.issueDate.label",
            type: "value",
            dataType: "Date",
            defaultInput: true,
            inputType: "date",
            validationType: "string",
            validations: [
                {
                    type: "required"
                }, 
            ]
        },
        validUntil: {
            name: "validUntil",
            label: "entities:passportData.attributes.validUntil.label",
            type: "value",
            dataType: "Date",
            defaultInput: true,
            inputType: "date",
            validationType: "string",
            validations: [
                {
                    type: "required"
                }, 
            ]
        }
    }
};
/* harmony default export */ var model = (passportDataModel);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(20414);
// EXTERNAL MODULE: ./src/entities/lib.ts
var lib = __webpack_require__(23480);
// EXTERNAL MODULE: ./src/lib/api/graphQLClient.ts
var graphQLClient = __webpack_require__(40112);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/swr/dist/index.mjs
var dist = __webpack_require__(8100);
// EXTERNAL MODULE: ./src/lib/helpers/helpers.ts
var helpers = __webpack_require__(15778);
;// CONCATENATED MODULE: ./src/entities/passportData/repository.ts










var hydrateObjects = function(objects) {
    return objects.map(function(object) {
        return (0,lib/* hydrateEntityObject */.b)(model, object);
    });
};
var hydrateObject = function(object) {
    return (0,lib/* hydrateEntityObject */.b)(model, object);
};
var passportDataRepository = {
    getObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    id: id
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(SINGLE_PASSPORT_DATA_QUERY, variables).then(function(data) {
                        return hydrateObject(data.passportData);
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }(),
    getObjects: /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        var includes;
        var _arguments = arguments;
        return (0,tslib_es6.__generator)(this, function(_state) {
            includes = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : {};
            return [
                2,
                graphQLClient/* default.request */.Z.request(ALL_PASSPORTS_DATA_QUERY, includes).then(function(data) {
                    return hydrateObjects(data.passportsData);
                })
            ];
        });
    }),
    useObject: function(id) {
        var includes = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        // eslint-disable-next-line react-hooks/exhaustive-deps
        var variables = (0,react.useMemo)(function() {
            return (0,_object_spread/* default */.Z)({
                id: id
            }, includes);
        }, [
            id
        ]);
        var ref = (0,dist/* default */.ZP)([
            SINGLE_PASSPORT_DATA_QUERY,
            variables
        ], {
            revalidateOnFocus: false
        }), data = ref.data, error = ref.error, mutate = ref.mutate;
        return {
            object: !data ? data : hydrateObject(data.passportData),
            isLoading: !error && !data,
            isError: error,
            mutate: mutate
        };
    },
    useObjects: function() {
        var includes = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        // eslint-disable-next-line react-hooks/exhaustive-deps
        var variables = (0,react.useMemo)(function() {
            return includes;
        }, []);
        var ref = (0,dist/* default */.ZP)([
            ALL_PASSPORTS_DATA_QUERY,
            variables
        ]), data = ref.data, error = ref.error, mutate = ref.mutate;
        return {
            objects: !data ? data : hydrateObjects(data.passportsData),
            isLoading: !error && !data,
            isError: error,
            mutate: mutate
        };
    },
    getDependents: function(id, includes) {
        var includeVars = {};
        includes.forEach(function(include) {
            includeVars["with".concat((0,helpers/* uppercaseFirst */.AB)(include))] = true;
        });
        var variables = (0,_object_spread/* default */.Z)({
            id: id
        }, includeVars);
        return graphQLClient/* default.request */.Z.request(PASSPORTS_DATA_DEPENDENTS_QUERY, variables).then(function(data) {
            return data.groupedDependents;
        });
    },
    useDependents: function(id, includes) {
        var includeVars = {};
        includes.forEach(function(include) {
            includeVars["with".concat((0,helpers/* uppercaseFirst */.AB)(include))] = true;
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
        var variables = (0,react.useMemo)(function() {
            return (0,_object_spread/* default */.Z)({
                id: id
            }, includeVars);
        }, [
            id
        ]);
        var ref = (0,dist/* default */.ZP)([
            PASSPORTS_DATA_DEPENDENTS_QUERY,
            variables
        ], {
            revalidateOnFocus: false
        }), data = ref.data, error = ref.error, mutate = ref.mutate;
        return {
            data: !data ? data : data.groupedDependents,
            isLoading: !error && !data,
            isError: error,
            mutate: mutate
        };
    },
    createObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(data) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    input: data
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(CREATE_PASSPORT_DATA_MUTATION, variables).then(function(data) {
                        return hydrateObject(data.passportData);
                    })
                ];
            });
        });
        return function(data) {
            return _ref.apply(this, arguments);
        };
    }(),
    updateObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(data) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    input: data
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(UPDATE_PASSPORT_DATA_MUTATION, variables).then(function(data) {
                        return hydrateObject(data.passportData);
                    })
                ];
            });
        });
        return function(data) {
            return _ref.apply(this, arguments);
        };
    }(),
    deleteObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(DELETE_PASSPORT_DATA_MUTATION, variables).then(function(data) {
                        return data.deletePassportData;
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }(),
    forceDeleteObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(FORCE_DELETE_PASSPORT_DATA_MUTATION, variables).then(function(data) {
                        return data.forceDeletePassportData;
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }()
};
/* harmony default export */ var repository = (passportDataRepository);

;// CONCATENATED MODULE: ./src/entities/passportData/entity.ts


var passportDataEntity = {
    model: model,
    repository: repository
};
/* harmony default export */ var entity = (passportDataEntity);


/***/ }),

/***/ 53656:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ ratioAccommodation_entity; }
});

;// CONCATENATED MODULE: ./src/entities/ratioAccommodation/graphql.ts
// language=GraphQL
var ALL_ACCOMMODATIONS_QUERY = "query Query($withCapacitySettings: Boolean = false, $withCapacitySettingsAgeGroupCapacities: Boolean = false, $withCapacitySettingsAgeGroupCapacitiesAgeGroup: Boolean = false, $withCapacitySettingsAgeGroupedTotalCapacities: Boolean = false, $withCapacitySettingsAgeGroupedTotalCapacitiesAgeGroups: Boolean = false, $withCapacitySettingsPartialOccupancyAllowedAgeGroups: Boolean = false, $withAddons: Boolean = false, $withAddonsCalculationSettings: Boolean = false, $withAddonsMandatorySettings: Boolean = false, $withAddonsMandatorySettingsRules: Boolean = false) {\n  accommodations: ratioAccommodations {\n    id\n    ratioPackageNo\n    name\n    label\n    info\n    isFamilyPackageAccommodation\n    isBabyPackage\n    capacitySettings @include(if: $withCapacitySettings) {\n      id\n      totalCapacity\n      rangesAllowed\n      ageGroupCapacities @include(if: $withCapacitySettingsAgeGroupCapacities) {\n        id\n        ageGroup @include(if: $withCapacitySettingsAgeGroupCapacitiesAgeGroup) {\n          id\n          name\n          type\n          icon\n          minAge\n          maxAge\n        }\n        minCapacity\n        maxCapacity\n      }\n      ageGroupedTotalCapacities @include(if: $withCapacitySettingsAgeGroupedTotalCapacities) {\n        id\n        ageGroups @include(if: $withCapacitySettingsAgeGroupedTotalCapacitiesAgeGroups) {\n          id\n          name\n          type\n          icon\n          minAge\n          maxAge\n        }\n        capacity\n      }\n      partialOccupancyAllowed\n      partialOccupancyAllowedAgeGroups @include(if: $withCapacitySettingsPartialOccupancyAllowedAgeGroups) {\n        id\n        name\n        type\n        icon\n        minAge\n        maxAge\n      }\n    }\n    addons @include(if: $withAddons) {\n      id\n      ratioServiceNo\n      name\n      label\n      info\n      calculationSettings @include(if: $withAddonsCalculationSettings) {\n        id\n        type\n        considerHotelNights\n      }\n      mandatorySettings @include(if: $withAddonsMandatorySettings) {\n        id\n        isMandatory\n        useRules\n        rules @include(if: $withAddonsMandatorySettingsRules) {\n          id\n          checkAccommodationTypes\n          checkAccommodationAddons\n          checkAgeGroups\n          useAgeFilter\n          checkDateRange\n          startDate\n          endDate\n          checkTravelDate\n        }\n      }\n    }\n  }\n}";
// language=GraphQL
var SINGLE_ACCOMMODATION_QUERY = "query Query($id: ID!, $withCapacitySettings: Boolean = false, $withCapacitySettingsAgeGroupCapacities: Boolean = false, $withCapacitySettingsAgeGroupCapacitiesAgeGroup: Boolean = false, $withCapacitySettingsAgeGroupedTotalCapacities: Boolean = false, $withCapacitySettingsAgeGroupedTotalCapacitiesAgeGroups: Boolean = false, $withCapacitySettingsPartialOccupancyAllowedAgeGroups: Boolean = false, $withAddons: Boolean = false, $withAddonsCalculationSettings: Boolean = false, $withAddonsMandatorySettings: Boolean = false, $withAddonsMandatorySettingsRules: Boolean = false) {\n  accommodation: ratioAccommodation(id: $id) {\n    id\n    ratioPackageNo\n    name\n    label\n    info\n    isFamilyPackageAccommodation\n    isBabyPackage\n    capacitySettings @include(if: $withCapacitySettings) {\n      id\n      totalCapacity\n      rangesAllowed\n      ageGroupCapacities @include(if: $withCapacitySettingsAgeGroupCapacities) {\n        id\n        ageGroup @include(if: $withCapacitySettingsAgeGroupCapacitiesAgeGroup) {\n          id\n          name\n          type\n          icon\n          minAge\n          maxAge\n        }\n        minCapacity\n        maxCapacity\n      }\n      ageGroupedTotalCapacities @include(if: $withCapacitySettingsAgeGroupedTotalCapacities) {\n        id\n        ageGroups @include(if: $withCapacitySettingsAgeGroupedTotalCapacitiesAgeGroups) {\n          id\n          name\n          type\n          icon\n          minAge\n          maxAge\n        }\n        capacity\n      }\n      partialOccupancyAllowed\n      partialOccupancyAllowedAgeGroups @include(if: $withCapacitySettingsPartialOccupancyAllowedAgeGroups) {\n        id\n        name\n        type\n        icon\n        minAge\n        maxAge\n      }\n    }\n    addons @include(if: $withAddons) {\n      id\n      ratioServiceNo\n      name\n      label\n      info\n      calculationSettings @include(if: $withAddonsCalculationSettings) {\n        id\n        type\n        considerHotelNights\n      }\n      mandatorySettings @include(if: $withAddonsMandatorySettings) {\n        id\n        isMandatory\n        useRules\n        rules @include(if: $withAddonsMandatorySettingsRules) {\n          id\n          checkAccommodationTypes\n          checkAccommodationAddons\n          checkAgeGroups\n          useAgeFilter\n          checkDateRange\n          startDate\n          endDate\n          checkTravelDate\n        }\n      }\n    }\n  }\n}";
// language=GraphQL
var CREATE_ACCOMMODATION_MUTATION = "\n  mutation Mutation($input: CreateRatioAccommodationInput, $withCapacitySettings: Boolean = false, $withCapacitySettingsAgeGroupCapacities: Boolean = false, $withCapacitySettingsAgeGroupCapacitiesAgeGroup: Boolean = false, $withCapacitySettingsAgeGroupedTotalCapacities: Boolean = false, $withCapacitySettingsAgeGroupedTotalCapacitiesAgeGroups: Boolean = false, $withCapacitySettingsPartialOccupancyAllowedAgeGroups: Boolean = false, $withAddons: Boolean = false, $withAddonsCalculationSettings: Boolean = false, $withAddonsMandatorySettings: Boolean = false, $withAddonsMandatorySettingsRules: Boolean = false) {\n    accommodation: createRatioAccommodation(input: $input) {\n      id\n      ratioPackageNo\n      name\n      label\n      info\n      isFamilyPackageAccommodation\n      isBabyPackage\n      capacitySettings @include(if: $withCapacitySettings) {\n        id\n        totalCapacity\n        rangesAllowed\n        ageGroupCapacities @include(if: $withCapacitySettingsAgeGroupCapacities) {\n          id\n          ageGroup @include(if: $withCapacitySettingsAgeGroupCapacitiesAgeGroup) {\n            id\n            name\n            type\n            icon\n            minAge\n            maxAge\n          }\n          minCapacity\n          maxCapacity\n        }\n        ageGroupedTotalCapacities @include(if: $withCapacitySettingsAgeGroupedTotalCapacities) {\n          id\n          ageGroups @include(if: $withCapacitySettingsAgeGroupedTotalCapacitiesAgeGroups) {\n            id\n            name\n            type\n            icon\n            minAge\n            maxAge\n          }\n          capacity\n        }\n        partialOccupancyAllowed\n        partialOccupancyAllowedAgeGroups @include(if: $withCapacitySettingsPartialOccupancyAllowedAgeGroups) {\n          id\n          name\n          type\n          icon\n          minAge\n          maxAge\n        }\n      }\n      addons @include(if: $withAddons) {\n        id\n        ratioServiceNo\n        name\n        label\n        info\n        calculationSettings @include(if: $withAddonsCalculationSettings) {\n          id\n          type\n          considerHotelNights\n        }\n        mandatorySettings @include(if: $withAddonsMandatorySettings) {\n          id\n          isMandatory\n          useRules\n          rules @include(if: $withAddonsMandatorySettingsRules) {\n            id\n            checkAccommodationTypes\n            checkAccommodationAddons\n            checkAgeGroups\n            useAgeFilter\n            checkDateRange\n            startDate\n            endDate\n            checkTravelDate\n          }\n        }\n      }\n    }\n  }";
// language=GraphQL
var UPDATE_ACCOMMODATION_MUTATION = "\n  mutation Mutation($input: UpdateRatioAccommodationInput, $withCapacitySettings: Boolean = false, $withCapacitySettingsAgeGroupCapacities: Boolean = false, $withCapacitySettingsAgeGroupCapacitiesAgeGroup: Boolean = false, $withCapacitySettingsAgeGroupedTotalCapacities: Boolean = false, $withCapacitySettingsAgeGroupedTotalCapacitiesAgeGroups: Boolean = false, $withCapacitySettingsPartialOccupancyAllowedAgeGroups: Boolean = false, $withAddons: Boolean = false, $withAddonsCalculationSettings: Boolean = false, $withAddonsMandatorySettings: Boolean = false, $withAddonsMandatorySettingsRules: Boolean = false) {\n    accommodation: updateRatioAccommodation(input: $input) {\n      id\n      ratioPackageNo\n      name\n      label\n      info\n      isFamilyPackageAccommodation\n      isBabyPackage\n      capacitySettings @include(if: $withCapacitySettings) {\n        id\n        totalCapacity\n        rangesAllowed\n        ageGroupCapacities @include(if: $withCapacitySettingsAgeGroupCapacities) {\n          id\n          ageGroup @include(if: $withCapacitySettingsAgeGroupCapacitiesAgeGroup) {\n            id\n            name\n            type\n            icon\n            minAge\n            maxAge\n          }\n          minCapacity\n          maxCapacity\n        }\n        ageGroupedTotalCapacities @include(if: $withCapacitySettingsAgeGroupedTotalCapacities) {\n          id\n          ageGroups @include(if: $withCapacitySettingsAgeGroupedTotalCapacitiesAgeGroups) {\n            id\n            name\n            type\n            icon\n            minAge\n            maxAge\n          }\n          capacity\n        }\n        partialOccupancyAllowed\n        partialOccupancyAllowedAgeGroups @include(if: $withCapacitySettingsPartialOccupancyAllowedAgeGroups) {\n          id\n          name\n          type\n          icon\n          minAge\n          maxAge\n        }\n      }\n      addons @include(if: $withAddons) {\n        id\n        ratioServiceNo\n        name\n        label\n        info\n        calculationSettings @include(if: $withAddonsCalculationSettings) {\n          id\n          type\n          considerHotelNights\n        }\n        mandatorySettings @include(if: $withAddonsMandatorySettings) {\n          id\n          isMandatory\n          useRules\n          rules @include(if: $withAddonsMandatorySettingsRules) {\n            id\n            checkAccommodationTypes\n            checkAccommodationAddons\n            checkAgeGroups\n            useAgeFilter\n            checkDateRange\n            startDate\n            endDate\n            checkTravelDate\n          }\n        }\n      }\n    }\n  }";
// language=GraphQL
var DELETE_ACCOMMODATION_MUTATION = "\n  mutation Mutation($input: DeleteRatioAccommodationInput) {\n    deleteRatioAccommodation(input: $input) {\n      success\n    }\n  }";
// language=GraphQL
var FORCE_DELETE_ACCOMMODATION_MUTATION = "\n  mutation Mutation($input: DeleteRatioAccommodationInput) {\n    forceDeleteRatioAccommodation(input: $input) {\n      success\n    }\n  }";
// language=GraphQL
var ADD_ACCOMMODATION_ADDONS_MUTATION = "\n  mutation Mutation($input: addRatioAccommodationAddonsInput) {\n    addRatioAccommodationAddons(input: $input) {\n      id\n      addonIds\n    }\n  }";
// language=GraphQL
var REMOVE_ACCOMMODATION_ADDONS_MUTATION = "\n  mutation Mutation($input: removeRatioAccommodationAddonsInput) {\n    removeRatioAccommodationAddons(input: $input) {\n      id\n      addonIds\n    }\n  }";
// language=GraphQL
var CREATE_ACCOMMODATION_ADDONS_MUTATION = "\n  mutation Mutation($input: createRatioAccommodationAddonsInput) {\n    createRatioAccommodationAddons(input: $input) {\n      id\n      addonIds\n    }\n  }";
// language=GraphQL
var DELETE_ACCOMMODATION_ADDONS_MUTATION = "\n  mutation Mutation($input: deleteRatioAccommodationAddonsInput) {\n    deleteRatioAccommodationAddons(input: $input) {\n      id\n      addonIds\n    }\n  }";
// language=GraphQL
var UPDATE_ACCOMMODATION_ADDONS_ORDER_MUTATION = "\n  mutation Mutation($input: updateRatioAccommodationAddonsOrderInput) {\n    updateRatioAccommodationAddonsOrder(input: $input) {\n      id\n      addonIds\n    }\n  }";
// language=GraphQL
var ACCOMMODATIONS_DEPENDENTS_QUERY = "query Query($id: ID!, $withRatioAccommodationServices: Boolean = false, $withTravellers: Boolean = false, $withRatioFamilyPackages: Boolean = false, $withRatioAccommodationExtensionMapItems: Boolean = false, $withRatioTravels: Boolean = false, $withTravelPricingRules: Boolean = false) {\n  groupedDependents: ratioAccommodationDependents(id: $id) {\n    ratioAccommodationServices @include(if: $withRatioAccommodationServices) {\n      id\n      ratioServiceNo\n    }\n    travellers @include(if: $withTravellers) {\n      id\n      salutation\n      firstName\n      lastName\n      birthday\n      nationality\n      email\n      phone\n      address\n      addressNumber\n      addressAddition\n      zip\n      city\n      country\n    }\n    ratioFamilyPackages @include(if: $withRatioFamilyPackages) {\n      id\n      ratioServiceNo\n      name\n      label\n      info\n    }\n    ratioAccommodationExtensionMapItems @include(if: $withRatioAccommodationExtensionMapItems) {\n      id\n    }\n    ratioTravels @include(if: $withRatioTravels) {\n      id\n      catalogCode\n      travelCode\n      destination\n      name\n      transportType\n      transportTypeLabel\n      importDateTime\n      importStatus    }\n    travelPricingRules @include(if: $withTravelPricingRules) {\n      id\n      checkAccommodationTypes\n      checkAccommodationAddons\n      checkAgeGroups\n      useAgeFilter\n      checkDateRange\n      startDate\n      endDate\n      checkTravelDate\n    }\n  }\n}";

// EXTERNAL MODULE: ./src/entities/accommodationCapacitySettings/entity.ts + 3 modules
var entity = __webpack_require__(11844);
// EXTERNAL MODULE: ./src/entities/ratioAccommodationAddon/entity.ts + 3 modules
var ratioAccommodationAddon_entity = __webpack_require__(88646);
;// CONCATENATED MODULE: ./src/entities/ratioAccommodation/model.ts



var ratioAccommodationModel = {
    name: "accommodation",
    namePlural: "accommodations",
    uniqueName: "ratioAccommodation",
    uniqueNamePlural: "ratioAccommodations",
    path: "travel/pricing/adaptors/ratio/accommodation",
    baseUrl: "/travel/pricing/adaptors/ratio/accommodations",
    translationPrefix: "entities:ratioAccommodation.",
    getDisplayName: function(values) {
        return values.label;
    },
    gql: {
        getAll: ALL_ACCOMMODATIONS_QUERY,
        getSingle: SINGLE_ACCOMMODATION_QUERY,
        create: CREATE_ACCOMMODATION_MUTATION,
        update: UPDATE_ACCOMMODATION_MUTATION,
        delete: DELETE_ACCOMMODATION_MUTATION,
        forceDelete: FORCE_DELETE_ACCOMMODATION_MUTATION
    },
    attributes: {
        ratioPackageNo: {
            name: "ratioPackageNo",
            label: "entities:ratioAccommodation.attributes.ratioPackageNo.label",
            type: "value",
            dataType: "string",
            defaultInput: true,
            inputType: "hidden",
            validationType: "string",
            validations: [
                {
                    type: "required"
                }, 
            ]
        },
        name: {
            name: "name",
            label: "entities:ratioAccommodation.attributes.name.label",
            type: "value",
            dataType: "string",
            defaultInput: true,
            inputType: "hidden",
            validationType: "string",
            validations: [
                {
                    type: "required"
                }, 
            ]
        },
        label: {
            name: "label",
            label: "entities:ratioAccommodation.attributes.label.label",
            type: "value",
            dataType: "string",
            defaultInput: true,
            inputType: "text",
            validationType: "string",
            validations: [
                {
                    type: "required"
                }, 
            ]
        },
        info: {
            name: "info",
            label: "entities:ratioAccommodation.attributes.info.label",
            type: "value",
            dataType: "string",
            defaultInput: true,
            inputType: "textarea",
            maxLength: 255,
            validationType: "string",
            validations: []
        },
        isFamilyPackageAccommodation: {
            name: "isFamilyPackageAccommodation",
            label: "entities:ratioAccommodation.attributes.isFamilyPackageAccommodation.label",
            type: "value",
            dataType: "boolean",
            defaultInput: true,
            inputType: "switch",
            validationType: "string",
            validations: []
        },
        isBabyPackage: {
            name: "isBabyPackage",
            label: "entities:ratioAccommodation.attributes.isBabyPackage.label",
            type: "value",
            dataType: "boolean",
            defaultInput: true,
            inputType: "switch",
            validationType: "string",
            validations: []
        },
        capacitySettings: {
            name: "capacitySettings",
            label: "entities:ratioAccommodation.attributes.capacitySettings.label",
            type: "entityObject",
            dataType: "any",
            getEntity: function() {
                return entity/* default */.Z;
            },
            defaultInput: false,
            inputType: "select",
            validationType: "string",
            validations: []
        },
        addons: {
            name: "addons",
            label: "entities:ratioAccommodation.attributes.addons.label",
            type: "entityCollection",
            dataType: "[any]",
            getEntity: function() {
                return ratioAccommodationAddon_entity/* default */.Z;
            },
            defaultInput: false,
            inputType: "text",
            validationType: "string",
            validations: []
        }
    }
};
/* harmony default export */ var model = (ratioAccommodationModel);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(20414);
// EXTERNAL MODULE: ./src/entities/lib.ts
var lib = __webpack_require__(23480);
// EXTERNAL MODULE: ./src/lib/api/graphQLClient.ts
var graphQLClient = __webpack_require__(40112);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/swr/dist/index.mjs
var dist = __webpack_require__(8100);
// EXTERNAL MODULE: ./src/lib/helpers/helpers.ts
var helpers = __webpack_require__(15778);
;// CONCATENATED MODULE: ./src/entities/ratioAccommodation/repository.ts










var hydrateObjects = function(objects) {
    return objects.map(function(object) {
        return (0,lib/* hydrateEntityObject */.b)(model, object);
    });
};
var hydrateObject = function(object) {
    return (0,lib/* hydrateEntityObject */.b)(model, object);
};
var ratioAccommodationRepository = {
    getObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    id: id
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(SINGLE_ACCOMMODATION_QUERY, variables).then(function(data) {
                        return hydrateObject(data.accommodation);
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }(),
    getObjects: /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        var includes;
        var _arguments = arguments;
        return (0,tslib_es6.__generator)(this, function(_state) {
            includes = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : {};
            return [
                2,
                graphQLClient/* default.request */.Z.request(ALL_ACCOMMODATIONS_QUERY, includes).then(function(data) {
                    return hydrateObjects(data.accommodations);
                })
            ];
        });
    }),
    useObject: function(id) {
        var includes = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        // eslint-disable-next-line react-hooks/exhaustive-deps
        var variables = (0,react.useMemo)(function() {
            return (0,_object_spread/* default */.Z)({
                id: id
            }, includes);
        }, [
            id
        ]);
        var ref = (0,dist/* default */.ZP)([
            SINGLE_ACCOMMODATION_QUERY,
            variables
        ], {
            revalidateOnFocus: false
        }), data = ref.data, error = ref.error, mutate = ref.mutate;
        return {
            object: !data ? data : hydrateObject(data.accommodation),
            isLoading: !error && !data,
            isError: error,
            mutate: mutate
        };
    },
    useObjects: function() {
        var includes = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        // eslint-disable-next-line react-hooks/exhaustive-deps
        var variables = (0,react.useMemo)(function() {
            return includes;
        }, []);
        var ref = (0,dist/* default */.ZP)([
            ALL_ACCOMMODATIONS_QUERY,
            variables
        ]), data = ref.data, error = ref.error, mutate = ref.mutate;
        return {
            objects: !data ? data : hydrateObjects(data.accommodations),
            isLoading: !error && !data,
            isError: error,
            mutate: mutate
        };
    },
    getDependents: function(id, includes) {
        var includeVars = {};
        includes.forEach(function(include) {
            includeVars["with".concat((0,helpers/* uppercaseFirst */.AB)(include))] = true;
        });
        var variables = (0,_object_spread/* default */.Z)({
            id: id
        }, includeVars);
        return graphQLClient/* default.request */.Z.request(ACCOMMODATIONS_DEPENDENTS_QUERY, variables).then(function(data) {
            return data.groupedDependents;
        });
    },
    useDependents: function(id, includes) {
        var includeVars = {};
        includes.forEach(function(include) {
            includeVars["with".concat((0,helpers/* uppercaseFirst */.AB)(include))] = true;
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
        var variables = (0,react.useMemo)(function() {
            return (0,_object_spread/* default */.Z)({
                id: id
            }, includeVars);
        }, [
            id
        ]);
        var ref = (0,dist/* default */.ZP)([
            ACCOMMODATIONS_DEPENDENTS_QUERY,
            variables
        ], {
            revalidateOnFocus: false
        }), data = ref.data, error = ref.error, mutate = ref.mutate;
        return {
            data: !data ? data : data.groupedDependents,
            isLoading: !error && !data,
            isError: error,
            mutate: mutate
        };
    },
    createObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(data) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    input: data
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(CREATE_ACCOMMODATION_MUTATION, variables).then(function(data) {
                        return hydrateObject(data.accommodation);
                    })
                ];
            });
        });
        return function(data) {
            return _ref.apply(this, arguments);
        };
    }(),
    updateObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(data) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    input: data
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(UPDATE_ACCOMMODATION_MUTATION, variables).then(function(data) {
                        return hydrateObject(data.accommodation);
                    })
                ];
            });
        });
        return function(data) {
            return _ref.apply(this, arguments);
        };
    }(),
    deleteObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(DELETE_ACCOMMODATION_MUTATION, variables).then(function(data) {
                        return data.deleteRatioAccommodation;
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }(),
    forceDeleteObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(FORCE_DELETE_ACCOMMODATION_MUTATION, variables).then(function(data) {
                        return data.forceDeleteRatioAccommodation;
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }(),
    assignAddons: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, itemIds) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        addonIds: itemIds
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(ADD_ACCOMMODATION_ADDONS_MUTATION, variables)
                ];
            });
        });
        return function(id, itemIds) {
            return _ref.apply(this, arguments);
        };
    }(),
    unassignAddons: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, itemIds) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        addonIds: itemIds
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(REMOVE_ACCOMMODATION_ADDONS_MUTATION, variables)
                ];
            });
        });
        return function(id, itemIds) {
            return _ref.apply(this, arguments);
        };
    }(),
    createAddons: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, items) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        addons: items
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(CREATE_ACCOMMODATION_ADDONS_MUTATION, variables)
                ];
            });
        });
        return function(id, items) {
            return _ref.apply(this, arguments);
        };
    }(),
    deleteAddons: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, itemIds) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        addonIds: itemIds
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(DELETE_ACCOMMODATION_ADDONS_MUTATION, variables)
                ];
            });
        });
        return function(id, itemIds) {
            return _ref.apply(this, arguments);
        };
    }(),
    updateAddonsOrder: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, itemIds) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        addonIds: itemIds
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(UPDATE_ACCOMMODATION_ADDONS_ORDER_MUTATION, variables)
                ];
            });
        });
        return function(id, itemIds) {
            return _ref.apply(this, arguments);
        };
    }()
};
/* harmony default export */ var repository = (ratioAccommodationRepository);

;// CONCATENATED MODULE: ./src/entities/ratioAccommodation/entity.ts


var ratioAccommodationEntity = {
    model: model,
    repository: repository
};
/* harmony default export */ var ratioAccommodation_entity = (ratioAccommodationEntity);


/***/ }),

/***/ 88646:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ ratioAccommodationAddon_entity; }
});

;// CONCATENATED MODULE: ./src/entities/ratioAccommodationAddon/graphql.ts
// language=GraphQL
var ALL_ACCOMMODATION_ADDONS_QUERY = "query Query($withCalculationSettings: Boolean = false, $withMandatorySettings: Boolean = false, $withMandatorySettingsRules: Boolean = false, $withMandatorySettingsRulesAccommodations: Boolean = false, $withMandatorySettingsRulesFamilyPackages: Boolean = false, $withMandatorySettingsRulesAccommodationAddons: Boolean = false, $withMandatorySettingsRulesAgeGroups: Boolean = false, $withMandatorySettingsRulesAgeFilter: Boolean = false, $withMandatorySettingsRulesTravelDates: Boolean = false) {\n  accommodationAddons: ratioAccommodationAddons {\n    id\n    ratioServiceNo\n    name\n    label\n    info\n    calculationSettings @include(if: $withCalculationSettings) {\n      id\n      type\n      considerHotelNights\n    }\n    mandatorySettings @include(if: $withMandatorySettings) {\n      id\n      isMandatory\n      useRules\n      rules @include(if: $withMandatorySettingsRules) {\n        id\n        checkAccommodationTypes\n        accommodations @include(if: $withMandatorySettingsRulesAccommodations) {\n          id\n          ratioPackageNo\n          name\n          label\n          info\n          isFamilyPackageAccommodation\n          isBabyPackage\n        }\n        familyPackages @include(if: $withMandatorySettingsRulesFamilyPackages) {\n          id\n          ratioServiceNo\n          name\n          label\n          info\n        }\n        checkAccommodationAddons\n        accommodationAddons @include(if: $withMandatorySettingsRulesAccommodationAddons) {\n          id\n          ratioServiceNo\n          name\n          label\n          info\n        }\n        checkAgeGroups\n        ageGroups @include(if: $withMandatorySettingsRulesAgeGroups) {\n          id\n          name\n          type\n          icon\n          minAge\n          maxAge\n        }\n        useAgeFilter\n        ageFilter @include(if: $withMandatorySettingsRulesAgeFilter) {\n          id\n          minAge\n          maxAge\n        }\n        checkDateRange\n        startDate\n        endDate\n        checkTravelDate\n        travelDates @include(if: $withMandatorySettingsRulesTravelDates) {\n          id\n          dateNo\n          startDate\n          endDate\n          includesExtension\n          json\n        }\n      }\n    }\n  }\n}";
// language=GraphQL
var SINGLE_ACCOMMODATION_ADDON_QUERY = "query Query($id: ID!, $withCalculationSettings: Boolean = false, $withMandatorySettings: Boolean = false, $withMandatorySettingsRules: Boolean = false, $withMandatorySettingsRulesAccommodations: Boolean = false, $withMandatorySettingsRulesFamilyPackages: Boolean = false, $withMandatorySettingsRulesAccommodationAddons: Boolean = false, $withMandatorySettingsRulesAgeGroups: Boolean = false, $withMandatorySettingsRulesAgeFilter: Boolean = false, $withMandatorySettingsRulesTravelDates: Boolean = false) {\n  accommodationAddon: ratioAccommodationAddon(id: $id) {\n    id\n    ratioServiceNo\n    name\n    label\n    info\n    calculationSettings @include(if: $withCalculationSettings) {\n      id\n      type\n      considerHotelNights\n    }\n    mandatorySettings @include(if: $withMandatorySettings) {\n      id\n      isMandatory\n      useRules\n      rules @include(if: $withMandatorySettingsRules) {\n        id\n        checkAccommodationTypes\n        accommodations @include(if: $withMandatorySettingsRulesAccommodations) {\n          id\n          ratioPackageNo\n          name\n          label\n          info\n          isFamilyPackageAccommodation\n          isBabyPackage\n        }\n        familyPackages @include(if: $withMandatorySettingsRulesFamilyPackages) {\n          id\n          ratioServiceNo\n          name\n          label\n          info\n        }\n        checkAccommodationAddons\n        accommodationAddons @include(if: $withMandatorySettingsRulesAccommodationAddons) {\n          id\n          ratioServiceNo\n          name\n          label\n          info\n        }\n        checkAgeGroups\n        ageGroups @include(if: $withMandatorySettingsRulesAgeGroups) {\n          id\n          name\n          type\n          icon\n          minAge\n          maxAge\n        }\n        useAgeFilter\n        ageFilter @include(if: $withMandatorySettingsRulesAgeFilter) {\n          id\n          minAge\n          maxAge\n        }\n        checkDateRange\n        startDate\n        endDate\n        checkTravelDate\n        travelDates @include(if: $withMandatorySettingsRulesTravelDates) {\n          id\n          dateNo\n          startDate\n          endDate\n          includesExtension\n          json\n        }\n      }\n    }\n  }\n}";
// language=GraphQL
var CREATE_ACCOMMODATION_ADDON_MUTATION = "\n  mutation Mutation($input: CreateRatioAccommodationAddonInput, $withCalculationSettings: Boolean = false, $withMandatorySettings: Boolean = false, $withMandatorySettingsRules: Boolean = false, $withMandatorySettingsRulesAccommodations: Boolean = false, $withMandatorySettingsRulesFamilyPackages: Boolean = false, $withMandatorySettingsRulesAccommodationAddons: Boolean = false, $withMandatorySettingsRulesAgeGroups: Boolean = false, $withMandatorySettingsRulesAgeFilter: Boolean = false, $withMandatorySettingsRulesTravelDates: Boolean = false) {\n    accommodationAddon: createRatioAccommodationAddon(input: $input) {\n      id\n      ratioServiceNo\n      name\n      label\n      info\n      calculationSettings @include(if: $withCalculationSettings) {\n        id\n        type\n        considerHotelNights\n      }\n      mandatorySettings @include(if: $withMandatorySettings) {\n        id\n        isMandatory\n        useRules\n        rules @include(if: $withMandatorySettingsRules) {\n          id\n          checkAccommodationTypes\n          accommodations @include(if: $withMandatorySettingsRulesAccommodations) {\n            id\n            ratioPackageNo\n            name\n            label\n            info\n            isFamilyPackageAccommodation\n            isBabyPackage\n          }\n          familyPackages @include(if: $withMandatorySettingsRulesFamilyPackages) {\n            id\n            ratioServiceNo\n            name\n            label\n            info\n          }\n          checkAccommodationAddons\n          accommodationAddons @include(if: $withMandatorySettingsRulesAccommodationAddons) {\n            id\n            ratioServiceNo\n            name\n            label\n            info\n          }\n          checkAgeGroups\n          ageGroups @include(if: $withMandatorySettingsRulesAgeGroups) {\n            id\n            name\n            type\n            icon\n            minAge\n            maxAge\n          }\n          useAgeFilter\n          ageFilter @include(if: $withMandatorySettingsRulesAgeFilter) {\n            id\n            minAge\n            maxAge\n          }\n          checkDateRange\n          startDate\n          endDate\n          checkTravelDate\n          travelDates @include(if: $withMandatorySettingsRulesTravelDates) {\n            id\n            dateNo\n            startDate\n            endDate\n            includesExtension\n            json\n          }\n        }\n      }\n    }\n  }";
// language=GraphQL
var UPDATE_ACCOMMODATION_ADDON_MUTATION = "\n  mutation Mutation($input: UpdateRatioAccommodationAddonInput, $withCalculationSettings: Boolean = false, $withMandatorySettings: Boolean = false, $withMandatorySettingsRules: Boolean = false, $withMandatorySettingsRulesAccommodations: Boolean = false, $withMandatorySettingsRulesFamilyPackages: Boolean = false, $withMandatorySettingsRulesAccommodationAddons: Boolean = false, $withMandatorySettingsRulesAgeGroups: Boolean = false, $withMandatorySettingsRulesAgeFilter: Boolean = false, $withMandatorySettingsRulesTravelDates: Boolean = false) {\n    accommodationAddon: updateRatioAccommodationAddon(input: $input) {\n      id\n      ratioServiceNo\n      name\n      label\n      info\n      calculationSettings @include(if: $withCalculationSettings) {\n        id\n        type\n        considerHotelNights\n      }\n      mandatorySettings @include(if: $withMandatorySettings) {\n        id\n        isMandatory\n        useRules\n        rules @include(if: $withMandatorySettingsRules) {\n          id\n          checkAccommodationTypes\n          accommodations @include(if: $withMandatorySettingsRulesAccommodations) {\n            id\n            ratioPackageNo\n            name\n            label\n            info\n            isFamilyPackageAccommodation\n            isBabyPackage\n          }\n          familyPackages @include(if: $withMandatorySettingsRulesFamilyPackages) {\n            id\n            ratioServiceNo\n            name\n            label\n            info\n          }\n          checkAccommodationAddons\n          accommodationAddons @include(if: $withMandatorySettingsRulesAccommodationAddons) {\n            id\n            ratioServiceNo\n            name\n            label\n            info\n          }\n          checkAgeGroups\n          ageGroups @include(if: $withMandatorySettingsRulesAgeGroups) {\n            id\n            name\n            type\n            icon\n            minAge\n            maxAge\n          }\n          useAgeFilter\n          ageFilter @include(if: $withMandatorySettingsRulesAgeFilter) {\n            id\n            minAge\n            maxAge\n          }\n          checkDateRange\n          startDate\n          endDate\n          checkTravelDate\n          travelDates @include(if: $withMandatorySettingsRulesTravelDates) {\n            id\n            dateNo\n            startDate\n            endDate\n            includesExtension\n            json\n          }\n        }\n      }\n    }\n  }";
// language=GraphQL
var DELETE_ACCOMMODATION_ADDON_MUTATION = "\n  mutation Mutation($input: DeleteRatioAccommodationAddonInput) {\n    deleteRatioAccommodationAddon(input: $input) {\n      success\n    }\n  }";
// language=GraphQL
var FORCE_DELETE_ACCOMMODATION_ADDON_MUTATION = "\n  mutation Mutation($input: DeleteRatioAccommodationAddonInput) {\n    forceDeleteRatioAccommodationAddon(input: $input) {\n      success\n    }\n  }";
// language=GraphQL
var ACCOMMODATION_ADDONS_DEPENDENTS_QUERY = "query Query($id: ID!, $withTravelPricingRules: Boolean = false, $withRatioTravels: Boolean = false, $withRatioAccommodations: Boolean = false, $withRatioFamilyPackages: Boolean = false, $withTravellers: Boolean = false) {\n  groupedDependents: ratioAccommodationAddonDependents(id: $id) {\n    travelPricingRules @include(if: $withTravelPricingRules) {\n      id\n      checkAccommodationTypes\n      checkAccommodationAddons\n      checkAgeGroups\n      useAgeFilter\n      checkDateRange\n      startDate\n      endDate\n      checkTravelDate\n    }\n    ratioTravels @include(if: $withRatioTravels) {\n      id\n      catalogCode\n      travelCode\n      destination\n      name\n      transportType\n      transportTypeLabel\n      importDateTime\n      importStatus    }\n    ratioAccommodations @include(if: $withRatioAccommodations) {\n      id\n      ratioPackageNo\n      name\n      label\n      info\n      isFamilyPackageAccommodation\n      isBabyPackage\n    }\n    ratioFamilyPackages @include(if: $withRatioFamilyPackages) {\n      id\n      ratioServiceNo\n      name\n      label\n      info\n    }\n    travellers @include(if: $withTravellers) {\n      id\n      salutation\n      firstName\n      lastName\n      birthday\n      nationality\n      email\n      phone\n      address\n      addressNumber\n      addressAddition\n      zip\n      city\n      country\n    }\n  }\n}";

// EXTERNAL MODULE: ./src/entities/travelPricingServiceCalculationSettings/entity.ts + 3 modules
var entity = __webpack_require__(49005);
// EXTERNAL MODULE: ./src/entities/travelPricingMandatorySettings/entity.ts + 3 modules
var travelPricingMandatorySettings_entity = __webpack_require__(28967);
;// CONCATENATED MODULE: ./src/entities/ratioAccommodationAddon/model.ts



var ratioAccommodationAddonModel = {
    name: "accommodationAddon",
    namePlural: "accommodationAddons",
    uniqueName: "ratioAccommodationAddon",
    uniqueNamePlural: "ratioAccommodationAddons",
    path: "travel/pricing/adaptors/ratio/accommodation_addon",
    baseUrl: "/travel/pricing/adaptors/ratio/accommodation_addons",
    translationPrefix: "entities:ratioAccommodationAddon.",
    getDisplayName: function(values) {
        return values.label;
    },
    gql: {
        getAll: ALL_ACCOMMODATION_ADDONS_QUERY,
        getSingle: SINGLE_ACCOMMODATION_ADDON_QUERY,
        create: CREATE_ACCOMMODATION_ADDON_MUTATION,
        update: UPDATE_ACCOMMODATION_ADDON_MUTATION,
        delete: DELETE_ACCOMMODATION_ADDON_MUTATION,
        forceDelete: FORCE_DELETE_ACCOMMODATION_ADDON_MUTATION
    },
    attributes: {
        ratioServiceNo: {
            name: "ratioServiceNo",
            label: "entities:ratioAccommodationAddon.attributes.ratioServiceNo.label",
            type: "value",
            dataType: "number",
            defaultInput: true,
            inputType: "hidden",
            validationType: "string",
            validations: [
                {
                    type: "required"
                }, 
            ]
        },
        name: {
            name: "name",
            label: "entities:ratioAccommodationAddon.attributes.name.label",
            type: "value",
            dataType: "string",
            defaultInput: true,
            inputType: "hidden",
            validationType: "string",
            validations: [
                {
                    type: "required"
                }, 
            ]
        },
        label: {
            name: "label",
            label: "entities:ratioAccommodationAddon.attributes.label.label",
            type: "value",
            dataType: "string",
            defaultInput: true,
            inputType: "text",
            validationType: "string",
            validations: [
                {
                    type: "required"
                }, 
            ]
        },
        info: {
            name: "info",
            label: "entities:ratioAccommodationAddon.attributes.info.label",
            type: "value",
            dataType: "string",
            defaultInput: true,
            inputType: "textarea",
            maxLength: 255,
            validationType: "string",
            validations: []
        },
        calculationSettings: {
            name: "calculationSettings",
            label: "entities:ratioAccommodationAddon.attributes.calculationSettings.label",
            type: "entityObject",
            dataType: "any",
            getEntity: function() {
                return entity/* default */.Z;
            },
            defaultInput: false,
            inputType: "select",
            validationType: "string",
            validations: []
        },
        mandatorySettings: {
            name: "mandatorySettings",
            label: "entities:ratioAccommodationAddon.attributes.mandatorySettings.label",
            type: "entityObject",
            dataType: "any",
            getEntity: function() {
                return travelPricingMandatorySettings_entity/* default */.Z;
            },
            defaultInput: false,
            inputType: "select",
            validationType: "string",
            validations: []
        }
    }
};
/* harmony default export */ var model = (ratioAccommodationAddonModel);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(20414);
// EXTERNAL MODULE: ./src/entities/lib.ts
var lib = __webpack_require__(23480);
// EXTERNAL MODULE: ./src/lib/api/graphQLClient.ts
var graphQLClient = __webpack_require__(40112);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/swr/dist/index.mjs
var dist = __webpack_require__(8100);
// EXTERNAL MODULE: ./src/lib/helpers/helpers.ts
var helpers = __webpack_require__(15778);
;// CONCATENATED MODULE: ./src/entities/ratioAccommodationAddon/repository.ts










var hydrateObjects = function(objects) {
    return objects.map(function(object) {
        return (0,lib/* hydrateEntityObject */.b)(model, object);
    });
};
var hydrateObject = function(object) {
    return (0,lib/* hydrateEntityObject */.b)(model, object);
};
var ratioAccommodationAddonRepository = {
    getObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    id: id
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(SINGLE_ACCOMMODATION_ADDON_QUERY, variables).then(function(data) {
                        return hydrateObject(data.accommodationAddon);
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }(),
    getObjects: /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        var includes;
        var _arguments = arguments;
        return (0,tslib_es6.__generator)(this, function(_state) {
            includes = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : {};
            return [
                2,
                graphQLClient/* default.request */.Z.request(ALL_ACCOMMODATION_ADDONS_QUERY, includes).then(function(data) {
                    return hydrateObjects(data.accommodationAddons);
                })
            ];
        });
    }),
    useObject: function(id) {
        var includes = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        // eslint-disable-next-line react-hooks/exhaustive-deps
        var variables = (0,react.useMemo)(function() {
            return (0,_object_spread/* default */.Z)({
                id: id
            }, includes);
        }, [
            id
        ]);
        var ref = (0,dist/* default */.ZP)([
            SINGLE_ACCOMMODATION_ADDON_QUERY,
            variables
        ], {
            revalidateOnFocus: false
        }), data = ref.data, error = ref.error, mutate = ref.mutate;
        return {
            object: !data ? data : hydrateObject(data.accommodationAddon),
            isLoading: !error && !data,
            isError: error,
            mutate: mutate
        };
    },
    useObjects: function() {
        var includes = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        // eslint-disable-next-line react-hooks/exhaustive-deps
        var variables = (0,react.useMemo)(function() {
            return includes;
        }, []);
        var ref = (0,dist/* default */.ZP)([
            ALL_ACCOMMODATION_ADDONS_QUERY,
            variables
        ]), data = ref.data, error = ref.error, mutate = ref.mutate;
        return {
            objects: !data ? data : hydrateObjects(data.accommodationAddons),
            isLoading: !error && !data,
            isError: error,
            mutate: mutate
        };
    },
    getDependents: function(id, includes) {
        var includeVars = {};
        includes.forEach(function(include) {
            includeVars["with".concat((0,helpers/* uppercaseFirst */.AB)(include))] = true;
        });
        var variables = (0,_object_spread/* default */.Z)({
            id: id
        }, includeVars);
        return graphQLClient/* default.request */.Z.request(ACCOMMODATION_ADDONS_DEPENDENTS_QUERY, variables).then(function(data) {
            return data.groupedDependents;
        });
    },
    useDependents: function(id, includes) {
        var includeVars = {};
        includes.forEach(function(include) {
            includeVars["with".concat((0,helpers/* uppercaseFirst */.AB)(include))] = true;
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
        var variables = (0,react.useMemo)(function() {
            return (0,_object_spread/* default */.Z)({
                id: id
            }, includeVars);
        }, [
            id
        ]);
        var ref = (0,dist/* default */.ZP)([
            ACCOMMODATION_ADDONS_DEPENDENTS_QUERY,
            variables
        ], {
            revalidateOnFocus: false
        }), data = ref.data, error = ref.error, mutate = ref.mutate;
        return {
            data: !data ? data : data.groupedDependents,
            isLoading: !error && !data,
            isError: error,
            mutate: mutate
        };
    },
    createObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(data) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    input: data
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(CREATE_ACCOMMODATION_ADDON_MUTATION, variables).then(function(data) {
                        return hydrateObject(data.accommodationAddon);
                    })
                ];
            });
        });
        return function(data) {
            return _ref.apply(this, arguments);
        };
    }(),
    updateObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(data) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    input: data
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(UPDATE_ACCOMMODATION_ADDON_MUTATION, variables).then(function(data) {
                        return hydrateObject(data.accommodationAddon);
                    })
                ];
            });
        });
        return function(data) {
            return _ref.apply(this, arguments);
        };
    }(),
    deleteObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(DELETE_ACCOMMODATION_ADDON_MUTATION, variables).then(function(data) {
                        return data.deleteRatioAccommodationAddon;
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }(),
    forceDeleteObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(FORCE_DELETE_ACCOMMODATION_ADDON_MUTATION, variables).then(function(data) {
                        return data.forceDeleteRatioAccommodationAddon;
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }()
};
/* harmony default export */ var repository = (ratioAccommodationAddonRepository);

;// CONCATENATED MODULE: ./src/entities/ratioAccommodationAddon/entity.ts


var ratioAccommodationAddonEntity = {
    model: model,
    repository: repository
};
/* harmony default export */ var ratioAccommodationAddon_entity = (ratioAccommodationAddonEntity);


/***/ }),

/***/ 15561:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ ratioAccommodationExtensionMapItem_entity; }
});

;// CONCATENATED MODULE: ./src/entities/ratioAccommodationExtensionMapItem/graphql.ts
// language=GraphQL
var ALL_EXTENSION_MAP_ITEMS_QUERY = "query Query($withBaseAccommodation: Boolean = false, $withBaseAccommodationCapacitySettings: Boolean = false, $withBaseAccommodationCapacitySettingsAgeGroupCapacities: Boolean = false, $withBaseAccommodationCapacitySettingsAgeGroupedTotalCapacities: Boolean = false, $withBaseAccommodationCapacitySettingsPartialOccupancyAllowedAgeGroups: Boolean = false, $withBaseAccommodationAddons: Boolean = false, $withBaseAccommodationAddonsCalculationSettings: Boolean = false, $withBaseAccommodationAddonsMandatorySettings: Boolean = false, $withExtensionAccommodation: Boolean = false) {\n  extensionMapItems: ratioAccommodationExtensionMapItems {\n    id\n    baseAccommodation @include(if: $withBaseAccommodation) {\n      id\n      ratioPackageNo\n      name\n      label\n      info\n      isFamilyPackageAccommodation\n      isBabyPackage\n      capacitySettings @include(if: $withBaseAccommodationCapacitySettings) {\n        id\n        totalCapacity\n        rangesAllowed\n        ageGroupCapacities @include(if: $withBaseAccommodationCapacitySettingsAgeGroupCapacities) {\n          id\n          minCapacity\n          maxCapacity\n        }\n        ageGroupedTotalCapacities @include(if: $withBaseAccommodationCapacitySettingsAgeGroupedTotalCapacities) {\n          id\n          capacity\n        }\n        partialOccupancyAllowed\n        partialOccupancyAllowedAgeGroups @include(if: $withBaseAccommodationCapacitySettingsPartialOccupancyAllowedAgeGroups) {\n          id\n          name\n          type\n          icon\n          minAge\n          maxAge\n        }\n      }\n      addons @include(if: $withBaseAccommodationAddons) {\n        id\n        ratioServiceNo\n        name\n        label\n        info\n        calculationSettings @include(if: $withBaseAccommodationAddonsCalculationSettings) {\n          id\n          type\n          considerHotelNights\n        }\n        mandatorySettings @include(if: $withBaseAccommodationAddonsMandatorySettings) {\n          id\n          isMandatory\n          useRules\n        }\n      }\n    }\n    extensionAccommodation @include(if: $withExtensionAccommodation) {\n      id\n      ratioPackageNo\n      name\n      label\n      info\n      extensionAccommodationServiceNo\n    }\n  }\n}";
// language=GraphQL
var SINGLE_EXTENSION_MAP_ITEM_QUERY = "query Query($id: ID!, $withBaseAccommodation: Boolean = false, $withBaseAccommodationCapacitySettings: Boolean = false, $withBaseAccommodationCapacitySettingsAgeGroupCapacities: Boolean = false, $withBaseAccommodationCapacitySettingsAgeGroupedTotalCapacities: Boolean = false, $withBaseAccommodationCapacitySettingsPartialOccupancyAllowedAgeGroups: Boolean = false, $withBaseAccommodationAddons: Boolean = false, $withBaseAccommodationAddonsCalculationSettings: Boolean = false, $withBaseAccommodationAddonsMandatorySettings: Boolean = false, $withExtensionAccommodation: Boolean = false) {\n  extensionMapItem: ratioAccommodationExtensionMapItem(id: $id) {\n    id\n    baseAccommodation @include(if: $withBaseAccommodation) {\n      id\n      ratioPackageNo\n      name\n      label\n      info\n      isFamilyPackageAccommodation\n      isBabyPackage\n      capacitySettings @include(if: $withBaseAccommodationCapacitySettings) {\n        id\n        totalCapacity\n        rangesAllowed\n        ageGroupCapacities @include(if: $withBaseAccommodationCapacitySettingsAgeGroupCapacities) {\n          id\n          minCapacity\n          maxCapacity\n        }\n        ageGroupedTotalCapacities @include(if: $withBaseAccommodationCapacitySettingsAgeGroupedTotalCapacities) {\n          id\n          capacity\n        }\n        partialOccupancyAllowed\n        partialOccupancyAllowedAgeGroups @include(if: $withBaseAccommodationCapacitySettingsPartialOccupancyAllowedAgeGroups) {\n          id\n          name\n          type\n          icon\n          minAge\n          maxAge\n        }\n      }\n      addons @include(if: $withBaseAccommodationAddons) {\n        id\n        ratioServiceNo\n        name\n        label\n        info\n        calculationSettings @include(if: $withBaseAccommodationAddonsCalculationSettings) {\n          id\n          type\n          considerHotelNights\n        }\n        mandatorySettings @include(if: $withBaseAccommodationAddonsMandatorySettings) {\n          id\n          isMandatory\n          useRules\n        }\n      }\n    }\n    extensionAccommodation @include(if: $withExtensionAccommodation) {\n      id\n      ratioPackageNo\n      name\n      label\n      info\n      extensionAccommodationServiceNo\n    }\n  }\n}";
// language=GraphQL
var CREATE_EXTENSION_MAP_ITEM_MUTATION = "\n  mutation Mutation($input: CreateRatioAccommodationExtensionMapItemInput, $withBaseAccommodation: Boolean = false, $withBaseAccommodationCapacitySettings: Boolean = false, $withBaseAccommodationCapacitySettingsAgeGroupCapacities: Boolean = false, $withBaseAccommodationCapacitySettingsAgeGroupedTotalCapacities: Boolean = false, $withBaseAccommodationCapacitySettingsPartialOccupancyAllowedAgeGroups: Boolean = false, $withBaseAccommodationAddons: Boolean = false, $withBaseAccommodationAddonsCalculationSettings: Boolean = false, $withBaseAccommodationAddonsMandatorySettings: Boolean = false, $withExtensionAccommodation: Boolean = false) {\n    extensionMapItem: createRatioAccommodationExtensionMapItem(input: $input) {\n      id\n      baseAccommodation @include(if: $withBaseAccommodation) {\n        id\n        ratioPackageNo\n        name\n        label\n        info\n        isFamilyPackageAccommodation\n        isBabyPackage\n        capacitySettings @include(if: $withBaseAccommodationCapacitySettings) {\n          id\n          totalCapacity\n          rangesAllowed\n          ageGroupCapacities @include(if: $withBaseAccommodationCapacitySettingsAgeGroupCapacities) {\n            id\n            minCapacity\n            maxCapacity\n          }\n          ageGroupedTotalCapacities @include(if: $withBaseAccommodationCapacitySettingsAgeGroupedTotalCapacities) {\n            id\n            capacity\n          }\n          partialOccupancyAllowed\n          partialOccupancyAllowedAgeGroups @include(if: $withBaseAccommodationCapacitySettingsPartialOccupancyAllowedAgeGroups) {\n            id\n            name\n            type\n            icon\n            minAge\n            maxAge\n          }\n        }\n        addons @include(if: $withBaseAccommodationAddons) {\n          id\n          ratioServiceNo\n          name\n          label\n          info\n          calculationSettings @include(if: $withBaseAccommodationAddonsCalculationSettings) {\n            id\n            type\n            considerHotelNights\n          }\n          mandatorySettings @include(if: $withBaseAccommodationAddonsMandatorySettings) {\n            id\n            isMandatory\n            useRules\n          }\n        }\n      }\n      extensionAccommodation @include(if: $withExtensionAccommodation) {\n        id\n        ratioPackageNo\n        name\n        label\n        info\n        extensionAccommodationServiceNo\n      }\n    }\n  }";
// language=GraphQL
var UPDATE_EXTENSION_MAP_ITEM_MUTATION = "\n  mutation Mutation($input: UpdateRatioAccommodationExtensionMapItemInput, $withBaseAccommodation: Boolean = false, $withBaseAccommodationCapacitySettings: Boolean = false, $withBaseAccommodationCapacitySettingsAgeGroupCapacities: Boolean = false, $withBaseAccommodationCapacitySettingsAgeGroupedTotalCapacities: Boolean = false, $withBaseAccommodationCapacitySettingsPartialOccupancyAllowedAgeGroups: Boolean = false, $withBaseAccommodationAddons: Boolean = false, $withBaseAccommodationAddonsCalculationSettings: Boolean = false, $withBaseAccommodationAddonsMandatorySettings: Boolean = false, $withExtensionAccommodation: Boolean = false) {\n    extensionMapItem: updateRatioAccommodationExtensionMapItem(input: $input) {\n      id\n      baseAccommodation @include(if: $withBaseAccommodation) {\n        id\n        ratioPackageNo\n        name\n        label\n        info\n        isFamilyPackageAccommodation\n        isBabyPackage\n        capacitySettings @include(if: $withBaseAccommodationCapacitySettings) {\n          id\n          totalCapacity\n          rangesAllowed\n          ageGroupCapacities @include(if: $withBaseAccommodationCapacitySettingsAgeGroupCapacities) {\n            id\n            minCapacity\n            maxCapacity\n          }\n          ageGroupedTotalCapacities @include(if: $withBaseAccommodationCapacitySettingsAgeGroupedTotalCapacities) {\n            id\n            capacity\n          }\n          partialOccupancyAllowed\n          partialOccupancyAllowedAgeGroups @include(if: $withBaseAccommodationCapacitySettingsPartialOccupancyAllowedAgeGroups) {\n            id\n            name\n            type\n            icon\n            minAge\n            maxAge\n          }\n        }\n        addons @include(if: $withBaseAccommodationAddons) {\n          id\n          ratioServiceNo\n          name\n          label\n          info\n          calculationSettings @include(if: $withBaseAccommodationAddonsCalculationSettings) {\n            id\n            type\n            considerHotelNights\n          }\n          mandatorySettings @include(if: $withBaseAccommodationAddonsMandatorySettings) {\n            id\n            isMandatory\n            useRules\n          }\n        }\n      }\n      extensionAccommodation @include(if: $withExtensionAccommodation) {\n        id\n        ratioPackageNo\n        name\n        label\n        info\n        extensionAccommodationServiceNo\n      }\n    }\n  }";
// language=GraphQL
var DELETE_EXTENSION_MAP_ITEM_MUTATION = "\n  mutation Mutation($input: DeleteRatioAccommodationExtensionMapItemInput) {\n    deleteRatioAccommodationExtensionMapItem(input: $input) {\n      success\n    }\n  }";
// language=GraphQL
var FORCE_DELETE_EXTENSION_MAP_ITEM_MUTATION = "\n  mutation Mutation($input: DeleteRatioAccommodationExtensionMapItemInput) {\n    forceDeleteRatioAccommodationExtensionMapItem(input: $input) {\n      success\n    }\n  }";
// language=GraphQL
var EXTENSION_MAP_ITEMS_DEPENDENTS_QUERY = "query Query($id: ID!, $withRatioTravelExtensions: Boolean = false) {\n  groupedDependents: ratioAccommodationExtensionMapItemDependents(id: $id) {\n    ratioTravelExtensions @include(if: $withRatioTravelExtensions) {\n      id\n      label\n      info\n    }\n  }\n}";

// EXTERNAL MODULE: ./src/entities/ratioAccommodation/entity.ts + 3 modules
var entity = __webpack_require__(53656);
// EXTERNAL MODULE: ./src/entities/ratioExtensionAccommodation/entity.ts + 3 modules
var ratioExtensionAccommodation_entity = __webpack_require__(51316);
;// CONCATENATED MODULE: ./src/entities/ratioAccommodationExtensionMapItem/model.ts



var ratioAccommodationExtensionMapItemModel = {
    name: "extensionMapItem",
    namePlural: "extensionMapItems",
    uniqueName: "ratioAccommodationExtensionMapItem",
    uniqueNamePlural: "ratioAccommodationExtensionMapItems",
    path: "travel/pricing/adaptors/ratio/extension_map_item",
    baseUrl: "/travel/pricing/adaptors/ratio/extension_map_items",
    translationPrefix: "entities:ratioAccommodationExtensionMapItem.",
    getDisplayName: function(values) {
        return "Accommodation Extension Map Item";
    },
    gql: {
        getAll: ALL_EXTENSION_MAP_ITEMS_QUERY,
        getSingle: SINGLE_EXTENSION_MAP_ITEM_QUERY,
        create: CREATE_EXTENSION_MAP_ITEM_MUTATION,
        update: UPDATE_EXTENSION_MAP_ITEM_MUTATION,
        delete: DELETE_EXTENSION_MAP_ITEM_MUTATION,
        forceDelete: FORCE_DELETE_EXTENSION_MAP_ITEM_MUTATION
    },
    attributes: {
        baseAccommodation: {
            name: "baseAccommodation",
            label: "entities:ratioAccommodationExtensionMapItem.attributes.baseAccommodation.label",
            type: "entityObject",
            dataType: "any",
            getEntity: function() {
                return entity/* default */.Z;
            },
            defaultInput: true,
            inputType: "select",
            validationType: "string",
            validations: []
        },
        extensionAccommodation: {
            name: "extensionAccommodation",
            label: "entities:ratioAccommodationExtensionMapItem.attributes.extensionAccommodation.label",
            type: "entityObject",
            dataType: "any",
            getEntity: function() {
                return ratioExtensionAccommodation_entity/* default */.Z;
            },
            defaultInput: true,
            inputType: "select",
            validationType: "string",
            validations: []
        }
    }
};
/* harmony default export */ var model = (ratioAccommodationExtensionMapItemModel);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(20414);
// EXTERNAL MODULE: ./src/entities/lib.ts
var lib = __webpack_require__(23480);
// EXTERNAL MODULE: ./src/lib/api/graphQLClient.ts
var graphQLClient = __webpack_require__(40112);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/swr/dist/index.mjs
var dist = __webpack_require__(8100);
// EXTERNAL MODULE: ./src/lib/helpers/helpers.ts
var helpers = __webpack_require__(15778);
;// CONCATENATED MODULE: ./src/entities/ratioAccommodationExtensionMapItem/repository.ts










var hydrateObjects = function(objects) {
    return objects.map(function(object) {
        return (0,lib/* hydrateEntityObject */.b)(model, object);
    });
};
var hydrateObject = function(object) {
    return (0,lib/* hydrateEntityObject */.b)(model, object);
};
var ratioAccommodationExtensionMapItemRepository = {
    getObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    id: id
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(SINGLE_EXTENSION_MAP_ITEM_QUERY, variables).then(function(data) {
                        return hydrateObject(data.extensionMapItem);
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }(),
    getObjects: /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        var includes;
        var _arguments = arguments;
        return (0,tslib_es6.__generator)(this, function(_state) {
            includes = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : {};
            return [
                2,
                graphQLClient/* default.request */.Z.request(ALL_EXTENSION_MAP_ITEMS_QUERY, includes).then(function(data) {
                    return hydrateObjects(data.extensionMapItems);
                })
            ];
        });
    }),
    useObject: function(id) {
        var includes = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        // eslint-disable-next-line react-hooks/exhaustive-deps
        var variables = (0,react.useMemo)(function() {
            return (0,_object_spread/* default */.Z)({
                id: id
            }, includes);
        }, [
            id
        ]);
        var ref = (0,dist/* default */.ZP)([
            SINGLE_EXTENSION_MAP_ITEM_QUERY,
            variables
        ], {
            revalidateOnFocus: false
        }), data = ref.data, error = ref.error, mutate = ref.mutate;
        return {
            object: !data ? data : hydrateObject(data.extensionMapItem),
            isLoading: !error && !data,
            isError: error,
            mutate: mutate
        };
    },
    useObjects: function() {
        var includes = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        // eslint-disable-next-line react-hooks/exhaustive-deps
        var variables = (0,react.useMemo)(function() {
            return includes;
        }, []);
        var ref = (0,dist/* default */.ZP)([
            ALL_EXTENSION_MAP_ITEMS_QUERY,
            variables
        ]), data = ref.data, error = ref.error, mutate = ref.mutate;
        return {
            objects: !data ? data : hydrateObjects(data.extensionMapItems),
            isLoading: !error && !data,
            isError: error,
            mutate: mutate
        };
    },
    getDependents: function(id, includes) {
        var includeVars = {};
        includes.forEach(function(include) {
            includeVars["with".concat((0,helpers/* uppercaseFirst */.AB)(include))] = true;
        });
        var variables = (0,_object_spread/* default */.Z)({
            id: id
        }, includeVars);
        return graphQLClient/* default.request */.Z.request(EXTENSION_MAP_ITEMS_DEPENDENTS_QUERY, variables).then(function(data) {
            return data.groupedDependents;
        });
    },
    useDependents: function(id, includes) {
        var includeVars = {};
        includes.forEach(function(include) {
            includeVars["with".concat((0,helpers/* uppercaseFirst */.AB)(include))] = true;
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
        var variables = (0,react.useMemo)(function() {
            return (0,_object_spread/* default */.Z)({
                id: id
            }, includeVars);
        }, [
            id
        ]);
        var ref = (0,dist/* default */.ZP)([
            EXTENSION_MAP_ITEMS_DEPENDENTS_QUERY,
            variables
        ], {
            revalidateOnFocus: false
        }), data = ref.data, error = ref.error, mutate = ref.mutate;
        return {
            data: !data ? data : data.groupedDependents,
            isLoading: !error && !data,
            isError: error,
            mutate: mutate
        };
    },
    createObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(data) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    input: data
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(CREATE_EXTENSION_MAP_ITEM_MUTATION, variables).then(function(data) {
                        return hydrateObject(data.extensionMapItem);
                    })
                ];
            });
        });
        return function(data) {
            return _ref.apply(this, arguments);
        };
    }(),
    updateObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(data) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    input: data
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(UPDATE_EXTENSION_MAP_ITEM_MUTATION, variables).then(function(data) {
                        return hydrateObject(data.extensionMapItem);
                    })
                ];
            });
        });
        return function(data) {
            return _ref.apply(this, arguments);
        };
    }(),
    deleteObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(DELETE_EXTENSION_MAP_ITEM_MUTATION, variables).then(function(data) {
                        return data.deleteRatioAccommodationExtensionMapItem;
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }(),
    forceDeleteObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(FORCE_DELETE_EXTENSION_MAP_ITEM_MUTATION, variables).then(function(data) {
                        return data.forceDeleteRatioAccommodationExtensionMapItem;
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }()
};
/* harmony default export */ var repository = (ratioAccommodationExtensionMapItemRepository);

;// CONCATENATED MODULE: ./src/entities/ratioAccommodationExtensionMapItem/entity.ts


var ratioAccommodationExtensionMapItemEntity = {
    model: model,
    repository: repository
};
/* harmony default export */ var ratioAccommodationExtensionMapItem_entity = (ratioAccommodationExtensionMapItemEntity);


/***/ }),

/***/ 21996:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ ratioAgeGroupService_entity; }
});

;// CONCATENATED MODULE: ./src/entities/ratioAgeGroupService/graphql.ts
// language=GraphQL
var ALL_AGE_GROUP_SERVICES_QUERY = "query Query($withAgeGroup: Boolean = false) {\n  ageGroupServices: ratioAgeGroupServices {\n    id\n    ageGroup @include(if: $withAgeGroup) {\n      id\n      name\n      type\n      icon\n      minAge\n      maxAge\n    }\n    ratioServiceNo\n  }\n}";
// language=GraphQL
var SINGLE_AGE_GROUP_SERVICE_QUERY = "query Query($id: ID!, $withAgeGroup: Boolean = false) {\n  ageGroupService: ratioAgeGroupService(id: $id) {\n    id\n    ageGroup @include(if: $withAgeGroup) {\n      id\n      name\n      type\n      icon\n      minAge\n      maxAge\n    }\n    ratioServiceNo\n  }\n}";
// language=GraphQL
var CREATE_AGE_GROUP_SERVICE_MUTATION = "\n  mutation Mutation($input: CreateRatioAgeGroupServiceInput, $withAgeGroup: Boolean = false) {\n    ageGroupService: createRatioAgeGroupService(input: $input) {\n      id\n      ageGroup @include(if: $withAgeGroup) {\n        id\n        name\n        type\n        icon\n        minAge\n        maxAge\n      }\n      ratioServiceNo\n    }\n  }";
// language=GraphQL
var UPDATE_AGE_GROUP_SERVICE_MUTATION = "\n  mutation Mutation($input: UpdateRatioAgeGroupServiceInput, $withAgeGroup: Boolean = false) {\n    ageGroupService: updateRatioAgeGroupService(input: $input) {\n      id\n      ageGroup @include(if: $withAgeGroup) {\n        id\n        name\n        type\n        icon\n        minAge\n        maxAge\n      }\n      ratioServiceNo\n    }\n  }";
// language=GraphQL
var DELETE_AGE_GROUP_SERVICE_MUTATION = "\n  mutation Mutation($input: DeleteRatioAgeGroupServiceInput) {\n    deleteRatioAgeGroupService(input: $input) {\n      success\n    }\n  }";
// language=GraphQL
var FORCE_DELETE_AGE_GROUP_SERVICE_MUTATION = "\n  mutation Mutation($input: DeleteRatioAgeGroupServiceInput) {\n    forceDeleteRatioAgeGroupService(input: $input) {\n      success\n    }\n  }";
// language=GraphQL
var AGE_GROUP_SERVICES_DEPENDENTS_QUERY = "query Query($id: ID!, $withRatioCollectiveAddons: Boolean = false) {\n  groupedDependents: ratioAgeGroupServiceDependents(id: $id) {\n    ratioCollectiveAddons @include(if: $withRatioCollectiveAddons) {\n      id\n      label\n      info\n    }\n  }\n}";

// EXTERNAL MODULE: ./src/entities/travelPricingAgeGroup/entity.ts + 3 modules
var entity = __webpack_require__(65966);
;// CONCATENATED MODULE: ./src/entities/ratioAgeGroupService/model.ts


var ratioAgeGroupServiceModel = {
    name: "ageGroupService",
    namePlural: "ageGroupServices",
    uniqueName: "ratioAgeGroupService",
    uniqueNamePlural: "ratioAgeGroupServices",
    path: "travel/pricing/adaptors/ratio/age_group_service",
    baseUrl: "/travel/pricing/adaptors/ratio/age_group_services",
    translationPrefix: "entities:ratioAgeGroupService.",
    getDisplayName: function(values) {
        return "Age Group Service";
    },
    gql: {
        getAll: ALL_AGE_GROUP_SERVICES_QUERY,
        getSingle: SINGLE_AGE_GROUP_SERVICE_QUERY,
        create: CREATE_AGE_GROUP_SERVICE_MUTATION,
        update: UPDATE_AGE_GROUP_SERVICE_MUTATION,
        delete: DELETE_AGE_GROUP_SERVICE_MUTATION,
        forceDelete: FORCE_DELETE_AGE_GROUP_SERVICE_MUTATION
    },
    attributes: {
        ageGroup: {
            name: "ageGroup",
            label: "entities:ratioAgeGroupService.attributes.ageGroup.label",
            type: "entityObject",
            dataType: "any",
            getEntity: function() {
                return entity/* default */.Z;
            },
            defaultInput: false,
            inputType: "select",
            validationType: "string",
            validations: [
                {
                    type: "required"
                }, 
            ]
        },
        ratioServiceNo: {
            name: "ratioServiceNo",
            label: "entities:ratioAgeGroupService.attributes.ratioServiceNo.label",
            type: "value",
            dataType: "string",
            defaultInput: true,
            inputType: "hidden",
            validationType: "string",
            validations: [
                {
                    type: "required"
                }, 
            ]
        }
    }
};
/* harmony default export */ var model = (ratioAgeGroupServiceModel);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(20414);
// EXTERNAL MODULE: ./src/entities/lib.ts
var lib = __webpack_require__(23480);
// EXTERNAL MODULE: ./src/lib/api/graphQLClient.ts
var graphQLClient = __webpack_require__(40112);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/swr/dist/index.mjs
var dist = __webpack_require__(8100);
// EXTERNAL MODULE: ./src/lib/helpers/helpers.ts
var helpers = __webpack_require__(15778);
;// CONCATENATED MODULE: ./src/entities/ratioAgeGroupService/repository.ts










var hydrateObjects = function(objects) {
    return objects.map(function(object) {
        return (0,lib/* hydrateEntityObject */.b)(model, object);
    });
};
var hydrateObject = function(object) {
    return (0,lib/* hydrateEntityObject */.b)(model, object);
};
var ratioAgeGroupServiceRepository = {
    getObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    id: id
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(SINGLE_AGE_GROUP_SERVICE_QUERY, variables).then(function(data) {
                        return hydrateObject(data.ageGroupService);
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }(),
    getObjects: /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        var includes;
        var _arguments = arguments;
        return (0,tslib_es6.__generator)(this, function(_state) {
            includes = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : {};
            return [
                2,
                graphQLClient/* default.request */.Z.request(ALL_AGE_GROUP_SERVICES_QUERY, includes).then(function(data) {
                    return hydrateObjects(data.ageGroupServices);
                })
            ];
        });
    }),
    useObject: function(id) {
        var includes = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        // eslint-disable-next-line react-hooks/exhaustive-deps
        var variables = (0,react.useMemo)(function() {
            return (0,_object_spread/* default */.Z)({
                id: id
            }, includes);
        }, [
            id
        ]);
        var ref = (0,dist/* default */.ZP)([
            SINGLE_AGE_GROUP_SERVICE_QUERY,
            variables
        ], {
            revalidateOnFocus: false
        }), data = ref.data, error = ref.error, mutate = ref.mutate;
        return {
            object: !data ? data : hydrateObject(data.ageGroupService),
            isLoading: !error && !data,
            isError: error,
            mutate: mutate
        };
    },
    useObjects: function() {
        var includes = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        // eslint-disable-next-line react-hooks/exhaustive-deps
        var variables = (0,react.useMemo)(function() {
            return includes;
        }, []);
        var ref = (0,dist/* default */.ZP)([
            ALL_AGE_GROUP_SERVICES_QUERY,
            variables
        ]), data = ref.data, error = ref.error, mutate = ref.mutate;
        return {
            objects: !data ? data : hydrateObjects(data.ageGroupServices),
            isLoading: !error && !data,
            isError: error,
            mutate: mutate
        };
    },
    getDependents: function(id, includes) {
        var includeVars = {};
        includes.forEach(function(include) {
            includeVars["with".concat((0,helpers/* uppercaseFirst */.AB)(include))] = true;
        });
        var variables = (0,_object_spread/* default */.Z)({
            id: id
        }, includeVars);
        return graphQLClient/* default.request */.Z.request(AGE_GROUP_SERVICES_DEPENDENTS_QUERY, variables).then(function(data) {
            return data.groupedDependents;
        });
    },
    useDependents: function(id, includes) {
        var includeVars = {};
        includes.forEach(function(include) {
            includeVars["with".concat((0,helpers/* uppercaseFirst */.AB)(include))] = true;
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
        var variables = (0,react.useMemo)(function() {
            return (0,_object_spread/* default */.Z)({
                id: id
            }, includeVars);
        }, [
            id
        ]);
        var ref = (0,dist/* default */.ZP)([
            AGE_GROUP_SERVICES_DEPENDENTS_QUERY,
            variables
        ], {
            revalidateOnFocus: false
        }), data = ref.data, error = ref.error, mutate = ref.mutate;
        return {
            data: !data ? data : data.groupedDependents,
            isLoading: !error && !data,
            isError: error,
            mutate: mutate
        };
    },
    createObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(data) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    input: data
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(CREATE_AGE_GROUP_SERVICE_MUTATION, variables).then(function(data) {
                        return hydrateObject(data.ageGroupService);
                    })
                ];
            });
        });
        return function(data) {
            return _ref.apply(this, arguments);
        };
    }(),
    updateObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(data) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    input: data
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(UPDATE_AGE_GROUP_SERVICE_MUTATION, variables).then(function(data) {
                        return hydrateObject(data.ageGroupService);
                    })
                ];
            });
        });
        return function(data) {
            return _ref.apply(this, arguments);
        };
    }(),
    deleteObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(DELETE_AGE_GROUP_SERVICE_MUTATION, variables).then(function(data) {
                        return data.deleteRatioAgeGroupService;
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }(),
    forceDeleteObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(FORCE_DELETE_AGE_GROUP_SERVICE_MUTATION, variables).then(function(data) {
                        return data.forceDeleteRatioAgeGroupService;
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }()
};
/* harmony default export */ var repository = (ratioAgeGroupServiceRepository);

;// CONCATENATED MODULE: ./src/entities/ratioAgeGroupService/entity.ts


var ratioAgeGroupServiceEntity = {
    model: model,
    repository: repository
};
/* harmony default export */ var ratioAgeGroupService_entity = (ratioAgeGroupServiceEntity);


/***/ }),

/***/ 30250:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ ratioBookingAddon_entity; }
});

;// CONCATENATED MODULE: ./src/entities/ratioBookingAddon/graphql.ts
// language=GraphQL
var ALL_BOOKING_ADDONS_QUERY = "query Query($withCalculationSettings: Boolean = false, $withMandatorySettings: Boolean = false, $withMandatorySettingsRules: Boolean = false, $withMandatorySettingsRulesAccommodations: Boolean = false, $withMandatorySettingsRulesFamilyPackages: Boolean = false, $withMandatorySettingsRulesAccommodationAddons: Boolean = false, $withMandatorySettingsRulesAgeGroups: Boolean = false, $withMandatorySettingsRulesAgeFilter: Boolean = false, $withMandatorySettingsRulesTravelDates: Boolean = false) {\n  bookingAddons: ratioBookingAddons {\n    id\n    ratioServiceNo\n    name\n    label\n    info\n    calculationSettings @include(if: $withCalculationSettings) {\n      id\n      type\n      considerHotelNights\n    }\n    mandatorySettings @include(if: $withMandatorySettings) {\n      id\n      isMandatory\n      useRules\n      rules @include(if: $withMandatorySettingsRules) {\n        id\n        checkAccommodationTypes\n        accommodations @include(if: $withMandatorySettingsRulesAccommodations) {\n          id\n          ratioPackageNo\n          name\n          label\n          info\n          isFamilyPackageAccommodation\n          isBabyPackage\n        }\n        familyPackages @include(if: $withMandatorySettingsRulesFamilyPackages) {\n          id\n          ratioServiceNo\n          name\n          label\n          info\n        }\n        checkAccommodationAddons\n        accommodationAddons @include(if: $withMandatorySettingsRulesAccommodationAddons) {\n          id\n          ratioServiceNo\n          name\n          label\n          info\n        }\n        checkAgeGroups\n        ageGroups @include(if: $withMandatorySettingsRulesAgeGroups) {\n          id\n          name\n          type\n          icon\n          minAge\n          maxAge\n        }\n        useAgeFilter\n        ageFilter @include(if: $withMandatorySettingsRulesAgeFilter) {\n          id\n          minAge\n          maxAge\n        }\n        checkDateRange\n        startDate\n        endDate\n        checkTravelDate\n        travelDates @include(if: $withMandatorySettingsRulesTravelDates) {\n          id\n          dateNo\n          startDate\n          endDate\n          includesExtension\n          json\n        }\n      }\n    }\n  }\n}";
// language=GraphQL
var SINGLE_BOOKING_ADDON_QUERY = "query Query($id: ID!, $withCalculationSettings: Boolean = false, $withMandatorySettings: Boolean = false, $withMandatorySettingsRules: Boolean = false, $withMandatorySettingsRulesAccommodations: Boolean = false, $withMandatorySettingsRulesFamilyPackages: Boolean = false, $withMandatorySettingsRulesAccommodationAddons: Boolean = false, $withMandatorySettingsRulesAgeGroups: Boolean = false, $withMandatorySettingsRulesAgeFilter: Boolean = false, $withMandatorySettingsRulesTravelDates: Boolean = false) {\n  bookingAddon: ratioBookingAddon(id: $id) {\n    id\n    ratioServiceNo\n    name\n    label\n    info\n    calculationSettings @include(if: $withCalculationSettings) {\n      id\n      type\n      considerHotelNights\n    }\n    mandatorySettings @include(if: $withMandatorySettings) {\n      id\n      isMandatory\n      useRules\n      rules @include(if: $withMandatorySettingsRules) {\n        id\n        checkAccommodationTypes\n        accommodations @include(if: $withMandatorySettingsRulesAccommodations) {\n          id\n          ratioPackageNo\n          name\n          label\n          info\n          isFamilyPackageAccommodation\n          isBabyPackage\n        }\n        familyPackages @include(if: $withMandatorySettingsRulesFamilyPackages) {\n          id\n          ratioServiceNo\n          name\n          label\n          info\n        }\n        checkAccommodationAddons\n        accommodationAddons @include(if: $withMandatorySettingsRulesAccommodationAddons) {\n          id\n          ratioServiceNo\n          name\n          label\n          info\n        }\n        checkAgeGroups\n        ageGroups @include(if: $withMandatorySettingsRulesAgeGroups) {\n          id\n          name\n          type\n          icon\n          minAge\n          maxAge\n        }\n        useAgeFilter\n        ageFilter @include(if: $withMandatorySettingsRulesAgeFilter) {\n          id\n          minAge\n          maxAge\n        }\n        checkDateRange\n        startDate\n        endDate\n        checkTravelDate\n        travelDates @include(if: $withMandatorySettingsRulesTravelDates) {\n          id\n          dateNo\n          startDate\n          endDate\n          includesExtension\n          json\n        }\n      }\n    }\n  }\n}";
// language=GraphQL
var CREATE_BOOKING_ADDON_MUTATION = "\n  mutation Mutation($input: CreateRatioBookingAddonInput, $withCalculationSettings: Boolean = false, $withMandatorySettings: Boolean = false, $withMandatorySettingsRules: Boolean = false, $withMandatorySettingsRulesAccommodations: Boolean = false, $withMandatorySettingsRulesFamilyPackages: Boolean = false, $withMandatorySettingsRulesAccommodationAddons: Boolean = false, $withMandatorySettingsRulesAgeGroups: Boolean = false, $withMandatorySettingsRulesAgeFilter: Boolean = false, $withMandatorySettingsRulesTravelDates: Boolean = false) {\n    bookingAddon: createRatioBookingAddon(input: $input) {\n      id\n      ratioServiceNo\n      name\n      label\n      info\n      calculationSettings @include(if: $withCalculationSettings) {\n        id\n        type\n        considerHotelNights\n      }\n      mandatorySettings @include(if: $withMandatorySettings) {\n        id\n        isMandatory\n        useRules\n        rules @include(if: $withMandatorySettingsRules) {\n          id\n          checkAccommodationTypes\n          accommodations @include(if: $withMandatorySettingsRulesAccommodations) {\n            id\n            ratioPackageNo\n            name\n            label\n            info\n            isFamilyPackageAccommodation\n            isBabyPackage\n          }\n          familyPackages @include(if: $withMandatorySettingsRulesFamilyPackages) {\n            id\n            ratioServiceNo\n            name\n            label\n            info\n          }\n          checkAccommodationAddons\n          accommodationAddons @include(if: $withMandatorySettingsRulesAccommodationAddons) {\n            id\n            ratioServiceNo\n            name\n            label\n            info\n          }\n          checkAgeGroups\n          ageGroups @include(if: $withMandatorySettingsRulesAgeGroups) {\n            id\n            name\n            type\n            icon\n            minAge\n            maxAge\n          }\n          useAgeFilter\n          ageFilter @include(if: $withMandatorySettingsRulesAgeFilter) {\n            id\n            minAge\n            maxAge\n          }\n          checkDateRange\n          startDate\n          endDate\n          checkTravelDate\n          travelDates @include(if: $withMandatorySettingsRulesTravelDates) {\n            id\n            dateNo\n            startDate\n            endDate\n            includesExtension\n            json\n          }\n        }\n      }\n    }\n  }";
// language=GraphQL
var UPDATE_BOOKING_ADDON_MUTATION = "\n  mutation Mutation($input: UpdateRatioBookingAddonInput, $withCalculationSettings: Boolean = false, $withMandatorySettings: Boolean = false, $withMandatorySettingsRules: Boolean = false, $withMandatorySettingsRulesAccommodations: Boolean = false, $withMandatorySettingsRulesFamilyPackages: Boolean = false, $withMandatorySettingsRulesAccommodationAddons: Boolean = false, $withMandatorySettingsRulesAgeGroups: Boolean = false, $withMandatorySettingsRulesAgeFilter: Boolean = false, $withMandatorySettingsRulesTravelDates: Boolean = false) {\n    bookingAddon: updateRatioBookingAddon(input: $input) {\n      id\n      ratioServiceNo\n      name\n      label\n      info\n      calculationSettings @include(if: $withCalculationSettings) {\n        id\n        type\n        considerHotelNights\n      }\n      mandatorySettings @include(if: $withMandatorySettings) {\n        id\n        isMandatory\n        useRules\n        rules @include(if: $withMandatorySettingsRules) {\n          id\n          checkAccommodationTypes\n          accommodations @include(if: $withMandatorySettingsRulesAccommodations) {\n            id\n            ratioPackageNo\n            name\n            label\n            info\n            isFamilyPackageAccommodation\n            isBabyPackage\n          }\n          familyPackages @include(if: $withMandatorySettingsRulesFamilyPackages) {\n            id\n            ratioServiceNo\n            name\n            label\n            info\n          }\n          checkAccommodationAddons\n          accommodationAddons @include(if: $withMandatorySettingsRulesAccommodationAddons) {\n            id\n            ratioServiceNo\n            name\n            label\n            info\n          }\n          checkAgeGroups\n          ageGroups @include(if: $withMandatorySettingsRulesAgeGroups) {\n            id\n            name\n            type\n            icon\n            minAge\n            maxAge\n          }\n          useAgeFilter\n          ageFilter @include(if: $withMandatorySettingsRulesAgeFilter) {\n            id\n            minAge\n            maxAge\n          }\n          checkDateRange\n          startDate\n          endDate\n          checkTravelDate\n          travelDates @include(if: $withMandatorySettingsRulesTravelDates) {\n            id\n            dateNo\n            startDate\n            endDate\n            includesExtension\n            json\n          }\n        }\n      }\n    }\n  }";
// language=GraphQL
var DELETE_BOOKING_ADDON_MUTATION = "\n  mutation Mutation($input: DeleteRatioBookingAddonInput) {\n    deleteRatioBookingAddon(input: $input) {\n      success\n    }\n  }";
// language=GraphQL
var FORCE_DELETE_BOOKING_ADDON_MUTATION = "\n  mutation Mutation($input: DeleteRatioBookingAddonInput) {\n    forceDeleteRatioBookingAddon(input: $input) {\n      success\n    }\n  }";
// language=GraphQL
var BOOKING_ADDONS_DEPENDENTS_QUERY = "query Query($id: ID!, $withRatioTravels: Boolean = false, $withTravellers: Boolean = false) {\n  groupedDependents: ratioBookingAddonDependents(id: $id) {\n    ratioTravels @include(if: $withRatioTravels) {\n      id\n      catalogCode\n      travelCode\n      destination\n      name\n      transportType\n      transportTypeLabel\n      importDateTime\n      importStatus    }\n    travellers @include(if: $withTravellers) {\n      id\n      salutation\n      firstName\n      lastName\n      birthday\n      nationality\n      email\n      phone\n      address\n      addressNumber\n      addressAddition\n      zip\n      city\n      country\n    }\n  }\n}";

// EXTERNAL MODULE: ./src/entities/travelPricingServiceCalculationSettings/entity.ts + 3 modules
var entity = __webpack_require__(49005);
// EXTERNAL MODULE: ./src/entities/travelPricingMandatorySettings/entity.ts + 3 modules
var travelPricingMandatorySettings_entity = __webpack_require__(28967);
;// CONCATENATED MODULE: ./src/entities/ratioBookingAddon/model.ts



var ratioBookingAddonModel = {
    name: "bookingAddon",
    namePlural: "bookingAddons",
    uniqueName: "ratioBookingAddon",
    uniqueNamePlural: "ratioBookingAddons",
    path: "travel/pricing/adaptors/ratio/booking_addon",
    baseUrl: "/travel/pricing/adaptors/ratio/booking_addons",
    translationPrefix: "entities:ratioBookingAddon.",
    getDisplayName: function(values) {
        return values.label;
    },
    gql: {
        getAll: ALL_BOOKING_ADDONS_QUERY,
        getSingle: SINGLE_BOOKING_ADDON_QUERY,
        create: CREATE_BOOKING_ADDON_MUTATION,
        update: UPDATE_BOOKING_ADDON_MUTATION,
        delete: DELETE_BOOKING_ADDON_MUTATION,
        forceDelete: FORCE_DELETE_BOOKING_ADDON_MUTATION
    },
    attributes: {
        ratioServiceNo: {
            name: "ratioServiceNo",
            label: "entities:ratioBookingAddon.attributes.ratioServiceNo.label",
            type: "value",
            dataType: "string",
            defaultInput: true,
            inputType: "hidden",
            validationType: "string",
            validations: [
                {
                    type: "required"
                }, 
            ]
        },
        name: {
            name: "name",
            label: "entities:ratioBookingAddon.attributes.name.label",
            type: "value",
            dataType: "string",
            defaultInput: true,
            inputType: "hidden",
            validationType: "string",
            validations: [
                {
                    type: "required"
                }, 
            ]
        },
        label: {
            name: "label",
            label: "entities:ratioBookingAddon.attributes.label.label",
            type: "value",
            dataType: "string",
            defaultInput: true,
            inputType: "text",
            validationType: "string",
            validations: [
                {
                    type: "required"
                }, 
            ]
        },
        info: {
            name: "info",
            label: "entities:ratioBookingAddon.attributes.info.label",
            type: "value",
            dataType: "string",
            defaultInput: true,
            inputType: "textarea",
            maxLength: 255,
            validationType: "string",
            validations: []
        },
        calculationSettings: {
            name: "calculationSettings",
            label: "entities:ratioBookingAddon.attributes.calculationSettings.label",
            type: "entityObject",
            dataType: "any",
            getEntity: function() {
                return entity/* default */.Z;
            },
            defaultInput: false,
            inputType: "select",
            validationType: "string",
            validations: []
        },
        mandatorySettings: {
            name: "mandatorySettings",
            label: "entities:ratioBookingAddon.attributes.mandatorySettings.label",
            type: "entityObject",
            dataType: "any",
            getEntity: function() {
                return travelPricingMandatorySettings_entity/* default */.Z;
            },
            defaultInput: false,
            inputType: "select",
            validationType: "string",
            validations: []
        }
    }
};
/* harmony default export */ var model = (ratioBookingAddonModel);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(20414);
// EXTERNAL MODULE: ./src/entities/lib.ts
var lib = __webpack_require__(23480);
// EXTERNAL MODULE: ./src/lib/api/graphQLClient.ts
var graphQLClient = __webpack_require__(40112);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/swr/dist/index.mjs
var dist = __webpack_require__(8100);
// EXTERNAL MODULE: ./src/lib/helpers/helpers.ts
var helpers = __webpack_require__(15778);
;// CONCATENATED MODULE: ./src/entities/ratioBookingAddon/repository.ts










var hydrateObjects = function(objects) {
    return objects.map(function(object) {
        return (0,lib/* hydrateEntityObject */.b)(model, object);
    });
};
var hydrateObject = function(object) {
    return (0,lib/* hydrateEntityObject */.b)(model, object);
};
var ratioBookingAddonRepository = {
    getObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    id: id
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(SINGLE_BOOKING_ADDON_QUERY, variables).then(function(data) {
                        return hydrateObject(data.bookingAddon);
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }(),
    getObjects: /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        var includes;
        var _arguments = arguments;
        return (0,tslib_es6.__generator)(this, function(_state) {
            includes = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : {};
            return [
                2,
                graphQLClient/* default.request */.Z.request(ALL_BOOKING_ADDONS_QUERY, includes).then(function(data) {
                    return hydrateObjects(data.bookingAddons);
                })
            ];
        });
    }),
    useObject: function(id) {
        var includes = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        // eslint-disable-next-line react-hooks/exhaustive-deps
        var variables = (0,react.useMemo)(function() {
            return (0,_object_spread/* default */.Z)({
                id: id
            }, includes);
        }, [
            id
        ]);
        var ref = (0,dist/* default */.ZP)([
            SINGLE_BOOKING_ADDON_QUERY,
            variables
        ], {
            revalidateOnFocus: false
        }), data = ref.data, error = ref.error, mutate = ref.mutate;
        return {
            object: !data ? data : hydrateObject(data.bookingAddon),
            isLoading: !error && !data,
            isError: error,
            mutate: mutate
        };
    },
    useObjects: function() {
        var includes = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        // eslint-disable-next-line react-hooks/exhaustive-deps
        var variables = (0,react.useMemo)(function() {
            return includes;
        }, []);
        var ref = (0,dist/* default */.ZP)([
            ALL_BOOKING_ADDONS_QUERY,
            variables
        ]), data = ref.data, error = ref.error, mutate = ref.mutate;
        return {
            objects: !data ? data : hydrateObjects(data.bookingAddons),
            isLoading: !error && !data,
            isError: error,
            mutate: mutate
        };
    },
    getDependents: function(id, includes) {
        var includeVars = {};
        includes.forEach(function(include) {
            includeVars["with".concat((0,helpers/* uppercaseFirst */.AB)(include))] = true;
        });
        var variables = (0,_object_spread/* default */.Z)({
            id: id
        }, includeVars);
        return graphQLClient/* default.request */.Z.request(BOOKING_ADDONS_DEPENDENTS_QUERY, variables).then(function(data) {
            return data.groupedDependents;
        });
    },
    useDependents: function(id, includes) {
        var includeVars = {};
        includes.forEach(function(include) {
            includeVars["with".concat((0,helpers/* uppercaseFirst */.AB)(include))] = true;
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
        var variables = (0,react.useMemo)(function() {
            return (0,_object_spread/* default */.Z)({
                id: id
            }, includeVars);
        }, [
            id
        ]);
        var ref = (0,dist/* default */.ZP)([
            BOOKING_ADDONS_DEPENDENTS_QUERY,
            variables
        ], {
            revalidateOnFocus: false
        }), data = ref.data, error = ref.error, mutate = ref.mutate;
        return {
            data: !data ? data : data.groupedDependents,
            isLoading: !error && !data,
            isError: error,
            mutate: mutate
        };
    },
    createObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(data) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    input: data
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(CREATE_BOOKING_ADDON_MUTATION, variables).then(function(data) {
                        return hydrateObject(data.bookingAddon);
                    })
                ];
            });
        });
        return function(data) {
            return _ref.apply(this, arguments);
        };
    }(),
    updateObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(data) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    input: data
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(UPDATE_BOOKING_ADDON_MUTATION, variables).then(function(data) {
                        return hydrateObject(data.bookingAddon);
                    })
                ];
            });
        });
        return function(data) {
            return _ref.apply(this, arguments);
        };
    }(),
    deleteObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(DELETE_BOOKING_ADDON_MUTATION, variables).then(function(data) {
                        return data.deleteRatioBookingAddon;
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }(),
    forceDeleteObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(FORCE_DELETE_BOOKING_ADDON_MUTATION, variables).then(function(data) {
                        return data.forceDeleteRatioBookingAddon;
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }()
};
/* harmony default export */ var repository = (ratioBookingAddonRepository);

;// CONCATENATED MODULE: ./src/entities/ratioBookingAddon/entity.ts


var ratioBookingAddonEntity = {
    model: model,
    repository: repository
};
/* harmony default export */ var ratioBookingAddon_entity = (ratioBookingAddonEntity);


/***/ }),

/***/ 54371:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ entity; }
});

;// CONCATENATED MODULE: ./src/entities/ratioCatalogBundle/graphql.ts
// language=GraphQL
var ALL_RATIO_CATALOG_BUNDLES_QUERY = "query Query {\n  ratioCatalogBundles: ratioCatalogBundles {\n    id\n    catalogCode\n    travelCode\n    json\n  }\n}";
// language=GraphQL
var SINGLE_RATIO_CATALOG_BUNDLE_QUERY = "query Query($id: ID!) {\n  ratioCatalogBundle: ratioCatalogBundle(id: $id) {\n    id\n    catalogCode\n    travelCode\n    json\n  }\n}";
// language=GraphQL
var CREATE_RATIO_CATALOG_BUNDLE_MUTATION = "\n  mutation Mutation($input: CreateRatioCatalogBundleInput) {\n    ratioCatalogBundle: createRatioCatalogBundle(input: $input) {\n      id\n      catalogCode\n      travelCode\n      json\n    }\n  }";
// language=GraphQL
var UPDATE_RATIO_CATALOG_BUNDLE_MUTATION = "\n  mutation Mutation($input: UpdateRatioCatalogBundleInput) {\n    ratioCatalogBundle: updateRatioCatalogBundle(input: $input) {\n      id\n      catalogCode\n      travelCode\n      json\n    }\n  }";
// language=GraphQL
var DELETE_RATIO_CATALOG_BUNDLE_MUTATION = "\n  mutation Mutation($input: DeleteRatioCatalogBundleInput) {\n    deleteRatioCatalogBundle(input: $input) {\n      success\n    }\n  }";
// language=GraphQL
var FORCE_DELETE_RATIO_CATALOG_BUNDLE_MUTATION = "\n  mutation Mutation($input: DeleteRatioCatalogBundleInput) {\n    forceDeleteRatioCatalogBundle(input: $input) {\n      success\n    }\n  }";
// language=GraphQL
var RATIO_CATALOG_BUNDLES_DEPENDENTS_QUERY = "query Query($id: ID!, $withRatioTravels: Boolean = false) {\n  groupedDependents: ratioCatalogBundleDependents(id: $id) {\n    ratioTravels @include(if: $withRatioTravels) {\n      id\n      catalogCode\n      travelCode\n      destination\n      name\n      transportType\n      transportTypeLabel\n      importDateTime\n      importStatus    }\n  }\n}";

;// CONCATENATED MODULE: ./src/entities/ratioCatalogBundle/model.ts

var ratioCatalogBundleModel = {
    name: "ratioCatalogBundle",
    namePlural: "ratioCatalogBundles",
    uniqueName: "ratioCatalogBundle",
    uniqueNamePlural: "ratioCatalogBundles",
    path: "travel/pricing/adaptors/ratio/ratio_catalog_bundle",
    baseUrl: "/travel/pricing/adaptors/ratio/ratio_catalog_bundles",
    translationPrefix: "entities:ratioCatalogBundle.",
    getDisplayName: function(values) {
        return "Ratio Catalog Bundle";
    },
    gql: {
        getAll: ALL_RATIO_CATALOG_BUNDLES_QUERY,
        getSingle: SINGLE_RATIO_CATALOG_BUNDLE_QUERY,
        create: CREATE_RATIO_CATALOG_BUNDLE_MUTATION,
        update: UPDATE_RATIO_CATALOG_BUNDLE_MUTATION,
        delete: DELETE_RATIO_CATALOG_BUNDLE_MUTATION,
        forceDelete: FORCE_DELETE_RATIO_CATALOG_BUNDLE_MUTATION
    },
    attributes: {
        catalogCode: {
            name: "catalogCode",
            label: "entities:ratioCatalogBundle.attributes.catalogCode.label",
            type: "value",
            dataType: "string",
            defaultInput: true,
            inputType: "text",
            validationType: "string",
            validations: [
                {
                    type: "required"
                }, 
            ]
        },
        travelCode: {
            name: "travelCode",
            label: "entities:ratioCatalogBundle.attributes.travelCode.label",
            type: "value",
            dataType: "string",
            defaultInput: true,
            inputType: "text",
            validationType: "string",
            validations: [
                {
                    type: "required"
                }, 
            ]
        },
        json: {
            name: "json",
            label: "entities:ratioCatalogBundle.attributes.json.label",
            type: "value",
            dataType: "{ [x: string]: any }",
            defaultInput: false,
            inputType: "text",
            validationType: "string",
            validations: []
        }
    }
};
/* harmony default export */ var model = (ratioCatalogBundleModel);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(20414);
// EXTERNAL MODULE: ./src/entities/lib.ts
var lib = __webpack_require__(23480);
// EXTERNAL MODULE: ./src/lib/api/graphQLClient.ts
var graphQLClient = __webpack_require__(40112);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/swr/dist/index.mjs
var dist = __webpack_require__(8100);
// EXTERNAL MODULE: ./src/lib/helpers/helpers.ts
var helpers = __webpack_require__(15778);
;// CONCATENATED MODULE: ./src/entities/ratioCatalogBundle/repository.ts










var hydrateObjects = function(objects) {
    return objects.map(function(object) {
        return (0,lib/* hydrateEntityObject */.b)(model, object);
    });
};
var hydrateObject = function(object) {
    return (0,lib/* hydrateEntityObject */.b)(model, object);
};
var ratioCatalogBundleRepository = {
    getObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    id: id
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(SINGLE_RATIO_CATALOG_BUNDLE_QUERY, variables).then(function(data) {
                        return hydrateObject(data.ratioCatalogBundle);
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }(),
    getObjects: /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        var includes;
        var _arguments = arguments;
        return (0,tslib_es6.__generator)(this, function(_state) {
            includes = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : {};
            return [
                2,
                graphQLClient/* default.request */.Z.request(ALL_RATIO_CATALOG_BUNDLES_QUERY, includes).then(function(data) {
                    return hydrateObjects(data.ratioCatalogBundles);
                })
            ];
        });
    }),
    useObject: function(id) {
        var includes = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        // eslint-disable-next-line react-hooks/exhaustive-deps
        var variables = (0,react.useMemo)(function() {
            return (0,_object_spread/* default */.Z)({
                id: id
            }, includes);
        }, [
            id
        ]);
        var ref = (0,dist/* default */.ZP)([
            SINGLE_RATIO_CATALOG_BUNDLE_QUERY,
            variables
        ], {
            revalidateOnFocus: false
        }), data = ref.data, error = ref.error, mutate = ref.mutate;
        return {
            object: !data ? data : hydrateObject(data.ratioCatalogBundle),
            isLoading: !error && !data,
            isError: error,
            mutate: mutate
        };
    },
    useObjects: function() {
        var includes = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        // eslint-disable-next-line react-hooks/exhaustive-deps
        var variables = (0,react.useMemo)(function() {
            return includes;
        }, []);
        var ref = (0,dist/* default */.ZP)([
            ALL_RATIO_CATALOG_BUNDLES_QUERY,
            variables
        ]), data = ref.data, error = ref.error, mutate = ref.mutate;
        return {
            objects: !data ? data : hydrateObjects(data.ratioCatalogBundles),
            isLoading: !error && !data,
            isError: error,
            mutate: mutate
        };
    },
    getDependents: function(id, includes) {
        var includeVars = {};
        includes.forEach(function(include) {
            includeVars["with".concat((0,helpers/* uppercaseFirst */.AB)(include))] = true;
        });
        var variables = (0,_object_spread/* default */.Z)({
            id: id
        }, includeVars);
        return graphQLClient/* default.request */.Z.request(RATIO_CATALOG_BUNDLES_DEPENDENTS_QUERY, variables).then(function(data) {
            return data.groupedDependents;
        });
    },
    useDependents: function(id, includes) {
        var includeVars = {};
        includes.forEach(function(include) {
            includeVars["with".concat((0,helpers/* uppercaseFirst */.AB)(include))] = true;
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
        var variables = (0,react.useMemo)(function() {
            return (0,_object_spread/* default */.Z)({
                id: id
            }, includeVars);
        }, [
            id
        ]);
        var ref = (0,dist/* default */.ZP)([
            RATIO_CATALOG_BUNDLES_DEPENDENTS_QUERY,
            variables
        ], {
            revalidateOnFocus: false
        }), data = ref.data, error = ref.error, mutate = ref.mutate;
        return {
            data: !data ? data : data.groupedDependents,
            isLoading: !error && !data,
            isError: error,
            mutate: mutate
        };
    },
    createObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(data) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    input: data
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(CREATE_RATIO_CATALOG_BUNDLE_MUTATION, variables).then(function(data) {
                        return hydrateObject(data.ratioCatalogBundle);
                    })
                ];
            });
        });
        return function(data) {
            return _ref.apply(this, arguments);
        };
    }(),
    updateObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(data) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    input: data
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(UPDATE_RATIO_CATALOG_BUNDLE_MUTATION, variables).then(function(data) {
                        return hydrateObject(data.ratioCatalogBundle);
                    })
                ];
            });
        });
        return function(data) {
            return _ref.apply(this, arguments);
        };
    }(),
    deleteObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(DELETE_RATIO_CATALOG_BUNDLE_MUTATION, variables).then(function(data) {
                        return data.deleteRatioCatalogBundle;
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }(),
    forceDeleteObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(FORCE_DELETE_RATIO_CATALOG_BUNDLE_MUTATION, variables).then(function(data) {
                        return data.forceDeleteRatioCatalogBundle;
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }()
};
/* harmony default export */ var repository = (ratioCatalogBundleRepository);

;// CONCATENATED MODULE: ./src/entities/ratioCatalogBundle/entity.ts


var ratioCatalogBundleEntity = {
    model: model,
    repository: repository
};
/* harmony default export */ var entity = (ratioCatalogBundleEntity);


/***/ }),

/***/ 60826:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ ratioCollectiveAddon_entity; }
});

;// CONCATENATED MODULE: ./src/entities/ratioCollectiveAddon/graphql.ts
// language=GraphQL
var ALL_COLLECTIVE_ADDONS_QUERY = "query Query($withAgeGroupServices: Boolean = false, $withAgeGroupServicesAgeGroup: Boolean = false, $withCalculationSettings: Boolean = false, $withMandatorySettings: Boolean = false, $withMandatorySettingsRules: Boolean = false, $withMandatorySettingsRulesAccommodations: Boolean = false, $withMandatorySettingsRulesFamilyPackages: Boolean = false, $withMandatorySettingsRulesAccommodationAddons: Boolean = false, $withMandatorySettingsRulesAgeGroups: Boolean = false, $withMandatorySettingsRulesAgeFilter: Boolean = false, $withMandatorySettingsRulesTravelDates: Boolean = false) {\n  collectiveAddons: ratioCollectiveAddons {\n    id\n    label\n    info\n    ageGroupServices @include(if: $withAgeGroupServices) {\n      id\n      ageGroup @include(if: $withAgeGroupServicesAgeGroup) {\n        id\n        name\n        type\n        icon\n        minAge\n        maxAge\n      }\n      ratioServiceNo\n    }\n    calculationSettings @include(if: $withCalculationSettings) {\n      id\n      type\n      considerHotelNights\n    }\n    mandatorySettings @include(if: $withMandatorySettings) {\n      id\n      isMandatory\n      useRules\n      rules @include(if: $withMandatorySettingsRules) {\n        id\n        checkAccommodationTypes\n        accommodations @include(if: $withMandatorySettingsRulesAccommodations) {\n          id\n          ratioPackageNo\n          name\n          label\n          info\n          isFamilyPackageAccommodation\n          isBabyPackage\n        }\n        familyPackages @include(if: $withMandatorySettingsRulesFamilyPackages) {\n          id\n          ratioServiceNo\n          name\n          label\n          info\n        }\n        checkAccommodationAddons\n        accommodationAddons @include(if: $withMandatorySettingsRulesAccommodationAddons) {\n          id\n          ratioServiceNo\n          name\n          label\n          info\n        }\n        checkAgeGroups\n        ageGroups @include(if: $withMandatorySettingsRulesAgeGroups) {\n          id\n          name\n          type\n          icon\n          minAge\n          maxAge\n        }\n        useAgeFilter\n        ageFilter @include(if: $withMandatorySettingsRulesAgeFilter) {\n          id\n          minAge\n          maxAge\n        }\n        checkDateRange\n        startDate\n        endDate\n        checkTravelDate\n        travelDates @include(if: $withMandatorySettingsRulesTravelDates) {\n          id\n          dateNo\n          startDate\n          endDate\n          includesExtension\n          json\n        }\n      }\n    }\n  }\n}";
// language=GraphQL
var SINGLE_COLLECTIVE_ADDON_QUERY = "query Query($id: ID!, $withAgeGroupServices: Boolean = false, $withAgeGroupServicesAgeGroup: Boolean = false, $withCalculationSettings: Boolean = false, $withMandatorySettings: Boolean = false, $withMandatorySettingsRules: Boolean = false, $withMandatorySettingsRulesAccommodations: Boolean = false, $withMandatorySettingsRulesFamilyPackages: Boolean = false, $withMandatorySettingsRulesAccommodationAddons: Boolean = false, $withMandatorySettingsRulesAgeGroups: Boolean = false, $withMandatorySettingsRulesAgeFilter: Boolean = false, $withMandatorySettingsRulesTravelDates: Boolean = false) {\n  collectiveAddon: ratioCollectiveAddon(id: $id) {\n    id\n    label\n    info\n    ageGroupServices @include(if: $withAgeGroupServices) {\n      id\n      ageGroup @include(if: $withAgeGroupServicesAgeGroup) {\n        id\n        name\n        type\n        icon\n        minAge\n        maxAge\n      }\n      ratioServiceNo\n    }\n    calculationSettings @include(if: $withCalculationSettings) {\n      id\n      type\n      considerHotelNights\n    }\n    mandatorySettings @include(if: $withMandatorySettings) {\n      id\n      isMandatory\n      useRules\n      rules @include(if: $withMandatorySettingsRules) {\n        id\n        checkAccommodationTypes\n        accommodations @include(if: $withMandatorySettingsRulesAccommodations) {\n          id\n          ratioPackageNo\n          name\n          label\n          info\n          isFamilyPackageAccommodation\n          isBabyPackage\n        }\n        familyPackages @include(if: $withMandatorySettingsRulesFamilyPackages) {\n          id\n          ratioServiceNo\n          name\n          label\n          info\n        }\n        checkAccommodationAddons\n        accommodationAddons @include(if: $withMandatorySettingsRulesAccommodationAddons) {\n          id\n          ratioServiceNo\n          name\n          label\n          info\n        }\n        checkAgeGroups\n        ageGroups @include(if: $withMandatorySettingsRulesAgeGroups) {\n          id\n          name\n          type\n          icon\n          minAge\n          maxAge\n        }\n        useAgeFilter\n        ageFilter @include(if: $withMandatorySettingsRulesAgeFilter) {\n          id\n          minAge\n          maxAge\n        }\n        checkDateRange\n        startDate\n        endDate\n        checkTravelDate\n        travelDates @include(if: $withMandatorySettingsRulesTravelDates) {\n          id\n          dateNo\n          startDate\n          endDate\n          includesExtension\n          json\n        }\n      }\n    }\n  }\n}";
// language=GraphQL
var CREATE_COLLECTIVE_ADDON_MUTATION = "\n  mutation Mutation($input: CreateRatioCollectiveAddonInput, $withAgeGroupServices: Boolean = false, $withAgeGroupServicesAgeGroup: Boolean = false, $withCalculationSettings: Boolean = false, $withMandatorySettings: Boolean = false, $withMandatorySettingsRules: Boolean = false, $withMandatorySettingsRulesAccommodations: Boolean = false, $withMandatorySettingsRulesFamilyPackages: Boolean = false, $withMandatorySettingsRulesAccommodationAddons: Boolean = false, $withMandatorySettingsRulesAgeGroups: Boolean = false, $withMandatorySettingsRulesAgeFilter: Boolean = false, $withMandatorySettingsRulesTravelDates: Boolean = false) {\n    collectiveAddon: createRatioCollectiveAddon(input: $input) {\n      id\n      label\n      info\n      ageGroupServices @include(if: $withAgeGroupServices) {\n        id\n        ageGroup @include(if: $withAgeGroupServicesAgeGroup) {\n          id\n          name\n          type\n          icon\n          minAge\n          maxAge\n        }\n        ratioServiceNo\n      }\n      calculationSettings @include(if: $withCalculationSettings) {\n        id\n        type\n        considerHotelNights\n      }\n      mandatorySettings @include(if: $withMandatorySettings) {\n        id\n        isMandatory\n        useRules\n        rules @include(if: $withMandatorySettingsRules) {\n          id\n          checkAccommodationTypes\n          accommodations @include(if: $withMandatorySettingsRulesAccommodations) {\n            id\n            ratioPackageNo\n            name\n            label\n            info\n            isFamilyPackageAccommodation\n            isBabyPackage\n          }\n          familyPackages @include(if: $withMandatorySettingsRulesFamilyPackages) {\n            id\n            ratioServiceNo\n            name\n            label\n            info\n          }\n          checkAccommodationAddons\n          accommodationAddons @include(if: $withMandatorySettingsRulesAccommodationAddons) {\n            id\n            ratioServiceNo\n            name\n            label\n            info\n          }\n          checkAgeGroups\n          ageGroups @include(if: $withMandatorySettingsRulesAgeGroups) {\n            id\n            name\n            type\n            icon\n            minAge\n            maxAge\n          }\n          useAgeFilter\n          ageFilter @include(if: $withMandatorySettingsRulesAgeFilter) {\n            id\n            minAge\n            maxAge\n          }\n          checkDateRange\n          startDate\n          endDate\n          checkTravelDate\n          travelDates @include(if: $withMandatorySettingsRulesTravelDates) {\n            id\n            dateNo\n            startDate\n            endDate\n            includesExtension\n            json\n          }\n        }\n      }\n    }\n  }";
// language=GraphQL
var UPDATE_COLLECTIVE_ADDON_MUTATION = "\n  mutation Mutation($input: UpdateRatioCollectiveAddonInput, $withAgeGroupServices: Boolean = false, $withAgeGroupServicesAgeGroup: Boolean = false, $withCalculationSettings: Boolean = false, $withMandatorySettings: Boolean = false, $withMandatorySettingsRules: Boolean = false, $withMandatorySettingsRulesAccommodations: Boolean = false, $withMandatorySettingsRulesFamilyPackages: Boolean = false, $withMandatorySettingsRulesAccommodationAddons: Boolean = false, $withMandatorySettingsRulesAgeGroups: Boolean = false, $withMandatorySettingsRulesAgeFilter: Boolean = false, $withMandatorySettingsRulesTravelDates: Boolean = false) {\n    collectiveAddon: updateRatioCollectiveAddon(input: $input) {\n      id\n      label\n      info\n      ageGroupServices @include(if: $withAgeGroupServices) {\n        id\n        ageGroup @include(if: $withAgeGroupServicesAgeGroup) {\n          id\n          name\n          type\n          icon\n          minAge\n          maxAge\n        }\n        ratioServiceNo\n      }\n      calculationSettings @include(if: $withCalculationSettings) {\n        id\n        type\n        considerHotelNights\n      }\n      mandatorySettings @include(if: $withMandatorySettings) {\n        id\n        isMandatory\n        useRules\n        rules @include(if: $withMandatorySettingsRules) {\n          id\n          checkAccommodationTypes\n          accommodations @include(if: $withMandatorySettingsRulesAccommodations) {\n            id\n            ratioPackageNo\n            name\n            label\n            info\n            isFamilyPackageAccommodation\n            isBabyPackage\n          }\n          familyPackages @include(if: $withMandatorySettingsRulesFamilyPackages) {\n            id\n            ratioServiceNo\n            name\n            label\n            info\n          }\n          checkAccommodationAddons\n          accommodationAddons @include(if: $withMandatorySettingsRulesAccommodationAddons) {\n            id\n            ratioServiceNo\n            name\n            label\n            info\n          }\n          checkAgeGroups\n          ageGroups @include(if: $withMandatorySettingsRulesAgeGroups) {\n            id\n            name\n            type\n            icon\n            minAge\n            maxAge\n          }\n          useAgeFilter\n          ageFilter @include(if: $withMandatorySettingsRulesAgeFilter) {\n            id\n            minAge\n            maxAge\n          }\n          checkDateRange\n          startDate\n          endDate\n          checkTravelDate\n          travelDates @include(if: $withMandatorySettingsRulesTravelDates) {\n            id\n            dateNo\n            startDate\n            endDate\n            includesExtension\n            json\n          }\n        }\n      }\n    }\n  }";
// language=GraphQL
var DELETE_COLLECTIVE_ADDON_MUTATION = "\n  mutation Mutation($input: DeleteRatioCollectiveAddonInput) {\n    deleteRatioCollectiveAddon(input: $input) {\n      success\n    }\n  }";
// language=GraphQL
var FORCE_DELETE_COLLECTIVE_ADDON_MUTATION = "\n  mutation Mutation($input: DeleteRatioCollectiveAddonInput) {\n    forceDeleteRatioCollectiveAddon(input: $input) {\n      success\n    }\n  }";
// language=GraphQL
var ADD_COLLECTIVE_ADDON_AGE_GROUP_SERVICES_MUTATION = "\n  mutation Mutation($input: addRatioCollectiveAddonAgeGroupServicesInput) {\n    addRatioCollectiveAddonAgeGroupServices(input: $input) {\n      id\n      ageGroupServiceIds\n    }\n  }";
// language=GraphQL
var REMOVE_COLLECTIVE_ADDON_AGE_GROUP_SERVICES_MUTATION = "\n  mutation Mutation($input: removeRatioCollectiveAddonAgeGroupServicesInput) {\n    removeRatioCollectiveAddonAgeGroupServices(input: $input) {\n      id\n      ageGroupServiceIds\n    }\n  }";
// language=GraphQL
var CREATE_COLLECTIVE_ADDON_AGE_GROUP_SERVICES_MUTATION = "\n  mutation Mutation($input: createRatioCollectiveAddonAgeGroupServicesInput) {\n    createRatioCollectiveAddonAgeGroupServices(input: $input) {\n      id\n      ageGroupServiceIds\n    }\n  }";
// language=GraphQL
var DELETE_COLLECTIVE_ADDON_AGE_GROUP_SERVICES_MUTATION = "\n  mutation Mutation($input: deleteRatioCollectiveAddonAgeGroupServicesInput) {\n    deleteRatioCollectiveAddonAgeGroupServices(input: $input) {\n      id\n      ageGroupServiceIds\n    }\n  }";
// language=GraphQL
var COLLECTIVE_ADDONS_DEPENDENTS_QUERY = "query Query($id: ID!, $withRatioTravels: Boolean = false) {\n  groupedDependents: ratioCollectiveAddonDependents(id: $id) {\n    ratioTravels @include(if: $withRatioTravels) {\n      id\n      catalogCode\n      travelCode\n      destination\n      name\n      transportType\n      transportTypeLabel\n      importDateTime\n      importStatus    }\n  }\n}";

// EXTERNAL MODULE: ./src/entities/ratioAgeGroupService/entity.ts + 3 modules
var entity = __webpack_require__(21996);
// EXTERNAL MODULE: ./src/entities/travelPricingServiceCalculationSettings/entity.ts + 3 modules
var travelPricingServiceCalculationSettings_entity = __webpack_require__(49005);
// EXTERNAL MODULE: ./src/entities/travelPricingMandatorySettings/entity.ts + 3 modules
var travelPricingMandatorySettings_entity = __webpack_require__(28967);
;// CONCATENATED MODULE: ./src/entities/ratioCollectiveAddon/model.ts




var ratioCollectiveAddonModel = {
    name: "collectiveAddon",
    namePlural: "collectiveAddons",
    uniqueName: "ratioCollectiveAddon",
    uniqueNamePlural: "ratioCollectiveAddons",
    path: "travel/pricing/adaptors/ratio/collective_addon",
    baseUrl: "/travel/pricing/adaptors/ratio/collective_addons",
    translationPrefix: "entities:ratioCollectiveAddon.",
    getDisplayName: function(values) {
        return values.label;
    },
    gql: {
        getAll: ALL_COLLECTIVE_ADDONS_QUERY,
        getSingle: SINGLE_COLLECTIVE_ADDON_QUERY,
        create: CREATE_COLLECTIVE_ADDON_MUTATION,
        update: UPDATE_COLLECTIVE_ADDON_MUTATION,
        delete: DELETE_COLLECTIVE_ADDON_MUTATION,
        forceDelete: FORCE_DELETE_COLLECTIVE_ADDON_MUTATION
    },
    attributes: {
        label: {
            name: "label",
            label: "entities:ratioCollectiveAddon.attributes.label.label",
            type: "value",
            dataType: "string",
            defaultInput: true,
            inputType: "text",
            validationType: "string",
            validations: [
                {
                    type: "required"
                }, 
            ]
        },
        info: {
            name: "info",
            label: "entities:ratioCollectiveAddon.attributes.info.label",
            type: "value",
            dataType: "string",
            defaultInput: true,
            inputType: "textarea",
            maxLength: 255,
            validationType: "string",
            validations: []
        },
        ageGroupServices: {
            name: "ageGroupServices",
            label: "entities:ratioCollectiveAddon.attributes.ageGroupServices.label",
            type: "entityCollection",
            dataType: "[any]",
            getEntity: function() {
                return entity/* default */.Z;
            },
            defaultInput: false,
            inputType: "text",
            validationType: "string",
            validations: []
        },
        calculationSettings: {
            name: "calculationSettings",
            label: "entities:ratioCollectiveAddon.attributes.calculationSettings.label",
            type: "entityObject",
            dataType: "any",
            getEntity: function() {
                return travelPricingServiceCalculationSettings_entity/* default */.Z;
            },
            defaultInput: false,
            inputType: "select",
            validationType: "string",
            validations: []
        },
        mandatorySettings: {
            name: "mandatorySettings",
            label: "entities:ratioCollectiveAddon.attributes.mandatorySettings.label",
            type: "entityObject",
            dataType: "any",
            getEntity: function() {
                return travelPricingMandatorySettings_entity/* default */.Z;
            },
            defaultInput: false,
            inputType: "select",
            validationType: "string",
            validations: []
        }
    }
};
/* harmony default export */ var model = (ratioCollectiveAddonModel);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(20414);
// EXTERNAL MODULE: ./src/entities/lib.ts
var lib = __webpack_require__(23480);
// EXTERNAL MODULE: ./src/lib/api/graphQLClient.ts
var graphQLClient = __webpack_require__(40112);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/swr/dist/index.mjs
var dist = __webpack_require__(8100);
// EXTERNAL MODULE: ./src/lib/helpers/helpers.ts
var helpers = __webpack_require__(15778);
;// CONCATENATED MODULE: ./src/entities/ratioCollectiveAddon/repository.ts










var hydrateObjects = function(objects) {
    return objects.map(function(object) {
        return (0,lib/* hydrateEntityObject */.b)(model, object);
    });
};
var hydrateObject = function(object) {
    return (0,lib/* hydrateEntityObject */.b)(model, object);
};
var ratioCollectiveAddonRepository = {
    getObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    id: id
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(SINGLE_COLLECTIVE_ADDON_QUERY, variables).then(function(data) {
                        return hydrateObject(data.collectiveAddon);
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }(),
    getObjects: /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        var includes;
        var _arguments = arguments;
        return (0,tslib_es6.__generator)(this, function(_state) {
            includes = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : {};
            return [
                2,
                graphQLClient/* default.request */.Z.request(ALL_COLLECTIVE_ADDONS_QUERY, includes).then(function(data) {
                    return hydrateObjects(data.collectiveAddons);
                })
            ];
        });
    }),
    useObject: function(id) {
        var includes = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        // eslint-disable-next-line react-hooks/exhaustive-deps
        var variables = (0,react.useMemo)(function() {
            return (0,_object_spread/* default */.Z)({
                id: id
            }, includes);
        }, [
            id
        ]);
        var ref = (0,dist/* default */.ZP)([
            SINGLE_COLLECTIVE_ADDON_QUERY,
            variables
        ], {
            revalidateOnFocus: false
        }), data = ref.data, error = ref.error, mutate = ref.mutate;
        return {
            object: !data ? data : hydrateObject(data.collectiveAddon),
            isLoading: !error && !data,
            isError: error,
            mutate: mutate
        };
    },
    useObjects: function() {
        var includes = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        // eslint-disable-next-line react-hooks/exhaustive-deps
        var variables = (0,react.useMemo)(function() {
            return includes;
        }, []);
        var ref = (0,dist/* default */.ZP)([
            ALL_COLLECTIVE_ADDONS_QUERY,
            variables
        ]), data = ref.data, error = ref.error, mutate = ref.mutate;
        return {
            objects: !data ? data : hydrateObjects(data.collectiveAddons),
            isLoading: !error && !data,
            isError: error,
            mutate: mutate
        };
    },
    getDependents: function(id, includes) {
        var includeVars = {};
        includes.forEach(function(include) {
            includeVars["with".concat((0,helpers/* uppercaseFirst */.AB)(include))] = true;
        });
        var variables = (0,_object_spread/* default */.Z)({
            id: id
        }, includeVars);
        return graphQLClient/* default.request */.Z.request(COLLECTIVE_ADDONS_DEPENDENTS_QUERY, variables).then(function(data) {
            return data.groupedDependents;
        });
    },
    useDependents: function(id, includes) {
        var includeVars = {};
        includes.forEach(function(include) {
            includeVars["with".concat((0,helpers/* uppercaseFirst */.AB)(include))] = true;
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
        var variables = (0,react.useMemo)(function() {
            return (0,_object_spread/* default */.Z)({
                id: id
            }, includeVars);
        }, [
            id
        ]);
        var ref = (0,dist/* default */.ZP)([
            COLLECTIVE_ADDONS_DEPENDENTS_QUERY,
            variables
        ], {
            revalidateOnFocus: false
        }), data = ref.data, error = ref.error, mutate = ref.mutate;
        return {
            data: !data ? data : data.groupedDependents,
            isLoading: !error && !data,
            isError: error,
            mutate: mutate
        };
    },
    createObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(data) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    input: data
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(CREATE_COLLECTIVE_ADDON_MUTATION, variables).then(function(data) {
                        return hydrateObject(data.collectiveAddon);
                    })
                ];
            });
        });
        return function(data) {
            return _ref.apply(this, arguments);
        };
    }(),
    updateObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(data) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    input: data
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(UPDATE_COLLECTIVE_ADDON_MUTATION, variables).then(function(data) {
                        return hydrateObject(data.collectiveAddon);
                    })
                ];
            });
        });
        return function(data) {
            return _ref.apply(this, arguments);
        };
    }(),
    deleteObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(DELETE_COLLECTIVE_ADDON_MUTATION, variables).then(function(data) {
                        return data.deleteRatioCollectiveAddon;
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }(),
    forceDeleteObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(FORCE_DELETE_COLLECTIVE_ADDON_MUTATION, variables).then(function(data) {
                        return data.forceDeleteRatioCollectiveAddon;
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }(),
    assignAgeGroupServices: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, itemIds) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        ageGroupServiceIds: itemIds
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(ADD_COLLECTIVE_ADDON_AGE_GROUP_SERVICES_MUTATION, variables)
                ];
            });
        });
        return function(id, itemIds) {
            return _ref.apply(this, arguments);
        };
    }(),
    unassignAgeGroupServices: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, itemIds) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        ageGroupServiceIds: itemIds
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(REMOVE_COLLECTIVE_ADDON_AGE_GROUP_SERVICES_MUTATION, variables)
                ];
            });
        });
        return function(id, itemIds) {
            return _ref.apply(this, arguments);
        };
    }(),
    createAgeGroupServices: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, items) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        ageGroupServices: items
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(CREATE_COLLECTIVE_ADDON_AGE_GROUP_SERVICES_MUTATION, variables)
                ];
            });
        });
        return function(id, items) {
            return _ref.apply(this, arguments);
        };
    }(),
    deleteAgeGroupServices: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, itemIds) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        ageGroupServiceIds: itemIds
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(DELETE_COLLECTIVE_ADDON_AGE_GROUP_SERVICES_MUTATION, variables)
                ];
            });
        });
        return function(id, itemIds) {
            return _ref.apply(this, arguments);
        };
    }()
};
/* harmony default export */ var repository = (ratioCollectiveAddonRepository);

;// CONCATENATED MODULE: ./src/entities/ratioCollectiveAddon/entity.ts


var ratioCollectiveAddonEntity = {
    model: model,
    repository: repository
};
/* harmony default export */ var ratioCollectiveAddon_entity = (ratioCollectiveAddonEntity);


/***/ }),

/***/ 81882:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ entity; }
});

;// CONCATENATED MODULE: ./src/entities/ratioDatePackageSettings/graphql.ts
// language=GraphQL
var ALL_DATE_PACKAGE_SETTINGS_QUERY = "query Query {\n  datePackageSettings: allRatioDatePackageSettings {\n    id\n    ratioPackageNo\n    price\n    availabilityStatus\n  }\n}";
// language=GraphQL
var SINGLE_DATE_PACKAGE_SETTINGS_QUERY = "query Query($id: ID!) {\n  datePackageSettings: ratioDatePackageSettings(id: $id) {\n    id\n    ratioPackageNo\n    price\n    availabilityStatus\n  }\n}";
// language=GraphQL
var CREATE_DATE_PACKAGE_SETTINGS_MUTATION = "\n  mutation Mutation($input: CreateRatioDatePackageSettingsInput) {\n    datePackageSettings: createRatioDatePackageSettings(input: $input) {\n      id\n      ratioPackageNo\n      price\n      availabilityStatus\n    }\n  }";
// language=GraphQL
var UPDATE_DATE_PACKAGE_SETTINGS_MUTATION = "\n  mutation Mutation($input: UpdateRatioDatePackageSettingsInput) {\n    datePackageSettings: updateRatioDatePackageSettings(input: $input) {\n      id\n      ratioPackageNo\n      price\n      availabilityStatus\n    }\n  }";
// language=GraphQL
var DELETE_DATE_PACKAGE_SETTINGS_MUTATION = "\n  mutation Mutation($input: DeleteRatioDatePackageSettingsInput) {\n    deleteRatioDatePackageSettings(input: $input) {\n      success\n    }\n  }";
// language=GraphQL
var FORCE_DELETE_DATE_PACKAGE_SETTINGS_MUTATION = "\n  mutation Mutation($input: DeleteRatioDatePackageSettingsInput) {\n    forceDeleteRatioDatePackageSettings(input: $input) {\n      success\n    }\n  }";
// language=GraphQL
var DATE_PACKAGE_SETTINGS_DEPENDENTS_QUERY = "query Query($id: ID!, $withRatioTravelDates: Boolean = false) {\n  groupedDependents: ratioDatePackageSettingsDependents(id: $id) {\n    ratioTravelDates @include(if: $withRatioTravelDates) {\n      id\n      dateNo\n      startDate\n      endDate\n      includesExtension\n      json\n    }\n  }\n}";

;// CONCATENATED MODULE: ./src/entities/ratioDatePackageSettings/model.ts

var ratioDatePackageSettingsModel = {
    name: "datePackageSettings",
    namePlural: "datePackageSettings",
    uniqueName: "ratioDatePackageSettings",
    uniqueNamePlural: "ratioDatePackageSettings",
    path: "travel/pricing/adaptors/ratio/date_package_settings",
    baseUrl: "/travel/pricing/adaptors/ratio/date_package_settings",
    translationPrefix: "entities:ratioDatePackageSettings.",
    getDisplayName: function(values) {
        return "Ratio Date Package Settings";
    },
    gql: {
        getAll: ALL_DATE_PACKAGE_SETTINGS_QUERY,
        getSingle: SINGLE_DATE_PACKAGE_SETTINGS_QUERY,
        create: CREATE_DATE_PACKAGE_SETTINGS_MUTATION,
        update: UPDATE_DATE_PACKAGE_SETTINGS_MUTATION,
        delete: DELETE_DATE_PACKAGE_SETTINGS_MUTATION,
        forceDelete: FORCE_DELETE_DATE_PACKAGE_SETTINGS_MUTATION
    },
    attributes: {
        ratioPackageNo: {
            name: "ratioPackageNo",
            label: "entities:ratioDatePackageSettings.attributes.ratioPackageNo.label",
            type: "value",
            dataType: "string",
            defaultInput: true,
            inputType: "text",
            validationType: "string",
            validations: [
                {
                    type: "required"
                }, 
            ]
        },
        price: {
            name: "price",
            label: "entities:ratioDatePackageSettings.attributes.price.label",
            type: "value",
            dataType: "string",
            defaultInput: true,
            inputType: "text",
            validationType: "string",
            validations: [
                {
                    type: "required"
                }, 
            ]
        },
        availabilityStatus: {
            name: "availabilityStatus",
            label: "entities:ratioDatePackageSettings.attributes.availabilityStatus.label",
            type: "value",
            dataType: "number",
            defaultValue: 1,
            defaultInput: true,
            inputType: "text",
            validationType: "string",
            validations: [
                {
                    type: "required"
                }, 
            ]
        }
    }
};
/* harmony default export */ var model = (ratioDatePackageSettingsModel);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(20414);
// EXTERNAL MODULE: ./src/entities/lib.ts
var lib = __webpack_require__(23480);
// EXTERNAL MODULE: ./src/lib/api/graphQLClient.ts
var graphQLClient = __webpack_require__(40112);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/swr/dist/index.mjs
var dist = __webpack_require__(8100);
// EXTERNAL MODULE: ./src/lib/helpers/helpers.ts
var helpers = __webpack_require__(15778);
;// CONCATENATED MODULE: ./src/entities/ratioDatePackageSettings/repository.ts










var hydrateObjects = function(objects) {
    return objects.map(function(object) {
        return (0,lib/* hydrateEntityObject */.b)(model, object);
    });
};
var hydrateObject = function(object) {
    return (0,lib/* hydrateEntityObject */.b)(model, object);
};
var ratioDatePackageSettingsRepository = {
    getObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    id: id
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(SINGLE_DATE_PACKAGE_SETTINGS_QUERY, variables).then(function(data) {
                        return hydrateObject(data.datePackageSettings);
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }(),
    getObjects: /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        var includes;
        var _arguments = arguments;
        return (0,tslib_es6.__generator)(this, function(_state) {
            includes = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : {};
            return [
                2,
                graphQLClient/* default.request */.Z.request(ALL_DATE_PACKAGE_SETTINGS_QUERY, includes).then(function(data) {
                    return hydrateObjects(data.datePackageSettings);
                })
            ];
        });
    }),
    useObject: function(id) {
        var includes = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        // eslint-disable-next-line react-hooks/exhaustive-deps
        var variables = (0,react.useMemo)(function() {
            return (0,_object_spread/* default */.Z)({
                id: id
            }, includes);
        }, [
            id
        ]);
        var ref = (0,dist/* default */.ZP)([
            SINGLE_DATE_PACKAGE_SETTINGS_QUERY,
            variables
        ], {
            revalidateOnFocus: false
        }), data = ref.data, error = ref.error, mutate = ref.mutate;
        return {
            object: !data ? data : hydrateObject(data.datePackageSettings),
            isLoading: !error && !data,
            isError: error,
            mutate: mutate
        };
    },
    useObjects: function() {
        var includes = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        // eslint-disable-next-line react-hooks/exhaustive-deps
        var variables = (0,react.useMemo)(function() {
            return includes;
        }, []);
        var ref = (0,dist/* default */.ZP)([
            ALL_DATE_PACKAGE_SETTINGS_QUERY,
            variables
        ]), data = ref.data, error = ref.error, mutate = ref.mutate;
        return {
            objects: !data ? data : hydrateObjects(data.datePackageSettings),
            isLoading: !error && !data,
            isError: error,
            mutate: mutate
        };
    },
    getDependents: function(id, includes) {
        var includeVars = {};
        includes.forEach(function(include) {
            includeVars["with".concat((0,helpers/* uppercaseFirst */.AB)(include))] = true;
        });
        var variables = (0,_object_spread/* default */.Z)({
            id: id
        }, includeVars);
        return graphQLClient/* default.request */.Z.request(DATE_PACKAGE_SETTINGS_DEPENDENTS_QUERY, variables).then(function(data) {
            return data.groupedDependents;
        });
    },
    useDependents: function(id, includes) {
        var includeVars = {};
        includes.forEach(function(include) {
            includeVars["with".concat((0,helpers/* uppercaseFirst */.AB)(include))] = true;
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
        var variables = (0,react.useMemo)(function() {
            return (0,_object_spread/* default */.Z)({
                id: id
            }, includeVars);
        }, [
            id
        ]);
        var ref = (0,dist/* default */.ZP)([
            DATE_PACKAGE_SETTINGS_DEPENDENTS_QUERY,
            variables
        ], {
            revalidateOnFocus: false
        }), data = ref.data, error = ref.error, mutate = ref.mutate;
        return {
            data: !data ? data : data.groupedDependents,
            isLoading: !error && !data,
            isError: error,
            mutate: mutate
        };
    },
    createObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(data) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    input: data
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(CREATE_DATE_PACKAGE_SETTINGS_MUTATION, variables).then(function(data) {
                        return hydrateObject(data.datePackageSettings);
                    })
                ];
            });
        });
        return function(data) {
            return _ref.apply(this, arguments);
        };
    }(),
    updateObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(data) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    input: data
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(UPDATE_DATE_PACKAGE_SETTINGS_MUTATION, variables).then(function(data) {
                        return hydrateObject(data.datePackageSettings);
                    })
                ];
            });
        });
        return function(data) {
            return _ref.apply(this, arguments);
        };
    }(),
    deleteObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(DELETE_DATE_PACKAGE_SETTINGS_MUTATION, variables).then(function(data) {
                        return data.deleteRatioDatePackageSettings;
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }(),
    forceDeleteObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(FORCE_DELETE_DATE_PACKAGE_SETTINGS_MUTATION, variables).then(function(data) {
                        return data.forceDeleteRatioDatePackageSettings;
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }()
};
/* harmony default export */ var repository = (ratioDatePackageSettingsRepository);

;// CONCATENATED MODULE: ./src/entities/ratioDatePackageSettings/entity.ts


var ratioDatePackageSettingsEntity = {
    model: model,
    repository: repository
};
/* harmony default export */ var entity = (ratioDatePackageSettingsEntity);


/***/ }),

/***/ 66819:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ entity; }
});

;// CONCATENATED MODULE: ./src/entities/ratioEsimRegion/graphql.ts
// language=GraphQL
var ALL_ESIM_REGIONS_QUERY = "query Query {\n  esimRegions: ratioEsimRegions {\n    id\n    name\n    serviceCodePrefix\n  }\n}";
// language=GraphQL
var SINGLE_ESIM_REGION_QUERY = "query Query($id: ID!) {\n  esimRegion: ratioEsimRegion(id: $id) {\n    id\n    name\n    serviceCodePrefix\n  }\n}";
// language=GraphQL
var CREATE_ESIM_REGION_MUTATION = "\n  mutation Mutation($input: CreateRatioEsimRegionInput) {\n    esimRegion: createRatioEsimRegion(input: $input) {\n      id\n      name\n      serviceCodePrefix\n    }\n  }";
// language=GraphQL
var UPDATE_ESIM_REGION_MUTATION = "\n  mutation Mutation($input: UpdateRatioEsimRegionInput) {\n    esimRegion: updateRatioEsimRegion(input: $input) {\n      id\n      name\n      serviceCodePrefix\n    }\n  }";
// language=GraphQL
var DELETE_ESIM_REGION_MUTATION = "\n  mutation Mutation($input: DeleteRatioEsimRegionInput) {\n    deleteRatioEsimRegion(input: $input) {\n      success\n    }\n  }";
// language=GraphQL
var FORCE_DELETE_ESIM_REGION_MUTATION = "\n  mutation Mutation($input: DeleteRatioEsimRegionInput) {\n    forceDeleteRatioEsimRegion(input: $input) {\n      success\n    }\n  }";
// language=GraphQL
var ESIM_REGIONS_DEPENDENTS_QUERY = "query Query($id: ID!, $withRatioEsimConfigs: Boolean = false, $withTravelEsimSettings: Boolean = false) {\n  groupedDependents: ratioEsimRegionDependents(id: $id) {\n    ratioEsimConfigs @include(if: $withRatioEsimConfigs) {\n      id\n      enabled\n    }\n    travelEsimSettings @include(if: $withTravelEsimSettings) {\n      id\n      enabled\n    }\n  }\n}";

;// CONCATENATED MODULE: ./src/entities/ratioEsimRegion/model.ts

var ratioEsimRegionModel = {
    name: "esimRegion",
    namePlural: "esimRegions",
    uniqueName: "ratioEsimRegion",
    uniqueNamePlural: "ratioEsimRegions",
    path: "config/ratio/esim/esim_region",
    baseUrl: "/config/ratio/esim/esim_regions",
    translationPrefix: "entities:ratioEsimRegion.",
    getDisplayName: function(values) {
        return values.name;
    },
    gql: {
        getAll: ALL_ESIM_REGIONS_QUERY,
        getSingle: SINGLE_ESIM_REGION_QUERY,
        create: CREATE_ESIM_REGION_MUTATION,
        update: UPDATE_ESIM_REGION_MUTATION,
        delete: DELETE_ESIM_REGION_MUTATION,
        forceDelete: FORCE_DELETE_ESIM_REGION_MUTATION
    },
    attributes: {
        name: {
            name: "name",
            label: "entities:ratioEsimRegion.attributes.name.label",
            type: "value",
            dataType: "string",
            defaultInput: true,
            inputType: "text",
            validationType: "string",
            validations: [
                {
                    type: "required"
                }, 
            ]
        },
        serviceCodePrefix: {
            name: "serviceCodePrefix",
            label: "entities:ratioEsimRegion.attributes.serviceCodePrefix.label",
            type: "value",
            dataType: "string",
            defaultInput: true,
            inputType: "text",
            validationType: "string",
            validations: [
                {
                    type: "required"
                }, 
            ]
        }
    }
};
/* harmony default export */ var model = (ratioEsimRegionModel);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(20414);
// EXTERNAL MODULE: ./src/entities/lib.ts
var lib = __webpack_require__(23480);
// EXTERNAL MODULE: ./src/lib/api/graphQLClient.ts
var graphQLClient = __webpack_require__(40112);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/swr/dist/index.mjs
var dist = __webpack_require__(8100);
// EXTERNAL MODULE: ./src/lib/helpers/helpers.ts
var helpers = __webpack_require__(15778);
;// CONCATENATED MODULE: ./src/entities/ratioEsimRegion/repository.ts










var hydrateObjects = function(objects) {
    return objects.map(function(object) {
        return (0,lib/* hydrateEntityObject */.b)(model, object);
    });
};
var hydrateObject = function(object) {
    return (0,lib/* hydrateEntityObject */.b)(model, object);
};
var ratioEsimRegionRepository = {
    getObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    id: id
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(SINGLE_ESIM_REGION_QUERY, variables).then(function(data) {
                        return hydrateObject(data.esimRegion);
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }(),
    getObjects: /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        var includes;
        var _arguments = arguments;
        return (0,tslib_es6.__generator)(this, function(_state) {
            includes = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : {};
            return [
                2,
                graphQLClient/* default.request */.Z.request(ALL_ESIM_REGIONS_QUERY, includes).then(function(data) {
                    return hydrateObjects(data.esimRegions);
                })
            ];
        });
    }),
    useObject: function(id) {
        var includes = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        // eslint-disable-next-line react-hooks/exhaustive-deps
        var variables = (0,react.useMemo)(function() {
            return (0,_object_spread/* default */.Z)({
                id: id
            }, includes);
        }, [
            id
        ]);
        var ref = (0,dist/* default */.ZP)([
            SINGLE_ESIM_REGION_QUERY,
            variables
        ], {
            revalidateOnFocus: false
        }), data = ref.data, error = ref.error, mutate = ref.mutate;
        return {
            object: !data ? data : hydrateObject(data.esimRegion),
            isLoading: !error && !data,
            isError: error,
            mutate: mutate
        };
    },
    useObjects: function() {
        var includes = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        // eslint-disable-next-line react-hooks/exhaustive-deps
        var variables = (0,react.useMemo)(function() {
            return includes;
        }, []);
        var ref = (0,dist/* default */.ZP)([
            ALL_ESIM_REGIONS_QUERY,
            variables
        ]), data = ref.data, error = ref.error, mutate = ref.mutate;
        return {
            objects: !data ? data : hydrateObjects(data.esimRegions),
            isLoading: !error && !data,
            isError: error,
            mutate: mutate
        };
    },
    getDependents: function(id, includes) {
        var includeVars = {};
        includes.forEach(function(include) {
            includeVars["with".concat((0,helpers/* uppercaseFirst */.AB)(include))] = true;
        });
        var variables = (0,_object_spread/* default */.Z)({
            id: id
        }, includeVars);
        return graphQLClient/* default.request */.Z.request(ESIM_REGIONS_DEPENDENTS_QUERY, variables).then(function(data) {
            return data.groupedDependents;
        });
    },
    useDependents: function(id, includes) {
        var includeVars = {};
        includes.forEach(function(include) {
            includeVars["with".concat((0,helpers/* uppercaseFirst */.AB)(include))] = true;
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
        var variables = (0,react.useMemo)(function() {
            return (0,_object_spread/* default */.Z)({
                id: id
            }, includeVars);
        }, [
            id
        ]);
        var ref = (0,dist/* default */.ZP)([
            ESIM_REGIONS_DEPENDENTS_QUERY,
            variables
        ], {
            revalidateOnFocus: false
        }), data = ref.data, error = ref.error, mutate = ref.mutate;
        return {
            data: !data ? data : data.groupedDependents,
            isLoading: !error && !data,
            isError: error,
            mutate: mutate
        };
    },
    createObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(data) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    input: data
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(CREATE_ESIM_REGION_MUTATION, variables).then(function(data) {
                        return hydrateObject(data.esimRegion);
                    })
                ];
            });
        });
        return function(data) {
            return _ref.apply(this, arguments);
        };
    }(),
    updateObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(data) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    input: data
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(UPDATE_ESIM_REGION_MUTATION, variables).then(function(data) {
                        return hydrateObject(data.esimRegion);
                    })
                ];
            });
        });
        return function(data) {
            return _ref.apply(this, arguments);
        };
    }(),
    deleteObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(DELETE_ESIM_REGION_MUTATION, variables).then(function(data) {
                        return data.deleteRatioEsimRegion;
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }(),
    forceDeleteObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(FORCE_DELETE_ESIM_REGION_MUTATION, variables).then(function(data) {
                        return data.forceDeleteRatioEsimRegion;
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }()
};
/* harmony default export */ var repository = (ratioEsimRegionRepository);

;// CONCATENATED MODULE: ./src/entities/ratioEsimRegion/entity.ts


var ratioEsimRegionEntity = {
    model: model,
    repository: repository
};
/* harmony default export */ var entity = (ratioEsimRegionEntity);


/***/ }),

/***/ 51316:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ entity; }
});

;// CONCATENATED MODULE: ./src/entities/ratioExtensionAccommodation/graphql.ts
// language=GraphQL
var ALL_EXTENSION_ACCOMMODATIONS_QUERY = "query Query {\n  extensionAccommodations: ratioExtensionAccommodations {\n    id\n    ratioPackageNo\n    name\n    label\n    info\n    extensionAccommodationServiceNo\n  }\n}";
// language=GraphQL
var SINGLE_EXTENSION_ACCOMMODATION_QUERY = "query Query($id: ID!) {\n  extensionAccommodation: ratioExtensionAccommodation(id: $id) {\n    id\n    ratioPackageNo\n    name\n    label\n    info\n    extensionAccommodationServiceNo\n  }\n}";
// language=GraphQL
var CREATE_EXTENSION_ACCOMMODATION_MUTATION = "\n  mutation Mutation($input: CreateRatioExtensionAccommodationInput) {\n    extensionAccommodation: createRatioExtensionAccommodation(input: $input) {\n      id\n      ratioPackageNo\n      name\n      label\n      info\n      extensionAccommodationServiceNo\n    }\n  }";
// language=GraphQL
var UPDATE_EXTENSION_ACCOMMODATION_MUTATION = "\n  mutation Mutation($input: UpdateRatioExtensionAccommodationInput) {\n    extensionAccommodation: updateRatioExtensionAccommodation(input: $input) {\n      id\n      ratioPackageNo\n      name\n      label\n      info\n      extensionAccommodationServiceNo\n    }\n  }";
// language=GraphQL
var DELETE_EXTENSION_ACCOMMODATION_MUTATION = "\n  mutation Mutation($input: DeleteRatioExtensionAccommodationInput) {\n    deleteRatioExtensionAccommodation(input: $input) {\n      success\n    }\n  }";
// language=GraphQL
var FORCE_DELETE_EXTENSION_ACCOMMODATION_MUTATION = "\n  mutation Mutation($input: DeleteRatioExtensionAccommodationInput) {\n    forceDeleteRatioExtensionAccommodation(input: $input) {\n      success\n    }\n  }";
// language=GraphQL
var EXTENSION_ACCOMMODATIONS_DEPENDENTS_QUERY = "query Query($id: ID!, $withRatioAccommodationExtensionMapItems: Boolean = false, $withRatioTravels: Boolean = false) {\n  groupedDependents: ratioExtensionAccommodationDependents(id: $id) {\n    ratioAccommodationExtensionMapItems @include(if: $withRatioAccommodationExtensionMapItems) {\n      id\n    }\n    ratioTravels @include(if: $withRatioTravels) {\n      id\n      catalogCode\n      travelCode\n      destination\n      name\n      transportType\n      transportTypeLabel\n      importDateTime\n      importStatus    }\n  }\n}";

;// CONCATENATED MODULE: ./src/entities/ratioExtensionAccommodation/model.ts

var ratioExtensionAccommodationModel = {
    name: "extensionAccommodation",
    namePlural: "extensionAccommodations",
    uniqueName: "ratioExtensionAccommodation",
    uniqueNamePlural: "ratioExtensionAccommodations",
    path: "travel/pricing/adaptors/ratio/extension_accommodation",
    baseUrl: "/travel/pricing/adaptors/ratio/extension_accommodations",
    translationPrefix: "entities:ratioExtensionAccommodation.",
    getDisplayName: function(values) {
        return values.label;
    },
    gql: {
        getAll: ALL_EXTENSION_ACCOMMODATIONS_QUERY,
        getSingle: SINGLE_EXTENSION_ACCOMMODATION_QUERY,
        create: CREATE_EXTENSION_ACCOMMODATION_MUTATION,
        update: UPDATE_EXTENSION_ACCOMMODATION_MUTATION,
        delete: DELETE_EXTENSION_ACCOMMODATION_MUTATION,
        forceDelete: FORCE_DELETE_EXTENSION_ACCOMMODATION_MUTATION
    },
    attributes: {
        ratioPackageNo: {
            name: "ratioPackageNo",
            label: "entities:ratioExtensionAccommodation.attributes.ratioPackageNo.label",
            type: "value",
            dataType: "number",
            defaultInput: false,
            inputType: "text",
            validationType: "string",
            validations: [
                {
                    type: "required"
                }, 
            ]
        },
        name: {
            name: "name",
            label: "entities:ratioExtensionAccommodation.attributes.name.label",
            type: "value",
            dataType: "string",
            defaultInput: false,
            inputType: "text",
            validationType: "string",
            validations: [
                {
                    type: "required"
                }, 
            ]
        },
        label: {
            name: "label",
            label: "entities:ratioExtensionAccommodation.attributes.label.label",
            type: "value",
            dataType: "string",
            defaultInput: true,
            inputType: "text",
            validationType: "string",
            validations: [
                {
                    type: "required"
                }, 
            ]
        },
        info: {
            name: "info",
            label: "entities:ratioExtensionAccommodation.attributes.info.label",
            type: "value",
            dataType: "string",
            defaultInput: true,
            inputType: "text",
            maxLength: 255,
            validationType: "string",
            validations: []
        },
        extensionAccommodationServiceNo: {
            name: "extensionAccommodationServiceNo",
            label: "entities:ratioExtensionAccommodation.attributes.extensionAccommodationServiceNo.label",
            type: "value",
            dataType: "number",
            defaultInput: false,
            inputType: "text",
            validationType: "string",
            validations: [
                {
                    type: "required"
                }, 
            ]
        }
    }
};
/* harmony default export */ var model = (ratioExtensionAccommodationModel);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(20414);
// EXTERNAL MODULE: ./src/entities/lib.ts
var lib = __webpack_require__(23480);
// EXTERNAL MODULE: ./src/lib/api/graphQLClient.ts
var graphQLClient = __webpack_require__(40112);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/swr/dist/index.mjs
var dist = __webpack_require__(8100);
// EXTERNAL MODULE: ./src/lib/helpers/helpers.ts
var helpers = __webpack_require__(15778);
;// CONCATENATED MODULE: ./src/entities/ratioExtensionAccommodation/repository.ts










var hydrateObjects = function(objects) {
    return objects.map(function(object) {
        return (0,lib/* hydrateEntityObject */.b)(model, object);
    });
};
var hydrateObject = function(object) {
    return (0,lib/* hydrateEntityObject */.b)(model, object);
};
var ratioExtensionAccommodationRepository = {
    getObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    id: id
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(SINGLE_EXTENSION_ACCOMMODATION_QUERY, variables).then(function(data) {
                        return hydrateObject(data.extensionAccommodation);
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }(),
    getObjects: /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        var includes;
        var _arguments = arguments;
        return (0,tslib_es6.__generator)(this, function(_state) {
            includes = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : {};
            return [
                2,
                graphQLClient/* default.request */.Z.request(ALL_EXTENSION_ACCOMMODATIONS_QUERY, includes).then(function(data) {
                    return hydrateObjects(data.extensionAccommodations);
                })
            ];
        });
    }),
    useObject: function(id) {
        var includes = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        // eslint-disable-next-line react-hooks/exhaustive-deps
        var variables = (0,react.useMemo)(function() {
            return (0,_object_spread/* default */.Z)({
                id: id
            }, includes);
        }, [
            id
        ]);
        var ref = (0,dist/* default */.ZP)([
            SINGLE_EXTENSION_ACCOMMODATION_QUERY,
            variables
        ], {
            revalidateOnFocus: false
        }), data = ref.data, error = ref.error, mutate = ref.mutate;
        return {
            object: !data ? data : hydrateObject(data.extensionAccommodation),
            isLoading: !error && !data,
            isError: error,
            mutate: mutate
        };
    },
    useObjects: function() {
        var includes = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        // eslint-disable-next-line react-hooks/exhaustive-deps
        var variables = (0,react.useMemo)(function() {
            return includes;
        }, []);
        var ref = (0,dist/* default */.ZP)([
            ALL_EXTENSION_ACCOMMODATIONS_QUERY,
            variables
        ]), data = ref.data, error = ref.error, mutate = ref.mutate;
        return {
            objects: !data ? data : hydrateObjects(data.extensionAccommodations),
            isLoading: !error && !data,
            isError: error,
            mutate: mutate
        };
    },
    getDependents: function(id, includes) {
        var includeVars = {};
        includes.forEach(function(include) {
            includeVars["with".concat((0,helpers/* uppercaseFirst */.AB)(include))] = true;
        });
        var variables = (0,_object_spread/* default */.Z)({
            id: id
        }, includeVars);
        return graphQLClient/* default.request */.Z.request(EXTENSION_ACCOMMODATIONS_DEPENDENTS_QUERY, variables).then(function(data) {
            return data.groupedDependents;
        });
    },
    useDependents: function(id, includes) {
        var includeVars = {};
        includes.forEach(function(include) {
            includeVars["with".concat((0,helpers/* uppercaseFirst */.AB)(include))] = true;
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
        var variables = (0,react.useMemo)(function() {
            return (0,_object_spread/* default */.Z)({
                id: id
            }, includeVars);
        }, [
            id
        ]);
        var ref = (0,dist/* default */.ZP)([
            EXTENSION_ACCOMMODATIONS_DEPENDENTS_QUERY,
            variables
        ], {
            revalidateOnFocus: false
        }), data = ref.data, error = ref.error, mutate = ref.mutate;
        return {
            data: !data ? data : data.groupedDependents,
            isLoading: !error && !data,
            isError: error,
            mutate: mutate
        };
    },
    createObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(data) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    input: data
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(CREATE_EXTENSION_ACCOMMODATION_MUTATION, variables).then(function(data) {
                        return hydrateObject(data.extensionAccommodation);
                    })
                ];
            });
        });
        return function(data) {
            return _ref.apply(this, arguments);
        };
    }(),
    updateObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(data) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    input: data
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(UPDATE_EXTENSION_ACCOMMODATION_MUTATION, variables).then(function(data) {
                        return hydrateObject(data.extensionAccommodation);
                    })
                ];
            });
        });
        return function(data) {
            return _ref.apply(this, arguments);
        };
    }(),
    deleteObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(DELETE_EXTENSION_ACCOMMODATION_MUTATION, variables).then(function(data) {
                        return data.deleteRatioExtensionAccommodation;
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }(),
    forceDeleteObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(FORCE_DELETE_EXTENSION_ACCOMMODATION_MUTATION, variables).then(function(data) {
                        return data.forceDeleteRatioExtensionAccommodation;
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }()
};
/* harmony default export */ var repository = (ratioExtensionAccommodationRepository);

;// CONCATENATED MODULE: ./src/entities/ratioExtensionAccommodation/entity.ts


var ratioExtensionAccommodationEntity = {
    model: model,
    repository: repository
};
/* harmony default export */ var entity = (ratioExtensionAccommodationEntity);


/***/ }),

/***/ 79028:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ ratioFamilyPackage_entity; }
});

;// CONCATENATED MODULE: ./src/entities/ratioFamilyPackage/graphql.ts
// language=GraphQL
var ALL_PACKAGES_QUERY = "query Query($withAccommodation: Boolean = false, $withAccommodationCapacitySettings: Boolean = false, $withAccommodationCapacitySettingsAgeGroupCapacities: Boolean = false, $withAccommodationCapacitySettingsAgeGroupedTotalCapacities: Boolean = false, $withAccommodationCapacitySettingsPartialOccupancyAllowedAgeGroups: Boolean = false, $withAccommodationAddons: Boolean = false, $withAccommodationAddonsCalculationSettings: Boolean = false, $withAccommodationAddonsMandatorySettings: Boolean = false, $withCapacitySettings: Boolean = false, $withCapacitySettingsAgeGroupCapacities: Boolean = false, $withCapacitySettingsAgeGroupCapacitiesAgeGroup: Boolean = false, $withCapacitySettingsAgeGroupedTotalCapacities: Boolean = false, $withCapacitySettingsAgeGroupedTotalCapacitiesAgeGroups: Boolean = false, $withCapacitySettingsPartialOccupancyAllowedAgeGroups: Boolean = false, $withAddons: Boolean = false, $withAddonsCalculationSettings: Boolean = false, $withAddonsMandatorySettings: Boolean = false, $withAddonsMandatorySettingsRules: Boolean = false) {\n  packages: ratioFamilyPackages {\n    id\n    ratioServiceNo\n    accommodation @include(if: $withAccommodation) {\n      id\n      ratioPackageNo\n      name\n      label\n      info\n      isFamilyPackageAccommodation\n      isBabyPackage\n      capacitySettings @include(if: $withAccommodationCapacitySettings) {\n        id\n        totalCapacity\n        rangesAllowed\n        ageGroupCapacities @include(if: $withAccommodationCapacitySettingsAgeGroupCapacities) {\n          id\n          minCapacity\n          maxCapacity\n        }\n        ageGroupedTotalCapacities @include(if: $withAccommodationCapacitySettingsAgeGroupedTotalCapacities) {\n          id\n          capacity\n        }\n        partialOccupancyAllowed\n        partialOccupancyAllowedAgeGroups @include(if: $withAccommodationCapacitySettingsPartialOccupancyAllowedAgeGroups) {\n          id\n          name\n          type\n          icon\n          minAge\n          maxAge\n        }\n      }\n      addons @include(if: $withAccommodationAddons) {\n        id\n        ratioServiceNo\n        name\n        label\n        info\n        calculationSettings @include(if: $withAccommodationAddonsCalculationSettings) {\n          id\n          type\n          considerHotelNights\n        }\n        mandatorySettings @include(if: $withAccommodationAddonsMandatorySettings) {\n          id\n          isMandatory\n          useRules\n        }\n      }\n    }\n    name\n    label\n    info\n    capacitySettings @include(if: $withCapacitySettings) {\n      id\n      totalCapacity\n      rangesAllowed\n      ageGroupCapacities @include(if: $withCapacitySettingsAgeGroupCapacities) {\n        id\n        ageGroup @include(if: $withCapacitySettingsAgeGroupCapacitiesAgeGroup) {\n          id\n          name\n          type\n          icon\n          minAge\n          maxAge\n        }\n        minCapacity\n        maxCapacity\n      }\n      ageGroupedTotalCapacities @include(if: $withCapacitySettingsAgeGroupedTotalCapacities) {\n        id\n        ageGroups @include(if: $withCapacitySettingsAgeGroupedTotalCapacitiesAgeGroups) {\n          id\n          name\n          type\n          icon\n          minAge\n          maxAge\n        }\n        capacity\n      }\n      partialOccupancyAllowed\n      partialOccupancyAllowedAgeGroups @include(if: $withCapacitySettingsPartialOccupancyAllowedAgeGroups) {\n        id\n        name\n        type\n        icon\n        minAge\n        maxAge\n      }\n    }\n    addons @include(if: $withAddons) {\n      id\n      ratioServiceNo\n      name\n      label\n      info\n      calculationSettings @include(if: $withAddonsCalculationSettings) {\n        id\n        type\n        considerHotelNights\n      }\n      mandatorySettings @include(if: $withAddonsMandatorySettings) {\n        id\n        isMandatory\n        useRules\n        rules @include(if: $withAddonsMandatorySettingsRules) {\n          id\n          checkAccommodationTypes\n          checkAccommodationAddons\n          checkAgeGroups\n          useAgeFilter\n          checkDateRange\n          startDate\n          endDate\n          checkTravelDate\n        }\n      }\n    }\n  }\n}";
// language=GraphQL
var SINGLE_PACKAGE_QUERY = "query Query($id: ID!, $withAccommodation: Boolean = false, $withAccommodationCapacitySettings: Boolean = false, $withAccommodationCapacitySettingsAgeGroupCapacities: Boolean = false, $withAccommodationCapacitySettingsAgeGroupedTotalCapacities: Boolean = false, $withAccommodationCapacitySettingsPartialOccupancyAllowedAgeGroups: Boolean = false, $withAccommodationAddons: Boolean = false, $withAccommodationAddonsCalculationSettings: Boolean = false, $withAccommodationAddonsMandatorySettings: Boolean = false, $withCapacitySettings: Boolean = false, $withCapacitySettingsAgeGroupCapacities: Boolean = false, $withCapacitySettingsAgeGroupCapacitiesAgeGroup: Boolean = false, $withCapacitySettingsAgeGroupedTotalCapacities: Boolean = false, $withCapacitySettingsAgeGroupedTotalCapacitiesAgeGroups: Boolean = false, $withCapacitySettingsPartialOccupancyAllowedAgeGroups: Boolean = false, $withAddons: Boolean = false, $withAddonsCalculationSettings: Boolean = false, $withAddonsMandatorySettings: Boolean = false, $withAddonsMandatorySettingsRules: Boolean = false) {\n  package: ratioFamilyPackage(id: $id) {\n    id\n    ratioServiceNo\n    accommodation @include(if: $withAccommodation) {\n      id\n      ratioPackageNo\n      name\n      label\n      info\n      isFamilyPackageAccommodation\n      isBabyPackage\n      capacitySettings @include(if: $withAccommodationCapacitySettings) {\n        id\n        totalCapacity\n        rangesAllowed\n        ageGroupCapacities @include(if: $withAccommodationCapacitySettingsAgeGroupCapacities) {\n          id\n          minCapacity\n          maxCapacity\n        }\n        ageGroupedTotalCapacities @include(if: $withAccommodationCapacitySettingsAgeGroupedTotalCapacities) {\n          id\n          capacity\n        }\n        partialOccupancyAllowed\n        partialOccupancyAllowedAgeGroups @include(if: $withAccommodationCapacitySettingsPartialOccupancyAllowedAgeGroups) {\n          id\n          name\n          type\n          icon\n          minAge\n          maxAge\n        }\n      }\n      addons @include(if: $withAccommodationAddons) {\n        id\n        ratioServiceNo\n        name\n        label\n        info\n        calculationSettings @include(if: $withAccommodationAddonsCalculationSettings) {\n          id\n          type\n          considerHotelNights\n        }\n        mandatorySettings @include(if: $withAccommodationAddonsMandatorySettings) {\n          id\n          isMandatory\n          useRules\n        }\n      }\n    }\n    name\n    label\n    info\n    capacitySettings @include(if: $withCapacitySettings) {\n      id\n      totalCapacity\n      rangesAllowed\n      ageGroupCapacities @include(if: $withCapacitySettingsAgeGroupCapacities) {\n        id\n        ageGroup @include(if: $withCapacitySettingsAgeGroupCapacitiesAgeGroup) {\n          id\n          name\n          type\n          icon\n          minAge\n          maxAge\n        }\n        minCapacity\n        maxCapacity\n      }\n      ageGroupedTotalCapacities @include(if: $withCapacitySettingsAgeGroupedTotalCapacities) {\n        id\n        ageGroups @include(if: $withCapacitySettingsAgeGroupedTotalCapacitiesAgeGroups) {\n          id\n          name\n          type\n          icon\n          minAge\n          maxAge\n        }\n        capacity\n      }\n      partialOccupancyAllowed\n      partialOccupancyAllowedAgeGroups @include(if: $withCapacitySettingsPartialOccupancyAllowedAgeGroups) {\n        id\n        name\n        type\n        icon\n        minAge\n        maxAge\n      }\n    }\n    addons @include(if: $withAddons) {\n      id\n      ratioServiceNo\n      name\n      label\n      info\n      calculationSettings @include(if: $withAddonsCalculationSettings) {\n        id\n        type\n        considerHotelNights\n      }\n      mandatorySettings @include(if: $withAddonsMandatorySettings) {\n        id\n        isMandatory\n        useRules\n        rules @include(if: $withAddonsMandatorySettingsRules) {\n          id\n          checkAccommodationTypes\n          checkAccommodationAddons\n          checkAgeGroups\n          useAgeFilter\n          checkDateRange\n          startDate\n          endDate\n          checkTravelDate\n        }\n      }\n    }\n  }\n}";
// language=GraphQL
var CREATE_PACKAGE_MUTATION = "\n  mutation Mutation($input: CreateRatioFamilyPackageInput, $withAccommodation: Boolean = false, $withAccommodationCapacitySettings: Boolean = false, $withAccommodationCapacitySettingsAgeGroupCapacities: Boolean = false, $withAccommodationCapacitySettingsAgeGroupedTotalCapacities: Boolean = false, $withAccommodationCapacitySettingsPartialOccupancyAllowedAgeGroups: Boolean = false, $withAccommodationAddons: Boolean = false, $withAccommodationAddonsCalculationSettings: Boolean = false, $withAccommodationAddonsMandatorySettings: Boolean = false, $withCapacitySettings: Boolean = false, $withCapacitySettingsAgeGroupCapacities: Boolean = false, $withCapacitySettingsAgeGroupCapacitiesAgeGroup: Boolean = false, $withCapacitySettingsAgeGroupedTotalCapacities: Boolean = false, $withCapacitySettingsAgeGroupedTotalCapacitiesAgeGroups: Boolean = false, $withCapacitySettingsPartialOccupancyAllowedAgeGroups: Boolean = false, $withAddons: Boolean = false, $withAddonsCalculationSettings: Boolean = false, $withAddonsMandatorySettings: Boolean = false, $withAddonsMandatorySettingsRules: Boolean = false) {\n    package: createRatioFamilyPackage(input: $input) {\n      id\n      ratioServiceNo\n      accommodation @include(if: $withAccommodation) {\n        id\n        ratioPackageNo\n        name\n        label\n        info\n        isFamilyPackageAccommodation\n        isBabyPackage\n        capacitySettings @include(if: $withAccommodationCapacitySettings) {\n          id\n          totalCapacity\n          rangesAllowed\n          ageGroupCapacities @include(if: $withAccommodationCapacitySettingsAgeGroupCapacities) {\n            id\n            minCapacity\n            maxCapacity\n          }\n          ageGroupedTotalCapacities @include(if: $withAccommodationCapacitySettingsAgeGroupedTotalCapacities) {\n            id\n            capacity\n          }\n          partialOccupancyAllowed\n          partialOccupancyAllowedAgeGroups @include(if: $withAccommodationCapacitySettingsPartialOccupancyAllowedAgeGroups) {\n            id\n            name\n            type\n            icon\n            minAge\n            maxAge\n          }\n        }\n        addons @include(if: $withAccommodationAddons) {\n          id\n          ratioServiceNo\n          name\n          label\n          info\n          calculationSettings @include(if: $withAccommodationAddonsCalculationSettings) {\n            id\n            type\n            considerHotelNights\n          }\n          mandatorySettings @include(if: $withAccommodationAddonsMandatorySettings) {\n            id\n            isMandatory\n            useRules\n          }\n        }\n      }\n      name\n      label\n      info\n      capacitySettings @include(if: $withCapacitySettings) {\n        id\n        totalCapacity\n        rangesAllowed\n        ageGroupCapacities @include(if: $withCapacitySettingsAgeGroupCapacities) {\n          id\n          ageGroup @include(if: $withCapacitySettingsAgeGroupCapacitiesAgeGroup) {\n            id\n            name\n            type\n            icon\n            minAge\n            maxAge\n          }\n          minCapacity\n          maxCapacity\n        }\n        ageGroupedTotalCapacities @include(if: $withCapacitySettingsAgeGroupedTotalCapacities) {\n          id\n          ageGroups @include(if: $withCapacitySettingsAgeGroupedTotalCapacitiesAgeGroups) {\n            id\n            name\n            type\n            icon\n            minAge\n            maxAge\n          }\n          capacity\n        }\n        partialOccupancyAllowed\n        partialOccupancyAllowedAgeGroups @include(if: $withCapacitySettingsPartialOccupancyAllowedAgeGroups) {\n          id\n          name\n          type\n          icon\n          minAge\n          maxAge\n        }\n      }\n      addons @include(if: $withAddons) {\n        id\n        ratioServiceNo\n        name\n        label\n        info\n        calculationSettings @include(if: $withAddonsCalculationSettings) {\n          id\n          type\n          considerHotelNights\n        }\n        mandatorySettings @include(if: $withAddonsMandatorySettings) {\n          id\n          isMandatory\n          useRules\n          rules @include(if: $withAddonsMandatorySettingsRules) {\n            id\n            checkAccommodationTypes\n            checkAccommodationAddons\n            checkAgeGroups\n            useAgeFilter\n            checkDateRange\n            startDate\n            endDate\n            checkTravelDate\n          }\n        }\n      }\n    }\n  }";
// language=GraphQL
var UPDATE_PACKAGE_MUTATION = "\n  mutation Mutation($input: UpdateRatioFamilyPackageInput, $withAccommodation: Boolean = false, $withAccommodationCapacitySettings: Boolean = false, $withAccommodationCapacitySettingsAgeGroupCapacities: Boolean = false, $withAccommodationCapacitySettingsAgeGroupedTotalCapacities: Boolean = false, $withAccommodationCapacitySettingsPartialOccupancyAllowedAgeGroups: Boolean = false, $withAccommodationAddons: Boolean = false, $withAccommodationAddonsCalculationSettings: Boolean = false, $withAccommodationAddonsMandatorySettings: Boolean = false, $withCapacitySettings: Boolean = false, $withCapacitySettingsAgeGroupCapacities: Boolean = false, $withCapacitySettingsAgeGroupCapacitiesAgeGroup: Boolean = false, $withCapacitySettingsAgeGroupedTotalCapacities: Boolean = false, $withCapacitySettingsAgeGroupedTotalCapacitiesAgeGroups: Boolean = false, $withCapacitySettingsPartialOccupancyAllowedAgeGroups: Boolean = false, $withAddons: Boolean = false, $withAddonsCalculationSettings: Boolean = false, $withAddonsMandatorySettings: Boolean = false, $withAddonsMandatorySettingsRules: Boolean = false) {\n    package: updateRatioFamilyPackage(input: $input) {\n      id\n      ratioServiceNo\n      accommodation @include(if: $withAccommodation) {\n        id\n        ratioPackageNo\n        name\n        label\n        info\n        isFamilyPackageAccommodation\n        isBabyPackage\n        capacitySettings @include(if: $withAccommodationCapacitySettings) {\n          id\n          totalCapacity\n          rangesAllowed\n          ageGroupCapacities @include(if: $withAccommodationCapacitySettingsAgeGroupCapacities) {\n            id\n            minCapacity\n            maxCapacity\n          }\n          ageGroupedTotalCapacities @include(if: $withAccommodationCapacitySettingsAgeGroupedTotalCapacities) {\n            id\n            capacity\n          }\n          partialOccupancyAllowed\n          partialOccupancyAllowedAgeGroups @include(if: $withAccommodationCapacitySettingsPartialOccupancyAllowedAgeGroups) {\n            id\n            name\n            type\n            icon\n            minAge\n            maxAge\n          }\n        }\n        addons @include(if: $withAccommodationAddons) {\n          id\n          ratioServiceNo\n          name\n          label\n          info\n          calculationSettings @include(if: $withAccommodationAddonsCalculationSettings) {\n            id\n            type\n            considerHotelNights\n          }\n          mandatorySettings @include(if: $withAccommodationAddonsMandatorySettings) {\n            id\n            isMandatory\n            useRules\n          }\n        }\n      }\n      name\n      label\n      info\n      capacitySettings @include(if: $withCapacitySettings) {\n        id\n        totalCapacity\n        rangesAllowed\n        ageGroupCapacities @include(if: $withCapacitySettingsAgeGroupCapacities) {\n          id\n          ageGroup @include(if: $withCapacitySettingsAgeGroupCapacitiesAgeGroup) {\n            id\n            name\n            type\n            icon\n            minAge\n            maxAge\n          }\n          minCapacity\n          maxCapacity\n        }\n        ageGroupedTotalCapacities @include(if: $withCapacitySettingsAgeGroupedTotalCapacities) {\n          id\n          ageGroups @include(if: $withCapacitySettingsAgeGroupedTotalCapacitiesAgeGroups) {\n            id\n            name\n            type\n            icon\n            minAge\n            maxAge\n          }\n          capacity\n        }\n        partialOccupancyAllowed\n        partialOccupancyAllowedAgeGroups @include(if: $withCapacitySettingsPartialOccupancyAllowedAgeGroups) {\n          id\n          name\n          type\n          icon\n          minAge\n          maxAge\n        }\n      }\n      addons @include(if: $withAddons) {\n        id\n        ratioServiceNo\n        name\n        label\n        info\n        calculationSettings @include(if: $withAddonsCalculationSettings) {\n          id\n          type\n          considerHotelNights\n        }\n        mandatorySettings @include(if: $withAddonsMandatorySettings) {\n          id\n          isMandatory\n          useRules\n          rules @include(if: $withAddonsMandatorySettingsRules) {\n            id\n            checkAccommodationTypes\n            checkAccommodationAddons\n            checkAgeGroups\n            useAgeFilter\n            checkDateRange\n            startDate\n            endDate\n            checkTravelDate\n          }\n        }\n      }\n    }\n  }";
// language=GraphQL
var DELETE_PACKAGE_MUTATION = "\n  mutation Mutation($input: DeleteRatioFamilyPackageInput) {\n    deleteRatioFamilyPackage(input: $input) {\n      success\n    }\n  }";
// language=GraphQL
var FORCE_DELETE_PACKAGE_MUTATION = "\n  mutation Mutation($input: DeleteRatioFamilyPackageInput) {\n    forceDeleteRatioFamilyPackage(input: $input) {\n      success\n    }\n  }";
// language=GraphQL
var ADD_PACKAGE_ADDONS_MUTATION = "\n  mutation Mutation($input: addRatioFamilyPackageAddonsInput) {\n    addRatioFamilyPackageAddons(input: $input) {\n      id\n      addonIds\n    }\n  }";
// language=GraphQL
var REMOVE_PACKAGE_ADDONS_MUTATION = "\n  mutation Mutation($input: removeRatioFamilyPackageAddonsInput) {\n    removeRatioFamilyPackageAddons(input: $input) {\n      id\n      addonIds\n    }\n  }";
// language=GraphQL
var CREATE_PACKAGE_ADDONS_MUTATION = "\n  mutation Mutation($input: createRatioFamilyPackageAddonsInput) {\n    createRatioFamilyPackageAddons(input: $input) {\n      id\n      addonIds\n    }\n  }";
// language=GraphQL
var DELETE_PACKAGE_ADDONS_MUTATION = "\n  mutation Mutation($input: deleteRatioFamilyPackageAddonsInput) {\n    deleteRatioFamilyPackageAddons(input: $input) {\n      id\n      addonIds\n    }\n  }";
// language=GraphQL
var UPDATE_PACKAGE_ADDONS_ORDER_MUTATION = "\n  mutation Mutation($input: updateRatioFamilyPackageAddonsOrderInput) {\n    updateRatioFamilyPackageAddonsOrder(input: $input) {\n      id\n      addonIds\n    }\n  }";
// language=GraphQL
var PACKAGES_DEPENDENTS_QUERY = "query Query($id: ID!, $withTravellers: Boolean = false, $withRatioTravels: Boolean = false, $withTravelPricingRules: Boolean = false) {\n  groupedDependents: ratioFamilyPackageDependents(id: $id) {\n    travellers @include(if: $withTravellers) {\n      id\n      salutation\n      firstName\n      lastName\n      birthday\n      nationality\n      email\n      phone\n      address\n      addressNumber\n      addressAddition\n      zip\n      city\n      country\n    }\n    ratioTravels @include(if: $withRatioTravels) {\n      id\n      catalogCode\n      travelCode\n      destination\n      name\n      transportType\n      transportTypeLabel\n      importDateTime\n      importStatus    }\n    travelPricingRules @include(if: $withTravelPricingRules) {\n      id\n      checkAccommodationTypes\n      checkAccommodationAddons\n      checkAgeGroups\n      useAgeFilter\n      checkDateRange\n      startDate\n      endDate\n      checkTravelDate\n    }\n  }\n}";

// EXTERNAL MODULE: ./src/entities/ratioAccommodation/entity.ts + 3 modules
var entity = __webpack_require__(53656);
// EXTERNAL MODULE: ./src/entities/accommodationCapacitySettings/entity.ts + 3 modules
var accommodationCapacitySettings_entity = __webpack_require__(11844);
// EXTERNAL MODULE: ./src/entities/ratioAccommodationAddon/entity.ts + 3 modules
var ratioAccommodationAddon_entity = __webpack_require__(88646);
;// CONCATENATED MODULE: ./src/entities/ratioFamilyPackage/model.ts




var ratioFamilyPackageModel = {
    name: "package",
    namePlural: "packages",
    uniqueName: "ratioFamilyPackage",
    uniqueNamePlural: "ratioFamilyPackages",
    path: "travel/pricing/adaptors/ratio/package",
    baseUrl: "/travel/pricing/adaptors/ratio/packages",
    translationPrefix: "entities:ratioFamilyPackage.",
    getDisplayName: function(values) {
        return values.label;
    },
    gql: {
        getAll: ALL_PACKAGES_QUERY,
        getSingle: SINGLE_PACKAGE_QUERY,
        create: CREATE_PACKAGE_MUTATION,
        update: UPDATE_PACKAGE_MUTATION,
        delete: DELETE_PACKAGE_MUTATION,
        forceDelete: FORCE_DELETE_PACKAGE_MUTATION
    },
    attributes: {
        ratioServiceNo: {
            name: "ratioServiceNo",
            label: "entities:ratioFamilyPackage.attributes.ratioServiceNo.label",
            type: "value",
            dataType: "number",
            defaultInput: true,
            inputType: "hidden",
            validationType: "string",
            validations: [
                {
                    type: "required"
                }, 
            ]
        },
        accommodation: {
            name: "accommodation",
            label: "entities:ratioFamilyPackage.attributes.accommodation.label",
            type: "entityObject",
            dataType: "any",
            getEntity: function() {
                return entity/* default */.Z;
            },
            defaultInput: true,
            inputType: "select",
            validationType: "string",
            validations: [
                {
                    type: "required"
                }, 
            ]
        },
        name: {
            name: "name",
            label: "entities:ratioFamilyPackage.attributes.name.label",
            type: "value",
            dataType: "string",
            defaultInput: true,
            inputType: "hidden",
            validationType: "string",
            validations: [
                {
                    type: "required"
                }, 
            ]
        },
        label: {
            name: "label",
            label: "entities:ratioFamilyPackage.attributes.label.label",
            type: "value",
            dataType: "string",
            defaultInput: true,
            inputType: "text",
            validationType: "string",
            validations: [
                {
                    type: "required"
                }, 
            ]
        },
        info: {
            name: "info",
            label: "entities:ratioFamilyPackage.attributes.info.label",
            type: "value",
            dataType: "string",
            defaultInput: true,
            inputType: "textarea",
            maxLength: 255,
            validationType: "string",
            validations: []
        },
        capacitySettings: {
            name: "capacitySettings",
            label: "entities:ratioFamilyPackage.attributes.capacitySettings.label",
            type: "entityObject",
            dataType: "any",
            getEntity: function() {
                return accommodationCapacitySettings_entity/* default */.Z;
            },
            defaultInput: false,
            inputType: "select",
            validationType: "string",
            validations: []
        },
        addons: {
            name: "addons",
            label: "entities:ratioFamilyPackage.attributes.addons.label",
            type: "entityCollection",
            dataType: "[any]",
            getEntity: function() {
                return ratioAccommodationAddon_entity/* default */.Z;
            },
            defaultInput: false,
            inputType: "text",
            validationType: "string",
            validations: []
        }
    }
};
/* harmony default export */ var model = (ratioFamilyPackageModel);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(20414);
// EXTERNAL MODULE: ./src/entities/lib.ts
var lib = __webpack_require__(23480);
// EXTERNAL MODULE: ./src/lib/api/graphQLClient.ts
var graphQLClient = __webpack_require__(40112);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/swr/dist/index.mjs
var dist = __webpack_require__(8100);
// EXTERNAL MODULE: ./src/lib/helpers/helpers.ts
var helpers = __webpack_require__(15778);
;// CONCATENATED MODULE: ./src/entities/ratioFamilyPackage/repository.ts










var hydrateObjects = function(objects) {
    return objects.map(function(object) {
        return (0,lib/* hydrateEntityObject */.b)(model, object);
    });
};
var hydrateObject = function(object) {
    return (0,lib/* hydrateEntityObject */.b)(model, object);
};
var ratioFamilyPackageRepository = {
    getObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    id: id
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(SINGLE_PACKAGE_QUERY, variables).then(function(data) {
                        return hydrateObject(data.package);
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }(),
    getObjects: /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        var includes;
        var _arguments = arguments;
        return (0,tslib_es6.__generator)(this, function(_state) {
            includes = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : {};
            return [
                2,
                graphQLClient/* default.request */.Z.request(ALL_PACKAGES_QUERY, includes).then(function(data) {
                    return hydrateObjects(data.packages);
                })
            ];
        });
    }),
    useObject: function(id) {
        var includes = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        // eslint-disable-next-line react-hooks/exhaustive-deps
        var variables = (0,react.useMemo)(function() {
            return (0,_object_spread/* default */.Z)({
                id: id
            }, includes);
        }, [
            id
        ]);
        var ref = (0,dist/* default */.ZP)([
            SINGLE_PACKAGE_QUERY,
            variables
        ], {
            revalidateOnFocus: false
        }), data = ref.data, error = ref.error, mutate = ref.mutate;
        return {
            object: !data ? data : hydrateObject(data.package),
            isLoading: !error && !data,
            isError: error,
            mutate: mutate
        };
    },
    useObjects: function() {
        var includes = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        // eslint-disable-next-line react-hooks/exhaustive-deps
        var variables = (0,react.useMemo)(function() {
            return includes;
        }, []);
        var ref = (0,dist/* default */.ZP)([
            ALL_PACKAGES_QUERY,
            variables
        ]), data = ref.data, error = ref.error, mutate = ref.mutate;
        return {
            objects: !data ? data : hydrateObjects(data.packages),
            isLoading: !error && !data,
            isError: error,
            mutate: mutate
        };
    },
    getDependents: function(id, includes) {
        var includeVars = {};
        includes.forEach(function(include) {
            includeVars["with".concat((0,helpers/* uppercaseFirst */.AB)(include))] = true;
        });
        var variables = (0,_object_spread/* default */.Z)({
            id: id
        }, includeVars);
        return graphQLClient/* default.request */.Z.request(PACKAGES_DEPENDENTS_QUERY, variables).then(function(data) {
            return data.groupedDependents;
        });
    },
    useDependents: function(id, includes) {
        var includeVars = {};
        includes.forEach(function(include) {
            includeVars["with".concat((0,helpers/* uppercaseFirst */.AB)(include))] = true;
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
        var variables = (0,react.useMemo)(function() {
            return (0,_object_spread/* default */.Z)({
                id: id
            }, includeVars);
        }, [
            id
        ]);
        var ref = (0,dist/* default */.ZP)([
            PACKAGES_DEPENDENTS_QUERY,
            variables
        ], {
            revalidateOnFocus: false
        }), data = ref.data, error = ref.error, mutate = ref.mutate;
        return {
            data: !data ? data : data.groupedDependents,
            isLoading: !error && !data,
            isError: error,
            mutate: mutate
        };
    },
    createObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(data) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    input: data
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(CREATE_PACKAGE_MUTATION, variables).then(function(data) {
                        return hydrateObject(data.package);
                    })
                ];
            });
        });
        return function(data) {
            return _ref.apply(this, arguments);
        };
    }(),
    updateObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(data) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    input: data
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(UPDATE_PACKAGE_MUTATION, variables).then(function(data) {
                        return hydrateObject(data.package);
                    })
                ];
            });
        });
        return function(data) {
            return _ref.apply(this, arguments);
        };
    }(),
    deleteObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(DELETE_PACKAGE_MUTATION, variables).then(function(data) {
                        return data.deleteRatioFamilyPackage;
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }(),
    forceDeleteObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(FORCE_DELETE_PACKAGE_MUTATION, variables).then(function(data) {
                        return data.forceDeleteRatioFamilyPackage;
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }(),
    assignAddons: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, itemIds) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        addonIds: itemIds
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(ADD_PACKAGE_ADDONS_MUTATION, variables)
                ];
            });
        });
        return function(id, itemIds) {
            return _ref.apply(this, arguments);
        };
    }(),
    unassignAddons: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, itemIds) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        addonIds: itemIds
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(REMOVE_PACKAGE_ADDONS_MUTATION, variables)
                ];
            });
        });
        return function(id, itemIds) {
            return _ref.apply(this, arguments);
        };
    }(),
    createAddons: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, items) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        addons: items
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(CREATE_PACKAGE_ADDONS_MUTATION, variables)
                ];
            });
        });
        return function(id, items) {
            return _ref.apply(this, arguments);
        };
    }(),
    deleteAddons: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, itemIds) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        addonIds: itemIds
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(DELETE_PACKAGE_ADDONS_MUTATION, variables)
                ];
            });
        });
        return function(id, itemIds) {
            return _ref.apply(this, arguments);
        };
    }(),
    updateAddonsOrder: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, itemIds) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        addonIds: itemIds
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(UPDATE_PACKAGE_ADDONS_ORDER_MUTATION, variables)
                ];
            });
        });
        return function(id, itemIds) {
            return _ref.apply(this, arguments);
        };
    }()
};
/* harmony default export */ var repository = (ratioFamilyPackageRepository);

;// CONCATENATED MODULE: ./src/entities/ratioFamilyPackage/entity.ts


var ratioFamilyPackageEntity = {
    model: model,
    repository: repository
};
/* harmony default export */ var ratioFamilyPackage_entity = (ratioFamilyPackageEntity);


/***/ }),

/***/ 34722:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ ratioPersonalAddon_entity; }
});

;// CONCATENATED MODULE: ./src/entities/ratioPersonalAddon/graphql.ts
// language=GraphQL
var ALL_PERSONAL_ADDONS_QUERY = "query Query($withAllowedAgeGroups: Boolean = false, $withCalculationSettings: Boolean = false, $withMandatorySettings: Boolean = false, $withMandatorySettingsRules: Boolean = false, $withMandatorySettingsRulesAccommodations: Boolean = false, $withMandatorySettingsRulesFamilyPackages: Boolean = false, $withMandatorySettingsRulesAccommodationAddons: Boolean = false, $withMandatorySettingsRulesAgeGroups: Boolean = false, $withMandatorySettingsRulesAgeFilter: Boolean = false, $withMandatorySettingsRulesTravelDates: Boolean = false) {\n  personalAddons: ratioPersonalAddons {\n    id\n    ratioServiceNo\n    name\n    label\n    info\n    allowedAgeGroups @include(if: $withAllowedAgeGroups) {\n      id\n      name\n      type\n      icon\n      minAge\n      maxAge\n    }\n    calculationSettings @include(if: $withCalculationSettings) {\n      id\n      type\n      considerHotelNights\n    }\n    mandatorySettings @include(if: $withMandatorySettings) {\n      id\n      isMandatory\n      useRules\n      rules @include(if: $withMandatorySettingsRules) {\n        id\n        checkAccommodationTypes\n        accommodations @include(if: $withMandatorySettingsRulesAccommodations) {\n          id\n          ratioPackageNo\n          name\n          label\n          info\n          isFamilyPackageAccommodation\n          isBabyPackage\n        }\n        familyPackages @include(if: $withMandatorySettingsRulesFamilyPackages) {\n          id\n          ratioServiceNo\n          name\n          label\n          info\n        }\n        checkAccommodationAddons\n        accommodationAddons @include(if: $withMandatorySettingsRulesAccommodationAddons) {\n          id\n          ratioServiceNo\n          name\n          label\n          info\n        }\n        checkAgeGroups\n        ageGroups @include(if: $withMandatorySettingsRulesAgeGroups) {\n          id\n          name\n          type\n          icon\n          minAge\n          maxAge\n        }\n        useAgeFilter\n        ageFilter @include(if: $withMandatorySettingsRulesAgeFilter) {\n          id\n          minAge\n          maxAge\n        }\n        checkDateRange\n        startDate\n        endDate\n        checkTravelDate\n        travelDates @include(if: $withMandatorySettingsRulesTravelDates) {\n          id\n          dateNo\n          startDate\n          endDate\n          includesExtension\n          json\n        }\n      }\n    }\n  }\n}";
// language=GraphQL
var SINGLE_PERSONAL_ADDON_QUERY = "query Query($id: ID!, $withAllowedAgeGroups: Boolean = false, $withCalculationSettings: Boolean = false, $withMandatorySettings: Boolean = false, $withMandatorySettingsRules: Boolean = false, $withMandatorySettingsRulesAccommodations: Boolean = false, $withMandatorySettingsRulesFamilyPackages: Boolean = false, $withMandatorySettingsRulesAccommodationAddons: Boolean = false, $withMandatorySettingsRulesAgeGroups: Boolean = false, $withMandatorySettingsRulesAgeFilter: Boolean = false, $withMandatorySettingsRulesTravelDates: Boolean = false) {\n  personalAddon: ratioPersonalAddon(id: $id) {\n    id\n    ratioServiceNo\n    name\n    label\n    info\n    allowedAgeGroups @include(if: $withAllowedAgeGroups) {\n      id\n      name\n      type\n      icon\n      minAge\n      maxAge\n    }\n    calculationSettings @include(if: $withCalculationSettings) {\n      id\n      type\n      considerHotelNights\n    }\n    mandatorySettings @include(if: $withMandatorySettings) {\n      id\n      isMandatory\n      useRules\n      rules @include(if: $withMandatorySettingsRules) {\n        id\n        checkAccommodationTypes\n        accommodations @include(if: $withMandatorySettingsRulesAccommodations) {\n          id\n          ratioPackageNo\n          name\n          label\n          info\n          isFamilyPackageAccommodation\n          isBabyPackage\n        }\n        familyPackages @include(if: $withMandatorySettingsRulesFamilyPackages) {\n          id\n          ratioServiceNo\n          name\n          label\n          info\n        }\n        checkAccommodationAddons\n        accommodationAddons @include(if: $withMandatorySettingsRulesAccommodationAddons) {\n          id\n          ratioServiceNo\n          name\n          label\n          info\n        }\n        checkAgeGroups\n        ageGroups @include(if: $withMandatorySettingsRulesAgeGroups) {\n          id\n          name\n          type\n          icon\n          minAge\n          maxAge\n        }\n        useAgeFilter\n        ageFilter @include(if: $withMandatorySettingsRulesAgeFilter) {\n          id\n          minAge\n          maxAge\n        }\n        checkDateRange\n        startDate\n        endDate\n        checkTravelDate\n        travelDates @include(if: $withMandatorySettingsRulesTravelDates) {\n          id\n          dateNo\n          startDate\n          endDate\n          includesExtension\n          json\n        }\n      }\n    }\n  }\n}";
// language=GraphQL
var CREATE_PERSONAL_ADDON_MUTATION = "\n  mutation Mutation($input: CreateRatioPersonalAddonInput, $withAllowedAgeGroups: Boolean = false, $withCalculationSettings: Boolean = false, $withMandatorySettings: Boolean = false, $withMandatorySettingsRules: Boolean = false, $withMandatorySettingsRulesAccommodations: Boolean = false, $withMandatorySettingsRulesFamilyPackages: Boolean = false, $withMandatorySettingsRulesAccommodationAddons: Boolean = false, $withMandatorySettingsRulesAgeGroups: Boolean = false, $withMandatorySettingsRulesAgeFilter: Boolean = false, $withMandatorySettingsRulesTravelDates: Boolean = false) {\n    personalAddon: createRatioPersonalAddon(input: $input) {\n      id\n      ratioServiceNo\n      name\n      label\n      info\n      allowedAgeGroups @include(if: $withAllowedAgeGroups) {\n        id\n        name\n        type\n        icon\n        minAge\n        maxAge\n      }\n      calculationSettings @include(if: $withCalculationSettings) {\n        id\n        type\n        considerHotelNights\n      }\n      mandatorySettings @include(if: $withMandatorySettings) {\n        id\n        isMandatory\n        useRules\n        rules @include(if: $withMandatorySettingsRules) {\n          id\n          checkAccommodationTypes\n          accommodations @include(if: $withMandatorySettingsRulesAccommodations) {\n            id\n            ratioPackageNo\n            name\n            label\n            info\n            isFamilyPackageAccommodation\n            isBabyPackage\n          }\n          familyPackages @include(if: $withMandatorySettingsRulesFamilyPackages) {\n            id\n            ratioServiceNo\n            name\n            label\n            info\n          }\n          checkAccommodationAddons\n          accommodationAddons @include(if: $withMandatorySettingsRulesAccommodationAddons) {\n            id\n            ratioServiceNo\n            name\n            label\n            info\n          }\n          checkAgeGroups\n          ageGroups @include(if: $withMandatorySettingsRulesAgeGroups) {\n            id\n            name\n            type\n            icon\n            minAge\n            maxAge\n          }\n          useAgeFilter\n          ageFilter @include(if: $withMandatorySettingsRulesAgeFilter) {\n            id\n            minAge\n            maxAge\n          }\n          checkDateRange\n          startDate\n          endDate\n          checkTravelDate\n          travelDates @include(if: $withMandatorySettingsRulesTravelDates) {\n            id\n            dateNo\n            startDate\n            endDate\n            includesExtension\n            json\n          }\n        }\n      }\n    }\n  }";
// language=GraphQL
var UPDATE_PERSONAL_ADDON_MUTATION = "\n  mutation Mutation($input: UpdateRatioPersonalAddonInput, $withAllowedAgeGroups: Boolean = false, $withCalculationSettings: Boolean = false, $withMandatorySettings: Boolean = false, $withMandatorySettingsRules: Boolean = false, $withMandatorySettingsRulesAccommodations: Boolean = false, $withMandatorySettingsRulesFamilyPackages: Boolean = false, $withMandatorySettingsRulesAccommodationAddons: Boolean = false, $withMandatorySettingsRulesAgeGroups: Boolean = false, $withMandatorySettingsRulesAgeFilter: Boolean = false, $withMandatorySettingsRulesTravelDates: Boolean = false) {\n    personalAddon: updateRatioPersonalAddon(input: $input) {\n      id\n      ratioServiceNo\n      name\n      label\n      info\n      allowedAgeGroups @include(if: $withAllowedAgeGroups) {\n        id\n        name\n        type\n        icon\n        minAge\n        maxAge\n      }\n      calculationSettings @include(if: $withCalculationSettings) {\n        id\n        type\n        considerHotelNights\n      }\n      mandatorySettings @include(if: $withMandatorySettings) {\n        id\n        isMandatory\n        useRules\n        rules @include(if: $withMandatorySettingsRules) {\n          id\n          checkAccommodationTypes\n          accommodations @include(if: $withMandatorySettingsRulesAccommodations) {\n            id\n            ratioPackageNo\n            name\n            label\n            info\n            isFamilyPackageAccommodation\n            isBabyPackage\n          }\n          familyPackages @include(if: $withMandatorySettingsRulesFamilyPackages) {\n            id\n            ratioServiceNo\n            name\n            label\n            info\n          }\n          checkAccommodationAddons\n          accommodationAddons @include(if: $withMandatorySettingsRulesAccommodationAddons) {\n            id\n            ratioServiceNo\n            name\n            label\n            info\n          }\n          checkAgeGroups\n          ageGroups @include(if: $withMandatorySettingsRulesAgeGroups) {\n            id\n            name\n            type\n            icon\n            minAge\n            maxAge\n          }\n          useAgeFilter\n          ageFilter @include(if: $withMandatorySettingsRulesAgeFilter) {\n            id\n            minAge\n            maxAge\n          }\n          checkDateRange\n          startDate\n          endDate\n          checkTravelDate\n          travelDates @include(if: $withMandatorySettingsRulesTravelDates) {\n            id\n            dateNo\n            startDate\n            endDate\n            includesExtension\n            json\n          }\n        }\n      }\n    }\n  }";
// language=GraphQL
var DELETE_PERSONAL_ADDON_MUTATION = "\n  mutation Mutation($input: DeleteRatioPersonalAddonInput) {\n    deleteRatioPersonalAddon(input: $input) {\n      success\n    }\n  }";
// language=GraphQL
var FORCE_DELETE_PERSONAL_ADDON_MUTATION = "\n  mutation Mutation($input: DeleteRatioPersonalAddonInput) {\n    forceDeleteRatioPersonalAddon(input: $input) {\n      success\n    }\n  }";
// language=GraphQL
var ADD_PERSONAL_ADDON_ALLOWED_AGE_GROUPS_MUTATION = "\n  mutation Mutation($input: addRatioPersonalAddonAllowedAgeGroupsInput) {\n    addRatioPersonalAddonAllowedAgeGroups(input: $input) {\n      id\n      allowedAgeGroupIds\n    }\n  }";
// language=GraphQL
var REMOVE_PERSONAL_ADDON_ALLOWED_AGE_GROUPS_MUTATION = "\n  mutation Mutation($input: removeRatioPersonalAddonAllowedAgeGroupsInput) {\n    removeRatioPersonalAddonAllowedAgeGroups(input: $input) {\n      id\n      allowedAgeGroupIds\n    }\n  }";
// language=GraphQL
var CREATE_PERSONAL_ADDON_ALLOWED_AGE_GROUPS_MUTATION = "\n  mutation Mutation($input: createRatioPersonalAddonAllowedAgeGroupsInput) {\n    createRatioPersonalAddonAllowedAgeGroups(input: $input) {\n      id\n      allowedAgeGroupIds\n    }\n  }";
// language=GraphQL
var DELETE_PERSONAL_ADDON_ALLOWED_AGE_GROUPS_MUTATION = "\n  mutation Mutation($input: deleteRatioPersonalAddonAllowedAgeGroupsInput) {\n    deleteRatioPersonalAddonAllowedAgeGroups(input: $input) {\n      id\n      allowedAgeGroupIds\n    }\n  }";
// language=GraphQL
var PERSONAL_ADDONS_DEPENDENTS_QUERY = "query Query($id: ID!, $withRatioTravels: Boolean = false, $withTravellers: Boolean = false) {\n  groupedDependents: ratioPersonalAddonDependents(id: $id) {\n    ratioTravels @include(if: $withRatioTravels) {\n      id\n      catalogCode\n      travelCode\n      destination\n      name\n      transportType\n      transportTypeLabel\n      importDateTime\n      importStatus    }\n    travellers @include(if: $withTravellers) {\n      id\n      salutation\n      firstName\n      lastName\n      birthday\n      nationality\n      email\n      phone\n      address\n      addressNumber\n      addressAddition\n      zip\n      city\n      country\n    }\n  }\n}";

// EXTERNAL MODULE: ./src/entities/travelPricingAgeGroup/entity.ts + 3 modules
var entity = __webpack_require__(65966);
// EXTERNAL MODULE: ./src/entities/travelPricingServiceCalculationSettings/entity.ts + 3 modules
var travelPricingServiceCalculationSettings_entity = __webpack_require__(49005);
// EXTERNAL MODULE: ./src/entities/travelPricingMandatorySettings/entity.ts + 3 modules
var travelPricingMandatorySettings_entity = __webpack_require__(28967);
;// CONCATENATED MODULE: ./src/entities/ratioPersonalAddon/model.ts




var ratioPersonalAddonModel = {
    name: "personalAddon",
    namePlural: "personalAddons",
    uniqueName: "ratioPersonalAddon",
    uniqueNamePlural: "ratioPersonalAddons",
    path: "travel/pricing/adaptors/ratio/personal_addon",
    baseUrl: "/travel/pricing/adaptors/ratio/personal_addons",
    translationPrefix: "entities:ratioPersonalAddon.",
    getDisplayName: function(values) {
        return values.label;
    },
    gql: {
        getAll: ALL_PERSONAL_ADDONS_QUERY,
        getSingle: SINGLE_PERSONAL_ADDON_QUERY,
        create: CREATE_PERSONAL_ADDON_MUTATION,
        update: UPDATE_PERSONAL_ADDON_MUTATION,
        delete: DELETE_PERSONAL_ADDON_MUTATION,
        forceDelete: FORCE_DELETE_PERSONAL_ADDON_MUTATION
    },
    attributes: {
        ratioServiceNo: {
            name: "ratioServiceNo",
            label: "entities:ratioPersonalAddon.attributes.ratioServiceNo.label",
            type: "value",
            dataType: "string",
            defaultInput: true,
            inputType: "hidden",
            validationType: "string",
            validations: [
                {
                    type: "required"
                }, 
            ]
        },
        name: {
            name: "name",
            label: "entities:ratioPersonalAddon.attributes.name.label",
            type: "value",
            dataType: "string",
            defaultInput: true,
            inputType: "hidden",
            validationType: "string",
            validations: [
                {
                    type: "required"
                }, 
            ]
        },
        label: {
            name: "label",
            label: "entities:ratioPersonalAddon.attributes.label.label",
            type: "value",
            dataType: "string",
            defaultInput: true,
            inputType: "text",
            validationType: "string",
            validations: [
                {
                    type: "required"
                }, 
            ]
        },
        info: {
            name: "info",
            label: "entities:ratioPersonalAddon.attributes.info.label",
            type: "value",
            dataType: "string",
            defaultInput: true,
            inputType: "textarea",
            maxLength: 255,
            validationType: "string",
            validations: []
        },
        allowedAgeGroups: {
            name: "allowedAgeGroups",
            label: "entities:ratioPersonalAddon.attributes.allowedAgeGroups.label",
            type: "entityCollection",
            dataType: "[any]",
            getEntity: function() {
                return entity/* default */.Z;
            },
            defaultInput: false,
            inputType: "text",
            validationType: "string",
            validations: []
        },
        calculationSettings: {
            name: "calculationSettings",
            label: "entities:ratioPersonalAddon.attributes.calculationSettings.label",
            type: "entityObject",
            dataType: "any",
            getEntity: function() {
                return travelPricingServiceCalculationSettings_entity/* default */.Z;
            },
            defaultInput: false,
            inputType: "select",
            validationType: "string",
            validations: []
        },
        mandatorySettings: {
            name: "mandatorySettings",
            label: "entities:ratioPersonalAddon.attributes.mandatorySettings.label",
            type: "entityObject",
            dataType: "any",
            getEntity: function() {
                return travelPricingMandatorySettings_entity/* default */.Z;
            },
            defaultInput: false,
            inputType: "select",
            validationType: "string",
            validations: []
        }
    }
};
/* harmony default export */ var model = (ratioPersonalAddonModel);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(20414);
// EXTERNAL MODULE: ./src/entities/lib.ts
var lib = __webpack_require__(23480);
// EXTERNAL MODULE: ./src/lib/api/graphQLClient.ts
var graphQLClient = __webpack_require__(40112);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/swr/dist/index.mjs
var dist = __webpack_require__(8100);
// EXTERNAL MODULE: ./src/lib/helpers/helpers.ts
var helpers = __webpack_require__(15778);
;// CONCATENATED MODULE: ./src/entities/ratioPersonalAddon/repository.ts










var hydrateObjects = function(objects) {
    return objects.map(function(object) {
        return (0,lib/* hydrateEntityObject */.b)(model, object);
    });
};
var hydrateObject = function(object) {
    return (0,lib/* hydrateEntityObject */.b)(model, object);
};
var ratioPersonalAddonRepository = {
    getObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    id: id
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(SINGLE_PERSONAL_ADDON_QUERY, variables).then(function(data) {
                        return hydrateObject(data.personalAddon);
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }(),
    getObjects: /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        var includes;
        var _arguments = arguments;
        return (0,tslib_es6.__generator)(this, function(_state) {
            includes = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : {};
            return [
                2,
                graphQLClient/* default.request */.Z.request(ALL_PERSONAL_ADDONS_QUERY, includes).then(function(data) {
                    return hydrateObjects(data.personalAddons);
                })
            ];
        });
    }),
    useObject: function(id) {
        var includes = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        // eslint-disable-next-line react-hooks/exhaustive-deps
        var variables = (0,react.useMemo)(function() {
            return (0,_object_spread/* default */.Z)({
                id: id
            }, includes);
        }, [
            id
        ]);
        var ref = (0,dist/* default */.ZP)([
            SINGLE_PERSONAL_ADDON_QUERY,
            variables
        ], {
            revalidateOnFocus: false
        }), data = ref.data, error = ref.error, mutate = ref.mutate;
        return {
            object: !data ? data : hydrateObject(data.personalAddon),
            isLoading: !error && !data,
            isError: error,
            mutate: mutate
        };
    },
    useObjects: function() {
        var includes = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        // eslint-disable-next-line react-hooks/exhaustive-deps
        var variables = (0,react.useMemo)(function() {
            return includes;
        }, []);
        var ref = (0,dist/* default */.ZP)([
            ALL_PERSONAL_ADDONS_QUERY,
            variables
        ]), data = ref.data, error = ref.error, mutate = ref.mutate;
        return {
            objects: !data ? data : hydrateObjects(data.personalAddons),
            isLoading: !error && !data,
            isError: error,
            mutate: mutate
        };
    },
    getDependents: function(id, includes) {
        var includeVars = {};
        includes.forEach(function(include) {
            includeVars["with".concat((0,helpers/* uppercaseFirst */.AB)(include))] = true;
        });
        var variables = (0,_object_spread/* default */.Z)({
            id: id
        }, includeVars);
        return graphQLClient/* default.request */.Z.request(PERSONAL_ADDONS_DEPENDENTS_QUERY, variables).then(function(data) {
            return data.groupedDependents;
        });
    },
    useDependents: function(id, includes) {
        var includeVars = {};
        includes.forEach(function(include) {
            includeVars["with".concat((0,helpers/* uppercaseFirst */.AB)(include))] = true;
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
        var variables = (0,react.useMemo)(function() {
            return (0,_object_spread/* default */.Z)({
                id: id
            }, includeVars);
        }, [
            id
        ]);
        var ref = (0,dist/* default */.ZP)([
            PERSONAL_ADDONS_DEPENDENTS_QUERY,
            variables
        ], {
            revalidateOnFocus: false
        }), data = ref.data, error = ref.error, mutate = ref.mutate;
        return {
            data: !data ? data : data.groupedDependents,
            isLoading: !error && !data,
            isError: error,
            mutate: mutate
        };
    },
    createObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(data) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    input: data
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(CREATE_PERSONAL_ADDON_MUTATION, variables).then(function(data) {
                        return hydrateObject(data.personalAddon);
                    })
                ];
            });
        });
        return function(data) {
            return _ref.apply(this, arguments);
        };
    }(),
    updateObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(data) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    input: data
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(UPDATE_PERSONAL_ADDON_MUTATION, variables).then(function(data) {
                        return hydrateObject(data.personalAddon);
                    })
                ];
            });
        });
        return function(data) {
            return _ref.apply(this, arguments);
        };
    }(),
    deleteObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(DELETE_PERSONAL_ADDON_MUTATION, variables).then(function(data) {
                        return data.deleteRatioPersonalAddon;
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }(),
    forceDeleteObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(FORCE_DELETE_PERSONAL_ADDON_MUTATION, variables).then(function(data) {
                        return data.forceDeleteRatioPersonalAddon;
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }(),
    assignAllowedAgeGroups: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, itemIds) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        allowedAgeGroupIds: itemIds
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(ADD_PERSONAL_ADDON_ALLOWED_AGE_GROUPS_MUTATION, variables)
                ];
            });
        });
        return function(id, itemIds) {
            return _ref.apply(this, arguments);
        };
    }(),
    unassignAllowedAgeGroups: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, itemIds) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        allowedAgeGroupIds: itemIds
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(REMOVE_PERSONAL_ADDON_ALLOWED_AGE_GROUPS_MUTATION, variables)
                ];
            });
        });
        return function(id, itemIds) {
            return _ref.apply(this, arguments);
        };
    }(),
    createAllowedAgeGroups: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, items) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        allowedAgeGroups: items
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(CREATE_PERSONAL_ADDON_ALLOWED_AGE_GROUPS_MUTATION, variables)
                ];
            });
        });
        return function(id, items) {
            return _ref.apply(this, arguments);
        };
    }(),
    deleteAllowedAgeGroups: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, itemIds) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        allowedAgeGroupIds: itemIds
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(DELETE_PERSONAL_ADDON_ALLOWED_AGE_GROUPS_MUTATION, variables)
                ];
            });
        });
        return function(id, itemIds) {
            return _ref.apply(this, arguments);
        };
    }()
};
/* harmony default export */ var repository = (ratioPersonalAddonRepository);

;// CONCATENATED MODULE: ./src/entities/ratioPersonalAddon/entity.ts


var ratioPersonalAddonEntity = {
    model: model,
    repository: repository
};
/* harmony default export */ var ratioPersonalAddon_entity = (ratioPersonalAddonEntity);


/***/ }),

/***/ 52374:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ ratioPersonalDiscount_entity; }
});

;// CONCATENATED MODULE: ./src/entities/ratioPersonalDiscount/graphql.ts
// language=GraphQL
var ALL_PERSONAL_DISCOUNTS_QUERY = "query Query($withMandatorySettings: Boolean = false, $withMandatorySettingsRules: Boolean = false, $withMandatorySettingsRulesAccommodations: Boolean = false, $withMandatorySettingsRulesFamilyPackages: Boolean = false, $withMandatorySettingsRulesAccommodationAddons: Boolean = false, $withMandatorySettingsRulesAgeGroups: Boolean = false, $withMandatorySettingsRulesAgeFilter: Boolean = false, $withMandatorySettingsRulesTravelDates: Boolean = false) {\n  personalDiscounts: ratioPersonalDiscounts {\n    id\n    ratioServiceNo\n    name\n    label\n    info\n    mandatorySettings @include(if: $withMandatorySettings) {\n      id\n      isMandatory\n      useRules\n      rules @include(if: $withMandatorySettingsRules) {\n        id\n        checkAccommodationTypes\n        accommodations @include(if: $withMandatorySettingsRulesAccommodations) {\n          id\n          ratioPackageNo\n          name\n          label\n          info\n          isFamilyPackageAccommodation\n          isBabyPackage\n        }\n        familyPackages @include(if: $withMandatorySettingsRulesFamilyPackages) {\n          id\n          ratioServiceNo\n          name\n          label\n          info\n        }\n        checkAccommodationAddons\n        accommodationAddons @include(if: $withMandatorySettingsRulesAccommodationAddons) {\n          id\n          ratioServiceNo\n          name\n          label\n          info\n        }\n        checkAgeGroups\n        ageGroups @include(if: $withMandatorySettingsRulesAgeGroups) {\n          id\n          name\n          type\n          icon\n          minAge\n          maxAge\n        }\n        useAgeFilter\n        ageFilter @include(if: $withMandatorySettingsRulesAgeFilter) {\n          id\n          minAge\n          maxAge\n        }\n        checkDateRange\n        startDate\n        endDate\n        checkTravelDate\n        travelDates @include(if: $withMandatorySettingsRulesTravelDates) {\n          id\n          dateNo\n          startDate\n          endDate\n          includesExtension\n          json\n        }\n      }\n    }\n  }\n}";
// language=GraphQL
var SINGLE_PERSONAL_DISCOUNT_QUERY = "query Query($id: ID!, $withMandatorySettings: Boolean = false, $withMandatorySettingsRules: Boolean = false, $withMandatorySettingsRulesAccommodations: Boolean = false, $withMandatorySettingsRulesFamilyPackages: Boolean = false, $withMandatorySettingsRulesAccommodationAddons: Boolean = false, $withMandatorySettingsRulesAgeGroups: Boolean = false, $withMandatorySettingsRulesAgeFilter: Boolean = false, $withMandatorySettingsRulesTravelDates: Boolean = false) {\n  personalDiscount: ratioPersonalDiscount(id: $id) {\n    id\n    ratioServiceNo\n    name\n    label\n    info\n    mandatorySettings @include(if: $withMandatorySettings) {\n      id\n      isMandatory\n      useRules\n      rules @include(if: $withMandatorySettingsRules) {\n        id\n        checkAccommodationTypes\n        accommodations @include(if: $withMandatorySettingsRulesAccommodations) {\n          id\n          ratioPackageNo\n          name\n          label\n          info\n          isFamilyPackageAccommodation\n          isBabyPackage\n        }\n        familyPackages @include(if: $withMandatorySettingsRulesFamilyPackages) {\n          id\n          ratioServiceNo\n          name\n          label\n          info\n        }\n        checkAccommodationAddons\n        accommodationAddons @include(if: $withMandatorySettingsRulesAccommodationAddons) {\n          id\n          ratioServiceNo\n          name\n          label\n          info\n        }\n        checkAgeGroups\n        ageGroups @include(if: $withMandatorySettingsRulesAgeGroups) {\n          id\n          name\n          type\n          icon\n          minAge\n          maxAge\n        }\n        useAgeFilter\n        ageFilter @include(if: $withMandatorySettingsRulesAgeFilter) {\n          id\n          minAge\n          maxAge\n        }\n        checkDateRange\n        startDate\n        endDate\n        checkTravelDate\n        travelDates @include(if: $withMandatorySettingsRulesTravelDates) {\n          id\n          dateNo\n          startDate\n          endDate\n          includesExtension\n          json\n        }\n      }\n    }\n  }\n}";
// language=GraphQL
var CREATE_PERSONAL_DISCOUNT_MUTATION = "\n  mutation Mutation($input: CreateRatioPersonalDiscountInput, $withMandatorySettings: Boolean = false, $withMandatorySettingsRules: Boolean = false, $withMandatorySettingsRulesAccommodations: Boolean = false, $withMandatorySettingsRulesFamilyPackages: Boolean = false, $withMandatorySettingsRulesAccommodationAddons: Boolean = false, $withMandatorySettingsRulesAgeGroups: Boolean = false, $withMandatorySettingsRulesAgeFilter: Boolean = false, $withMandatorySettingsRulesTravelDates: Boolean = false) {\n    personalDiscount: createRatioPersonalDiscount(input: $input) {\n      id\n      ratioServiceNo\n      name\n      label\n      info\n      mandatorySettings @include(if: $withMandatorySettings) {\n        id\n        isMandatory\n        useRules\n        rules @include(if: $withMandatorySettingsRules) {\n          id\n          checkAccommodationTypes\n          accommodations @include(if: $withMandatorySettingsRulesAccommodations) {\n            id\n            ratioPackageNo\n            name\n            label\n            info\n            isFamilyPackageAccommodation\n            isBabyPackage\n          }\n          familyPackages @include(if: $withMandatorySettingsRulesFamilyPackages) {\n            id\n            ratioServiceNo\n            name\n            label\n            info\n          }\n          checkAccommodationAddons\n          accommodationAddons @include(if: $withMandatorySettingsRulesAccommodationAddons) {\n            id\n            ratioServiceNo\n            name\n            label\n            info\n          }\n          checkAgeGroups\n          ageGroups @include(if: $withMandatorySettingsRulesAgeGroups) {\n            id\n            name\n            type\n            icon\n            minAge\n            maxAge\n          }\n          useAgeFilter\n          ageFilter @include(if: $withMandatorySettingsRulesAgeFilter) {\n            id\n            minAge\n            maxAge\n          }\n          checkDateRange\n          startDate\n          endDate\n          checkTravelDate\n          travelDates @include(if: $withMandatorySettingsRulesTravelDates) {\n            id\n            dateNo\n            startDate\n            endDate\n            includesExtension\n            json\n          }\n        }\n      }\n    }\n  }";
// language=GraphQL
var UPDATE_PERSONAL_DISCOUNT_MUTATION = "\n  mutation Mutation($input: UpdateRatioPersonalDiscountInput, $withMandatorySettings: Boolean = false, $withMandatorySettingsRules: Boolean = false, $withMandatorySettingsRulesAccommodations: Boolean = false, $withMandatorySettingsRulesFamilyPackages: Boolean = false, $withMandatorySettingsRulesAccommodationAddons: Boolean = false, $withMandatorySettingsRulesAgeGroups: Boolean = false, $withMandatorySettingsRulesAgeFilter: Boolean = false, $withMandatorySettingsRulesTravelDates: Boolean = false) {\n    personalDiscount: updateRatioPersonalDiscount(input: $input) {\n      id\n      ratioServiceNo\n      name\n      label\n      info\n      mandatorySettings @include(if: $withMandatorySettings) {\n        id\n        isMandatory\n        useRules\n        rules @include(if: $withMandatorySettingsRules) {\n          id\n          checkAccommodationTypes\n          accommodations @include(if: $withMandatorySettingsRulesAccommodations) {\n            id\n            ratioPackageNo\n            name\n            label\n            info\n            isFamilyPackageAccommodation\n            isBabyPackage\n          }\n          familyPackages @include(if: $withMandatorySettingsRulesFamilyPackages) {\n            id\n            ratioServiceNo\n            name\n            label\n            info\n          }\n          checkAccommodationAddons\n          accommodationAddons @include(if: $withMandatorySettingsRulesAccommodationAddons) {\n            id\n            ratioServiceNo\n            name\n            label\n            info\n          }\n          checkAgeGroups\n          ageGroups @include(if: $withMandatorySettingsRulesAgeGroups) {\n            id\n            name\n            type\n            icon\n            minAge\n            maxAge\n          }\n          useAgeFilter\n          ageFilter @include(if: $withMandatorySettingsRulesAgeFilter) {\n            id\n            minAge\n            maxAge\n          }\n          checkDateRange\n          startDate\n          endDate\n          checkTravelDate\n          travelDates @include(if: $withMandatorySettingsRulesTravelDates) {\n            id\n            dateNo\n            startDate\n            endDate\n            includesExtension\n            json\n          }\n        }\n      }\n    }\n  }";
// language=GraphQL
var DELETE_PERSONAL_DISCOUNT_MUTATION = "\n  mutation Mutation($input: DeleteRatioPersonalDiscountInput) {\n    deleteRatioPersonalDiscount(input: $input) {\n      success\n    }\n  }";
// language=GraphQL
var FORCE_DELETE_PERSONAL_DISCOUNT_MUTATION = "\n  mutation Mutation($input: DeleteRatioPersonalDiscountInput) {\n    forceDeleteRatioPersonalDiscount(input: $input) {\n      success\n    }\n  }";
// language=GraphQL
var PERSONAL_DISCOUNTS_DEPENDENTS_QUERY = "query Query($id: ID!, $withRatioTravels: Boolean = false) {\n  groupedDependents: ratioPersonalDiscountDependents(id: $id) {\n    ratioTravels @include(if: $withRatioTravels) {\n      id\n      catalogCode\n      travelCode\n      destination\n      name\n      transportType\n      transportTypeLabel\n      importDateTime\n      importStatus    }\n  }\n}";

// EXTERNAL MODULE: ./src/entities/travelPricingMandatorySettings/entity.ts + 3 modules
var entity = __webpack_require__(28967);
;// CONCATENATED MODULE: ./src/entities/ratioPersonalDiscount/model.ts


var ratioPersonalDiscountModel = {
    name: "personalDiscount",
    namePlural: "personalDiscounts",
    uniqueName: "ratioPersonalDiscount",
    uniqueNamePlural: "ratioPersonalDiscounts",
    path: "travel/pricing/adaptors/ratio/personal_discount",
    baseUrl: "/travel/pricing/adaptors/ratio/personal_discounts",
    translationPrefix: "entities:ratioPersonalDiscount.",
    getDisplayName: function(values) {
        return values.label;
    },
    gql: {
        getAll: ALL_PERSONAL_DISCOUNTS_QUERY,
        getSingle: SINGLE_PERSONAL_DISCOUNT_QUERY,
        create: CREATE_PERSONAL_DISCOUNT_MUTATION,
        update: UPDATE_PERSONAL_DISCOUNT_MUTATION,
        delete: DELETE_PERSONAL_DISCOUNT_MUTATION,
        forceDelete: FORCE_DELETE_PERSONAL_DISCOUNT_MUTATION
    },
    attributes: {
        ratioServiceNo: {
            name: "ratioServiceNo",
            label: "entities:ratioPersonalDiscount.attributes.ratioServiceNo.label",
            type: "value",
            dataType: "number",
            defaultInput: true,
            inputType: "hidden",
            validationType: "string",
            validations: [
                {
                    type: "required"
                }, 
            ]
        },
        name: {
            name: "name",
            label: "entities:ratioPersonalDiscount.attributes.name.label",
            type: "value",
            dataType: "string",
            defaultInput: true,
            inputType: "hidden",
            validationType: "string",
            validations: [
                {
                    type: "required"
                }, 
            ]
        },
        label: {
            name: "label",
            label: "entities:ratioPersonalDiscount.attributes.label.label",
            type: "value",
            dataType: "string",
            defaultInput: true,
            inputType: "text",
            validationType: "string",
            validations: [
                {
                    type: "required"
                }, 
            ]
        },
        info: {
            name: "info",
            label: "entities:ratioPersonalDiscount.attributes.info.label",
            type: "value",
            dataType: "string",
            defaultInput: true,
            inputType: "textarea",
            maxLength: 255,
            validationType: "string",
            validations: []
        },
        mandatorySettings: {
            name: "mandatorySettings",
            label: "entities:ratioPersonalDiscount.attributes.mandatorySettings.label",
            type: "entityObject",
            dataType: "any",
            getEntity: function() {
                return entity/* default */.Z;
            },
            defaultInput: false,
            inputType: "select",
            validationType: "string",
            validations: []
        }
    }
};
/* harmony default export */ var model = (ratioPersonalDiscountModel);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(20414);
// EXTERNAL MODULE: ./src/entities/lib.ts
var lib = __webpack_require__(23480);
// EXTERNAL MODULE: ./src/lib/api/graphQLClient.ts
var graphQLClient = __webpack_require__(40112);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/swr/dist/index.mjs
var dist = __webpack_require__(8100);
// EXTERNAL MODULE: ./src/lib/helpers/helpers.ts
var helpers = __webpack_require__(15778);
;// CONCATENATED MODULE: ./src/entities/ratioPersonalDiscount/repository.ts










var hydrateObjects = function(objects) {
    return objects.map(function(object) {
        return (0,lib/* hydrateEntityObject */.b)(model, object);
    });
};
var hydrateObject = function(object) {
    return (0,lib/* hydrateEntityObject */.b)(model, object);
};
var ratioPersonalDiscountRepository = {
    getObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    id: id
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(SINGLE_PERSONAL_DISCOUNT_QUERY, variables).then(function(data) {
                        return hydrateObject(data.personalDiscount);
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }(),
    getObjects: /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        var includes;
        var _arguments = arguments;
        return (0,tslib_es6.__generator)(this, function(_state) {
            includes = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : {};
            return [
                2,
                graphQLClient/* default.request */.Z.request(ALL_PERSONAL_DISCOUNTS_QUERY, includes).then(function(data) {
                    return hydrateObjects(data.personalDiscounts);
                })
            ];
        });
    }),
    useObject: function(id) {
        var includes = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        // eslint-disable-next-line react-hooks/exhaustive-deps
        var variables = (0,react.useMemo)(function() {
            return (0,_object_spread/* default */.Z)({
                id: id
            }, includes);
        }, [
            id
        ]);
        var ref = (0,dist/* default */.ZP)([
            SINGLE_PERSONAL_DISCOUNT_QUERY,
            variables
        ], {
            revalidateOnFocus: false
        }), data = ref.data, error = ref.error, mutate = ref.mutate;
        return {
            object: !data ? data : hydrateObject(data.personalDiscount),
            isLoading: !error && !data,
            isError: error,
            mutate: mutate
        };
    },
    useObjects: function() {
        var includes = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        // eslint-disable-next-line react-hooks/exhaustive-deps
        var variables = (0,react.useMemo)(function() {
            return includes;
        }, []);
        var ref = (0,dist/* default */.ZP)([
            ALL_PERSONAL_DISCOUNTS_QUERY,
            variables
        ]), data = ref.data, error = ref.error, mutate = ref.mutate;
        return {
            objects: !data ? data : hydrateObjects(data.personalDiscounts),
            isLoading: !error && !data,
            isError: error,
            mutate: mutate
        };
    },
    getDependents: function(id, includes) {
        var includeVars = {};
        includes.forEach(function(include) {
            includeVars["with".concat((0,helpers/* uppercaseFirst */.AB)(include))] = true;
        });
        var variables = (0,_object_spread/* default */.Z)({
            id: id
        }, includeVars);
        return graphQLClient/* default.request */.Z.request(PERSONAL_DISCOUNTS_DEPENDENTS_QUERY, variables).then(function(data) {
            return data.groupedDependents;
        });
    },
    useDependents: function(id, includes) {
        var includeVars = {};
        includes.forEach(function(include) {
            includeVars["with".concat((0,helpers/* uppercaseFirst */.AB)(include))] = true;
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
        var variables = (0,react.useMemo)(function() {
            return (0,_object_spread/* default */.Z)({
                id: id
            }, includeVars);
        }, [
            id
        ]);
        var ref = (0,dist/* default */.ZP)([
            PERSONAL_DISCOUNTS_DEPENDENTS_QUERY,
            variables
        ], {
            revalidateOnFocus: false
        }), data = ref.data, error = ref.error, mutate = ref.mutate;
        return {
            data: !data ? data : data.groupedDependents,
            isLoading: !error && !data,
            isError: error,
            mutate: mutate
        };
    },
    createObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(data) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    input: data
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(CREATE_PERSONAL_DISCOUNT_MUTATION, variables).then(function(data) {
                        return hydrateObject(data.personalDiscount);
                    })
                ];
            });
        });
        return function(data) {
            return _ref.apply(this, arguments);
        };
    }(),
    updateObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(data) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    input: data
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(UPDATE_PERSONAL_DISCOUNT_MUTATION, variables).then(function(data) {
                        return hydrateObject(data.personalDiscount);
                    })
                ];
            });
        });
        return function(data) {
            return _ref.apply(this, arguments);
        };
    }(),
    deleteObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(DELETE_PERSONAL_DISCOUNT_MUTATION, variables).then(function(data) {
                        return data.deleteRatioPersonalDiscount;
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }(),
    forceDeleteObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(FORCE_DELETE_PERSONAL_DISCOUNT_MUTATION, variables).then(function(data) {
                        return data.forceDeleteRatioPersonalDiscount;
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }()
};
/* harmony default export */ var repository = (ratioPersonalDiscountRepository);

;// CONCATENATED MODULE: ./src/entities/ratioPersonalDiscount/entity.ts


var ratioPersonalDiscountEntity = {
    model: model,
    repository: repository
};
/* harmony default export */ var ratioPersonalDiscount_entity = (ratioPersonalDiscountEntity);


/***/ }),

/***/ 81065:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ ratioTravel_entity; }
});

;// CONCATENATED MODULE: ./src/entities/ratioTravel/graphql.ts
// language=GraphQL
var ALL_TRAVELS_QUERY = "query Query($withRatioCatalogBundle: Boolean = false, $withDates: Boolean = false, $withDatesAvailabilityStatus: Boolean = false, $withDatesAvailabilityStatusTenantSettings: Boolean = false, $withDatesExtensionBaseDate: Boolean = false, $withDatesExtensionBaseDateAvailabilityStatus: Boolean = false, $withDatesExtensionBaseDateExtensionBaseDate: Boolean = false, $withDatesExtensionBaseDateExtension: Boolean = false, $withDatesExtensionBaseDatePackageSettings: Boolean = false, $withDatesExtensionBaseDateExtensions: Boolean = false, $withDatesExtension: Boolean = false, $withDatesExtensionTravelExtension: Boolean = false, $withDatesExtensionAccommodationMapItems: Boolean = false, $withDatesPackageSettings: Boolean = false, $withDatesExtensions: Boolean = false, $withDatesExtensionsTravelExtension: Boolean = false, $withDatesExtensionsAccommodationMapItems: Boolean = false, $withAccommodations: Boolean = false, $withAccommodationsCapacitySettings: Boolean = false, $withAccommodationsCapacitySettingsAgeGroupCapacities: Boolean = false, $withAccommodationsCapacitySettingsAgeGroupedTotalCapacities: Boolean = false, $withAccommodationsCapacitySettingsPartialOccupancyAllowedAgeGroups: Boolean = false, $withAccommodationsAddons: Boolean = false, $withAccommodationsAddonsCalculationSettings: Boolean = false, $withAccommodationsAddonsMandatorySettings: Boolean = false, $withExtensionAccommodations: Boolean = false, $withFamilyPackages: Boolean = false, $withFamilyPackagesAccommodation: Boolean = false, $withFamilyPackagesAccommodationCapacitySettings: Boolean = false, $withFamilyPackagesAccommodationAddons: Boolean = false, $withFamilyPackagesCapacitySettings: Boolean = false, $withFamilyPackagesCapacitySettingsAgeGroupCapacities: Boolean = false, $withFamilyPackagesCapacitySettingsAgeGroupedTotalCapacities: Boolean = false, $withFamilyPackagesCapacitySettingsPartialOccupancyAllowedAgeGroups: Boolean = false, $withFamilyPackagesAddons: Boolean = false, $withFamilyPackagesAddonsCalculationSettings: Boolean = false, $withFamilyPackagesAddonsMandatorySettings: Boolean = false, $withPersonalAddons: Boolean = false, $withPersonalAddonsAllowedAgeGroups: Boolean = false, $withPersonalAddonsCalculationSettings: Boolean = false, $withPersonalAddonsMandatorySettings: Boolean = false, $withPersonalAddonsMandatorySettingsRules: Boolean = false, $withAccommodationAddons: Boolean = false, $withAccommodationAddonsCalculationSettings: Boolean = false, $withAccommodationAddonsMandatorySettings: Boolean = false, $withAccommodationAddonsMandatorySettingsRules: Boolean = false, $withBookingAddons: Boolean = false, $withBookingAddonsCalculationSettings: Boolean = false, $withBookingAddonsMandatorySettings: Boolean = false, $withBookingAddonsMandatorySettingsRules: Boolean = false, $withCollectiveAddons: Boolean = false, $withCollectiveAddonsAgeGroupServices: Boolean = false, $withCollectiveAddonsAgeGroupServicesAgeGroup: Boolean = false, $withCollectiveAddonsCalculationSettings: Boolean = false, $withCollectiveAddonsMandatorySettings: Boolean = false, $withCollectiveAddonsMandatorySettingsRules: Boolean = false, $withExtensions: Boolean = false, $withExtensionsTravelExtension: Boolean = false, $withExtensionsTravelExtensionHighlights: Boolean = false, $withExtensionsTravelExtensionImage: Boolean = false, $withExtensionsAccommodationMapItems: Boolean = false, $withExtensionsAccommodationMapItemsBaseAccommodation: Boolean = false, $withExtensionsAccommodationMapItemsExtensionAccommodation: Boolean = false, $withPersonalDiscounts: Boolean = false, $withPersonalDiscountsMandatorySettings: Boolean = false, $withPersonalDiscountsMandatorySettingsRules: Boolean = false) {\n  travels: ratioTravels {\n    id\n    ratioCatalogBundle @include(if: $withRatioCatalogBundle) {\n      id\n      catalogCode\n      travelCode\n      json\n    }\n    catalogCode\n    travelCode\n    destination\n    name\n    transportType\n    transportTypeLabel\n    dates @include(if: $withDates) {\n      id\n      dateNo\n      startDate\n      endDate\n      availabilityStatus @include(if: $withDatesAvailabilityStatus) {\n        id\n        label\n        status\n        isDefaultStatus\n        isDefaultWaitlistFallback\n        tenantSettings @include(if: $withDatesAvailabilityStatusTenantSettings) {\n          id\n          label\n          info\n          switchToStatusInfo\n          submitButtonLabel\n        }\n      }\n      includesExtension\n      extensionBaseDate @include(if: $withDatesExtensionBaseDate) {\n        id\n        dateNo\n        startDate\n        endDate\n        availabilityStatus @include(if: $withDatesExtensionBaseDateAvailabilityStatus) {\n          id\n          label\n          status\n          isDefaultStatus\n          isDefaultWaitlistFallback\n        }\n        includesExtension\n        extensionBaseDate @include(if: $withDatesExtensionBaseDateExtensionBaseDate) {\n          id\n          dateNo\n          startDate\n          endDate\n          includesExtension\n          json\n        }\n        extension @include(if: $withDatesExtensionBaseDateExtension) {\n          id\n          label\n          info\n        }\n        packageSettings @include(if: $withDatesExtensionBaseDatePackageSettings) {\n          id\n          ratioPackageNo\n          price\n          availabilityStatus\n        }\n        json\n        extensions @include(if: $withDatesExtensionBaseDateExtensions) {\n          id\n          label\n          info\n        }\n      }\n      extension @include(if: $withDatesExtension) {\n        id\n        label\n        info\n        travelExtension @include(if: $withDatesExtensionTravelExtension) {\n          id\n          duration\n          name\n          description\n        }\n        accommodationMapItems @include(if: $withDatesExtensionAccommodationMapItems) {\n          id\n        }\n      }\n      packageSettings @include(if: $withDatesPackageSettings) {\n        id\n        ratioPackageNo\n        price\n        availabilityStatus\n      }\n      json\n      extensions @include(if: $withDatesExtensions) {\n        id\n        label\n        info\n        travelExtension @include(if: $withDatesExtensionsTravelExtension) {\n          id\n          duration\n          name\n          description\n        }\n        accommodationMapItems @include(if: $withDatesExtensionsAccommodationMapItems) {\n          id\n        }\n      }\n    }\n    accommodations @include(if: $withAccommodations) {\n      id\n      ratioPackageNo\n      name\n      label\n      info\n      isFamilyPackageAccommodation\n      isBabyPackage\n      capacitySettings @include(if: $withAccommodationsCapacitySettings) {\n        id\n        totalCapacity\n        rangesAllowed\n        ageGroupCapacities @include(if: $withAccommodationsCapacitySettingsAgeGroupCapacities) {\n          id\n          minCapacity\n          maxCapacity\n        }\n        ageGroupedTotalCapacities @include(if: $withAccommodationsCapacitySettingsAgeGroupedTotalCapacities) {\n          id\n          capacity\n        }\n        partialOccupancyAllowed\n        partialOccupancyAllowedAgeGroups @include(if: $withAccommodationsCapacitySettingsPartialOccupancyAllowedAgeGroups) {\n          id\n          name\n          type\n          icon\n          minAge\n          maxAge\n        }\n      }\n      addons @include(if: $withAccommodationsAddons) {\n        id\n        ratioServiceNo\n        name\n        label\n        info\n        calculationSettings @include(if: $withAccommodationsAddonsCalculationSettings) {\n          id\n          type\n          considerHotelNights\n        }\n        mandatorySettings @include(if: $withAccommodationsAddonsMandatorySettings) {\n          id\n          isMandatory\n          useRules\n        }\n      }\n    }\n    extensionAccommodations @include(if: $withExtensionAccommodations) {\n      id\n      ratioPackageNo\n      name\n      label\n      info\n      extensionAccommodationServiceNo\n    }\n    familyPackages @include(if: $withFamilyPackages) {\n      id\n      ratioServiceNo\n      accommodation @include(if: $withFamilyPackagesAccommodation) {\n        id\n        ratioPackageNo\n        name\n        label\n        info\n        isFamilyPackageAccommodation\n        isBabyPackage\n        capacitySettings @include(if: $withFamilyPackagesAccommodationCapacitySettings) {\n          id\n          totalCapacity\n          rangesAllowed\n          partialOccupancyAllowed\n        }\n        addons @include(if: $withFamilyPackagesAccommodationAddons) {\n          id\n          ratioServiceNo\n          name\n          label\n          info\n        }\n      }\n      name\n      label\n      info\n      capacitySettings @include(if: $withFamilyPackagesCapacitySettings) {\n        id\n        totalCapacity\n        rangesAllowed\n        ageGroupCapacities @include(if: $withFamilyPackagesCapacitySettingsAgeGroupCapacities) {\n          id\n          minCapacity\n          maxCapacity\n        }\n        ageGroupedTotalCapacities @include(if: $withFamilyPackagesCapacitySettingsAgeGroupedTotalCapacities) {\n          id\n          capacity\n        }\n        partialOccupancyAllowed\n        partialOccupancyAllowedAgeGroups @include(if: $withFamilyPackagesCapacitySettingsPartialOccupancyAllowedAgeGroups) {\n          id\n          name\n          type\n          icon\n          minAge\n          maxAge\n        }\n      }\n      addons @include(if: $withFamilyPackagesAddons) {\n        id\n        ratioServiceNo\n        name\n        label\n        info\n        calculationSettings @include(if: $withFamilyPackagesAddonsCalculationSettings) {\n          id\n          type\n          considerHotelNights\n        }\n        mandatorySettings @include(if: $withFamilyPackagesAddonsMandatorySettings) {\n          id\n          isMandatory\n          useRules\n        }\n      }\n    }\n    personalAddons @include(if: $withPersonalAddons) {\n      id\n      ratioServiceNo\n      name\n      label\n      info\n      allowedAgeGroups @include(if: $withPersonalAddonsAllowedAgeGroups) {\n        id\n        name\n        type\n        icon\n        minAge\n        maxAge\n      }\n      calculationSettings @include(if: $withPersonalAddonsCalculationSettings) {\n        id\n        type\n        considerHotelNights\n      }\n      mandatorySettings @include(if: $withPersonalAddonsMandatorySettings) {\n        id\n        isMandatory\n        useRules\n        rules @include(if: $withPersonalAddonsMandatorySettingsRules) {\n          id\n          checkAccommodationTypes\n          checkAccommodationAddons\n          checkAgeGroups\n          useAgeFilter\n          checkDateRange\n          startDate\n          endDate\n          checkTravelDate\n        }\n      }\n    }\n    accommodationAddons @include(if: $withAccommodationAddons) {\n      id\n      ratioServiceNo\n      name\n      label\n      info\n      calculationSettings @include(if: $withAccommodationAddonsCalculationSettings) {\n        id\n        type\n        considerHotelNights\n      }\n      mandatorySettings @include(if: $withAccommodationAddonsMandatorySettings) {\n        id\n        isMandatory\n        useRules\n        rules @include(if: $withAccommodationAddonsMandatorySettingsRules) {\n          id\n          checkAccommodationTypes\n          checkAccommodationAddons\n          checkAgeGroups\n          useAgeFilter\n          checkDateRange\n          startDate\n          endDate\n          checkTravelDate\n        }\n      }\n    }\n    bookingAddons @include(if: $withBookingAddons) {\n      id\n      ratioServiceNo\n      name\n      label\n      info\n      calculationSettings @include(if: $withBookingAddonsCalculationSettings) {\n        id\n        type\n        considerHotelNights\n      }\n      mandatorySettings @include(if: $withBookingAddonsMandatorySettings) {\n        id\n        isMandatory\n        useRules\n        rules @include(if: $withBookingAddonsMandatorySettingsRules) {\n          id\n          checkAccommodationTypes\n          checkAccommodationAddons\n          checkAgeGroups\n          useAgeFilter\n          checkDateRange\n          startDate\n          endDate\n          checkTravelDate\n        }\n      }\n    }\n    collectiveAddons @include(if: $withCollectiveAddons) {\n      id\n      label\n      info\n      ageGroupServices @include(if: $withCollectiveAddonsAgeGroupServices) {\n        id\n        ageGroup @include(if: $withCollectiveAddonsAgeGroupServicesAgeGroup) {\n          id\n          name\n          type\n          icon\n          minAge\n          maxAge\n        }\n        ratioServiceNo\n      }\n      calculationSettings @include(if: $withCollectiveAddonsCalculationSettings) {\n        id\n        type\n        considerHotelNights\n      }\n      mandatorySettings @include(if: $withCollectiveAddonsMandatorySettings) {\n        id\n        isMandatory\n        useRules\n        rules @include(if: $withCollectiveAddonsMandatorySettingsRules) {\n          id\n          checkAccommodationTypes\n          checkAccommodationAddons\n          checkAgeGroups\n          useAgeFilter\n          checkDateRange\n          startDate\n          endDate\n          checkTravelDate\n        }\n      }\n    }\n    extensions @include(if: $withExtensions) {\n      id\n      label\n      info\n      travelExtension @include(if: $withExtensionsTravelExtension) {\n        id\n        duration\n        name\n        description\n        highlights @include(if: $withExtensionsTravelExtensionHighlights) {\n          id\n          text\n        }\n        image @include(if: $withExtensionsTravelExtensionImage) {\n          id\n          assetId\n          publicId\n          url\n          resourceType\n          format\n          width\n          height\n          caption\n          title\n          description\n        }\n      }\n      accommodationMapItems @include(if: $withExtensionsAccommodationMapItems) {\n        id\n        baseAccommodation @include(if: $withExtensionsAccommodationMapItemsBaseAccommodation) {\n          id\n          ratioPackageNo\n          name\n          label\n          info\n          isFamilyPackageAccommodation\n          isBabyPackage\n        }\n        extensionAccommodation @include(if: $withExtensionsAccommodationMapItemsExtensionAccommodation) {\n          id\n          ratioPackageNo\n          name\n          label\n          info\n          extensionAccommodationServiceNo\n        }\n      }\n    }\n    personalDiscounts @include(if: $withPersonalDiscounts) {\n      id\n      ratioServiceNo\n      name\n      label\n      info\n      mandatorySettings @include(if: $withPersonalDiscountsMandatorySettings) {\n        id\n        isMandatory\n        useRules\n        rules @include(if: $withPersonalDiscountsMandatorySettingsRules) {\n          id\n          checkAccommodationTypes\n          checkAccommodationAddons\n          checkAgeGroups\n          useAgeFilter\n          checkDateRange\n          startDate\n          endDate\n          checkTravelDate\n        }\n      }\n    }\n    importDateTime\n    importStatus\n  }\n}";
// language=GraphQL
var SINGLE_TRAVEL_QUERY = "query Query($id: ID!, $withRatioCatalogBundle: Boolean = false, $withDates: Boolean = false, $withDatesAvailabilityStatus: Boolean = false, $withDatesAvailabilityStatusTenantSettings: Boolean = false, $withDatesExtensionBaseDate: Boolean = false, $withDatesExtensionBaseDateAvailabilityStatus: Boolean = false, $withDatesExtensionBaseDateExtensionBaseDate: Boolean = false, $withDatesExtensionBaseDateExtension: Boolean = false, $withDatesExtensionBaseDatePackageSettings: Boolean = false, $withDatesExtensionBaseDateExtensions: Boolean = false, $withDatesExtension: Boolean = false, $withDatesExtensionTravelExtension: Boolean = false, $withDatesExtensionAccommodationMapItems: Boolean = false, $withDatesPackageSettings: Boolean = false, $withDatesExtensions: Boolean = false, $withDatesExtensionsTravelExtension: Boolean = false, $withDatesExtensionsAccommodationMapItems: Boolean = false, $withAccommodations: Boolean = false, $withAccommodationsCapacitySettings: Boolean = false, $withAccommodationsCapacitySettingsAgeGroupCapacities: Boolean = false, $withAccommodationsCapacitySettingsAgeGroupedTotalCapacities: Boolean = false, $withAccommodationsCapacitySettingsPartialOccupancyAllowedAgeGroups: Boolean = false, $withAccommodationsAddons: Boolean = false, $withAccommodationsAddonsCalculationSettings: Boolean = false, $withAccommodationsAddonsMandatorySettings: Boolean = false, $withExtensionAccommodations: Boolean = false, $withFamilyPackages: Boolean = false, $withFamilyPackagesAccommodation: Boolean = false, $withFamilyPackagesAccommodationCapacitySettings: Boolean = false, $withFamilyPackagesAccommodationAddons: Boolean = false, $withFamilyPackagesCapacitySettings: Boolean = false, $withFamilyPackagesCapacitySettingsAgeGroupCapacities: Boolean = false, $withFamilyPackagesCapacitySettingsAgeGroupedTotalCapacities: Boolean = false, $withFamilyPackagesCapacitySettingsPartialOccupancyAllowedAgeGroups: Boolean = false, $withFamilyPackagesAddons: Boolean = false, $withFamilyPackagesAddonsCalculationSettings: Boolean = false, $withFamilyPackagesAddonsMandatorySettings: Boolean = false, $withPersonalAddons: Boolean = false, $withPersonalAddonsAllowedAgeGroups: Boolean = false, $withPersonalAddonsCalculationSettings: Boolean = false, $withPersonalAddonsMandatorySettings: Boolean = false, $withPersonalAddonsMandatorySettingsRules: Boolean = false, $withAccommodationAddons: Boolean = false, $withAccommodationAddonsCalculationSettings: Boolean = false, $withAccommodationAddonsMandatorySettings: Boolean = false, $withAccommodationAddonsMandatorySettingsRules: Boolean = false, $withBookingAddons: Boolean = false, $withBookingAddonsCalculationSettings: Boolean = false, $withBookingAddonsMandatorySettings: Boolean = false, $withBookingAddonsMandatorySettingsRules: Boolean = false, $withCollectiveAddons: Boolean = false, $withCollectiveAddonsAgeGroupServices: Boolean = false, $withCollectiveAddonsAgeGroupServicesAgeGroup: Boolean = false, $withCollectiveAddonsCalculationSettings: Boolean = false, $withCollectiveAddonsMandatorySettings: Boolean = false, $withCollectiveAddonsMandatorySettingsRules: Boolean = false, $withExtensions: Boolean = false, $withExtensionsTravelExtension: Boolean = false, $withExtensionsTravelExtensionHighlights: Boolean = false, $withExtensionsTravelExtensionImage: Boolean = false, $withExtensionsAccommodationMapItems: Boolean = false, $withExtensionsAccommodationMapItemsBaseAccommodation: Boolean = false, $withExtensionsAccommodationMapItemsExtensionAccommodation: Boolean = false, $withPersonalDiscounts: Boolean = false, $withPersonalDiscountsMandatorySettings: Boolean = false, $withPersonalDiscountsMandatorySettingsRules: Boolean = false) {\n  travel: ratioTravel(id: $id) {\n    id\n    ratioCatalogBundle @include(if: $withRatioCatalogBundle) {\n      id\n      catalogCode\n      travelCode\n      json\n    }\n    catalogCode\n    travelCode\n    destination\n    name\n    transportType\n    transportTypeLabel\n    dates @include(if: $withDates) {\n      id\n      dateNo\n      startDate\n      endDate\n      availabilityStatus @include(if: $withDatesAvailabilityStatus) {\n        id\n        label\n        status\n        isDefaultStatus\n        isDefaultWaitlistFallback\n        tenantSettings @include(if: $withDatesAvailabilityStatusTenantSettings) {\n          id\n          label\n          info\n          switchToStatusInfo\n          submitButtonLabel\n        }\n      }\n      includesExtension\n      extensionBaseDate @include(if: $withDatesExtensionBaseDate) {\n        id\n        dateNo\n        startDate\n        endDate\n        availabilityStatus @include(if: $withDatesExtensionBaseDateAvailabilityStatus) {\n          id\n          label\n          status\n          isDefaultStatus\n          isDefaultWaitlistFallback\n        }\n        includesExtension\n        extensionBaseDate @include(if: $withDatesExtensionBaseDateExtensionBaseDate) {\n          id\n          dateNo\n          startDate\n          endDate\n          includesExtension\n          json\n        }\n        extension @include(if: $withDatesExtensionBaseDateExtension) {\n          id\n          label\n          info\n        }\n        packageSettings @include(if: $withDatesExtensionBaseDatePackageSettings) {\n          id\n          ratioPackageNo\n          price\n          availabilityStatus\n        }\n        json\n        extensions @include(if: $withDatesExtensionBaseDateExtensions) {\n          id\n          label\n          info\n        }\n      }\n      extension @include(if: $withDatesExtension) {\n        id\n        label\n        info\n        travelExtension @include(if: $withDatesExtensionTravelExtension) {\n          id\n          duration\n          name\n          description\n        }\n        accommodationMapItems @include(if: $withDatesExtensionAccommodationMapItems) {\n          id\n        }\n      }\n      packageSettings @include(if: $withDatesPackageSettings) {\n        id\n        ratioPackageNo\n        price\n        availabilityStatus\n      }\n      json\n      extensions @include(if: $withDatesExtensions) {\n        id\n        label\n        info\n        travelExtension @include(if: $withDatesExtensionsTravelExtension) {\n          id\n          duration\n          name\n          description\n        }\n        accommodationMapItems @include(if: $withDatesExtensionsAccommodationMapItems) {\n          id\n        }\n      }\n    }\n    accommodations @include(if: $withAccommodations) {\n      id\n      ratioPackageNo\n      name\n      label\n      info\n      isFamilyPackageAccommodation\n      isBabyPackage\n      capacitySettings @include(if: $withAccommodationsCapacitySettings) {\n        id\n        totalCapacity\n        rangesAllowed\n        ageGroupCapacities @include(if: $withAccommodationsCapacitySettingsAgeGroupCapacities) {\n          id\n          minCapacity\n          maxCapacity\n        }\n        ageGroupedTotalCapacities @include(if: $withAccommodationsCapacitySettingsAgeGroupedTotalCapacities) {\n          id\n          capacity\n        }\n        partialOccupancyAllowed\n        partialOccupancyAllowedAgeGroups @include(if: $withAccommodationsCapacitySettingsPartialOccupancyAllowedAgeGroups) {\n          id\n          name\n          type\n          icon\n          minAge\n          maxAge\n        }\n      }\n      addons @include(if: $withAccommodationsAddons) {\n        id\n        ratioServiceNo\n        name\n        label\n        info\n        calculationSettings @include(if: $withAccommodationsAddonsCalculationSettings) {\n          id\n          type\n          considerHotelNights\n        }\n        mandatorySettings @include(if: $withAccommodationsAddonsMandatorySettings) {\n          id\n          isMandatory\n          useRules\n        }\n      }\n    }\n    extensionAccommodations @include(if: $withExtensionAccommodations) {\n      id\n      ratioPackageNo\n      name\n      label\n      info\n      extensionAccommodationServiceNo\n    }\n    familyPackages @include(if: $withFamilyPackages) {\n      id\n      ratioServiceNo\n      accommodation @include(if: $withFamilyPackagesAccommodation) {\n        id\n        ratioPackageNo\n        name\n        label\n        info\n        isFamilyPackageAccommodation\n        isBabyPackage\n        capacitySettings @include(if: $withFamilyPackagesAccommodationCapacitySettings) {\n          id\n          totalCapacity\n          rangesAllowed\n          partialOccupancyAllowed\n        }\n        addons @include(if: $withFamilyPackagesAccommodationAddons) {\n          id\n          ratioServiceNo\n          name\n          label\n          info\n        }\n      }\n      name\n      label\n      info\n      capacitySettings @include(if: $withFamilyPackagesCapacitySettings) {\n        id\n        totalCapacity\n        rangesAllowed\n        ageGroupCapacities @include(if: $withFamilyPackagesCapacitySettingsAgeGroupCapacities) {\n          id\n          minCapacity\n          maxCapacity\n        }\n        ageGroupedTotalCapacities @include(if: $withFamilyPackagesCapacitySettingsAgeGroupedTotalCapacities) {\n          id\n          capacity\n        }\n        partialOccupancyAllowed\n        partialOccupancyAllowedAgeGroups @include(if: $withFamilyPackagesCapacitySettingsPartialOccupancyAllowedAgeGroups) {\n          id\n          name\n          type\n          icon\n          minAge\n          maxAge\n        }\n      }\n      addons @include(if: $withFamilyPackagesAddons) {\n        id\n        ratioServiceNo\n        name\n        label\n        info\n        calculationSettings @include(if: $withFamilyPackagesAddonsCalculationSettings) {\n          id\n          type\n          considerHotelNights\n        }\n        mandatorySettings @include(if: $withFamilyPackagesAddonsMandatorySettings) {\n          id\n          isMandatory\n          useRules\n        }\n      }\n    }\n    personalAddons @include(if: $withPersonalAddons) {\n      id\n      ratioServiceNo\n      name\n      label\n      info\n      allowedAgeGroups @include(if: $withPersonalAddonsAllowedAgeGroups) {\n        id\n        name\n        type\n        icon\n        minAge\n        maxAge\n      }\n      calculationSettings @include(if: $withPersonalAddonsCalculationSettings) {\n        id\n        type\n        considerHotelNights\n      }\n      mandatorySettings @include(if: $withPersonalAddonsMandatorySettings) {\n        id\n        isMandatory\n        useRules\n        rules @include(if: $withPersonalAddonsMandatorySettingsRules) {\n          id\n          checkAccommodationTypes\n          checkAccommodationAddons\n          checkAgeGroups\n          useAgeFilter\n          checkDateRange\n          startDate\n          endDate\n          checkTravelDate\n        }\n      }\n    }\n    accommodationAddons @include(if: $withAccommodationAddons) {\n      id\n      ratioServiceNo\n      name\n      label\n      info\n      calculationSettings @include(if: $withAccommodationAddonsCalculationSettings) {\n        id\n        type\n        considerHotelNights\n      }\n      mandatorySettings @include(if: $withAccommodationAddonsMandatorySettings) {\n        id\n        isMandatory\n        useRules\n        rules @include(if: $withAccommodationAddonsMandatorySettingsRules) {\n          id\n          checkAccommodationTypes\n          checkAccommodationAddons\n          checkAgeGroups\n          useAgeFilter\n          checkDateRange\n          startDate\n          endDate\n          checkTravelDate\n        }\n      }\n    }\n    bookingAddons @include(if: $withBookingAddons) {\n      id\n      ratioServiceNo\n      name\n      label\n      info\n      calculationSettings @include(if: $withBookingAddonsCalculationSettings) {\n        id\n        type\n        considerHotelNights\n      }\n      mandatorySettings @include(if: $withBookingAddonsMandatorySettings) {\n        id\n        isMandatory\n        useRules\n        rules @include(if: $withBookingAddonsMandatorySettingsRules) {\n          id\n          checkAccommodationTypes\n          checkAccommodationAddons\n          checkAgeGroups\n          useAgeFilter\n          checkDateRange\n          startDate\n          endDate\n          checkTravelDate\n        }\n      }\n    }\n    collectiveAddons @include(if: $withCollectiveAddons) {\n      id\n      label\n      info\n      ageGroupServices @include(if: $withCollectiveAddonsAgeGroupServices) {\n        id\n        ageGroup @include(if: $withCollectiveAddonsAgeGroupServicesAgeGroup) {\n          id\n          name\n          type\n          icon\n          minAge\n          maxAge\n        }\n        ratioServiceNo\n      }\n      calculationSettings @include(if: $withCollectiveAddonsCalculationSettings) {\n        id\n        type\n        considerHotelNights\n      }\n      mandatorySettings @include(if: $withCollectiveAddonsMandatorySettings) {\n        id\n        isMandatory\n        useRules\n        rules @include(if: $withCollectiveAddonsMandatorySettingsRules) {\n          id\n          checkAccommodationTypes\n          checkAccommodationAddons\n          checkAgeGroups\n          useAgeFilter\n          checkDateRange\n          startDate\n          endDate\n          checkTravelDate\n        }\n      }\n    }\n    extensions @include(if: $withExtensions) {\n      id\n      label\n      info\n      travelExtension @include(if: $withExtensionsTravelExtension) {\n        id\n        duration\n        name\n        description\n        highlights @include(if: $withExtensionsTravelExtensionHighlights) {\n          id\n          text\n        }\n        image @include(if: $withExtensionsTravelExtensionImage) {\n          id\n          assetId\n          publicId\n          url\n          resourceType\n          format\n          width\n          height\n          caption\n          title\n          description\n        }\n      }\n      accommodationMapItems @include(if: $withExtensionsAccommodationMapItems) {\n        id\n        baseAccommodation @include(if: $withExtensionsAccommodationMapItemsBaseAccommodation) {\n          id\n          ratioPackageNo\n          name\n          label\n          info\n          isFamilyPackageAccommodation\n          isBabyPackage\n        }\n        extensionAccommodation @include(if: $withExtensionsAccommodationMapItemsExtensionAccommodation) {\n          id\n          ratioPackageNo\n          name\n          label\n          info\n          extensionAccommodationServiceNo\n        }\n      }\n    }\n    personalDiscounts @include(if: $withPersonalDiscounts) {\n      id\n      ratioServiceNo\n      name\n      label\n      info\n      mandatorySettings @include(if: $withPersonalDiscountsMandatorySettings) {\n        id\n        isMandatory\n        useRules\n        rules @include(if: $withPersonalDiscountsMandatorySettingsRules) {\n          id\n          checkAccommodationTypes\n          checkAccommodationAddons\n          checkAgeGroups\n          useAgeFilter\n          checkDateRange\n          startDate\n          endDate\n          checkTravelDate\n        }\n      }\n    }\n    importDateTime\n    importStatus\n  }\n}";
// language=GraphQL
var CREATE_TRAVEL_MUTATION = "\n  mutation Mutation($input: CreateRatioTravelInput, $withRatioCatalogBundle: Boolean = false, $withDates: Boolean = false, $withDatesAvailabilityStatus: Boolean = false, $withDatesAvailabilityStatusTenantSettings: Boolean = false, $withDatesExtensionBaseDate: Boolean = false, $withDatesExtensionBaseDateAvailabilityStatus: Boolean = false, $withDatesExtensionBaseDateExtensionBaseDate: Boolean = false, $withDatesExtensionBaseDateExtension: Boolean = false, $withDatesExtensionBaseDatePackageSettings: Boolean = false, $withDatesExtensionBaseDateExtensions: Boolean = false, $withDatesExtension: Boolean = false, $withDatesExtensionTravelExtension: Boolean = false, $withDatesExtensionAccommodationMapItems: Boolean = false, $withDatesPackageSettings: Boolean = false, $withDatesExtensions: Boolean = false, $withDatesExtensionsTravelExtension: Boolean = false, $withDatesExtensionsAccommodationMapItems: Boolean = false, $withAccommodations: Boolean = false, $withAccommodationsCapacitySettings: Boolean = false, $withAccommodationsCapacitySettingsAgeGroupCapacities: Boolean = false, $withAccommodationsCapacitySettingsAgeGroupedTotalCapacities: Boolean = false, $withAccommodationsCapacitySettingsPartialOccupancyAllowedAgeGroups: Boolean = false, $withAccommodationsAddons: Boolean = false, $withAccommodationsAddonsCalculationSettings: Boolean = false, $withAccommodationsAddonsMandatorySettings: Boolean = false, $withExtensionAccommodations: Boolean = false, $withFamilyPackages: Boolean = false, $withFamilyPackagesAccommodation: Boolean = false, $withFamilyPackagesAccommodationCapacitySettings: Boolean = false, $withFamilyPackagesAccommodationAddons: Boolean = false, $withFamilyPackagesCapacitySettings: Boolean = false, $withFamilyPackagesCapacitySettingsAgeGroupCapacities: Boolean = false, $withFamilyPackagesCapacitySettingsAgeGroupedTotalCapacities: Boolean = false, $withFamilyPackagesCapacitySettingsPartialOccupancyAllowedAgeGroups: Boolean = false, $withFamilyPackagesAddons: Boolean = false, $withFamilyPackagesAddonsCalculationSettings: Boolean = false, $withFamilyPackagesAddonsMandatorySettings: Boolean = false, $withPersonalAddons: Boolean = false, $withPersonalAddonsAllowedAgeGroups: Boolean = false, $withPersonalAddonsCalculationSettings: Boolean = false, $withPersonalAddonsMandatorySettings: Boolean = false, $withPersonalAddonsMandatorySettingsRules: Boolean = false, $withAccommodationAddons: Boolean = false, $withAccommodationAddonsCalculationSettings: Boolean = false, $withAccommodationAddonsMandatorySettings: Boolean = false, $withAccommodationAddonsMandatorySettingsRules: Boolean = false, $withBookingAddons: Boolean = false, $withBookingAddonsCalculationSettings: Boolean = false, $withBookingAddonsMandatorySettings: Boolean = false, $withBookingAddonsMandatorySettingsRules: Boolean = false, $withCollectiveAddons: Boolean = false, $withCollectiveAddonsAgeGroupServices: Boolean = false, $withCollectiveAddonsAgeGroupServicesAgeGroup: Boolean = false, $withCollectiveAddonsCalculationSettings: Boolean = false, $withCollectiveAddonsMandatorySettings: Boolean = false, $withCollectiveAddonsMandatorySettingsRules: Boolean = false, $withExtensions: Boolean = false, $withExtensionsTravelExtension: Boolean = false, $withExtensionsTravelExtensionHighlights: Boolean = false, $withExtensionsTravelExtensionImage: Boolean = false, $withExtensionsAccommodationMapItems: Boolean = false, $withExtensionsAccommodationMapItemsBaseAccommodation: Boolean = false, $withExtensionsAccommodationMapItemsExtensionAccommodation: Boolean = false, $withPersonalDiscounts: Boolean = false, $withPersonalDiscountsMandatorySettings: Boolean = false, $withPersonalDiscountsMandatorySettingsRules: Boolean = false) {\n    travel: createRatioTravel(input: $input) {\n      id\n      ratioCatalogBundle @include(if: $withRatioCatalogBundle) {\n        id\n        catalogCode\n        travelCode\n        json\n      }\n      catalogCode\n      travelCode\n      destination\n      name\n      transportType\n      transportTypeLabel\n      dates @include(if: $withDates) {\n        id\n        dateNo\n        startDate\n        endDate\n        availabilityStatus @include(if: $withDatesAvailabilityStatus) {\n          id\n          label\n          status\n          isDefaultStatus\n          isDefaultWaitlistFallback\n          tenantSettings @include(if: $withDatesAvailabilityStatusTenantSettings) {\n            id\n            label\n            info\n            switchToStatusInfo\n            submitButtonLabel\n          }\n        }\n        includesExtension\n        extensionBaseDate @include(if: $withDatesExtensionBaseDate) {\n          id\n          dateNo\n          startDate\n          endDate\n          availabilityStatus @include(if: $withDatesExtensionBaseDateAvailabilityStatus) {\n            id\n            label\n            status\n            isDefaultStatus\n            isDefaultWaitlistFallback\n          }\n          includesExtension\n          extensionBaseDate @include(if: $withDatesExtensionBaseDateExtensionBaseDate) {\n            id\n            dateNo\n            startDate\n            endDate\n            includesExtension\n            json\n          }\n          extension @include(if: $withDatesExtensionBaseDateExtension) {\n            id\n            label\n            info\n          }\n          packageSettings @include(if: $withDatesExtensionBaseDatePackageSettings) {\n            id\n            ratioPackageNo\n            price\n            availabilityStatus\n          }\n          json\n          extensions @include(if: $withDatesExtensionBaseDateExtensions) {\n            id\n            label\n            info\n          }\n        }\n        extension @include(if: $withDatesExtension) {\n          id\n          label\n          info\n          travelExtension @include(if: $withDatesExtensionTravelExtension) {\n            id\n            duration\n            name\n            description\n          }\n          accommodationMapItems @include(if: $withDatesExtensionAccommodationMapItems) {\n            id\n          }\n        }\n        packageSettings @include(if: $withDatesPackageSettings) {\n          id\n          ratioPackageNo\n          price\n          availabilityStatus\n        }\n        json\n        extensions @include(if: $withDatesExtensions) {\n          id\n          label\n          info\n          travelExtension @include(if: $withDatesExtensionsTravelExtension) {\n            id\n            duration\n            name\n            description\n          }\n          accommodationMapItems @include(if: $withDatesExtensionsAccommodationMapItems) {\n            id\n          }\n        }\n      }\n      accommodations @include(if: $withAccommodations) {\n        id\n        ratioPackageNo\n        name\n        label\n        info\n        isFamilyPackageAccommodation\n        isBabyPackage\n        capacitySettings @include(if: $withAccommodationsCapacitySettings) {\n          id\n          totalCapacity\n          rangesAllowed\n          ageGroupCapacities @include(if: $withAccommodationsCapacitySettingsAgeGroupCapacities) {\n            id\n            minCapacity\n            maxCapacity\n          }\n          ageGroupedTotalCapacities @include(if: $withAccommodationsCapacitySettingsAgeGroupedTotalCapacities) {\n            id\n            capacity\n          }\n          partialOccupancyAllowed\n          partialOccupancyAllowedAgeGroups @include(if: $withAccommodationsCapacitySettingsPartialOccupancyAllowedAgeGroups) {\n            id\n            name\n            type\n            icon\n            minAge\n            maxAge\n          }\n        }\n        addons @include(if: $withAccommodationsAddons) {\n          id\n          ratioServiceNo\n          name\n          label\n          info\n          calculationSettings @include(if: $withAccommodationsAddonsCalculationSettings) {\n            id\n            type\n            considerHotelNights\n          }\n          mandatorySettings @include(if: $withAccommodationsAddonsMandatorySettings) {\n            id\n            isMandatory\n            useRules\n          }\n        }\n      }\n      extensionAccommodations @include(if: $withExtensionAccommodations) {\n        id\n        ratioPackageNo\n        name\n        label\n        info\n        extensionAccommodationServiceNo\n      }\n      familyPackages @include(if: $withFamilyPackages) {\n        id\n        ratioServiceNo\n        accommodation @include(if: $withFamilyPackagesAccommodation) {\n          id\n          ratioPackageNo\n          name\n          label\n          info\n          isFamilyPackageAccommodation\n          isBabyPackage\n          capacitySettings @include(if: $withFamilyPackagesAccommodationCapacitySettings) {\n            id\n            totalCapacity\n            rangesAllowed\n            partialOccupancyAllowed\n          }\n          addons @include(if: $withFamilyPackagesAccommodationAddons) {\n            id\n            ratioServiceNo\n            name\n            label\n            info\n          }\n        }\n        name\n        label\n        info\n        capacitySettings @include(if: $withFamilyPackagesCapacitySettings) {\n          id\n          totalCapacity\n          rangesAllowed\n          ageGroupCapacities @include(if: $withFamilyPackagesCapacitySettingsAgeGroupCapacities) {\n            id\n            minCapacity\n            maxCapacity\n          }\n          ageGroupedTotalCapacities @include(if: $withFamilyPackagesCapacitySettingsAgeGroupedTotalCapacities) {\n            id\n            capacity\n          }\n          partialOccupancyAllowed\n          partialOccupancyAllowedAgeGroups @include(if: $withFamilyPackagesCapacitySettingsPartialOccupancyAllowedAgeGroups) {\n            id\n            name\n            type\n            icon\n            minAge\n            maxAge\n          }\n        }\n        addons @include(if: $withFamilyPackagesAddons) {\n          id\n          ratioServiceNo\n          name\n          label\n          info\n          calculationSettings @include(if: $withFamilyPackagesAddonsCalculationSettings) {\n            id\n            type\n            considerHotelNights\n          }\n          mandatorySettings @include(if: $withFamilyPackagesAddonsMandatorySettings) {\n            id\n            isMandatory\n            useRules\n          }\n        }\n      }\n      personalAddons @include(if: $withPersonalAddons) {\n        id\n        ratioServiceNo\n        name\n        label\n        info\n        allowedAgeGroups @include(if: $withPersonalAddonsAllowedAgeGroups) {\n          id\n          name\n          type\n          icon\n          minAge\n          maxAge\n        }\n        calculationSettings @include(if: $withPersonalAddonsCalculationSettings) {\n          id\n          type\n          considerHotelNights\n        }\n        mandatorySettings @include(if: $withPersonalAddonsMandatorySettings) {\n          id\n          isMandatory\n          useRules\n          rules @include(if: $withPersonalAddonsMandatorySettingsRules) {\n            id\n            checkAccommodationTypes\n            checkAccommodationAddons\n            checkAgeGroups\n            useAgeFilter\n            checkDateRange\n            startDate\n            endDate\n            checkTravelDate\n          }\n        }\n      }\n      accommodationAddons @include(if: $withAccommodationAddons) {\n        id\n        ratioServiceNo\n        name\n        label\n        info\n        calculationSettings @include(if: $withAccommodationAddonsCalculationSettings) {\n          id\n          type\n          considerHotelNights\n        }\n        mandatorySettings @include(if: $withAccommodationAddonsMandatorySettings) {\n          id\n          isMandatory\n          useRules\n          rules @include(if: $withAccommodationAddonsMandatorySettingsRules) {\n            id\n            checkAccommodationTypes\n            checkAccommodationAddons\n            checkAgeGroups\n            useAgeFilter\n            checkDateRange\n            startDate\n            endDate\n            checkTravelDate\n          }\n        }\n      }\n      bookingAddons @include(if: $withBookingAddons) {\n        id\n        ratioServiceNo\n        name\n        label\n        info\n        calculationSettings @include(if: $withBookingAddonsCalculationSettings) {\n          id\n          type\n          considerHotelNights\n        }\n        mandatorySettings @include(if: $withBookingAddonsMandatorySettings) {\n          id\n          isMandatory\n          useRules\n          rules @include(if: $withBookingAddonsMandatorySettingsRules) {\n            id\n            checkAccommodationTypes\n            checkAccommodationAddons\n            checkAgeGroups\n            useAgeFilter\n            checkDateRange\n            startDate\n            endDate\n            checkTravelDate\n          }\n        }\n      }\n      collectiveAddons @include(if: $withCollectiveAddons) {\n        id\n        label\n        info\n        ageGroupServices @include(if: $withCollectiveAddonsAgeGroupServices) {\n          id\n          ageGroup @include(if: $withCollectiveAddonsAgeGroupServicesAgeGroup) {\n            id\n            name\n            type\n            icon\n            minAge\n            maxAge\n          }\n          ratioServiceNo\n        }\n        calculationSettings @include(if: $withCollectiveAddonsCalculationSettings) {\n          id\n          type\n          considerHotelNights\n        }\n        mandatorySettings @include(if: $withCollectiveAddonsMandatorySettings) {\n          id\n          isMandatory\n          useRules\n          rules @include(if: $withCollectiveAddonsMandatorySettingsRules) {\n            id\n            checkAccommodationTypes\n            checkAccommodationAddons\n            checkAgeGroups\n            useAgeFilter\n            checkDateRange\n            startDate\n            endDate\n            checkTravelDate\n          }\n        }\n      }\n      extensions @include(if: $withExtensions) {\n        id\n        label\n        info\n        travelExtension @include(if: $withExtensionsTravelExtension) {\n          id\n          duration\n          name\n          description\n          highlights @include(if: $withExtensionsTravelExtensionHighlights) {\n            id\n            text\n          }\n          image @include(if: $withExtensionsTravelExtensionImage) {\n            id\n            assetId\n            publicId\n            url\n            resourceType\n            format\n            width\n            height\n            caption\n            title\n            description\n          }\n        }\n        accommodationMapItems @include(if: $withExtensionsAccommodationMapItems) {\n          id\n          baseAccommodation @include(if: $withExtensionsAccommodationMapItemsBaseAccommodation) {\n            id\n            ratioPackageNo\n            name\n            label\n            info\n            isFamilyPackageAccommodation\n            isBabyPackage\n          }\n          extensionAccommodation @include(if: $withExtensionsAccommodationMapItemsExtensionAccommodation) {\n            id\n            ratioPackageNo\n            name\n            label\n            info\n            extensionAccommodationServiceNo\n          }\n        }\n      }\n      personalDiscounts @include(if: $withPersonalDiscounts) {\n        id\n        ratioServiceNo\n        name\n        label\n        info\n        mandatorySettings @include(if: $withPersonalDiscountsMandatorySettings) {\n          id\n          isMandatory\n          useRules\n          rules @include(if: $withPersonalDiscountsMandatorySettingsRules) {\n            id\n            checkAccommodationTypes\n            checkAccommodationAddons\n            checkAgeGroups\n            useAgeFilter\n            checkDateRange\n            startDate\n            endDate\n            checkTravelDate\n          }\n        }\n      }\n      importDateTime\n      importStatus\n    }\n  }";
// language=GraphQL
var UPDATE_TRAVEL_MUTATION = "\n  mutation Mutation($input: UpdateRatioTravelInput, $withRatioCatalogBundle: Boolean = false, $withDates: Boolean = false, $withDatesAvailabilityStatus: Boolean = false, $withDatesAvailabilityStatusTenantSettings: Boolean = false, $withDatesExtensionBaseDate: Boolean = false, $withDatesExtensionBaseDateAvailabilityStatus: Boolean = false, $withDatesExtensionBaseDateExtensionBaseDate: Boolean = false, $withDatesExtensionBaseDateExtension: Boolean = false, $withDatesExtensionBaseDatePackageSettings: Boolean = false, $withDatesExtensionBaseDateExtensions: Boolean = false, $withDatesExtension: Boolean = false, $withDatesExtensionTravelExtension: Boolean = false, $withDatesExtensionAccommodationMapItems: Boolean = false, $withDatesPackageSettings: Boolean = false, $withDatesExtensions: Boolean = false, $withDatesExtensionsTravelExtension: Boolean = false, $withDatesExtensionsAccommodationMapItems: Boolean = false, $withAccommodations: Boolean = false, $withAccommodationsCapacitySettings: Boolean = false, $withAccommodationsCapacitySettingsAgeGroupCapacities: Boolean = false, $withAccommodationsCapacitySettingsAgeGroupedTotalCapacities: Boolean = false, $withAccommodationsCapacitySettingsPartialOccupancyAllowedAgeGroups: Boolean = false, $withAccommodationsAddons: Boolean = false, $withAccommodationsAddonsCalculationSettings: Boolean = false, $withAccommodationsAddonsMandatorySettings: Boolean = false, $withExtensionAccommodations: Boolean = false, $withFamilyPackages: Boolean = false, $withFamilyPackagesAccommodation: Boolean = false, $withFamilyPackagesAccommodationCapacitySettings: Boolean = false, $withFamilyPackagesAccommodationAddons: Boolean = false, $withFamilyPackagesCapacitySettings: Boolean = false, $withFamilyPackagesCapacitySettingsAgeGroupCapacities: Boolean = false, $withFamilyPackagesCapacitySettingsAgeGroupedTotalCapacities: Boolean = false, $withFamilyPackagesCapacitySettingsPartialOccupancyAllowedAgeGroups: Boolean = false, $withFamilyPackagesAddons: Boolean = false, $withFamilyPackagesAddonsCalculationSettings: Boolean = false, $withFamilyPackagesAddonsMandatorySettings: Boolean = false, $withPersonalAddons: Boolean = false, $withPersonalAddonsAllowedAgeGroups: Boolean = false, $withPersonalAddonsCalculationSettings: Boolean = false, $withPersonalAddonsMandatorySettings: Boolean = false, $withPersonalAddonsMandatorySettingsRules: Boolean = false, $withAccommodationAddons: Boolean = false, $withAccommodationAddonsCalculationSettings: Boolean = false, $withAccommodationAddonsMandatorySettings: Boolean = false, $withAccommodationAddonsMandatorySettingsRules: Boolean = false, $withBookingAddons: Boolean = false, $withBookingAddonsCalculationSettings: Boolean = false, $withBookingAddonsMandatorySettings: Boolean = false, $withBookingAddonsMandatorySettingsRules: Boolean = false, $withCollectiveAddons: Boolean = false, $withCollectiveAddonsAgeGroupServices: Boolean = false, $withCollectiveAddonsAgeGroupServicesAgeGroup: Boolean = false, $withCollectiveAddonsCalculationSettings: Boolean = false, $withCollectiveAddonsMandatorySettings: Boolean = false, $withCollectiveAddonsMandatorySettingsRules: Boolean = false, $withExtensions: Boolean = false, $withExtensionsTravelExtension: Boolean = false, $withExtensionsTravelExtensionHighlights: Boolean = false, $withExtensionsTravelExtensionImage: Boolean = false, $withExtensionsAccommodationMapItems: Boolean = false, $withExtensionsAccommodationMapItemsBaseAccommodation: Boolean = false, $withExtensionsAccommodationMapItemsExtensionAccommodation: Boolean = false, $withPersonalDiscounts: Boolean = false, $withPersonalDiscountsMandatorySettings: Boolean = false, $withPersonalDiscountsMandatorySettingsRules: Boolean = false) {\n    travel: updateRatioTravel(input: $input) {\n      id\n      ratioCatalogBundle @include(if: $withRatioCatalogBundle) {\n        id\n        catalogCode\n        travelCode\n        json\n      }\n      catalogCode\n      travelCode\n      destination\n      name\n      transportType\n      transportTypeLabel\n      dates @include(if: $withDates) {\n        id\n        dateNo\n        startDate\n        endDate\n        availabilityStatus @include(if: $withDatesAvailabilityStatus) {\n          id\n          label\n          status\n          isDefaultStatus\n          isDefaultWaitlistFallback\n          tenantSettings @include(if: $withDatesAvailabilityStatusTenantSettings) {\n            id\n            label\n            info\n            switchToStatusInfo\n            submitButtonLabel\n          }\n        }\n        includesExtension\n        extensionBaseDate @include(if: $withDatesExtensionBaseDate) {\n          id\n          dateNo\n          startDate\n          endDate\n          availabilityStatus @include(if: $withDatesExtensionBaseDateAvailabilityStatus) {\n            id\n            label\n            status\n            isDefaultStatus\n            isDefaultWaitlistFallback\n          }\n          includesExtension\n          extensionBaseDate @include(if: $withDatesExtensionBaseDateExtensionBaseDate) {\n            id\n            dateNo\n            startDate\n            endDate\n            includesExtension\n            json\n          }\n          extension @include(if: $withDatesExtensionBaseDateExtension) {\n            id\n            label\n            info\n          }\n          packageSettings @include(if: $withDatesExtensionBaseDatePackageSettings) {\n            id\n            ratioPackageNo\n            price\n            availabilityStatus\n          }\n          json\n          extensions @include(if: $withDatesExtensionBaseDateExtensions) {\n            id\n            label\n            info\n          }\n        }\n        extension @include(if: $withDatesExtension) {\n          id\n          label\n          info\n          travelExtension @include(if: $withDatesExtensionTravelExtension) {\n            id\n            duration\n            name\n            description\n          }\n          accommodationMapItems @include(if: $withDatesExtensionAccommodationMapItems) {\n            id\n          }\n        }\n        packageSettings @include(if: $withDatesPackageSettings) {\n          id\n          ratioPackageNo\n          price\n          availabilityStatus\n        }\n        json\n        extensions @include(if: $withDatesExtensions) {\n          id\n          label\n          info\n          travelExtension @include(if: $withDatesExtensionsTravelExtension) {\n            id\n            duration\n            name\n            description\n          }\n          accommodationMapItems @include(if: $withDatesExtensionsAccommodationMapItems) {\n            id\n          }\n        }\n      }\n      accommodations @include(if: $withAccommodations) {\n        id\n        ratioPackageNo\n        name\n        label\n        info\n        isFamilyPackageAccommodation\n        isBabyPackage\n        capacitySettings @include(if: $withAccommodationsCapacitySettings) {\n          id\n          totalCapacity\n          rangesAllowed\n          ageGroupCapacities @include(if: $withAccommodationsCapacitySettingsAgeGroupCapacities) {\n            id\n            minCapacity\n            maxCapacity\n          }\n          ageGroupedTotalCapacities @include(if: $withAccommodationsCapacitySettingsAgeGroupedTotalCapacities) {\n            id\n            capacity\n          }\n          partialOccupancyAllowed\n          partialOccupancyAllowedAgeGroups @include(if: $withAccommodationsCapacitySettingsPartialOccupancyAllowedAgeGroups) {\n            id\n            name\n            type\n            icon\n            minAge\n            maxAge\n          }\n        }\n        addons @include(if: $withAccommodationsAddons) {\n          id\n          ratioServiceNo\n          name\n          label\n          info\n          calculationSettings @include(if: $withAccommodationsAddonsCalculationSettings) {\n            id\n            type\n            considerHotelNights\n          }\n          mandatorySettings @include(if: $withAccommodationsAddonsMandatorySettings) {\n            id\n            isMandatory\n            useRules\n          }\n        }\n      }\n      extensionAccommodations @include(if: $withExtensionAccommodations) {\n        id\n        ratioPackageNo\n        name\n        label\n        info\n        extensionAccommodationServiceNo\n      }\n      familyPackages @include(if: $withFamilyPackages) {\n        id\n        ratioServiceNo\n        accommodation @include(if: $withFamilyPackagesAccommodation) {\n          id\n          ratioPackageNo\n          name\n          label\n          info\n          isFamilyPackageAccommodation\n          isBabyPackage\n          capacitySettings @include(if: $withFamilyPackagesAccommodationCapacitySettings) {\n            id\n            totalCapacity\n            rangesAllowed\n            partialOccupancyAllowed\n          }\n          addons @include(if: $withFamilyPackagesAccommodationAddons) {\n            id\n            ratioServiceNo\n            name\n            label\n            info\n          }\n        }\n        name\n        label\n        info\n        capacitySettings @include(if: $withFamilyPackagesCapacitySettings) {\n          id\n          totalCapacity\n          rangesAllowed\n          ageGroupCapacities @include(if: $withFamilyPackagesCapacitySettingsAgeGroupCapacities) {\n            id\n            minCapacity\n            maxCapacity\n          }\n          ageGroupedTotalCapacities @include(if: $withFamilyPackagesCapacitySettingsAgeGroupedTotalCapacities) {\n            id\n            capacity\n          }\n          partialOccupancyAllowed\n          partialOccupancyAllowedAgeGroups @include(if: $withFamilyPackagesCapacitySettingsPartialOccupancyAllowedAgeGroups) {\n            id\n            name\n            type\n            icon\n            minAge\n            maxAge\n          }\n        }\n        addons @include(if: $withFamilyPackagesAddons) {\n          id\n          ratioServiceNo\n          name\n          label\n          info\n          calculationSettings @include(if: $withFamilyPackagesAddonsCalculationSettings) {\n            id\n            type\n            considerHotelNights\n          }\n          mandatorySettings @include(if: $withFamilyPackagesAddonsMandatorySettings) {\n            id\n            isMandatory\n            useRules\n          }\n        }\n      }\n      personalAddons @include(if: $withPersonalAddons) {\n        id\n        ratioServiceNo\n        name\n        label\n        info\n        allowedAgeGroups @include(if: $withPersonalAddonsAllowedAgeGroups) {\n          id\n          name\n          type\n          icon\n          minAge\n          maxAge\n        }\n        calculationSettings @include(if: $withPersonalAddonsCalculationSettings) {\n          id\n          type\n          considerHotelNights\n        }\n        mandatorySettings @include(if: $withPersonalAddonsMandatorySettings) {\n          id\n          isMandatory\n          useRules\n          rules @include(if: $withPersonalAddonsMandatorySettingsRules) {\n            id\n            checkAccommodationTypes\n            checkAccommodationAddons\n            checkAgeGroups\n            useAgeFilter\n            checkDateRange\n            startDate\n            endDate\n            checkTravelDate\n          }\n        }\n      }\n      accommodationAddons @include(if: $withAccommodationAddons) {\n        id\n        ratioServiceNo\n        name\n        label\n        info\n        calculationSettings @include(if: $withAccommodationAddonsCalculationSettings) {\n          id\n          type\n          considerHotelNights\n        }\n        mandatorySettings @include(if: $withAccommodationAddonsMandatorySettings) {\n          id\n          isMandatory\n          useRules\n          rules @include(if: $withAccommodationAddonsMandatorySettingsRules) {\n            id\n            checkAccommodationTypes\n            checkAccommodationAddons\n            checkAgeGroups\n            useAgeFilter\n            checkDateRange\n            startDate\n            endDate\n            checkTravelDate\n          }\n        }\n      }\n      bookingAddons @include(if: $withBookingAddons) {\n        id\n        ratioServiceNo\n        name\n        label\n        info\n        calculationSettings @include(if: $withBookingAddonsCalculationSettings) {\n          id\n          type\n          considerHotelNights\n        }\n        mandatorySettings @include(if: $withBookingAddonsMandatorySettings) {\n          id\n          isMandatory\n          useRules\n          rules @include(if: $withBookingAddonsMandatorySettingsRules) {\n            id\n            checkAccommodationTypes\n            checkAccommodationAddons\n            checkAgeGroups\n            useAgeFilter\n            checkDateRange\n            startDate\n            endDate\n            checkTravelDate\n          }\n        }\n      }\n      collectiveAddons @include(if: $withCollectiveAddons) {\n        id\n        label\n        info\n        ageGroupServices @include(if: $withCollectiveAddonsAgeGroupServices) {\n          id\n          ageGroup @include(if: $withCollectiveAddonsAgeGroupServicesAgeGroup) {\n            id\n            name\n            type\n            icon\n            minAge\n            maxAge\n          }\n          ratioServiceNo\n        }\n        calculationSettings @include(if: $withCollectiveAddonsCalculationSettings) {\n          id\n          type\n          considerHotelNights\n        }\n        mandatorySettings @include(if: $withCollectiveAddonsMandatorySettings) {\n          id\n          isMandatory\n          useRules\n          rules @include(if: $withCollectiveAddonsMandatorySettingsRules) {\n            id\n            checkAccommodationTypes\n            checkAccommodationAddons\n            checkAgeGroups\n            useAgeFilter\n            checkDateRange\n            startDate\n            endDate\n            checkTravelDate\n          }\n        }\n      }\n      extensions @include(if: $withExtensions) {\n        id\n        label\n        info\n        travelExtension @include(if: $withExtensionsTravelExtension) {\n          id\n          duration\n          name\n          description\n          highlights @include(if: $withExtensionsTravelExtensionHighlights) {\n            id\n            text\n          }\n          image @include(if: $withExtensionsTravelExtensionImage) {\n            id\n            assetId\n            publicId\n            url\n            resourceType\n            format\n            width\n            height\n            caption\n            title\n            description\n          }\n        }\n        accommodationMapItems @include(if: $withExtensionsAccommodationMapItems) {\n          id\n          baseAccommodation @include(if: $withExtensionsAccommodationMapItemsBaseAccommodation) {\n            id\n            ratioPackageNo\n            name\n            label\n            info\n            isFamilyPackageAccommodation\n            isBabyPackage\n          }\n          extensionAccommodation @include(if: $withExtensionsAccommodationMapItemsExtensionAccommodation) {\n            id\n            ratioPackageNo\n            name\n            label\n            info\n            extensionAccommodationServiceNo\n          }\n        }\n      }\n      personalDiscounts @include(if: $withPersonalDiscounts) {\n        id\n        ratioServiceNo\n        name\n        label\n        info\n        mandatorySettings @include(if: $withPersonalDiscountsMandatorySettings) {\n          id\n          isMandatory\n          useRules\n          rules @include(if: $withPersonalDiscountsMandatorySettingsRules) {\n            id\n            checkAccommodationTypes\n            checkAccommodationAddons\n            checkAgeGroups\n            useAgeFilter\n            checkDateRange\n            startDate\n            endDate\n            checkTravelDate\n          }\n        }\n      }\n      importDateTime\n      importStatus\n    }\n  }";
// language=GraphQL
var DELETE_TRAVEL_MUTATION = "\n  mutation Mutation($input: DeleteRatioTravelInput) {\n    deleteRatioTravel(input: $input) {\n      success\n    }\n  }";
// language=GraphQL
var FORCE_DELETE_TRAVEL_MUTATION = "\n  mutation Mutation($input: DeleteRatioTravelInput) {\n    forceDeleteRatioTravel(input: $input) {\n      success\n    }\n  }";
// language=GraphQL
var ADD_TRAVEL_DATES_MUTATION = "\n  mutation Mutation($input: addRatioTravelDatesInput) {\n    addRatioTravelDates(input: $input) {\n      id\n      dateIds\n    }\n  }";
// language=GraphQL
var REMOVE_TRAVEL_DATES_MUTATION = "\n  mutation Mutation($input: removeRatioTravelDatesInput) {\n    removeRatioTravelDates(input: $input) {\n      id\n      dateIds\n    }\n  }";
// language=GraphQL
var CREATE_TRAVEL_DATES_MUTATION = "\n  mutation Mutation($input: createRatioTravelDatesInput) {\n    createRatioTravelDates(input: $input) {\n      id\n      dateIds\n    }\n  }";
// language=GraphQL
var DELETE_TRAVEL_DATES_MUTATION = "\n  mutation Mutation($input: deleteRatioTravelDatesInput) {\n    deleteRatioTravelDates(input: $input) {\n      id\n      dateIds\n    }\n  }";
// language=GraphQL
var UPDATE_TRAVEL_DATES_ORDER_MUTATION = "\n  mutation Mutation($input: updateRatioTravelDatesOrderInput) {\n    updateRatioTravelDatesOrder(input: $input) {\n      id\n      dateIds\n    }\n  }";
// language=GraphQL
var ADD_TRAVEL_ACCOMMODATIONS_MUTATION = "\n  mutation Mutation($input: addRatioTravelAccommodationsInput) {\n    addRatioTravelAccommodations(input: $input) {\n      id\n      accommodationIds\n    }\n  }";
// language=GraphQL
var REMOVE_TRAVEL_ACCOMMODATIONS_MUTATION = "\n  mutation Mutation($input: removeRatioTravelAccommodationsInput) {\n    removeRatioTravelAccommodations(input: $input) {\n      id\n      accommodationIds\n    }\n  }";
// language=GraphQL
var CREATE_TRAVEL_ACCOMMODATIONS_MUTATION = "\n  mutation Mutation($input: createRatioTravelAccommodationsInput) {\n    createRatioTravelAccommodations(input: $input) {\n      id\n      accommodationIds\n    }\n  }";
// language=GraphQL
var DELETE_TRAVEL_ACCOMMODATIONS_MUTATION = "\n  mutation Mutation($input: deleteRatioTravelAccommodationsInput) {\n    deleteRatioTravelAccommodations(input: $input) {\n      id\n      accommodationIds\n    }\n  }";
// language=GraphQL
var UPDATE_TRAVEL_ACCOMMODATIONS_ORDER_MUTATION = "\n  mutation Mutation($input: updateRatioTravelAccommodationsOrderInput) {\n    updateRatioTravelAccommodationsOrder(input: $input) {\n      id\n      accommodationIds\n    }\n  }";
// language=GraphQL
var ADD_TRAVEL_EXTENSION_ACCOMMODATIONS_MUTATION = "\n  mutation Mutation($input: addRatioTravelExtensionAccommodationsInput) {\n    addRatioTravelExtensionAccommodations(input: $input) {\n      id\n      extensionAccommodationIds\n    }\n  }";
// language=GraphQL
var REMOVE_TRAVEL_EXTENSION_ACCOMMODATIONS_MUTATION = "\n  mutation Mutation($input: removeRatioTravelExtensionAccommodationsInput) {\n    removeRatioTravelExtensionAccommodations(input: $input) {\n      id\n      extensionAccommodationIds\n    }\n  }";
// language=GraphQL
var CREATE_TRAVEL_EXTENSION_ACCOMMODATIONS_MUTATION = "\n  mutation Mutation($input: createRatioTravelExtensionAccommodationsInput) {\n    createRatioTravelExtensionAccommodations(input: $input) {\n      id\n      extensionAccommodationIds\n    }\n  }";
// language=GraphQL
var DELETE_TRAVEL_EXTENSION_ACCOMMODATIONS_MUTATION = "\n  mutation Mutation($input: deleteRatioTravelExtensionAccommodationsInput) {\n    deleteRatioTravelExtensionAccommodations(input: $input) {\n      id\n      extensionAccommodationIds\n    }\n  }";
// language=GraphQL
var UPDATE_TRAVEL_EXTENSION_ACCOMMODATIONS_ORDER_MUTATION = "\n  mutation Mutation($input: updateRatioTravelExtensionAccommodationsOrderInput) {\n    updateRatioTravelExtensionAccommodationsOrder(input: $input) {\n      id\n      extensionAccommodationIds\n    }\n  }";
// language=GraphQL
var ADD_TRAVEL_FAMILY_PACKAGES_MUTATION = "\n  mutation Mutation($input: addRatioTravelFamilyPackagesInput) {\n    addRatioTravelFamilyPackages(input: $input) {\n      id\n      familyPackageIds\n    }\n  }";
// language=GraphQL
var REMOVE_TRAVEL_FAMILY_PACKAGES_MUTATION = "\n  mutation Mutation($input: removeRatioTravelFamilyPackagesInput) {\n    removeRatioTravelFamilyPackages(input: $input) {\n      id\n      familyPackageIds\n    }\n  }";
// language=GraphQL
var CREATE_TRAVEL_FAMILY_PACKAGES_MUTATION = "\n  mutation Mutation($input: createRatioTravelFamilyPackagesInput) {\n    createRatioTravelFamilyPackages(input: $input) {\n      id\n      familyPackageIds\n    }\n  }";
// language=GraphQL
var DELETE_TRAVEL_FAMILY_PACKAGES_MUTATION = "\n  mutation Mutation($input: deleteRatioTravelFamilyPackagesInput) {\n    deleteRatioTravelFamilyPackages(input: $input) {\n      id\n      familyPackageIds\n    }\n  }";
// language=GraphQL
var UPDATE_TRAVEL_FAMILY_PACKAGES_ORDER_MUTATION = "\n  mutation Mutation($input: updateRatioTravelFamilyPackagesOrderInput) {\n    updateRatioTravelFamilyPackagesOrder(input: $input) {\n      id\n      familyPackageIds\n    }\n  }";
// language=GraphQL
var ADD_TRAVEL_PERSONAL_ADDONS_MUTATION = "\n  mutation Mutation($input: addRatioTravelPersonalAddonsInput) {\n    addRatioTravelPersonalAddons(input: $input) {\n      id\n      personalAddonIds\n    }\n  }";
// language=GraphQL
var REMOVE_TRAVEL_PERSONAL_ADDONS_MUTATION = "\n  mutation Mutation($input: removeRatioTravelPersonalAddonsInput) {\n    removeRatioTravelPersonalAddons(input: $input) {\n      id\n      personalAddonIds\n    }\n  }";
// language=GraphQL
var CREATE_TRAVEL_PERSONAL_ADDONS_MUTATION = "\n  mutation Mutation($input: createRatioTravelPersonalAddonsInput) {\n    createRatioTravelPersonalAddons(input: $input) {\n      id\n      personalAddonIds\n    }\n  }";
// language=GraphQL
var DELETE_TRAVEL_PERSONAL_ADDONS_MUTATION = "\n  mutation Mutation($input: deleteRatioTravelPersonalAddonsInput) {\n    deleteRatioTravelPersonalAddons(input: $input) {\n      id\n      personalAddonIds\n    }\n  }";
// language=GraphQL
var UPDATE_TRAVEL_PERSONAL_ADDONS_ORDER_MUTATION = "\n  mutation Mutation($input: updateRatioTravelPersonalAddonsOrderInput) {\n    updateRatioTravelPersonalAddonsOrder(input: $input) {\n      id\n      personalAddonIds\n    }\n  }";
// language=GraphQL
var ADD_TRAVEL_ACCOMMODATION_ADDONS_MUTATION = "\n  mutation Mutation($input: addRatioTravelAccommodationAddonsInput) {\n    addRatioTravelAccommodationAddons(input: $input) {\n      id\n      accommodationAddonIds\n    }\n  }";
// language=GraphQL
var REMOVE_TRAVEL_ACCOMMODATION_ADDONS_MUTATION = "\n  mutation Mutation($input: removeRatioTravelAccommodationAddonsInput) {\n    removeRatioTravelAccommodationAddons(input: $input) {\n      id\n      accommodationAddonIds\n    }\n  }";
// language=GraphQL
var CREATE_TRAVEL_ACCOMMODATION_ADDONS_MUTATION = "\n  mutation Mutation($input: createRatioTravelAccommodationAddonsInput) {\n    createRatioTravelAccommodationAddons(input: $input) {\n      id\n      accommodationAddonIds\n    }\n  }";
// language=GraphQL
var DELETE_TRAVEL_ACCOMMODATION_ADDONS_MUTATION = "\n  mutation Mutation($input: deleteRatioTravelAccommodationAddonsInput) {\n    deleteRatioTravelAccommodationAddons(input: $input) {\n      id\n      accommodationAddonIds\n    }\n  }";
// language=GraphQL
var UPDATE_TRAVEL_ACCOMMODATION_ADDONS_ORDER_MUTATION = "\n  mutation Mutation($input: updateRatioTravelAccommodationAddonsOrderInput) {\n    updateRatioTravelAccommodationAddonsOrder(input: $input) {\n      id\n      accommodationAddonIds\n    }\n  }";
// language=GraphQL
var ADD_TRAVEL_BOOKING_ADDONS_MUTATION = "\n  mutation Mutation($input: addRatioTravelBookingAddonsInput) {\n    addRatioTravelBookingAddons(input: $input) {\n      id\n      bookingAddonIds\n    }\n  }";
// language=GraphQL
var REMOVE_TRAVEL_BOOKING_ADDONS_MUTATION = "\n  mutation Mutation($input: removeRatioTravelBookingAddonsInput) {\n    removeRatioTravelBookingAddons(input: $input) {\n      id\n      bookingAddonIds\n    }\n  }";
// language=GraphQL
var CREATE_TRAVEL_BOOKING_ADDONS_MUTATION = "\n  mutation Mutation($input: createRatioTravelBookingAddonsInput) {\n    createRatioTravelBookingAddons(input: $input) {\n      id\n      bookingAddonIds\n    }\n  }";
// language=GraphQL
var DELETE_TRAVEL_BOOKING_ADDONS_MUTATION = "\n  mutation Mutation($input: deleteRatioTravelBookingAddonsInput) {\n    deleteRatioTravelBookingAddons(input: $input) {\n      id\n      bookingAddonIds\n    }\n  }";
// language=GraphQL
var UPDATE_TRAVEL_BOOKING_ADDONS_ORDER_MUTATION = "\n  mutation Mutation($input: updateRatioTravelBookingAddonsOrderInput) {\n    updateRatioTravelBookingAddonsOrder(input: $input) {\n      id\n      bookingAddonIds\n    }\n  }";
// language=GraphQL
var ADD_TRAVEL_COLLECTIVE_ADDONS_MUTATION = "\n  mutation Mutation($input: addRatioTravelCollectiveAddonsInput) {\n    addRatioTravelCollectiveAddons(input: $input) {\n      id\n      collectiveAddonIds\n    }\n  }";
// language=GraphQL
var REMOVE_TRAVEL_COLLECTIVE_ADDONS_MUTATION = "\n  mutation Mutation($input: removeRatioTravelCollectiveAddonsInput) {\n    removeRatioTravelCollectiveAddons(input: $input) {\n      id\n      collectiveAddonIds\n    }\n  }";
// language=GraphQL
var CREATE_TRAVEL_COLLECTIVE_ADDONS_MUTATION = "\n  mutation Mutation($input: createRatioTravelCollectiveAddonsInput) {\n    createRatioTravelCollectiveAddons(input: $input) {\n      id\n      collectiveAddonIds\n    }\n  }";
// language=GraphQL
var DELETE_TRAVEL_COLLECTIVE_ADDONS_MUTATION = "\n  mutation Mutation($input: deleteRatioTravelCollectiveAddonsInput) {\n    deleteRatioTravelCollectiveAddons(input: $input) {\n      id\n      collectiveAddonIds\n    }\n  }";
// language=GraphQL
var UPDATE_TRAVEL_COLLECTIVE_ADDONS_ORDER_MUTATION = "\n  mutation Mutation($input: updateRatioTravelCollectiveAddonsOrderInput) {\n    updateRatioTravelCollectiveAddonsOrder(input: $input) {\n      id\n      collectiveAddonIds\n    }\n  }";
// language=GraphQL
var ADD_TRAVEL_EXTENSIONS_MUTATION = "\n  mutation Mutation($input: addRatioTravelExtensionsInput) {\n    addRatioTravelExtensions(input: $input) {\n      id\n      extensionIds\n    }\n  }";
// language=GraphQL
var REMOVE_TRAVEL_EXTENSIONS_MUTATION = "\n  mutation Mutation($input: removeRatioTravelExtensionsInput) {\n    removeRatioTravelExtensions(input: $input) {\n      id\n      extensionIds\n    }\n  }";
// language=GraphQL
var CREATE_TRAVEL_EXTENSIONS_MUTATION = "\n  mutation Mutation($input: createRatioTravelExtensionsInput) {\n    createRatioTravelExtensions(input: $input) {\n      id\n      extensionIds\n    }\n  }";
// language=GraphQL
var DELETE_TRAVEL_EXTENSIONS_MUTATION = "\n  mutation Mutation($input: deleteRatioTravelExtensionsInput) {\n    deleteRatioTravelExtensions(input: $input) {\n      id\n      extensionIds\n    }\n  }";
// language=GraphQL
var UPDATE_TRAVEL_EXTENSIONS_ORDER_MUTATION = "\n  mutation Mutation($input: updateRatioTravelExtensionsOrderInput) {\n    updateRatioTravelExtensionsOrder(input: $input) {\n      id\n      extensionIds\n    }\n  }";
// language=GraphQL
var ADD_TRAVEL_PERSONAL_DISCOUNTS_MUTATION = "\n  mutation Mutation($input: addRatioTravelPersonalDiscountsInput) {\n    addRatioTravelPersonalDiscounts(input: $input) {\n      id\n      personalDiscountIds\n    }\n  }";
// language=GraphQL
var REMOVE_TRAVEL_PERSONAL_DISCOUNTS_MUTATION = "\n  mutation Mutation($input: removeRatioTravelPersonalDiscountsInput) {\n    removeRatioTravelPersonalDiscounts(input: $input) {\n      id\n      personalDiscountIds\n    }\n  }";
// language=GraphQL
var CREATE_TRAVEL_PERSONAL_DISCOUNTS_MUTATION = "\n  mutation Mutation($input: createRatioTravelPersonalDiscountsInput) {\n    createRatioTravelPersonalDiscounts(input: $input) {\n      id\n      personalDiscountIds\n    }\n  }";
// language=GraphQL
var DELETE_TRAVEL_PERSONAL_DISCOUNTS_MUTATION = "\n  mutation Mutation($input: deleteRatioTravelPersonalDiscountsInput) {\n    deleteRatioTravelPersonalDiscounts(input: $input) {\n      id\n      personalDiscountIds\n    }\n  }";
// language=GraphQL
var UPDATE_TRAVEL_PERSONAL_DISCOUNTS_ORDER_MUTATION = "\n  mutation Mutation($input: updateRatioTravelPersonalDiscountsOrderInput) {\n    updateRatioTravelPersonalDiscountsOrder(input: $input) {\n      id\n      personalDiscountIds\n    }\n  }";
// language=GraphQL
var TRAVELS_DEPENDENTS_QUERY = "query Query($id: ID!, $withBookings: Boolean = false, $withTravelPricings: Boolean = false, $withCustomBookingFormFieldVisibilityConfigs: Boolean = false) {\n  groupedDependents: ratioTravelDependents(id: $id) {\n    bookings @include(if: $withBookings) {\n      id\n      referenceNo\n      travellerRemarks\n      travellerDataCorrectnessConfirmation\n      localState\n      backofficePayload\n      backofficeResponse\n      transmissionStatus\n      webhookStatus\n      webhookResponse\n      webhookDuration\n      confirmationEmailSent\n      isPassportDataRequired\n      passportDataReminderEmailSent\n      passportDataReceived    }\n    travelPricings @include(if: $withTravelPricings) {\n      id\n      isTravelDocumentationAvailable\n    }\n    customBookingFormFieldVisibilityConfigs @include(if: $withCustomBookingFormFieldVisibilityConfigs) {\n      id\n    }\n  }\n}";

// EXTERNAL MODULE: ./src/entities/ratioCatalogBundle/entity.ts + 3 modules
var entity = __webpack_require__(54371);
// EXTERNAL MODULE: ./src/entities/ratioTravelDate/entity.ts + 3 modules
var ratioTravelDate_entity = __webpack_require__(48086);
// EXTERNAL MODULE: ./src/entities/ratioAccommodation/entity.ts + 3 modules
var ratioAccommodation_entity = __webpack_require__(53656);
// EXTERNAL MODULE: ./src/entities/ratioExtensionAccommodation/entity.ts + 3 modules
var ratioExtensionAccommodation_entity = __webpack_require__(51316);
// EXTERNAL MODULE: ./src/entities/ratioFamilyPackage/entity.ts + 3 modules
var ratioFamilyPackage_entity = __webpack_require__(79028);
// EXTERNAL MODULE: ./src/entities/ratioPersonalAddon/entity.ts + 3 modules
var ratioPersonalAddon_entity = __webpack_require__(34722);
// EXTERNAL MODULE: ./src/entities/ratioAccommodationAddon/entity.ts + 3 modules
var ratioAccommodationAddon_entity = __webpack_require__(88646);
// EXTERNAL MODULE: ./src/entities/ratioBookingAddon/entity.ts + 3 modules
var ratioBookingAddon_entity = __webpack_require__(30250);
// EXTERNAL MODULE: ./src/entities/ratioCollectiveAddon/entity.ts + 3 modules
var ratioCollectiveAddon_entity = __webpack_require__(60826);
// EXTERNAL MODULE: ./src/entities/ratioTravelExtension/entity.ts + 3 modules
var ratioTravelExtension_entity = __webpack_require__(6607);
// EXTERNAL MODULE: ./src/entities/ratioPersonalDiscount/entity.ts + 3 modules
var ratioPersonalDiscount_entity = __webpack_require__(52374);
;// CONCATENATED MODULE: ./src/entities/ratioTravel/model.ts












var ratioTravelModel = {
    name: "travel",
    namePlural: "travels",
    uniqueName: "ratioTravel",
    uniqueNamePlural: "ratioTravels",
    path: "travel/pricing/adaptors/ratio/travel",
    baseUrl: "/travel/pricing/adaptors/ratio/travels",
    translationPrefix: "entities:ratioTravel.",
    getDisplayName: function(values) {
        return "".concat(values.name, " (").concat(values.catalogCode, "/").concat(values.travelCode, ")");
    },
    gql: {
        getAll: ALL_TRAVELS_QUERY,
        getSingle: SINGLE_TRAVEL_QUERY,
        create: CREATE_TRAVEL_MUTATION,
        update: UPDATE_TRAVEL_MUTATION,
        delete: DELETE_TRAVEL_MUTATION,
        forceDelete: FORCE_DELETE_TRAVEL_MUTATION
    },
    attributes: {
        ratioCatalogBundle: {
            name: "ratioCatalogBundle",
            label: "entities:ratioTravel.attributes.ratioCatalogBundle.label",
            type: "entityObject",
            dataType: "any",
            getEntity: function() {
                return entity/* default */.Z;
            },
            defaultInput: false,
            inputType: "select",
            validationType: "string",
            validations: [
                {
                    type: "required"
                }, 
            ]
        },
        catalogCode: {
            name: "catalogCode",
            label: "entities:ratioTravel.attributes.catalogCode.label",
            type: "value",
            dataType: "string",
            defaultInput: true,
            inputType: "text",
            validationType: "string",
            validations: [
                {
                    type: "required"
                }, 
            ]
        },
        travelCode: {
            name: "travelCode",
            label: "entities:ratioTravel.attributes.travelCode.label",
            type: "value",
            dataType: "string",
            defaultInput: true,
            inputType: "text",
            validationType: "string",
            validations: [
                {
                    type: "required"
                }, 
            ]
        },
        destination: {
            name: "destination",
            label: "entities:ratioTravel.attributes.destination.label",
            type: "value",
            dataType: "string",
            defaultInput: true,
            inputType: "text",
            validationType: "string",
            validations: [
                {
                    type: "required"
                }, 
            ]
        },
        name: {
            name: "name",
            label: "entities:ratioTravel.attributes.name.label",
            type: "value",
            dataType: "string",
            defaultInput: true,
            inputType: "text",
            validationType: "string",
            validations: [
                {
                    type: "required"
                }, 
            ]
        },
        transportType: {
            name: "transportType",
            label: "entities:ratioTravel.attributes.transportType.label",
            type: "value",
            dataType: "string",
            defaultInput: true,
            inputType: "text",
            validationType: "string",
            validations: [
                {
                    type: "required"
                }, 
            ]
        },
        transportTypeLabel: {
            name: "transportTypeLabel",
            label: "entities:ratioTravel.attributes.transportTypeLabel.label",
            type: "value",
            dataType: "string",
            defaultInput: true,
            inputType: "text",
            validationType: "string",
            validations: [
                {
                    type: "required"
                }, 
            ]
        },
        dates: {
            name: "dates",
            label: "entities:ratioTravel.attributes.dates.label",
            type: "entityCollection",
            dataType: "[any]",
            getEntity: function() {
                return ratioTravelDate_entity/* default */.Z;
            },
            defaultInput: false,
            inputType: "text",
            validationType: "string",
            validations: []
        },
        accommodations: {
            name: "accommodations",
            label: "entities:ratioTravel.attributes.accommodations.label",
            type: "entityCollection",
            dataType: "[any]",
            getEntity: function() {
                return ratioAccommodation_entity/* default */.Z;
            },
            defaultInput: false,
            inputType: "text",
            validationType: "string",
            validations: []
        },
        extensionAccommodations: {
            name: "extensionAccommodations",
            label: "entities:ratioTravel.attributes.extensionAccommodations.label",
            type: "entityCollection",
            dataType: "[any]",
            getEntity: function() {
                return ratioExtensionAccommodation_entity/* default */.Z;
            },
            defaultInput: false,
            inputType: "text",
            validationType: "string",
            validations: []
        },
        familyPackages: {
            name: "familyPackages",
            label: "entities:ratioTravel.attributes.familyPackages.label",
            type: "entityCollection",
            dataType: "[any]",
            getEntity: function() {
                return ratioFamilyPackage_entity/* default */.Z;
            },
            defaultInput: false,
            inputType: "text",
            validationType: "string",
            validations: []
        },
        personalAddons: {
            name: "personalAddons",
            label: "entities:ratioTravel.attributes.personalAddons.label",
            type: "entityCollection",
            dataType: "[any]",
            getEntity: function() {
                return ratioPersonalAddon_entity/* default */.Z;
            },
            defaultInput: false,
            inputType: "text",
            validationType: "string",
            validations: []
        },
        accommodationAddons: {
            name: "accommodationAddons",
            label: "entities:ratioTravel.attributes.accommodationAddons.label",
            type: "entityCollection",
            dataType: "[any]",
            getEntity: function() {
                return ratioAccommodationAddon_entity/* default */.Z;
            },
            defaultInput: true,
            inputType: "text",
            validationType: "string",
            validations: []
        },
        bookingAddons: {
            name: "bookingAddons",
            label: "entities:ratioTravel.attributes.bookingAddons.label",
            type: "entityCollection",
            dataType: "[any]",
            getEntity: function() {
                return ratioBookingAddon_entity/* default */.Z;
            },
            defaultInput: false,
            inputType: "text",
            validationType: "string",
            validations: []
        },
        collectiveAddons: {
            name: "collectiveAddons",
            label: "entities:ratioTravel.attributes.collectiveAddons.label",
            type: "entityCollection",
            dataType: "[any]",
            getEntity: function() {
                return ratioCollectiveAddon_entity/* default */.Z;
            },
            defaultInput: false,
            inputType: "text",
            validationType: "string",
            validations: []
        },
        extensions: {
            name: "extensions",
            label: "entities:ratioTravel.attributes.extensions.label",
            type: "entityCollection",
            dataType: "[any]",
            getEntity: function() {
                return ratioTravelExtension_entity/* default */.Z;
            },
            defaultInput: false,
            inputType: "text",
            validationType: "string",
            validations: []
        },
        personalDiscounts: {
            name: "personalDiscounts",
            label: "entities:ratioTravel.attributes.personalDiscounts.label",
            type: "entityCollection",
            dataType: "[any]",
            getEntity: function() {
                return ratioPersonalDiscount_entity/* default */.Z;
            },
            defaultInput: true,
            inputType: "text",
            validationType: "string",
            validations: []
        },
        importDateTime: {
            name: "importDateTime",
            label: "entities:ratioTravel.attributes.importDateTime.label",
            type: "value",
            dataType: "string",
            defaultInput: false,
            inputType: "text",
            validationType: "string",
            validations: []
        },
        importStatus: {
            name: "importStatus",
            label: "entities:ratioTravel.attributes.importStatus.label",
            type: "value",
            dataType: "string",
            defaultInput: true,
            inputType: "text",
            validationType: "string",
            validations: []
        }
    }
};
/* harmony default export */ var model = (ratioTravelModel);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(20414);
// EXTERNAL MODULE: ./src/entities/lib.ts
var lib = __webpack_require__(23480);
// EXTERNAL MODULE: ./src/lib/api/graphQLClient.ts
var graphQLClient = __webpack_require__(40112);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/swr/dist/index.mjs
var dist = __webpack_require__(8100);
// EXTERNAL MODULE: ./src/lib/helpers/helpers.ts
var helpers = __webpack_require__(15778);
;// CONCATENATED MODULE: ./src/entities/ratioTravel/repository.ts










var hydrateObjects = function(objects) {
    return objects.map(function(object) {
        return (0,lib/* hydrateEntityObject */.b)(model, object);
    });
};
var hydrateObject = function(object) {
    return (0,lib/* hydrateEntityObject */.b)(model, object);
};
var ratioTravelRepository = {
    getObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    id: id
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(SINGLE_TRAVEL_QUERY, variables).then(function(data) {
                        return hydrateObject(data.travel);
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }(),
    getObjects: /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        var includes;
        var _arguments = arguments;
        return (0,tslib_es6.__generator)(this, function(_state) {
            includes = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : {};
            return [
                2,
                graphQLClient/* default.request */.Z.request(ALL_TRAVELS_QUERY, includes).then(function(data) {
                    return hydrateObjects(data.travels);
                })
            ];
        });
    }),
    useObject: function(id) {
        var includes = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        // eslint-disable-next-line react-hooks/exhaustive-deps
        var variables = (0,react.useMemo)(function() {
            return (0,_object_spread/* default */.Z)({
                id: id
            }, includes);
        }, [
            id
        ]);
        var ref = (0,dist/* default */.ZP)([
            SINGLE_TRAVEL_QUERY,
            variables
        ], {
            revalidateOnFocus: false
        }), data = ref.data, error = ref.error, mutate = ref.mutate;
        return {
            object: !data ? data : hydrateObject(data.travel),
            isLoading: !error && !data,
            isError: error,
            mutate: mutate
        };
    },
    useObjects: function() {
        var includes = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        // eslint-disable-next-line react-hooks/exhaustive-deps
        var variables = (0,react.useMemo)(function() {
            return includes;
        }, []);
        var ref = (0,dist/* default */.ZP)([
            ALL_TRAVELS_QUERY,
            variables
        ]), data = ref.data, error = ref.error, mutate = ref.mutate;
        return {
            objects: !data ? data : hydrateObjects(data.travels),
            isLoading: !error && !data,
            isError: error,
            mutate: mutate
        };
    },
    getDependents: function(id, includes) {
        var includeVars = {};
        includes.forEach(function(include) {
            includeVars["with".concat((0,helpers/* uppercaseFirst */.AB)(include))] = true;
        });
        var variables = (0,_object_spread/* default */.Z)({
            id: id
        }, includeVars);
        return graphQLClient/* default.request */.Z.request(TRAVELS_DEPENDENTS_QUERY, variables).then(function(data) {
            return data.groupedDependents;
        });
    },
    useDependents: function(id, includes) {
        var includeVars = {};
        includes.forEach(function(include) {
            includeVars["with".concat((0,helpers/* uppercaseFirst */.AB)(include))] = true;
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
        var variables = (0,react.useMemo)(function() {
            return (0,_object_spread/* default */.Z)({
                id: id
            }, includeVars);
        }, [
            id
        ]);
        var ref = (0,dist/* default */.ZP)([
            TRAVELS_DEPENDENTS_QUERY,
            variables
        ], {
            revalidateOnFocus: false
        }), data = ref.data, error = ref.error, mutate = ref.mutate;
        return {
            data: !data ? data : data.groupedDependents,
            isLoading: !error && !data,
            isError: error,
            mutate: mutate
        };
    },
    createObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(data) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    input: data
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(CREATE_TRAVEL_MUTATION, variables).then(function(data) {
                        return hydrateObject(data.travel);
                    })
                ];
            });
        });
        return function(data) {
            return _ref.apply(this, arguments);
        };
    }(),
    updateObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(data) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    input: data
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(UPDATE_TRAVEL_MUTATION, variables).then(function(data) {
                        return hydrateObject(data.travel);
                    })
                ];
            });
        });
        return function(data) {
            return _ref.apply(this, arguments);
        };
    }(),
    deleteObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(DELETE_TRAVEL_MUTATION, variables).then(function(data) {
                        return data.deleteRatioTravel;
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }(),
    forceDeleteObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(FORCE_DELETE_TRAVEL_MUTATION, variables).then(function(data) {
                        return data.forceDeleteRatioTravel;
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }(),
    assignDates: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, itemIds) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        dateIds: itemIds
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(ADD_TRAVEL_DATES_MUTATION, variables)
                ];
            });
        });
        return function(id, itemIds) {
            return _ref.apply(this, arguments);
        };
    }(),
    unassignDates: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, itemIds) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        dateIds: itemIds
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(REMOVE_TRAVEL_DATES_MUTATION, variables)
                ];
            });
        });
        return function(id, itemIds) {
            return _ref.apply(this, arguments);
        };
    }(),
    createDates: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, items) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        dates: items
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(CREATE_TRAVEL_DATES_MUTATION, variables)
                ];
            });
        });
        return function(id, items) {
            return _ref.apply(this, arguments);
        };
    }(),
    deleteDates: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, itemIds) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        dateIds: itemIds
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(DELETE_TRAVEL_DATES_MUTATION, variables)
                ];
            });
        });
        return function(id, itemIds) {
            return _ref.apply(this, arguments);
        };
    }(),
    updateDatesOrder: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, itemIds) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        dateIds: itemIds
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(UPDATE_TRAVEL_DATES_ORDER_MUTATION, variables)
                ];
            });
        });
        return function(id, itemIds) {
            return _ref.apply(this, arguments);
        };
    }(),
    assignAccommodations: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, itemIds) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        accommodationIds: itemIds
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(ADD_TRAVEL_ACCOMMODATIONS_MUTATION, variables)
                ];
            });
        });
        return function(id, itemIds) {
            return _ref.apply(this, arguments);
        };
    }(),
    unassignAccommodations: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, itemIds) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        accommodationIds: itemIds
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(REMOVE_TRAVEL_ACCOMMODATIONS_MUTATION, variables)
                ];
            });
        });
        return function(id, itemIds) {
            return _ref.apply(this, arguments);
        };
    }(),
    createAccommodations: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, items) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        accommodations: items
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(CREATE_TRAVEL_ACCOMMODATIONS_MUTATION, variables)
                ];
            });
        });
        return function(id, items) {
            return _ref.apply(this, arguments);
        };
    }(),
    deleteAccommodations: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, itemIds) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        accommodationIds: itemIds
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(DELETE_TRAVEL_ACCOMMODATIONS_MUTATION, variables)
                ];
            });
        });
        return function(id, itemIds) {
            return _ref.apply(this, arguments);
        };
    }(),
    updateAccommodationsOrder: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, itemIds) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        accommodationIds: itemIds
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(UPDATE_TRAVEL_ACCOMMODATIONS_ORDER_MUTATION, variables)
                ];
            });
        });
        return function(id, itemIds) {
            return _ref.apply(this, arguments);
        };
    }(),
    assignExtensionAccommodations: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, itemIds) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        extensionAccommodationIds: itemIds
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(ADD_TRAVEL_EXTENSION_ACCOMMODATIONS_MUTATION, variables)
                ];
            });
        });
        return function(id, itemIds) {
            return _ref.apply(this, arguments);
        };
    }(),
    unassignExtensionAccommodations: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, itemIds) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        extensionAccommodationIds: itemIds
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(REMOVE_TRAVEL_EXTENSION_ACCOMMODATIONS_MUTATION, variables)
                ];
            });
        });
        return function(id, itemIds) {
            return _ref.apply(this, arguments);
        };
    }(),
    createExtensionAccommodations: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, items) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        extensionAccommodations: items
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(CREATE_TRAVEL_EXTENSION_ACCOMMODATIONS_MUTATION, variables)
                ];
            });
        });
        return function(id, items) {
            return _ref.apply(this, arguments);
        };
    }(),
    deleteExtensionAccommodations: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, itemIds) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        extensionAccommodationIds: itemIds
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(DELETE_TRAVEL_EXTENSION_ACCOMMODATIONS_MUTATION, variables)
                ];
            });
        });
        return function(id, itemIds) {
            return _ref.apply(this, arguments);
        };
    }(),
    updateExtensionAccommodationsOrder: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, itemIds) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        extensionAccommodationIds: itemIds
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(UPDATE_TRAVEL_EXTENSION_ACCOMMODATIONS_ORDER_MUTATION, variables)
                ];
            });
        });
        return function(id, itemIds) {
            return _ref.apply(this, arguments);
        };
    }(),
    assignFamilyPackages: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, itemIds) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        familyPackageIds: itemIds
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(ADD_TRAVEL_FAMILY_PACKAGES_MUTATION, variables)
                ];
            });
        });
        return function(id, itemIds) {
            return _ref.apply(this, arguments);
        };
    }(),
    unassignFamilyPackages: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, itemIds) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        familyPackageIds: itemIds
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(REMOVE_TRAVEL_FAMILY_PACKAGES_MUTATION, variables)
                ];
            });
        });
        return function(id, itemIds) {
            return _ref.apply(this, arguments);
        };
    }(),
    createFamilyPackages: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, items) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        familyPackages: items
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(CREATE_TRAVEL_FAMILY_PACKAGES_MUTATION, variables)
                ];
            });
        });
        return function(id, items) {
            return _ref.apply(this, arguments);
        };
    }(),
    deleteFamilyPackages: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, itemIds) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        familyPackageIds: itemIds
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(DELETE_TRAVEL_FAMILY_PACKAGES_MUTATION, variables)
                ];
            });
        });
        return function(id, itemIds) {
            return _ref.apply(this, arguments);
        };
    }(),
    updateFamilyPackagesOrder: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, itemIds) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        familyPackageIds: itemIds
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(UPDATE_TRAVEL_FAMILY_PACKAGES_ORDER_MUTATION, variables)
                ];
            });
        });
        return function(id, itemIds) {
            return _ref.apply(this, arguments);
        };
    }(),
    assignPersonalAddons: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, itemIds) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        personalAddonIds: itemIds
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(ADD_TRAVEL_PERSONAL_ADDONS_MUTATION, variables)
                ];
            });
        });
        return function(id, itemIds) {
            return _ref.apply(this, arguments);
        };
    }(),
    unassignPersonalAddons: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, itemIds) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        personalAddonIds: itemIds
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(REMOVE_TRAVEL_PERSONAL_ADDONS_MUTATION, variables)
                ];
            });
        });
        return function(id, itemIds) {
            return _ref.apply(this, arguments);
        };
    }(),
    createPersonalAddons: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, items) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        personalAddons: items
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(CREATE_TRAVEL_PERSONAL_ADDONS_MUTATION, variables)
                ];
            });
        });
        return function(id, items) {
            return _ref.apply(this, arguments);
        };
    }(),
    deletePersonalAddons: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, itemIds) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        personalAddonIds: itemIds
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(DELETE_TRAVEL_PERSONAL_ADDONS_MUTATION, variables)
                ];
            });
        });
        return function(id, itemIds) {
            return _ref.apply(this, arguments);
        };
    }(),
    updatePersonalAddonsOrder: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, itemIds) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        personalAddonIds: itemIds
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(UPDATE_TRAVEL_PERSONAL_ADDONS_ORDER_MUTATION, variables)
                ];
            });
        });
        return function(id, itemIds) {
            return _ref.apply(this, arguments);
        };
    }(),
    assignAccommodationAddons: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, itemIds) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        accommodationAddonIds: itemIds
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(ADD_TRAVEL_ACCOMMODATION_ADDONS_MUTATION, variables)
                ];
            });
        });
        return function(id, itemIds) {
            return _ref.apply(this, arguments);
        };
    }(),
    unassignAccommodationAddons: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, itemIds) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        accommodationAddonIds: itemIds
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(REMOVE_TRAVEL_ACCOMMODATION_ADDONS_MUTATION, variables)
                ];
            });
        });
        return function(id, itemIds) {
            return _ref.apply(this, arguments);
        };
    }(),
    createAccommodationAddons: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, items) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        accommodationAddons: items
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(CREATE_TRAVEL_ACCOMMODATION_ADDONS_MUTATION, variables)
                ];
            });
        });
        return function(id, items) {
            return _ref.apply(this, arguments);
        };
    }(),
    deleteAccommodationAddons: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, itemIds) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        accommodationAddonIds: itemIds
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(DELETE_TRAVEL_ACCOMMODATION_ADDONS_MUTATION, variables)
                ];
            });
        });
        return function(id, itemIds) {
            return _ref.apply(this, arguments);
        };
    }(),
    updateAccommodationAddonsOrder: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, itemIds) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        accommodationAddonIds: itemIds
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(UPDATE_TRAVEL_ACCOMMODATION_ADDONS_ORDER_MUTATION, variables)
                ];
            });
        });
        return function(id, itemIds) {
            return _ref.apply(this, arguments);
        };
    }(),
    assignBookingAddons: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, itemIds) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        bookingAddonIds: itemIds
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(ADD_TRAVEL_BOOKING_ADDONS_MUTATION, variables)
                ];
            });
        });
        return function(id, itemIds) {
            return _ref.apply(this, arguments);
        };
    }(),
    unassignBookingAddons: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, itemIds) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        bookingAddonIds: itemIds
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(REMOVE_TRAVEL_BOOKING_ADDONS_MUTATION, variables)
                ];
            });
        });
        return function(id, itemIds) {
            return _ref.apply(this, arguments);
        };
    }(),
    createBookingAddons: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, items) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        bookingAddons: items
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(CREATE_TRAVEL_BOOKING_ADDONS_MUTATION, variables)
                ];
            });
        });
        return function(id, items) {
            return _ref.apply(this, arguments);
        };
    }(),
    deleteBookingAddons: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, itemIds) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        bookingAddonIds: itemIds
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(DELETE_TRAVEL_BOOKING_ADDONS_MUTATION, variables)
                ];
            });
        });
        return function(id, itemIds) {
            return _ref.apply(this, arguments);
        };
    }(),
    updateBookingAddonsOrder: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, itemIds) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        bookingAddonIds: itemIds
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(UPDATE_TRAVEL_BOOKING_ADDONS_ORDER_MUTATION, variables)
                ];
            });
        });
        return function(id, itemIds) {
            return _ref.apply(this, arguments);
        };
    }(),
    assignCollectiveAddons: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, itemIds) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        collectiveAddonIds: itemIds
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(ADD_TRAVEL_COLLECTIVE_ADDONS_MUTATION, variables)
                ];
            });
        });
        return function(id, itemIds) {
            return _ref.apply(this, arguments);
        };
    }(),
    unassignCollectiveAddons: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, itemIds) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        collectiveAddonIds: itemIds
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(REMOVE_TRAVEL_COLLECTIVE_ADDONS_MUTATION, variables)
                ];
            });
        });
        return function(id, itemIds) {
            return _ref.apply(this, arguments);
        };
    }(),
    createCollectiveAddons: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, items) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        collectiveAddons: items
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(CREATE_TRAVEL_COLLECTIVE_ADDONS_MUTATION, variables)
                ];
            });
        });
        return function(id, items) {
            return _ref.apply(this, arguments);
        };
    }(),
    deleteCollectiveAddons: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, itemIds) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        collectiveAddonIds: itemIds
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(DELETE_TRAVEL_COLLECTIVE_ADDONS_MUTATION, variables)
                ];
            });
        });
        return function(id, itemIds) {
            return _ref.apply(this, arguments);
        };
    }(),
    updateCollectiveAddonsOrder: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, itemIds) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        collectiveAddonIds: itemIds
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(UPDATE_TRAVEL_COLLECTIVE_ADDONS_ORDER_MUTATION, variables)
                ];
            });
        });
        return function(id, itemIds) {
            return _ref.apply(this, arguments);
        };
    }(),
    assignExtensions: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, itemIds) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        extensionIds: itemIds
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(ADD_TRAVEL_EXTENSIONS_MUTATION, variables)
                ];
            });
        });
        return function(id, itemIds) {
            return _ref.apply(this, arguments);
        };
    }(),
    unassignExtensions: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, itemIds) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        extensionIds: itemIds
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(REMOVE_TRAVEL_EXTENSIONS_MUTATION, variables)
                ];
            });
        });
        return function(id, itemIds) {
            return _ref.apply(this, arguments);
        };
    }(),
    createExtensions: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, items) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        extensions: items
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(CREATE_TRAVEL_EXTENSIONS_MUTATION, variables)
                ];
            });
        });
        return function(id, items) {
            return _ref.apply(this, arguments);
        };
    }(),
    deleteExtensions: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, itemIds) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        extensionIds: itemIds
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(DELETE_TRAVEL_EXTENSIONS_MUTATION, variables)
                ];
            });
        });
        return function(id, itemIds) {
            return _ref.apply(this, arguments);
        };
    }(),
    updateExtensionsOrder: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, itemIds) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        extensionIds: itemIds
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(UPDATE_TRAVEL_EXTENSIONS_ORDER_MUTATION, variables)
                ];
            });
        });
        return function(id, itemIds) {
            return _ref.apply(this, arguments);
        };
    }(),
    assignPersonalDiscounts: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, itemIds) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        personalDiscountIds: itemIds
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(ADD_TRAVEL_PERSONAL_DISCOUNTS_MUTATION, variables)
                ];
            });
        });
        return function(id, itemIds) {
            return _ref.apply(this, arguments);
        };
    }(),
    unassignPersonalDiscounts: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, itemIds) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        personalDiscountIds: itemIds
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(REMOVE_TRAVEL_PERSONAL_DISCOUNTS_MUTATION, variables)
                ];
            });
        });
        return function(id, itemIds) {
            return _ref.apply(this, arguments);
        };
    }(),
    createPersonalDiscounts: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, items) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        personalDiscounts: items
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(CREATE_TRAVEL_PERSONAL_DISCOUNTS_MUTATION, variables)
                ];
            });
        });
        return function(id, items) {
            return _ref.apply(this, arguments);
        };
    }(),
    deletePersonalDiscounts: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, itemIds) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        personalDiscountIds: itemIds
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(DELETE_TRAVEL_PERSONAL_DISCOUNTS_MUTATION, variables)
                ];
            });
        });
        return function(id, itemIds) {
            return _ref.apply(this, arguments);
        };
    }(),
    updatePersonalDiscountsOrder: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, itemIds) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        personalDiscountIds: itemIds
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(UPDATE_TRAVEL_PERSONAL_DISCOUNTS_ORDER_MUTATION, variables)
                ];
            });
        });
        return function(id, itemIds) {
            return _ref.apply(this, arguments);
        };
    }()
};
/* harmony default export */ var repository = (ratioTravelRepository);

;// CONCATENATED MODULE: ./src/entities/ratioTravel/entity.ts


var ratioTravelEntity = {
    model: model,
    repository: repository
};
/* harmony default export */ var ratioTravel_entity = (ratioTravelEntity);


/***/ }),

/***/ 48086:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ ratioTravelDate_entity; }
});

;// CONCATENATED MODULE: ./src/entities/ratioTravelDate/graphql.ts
// language=GraphQL
var ALL_DATES_QUERY = "query Query($withAvailabilityStatus: Boolean = false, $withAvailabilityStatusTenantSettings: Boolean = false, $withAvailabilityStatusTenantSettingsTenant: Boolean = false, $withExtensionBaseDate: Boolean = false, $withExtensionBaseDateAvailabilityStatus: Boolean = false, $withExtensionBaseDateAvailabilityStatusTenantSettings: Boolean = false, $withExtensionBaseDateExtensionBaseDate: Boolean = false, $withExtensionBaseDateExtensionBaseDateAvailabilityStatus: Boolean = false, $withExtensionBaseDateExtensionBaseDateExtensionBaseDate: Boolean = false, $withExtensionBaseDateExtensionBaseDateExtension: Boolean = false, $withExtensionBaseDateExtensionBaseDatePackageSettings: Boolean = false, $withExtensionBaseDateExtensionBaseDateExtensions: Boolean = false, $withExtensionBaseDateExtension: Boolean = false, $withExtensionBaseDateExtensionTravelExtension: Boolean = false, $withExtensionBaseDateExtensionAccommodationMapItems: Boolean = false, $withExtensionBaseDatePackageSettings: Boolean = false, $withExtensionBaseDateExtensions: Boolean = false, $withExtensionBaseDateExtensionsTravelExtension: Boolean = false, $withExtensionBaseDateExtensionsAccommodationMapItems: Boolean = false, $withExtension: Boolean = false, $withExtensionTravelExtension: Boolean = false, $withExtensionTravelExtensionHighlights: Boolean = false, $withExtensionTravelExtensionImage: Boolean = false, $withExtensionAccommodationMapItems: Boolean = false, $withExtensionAccommodationMapItemsBaseAccommodation: Boolean = false, $withExtensionAccommodationMapItemsExtensionAccommodation: Boolean = false, $withPackageSettings: Boolean = false, $withExtensions: Boolean = false, $withExtensionsTravelExtension: Boolean = false, $withExtensionsTravelExtensionHighlights: Boolean = false, $withExtensionsTravelExtensionImage: Boolean = false, $withExtensionsAccommodationMapItems: Boolean = false, $withExtensionsAccommodationMapItemsBaseAccommodation: Boolean = false, $withExtensionsAccommodationMapItemsExtensionAccommodation: Boolean = false) {\n  dates: ratioTravelDates {\n    id\n    dateNo\n    startDate\n    endDate\n    availabilityStatus @include(if: $withAvailabilityStatus) {\n      id\n      label\n      status\n      isDefaultStatus\n      isDefaultWaitlistFallback\n      tenantSettings @include(if: $withAvailabilityStatusTenantSettings) {\n        id\n        tenant @include(if: $withAvailabilityStatusTenantSettingsTenant) {\n          id\n          name\n          slug\n          domain\n          externalReference\n        }\n        label\n        info\n        switchToStatusInfo\n        submitButtonLabel\n      }\n    }\n    includesExtension\n    extensionBaseDate @include(if: $withExtensionBaseDate) {\n      id\n      dateNo\n      startDate\n      endDate\n      availabilityStatus @include(if: $withExtensionBaseDateAvailabilityStatus) {\n        id\n        label\n        status\n        isDefaultStatus\n        isDefaultWaitlistFallback\n        tenantSettings @include(if: $withExtensionBaseDateAvailabilityStatusTenantSettings) {\n          id\n          label\n          info\n          switchToStatusInfo\n          submitButtonLabel\n        }\n      }\n      includesExtension\n      extensionBaseDate @include(if: $withExtensionBaseDateExtensionBaseDate) {\n        id\n        dateNo\n        startDate\n        endDate\n        availabilityStatus @include(if: $withExtensionBaseDateExtensionBaseDateAvailabilityStatus) {\n          id\n          label\n          status\n          isDefaultStatus\n          isDefaultWaitlistFallback\n        }\n        includesExtension\n        extensionBaseDate @include(if: $withExtensionBaseDateExtensionBaseDateExtensionBaseDate) {\n          id\n          dateNo\n          startDate\n          endDate\n          includesExtension\n          json\n        }\n        extension @include(if: $withExtensionBaseDateExtensionBaseDateExtension) {\n          id\n          label\n          info\n        }\n        packageSettings @include(if: $withExtensionBaseDateExtensionBaseDatePackageSettings) {\n          id\n          ratioPackageNo\n          price\n          availabilityStatus\n        }\n        json\n        extensions @include(if: $withExtensionBaseDateExtensionBaseDateExtensions) {\n          id\n          label\n          info\n        }\n      }\n      extension @include(if: $withExtensionBaseDateExtension) {\n        id\n        label\n        info\n        travelExtension @include(if: $withExtensionBaseDateExtensionTravelExtension) {\n          id\n          duration\n          name\n          description\n        }\n        accommodationMapItems @include(if: $withExtensionBaseDateExtensionAccommodationMapItems) {\n          id\n        }\n      }\n      packageSettings @include(if: $withExtensionBaseDatePackageSettings) {\n        id\n        ratioPackageNo\n        price\n        availabilityStatus\n      }\n      json\n      extensions @include(if: $withExtensionBaseDateExtensions) {\n        id\n        label\n        info\n        travelExtension @include(if: $withExtensionBaseDateExtensionsTravelExtension) {\n          id\n          duration\n          name\n          description\n        }\n        accommodationMapItems @include(if: $withExtensionBaseDateExtensionsAccommodationMapItems) {\n          id\n        }\n      }\n    }\n    extension @include(if: $withExtension) {\n      id\n      label\n      info\n      travelExtension @include(if: $withExtensionTravelExtension) {\n        id\n        duration\n        name\n        description\n        highlights @include(if: $withExtensionTravelExtensionHighlights) {\n          id\n          text\n        }\n        image @include(if: $withExtensionTravelExtensionImage) {\n          id\n          assetId\n          publicId\n          url\n          resourceType\n          format\n          width\n          height\n          caption\n          title\n          description\n        }\n      }\n      accommodationMapItems @include(if: $withExtensionAccommodationMapItems) {\n        id\n        baseAccommodation @include(if: $withExtensionAccommodationMapItemsBaseAccommodation) {\n          id\n          ratioPackageNo\n          name\n          label\n          info\n          isFamilyPackageAccommodation\n          isBabyPackage\n        }\n        extensionAccommodation @include(if: $withExtensionAccommodationMapItemsExtensionAccommodation) {\n          id\n          ratioPackageNo\n          name\n          label\n          info\n          extensionAccommodationServiceNo\n        }\n      }\n    }\n    packageSettings @include(if: $withPackageSettings) {\n      id\n      ratioPackageNo\n      price\n      availabilityStatus\n    }\n    json\n    extensions @include(if: $withExtensions) {\n      id\n      label\n      info\n      travelExtension @include(if: $withExtensionsTravelExtension) {\n        id\n        duration\n        name\n        description\n        highlights @include(if: $withExtensionsTravelExtensionHighlights) {\n          id\n          text\n        }\n        image @include(if: $withExtensionsTravelExtensionImage) {\n          id\n          assetId\n          publicId\n          url\n          resourceType\n          format\n          width\n          height\n          caption\n          title\n          description\n        }\n      }\n      accommodationMapItems @include(if: $withExtensionsAccommodationMapItems) {\n        id\n        baseAccommodation @include(if: $withExtensionsAccommodationMapItemsBaseAccommodation) {\n          id\n          ratioPackageNo\n          name\n          label\n          info\n          isFamilyPackageAccommodation\n          isBabyPackage\n        }\n        extensionAccommodation @include(if: $withExtensionsAccommodationMapItemsExtensionAccommodation) {\n          id\n          ratioPackageNo\n          name\n          label\n          info\n          extensionAccommodationServiceNo\n        }\n      }\n    }\n  }\n}";
// language=GraphQL
var SINGLE_DATE_QUERY = "query Query($id: ID!, $withAvailabilityStatus: Boolean = false, $withAvailabilityStatusTenantSettings: Boolean = false, $withAvailabilityStatusTenantSettingsTenant: Boolean = false, $withExtensionBaseDate: Boolean = false, $withExtensionBaseDateAvailabilityStatus: Boolean = false, $withExtensionBaseDateAvailabilityStatusTenantSettings: Boolean = false, $withExtensionBaseDateExtensionBaseDate: Boolean = false, $withExtensionBaseDateExtensionBaseDateAvailabilityStatus: Boolean = false, $withExtensionBaseDateExtensionBaseDateExtensionBaseDate: Boolean = false, $withExtensionBaseDateExtensionBaseDateExtension: Boolean = false, $withExtensionBaseDateExtensionBaseDatePackageSettings: Boolean = false, $withExtensionBaseDateExtensionBaseDateExtensions: Boolean = false, $withExtensionBaseDateExtension: Boolean = false, $withExtensionBaseDateExtensionTravelExtension: Boolean = false, $withExtensionBaseDateExtensionAccommodationMapItems: Boolean = false, $withExtensionBaseDatePackageSettings: Boolean = false, $withExtensionBaseDateExtensions: Boolean = false, $withExtensionBaseDateExtensionsTravelExtension: Boolean = false, $withExtensionBaseDateExtensionsAccommodationMapItems: Boolean = false, $withExtension: Boolean = false, $withExtensionTravelExtension: Boolean = false, $withExtensionTravelExtensionHighlights: Boolean = false, $withExtensionTravelExtensionImage: Boolean = false, $withExtensionAccommodationMapItems: Boolean = false, $withExtensionAccommodationMapItemsBaseAccommodation: Boolean = false, $withExtensionAccommodationMapItemsExtensionAccommodation: Boolean = false, $withPackageSettings: Boolean = false, $withExtensions: Boolean = false, $withExtensionsTravelExtension: Boolean = false, $withExtensionsTravelExtensionHighlights: Boolean = false, $withExtensionsTravelExtensionImage: Boolean = false, $withExtensionsAccommodationMapItems: Boolean = false, $withExtensionsAccommodationMapItemsBaseAccommodation: Boolean = false, $withExtensionsAccommodationMapItemsExtensionAccommodation: Boolean = false) {\n  date: ratioTravelDate(id: $id) {\n    id\n    dateNo\n    startDate\n    endDate\n    availabilityStatus @include(if: $withAvailabilityStatus) {\n      id\n      label\n      status\n      isDefaultStatus\n      isDefaultWaitlistFallback\n      tenantSettings @include(if: $withAvailabilityStatusTenantSettings) {\n        id\n        tenant @include(if: $withAvailabilityStatusTenantSettingsTenant) {\n          id\n          name\n          slug\n          domain\n          externalReference\n        }\n        label\n        info\n        switchToStatusInfo\n        submitButtonLabel\n      }\n    }\n    includesExtension\n    extensionBaseDate @include(if: $withExtensionBaseDate) {\n      id\n      dateNo\n      startDate\n      endDate\n      availabilityStatus @include(if: $withExtensionBaseDateAvailabilityStatus) {\n        id\n        label\n        status\n        isDefaultStatus\n        isDefaultWaitlistFallback\n        tenantSettings @include(if: $withExtensionBaseDateAvailabilityStatusTenantSettings) {\n          id\n          label\n          info\n          switchToStatusInfo\n          submitButtonLabel\n        }\n      }\n      includesExtension\n      extensionBaseDate @include(if: $withExtensionBaseDateExtensionBaseDate) {\n        id\n        dateNo\n        startDate\n        endDate\n        availabilityStatus @include(if: $withExtensionBaseDateExtensionBaseDateAvailabilityStatus) {\n          id\n          label\n          status\n          isDefaultStatus\n          isDefaultWaitlistFallback\n        }\n        includesExtension\n        extensionBaseDate @include(if: $withExtensionBaseDateExtensionBaseDateExtensionBaseDate) {\n          id\n          dateNo\n          startDate\n          endDate\n          includesExtension\n          json\n        }\n        extension @include(if: $withExtensionBaseDateExtensionBaseDateExtension) {\n          id\n          label\n          info\n        }\n        packageSettings @include(if: $withExtensionBaseDateExtensionBaseDatePackageSettings) {\n          id\n          ratioPackageNo\n          price\n          availabilityStatus\n        }\n        json\n        extensions @include(if: $withExtensionBaseDateExtensionBaseDateExtensions) {\n          id\n          label\n          info\n        }\n      }\n      extension @include(if: $withExtensionBaseDateExtension) {\n        id\n        label\n        info\n        travelExtension @include(if: $withExtensionBaseDateExtensionTravelExtension) {\n          id\n          duration\n          name\n          description\n        }\n        accommodationMapItems @include(if: $withExtensionBaseDateExtensionAccommodationMapItems) {\n          id\n        }\n      }\n      packageSettings @include(if: $withExtensionBaseDatePackageSettings) {\n        id\n        ratioPackageNo\n        price\n        availabilityStatus\n      }\n      json\n      extensions @include(if: $withExtensionBaseDateExtensions) {\n        id\n        label\n        info\n        travelExtension @include(if: $withExtensionBaseDateExtensionsTravelExtension) {\n          id\n          duration\n          name\n          description\n        }\n        accommodationMapItems @include(if: $withExtensionBaseDateExtensionsAccommodationMapItems) {\n          id\n        }\n      }\n    }\n    extension @include(if: $withExtension) {\n      id\n      label\n      info\n      travelExtension @include(if: $withExtensionTravelExtension) {\n        id\n        duration\n        name\n        description\n        highlights @include(if: $withExtensionTravelExtensionHighlights) {\n          id\n          text\n        }\n        image @include(if: $withExtensionTravelExtensionImage) {\n          id\n          assetId\n          publicId\n          url\n          resourceType\n          format\n          width\n          height\n          caption\n          title\n          description\n        }\n      }\n      accommodationMapItems @include(if: $withExtensionAccommodationMapItems) {\n        id\n        baseAccommodation @include(if: $withExtensionAccommodationMapItemsBaseAccommodation) {\n          id\n          ratioPackageNo\n          name\n          label\n          info\n          isFamilyPackageAccommodation\n          isBabyPackage\n        }\n        extensionAccommodation @include(if: $withExtensionAccommodationMapItemsExtensionAccommodation) {\n          id\n          ratioPackageNo\n          name\n          label\n          info\n          extensionAccommodationServiceNo\n        }\n      }\n    }\n    packageSettings @include(if: $withPackageSettings) {\n      id\n      ratioPackageNo\n      price\n      availabilityStatus\n    }\n    json\n    extensions @include(if: $withExtensions) {\n      id\n      label\n      info\n      travelExtension @include(if: $withExtensionsTravelExtension) {\n        id\n        duration\n        name\n        description\n        highlights @include(if: $withExtensionsTravelExtensionHighlights) {\n          id\n          text\n        }\n        image @include(if: $withExtensionsTravelExtensionImage) {\n          id\n          assetId\n          publicId\n          url\n          resourceType\n          format\n          width\n          height\n          caption\n          title\n          description\n        }\n      }\n      accommodationMapItems @include(if: $withExtensionsAccommodationMapItems) {\n        id\n        baseAccommodation @include(if: $withExtensionsAccommodationMapItemsBaseAccommodation) {\n          id\n          ratioPackageNo\n          name\n          label\n          info\n          isFamilyPackageAccommodation\n          isBabyPackage\n        }\n        extensionAccommodation @include(if: $withExtensionsAccommodationMapItemsExtensionAccommodation) {\n          id\n          ratioPackageNo\n          name\n          label\n          info\n          extensionAccommodationServiceNo\n        }\n      }\n    }\n  }\n}";
// language=GraphQL
var CREATE_DATE_MUTATION = "\n  mutation Mutation($input: CreateRatioTravelDateInput, $withAvailabilityStatus: Boolean = false, $withAvailabilityStatusTenantSettings: Boolean = false, $withAvailabilityStatusTenantSettingsTenant: Boolean = false, $withExtensionBaseDate: Boolean = false, $withExtensionBaseDateAvailabilityStatus: Boolean = false, $withExtensionBaseDateAvailabilityStatusTenantSettings: Boolean = false, $withExtensionBaseDateExtensionBaseDate: Boolean = false, $withExtensionBaseDateExtensionBaseDateAvailabilityStatus: Boolean = false, $withExtensionBaseDateExtensionBaseDateExtensionBaseDate: Boolean = false, $withExtensionBaseDateExtensionBaseDateExtension: Boolean = false, $withExtensionBaseDateExtensionBaseDatePackageSettings: Boolean = false, $withExtensionBaseDateExtensionBaseDateExtensions: Boolean = false, $withExtensionBaseDateExtension: Boolean = false, $withExtensionBaseDateExtensionTravelExtension: Boolean = false, $withExtensionBaseDateExtensionAccommodationMapItems: Boolean = false, $withExtensionBaseDatePackageSettings: Boolean = false, $withExtensionBaseDateExtensions: Boolean = false, $withExtensionBaseDateExtensionsTravelExtension: Boolean = false, $withExtensionBaseDateExtensionsAccommodationMapItems: Boolean = false, $withExtension: Boolean = false, $withExtensionTravelExtension: Boolean = false, $withExtensionTravelExtensionHighlights: Boolean = false, $withExtensionTravelExtensionImage: Boolean = false, $withExtensionAccommodationMapItems: Boolean = false, $withExtensionAccommodationMapItemsBaseAccommodation: Boolean = false, $withExtensionAccommodationMapItemsExtensionAccommodation: Boolean = false, $withPackageSettings: Boolean = false, $withExtensions: Boolean = false, $withExtensionsTravelExtension: Boolean = false, $withExtensionsTravelExtensionHighlights: Boolean = false, $withExtensionsTravelExtensionImage: Boolean = false, $withExtensionsAccommodationMapItems: Boolean = false, $withExtensionsAccommodationMapItemsBaseAccommodation: Boolean = false, $withExtensionsAccommodationMapItemsExtensionAccommodation: Boolean = false) {\n    date: createRatioTravelDate(input: $input) {\n      id\n      dateNo\n      startDate\n      endDate\n      availabilityStatus @include(if: $withAvailabilityStatus) {\n        id\n        label\n        status\n        isDefaultStatus\n        isDefaultWaitlistFallback\n        tenantSettings @include(if: $withAvailabilityStatusTenantSettings) {\n          id\n          tenant @include(if: $withAvailabilityStatusTenantSettingsTenant) {\n            id\n            name\n            slug\n            domain\n            externalReference\n          }\n          label\n          info\n          switchToStatusInfo\n          submitButtonLabel\n        }\n      }\n      includesExtension\n      extensionBaseDate @include(if: $withExtensionBaseDate) {\n        id\n        dateNo\n        startDate\n        endDate\n        availabilityStatus @include(if: $withExtensionBaseDateAvailabilityStatus) {\n          id\n          label\n          status\n          isDefaultStatus\n          isDefaultWaitlistFallback\n          tenantSettings @include(if: $withExtensionBaseDateAvailabilityStatusTenantSettings) {\n            id\n            label\n            info\n            switchToStatusInfo\n            submitButtonLabel\n          }\n        }\n        includesExtension\n        extensionBaseDate @include(if: $withExtensionBaseDateExtensionBaseDate) {\n          id\n          dateNo\n          startDate\n          endDate\n          availabilityStatus @include(if: $withExtensionBaseDateExtensionBaseDateAvailabilityStatus) {\n            id\n            label\n            status\n            isDefaultStatus\n            isDefaultWaitlistFallback\n          }\n          includesExtension\n          extensionBaseDate @include(if: $withExtensionBaseDateExtensionBaseDateExtensionBaseDate) {\n            id\n            dateNo\n            startDate\n            endDate\n            includesExtension\n            json\n          }\n          extension @include(if: $withExtensionBaseDateExtensionBaseDateExtension) {\n            id\n            label\n            info\n          }\n          packageSettings @include(if: $withExtensionBaseDateExtensionBaseDatePackageSettings) {\n            id\n            ratioPackageNo\n            price\n            availabilityStatus\n          }\n          json\n          extensions @include(if: $withExtensionBaseDateExtensionBaseDateExtensions) {\n            id\n            label\n            info\n          }\n        }\n        extension @include(if: $withExtensionBaseDateExtension) {\n          id\n          label\n          info\n          travelExtension @include(if: $withExtensionBaseDateExtensionTravelExtension) {\n            id\n            duration\n            name\n            description\n          }\n          accommodationMapItems @include(if: $withExtensionBaseDateExtensionAccommodationMapItems) {\n            id\n          }\n        }\n        packageSettings @include(if: $withExtensionBaseDatePackageSettings) {\n          id\n          ratioPackageNo\n          price\n          availabilityStatus\n        }\n        json\n        extensions @include(if: $withExtensionBaseDateExtensions) {\n          id\n          label\n          info\n          travelExtension @include(if: $withExtensionBaseDateExtensionsTravelExtension) {\n            id\n            duration\n            name\n            description\n          }\n          accommodationMapItems @include(if: $withExtensionBaseDateExtensionsAccommodationMapItems) {\n            id\n          }\n        }\n      }\n      extension @include(if: $withExtension) {\n        id\n        label\n        info\n        travelExtension @include(if: $withExtensionTravelExtension) {\n          id\n          duration\n          name\n          description\n          highlights @include(if: $withExtensionTravelExtensionHighlights) {\n            id\n            text\n          }\n          image @include(if: $withExtensionTravelExtensionImage) {\n            id\n            assetId\n            publicId\n            url\n            resourceType\n            format\n            width\n            height\n            caption\n            title\n            description\n          }\n        }\n        accommodationMapItems @include(if: $withExtensionAccommodationMapItems) {\n          id\n          baseAccommodation @include(if: $withExtensionAccommodationMapItemsBaseAccommodation) {\n            id\n            ratioPackageNo\n            name\n            label\n            info\n            isFamilyPackageAccommodation\n            isBabyPackage\n          }\n          extensionAccommodation @include(if: $withExtensionAccommodationMapItemsExtensionAccommodation) {\n            id\n            ratioPackageNo\n            name\n            label\n            info\n            extensionAccommodationServiceNo\n          }\n        }\n      }\n      packageSettings @include(if: $withPackageSettings) {\n        id\n        ratioPackageNo\n        price\n        availabilityStatus\n      }\n      json\n      extensions @include(if: $withExtensions) {\n        id\n        label\n        info\n        travelExtension @include(if: $withExtensionsTravelExtension) {\n          id\n          duration\n          name\n          description\n          highlights @include(if: $withExtensionsTravelExtensionHighlights) {\n            id\n            text\n          }\n          image @include(if: $withExtensionsTravelExtensionImage) {\n            id\n            assetId\n            publicId\n            url\n            resourceType\n            format\n            width\n            height\n            caption\n            title\n            description\n          }\n        }\n        accommodationMapItems @include(if: $withExtensionsAccommodationMapItems) {\n          id\n          baseAccommodation @include(if: $withExtensionsAccommodationMapItemsBaseAccommodation) {\n            id\n            ratioPackageNo\n            name\n            label\n            info\n            isFamilyPackageAccommodation\n            isBabyPackage\n          }\n          extensionAccommodation @include(if: $withExtensionsAccommodationMapItemsExtensionAccommodation) {\n            id\n            ratioPackageNo\n            name\n            label\n            info\n            extensionAccommodationServiceNo\n          }\n        }\n      }\n    }\n  }";
// language=GraphQL
var UPDATE_DATE_MUTATION = "\n  mutation Mutation($input: UpdateRatioTravelDateInput, $withAvailabilityStatus: Boolean = false, $withAvailabilityStatusTenantSettings: Boolean = false, $withAvailabilityStatusTenantSettingsTenant: Boolean = false, $withExtensionBaseDate: Boolean = false, $withExtensionBaseDateAvailabilityStatus: Boolean = false, $withExtensionBaseDateAvailabilityStatusTenantSettings: Boolean = false, $withExtensionBaseDateExtensionBaseDate: Boolean = false, $withExtensionBaseDateExtensionBaseDateAvailabilityStatus: Boolean = false, $withExtensionBaseDateExtensionBaseDateExtensionBaseDate: Boolean = false, $withExtensionBaseDateExtensionBaseDateExtension: Boolean = false, $withExtensionBaseDateExtensionBaseDatePackageSettings: Boolean = false, $withExtensionBaseDateExtensionBaseDateExtensions: Boolean = false, $withExtensionBaseDateExtension: Boolean = false, $withExtensionBaseDateExtensionTravelExtension: Boolean = false, $withExtensionBaseDateExtensionAccommodationMapItems: Boolean = false, $withExtensionBaseDatePackageSettings: Boolean = false, $withExtensionBaseDateExtensions: Boolean = false, $withExtensionBaseDateExtensionsTravelExtension: Boolean = false, $withExtensionBaseDateExtensionsAccommodationMapItems: Boolean = false, $withExtension: Boolean = false, $withExtensionTravelExtension: Boolean = false, $withExtensionTravelExtensionHighlights: Boolean = false, $withExtensionTravelExtensionImage: Boolean = false, $withExtensionAccommodationMapItems: Boolean = false, $withExtensionAccommodationMapItemsBaseAccommodation: Boolean = false, $withExtensionAccommodationMapItemsExtensionAccommodation: Boolean = false, $withPackageSettings: Boolean = false, $withExtensions: Boolean = false, $withExtensionsTravelExtension: Boolean = false, $withExtensionsTravelExtensionHighlights: Boolean = false, $withExtensionsTravelExtensionImage: Boolean = false, $withExtensionsAccommodationMapItems: Boolean = false, $withExtensionsAccommodationMapItemsBaseAccommodation: Boolean = false, $withExtensionsAccommodationMapItemsExtensionAccommodation: Boolean = false) {\n    date: updateRatioTravelDate(input: $input) {\n      id\n      dateNo\n      startDate\n      endDate\n      availabilityStatus @include(if: $withAvailabilityStatus) {\n        id\n        label\n        status\n        isDefaultStatus\n        isDefaultWaitlistFallback\n        tenantSettings @include(if: $withAvailabilityStatusTenantSettings) {\n          id\n          tenant @include(if: $withAvailabilityStatusTenantSettingsTenant) {\n            id\n            name\n            slug\n            domain\n            externalReference\n          }\n          label\n          info\n          switchToStatusInfo\n          submitButtonLabel\n        }\n      }\n      includesExtension\n      extensionBaseDate @include(if: $withExtensionBaseDate) {\n        id\n        dateNo\n        startDate\n        endDate\n        availabilityStatus @include(if: $withExtensionBaseDateAvailabilityStatus) {\n          id\n          label\n          status\n          isDefaultStatus\n          isDefaultWaitlistFallback\n          tenantSettings @include(if: $withExtensionBaseDateAvailabilityStatusTenantSettings) {\n            id\n            label\n            info\n            switchToStatusInfo\n            submitButtonLabel\n          }\n        }\n        includesExtension\n        extensionBaseDate @include(if: $withExtensionBaseDateExtensionBaseDate) {\n          id\n          dateNo\n          startDate\n          endDate\n          availabilityStatus @include(if: $withExtensionBaseDateExtensionBaseDateAvailabilityStatus) {\n            id\n            label\n            status\n            isDefaultStatus\n            isDefaultWaitlistFallback\n          }\n          includesExtension\n          extensionBaseDate @include(if: $withExtensionBaseDateExtensionBaseDateExtensionBaseDate) {\n            id\n            dateNo\n            startDate\n            endDate\n            includesExtension\n            json\n          }\n          extension @include(if: $withExtensionBaseDateExtensionBaseDateExtension) {\n            id\n            label\n            info\n          }\n          packageSettings @include(if: $withExtensionBaseDateExtensionBaseDatePackageSettings) {\n            id\n            ratioPackageNo\n            price\n            availabilityStatus\n          }\n          json\n          extensions @include(if: $withExtensionBaseDateExtensionBaseDateExtensions) {\n            id\n            label\n            info\n          }\n        }\n        extension @include(if: $withExtensionBaseDateExtension) {\n          id\n          label\n          info\n          travelExtension @include(if: $withExtensionBaseDateExtensionTravelExtension) {\n            id\n            duration\n            name\n            description\n          }\n          accommodationMapItems @include(if: $withExtensionBaseDateExtensionAccommodationMapItems) {\n            id\n          }\n        }\n        packageSettings @include(if: $withExtensionBaseDatePackageSettings) {\n          id\n          ratioPackageNo\n          price\n          availabilityStatus\n        }\n        json\n        extensions @include(if: $withExtensionBaseDateExtensions) {\n          id\n          label\n          info\n          travelExtension @include(if: $withExtensionBaseDateExtensionsTravelExtension) {\n            id\n            duration\n            name\n            description\n          }\n          accommodationMapItems @include(if: $withExtensionBaseDateExtensionsAccommodationMapItems) {\n            id\n          }\n        }\n      }\n      extension @include(if: $withExtension) {\n        id\n        label\n        info\n        travelExtension @include(if: $withExtensionTravelExtension) {\n          id\n          duration\n          name\n          description\n          highlights @include(if: $withExtensionTravelExtensionHighlights) {\n            id\n            text\n          }\n          image @include(if: $withExtensionTravelExtensionImage) {\n            id\n            assetId\n            publicId\n            url\n            resourceType\n            format\n            width\n            height\n            caption\n            title\n            description\n          }\n        }\n        accommodationMapItems @include(if: $withExtensionAccommodationMapItems) {\n          id\n          baseAccommodation @include(if: $withExtensionAccommodationMapItemsBaseAccommodation) {\n            id\n            ratioPackageNo\n            name\n            label\n            info\n            isFamilyPackageAccommodation\n            isBabyPackage\n          }\n          extensionAccommodation @include(if: $withExtensionAccommodationMapItemsExtensionAccommodation) {\n            id\n            ratioPackageNo\n            name\n            label\n            info\n            extensionAccommodationServiceNo\n          }\n        }\n      }\n      packageSettings @include(if: $withPackageSettings) {\n        id\n        ratioPackageNo\n        price\n        availabilityStatus\n      }\n      json\n      extensions @include(if: $withExtensions) {\n        id\n        label\n        info\n        travelExtension @include(if: $withExtensionsTravelExtension) {\n          id\n          duration\n          name\n          description\n          highlights @include(if: $withExtensionsTravelExtensionHighlights) {\n            id\n            text\n          }\n          image @include(if: $withExtensionsTravelExtensionImage) {\n            id\n            assetId\n            publicId\n            url\n            resourceType\n            format\n            width\n            height\n            caption\n            title\n            description\n          }\n        }\n        accommodationMapItems @include(if: $withExtensionsAccommodationMapItems) {\n          id\n          baseAccommodation @include(if: $withExtensionsAccommodationMapItemsBaseAccommodation) {\n            id\n            ratioPackageNo\n            name\n            label\n            info\n            isFamilyPackageAccommodation\n            isBabyPackage\n          }\n          extensionAccommodation @include(if: $withExtensionsAccommodationMapItemsExtensionAccommodation) {\n            id\n            ratioPackageNo\n            name\n            label\n            info\n            extensionAccommodationServiceNo\n          }\n        }\n      }\n    }\n  }";
// language=GraphQL
var DELETE_DATE_MUTATION = "\n  mutation Mutation($input: DeleteRatioTravelDateInput) {\n    deleteRatioTravelDate(input: $input) {\n      success\n    }\n  }";
// language=GraphQL
var FORCE_DELETE_DATE_MUTATION = "\n  mutation Mutation($input: DeleteRatioTravelDateInput) {\n    forceDeleteRatioTravelDate(input: $input) {\n      success\n    }\n  }";
// language=GraphQL
var ADD_DATE_PACKAGE_SETTINGS_MUTATION = "\n  mutation Mutation($input: addRatioTravelDatePackageSettingsInput) {\n    addRatioTravelDatePackageSettings(input: $input) {\n      id\n      packageSettingsIds\n    }\n  }";
// language=GraphQL
var REMOVE_DATE_PACKAGE_SETTINGS_MUTATION = "\n  mutation Mutation($input: removeRatioTravelDatePackageSettingsInput) {\n    removeRatioTravelDatePackageSettings(input: $input) {\n      id\n      packageSettingsIds\n    }\n  }";
// language=GraphQL
var CREATE_DATE_PACKAGE_SETTINGS_MUTATION = "\n  mutation Mutation($input: createRatioTravelDatePackageSettingsInput) {\n    createRatioTravelDatePackageSettings(input: $input) {\n      id\n      packageSettingsIds\n    }\n  }";
// language=GraphQL
var DELETE_DATE_PACKAGE_SETTINGS_MUTATION = "\n  mutation Mutation($input: deleteRatioTravelDatePackageSettingsInput) {\n    deleteRatioTravelDatePackageSettings(input: $input) {\n      id\n      packageSettingsIds\n    }\n  }";
// language=GraphQL
var ADD_DATE_EXTENSIONS_MUTATION = "\n  mutation Mutation($input: addRatioTravelDateExtensionsInput) {\n    addRatioTravelDateExtensions(input: $input) {\n      id\n      extensionIds\n    }\n  }";
// language=GraphQL
var REMOVE_DATE_EXTENSIONS_MUTATION = "\n  mutation Mutation($input: removeRatioTravelDateExtensionsInput) {\n    removeRatioTravelDateExtensions(input: $input) {\n      id\n      extensionIds\n    }\n  }";
// language=GraphQL
var CREATE_DATE_EXTENSIONS_MUTATION = "\n  mutation Mutation($input: createRatioTravelDateExtensionsInput) {\n    createRatioTravelDateExtensions(input: $input) {\n      id\n      extensionIds\n    }\n  }";
// language=GraphQL
var DELETE_DATE_EXTENSIONS_MUTATION = "\n  mutation Mutation($input: deleteRatioTravelDateExtensionsInput) {\n    deleteRatioTravelDateExtensions(input: $input) {\n      id\n      extensionIds\n    }\n  }";
// language=GraphQL
var UPDATE_DATE_EXTENSIONS_ORDER_MUTATION = "\n  mutation Mutation($input: updateRatioTravelDateExtensionsOrderInput) {\n    updateRatioTravelDateExtensionsOrder(input: $input) {\n      id\n      extensionIds\n    }\n  }";
// language=GraphQL
var DATES_DEPENDENTS_QUERY = "query Query($id: ID!, $withRatioTravelDates: Boolean = false, $withBookings: Boolean = false, $withRatioTravels: Boolean = false, $withTravelPricingRules: Boolean = false) {\n  groupedDependents: ratioTravelDateDependents(id: $id) {\n    ratioTravelDates @include(if: $withRatioTravelDates) {\n      id\n      dateNo\n      startDate\n      endDate\n      includesExtension\n      json\n    }\n    bookings @include(if: $withBookings) {\n      id\n      referenceNo\n      travellerRemarks\n      travellerDataCorrectnessConfirmation\n      localState\n      backofficePayload\n      backofficeResponse\n      transmissionStatus\n      webhookStatus\n      webhookResponse\n      webhookDuration\n      confirmationEmailSent\n      isPassportDataRequired\n      passportDataReminderEmailSent\n      passportDataReceived    }\n    ratioTravels @include(if: $withRatioTravels) {\n      id\n      catalogCode\n      travelCode\n      destination\n      name\n      transportType\n      transportTypeLabel\n      importDateTime\n      importStatus    }\n    travelPricingRules @include(if: $withTravelPricingRules) {\n      id\n      checkAccommodationTypes\n      checkAccommodationAddons\n      checkAgeGroups\n      useAgeFilter\n      checkDateRange\n      startDate\n      endDate\n      checkTravelDate\n    }\n  }\n}";

// EXTERNAL MODULE: ./src/lib/helpers/helpers.ts
var helpers = __webpack_require__(15778);
// EXTERNAL MODULE: ./src/entities/travelAvailabilityStatus/entity.ts + 3 modules
var entity = __webpack_require__(47041);
// EXTERNAL MODULE: ./src/entities/ratioTravelExtension/entity.ts + 3 modules
var ratioTravelExtension_entity = __webpack_require__(6607);
// EXTERNAL MODULE: ./src/entities/ratioDatePackageSettings/entity.ts + 3 modules
var ratioDatePackageSettings_entity = __webpack_require__(81882);
;// CONCATENATED MODULE: ./src/entities/ratioTravelDate/model.ts






var ratioTravelDateModel = {
    name: "date",
    namePlural: "dates",
    uniqueName: "ratioTravelDate",
    uniqueNamePlural: "ratioTravelDates",
    path: "travel/pricing/adaptors/ratio/date",
    baseUrl: "/travel/pricing/adaptors/ratio/dates",
    translationPrefix: "entities:ratioTravelDate.",
    getDisplayName: function(values) {
        return (0,helpers/* toUiDate */.$I)(values.startDate) + " - " + (0,helpers/* toUiDate */.$I)(values.endDate);
    },
    gql: {
        getAll: ALL_DATES_QUERY,
        getSingle: SINGLE_DATE_QUERY,
        create: CREATE_DATE_MUTATION,
        update: UPDATE_DATE_MUTATION,
        delete: DELETE_DATE_MUTATION,
        forceDelete: FORCE_DELETE_DATE_MUTATION
    },
    attributes: {
        dateNo: {
            name: "dateNo",
            label: "entities:ratioTravelDate.attributes.dateNo.label",
            type: "value",
            dataType: "number",
            defaultInput: true,
            inputType: "text",
            validationType: "string",
            validations: [
                {
                    type: "required"
                }, 
            ]
        },
        startDate: {
            name: "startDate",
            label: "entities:ratioTravelDate.attributes.startDate.label",
            type: "value",
            dataType: "Date",
            defaultInput: true,
            inputType: "date",
            isStartDate: true,
            endDateAttribute: "endDate",
            validationType: "string",
            validations: [
                {
                    type: "required"
                }, 
            ]
        },
        endDate: {
            name: "endDate",
            label: "entities:ratioTravelDate.attributes.endDate.label",
            type: "value",
            dataType: "Date",
            defaultInput: true,
            inputType: "date",
            isEndDate: true,
            startDateAttribute: "startDate",
            validationType: "string",
            validations: [
                {
                    type: "required"
                }, 
            ]
        },
        availabilityStatus: {
            name: "availabilityStatus",
            label: "entities:ratioTravelDate.attributes.availabilityStatus.label",
            type: "entityObject",
            dataType: "any",
            getEntity: function() {
                return entity/* default */.Z;
            },
            defaultInput: true,
            inputType: "select",
            validationType: "string",
            validations: []
        },
        includesExtension: {
            name: "includesExtension",
            label: "entities:ratioTravelDate.attributes.includesExtension.label",
            type: "value",
            dataType: "boolean",
            defaultInput: true,
            inputType: "switch",
            validationType: "string",
            validations: []
        },
        extensionBaseDate: {
            name: "extensionBaseDate",
            label: "entities:ratioTravelDate.attributes.extensionBaseDate.label",
            type: "entityObject",
            dataType: "any",
            getEntity: function() {
                return ratioTravelDate_entity;
            },
            defaultInput: true,
            inputType: "select",
            validationType: "string",
            validations: []
        },
        extension: {
            name: "extension",
            label: "entities:ratioTravelDate.attributes.extension.label",
            type: "entityObject",
            dataType: "any",
            getEntity: function() {
                return ratioTravelExtension_entity/* default */.Z;
            },
            defaultInput: false,
            inputType: "select",
            validationType: "string",
            validations: []
        },
        packageSettings: {
            name: "packageSettings",
            label: "entities:ratioTravelDate.attributes.packageSettings.label",
            type: "entityCollection",
            dataType: "[any]",
            getEntity: function() {
                return ratioDatePackageSettings_entity/* default */.Z;
            },
            defaultInput: false,
            inputType: "text",
            validationType: "string",
            validations: []
        },
        json: {
            name: "json",
            label: "entities:ratioTravelDate.attributes.json.label",
            type: "value",
            dataType: "{ [x: string]: any }",
            defaultInput: false,
            inputType: "text",
            validationType: "string",
            validations: []
        },
        extensions: {
            name: "extensions",
            label: "entities:ratioTravelDate.attributes.extensions.label",
            type: "entityCollection",
            dataType: "[any]",
            getEntity: function() {
                return ratioTravelExtension_entity/* default */.Z;
            },
            defaultInput: false,
            inputType: "text",
            validationType: "string",
            validations: []
        }
    }
};
/* harmony default export */ var model = (ratioTravelDateModel);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(20414);
// EXTERNAL MODULE: ./src/entities/lib.ts
var lib = __webpack_require__(23480);
// EXTERNAL MODULE: ./src/lib/api/graphQLClient.ts
var graphQLClient = __webpack_require__(40112);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/swr/dist/index.mjs
var dist = __webpack_require__(8100);
;// CONCATENATED MODULE: ./src/entities/ratioTravelDate/repository.ts










var hydrateObjects = function(objects) {
    return objects.map(function(object) {
        return (0,lib/* hydrateEntityObject */.b)(model, object);
    });
};
var hydrateObject = function(object) {
    return (0,lib/* hydrateEntityObject */.b)(model, object);
};
var ratioTravelDateRepository = {
    getObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    id: id
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(SINGLE_DATE_QUERY, variables).then(function(data) {
                        return hydrateObject(data.date);
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }(),
    getObjects: /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        var includes;
        var _arguments = arguments;
        return (0,tslib_es6.__generator)(this, function(_state) {
            includes = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : {};
            return [
                2,
                graphQLClient/* default.request */.Z.request(ALL_DATES_QUERY, includes).then(function(data) {
                    return hydrateObjects(data.dates);
                })
            ];
        });
    }),
    useObject: function(id) {
        var includes = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        // eslint-disable-next-line react-hooks/exhaustive-deps
        var variables = (0,react.useMemo)(function() {
            return (0,_object_spread/* default */.Z)({
                id: id
            }, includes);
        }, [
            id
        ]);
        var ref = (0,dist/* default */.ZP)([
            SINGLE_DATE_QUERY,
            variables
        ], {
            revalidateOnFocus: false
        }), data = ref.data, error = ref.error, mutate = ref.mutate;
        return {
            object: !data ? data : hydrateObject(data.date),
            isLoading: !error && !data,
            isError: error,
            mutate: mutate
        };
    },
    useObjects: function() {
        var includes = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        // eslint-disable-next-line react-hooks/exhaustive-deps
        var variables = (0,react.useMemo)(function() {
            return includes;
        }, []);
        var ref = (0,dist/* default */.ZP)([
            ALL_DATES_QUERY,
            variables
        ]), data = ref.data, error = ref.error, mutate = ref.mutate;
        return {
            objects: !data ? data : hydrateObjects(data.dates),
            isLoading: !error && !data,
            isError: error,
            mutate: mutate
        };
    },
    getDependents: function(id, includes) {
        var includeVars = {};
        includes.forEach(function(include) {
            includeVars["with".concat((0,helpers/* uppercaseFirst */.AB)(include))] = true;
        });
        var variables = (0,_object_spread/* default */.Z)({
            id: id
        }, includeVars);
        return graphQLClient/* default.request */.Z.request(DATES_DEPENDENTS_QUERY, variables).then(function(data) {
            return data.groupedDependents;
        });
    },
    useDependents: function(id, includes) {
        var includeVars = {};
        includes.forEach(function(include) {
            includeVars["with".concat((0,helpers/* uppercaseFirst */.AB)(include))] = true;
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
        var variables = (0,react.useMemo)(function() {
            return (0,_object_spread/* default */.Z)({
                id: id
            }, includeVars);
        }, [
            id
        ]);
        var ref = (0,dist/* default */.ZP)([
            DATES_DEPENDENTS_QUERY,
            variables
        ], {
            revalidateOnFocus: false
        }), data = ref.data, error = ref.error, mutate = ref.mutate;
        return {
            data: !data ? data : data.groupedDependents,
            isLoading: !error && !data,
            isError: error,
            mutate: mutate
        };
    },
    createObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(data) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    input: data
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(CREATE_DATE_MUTATION, variables).then(function(data) {
                        return hydrateObject(data.date);
                    })
                ];
            });
        });
        return function(data) {
            return _ref.apply(this, arguments);
        };
    }(),
    updateObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(data) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    input: data
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(UPDATE_DATE_MUTATION, variables).then(function(data) {
                        return hydrateObject(data.date);
                    })
                ];
            });
        });
        return function(data) {
            return _ref.apply(this, arguments);
        };
    }(),
    deleteObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(DELETE_DATE_MUTATION, variables).then(function(data) {
                        return data.deleteRatioTravelDate;
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }(),
    forceDeleteObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(FORCE_DELETE_DATE_MUTATION, variables).then(function(data) {
                        return data.forceDeleteRatioTravelDate;
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }(),
    assignPackageSettings: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, itemIds) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        packageSettingsIds: itemIds
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(ADD_DATE_PACKAGE_SETTINGS_MUTATION, variables)
                ];
            });
        });
        return function(id, itemIds) {
            return _ref.apply(this, arguments);
        };
    }(),
    unassignPackageSettings: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, itemIds) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        packageSettingsIds: itemIds
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(REMOVE_DATE_PACKAGE_SETTINGS_MUTATION, variables)
                ];
            });
        });
        return function(id, itemIds) {
            return _ref.apply(this, arguments);
        };
    }(),
    createPackageSettings: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, items) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        packageSettings: items
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(CREATE_DATE_PACKAGE_SETTINGS_MUTATION, variables)
                ];
            });
        });
        return function(id, items) {
            return _ref.apply(this, arguments);
        };
    }(),
    deletePackageSettings: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, itemIds) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        packageSettingsIds: itemIds
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(DELETE_DATE_PACKAGE_SETTINGS_MUTATION, variables)
                ];
            });
        });
        return function(id, itemIds) {
            return _ref.apply(this, arguments);
        };
    }(),
    assignExtensions: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, itemIds) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        extensionIds: itemIds
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(ADD_DATE_EXTENSIONS_MUTATION, variables)
                ];
            });
        });
        return function(id, itemIds) {
            return _ref.apply(this, arguments);
        };
    }(),
    unassignExtensions: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, itemIds) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        extensionIds: itemIds
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(REMOVE_DATE_EXTENSIONS_MUTATION, variables)
                ];
            });
        });
        return function(id, itemIds) {
            return _ref.apply(this, arguments);
        };
    }(),
    createExtensions: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, items) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        extensions: items
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(CREATE_DATE_EXTENSIONS_MUTATION, variables)
                ];
            });
        });
        return function(id, items) {
            return _ref.apply(this, arguments);
        };
    }(),
    deleteExtensions: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, itemIds) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        extensionIds: itemIds
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(DELETE_DATE_EXTENSIONS_MUTATION, variables)
                ];
            });
        });
        return function(id, itemIds) {
            return _ref.apply(this, arguments);
        };
    }(),
    updateExtensionsOrder: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, itemIds) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        extensionIds: itemIds
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(UPDATE_DATE_EXTENSIONS_ORDER_MUTATION, variables)
                ];
            });
        });
        return function(id, itemIds) {
            return _ref.apply(this, arguments);
        };
    }()
};
/* harmony default export */ var repository = (ratioTravelDateRepository);

;// CONCATENATED MODULE: ./src/entities/ratioTravelDate/entity.ts


var ratioTravelDateEntity = {
    model: model,
    repository: repository
};
/* harmony default export */ var ratioTravelDate_entity = (ratioTravelDateEntity);


/***/ }),

/***/ 6607:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ ratioTravelExtension_entity; }
});

;// CONCATENATED MODULE: ./src/entities/ratioTravelExtension/graphql.ts
// language=GraphQL
var ALL_EXTENSIONS_QUERY = "query Query($withTravelExtension: Boolean = false, $withTravelExtensionHighlights: Boolean = false, $withTravelExtensionImage: Boolean = false, $withAccommodationMapItems: Boolean = false, $withAccommodationMapItemsBaseAccommodation: Boolean = false, $withAccommodationMapItemsBaseAccommodationCapacitySettings: Boolean = false, $withAccommodationMapItemsBaseAccommodationAddons: Boolean = false, $withAccommodationMapItemsExtensionAccommodation: Boolean = false) {\n  extensions: ratioTravelExtensions {\n    id\n    label\n    info\n    travelExtension @include(if: $withTravelExtension) {\n      id\n      duration\n      name\n      description\n      highlights @include(if: $withTravelExtensionHighlights) {\n        id\n        text\n      }\n      image @include(if: $withTravelExtensionImage) {\n        id\n        assetId\n        publicId\n        url\n        resourceType\n        format\n        width\n        height\n        caption\n        title\n        description\n      }\n    }\n    accommodationMapItems @include(if: $withAccommodationMapItems) {\n      id\n      baseAccommodation @include(if: $withAccommodationMapItemsBaseAccommodation) {\n        id\n        ratioPackageNo\n        name\n        label\n        info\n        isFamilyPackageAccommodation\n        isBabyPackage\n        capacitySettings @include(if: $withAccommodationMapItemsBaseAccommodationCapacitySettings) {\n          id\n          totalCapacity\n          rangesAllowed\n          partialOccupancyAllowed\n        }\n        addons @include(if: $withAccommodationMapItemsBaseAccommodationAddons) {\n          id\n          ratioServiceNo\n          name\n          label\n          info\n        }\n      }\n      extensionAccommodation @include(if: $withAccommodationMapItemsExtensionAccommodation) {\n        id\n        ratioPackageNo\n        name\n        label\n        info\n        extensionAccommodationServiceNo\n      }\n    }\n  }\n}";
// language=GraphQL
var SINGLE_EXTENSION_QUERY = "query Query($id: ID!, $withTravelExtension: Boolean = false, $withTravelExtensionHighlights: Boolean = false, $withTravelExtensionImage: Boolean = false, $withAccommodationMapItems: Boolean = false, $withAccommodationMapItemsBaseAccommodation: Boolean = false, $withAccommodationMapItemsBaseAccommodationCapacitySettings: Boolean = false, $withAccommodationMapItemsBaseAccommodationAddons: Boolean = false, $withAccommodationMapItemsExtensionAccommodation: Boolean = false) {\n  extension: ratioTravelExtension(id: $id) {\n    id\n    label\n    info\n    travelExtension @include(if: $withTravelExtension) {\n      id\n      duration\n      name\n      description\n      highlights @include(if: $withTravelExtensionHighlights) {\n        id\n        text\n      }\n      image @include(if: $withTravelExtensionImage) {\n        id\n        assetId\n        publicId\n        url\n        resourceType\n        format\n        width\n        height\n        caption\n        title\n        description\n      }\n    }\n    accommodationMapItems @include(if: $withAccommodationMapItems) {\n      id\n      baseAccommodation @include(if: $withAccommodationMapItemsBaseAccommodation) {\n        id\n        ratioPackageNo\n        name\n        label\n        info\n        isFamilyPackageAccommodation\n        isBabyPackage\n        capacitySettings @include(if: $withAccommodationMapItemsBaseAccommodationCapacitySettings) {\n          id\n          totalCapacity\n          rangesAllowed\n          partialOccupancyAllowed\n        }\n        addons @include(if: $withAccommodationMapItemsBaseAccommodationAddons) {\n          id\n          ratioServiceNo\n          name\n          label\n          info\n        }\n      }\n      extensionAccommodation @include(if: $withAccommodationMapItemsExtensionAccommodation) {\n        id\n        ratioPackageNo\n        name\n        label\n        info\n        extensionAccommodationServiceNo\n      }\n    }\n  }\n}";
// language=GraphQL
var CREATE_EXTENSION_MUTATION = "\n  mutation Mutation($input: CreateRatioTravelExtensionInput, $withTravelExtension: Boolean = false, $withTravelExtensionHighlights: Boolean = false, $withTravelExtensionImage: Boolean = false, $withAccommodationMapItems: Boolean = false, $withAccommodationMapItemsBaseAccommodation: Boolean = false, $withAccommodationMapItemsBaseAccommodationCapacitySettings: Boolean = false, $withAccommodationMapItemsBaseAccommodationAddons: Boolean = false, $withAccommodationMapItemsExtensionAccommodation: Boolean = false) {\n    extension: createRatioTravelExtension(input: $input) {\n      id\n      label\n      info\n      travelExtension @include(if: $withTravelExtension) {\n        id\n        duration\n        name\n        description\n        highlights @include(if: $withTravelExtensionHighlights) {\n          id\n          text\n        }\n        image @include(if: $withTravelExtensionImage) {\n          id\n          assetId\n          publicId\n          url\n          resourceType\n          format\n          width\n          height\n          caption\n          title\n          description\n        }\n      }\n      accommodationMapItems @include(if: $withAccommodationMapItems) {\n        id\n        baseAccommodation @include(if: $withAccommodationMapItemsBaseAccommodation) {\n          id\n          ratioPackageNo\n          name\n          label\n          info\n          isFamilyPackageAccommodation\n          isBabyPackage\n          capacitySettings @include(if: $withAccommodationMapItemsBaseAccommodationCapacitySettings) {\n            id\n            totalCapacity\n            rangesAllowed\n            partialOccupancyAllowed\n          }\n          addons @include(if: $withAccommodationMapItemsBaseAccommodationAddons) {\n            id\n            ratioServiceNo\n            name\n            label\n            info\n          }\n        }\n        extensionAccommodation @include(if: $withAccommodationMapItemsExtensionAccommodation) {\n          id\n          ratioPackageNo\n          name\n          label\n          info\n          extensionAccommodationServiceNo\n        }\n      }\n    }\n  }";
// language=GraphQL
var UPDATE_EXTENSION_MUTATION = "\n  mutation Mutation($input: UpdateRatioTravelExtensionInput, $withTravelExtension: Boolean = false, $withTravelExtensionHighlights: Boolean = false, $withTravelExtensionImage: Boolean = false, $withAccommodationMapItems: Boolean = false, $withAccommodationMapItemsBaseAccommodation: Boolean = false, $withAccommodationMapItemsBaseAccommodationCapacitySettings: Boolean = false, $withAccommodationMapItemsBaseAccommodationAddons: Boolean = false, $withAccommodationMapItemsExtensionAccommodation: Boolean = false) {\n    extension: updateRatioTravelExtension(input: $input) {\n      id\n      label\n      info\n      travelExtension @include(if: $withTravelExtension) {\n        id\n        duration\n        name\n        description\n        highlights @include(if: $withTravelExtensionHighlights) {\n          id\n          text\n        }\n        image @include(if: $withTravelExtensionImage) {\n          id\n          assetId\n          publicId\n          url\n          resourceType\n          format\n          width\n          height\n          caption\n          title\n          description\n        }\n      }\n      accommodationMapItems @include(if: $withAccommodationMapItems) {\n        id\n        baseAccommodation @include(if: $withAccommodationMapItemsBaseAccommodation) {\n          id\n          ratioPackageNo\n          name\n          label\n          info\n          isFamilyPackageAccommodation\n          isBabyPackage\n          capacitySettings @include(if: $withAccommodationMapItemsBaseAccommodationCapacitySettings) {\n            id\n            totalCapacity\n            rangesAllowed\n            partialOccupancyAllowed\n          }\n          addons @include(if: $withAccommodationMapItemsBaseAccommodationAddons) {\n            id\n            ratioServiceNo\n            name\n            label\n            info\n          }\n        }\n        extensionAccommodation @include(if: $withAccommodationMapItemsExtensionAccommodation) {\n          id\n          ratioPackageNo\n          name\n          label\n          info\n          extensionAccommodationServiceNo\n        }\n      }\n    }\n  }";
// language=GraphQL
var DELETE_EXTENSION_MUTATION = "\n  mutation Mutation($input: DeleteRatioTravelExtensionInput) {\n    deleteRatioTravelExtension(input: $input) {\n      success\n    }\n  }";
// language=GraphQL
var FORCE_DELETE_EXTENSION_MUTATION = "\n  mutation Mutation($input: DeleteRatioTravelExtensionInput) {\n    forceDeleteRatioTravelExtension(input: $input) {\n      success\n    }\n  }";
// language=GraphQL
var ADD_EXTENSION_ACCOMMODATION_MAP_ITEMS_MUTATION = "\n  mutation Mutation($input: addRatioTravelExtensionAccommodationMapItemsInput) {\n    addRatioTravelExtensionAccommodationMapItems(input: $input) {\n      id\n      accommodationMapItemIds\n    }\n  }";
// language=GraphQL
var REMOVE_EXTENSION_ACCOMMODATION_MAP_ITEMS_MUTATION = "\n  mutation Mutation($input: removeRatioTravelExtensionAccommodationMapItemsInput) {\n    removeRatioTravelExtensionAccommodationMapItems(input: $input) {\n      id\n      accommodationMapItemIds\n    }\n  }";
// language=GraphQL
var CREATE_EXTENSION_ACCOMMODATION_MAP_ITEMS_MUTATION = "\n  mutation Mutation($input: createRatioTravelExtensionAccommodationMapItemsInput) {\n    createRatioTravelExtensionAccommodationMapItems(input: $input) {\n      id\n      accommodationMapItemIds\n    }\n  }";
// language=GraphQL
var DELETE_EXTENSION_ACCOMMODATION_MAP_ITEMS_MUTATION = "\n  mutation Mutation($input: deleteRatioTravelExtensionAccommodationMapItemsInput) {\n    deleteRatioTravelExtensionAccommodationMapItems(input: $input) {\n      id\n      accommodationMapItemIds\n    }\n  }";
// language=GraphQL
var EXTENSIONS_DEPENDENTS_QUERY = "query Query($id: ID!, $withRatioTravelDates: Boolean = false, $withRatioTravels: Boolean = false, $withTravellers: Boolean = false) {\n  groupedDependents: ratioTravelExtensionDependents(id: $id) {\n    ratioTravelDates @include(if: $withRatioTravelDates) {\n      id\n      dateNo\n      startDate\n      endDate\n      includesExtension\n      json\n    }\n    ratioTravels @include(if: $withRatioTravels) {\n      id\n      catalogCode\n      travelCode\n      destination\n      name\n      transportType\n      transportTypeLabel\n      importDateTime\n      importStatus    }\n    travellers @include(if: $withTravellers) {\n      id\n      salutation\n      firstName\n      lastName\n      birthday\n      nationality\n      email\n      phone\n      address\n      addressNumber\n      addressAddition\n      zip\n      city\n      country\n    }\n  }\n}";

// EXTERNAL MODULE: ./src/entities/travelExtension/entity.ts + 3 modules
var entity = __webpack_require__(14585);
// EXTERNAL MODULE: ./src/entities/ratioAccommodationExtensionMapItem/entity.ts + 3 modules
var ratioAccommodationExtensionMapItem_entity = __webpack_require__(15561);
;// CONCATENATED MODULE: ./src/entities/ratioTravelExtension/model.ts



var ratioTravelExtensionModel = {
    name: "extension",
    namePlural: "extensions",
    uniqueName: "ratioTravelExtension",
    uniqueNamePlural: "ratioTravelExtensions",
    path: "travel/pricing/adaptors/ratio/extension",
    baseUrl: "/travel/pricing/adaptors/ratio/extensions",
    translationPrefix: "entities:ratioTravelExtension.",
    getDisplayName: function(values) {
        return "";
    },
    gql: {
        getAll: ALL_EXTENSIONS_QUERY,
        getSingle: SINGLE_EXTENSION_QUERY,
        create: CREATE_EXTENSION_MUTATION,
        update: UPDATE_EXTENSION_MUTATION,
        delete: DELETE_EXTENSION_MUTATION,
        forceDelete: FORCE_DELETE_EXTENSION_MUTATION
    },
    attributes: {
        label: {
            name: "label",
            label: "entities:ratioTravelExtension.attributes.label.label",
            type: "value",
            dataType: "string",
            defaultInput: true,
            inputType: "text",
            validationType: "string",
            validations: [
                {
                    type: "required"
                }, 
            ]
        },
        info: {
            name: "info",
            label: "entities:ratioTravelExtension.attributes.info.label",
            type: "value",
            dataType: "string",
            defaultInput: true,
            inputType: "text",
            maxLength: 255,
            validationType: "string",
            validations: []
        },
        travelExtension: {
            name: "travelExtension",
            label: "entities:ratioTravelExtension.attributes.travelExtension.label",
            type: "entityObject",
            dataType: "any",
            getEntity: function() {
                return entity/* default */.Z;
            },
            defaultInput: false,
            inputType: "select",
            validationType: "string",
            validations: []
        },
        accommodationMapItems: {
            name: "accommodationMapItems",
            label: "entities:ratioTravelExtension.attributes.accommodationMapItems.label",
            type: "entityCollection",
            dataType: "[any]",
            getEntity: function() {
                return ratioAccommodationExtensionMapItem_entity/* default */.Z;
            },
            defaultInput: false,
            inputType: "text",
            validationType: "string",
            validations: []
        }
    }
};
/* harmony default export */ var model = (ratioTravelExtensionModel);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(20414);
// EXTERNAL MODULE: ./src/entities/lib.ts
var lib = __webpack_require__(23480);
// EXTERNAL MODULE: ./src/lib/api/graphQLClient.ts
var graphQLClient = __webpack_require__(40112);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/swr/dist/index.mjs
var dist = __webpack_require__(8100);
// EXTERNAL MODULE: ./src/lib/helpers/helpers.ts
var helpers = __webpack_require__(15778);
;// CONCATENATED MODULE: ./src/entities/ratioTravelExtension/repository.ts










var hydrateObjects = function(objects) {
    return objects.map(function(object) {
        return (0,lib/* hydrateEntityObject */.b)(model, object);
    });
};
var hydrateObject = function(object) {
    return (0,lib/* hydrateEntityObject */.b)(model, object);
};
var ratioTravelExtensionRepository = {
    getObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    id: id
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(SINGLE_EXTENSION_QUERY, variables).then(function(data) {
                        return hydrateObject(data.extension);
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }(),
    getObjects: /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        var includes;
        var _arguments = arguments;
        return (0,tslib_es6.__generator)(this, function(_state) {
            includes = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : {};
            return [
                2,
                graphQLClient/* default.request */.Z.request(ALL_EXTENSIONS_QUERY, includes).then(function(data) {
                    return hydrateObjects(data.extensions);
                })
            ];
        });
    }),
    useObject: function(id) {
        var includes = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        // eslint-disable-next-line react-hooks/exhaustive-deps
        var variables = (0,react.useMemo)(function() {
            return (0,_object_spread/* default */.Z)({
                id: id
            }, includes);
        }, [
            id
        ]);
        var ref = (0,dist/* default */.ZP)([
            SINGLE_EXTENSION_QUERY,
            variables
        ], {
            revalidateOnFocus: false
        }), data = ref.data, error = ref.error, mutate = ref.mutate;
        return {
            object: !data ? data : hydrateObject(data.extension),
            isLoading: !error && !data,
            isError: error,
            mutate: mutate
        };
    },
    useObjects: function() {
        var includes = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        // eslint-disable-next-line react-hooks/exhaustive-deps
        var variables = (0,react.useMemo)(function() {
            return includes;
        }, []);
        var ref = (0,dist/* default */.ZP)([
            ALL_EXTENSIONS_QUERY,
            variables
        ]), data = ref.data, error = ref.error, mutate = ref.mutate;
        return {
            objects: !data ? data : hydrateObjects(data.extensions),
            isLoading: !error && !data,
            isError: error,
            mutate: mutate
        };
    },
    getDependents: function(id, includes) {
        var includeVars = {};
        includes.forEach(function(include) {
            includeVars["with".concat((0,helpers/* uppercaseFirst */.AB)(include))] = true;
        });
        var variables = (0,_object_spread/* default */.Z)({
            id: id
        }, includeVars);
        return graphQLClient/* default.request */.Z.request(EXTENSIONS_DEPENDENTS_QUERY, variables).then(function(data) {
            return data.groupedDependents;
        });
    },
    useDependents: function(id, includes) {
        var includeVars = {};
        includes.forEach(function(include) {
            includeVars["with".concat((0,helpers/* uppercaseFirst */.AB)(include))] = true;
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
        var variables = (0,react.useMemo)(function() {
            return (0,_object_spread/* default */.Z)({
                id: id
            }, includeVars);
        }, [
            id
        ]);
        var ref = (0,dist/* default */.ZP)([
            EXTENSIONS_DEPENDENTS_QUERY,
            variables
        ], {
            revalidateOnFocus: false
        }), data = ref.data, error = ref.error, mutate = ref.mutate;
        return {
            data: !data ? data : data.groupedDependents,
            isLoading: !error && !data,
            isError: error,
            mutate: mutate
        };
    },
    createObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(data) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    input: data
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(CREATE_EXTENSION_MUTATION, variables).then(function(data) {
                        return hydrateObject(data.extension);
                    })
                ];
            });
        });
        return function(data) {
            return _ref.apply(this, arguments);
        };
    }(),
    updateObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(data) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    input: data
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(UPDATE_EXTENSION_MUTATION, variables).then(function(data) {
                        return hydrateObject(data.extension);
                    })
                ];
            });
        });
        return function(data) {
            return _ref.apply(this, arguments);
        };
    }(),
    deleteObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(DELETE_EXTENSION_MUTATION, variables).then(function(data) {
                        return data.deleteRatioTravelExtension;
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }(),
    forceDeleteObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(FORCE_DELETE_EXTENSION_MUTATION, variables).then(function(data) {
                        return data.forceDeleteRatioTravelExtension;
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }(),
    assignAccommodationMapItems: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, itemIds) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        accommodationMapItemIds: itemIds
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(ADD_EXTENSION_ACCOMMODATION_MAP_ITEMS_MUTATION, variables)
                ];
            });
        });
        return function(id, itemIds) {
            return _ref.apply(this, arguments);
        };
    }(),
    unassignAccommodationMapItems: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, itemIds) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        accommodationMapItemIds: itemIds
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(REMOVE_EXTENSION_ACCOMMODATION_MAP_ITEMS_MUTATION, variables)
                ];
            });
        });
        return function(id, itemIds) {
            return _ref.apply(this, arguments);
        };
    }(),
    createAccommodationMapItems: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, items) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        accommodationMapItems: items
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(CREATE_EXTENSION_ACCOMMODATION_MAP_ITEMS_MUTATION, variables)
                ];
            });
        });
        return function(id, items) {
            return _ref.apply(this, arguments);
        };
    }(),
    deleteAccommodationMapItems: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, itemIds) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        accommodationMapItemIds: itemIds
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(DELETE_EXTENSION_ACCOMMODATION_MAP_ITEMS_MUTATION, variables)
                ];
            });
        });
        return function(id, itemIds) {
            return _ref.apply(this, arguments);
        };
    }()
};
/* harmony default export */ var repository = (ratioTravelExtensionRepository);

;// CONCATENATED MODULE: ./src/entities/ratioTravelExtension/entity.ts


var ratioTravelExtensionEntity = {
    model: model,
    repository: repository
};
/* harmony default export */ var ratioTravelExtension_entity = (ratioTravelExtensionEntity);


/***/ }),

/***/ 79070:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ redirect_entity; }
});

;// CONCATENATED MODULE: ./src/entities/redirect/graphql.ts
// language=GraphQL
var ALL_REDIRECTS_QUERY = "query Query($withFromPage: Boolean = false, $withFromPageSeoSettings: Boolean = false, $withFromPageSeoSettingsOgImage: Boolean = false, $withFromPageContentBlockAssignments: Boolean = false, $withFromPageContentBlockAssignmentsBlock: Boolean = false, $withFromTravel: Boolean = false, $withFromTravelAvailabilityStatus: Boolean = false, $withFromTravelAvailabilityStatusTenantSettings: Boolean = false, $withFromTravelTravelConsultant: Boolean = false, $withFromTravelTravelConsultantImage: Boolean = false, $withFromTravelLabel: Boolean = false, $withFromTravelSeoSettings: Boolean = false, $withFromTravelSeoSettingsOgImage: Boolean = false, $withFromTravelTenantSettings: Boolean = false, $withFromTravelTenantSettingsTenant: Boolean = false, $withFromTravelTenantSettingsTravelTypes: Boolean = false, $withFromTravelHighlights: Boolean = false, $withFromTravelPartners: Boolean = false, $withFromTravelPartnersLogo: Boolean = false, $withFromTravelPartnersGtcPdf: Boolean = false, $withFromTravelTravelGuides: Boolean = false, $withFromTravelTravelGuidesImage: Boolean = false, $withFromTravelTeams: Boolean = false, $withFromTravelTeamsMembers: Boolean = false, $withFromTravelAccommodationAssignments: Boolean = false, $withFromTravelAccommodationAssignmentsAccommodation: Boolean = false, $withFromTravelAccommodationAssignmentsRoomTypes: Boolean = false, $withFromTravelAccommodations: Boolean = false, $withFromTravelAccommodationsRoomTypes: Boolean = false, $withFromTravelAccommodationsAvailableAddons: Boolean = false, $withFromTravelAccommodationsGallery: Boolean = false, $withFromTravelDestinations: Boolean = false, $withFromTravelTestimonials: Boolean = false, $withFromTravelTestimonialsContentBlock: Boolean = false, $withFromTravelMainImage: Boolean = false, $withFromTravelMainVideo: Boolean = false, $withFromTravelGallery: Boolean = false, $withFromTravelGalleryImages: Boolean = false, $withFromTravelTravelPdf: Boolean = false, $withFromTravelTravelExtensions: Boolean = false, $withFromTravelTravelExtensionsHighlights: Boolean = false, $withFromTravelTravelExtensionsImage: Boolean = false, $withFromTravelItinerary: Boolean = false, $withFromTravelItineraryItems: Boolean = false, $withFromTravelPricing: Boolean = false, $withFromTravelPricingAgeGroupSettings: Boolean = false, $withFromTravelPricingCustomDataConfig: Boolean = false, $withFromTravelPricingTravels: Boolean = false, $withFromTravelPricingWebhookConfig: Boolean = false, $withFromTravelPricingBranding: Boolean = false, $withFromTravelPricingBargainSettings: Boolean = false, $withFromTravelPricingEsimSettings: Boolean = false, $withFromTravelPricingPassportConfig: Boolean = false, $withFromTravelPricingTourOperator: Boolean = false, $withToPage: Boolean = false, $withToPageSeoSettings: Boolean = false, $withToPageSeoSettingsOgImage: Boolean = false, $withToPageContentBlockAssignments: Boolean = false, $withToPageContentBlockAssignmentsBlock: Boolean = false, $withToTravel: Boolean = false, $withToTravelAvailabilityStatus: Boolean = false, $withToTravelAvailabilityStatusTenantSettings: Boolean = false, $withToTravelTravelConsultant: Boolean = false, $withToTravelTravelConsultantImage: Boolean = false, $withToTravelLabel: Boolean = false, $withToTravelSeoSettings: Boolean = false, $withToTravelSeoSettingsOgImage: Boolean = false, $withToTravelTenantSettings: Boolean = false, $withToTravelTenantSettingsTenant: Boolean = false, $withToTravelTenantSettingsTravelTypes: Boolean = false, $withToTravelHighlights: Boolean = false, $withToTravelPartners: Boolean = false, $withToTravelPartnersLogo: Boolean = false, $withToTravelPartnersGtcPdf: Boolean = false, $withToTravelTravelGuides: Boolean = false, $withToTravelTravelGuidesImage: Boolean = false, $withToTravelTeams: Boolean = false, $withToTravelTeamsMembers: Boolean = false, $withToTravelAccommodationAssignments: Boolean = false, $withToTravelAccommodationAssignmentsAccommodation: Boolean = false, $withToTravelAccommodationAssignmentsRoomTypes: Boolean = false, $withToTravelAccommodations: Boolean = false, $withToTravelAccommodationsRoomTypes: Boolean = false, $withToTravelAccommodationsAvailableAddons: Boolean = false, $withToTravelAccommodationsGallery: Boolean = false, $withToTravelDestinations: Boolean = false, $withToTravelTestimonials: Boolean = false, $withToTravelTestimonialsContentBlock: Boolean = false, $withToTravelMainImage: Boolean = false, $withToTravelMainVideo: Boolean = false, $withToTravelGallery: Boolean = false, $withToTravelGalleryImages: Boolean = false, $withToTravelTravelPdf: Boolean = false, $withToTravelTravelExtensions: Boolean = false, $withToTravelTravelExtensionsHighlights: Boolean = false, $withToTravelTravelExtensionsImage: Boolean = false, $withToTravelItinerary: Boolean = false, $withToTravelItineraryItems: Boolean = false, $withToTravelPricing: Boolean = false, $withToTravelPricingAgeGroupSettings: Boolean = false, $withToTravelPricingCustomDataConfig: Boolean = false, $withToTravelPricingTravels: Boolean = false, $withToTravelPricingWebhookConfig: Boolean = false, $withToTravelPricingBranding: Boolean = false, $withToTravelPricingBargainSettings: Boolean = false, $withToTravelPricingEsimSettings: Boolean = false, $withToTravelPricingPassportConfig: Boolean = false, $withToTravelPricingTourOperator: Boolean = false) {\n  redirects: redirects {\n    id\n    fromType\n    fromUrl\n    fromPage @include(if: $withFromPage) {\n      id\n      name\n      onlineStatus\n      seoSettings @include(if: $withFromPageSeoSettings) {\n        id\n        urlSlug\n        metaTitle\n        metaDescription\n        ogTitle\n        ogDescription\n        ogImage @include(if: $withFromPageSeoSettingsOgImage) {\n          id\n          assetId\n          publicId\n          url\n          resourceType\n          format\n          width\n          height\n          caption\n          title\n          description\n        }\n      }\n      contentBlockAssignments @include(if: $withFromPageContentBlockAssignments) {\n        id\n        type\n        block @include(if: $withFromPageContentBlockAssignmentsBlock) {\n          __typename\n          ... on CmsTextBlock {\n            id\n            text\n\n          }\n          ... on CmsTextWithImageBlock {\n            id\n            title\n            subtitle\n            text\n            imagePosition\n            imageFixedAspectRatio\n\n          }\n          ... on CmsPageHeaderBlock {\n            id\n            title\n            text\n\n          }\n          ... on CmsWysiwygBlock {\n            id\n            html\n\n          }\n          ... on CmsHeadingBlock {\n            id\n            importance\n            heading\n            addon\n            decoration\n\n          }\n          ... on CmsTextWithIconBlock {\n            id\n            title\n            text\n            imagePosition\n\n          }\n          ... on CmsAccordionBlock {\n            id\n\n          }\n          ... on CmsGridBlock {\n            id\n\n          }\n          ... on CmsImageBlock {\n            id\n            text\n            fluid\n\n          }\n          ... on CmsEmployeesBlock {\n            id\n\n          }\n          ... on CmsContactBannerBlock {\n            id\n            phone\n            email\n\n          }\n          ... on CmsNewsletterRegisterBlock {\n            id\n            fluid\n\n          }\n          ... on CmsIssuuCatalogBlock {\n            id\n            publicationCode\n            accountName\n\n          }\n          ... on CmsFormBlock {\n            id\n            formName\n\n          }\n          ... on CmsHeaderSliderBlock {\n            id\n\n          }\n          ... on CmsBestsellerSliderBlock {\n            id\n            fluid\n\n          }\n          ... on CmsFilterLeadBlock {\n            id\n            layout\n\n          }\n          ... on CmsTravelTypesBlock {\n            id\n            layout\n\n          }\n          ... on CmsPrefilteredTravelsBlock {\n            id\n            maxResults\n\n          }\n          ... on CmsDividerBlock {\n            id\n            fluid\n\n          }\n          ... on CmsTravelSelectionBlock {\n            id\n\n          }\n          ... on CmsIframeBlock {\n            id\n            url\n            minHeight\n\n          }\n          ... on CmsSliderBlock {\n            id\n            fluid\n            size\n            showDots\n            showArrows\n            showLightbox\n            autoplay\n\n          }\n          ... on CmsDestinationsBlock {\n            id\n\n          }\n          ... on CmsTravelGuidesBlock {\n            id\n\n          }\n          ... on CmsBusfinderBlock {\n            id\n            title\n\n          }\n          ... on CmsBackgroundBlock {\n            id\n            backgroundVariant\n\n          }\n        }\n      }\n    }\n    fromTravel @include(if: $withFromTravel) {\n      id\n      name\n      isBestseller\n      startDate\n      endDate\n      availabilityStatus @include(if: $withFromTravelAvailabilityStatus) {\n        id\n        label\n        status\n        isDefaultStatus\n        isDefaultWaitlistFallback\n        tenantSettings @include(if: $withFromTravelAvailabilityStatusTenantSettings) {\n          id\n          label\n          info\n          switchToStatusInfo\n          submitButtonLabel\n        }\n      }\n      executionStatus\n      travelConsultant @include(if: $withFromTravelTravelConsultant) {\n        id\n        firstName\n        lastName\n        jobTitle\n        description\n        email\n        image @include(if: $withFromTravelTravelConsultantImage) {\n          id\n          assetId\n          publicId\n          url\n          resourceType\n          format\n          width\n          height\n          caption\n          title\n          description\n        }\n        phone\n      }\n      label @include(if: $withFromTravelLabel) {\n        id\n        label\n      }\n      title\n      description\n      includedServices\n      excludedServices\n      pricingTable\n      priceCalculationInfo\n      seoSettings @include(if: $withFromTravelSeoSettings) {\n        id\n        urlSlug\n        metaTitle\n        metaDescription\n        ogTitle\n        ogDescription\n        ogImage @include(if: $withFromTravelSeoSettingsOgImage) {\n          id\n          assetId\n          publicId\n          url\n          resourceType\n          format\n          width\n          height\n          caption\n          title\n          description\n        }\n      }\n      tenantSettings @include(if: $withFromTravelTenantSettings) {\n        id\n        tenant @include(if: $withFromTravelTenantSettingsTenant) {\n          id\n          name\n          slug\n          domain\n          externalReference\n        }\n        onlineStatus\n        redirectToBooking\n        useTiming\n        startDate\n        endDate\n        travelTypes @include(if: $withFromTravelTenantSettingsTravelTypes) {\n          id\n          name\n          description\n        }\n      }\n      highlights @include(if: $withFromTravelHighlights) {\n        id\n        text\n      }\n      partners @include(if: $withFromTravelPartners) {\n        id\n        name\n        url\n        logo @include(if: $withFromTravelPartnersLogo) {\n          id\n          assetId\n          publicId\n          url\n          resourceType\n          format\n          width\n          height\n          caption\n          title\n          description\n        }\n        logoWidth\n        gtcPdf @include(if: $withFromTravelPartnersGtcPdf) {\n          id\n          assetId\n          publicId\n          url\n          resourceType\n          format\n          width\n          height\n          caption\n          title\n          description\n        }\n      }\n      travelGuides @include(if: $withFromTravelTravelGuides) {\n        id\n        firstName\n        lastName\n        description\n        image @include(if: $withFromTravelTravelGuidesImage) {\n          id\n          assetId\n          publicId\n          url\n          resourceType\n          format\n          width\n          height\n          caption\n          title\n          description\n        }\n      }\n      teams @include(if: $withFromTravelTeams) {\n        id\n        name\n        members @include(if: $withFromTravelTeamsMembers) {\n          id\n          firstName\n          lastName\n          description\n        }\n      }\n      accommodationAssignments @include(if: $withFromTravelAccommodationAssignments) {\n        id\n        accommodation @include(if: $withFromTravelAccommodationAssignmentsAccommodation) {\n          id\n          label\n          name\n          stars\n          description\n        }\n        roomTypes @include(if: $withFromTravelAccommodationAssignmentsRoomTypes) {\n          id\n          name\n          description\n        }\n        useCustomRoomTypeSelection\n      }\n      accommodations @include(if: $withFromTravelAccommodations) {\n        id\n        label\n        name\n        stars\n        description\n        roomTypes @include(if: $withFromTravelAccommodationsRoomTypes) {\n          id\n          name\n          description\n        }\n        availableAddons @include(if: $withFromTravelAccommodationsAvailableAddons) {\n          id\n          name\n          description\n        }\n        gallery @include(if: $withFromTravelAccommodationsGallery) {\n          id\n        }\n      }\n      destinations @include(if: $withFromTravelDestinations) {\n        id\n        name\n        entryRequirements\n        medicalInformation\n        language\n        timeShift\n        climate\n        currency\n      }\n      testimonials @include(if: $withFromTravelTestimonials) {\n        id\n        contentBlock @include(if: $withFromTravelTestimonialsContentBlock) {\n          id\n          title\n          text\n          imagePosition\n        }\n      }\n      mainImage @include(if: $withFromTravelMainImage) {\n        id\n        assetId\n        publicId\n        url\n        resourceType\n        format\n        width\n        height\n        caption\n        title\n        description\n      }\n      mainVideo @include(if: $withFromTravelMainVideo) {\n        id\n        assetId\n        publicId\n        url\n        resourceType\n        format\n        width\n        height\n        caption\n        title\n        description\n      }\n      gallery @include(if: $withFromTravelGallery) {\n        id\n        images @include(if: $withFromTravelGalleryImages) {\n          id\n          assetId\n          publicId\n          url\n          resourceType\n          format\n          width\n          height\n          caption\n          title\n          description\n        }\n      }\n      travelPdf @include(if: $withFromTravelTravelPdf) {\n        id\n        assetId\n        publicId\n        url\n        resourceType\n        format\n        width\n        height\n        caption\n        title\n        description\n      }\n      travelExtensions @include(if: $withFromTravelTravelExtensions) {\n        id\n        duration\n        name\n        description\n        highlights @include(if: $withFromTravelTravelExtensionsHighlights) {\n          id\n          text\n        }\n        image @include(if: $withFromTravelTravelExtensionsImage) {\n          id\n          assetId\n          publicId\n          url\n          resourceType\n          format\n          width\n          height\n          caption\n          title\n          description\n        }\n      }\n      programType\n      itinerary @include(if: $withFromTravelItinerary) {\n        id\n        items @include(if: $withFromTravelItineraryItems) {\n          id\n          duration\n          title\n          text\n        }\n      }\n      programText\n      pricing @include(if: $withFromTravelPricing) {\n        id\n        ageGroupSettings @include(if: $withFromTravelPricingAgeGroupSettings) {\n          id\n          freeUntilAge\n        }\n        isTravelDocumentationAvailable\n        customDataConfig @include(if: $withFromTravelPricingCustomDataConfig) {\n          id\n          useTravellerForm\n          useBookingForm\n        }\n        travels @include(if: $withFromTravelPricingTravels) {\n          id\n          catalogCode\n          travelCode\n          destination\n          name\n          transportType\n          transportTypeLabel\n          importDateTime\n          importStatus\n        }\n        webhookConfig @include(if: $withFromTravelPricingWebhookConfig) {\n          id\n          enabled\n          url\n        }\n        branding @include(if: $withFromTravelPricingBranding) {\n          id\n          logoWidth\n        }\n        bargainSettings @include(if: $withFromTravelPricingBargainSettings) {\n          id\n          active\n          untilDaysBeforeStart\n        }\n        esimSettings @include(if: $withFromTravelPricingEsimSettings) {\n          id\n          enabled\n        }\n        passportConfig @include(if: $withFromTravelPricingPassportConfig) {\n          id\n          passportOnly\n        }\n        tourOperator @include(if: $withFromTravelPricingTourOperator) {\n          id\n          name\n          url\n          logoWidth\n        }\n      }\n      minPrice\n      minPriceManualOverride\n      currency\n    }\n    toType\n    toUrl\n    toPage @include(if: $withToPage) {\n      id\n      name\n      onlineStatus\n      seoSettings @include(if: $withToPageSeoSettings) {\n        id\n        urlSlug\n        metaTitle\n        metaDescription\n        ogTitle\n        ogDescription\n        ogImage @include(if: $withToPageSeoSettingsOgImage) {\n          id\n          assetId\n          publicId\n          url\n          resourceType\n          format\n          width\n          height\n          caption\n          title\n          description\n        }\n      }\n      contentBlockAssignments @include(if: $withToPageContentBlockAssignments) {\n        id\n        type\n        block @include(if: $withToPageContentBlockAssignmentsBlock) {\n          __typename\n          ... on CmsTextBlock {\n            id\n            text\n\n          }\n          ... on CmsTextWithImageBlock {\n            id\n            title\n            subtitle\n            text\n            imagePosition\n            imageFixedAspectRatio\n\n          }\n          ... on CmsPageHeaderBlock {\n            id\n            title\n            text\n\n          }\n          ... on CmsWysiwygBlock {\n            id\n            html\n\n          }\n          ... on CmsHeadingBlock {\n            id\n            importance\n            heading\n            addon\n            decoration\n\n          }\n          ... on CmsTextWithIconBlock {\n            id\n            title\n            text\n            imagePosition\n\n          }\n          ... on CmsAccordionBlock {\n            id\n\n          }\n          ... on CmsGridBlock {\n            id\n\n          }\n          ... on CmsImageBlock {\n            id\n            text\n            fluid\n\n          }\n          ... on CmsEmployeesBlock {\n            id\n\n          }\n          ... on CmsContactBannerBlock {\n            id\n            phone\n            email\n\n          }\n          ... on CmsNewsletterRegisterBlock {\n            id\n            fluid\n\n          }\n          ... on CmsIssuuCatalogBlock {\n            id\n            publicationCode\n            accountName\n\n          }\n          ... on CmsFormBlock {\n            id\n            formName\n\n          }\n          ... on CmsHeaderSliderBlock {\n            id\n\n          }\n          ... on CmsBestsellerSliderBlock {\n            id\n            fluid\n\n          }\n          ... on CmsFilterLeadBlock {\n            id\n            layout\n\n          }\n          ... on CmsTravelTypesBlock {\n            id\n            layout\n\n          }\n          ... on CmsPrefilteredTravelsBlock {\n            id\n            maxResults\n\n          }\n          ... on CmsDividerBlock {\n            id\n            fluid\n\n          }\n          ... on CmsTravelSelectionBlock {\n            id\n\n          }\n          ... on CmsIframeBlock {\n            id\n            url\n            minHeight\n\n          }\n          ... on CmsSliderBlock {\n            id\n            fluid\n            size\n            showDots\n            showArrows\n            showLightbox\n            autoplay\n\n          }\n          ... on CmsDestinationsBlock {\n            id\n\n          }\n          ... on CmsTravelGuidesBlock {\n            id\n\n          }\n          ... on CmsBusfinderBlock {\n            id\n            title\n\n          }\n          ... on CmsBackgroundBlock {\n            id\n            backgroundVariant\n\n          }\n        }\n      }\n    }\n    toTravel @include(if: $withToTravel) {\n      id\n      name\n      isBestseller\n      startDate\n      endDate\n      availabilityStatus @include(if: $withToTravelAvailabilityStatus) {\n        id\n        label\n        status\n        isDefaultStatus\n        isDefaultWaitlistFallback\n        tenantSettings @include(if: $withToTravelAvailabilityStatusTenantSettings) {\n          id\n          label\n          info\n          switchToStatusInfo\n          submitButtonLabel\n        }\n      }\n      executionStatus\n      travelConsultant @include(if: $withToTravelTravelConsultant) {\n        id\n        firstName\n        lastName\n        jobTitle\n        description\n        email\n        image @include(if: $withToTravelTravelConsultantImage) {\n          id\n          assetId\n          publicId\n          url\n          resourceType\n          format\n          width\n          height\n          caption\n          title\n          description\n        }\n        phone\n      }\n      label @include(if: $withToTravelLabel) {\n        id\n        label\n      }\n      title\n      description\n      includedServices\n      excludedServices\n      pricingTable\n      priceCalculationInfo\n      seoSettings @include(if: $withToTravelSeoSettings) {\n        id\n        urlSlug\n        metaTitle\n        metaDescription\n        ogTitle\n        ogDescription\n        ogImage @include(if: $withToTravelSeoSettingsOgImage) {\n          id\n          assetId\n          publicId\n          url\n          resourceType\n          format\n          width\n          height\n          caption\n          title\n          description\n        }\n      }\n      tenantSettings @include(if: $withToTravelTenantSettings) {\n        id\n        tenant @include(if: $withToTravelTenantSettingsTenant) {\n          id\n          name\n          slug\n          domain\n          externalReference\n        }\n        onlineStatus\n        redirectToBooking\n        useTiming\n        startDate\n        endDate\n        travelTypes @include(if: $withToTravelTenantSettingsTravelTypes) {\n          id\n          name\n          description\n        }\n      }\n      highlights @include(if: $withToTravelHighlights) {\n        id\n        text\n      }\n      partners @include(if: $withToTravelPartners) {\n        id\n        name\n        url\n        logo @include(if: $withToTravelPartnersLogo) {\n          id\n          assetId\n          publicId\n          url\n          resourceType\n          format\n          width\n          height\n          caption\n          title\n          description\n        }\n        logoWidth\n        gtcPdf @include(if: $withToTravelPartnersGtcPdf) {\n          id\n          assetId\n          publicId\n          url\n          resourceType\n          format\n          width\n          height\n          caption\n          title\n          description\n        }\n      }\n      travelGuides @include(if: $withToTravelTravelGuides) {\n        id\n        firstName\n        lastName\n        description\n        image @include(if: $withToTravelTravelGuidesImage) {\n          id\n          assetId\n          publicId\n          url\n          resourceType\n          format\n          width\n          height\n          caption\n          title\n          description\n        }\n      }\n      teams @include(if: $withToTravelTeams) {\n        id\n        name\n        members @include(if: $withToTravelTeamsMembers) {\n          id\n          firstName\n          lastName\n          description\n        }\n      }\n      accommodationAssignments @include(if: $withToTravelAccommodationAssignments) {\n        id\n        accommodation @include(if: $withToTravelAccommodationAssignmentsAccommodation) {\n          id\n          label\n          name\n          stars\n          description\n        }\n        roomTypes @include(if: $withToTravelAccommodationAssignmentsRoomTypes) {\n          id\n          name\n          description\n        }\n        useCustomRoomTypeSelection\n      }\n      accommodations @include(if: $withToTravelAccommodations) {\n        id\n        label\n        name\n        stars\n        description\n        roomTypes @include(if: $withToTravelAccommodationsRoomTypes) {\n          id\n          name\n          description\n        }\n        availableAddons @include(if: $withToTravelAccommodationsAvailableAddons) {\n          id\n          name\n          description\n        }\n        gallery @include(if: $withToTravelAccommodationsGallery) {\n          id\n        }\n      }\n      destinations @include(if: $withToTravelDestinations) {\n        id\n        name\n        entryRequirements\n        medicalInformation\n        language\n        timeShift\n        climate\n        currency\n      }\n      testimonials @include(if: $withToTravelTestimonials) {\n        id\n        contentBlock @include(if: $withToTravelTestimonialsContentBlock) {\n          id\n          title\n          text\n          imagePosition\n        }\n      }\n      mainImage @include(if: $withToTravelMainImage) {\n        id\n        assetId\n        publicId\n        url\n        resourceType\n        format\n        width\n        height\n        caption\n        title\n        description\n      }\n      mainVideo @include(if: $withToTravelMainVideo) {\n        id\n        assetId\n        publicId\n        url\n        resourceType\n        format\n        width\n        height\n        caption\n        title\n        description\n      }\n      gallery @include(if: $withToTravelGallery) {\n        id\n        images @include(if: $withToTravelGalleryImages) {\n          id\n          assetId\n          publicId\n          url\n          resourceType\n          format\n          width\n          height\n          caption\n          title\n          description\n        }\n      }\n      travelPdf @include(if: $withToTravelTravelPdf) {\n        id\n        assetId\n        publicId\n        url\n        resourceType\n        format\n        width\n        height\n        caption\n        title\n        description\n      }\n      travelExtensions @include(if: $withToTravelTravelExtensions) {\n        id\n        duration\n        name\n        description\n        highlights @include(if: $withToTravelTravelExtensionsHighlights) {\n          id\n          text\n        }\n        image @include(if: $withToTravelTravelExtensionsImage) {\n          id\n          assetId\n          publicId\n          url\n          resourceType\n          format\n          width\n          height\n          caption\n          title\n          description\n        }\n      }\n      programType\n      itinerary @include(if: $withToTravelItinerary) {\n        id\n        items @include(if: $withToTravelItineraryItems) {\n          id\n          duration\n          title\n          text\n        }\n      }\n      programText\n      pricing @include(if: $withToTravelPricing) {\n        id\n        ageGroupSettings @include(if: $withToTravelPricingAgeGroupSettings) {\n          id\n          freeUntilAge\n        }\n        isTravelDocumentationAvailable\n        customDataConfig @include(if: $withToTravelPricingCustomDataConfig) {\n          id\n          useTravellerForm\n          useBookingForm\n        }\n        travels @include(if: $withToTravelPricingTravels) {\n          id\n          catalogCode\n          travelCode\n          destination\n          name\n          transportType\n          transportTypeLabel\n          importDateTime\n          importStatus\n        }\n        webhookConfig @include(if: $withToTravelPricingWebhookConfig) {\n          id\n          enabled\n          url\n        }\n        branding @include(if: $withToTravelPricingBranding) {\n          id\n          logoWidth\n        }\n        bargainSettings @include(if: $withToTravelPricingBargainSettings) {\n          id\n          active\n          untilDaysBeforeStart\n        }\n        esimSettings @include(if: $withToTravelPricingEsimSettings) {\n          id\n          enabled\n        }\n        passportConfig @include(if: $withToTravelPricingPassportConfig) {\n          id\n          passportOnly\n        }\n        tourOperator @include(if: $withToTravelPricingTourOperator) {\n          id\n          name\n          url\n          logoWidth\n        }\n      }\n      minPrice\n      minPriceManualOverride\n      currency\n    }\n  }\n}";
// language=GraphQL
var SINGLE_REDIRECT_QUERY = "query Query($id: ID!, $withFromPage: Boolean = false, $withFromPageSeoSettings: Boolean = false, $withFromPageSeoSettingsOgImage: Boolean = false, $withFromPageContentBlockAssignments: Boolean = false, $withFromPageContentBlockAssignmentsBlock: Boolean = false, $withFromTravel: Boolean = false, $withFromTravelAvailabilityStatus: Boolean = false, $withFromTravelAvailabilityStatusTenantSettings: Boolean = false, $withFromTravelTravelConsultant: Boolean = false, $withFromTravelTravelConsultantImage: Boolean = false, $withFromTravelLabel: Boolean = false, $withFromTravelSeoSettings: Boolean = false, $withFromTravelSeoSettingsOgImage: Boolean = false, $withFromTravelTenantSettings: Boolean = false, $withFromTravelTenantSettingsTenant: Boolean = false, $withFromTravelTenantSettingsTravelTypes: Boolean = false, $withFromTravelHighlights: Boolean = false, $withFromTravelPartners: Boolean = false, $withFromTravelPartnersLogo: Boolean = false, $withFromTravelPartnersGtcPdf: Boolean = false, $withFromTravelTravelGuides: Boolean = false, $withFromTravelTravelGuidesImage: Boolean = false, $withFromTravelTeams: Boolean = false, $withFromTravelTeamsMembers: Boolean = false, $withFromTravelAccommodationAssignments: Boolean = false, $withFromTravelAccommodationAssignmentsAccommodation: Boolean = false, $withFromTravelAccommodationAssignmentsRoomTypes: Boolean = false, $withFromTravelAccommodations: Boolean = false, $withFromTravelAccommodationsRoomTypes: Boolean = false, $withFromTravelAccommodationsAvailableAddons: Boolean = false, $withFromTravelAccommodationsGallery: Boolean = false, $withFromTravelDestinations: Boolean = false, $withFromTravelTestimonials: Boolean = false, $withFromTravelTestimonialsContentBlock: Boolean = false, $withFromTravelMainImage: Boolean = false, $withFromTravelMainVideo: Boolean = false, $withFromTravelGallery: Boolean = false, $withFromTravelGalleryImages: Boolean = false, $withFromTravelTravelPdf: Boolean = false, $withFromTravelTravelExtensions: Boolean = false, $withFromTravelTravelExtensionsHighlights: Boolean = false, $withFromTravelTravelExtensionsImage: Boolean = false, $withFromTravelItinerary: Boolean = false, $withFromTravelItineraryItems: Boolean = false, $withFromTravelPricing: Boolean = false, $withFromTravelPricingAgeGroupSettings: Boolean = false, $withFromTravelPricingCustomDataConfig: Boolean = false, $withFromTravelPricingTravels: Boolean = false, $withFromTravelPricingWebhookConfig: Boolean = false, $withFromTravelPricingBranding: Boolean = false, $withFromTravelPricingBargainSettings: Boolean = false, $withFromTravelPricingEsimSettings: Boolean = false, $withFromTravelPricingPassportConfig: Boolean = false, $withFromTravelPricingTourOperator: Boolean = false, $withToPage: Boolean = false, $withToPageSeoSettings: Boolean = false, $withToPageSeoSettingsOgImage: Boolean = false, $withToPageContentBlockAssignments: Boolean = false, $withToPageContentBlockAssignmentsBlock: Boolean = false, $withToTravel: Boolean = false, $withToTravelAvailabilityStatus: Boolean = false, $withToTravelAvailabilityStatusTenantSettings: Boolean = false, $withToTravelTravelConsultant: Boolean = false, $withToTravelTravelConsultantImage: Boolean = false, $withToTravelLabel: Boolean = false, $withToTravelSeoSettings: Boolean = false, $withToTravelSeoSettingsOgImage: Boolean = false, $withToTravelTenantSettings: Boolean = false, $withToTravelTenantSettingsTenant: Boolean = false, $withToTravelTenantSettingsTravelTypes: Boolean = false, $withToTravelHighlights: Boolean = false, $withToTravelPartners: Boolean = false, $withToTravelPartnersLogo: Boolean = false, $withToTravelPartnersGtcPdf: Boolean = false, $withToTravelTravelGuides: Boolean = false, $withToTravelTravelGuidesImage: Boolean = false, $withToTravelTeams: Boolean = false, $withToTravelTeamsMembers: Boolean = false, $withToTravelAccommodationAssignments: Boolean = false, $withToTravelAccommodationAssignmentsAccommodation: Boolean = false, $withToTravelAccommodationAssignmentsRoomTypes: Boolean = false, $withToTravelAccommodations: Boolean = false, $withToTravelAccommodationsRoomTypes: Boolean = false, $withToTravelAccommodationsAvailableAddons: Boolean = false, $withToTravelAccommodationsGallery: Boolean = false, $withToTravelDestinations: Boolean = false, $withToTravelTestimonials: Boolean = false, $withToTravelTestimonialsContentBlock: Boolean = false, $withToTravelMainImage: Boolean = false, $withToTravelMainVideo: Boolean = false, $withToTravelGallery: Boolean = false, $withToTravelGalleryImages: Boolean = false, $withToTravelTravelPdf: Boolean = false, $withToTravelTravelExtensions: Boolean = false, $withToTravelTravelExtensionsHighlights: Boolean = false, $withToTravelTravelExtensionsImage: Boolean = false, $withToTravelItinerary: Boolean = false, $withToTravelItineraryItems: Boolean = false, $withToTravelPricing: Boolean = false, $withToTravelPricingAgeGroupSettings: Boolean = false, $withToTravelPricingCustomDataConfig: Boolean = false, $withToTravelPricingTravels: Boolean = false, $withToTravelPricingWebhookConfig: Boolean = false, $withToTravelPricingBranding: Boolean = false, $withToTravelPricingBargainSettings: Boolean = false, $withToTravelPricingEsimSettings: Boolean = false, $withToTravelPricingPassportConfig: Boolean = false, $withToTravelPricingTourOperator: Boolean = false) {\n  redirect: redirect(id: $id) {\n    id\n    fromType\n    fromUrl\n    fromPage @include(if: $withFromPage) {\n      id\n      name\n      onlineStatus\n      seoSettings @include(if: $withFromPageSeoSettings) {\n        id\n        urlSlug\n        metaTitle\n        metaDescription\n        ogTitle\n        ogDescription\n        ogImage @include(if: $withFromPageSeoSettingsOgImage) {\n          id\n          assetId\n          publicId\n          url\n          resourceType\n          format\n          width\n          height\n          caption\n          title\n          description\n        }\n      }\n      contentBlockAssignments @include(if: $withFromPageContentBlockAssignments) {\n        id\n        type\n        block @include(if: $withFromPageContentBlockAssignmentsBlock) {\n          __typename\n          ... on CmsTextBlock {\n            id\n            text\n\n          }\n          ... on CmsTextWithImageBlock {\n            id\n            title\n            subtitle\n            text\n            imagePosition\n            imageFixedAspectRatio\n\n          }\n          ... on CmsPageHeaderBlock {\n            id\n            title\n            text\n\n          }\n          ... on CmsWysiwygBlock {\n            id\n            html\n\n          }\n          ... on CmsHeadingBlock {\n            id\n            importance\n            heading\n            addon\n            decoration\n\n          }\n          ... on CmsTextWithIconBlock {\n            id\n            title\n            text\n            imagePosition\n\n          }\n          ... on CmsAccordionBlock {\n            id\n\n          }\n          ... on CmsGridBlock {\n            id\n\n          }\n          ... on CmsImageBlock {\n            id\n            text\n            fluid\n\n          }\n          ... on CmsEmployeesBlock {\n            id\n\n          }\n          ... on CmsContactBannerBlock {\n            id\n            phone\n            email\n\n          }\n          ... on CmsNewsletterRegisterBlock {\n            id\n            fluid\n\n          }\n          ... on CmsIssuuCatalogBlock {\n            id\n            publicationCode\n            accountName\n\n          }\n          ... on CmsFormBlock {\n            id\n            formName\n\n          }\n          ... on CmsHeaderSliderBlock {\n            id\n\n          }\n          ... on CmsBestsellerSliderBlock {\n            id\n            fluid\n\n          }\n          ... on CmsFilterLeadBlock {\n            id\n            layout\n\n          }\n          ... on CmsTravelTypesBlock {\n            id\n            layout\n\n          }\n          ... on CmsPrefilteredTravelsBlock {\n            id\n            maxResults\n\n          }\n          ... on CmsDividerBlock {\n            id\n            fluid\n\n          }\n          ... on CmsTravelSelectionBlock {\n            id\n\n          }\n          ... on CmsIframeBlock {\n            id\n            url\n            minHeight\n\n          }\n          ... on CmsSliderBlock {\n            id\n            fluid\n            size\n            showDots\n            showArrows\n            showLightbox\n            autoplay\n\n          }\n          ... on CmsDestinationsBlock {\n            id\n\n          }\n          ... on CmsTravelGuidesBlock {\n            id\n\n          }\n          ... on CmsBusfinderBlock {\n            id\n            title\n\n          }\n          ... on CmsBackgroundBlock {\n            id\n            backgroundVariant\n\n          }\n        }\n      }\n    }\n    fromTravel @include(if: $withFromTravel) {\n      id\n      name\n      isBestseller\n      startDate\n      endDate\n      availabilityStatus @include(if: $withFromTravelAvailabilityStatus) {\n        id\n        label\n        status\n        isDefaultStatus\n        isDefaultWaitlistFallback\n        tenantSettings @include(if: $withFromTravelAvailabilityStatusTenantSettings) {\n          id\n          label\n          info\n          switchToStatusInfo\n          submitButtonLabel\n        }\n      }\n      executionStatus\n      travelConsultant @include(if: $withFromTravelTravelConsultant) {\n        id\n        firstName\n        lastName\n        jobTitle\n        description\n        email\n        image @include(if: $withFromTravelTravelConsultantImage) {\n          id\n          assetId\n          publicId\n          url\n          resourceType\n          format\n          width\n          height\n          caption\n          title\n          description\n        }\n        phone\n      }\n      label @include(if: $withFromTravelLabel) {\n        id\n        label\n      }\n      title\n      description\n      includedServices\n      excludedServices\n      pricingTable\n      priceCalculationInfo\n      seoSettings @include(if: $withFromTravelSeoSettings) {\n        id\n        urlSlug\n        metaTitle\n        metaDescription\n        ogTitle\n        ogDescription\n        ogImage @include(if: $withFromTravelSeoSettingsOgImage) {\n          id\n          assetId\n          publicId\n          url\n          resourceType\n          format\n          width\n          height\n          caption\n          title\n          description\n        }\n      }\n      tenantSettings @include(if: $withFromTravelTenantSettings) {\n        id\n        tenant @include(if: $withFromTravelTenantSettingsTenant) {\n          id\n          name\n          slug\n          domain\n          externalReference\n        }\n        onlineStatus\n        redirectToBooking\n        useTiming\n        startDate\n        endDate\n        travelTypes @include(if: $withFromTravelTenantSettingsTravelTypes) {\n          id\n          name\n          description\n        }\n      }\n      highlights @include(if: $withFromTravelHighlights) {\n        id\n        text\n      }\n      partners @include(if: $withFromTravelPartners) {\n        id\n        name\n        url\n        logo @include(if: $withFromTravelPartnersLogo) {\n          id\n          assetId\n          publicId\n          url\n          resourceType\n          format\n          width\n          height\n          caption\n          title\n          description\n        }\n        logoWidth\n        gtcPdf @include(if: $withFromTravelPartnersGtcPdf) {\n          id\n          assetId\n          publicId\n          url\n          resourceType\n          format\n          width\n          height\n          caption\n          title\n          description\n        }\n      }\n      travelGuides @include(if: $withFromTravelTravelGuides) {\n        id\n        firstName\n        lastName\n        description\n        image @include(if: $withFromTravelTravelGuidesImage) {\n          id\n          assetId\n          publicId\n          url\n          resourceType\n          format\n          width\n          height\n          caption\n          title\n          description\n        }\n      }\n      teams @include(if: $withFromTravelTeams) {\n        id\n        name\n        members @include(if: $withFromTravelTeamsMembers) {\n          id\n          firstName\n          lastName\n          description\n        }\n      }\n      accommodationAssignments @include(if: $withFromTravelAccommodationAssignments) {\n        id\n        accommodation @include(if: $withFromTravelAccommodationAssignmentsAccommodation) {\n          id\n          label\n          name\n          stars\n          description\n        }\n        roomTypes @include(if: $withFromTravelAccommodationAssignmentsRoomTypes) {\n          id\n          name\n          description\n        }\n        useCustomRoomTypeSelection\n      }\n      accommodations @include(if: $withFromTravelAccommodations) {\n        id\n        label\n        name\n        stars\n        description\n        roomTypes @include(if: $withFromTravelAccommodationsRoomTypes) {\n          id\n          name\n          description\n        }\n        availableAddons @include(if: $withFromTravelAccommodationsAvailableAddons) {\n          id\n          name\n          description\n        }\n        gallery @include(if: $withFromTravelAccommodationsGallery) {\n          id\n        }\n      }\n      destinations @include(if: $withFromTravelDestinations) {\n        id\n        name\n        entryRequirements\n        medicalInformation\n        language\n        timeShift\n        climate\n        currency\n      }\n      testimonials @include(if: $withFromTravelTestimonials) {\n        id\n        contentBlock @include(if: $withFromTravelTestimonialsContentBlock) {\n          id\n          title\n          text\n          imagePosition\n        }\n      }\n      mainImage @include(if: $withFromTravelMainImage) {\n        id\n        assetId\n        publicId\n        url\n        resourceType\n        format\n        width\n        height\n        caption\n        title\n        description\n      }\n      mainVideo @include(if: $withFromTravelMainVideo) {\n        id\n        assetId\n        publicId\n        url\n        resourceType\n        format\n        width\n        height\n        caption\n        title\n        description\n      }\n      gallery @include(if: $withFromTravelGallery) {\n        id\n        images @include(if: $withFromTravelGalleryImages) {\n          id\n          assetId\n          publicId\n          url\n          resourceType\n          format\n          width\n          height\n          caption\n          title\n          description\n        }\n      }\n      travelPdf @include(if: $withFromTravelTravelPdf) {\n        id\n        assetId\n        publicId\n        url\n        resourceType\n        format\n        width\n        height\n        caption\n        title\n        description\n      }\n      travelExtensions @include(if: $withFromTravelTravelExtensions) {\n        id\n        duration\n        name\n        description\n        highlights @include(if: $withFromTravelTravelExtensionsHighlights) {\n          id\n          text\n        }\n        image @include(if: $withFromTravelTravelExtensionsImage) {\n          id\n          assetId\n          publicId\n          url\n          resourceType\n          format\n          width\n          height\n          caption\n          title\n          description\n        }\n      }\n      programType\n      itinerary @include(if: $withFromTravelItinerary) {\n        id\n        items @include(if: $withFromTravelItineraryItems) {\n          id\n          duration\n          title\n          text\n        }\n      }\n      programText\n      pricing @include(if: $withFromTravelPricing) {\n        id\n        ageGroupSettings @include(if: $withFromTravelPricingAgeGroupSettings) {\n          id\n          freeUntilAge\n        }\n        isTravelDocumentationAvailable\n        customDataConfig @include(if: $withFromTravelPricingCustomDataConfig) {\n          id\n          useTravellerForm\n          useBookingForm\n        }\n        travels @include(if: $withFromTravelPricingTravels) {\n          id\n          catalogCode\n          travelCode\n          destination\n          name\n          transportType\n          transportTypeLabel\n          importDateTime\n          importStatus\n        }\n        webhookConfig @include(if: $withFromTravelPricingWebhookConfig) {\n          id\n          enabled\n          url\n        }\n        branding @include(if: $withFromTravelPricingBranding) {\n          id\n          logoWidth\n        }\n        bargainSettings @include(if: $withFromTravelPricingBargainSettings) {\n          id\n          active\n          untilDaysBeforeStart\n        }\n        esimSettings @include(if: $withFromTravelPricingEsimSettings) {\n          id\n          enabled\n        }\n        passportConfig @include(if: $withFromTravelPricingPassportConfig) {\n          id\n          passportOnly\n        }\n        tourOperator @include(if: $withFromTravelPricingTourOperator) {\n          id\n          name\n          url\n          logoWidth\n        }\n      }\n      minPrice\n      minPriceManualOverride\n      currency\n    }\n    toType\n    toUrl\n    toPage @include(if: $withToPage) {\n      id\n      name\n      onlineStatus\n      seoSettings @include(if: $withToPageSeoSettings) {\n        id\n        urlSlug\n        metaTitle\n        metaDescription\n        ogTitle\n        ogDescription\n        ogImage @include(if: $withToPageSeoSettingsOgImage) {\n          id\n          assetId\n          publicId\n          url\n          resourceType\n          format\n          width\n          height\n          caption\n          title\n          description\n        }\n      }\n      contentBlockAssignments @include(if: $withToPageContentBlockAssignments) {\n        id\n        type\n        block @include(if: $withToPageContentBlockAssignmentsBlock) {\n          __typename\n          ... on CmsTextBlock {\n            id\n            text\n\n          }\n          ... on CmsTextWithImageBlock {\n            id\n            title\n            subtitle\n            text\n            imagePosition\n            imageFixedAspectRatio\n\n          }\n          ... on CmsPageHeaderBlock {\n            id\n            title\n            text\n\n          }\n          ... on CmsWysiwygBlock {\n            id\n            html\n\n          }\n          ... on CmsHeadingBlock {\n            id\n            importance\n            heading\n            addon\n            decoration\n\n          }\n          ... on CmsTextWithIconBlock {\n            id\n            title\n            text\n            imagePosition\n\n          }\n          ... on CmsAccordionBlock {\n            id\n\n          }\n          ... on CmsGridBlock {\n            id\n\n          }\n          ... on CmsImageBlock {\n            id\n            text\n            fluid\n\n          }\n          ... on CmsEmployeesBlock {\n            id\n\n          }\n          ... on CmsContactBannerBlock {\n            id\n            phone\n            email\n\n          }\n          ... on CmsNewsletterRegisterBlock {\n            id\n            fluid\n\n          }\n          ... on CmsIssuuCatalogBlock {\n            id\n            publicationCode\n            accountName\n\n          }\n          ... on CmsFormBlock {\n            id\n            formName\n\n          }\n          ... on CmsHeaderSliderBlock {\n            id\n\n          }\n          ... on CmsBestsellerSliderBlock {\n            id\n            fluid\n\n          }\n          ... on CmsFilterLeadBlock {\n            id\n            layout\n\n          }\n          ... on CmsTravelTypesBlock {\n            id\n            layout\n\n          }\n          ... on CmsPrefilteredTravelsBlock {\n            id\n            maxResults\n\n          }\n          ... on CmsDividerBlock {\n            id\n            fluid\n\n          }\n          ... on CmsTravelSelectionBlock {\n            id\n\n          }\n          ... on CmsIframeBlock {\n            id\n            url\n            minHeight\n\n          }\n          ... on CmsSliderBlock {\n            id\n            fluid\n            size\n            showDots\n            showArrows\n            showLightbox\n            autoplay\n\n          }\n          ... on CmsDestinationsBlock {\n            id\n\n          }\n          ... on CmsTravelGuidesBlock {\n            id\n\n          }\n          ... on CmsBusfinderBlock {\n            id\n            title\n\n          }\n          ... on CmsBackgroundBlock {\n            id\n            backgroundVariant\n\n          }\n        }\n      }\n    }\n    toTravel @include(if: $withToTravel) {\n      id\n      name\n      isBestseller\n      startDate\n      endDate\n      availabilityStatus @include(if: $withToTravelAvailabilityStatus) {\n        id\n        label\n        status\n        isDefaultStatus\n        isDefaultWaitlistFallback\n        tenantSettings @include(if: $withToTravelAvailabilityStatusTenantSettings) {\n          id\n          label\n          info\n          switchToStatusInfo\n          submitButtonLabel\n        }\n      }\n      executionStatus\n      travelConsultant @include(if: $withToTravelTravelConsultant) {\n        id\n        firstName\n        lastName\n        jobTitle\n        description\n        email\n        image @include(if: $withToTravelTravelConsultantImage) {\n          id\n          assetId\n          publicId\n          url\n          resourceType\n          format\n          width\n          height\n          caption\n          title\n          description\n        }\n        phone\n      }\n      label @include(if: $withToTravelLabel) {\n        id\n        label\n      }\n      title\n      description\n      includedServices\n      excludedServices\n      pricingTable\n      priceCalculationInfo\n      seoSettings @include(if: $withToTravelSeoSettings) {\n        id\n        urlSlug\n        metaTitle\n        metaDescription\n        ogTitle\n        ogDescription\n        ogImage @include(if: $withToTravelSeoSettingsOgImage) {\n          id\n          assetId\n          publicId\n          url\n          resourceType\n          format\n          width\n          height\n          caption\n          title\n          description\n        }\n      }\n      tenantSettings @include(if: $withToTravelTenantSettings) {\n        id\n        tenant @include(if: $withToTravelTenantSettingsTenant) {\n          id\n          name\n          slug\n          domain\n          externalReference\n        }\n        onlineStatus\n        redirectToBooking\n        useTiming\n        startDate\n        endDate\n        travelTypes @include(if: $withToTravelTenantSettingsTravelTypes) {\n          id\n          name\n          description\n        }\n      }\n      highlights @include(if: $withToTravelHighlights) {\n        id\n        text\n      }\n      partners @include(if: $withToTravelPartners) {\n        id\n        name\n        url\n        logo @include(if: $withToTravelPartnersLogo) {\n          id\n          assetId\n          publicId\n          url\n          resourceType\n          format\n          width\n          height\n          caption\n          title\n          description\n        }\n        logoWidth\n        gtcPdf @include(if: $withToTravelPartnersGtcPdf) {\n          id\n          assetId\n          publicId\n          url\n          resourceType\n          format\n          width\n          height\n          caption\n          title\n          description\n        }\n      }\n      travelGuides @include(if: $withToTravelTravelGuides) {\n        id\n        firstName\n        lastName\n        description\n        image @include(if: $withToTravelTravelGuidesImage) {\n          id\n          assetId\n          publicId\n          url\n          resourceType\n          format\n          width\n          height\n          caption\n          title\n          description\n        }\n      }\n      teams @include(if: $withToTravelTeams) {\n        id\n        name\n        members @include(if: $withToTravelTeamsMembers) {\n          id\n          firstName\n          lastName\n          description\n        }\n      }\n      accommodationAssignments @include(if: $withToTravelAccommodationAssignments) {\n        id\n        accommodation @include(if: $withToTravelAccommodationAssignmentsAccommodation) {\n          id\n          label\n          name\n          stars\n          description\n        }\n        roomTypes @include(if: $withToTravelAccommodationAssignmentsRoomTypes) {\n          id\n          name\n          description\n        }\n        useCustomRoomTypeSelection\n      }\n      accommodations @include(if: $withToTravelAccommodations) {\n        id\n        label\n        name\n        stars\n        description\n        roomTypes @include(if: $withToTravelAccommodationsRoomTypes) {\n          id\n          name\n          description\n        }\n        availableAddons @include(if: $withToTravelAccommodationsAvailableAddons) {\n          id\n          name\n          description\n        }\n        gallery @include(if: $withToTravelAccommodationsGallery) {\n          id\n        }\n      }\n      destinations @include(if: $withToTravelDestinations) {\n        id\n        name\n        entryRequirements\n        medicalInformation\n        language\n        timeShift\n        climate\n        currency\n      }\n      testimonials @include(if: $withToTravelTestimonials) {\n        id\n        contentBlock @include(if: $withToTravelTestimonialsContentBlock) {\n          id\n          title\n          text\n          imagePosition\n        }\n      }\n      mainImage @include(if: $withToTravelMainImage) {\n        id\n        assetId\n        publicId\n        url\n        resourceType\n        format\n        width\n        height\n        caption\n        title\n        description\n      }\n      mainVideo @include(if: $withToTravelMainVideo) {\n        id\n        assetId\n        publicId\n        url\n        resourceType\n        format\n        width\n        height\n        caption\n        title\n        description\n      }\n      gallery @include(if: $withToTravelGallery) {\n        id\n        images @include(if: $withToTravelGalleryImages) {\n          id\n          assetId\n          publicId\n          url\n          resourceType\n          format\n          width\n          height\n          caption\n          title\n          description\n        }\n      }\n      travelPdf @include(if: $withToTravelTravelPdf) {\n        id\n        assetId\n        publicId\n        url\n        resourceType\n        format\n        width\n        height\n        caption\n        title\n        description\n      }\n      travelExtensions @include(if: $withToTravelTravelExtensions) {\n        id\n        duration\n        name\n        description\n        highlights @include(if: $withToTravelTravelExtensionsHighlights) {\n          id\n          text\n        }\n        image @include(if: $withToTravelTravelExtensionsImage) {\n          id\n          assetId\n          publicId\n          url\n          resourceType\n          format\n          width\n          height\n          caption\n          title\n          description\n        }\n      }\n      programType\n      itinerary @include(if: $withToTravelItinerary) {\n        id\n        items @include(if: $withToTravelItineraryItems) {\n          id\n          duration\n          title\n          text\n        }\n      }\n      programText\n      pricing @include(if: $withToTravelPricing) {\n        id\n        ageGroupSettings @include(if: $withToTravelPricingAgeGroupSettings) {\n          id\n          freeUntilAge\n        }\n        isTravelDocumentationAvailable\n        customDataConfig @include(if: $withToTravelPricingCustomDataConfig) {\n          id\n          useTravellerForm\n          useBookingForm\n        }\n        travels @include(if: $withToTravelPricingTravels) {\n          id\n          catalogCode\n          travelCode\n          destination\n          name\n          transportType\n          transportTypeLabel\n          importDateTime\n          importStatus\n        }\n        webhookConfig @include(if: $withToTravelPricingWebhookConfig) {\n          id\n          enabled\n          url\n        }\n        branding @include(if: $withToTravelPricingBranding) {\n          id\n          logoWidth\n        }\n        bargainSettings @include(if: $withToTravelPricingBargainSettings) {\n          id\n          active\n          untilDaysBeforeStart\n        }\n        esimSettings @include(if: $withToTravelPricingEsimSettings) {\n          id\n          enabled\n        }\n        passportConfig @include(if: $withToTravelPricingPassportConfig) {\n          id\n          passportOnly\n        }\n        tourOperator @include(if: $withToTravelPricingTourOperator) {\n          id\n          name\n          url\n          logoWidth\n        }\n      }\n      minPrice\n      minPriceManualOverride\n      currency\n    }\n  }\n}";
// language=GraphQL
var CREATE_REDIRECT_MUTATION = "\n  mutation Mutation($input: CreateRedirectInput, $withFromPage: Boolean = false, $withFromPageSeoSettings: Boolean = false, $withFromPageSeoSettingsOgImage: Boolean = false, $withFromPageContentBlockAssignments: Boolean = false, $withFromPageContentBlockAssignmentsBlock: Boolean = false, $withFromTravel: Boolean = false, $withFromTravelAvailabilityStatus: Boolean = false, $withFromTravelAvailabilityStatusTenantSettings: Boolean = false, $withFromTravelTravelConsultant: Boolean = false, $withFromTravelTravelConsultantImage: Boolean = false, $withFromTravelLabel: Boolean = false, $withFromTravelSeoSettings: Boolean = false, $withFromTravelSeoSettingsOgImage: Boolean = false, $withFromTravelTenantSettings: Boolean = false, $withFromTravelTenantSettingsTenant: Boolean = false, $withFromTravelTenantSettingsTravelTypes: Boolean = false, $withFromTravelHighlights: Boolean = false, $withFromTravelPartners: Boolean = false, $withFromTravelPartnersLogo: Boolean = false, $withFromTravelPartnersGtcPdf: Boolean = false, $withFromTravelTravelGuides: Boolean = false, $withFromTravelTravelGuidesImage: Boolean = false, $withFromTravelTeams: Boolean = false, $withFromTravelTeamsMembers: Boolean = false, $withFromTravelAccommodationAssignments: Boolean = false, $withFromTravelAccommodationAssignmentsAccommodation: Boolean = false, $withFromTravelAccommodationAssignmentsRoomTypes: Boolean = false, $withFromTravelAccommodations: Boolean = false, $withFromTravelAccommodationsRoomTypes: Boolean = false, $withFromTravelAccommodationsAvailableAddons: Boolean = false, $withFromTravelAccommodationsGallery: Boolean = false, $withFromTravelDestinations: Boolean = false, $withFromTravelTestimonials: Boolean = false, $withFromTravelTestimonialsContentBlock: Boolean = false, $withFromTravelMainImage: Boolean = false, $withFromTravelMainVideo: Boolean = false, $withFromTravelGallery: Boolean = false, $withFromTravelGalleryImages: Boolean = false, $withFromTravelTravelPdf: Boolean = false, $withFromTravelTravelExtensions: Boolean = false, $withFromTravelTravelExtensionsHighlights: Boolean = false, $withFromTravelTravelExtensionsImage: Boolean = false, $withFromTravelItinerary: Boolean = false, $withFromTravelItineraryItems: Boolean = false, $withFromTravelPricing: Boolean = false, $withFromTravelPricingAgeGroupSettings: Boolean = false, $withFromTravelPricingCustomDataConfig: Boolean = false, $withFromTravelPricingTravels: Boolean = false, $withFromTravelPricingWebhookConfig: Boolean = false, $withFromTravelPricingBranding: Boolean = false, $withFromTravelPricingBargainSettings: Boolean = false, $withFromTravelPricingEsimSettings: Boolean = false, $withFromTravelPricingPassportConfig: Boolean = false, $withFromTravelPricingTourOperator: Boolean = false, $withToPage: Boolean = false, $withToPageSeoSettings: Boolean = false, $withToPageSeoSettingsOgImage: Boolean = false, $withToPageContentBlockAssignments: Boolean = false, $withToPageContentBlockAssignmentsBlock: Boolean = false, $withToTravel: Boolean = false, $withToTravelAvailabilityStatus: Boolean = false, $withToTravelAvailabilityStatusTenantSettings: Boolean = false, $withToTravelTravelConsultant: Boolean = false, $withToTravelTravelConsultantImage: Boolean = false, $withToTravelLabel: Boolean = false, $withToTravelSeoSettings: Boolean = false, $withToTravelSeoSettingsOgImage: Boolean = false, $withToTravelTenantSettings: Boolean = false, $withToTravelTenantSettingsTenant: Boolean = false, $withToTravelTenantSettingsTravelTypes: Boolean = false, $withToTravelHighlights: Boolean = false, $withToTravelPartners: Boolean = false, $withToTravelPartnersLogo: Boolean = false, $withToTravelPartnersGtcPdf: Boolean = false, $withToTravelTravelGuides: Boolean = false, $withToTravelTravelGuidesImage: Boolean = false, $withToTravelTeams: Boolean = false, $withToTravelTeamsMembers: Boolean = false, $withToTravelAccommodationAssignments: Boolean = false, $withToTravelAccommodationAssignmentsAccommodation: Boolean = false, $withToTravelAccommodationAssignmentsRoomTypes: Boolean = false, $withToTravelAccommodations: Boolean = false, $withToTravelAccommodationsRoomTypes: Boolean = false, $withToTravelAccommodationsAvailableAddons: Boolean = false, $withToTravelAccommodationsGallery: Boolean = false, $withToTravelDestinations: Boolean = false, $withToTravelTestimonials: Boolean = false, $withToTravelTestimonialsContentBlock: Boolean = false, $withToTravelMainImage: Boolean = false, $withToTravelMainVideo: Boolean = false, $withToTravelGallery: Boolean = false, $withToTravelGalleryImages: Boolean = false, $withToTravelTravelPdf: Boolean = false, $withToTravelTravelExtensions: Boolean = false, $withToTravelTravelExtensionsHighlights: Boolean = false, $withToTravelTravelExtensionsImage: Boolean = false, $withToTravelItinerary: Boolean = false, $withToTravelItineraryItems: Boolean = false, $withToTravelPricing: Boolean = false, $withToTravelPricingAgeGroupSettings: Boolean = false, $withToTravelPricingCustomDataConfig: Boolean = false, $withToTravelPricingTravels: Boolean = false, $withToTravelPricingWebhookConfig: Boolean = false, $withToTravelPricingBranding: Boolean = false, $withToTravelPricingBargainSettings: Boolean = false, $withToTravelPricingEsimSettings: Boolean = false, $withToTravelPricingPassportConfig: Boolean = false, $withToTravelPricingTourOperator: Boolean = false) {\n    redirect: createRedirect(input: $input) {\n      id\n      fromType\n      fromUrl\n      fromPage @include(if: $withFromPage) {\n        id\n        name\n        onlineStatus\n        seoSettings @include(if: $withFromPageSeoSettings) {\n          id\n          urlSlug\n          metaTitle\n          metaDescription\n          ogTitle\n          ogDescription\n          ogImage @include(if: $withFromPageSeoSettingsOgImage) {\n            id\n            assetId\n            publicId\n            url\n            resourceType\n            format\n            width\n            height\n            caption\n            title\n            description\n          }\n        }\n        contentBlockAssignments @include(if: $withFromPageContentBlockAssignments) {\n          id\n          type\n          block @include(if: $withFromPageContentBlockAssignmentsBlock) {\n            __typename\n            ... on CmsTextBlock {\n              id\n              text\n\n            }\n            ... on CmsTextWithImageBlock {\n              id\n              title\n              subtitle\n              text\n              imagePosition\n              imageFixedAspectRatio\n\n            }\n            ... on CmsPageHeaderBlock {\n              id\n              title\n              text\n\n            }\n            ... on CmsWysiwygBlock {\n              id\n              html\n\n            }\n            ... on CmsHeadingBlock {\n              id\n              importance\n              heading\n              addon\n              decoration\n\n            }\n            ... on CmsTextWithIconBlock {\n              id\n              title\n              text\n              imagePosition\n\n            }\n            ... on CmsAccordionBlock {\n              id\n\n            }\n            ... on CmsGridBlock {\n              id\n\n            }\n            ... on CmsImageBlock {\n              id\n              text\n              fluid\n\n            }\n            ... on CmsEmployeesBlock {\n              id\n\n            }\n            ... on CmsContactBannerBlock {\n              id\n              phone\n              email\n\n            }\n            ... on CmsNewsletterRegisterBlock {\n              id\n              fluid\n\n            }\n            ... on CmsIssuuCatalogBlock {\n              id\n              publicationCode\n              accountName\n\n            }\n            ... on CmsFormBlock {\n              id\n              formName\n\n            }\n            ... on CmsHeaderSliderBlock {\n              id\n\n            }\n            ... on CmsBestsellerSliderBlock {\n              id\n              fluid\n\n            }\n            ... on CmsFilterLeadBlock {\n              id\n              layout\n\n            }\n            ... on CmsTravelTypesBlock {\n              id\n              layout\n\n            }\n            ... on CmsPrefilteredTravelsBlock {\n              id\n              maxResults\n\n            }\n            ... on CmsDividerBlock {\n              id\n              fluid\n\n            }\n            ... on CmsTravelSelectionBlock {\n              id\n\n            }\n            ... on CmsIframeBlock {\n              id\n              url\n              minHeight\n\n            }\n            ... on CmsSliderBlock {\n              id\n              fluid\n              size\n              showDots\n              showArrows\n              showLightbox\n              autoplay\n\n            }\n            ... on CmsDestinationsBlock {\n              id\n\n            }\n            ... on CmsTravelGuidesBlock {\n              id\n\n            }\n            ... on CmsBusfinderBlock {\n              id\n              title\n\n            }\n            ... on CmsBackgroundBlock {\n              id\n              backgroundVariant\n\n            }\n          }\n        }\n      }\n      fromTravel @include(if: $withFromTravel) {\n        id\n        name\n        isBestseller\n        startDate\n        endDate\n        availabilityStatus @include(if: $withFromTravelAvailabilityStatus) {\n          id\n          label\n          status\n          isDefaultStatus\n          isDefaultWaitlistFallback\n          tenantSettings @include(if: $withFromTravelAvailabilityStatusTenantSettings) {\n            id\n            label\n            info\n            switchToStatusInfo\n            submitButtonLabel\n          }\n        }\n        executionStatus\n        travelConsultant @include(if: $withFromTravelTravelConsultant) {\n          id\n          firstName\n          lastName\n          jobTitle\n          description\n          email\n          image @include(if: $withFromTravelTravelConsultantImage) {\n            id\n            assetId\n            publicId\n            url\n            resourceType\n            format\n            width\n            height\n            caption\n            title\n            description\n          }\n          phone\n        }\n        label @include(if: $withFromTravelLabel) {\n          id\n          label\n        }\n        title\n        description\n        includedServices\n        excludedServices\n        pricingTable\n        priceCalculationInfo\n        seoSettings @include(if: $withFromTravelSeoSettings) {\n          id\n          urlSlug\n          metaTitle\n          metaDescription\n          ogTitle\n          ogDescription\n          ogImage @include(if: $withFromTravelSeoSettingsOgImage) {\n            id\n            assetId\n            publicId\n            url\n            resourceType\n            format\n            width\n            height\n            caption\n            title\n            description\n          }\n        }\n        tenantSettings @include(if: $withFromTravelTenantSettings) {\n          id\n          tenant @include(if: $withFromTravelTenantSettingsTenant) {\n            id\n            name\n            slug\n            domain\n            externalReference\n          }\n          onlineStatus\n          redirectToBooking\n          useTiming\n          startDate\n          endDate\n          travelTypes @include(if: $withFromTravelTenantSettingsTravelTypes) {\n            id\n            name\n            description\n          }\n        }\n        highlights @include(if: $withFromTravelHighlights) {\n          id\n          text\n        }\n        partners @include(if: $withFromTravelPartners) {\n          id\n          name\n          url\n          logo @include(if: $withFromTravelPartnersLogo) {\n            id\n            assetId\n            publicId\n            url\n            resourceType\n            format\n            width\n            height\n            caption\n            title\n            description\n          }\n          logoWidth\n          gtcPdf @include(if: $withFromTravelPartnersGtcPdf) {\n            id\n            assetId\n            publicId\n            url\n            resourceType\n            format\n            width\n            height\n            caption\n            title\n            description\n          }\n        }\n        travelGuides @include(if: $withFromTravelTravelGuides) {\n          id\n          firstName\n          lastName\n          description\n          image @include(if: $withFromTravelTravelGuidesImage) {\n            id\n            assetId\n            publicId\n            url\n            resourceType\n            format\n            width\n            height\n            caption\n            title\n            description\n          }\n        }\n        teams @include(if: $withFromTravelTeams) {\n          id\n          name\n          members @include(if: $withFromTravelTeamsMembers) {\n            id\n            firstName\n            lastName\n            description\n          }\n        }\n        accommodationAssignments @include(if: $withFromTravelAccommodationAssignments) {\n          id\n          accommodation @include(if: $withFromTravelAccommodationAssignmentsAccommodation) {\n            id\n            label\n            name\n            stars\n            description\n          }\n          roomTypes @include(if: $withFromTravelAccommodationAssignmentsRoomTypes) {\n            id\n            name\n            description\n          }\n          useCustomRoomTypeSelection\n        }\n        accommodations @include(if: $withFromTravelAccommodations) {\n          id\n          label\n          name\n          stars\n          description\n          roomTypes @include(if: $withFromTravelAccommodationsRoomTypes) {\n            id\n            name\n            description\n          }\n          availableAddons @include(if: $withFromTravelAccommodationsAvailableAddons) {\n            id\n            name\n            description\n          }\n          gallery @include(if: $withFromTravelAccommodationsGallery) {\n            id\n          }\n        }\n        destinations @include(if: $withFromTravelDestinations) {\n          id\n          name\n          entryRequirements\n          medicalInformation\n          language\n          timeShift\n          climate\n          currency\n        }\n        testimonials @include(if: $withFromTravelTestimonials) {\n          id\n          contentBlock @include(if: $withFromTravelTestimonialsContentBlock) {\n            id\n            title\n            text\n            imagePosition\n          }\n        }\n        mainImage @include(if: $withFromTravelMainImage) {\n          id\n          assetId\n          publicId\n          url\n          resourceType\n          format\n          width\n          height\n          caption\n          title\n          description\n        }\n        mainVideo @include(if: $withFromTravelMainVideo) {\n          id\n          assetId\n          publicId\n          url\n          resourceType\n          format\n          width\n          height\n          caption\n          title\n          description\n        }\n        gallery @include(if: $withFromTravelGallery) {\n          id\n          images @include(if: $withFromTravelGalleryImages) {\n            id\n            assetId\n            publicId\n            url\n            resourceType\n            format\n            width\n            height\n            caption\n            title\n            description\n          }\n        }\n        travelPdf @include(if: $withFromTravelTravelPdf) {\n          id\n          assetId\n          publicId\n          url\n          resourceType\n          format\n          width\n          height\n          caption\n          title\n          description\n        }\n        travelExtensions @include(if: $withFromTravelTravelExtensions) {\n          id\n          duration\n          name\n          description\n          highlights @include(if: $withFromTravelTravelExtensionsHighlights) {\n            id\n            text\n          }\n          image @include(if: $withFromTravelTravelExtensionsImage) {\n            id\n            assetId\n            publicId\n            url\n            resourceType\n            format\n            width\n            height\n            caption\n            title\n            description\n          }\n        }\n        programType\n        itinerary @include(if: $withFromTravelItinerary) {\n          id\n          items @include(if: $withFromTravelItineraryItems) {\n            id\n            duration\n            title\n            text\n          }\n        }\n        programText\n        pricing @include(if: $withFromTravelPricing) {\n          id\n          ageGroupSettings @include(if: $withFromTravelPricingAgeGroupSettings) {\n            id\n            freeUntilAge\n          }\n          isTravelDocumentationAvailable\n          customDataConfig @include(if: $withFromTravelPricingCustomDataConfig) {\n            id\n            useTravellerForm\n            useBookingForm\n          }\n          travels @include(if: $withFromTravelPricingTravels) {\n            id\n            catalogCode\n            travelCode\n            destination\n            name\n            transportType\n            transportTypeLabel\n            importDateTime\n            importStatus\n          }\n          webhookConfig @include(if: $withFromTravelPricingWebhookConfig) {\n            id\n            enabled\n            url\n          }\n          branding @include(if: $withFromTravelPricingBranding) {\n            id\n            logoWidth\n          }\n          bargainSettings @include(if: $withFromTravelPricingBargainSettings) {\n            id\n            active\n            untilDaysBeforeStart\n          }\n          esimSettings @include(if: $withFromTravelPricingEsimSettings) {\n            id\n            enabled\n          }\n          passportConfig @include(if: $withFromTravelPricingPassportConfig) {\n            id\n            passportOnly\n          }\n          tourOperator @include(if: $withFromTravelPricingTourOperator) {\n            id\n            name\n            url\n            logoWidth\n          }\n        }\n        minPrice\n        minPriceManualOverride\n        currency\n      }\n      toType\n      toUrl\n      toPage @include(if: $withToPage) {\n        id\n        name\n        onlineStatus\n        seoSettings @include(if: $withToPageSeoSettings) {\n          id\n          urlSlug\n          metaTitle\n          metaDescription\n          ogTitle\n          ogDescription\n          ogImage @include(if: $withToPageSeoSettingsOgImage) {\n            id\n            assetId\n            publicId\n            url\n            resourceType\n            format\n            width\n            height\n            caption\n            title\n            description\n          }\n        }\n        contentBlockAssignments @include(if: $withToPageContentBlockAssignments) {\n          id\n          type\n          block @include(if: $withToPageContentBlockAssignmentsBlock) {\n            __typename\n            ... on CmsTextBlock {\n              id\n              text\n\n            }\n            ... on CmsTextWithImageBlock {\n              id\n              title\n              subtitle\n              text\n              imagePosition\n              imageFixedAspectRatio\n\n            }\n            ... on CmsPageHeaderBlock {\n              id\n              title\n              text\n\n            }\n            ... on CmsWysiwygBlock {\n              id\n              html\n\n            }\n            ... on CmsHeadingBlock {\n              id\n              importance\n              heading\n              addon\n              decoration\n\n            }\n            ... on CmsTextWithIconBlock {\n              id\n              title\n              text\n              imagePosition\n\n            }\n            ... on CmsAccordionBlock {\n              id\n\n            }\n            ... on CmsGridBlock {\n              id\n\n            }\n            ... on CmsImageBlock {\n              id\n              text\n              fluid\n\n            }\n            ... on CmsEmployeesBlock {\n              id\n\n            }\n            ... on CmsContactBannerBlock {\n              id\n              phone\n              email\n\n            }\n            ... on CmsNewsletterRegisterBlock {\n              id\n              fluid\n\n            }\n            ... on CmsIssuuCatalogBlock {\n              id\n              publicationCode\n              accountName\n\n            }\n            ... on CmsFormBlock {\n              id\n              formName\n\n            }\n            ... on CmsHeaderSliderBlock {\n              id\n\n            }\n            ... on CmsBestsellerSliderBlock {\n              id\n              fluid\n\n            }\n            ... on CmsFilterLeadBlock {\n              id\n              layout\n\n            }\n            ... on CmsTravelTypesBlock {\n              id\n              layout\n\n            }\n            ... on CmsPrefilteredTravelsBlock {\n              id\n              maxResults\n\n            }\n            ... on CmsDividerBlock {\n              id\n              fluid\n\n            }\n            ... on CmsTravelSelectionBlock {\n              id\n\n            }\n            ... on CmsIframeBlock {\n              id\n              url\n              minHeight\n\n            }\n            ... on CmsSliderBlock {\n              id\n              fluid\n              size\n              showDots\n              showArrows\n              showLightbox\n              autoplay\n\n            }\n            ... on CmsDestinationsBlock {\n              id\n\n            }\n            ... on CmsTravelGuidesBlock {\n              id\n\n            }\n            ... on CmsBusfinderBlock {\n              id\n              title\n\n            }\n            ... on CmsBackgroundBlock {\n              id\n              backgroundVariant\n\n            }\n          }\n        }\n      }\n      toTravel @include(if: $withToTravel) {\n        id\n        name\n        isBestseller\n        startDate\n        endDate\n        availabilityStatus @include(if: $withToTravelAvailabilityStatus) {\n          id\n          label\n          status\n          isDefaultStatus\n          isDefaultWaitlistFallback\n          tenantSettings @include(if: $withToTravelAvailabilityStatusTenantSettings) {\n            id\n            label\n            info\n            switchToStatusInfo\n            submitButtonLabel\n          }\n        }\n        executionStatus\n        travelConsultant @include(if: $withToTravelTravelConsultant) {\n          id\n          firstName\n          lastName\n          jobTitle\n          description\n          email\n          image @include(if: $withToTravelTravelConsultantImage) {\n            id\n            assetId\n            publicId\n            url\n            resourceType\n            format\n            width\n            height\n            caption\n            title\n            description\n          }\n          phone\n        }\n        label @include(if: $withToTravelLabel) {\n          id\n          label\n        }\n        title\n        description\n        includedServices\n        excludedServices\n        pricingTable\n        priceCalculationInfo\n        seoSettings @include(if: $withToTravelSeoSettings) {\n          id\n          urlSlug\n          metaTitle\n          metaDescription\n          ogTitle\n          ogDescription\n          ogImage @include(if: $withToTravelSeoSettingsOgImage) {\n            id\n            assetId\n            publicId\n            url\n            resourceType\n            format\n            width\n            height\n            caption\n            title\n            description\n          }\n        }\n        tenantSettings @include(if: $withToTravelTenantSettings) {\n          id\n          tenant @include(if: $withToTravelTenantSettingsTenant) {\n            id\n            name\n            slug\n            domain\n            externalReference\n          }\n          onlineStatus\n          redirectToBooking\n          useTiming\n          startDate\n          endDate\n          travelTypes @include(if: $withToTravelTenantSettingsTravelTypes) {\n            id\n            name\n            description\n          }\n        }\n        highlights @include(if: $withToTravelHighlights) {\n          id\n          text\n        }\n        partners @include(if: $withToTravelPartners) {\n          id\n          name\n          url\n          logo @include(if: $withToTravelPartnersLogo) {\n            id\n            assetId\n            publicId\n            url\n            resourceType\n            format\n            width\n            height\n            caption\n            title\n            description\n          }\n          logoWidth\n          gtcPdf @include(if: $withToTravelPartnersGtcPdf) {\n            id\n            assetId\n            publicId\n            url\n            resourceType\n            format\n            width\n            height\n            caption\n            title\n            description\n          }\n        }\n        travelGuides @include(if: $withToTravelTravelGuides) {\n          id\n          firstName\n          lastName\n          description\n          image @include(if: $withToTravelTravelGuidesImage) {\n            id\n            assetId\n            publicId\n            url\n            resourceType\n            format\n            width\n            height\n            caption\n            title\n            description\n          }\n        }\n        teams @include(if: $withToTravelTeams) {\n          id\n          name\n          members @include(if: $withToTravelTeamsMembers) {\n            id\n            firstName\n            lastName\n            description\n          }\n        }\n        accommodationAssignments @include(if: $withToTravelAccommodationAssignments) {\n          id\n          accommodation @include(if: $withToTravelAccommodationAssignmentsAccommodation) {\n            id\n            label\n            name\n            stars\n            description\n          }\n          roomTypes @include(if: $withToTravelAccommodationAssignmentsRoomTypes) {\n            id\n            name\n            description\n          }\n          useCustomRoomTypeSelection\n        }\n        accommodations @include(if: $withToTravelAccommodations) {\n          id\n          label\n          name\n          stars\n          description\n          roomTypes @include(if: $withToTravelAccommodationsRoomTypes) {\n            id\n            name\n            description\n          }\n          availableAddons @include(if: $withToTravelAccommodationsAvailableAddons) {\n            id\n            name\n            description\n          }\n          gallery @include(if: $withToTravelAccommodationsGallery) {\n            id\n          }\n        }\n        destinations @include(if: $withToTravelDestinations) {\n          id\n          name\n          entryRequirements\n          medicalInformation\n          language\n          timeShift\n          climate\n          currency\n        }\n        testimonials @include(if: $withToTravelTestimonials) {\n          id\n          contentBlock @include(if: $withToTravelTestimonialsContentBlock) {\n            id\n            title\n            text\n            imagePosition\n          }\n        }\n        mainImage @include(if: $withToTravelMainImage) {\n          id\n          assetId\n          publicId\n          url\n          resourceType\n          format\n          width\n          height\n          caption\n          title\n          description\n        }\n        mainVideo @include(if: $withToTravelMainVideo) {\n          id\n          assetId\n          publicId\n          url\n          resourceType\n          format\n          width\n          height\n          caption\n          title\n          description\n        }\n        gallery @include(if: $withToTravelGallery) {\n          id\n          images @include(if: $withToTravelGalleryImages) {\n            id\n            assetId\n            publicId\n            url\n            resourceType\n            format\n            width\n            height\n            caption\n            title\n            description\n          }\n        }\n        travelPdf @include(if: $withToTravelTravelPdf) {\n          id\n          assetId\n          publicId\n          url\n          resourceType\n          format\n          width\n          height\n          caption\n          title\n          description\n        }\n        travelExtensions @include(if: $withToTravelTravelExtensions) {\n          id\n          duration\n          name\n          description\n          highlights @include(if: $withToTravelTravelExtensionsHighlights) {\n            id\n            text\n          }\n          image @include(if: $withToTravelTravelExtensionsImage) {\n            id\n            assetId\n            publicId\n            url\n            resourceType\n            format\n            width\n            height\n            caption\n            title\n            description\n          }\n        }\n        programType\n        itinerary @include(if: $withToTravelItinerary) {\n          id\n          items @include(if: $withToTravelItineraryItems) {\n            id\n            duration\n            title\n            text\n          }\n        }\n        programText\n        pricing @include(if: $withToTravelPricing) {\n          id\n          ageGroupSettings @include(if: $withToTravelPricingAgeGroupSettings) {\n            id\n            freeUntilAge\n          }\n          isTravelDocumentationAvailable\n          customDataConfig @include(if: $withToTravelPricingCustomDataConfig) {\n            id\n            useTravellerForm\n            useBookingForm\n          }\n          travels @include(if: $withToTravelPricingTravels) {\n            id\n            catalogCode\n            travelCode\n            destination\n            name\n            transportType\n            transportTypeLabel\n            importDateTime\n            importStatus\n          }\n          webhookConfig @include(if: $withToTravelPricingWebhookConfig) {\n            id\n            enabled\n            url\n          }\n          branding @include(if: $withToTravelPricingBranding) {\n            id\n            logoWidth\n          }\n          bargainSettings @include(if: $withToTravelPricingBargainSettings) {\n            id\n            active\n            untilDaysBeforeStart\n          }\n          esimSettings @include(if: $withToTravelPricingEsimSettings) {\n            id\n            enabled\n          }\n          passportConfig @include(if: $withToTravelPricingPassportConfig) {\n            id\n            passportOnly\n          }\n          tourOperator @include(if: $withToTravelPricingTourOperator) {\n            id\n            name\n            url\n            logoWidth\n          }\n        }\n        minPrice\n        minPriceManualOverride\n        currency\n      }\n    }\n  }";
// language=GraphQL
var UPDATE_REDIRECT_MUTATION = "\n  mutation Mutation($input: UpdateRedirectInput, $withFromPage: Boolean = false, $withFromPageSeoSettings: Boolean = false, $withFromPageSeoSettingsOgImage: Boolean = false, $withFromPageContentBlockAssignments: Boolean = false, $withFromPageContentBlockAssignmentsBlock: Boolean = false, $withFromTravel: Boolean = false, $withFromTravelAvailabilityStatus: Boolean = false, $withFromTravelAvailabilityStatusTenantSettings: Boolean = false, $withFromTravelTravelConsultant: Boolean = false, $withFromTravelTravelConsultantImage: Boolean = false, $withFromTravelLabel: Boolean = false, $withFromTravelSeoSettings: Boolean = false, $withFromTravelSeoSettingsOgImage: Boolean = false, $withFromTravelTenantSettings: Boolean = false, $withFromTravelTenantSettingsTenant: Boolean = false, $withFromTravelTenantSettingsTravelTypes: Boolean = false, $withFromTravelHighlights: Boolean = false, $withFromTravelPartners: Boolean = false, $withFromTravelPartnersLogo: Boolean = false, $withFromTravelPartnersGtcPdf: Boolean = false, $withFromTravelTravelGuides: Boolean = false, $withFromTravelTravelGuidesImage: Boolean = false, $withFromTravelTeams: Boolean = false, $withFromTravelTeamsMembers: Boolean = false, $withFromTravelAccommodationAssignments: Boolean = false, $withFromTravelAccommodationAssignmentsAccommodation: Boolean = false, $withFromTravelAccommodationAssignmentsRoomTypes: Boolean = false, $withFromTravelAccommodations: Boolean = false, $withFromTravelAccommodationsRoomTypes: Boolean = false, $withFromTravelAccommodationsAvailableAddons: Boolean = false, $withFromTravelAccommodationsGallery: Boolean = false, $withFromTravelDestinations: Boolean = false, $withFromTravelTestimonials: Boolean = false, $withFromTravelTestimonialsContentBlock: Boolean = false, $withFromTravelMainImage: Boolean = false, $withFromTravelMainVideo: Boolean = false, $withFromTravelGallery: Boolean = false, $withFromTravelGalleryImages: Boolean = false, $withFromTravelTravelPdf: Boolean = false, $withFromTravelTravelExtensions: Boolean = false, $withFromTravelTravelExtensionsHighlights: Boolean = false, $withFromTravelTravelExtensionsImage: Boolean = false, $withFromTravelItinerary: Boolean = false, $withFromTravelItineraryItems: Boolean = false, $withFromTravelPricing: Boolean = false, $withFromTravelPricingAgeGroupSettings: Boolean = false, $withFromTravelPricingCustomDataConfig: Boolean = false, $withFromTravelPricingTravels: Boolean = false, $withFromTravelPricingWebhookConfig: Boolean = false, $withFromTravelPricingBranding: Boolean = false, $withFromTravelPricingBargainSettings: Boolean = false, $withFromTravelPricingEsimSettings: Boolean = false, $withFromTravelPricingPassportConfig: Boolean = false, $withFromTravelPricingTourOperator: Boolean = false, $withToPage: Boolean = false, $withToPageSeoSettings: Boolean = false, $withToPageSeoSettingsOgImage: Boolean = false, $withToPageContentBlockAssignments: Boolean = false, $withToPageContentBlockAssignmentsBlock: Boolean = false, $withToTravel: Boolean = false, $withToTravelAvailabilityStatus: Boolean = false, $withToTravelAvailabilityStatusTenantSettings: Boolean = false, $withToTravelTravelConsultant: Boolean = false, $withToTravelTravelConsultantImage: Boolean = false, $withToTravelLabel: Boolean = false, $withToTravelSeoSettings: Boolean = false, $withToTravelSeoSettingsOgImage: Boolean = false, $withToTravelTenantSettings: Boolean = false, $withToTravelTenantSettingsTenant: Boolean = false, $withToTravelTenantSettingsTravelTypes: Boolean = false, $withToTravelHighlights: Boolean = false, $withToTravelPartners: Boolean = false, $withToTravelPartnersLogo: Boolean = false, $withToTravelPartnersGtcPdf: Boolean = false, $withToTravelTravelGuides: Boolean = false, $withToTravelTravelGuidesImage: Boolean = false, $withToTravelTeams: Boolean = false, $withToTravelTeamsMembers: Boolean = false, $withToTravelAccommodationAssignments: Boolean = false, $withToTravelAccommodationAssignmentsAccommodation: Boolean = false, $withToTravelAccommodationAssignmentsRoomTypes: Boolean = false, $withToTravelAccommodations: Boolean = false, $withToTravelAccommodationsRoomTypes: Boolean = false, $withToTravelAccommodationsAvailableAddons: Boolean = false, $withToTravelAccommodationsGallery: Boolean = false, $withToTravelDestinations: Boolean = false, $withToTravelTestimonials: Boolean = false, $withToTravelTestimonialsContentBlock: Boolean = false, $withToTravelMainImage: Boolean = false, $withToTravelMainVideo: Boolean = false, $withToTravelGallery: Boolean = false, $withToTravelGalleryImages: Boolean = false, $withToTravelTravelPdf: Boolean = false, $withToTravelTravelExtensions: Boolean = false, $withToTravelTravelExtensionsHighlights: Boolean = false, $withToTravelTravelExtensionsImage: Boolean = false, $withToTravelItinerary: Boolean = false, $withToTravelItineraryItems: Boolean = false, $withToTravelPricing: Boolean = false, $withToTravelPricingAgeGroupSettings: Boolean = false, $withToTravelPricingCustomDataConfig: Boolean = false, $withToTravelPricingTravels: Boolean = false, $withToTravelPricingWebhookConfig: Boolean = false, $withToTravelPricingBranding: Boolean = false, $withToTravelPricingBargainSettings: Boolean = false, $withToTravelPricingEsimSettings: Boolean = false, $withToTravelPricingPassportConfig: Boolean = false, $withToTravelPricingTourOperator: Boolean = false) {\n    redirect: updateRedirect(input: $input) {\n      id\n      fromType\n      fromUrl\n      fromPage @include(if: $withFromPage) {\n        id\n        name\n        onlineStatus\n        seoSettings @include(if: $withFromPageSeoSettings) {\n          id\n          urlSlug\n          metaTitle\n          metaDescription\n          ogTitle\n          ogDescription\n          ogImage @include(if: $withFromPageSeoSettingsOgImage) {\n            id\n            assetId\n            publicId\n            url\n            resourceType\n            format\n            width\n            height\n            caption\n            title\n            description\n          }\n        }\n        contentBlockAssignments @include(if: $withFromPageContentBlockAssignments) {\n          id\n          type\n          block @include(if: $withFromPageContentBlockAssignmentsBlock) {\n            __typename\n            ... on CmsTextBlock {\n              id\n              text\n\n            }\n            ... on CmsTextWithImageBlock {\n              id\n              title\n              subtitle\n              text\n              imagePosition\n              imageFixedAspectRatio\n\n            }\n            ... on CmsPageHeaderBlock {\n              id\n              title\n              text\n\n            }\n            ... on CmsWysiwygBlock {\n              id\n              html\n\n            }\n            ... on CmsHeadingBlock {\n              id\n              importance\n              heading\n              addon\n              decoration\n\n            }\n            ... on CmsTextWithIconBlock {\n              id\n              title\n              text\n              imagePosition\n\n            }\n            ... on CmsAccordionBlock {\n              id\n\n            }\n            ... on CmsGridBlock {\n              id\n\n            }\n            ... on CmsImageBlock {\n              id\n              text\n              fluid\n\n            }\n            ... on CmsEmployeesBlock {\n              id\n\n            }\n            ... on CmsContactBannerBlock {\n              id\n              phone\n              email\n\n            }\n            ... on CmsNewsletterRegisterBlock {\n              id\n              fluid\n\n            }\n            ... on CmsIssuuCatalogBlock {\n              id\n              publicationCode\n              accountName\n\n            }\n            ... on CmsFormBlock {\n              id\n              formName\n\n            }\n            ... on CmsHeaderSliderBlock {\n              id\n\n            }\n            ... on CmsBestsellerSliderBlock {\n              id\n              fluid\n\n            }\n            ... on CmsFilterLeadBlock {\n              id\n              layout\n\n            }\n            ... on CmsTravelTypesBlock {\n              id\n              layout\n\n            }\n            ... on CmsPrefilteredTravelsBlock {\n              id\n              maxResults\n\n            }\n            ... on CmsDividerBlock {\n              id\n              fluid\n\n            }\n            ... on CmsTravelSelectionBlock {\n              id\n\n            }\n            ... on CmsIframeBlock {\n              id\n              url\n              minHeight\n\n            }\n            ... on CmsSliderBlock {\n              id\n              fluid\n              size\n              showDots\n              showArrows\n              showLightbox\n              autoplay\n\n            }\n            ... on CmsDestinationsBlock {\n              id\n\n            }\n            ... on CmsTravelGuidesBlock {\n              id\n\n            }\n            ... on CmsBusfinderBlock {\n              id\n              title\n\n            }\n            ... on CmsBackgroundBlock {\n              id\n              backgroundVariant\n\n            }\n          }\n        }\n      }\n      fromTravel @include(if: $withFromTravel) {\n        id\n        name\n        isBestseller\n        startDate\n        endDate\n        availabilityStatus @include(if: $withFromTravelAvailabilityStatus) {\n          id\n          label\n          status\n          isDefaultStatus\n          isDefaultWaitlistFallback\n          tenantSettings @include(if: $withFromTravelAvailabilityStatusTenantSettings) {\n            id\n            label\n            info\n            switchToStatusInfo\n            submitButtonLabel\n          }\n        }\n        executionStatus\n        travelConsultant @include(if: $withFromTravelTravelConsultant) {\n          id\n          firstName\n          lastName\n          jobTitle\n          description\n          email\n          image @include(if: $withFromTravelTravelConsultantImage) {\n            id\n            assetId\n            publicId\n            url\n            resourceType\n            format\n            width\n            height\n            caption\n            title\n            description\n          }\n          phone\n        }\n        label @include(if: $withFromTravelLabel) {\n          id\n          label\n        }\n        title\n        description\n        includedServices\n        excludedServices\n        pricingTable\n        priceCalculationInfo\n        seoSettings @include(if: $withFromTravelSeoSettings) {\n          id\n          urlSlug\n          metaTitle\n          metaDescription\n          ogTitle\n          ogDescription\n          ogImage @include(if: $withFromTravelSeoSettingsOgImage) {\n            id\n            assetId\n            publicId\n            url\n            resourceType\n            format\n            width\n            height\n            caption\n            title\n            description\n          }\n        }\n        tenantSettings @include(if: $withFromTravelTenantSettings) {\n          id\n          tenant @include(if: $withFromTravelTenantSettingsTenant) {\n            id\n            name\n            slug\n            domain\n            externalReference\n          }\n          onlineStatus\n          redirectToBooking\n          useTiming\n          startDate\n          endDate\n          travelTypes @include(if: $withFromTravelTenantSettingsTravelTypes) {\n            id\n            name\n            description\n          }\n        }\n        highlights @include(if: $withFromTravelHighlights) {\n          id\n          text\n        }\n        partners @include(if: $withFromTravelPartners) {\n          id\n          name\n          url\n          logo @include(if: $withFromTravelPartnersLogo) {\n            id\n            assetId\n            publicId\n            url\n            resourceType\n            format\n            width\n            height\n            caption\n            title\n            description\n          }\n          logoWidth\n          gtcPdf @include(if: $withFromTravelPartnersGtcPdf) {\n            id\n            assetId\n            publicId\n            url\n            resourceType\n            format\n            width\n            height\n            caption\n            title\n            description\n          }\n        }\n        travelGuides @include(if: $withFromTravelTravelGuides) {\n          id\n          firstName\n          lastName\n          description\n          image @include(if: $withFromTravelTravelGuidesImage) {\n            id\n            assetId\n            publicId\n            url\n            resourceType\n            format\n            width\n            height\n            caption\n            title\n            description\n          }\n        }\n        teams @include(if: $withFromTravelTeams) {\n          id\n          name\n          members @include(if: $withFromTravelTeamsMembers) {\n            id\n            firstName\n            lastName\n            description\n          }\n        }\n        accommodationAssignments @include(if: $withFromTravelAccommodationAssignments) {\n          id\n          accommodation @include(if: $withFromTravelAccommodationAssignmentsAccommodation) {\n            id\n            label\n            name\n            stars\n            description\n          }\n          roomTypes @include(if: $withFromTravelAccommodationAssignmentsRoomTypes) {\n            id\n            name\n            description\n          }\n          useCustomRoomTypeSelection\n        }\n        accommodations @include(if: $withFromTravelAccommodations) {\n          id\n          label\n          name\n          stars\n          description\n          roomTypes @include(if: $withFromTravelAccommodationsRoomTypes) {\n            id\n            name\n            description\n          }\n          availableAddons @include(if: $withFromTravelAccommodationsAvailableAddons) {\n            id\n            name\n            description\n          }\n          gallery @include(if: $withFromTravelAccommodationsGallery) {\n            id\n          }\n        }\n        destinations @include(if: $withFromTravelDestinations) {\n          id\n          name\n          entryRequirements\n          medicalInformation\n          language\n          timeShift\n          climate\n          currency\n        }\n        testimonials @include(if: $withFromTravelTestimonials) {\n          id\n          contentBlock @include(if: $withFromTravelTestimonialsContentBlock) {\n            id\n            title\n            text\n            imagePosition\n          }\n        }\n        mainImage @include(if: $withFromTravelMainImage) {\n          id\n          assetId\n          publicId\n          url\n          resourceType\n          format\n          width\n          height\n          caption\n          title\n          description\n        }\n        mainVideo @include(if: $withFromTravelMainVideo) {\n          id\n          assetId\n          publicId\n          url\n          resourceType\n          format\n          width\n          height\n          caption\n          title\n          description\n        }\n        gallery @include(if: $withFromTravelGallery) {\n          id\n          images @include(if: $withFromTravelGalleryImages) {\n            id\n            assetId\n            publicId\n            url\n            resourceType\n            format\n            width\n            height\n            caption\n            title\n            description\n          }\n        }\n        travelPdf @include(if: $withFromTravelTravelPdf) {\n          id\n          assetId\n          publicId\n          url\n          resourceType\n          format\n          width\n          height\n          caption\n          title\n          description\n        }\n        travelExtensions @include(if: $withFromTravelTravelExtensions) {\n          id\n          duration\n          name\n          description\n          highlights @include(if: $withFromTravelTravelExtensionsHighlights) {\n            id\n            text\n          }\n          image @include(if: $withFromTravelTravelExtensionsImage) {\n            id\n            assetId\n            publicId\n            url\n            resourceType\n            format\n            width\n            height\n            caption\n            title\n            description\n          }\n        }\n        programType\n        itinerary @include(if: $withFromTravelItinerary) {\n          id\n          items @include(if: $withFromTravelItineraryItems) {\n            id\n            duration\n            title\n            text\n          }\n        }\n        programText\n        pricing @include(if: $withFromTravelPricing) {\n          id\n          ageGroupSettings @include(if: $withFromTravelPricingAgeGroupSettings) {\n            id\n            freeUntilAge\n          }\n          isTravelDocumentationAvailable\n          customDataConfig @include(if: $withFromTravelPricingCustomDataConfig) {\n            id\n            useTravellerForm\n            useBookingForm\n          }\n          travels @include(if: $withFromTravelPricingTravels) {\n            id\n            catalogCode\n            travelCode\n            destination\n            name\n            transportType\n            transportTypeLabel\n            importDateTime\n            importStatus\n          }\n          webhookConfig @include(if: $withFromTravelPricingWebhookConfig) {\n            id\n            enabled\n            url\n          }\n          branding @include(if: $withFromTravelPricingBranding) {\n            id\n            logoWidth\n          }\n          bargainSettings @include(if: $withFromTravelPricingBargainSettings) {\n            id\n            active\n            untilDaysBeforeStart\n          }\n          esimSettings @include(if: $withFromTravelPricingEsimSettings) {\n            id\n            enabled\n          }\n          passportConfig @include(if: $withFromTravelPricingPassportConfig) {\n            id\n            passportOnly\n          }\n          tourOperator @include(if: $withFromTravelPricingTourOperator) {\n            id\n            name\n            url\n            logoWidth\n          }\n        }\n        minPrice\n        minPriceManualOverride\n        currency\n      }\n      toType\n      toUrl\n      toPage @include(if: $withToPage) {\n        id\n        name\n        onlineStatus\n        seoSettings @include(if: $withToPageSeoSettings) {\n          id\n          urlSlug\n          metaTitle\n          metaDescription\n          ogTitle\n          ogDescription\n          ogImage @include(if: $withToPageSeoSettingsOgImage) {\n            id\n            assetId\n            publicId\n            url\n            resourceType\n            format\n            width\n            height\n            caption\n            title\n            description\n          }\n        }\n        contentBlockAssignments @include(if: $withToPageContentBlockAssignments) {\n          id\n          type\n          block @include(if: $withToPageContentBlockAssignmentsBlock) {\n            __typename\n            ... on CmsTextBlock {\n              id\n              text\n\n            }\n            ... on CmsTextWithImageBlock {\n              id\n              title\n              subtitle\n              text\n              imagePosition\n              imageFixedAspectRatio\n\n            }\n            ... on CmsPageHeaderBlock {\n              id\n              title\n              text\n\n            }\n            ... on CmsWysiwygBlock {\n              id\n              html\n\n            }\n            ... on CmsHeadingBlock {\n              id\n              importance\n              heading\n              addon\n              decoration\n\n            }\n            ... on CmsTextWithIconBlock {\n              id\n              title\n              text\n              imagePosition\n\n            }\n            ... on CmsAccordionBlock {\n              id\n\n            }\n            ... on CmsGridBlock {\n              id\n\n            }\n            ... on CmsImageBlock {\n              id\n              text\n              fluid\n\n            }\n            ... on CmsEmployeesBlock {\n              id\n\n            }\n            ... on CmsContactBannerBlock {\n              id\n              phone\n              email\n\n            }\n            ... on CmsNewsletterRegisterBlock {\n              id\n              fluid\n\n            }\n            ... on CmsIssuuCatalogBlock {\n              id\n              publicationCode\n              accountName\n\n            }\n            ... on CmsFormBlock {\n              id\n              formName\n\n            }\n            ... on CmsHeaderSliderBlock {\n              id\n\n            }\n            ... on CmsBestsellerSliderBlock {\n              id\n              fluid\n\n            }\n            ... on CmsFilterLeadBlock {\n              id\n              layout\n\n            }\n            ... on CmsTravelTypesBlock {\n              id\n              layout\n\n            }\n            ... on CmsPrefilteredTravelsBlock {\n              id\n              maxResults\n\n            }\n            ... on CmsDividerBlock {\n              id\n              fluid\n\n            }\n            ... on CmsTravelSelectionBlock {\n              id\n\n            }\n            ... on CmsIframeBlock {\n              id\n              url\n              minHeight\n\n            }\n            ... on CmsSliderBlock {\n              id\n              fluid\n              size\n              showDots\n              showArrows\n              showLightbox\n              autoplay\n\n            }\n            ... on CmsDestinationsBlock {\n              id\n\n            }\n            ... on CmsTravelGuidesBlock {\n              id\n\n            }\n            ... on CmsBusfinderBlock {\n              id\n              title\n\n            }\n            ... on CmsBackgroundBlock {\n              id\n              backgroundVariant\n\n            }\n          }\n        }\n      }\n      toTravel @include(if: $withToTravel) {\n        id\n        name\n        isBestseller\n        startDate\n        endDate\n        availabilityStatus @include(if: $withToTravelAvailabilityStatus) {\n          id\n          label\n          status\n          isDefaultStatus\n          isDefaultWaitlistFallback\n          tenantSettings @include(if: $withToTravelAvailabilityStatusTenantSettings) {\n            id\n            label\n            info\n            switchToStatusInfo\n            submitButtonLabel\n          }\n        }\n        executionStatus\n        travelConsultant @include(if: $withToTravelTravelConsultant) {\n          id\n          firstName\n          lastName\n          jobTitle\n          description\n          email\n          image @include(if: $withToTravelTravelConsultantImage) {\n            id\n            assetId\n            publicId\n            url\n            resourceType\n            format\n            width\n            height\n            caption\n            title\n            description\n          }\n          phone\n        }\n        label @include(if: $withToTravelLabel) {\n          id\n          label\n        }\n        title\n        description\n        includedServices\n        excludedServices\n        pricingTable\n        priceCalculationInfo\n        seoSettings @include(if: $withToTravelSeoSettings) {\n          id\n          urlSlug\n          metaTitle\n          metaDescription\n          ogTitle\n          ogDescription\n          ogImage @include(if: $withToTravelSeoSettingsOgImage) {\n            id\n            assetId\n            publicId\n            url\n            resourceType\n            format\n            width\n            height\n            caption\n            title\n            description\n          }\n        }\n        tenantSettings @include(if: $withToTravelTenantSettings) {\n          id\n          tenant @include(if: $withToTravelTenantSettingsTenant) {\n            id\n            name\n            slug\n            domain\n            externalReference\n          }\n          onlineStatus\n          redirectToBooking\n          useTiming\n          startDate\n          endDate\n          travelTypes @include(if: $withToTravelTenantSettingsTravelTypes) {\n            id\n            name\n            description\n          }\n        }\n        highlights @include(if: $withToTravelHighlights) {\n          id\n          text\n        }\n        partners @include(if: $withToTravelPartners) {\n          id\n          name\n          url\n          logo @include(if: $withToTravelPartnersLogo) {\n            id\n            assetId\n            publicId\n            url\n            resourceType\n            format\n            width\n            height\n            caption\n            title\n            description\n          }\n          logoWidth\n          gtcPdf @include(if: $withToTravelPartnersGtcPdf) {\n            id\n            assetId\n            publicId\n            url\n            resourceType\n            format\n            width\n            height\n            caption\n            title\n            description\n          }\n        }\n        travelGuides @include(if: $withToTravelTravelGuides) {\n          id\n          firstName\n          lastName\n          description\n          image @include(if: $withToTravelTravelGuidesImage) {\n            id\n            assetId\n            publicId\n            url\n            resourceType\n            format\n            width\n            height\n            caption\n            title\n            description\n          }\n        }\n        teams @include(if: $withToTravelTeams) {\n          id\n          name\n          members @include(if: $withToTravelTeamsMembers) {\n            id\n            firstName\n            lastName\n            description\n          }\n        }\n        accommodationAssignments @include(if: $withToTravelAccommodationAssignments) {\n          id\n          accommodation @include(if: $withToTravelAccommodationAssignmentsAccommodation) {\n            id\n            label\n            name\n            stars\n            description\n          }\n          roomTypes @include(if: $withToTravelAccommodationAssignmentsRoomTypes) {\n            id\n            name\n            description\n          }\n          useCustomRoomTypeSelection\n        }\n        accommodations @include(if: $withToTravelAccommodations) {\n          id\n          label\n          name\n          stars\n          description\n          roomTypes @include(if: $withToTravelAccommodationsRoomTypes) {\n            id\n            name\n            description\n          }\n          availableAddons @include(if: $withToTravelAccommodationsAvailableAddons) {\n            id\n            name\n            description\n          }\n          gallery @include(if: $withToTravelAccommodationsGallery) {\n            id\n          }\n        }\n        destinations @include(if: $withToTravelDestinations) {\n          id\n          name\n          entryRequirements\n          medicalInformation\n          language\n          timeShift\n          climate\n          currency\n        }\n        testimonials @include(if: $withToTravelTestimonials) {\n          id\n          contentBlock @include(if: $withToTravelTestimonialsContentBlock) {\n            id\n            title\n            text\n            imagePosition\n          }\n        }\n        mainImage @include(if: $withToTravelMainImage) {\n          id\n          assetId\n          publicId\n          url\n          resourceType\n          format\n          width\n          height\n          caption\n          title\n          description\n        }\n        mainVideo @include(if: $withToTravelMainVideo) {\n          id\n          assetId\n          publicId\n          url\n          resourceType\n          format\n          width\n          height\n          caption\n          title\n          description\n        }\n        gallery @include(if: $withToTravelGallery) {\n          id\n          images @include(if: $withToTravelGalleryImages) {\n            id\n            assetId\n            publicId\n            url\n            resourceType\n            format\n            width\n            height\n            caption\n            title\n            description\n          }\n        }\n        travelPdf @include(if: $withToTravelTravelPdf) {\n          id\n          assetId\n          publicId\n          url\n          resourceType\n          format\n          width\n          height\n          caption\n          title\n          description\n        }\n        travelExtensions @include(if: $withToTravelTravelExtensions) {\n          id\n          duration\n          name\n          description\n          highlights @include(if: $withToTravelTravelExtensionsHighlights) {\n            id\n            text\n          }\n          image @include(if: $withToTravelTravelExtensionsImage) {\n            id\n            assetId\n            publicId\n            url\n            resourceType\n            format\n            width\n            height\n            caption\n            title\n            description\n          }\n        }\n        programType\n        itinerary @include(if: $withToTravelItinerary) {\n          id\n          items @include(if: $withToTravelItineraryItems) {\n            id\n            duration\n            title\n            text\n          }\n        }\n        programText\n        pricing @include(if: $withToTravelPricing) {\n          id\n          ageGroupSettings @include(if: $withToTravelPricingAgeGroupSettings) {\n            id\n            freeUntilAge\n          }\n          isTravelDocumentationAvailable\n          customDataConfig @include(if: $withToTravelPricingCustomDataConfig) {\n            id\n            useTravellerForm\n            useBookingForm\n          }\n          travels @include(if: $withToTravelPricingTravels) {\n            id\n            catalogCode\n            travelCode\n            destination\n            name\n            transportType\n            transportTypeLabel\n            importDateTime\n            importStatus\n          }\n          webhookConfig @include(if: $withToTravelPricingWebhookConfig) {\n            id\n            enabled\n            url\n          }\n          branding @include(if: $withToTravelPricingBranding) {\n            id\n            logoWidth\n          }\n          bargainSettings @include(if: $withToTravelPricingBargainSettings) {\n            id\n            active\n            untilDaysBeforeStart\n          }\n          esimSettings @include(if: $withToTravelPricingEsimSettings) {\n            id\n            enabled\n          }\n          passportConfig @include(if: $withToTravelPricingPassportConfig) {\n            id\n            passportOnly\n          }\n          tourOperator @include(if: $withToTravelPricingTourOperator) {\n            id\n            name\n            url\n            logoWidth\n          }\n        }\n        minPrice\n        minPriceManualOverride\n        currency\n      }\n    }\n  }";
// language=GraphQL
var DELETE_REDIRECT_MUTATION = "\n  mutation Mutation($input: DeleteRedirectInput) {\n    deleteRedirect(input: $input) {\n      success\n    }\n  }";
// language=GraphQL
var FORCE_DELETE_REDIRECT_MUTATION = "\n  mutation Mutation($input: DeleteRedirectInput) {\n    forceDeleteRedirect(input: $input) {\n      success\n    }\n  }";
// language=GraphQL
var REDIRECTS_DEPENDENTS_QUERY = "query Query($id: ID!, $withTenants: Boolean = false) {\n  groupedDependents: redirectDependents(id: $id) {\n    tenants @include(if: $withTenants) {\n      id\n      name\n      slug\n      domain\n      externalReference\n    }\n  }\n}";

// EXTERNAL MODULE: ./src/entities/cmsPage/entity.ts + 3 modules
var entity = __webpack_require__(49647);
// EXTERNAL MODULE: ./src/entities/travel/entity.ts + 3 modules
var travel_entity = __webpack_require__(82327);
;// CONCATENATED MODULE: ./src/entities/redirect/model.ts



var redirectModel = {
    name: "redirect",
    namePlural: "redirects",
    uniqueName: "redirect",
    uniqueNamePlural: "redirects",
    path: "config/tenant/redirect",
    baseUrl: "/config/tenant/redirects",
    translationPrefix: "entities:redirect.",
    getDisplayName: function(values) {
        return "URL Redirect";
    },
    gql: {
        getAll: ALL_REDIRECTS_QUERY,
        getSingle: SINGLE_REDIRECT_QUERY,
        create: CREATE_REDIRECT_MUTATION,
        update: UPDATE_REDIRECT_MUTATION,
        delete: DELETE_REDIRECT_MUTATION,
        forceDelete: FORCE_DELETE_REDIRECT_MUTATION
    },
    attributes: {
        fromType: {
            name: "fromType",
            label: "entities:redirect.attributes.fromType.label",
            type: "value",
            dataType: "string",
            defaultValue: "URL",
            defaultInput: true,
            inputType: "hidden",
            validationType: "string",
            validations: [
                {
                    type: "required"
                }, 
            ]
        },
        fromUrl: {
            name: "fromUrl",
            label: "entities:redirect.attributes.fromUrl.label",
            type: "value",
            dataType: "string",
            defaultInput: true,
            inputType: "text",
            validationType: "string",
            validations: []
        },
        fromPage: {
            name: "fromPage",
            label: "entities:redirect.attributes.fromPage.label",
            type: "entityObject",
            dataType: "any",
            getEntity: function() {
                return entity/* default */.Z;
            },
            defaultInput: false,
            inputType: "select",
            validationType: "string",
            validations: []
        },
        fromTravel: {
            name: "fromTravel",
            label: "entities:redirect.attributes.fromTravel.label",
            type: "entityObject",
            dataType: "any",
            getEntity: function() {
                return travel_entity/* default */.Z;
            },
            defaultInput: false,
            inputType: "select",
            validationType: "string",
            validations: []
        },
        toType: {
            name: "toType",
            label: "entities:redirect.attributes.toType.label",
            type: "value",
            dataType: "string",
            defaultValue: "URL",
            defaultInput: true,
            inputType: "hidden",
            validationType: "string",
            validations: [
                {
                    type: "required"
                }, 
            ]
        },
        toUrl: {
            name: "toUrl",
            label: "entities:redirect.attributes.toUrl.label",
            type: "value",
            dataType: "string",
            defaultInput: true,
            inputType: "text",
            validationType: "string",
            validations: []
        },
        toPage: {
            name: "toPage",
            label: "entities:redirect.attributes.toPage.label",
            type: "entityObject",
            dataType: "any",
            getEntity: function() {
                return entity/* default */.Z;
            },
            defaultInput: false,
            inputType: "select",
            validationType: "string",
            validations: []
        },
        toTravel: {
            name: "toTravel",
            label: "entities:redirect.attributes.toTravel.label",
            type: "entityObject",
            dataType: "any",
            getEntity: function() {
                return travel_entity/* default */.Z;
            },
            defaultInput: false,
            inputType: "select",
            validationType: "string",
            validations: []
        }
    }
};
/* harmony default export */ var model = (redirectModel);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(20414);
// EXTERNAL MODULE: ./src/entities/lib.ts
var lib = __webpack_require__(23480);
// EXTERNAL MODULE: ./src/lib/api/graphQLClient.ts
var graphQLClient = __webpack_require__(40112);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/swr/dist/index.mjs
var dist = __webpack_require__(8100);
// EXTERNAL MODULE: ./src/lib/helpers/helpers.ts
var helpers = __webpack_require__(15778);
;// CONCATENATED MODULE: ./src/entities/redirect/repository.ts










var hydrateObjects = function(objects) {
    return objects.map(function(object) {
        return (0,lib/* hydrateEntityObject */.b)(model, object);
    });
};
var hydrateObject = function(object) {
    return (0,lib/* hydrateEntityObject */.b)(model, object);
};
var redirectRepository = {
    getObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    id: id
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(SINGLE_REDIRECT_QUERY, variables).then(function(data) {
                        return hydrateObject(data.redirect);
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }(),
    getObjects: /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        var includes;
        var _arguments = arguments;
        return (0,tslib_es6.__generator)(this, function(_state) {
            includes = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : {};
            return [
                2,
                graphQLClient/* default.request */.Z.request(ALL_REDIRECTS_QUERY, includes).then(function(data) {
                    return hydrateObjects(data.redirects);
                })
            ];
        });
    }),
    useObject: function(id) {
        var includes = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        // eslint-disable-next-line react-hooks/exhaustive-deps
        var variables = (0,react.useMemo)(function() {
            return (0,_object_spread/* default */.Z)({
                id: id
            }, includes);
        }, [
            id
        ]);
        var ref = (0,dist/* default */.ZP)([
            SINGLE_REDIRECT_QUERY,
            variables
        ], {
            revalidateOnFocus: false
        }), data = ref.data, error = ref.error, mutate = ref.mutate;
        return {
            object: !data ? data : hydrateObject(data.redirect),
            isLoading: !error && !data,
            isError: error,
            mutate: mutate
        };
    },
    useObjects: function() {
        var includes = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        // eslint-disable-next-line react-hooks/exhaustive-deps
        var variables = (0,react.useMemo)(function() {
            return includes;
        }, []);
        var ref = (0,dist/* default */.ZP)([
            ALL_REDIRECTS_QUERY,
            variables
        ]), data = ref.data, error = ref.error, mutate = ref.mutate;
        return {
            objects: !data ? data : hydrateObjects(data.redirects),
            isLoading: !error && !data,
            isError: error,
            mutate: mutate
        };
    },
    getDependents: function(id, includes) {
        var includeVars = {};
        includes.forEach(function(include) {
            includeVars["with".concat((0,helpers/* uppercaseFirst */.AB)(include))] = true;
        });
        var variables = (0,_object_spread/* default */.Z)({
            id: id
        }, includeVars);
        return graphQLClient/* default.request */.Z.request(REDIRECTS_DEPENDENTS_QUERY, variables).then(function(data) {
            return data.groupedDependents;
        });
    },
    useDependents: function(id, includes) {
        var includeVars = {};
        includes.forEach(function(include) {
            includeVars["with".concat((0,helpers/* uppercaseFirst */.AB)(include))] = true;
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
        var variables = (0,react.useMemo)(function() {
            return (0,_object_spread/* default */.Z)({
                id: id
            }, includeVars);
        }, [
            id
        ]);
        var ref = (0,dist/* default */.ZP)([
            REDIRECTS_DEPENDENTS_QUERY,
            variables
        ], {
            revalidateOnFocus: false
        }), data = ref.data, error = ref.error, mutate = ref.mutate;
        return {
            data: !data ? data : data.groupedDependents,
            isLoading: !error && !data,
            isError: error,
            mutate: mutate
        };
    },
    createObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(data) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    input: data
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(CREATE_REDIRECT_MUTATION, variables).then(function(data) {
                        return hydrateObject(data.redirect);
                    })
                ];
            });
        });
        return function(data) {
            return _ref.apply(this, arguments);
        };
    }(),
    updateObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(data) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    input: data
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(UPDATE_REDIRECT_MUTATION, variables).then(function(data) {
                        return hydrateObject(data.redirect);
                    })
                ];
            });
        });
        return function(data) {
            return _ref.apply(this, arguments);
        };
    }(),
    deleteObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(DELETE_REDIRECT_MUTATION, variables).then(function(data) {
                        return data.deleteRedirect;
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }(),
    forceDeleteObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(FORCE_DELETE_REDIRECT_MUTATION, variables).then(function(data) {
                        return data.forceDeleteRedirect;
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }()
};
/* harmony default export */ var repository = (redirectRepository);

;// CONCATENATED MODULE: ./src/entities/redirect/entity.ts


var redirectEntity = {
    model: model,
    repository: repository
};
/* harmony default export */ var redirect_entity = (redirectEntity);


/***/ }),

/***/ 57850:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ tenant_entity; }
});

;// CONCATENATED MODULE: ./src/entities/tenant/graphql.ts
// language=GraphQL
var ALL_TENANTS_QUERY = "query Query($withCms: Boolean = false, $withCmsHomepage: Boolean = false, $withCmsHomepageSeoSettings: Boolean = false, $withCmsHomepageContentBlockAssignments: Boolean = false, $withCmsCategories: Boolean = false, $withCmsCategoriesPages: Boolean = false, $withCmsCategoriesSeoSettings: Boolean = false, $withCmsPages: Boolean = false, $withCmsPagesSeoSettings: Boolean = false, $withCmsPagesContentBlockAssignments: Boolean = false, $withCmsErrorPage404: Boolean = false, $withCmsErrorPage404SeoSettings: Boolean = false, $withCmsErrorPage404ContentBlockAssignments: Boolean = false, $withCmsErrorPage500: Boolean = false, $withCmsErrorPage500SeoSettings: Boolean = false, $withCmsErrorPage500ContentBlockAssignments: Boolean = false, $withCmsConfig: Boolean = false, $withCmsConfigContactBlockSettings: Boolean = false, $withCmsConfigSocialMediaSettings: Boolean = false, $withCmsConfigPrivacyPolicyPage: Boolean = false, $withCmsConfigGtcPage: Boolean = false, $withTravelTypes: Boolean = false, $withTravelTypesImage: Boolean = false, $withEmployees: Boolean = false, $withEmployeesImage: Boolean = false, $withEmailConfig: Boolean = false, $withNewsletterProvider: Boolean = false, $withNewsletterProviderConfig: Boolean = false, $withRedirects: Boolean = false, $withRedirectsFromPage: Boolean = false, $withRedirectsFromPageSeoSettings: Boolean = false, $withRedirectsFromPageContentBlockAssignments: Boolean = false, $withRedirectsFromTravel: Boolean = false, $withRedirectsFromTravelAvailabilityStatus: Boolean = false, $withRedirectsFromTravelTravelConsultant: Boolean = false, $withRedirectsFromTravelLabel: Boolean = false, $withRedirectsFromTravelSeoSettings: Boolean = false, $withRedirectsFromTravelTenantSettings: Boolean = false, $withRedirectsFromTravelHighlights: Boolean = false, $withRedirectsFromTravelPartners: Boolean = false, $withRedirectsFromTravelTravelGuides: Boolean = false, $withRedirectsFromTravelTeams: Boolean = false, $withRedirectsFromTravelAccommodationAssignments: Boolean = false, $withRedirectsFromTravelAccommodations: Boolean = false, $withRedirectsFromTravelDestinations: Boolean = false, $withRedirectsFromTravelTestimonials: Boolean = false, $withRedirectsFromTravelMainImage: Boolean = false, $withRedirectsFromTravelMainVideo: Boolean = false, $withRedirectsFromTravelGallery: Boolean = false, $withRedirectsFromTravelTravelPdf: Boolean = false, $withRedirectsFromTravelTravelExtensions: Boolean = false, $withRedirectsFromTravelItinerary: Boolean = false, $withRedirectsFromTravelPricing: Boolean = false, $withRedirectsToPage: Boolean = false, $withRedirectsToPageSeoSettings: Boolean = false, $withRedirectsToPageContentBlockAssignments: Boolean = false, $withRedirectsToTravel: Boolean = false, $withRedirectsToTravelAvailabilityStatus: Boolean = false, $withRedirectsToTravelTravelConsultant: Boolean = false, $withRedirectsToTravelLabel: Boolean = false, $withRedirectsToTravelSeoSettings: Boolean = false, $withRedirectsToTravelTenantSettings: Boolean = false, $withRedirectsToTravelHighlights: Boolean = false, $withRedirectsToTravelPartners: Boolean = false, $withRedirectsToTravelTravelGuides: Boolean = false, $withRedirectsToTravelTeams: Boolean = false, $withRedirectsToTravelAccommodationAssignments: Boolean = false, $withRedirectsToTravelAccommodations: Boolean = false, $withRedirectsToTravelDestinations: Boolean = false, $withRedirectsToTravelTestimonials: Boolean = false, $withRedirectsToTravelMainImage: Boolean = false, $withRedirectsToTravelMainVideo: Boolean = false, $withRedirectsToTravelGallery: Boolean = false, $withRedirectsToTravelTravelPdf: Boolean = false, $withRedirectsToTravelTravelExtensions: Boolean = false, $withRedirectsToTravelItinerary: Boolean = false, $withRedirectsToTravelPricing: Boolean = false, $withOnlinePaymentConfig: Boolean = false, $withRatioConfig: Boolean = false, $withContent: Boolean = false, $withPartnerTenants: Boolean = false, $withPartnerTenantsTenant: Boolean = false, $withPartnerTenantsTenantCms: Boolean = false, $withPartnerTenantsTenantTravelTypes: Boolean = false, $withPartnerTenantsTenantEmployees: Boolean = false, $withPartnerTenantsTenantEmailConfig: Boolean = false, $withPartnerTenantsTenantNewsletterProvider: Boolean = false, $withPartnerTenantsTenantRedirects: Boolean = false, $withPartnerTenantsTenantOnlinePaymentConfig: Boolean = false, $withPartnerTenantsTenantRatioConfig: Boolean = false, $withPartnerTenantsTenantContent: Boolean = false, $withPartnerTenantsTenantPartnerTenants: Boolean = false) {\n  tenants: tenants {\n    id\n    name\n    slug\n    domain\n    externalReference\n    cms @include(if: $withCms) {\n      id\n      homepage @include(if: $withCmsHomepage) {\n        id\n        name\n        onlineStatus\n        seoSettings @include(if: $withCmsHomepageSeoSettings) {\n          id\n          urlSlug\n          metaTitle\n          metaDescription\n          ogTitle\n          ogDescription\n        }\n        contentBlockAssignments @include(if: $withCmsHomepageContentBlockAssignments) {\n          id\n          type\n        }\n      }\n      categories @include(if: $withCmsCategories) {\n        id\n        name\n        pages @include(if: $withCmsCategoriesPages) {\n          id\n          name\n          onlineStatus\n        }\n        seoSettings @include(if: $withCmsCategoriesSeoSettings) {\n          id\n          urlSlug\n          metaTitle\n          metaDescription\n          ogTitle\n          ogDescription\n        }\n      }\n      pages @include(if: $withCmsPages) {\n        id\n        name\n        onlineStatus\n        seoSettings @include(if: $withCmsPagesSeoSettings) {\n          id\n          urlSlug\n          metaTitle\n          metaDescription\n          ogTitle\n          ogDescription\n        }\n        contentBlockAssignments @include(if: $withCmsPagesContentBlockAssignments) {\n          id\n          type\n        }\n      }\n      errorPage404 @include(if: $withCmsErrorPage404) {\n        id\n        name\n        onlineStatus\n        seoSettings @include(if: $withCmsErrorPage404SeoSettings) {\n          id\n          urlSlug\n          metaTitle\n          metaDescription\n          ogTitle\n          ogDescription\n        }\n        contentBlockAssignments @include(if: $withCmsErrorPage404ContentBlockAssignments) {\n          id\n          type\n        }\n      }\n      errorPage500 @include(if: $withCmsErrorPage500) {\n        id\n        name\n        onlineStatus\n        seoSettings @include(if: $withCmsErrorPage500SeoSettings) {\n          id\n          urlSlug\n          metaTitle\n          metaDescription\n          ogTitle\n          ogDescription\n        }\n        contentBlockAssignments @include(if: $withCmsErrorPage500ContentBlockAssignments) {\n          id\n          type\n        }\n      }\n      config @include(if: $withCmsConfig) {\n        id\n        contactBlockSettings @include(if: $withCmsConfigContactBlockSettings) {\n          id\n          slogan\n          title\n          text\n          phonePrefix\n          phone\n          phone2Prefix\n          phone2\n          openingHours1\n          openingHours2\n          email\n        }\n        socialMediaSettings @include(if: $withCmsConfigSocialMediaSettings) {\n          id\n          facebookUrl\n          instagramUrl\n        }\n        privacyPolicyPage @include(if: $withCmsConfigPrivacyPolicyPage) {\n          id\n          name\n          onlineStatus\n        }\n        gtcPage @include(if: $withCmsConfigGtcPage) {\n          id\n          name\n          onlineStatus\n        }\n      }\n    }\n    travelTypes @include(if: $withTravelTypes) {\n      id\n      name\n      description\n      image @include(if: $withTravelTypesImage) {\n        id\n        assetId\n        publicId\n        url\n        resourceType\n        format\n        width\n        height\n        caption\n        title\n        description\n      }\n    }\n    employees @include(if: $withEmployees) {\n      id\n      firstName\n      lastName\n      jobTitle\n      description\n      email\n      image @include(if: $withEmployeesImage) {\n        id\n        assetId\n        publicId\n        url\n        resourceType\n        format\n        width\n        height\n        caption\n        title\n        description\n      }\n      phone\n    }\n    emailConfig @include(if: $withEmailConfig) {\n      id\n      defaultInternalRecipientEmail\n      internalBookingRecipientEmails\n      bookingConfirmationTemplateId\n      bookingConfirmationInternalTemplateId\n      bookingRequestConfirmationTemplateId\n      bookingWaitlistConfirmationTemplateId\n      bookingWaitlistContingentCheckConfirmationTemplateId\n      bookingCustomRequestTemplateId\n      bookingPassportDataReminderTemplateId\n      contactFormTemplateId\n      esimInstallationInfoTemplateId\n    }\n    newsletterProvider @include(if: $withNewsletterProvider) {\n      id\n      provider\n      config @include(if: $withNewsletterProviderConfig) {\n        __typename\n        ... on MailchimpConfig {\n          id\n          apiKey\n          serverPrefix\n          listId\n\n        }\n      }\n    }\n    redirects @include(if: $withRedirects) {\n      id\n      fromType\n      fromUrl\n      fromPage @include(if: $withRedirectsFromPage) {\n        id\n        name\n        onlineStatus\n        seoSettings @include(if: $withRedirectsFromPageSeoSettings) {\n          id\n          urlSlug\n          metaTitle\n          metaDescription\n          ogTitle\n          ogDescription\n        }\n        contentBlockAssignments @include(if: $withRedirectsFromPageContentBlockAssignments) {\n          id\n          type\n        }\n      }\n      fromTravel @include(if: $withRedirectsFromTravel) {\n        id\n        name\n        isBestseller\n        startDate\n        endDate\n        availabilityStatus @include(if: $withRedirectsFromTravelAvailabilityStatus) {\n          id\n          label\n          status\n          isDefaultStatus\n          isDefaultWaitlistFallback\n        }\n        executionStatus\n        travelConsultant @include(if: $withRedirectsFromTravelTravelConsultant) {\n          id\n          firstName\n          lastName\n          jobTitle\n          description\n          email\n          phone\n        }\n        label @include(if: $withRedirectsFromTravelLabel) {\n          id\n          label\n        }\n        title\n        description\n        includedServices\n        excludedServices\n        pricingTable\n        priceCalculationInfo\n        seoSettings @include(if: $withRedirectsFromTravelSeoSettings) {\n          id\n          urlSlug\n          metaTitle\n          metaDescription\n          ogTitle\n          ogDescription\n        }\n        tenantSettings @include(if: $withRedirectsFromTravelTenantSettings) {\n          id\n          onlineStatus\n          redirectToBooking\n          useTiming\n          startDate\n          endDate\n        }\n        highlights @include(if: $withRedirectsFromTravelHighlights) {\n          id\n          text\n        }\n        partners @include(if: $withRedirectsFromTravelPartners) {\n          id\n          name\n          url\n          logoWidth\n        }\n        travelGuides @include(if: $withRedirectsFromTravelTravelGuides) {\n          id\n          firstName\n          lastName\n          description\n        }\n        teams @include(if: $withRedirectsFromTravelTeams) {\n          id\n          name\n        }\n        accommodationAssignments @include(if: $withRedirectsFromTravelAccommodationAssignments) {\n          id\n          useCustomRoomTypeSelection\n        }\n        accommodations @include(if: $withRedirectsFromTravelAccommodations) {\n          id\n          label\n          name\n          stars\n          description\n        }\n        destinations @include(if: $withRedirectsFromTravelDestinations) {\n          id\n          name\n          entryRequirements\n          medicalInformation\n          language\n          timeShift\n          climate\n          currency\n        }\n        testimonials @include(if: $withRedirectsFromTravelTestimonials) {\n          id\n        }\n        mainImage @include(if: $withRedirectsFromTravelMainImage) {\n          id\n          assetId\n          publicId\n          url\n          resourceType\n          format\n          width\n          height\n          caption\n          title\n          description\n        }\n        mainVideo @include(if: $withRedirectsFromTravelMainVideo) {\n          id\n          assetId\n          publicId\n          url\n          resourceType\n          format\n          width\n          height\n          caption\n          title\n          description\n        }\n        gallery @include(if: $withRedirectsFromTravelGallery) {\n          id\n        }\n        travelPdf @include(if: $withRedirectsFromTravelTravelPdf) {\n          id\n          assetId\n          publicId\n          url\n          resourceType\n          format\n          width\n          height\n          caption\n          title\n          description\n        }\n        travelExtensions @include(if: $withRedirectsFromTravelTravelExtensions) {\n          id\n          duration\n          name\n          description\n        }\n        programType\n        itinerary @include(if: $withRedirectsFromTravelItinerary) {\n          id\n        }\n        programText\n        pricing @include(if: $withRedirectsFromTravelPricing) {\n          id\n          isTravelDocumentationAvailable\n        }\n        minPrice\n        minPriceManualOverride\n        currency\n      }\n      toType\n      toUrl\n      toPage @include(if: $withRedirectsToPage) {\n        id\n        name\n        onlineStatus\n        seoSettings @include(if: $withRedirectsToPageSeoSettings) {\n          id\n          urlSlug\n          metaTitle\n          metaDescription\n          ogTitle\n          ogDescription\n        }\n        contentBlockAssignments @include(if: $withRedirectsToPageContentBlockAssignments) {\n          id\n          type\n        }\n      }\n      toTravel @include(if: $withRedirectsToTravel) {\n        id\n        name\n        isBestseller\n        startDate\n        endDate\n        availabilityStatus @include(if: $withRedirectsToTravelAvailabilityStatus) {\n          id\n          label\n          status\n          isDefaultStatus\n          isDefaultWaitlistFallback\n        }\n        executionStatus\n        travelConsultant @include(if: $withRedirectsToTravelTravelConsultant) {\n          id\n          firstName\n          lastName\n          jobTitle\n          description\n          email\n          phone\n        }\n        label @include(if: $withRedirectsToTravelLabel) {\n          id\n          label\n        }\n        title\n        description\n        includedServices\n        excludedServices\n        pricingTable\n        priceCalculationInfo\n        seoSettings @include(if: $withRedirectsToTravelSeoSettings) {\n          id\n          urlSlug\n          metaTitle\n          metaDescription\n          ogTitle\n          ogDescription\n        }\n        tenantSettings @include(if: $withRedirectsToTravelTenantSettings) {\n          id\n          onlineStatus\n          redirectToBooking\n          useTiming\n          startDate\n          endDate\n        }\n        highlights @include(if: $withRedirectsToTravelHighlights) {\n          id\n          text\n        }\n        partners @include(if: $withRedirectsToTravelPartners) {\n          id\n          name\n          url\n          logoWidth\n        }\n        travelGuides @include(if: $withRedirectsToTravelTravelGuides) {\n          id\n          firstName\n          lastName\n          description\n        }\n        teams @include(if: $withRedirectsToTravelTeams) {\n          id\n          name\n        }\n        accommodationAssignments @include(if: $withRedirectsToTravelAccommodationAssignments) {\n          id\n          useCustomRoomTypeSelection\n        }\n        accommodations @include(if: $withRedirectsToTravelAccommodations) {\n          id\n          label\n          name\n          stars\n          description\n        }\n        destinations @include(if: $withRedirectsToTravelDestinations) {\n          id\n          name\n          entryRequirements\n          medicalInformation\n          language\n          timeShift\n          climate\n          currency\n        }\n        testimonials @include(if: $withRedirectsToTravelTestimonials) {\n          id\n        }\n        mainImage @include(if: $withRedirectsToTravelMainImage) {\n          id\n          assetId\n          publicId\n          url\n          resourceType\n          format\n          width\n          height\n          caption\n          title\n          description\n        }\n        mainVideo @include(if: $withRedirectsToTravelMainVideo) {\n          id\n          assetId\n          publicId\n          url\n          resourceType\n          format\n          width\n          height\n          caption\n          title\n          description\n        }\n        gallery @include(if: $withRedirectsToTravelGallery) {\n          id\n        }\n        travelPdf @include(if: $withRedirectsToTravelTravelPdf) {\n          id\n          assetId\n          publicId\n          url\n          resourceType\n          format\n          width\n          height\n          caption\n          title\n          description\n        }\n        travelExtensions @include(if: $withRedirectsToTravelTravelExtensions) {\n          id\n          duration\n          name\n          description\n        }\n        programType\n        itinerary @include(if: $withRedirectsToTravelItinerary) {\n          id\n        }\n        programText\n        pricing @include(if: $withRedirectsToTravelPricing) {\n          id\n          isTravelDocumentationAvailable\n        }\n        minPrice\n        minPriceManualOverride\n        currency\n      }\n    }\n    onlinePaymentConfig @include(if: $withOnlinePaymentConfig) {\n      id\n      enabled\n      ratioFibuAccountNo\n      infoText\n      datatransThemeConfig\n    }\n    ratioConfig @include(if: $withRatioConfig) {\n      id\n      adressgruppe\n    }\n    content @include(if: $withContent) {\n      id\n      bookingInsuranceInfo\n    }\n    partnerTenants @include(if: $withPartnerTenants) {\n      id\n      tenant @include(if: $withPartnerTenantsTenant) {\n        id\n        name\n        slug\n        domain\n        externalReference\n        cms @include(if: $withPartnerTenantsTenantCms) {\n          id\n        }\n        travelTypes @include(if: $withPartnerTenantsTenantTravelTypes) {\n          id\n          name\n          description\n        }\n        employees @include(if: $withPartnerTenantsTenantEmployees) {\n          id\n          firstName\n          lastName\n          jobTitle\n          description\n          email\n          phone\n        }\n        emailConfig @include(if: $withPartnerTenantsTenantEmailConfig) {\n          id\n          defaultInternalRecipientEmail\n          internalBookingRecipientEmails\n          bookingConfirmationTemplateId\n          bookingConfirmationInternalTemplateId\n          bookingRequestConfirmationTemplateId\n          bookingWaitlistConfirmationTemplateId\n          bookingWaitlistContingentCheckConfirmationTemplateId\n          bookingCustomRequestTemplateId\n          bookingPassportDataReminderTemplateId\n          contactFormTemplateId\n          esimInstallationInfoTemplateId\n        }\n        newsletterProvider @include(if: $withPartnerTenantsTenantNewsletterProvider) {\n          id\n          provider\n        }\n        redirects @include(if: $withPartnerTenantsTenantRedirects) {\n          id\n          fromType\n          fromUrl\n          toType\n          toUrl\n        }\n        onlinePaymentConfig @include(if: $withPartnerTenantsTenantOnlinePaymentConfig) {\n          id\n          enabled\n          ratioFibuAccountNo\n          infoText\n          datatransThemeConfig\n        }\n        ratioConfig @include(if: $withPartnerTenantsTenantRatioConfig) {\n          id\n          adressgruppe\n        }\n        content @include(if: $withPartnerTenantsTenantContent) {\n          id\n          bookingInsuranceInfo\n        }\n        partnerTenants @include(if: $withPartnerTenantsTenantPartnerTenants) {\n          id\n          filterCrossLinking\n        }\n      }\n      filterCrossLinking\n    }\n  }\n}";
// language=GraphQL
var SINGLE_TENANT_QUERY = "query Query($id: ID!, $withCms: Boolean = false, $withCmsHomepage: Boolean = false, $withCmsHomepageSeoSettings: Boolean = false, $withCmsHomepageContentBlockAssignments: Boolean = false, $withCmsCategories: Boolean = false, $withCmsCategoriesPages: Boolean = false, $withCmsCategoriesSeoSettings: Boolean = false, $withCmsPages: Boolean = false, $withCmsPagesSeoSettings: Boolean = false, $withCmsPagesContentBlockAssignments: Boolean = false, $withCmsErrorPage404: Boolean = false, $withCmsErrorPage404SeoSettings: Boolean = false, $withCmsErrorPage404ContentBlockAssignments: Boolean = false, $withCmsErrorPage500: Boolean = false, $withCmsErrorPage500SeoSettings: Boolean = false, $withCmsErrorPage500ContentBlockAssignments: Boolean = false, $withCmsConfig: Boolean = false, $withCmsConfigContactBlockSettings: Boolean = false, $withCmsConfigSocialMediaSettings: Boolean = false, $withCmsConfigPrivacyPolicyPage: Boolean = false, $withCmsConfigGtcPage: Boolean = false, $withTravelTypes: Boolean = false, $withTravelTypesImage: Boolean = false, $withEmployees: Boolean = false, $withEmployeesImage: Boolean = false, $withEmailConfig: Boolean = false, $withNewsletterProvider: Boolean = false, $withNewsletterProviderConfig: Boolean = false, $withRedirects: Boolean = false, $withRedirectsFromPage: Boolean = false, $withRedirectsFromPageSeoSettings: Boolean = false, $withRedirectsFromPageContentBlockAssignments: Boolean = false, $withRedirectsFromTravel: Boolean = false, $withRedirectsFromTravelAvailabilityStatus: Boolean = false, $withRedirectsFromTravelTravelConsultant: Boolean = false, $withRedirectsFromTravelLabel: Boolean = false, $withRedirectsFromTravelSeoSettings: Boolean = false, $withRedirectsFromTravelTenantSettings: Boolean = false, $withRedirectsFromTravelHighlights: Boolean = false, $withRedirectsFromTravelPartners: Boolean = false, $withRedirectsFromTravelTravelGuides: Boolean = false, $withRedirectsFromTravelTeams: Boolean = false, $withRedirectsFromTravelAccommodationAssignments: Boolean = false, $withRedirectsFromTravelAccommodations: Boolean = false, $withRedirectsFromTravelDestinations: Boolean = false, $withRedirectsFromTravelTestimonials: Boolean = false, $withRedirectsFromTravelMainImage: Boolean = false, $withRedirectsFromTravelMainVideo: Boolean = false, $withRedirectsFromTravelGallery: Boolean = false, $withRedirectsFromTravelTravelPdf: Boolean = false, $withRedirectsFromTravelTravelExtensions: Boolean = false, $withRedirectsFromTravelItinerary: Boolean = false, $withRedirectsFromTravelPricing: Boolean = false, $withRedirectsToPage: Boolean = false, $withRedirectsToPageSeoSettings: Boolean = false, $withRedirectsToPageContentBlockAssignments: Boolean = false, $withRedirectsToTravel: Boolean = false, $withRedirectsToTravelAvailabilityStatus: Boolean = false, $withRedirectsToTravelTravelConsultant: Boolean = false, $withRedirectsToTravelLabel: Boolean = false, $withRedirectsToTravelSeoSettings: Boolean = false, $withRedirectsToTravelTenantSettings: Boolean = false, $withRedirectsToTravelHighlights: Boolean = false, $withRedirectsToTravelPartners: Boolean = false, $withRedirectsToTravelTravelGuides: Boolean = false, $withRedirectsToTravelTeams: Boolean = false, $withRedirectsToTravelAccommodationAssignments: Boolean = false, $withRedirectsToTravelAccommodations: Boolean = false, $withRedirectsToTravelDestinations: Boolean = false, $withRedirectsToTravelTestimonials: Boolean = false, $withRedirectsToTravelMainImage: Boolean = false, $withRedirectsToTravelMainVideo: Boolean = false, $withRedirectsToTravelGallery: Boolean = false, $withRedirectsToTravelTravelPdf: Boolean = false, $withRedirectsToTravelTravelExtensions: Boolean = false, $withRedirectsToTravelItinerary: Boolean = false, $withRedirectsToTravelPricing: Boolean = false, $withOnlinePaymentConfig: Boolean = false, $withRatioConfig: Boolean = false, $withContent: Boolean = false, $withPartnerTenants: Boolean = false, $withPartnerTenantsTenant: Boolean = false, $withPartnerTenantsTenantCms: Boolean = false, $withPartnerTenantsTenantTravelTypes: Boolean = false, $withPartnerTenantsTenantEmployees: Boolean = false, $withPartnerTenantsTenantEmailConfig: Boolean = false, $withPartnerTenantsTenantNewsletterProvider: Boolean = false, $withPartnerTenantsTenantRedirects: Boolean = false, $withPartnerTenantsTenantOnlinePaymentConfig: Boolean = false, $withPartnerTenantsTenantRatioConfig: Boolean = false, $withPartnerTenantsTenantContent: Boolean = false, $withPartnerTenantsTenantPartnerTenants: Boolean = false) {\n  tenant: tenant(id: $id) {\n    id\n    name\n    slug\n    domain\n    externalReference\n    cms @include(if: $withCms) {\n      id\n      homepage @include(if: $withCmsHomepage) {\n        id\n        name\n        onlineStatus\n        seoSettings @include(if: $withCmsHomepageSeoSettings) {\n          id\n          urlSlug\n          metaTitle\n          metaDescription\n          ogTitle\n          ogDescription\n        }\n        contentBlockAssignments @include(if: $withCmsHomepageContentBlockAssignments) {\n          id\n          type\n        }\n      }\n      categories @include(if: $withCmsCategories) {\n        id\n        name\n        pages @include(if: $withCmsCategoriesPages) {\n          id\n          name\n          onlineStatus\n        }\n        seoSettings @include(if: $withCmsCategoriesSeoSettings) {\n          id\n          urlSlug\n          metaTitle\n          metaDescription\n          ogTitle\n          ogDescription\n        }\n      }\n      pages @include(if: $withCmsPages) {\n        id\n        name\n        onlineStatus\n        seoSettings @include(if: $withCmsPagesSeoSettings) {\n          id\n          urlSlug\n          metaTitle\n          metaDescription\n          ogTitle\n          ogDescription\n        }\n        contentBlockAssignments @include(if: $withCmsPagesContentBlockAssignments) {\n          id\n          type\n        }\n      }\n      errorPage404 @include(if: $withCmsErrorPage404) {\n        id\n        name\n        onlineStatus\n        seoSettings @include(if: $withCmsErrorPage404SeoSettings) {\n          id\n          urlSlug\n          metaTitle\n          metaDescription\n          ogTitle\n          ogDescription\n        }\n        contentBlockAssignments @include(if: $withCmsErrorPage404ContentBlockAssignments) {\n          id\n          type\n        }\n      }\n      errorPage500 @include(if: $withCmsErrorPage500) {\n        id\n        name\n        onlineStatus\n        seoSettings @include(if: $withCmsErrorPage500SeoSettings) {\n          id\n          urlSlug\n          metaTitle\n          metaDescription\n          ogTitle\n          ogDescription\n        }\n        contentBlockAssignments @include(if: $withCmsErrorPage500ContentBlockAssignments) {\n          id\n          type\n        }\n      }\n      config @include(if: $withCmsConfig) {\n        id\n        contactBlockSettings @include(if: $withCmsConfigContactBlockSettings) {\n          id\n          slogan\n          title\n          text\n          phonePrefix\n          phone\n          phone2Prefix\n          phone2\n          openingHours1\n          openingHours2\n          email\n        }\n        socialMediaSettings @include(if: $withCmsConfigSocialMediaSettings) {\n          id\n          facebookUrl\n          instagramUrl\n        }\n        privacyPolicyPage @include(if: $withCmsConfigPrivacyPolicyPage) {\n          id\n          name\n          onlineStatus\n        }\n        gtcPage @include(if: $withCmsConfigGtcPage) {\n          id\n          name\n          onlineStatus\n        }\n      }\n    }\n    travelTypes @include(if: $withTravelTypes) {\n      id\n      name\n      description\n      image @include(if: $withTravelTypesImage) {\n        id\n        assetId\n        publicId\n        url\n        resourceType\n        format\n        width\n        height\n        caption\n        title\n        description\n      }\n    }\n    employees @include(if: $withEmployees) {\n      id\n      firstName\n      lastName\n      jobTitle\n      description\n      email\n      image @include(if: $withEmployeesImage) {\n        id\n        assetId\n        publicId\n        url\n        resourceType\n        format\n        width\n        height\n        caption\n        title\n        description\n      }\n      phone\n    }\n    emailConfig @include(if: $withEmailConfig) {\n      id\n      defaultInternalRecipientEmail\n      internalBookingRecipientEmails\n      bookingConfirmationTemplateId\n      bookingConfirmationInternalTemplateId\n      bookingRequestConfirmationTemplateId\n      bookingWaitlistConfirmationTemplateId\n      bookingWaitlistContingentCheckConfirmationTemplateId\n      bookingCustomRequestTemplateId\n      bookingPassportDataReminderTemplateId\n      contactFormTemplateId\n      esimInstallationInfoTemplateId\n    }\n    newsletterProvider @include(if: $withNewsletterProvider) {\n      id\n      provider\n      config @include(if: $withNewsletterProviderConfig) {\n        __typename\n        ... on MailchimpConfig {\n          id\n          apiKey\n          serverPrefix\n          listId\n\n        }\n      }\n    }\n    redirects @include(if: $withRedirects) {\n      id\n      fromType\n      fromUrl\n      fromPage @include(if: $withRedirectsFromPage) {\n        id\n        name\n        onlineStatus\n        seoSettings @include(if: $withRedirectsFromPageSeoSettings) {\n          id\n          urlSlug\n          metaTitle\n          metaDescription\n          ogTitle\n          ogDescription\n        }\n        contentBlockAssignments @include(if: $withRedirectsFromPageContentBlockAssignments) {\n          id\n          type\n        }\n      }\n      fromTravel @include(if: $withRedirectsFromTravel) {\n        id\n        name\n        isBestseller\n        startDate\n        endDate\n        availabilityStatus @include(if: $withRedirectsFromTravelAvailabilityStatus) {\n          id\n          label\n          status\n          isDefaultStatus\n          isDefaultWaitlistFallback\n        }\n        executionStatus\n        travelConsultant @include(if: $withRedirectsFromTravelTravelConsultant) {\n          id\n          firstName\n          lastName\n          jobTitle\n          description\n          email\n          phone\n        }\n        label @include(if: $withRedirectsFromTravelLabel) {\n          id\n          label\n        }\n        title\n        description\n        includedServices\n        excludedServices\n        pricingTable\n        priceCalculationInfo\n        seoSettings @include(if: $withRedirectsFromTravelSeoSettings) {\n          id\n          urlSlug\n          metaTitle\n          metaDescription\n          ogTitle\n          ogDescription\n        }\n        tenantSettings @include(if: $withRedirectsFromTravelTenantSettings) {\n          id\n          onlineStatus\n          redirectToBooking\n          useTiming\n          startDate\n          endDate\n        }\n        highlights @include(if: $withRedirectsFromTravelHighlights) {\n          id\n          text\n        }\n        partners @include(if: $withRedirectsFromTravelPartners) {\n          id\n          name\n          url\n          logoWidth\n        }\n        travelGuides @include(if: $withRedirectsFromTravelTravelGuides) {\n          id\n          firstName\n          lastName\n          description\n        }\n        teams @include(if: $withRedirectsFromTravelTeams) {\n          id\n          name\n        }\n        accommodationAssignments @include(if: $withRedirectsFromTravelAccommodationAssignments) {\n          id\n          useCustomRoomTypeSelection\n        }\n        accommodations @include(if: $withRedirectsFromTravelAccommodations) {\n          id\n          label\n          name\n          stars\n          description\n        }\n        destinations @include(if: $withRedirectsFromTravelDestinations) {\n          id\n          name\n          entryRequirements\n          medicalInformation\n          language\n          timeShift\n          climate\n          currency\n        }\n        testimonials @include(if: $withRedirectsFromTravelTestimonials) {\n          id\n        }\n        mainImage @include(if: $withRedirectsFromTravelMainImage) {\n          id\n          assetId\n          publicId\n          url\n          resourceType\n          format\n          width\n          height\n          caption\n          title\n          description\n        }\n        mainVideo @include(if: $withRedirectsFromTravelMainVideo) {\n          id\n          assetId\n          publicId\n          url\n          resourceType\n          format\n          width\n          height\n          caption\n          title\n          description\n        }\n        gallery @include(if: $withRedirectsFromTravelGallery) {\n          id\n        }\n        travelPdf @include(if: $withRedirectsFromTravelTravelPdf) {\n          id\n          assetId\n          publicId\n          url\n          resourceType\n          format\n          width\n          height\n          caption\n          title\n          description\n        }\n        travelExtensions @include(if: $withRedirectsFromTravelTravelExtensions) {\n          id\n          duration\n          name\n          description\n        }\n        programType\n        itinerary @include(if: $withRedirectsFromTravelItinerary) {\n          id\n        }\n        programText\n        pricing @include(if: $withRedirectsFromTravelPricing) {\n          id\n          isTravelDocumentationAvailable\n        }\n        minPrice\n        minPriceManualOverride\n        currency\n      }\n      toType\n      toUrl\n      toPage @include(if: $withRedirectsToPage) {\n        id\n        name\n        onlineStatus\n        seoSettings @include(if: $withRedirectsToPageSeoSettings) {\n          id\n          urlSlug\n          metaTitle\n          metaDescription\n          ogTitle\n          ogDescription\n        }\n        contentBlockAssignments @include(if: $withRedirectsToPageContentBlockAssignments) {\n          id\n          type\n        }\n      }\n      toTravel @include(if: $withRedirectsToTravel) {\n        id\n        name\n        isBestseller\n        startDate\n        endDate\n        availabilityStatus @include(if: $withRedirectsToTravelAvailabilityStatus) {\n          id\n          label\n          status\n          isDefaultStatus\n          isDefaultWaitlistFallback\n        }\n        executionStatus\n        travelConsultant @include(if: $withRedirectsToTravelTravelConsultant) {\n          id\n          firstName\n          lastName\n          jobTitle\n          description\n          email\n          phone\n        }\n        label @include(if: $withRedirectsToTravelLabel) {\n          id\n          label\n        }\n        title\n        description\n        includedServices\n        excludedServices\n        pricingTable\n        priceCalculationInfo\n        seoSettings @include(if: $withRedirectsToTravelSeoSettings) {\n          id\n          urlSlug\n          metaTitle\n          metaDescription\n          ogTitle\n          ogDescription\n        }\n        tenantSettings @include(if: $withRedirectsToTravelTenantSettings) {\n          id\n          onlineStatus\n          redirectToBooking\n          useTiming\n          startDate\n          endDate\n        }\n        highlights @include(if: $withRedirectsToTravelHighlights) {\n          id\n          text\n        }\n        partners @include(if: $withRedirectsToTravelPartners) {\n          id\n          name\n          url\n          logoWidth\n        }\n        travelGuides @include(if: $withRedirectsToTravelTravelGuides) {\n          id\n          firstName\n          lastName\n          description\n        }\n        teams @include(if: $withRedirectsToTravelTeams) {\n          id\n          name\n        }\n        accommodationAssignments @include(if: $withRedirectsToTravelAccommodationAssignments) {\n          id\n          useCustomRoomTypeSelection\n        }\n        accommodations @include(if: $withRedirectsToTravelAccommodations) {\n          id\n          label\n          name\n          stars\n          description\n        }\n        destinations @include(if: $withRedirectsToTravelDestinations) {\n          id\n          name\n          entryRequirements\n          medicalInformation\n          language\n          timeShift\n          climate\n          currency\n        }\n        testimonials @include(if: $withRedirectsToTravelTestimonials) {\n          id\n        }\n        mainImage @include(if: $withRedirectsToTravelMainImage) {\n          id\n          assetId\n          publicId\n          url\n          resourceType\n          format\n          width\n          height\n          caption\n          title\n          description\n        }\n        mainVideo @include(if: $withRedirectsToTravelMainVideo) {\n          id\n          assetId\n          publicId\n          url\n          resourceType\n          format\n          width\n          height\n          caption\n          title\n          description\n        }\n        gallery @include(if: $withRedirectsToTravelGallery) {\n          id\n        }\n        travelPdf @include(if: $withRedirectsToTravelTravelPdf) {\n          id\n          assetId\n          publicId\n          url\n          resourceType\n          format\n          width\n          height\n          caption\n          title\n          description\n        }\n        travelExtensions @include(if: $withRedirectsToTravelTravelExtensions) {\n          id\n          duration\n          name\n          description\n        }\n        programType\n        itinerary @include(if: $withRedirectsToTravelItinerary) {\n          id\n        }\n        programText\n        pricing @include(if: $withRedirectsToTravelPricing) {\n          id\n          isTravelDocumentationAvailable\n        }\n        minPrice\n        minPriceManualOverride\n        currency\n      }\n    }\n    onlinePaymentConfig @include(if: $withOnlinePaymentConfig) {\n      id\n      enabled\n      ratioFibuAccountNo\n      infoText\n      datatransThemeConfig\n    }\n    ratioConfig @include(if: $withRatioConfig) {\n      id\n      adressgruppe\n    }\n    content @include(if: $withContent) {\n      id\n      bookingInsuranceInfo\n    }\n    partnerTenants @include(if: $withPartnerTenants) {\n      id\n      tenant @include(if: $withPartnerTenantsTenant) {\n        id\n        name\n        slug\n        domain\n        externalReference\n        cms @include(if: $withPartnerTenantsTenantCms) {\n          id\n        }\n        travelTypes @include(if: $withPartnerTenantsTenantTravelTypes) {\n          id\n          name\n          description\n        }\n        employees @include(if: $withPartnerTenantsTenantEmployees) {\n          id\n          firstName\n          lastName\n          jobTitle\n          description\n          email\n          phone\n        }\n        emailConfig @include(if: $withPartnerTenantsTenantEmailConfig) {\n          id\n          defaultInternalRecipientEmail\n          internalBookingRecipientEmails\n          bookingConfirmationTemplateId\n          bookingConfirmationInternalTemplateId\n          bookingRequestConfirmationTemplateId\n          bookingWaitlistConfirmationTemplateId\n          bookingWaitlistContingentCheckConfirmationTemplateId\n          bookingCustomRequestTemplateId\n          bookingPassportDataReminderTemplateId\n          contactFormTemplateId\n          esimInstallationInfoTemplateId\n        }\n        newsletterProvider @include(if: $withPartnerTenantsTenantNewsletterProvider) {\n          id\n          provider\n        }\n        redirects @include(if: $withPartnerTenantsTenantRedirects) {\n          id\n          fromType\n          fromUrl\n          toType\n          toUrl\n        }\n        onlinePaymentConfig @include(if: $withPartnerTenantsTenantOnlinePaymentConfig) {\n          id\n          enabled\n          ratioFibuAccountNo\n          infoText\n          datatransThemeConfig\n        }\n        ratioConfig @include(if: $withPartnerTenantsTenantRatioConfig) {\n          id\n          adressgruppe\n        }\n        content @include(if: $withPartnerTenantsTenantContent) {\n          id\n          bookingInsuranceInfo\n        }\n        partnerTenants @include(if: $withPartnerTenantsTenantPartnerTenants) {\n          id\n          filterCrossLinking\n        }\n      }\n      filterCrossLinking\n    }\n  }\n}";
// language=GraphQL
var CREATE_TENANT_MUTATION = "\n  mutation Mutation($input: CreateTenantInput, $withCms: Boolean = false, $withCmsHomepage: Boolean = false, $withCmsHomepageSeoSettings: Boolean = false, $withCmsHomepageContentBlockAssignments: Boolean = false, $withCmsCategories: Boolean = false, $withCmsCategoriesPages: Boolean = false, $withCmsCategoriesSeoSettings: Boolean = false, $withCmsPages: Boolean = false, $withCmsPagesSeoSettings: Boolean = false, $withCmsPagesContentBlockAssignments: Boolean = false, $withCmsErrorPage404: Boolean = false, $withCmsErrorPage404SeoSettings: Boolean = false, $withCmsErrorPage404ContentBlockAssignments: Boolean = false, $withCmsErrorPage500: Boolean = false, $withCmsErrorPage500SeoSettings: Boolean = false, $withCmsErrorPage500ContentBlockAssignments: Boolean = false, $withCmsConfig: Boolean = false, $withCmsConfigContactBlockSettings: Boolean = false, $withCmsConfigSocialMediaSettings: Boolean = false, $withCmsConfigPrivacyPolicyPage: Boolean = false, $withCmsConfigGtcPage: Boolean = false, $withTravelTypes: Boolean = false, $withTravelTypesImage: Boolean = false, $withEmployees: Boolean = false, $withEmployeesImage: Boolean = false, $withEmailConfig: Boolean = false, $withNewsletterProvider: Boolean = false, $withNewsletterProviderConfig: Boolean = false, $withRedirects: Boolean = false, $withRedirectsFromPage: Boolean = false, $withRedirectsFromPageSeoSettings: Boolean = false, $withRedirectsFromPageContentBlockAssignments: Boolean = false, $withRedirectsFromTravel: Boolean = false, $withRedirectsFromTravelAvailabilityStatus: Boolean = false, $withRedirectsFromTravelTravelConsultant: Boolean = false, $withRedirectsFromTravelLabel: Boolean = false, $withRedirectsFromTravelSeoSettings: Boolean = false, $withRedirectsFromTravelTenantSettings: Boolean = false, $withRedirectsFromTravelHighlights: Boolean = false, $withRedirectsFromTravelPartners: Boolean = false, $withRedirectsFromTravelTravelGuides: Boolean = false, $withRedirectsFromTravelTeams: Boolean = false, $withRedirectsFromTravelAccommodationAssignments: Boolean = false, $withRedirectsFromTravelAccommodations: Boolean = false, $withRedirectsFromTravelDestinations: Boolean = false, $withRedirectsFromTravelTestimonials: Boolean = false, $withRedirectsFromTravelMainImage: Boolean = false, $withRedirectsFromTravelMainVideo: Boolean = false, $withRedirectsFromTravelGallery: Boolean = false, $withRedirectsFromTravelTravelPdf: Boolean = false, $withRedirectsFromTravelTravelExtensions: Boolean = false, $withRedirectsFromTravelItinerary: Boolean = false, $withRedirectsFromTravelPricing: Boolean = false, $withRedirectsToPage: Boolean = false, $withRedirectsToPageSeoSettings: Boolean = false, $withRedirectsToPageContentBlockAssignments: Boolean = false, $withRedirectsToTravel: Boolean = false, $withRedirectsToTravelAvailabilityStatus: Boolean = false, $withRedirectsToTravelTravelConsultant: Boolean = false, $withRedirectsToTravelLabel: Boolean = false, $withRedirectsToTravelSeoSettings: Boolean = false, $withRedirectsToTravelTenantSettings: Boolean = false, $withRedirectsToTravelHighlights: Boolean = false, $withRedirectsToTravelPartners: Boolean = false, $withRedirectsToTravelTravelGuides: Boolean = false, $withRedirectsToTravelTeams: Boolean = false, $withRedirectsToTravelAccommodationAssignments: Boolean = false, $withRedirectsToTravelAccommodations: Boolean = false, $withRedirectsToTravelDestinations: Boolean = false, $withRedirectsToTravelTestimonials: Boolean = false, $withRedirectsToTravelMainImage: Boolean = false, $withRedirectsToTravelMainVideo: Boolean = false, $withRedirectsToTravelGallery: Boolean = false, $withRedirectsToTravelTravelPdf: Boolean = false, $withRedirectsToTravelTravelExtensions: Boolean = false, $withRedirectsToTravelItinerary: Boolean = false, $withRedirectsToTravelPricing: Boolean = false, $withOnlinePaymentConfig: Boolean = false, $withRatioConfig: Boolean = false, $withContent: Boolean = false, $withPartnerTenants: Boolean = false, $withPartnerTenantsTenant: Boolean = false, $withPartnerTenantsTenantCms: Boolean = false, $withPartnerTenantsTenantTravelTypes: Boolean = false, $withPartnerTenantsTenantEmployees: Boolean = false, $withPartnerTenantsTenantEmailConfig: Boolean = false, $withPartnerTenantsTenantNewsletterProvider: Boolean = false, $withPartnerTenantsTenantRedirects: Boolean = false, $withPartnerTenantsTenantOnlinePaymentConfig: Boolean = false, $withPartnerTenantsTenantRatioConfig: Boolean = false, $withPartnerTenantsTenantContent: Boolean = false, $withPartnerTenantsTenantPartnerTenants: Boolean = false) {\n    tenant: createTenant(input: $input) {\n      id\n      name\n      slug\n      domain\n      externalReference\n      cms @include(if: $withCms) {\n        id\n        homepage @include(if: $withCmsHomepage) {\n          id\n          name\n          onlineStatus\n          seoSettings @include(if: $withCmsHomepageSeoSettings) {\n            id\n            urlSlug\n            metaTitle\n            metaDescription\n            ogTitle\n            ogDescription\n          }\n          contentBlockAssignments @include(if: $withCmsHomepageContentBlockAssignments) {\n            id\n            type\n          }\n        }\n        categories @include(if: $withCmsCategories) {\n          id\n          name\n          pages @include(if: $withCmsCategoriesPages) {\n            id\n            name\n            onlineStatus\n          }\n          seoSettings @include(if: $withCmsCategoriesSeoSettings) {\n            id\n            urlSlug\n            metaTitle\n            metaDescription\n            ogTitle\n            ogDescription\n          }\n        }\n        pages @include(if: $withCmsPages) {\n          id\n          name\n          onlineStatus\n          seoSettings @include(if: $withCmsPagesSeoSettings) {\n            id\n            urlSlug\n            metaTitle\n            metaDescription\n            ogTitle\n            ogDescription\n          }\n          contentBlockAssignments @include(if: $withCmsPagesContentBlockAssignments) {\n            id\n            type\n          }\n        }\n        errorPage404 @include(if: $withCmsErrorPage404) {\n          id\n          name\n          onlineStatus\n          seoSettings @include(if: $withCmsErrorPage404SeoSettings) {\n            id\n            urlSlug\n            metaTitle\n            metaDescription\n            ogTitle\n            ogDescription\n          }\n          contentBlockAssignments @include(if: $withCmsErrorPage404ContentBlockAssignments) {\n            id\n            type\n          }\n        }\n        errorPage500 @include(if: $withCmsErrorPage500) {\n          id\n          name\n          onlineStatus\n          seoSettings @include(if: $withCmsErrorPage500SeoSettings) {\n            id\n            urlSlug\n            metaTitle\n            metaDescription\n            ogTitle\n            ogDescription\n          }\n          contentBlockAssignments @include(if: $withCmsErrorPage500ContentBlockAssignments) {\n            id\n            type\n          }\n        }\n        config @include(if: $withCmsConfig) {\n          id\n          contactBlockSettings @include(if: $withCmsConfigContactBlockSettings) {\n            id\n            slogan\n            title\n            text\n            phonePrefix\n            phone\n            phone2Prefix\n            phone2\n            openingHours1\n            openingHours2\n            email\n          }\n          socialMediaSettings @include(if: $withCmsConfigSocialMediaSettings) {\n            id\n            facebookUrl\n            instagramUrl\n          }\n          privacyPolicyPage @include(if: $withCmsConfigPrivacyPolicyPage) {\n            id\n            name\n            onlineStatus\n          }\n          gtcPage @include(if: $withCmsConfigGtcPage) {\n            id\n            name\n            onlineStatus\n          }\n        }\n      }\n      travelTypes @include(if: $withTravelTypes) {\n        id\n        name\n        description\n        image @include(if: $withTravelTypesImage) {\n          id\n          assetId\n          publicId\n          url\n          resourceType\n          format\n          width\n          height\n          caption\n          title\n          description\n        }\n      }\n      employees @include(if: $withEmployees) {\n        id\n        firstName\n        lastName\n        jobTitle\n        description\n        email\n        image @include(if: $withEmployeesImage) {\n          id\n          assetId\n          publicId\n          url\n          resourceType\n          format\n          width\n          height\n          caption\n          title\n          description\n        }\n        phone\n      }\n      emailConfig @include(if: $withEmailConfig) {\n        id\n        defaultInternalRecipientEmail\n        internalBookingRecipientEmails\n        bookingConfirmationTemplateId\n        bookingConfirmationInternalTemplateId\n        bookingRequestConfirmationTemplateId\n        bookingWaitlistConfirmationTemplateId\n        bookingWaitlistContingentCheckConfirmationTemplateId\n        bookingCustomRequestTemplateId\n        bookingPassportDataReminderTemplateId\n        contactFormTemplateId\n        esimInstallationInfoTemplateId\n      }\n      newsletterProvider @include(if: $withNewsletterProvider) {\n        id\n        provider\n        config @include(if: $withNewsletterProviderConfig) {\n          __typename\n          ... on MailchimpConfig {\n            id\n            apiKey\n            serverPrefix\n            listId\n\n          }\n        }\n      }\n      redirects @include(if: $withRedirects) {\n        id\n        fromType\n        fromUrl\n        fromPage @include(if: $withRedirectsFromPage) {\n          id\n          name\n          onlineStatus\n          seoSettings @include(if: $withRedirectsFromPageSeoSettings) {\n            id\n            urlSlug\n            metaTitle\n            metaDescription\n            ogTitle\n            ogDescription\n          }\n          contentBlockAssignments @include(if: $withRedirectsFromPageContentBlockAssignments) {\n            id\n            type\n          }\n        }\n        fromTravel @include(if: $withRedirectsFromTravel) {\n          id\n          name\n          isBestseller\n          startDate\n          endDate\n          availabilityStatus @include(if: $withRedirectsFromTravelAvailabilityStatus) {\n            id\n            label\n            status\n            isDefaultStatus\n            isDefaultWaitlistFallback\n          }\n          executionStatus\n          travelConsultant @include(if: $withRedirectsFromTravelTravelConsultant) {\n            id\n            firstName\n            lastName\n            jobTitle\n            description\n            email\n            phone\n          }\n          label @include(if: $withRedirectsFromTravelLabel) {\n            id\n            label\n          }\n          title\n          description\n          includedServices\n          excludedServices\n          pricingTable\n          priceCalculationInfo\n          seoSettings @include(if: $withRedirectsFromTravelSeoSettings) {\n            id\n            urlSlug\n            metaTitle\n            metaDescription\n            ogTitle\n            ogDescription\n          }\n          tenantSettings @include(if: $withRedirectsFromTravelTenantSettings) {\n            id\n            onlineStatus\n            redirectToBooking\n            useTiming\n            startDate\n            endDate\n          }\n          highlights @include(if: $withRedirectsFromTravelHighlights) {\n            id\n            text\n          }\n          partners @include(if: $withRedirectsFromTravelPartners) {\n            id\n            name\n            url\n            logoWidth\n          }\n          travelGuides @include(if: $withRedirectsFromTravelTravelGuides) {\n            id\n            firstName\n            lastName\n            description\n          }\n          teams @include(if: $withRedirectsFromTravelTeams) {\n            id\n            name\n          }\n          accommodationAssignments @include(if: $withRedirectsFromTravelAccommodationAssignments) {\n            id\n            useCustomRoomTypeSelection\n          }\n          accommodations @include(if: $withRedirectsFromTravelAccommodations) {\n            id\n            label\n            name\n            stars\n            description\n          }\n          destinations @include(if: $withRedirectsFromTravelDestinations) {\n            id\n            name\n            entryRequirements\n            medicalInformation\n            language\n            timeShift\n            climate\n            currency\n          }\n          testimonials @include(if: $withRedirectsFromTravelTestimonials) {\n            id\n          }\n          mainImage @include(if: $withRedirectsFromTravelMainImage) {\n            id\n            assetId\n            publicId\n            url\n            resourceType\n            format\n            width\n            height\n            caption\n            title\n            description\n          }\n          mainVideo @include(if: $withRedirectsFromTravelMainVideo) {\n            id\n            assetId\n            publicId\n            url\n            resourceType\n            format\n            width\n            height\n            caption\n            title\n            description\n          }\n          gallery @include(if: $withRedirectsFromTravelGallery) {\n            id\n          }\n          travelPdf @include(if: $withRedirectsFromTravelTravelPdf) {\n            id\n            assetId\n            publicId\n            url\n            resourceType\n            format\n            width\n            height\n            caption\n            title\n            description\n          }\n          travelExtensions @include(if: $withRedirectsFromTravelTravelExtensions) {\n            id\n            duration\n            name\n            description\n          }\n          programType\n          itinerary @include(if: $withRedirectsFromTravelItinerary) {\n            id\n          }\n          programText\n          pricing @include(if: $withRedirectsFromTravelPricing) {\n            id\n            isTravelDocumentationAvailable\n          }\n          minPrice\n          minPriceManualOverride\n          currency\n        }\n        toType\n        toUrl\n        toPage @include(if: $withRedirectsToPage) {\n          id\n          name\n          onlineStatus\n          seoSettings @include(if: $withRedirectsToPageSeoSettings) {\n            id\n            urlSlug\n            metaTitle\n            metaDescription\n            ogTitle\n            ogDescription\n          }\n          contentBlockAssignments @include(if: $withRedirectsToPageContentBlockAssignments) {\n            id\n            type\n          }\n        }\n        toTravel @include(if: $withRedirectsToTravel) {\n          id\n          name\n          isBestseller\n          startDate\n          endDate\n          availabilityStatus @include(if: $withRedirectsToTravelAvailabilityStatus) {\n            id\n            label\n            status\n            isDefaultStatus\n            isDefaultWaitlistFallback\n          }\n          executionStatus\n          travelConsultant @include(if: $withRedirectsToTravelTravelConsultant) {\n            id\n            firstName\n            lastName\n            jobTitle\n            description\n            email\n            phone\n          }\n          label @include(if: $withRedirectsToTravelLabel) {\n            id\n            label\n          }\n          title\n          description\n          includedServices\n          excludedServices\n          pricingTable\n          priceCalculationInfo\n          seoSettings @include(if: $withRedirectsToTravelSeoSettings) {\n            id\n            urlSlug\n            metaTitle\n            metaDescription\n            ogTitle\n            ogDescription\n          }\n          tenantSettings @include(if: $withRedirectsToTravelTenantSettings) {\n            id\n            onlineStatus\n            redirectToBooking\n            useTiming\n            startDate\n            endDate\n          }\n          highlights @include(if: $withRedirectsToTravelHighlights) {\n            id\n            text\n          }\n          partners @include(if: $withRedirectsToTravelPartners) {\n            id\n            name\n            url\n            logoWidth\n          }\n          travelGuides @include(if: $withRedirectsToTravelTravelGuides) {\n            id\n            firstName\n            lastName\n            description\n          }\n          teams @include(if: $withRedirectsToTravelTeams) {\n            id\n            name\n          }\n          accommodationAssignments @include(if: $withRedirectsToTravelAccommodationAssignments) {\n            id\n            useCustomRoomTypeSelection\n          }\n          accommodations @include(if: $withRedirectsToTravelAccommodations) {\n            id\n            label\n            name\n            stars\n            description\n          }\n          destinations @include(if: $withRedirectsToTravelDestinations) {\n            id\n            name\n            entryRequirements\n            medicalInformation\n            language\n            timeShift\n            climate\n            currency\n          }\n          testimonials @include(if: $withRedirectsToTravelTestimonials) {\n            id\n          }\n          mainImage @include(if: $withRedirectsToTravelMainImage) {\n            id\n            assetId\n            publicId\n            url\n            resourceType\n            format\n            width\n            height\n            caption\n            title\n            description\n          }\n          mainVideo @include(if: $withRedirectsToTravelMainVideo) {\n            id\n            assetId\n            publicId\n            url\n            resourceType\n            format\n            width\n            height\n            caption\n            title\n            description\n          }\n          gallery @include(if: $withRedirectsToTravelGallery) {\n            id\n          }\n          travelPdf @include(if: $withRedirectsToTravelTravelPdf) {\n            id\n            assetId\n            publicId\n            url\n            resourceType\n            format\n            width\n            height\n            caption\n            title\n            description\n          }\n          travelExtensions @include(if: $withRedirectsToTravelTravelExtensions) {\n            id\n            duration\n            name\n            description\n          }\n          programType\n          itinerary @include(if: $withRedirectsToTravelItinerary) {\n            id\n          }\n          programText\n          pricing @include(if: $withRedirectsToTravelPricing) {\n            id\n            isTravelDocumentationAvailable\n          }\n          minPrice\n          minPriceManualOverride\n          currency\n        }\n      }\n      onlinePaymentConfig @include(if: $withOnlinePaymentConfig) {\n        id\n        enabled\n        ratioFibuAccountNo\n        infoText\n        datatransThemeConfig\n      }\n      ratioConfig @include(if: $withRatioConfig) {\n        id\n        adressgruppe\n      }\n      content @include(if: $withContent) {\n        id\n        bookingInsuranceInfo\n      }\n      partnerTenants @include(if: $withPartnerTenants) {\n        id\n        tenant @include(if: $withPartnerTenantsTenant) {\n          id\n          name\n          slug\n          domain\n          externalReference\n          cms @include(if: $withPartnerTenantsTenantCms) {\n            id\n          }\n          travelTypes @include(if: $withPartnerTenantsTenantTravelTypes) {\n            id\n            name\n            description\n          }\n          employees @include(if: $withPartnerTenantsTenantEmployees) {\n            id\n            firstName\n            lastName\n            jobTitle\n            description\n            email\n            phone\n          }\n          emailConfig @include(if: $withPartnerTenantsTenantEmailConfig) {\n            id\n            defaultInternalRecipientEmail\n            internalBookingRecipientEmails\n            bookingConfirmationTemplateId\n            bookingConfirmationInternalTemplateId\n            bookingRequestConfirmationTemplateId\n            bookingWaitlistConfirmationTemplateId\n            bookingWaitlistContingentCheckConfirmationTemplateId\n            bookingCustomRequestTemplateId\n            bookingPassportDataReminderTemplateId\n            contactFormTemplateId\n            esimInstallationInfoTemplateId\n          }\n          newsletterProvider @include(if: $withPartnerTenantsTenantNewsletterProvider) {\n            id\n            provider\n          }\n          redirects @include(if: $withPartnerTenantsTenantRedirects) {\n            id\n            fromType\n            fromUrl\n            toType\n            toUrl\n          }\n          onlinePaymentConfig @include(if: $withPartnerTenantsTenantOnlinePaymentConfig) {\n            id\n            enabled\n            ratioFibuAccountNo\n            infoText\n            datatransThemeConfig\n          }\n          ratioConfig @include(if: $withPartnerTenantsTenantRatioConfig) {\n            id\n            adressgruppe\n          }\n          content @include(if: $withPartnerTenantsTenantContent) {\n            id\n            bookingInsuranceInfo\n          }\n          partnerTenants @include(if: $withPartnerTenantsTenantPartnerTenants) {\n            id\n            filterCrossLinking\n          }\n        }\n        filterCrossLinking\n      }\n    }\n  }";
// language=GraphQL
var UPDATE_TENANT_MUTATION = "\n  mutation Mutation($input: UpdateTenantInput, $withCms: Boolean = false, $withCmsHomepage: Boolean = false, $withCmsHomepageSeoSettings: Boolean = false, $withCmsHomepageContentBlockAssignments: Boolean = false, $withCmsCategories: Boolean = false, $withCmsCategoriesPages: Boolean = false, $withCmsCategoriesSeoSettings: Boolean = false, $withCmsPages: Boolean = false, $withCmsPagesSeoSettings: Boolean = false, $withCmsPagesContentBlockAssignments: Boolean = false, $withCmsErrorPage404: Boolean = false, $withCmsErrorPage404SeoSettings: Boolean = false, $withCmsErrorPage404ContentBlockAssignments: Boolean = false, $withCmsErrorPage500: Boolean = false, $withCmsErrorPage500SeoSettings: Boolean = false, $withCmsErrorPage500ContentBlockAssignments: Boolean = false, $withCmsConfig: Boolean = false, $withCmsConfigContactBlockSettings: Boolean = false, $withCmsConfigSocialMediaSettings: Boolean = false, $withCmsConfigPrivacyPolicyPage: Boolean = false, $withCmsConfigGtcPage: Boolean = false, $withTravelTypes: Boolean = false, $withTravelTypesImage: Boolean = false, $withEmployees: Boolean = false, $withEmployeesImage: Boolean = false, $withEmailConfig: Boolean = false, $withNewsletterProvider: Boolean = false, $withNewsletterProviderConfig: Boolean = false, $withRedirects: Boolean = false, $withRedirectsFromPage: Boolean = false, $withRedirectsFromPageSeoSettings: Boolean = false, $withRedirectsFromPageContentBlockAssignments: Boolean = false, $withRedirectsFromTravel: Boolean = false, $withRedirectsFromTravelAvailabilityStatus: Boolean = false, $withRedirectsFromTravelTravelConsultant: Boolean = false, $withRedirectsFromTravelLabel: Boolean = false, $withRedirectsFromTravelSeoSettings: Boolean = false, $withRedirectsFromTravelTenantSettings: Boolean = false, $withRedirectsFromTravelHighlights: Boolean = false, $withRedirectsFromTravelPartners: Boolean = false, $withRedirectsFromTravelTravelGuides: Boolean = false, $withRedirectsFromTravelTeams: Boolean = false, $withRedirectsFromTravelAccommodationAssignments: Boolean = false, $withRedirectsFromTravelAccommodations: Boolean = false, $withRedirectsFromTravelDestinations: Boolean = false, $withRedirectsFromTravelTestimonials: Boolean = false, $withRedirectsFromTravelMainImage: Boolean = false, $withRedirectsFromTravelMainVideo: Boolean = false, $withRedirectsFromTravelGallery: Boolean = false, $withRedirectsFromTravelTravelPdf: Boolean = false, $withRedirectsFromTravelTravelExtensions: Boolean = false, $withRedirectsFromTravelItinerary: Boolean = false, $withRedirectsFromTravelPricing: Boolean = false, $withRedirectsToPage: Boolean = false, $withRedirectsToPageSeoSettings: Boolean = false, $withRedirectsToPageContentBlockAssignments: Boolean = false, $withRedirectsToTravel: Boolean = false, $withRedirectsToTravelAvailabilityStatus: Boolean = false, $withRedirectsToTravelTravelConsultant: Boolean = false, $withRedirectsToTravelLabel: Boolean = false, $withRedirectsToTravelSeoSettings: Boolean = false, $withRedirectsToTravelTenantSettings: Boolean = false, $withRedirectsToTravelHighlights: Boolean = false, $withRedirectsToTravelPartners: Boolean = false, $withRedirectsToTravelTravelGuides: Boolean = false, $withRedirectsToTravelTeams: Boolean = false, $withRedirectsToTravelAccommodationAssignments: Boolean = false, $withRedirectsToTravelAccommodations: Boolean = false, $withRedirectsToTravelDestinations: Boolean = false, $withRedirectsToTravelTestimonials: Boolean = false, $withRedirectsToTravelMainImage: Boolean = false, $withRedirectsToTravelMainVideo: Boolean = false, $withRedirectsToTravelGallery: Boolean = false, $withRedirectsToTravelTravelPdf: Boolean = false, $withRedirectsToTravelTravelExtensions: Boolean = false, $withRedirectsToTravelItinerary: Boolean = false, $withRedirectsToTravelPricing: Boolean = false, $withOnlinePaymentConfig: Boolean = false, $withRatioConfig: Boolean = false, $withContent: Boolean = false, $withPartnerTenants: Boolean = false, $withPartnerTenantsTenant: Boolean = false, $withPartnerTenantsTenantCms: Boolean = false, $withPartnerTenantsTenantTravelTypes: Boolean = false, $withPartnerTenantsTenantEmployees: Boolean = false, $withPartnerTenantsTenantEmailConfig: Boolean = false, $withPartnerTenantsTenantNewsletterProvider: Boolean = false, $withPartnerTenantsTenantRedirects: Boolean = false, $withPartnerTenantsTenantOnlinePaymentConfig: Boolean = false, $withPartnerTenantsTenantRatioConfig: Boolean = false, $withPartnerTenantsTenantContent: Boolean = false, $withPartnerTenantsTenantPartnerTenants: Boolean = false) {\n    tenant: updateTenant(input: $input) {\n      id\n      name\n      slug\n      domain\n      externalReference\n      cms @include(if: $withCms) {\n        id\n        homepage @include(if: $withCmsHomepage) {\n          id\n          name\n          onlineStatus\n          seoSettings @include(if: $withCmsHomepageSeoSettings) {\n            id\n            urlSlug\n            metaTitle\n            metaDescription\n            ogTitle\n            ogDescription\n          }\n          contentBlockAssignments @include(if: $withCmsHomepageContentBlockAssignments) {\n            id\n            type\n          }\n        }\n        categories @include(if: $withCmsCategories) {\n          id\n          name\n          pages @include(if: $withCmsCategoriesPages) {\n            id\n            name\n            onlineStatus\n          }\n          seoSettings @include(if: $withCmsCategoriesSeoSettings) {\n            id\n            urlSlug\n            metaTitle\n            metaDescription\n            ogTitle\n            ogDescription\n          }\n        }\n        pages @include(if: $withCmsPages) {\n          id\n          name\n          onlineStatus\n          seoSettings @include(if: $withCmsPagesSeoSettings) {\n            id\n            urlSlug\n            metaTitle\n            metaDescription\n            ogTitle\n            ogDescription\n          }\n          contentBlockAssignments @include(if: $withCmsPagesContentBlockAssignments) {\n            id\n            type\n          }\n        }\n        errorPage404 @include(if: $withCmsErrorPage404) {\n          id\n          name\n          onlineStatus\n          seoSettings @include(if: $withCmsErrorPage404SeoSettings) {\n            id\n            urlSlug\n            metaTitle\n            metaDescription\n            ogTitle\n            ogDescription\n          }\n          contentBlockAssignments @include(if: $withCmsErrorPage404ContentBlockAssignments) {\n            id\n            type\n          }\n        }\n        errorPage500 @include(if: $withCmsErrorPage500) {\n          id\n          name\n          onlineStatus\n          seoSettings @include(if: $withCmsErrorPage500SeoSettings) {\n            id\n            urlSlug\n            metaTitle\n            metaDescription\n            ogTitle\n            ogDescription\n          }\n          contentBlockAssignments @include(if: $withCmsErrorPage500ContentBlockAssignments) {\n            id\n            type\n          }\n        }\n        config @include(if: $withCmsConfig) {\n          id\n          contactBlockSettings @include(if: $withCmsConfigContactBlockSettings) {\n            id\n            slogan\n            title\n            text\n            phonePrefix\n            phone\n            phone2Prefix\n            phone2\n            openingHours1\n            openingHours2\n            email\n          }\n          socialMediaSettings @include(if: $withCmsConfigSocialMediaSettings) {\n            id\n            facebookUrl\n            instagramUrl\n          }\n          privacyPolicyPage @include(if: $withCmsConfigPrivacyPolicyPage) {\n            id\n            name\n            onlineStatus\n          }\n          gtcPage @include(if: $withCmsConfigGtcPage) {\n            id\n            name\n            onlineStatus\n          }\n        }\n      }\n      travelTypes @include(if: $withTravelTypes) {\n        id\n        name\n        description\n        image @include(if: $withTravelTypesImage) {\n          id\n          assetId\n          publicId\n          url\n          resourceType\n          format\n          width\n          height\n          caption\n          title\n          description\n        }\n      }\n      employees @include(if: $withEmployees) {\n        id\n        firstName\n        lastName\n        jobTitle\n        description\n        email\n        image @include(if: $withEmployeesImage) {\n          id\n          assetId\n          publicId\n          url\n          resourceType\n          format\n          width\n          height\n          caption\n          title\n          description\n        }\n        phone\n      }\n      emailConfig @include(if: $withEmailConfig) {\n        id\n        defaultInternalRecipientEmail\n        internalBookingRecipientEmails\n        bookingConfirmationTemplateId\n        bookingConfirmationInternalTemplateId\n        bookingRequestConfirmationTemplateId\n        bookingWaitlistConfirmationTemplateId\n        bookingWaitlistContingentCheckConfirmationTemplateId\n        bookingCustomRequestTemplateId\n        bookingPassportDataReminderTemplateId\n        contactFormTemplateId\n        esimInstallationInfoTemplateId\n      }\n      newsletterProvider @include(if: $withNewsletterProvider) {\n        id\n        provider\n        config @include(if: $withNewsletterProviderConfig) {\n          __typename\n          ... on MailchimpConfig {\n            id\n            apiKey\n            serverPrefix\n            listId\n\n          }\n        }\n      }\n      redirects @include(if: $withRedirects) {\n        id\n        fromType\n        fromUrl\n        fromPage @include(if: $withRedirectsFromPage) {\n          id\n          name\n          onlineStatus\n          seoSettings @include(if: $withRedirectsFromPageSeoSettings) {\n            id\n            urlSlug\n            metaTitle\n            metaDescription\n            ogTitle\n            ogDescription\n          }\n          contentBlockAssignments @include(if: $withRedirectsFromPageContentBlockAssignments) {\n            id\n            type\n          }\n        }\n        fromTravel @include(if: $withRedirectsFromTravel) {\n          id\n          name\n          isBestseller\n          startDate\n          endDate\n          availabilityStatus @include(if: $withRedirectsFromTravelAvailabilityStatus) {\n            id\n            label\n            status\n            isDefaultStatus\n            isDefaultWaitlistFallback\n          }\n          executionStatus\n          travelConsultant @include(if: $withRedirectsFromTravelTravelConsultant) {\n            id\n            firstName\n            lastName\n            jobTitle\n            description\n            email\n            phone\n          }\n          label @include(if: $withRedirectsFromTravelLabel) {\n            id\n            label\n          }\n          title\n          description\n          includedServices\n          excludedServices\n          pricingTable\n          priceCalculationInfo\n          seoSettings @include(if: $withRedirectsFromTravelSeoSettings) {\n            id\n            urlSlug\n            metaTitle\n            metaDescription\n            ogTitle\n            ogDescription\n          }\n          tenantSettings @include(if: $withRedirectsFromTravelTenantSettings) {\n            id\n            onlineStatus\n            redirectToBooking\n            useTiming\n            startDate\n            endDate\n          }\n          highlights @include(if: $withRedirectsFromTravelHighlights) {\n            id\n            text\n          }\n          partners @include(if: $withRedirectsFromTravelPartners) {\n            id\n            name\n            url\n            logoWidth\n          }\n          travelGuides @include(if: $withRedirectsFromTravelTravelGuides) {\n            id\n            firstName\n            lastName\n            description\n          }\n          teams @include(if: $withRedirectsFromTravelTeams) {\n            id\n            name\n          }\n          accommodationAssignments @include(if: $withRedirectsFromTravelAccommodationAssignments) {\n            id\n            useCustomRoomTypeSelection\n          }\n          accommodations @include(if: $withRedirectsFromTravelAccommodations) {\n            id\n            label\n            name\n            stars\n            description\n          }\n          destinations @include(if: $withRedirectsFromTravelDestinations) {\n            id\n            name\n            entryRequirements\n            medicalInformation\n            language\n            timeShift\n            climate\n            currency\n          }\n          testimonials @include(if: $withRedirectsFromTravelTestimonials) {\n            id\n          }\n          mainImage @include(if: $withRedirectsFromTravelMainImage) {\n            id\n            assetId\n            publicId\n            url\n            resourceType\n            format\n            width\n            height\n            caption\n            title\n            description\n          }\n          mainVideo @include(if: $withRedirectsFromTravelMainVideo) {\n            id\n            assetId\n            publicId\n            url\n            resourceType\n            format\n            width\n            height\n            caption\n            title\n            description\n          }\n          gallery @include(if: $withRedirectsFromTravelGallery) {\n            id\n          }\n          travelPdf @include(if: $withRedirectsFromTravelTravelPdf) {\n            id\n            assetId\n            publicId\n            url\n            resourceType\n            format\n            width\n            height\n            caption\n            title\n            description\n          }\n          travelExtensions @include(if: $withRedirectsFromTravelTravelExtensions) {\n            id\n            duration\n            name\n            description\n          }\n          programType\n          itinerary @include(if: $withRedirectsFromTravelItinerary) {\n            id\n          }\n          programText\n          pricing @include(if: $withRedirectsFromTravelPricing) {\n            id\n            isTravelDocumentationAvailable\n          }\n          minPrice\n          minPriceManualOverride\n          currency\n        }\n        toType\n        toUrl\n        toPage @include(if: $withRedirectsToPage) {\n          id\n          name\n          onlineStatus\n          seoSettings @include(if: $withRedirectsToPageSeoSettings) {\n            id\n            urlSlug\n            metaTitle\n            metaDescription\n            ogTitle\n            ogDescription\n          }\n          contentBlockAssignments @include(if: $withRedirectsToPageContentBlockAssignments) {\n            id\n            type\n          }\n        }\n        toTravel @include(if: $withRedirectsToTravel) {\n          id\n          name\n          isBestseller\n          startDate\n          endDate\n          availabilityStatus @include(if: $withRedirectsToTravelAvailabilityStatus) {\n            id\n            label\n            status\n            isDefaultStatus\n            isDefaultWaitlistFallback\n          }\n          executionStatus\n          travelConsultant @include(if: $withRedirectsToTravelTravelConsultant) {\n            id\n            firstName\n            lastName\n            jobTitle\n            description\n            email\n            phone\n          }\n          label @include(if: $withRedirectsToTravelLabel) {\n            id\n            label\n          }\n          title\n          description\n          includedServices\n          excludedServices\n          pricingTable\n          priceCalculationInfo\n          seoSettings @include(if: $withRedirectsToTravelSeoSettings) {\n            id\n            urlSlug\n            metaTitle\n            metaDescription\n            ogTitle\n            ogDescription\n          }\n          tenantSettings @include(if: $withRedirectsToTravelTenantSettings) {\n            id\n            onlineStatus\n            redirectToBooking\n            useTiming\n            startDate\n            endDate\n          }\n          highlights @include(if: $withRedirectsToTravelHighlights) {\n            id\n            text\n          }\n          partners @include(if: $withRedirectsToTravelPartners) {\n            id\n            name\n            url\n            logoWidth\n          }\n          travelGuides @include(if: $withRedirectsToTravelTravelGuides) {\n            id\n            firstName\n            lastName\n            description\n          }\n          teams @include(if: $withRedirectsToTravelTeams) {\n            id\n            name\n          }\n          accommodationAssignments @include(if: $withRedirectsToTravelAccommodationAssignments) {\n            id\n            useCustomRoomTypeSelection\n          }\n          accommodations @include(if: $withRedirectsToTravelAccommodations) {\n            id\n            label\n            name\n            stars\n            description\n          }\n          destinations @include(if: $withRedirectsToTravelDestinations) {\n            id\n            name\n            entryRequirements\n            medicalInformation\n            language\n            timeShift\n            climate\n            currency\n          }\n          testimonials @include(if: $withRedirectsToTravelTestimonials) {\n            id\n          }\n          mainImage @include(if: $withRedirectsToTravelMainImage) {\n            id\n            assetId\n            publicId\n            url\n            resourceType\n            format\n            width\n            height\n            caption\n            title\n            description\n          }\n          mainVideo @include(if: $withRedirectsToTravelMainVideo) {\n            id\n            assetId\n            publicId\n            url\n            resourceType\n            format\n            width\n            height\n            caption\n            title\n            description\n          }\n          gallery @include(if: $withRedirectsToTravelGallery) {\n            id\n          }\n          travelPdf @include(if: $withRedirectsToTravelTravelPdf) {\n            id\n            assetId\n            publicId\n            url\n            resourceType\n            format\n            width\n            height\n            caption\n            title\n            description\n          }\n          travelExtensions @include(if: $withRedirectsToTravelTravelExtensions) {\n            id\n            duration\n            name\n            description\n          }\n          programType\n          itinerary @include(if: $withRedirectsToTravelItinerary) {\n            id\n          }\n          programText\n          pricing @include(if: $withRedirectsToTravelPricing) {\n            id\n            isTravelDocumentationAvailable\n          }\n          minPrice\n          minPriceManualOverride\n          currency\n        }\n      }\n      onlinePaymentConfig @include(if: $withOnlinePaymentConfig) {\n        id\n        enabled\n        ratioFibuAccountNo\n        infoText\n        datatransThemeConfig\n      }\n      ratioConfig @include(if: $withRatioConfig) {\n        id\n        adressgruppe\n      }\n      content @include(if: $withContent) {\n        id\n        bookingInsuranceInfo\n      }\n      partnerTenants @include(if: $withPartnerTenants) {\n        id\n        tenant @include(if: $withPartnerTenantsTenant) {\n          id\n          name\n          slug\n          domain\n          externalReference\n          cms @include(if: $withPartnerTenantsTenantCms) {\n            id\n          }\n          travelTypes @include(if: $withPartnerTenantsTenantTravelTypes) {\n            id\n            name\n            description\n          }\n          employees @include(if: $withPartnerTenantsTenantEmployees) {\n            id\n            firstName\n            lastName\n            jobTitle\n            description\n            email\n            phone\n          }\n          emailConfig @include(if: $withPartnerTenantsTenantEmailConfig) {\n            id\n            defaultInternalRecipientEmail\n            internalBookingRecipientEmails\n            bookingConfirmationTemplateId\n            bookingConfirmationInternalTemplateId\n            bookingRequestConfirmationTemplateId\n            bookingWaitlistConfirmationTemplateId\n            bookingWaitlistContingentCheckConfirmationTemplateId\n            bookingCustomRequestTemplateId\n            bookingPassportDataReminderTemplateId\n            contactFormTemplateId\n            esimInstallationInfoTemplateId\n          }\n          newsletterProvider @include(if: $withPartnerTenantsTenantNewsletterProvider) {\n            id\n            provider\n          }\n          redirects @include(if: $withPartnerTenantsTenantRedirects) {\n            id\n            fromType\n            fromUrl\n            toType\n            toUrl\n          }\n          onlinePaymentConfig @include(if: $withPartnerTenantsTenantOnlinePaymentConfig) {\n            id\n            enabled\n            ratioFibuAccountNo\n            infoText\n            datatransThemeConfig\n          }\n          ratioConfig @include(if: $withPartnerTenantsTenantRatioConfig) {\n            id\n            adressgruppe\n          }\n          content @include(if: $withPartnerTenantsTenantContent) {\n            id\n            bookingInsuranceInfo\n          }\n          partnerTenants @include(if: $withPartnerTenantsTenantPartnerTenants) {\n            id\n            filterCrossLinking\n          }\n        }\n        filterCrossLinking\n      }\n    }\n  }";
// language=GraphQL
var DELETE_TENANT_MUTATION = "\n  mutation Mutation($input: DeleteTenantInput) {\n    deleteTenant(input: $input) {\n      success\n    }\n  }";
// language=GraphQL
var FORCE_DELETE_TENANT_MUTATION = "\n  mutation Mutation($input: DeleteTenantInput) {\n    forceDeleteTenant(input: $input) {\n      success\n    }\n  }";
// language=GraphQL
var ADD_TENANT_TRAVEL_TYPES_MUTATION = "\n  mutation Mutation($input: addTenantTravelTypesInput) {\n    addTenantTravelTypes(input: $input) {\n      id\n      travelTypeIds\n    }\n  }";
// language=GraphQL
var REMOVE_TENANT_TRAVEL_TYPES_MUTATION = "\n  mutation Mutation($input: removeTenantTravelTypesInput) {\n    removeTenantTravelTypes(input: $input) {\n      id\n      travelTypeIds\n    }\n  }";
// language=GraphQL
var CREATE_TENANT_TRAVEL_TYPES_MUTATION = "\n  mutation Mutation($input: createTenantTravelTypesInput) {\n    createTenantTravelTypes(input: $input) {\n      id\n      travelTypeIds\n    }\n  }";
// language=GraphQL
var DELETE_TENANT_TRAVEL_TYPES_MUTATION = "\n  mutation Mutation($input: deleteTenantTravelTypesInput) {\n    deleteTenantTravelTypes(input: $input) {\n      id\n      travelTypeIds\n    }\n  }";
// language=GraphQL
var UPDATE_TENANT_TRAVEL_TYPES_ORDER_MUTATION = "\n  mutation Mutation($input: updateTenantTravelTypesOrderInput) {\n    updateTenantTravelTypesOrder(input: $input) {\n      id\n      travelTypeIds\n    }\n  }";
// language=GraphQL
var ADD_TENANT_EMPLOYEES_MUTATION = "\n  mutation Mutation($input: addTenantEmployeesInput) {\n    addTenantEmployees(input: $input) {\n      id\n      employeeIds\n    }\n  }";
// language=GraphQL
var REMOVE_TENANT_EMPLOYEES_MUTATION = "\n  mutation Mutation($input: removeTenantEmployeesInput) {\n    removeTenantEmployees(input: $input) {\n      id\n      employeeIds\n    }\n  }";
// language=GraphQL
var CREATE_TENANT_EMPLOYEES_MUTATION = "\n  mutation Mutation($input: createTenantEmployeesInput) {\n    createTenantEmployees(input: $input) {\n      id\n      employeeIds\n    }\n  }";
// language=GraphQL
var DELETE_TENANT_EMPLOYEES_MUTATION = "\n  mutation Mutation($input: deleteTenantEmployeesInput) {\n    deleteTenantEmployees(input: $input) {\n      id\n      employeeIds\n    }\n  }";
// language=GraphQL
var UPDATE_TENANT_EMPLOYEES_ORDER_MUTATION = "\n  mutation Mutation($input: updateTenantEmployeesOrderInput) {\n    updateTenantEmployeesOrder(input: $input) {\n      id\n      employeeIds\n    }\n  }";
// language=GraphQL
var ADD_TENANT_REDIRECTS_MUTATION = "\n  mutation Mutation($input: addTenantRedirectsInput) {\n    addTenantRedirects(input: $input) {\n      id\n      redirectIds\n    }\n  }";
// language=GraphQL
var REMOVE_TENANT_REDIRECTS_MUTATION = "\n  mutation Mutation($input: removeTenantRedirectsInput) {\n    removeTenantRedirects(input: $input) {\n      id\n      redirectIds\n    }\n  }";
// language=GraphQL
var CREATE_TENANT_REDIRECTS_MUTATION = "\n  mutation Mutation($input: createTenantRedirectsInput) {\n    createTenantRedirects(input: $input) {\n      id\n      redirectIds\n    }\n  }";
// language=GraphQL
var DELETE_TENANT_REDIRECTS_MUTATION = "\n  mutation Mutation($input: deleteTenantRedirectsInput) {\n    deleteTenantRedirects(input: $input) {\n      id\n      redirectIds\n    }\n  }";
// language=GraphQL
var UPDATE_TENANT_REDIRECTS_ORDER_MUTATION = "\n  mutation Mutation($input: updateTenantRedirectsOrderInput) {\n    updateTenantRedirectsOrder(input: $input) {\n      id\n      redirectIds\n    }\n  }";
// language=GraphQL
var ADD_TENANT_PARTNER_TENANTS_MUTATION = "\n  mutation Mutation($input: addTenantPartnerTenantsInput) {\n    addTenantPartnerTenants(input: $input) {\n      id\n      partnerTenantIds\n    }\n  }";
// language=GraphQL
var REMOVE_TENANT_PARTNER_TENANTS_MUTATION = "\n  mutation Mutation($input: removeTenantPartnerTenantsInput) {\n    removeTenantPartnerTenants(input: $input) {\n      id\n      partnerTenantIds\n    }\n  }";
// language=GraphQL
var CREATE_TENANT_PARTNER_TENANTS_MUTATION = "\n  mutation Mutation($input: createTenantPartnerTenantsInput) {\n    createTenantPartnerTenants(input: $input) {\n      id\n      partnerTenantIds\n    }\n  }";
// language=GraphQL
var DELETE_TENANT_PARTNER_TENANTS_MUTATION = "\n  mutation Mutation($input: deleteTenantPartnerTenantsInput) {\n    deleteTenantPartnerTenants(input: $input) {\n      id\n      partnerTenantIds\n    }\n  }";
// language=GraphQL
var UPDATE_TENANT_PARTNER_TENANTS_ORDER_MUTATION = "\n  mutation Mutation($input: updateTenantPartnerTenantsOrderInput) {\n    updateTenantPartnerTenantsOrder(input: $input) {\n      id\n      partnerTenantIds\n    }\n  }";
// language=GraphQL
var TENANTS_DEPENDENTS_QUERY = "query Query($id: ID!, $withTravelObjectTenantSettings: Boolean = false, $withAvailabilityStatusTenantSettings: Boolean = false, $withBookings: Boolean = false, $withOnlinePayments: Boolean = false, $withTrackingConversions: Boolean = false, $withPartnerTenants: Boolean = false) {\n  groupedDependents: tenantDependents(id: $id) {\n    travelObjectTenantSettings @include(if: $withTravelObjectTenantSettings) {\n      id\n      onlineStatus\n      redirectToBooking\n      useTiming\n      startDate\n      endDate\n    }\n    availabilityStatusTenantSettings @include(if: $withAvailabilityStatusTenantSettings) {\n      id\n      label\n      info\n      switchToStatusInfo\n      submitButtonLabel    }\n    bookings @include(if: $withBookings) {\n      id\n      referenceNo\n      travellerRemarks\n      travellerDataCorrectnessConfirmation\n      localState\n      backofficePayload\n      backofficeResponse\n      transmissionStatus\n      webhookStatus\n      webhookResponse\n      webhookDuration\n      confirmationEmailSent\n      isPassportDataRequired\n      passportDataReminderEmailSent\n      passportDataReceived    }\n    onlinePayments @include(if: $withOnlinePayments) {\n      id\n      transactionId\n      transactionStatus\n      submittedToBackoffice\n      statusPayload    }\n    trackingConversions @include(if: $withTrackingConversions) {\n      id\n      sessionId\n      conversionName\n      conversionTime\n      conversionValue\n      conversionCurrency\n      tourName\n      tourId\n      bookingId\n      landingPageUrl\n      source\n      medium\n      utmSource\n      utmMedium\n      utmCampaign\n      utmTerm\n      utmContent\n      gclid\n      gbraid\n      msclkid\n      fbclid\n      ttclid\n      scclid\n      liFatId\n      acquisitionTimestamp\n    }\n    partnerTenants @include(if: $withPartnerTenants) {\n      id\n      filterCrossLinking    }\n  }\n}";

// EXTERNAL MODULE: ./src/entities/tenantCms/entity.ts + 3 modules
var entity = __webpack_require__(57442);
// EXTERNAL MODULE: ./src/entities/travelType/entity.ts + 3 modules
var travelType_entity = __webpack_require__(31250);
// EXTERNAL MODULE: ./src/entities/employee/entity.ts + 3 modules
var employee_entity = __webpack_require__(4383);
// EXTERNAL MODULE: ./src/entities/tenantEmailConfig/entity.ts + 3 modules
var tenantEmailConfig_entity = __webpack_require__(22521);
// EXTERNAL MODULE: ./src/entities/newsletterProvider/entity.ts + 3 modules
var newsletterProvider_entity = __webpack_require__(5433);
// EXTERNAL MODULE: ./src/entities/redirect/entity.ts + 3 modules
var redirect_entity = __webpack_require__(79070);
// EXTERNAL MODULE: ./src/entities/tenantOnlinePaymentConfig/entity.ts + 3 modules
var tenantOnlinePaymentConfig_entity = __webpack_require__(33076);
// EXTERNAL MODULE: ./src/entities/tenantRatioConfig/entity.ts + 3 modules
var tenantRatioConfig_entity = __webpack_require__(1871);
// EXTERNAL MODULE: ./src/entities/tenantContent/entity.ts + 3 modules
var tenantContent_entity = __webpack_require__(61559);
// EXTERNAL MODULE: ./src/entities/partnerTenant/entity.ts + 3 modules
var partnerTenant_entity = __webpack_require__(67566);
;// CONCATENATED MODULE: ./src/entities/tenant/model.ts











var tenantModel = {
    name: "tenant",
    namePlural: "tenants",
    uniqueName: "tenant",
    uniqueNamePlural: "tenants",
    path: "config/tenant/tenant",
    baseUrl: "/config/tenants",
    translationPrefix: "entities:tenant.",
    getDisplayName: function(values) {
        return values.name;
    },
    gql: {
        getAll: ALL_TENANTS_QUERY,
        getSingle: SINGLE_TENANT_QUERY,
        create: CREATE_TENANT_MUTATION,
        update: UPDATE_TENANT_MUTATION,
        delete: DELETE_TENANT_MUTATION,
        forceDelete: FORCE_DELETE_TENANT_MUTATION
    },
    attributes: {
        name: {
            name: "name",
            label: "entities:tenant.attributes.name.label",
            type: "value",
            dataType: "string",
            defaultInput: true,
            inputType: "text",
            validationType: "string",
            validations: [
                {
                    type: "required"
                }, 
            ]
        },
        slug: {
            name: "slug",
            label: "entities:tenant.attributes.slug.label",
            type: "value",
            dataType: "string",
            defaultInput: true,
            inputType: "text",
            validationType: "string",
            validations: [
                {
                    type: "required"
                },
                {
                    type: "regex",
                    pattern: /^[a-z-]*$/
                }, 
            ]
        },
        domain: {
            name: "domain",
            label: "entities:tenant.attributes.domain.label",
            type: "value",
            dataType: "string",
            defaultInput: true,
            inputType: "text",
            validationType: "string",
            validations: [
                {
                    type: "required"
                }, 
            ]
        },
        externalReference: {
            name: "externalReference",
            label: "entities:tenant.attributes.externalReference.label",
            type: "value",
            dataType: "string",
            defaultInput: true,
            inputType: "text",
            validationType: "string",
            validations: [
                {
                    type: "required"
                }, 
            ]
        },
        cms: {
            name: "cms",
            label: "entities:tenant.attributes.cms.label",
            type: "entityObject",
            dataType: "any",
            getEntity: function() {
                return entity/* default */.Z;
            },
            defaultInput: false,
            inputType: "select",
            validationType: "string",
            validations: []
        },
        travelTypes: {
            name: "travelTypes",
            label: "entities:tenant.attributes.travelTypes.label",
            type: "entityCollection",
            dataType: "[any]",
            getEntity: function() {
                return travelType_entity/* default */.Z;
            },
            defaultInput: false,
            inputType: "text",
            validationType: "string",
            validations: []
        },
        employees: {
            name: "employees",
            label: "entities:tenant.attributes.employees.label",
            type: "entityCollection",
            dataType: "[any]",
            getEntity: function() {
                return employee_entity/* default */.Z;
            },
            defaultInput: false,
            inputType: "text",
            validationType: "string",
            validations: []
        },
        emailConfig: {
            name: "emailConfig",
            label: "entities:tenant.attributes.emailConfig.label",
            type: "entityObject",
            dataType: "any",
            getEntity: function() {
                return tenantEmailConfig_entity/* default */.Z;
            },
            defaultInput: false,
            inputType: "select",
            validationType: "string",
            validations: []
        },
        newsletterProvider: {
            name: "newsletterProvider",
            label: "entities:tenant.attributes.newsletterProvider.label",
            type: "entityObject",
            dataType: "any",
            getEntity: function() {
                return newsletterProvider_entity/* default */.Z;
            },
            defaultInput: false,
            inputType: "select",
            validationType: "string",
            validations: []
        },
        redirects: {
            name: "redirects",
            label: "entities:tenant.attributes.redirects.label",
            type: "entityCollection",
            dataType: "[any]",
            getEntity: function() {
                return redirect_entity/* default */.Z;
            },
            defaultInput: false,
            inputType: "text",
            validationType: "string",
            validations: []
        },
        onlinePaymentConfig: {
            name: "onlinePaymentConfig",
            label: "entities:tenant.attributes.onlinePaymentConfig.label",
            type: "entityObject",
            dataType: "any",
            getEntity: function() {
                return tenantOnlinePaymentConfig_entity/* default */.Z;
            },
            defaultInput: false,
            inputType: "select",
            validationType: "string",
            validations: []
        },
        ratioConfig: {
            name: "ratioConfig",
            label: "entities:tenant.attributes.ratioConfig.label",
            type: "entityObject",
            dataType: "any",
            getEntity: function() {
                return tenantRatioConfig_entity/* default */.Z;
            },
            defaultInput: false,
            inputType: "select",
            validationType: "string",
            validations: []
        },
        content: {
            name: "content",
            label: "entities:tenant.attributes.content.label",
            type: "entityObject",
            dataType: "any",
            getEntity: function() {
                return tenantContent_entity/* default */.Z;
            },
            defaultInput: false,
            inputType: "select",
            validationType: "string",
            validations: []
        },
        partnerTenants: {
            name: "partnerTenants",
            label: "entities:tenant.attributes.partnerTenants.label",
            type: "entityCollection",
            dataType: "[any]",
            getEntity: function() {
                return partnerTenant_entity/* default */.Z;
            },
            defaultInput: false,
            inputType: "text",
            validationType: "string",
            validations: []
        }
    }
};
/* harmony default export */ var model = (tenantModel);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(20414);
// EXTERNAL MODULE: ./src/entities/lib.ts
var lib = __webpack_require__(23480);
// EXTERNAL MODULE: ./src/lib/api/graphQLClient.ts
var graphQLClient = __webpack_require__(40112);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/swr/dist/index.mjs
var dist = __webpack_require__(8100);
// EXTERNAL MODULE: ./src/lib/helpers/helpers.ts
var helpers = __webpack_require__(15778);
;// CONCATENATED MODULE: ./src/entities/tenant/repository.ts










var hydrateObjects = function(objects) {
    return objects.map(function(object) {
        return (0,lib/* hydrateEntityObject */.b)(model, object);
    });
};
var hydrateObject = function(object) {
    return (0,lib/* hydrateEntityObject */.b)(model, object);
};
var tenantRepository = {
    getObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    id: id
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(SINGLE_TENANT_QUERY, variables).then(function(data) {
                        return hydrateObject(data.tenant);
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }(),
    getObjects: /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        var includes;
        var _arguments = arguments;
        return (0,tslib_es6.__generator)(this, function(_state) {
            includes = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : {};
            return [
                2,
                graphQLClient/* default.request */.Z.request(ALL_TENANTS_QUERY, includes).then(function(data) {
                    return hydrateObjects(data.tenants);
                })
            ];
        });
    }),
    useObject: function(id) {
        var includes = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        // eslint-disable-next-line react-hooks/exhaustive-deps
        var variables = (0,react.useMemo)(function() {
            return (0,_object_spread/* default */.Z)({
                id: id
            }, includes);
        }, [
            id
        ]);
        var ref = (0,dist/* default */.ZP)([
            SINGLE_TENANT_QUERY,
            variables
        ], {
            revalidateOnFocus: false
        }), data = ref.data, error = ref.error, mutate = ref.mutate;
        return {
            object: !data ? data : hydrateObject(data.tenant),
            isLoading: !error && !data,
            isError: error,
            mutate: mutate
        };
    },
    useObjects: function() {
        var includes = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        // eslint-disable-next-line react-hooks/exhaustive-deps
        var variables = (0,react.useMemo)(function() {
            return includes;
        }, []);
        var ref = (0,dist/* default */.ZP)([
            ALL_TENANTS_QUERY,
            variables
        ]), data = ref.data, error = ref.error, mutate = ref.mutate;
        return {
            objects: !data ? data : hydrateObjects(data.tenants),
            isLoading: !error && !data,
            isError: error,
            mutate: mutate
        };
    },
    getDependents: function(id, includes) {
        var includeVars = {};
        includes.forEach(function(include) {
            includeVars["with".concat((0,helpers/* uppercaseFirst */.AB)(include))] = true;
        });
        var variables = (0,_object_spread/* default */.Z)({
            id: id
        }, includeVars);
        return graphQLClient/* default.request */.Z.request(TENANTS_DEPENDENTS_QUERY, variables).then(function(data) {
            return data.groupedDependents;
        });
    },
    useDependents: function(id, includes) {
        var includeVars = {};
        includes.forEach(function(include) {
            includeVars["with".concat((0,helpers/* uppercaseFirst */.AB)(include))] = true;
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
        var variables = (0,react.useMemo)(function() {
            return (0,_object_spread/* default */.Z)({
                id: id
            }, includeVars);
        }, [
            id
        ]);
        var ref = (0,dist/* default */.ZP)([
            TENANTS_DEPENDENTS_QUERY,
            variables
        ], {
            revalidateOnFocus: false
        }), data = ref.data, error = ref.error, mutate = ref.mutate;
        return {
            data: !data ? data : data.groupedDependents,
            isLoading: !error && !data,
            isError: error,
            mutate: mutate
        };
    },
    createObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(data) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    input: data
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(CREATE_TENANT_MUTATION, variables).then(function(data) {
                        return hydrateObject(data.tenant);
                    })
                ];
            });
        });
        return function(data) {
            return _ref.apply(this, arguments);
        };
    }(),
    updateObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(data) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    input: data
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(UPDATE_TENANT_MUTATION, variables).then(function(data) {
                        return hydrateObject(data.tenant);
                    })
                ];
            });
        });
        return function(data) {
            return _ref.apply(this, arguments);
        };
    }(),
    deleteObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(DELETE_TENANT_MUTATION, variables).then(function(data) {
                        return data.deleteTenant;
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }(),
    forceDeleteObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(FORCE_DELETE_TENANT_MUTATION, variables).then(function(data) {
                        return data.forceDeleteTenant;
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }(),
    assignTravelTypes: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, itemIds) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        travelTypeIds: itemIds
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(ADD_TENANT_TRAVEL_TYPES_MUTATION, variables)
                ];
            });
        });
        return function(id, itemIds) {
            return _ref.apply(this, arguments);
        };
    }(),
    unassignTravelTypes: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, itemIds) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        travelTypeIds: itemIds
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(REMOVE_TENANT_TRAVEL_TYPES_MUTATION, variables)
                ];
            });
        });
        return function(id, itemIds) {
            return _ref.apply(this, arguments);
        };
    }(),
    createTravelTypes: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, items) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        travelTypes: items
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(CREATE_TENANT_TRAVEL_TYPES_MUTATION, variables)
                ];
            });
        });
        return function(id, items) {
            return _ref.apply(this, arguments);
        };
    }(),
    deleteTravelTypes: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, itemIds) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        travelTypeIds: itemIds
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(DELETE_TENANT_TRAVEL_TYPES_MUTATION, variables)
                ];
            });
        });
        return function(id, itemIds) {
            return _ref.apply(this, arguments);
        };
    }(),
    updateTravelTypesOrder: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, itemIds) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        travelTypeIds: itemIds
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(UPDATE_TENANT_TRAVEL_TYPES_ORDER_MUTATION, variables)
                ];
            });
        });
        return function(id, itemIds) {
            return _ref.apply(this, arguments);
        };
    }(),
    assignEmployees: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, itemIds) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        employeeIds: itemIds
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(ADD_TENANT_EMPLOYEES_MUTATION, variables)
                ];
            });
        });
        return function(id, itemIds) {
            return _ref.apply(this, arguments);
        };
    }(),
    unassignEmployees: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, itemIds) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        employeeIds: itemIds
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(REMOVE_TENANT_EMPLOYEES_MUTATION, variables)
                ];
            });
        });
        return function(id, itemIds) {
            return _ref.apply(this, arguments);
        };
    }(),
    createEmployees: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, items) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        employees: items
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(CREATE_TENANT_EMPLOYEES_MUTATION, variables)
                ];
            });
        });
        return function(id, items) {
            return _ref.apply(this, arguments);
        };
    }(),
    deleteEmployees: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, itemIds) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        employeeIds: itemIds
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(DELETE_TENANT_EMPLOYEES_MUTATION, variables)
                ];
            });
        });
        return function(id, itemIds) {
            return _ref.apply(this, arguments);
        };
    }(),
    updateEmployeesOrder: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, itemIds) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        employeeIds: itemIds
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(UPDATE_TENANT_EMPLOYEES_ORDER_MUTATION, variables)
                ];
            });
        });
        return function(id, itemIds) {
            return _ref.apply(this, arguments);
        };
    }(),
    assignRedirects: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, itemIds) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        redirectIds: itemIds
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(ADD_TENANT_REDIRECTS_MUTATION, variables)
                ];
            });
        });
        return function(id, itemIds) {
            return _ref.apply(this, arguments);
        };
    }(),
    unassignRedirects: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, itemIds) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        redirectIds: itemIds
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(REMOVE_TENANT_REDIRECTS_MUTATION, variables)
                ];
            });
        });
        return function(id, itemIds) {
            return _ref.apply(this, arguments);
        };
    }(),
    createRedirects: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, items) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        redirects: items
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(CREATE_TENANT_REDIRECTS_MUTATION, variables)
                ];
            });
        });
        return function(id, items) {
            return _ref.apply(this, arguments);
        };
    }(),
    deleteRedirects: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, itemIds) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        redirectIds: itemIds
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(DELETE_TENANT_REDIRECTS_MUTATION, variables)
                ];
            });
        });
        return function(id, itemIds) {
            return _ref.apply(this, arguments);
        };
    }(),
    updateRedirectsOrder: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, itemIds) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        redirectIds: itemIds
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(UPDATE_TENANT_REDIRECTS_ORDER_MUTATION, variables)
                ];
            });
        });
        return function(id, itemIds) {
            return _ref.apply(this, arguments);
        };
    }(),
    assignPartnerTenants: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, itemIds) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        partnerTenantIds: itemIds
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(ADD_TENANT_PARTNER_TENANTS_MUTATION, variables)
                ];
            });
        });
        return function(id, itemIds) {
            return _ref.apply(this, arguments);
        };
    }(),
    unassignPartnerTenants: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, itemIds) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        partnerTenantIds: itemIds
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(REMOVE_TENANT_PARTNER_TENANTS_MUTATION, variables)
                ];
            });
        });
        return function(id, itemIds) {
            return _ref.apply(this, arguments);
        };
    }(),
    createPartnerTenants: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, items) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        partnerTenants: items
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(CREATE_TENANT_PARTNER_TENANTS_MUTATION, variables)
                ];
            });
        });
        return function(id, items) {
            return _ref.apply(this, arguments);
        };
    }(),
    deletePartnerTenants: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, itemIds) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        partnerTenantIds: itemIds
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(DELETE_TENANT_PARTNER_TENANTS_MUTATION, variables)
                ];
            });
        });
        return function(id, itemIds) {
            return _ref.apply(this, arguments);
        };
    }(),
    updatePartnerTenantsOrder: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, itemIds) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        partnerTenantIds: itemIds
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(UPDATE_TENANT_PARTNER_TENANTS_ORDER_MUTATION, variables)
                ];
            });
        });
        return function(id, itemIds) {
            return _ref.apply(this, arguments);
        };
    }()
};
/* harmony default export */ var repository = (tenantRepository);

;// CONCATENATED MODULE: ./src/entities/tenant/entity.ts


var tenantEntity = {
    model: model,
    repository: repository
};
/* harmony default export */ var tenant_entity = (tenantEntity);


/***/ }),

/***/ 57442:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ tenantCms_entity; }
});

;// CONCATENATED MODULE: ./src/entities/tenantCms/graphql.ts
// language=GraphQL
var ALL_CMS_QUERY = "query Query($withHomepage: Boolean = false, $withHomepageSeoSettings: Boolean = false, $withHomepageSeoSettingsOgImage: Boolean = false, $withHomepageContentBlockAssignments: Boolean = false, $withHomepageContentBlockAssignmentsBlock: Boolean = false, $withCategories: Boolean = false, $withCategoriesPages: Boolean = false, $withCategoriesPagesSeoSettings: Boolean = false, $withCategoriesPagesContentBlockAssignments: Boolean = false, $withCategoriesSeoSettings: Boolean = false, $withCategoriesSeoSettingsOgImage: Boolean = false, $withPages: Boolean = false, $withPagesSeoSettings: Boolean = false, $withPagesSeoSettingsOgImage: Boolean = false, $withPagesContentBlockAssignments: Boolean = false, $withPagesContentBlockAssignmentsBlock: Boolean = false, $withErrorPage404: Boolean = false, $withErrorPage404SeoSettings: Boolean = false, $withErrorPage404SeoSettingsOgImage: Boolean = false, $withErrorPage404ContentBlockAssignments: Boolean = false, $withErrorPage404ContentBlockAssignmentsBlock: Boolean = false, $withErrorPage500: Boolean = false, $withErrorPage500SeoSettings: Boolean = false, $withErrorPage500SeoSettingsOgImage: Boolean = false, $withErrorPage500ContentBlockAssignments: Boolean = false, $withErrorPage500ContentBlockAssignmentsBlock: Boolean = false, $withConfig: Boolean = false, $withConfigContactBlockSettings: Boolean = false, $withConfigSocialMediaSettings: Boolean = false, $withConfigPrivacyPolicyPage: Boolean = false, $withConfigPrivacyPolicyPageSeoSettings: Boolean = false, $withConfigPrivacyPolicyPageContentBlockAssignments: Boolean = false, $withConfigGtcPage: Boolean = false, $withConfigGtcPageSeoSettings: Boolean = false, $withConfigGtcPageContentBlockAssignments: Boolean = false) {\n  cms: allTenantCms {\n    id\n    homepage @include(if: $withHomepage) {\n      id\n      name\n      onlineStatus\n      seoSettings @include(if: $withHomepageSeoSettings) {\n        id\n        urlSlug\n        metaTitle\n        metaDescription\n        ogTitle\n        ogDescription\n        ogImage @include(if: $withHomepageSeoSettingsOgImage) {\n          id\n          assetId\n          publicId\n          url\n          resourceType\n          format\n          width\n          height\n          caption\n          title\n          description\n        }\n      }\n      contentBlockAssignments @include(if: $withHomepageContentBlockAssignments) {\n        id\n        type\n        block @include(if: $withHomepageContentBlockAssignmentsBlock) {\n          __typename\n          ... on CmsTextBlock {\n            id\n            text\n\n          }\n          ... on CmsTextWithImageBlock {\n            id\n            title\n            subtitle\n            text\n            imagePosition\n            imageFixedAspectRatio\n\n          }\n          ... on CmsPageHeaderBlock {\n            id\n            title\n            text\n\n          }\n          ... on CmsWysiwygBlock {\n            id\n            html\n\n          }\n          ... on CmsHeadingBlock {\n            id\n            importance\n            heading\n            addon\n            decoration\n\n          }\n          ... on CmsTextWithIconBlock {\n            id\n            title\n            text\n            imagePosition\n\n          }\n          ... on CmsAccordionBlock {\n            id\n\n          }\n          ... on CmsGridBlock {\n            id\n\n          }\n          ... on CmsImageBlock {\n            id\n            text\n            fluid\n\n          }\n          ... on CmsEmployeesBlock {\n            id\n\n          }\n          ... on CmsContactBannerBlock {\n            id\n            phone\n            email\n\n          }\n          ... on CmsNewsletterRegisterBlock {\n            id\n            fluid\n\n          }\n          ... on CmsIssuuCatalogBlock {\n            id\n            publicationCode\n            accountName\n\n          }\n          ... on CmsFormBlock {\n            id\n            formName\n\n          }\n          ... on CmsHeaderSliderBlock {\n            id\n\n          }\n          ... on CmsBestsellerSliderBlock {\n            id\n            fluid\n\n          }\n          ... on CmsFilterLeadBlock {\n            id\n            layout\n\n          }\n          ... on CmsTravelTypesBlock {\n            id\n            layout\n\n          }\n          ... on CmsPrefilteredTravelsBlock {\n            id\n            maxResults\n\n          }\n          ... on CmsDividerBlock {\n            id\n            fluid\n\n          }\n          ... on CmsTravelSelectionBlock {\n            id\n\n          }\n          ... on CmsIframeBlock {\n            id\n            url\n            minHeight\n\n          }\n          ... on CmsSliderBlock {\n            id\n            fluid\n            size\n            showDots\n            showArrows\n            showLightbox\n            autoplay\n\n          }\n          ... on CmsDestinationsBlock {\n            id\n\n          }\n          ... on CmsTravelGuidesBlock {\n            id\n\n          }\n          ... on CmsBusfinderBlock {\n            id\n            title\n\n          }\n          ... on CmsBackgroundBlock {\n            id\n            backgroundVariant\n\n          }\n        }\n      }\n    }\n    categories @include(if: $withCategories) {\n      id\n      name\n      pages @include(if: $withCategoriesPages) {\n        id\n        name\n        onlineStatus\n        seoSettings @include(if: $withCategoriesPagesSeoSettings) {\n          id\n          urlSlug\n          metaTitle\n          metaDescription\n          ogTitle\n          ogDescription\n        }\n        contentBlockAssignments @include(if: $withCategoriesPagesContentBlockAssignments) {\n          id\n          type\n        }\n      }\n      seoSettings @include(if: $withCategoriesSeoSettings) {\n        id\n        urlSlug\n        metaTitle\n        metaDescription\n        ogTitle\n        ogDescription\n        ogImage @include(if: $withCategoriesSeoSettingsOgImage) {\n          id\n          assetId\n          publicId\n          url\n          resourceType\n          format\n          width\n          height\n          caption\n          title\n          description\n        }\n      }\n    }\n    pages @include(if: $withPages) {\n      id\n      name\n      onlineStatus\n      seoSettings @include(if: $withPagesSeoSettings) {\n        id\n        urlSlug\n        metaTitle\n        metaDescription\n        ogTitle\n        ogDescription\n        ogImage @include(if: $withPagesSeoSettingsOgImage) {\n          id\n          assetId\n          publicId\n          url\n          resourceType\n          format\n          width\n          height\n          caption\n          title\n          description\n        }\n      }\n      contentBlockAssignments @include(if: $withPagesContentBlockAssignments) {\n        id\n        type\n        block @include(if: $withPagesContentBlockAssignmentsBlock) {\n          __typename\n          ... on CmsTextBlock {\n            id\n            text\n\n          }\n          ... on CmsTextWithImageBlock {\n            id\n            title\n            subtitle\n            text\n            imagePosition\n            imageFixedAspectRatio\n\n          }\n          ... on CmsPageHeaderBlock {\n            id\n            title\n            text\n\n          }\n          ... on CmsWysiwygBlock {\n            id\n            html\n\n          }\n          ... on CmsHeadingBlock {\n            id\n            importance\n            heading\n            addon\n            decoration\n\n          }\n          ... on CmsTextWithIconBlock {\n            id\n            title\n            text\n            imagePosition\n\n          }\n          ... on CmsAccordionBlock {\n            id\n\n          }\n          ... on CmsGridBlock {\n            id\n\n          }\n          ... on CmsImageBlock {\n            id\n            text\n            fluid\n\n          }\n          ... on CmsEmployeesBlock {\n            id\n\n          }\n          ... on CmsContactBannerBlock {\n            id\n            phone\n            email\n\n          }\n          ... on CmsNewsletterRegisterBlock {\n            id\n            fluid\n\n          }\n          ... on CmsIssuuCatalogBlock {\n            id\n            publicationCode\n            accountName\n\n          }\n          ... on CmsFormBlock {\n            id\n            formName\n\n          }\n          ... on CmsHeaderSliderBlock {\n            id\n\n          }\n          ... on CmsBestsellerSliderBlock {\n            id\n            fluid\n\n          }\n          ... on CmsFilterLeadBlock {\n            id\n            layout\n\n          }\n          ... on CmsTravelTypesBlock {\n            id\n            layout\n\n          }\n          ... on CmsPrefilteredTravelsBlock {\n            id\n            maxResults\n\n          }\n          ... on CmsDividerBlock {\n            id\n            fluid\n\n          }\n          ... on CmsTravelSelectionBlock {\n            id\n\n          }\n          ... on CmsIframeBlock {\n            id\n            url\n            minHeight\n\n          }\n          ... on CmsSliderBlock {\n            id\n            fluid\n            size\n            showDots\n            showArrows\n            showLightbox\n            autoplay\n\n          }\n          ... on CmsDestinationsBlock {\n            id\n\n          }\n          ... on CmsTravelGuidesBlock {\n            id\n\n          }\n          ... on CmsBusfinderBlock {\n            id\n            title\n\n          }\n          ... on CmsBackgroundBlock {\n            id\n            backgroundVariant\n\n          }\n        }\n      }\n    }\n    errorPage404 @include(if: $withErrorPage404) {\n      id\n      name\n      onlineStatus\n      seoSettings @include(if: $withErrorPage404SeoSettings) {\n        id\n        urlSlug\n        metaTitle\n        metaDescription\n        ogTitle\n        ogDescription\n        ogImage @include(if: $withErrorPage404SeoSettingsOgImage) {\n          id\n          assetId\n          publicId\n          url\n          resourceType\n          format\n          width\n          height\n          caption\n          title\n          description\n        }\n      }\n      contentBlockAssignments @include(if: $withErrorPage404ContentBlockAssignments) {\n        id\n        type\n        block @include(if: $withErrorPage404ContentBlockAssignmentsBlock) {\n          __typename\n          ... on CmsTextBlock {\n            id\n            text\n\n          }\n          ... on CmsTextWithImageBlock {\n            id\n            title\n            subtitle\n            text\n            imagePosition\n            imageFixedAspectRatio\n\n          }\n          ... on CmsPageHeaderBlock {\n            id\n            title\n            text\n\n          }\n          ... on CmsWysiwygBlock {\n            id\n            html\n\n          }\n          ... on CmsHeadingBlock {\n            id\n            importance\n            heading\n            addon\n            decoration\n\n          }\n          ... on CmsTextWithIconBlock {\n            id\n            title\n            text\n            imagePosition\n\n          }\n          ... on CmsAccordionBlock {\n            id\n\n          }\n          ... on CmsGridBlock {\n            id\n\n          }\n          ... on CmsImageBlock {\n            id\n            text\n            fluid\n\n          }\n          ... on CmsEmployeesBlock {\n            id\n\n          }\n          ... on CmsContactBannerBlock {\n            id\n            phone\n            email\n\n          }\n          ... on CmsNewsletterRegisterBlock {\n            id\n            fluid\n\n          }\n          ... on CmsIssuuCatalogBlock {\n            id\n            publicationCode\n            accountName\n\n          }\n          ... on CmsFormBlock {\n            id\n            formName\n\n          }\n          ... on CmsHeaderSliderBlock {\n            id\n\n          }\n          ... on CmsBestsellerSliderBlock {\n            id\n            fluid\n\n          }\n          ... on CmsFilterLeadBlock {\n            id\n            layout\n\n          }\n          ... on CmsTravelTypesBlock {\n            id\n            layout\n\n          }\n          ... on CmsPrefilteredTravelsBlock {\n            id\n            maxResults\n\n          }\n          ... on CmsDividerBlock {\n            id\n            fluid\n\n          }\n          ... on CmsTravelSelectionBlock {\n            id\n\n          }\n          ... on CmsIframeBlock {\n            id\n            url\n            minHeight\n\n          }\n          ... on CmsSliderBlock {\n            id\n            fluid\n            size\n            showDots\n            showArrows\n            showLightbox\n            autoplay\n\n          }\n          ... on CmsDestinationsBlock {\n            id\n\n          }\n          ... on CmsTravelGuidesBlock {\n            id\n\n          }\n          ... on CmsBusfinderBlock {\n            id\n            title\n\n          }\n          ... on CmsBackgroundBlock {\n            id\n            backgroundVariant\n\n          }\n        }\n      }\n    }\n    errorPage500 @include(if: $withErrorPage500) {\n      id\n      name\n      onlineStatus\n      seoSettings @include(if: $withErrorPage500SeoSettings) {\n        id\n        urlSlug\n        metaTitle\n        metaDescription\n        ogTitle\n        ogDescription\n        ogImage @include(if: $withErrorPage500SeoSettingsOgImage) {\n          id\n          assetId\n          publicId\n          url\n          resourceType\n          format\n          width\n          height\n          caption\n          title\n          description\n        }\n      }\n      contentBlockAssignments @include(if: $withErrorPage500ContentBlockAssignments) {\n        id\n        type\n        block @include(if: $withErrorPage500ContentBlockAssignmentsBlock) {\n          __typename\n          ... on CmsTextBlock {\n            id\n            text\n\n          }\n          ... on CmsTextWithImageBlock {\n            id\n            title\n            subtitle\n            text\n            imagePosition\n            imageFixedAspectRatio\n\n          }\n          ... on CmsPageHeaderBlock {\n            id\n            title\n            text\n\n          }\n          ... on CmsWysiwygBlock {\n            id\n            html\n\n          }\n          ... on CmsHeadingBlock {\n            id\n            importance\n            heading\n            addon\n            decoration\n\n          }\n          ... on CmsTextWithIconBlock {\n            id\n            title\n            text\n            imagePosition\n\n          }\n          ... on CmsAccordionBlock {\n            id\n\n          }\n          ... on CmsGridBlock {\n            id\n\n          }\n          ... on CmsImageBlock {\n            id\n            text\n            fluid\n\n          }\n          ... on CmsEmployeesBlock {\n            id\n\n          }\n          ... on CmsContactBannerBlock {\n            id\n            phone\n            email\n\n          }\n          ... on CmsNewsletterRegisterBlock {\n            id\n            fluid\n\n          }\n          ... on CmsIssuuCatalogBlock {\n            id\n            publicationCode\n            accountName\n\n          }\n          ... on CmsFormBlock {\n            id\n            formName\n\n          }\n          ... on CmsHeaderSliderBlock {\n            id\n\n          }\n          ... on CmsBestsellerSliderBlock {\n            id\n            fluid\n\n          }\n          ... on CmsFilterLeadBlock {\n            id\n            layout\n\n          }\n          ... on CmsTravelTypesBlock {\n            id\n            layout\n\n          }\n          ... on CmsPrefilteredTravelsBlock {\n            id\n            maxResults\n\n          }\n          ... on CmsDividerBlock {\n            id\n            fluid\n\n          }\n          ... on CmsTravelSelectionBlock {\n            id\n\n          }\n          ... on CmsIframeBlock {\n            id\n            url\n            minHeight\n\n          }\n          ... on CmsSliderBlock {\n            id\n            fluid\n            size\n            showDots\n            showArrows\n            showLightbox\n            autoplay\n\n          }\n          ... on CmsDestinationsBlock {\n            id\n\n          }\n          ... on CmsTravelGuidesBlock {\n            id\n\n          }\n          ... on CmsBusfinderBlock {\n            id\n            title\n\n          }\n          ... on CmsBackgroundBlock {\n            id\n            backgroundVariant\n\n          }\n        }\n      }\n    }\n    config @include(if: $withConfig) {\n      id\n      contactBlockSettings @include(if: $withConfigContactBlockSettings) {\n        id\n        slogan\n        title\n        text\n        phonePrefix\n        phone\n        phone2Prefix\n        phone2\n        openingHours1\n        openingHours2\n        email\n      }\n      socialMediaSettings @include(if: $withConfigSocialMediaSettings) {\n        id\n        facebookUrl\n        instagramUrl\n      }\n      privacyPolicyPage @include(if: $withConfigPrivacyPolicyPage) {\n        id\n        name\n        onlineStatus\n        seoSettings @include(if: $withConfigPrivacyPolicyPageSeoSettings) {\n          id\n          urlSlug\n          metaTitle\n          metaDescription\n          ogTitle\n          ogDescription\n        }\n        contentBlockAssignments @include(if: $withConfigPrivacyPolicyPageContentBlockAssignments) {\n          id\n          type\n        }\n      }\n      gtcPage @include(if: $withConfigGtcPage) {\n        id\n        name\n        onlineStatus\n        seoSettings @include(if: $withConfigGtcPageSeoSettings) {\n          id\n          urlSlug\n          metaTitle\n          metaDescription\n          ogTitle\n          ogDescription\n        }\n        contentBlockAssignments @include(if: $withConfigGtcPageContentBlockAssignments) {\n          id\n          type\n        }\n      }\n    }\n  }\n}";
// language=GraphQL
var SINGLE_CMS_QUERY = "query Query($id: ID!, $withHomepage: Boolean = false, $withHomepageSeoSettings: Boolean = false, $withHomepageSeoSettingsOgImage: Boolean = false, $withHomepageContentBlockAssignments: Boolean = false, $withHomepageContentBlockAssignmentsBlock: Boolean = false, $withCategories: Boolean = false, $withCategoriesPages: Boolean = false, $withCategoriesPagesSeoSettings: Boolean = false, $withCategoriesPagesContentBlockAssignments: Boolean = false, $withCategoriesSeoSettings: Boolean = false, $withCategoriesSeoSettingsOgImage: Boolean = false, $withPages: Boolean = false, $withPagesSeoSettings: Boolean = false, $withPagesSeoSettingsOgImage: Boolean = false, $withPagesContentBlockAssignments: Boolean = false, $withPagesContentBlockAssignmentsBlock: Boolean = false, $withErrorPage404: Boolean = false, $withErrorPage404SeoSettings: Boolean = false, $withErrorPage404SeoSettingsOgImage: Boolean = false, $withErrorPage404ContentBlockAssignments: Boolean = false, $withErrorPage404ContentBlockAssignmentsBlock: Boolean = false, $withErrorPage500: Boolean = false, $withErrorPage500SeoSettings: Boolean = false, $withErrorPage500SeoSettingsOgImage: Boolean = false, $withErrorPage500ContentBlockAssignments: Boolean = false, $withErrorPage500ContentBlockAssignmentsBlock: Boolean = false, $withConfig: Boolean = false, $withConfigContactBlockSettings: Boolean = false, $withConfigSocialMediaSettings: Boolean = false, $withConfigPrivacyPolicyPage: Boolean = false, $withConfigPrivacyPolicyPageSeoSettings: Boolean = false, $withConfigPrivacyPolicyPageContentBlockAssignments: Boolean = false, $withConfigGtcPage: Boolean = false, $withConfigGtcPageSeoSettings: Boolean = false, $withConfigGtcPageContentBlockAssignments: Boolean = false) {\n  cms: tenantCms(id: $id) {\n    id\n    homepage @include(if: $withHomepage) {\n      id\n      name\n      onlineStatus\n      seoSettings @include(if: $withHomepageSeoSettings) {\n        id\n        urlSlug\n        metaTitle\n        metaDescription\n        ogTitle\n        ogDescription\n        ogImage @include(if: $withHomepageSeoSettingsOgImage) {\n          id\n          assetId\n          publicId\n          url\n          resourceType\n          format\n          width\n          height\n          caption\n          title\n          description\n        }\n      }\n      contentBlockAssignments @include(if: $withHomepageContentBlockAssignments) {\n        id\n        type\n        block @include(if: $withHomepageContentBlockAssignmentsBlock) {\n          __typename\n          ... on CmsTextBlock {\n            id\n            text\n\n          }\n          ... on CmsTextWithImageBlock {\n            id\n            title\n            subtitle\n            text\n            imagePosition\n            imageFixedAspectRatio\n\n          }\n          ... on CmsPageHeaderBlock {\n            id\n            title\n            text\n\n          }\n          ... on CmsWysiwygBlock {\n            id\n            html\n\n          }\n          ... on CmsHeadingBlock {\n            id\n            importance\n            heading\n            addon\n            decoration\n\n          }\n          ... on CmsTextWithIconBlock {\n            id\n            title\n            text\n            imagePosition\n\n          }\n          ... on CmsAccordionBlock {\n            id\n\n          }\n          ... on CmsGridBlock {\n            id\n\n          }\n          ... on CmsImageBlock {\n            id\n            text\n            fluid\n\n          }\n          ... on CmsEmployeesBlock {\n            id\n\n          }\n          ... on CmsContactBannerBlock {\n            id\n            phone\n            email\n\n          }\n          ... on CmsNewsletterRegisterBlock {\n            id\n            fluid\n\n          }\n          ... on CmsIssuuCatalogBlock {\n            id\n            publicationCode\n            accountName\n\n          }\n          ... on CmsFormBlock {\n            id\n            formName\n\n          }\n          ... on CmsHeaderSliderBlock {\n            id\n\n          }\n          ... on CmsBestsellerSliderBlock {\n            id\n            fluid\n\n          }\n          ... on CmsFilterLeadBlock {\n            id\n            layout\n\n          }\n          ... on CmsTravelTypesBlock {\n            id\n            layout\n\n          }\n          ... on CmsPrefilteredTravelsBlock {\n            id\n            maxResults\n\n          }\n          ... on CmsDividerBlock {\n            id\n            fluid\n\n          }\n          ... on CmsTravelSelectionBlock {\n            id\n\n          }\n          ... on CmsIframeBlock {\n            id\n            url\n            minHeight\n\n          }\n          ... on CmsSliderBlock {\n            id\n            fluid\n            size\n            showDots\n            showArrows\n            showLightbox\n            autoplay\n\n          }\n          ... on CmsDestinationsBlock {\n            id\n\n          }\n          ... on CmsTravelGuidesBlock {\n            id\n\n          }\n          ... on CmsBusfinderBlock {\n            id\n            title\n\n          }\n          ... on CmsBackgroundBlock {\n            id\n            backgroundVariant\n\n          }\n        }\n      }\n    }\n    categories @include(if: $withCategories) {\n      id\n      name\n      pages @include(if: $withCategoriesPages) {\n        id\n        name\n        onlineStatus\n        seoSettings @include(if: $withCategoriesPagesSeoSettings) {\n          id\n          urlSlug\n          metaTitle\n          metaDescription\n          ogTitle\n          ogDescription\n        }\n        contentBlockAssignments @include(if: $withCategoriesPagesContentBlockAssignments) {\n          id\n          type\n        }\n      }\n      seoSettings @include(if: $withCategoriesSeoSettings) {\n        id\n        urlSlug\n        metaTitle\n        metaDescription\n        ogTitle\n        ogDescription\n        ogImage @include(if: $withCategoriesSeoSettingsOgImage) {\n          id\n          assetId\n          publicId\n          url\n          resourceType\n          format\n          width\n          height\n          caption\n          title\n          description\n        }\n      }\n    }\n    pages @include(if: $withPages) {\n      id\n      name\n      onlineStatus\n      seoSettings @include(if: $withPagesSeoSettings) {\n        id\n        urlSlug\n        metaTitle\n        metaDescription\n        ogTitle\n        ogDescription\n        ogImage @include(if: $withPagesSeoSettingsOgImage) {\n          id\n          assetId\n          publicId\n          url\n          resourceType\n          format\n          width\n          height\n          caption\n          title\n          description\n        }\n      }\n      contentBlockAssignments @include(if: $withPagesContentBlockAssignments) {\n        id\n        type\n        block @include(if: $withPagesContentBlockAssignmentsBlock) {\n          __typename\n          ... on CmsTextBlock {\n            id\n            text\n\n          }\n          ... on CmsTextWithImageBlock {\n            id\n            title\n            subtitle\n            text\n            imagePosition\n            imageFixedAspectRatio\n\n          }\n          ... on CmsPageHeaderBlock {\n            id\n            title\n            text\n\n          }\n          ... on CmsWysiwygBlock {\n            id\n            html\n\n          }\n          ... on CmsHeadingBlock {\n            id\n            importance\n            heading\n            addon\n            decoration\n\n          }\n          ... on CmsTextWithIconBlock {\n            id\n            title\n            text\n            imagePosition\n\n          }\n          ... on CmsAccordionBlock {\n            id\n\n          }\n          ... on CmsGridBlock {\n            id\n\n          }\n          ... on CmsImageBlock {\n            id\n            text\n            fluid\n\n          }\n          ... on CmsEmployeesBlock {\n            id\n\n          }\n          ... on CmsContactBannerBlock {\n            id\n            phone\n            email\n\n          }\n          ... on CmsNewsletterRegisterBlock {\n            id\n            fluid\n\n          }\n          ... on CmsIssuuCatalogBlock {\n            id\n            publicationCode\n            accountName\n\n          }\n          ... on CmsFormBlock {\n            id\n            formName\n\n          }\n          ... on CmsHeaderSliderBlock {\n            id\n\n          }\n          ... on CmsBestsellerSliderBlock {\n            id\n            fluid\n\n          }\n          ... on CmsFilterLeadBlock {\n            id\n            layout\n\n          }\n          ... on CmsTravelTypesBlock {\n            id\n            layout\n\n          }\n          ... on CmsPrefilteredTravelsBlock {\n            id\n            maxResults\n\n          }\n          ... on CmsDividerBlock {\n            id\n            fluid\n\n          }\n          ... on CmsTravelSelectionBlock {\n            id\n\n          }\n          ... on CmsIframeBlock {\n            id\n            url\n            minHeight\n\n          }\n          ... on CmsSliderBlock {\n            id\n            fluid\n            size\n            showDots\n            showArrows\n            showLightbox\n            autoplay\n\n          }\n          ... on CmsDestinationsBlock {\n            id\n\n          }\n          ... on CmsTravelGuidesBlock {\n            id\n\n          }\n          ... on CmsBusfinderBlock {\n            id\n            title\n\n          }\n          ... on CmsBackgroundBlock {\n            id\n            backgroundVariant\n\n          }\n        }\n      }\n    }\n    errorPage404 @include(if: $withErrorPage404) {\n      id\n      name\n      onlineStatus\n      seoSettings @include(if: $withErrorPage404SeoSettings) {\n        id\n        urlSlug\n        metaTitle\n        metaDescription\n        ogTitle\n        ogDescription\n        ogImage @include(if: $withErrorPage404SeoSettingsOgImage) {\n          id\n          assetId\n          publicId\n          url\n          resourceType\n          format\n          width\n          height\n          caption\n          title\n          description\n        }\n      }\n      contentBlockAssignments @include(if: $withErrorPage404ContentBlockAssignments) {\n        id\n        type\n        block @include(if: $withErrorPage404ContentBlockAssignmentsBlock) {\n          __typename\n          ... on CmsTextBlock {\n            id\n            text\n\n          }\n          ... on CmsTextWithImageBlock {\n            id\n            title\n            subtitle\n            text\n            imagePosition\n            imageFixedAspectRatio\n\n          }\n          ... on CmsPageHeaderBlock {\n            id\n            title\n            text\n\n          }\n          ... on CmsWysiwygBlock {\n            id\n            html\n\n          }\n          ... on CmsHeadingBlock {\n            id\n            importance\n            heading\n            addon\n            decoration\n\n          }\n          ... on CmsTextWithIconBlock {\n            id\n            title\n            text\n            imagePosition\n\n          }\n          ... on CmsAccordionBlock {\n            id\n\n          }\n          ... on CmsGridBlock {\n            id\n\n          }\n          ... on CmsImageBlock {\n            id\n            text\n            fluid\n\n          }\n          ... on CmsEmployeesBlock {\n            id\n\n          }\n          ... on CmsContactBannerBlock {\n            id\n            phone\n            email\n\n          }\n          ... on CmsNewsletterRegisterBlock {\n            id\n            fluid\n\n          }\n          ... on CmsIssuuCatalogBlock {\n            id\n            publicationCode\n            accountName\n\n          }\n          ... on CmsFormBlock {\n            id\n            formName\n\n          }\n          ... on CmsHeaderSliderBlock {\n            id\n\n          }\n          ... on CmsBestsellerSliderBlock {\n            id\n            fluid\n\n          }\n          ... on CmsFilterLeadBlock {\n            id\n            layout\n\n          }\n          ... on CmsTravelTypesBlock {\n            id\n            layout\n\n          }\n          ... on CmsPrefilteredTravelsBlock {\n            id\n            maxResults\n\n          }\n          ... on CmsDividerBlock {\n            id\n            fluid\n\n          }\n          ... on CmsTravelSelectionBlock {\n            id\n\n          }\n          ... on CmsIframeBlock {\n            id\n            url\n            minHeight\n\n          }\n          ... on CmsSliderBlock {\n            id\n            fluid\n            size\n            showDots\n            showArrows\n            showLightbox\n            autoplay\n\n          }\n          ... on CmsDestinationsBlock {\n            id\n\n          }\n          ... on CmsTravelGuidesBlock {\n            id\n\n          }\n          ... on CmsBusfinderBlock {\n            id\n            title\n\n          }\n          ... on CmsBackgroundBlock {\n            id\n            backgroundVariant\n\n          }\n        }\n      }\n    }\n    errorPage500 @include(if: $withErrorPage500) {\n      id\n      name\n      onlineStatus\n      seoSettings @include(if: $withErrorPage500SeoSettings) {\n        id\n        urlSlug\n        metaTitle\n        metaDescription\n        ogTitle\n        ogDescription\n        ogImage @include(if: $withErrorPage500SeoSettingsOgImage) {\n          id\n          assetId\n          publicId\n          url\n          resourceType\n          format\n          width\n          height\n          caption\n          title\n          description\n        }\n      }\n      contentBlockAssignments @include(if: $withErrorPage500ContentBlockAssignments) {\n        id\n        type\n        block @include(if: $withErrorPage500ContentBlockAssignmentsBlock) {\n          __typename\n          ... on CmsTextBlock {\n            id\n            text\n\n          }\n          ... on CmsTextWithImageBlock {\n            id\n            title\n            subtitle\n            text\n            imagePosition\n            imageFixedAspectRatio\n\n          }\n          ... on CmsPageHeaderBlock {\n            id\n            title\n            text\n\n          }\n          ... on CmsWysiwygBlock {\n            id\n            html\n\n          }\n          ... on CmsHeadingBlock {\n            id\n            importance\n            heading\n            addon\n            decoration\n\n          }\n          ... on CmsTextWithIconBlock {\n            id\n            title\n            text\n            imagePosition\n\n          }\n          ... on CmsAccordionBlock {\n            id\n\n          }\n          ... on CmsGridBlock {\n            id\n\n          }\n          ... on CmsImageBlock {\n            id\n            text\n            fluid\n\n          }\n          ... on CmsEmployeesBlock {\n            id\n\n          }\n          ... on CmsContactBannerBlock {\n            id\n            phone\n            email\n\n          }\n          ... on CmsNewsletterRegisterBlock {\n            id\n            fluid\n\n          }\n          ... on CmsIssuuCatalogBlock {\n            id\n            publicationCode\n            accountName\n\n          }\n          ... on CmsFormBlock {\n            id\n            formName\n\n          }\n          ... on CmsHeaderSliderBlock {\n            id\n\n          }\n          ... on CmsBestsellerSliderBlock {\n            id\n            fluid\n\n          }\n          ... on CmsFilterLeadBlock {\n            id\n            layout\n\n          }\n          ... on CmsTravelTypesBlock {\n            id\n            layout\n\n          }\n          ... on CmsPrefilteredTravelsBlock {\n            id\n            maxResults\n\n          }\n          ... on CmsDividerBlock {\n            id\n            fluid\n\n          }\n          ... on CmsTravelSelectionBlock {\n            id\n\n          }\n          ... on CmsIframeBlock {\n            id\n            url\n            minHeight\n\n          }\n          ... on CmsSliderBlock {\n            id\n            fluid\n            size\n            showDots\n            showArrows\n            showLightbox\n            autoplay\n\n          }\n          ... on CmsDestinationsBlock {\n            id\n\n          }\n          ... on CmsTravelGuidesBlock {\n            id\n\n          }\n          ... on CmsBusfinderBlock {\n            id\n            title\n\n          }\n          ... on CmsBackgroundBlock {\n            id\n            backgroundVariant\n\n          }\n        }\n      }\n    }\n    config @include(if: $withConfig) {\n      id\n      contactBlockSettings @include(if: $withConfigContactBlockSettings) {\n        id\n        slogan\n        title\n        text\n        phonePrefix\n        phone\n        phone2Prefix\n        phone2\n        openingHours1\n        openingHours2\n        email\n      }\n      socialMediaSettings @include(if: $withConfigSocialMediaSettings) {\n        id\n        facebookUrl\n        instagramUrl\n      }\n      privacyPolicyPage @include(if: $withConfigPrivacyPolicyPage) {\n        id\n        name\n        onlineStatus\n        seoSettings @include(if: $withConfigPrivacyPolicyPageSeoSettings) {\n          id\n          urlSlug\n          metaTitle\n          metaDescription\n          ogTitle\n          ogDescription\n        }\n        contentBlockAssignments @include(if: $withConfigPrivacyPolicyPageContentBlockAssignments) {\n          id\n          type\n        }\n      }\n      gtcPage @include(if: $withConfigGtcPage) {\n        id\n        name\n        onlineStatus\n        seoSettings @include(if: $withConfigGtcPageSeoSettings) {\n          id\n          urlSlug\n          metaTitle\n          metaDescription\n          ogTitle\n          ogDescription\n        }\n        contentBlockAssignments @include(if: $withConfigGtcPageContentBlockAssignments) {\n          id\n          type\n        }\n      }\n    }\n  }\n}";
// language=GraphQL
var CREATE_CMS_MUTATION = "\n  mutation Mutation($input: CreateTenantCmsInput, $withHomepage: Boolean = false, $withHomepageSeoSettings: Boolean = false, $withHomepageSeoSettingsOgImage: Boolean = false, $withHomepageContentBlockAssignments: Boolean = false, $withHomepageContentBlockAssignmentsBlock: Boolean = false, $withCategories: Boolean = false, $withCategoriesPages: Boolean = false, $withCategoriesPagesSeoSettings: Boolean = false, $withCategoriesPagesContentBlockAssignments: Boolean = false, $withCategoriesSeoSettings: Boolean = false, $withCategoriesSeoSettingsOgImage: Boolean = false, $withPages: Boolean = false, $withPagesSeoSettings: Boolean = false, $withPagesSeoSettingsOgImage: Boolean = false, $withPagesContentBlockAssignments: Boolean = false, $withPagesContentBlockAssignmentsBlock: Boolean = false, $withErrorPage404: Boolean = false, $withErrorPage404SeoSettings: Boolean = false, $withErrorPage404SeoSettingsOgImage: Boolean = false, $withErrorPage404ContentBlockAssignments: Boolean = false, $withErrorPage404ContentBlockAssignmentsBlock: Boolean = false, $withErrorPage500: Boolean = false, $withErrorPage500SeoSettings: Boolean = false, $withErrorPage500SeoSettingsOgImage: Boolean = false, $withErrorPage500ContentBlockAssignments: Boolean = false, $withErrorPage500ContentBlockAssignmentsBlock: Boolean = false, $withConfig: Boolean = false, $withConfigContactBlockSettings: Boolean = false, $withConfigSocialMediaSettings: Boolean = false, $withConfigPrivacyPolicyPage: Boolean = false, $withConfigPrivacyPolicyPageSeoSettings: Boolean = false, $withConfigPrivacyPolicyPageContentBlockAssignments: Boolean = false, $withConfigGtcPage: Boolean = false, $withConfigGtcPageSeoSettings: Boolean = false, $withConfigGtcPageContentBlockAssignments: Boolean = false) {\n    cms: createTenantCms(input: $input) {\n      id\n      homepage @include(if: $withHomepage) {\n        id\n        name\n        onlineStatus\n        seoSettings @include(if: $withHomepageSeoSettings) {\n          id\n          urlSlug\n          metaTitle\n          metaDescription\n          ogTitle\n          ogDescription\n          ogImage @include(if: $withHomepageSeoSettingsOgImage) {\n            id\n            assetId\n            publicId\n            url\n            resourceType\n            format\n            width\n            height\n            caption\n            title\n            description\n          }\n        }\n        contentBlockAssignments @include(if: $withHomepageContentBlockAssignments) {\n          id\n          type\n          block @include(if: $withHomepageContentBlockAssignmentsBlock) {\n            __typename\n            ... on CmsTextBlock {\n              id\n              text\n\n            }\n            ... on CmsTextWithImageBlock {\n              id\n              title\n              subtitle\n              text\n              imagePosition\n              imageFixedAspectRatio\n\n            }\n            ... on CmsPageHeaderBlock {\n              id\n              title\n              text\n\n            }\n            ... on CmsWysiwygBlock {\n              id\n              html\n\n            }\n            ... on CmsHeadingBlock {\n              id\n              importance\n              heading\n              addon\n              decoration\n\n            }\n            ... on CmsTextWithIconBlock {\n              id\n              title\n              text\n              imagePosition\n\n            }\n            ... on CmsAccordionBlock {\n              id\n\n            }\n            ... on CmsGridBlock {\n              id\n\n            }\n            ... on CmsImageBlock {\n              id\n              text\n              fluid\n\n            }\n            ... on CmsEmployeesBlock {\n              id\n\n            }\n            ... on CmsContactBannerBlock {\n              id\n              phone\n              email\n\n            }\n            ... on CmsNewsletterRegisterBlock {\n              id\n              fluid\n\n            }\n            ... on CmsIssuuCatalogBlock {\n              id\n              publicationCode\n              accountName\n\n            }\n            ... on CmsFormBlock {\n              id\n              formName\n\n            }\n            ... on CmsHeaderSliderBlock {\n              id\n\n            }\n            ... on CmsBestsellerSliderBlock {\n              id\n              fluid\n\n            }\n            ... on CmsFilterLeadBlock {\n              id\n              layout\n\n            }\n            ... on CmsTravelTypesBlock {\n              id\n              layout\n\n            }\n            ... on CmsPrefilteredTravelsBlock {\n              id\n              maxResults\n\n            }\n            ... on CmsDividerBlock {\n              id\n              fluid\n\n            }\n            ... on CmsTravelSelectionBlock {\n              id\n\n            }\n            ... on CmsIframeBlock {\n              id\n              url\n              minHeight\n\n            }\n            ... on CmsSliderBlock {\n              id\n              fluid\n              size\n              showDots\n              showArrows\n              showLightbox\n              autoplay\n\n            }\n            ... on CmsDestinationsBlock {\n              id\n\n            }\n            ... on CmsTravelGuidesBlock {\n              id\n\n            }\n            ... on CmsBusfinderBlock {\n              id\n              title\n\n            }\n            ... on CmsBackgroundBlock {\n              id\n              backgroundVariant\n\n            }\n          }\n        }\n      }\n      categories @include(if: $withCategories) {\n        id\n        name\n        pages @include(if: $withCategoriesPages) {\n          id\n          name\n          onlineStatus\n          seoSettings @include(if: $withCategoriesPagesSeoSettings) {\n            id\n            urlSlug\n            metaTitle\n            metaDescription\n            ogTitle\n            ogDescription\n          }\n          contentBlockAssignments @include(if: $withCategoriesPagesContentBlockAssignments) {\n            id\n            type\n          }\n        }\n        seoSettings @include(if: $withCategoriesSeoSettings) {\n          id\n          urlSlug\n          metaTitle\n          metaDescription\n          ogTitle\n          ogDescription\n          ogImage @include(if: $withCategoriesSeoSettingsOgImage) {\n            id\n            assetId\n            publicId\n            url\n            resourceType\n            format\n            width\n            height\n            caption\n            title\n            description\n          }\n        }\n      }\n      pages @include(if: $withPages) {\n        id\n        name\n        onlineStatus\n        seoSettings @include(if: $withPagesSeoSettings) {\n          id\n          urlSlug\n          metaTitle\n          metaDescription\n          ogTitle\n          ogDescription\n          ogImage @include(if: $withPagesSeoSettingsOgImage) {\n            id\n            assetId\n            publicId\n            url\n            resourceType\n            format\n            width\n            height\n            caption\n            title\n            description\n          }\n        }\n        contentBlockAssignments @include(if: $withPagesContentBlockAssignments) {\n          id\n          type\n          block @include(if: $withPagesContentBlockAssignmentsBlock) {\n            __typename\n            ... on CmsTextBlock {\n              id\n              text\n\n            }\n            ... on CmsTextWithImageBlock {\n              id\n              title\n              subtitle\n              text\n              imagePosition\n              imageFixedAspectRatio\n\n            }\n            ... on CmsPageHeaderBlock {\n              id\n              title\n              text\n\n            }\n            ... on CmsWysiwygBlock {\n              id\n              html\n\n            }\n            ... on CmsHeadingBlock {\n              id\n              importance\n              heading\n              addon\n              decoration\n\n            }\n            ... on CmsTextWithIconBlock {\n              id\n              title\n              text\n              imagePosition\n\n            }\n            ... on CmsAccordionBlock {\n              id\n\n            }\n            ... on CmsGridBlock {\n              id\n\n            }\n            ... on CmsImageBlock {\n              id\n              text\n              fluid\n\n            }\n            ... on CmsEmployeesBlock {\n              id\n\n            }\n            ... on CmsContactBannerBlock {\n              id\n              phone\n              email\n\n            }\n            ... on CmsNewsletterRegisterBlock {\n              id\n              fluid\n\n            }\n            ... on CmsIssuuCatalogBlock {\n              id\n              publicationCode\n              accountName\n\n            }\n            ... on CmsFormBlock {\n              id\n              formName\n\n            }\n            ... on CmsHeaderSliderBlock {\n              id\n\n            }\n            ... on CmsBestsellerSliderBlock {\n              id\n              fluid\n\n            }\n            ... on CmsFilterLeadBlock {\n              id\n              layout\n\n            }\n            ... on CmsTravelTypesBlock {\n              id\n              layout\n\n            }\n            ... on CmsPrefilteredTravelsBlock {\n              id\n              maxResults\n\n            }\n            ... on CmsDividerBlock {\n              id\n              fluid\n\n            }\n            ... on CmsTravelSelectionBlock {\n              id\n\n            }\n            ... on CmsIframeBlock {\n              id\n              url\n              minHeight\n\n            }\n            ... on CmsSliderBlock {\n              id\n              fluid\n              size\n              showDots\n              showArrows\n              showLightbox\n              autoplay\n\n            }\n            ... on CmsDestinationsBlock {\n              id\n\n            }\n            ... on CmsTravelGuidesBlock {\n              id\n\n            }\n            ... on CmsBusfinderBlock {\n              id\n              title\n\n            }\n            ... on CmsBackgroundBlock {\n              id\n              backgroundVariant\n\n            }\n          }\n        }\n      }\n      errorPage404 @include(if: $withErrorPage404) {\n        id\n        name\n        onlineStatus\n        seoSettings @include(if: $withErrorPage404SeoSettings) {\n          id\n          urlSlug\n          metaTitle\n          metaDescription\n          ogTitle\n          ogDescription\n          ogImage @include(if: $withErrorPage404SeoSettingsOgImage) {\n            id\n            assetId\n            publicId\n            url\n            resourceType\n            format\n            width\n            height\n            caption\n            title\n            description\n          }\n        }\n        contentBlockAssignments @include(if: $withErrorPage404ContentBlockAssignments) {\n          id\n          type\n          block @include(if: $withErrorPage404ContentBlockAssignmentsBlock) {\n            __typename\n            ... on CmsTextBlock {\n              id\n              text\n\n            }\n            ... on CmsTextWithImageBlock {\n              id\n              title\n              subtitle\n              text\n              imagePosition\n              imageFixedAspectRatio\n\n            }\n            ... on CmsPageHeaderBlock {\n              id\n              title\n              text\n\n            }\n            ... on CmsWysiwygBlock {\n              id\n              html\n\n            }\n            ... on CmsHeadingBlock {\n              id\n              importance\n              heading\n              addon\n              decoration\n\n            }\n            ... on CmsTextWithIconBlock {\n              id\n              title\n              text\n              imagePosition\n\n            }\n            ... on CmsAccordionBlock {\n              id\n\n            }\n            ... on CmsGridBlock {\n              id\n\n            }\n            ... on CmsImageBlock {\n              id\n              text\n              fluid\n\n            }\n            ... on CmsEmployeesBlock {\n              id\n\n            }\n            ... on CmsContactBannerBlock {\n              id\n              phone\n              email\n\n            }\n            ... on CmsNewsletterRegisterBlock {\n              id\n              fluid\n\n            }\n            ... on CmsIssuuCatalogBlock {\n              id\n              publicationCode\n              accountName\n\n            }\n            ... on CmsFormBlock {\n              id\n              formName\n\n            }\n            ... on CmsHeaderSliderBlock {\n              id\n\n            }\n            ... on CmsBestsellerSliderBlock {\n              id\n              fluid\n\n            }\n            ... on CmsFilterLeadBlock {\n              id\n              layout\n\n            }\n            ... on CmsTravelTypesBlock {\n              id\n              layout\n\n            }\n            ... on CmsPrefilteredTravelsBlock {\n              id\n              maxResults\n\n            }\n            ... on CmsDividerBlock {\n              id\n              fluid\n\n            }\n            ... on CmsTravelSelectionBlock {\n              id\n\n            }\n            ... on CmsIframeBlock {\n              id\n              url\n              minHeight\n\n            }\n            ... on CmsSliderBlock {\n              id\n              fluid\n              size\n              showDots\n              showArrows\n              showLightbox\n              autoplay\n\n            }\n            ... on CmsDestinationsBlock {\n              id\n\n            }\n            ... on CmsTravelGuidesBlock {\n              id\n\n            }\n            ... on CmsBusfinderBlock {\n              id\n              title\n\n            }\n            ... on CmsBackgroundBlock {\n              id\n              backgroundVariant\n\n            }\n          }\n        }\n      }\n      errorPage500 @include(if: $withErrorPage500) {\n        id\n        name\n        onlineStatus\n        seoSettings @include(if: $withErrorPage500SeoSettings) {\n          id\n          urlSlug\n          metaTitle\n          metaDescription\n          ogTitle\n          ogDescription\n          ogImage @include(if: $withErrorPage500SeoSettingsOgImage) {\n            id\n            assetId\n            publicId\n            url\n            resourceType\n            format\n            width\n            height\n            caption\n            title\n            description\n          }\n        }\n        contentBlockAssignments @include(if: $withErrorPage500ContentBlockAssignments) {\n          id\n          type\n          block @include(if: $withErrorPage500ContentBlockAssignmentsBlock) {\n            __typename\n            ... on CmsTextBlock {\n              id\n              text\n\n            }\n            ... on CmsTextWithImageBlock {\n              id\n              title\n              subtitle\n              text\n              imagePosition\n              imageFixedAspectRatio\n\n            }\n            ... on CmsPageHeaderBlock {\n              id\n              title\n              text\n\n            }\n            ... on CmsWysiwygBlock {\n              id\n              html\n\n            }\n            ... on CmsHeadingBlock {\n              id\n              importance\n              heading\n              addon\n              decoration\n\n            }\n            ... on CmsTextWithIconBlock {\n              id\n              title\n              text\n              imagePosition\n\n            }\n            ... on CmsAccordionBlock {\n              id\n\n            }\n            ... on CmsGridBlock {\n              id\n\n            }\n            ... on CmsImageBlock {\n              id\n              text\n              fluid\n\n            }\n            ... on CmsEmployeesBlock {\n              id\n\n            }\n            ... on CmsContactBannerBlock {\n              id\n              phone\n              email\n\n            }\n            ... on CmsNewsletterRegisterBlock {\n              id\n              fluid\n\n            }\n            ... on CmsIssuuCatalogBlock {\n              id\n              publicationCode\n              accountName\n\n            }\n            ... on CmsFormBlock {\n              id\n              formName\n\n            }\n            ... on CmsHeaderSliderBlock {\n              id\n\n            }\n            ... on CmsBestsellerSliderBlock {\n              id\n              fluid\n\n            }\n            ... on CmsFilterLeadBlock {\n              id\n              layout\n\n            }\n            ... on CmsTravelTypesBlock {\n              id\n              layout\n\n            }\n            ... on CmsPrefilteredTravelsBlock {\n              id\n              maxResults\n\n            }\n            ... on CmsDividerBlock {\n              id\n              fluid\n\n            }\n            ... on CmsTravelSelectionBlock {\n              id\n\n            }\n            ... on CmsIframeBlock {\n              id\n              url\n              minHeight\n\n            }\n            ... on CmsSliderBlock {\n              id\n              fluid\n              size\n              showDots\n              showArrows\n              showLightbox\n              autoplay\n\n            }\n            ... on CmsDestinationsBlock {\n              id\n\n            }\n            ... on CmsTravelGuidesBlock {\n              id\n\n            }\n            ... on CmsBusfinderBlock {\n              id\n              title\n\n            }\n            ... on CmsBackgroundBlock {\n              id\n              backgroundVariant\n\n            }\n          }\n        }\n      }\n      config @include(if: $withConfig) {\n        id\n        contactBlockSettings @include(if: $withConfigContactBlockSettings) {\n          id\n          slogan\n          title\n          text\n          phonePrefix\n          phone\n          phone2Prefix\n          phone2\n          openingHours1\n          openingHours2\n          email\n        }\n        socialMediaSettings @include(if: $withConfigSocialMediaSettings) {\n          id\n          facebookUrl\n          instagramUrl\n        }\n        privacyPolicyPage @include(if: $withConfigPrivacyPolicyPage) {\n          id\n          name\n          onlineStatus\n          seoSettings @include(if: $withConfigPrivacyPolicyPageSeoSettings) {\n            id\n            urlSlug\n            metaTitle\n            metaDescription\n            ogTitle\n            ogDescription\n          }\n          contentBlockAssignments @include(if: $withConfigPrivacyPolicyPageContentBlockAssignments) {\n            id\n            type\n          }\n        }\n        gtcPage @include(if: $withConfigGtcPage) {\n          id\n          name\n          onlineStatus\n          seoSettings @include(if: $withConfigGtcPageSeoSettings) {\n            id\n            urlSlug\n            metaTitle\n            metaDescription\n            ogTitle\n            ogDescription\n          }\n          contentBlockAssignments @include(if: $withConfigGtcPageContentBlockAssignments) {\n            id\n            type\n          }\n        }\n      }\n    }\n  }";
// language=GraphQL
var UPDATE_CMS_MUTATION = "\n  mutation Mutation($input: UpdateTenantCmsInput, $withHomepage: Boolean = false, $withHomepageSeoSettings: Boolean = false, $withHomepageSeoSettingsOgImage: Boolean = false, $withHomepageContentBlockAssignments: Boolean = false, $withHomepageContentBlockAssignmentsBlock: Boolean = false, $withCategories: Boolean = false, $withCategoriesPages: Boolean = false, $withCategoriesPagesSeoSettings: Boolean = false, $withCategoriesPagesContentBlockAssignments: Boolean = false, $withCategoriesSeoSettings: Boolean = false, $withCategoriesSeoSettingsOgImage: Boolean = false, $withPages: Boolean = false, $withPagesSeoSettings: Boolean = false, $withPagesSeoSettingsOgImage: Boolean = false, $withPagesContentBlockAssignments: Boolean = false, $withPagesContentBlockAssignmentsBlock: Boolean = false, $withErrorPage404: Boolean = false, $withErrorPage404SeoSettings: Boolean = false, $withErrorPage404SeoSettingsOgImage: Boolean = false, $withErrorPage404ContentBlockAssignments: Boolean = false, $withErrorPage404ContentBlockAssignmentsBlock: Boolean = false, $withErrorPage500: Boolean = false, $withErrorPage500SeoSettings: Boolean = false, $withErrorPage500SeoSettingsOgImage: Boolean = false, $withErrorPage500ContentBlockAssignments: Boolean = false, $withErrorPage500ContentBlockAssignmentsBlock: Boolean = false, $withConfig: Boolean = false, $withConfigContactBlockSettings: Boolean = false, $withConfigSocialMediaSettings: Boolean = false, $withConfigPrivacyPolicyPage: Boolean = false, $withConfigPrivacyPolicyPageSeoSettings: Boolean = false, $withConfigPrivacyPolicyPageContentBlockAssignments: Boolean = false, $withConfigGtcPage: Boolean = false, $withConfigGtcPageSeoSettings: Boolean = false, $withConfigGtcPageContentBlockAssignments: Boolean = false) {\n    cms: updateTenantCms(input: $input) {\n      id\n      homepage @include(if: $withHomepage) {\n        id\n        name\n        onlineStatus\n        seoSettings @include(if: $withHomepageSeoSettings) {\n          id\n          urlSlug\n          metaTitle\n          metaDescription\n          ogTitle\n          ogDescription\n          ogImage @include(if: $withHomepageSeoSettingsOgImage) {\n            id\n            assetId\n            publicId\n            url\n            resourceType\n            format\n            width\n            height\n            caption\n            title\n            description\n          }\n        }\n        contentBlockAssignments @include(if: $withHomepageContentBlockAssignments) {\n          id\n          type\n          block @include(if: $withHomepageContentBlockAssignmentsBlock) {\n            __typename\n            ... on CmsTextBlock {\n              id\n              text\n\n            }\n            ... on CmsTextWithImageBlock {\n              id\n              title\n              subtitle\n              text\n              imagePosition\n              imageFixedAspectRatio\n\n            }\n            ... on CmsPageHeaderBlock {\n              id\n              title\n              text\n\n            }\n            ... on CmsWysiwygBlock {\n              id\n              html\n\n            }\n            ... on CmsHeadingBlock {\n              id\n              importance\n              heading\n              addon\n              decoration\n\n            }\n            ... on CmsTextWithIconBlock {\n              id\n              title\n              text\n              imagePosition\n\n            }\n            ... on CmsAccordionBlock {\n              id\n\n            }\n            ... on CmsGridBlock {\n              id\n\n            }\n            ... on CmsImageBlock {\n              id\n              text\n              fluid\n\n            }\n            ... on CmsEmployeesBlock {\n              id\n\n            }\n            ... on CmsContactBannerBlock {\n              id\n              phone\n              email\n\n            }\n            ... on CmsNewsletterRegisterBlock {\n              id\n              fluid\n\n            }\n            ... on CmsIssuuCatalogBlock {\n              id\n              publicationCode\n              accountName\n\n            }\n            ... on CmsFormBlock {\n              id\n              formName\n\n            }\n            ... on CmsHeaderSliderBlock {\n              id\n\n            }\n            ... on CmsBestsellerSliderBlock {\n              id\n              fluid\n\n            }\n            ... on CmsFilterLeadBlock {\n              id\n              layout\n\n            }\n            ... on CmsTravelTypesBlock {\n              id\n              layout\n\n            }\n            ... on CmsPrefilteredTravelsBlock {\n              id\n              maxResults\n\n            }\n            ... on CmsDividerBlock {\n              id\n              fluid\n\n            }\n            ... on CmsTravelSelectionBlock {\n              id\n\n            }\n            ... on CmsIframeBlock {\n              id\n              url\n              minHeight\n\n            }\n            ... on CmsSliderBlock {\n              id\n              fluid\n              size\n              showDots\n              showArrows\n              showLightbox\n              autoplay\n\n            }\n            ... on CmsDestinationsBlock {\n              id\n\n            }\n            ... on CmsTravelGuidesBlock {\n              id\n\n            }\n            ... on CmsBusfinderBlock {\n              id\n              title\n\n            }\n            ... on CmsBackgroundBlock {\n              id\n              backgroundVariant\n\n            }\n          }\n        }\n      }\n      categories @include(if: $withCategories) {\n        id\n        name\n        pages @include(if: $withCategoriesPages) {\n          id\n          name\n          onlineStatus\n          seoSettings @include(if: $withCategoriesPagesSeoSettings) {\n            id\n            urlSlug\n            metaTitle\n            metaDescription\n            ogTitle\n            ogDescription\n          }\n          contentBlockAssignments @include(if: $withCategoriesPagesContentBlockAssignments) {\n            id\n            type\n          }\n        }\n        seoSettings @include(if: $withCategoriesSeoSettings) {\n          id\n          urlSlug\n          metaTitle\n          metaDescription\n          ogTitle\n          ogDescription\n          ogImage @include(if: $withCategoriesSeoSettingsOgImage) {\n            id\n            assetId\n            publicId\n            url\n            resourceType\n            format\n            width\n            height\n            caption\n            title\n            description\n          }\n        }\n      }\n      pages @include(if: $withPages) {\n        id\n        name\n        onlineStatus\n        seoSettings @include(if: $withPagesSeoSettings) {\n          id\n          urlSlug\n          metaTitle\n          metaDescription\n          ogTitle\n          ogDescription\n          ogImage @include(if: $withPagesSeoSettingsOgImage) {\n            id\n            assetId\n            publicId\n            url\n            resourceType\n            format\n            width\n            height\n            caption\n            title\n            description\n          }\n        }\n        contentBlockAssignments @include(if: $withPagesContentBlockAssignments) {\n          id\n          type\n          block @include(if: $withPagesContentBlockAssignmentsBlock) {\n            __typename\n            ... on CmsTextBlock {\n              id\n              text\n\n            }\n            ... on CmsTextWithImageBlock {\n              id\n              title\n              subtitle\n              text\n              imagePosition\n              imageFixedAspectRatio\n\n            }\n            ... on CmsPageHeaderBlock {\n              id\n              title\n              text\n\n            }\n            ... on CmsWysiwygBlock {\n              id\n              html\n\n            }\n            ... on CmsHeadingBlock {\n              id\n              importance\n              heading\n              addon\n              decoration\n\n            }\n            ... on CmsTextWithIconBlock {\n              id\n              title\n              text\n              imagePosition\n\n            }\n            ... on CmsAccordionBlock {\n              id\n\n            }\n            ... on CmsGridBlock {\n              id\n\n            }\n            ... on CmsImageBlock {\n              id\n              text\n              fluid\n\n            }\n            ... on CmsEmployeesBlock {\n              id\n\n            }\n            ... on CmsContactBannerBlock {\n              id\n              phone\n              email\n\n            }\n            ... on CmsNewsletterRegisterBlock {\n              id\n              fluid\n\n            }\n            ... on CmsIssuuCatalogBlock {\n              id\n              publicationCode\n              accountName\n\n            }\n            ... on CmsFormBlock {\n              id\n              formName\n\n            }\n            ... on CmsHeaderSliderBlock {\n              id\n\n            }\n            ... on CmsBestsellerSliderBlock {\n              id\n              fluid\n\n            }\n            ... on CmsFilterLeadBlock {\n              id\n              layout\n\n            }\n            ... on CmsTravelTypesBlock {\n              id\n              layout\n\n            }\n            ... on CmsPrefilteredTravelsBlock {\n              id\n              maxResults\n\n            }\n            ... on CmsDividerBlock {\n              id\n              fluid\n\n            }\n            ... on CmsTravelSelectionBlock {\n              id\n\n            }\n            ... on CmsIframeBlock {\n              id\n              url\n              minHeight\n\n            }\n            ... on CmsSliderBlock {\n              id\n              fluid\n              size\n              showDots\n              showArrows\n              showLightbox\n              autoplay\n\n            }\n            ... on CmsDestinationsBlock {\n              id\n\n            }\n            ... on CmsTravelGuidesBlock {\n              id\n\n            }\n            ... on CmsBusfinderBlock {\n              id\n              title\n\n            }\n            ... on CmsBackgroundBlock {\n              id\n              backgroundVariant\n\n            }\n          }\n        }\n      }\n      errorPage404 @include(if: $withErrorPage404) {\n        id\n        name\n        onlineStatus\n        seoSettings @include(if: $withErrorPage404SeoSettings) {\n          id\n          urlSlug\n          metaTitle\n          metaDescription\n          ogTitle\n          ogDescription\n          ogImage @include(if: $withErrorPage404SeoSettingsOgImage) {\n            id\n            assetId\n            publicId\n            url\n            resourceType\n            format\n            width\n            height\n            caption\n            title\n            description\n          }\n        }\n        contentBlockAssignments @include(if: $withErrorPage404ContentBlockAssignments) {\n          id\n          type\n          block @include(if: $withErrorPage404ContentBlockAssignmentsBlock) {\n            __typename\n            ... on CmsTextBlock {\n              id\n              text\n\n            }\n            ... on CmsTextWithImageBlock {\n              id\n              title\n              subtitle\n              text\n              imagePosition\n              imageFixedAspectRatio\n\n            }\n            ... on CmsPageHeaderBlock {\n              id\n              title\n              text\n\n            }\n            ... on CmsWysiwygBlock {\n              id\n              html\n\n            }\n            ... on CmsHeadingBlock {\n              id\n              importance\n              heading\n              addon\n              decoration\n\n            }\n            ... on CmsTextWithIconBlock {\n              id\n              title\n              text\n              imagePosition\n\n            }\n            ... on CmsAccordionBlock {\n              id\n\n            }\n            ... on CmsGridBlock {\n              id\n\n            }\n            ... on CmsImageBlock {\n              id\n              text\n              fluid\n\n            }\n            ... on CmsEmployeesBlock {\n              id\n\n            }\n            ... on CmsContactBannerBlock {\n              id\n              phone\n              email\n\n            }\n            ... on CmsNewsletterRegisterBlock {\n              id\n              fluid\n\n            }\n            ... on CmsIssuuCatalogBlock {\n              id\n              publicationCode\n              accountName\n\n            }\n            ... on CmsFormBlock {\n              id\n              formName\n\n            }\n            ... on CmsHeaderSliderBlock {\n              id\n\n            }\n            ... on CmsBestsellerSliderBlock {\n              id\n              fluid\n\n            }\n            ... on CmsFilterLeadBlock {\n              id\n              layout\n\n            }\n            ... on CmsTravelTypesBlock {\n              id\n              layout\n\n            }\n            ... on CmsPrefilteredTravelsBlock {\n              id\n              maxResults\n\n            }\n            ... on CmsDividerBlock {\n              id\n              fluid\n\n            }\n            ... on CmsTravelSelectionBlock {\n              id\n\n            }\n            ... on CmsIframeBlock {\n              id\n              url\n              minHeight\n\n            }\n            ... on CmsSliderBlock {\n              id\n              fluid\n              size\n              showDots\n              showArrows\n              showLightbox\n              autoplay\n\n            }\n            ... on CmsDestinationsBlock {\n              id\n\n            }\n            ... on CmsTravelGuidesBlock {\n              id\n\n            }\n            ... on CmsBusfinderBlock {\n              id\n              title\n\n            }\n            ... on CmsBackgroundBlock {\n              id\n              backgroundVariant\n\n            }\n          }\n        }\n      }\n      errorPage500 @include(if: $withErrorPage500) {\n        id\n        name\n        onlineStatus\n        seoSettings @include(if: $withErrorPage500SeoSettings) {\n          id\n          urlSlug\n          metaTitle\n          metaDescription\n          ogTitle\n          ogDescription\n          ogImage @include(if: $withErrorPage500SeoSettingsOgImage) {\n            id\n            assetId\n            publicId\n            url\n            resourceType\n            format\n            width\n            height\n            caption\n            title\n            description\n          }\n        }\n        contentBlockAssignments @include(if: $withErrorPage500ContentBlockAssignments) {\n          id\n          type\n          block @include(if: $withErrorPage500ContentBlockAssignmentsBlock) {\n            __typename\n            ... on CmsTextBlock {\n              id\n              text\n\n            }\n            ... on CmsTextWithImageBlock {\n              id\n              title\n              subtitle\n              text\n              imagePosition\n              imageFixedAspectRatio\n\n            }\n            ... on CmsPageHeaderBlock {\n              id\n              title\n              text\n\n            }\n            ... on CmsWysiwygBlock {\n              id\n              html\n\n            }\n            ... on CmsHeadingBlock {\n              id\n              importance\n              heading\n              addon\n              decoration\n\n            }\n            ... on CmsTextWithIconBlock {\n              id\n              title\n              text\n              imagePosition\n\n            }\n            ... on CmsAccordionBlock {\n              id\n\n            }\n            ... on CmsGridBlock {\n              id\n\n            }\n            ... on CmsImageBlock {\n              id\n              text\n              fluid\n\n            }\n            ... on CmsEmployeesBlock {\n              id\n\n            }\n            ... on CmsContactBannerBlock {\n              id\n              phone\n              email\n\n            }\n            ... on CmsNewsletterRegisterBlock {\n              id\n              fluid\n\n            }\n            ... on CmsIssuuCatalogBlock {\n              id\n              publicationCode\n              accountName\n\n            }\n            ... on CmsFormBlock {\n              id\n              formName\n\n            }\n            ... on CmsHeaderSliderBlock {\n              id\n\n            }\n            ... on CmsBestsellerSliderBlock {\n              id\n              fluid\n\n            }\n            ... on CmsFilterLeadBlock {\n              id\n              layout\n\n            }\n            ... on CmsTravelTypesBlock {\n              id\n              layout\n\n            }\n            ... on CmsPrefilteredTravelsBlock {\n              id\n              maxResults\n\n            }\n            ... on CmsDividerBlock {\n              id\n              fluid\n\n            }\n            ... on CmsTravelSelectionBlock {\n              id\n\n            }\n            ... on CmsIframeBlock {\n              id\n              url\n              minHeight\n\n            }\n            ... on CmsSliderBlock {\n              id\n              fluid\n              size\n              showDots\n              showArrows\n              showLightbox\n              autoplay\n\n            }\n            ... on CmsDestinationsBlock {\n              id\n\n            }\n            ... on CmsTravelGuidesBlock {\n              id\n\n            }\n            ... on CmsBusfinderBlock {\n              id\n              title\n\n            }\n            ... on CmsBackgroundBlock {\n              id\n              backgroundVariant\n\n            }\n          }\n        }\n      }\n      config @include(if: $withConfig) {\n        id\n        contactBlockSettings @include(if: $withConfigContactBlockSettings) {\n          id\n          slogan\n          title\n          text\n          phonePrefix\n          phone\n          phone2Prefix\n          phone2\n          openingHours1\n          openingHours2\n          email\n        }\n        socialMediaSettings @include(if: $withConfigSocialMediaSettings) {\n          id\n          facebookUrl\n          instagramUrl\n        }\n        privacyPolicyPage @include(if: $withConfigPrivacyPolicyPage) {\n          id\n          name\n          onlineStatus\n          seoSettings @include(if: $withConfigPrivacyPolicyPageSeoSettings) {\n            id\n            urlSlug\n            metaTitle\n            metaDescription\n            ogTitle\n            ogDescription\n          }\n          contentBlockAssignments @include(if: $withConfigPrivacyPolicyPageContentBlockAssignments) {\n            id\n            type\n          }\n        }\n        gtcPage @include(if: $withConfigGtcPage) {\n          id\n          name\n          onlineStatus\n          seoSettings @include(if: $withConfigGtcPageSeoSettings) {\n            id\n            urlSlug\n            metaTitle\n            metaDescription\n            ogTitle\n            ogDescription\n          }\n          contentBlockAssignments @include(if: $withConfigGtcPageContentBlockAssignments) {\n            id\n            type\n          }\n        }\n      }\n    }\n  }";
// language=GraphQL
var DELETE_CMS_MUTATION = "\n  mutation Mutation($input: DeleteTenantCmsInput) {\n    deleteTenantCms(input: $input) {\n      success\n    }\n  }";
// language=GraphQL
var FORCE_DELETE_CMS_MUTATION = "\n  mutation Mutation($input: DeleteTenantCmsInput) {\n    forceDeleteTenantCms(input: $input) {\n      success\n    }\n  }";
// language=GraphQL
var ADD_CMS_CATEGORIES_MUTATION = "\n  mutation Mutation($input: addTenantCmsCategoriesInput) {\n    addTenantCmsCategories(input: $input) {\n      id\n      categoryIds\n    }\n  }";
// language=GraphQL
var REMOVE_CMS_CATEGORIES_MUTATION = "\n  mutation Mutation($input: removeTenantCmsCategoriesInput) {\n    removeTenantCmsCategories(input: $input) {\n      id\n      categoryIds\n    }\n  }";
// language=GraphQL
var CREATE_CMS_CATEGORIES_MUTATION = "\n  mutation Mutation($input: createTenantCmsCategoriesInput) {\n    createTenantCmsCategories(input: $input) {\n      id\n      categoryIds\n    }\n  }";
// language=GraphQL
var DELETE_CMS_CATEGORIES_MUTATION = "\n  mutation Mutation($input: deleteTenantCmsCategoriesInput) {\n    deleteTenantCmsCategories(input: $input) {\n      id\n      categoryIds\n    }\n  }";
// language=GraphQL
var UPDATE_CMS_CATEGORIES_ORDER_MUTATION = "\n  mutation Mutation($input: updateTenantCmsCategoriesOrderInput) {\n    updateTenantCmsCategoriesOrder(input: $input) {\n      id\n      categoryIds\n    }\n  }";
// language=GraphQL
var ADD_CMS_PAGES_MUTATION = "\n  mutation Mutation($input: addTenantCmsPagesInput) {\n    addTenantCmsPages(input: $input) {\n      id\n      pageIds\n    }\n  }";
// language=GraphQL
var REMOVE_CMS_PAGES_MUTATION = "\n  mutation Mutation($input: removeTenantCmsPagesInput) {\n    removeTenantCmsPages(input: $input) {\n      id\n      pageIds\n    }\n  }";
// language=GraphQL
var CREATE_CMS_PAGES_MUTATION = "\n  mutation Mutation($input: createTenantCmsPagesInput) {\n    createTenantCmsPages(input: $input) {\n      id\n      pageIds\n    }\n  }";
// language=GraphQL
var DELETE_CMS_PAGES_MUTATION = "\n  mutation Mutation($input: deleteTenantCmsPagesInput) {\n    deleteTenantCmsPages(input: $input) {\n      id\n      pageIds\n    }\n  }";
// language=GraphQL
var CMS_DEPENDENTS_QUERY = "query Query($id: ID!, $withTenants: Boolean = false) {\n  groupedDependents: tenantCmsDependents(id: $id) {\n    tenants @include(if: $withTenants) {\n      id\n      name\n      slug\n      domain\n      externalReference\n    }\n  }\n}";

// EXTERNAL MODULE: ./src/entities/cmsPage/entity.ts + 3 modules
var entity = __webpack_require__(49647);
// EXTERNAL MODULE: ./src/entities/cmsCategory/entity.ts + 3 modules
var cmsCategory_entity = __webpack_require__(4377);
// EXTERNAL MODULE: ./src/entities/cmsConfig/entity.ts + 3 modules
var cmsConfig_entity = __webpack_require__(78069);
;// CONCATENATED MODULE: ./src/entities/tenantCms/model.ts




var tenantCmsModel = {
    name: "cms",
    namePlural: "cms",
    uniqueName: "tenantCms",
    uniqueNamePlural: "tenantCms",
    path: "config/tenant/cms",
    baseUrl: "/config/tenant/cms",
    translationPrefix: "entities:tenantCms.",
    getDisplayName: function(values) {
        return "Tenant CMS";
    },
    gql: {
        getAll: ALL_CMS_QUERY,
        getSingle: SINGLE_CMS_QUERY,
        create: CREATE_CMS_MUTATION,
        update: UPDATE_CMS_MUTATION,
        delete: DELETE_CMS_MUTATION,
        forceDelete: FORCE_DELETE_CMS_MUTATION
    },
    attributes: {
        homepage: {
            name: "homepage",
            label: "entities:tenantCms.attributes.homepage.label",
            type: "entityObject",
            dataType: "any",
            getEntity: function() {
                return entity/* default */.Z;
            },
            defaultInput: false,
            inputType: "select",
            validationType: "string",
            validations: []
        },
        categories: {
            name: "categories",
            label: "entities:tenantCms.attributes.categories.label",
            type: "entityCollection",
            dataType: "[any]",
            getEntity: function() {
                return cmsCategory_entity/* default */.Z;
            },
            defaultInput: false,
            inputType: "text",
            validationType: "string",
            validations: []
        },
        pages: {
            name: "pages",
            label: "entities:tenantCms.attributes.pages.label",
            type: "entityCollection",
            dataType: "[any]",
            getEntity: function() {
                return entity/* default */.Z;
            },
            defaultInput: false,
            inputType: "text",
            validationType: "string",
            validations: []
        },
        errorPage404: {
            name: "errorPage404",
            label: "entities:tenantCms.attributes.errorPage404.label",
            type: "entityObject",
            dataType: "any",
            getEntity: function() {
                return entity/* default */.Z;
            },
            defaultInput: false,
            inputType: "select",
            validationType: "string",
            validations: []
        },
        errorPage500: {
            name: "errorPage500",
            label: "entities:tenantCms.attributes.errorPage500.label",
            type: "entityObject",
            dataType: "any",
            getEntity: function() {
                return entity/* default */.Z;
            },
            defaultInput: false,
            inputType: "select",
            validationType: "string",
            validations: []
        },
        config: {
            name: "config",
            label: "entities:tenantCms.attributes.config.label",
            type: "entityObject",
            dataType: "any",
            getEntity: function() {
                return cmsConfig_entity/* default */.Z;
            },
            defaultInput: false,
            inputType: "select",
            validationType: "string",
            validations: []
        }
    }
};
/* harmony default export */ var model = (tenantCmsModel);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(20414);
// EXTERNAL MODULE: ./src/entities/lib.ts
var lib = __webpack_require__(23480);
// EXTERNAL MODULE: ./src/lib/api/graphQLClient.ts
var graphQLClient = __webpack_require__(40112);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/swr/dist/index.mjs
var dist = __webpack_require__(8100);
// EXTERNAL MODULE: ./src/lib/helpers/helpers.ts
var helpers = __webpack_require__(15778);
;// CONCATENATED MODULE: ./src/entities/tenantCms/repository.ts










var hydrateObjects = function(objects) {
    return objects.map(function(object) {
        return (0,lib/* hydrateEntityObject */.b)(model, object);
    });
};
var hydrateObject = function(object) {
    return (0,lib/* hydrateEntityObject */.b)(model, object);
};
var tenantCmsRepository = {
    getObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    id: id
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(SINGLE_CMS_QUERY, variables).then(function(data) {
                        return hydrateObject(data.cms);
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }(),
    getObjects: /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        var includes;
        var _arguments = arguments;
        return (0,tslib_es6.__generator)(this, function(_state) {
            includes = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : {};
            return [
                2,
                graphQLClient/* default.request */.Z.request(ALL_CMS_QUERY, includes).then(function(data) {
                    return hydrateObjects(data.cms);
                })
            ];
        });
    }),
    useObject: function(id) {
        var includes = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        // eslint-disable-next-line react-hooks/exhaustive-deps
        var variables = (0,react.useMemo)(function() {
            return (0,_object_spread/* default */.Z)({
                id: id
            }, includes);
        }, [
            id
        ]);
        var ref = (0,dist/* default */.ZP)([
            SINGLE_CMS_QUERY,
            variables
        ], {
            revalidateOnFocus: false
        }), data = ref.data, error = ref.error, mutate = ref.mutate;
        return {
            object: !data ? data : hydrateObject(data.cms),
            isLoading: !error && !data,
            isError: error,
            mutate: mutate
        };
    },
    useObjects: function() {
        var includes = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        // eslint-disable-next-line react-hooks/exhaustive-deps
        var variables = (0,react.useMemo)(function() {
            return includes;
        }, []);
        var ref = (0,dist/* default */.ZP)([
            ALL_CMS_QUERY,
            variables
        ]), data = ref.data, error = ref.error, mutate = ref.mutate;
        return {
            objects: !data ? data : hydrateObjects(data.cms),
            isLoading: !error && !data,
            isError: error,
            mutate: mutate
        };
    },
    getDependents: function(id, includes) {
        var includeVars = {};
        includes.forEach(function(include) {
            includeVars["with".concat((0,helpers/* uppercaseFirst */.AB)(include))] = true;
        });
        var variables = (0,_object_spread/* default */.Z)({
            id: id
        }, includeVars);
        return graphQLClient/* default.request */.Z.request(CMS_DEPENDENTS_QUERY, variables).then(function(data) {
            return data.groupedDependents;
        });
    },
    useDependents: function(id, includes) {
        var includeVars = {};
        includes.forEach(function(include) {
            includeVars["with".concat((0,helpers/* uppercaseFirst */.AB)(include))] = true;
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
        var variables = (0,react.useMemo)(function() {
            return (0,_object_spread/* default */.Z)({
                id: id
            }, includeVars);
        }, [
            id
        ]);
        var ref = (0,dist/* default */.ZP)([
            CMS_DEPENDENTS_QUERY,
            variables
        ], {
            revalidateOnFocus: false
        }), data = ref.data, error = ref.error, mutate = ref.mutate;
        return {
            data: !data ? data : data.groupedDependents,
            isLoading: !error && !data,
            isError: error,
            mutate: mutate
        };
    },
    createObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(data) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    input: data
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(CREATE_CMS_MUTATION, variables).then(function(data) {
                        return hydrateObject(data.cms);
                    })
                ];
            });
        });
        return function(data) {
            return _ref.apply(this, arguments);
        };
    }(),
    updateObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(data) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    input: data
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(UPDATE_CMS_MUTATION, variables).then(function(data) {
                        return hydrateObject(data.cms);
                    })
                ];
            });
        });
        return function(data) {
            return _ref.apply(this, arguments);
        };
    }(),
    deleteObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(DELETE_CMS_MUTATION, variables).then(function(data) {
                        return data.deleteTenantCms;
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }(),
    forceDeleteObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(FORCE_DELETE_CMS_MUTATION, variables).then(function(data) {
                        return data.forceDeleteTenantCms;
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }(),
    assignCategories: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, itemIds) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        categoryIds: itemIds
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(ADD_CMS_CATEGORIES_MUTATION, variables)
                ];
            });
        });
        return function(id, itemIds) {
            return _ref.apply(this, arguments);
        };
    }(),
    unassignCategories: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, itemIds) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        categoryIds: itemIds
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(REMOVE_CMS_CATEGORIES_MUTATION, variables)
                ];
            });
        });
        return function(id, itemIds) {
            return _ref.apply(this, arguments);
        };
    }(),
    createCategories: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, items) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        categories: items
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(CREATE_CMS_CATEGORIES_MUTATION, variables)
                ];
            });
        });
        return function(id, items) {
            return _ref.apply(this, arguments);
        };
    }(),
    deleteCategories: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, itemIds) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        categoryIds: itemIds
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(DELETE_CMS_CATEGORIES_MUTATION, variables)
                ];
            });
        });
        return function(id, itemIds) {
            return _ref.apply(this, arguments);
        };
    }(),
    updateCategoriesOrder: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, itemIds) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        categoryIds: itemIds
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(UPDATE_CMS_CATEGORIES_ORDER_MUTATION, variables)
                ];
            });
        });
        return function(id, itemIds) {
            return _ref.apply(this, arguments);
        };
    }(),
    assignPages: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, itemIds) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        pageIds: itemIds
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(ADD_CMS_PAGES_MUTATION, variables)
                ];
            });
        });
        return function(id, itemIds) {
            return _ref.apply(this, arguments);
        };
    }(),
    unassignPages: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, itemIds) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        pageIds: itemIds
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(REMOVE_CMS_PAGES_MUTATION, variables)
                ];
            });
        });
        return function(id, itemIds) {
            return _ref.apply(this, arguments);
        };
    }(),
    createPages: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, items) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        pages: items
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(CREATE_CMS_PAGES_MUTATION, variables)
                ];
            });
        });
        return function(id, items) {
            return _ref.apply(this, arguments);
        };
    }(),
    deletePages: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, itemIds) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        pageIds: itemIds
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(DELETE_CMS_PAGES_MUTATION, variables)
                ];
            });
        });
        return function(id, itemIds) {
            return _ref.apply(this, arguments);
        };
    }()
};
/* harmony default export */ var repository = (tenantCmsRepository);

;// CONCATENATED MODULE: ./src/entities/tenantCms/entity.ts


var tenantCmsEntity = {
    model: model,
    repository: repository
};
/* harmony default export */ var tenantCms_entity = (tenantCmsEntity);


/***/ }),

/***/ 61559:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ entity; }
});

;// CONCATENATED MODULE: ./src/entities/tenantContent/graphql.ts
// language=GraphQL
var ALL_TENANT_CONTENTS_QUERY = "query Query {\n  tenantContents: tenantContents {\n    id\n    bookingInsuranceInfo\n  }\n}";
// language=GraphQL
var SINGLE_TENANT_CONTENT_QUERY = "query Query($id: ID!) {\n  tenantContent: tenantContent(id: $id) {\n    id\n    bookingInsuranceInfo\n  }\n}";
// language=GraphQL
var CREATE_TENANT_CONTENT_MUTATION = "\n  mutation Mutation($input: CreateTenantContentInput) {\n    tenantContent: createTenantContent(input: $input) {\n      id\n      bookingInsuranceInfo\n    }\n  }";
// language=GraphQL
var UPDATE_TENANT_CONTENT_MUTATION = "\n  mutation Mutation($input: UpdateTenantContentInput) {\n    tenantContent: updateTenantContent(input: $input) {\n      id\n      bookingInsuranceInfo\n    }\n  }";
// language=GraphQL
var DELETE_TENANT_CONTENT_MUTATION = "\n  mutation Mutation($input: DeleteTenantContentInput) {\n    deleteTenantContent(input: $input) {\n      success\n    }\n  }";
// language=GraphQL
var FORCE_DELETE_TENANT_CONTENT_MUTATION = "\n  mutation Mutation($input: DeleteTenantContentInput) {\n    forceDeleteTenantContent(input: $input) {\n      success\n    }\n  }";
// language=GraphQL
var TENANT_CONTENTS_DEPENDENTS_QUERY = "query Query($id: ID!, $withTenants: Boolean = false) {\n  groupedDependents: tenantContentDependents(id: $id) {\n    tenants @include(if: $withTenants) {\n      id\n      name\n      slug\n      domain\n      externalReference\n    }\n  }\n}";

;// CONCATENATED MODULE: ./src/entities/tenantContent/model.ts

var tenantContentModel = {
    name: "tenantContent",
    namePlural: "tenantContents",
    uniqueName: "tenantContent",
    uniqueNamePlural: "tenantContents",
    path: "config/tenant/tenant_content",
    baseUrl: "/config/tenant/tenant_contents",
    translationPrefix: "entities:tenantContent.",
    getDisplayName: function(values) {
        return "TENANT CONTENT";
    },
    gql: {
        getAll: ALL_TENANT_CONTENTS_QUERY,
        getSingle: SINGLE_TENANT_CONTENT_QUERY,
        create: CREATE_TENANT_CONTENT_MUTATION,
        update: UPDATE_TENANT_CONTENT_MUTATION,
        delete: DELETE_TENANT_CONTENT_MUTATION,
        forceDelete: FORCE_DELETE_TENANT_CONTENT_MUTATION
    },
    attributes: {
        bookingInsuranceInfo: {
            name: "bookingInsuranceInfo",
            label: "entities:tenantContent.attributes.bookingInsuranceInfo.label",
            type: "value",
            dataType: "string",
            defaultInput: true,
            inputType: "wysiwyg",
            validationType: "string",
            validations: [
                {
                    type: "required"
                }, 
            ]
        }
    }
};
/* harmony default export */ var model = (tenantContentModel);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(20414);
// EXTERNAL MODULE: ./src/entities/lib.ts
var lib = __webpack_require__(23480);
// EXTERNAL MODULE: ./src/lib/api/graphQLClient.ts
var graphQLClient = __webpack_require__(40112);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/swr/dist/index.mjs
var dist = __webpack_require__(8100);
// EXTERNAL MODULE: ./src/lib/helpers/helpers.ts
var helpers = __webpack_require__(15778);
;// CONCATENATED MODULE: ./src/entities/tenantContent/repository.ts










var hydrateObjects = function(objects) {
    return objects.map(function(object) {
        return (0,lib/* hydrateEntityObject */.b)(model, object);
    });
};
var hydrateObject = function(object) {
    return (0,lib/* hydrateEntityObject */.b)(model, object);
};
var tenantContentRepository = {
    getObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    id: id
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(SINGLE_TENANT_CONTENT_QUERY, variables).then(function(data) {
                        return hydrateObject(data.tenantContent);
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }(),
    getObjects: /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        var includes;
        var _arguments = arguments;
        return (0,tslib_es6.__generator)(this, function(_state) {
            includes = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : {};
            return [
                2,
                graphQLClient/* default.request */.Z.request(ALL_TENANT_CONTENTS_QUERY, includes).then(function(data) {
                    return hydrateObjects(data.tenantContents);
                })
            ];
        });
    }),
    useObject: function(id) {
        var includes = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        // eslint-disable-next-line react-hooks/exhaustive-deps
        var variables = (0,react.useMemo)(function() {
            return (0,_object_spread/* default */.Z)({
                id: id
            }, includes);
        }, [
            id
        ]);
        var ref = (0,dist/* default */.ZP)([
            SINGLE_TENANT_CONTENT_QUERY,
            variables
        ], {
            revalidateOnFocus: false
        }), data = ref.data, error = ref.error, mutate = ref.mutate;
        return {
            object: !data ? data : hydrateObject(data.tenantContent),
            isLoading: !error && !data,
            isError: error,
            mutate: mutate
        };
    },
    useObjects: function() {
        var includes = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        // eslint-disable-next-line react-hooks/exhaustive-deps
        var variables = (0,react.useMemo)(function() {
            return includes;
        }, []);
        var ref = (0,dist/* default */.ZP)([
            ALL_TENANT_CONTENTS_QUERY,
            variables
        ]), data = ref.data, error = ref.error, mutate = ref.mutate;
        return {
            objects: !data ? data : hydrateObjects(data.tenantContents),
            isLoading: !error && !data,
            isError: error,
            mutate: mutate
        };
    },
    getDependents: function(id, includes) {
        var includeVars = {};
        includes.forEach(function(include) {
            includeVars["with".concat((0,helpers/* uppercaseFirst */.AB)(include))] = true;
        });
        var variables = (0,_object_spread/* default */.Z)({
            id: id
        }, includeVars);
        return graphQLClient/* default.request */.Z.request(TENANT_CONTENTS_DEPENDENTS_QUERY, variables).then(function(data) {
            return data.groupedDependents;
        });
    },
    useDependents: function(id, includes) {
        var includeVars = {};
        includes.forEach(function(include) {
            includeVars["with".concat((0,helpers/* uppercaseFirst */.AB)(include))] = true;
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
        var variables = (0,react.useMemo)(function() {
            return (0,_object_spread/* default */.Z)({
                id: id
            }, includeVars);
        }, [
            id
        ]);
        var ref = (0,dist/* default */.ZP)([
            TENANT_CONTENTS_DEPENDENTS_QUERY,
            variables
        ], {
            revalidateOnFocus: false
        }), data = ref.data, error = ref.error, mutate = ref.mutate;
        return {
            data: !data ? data : data.groupedDependents,
            isLoading: !error && !data,
            isError: error,
            mutate: mutate
        };
    },
    createObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(data) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    input: data
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(CREATE_TENANT_CONTENT_MUTATION, variables).then(function(data) {
                        return hydrateObject(data.tenantContent);
                    })
                ];
            });
        });
        return function(data) {
            return _ref.apply(this, arguments);
        };
    }(),
    updateObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(data) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    input: data
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(UPDATE_TENANT_CONTENT_MUTATION, variables).then(function(data) {
                        return hydrateObject(data.tenantContent);
                    })
                ];
            });
        });
        return function(data) {
            return _ref.apply(this, arguments);
        };
    }(),
    deleteObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(DELETE_TENANT_CONTENT_MUTATION, variables).then(function(data) {
                        return data.deleteTenantContent;
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }(),
    forceDeleteObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(FORCE_DELETE_TENANT_CONTENT_MUTATION, variables).then(function(data) {
                        return data.forceDeleteTenantContent;
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }()
};
/* harmony default export */ var repository = (tenantContentRepository);

;// CONCATENATED MODULE: ./src/entities/tenantContent/entity.ts


var tenantContentEntity = {
    model: model,
    repository: repository
};
/* harmony default export */ var entity = (tenantContentEntity);


/***/ }),

/***/ 22521:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ entity; }
});

;// CONCATENATED MODULE: ./src/entities/tenantEmailConfig/graphql.ts
// language=GraphQL
var ALL_EMAIL_CONFIGS_QUERY = "query Query {\n  emailConfigs: tenantEmailConfigs {\n    id\n    defaultInternalRecipientEmail\n    internalBookingRecipientEmails\n    bookingConfirmationTemplateId\n    bookingConfirmationInternalTemplateId\n    bookingRequestConfirmationTemplateId\n    bookingWaitlistConfirmationTemplateId\n    bookingWaitlistContingentCheckConfirmationTemplateId\n    bookingCustomRequestTemplateId\n    bookingPassportDataReminderTemplateId\n    contactFormTemplateId\n    esimInstallationInfoTemplateId\n  }\n}";
// language=GraphQL
var SINGLE_EMAIL_CONFIG_QUERY = "query Query($id: ID!) {\n  emailConfig: tenantEmailConfig(id: $id) {\n    id\n    defaultInternalRecipientEmail\n    internalBookingRecipientEmails\n    bookingConfirmationTemplateId\n    bookingConfirmationInternalTemplateId\n    bookingRequestConfirmationTemplateId\n    bookingWaitlistConfirmationTemplateId\n    bookingWaitlistContingentCheckConfirmationTemplateId\n    bookingCustomRequestTemplateId\n    bookingPassportDataReminderTemplateId\n    contactFormTemplateId\n    esimInstallationInfoTemplateId\n  }\n}";
// language=GraphQL
var CREATE_EMAIL_CONFIG_MUTATION = "\n  mutation Mutation($input: CreateTenantEmailConfigInput) {\n    emailConfig: createTenantEmailConfig(input: $input) {\n      id\n      defaultInternalRecipientEmail\n      internalBookingRecipientEmails\n      bookingConfirmationTemplateId\n      bookingConfirmationInternalTemplateId\n      bookingRequestConfirmationTemplateId\n      bookingWaitlistConfirmationTemplateId\n      bookingWaitlistContingentCheckConfirmationTemplateId\n      bookingCustomRequestTemplateId\n      bookingPassportDataReminderTemplateId\n      contactFormTemplateId\n      esimInstallationInfoTemplateId\n    }\n  }";
// language=GraphQL
var UPDATE_EMAIL_CONFIG_MUTATION = "\n  mutation Mutation($input: UpdateTenantEmailConfigInput) {\n    emailConfig: updateTenantEmailConfig(input: $input) {\n      id\n      defaultInternalRecipientEmail\n      internalBookingRecipientEmails\n      bookingConfirmationTemplateId\n      bookingConfirmationInternalTemplateId\n      bookingRequestConfirmationTemplateId\n      bookingWaitlistConfirmationTemplateId\n      bookingWaitlistContingentCheckConfirmationTemplateId\n      bookingCustomRequestTemplateId\n      bookingPassportDataReminderTemplateId\n      contactFormTemplateId\n      esimInstallationInfoTemplateId\n    }\n  }";
// language=GraphQL
var DELETE_EMAIL_CONFIG_MUTATION = "\n  mutation Mutation($input: DeleteTenantEmailConfigInput) {\n    deleteTenantEmailConfig(input: $input) {\n      success\n    }\n  }";
// language=GraphQL
var FORCE_DELETE_EMAIL_CONFIG_MUTATION = "\n  mutation Mutation($input: DeleteTenantEmailConfigInput) {\n    forceDeleteTenantEmailConfig(input: $input) {\n      success\n    }\n  }";
// language=GraphQL
var EMAIL_CONFIGS_DEPENDENTS_QUERY = "query Query($id: ID!, $withTenants: Boolean = false) {\n  groupedDependents: tenantEmailConfigDependents(id: $id) {\n    tenants @include(if: $withTenants) {\n      id\n      name\n      slug\n      domain\n      externalReference\n    }\n  }\n}";

;// CONCATENATED MODULE: ./src/entities/tenantEmailConfig/model.ts

var tenantEmailConfigModel = {
    name: "emailConfig",
    namePlural: "emailConfigs",
    uniqueName: "tenantEmailConfig",
    uniqueNamePlural: "tenantEmailConfigs",
    path: "config/tenant/email_config",
    baseUrl: "/config/tenant/email_configs",
    translationPrefix: "entities:tenantEmailConfig.",
    getDisplayName: function(values) {
        return "Emails";
    },
    gql: {
        getAll: ALL_EMAIL_CONFIGS_QUERY,
        getSingle: SINGLE_EMAIL_CONFIG_QUERY,
        create: CREATE_EMAIL_CONFIG_MUTATION,
        update: UPDATE_EMAIL_CONFIG_MUTATION,
        delete: DELETE_EMAIL_CONFIG_MUTATION,
        forceDelete: FORCE_DELETE_EMAIL_CONFIG_MUTATION
    },
    attributes: {
        defaultInternalRecipientEmail: {
            name: "defaultInternalRecipientEmail",
            label: "entities:tenantEmailConfig.attributes.defaultInternalRecipientEmail.label",
            type: "value",
            dataType: "string",
            defaultInput: true,
            inputType: "text",
            validationType: "string",
            validations: [
                {
                    type: "required"
                },
                {
                    type: "email"
                }, 
            ]
        },
        internalBookingRecipientEmails: {
            name: "internalBookingRecipientEmails",
            label: "entities:tenantEmailConfig.attributes.internalBookingRecipientEmails.label",
            type: "value",
            dataType: "string",
            defaultInput: true,
            inputType: "tags",
            validationType: "string",
            validations: [
                {
                    type: "required"
                },
                {
                    type: "regex",
                    pattern: /^(([a-zA-Z0-9_\-\.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([a-zA-Z0-9\-]+\.)+))([a-zA-Z]{2,9}|[0-9]{1,3})(\]?)(\s*,\s*|\s*$))*$/
                }, 
            ]
        },
        bookingConfirmationTemplateId: {
            name: "bookingConfirmationTemplateId",
            label: "entities:tenantEmailConfig.attributes.bookingConfirmationTemplateId.label",
            type: "value",
            dataType: "number",
            defaultInput: true,
            inputType: "text",
            validationType: "string",
            validations: [
                {
                    type: "required"
                },
                {
                    type: "number"
                }, 
            ]
        },
        bookingConfirmationInternalTemplateId: {
            name: "bookingConfirmationInternalTemplateId",
            label: "entities:tenantEmailConfig.attributes.bookingConfirmationInternalTemplateId.label",
            type: "value",
            dataType: "number",
            defaultInput: true,
            inputType: "text",
            validationType: "string",
            validations: []
        },
        bookingRequestConfirmationTemplateId: {
            name: "bookingRequestConfirmationTemplateId",
            label: "entities:tenantEmailConfig.attributes.bookingRequestConfirmationTemplateId.label",
            type: "value",
            dataType: "number",
            defaultInput: true,
            inputType: "text",
            validationType: "string",
            validations: [
                {
                    type: "required"
                },
                {
                    type: "number"
                }, 
            ]
        },
        bookingWaitlistConfirmationTemplateId: {
            name: "bookingWaitlistConfirmationTemplateId",
            label: "entities:tenantEmailConfig.attributes.bookingWaitlistConfirmationTemplateId.label",
            type: "value",
            dataType: "number",
            defaultInput: true,
            inputType: "text",
            validationType: "string",
            validations: [
                {
                    type: "required"
                },
                {
                    type: "number"
                }, 
            ]
        },
        bookingWaitlistContingentCheckConfirmationTemplateId: {
            name: "bookingWaitlistContingentCheckConfirmationTemplateId",
            label: "entities:tenantEmailConfig.attributes.bookingWaitlistContingentCheckConfirmationTemplateId.label",
            type: "value",
            dataType: "number",
            defaultInput: true,
            inputType: "text",
            validationType: "string",
            validations: [
                {
                    type: "required"
                },
                {
                    type: "number"
                }, 
            ]
        },
        bookingCustomRequestTemplateId: {
            name: "bookingCustomRequestTemplateId",
            label: "entities:tenantEmailConfig.attributes.bookingCustomRequestTemplateId.label",
            type: "value",
            dataType: "number",
            defaultInput: true,
            inputType: "text",
            validationType: "string",
            validations: [
                {
                    type: "required"
                }, 
            ]
        },
        bookingPassportDataReminderTemplateId: {
            name: "bookingPassportDataReminderTemplateId",
            label: "entities:tenantEmailConfig.attributes.bookingPassportDataReminderTemplateId.label",
            type: "value",
            dataType: "number",
            defaultInput: true,
            inputType: "text",
            validationType: "string",
            validations: [
                {
                    type: "required"
                }, 
            ]
        },
        contactFormTemplateId: {
            name: "contactFormTemplateId",
            label: "entities:tenantEmailConfig.attributes.contactFormTemplateId.label",
            type: "value",
            dataType: "number",
            defaultInput: true,
            inputType: "text",
            validationType: "string",
            validations: [
                {
                    type: "required"
                },
                {
                    type: "number"
                }, 
            ]
        },
        esimInstallationInfoTemplateId: {
            name: "esimInstallationInfoTemplateId",
            label: "entities:tenantEmailConfig.attributes.esimInstallationInfoTemplateId.label",
            type: "value",
            dataType: "number",
            defaultInput: true,
            inputType: "text",
            validationType: "string",
            validations: []
        }
    }
};
/* harmony default export */ var model = (tenantEmailConfigModel);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(20414);
// EXTERNAL MODULE: ./src/entities/lib.ts
var lib = __webpack_require__(23480);
// EXTERNAL MODULE: ./src/lib/api/graphQLClient.ts
var graphQLClient = __webpack_require__(40112);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/swr/dist/index.mjs
var dist = __webpack_require__(8100);
// EXTERNAL MODULE: ./src/lib/helpers/helpers.ts
var helpers = __webpack_require__(15778);
;// CONCATENATED MODULE: ./src/entities/tenantEmailConfig/repository.ts










var hydrateObjects = function(objects) {
    return objects.map(function(object) {
        return (0,lib/* hydrateEntityObject */.b)(model, object);
    });
};
var hydrateObject = function(object) {
    return (0,lib/* hydrateEntityObject */.b)(model, object);
};
var tenantEmailConfigRepository = {
    getObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    id: id
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(SINGLE_EMAIL_CONFIG_QUERY, variables).then(function(data) {
                        return hydrateObject(data.emailConfig);
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }(),
    getObjects: /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        var includes;
        var _arguments = arguments;
        return (0,tslib_es6.__generator)(this, function(_state) {
            includes = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : {};
            return [
                2,
                graphQLClient/* default.request */.Z.request(ALL_EMAIL_CONFIGS_QUERY, includes).then(function(data) {
                    return hydrateObjects(data.emailConfigs);
                })
            ];
        });
    }),
    useObject: function(id) {
        var includes = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        // eslint-disable-next-line react-hooks/exhaustive-deps
        var variables = (0,react.useMemo)(function() {
            return (0,_object_spread/* default */.Z)({
                id: id
            }, includes);
        }, [
            id
        ]);
        var ref = (0,dist/* default */.ZP)([
            SINGLE_EMAIL_CONFIG_QUERY,
            variables
        ], {
            revalidateOnFocus: false
        }), data = ref.data, error = ref.error, mutate = ref.mutate;
        return {
            object: !data ? data : hydrateObject(data.emailConfig),
            isLoading: !error && !data,
            isError: error,
            mutate: mutate
        };
    },
    useObjects: function() {
        var includes = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        // eslint-disable-next-line react-hooks/exhaustive-deps
        var variables = (0,react.useMemo)(function() {
            return includes;
        }, []);
        var ref = (0,dist/* default */.ZP)([
            ALL_EMAIL_CONFIGS_QUERY,
            variables
        ]), data = ref.data, error = ref.error, mutate = ref.mutate;
        return {
            objects: !data ? data : hydrateObjects(data.emailConfigs),
            isLoading: !error && !data,
            isError: error,
            mutate: mutate
        };
    },
    getDependents: function(id, includes) {
        var includeVars = {};
        includes.forEach(function(include) {
            includeVars["with".concat((0,helpers/* uppercaseFirst */.AB)(include))] = true;
        });
        var variables = (0,_object_spread/* default */.Z)({
            id: id
        }, includeVars);
        return graphQLClient/* default.request */.Z.request(EMAIL_CONFIGS_DEPENDENTS_QUERY, variables).then(function(data) {
            return data.groupedDependents;
        });
    },
    useDependents: function(id, includes) {
        var includeVars = {};
        includes.forEach(function(include) {
            includeVars["with".concat((0,helpers/* uppercaseFirst */.AB)(include))] = true;
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
        var variables = (0,react.useMemo)(function() {
            return (0,_object_spread/* default */.Z)({
                id: id
            }, includeVars);
        }, [
            id
        ]);
        var ref = (0,dist/* default */.ZP)([
            EMAIL_CONFIGS_DEPENDENTS_QUERY,
            variables
        ], {
            revalidateOnFocus: false
        }), data = ref.data, error = ref.error, mutate = ref.mutate;
        return {
            data: !data ? data : data.groupedDependents,
            isLoading: !error && !data,
            isError: error,
            mutate: mutate
        };
    },
    createObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(data) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    input: data
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(CREATE_EMAIL_CONFIG_MUTATION, variables).then(function(data) {
                        return hydrateObject(data.emailConfig);
                    })
                ];
            });
        });
        return function(data) {
            return _ref.apply(this, arguments);
        };
    }(),
    updateObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(data) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    input: data
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(UPDATE_EMAIL_CONFIG_MUTATION, variables).then(function(data) {
                        return hydrateObject(data.emailConfig);
                    })
                ];
            });
        });
        return function(data) {
            return _ref.apply(this, arguments);
        };
    }(),
    deleteObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(DELETE_EMAIL_CONFIG_MUTATION, variables).then(function(data) {
                        return data.deleteTenantEmailConfig;
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }(),
    forceDeleteObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(FORCE_DELETE_EMAIL_CONFIG_MUTATION, variables).then(function(data) {
                        return data.forceDeleteTenantEmailConfig;
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }()
};
/* harmony default export */ var repository = (tenantEmailConfigRepository);

;// CONCATENATED MODULE: ./src/entities/tenantEmailConfig/entity.ts


var tenantEmailConfigEntity = {
    model: model,
    repository: repository
};
/* harmony default export */ var entity = (tenantEmailConfigEntity);


/***/ }),

/***/ 33076:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ entity; }
});

;// CONCATENATED MODULE: ./src/entities/tenantOnlinePaymentConfig/graphql.ts
// language=GraphQL
var ALL_ONLINE_PAYMENT_CONFIGS_QUERY = "query Query {\n  onlinePaymentConfigs: tenantOnlinePaymentConfigs {\n    id\n    enabled\n    ratioFibuAccountNo\n    infoText\n    datatransThemeConfig\n  }\n}";
// language=GraphQL
var SINGLE_ONLINE_PAYMENT_CONFIG_QUERY = "query Query($id: ID!) {\n  onlinePaymentConfig: tenantOnlinePaymentConfig(id: $id) {\n    id\n    enabled\n    ratioFibuAccountNo\n    infoText\n    datatransThemeConfig\n  }\n}";
// language=GraphQL
var CREATE_ONLINE_PAYMENT_CONFIG_MUTATION = "\n  mutation Mutation($input: CreateTenantOnlinePaymentConfigInput) {\n    onlinePaymentConfig: createTenantOnlinePaymentConfig(input: $input) {\n      id\n      enabled\n      ratioFibuAccountNo\n      infoText\n      datatransThemeConfig\n    }\n  }";
// language=GraphQL
var UPDATE_ONLINE_PAYMENT_CONFIG_MUTATION = "\n  mutation Mutation($input: UpdateTenantOnlinePaymentConfigInput) {\n    onlinePaymentConfig: updateTenantOnlinePaymentConfig(input: $input) {\n      id\n      enabled\n      ratioFibuAccountNo\n      infoText\n      datatransThemeConfig\n    }\n  }";
// language=GraphQL
var DELETE_ONLINE_PAYMENT_CONFIG_MUTATION = "\n  mutation Mutation($input: DeleteTenantOnlinePaymentConfigInput) {\n    deleteTenantOnlinePaymentConfig(input: $input) {\n      success\n    }\n  }";
// language=GraphQL
var FORCE_DELETE_ONLINE_PAYMENT_CONFIG_MUTATION = "\n  mutation Mutation($input: DeleteTenantOnlinePaymentConfigInput) {\n    forceDeleteTenantOnlinePaymentConfig(input: $input) {\n      success\n    }\n  }";
// language=GraphQL
var ONLINE_PAYMENT_CONFIGS_DEPENDENTS_QUERY = "query Query($id: ID!, $withTenants: Boolean = false) {\n  groupedDependents: tenantOnlinePaymentConfigDependents(id: $id) {\n    tenants @include(if: $withTenants) {\n      id\n      name\n      slug\n      domain\n      externalReference\n    }\n  }\n}";

;// CONCATENATED MODULE: ./src/entities/tenantOnlinePaymentConfig/model.ts

var tenantOnlinePaymentConfigModel = {
    name: "onlinePaymentConfig",
    namePlural: "onlinePaymentConfigs",
    uniqueName: "tenantOnlinePaymentConfig",
    uniqueNamePlural: "tenantOnlinePaymentConfigs",
    path: "config/tenant/online_payment_config",
    baseUrl: "/config/tenant/online_payment_configs",
    translationPrefix: "entities:tenantOnlinePaymentConfig.",
    getDisplayName: function(values) {
        return "ONLINE PAYMENT CONFIG";
    },
    gql: {
        getAll: ALL_ONLINE_PAYMENT_CONFIGS_QUERY,
        getSingle: SINGLE_ONLINE_PAYMENT_CONFIG_QUERY,
        create: CREATE_ONLINE_PAYMENT_CONFIG_MUTATION,
        update: UPDATE_ONLINE_PAYMENT_CONFIG_MUTATION,
        delete: DELETE_ONLINE_PAYMENT_CONFIG_MUTATION,
        forceDelete: FORCE_DELETE_ONLINE_PAYMENT_CONFIG_MUTATION
    },
    attributes: {
        enabled: {
            name: "enabled",
            label: "entities:tenantOnlinePaymentConfig.attributes.enabled.label",
            type: "value",
            dataType: "boolean",
            defaultInput: true,
            inputType: "switch",
            validationType: "string",
            validations: []
        },
        ratioFibuAccountNo: {
            name: "ratioFibuAccountNo",
            label: "entities:tenantOnlinePaymentConfig.attributes.ratioFibuAccountNo.label",
            type: "value",
            dataType: "number",
            defaultInput: true,
            inputType: "number",
            validationType: "string",
            validations: [
                {
                    type: "required"
                }, 
            ]
        },
        infoText: {
            name: "infoText",
            label: "entities:tenantOnlinePaymentConfig.attributes.infoText.label",
            type: "value",
            dataType: "string",
            defaultInput: true,
            inputType: "textarea",
            validationType: "string",
            validations: []
        },
        datatransThemeConfig: {
            name: "datatransThemeConfig",
            label: "entities:tenantOnlinePaymentConfig.attributes.datatransThemeConfig.label",
            type: "value",
            dataType: "{ [x: string]: any }",
            defaultInput: true,
            inputType: "textarea",
            validationType: "string",
            validations: []
        }
    }
};
/* harmony default export */ var model = (tenantOnlinePaymentConfigModel);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(20414);
// EXTERNAL MODULE: ./src/entities/lib.ts
var lib = __webpack_require__(23480);
// EXTERNAL MODULE: ./src/lib/api/graphQLClient.ts
var graphQLClient = __webpack_require__(40112);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/swr/dist/index.mjs
var dist = __webpack_require__(8100);
// EXTERNAL MODULE: ./src/lib/helpers/helpers.ts
var helpers = __webpack_require__(15778);
;// CONCATENATED MODULE: ./src/entities/tenantOnlinePaymentConfig/repository.ts










var hydrateObjects = function(objects) {
    return objects.map(function(object) {
        return (0,lib/* hydrateEntityObject */.b)(model, object);
    });
};
var hydrateObject = function(object) {
    return (0,lib/* hydrateEntityObject */.b)(model, object);
};
var tenantOnlinePaymentConfigRepository = {
    getObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    id: id
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(SINGLE_ONLINE_PAYMENT_CONFIG_QUERY, variables).then(function(data) {
                        return hydrateObject(data.onlinePaymentConfig);
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }(),
    getObjects: /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        var includes;
        var _arguments = arguments;
        return (0,tslib_es6.__generator)(this, function(_state) {
            includes = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : {};
            return [
                2,
                graphQLClient/* default.request */.Z.request(ALL_ONLINE_PAYMENT_CONFIGS_QUERY, includes).then(function(data) {
                    return hydrateObjects(data.onlinePaymentConfigs);
                })
            ];
        });
    }),
    useObject: function(id) {
        var includes = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        // eslint-disable-next-line react-hooks/exhaustive-deps
        var variables = (0,react.useMemo)(function() {
            return (0,_object_spread/* default */.Z)({
                id: id
            }, includes);
        }, [
            id
        ]);
        var ref = (0,dist/* default */.ZP)([
            SINGLE_ONLINE_PAYMENT_CONFIG_QUERY,
            variables
        ], {
            revalidateOnFocus: false
        }), data = ref.data, error = ref.error, mutate = ref.mutate;
        return {
            object: !data ? data : hydrateObject(data.onlinePaymentConfig),
            isLoading: !error && !data,
            isError: error,
            mutate: mutate
        };
    },
    useObjects: function() {
        var includes = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        // eslint-disable-next-line react-hooks/exhaustive-deps
        var variables = (0,react.useMemo)(function() {
            return includes;
        }, []);
        var ref = (0,dist/* default */.ZP)([
            ALL_ONLINE_PAYMENT_CONFIGS_QUERY,
            variables
        ]), data = ref.data, error = ref.error, mutate = ref.mutate;
        return {
            objects: !data ? data : hydrateObjects(data.onlinePaymentConfigs),
            isLoading: !error && !data,
            isError: error,
            mutate: mutate
        };
    },
    getDependents: function(id, includes) {
        var includeVars = {};
        includes.forEach(function(include) {
            includeVars["with".concat((0,helpers/* uppercaseFirst */.AB)(include))] = true;
        });
        var variables = (0,_object_spread/* default */.Z)({
            id: id
        }, includeVars);
        return graphQLClient/* default.request */.Z.request(ONLINE_PAYMENT_CONFIGS_DEPENDENTS_QUERY, variables).then(function(data) {
            return data.groupedDependents;
        });
    },
    useDependents: function(id, includes) {
        var includeVars = {};
        includes.forEach(function(include) {
            includeVars["with".concat((0,helpers/* uppercaseFirst */.AB)(include))] = true;
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
        var variables = (0,react.useMemo)(function() {
            return (0,_object_spread/* default */.Z)({
                id: id
            }, includeVars);
        }, [
            id
        ]);
        var ref = (0,dist/* default */.ZP)([
            ONLINE_PAYMENT_CONFIGS_DEPENDENTS_QUERY,
            variables
        ], {
            revalidateOnFocus: false
        }), data = ref.data, error = ref.error, mutate = ref.mutate;
        return {
            data: !data ? data : data.groupedDependents,
            isLoading: !error && !data,
            isError: error,
            mutate: mutate
        };
    },
    createObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(data) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    input: data
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(CREATE_ONLINE_PAYMENT_CONFIG_MUTATION, variables).then(function(data) {
                        return hydrateObject(data.onlinePaymentConfig);
                    })
                ];
            });
        });
        return function(data) {
            return _ref.apply(this, arguments);
        };
    }(),
    updateObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(data) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    input: data
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(UPDATE_ONLINE_PAYMENT_CONFIG_MUTATION, variables).then(function(data) {
                        return hydrateObject(data.onlinePaymentConfig);
                    })
                ];
            });
        });
        return function(data) {
            return _ref.apply(this, arguments);
        };
    }(),
    deleteObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(DELETE_ONLINE_PAYMENT_CONFIG_MUTATION, variables).then(function(data) {
                        return data.deleteTenantOnlinePaymentConfig;
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }(),
    forceDeleteObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(FORCE_DELETE_ONLINE_PAYMENT_CONFIG_MUTATION, variables).then(function(data) {
                        return data.forceDeleteTenantOnlinePaymentConfig;
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }()
};
/* harmony default export */ var repository = (tenantOnlinePaymentConfigRepository);

;// CONCATENATED MODULE: ./src/entities/tenantOnlinePaymentConfig/entity.ts


var tenantOnlinePaymentConfigEntity = {
    model: model,
    repository: repository
};
/* harmony default export */ var entity = (tenantOnlinePaymentConfigEntity);


/***/ }),

/***/ 1871:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ entity; }
});

;// CONCATENATED MODULE: ./src/entities/tenantRatioConfig/graphql.ts
// language=GraphQL
var ALL_RATIO_CONFIGS_QUERY = "query Query {\n  ratioConfigs: tenantRatioConfigs {\n    id\n    adressgruppe\n  }\n}";
// language=GraphQL
var SINGLE_RATIO_CONFIG_QUERY = "query Query($id: ID!) {\n  ratioConfig: tenantRatioConfig(id: $id) {\n    id\n    adressgruppe\n  }\n}";
// language=GraphQL
var CREATE_RATIO_CONFIG_MUTATION = "\n  mutation Mutation($input: CreateTenantRatioConfigInput) {\n    ratioConfig: createTenantRatioConfig(input: $input) {\n      id\n      adressgruppe\n    }\n  }";
// language=GraphQL
var UPDATE_RATIO_CONFIG_MUTATION = "\n  mutation Mutation($input: UpdateTenantRatioConfigInput) {\n    ratioConfig: updateTenantRatioConfig(input: $input) {\n      id\n      adressgruppe\n    }\n  }";
// language=GraphQL
var DELETE_RATIO_CONFIG_MUTATION = "\n  mutation Mutation($input: DeleteTenantRatioConfigInput) {\n    deleteTenantRatioConfig(input: $input) {\n      success\n    }\n  }";
// language=GraphQL
var FORCE_DELETE_RATIO_CONFIG_MUTATION = "\n  mutation Mutation($input: DeleteTenantRatioConfigInput) {\n    forceDeleteTenantRatioConfig(input: $input) {\n      success\n    }\n  }";
// language=GraphQL
var RATIO_CONFIGS_DEPENDENTS_QUERY = "query Query($id: ID!, $withTenants: Boolean = false) {\n  groupedDependents: tenantRatioConfigDependents(id: $id) {\n    tenants @include(if: $withTenants) {\n      id\n      name\n      slug\n      domain\n      externalReference\n    }\n  }\n}";

;// CONCATENATED MODULE: ./src/entities/tenantRatioConfig/model.ts

var tenantRatioConfigModel = {
    name: "ratioConfig",
    namePlural: "ratioConfigs",
    uniqueName: "tenantRatioConfig",
    uniqueNamePlural: "tenantRatioConfigs",
    path: "config/tenant/ratio_config",
    baseUrl: "/config/tenant/ratio_configs",
    translationPrefix: "entities:tenantRatioConfig.",
    getDisplayName: function(values) {
        return "TENANT RATIO CONFIG";
    },
    gql: {
        getAll: ALL_RATIO_CONFIGS_QUERY,
        getSingle: SINGLE_RATIO_CONFIG_QUERY,
        create: CREATE_RATIO_CONFIG_MUTATION,
        update: UPDATE_RATIO_CONFIG_MUTATION,
        delete: DELETE_RATIO_CONFIG_MUTATION,
        forceDelete: FORCE_DELETE_RATIO_CONFIG_MUTATION
    },
    attributes: {
        adressgruppe: {
            name: "adressgruppe",
            label: "entities:tenantRatioConfig.attributes.adressgruppe.label",
            type: "value",
            dataType: "number",
            defaultInput: true,
            inputType: "number",
            validationType: "string",
            validations: [
                {
                    type: "required"
                },
                {
                    type: "number"
                }, 
            ]
        }
    }
};
/* harmony default export */ var model = (tenantRatioConfigModel);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(20414);
// EXTERNAL MODULE: ./src/entities/lib.ts
var lib = __webpack_require__(23480);
// EXTERNAL MODULE: ./src/lib/api/graphQLClient.ts
var graphQLClient = __webpack_require__(40112);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/swr/dist/index.mjs
var dist = __webpack_require__(8100);
// EXTERNAL MODULE: ./src/lib/helpers/helpers.ts
var helpers = __webpack_require__(15778);
;// CONCATENATED MODULE: ./src/entities/tenantRatioConfig/repository.ts










var hydrateObjects = function(objects) {
    return objects.map(function(object) {
        return (0,lib/* hydrateEntityObject */.b)(model, object);
    });
};
var hydrateObject = function(object) {
    return (0,lib/* hydrateEntityObject */.b)(model, object);
};
var tenantRatioConfigRepository = {
    getObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    id: id
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(SINGLE_RATIO_CONFIG_QUERY, variables).then(function(data) {
                        return hydrateObject(data.ratioConfig);
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }(),
    getObjects: /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        var includes;
        var _arguments = arguments;
        return (0,tslib_es6.__generator)(this, function(_state) {
            includes = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : {};
            return [
                2,
                graphQLClient/* default.request */.Z.request(ALL_RATIO_CONFIGS_QUERY, includes).then(function(data) {
                    return hydrateObjects(data.ratioConfigs);
                })
            ];
        });
    }),
    useObject: function(id) {
        var includes = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        // eslint-disable-next-line react-hooks/exhaustive-deps
        var variables = (0,react.useMemo)(function() {
            return (0,_object_spread/* default */.Z)({
                id: id
            }, includes);
        }, [
            id
        ]);
        var ref = (0,dist/* default */.ZP)([
            SINGLE_RATIO_CONFIG_QUERY,
            variables
        ], {
            revalidateOnFocus: false
        }), data = ref.data, error = ref.error, mutate = ref.mutate;
        return {
            object: !data ? data : hydrateObject(data.ratioConfig),
            isLoading: !error && !data,
            isError: error,
            mutate: mutate
        };
    },
    useObjects: function() {
        var includes = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        // eslint-disable-next-line react-hooks/exhaustive-deps
        var variables = (0,react.useMemo)(function() {
            return includes;
        }, []);
        var ref = (0,dist/* default */.ZP)([
            ALL_RATIO_CONFIGS_QUERY,
            variables
        ]), data = ref.data, error = ref.error, mutate = ref.mutate;
        return {
            objects: !data ? data : hydrateObjects(data.ratioConfigs),
            isLoading: !error && !data,
            isError: error,
            mutate: mutate
        };
    },
    getDependents: function(id, includes) {
        var includeVars = {};
        includes.forEach(function(include) {
            includeVars["with".concat((0,helpers/* uppercaseFirst */.AB)(include))] = true;
        });
        var variables = (0,_object_spread/* default */.Z)({
            id: id
        }, includeVars);
        return graphQLClient/* default.request */.Z.request(RATIO_CONFIGS_DEPENDENTS_QUERY, variables).then(function(data) {
            return data.groupedDependents;
        });
    },
    useDependents: function(id, includes) {
        var includeVars = {};
        includes.forEach(function(include) {
            includeVars["with".concat((0,helpers/* uppercaseFirst */.AB)(include))] = true;
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
        var variables = (0,react.useMemo)(function() {
            return (0,_object_spread/* default */.Z)({
                id: id
            }, includeVars);
        }, [
            id
        ]);
        var ref = (0,dist/* default */.ZP)([
            RATIO_CONFIGS_DEPENDENTS_QUERY,
            variables
        ], {
            revalidateOnFocus: false
        }), data = ref.data, error = ref.error, mutate = ref.mutate;
        return {
            data: !data ? data : data.groupedDependents,
            isLoading: !error && !data,
            isError: error,
            mutate: mutate
        };
    },
    createObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(data) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    input: data
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(CREATE_RATIO_CONFIG_MUTATION, variables).then(function(data) {
                        return hydrateObject(data.ratioConfig);
                    })
                ];
            });
        });
        return function(data) {
            return _ref.apply(this, arguments);
        };
    }(),
    updateObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(data) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    input: data
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(UPDATE_RATIO_CONFIG_MUTATION, variables).then(function(data) {
                        return hydrateObject(data.ratioConfig);
                    })
                ];
            });
        });
        return function(data) {
            return _ref.apply(this, arguments);
        };
    }(),
    deleteObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(DELETE_RATIO_CONFIG_MUTATION, variables).then(function(data) {
                        return data.deleteTenantRatioConfig;
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }(),
    forceDeleteObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(FORCE_DELETE_RATIO_CONFIG_MUTATION, variables).then(function(data) {
                        return data.forceDeleteTenantRatioConfig;
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }()
};
/* harmony default export */ var repository = (tenantRatioConfigRepository);

;// CONCATENATED MODULE: ./src/entities/tenantRatioConfig/entity.ts


var tenantRatioConfigEntity = {
    model: model,
    repository: repository
};
/* harmony default export */ var entity = (tenantRatioConfigEntity);


/***/ }),

/***/ 82327:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ travel_entity; }
});

;// CONCATENATED MODULE: ./src/entities/travel/graphql.ts
// language=GraphQL
var ALL_TRAVELS_QUERY = "query Query($withAvailabilityStatus: Boolean = false, $withAvailabilityStatusTenantSettings: Boolean = false, $withAvailabilityStatusTenantSettingsTenant: Boolean = false, $withTravelConsultant: Boolean = false, $withTravelConsultantImage: Boolean = false, $withLabel: Boolean = false, $withSeoSettings: Boolean = false, $withSeoSettingsOgImage: Boolean = false, $withTenantSettings: Boolean = false, $withTenantSettingsTenant: Boolean = false, $withTenantSettingsTenantCms: Boolean = false, $withTenantSettingsTenantTravelTypes: Boolean = false, $withTenantSettingsTenantEmployees: Boolean = false, $withTenantSettingsTenantEmailConfig: Boolean = false, $withTenantSettingsTenantNewsletterProvider: Boolean = false, $withTenantSettingsTenantRedirects: Boolean = false, $withTenantSettingsTenantOnlinePaymentConfig: Boolean = false, $withTenantSettingsTenantRatioConfig: Boolean = false, $withTenantSettingsTenantContent: Boolean = false, $withTenantSettingsTenantPartnerTenants: Boolean = false, $withTenantSettingsTravelTypes: Boolean = false, $withTenantSettingsTravelTypesImage: Boolean = false, $withHighlights: Boolean = false, $withPartners: Boolean = false, $withPartnersLogo: Boolean = false, $withPartnersGtcPdf: Boolean = false, $withTravelGuides: Boolean = false, $withTravelGuidesImage: Boolean = false, $withTeams: Boolean = false, $withTeamsMembers: Boolean = false, $withTeamsMembersImage: Boolean = false, $withAccommodationAssignments: Boolean = false, $withAccommodationAssignmentsAccommodation: Boolean = false, $withAccommodationAssignmentsAccommodationRoomTypes: Boolean = false, $withAccommodationAssignmentsAccommodationAvailableAddons: Boolean = false, $withAccommodationAssignmentsAccommodationGallery: Boolean = false, $withAccommodationAssignmentsRoomTypes: Boolean = false, $withAccommodationAssignmentsRoomTypesGallery: Boolean = false, $withAccommodations: Boolean = false, $withAccommodationsRoomTypes: Boolean = false, $withAccommodationsRoomTypesGallery: Boolean = false, $withAccommodationsAvailableAddons: Boolean = false, $withAccommodationsAvailableAddonsIcon: Boolean = false, $withAccommodationsGallery: Boolean = false, $withAccommodationsGalleryImages: Boolean = false, $withDestinations: Boolean = false, $withTestimonials: Boolean = false, $withTestimonialsContentBlock: Boolean = false, $withTestimonialsContentBlockImage: Boolean = false, $withMainImage: Boolean = false, $withMainVideo: Boolean = false, $withGallery: Boolean = false, $withGalleryImages: Boolean = false, $withTravelPdf: Boolean = false, $withTravelExtensions: Boolean = false, $withTravelExtensionsHighlights: Boolean = false, $withTravelExtensionsImage: Boolean = false, $withItinerary: Boolean = false, $withItineraryItems: Boolean = false, $withItineraryItemsImage: Boolean = false, $withItineraryItemsMapMarkers: Boolean = false, $withPricing: Boolean = false, $withPricingAgeGroupSettings: Boolean = false, $withPricingAgeGroupSettingsAgeGroups: Boolean = false, $withPricingCustomDataConfig: Boolean = false, $withPricingCustomDataConfigTravellerForm: Boolean = false, $withPricingCustomDataConfigBookingForm: Boolean = false, $withPricingTravels: Boolean = false, $withPricingTravelsRatioCatalogBundle: Boolean = false, $withPricingTravelsDates: Boolean = false, $withPricingTravelsAccommodations: Boolean = false, $withPricingTravelsExtensionAccommodations: Boolean = false, $withPricingTravelsFamilyPackages: Boolean = false, $withPricingTravelsPersonalAddons: Boolean = false, $withPricingTravelsAccommodationAddons: Boolean = false, $withPricingTravelsBookingAddons: Boolean = false, $withPricingTravelsCollectiveAddons: Boolean = false, $withPricingTravelsExtensions: Boolean = false, $withPricingTravelsPersonalDiscounts: Boolean = false, $withPricingWebhookConfig: Boolean = false, $withPricingBranding: Boolean = false, $withPricingBrandingLogo: Boolean = false, $withPricingBargainSettings: Boolean = false, $withPricingBargainSettingsBargainTier: Boolean = false, $withPricingEsimSettings: Boolean = false, $withPricingEsimSettingsRegions: Boolean = false, $withPricingPassportConfig: Boolean = false, $withPricingTourOperator: Boolean = false, $withPricingTourOperatorLogo: Boolean = false, $withPricingTourOperatorGtcPdf: Boolean = false) {\n  travels: travels {\n    id\n    name\n    isBestseller\n    startDate\n    endDate\n    availabilityStatus @include(if: $withAvailabilityStatus) {\n      id\n      label\n      status\n      isDefaultStatus\n      isDefaultWaitlistFallback\n      tenantSettings @include(if: $withAvailabilityStatusTenantSettings) {\n        id\n        tenant @include(if: $withAvailabilityStatusTenantSettingsTenant) {\n          id\n          name\n          slug\n          domain\n          externalReference\n        }\n        label\n        info\n        switchToStatusInfo\n        submitButtonLabel\n      }\n    }\n    executionStatus\n    travelConsultant @include(if: $withTravelConsultant) {\n      id\n      firstName\n      lastName\n      jobTitle\n      description\n      email\n      image @include(if: $withTravelConsultantImage) {\n        id\n        assetId\n        publicId\n        url\n        resourceType\n        format\n        width\n        height\n        caption\n        title\n        description\n      }\n      phone\n    }\n    label @include(if: $withLabel) {\n      id\n      label\n    }\n    title\n    description\n    includedServices\n    excludedServices\n    pricingTable\n    priceCalculationInfo\n    seoSettings @include(if: $withSeoSettings) {\n      id\n      urlSlug\n      metaTitle\n      metaDescription\n      ogTitle\n      ogDescription\n      ogImage @include(if: $withSeoSettingsOgImage) {\n        id\n        assetId\n        publicId\n        url\n        resourceType\n        format\n        width\n        height\n        caption\n        title\n        description\n      }\n    }\n    tenantSettings @include(if: $withTenantSettings) {\n      id\n      tenant @include(if: $withTenantSettingsTenant) {\n        id\n        name\n        slug\n        domain\n        externalReference\n        cms @include(if: $withTenantSettingsTenantCms) {\n          id\n        }\n        travelTypes @include(if: $withTenantSettingsTenantTravelTypes) {\n          id\n          name\n          description\n        }\n        employees @include(if: $withTenantSettingsTenantEmployees) {\n          id\n          firstName\n          lastName\n          jobTitle\n          description\n          email\n          phone\n        }\n        emailConfig @include(if: $withTenantSettingsTenantEmailConfig) {\n          id\n          defaultInternalRecipientEmail\n          internalBookingRecipientEmails\n          bookingConfirmationTemplateId\n          bookingConfirmationInternalTemplateId\n          bookingRequestConfirmationTemplateId\n          bookingWaitlistConfirmationTemplateId\n          bookingWaitlistContingentCheckConfirmationTemplateId\n          bookingCustomRequestTemplateId\n          bookingPassportDataReminderTemplateId\n          contactFormTemplateId\n          esimInstallationInfoTemplateId\n        }\n        newsletterProvider @include(if: $withTenantSettingsTenantNewsletterProvider) {\n          id\n          provider\n        }\n        redirects @include(if: $withTenantSettingsTenantRedirects) {\n          id\n          fromType\n          fromUrl\n          toType\n          toUrl\n        }\n        onlinePaymentConfig @include(if: $withTenantSettingsTenantOnlinePaymentConfig) {\n          id\n          enabled\n          ratioFibuAccountNo\n          infoText\n          datatransThemeConfig\n        }\n        ratioConfig @include(if: $withTenantSettingsTenantRatioConfig) {\n          id\n          adressgruppe\n        }\n        content @include(if: $withTenantSettingsTenantContent) {\n          id\n          bookingInsuranceInfo\n        }\n        partnerTenants @include(if: $withTenantSettingsTenantPartnerTenants) {\n          id\n          filterCrossLinking\n        }\n      }\n      onlineStatus\n      redirectToBooking\n      useTiming\n      startDate\n      endDate\n      travelTypes @include(if: $withTenantSettingsTravelTypes) {\n        id\n        name\n        description\n        image @include(if: $withTenantSettingsTravelTypesImage) {\n          id\n          assetId\n          publicId\n          url\n          resourceType\n          format\n          width\n          height\n          caption\n          title\n          description\n        }\n      }\n    }\n    highlights @include(if: $withHighlights) {\n      id\n      text\n    }\n    partners @include(if: $withPartners) {\n      id\n      name\n      url\n      logo @include(if: $withPartnersLogo) {\n        id\n        assetId\n        publicId\n        url\n        resourceType\n        format\n        width\n        height\n        caption\n        title\n        description\n      }\n      logoWidth\n      gtcPdf @include(if: $withPartnersGtcPdf) {\n        id\n        assetId\n        publicId\n        url\n        resourceType\n        format\n        width\n        height\n        caption\n        title\n        description\n      }\n    }\n    travelGuides @include(if: $withTravelGuides) {\n      id\n      firstName\n      lastName\n      description\n      image @include(if: $withTravelGuidesImage) {\n        id\n        assetId\n        publicId\n        url\n        resourceType\n        format\n        width\n        height\n        caption\n        title\n        description\n      }\n    }\n    teams @include(if: $withTeams) {\n      id\n      name\n      members @include(if: $withTeamsMembers) {\n        id\n        firstName\n        lastName\n        description\n        image @include(if: $withTeamsMembersImage) {\n          id\n          assetId\n          publicId\n          url\n          resourceType\n          format\n          width\n          height\n          caption\n          title\n          description\n        }\n      }\n    }\n    accommodationAssignments @include(if: $withAccommodationAssignments) {\n      id\n      accommodation @include(if: $withAccommodationAssignmentsAccommodation) {\n        id\n        label\n        name\n        stars\n        description\n        roomTypes @include(if: $withAccommodationAssignmentsAccommodationRoomTypes) {\n          id\n          name\n          description\n        }\n        availableAddons @include(if: $withAccommodationAssignmentsAccommodationAvailableAddons) {\n          id\n          name\n          description\n        }\n        gallery @include(if: $withAccommodationAssignmentsAccommodationGallery) {\n          id\n        }\n      }\n      roomTypes @include(if: $withAccommodationAssignmentsRoomTypes) {\n        id\n        name\n        description\n        gallery @include(if: $withAccommodationAssignmentsRoomTypesGallery) {\n          id\n        }\n      }\n      useCustomRoomTypeSelection\n    }\n    accommodations @include(if: $withAccommodations) {\n      id\n      label\n      name\n      stars\n      description\n      roomTypes @include(if: $withAccommodationsRoomTypes) {\n        id\n        name\n        description\n        gallery @include(if: $withAccommodationsRoomTypesGallery) {\n          id\n        }\n      }\n      availableAddons @include(if: $withAccommodationsAvailableAddons) {\n        id\n        name\n        description\n        icon @include(if: $withAccommodationsAvailableAddonsIcon) {\n          id\n          assetId\n          publicId\n          url\n          resourceType\n          format\n          width\n          height\n          caption\n          title\n          description\n        }\n      }\n      gallery @include(if: $withAccommodationsGallery) {\n        id\n        images @include(if: $withAccommodationsGalleryImages) {\n          id\n          assetId\n          publicId\n          url\n          resourceType\n          format\n          width\n          height\n          caption\n          title\n          description\n        }\n      }\n    }\n    destinations @include(if: $withDestinations) {\n      id\n      name\n      entryRequirements\n      medicalInformation\n      language\n      timeShift\n      climate\n      currency\n    }\n    testimonials @include(if: $withTestimonials) {\n      id\n      contentBlock @include(if: $withTestimonialsContentBlock) {\n        id\n        title\n        text\n        image @include(if: $withTestimonialsContentBlockImage) {\n          id\n          assetId\n          publicId\n          url\n          resourceType\n          format\n          width\n          height\n          caption\n          title\n          description\n        }\n        imagePosition\n      }\n    }\n    mainImage @include(if: $withMainImage) {\n      id\n      assetId\n      publicId\n      url\n      resourceType\n      format\n      width\n      height\n      caption\n      title\n      description\n    }\n    mainVideo @include(if: $withMainVideo) {\n      id\n      assetId\n      publicId\n      url\n      resourceType\n      format\n      width\n      height\n      caption\n      title\n      description\n    }\n    gallery @include(if: $withGallery) {\n      id\n      images @include(if: $withGalleryImages) {\n        id\n        assetId\n        publicId\n        url\n        resourceType\n        format\n        width\n        height\n        caption\n        title\n        description\n      }\n    }\n    travelPdf @include(if: $withTravelPdf) {\n      id\n      assetId\n      publicId\n      url\n      resourceType\n      format\n      width\n      height\n      caption\n      title\n      description\n    }\n    travelExtensions @include(if: $withTravelExtensions) {\n      id\n      duration\n      name\n      description\n      highlights @include(if: $withTravelExtensionsHighlights) {\n        id\n        text\n      }\n      image @include(if: $withTravelExtensionsImage) {\n        id\n        assetId\n        publicId\n        url\n        resourceType\n        format\n        width\n        height\n        caption\n        title\n        description\n      }\n    }\n    programType\n    itinerary @include(if: $withItinerary) {\n      id\n      items @include(if: $withItineraryItems) {\n        id\n        duration\n        title\n        text\n        image @include(if: $withItineraryItemsImage) {\n          id\n          assetId\n          publicId\n          url\n          resourceType\n          format\n          width\n          height\n          caption\n          title\n          description\n        }\n        mapMarkers @include(if: $withItineraryItemsMapMarkers) {\n          id\n          lat\n          lng\n        }\n      }\n    }\n    programText\n    pricing @include(if: $withPricing) {\n      id\n      ageGroupSettings @include(if: $withPricingAgeGroupSettings) {\n        id\n        freeUntilAge\n        ageGroups @include(if: $withPricingAgeGroupSettingsAgeGroups) {\n          id\n          name\n          type\n          icon\n          minAge\n          maxAge\n        }\n      }\n      isTravelDocumentationAvailable\n      customDataConfig @include(if: $withPricingCustomDataConfig) {\n        id\n        useTravellerForm\n        travellerForm @include(if: $withPricingCustomDataConfigTravellerForm) {\n          id\n        }\n        useBookingForm\n        bookingForm @include(if: $withPricingCustomDataConfigBookingForm) {\n          id\n        }\n      }\n      travels @include(if: $withPricingTravels) {\n        id\n        ratioCatalogBundle @include(if: $withPricingTravelsRatioCatalogBundle) {\n          id\n          catalogCode\n          travelCode\n          json\n        }\n        catalogCode\n        travelCode\n        destination\n        name\n        transportType\n        transportTypeLabel\n        dates @include(if: $withPricingTravelsDates) {\n          id\n          dateNo\n          startDate\n          endDate\n          includesExtension\n          json\n        }\n        accommodations @include(if: $withPricingTravelsAccommodations) {\n          id\n          ratioPackageNo\n          name\n          label\n          info\n          isFamilyPackageAccommodation\n          isBabyPackage\n        }\n        extensionAccommodations @include(if: $withPricingTravelsExtensionAccommodations) {\n          id\n          ratioPackageNo\n          name\n          label\n          info\n          extensionAccommodationServiceNo\n        }\n        familyPackages @include(if: $withPricingTravelsFamilyPackages) {\n          id\n          ratioServiceNo\n          name\n          label\n          info\n        }\n        personalAddons @include(if: $withPricingTravelsPersonalAddons) {\n          id\n          ratioServiceNo\n          name\n          label\n          info\n        }\n        accommodationAddons @include(if: $withPricingTravelsAccommodationAddons) {\n          id\n          ratioServiceNo\n          name\n          label\n          info\n        }\n        bookingAddons @include(if: $withPricingTravelsBookingAddons) {\n          id\n          ratioServiceNo\n          name\n          label\n          info\n        }\n        collectiveAddons @include(if: $withPricingTravelsCollectiveAddons) {\n          id\n          label\n          info\n        }\n        extensions @include(if: $withPricingTravelsExtensions) {\n          id\n          label\n          info\n        }\n        personalDiscounts @include(if: $withPricingTravelsPersonalDiscounts) {\n          id\n          ratioServiceNo\n          name\n          label\n          info\n        }\n        importDateTime\n        importStatus\n      }\n      webhookConfig @include(if: $withPricingWebhookConfig) {\n        id\n        enabled\n        url\n      }\n      branding @include(if: $withPricingBranding) {\n        id\n        logo @include(if: $withPricingBrandingLogo) {\n          id\n          assetId\n          publicId\n          url\n          resourceType\n          format\n          width\n          height\n          caption\n          title\n          description\n        }\n        logoWidth\n      }\n      bargainSettings @include(if: $withPricingBargainSettings) {\n        id\n        active\n        untilDaysBeforeStart\n        bargainTier @include(if: $withPricingBargainSettingsBargainTier) {\n          id\n          fromPrice\n          discount\n        }\n      }\n      esimSettings @include(if: $withPricingEsimSettings) {\n        id\n        enabled\n        regions @include(if: $withPricingEsimSettingsRegions) {\n          id\n          name\n          serviceCodePrefix\n        }\n      }\n      passportConfig @include(if: $withPricingPassportConfig) {\n        id\n        passportOnly\n      }\n      tourOperator @include(if: $withPricingTourOperator) {\n        id\n        name\n        url\n        logo @include(if: $withPricingTourOperatorLogo) {\n          id\n          assetId\n          publicId\n          url\n          resourceType\n          format\n          width\n          height\n          caption\n          title\n          description\n        }\n        logoWidth\n        gtcPdf @include(if: $withPricingTourOperatorGtcPdf) {\n          id\n          assetId\n          publicId\n          url\n          resourceType\n          format\n          width\n          height\n          caption\n          title\n          description\n        }\n      }\n    }\n    minPrice\n    minPriceManualOverride\n    currency\n  }\n}";
// language=GraphQL
var SINGLE_TRAVEL_QUERY = "query Query($id: ID!, $withAvailabilityStatus: Boolean = false, $withAvailabilityStatusTenantSettings: Boolean = false, $withAvailabilityStatusTenantSettingsTenant: Boolean = false, $withTravelConsultant: Boolean = false, $withTravelConsultantImage: Boolean = false, $withLabel: Boolean = false, $withSeoSettings: Boolean = false, $withSeoSettingsOgImage: Boolean = false, $withTenantSettings: Boolean = false, $withTenantSettingsTenant: Boolean = false, $withTenantSettingsTenantCms: Boolean = false, $withTenantSettingsTenantTravelTypes: Boolean = false, $withTenantSettingsTenantEmployees: Boolean = false, $withTenantSettingsTenantEmailConfig: Boolean = false, $withTenantSettingsTenantNewsletterProvider: Boolean = false, $withTenantSettingsTenantRedirects: Boolean = false, $withTenantSettingsTenantOnlinePaymentConfig: Boolean = false, $withTenantSettingsTenantRatioConfig: Boolean = false, $withTenantSettingsTenantContent: Boolean = false, $withTenantSettingsTenantPartnerTenants: Boolean = false, $withTenantSettingsTravelTypes: Boolean = false, $withTenantSettingsTravelTypesImage: Boolean = false, $withHighlights: Boolean = false, $withPartners: Boolean = false, $withPartnersLogo: Boolean = false, $withPartnersGtcPdf: Boolean = false, $withTravelGuides: Boolean = false, $withTravelGuidesImage: Boolean = false, $withTeams: Boolean = false, $withTeamsMembers: Boolean = false, $withTeamsMembersImage: Boolean = false, $withAccommodationAssignments: Boolean = false, $withAccommodationAssignmentsAccommodation: Boolean = false, $withAccommodationAssignmentsAccommodationRoomTypes: Boolean = false, $withAccommodationAssignmentsAccommodationAvailableAddons: Boolean = false, $withAccommodationAssignmentsAccommodationGallery: Boolean = false, $withAccommodationAssignmentsRoomTypes: Boolean = false, $withAccommodationAssignmentsRoomTypesGallery: Boolean = false, $withAccommodations: Boolean = false, $withAccommodationsRoomTypes: Boolean = false, $withAccommodationsRoomTypesGallery: Boolean = false, $withAccommodationsAvailableAddons: Boolean = false, $withAccommodationsAvailableAddonsIcon: Boolean = false, $withAccommodationsGallery: Boolean = false, $withAccommodationsGalleryImages: Boolean = false, $withDestinations: Boolean = false, $withTestimonials: Boolean = false, $withTestimonialsContentBlock: Boolean = false, $withTestimonialsContentBlockImage: Boolean = false, $withMainImage: Boolean = false, $withMainVideo: Boolean = false, $withGallery: Boolean = false, $withGalleryImages: Boolean = false, $withTravelPdf: Boolean = false, $withTravelExtensions: Boolean = false, $withTravelExtensionsHighlights: Boolean = false, $withTravelExtensionsImage: Boolean = false, $withItinerary: Boolean = false, $withItineraryItems: Boolean = false, $withItineraryItemsImage: Boolean = false, $withItineraryItemsMapMarkers: Boolean = false, $withPricing: Boolean = false, $withPricingAgeGroupSettings: Boolean = false, $withPricingAgeGroupSettingsAgeGroups: Boolean = false, $withPricingCustomDataConfig: Boolean = false, $withPricingCustomDataConfigTravellerForm: Boolean = false, $withPricingCustomDataConfigBookingForm: Boolean = false, $withPricingTravels: Boolean = false, $withPricingTravelsRatioCatalogBundle: Boolean = false, $withPricingTravelsDates: Boolean = false, $withPricingTravelsAccommodations: Boolean = false, $withPricingTravelsExtensionAccommodations: Boolean = false, $withPricingTravelsFamilyPackages: Boolean = false, $withPricingTravelsPersonalAddons: Boolean = false, $withPricingTravelsAccommodationAddons: Boolean = false, $withPricingTravelsBookingAddons: Boolean = false, $withPricingTravelsCollectiveAddons: Boolean = false, $withPricingTravelsExtensions: Boolean = false, $withPricingTravelsPersonalDiscounts: Boolean = false, $withPricingWebhookConfig: Boolean = false, $withPricingBranding: Boolean = false, $withPricingBrandingLogo: Boolean = false, $withPricingBargainSettings: Boolean = false, $withPricingBargainSettingsBargainTier: Boolean = false, $withPricingEsimSettings: Boolean = false, $withPricingEsimSettingsRegions: Boolean = false, $withPricingPassportConfig: Boolean = false, $withPricingTourOperator: Boolean = false, $withPricingTourOperatorLogo: Boolean = false, $withPricingTourOperatorGtcPdf: Boolean = false) {\n  travel: travel(id: $id) {\n    id\n    name\n    isBestseller\n    startDate\n    endDate\n    availabilityStatus @include(if: $withAvailabilityStatus) {\n      id\n      label\n      status\n      isDefaultStatus\n      isDefaultWaitlistFallback\n      tenantSettings @include(if: $withAvailabilityStatusTenantSettings) {\n        id\n        tenant @include(if: $withAvailabilityStatusTenantSettingsTenant) {\n          id\n          name\n          slug\n          domain\n          externalReference\n        }\n        label\n        info\n        switchToStatusInfo\n        submitButtonLabel\n      }\n    }\n    executionStatus\n    travelConsultant @include(if: $withTravelConsultant) {\n      id\n      firstName\n      lastName\n      jobTitle\n      description\n      email\n      image @include(if: $withTravelConsultantImage) {\n        id\n        assetId\n        publicId\n        url\n        resourceType\n        format\n        width\n        height\n        caption\n        title\n        description\n      }\n      phone\n    }\n    label @include(if: $withLabel) {\n      id\n      label\n    }\n    title\n    description\n    includedServices\n    excludedServices\n    pricingTable\n    priceCalculationInfo\n    seoSettings @include(if: $withSeoSettings) {\n      id\n      urlSlug\n      metaTitle\n      metaDescription\n      ogTitle\n      ogDescription\n      ogImage @include(if: $withSeoSettingsOgImage) {\n        id\n        assetId\n        publicId\n        url\n        resourceType\n        format\n        width\n        height\n        caption\n        title\n        description\n      }\n    }\n    tenantSettings @include(if: $withTenantSettings) {\n      id\n      tenant @include(if: $withTenantSettingsTenant) {\n        id\n        name\n        slug\n        domain\n        externalReference\n        cms @include(if: $withTenantSettingsTenantCms) {\n          id\n        }\n        travelTypes @include(if: $withTenantSettingsTenantTravelTypes) {\n          id\n          name\n          description\n        }\n        employees @include(if: $withTenantSettingsTenantEmployees) {\n          id\n          firstName\n          lastName\n          jobTitle\n          description\n          email\n          phone\n        }\n        emailConfig @include(if: $withTenantSettingsTenantEmailConfig) {\n          id\n          defaultInternalRecipientEmail\n          internalBookingRecipientEmails\n          bookingConfirmationTemplateId\n          bookingConfirmationInternalTemplateId\n          bookingRequestConfirmationTemplateId\n          bookingWaitlistConfirmationTemplateId\n          bookingWaitlistContingentCheckConfirmationTemplateId\n          bookingCustomRequestTemplateId\n          bookingPassportDataReminderTemplateId\n          contactFormTemplateId\n          esimInstallationInfoTemplateId\n        }\n        newsletterProvider @include(if: $withTenantSettingsTenantNewsletterProvider) {\n          id\n          provider\n        }\n        redirects @include(if: $withTenantSettingsTenantRedirects) {\n          id\n          fromType\n          fromUrl\n          toType\n          toUrl\n        }\n        onlinePaymentConfig @include(if: $withTenantSettingsTenantOnlinePaymentConfig) {\n          id\n          enabled\n          ratioFibuAccountNo\n          infoText\n          datatransThemeConfig\n        }\n        ratioConfig @include(if: $withTenantSettingsTenantRatioConfig) {\n          id\n          adressgruppe\n        }\n        content @include(if: $withTenantSettingsTenantContent) {\n          id\n          bookingInsuranceInfo\n        }\n        partnerTenants @include(if: $withTenantSettingsTenantPartnerTenants) {\n          id\n          filterCrossLinking\n        }\n      }\n      onlineStatus\n      redirectToBooking\n      useTiming\n      startDate\n      endDate\n      travelTypes @include(if: $withTenantSettingsTravelTypes) {\n        id\n        name\n        description\n        image @include(if: $withTenantSettingsTravelTypesImage) {\n          id\n          assetId\n          publicId\n          url\n          resourceType\n          format\n          width\n          height\n          caption\n          title\n          description\n        }\n      }\n    }\n    highlights @include(if: $withHighlights) {\n      id\n      text\n    }\n    partners @include(if: $withPartners) {\n      id\n      name\n      url\n      logo @include(if: $withPartnersLogo) {\n        id\n        assetId\n        publicId\n        url\n        resourceType\n        format\n        width\n        height\n        caption\n        title\n        description\n      }\n      logoWidth\n      gtcPdf @include(if: $withPartnersGtcPdf) {\n        id\n        assetId\n        publicId\n        url\n        resourceType\n        format\n        width\n        height\n        caption\n        title\n        description\n      }\n    }\n    travelGuides @include(if: $withTravelGuides) {\n      id\n      firstName\n      lastName\n      description\n      image @include(if: $withTravelGuidesImage) {\n        id\n        assetId\n        publicId\n        url\n        resourceType\n        format\n        width\n        height\n        caption\n        title\n        description\n      }\n    }\n    teams @include(if: $withTeams) {\n      id\n      name\n      members @include(if: $withTeamsMembers) {\n        id\n        firstName\n        lastName\n        description\n        image @include(if: $withTeamsMembersImage) {\n          id\n          assetId\n          publicId\n          url\n          resourceType\n          format\n          width\n          height\n          caption\n          title\n          description\n        }\n      }\n    }\n    accommodationAssignments @include(if: $withAccommodationAssignments) {\n      id\n      accommodation @include(if: $withAccommodationAssignmentsAccommodation) {\n        id\n        label\n        name\n        stars\n        description\n        roomTypes @include(if: $withAccommodationAssignmentsAccommodationRoomTypes) {\n          id\n          name\n          description\n        }\n        availableAddons @include(if: $withAccommodationAssignmentsAccommodationAvailableAddons) {\n          id\n          name\n          description\n        }\n        gallery @include(if: $withAccommodationAssignmentsAccommodationGallery) {\n          id\n        }\n      }\n      roomTypes @include(if: $withAccommodationAssignmentsRoomTypes) {\n        id\n        name\n        description\n        gallery @include(if: $withAccommodationAssignmentsRoomTypesGallery) {\n          id\n        }\n      }\n      useCustomRoomTypeSelection\n    }\n    accommodations @include(if: $withAccommodations) {\n      id\n      label\n      name\n      stars\n      description\n      roomTypes @include(if: $withAccommodationsRoomTypes) {\n        id\n        name\n        description\n        gallery @include(if: $withAccommodationsRoomTypesGallery) {\n          id\n        }\n      }\n      availableAddons @include(if: $withAccommodationsAvailableAddons) {\n        id\n        name\n        description\n        icon @include(if: $withAccommodationsAvailableAddonsIcon) {\n          id\n          assetId\n          publicId\n          url\n          resourceType\n          format\n          width\n          height\n          caption\n          title\n          description\n        }\n      }\n      gallery @include(if: $withAccommodationsGallery) {\n        id\n        images @include(if: $withAccommodationsGalleryImages) {\n          id\n          assetId\n          publicId\n          url\n          resourceType\n          format\n          width\n          height\n          caption\n          title\n          description\n        }\n      }\n    }\n    destinations @include(if: $withDestinations) {\n      id\n      name\n      entryRequirements\n      medicalInformation\n      language\n      timeShift\n      climate\n      currency\n    }\n    testimonials @include(if: $withTestimonials) {\n      id\n      contentBlock @include(if: $withTestimonialsContentBlock) {\n        id\n        title\n        text\n        image @include(if: $withTestimonialsContentBlockImage) {\n          id\n          assetId\n          publicId\n          url\n          resourceType\n          format\n          width\n          height\n          caption\n          title\n          description\n        }\n        imagePosition\n      }\n    }\n    mainImage @include(if: $withMainImage) {\n      id\n      assetId\n      publicId\n      url\n      resourceType\n      format\n      width\n      height\n      caption\n      title\n      description\n    }\n    mainVideo @include(if: $withMainVideo) {\n      id\n      assetId\n      publicId\n      url\n      resourceType\n      format\n      width\n      height\n      caption\n      title\n      description\n    }\n    gallery @include(if: $withGallery) {\n      id\n      images @include(if: $withGalleryImages) {\n        id\n        assetId\n        publicId\n        url\n        resourceType\n        format\n        width\n        height\n        caption\n        title\n        description\n      }\n    }\n    travelPdf @include(if: $withTravelPdf) {\n      id\n      assetId\n      publicId\n      url\n      resourceType\n      format\n      width\n      height\n      caption\n      title\n      description\n    }\n    travelExtensions @include(if: $withTravelExtensions) {\n      id\n      duration\n      name\n      description\n      highlights @include(if: $withTravelExtensionsHighlights) {\n        id\n        text\n      }\n      image @include(if: $withTravelExtensionsImage) {\n        id\n        assetId\n        publicId\n        url\n        resourceType\n        format\n        width\n        height\n        caption\n        title\n        description\n      }\n    }\n    programType\n    itinerary @include(if: $withItinerary) {\n      id\n      items @include(if: $withItineraryItems) {\n        id\n        duration\n        title\n        text\n        image @include(if: $withItineraryItemsImage) {\n          id\n          assetId\n          publicId\n          url\n          resourceType\n          format\n          width\n          height\n          caption\n          title\n          description\n        }\n        mapMarkers @include(if: $withItineraryItemsMapMarkers) {\n          id\n          lat\n          lng\n        }\n      }\n    }\n    programText\n    pricing @include(if: $withPricing) {\n      id\n      ageGroupSettings @include(if: $withPricingAgeGroupSettings) {\n        id\n        freeUntilAge\n        ageGroups @include(if: $withPricingAgeGroupSettingsAgeGroups) {\n          id\n          name\n          type\n          icon\n          minAge\n          maxAge\n        }\n      }\n      isTravelDocumentationAvailable\n      customDataConfig @include(if: $withPricingCustomDataConfig) {\n        id\n        useTravellerForm\n        travellerForm @include(if: $withPricingCustomDataConfigTravellerForm) {\n          id\n        }\n        useBookingForm\n        bookingForm @include(if: $withPricingCustomDataConfigBookingForm) {\n          id\n        }\n      }\n      travels @include(if: $withPricingTravels) {\n        id\n        ratioCatalogBundle @include(if: $withPricingTravelsRatioCatalogBundle) {\n          id\n          catalogCode\n          travelCode\n          json\n        }\n        catalogCode\n        travelCode\n        destination\n        name\n        transportType\n        transportTypeLabel\n        dates @include(if: $withPricingTravelsDates) {\n          id\n          dateNo\n          startDate\n          endDate\n          includesExtension\n          json\n        }\n        accommodations @include(if: $withPricingTravelsAccommodations) {\n          id\n          ratioPackageNo\n          name\n          label\n          info\n          isFamilyPackageAccommodation\n          isBabyPackage\n        }\n        extensionAccommodations @include(if: $withPricingTravelsExtensionAccommodations) {\n          id\n          ratioPackageNo\n          name\n          label\n          info\n          extensionAccommodationServiceNo\n        }\n        familyPackages @include(if: $withPricingTravelsFamilyPackages) {\n          id\n          ratioServiceNo\n          name\n          label\n          info\n        }\n        personalAddons @include(if: $withPricingTravelsPersonalAddons) {\n          id\n          ratioServiceNo\n          name\n          label\n          info\n        }\n        accommodationAddons @include(if: $withPricingTravelsAccommodationAddons) {\n          id\n          ratioServiceNo\n          name\n          label\n          info\n        }\n        bookingAddons @include(if: $withPricingTravelsBookingAddons) {\n          id\n          ratioServiceNo\n          name\n          label\n          info\n        }\n        collectiveAddons @include(if: $withPricingTravelsCollectiveAddons) {\n          id\n          label\n          info\n        }\n        extensions @include(if: $withPricingTravelsExtensions) {\n          id\n          label\n          info\n        }\n        personalDiscounts @include(if: $withPricingTravelsPersonalDiscounts) {\n          id\n          ratioServiceNo\n          name\n          label\n          info\n        }\n        importDateTime\n        importStatus\n      }\n      webhookConfig @include(if: $withPricingWebhookConfig) {\n        id\n        enabled\n        url\n      }\n      branding @include(if: $withPricingBranding) {\n        id\n        logo @include(if: $withPricingBrandingLogo) {\n          id\n          assetId\n          publicId\n          url\n          resourceType\n          format\n          width\n          height\n          caption\n          title\n          description\n        }\n        logoWidth\n      }\n      bargainSettings @include(if: $withPricingBargainSettings) {\n        id\n        active\n        untilDaysBeforeStart\n        bargainTier @include(if: $withPricingBargainSettingsBargainTier) {\n          id\n          fromPrice\n          discount\n        }\n      }\n      esimSettings @include(if: $withPricingEsimSettings) {\n        id\n        enabled\n        regions @include(if: $withPricingEsimSettingsRegions) {\n          id\n          name\n          serviceCodePrefix\n        }\n      }\n      passportConfig @include(if: $withPricingPassportConfig) {\n        id\n        passportOnly\n      }\n      tourOperator @include(if: $withPricingTourOperator) {\n        id\n        name\n        url\n        logo @include(if: $withPricingTourOperatorLogo) {\n          id\n          assetId\n          publicId\n          url\n          resourceType\n          format\n          width\n          height\n          caption\n          title\n          description\n        }\n        logoWidth\n        gtcPdf @include(if: $withPricingTourOperatorGtcPdf) {\n          id\n          assetId\n          publicId\n          url\n          resourceType\n          format\n          width\n          height\n          caption\n          title\n          description\n        }\n      }\n    }\n    minPrice\n    minPriceManualOverride\n    currency\n  }\n}";
// language=GraphQL
var CREATE_TRAVEL_MUTATION = "\n  mutation Mutation($input: CreateTravelInput, $withAvailabilityStatus: Boolean = false, $withAvailabilityStatusTenantSettings: Boolean = false, $withAvailabilityStatusTenantSettingsTenant: Boolean = false, $withTravelConsultant: Boolean = false, $withTravelConsultantImage: Boolean = false, $withLabel: Boolean = false, $withSeoSettings: Boolean = false, $withSeoSettingsOgImage: Boolean = false, $withTenantSettings: Boolean = false, $withTenantSettingsTenant: Boolean = false, $withTenantSettingsTenantCms: Boolean = false, $withTenantSettingsTenantTravelTypes: Boolean = false, $withTenantSettingsTenantEmployees: Boolean = false, $withTenantSettingsTenantEmailConfig: Boolean = false, $withTenantSettingsTenantNewsletterProvider: Boolean = false, $withTenantSettingsTenantRedirects: Boolean = false, $withTenantSettingsTenantOnlinePaymentConfig: Boolean = false, $withTenantSettingsTenantRatioConfig: Boolean = false, $withTenantSettingsTenantContent: Boolean = false, $withTenantSettingsTenantPartnerTenants: Boolean = false, $withTenantSettingsTravelTypes: Boolean = false, $withTenantSettingsTravelTypesImage: Boolean = false, $withHighlights: Boolean = false, $withPartners: Boolean = false, $withPartnersLogo: Boolean = false, $withPartnersGtcPdf: Boolean = false, $withTravelGuides: Boolean = false, $withTravelGuidesImage: Boolean = false, $withTeams: Boolean = false, $withTeamsMembers: Boolean = false, $withTeamsMembersImage: Boolean = false, $withAccommodationAssignments: Boolean = false, $withAccommodationAssignmentsAccommodation: Boolean = false, $withAccommodationAssignmentsAccommodationRoomTypes: Boolean = false, $withAccommodationAssignmentsAccommodationAvailableAddons: Boolean = false, $withAccommodationAssignmentsAccommodationGallery: Boolean = false, $withAccommodationAssignmentsRoomTypes: Boolean = false, $withAccommodationAssignmentsRoomTypesGallery: Boolean = false, $withAccommodations: Boolean = false, $withAccommodationsRoomTypes: Boolean = false, $withAccommodationsRoomTypesGallery: Boolean = false, $withAccommodationsAvailableAddons: Boolean = false, $withAccommodationsAvailableAddonsIcon: Boolean = false, $withAccommodationsGallery: Boolean = false, $withAccommodationsGalleryImages: Boolean = false, $withDestinations: Boolean = false, $withTestimonials: Boolean = false, $withTestimonialsContentBlock: Boolean = false, $withTestimonialsContentBlockImage: Boolean = false, $withMainImage: Boolean = false, $withMainVideo: Boolean = false, $withGallery: Boolean = false, $withGalleryImages: Boolean = false, $withTravelPdf: Boolean = false, $withTravelExtensions: Boolean = false, $withTravelExtensionsHighlights: Boolean = false, $withTravelExtensionsImage: Boolean = false, $withItinerary: Boolean = false, $withItineraryItems: Boolean = false, $withItineraryItemsImage: Boolean = false, $withItineraryItemsMapMarkers: Boolean = false, $withPricing: Boolean = false, $withPricingAgeGroupSettings: Boolean = false, $withPricingAgeGroupSettingsAgeGroups: Boolean = false, $withPricingCustomDataConfig: Boolean = false, $withPricingCustomDataConfigTravellerForm: Boolean = false, $withPricingCustomDataConfigBookingForm: Boolean = false, $withPricingTravels: Boolean = false, $withPricingTravelsRatioCatalogBundle: Boolean = false, $withPricingTravelsDates: Boolean = false, $withPricingTravelsAccommodations: Boolean = false, $withPricingTravelsExtensionAccommodations: Boolean = false, $withPricingTravelsFamilyPackages: Boolean = false, $withPricingTravelsPersonalAddons: Boolean = false, $withPricingTravelsAccommodationAddons: Boolean = false, $withPricingTravelsBookingAddons: Boolean = false, $withPricingTravelsCollectiveAddons: Boolean = false, $withPricingTravelsExtensions: Boolean = false, $withPricingTravelsPersonalDiscounts: Boolean = false, $withPricingWebhookConfig: Boolean = false, $withPricingBranding: Boolean = false, $withPricingBrandingLogo: Boolean = false, $withPricingBargainSettings: Boolean = false, $withPricingBargainSettingsBargainTier: Boolean = false, $withPricingEsimSettings: Boolean = false, $withPricingEsimSettingsRegions: Boolean = false, $withPricingPassportConfig: Boolean = false, $withPricingTourOperator: Boolean = false, $withPricingTourOperatorLogo: Boolean = false, $withPricingTourOperatorGtcPdf: Boolean = false) {\n    travel: createTravel(input: $input) {\n      id\n      name\n      isBestseller\n      startDate\n      endDate\n      availabilityStatus @include(if: $withAvailabilityStatus) {\n        id\n        label\n        status\n        isDefaultStatus\n        isDefaultWaitlistFallback\n        tenantSettings @include(if: $withAvailabilityStatusTenantSettings) {\n          id\n          tenant @include(if: $withAvailabilityStatusTenantSettingsTenant) {\n            id\n            name\n            slug\n            domain\n            externalReference\n          }\n          label\n          info\n          switchToStatusInfo\n          submitButtonLabel\n        }\n      }\n      executionStatus\n      travelConsultant @include(if: $withTravelConsultant) {\n        id\n        firstName\n        lastName\n        jobTitle\n        description\n        email\n        image @include(if: $withTravelConsultantImage) {\n          id\n          assetId\n          publicId\n          url\n          resourceType\n          format\n          width\n          height\n          caption\n          title\n          description\n        }\n        phone\n      }\n      label @include(if: $withLabel) {\n        id\n        label\n      }\n      title\n      description\n      includedServices\n      excludedServices\n      pricingTable\n      priceCalculationInfo\n      seoSettings @include(if: $withSeoSettings) {\n        id\n        urlSlug\n        metaTitle\n        metaDescription\n        ogTitle\n        ogDescription\n        ogImage @include(if: $withSeoSettingsOgImage) {\n          id\n          assetId\n          publicId\n          url\n          resourceType\n          format\n          width\n          height\n          caption\n          title\n          description\n        }\n      }\n      tenantSettings @include(if: $withTenantSettings) {\n        id\n        tenant @include(if: $withTenantSettingsTenant) {\n          id\n          name\n          slug\n          domain\n          externalReference\n          cms @include(if: $withTenantSettingsTenantCms) {\n            id\n          }\n          travelTypes @include(if: $withTenantSettingsTenantTravelTypes) {\n            id\n            name\n            description\n          }\n          employees @include(if: $withTenantSettingsTenantEmployees) {\n            id\n            firstName\n            lastName\n            jobTitle\n            description\n            email\n            phone\n          }\n          emailConfig @include(if: $withTenantSettingsTenantEmailConfig) {\n            id\n            defaultInternalRecipientEmail\n            internalBookingRecipientEmails\n            bookingConfirmationTemplateId\n            bookingConfirmationInternalTemplateId\n            bookingRequestConfirmationTemplateId\n            bookingWaitlistConfirmationTemplateId\n            bookingWaitlistContingentCheckConfirmationTemplateId\n            bookingCustomRequestTemplateId\n            bookingPassportDataReminderTemplateId\n            contactFormTemplateId\n            esimInstallationInfoTemplateId\n          }\n          newsletterProvider @include(if: $withTenantSettingsTenantNewsletterProvider) {\n            id\n            provider\n          }\n          redirects @include(if: $withTenantSettingsTenantRedirects) {\n            id\n            fromType\n            fromUrl\n            toType\n            toUrl\n          }\n          onlinePaymentConfig @include(if: $withTenantSettingsTenantOnlinePaymentConfig) {\n            id\n            enabled\n            ratioFibuAccountNo\n            infoText\n            datatransThemeConfig\n          }\n          ratioConfig @include(if: $withTenantSettingsTenantRatioConfig) {\n            id\n            adressgruppe\n          }\n          content @include(if: $withTenantSettingsTenantContent) {\n            id\n            bookingInsuranceInfo\n          }\n          partnerTenants @include(if: $withTenantSettingsTenantPartnerTenants) {\n            id\n            filterCrossLinking\n          }\n        }\n        onlineStatus\n        redirectToBooking\n        useTiming\n        startDate\n        endDate\n        travelTypes @include(if: $withTenantSettingsTravelTypes) {\n          id\n          name\n          description\n          image @include(if: $withTenantSettingsTravelTypesImage) {\n            id\n            assetId\n            publicId\n            url\n            resourceType\n            format\n            width\n            height\n            caption\n            title\n            description\n          }\n        }\n      }\n      highlights @include(if: $withHighlights) {\n        id\n        text\n      }\n      partners @include(if: $withPartners) {\n        id\n        name\n        url\n        logo @include(if: $withPartnersLogo) {\n          id\n          assetId\n          publicId\n          url\n          resourceType\n          format\n          width\n          height\n          caption\n          title\n          description\n        }\n        logoWidth\n        gtcPdf @include(if: $withPartnersGtcPdf) {\n          id\n          assetId\n          publicId\n          url\n          resourceType\n          format\n          width\n          height\n          caption\n          title\n          description\n        }\n      }\n      travelGuides @include(if: $withTravelGuides) {\n        id\n        firstName\n        lastName\n        description\n        image @include(if: $withTravelGuidesImage) {\n          id\n          assetId\n          publicId\n          url\n          resourceType\n          format\n          width\n          height\n          caption\n          title\n          description\n        }\n      }\n      teams @include(if: $withTeams) {\n        id\n        name\n        members @include(if: $withTeamsMembers) {\n          id\n          firstName\n          lastName\n          description\n          image @include(if: $withTeamsMembersImage) {\n            id\n            assetId\n            publicId\n            url\n            resourceType\n            format\n            width\n            height\n            caption\n            title\n            description\n          }\n        }\n      }\n      accommodationAssignments @include(if: $withAccommodationAssignments) {\n        id\n        accommodation @include(if: $withAccommodationAssignmentsAccommodation) {\n          id\n          label\n          name\n          stars\n          description\n          roomTypes @include(if: $withAccommodationAssignmentsAccommodationRoomTypes) {\n            id\n            name\n            description\n          }\n          availableAddons @include(if: $withAccommodationAssignmentsAccommodationAvailableAddons) {\n            id\n            name\n            description\n          }\n          gallery @include(if: $withAccommodationAssignmentsAccommodationGallery) {\n            id\n          }\n        }\n        roomTypes @include(if: $withAccommodationAssignmentsRoomTypes) {\n          id\n          name\n          description\n          gallery @include(if: $withAccommodationAssignmentsRoomTypesGallery) {\n            id\n          }\n        }\n        useCustomRoomTypeSelection\n      }\n      accommodations @include(if: $withAccommodations) {\n        id\n        label\n        name\n        stars\n        description\n        roomTypes @include(if: $withAccommodationsRoomTypes) {\n          id\n          name\n          description\n          gallery @include(if: $withAccommodationsRoomTypesGallery) {\n            id\n          }\n        }\n        availableAddons @include(if: $withAccommodationsAvailableAddons) {\n          id\n          name\n          description\n          icon @include(if: $withAccommodationsAvailableAddonsIcon) {\n            id\n            assetId\n            publicId\n            url\n            resourceType\n            format\n            width\n            height\n            caption\n            title\n            description\n          }\n        }\n        gallery @include(if: $withAccommodationsGallery) {\n          id\n          images @include(if: $withAccommodationsGalleryImages) {\n            id\n            assetId\n            publicId\n            url\n            resourceType\n            format\n            width\n            height\n            caption\n            title\n            description\n          }\n        }\n      }\n      destinations @include(if: $withDestinations) {\n        id\n        name\n        entryRequirements\n        medicalInformation\n        language\n        timeShift\n        climate\n        currency\n      }\n      testimonials @include(if: $withTestimonials) {\n        id\n        contentBlock @include(if: $withTestimonialsContentBlock) {\n          id\n          title\n          text\n          image @include(if: $withTestimonialsContentBlockImage) {\n            id\n            assetId\n            publicId\n            url\n            resourceType\n            format\n            width\n            height\n            caption\n            title\n            description\n          }\n          imagePosition\n        }\n      }\n      mainImage @include(if: $withMainImage) {\n        id\n        assetId\n        publicId\n        url\n        resourceType\n        format\n        width\n        height\n        caption\n        title\n        description\n      }\n      mainVideo @include(if: $withMainVideo) {\n        id\n        assetId\n        publicId\n        url\n        resourceType\n        format\n        width\n        height\n        caption\n        title\n        description\n      }\n      gallery @include(if: $withGallery) {\n        id\n        images @include(if: $withGalleryImages) {\n          id\n          assetId\n          publicId\n          url\n          resourceType\n          format\n          width\n          height\n          caption\n          title\n          description\n        }\n      }\n      travelPdf @include(if: $withTravelPdf) {\n        id\n        assetId\n        publicId\n        url\n        resourceType\n        format\n        width\n        height\n        caption\n        title\n        description\n      }\n      travelExtensions @include(if: $withTravelExtensions) {\n        id\n        duration\n        name\n        description\n        highlights @include(if: $withTravelExtensionsHighlights) {\n          id\n          text\n        }\n        image @include(if: $withTravelExtensionsImage) {\n          id\n          assetId\n          publicId\n          url\n          resourceType\n          format\n          width\n          height\n          caption\n          title\n          description\n        }\n      }\n      programType\n      itinerary @include(if: $withItinerary) {\n        id\n        items @include(if: $withItineraryItems) {\n          id\n          duration\n          title\n          text\n          image @include(if: $withItineraryItemsImage) {\n            id\n            assetId\n            publicId\n            url\n            resourceType\n            format\n            width\n            height\n            caption\n            title\n            description\n          }\n          mapMarkers @include(if: $withItineraryItemsMapMarkers) {\n            id\n            lat\n            lng\n          }\n        }\n      }\n      programText\n      pricing @include(if: $withPricing) {\n        id\n        ageGroupSettings @include(if: $withPricingAgeGroupSettings) {\n          id\n          freeUntilAge\n          ageGroups @include(if: $withPricingAgeGroupSettingsAgeGroups) {\n            id\n            name\n            type\n            icon\n            minAge\n            maxAge\n          }\n        }\n        isTravelDocumentationAvailable\n        customDataConfig @include(if: $withPricingCustomDataConfig) {\n          id\n          useTravellerForm\n          travellerForm @include(if: $withPricingCustomDataConfigTravellerForm) {\n            id\n          }\n          useBookingForm\n          bookingForm @include(if: $withPricingCustomDataConfigBookingForm) {\n            id\n          }\n        }\n        travels @include(if: $withPricingTravels) {\n          id\n          ratioCatalogBundle @include(if: $withPricingTravelsRatioCatalogBundle) {\n            id\n            catalogCode\n            travelCode\n            json\n          }\n          catalogCode\n          travelCode\n          destination\n          name\n          transportType\n          transportTypeLabel\n          dates @include(if: $withPricingTravelsDates) {\n            id\n            dateNo\n            startDate\n            endDate\n            includesExtension\n            json\n          }\n          accommodations @include(if: $withPricingTravelsAccommodations) {\n            id\n            ratioPackageNo\n            name\n            label\n            info\n            isFamilyPackageAccommodation\n            isBabyPackage\n          }\n          extensionAccommodations @include(if: $withPricingTravelsExtensionAccommodations) {\n            id\n            ratioPackageNo\n            name\n            label\n            info\n            extensionAccommodationServiceNo\n          }\n          familyPackages @include(if: $withPricingTravelsFamilyPackages) {\n            id\n            ratioServiceNo\n            name\n            label\n            info\n          }\n          personalAddons @include(if: $withPricingTravelsPersonalAddons) {\n            id\n            ratioServiceNo\n            name\n            label\n            info\n          }\n          accommodationAddons @include(if: $withPricingTravelsAccommodationAddons) {\n            id\n            ratioServiceNo\n            name\n            label\n            info\n          }\n          bookingAddons @include(if: $withPricingTravelsBookingAddons) {\n            id\n            ratioServiceNo\n            name\n            label\n            info\n          }\n          collectiveAddons @include(if: $withPricingTravelsCollectiveAddons) {\n            id\n            label\n            info\n          }\n          extensions @include(if: $withPricingTravelsExtensions) {\n            id\n            label\n            info\n          }\n          personalDiscounts @include(if: $withPricingTravelsPersonalDiscounts) {\n            id\n            ratioServiceNo\n            name\n            label\n            info\n          }\n          importDateTime\n          importStatus\n        }\n        webhookConfig @include(if: $withPricingWebhookConfig) {\n          id\n          enabled\n          url\n        }\n        branding @include(if: $withPricingBranding) {\n          id\n          logo @include(if: $withPricingBrandingLogo) {\n            id\n            assetId\n            publicId\n            url\n            resourceType\n            format\n            width\n            height\n            caption\n            title\n            description\n          }\n          logoWidth\n        }\n        bargainSettings @include(if: $withPricingBargainSettings) {\n          id\n          active\n          untilDaysBeforeStart\n          bargainTier @include(if: $withPricingBargainSettingsBargainTier) {\n            id\n            fromPrice\n            discount\n          }\n        }\n        esimSettings @include(if: $withPricingEsimSettings) {\n          id\n          enabled\n          regions @include(if: $withPricingEsimSettingsRegions) {\n            id\n            name\n            serviceCodePrefix\n          }\n        }\n        passportConfig @include(if: $withPricingPassportConfig) {\n          id\n          passportOnly\n        }\n        tourOperator @include(if: $withPricingTourOperator) {\n          id\n          name\n          url\n          logo @include(if: $withPricingTourOperatorLogo) {\n            id\n            assetId\n            publicId\n            url\n            resourceType\n            format\n            width\n            height\n            caption\n            title\n            description\n          }\n          logoWidth\n          gtcPdf @include(if: $withPricingTourOperatorGtcPdf) {\n            id\n            assetId\n            publicId\n            url\n            resourceType\n            format\n            width\n            height\n            caption\n            title\n            description\n          }\n        }\n      }\n      minPrice\n      minPriceManualOverride\n      currency\n    }\n  }";
// language=GraphQL
var UPDATE_TRAVEL_MUTATION = "\n  mutation Mutation($input: UpdateTravelInput, $withAvailabilityStatus: Boolean = false, $withAvailabilityStatusTenantSettings: Boolean = false, $withAvailabilityStatusTenantSettingsTenant: Boolean = false, $withTravelConsultant: Boolean = false, $withTravelConsultantImage: Boolean = false, $withLabel: Boolean = false, $withSeoSettings: Boolean = false, $withSeoSettingsOgImage: Boolean = false, $withTenantSettings: Boolean = false, $withTenantSettingsTenant: Boolean = false, $withTenantSettingsTenantCms: Boolean = false, $withTenantSettingsTenantTravelTypes: Boolean = false, $withTenantSettingsTenantEmployees: Boolean = false, $withTenantSettingsTenantEmailConfig: Boolean = false, $withTenantSettingsTenantNewsletterProvider: Boolean = false, $withTenantSettingsTenantRedirects: Boolean = false, $withTenantSettingsTenantOnlinePaymentConfig: Boolean = false, $withTenantSettingsTenantRatioConfig: Boolean = false, $withTenantSettingsTenantContent: Boolean = false, $withTenantSettingsTenantPartnerTenants: Boolean = false, $withTenantSettingsTravelTypes: Boolean = false, $withTenantSettingsTravelTypesImage: Boolean = false, $withHighlights: Boolean = false, $withPartners: Boolean = false, $withPartnersLogo: Boolean = false, $withPartnersGtcPdf: Boolean = false, $withTravelGuides: Boolean = false, $withTravelGuidesImage: Boolean = false, $withTeams: Boolean = false, $withTeamsMembers: Boolean = false, $withTeamsMembersImage: Boolean = false, $withAccommodationAssignments: Boolean = false, $withAccommodationAssignmentsAccommodation: Boolean = false, $withAccommodationAssignmentsAccommodationRoomTypes: Boolean = false, $withAccommodationAssignmentsAccommodationAvailableAddons: Boolean = false, $withAccommodationAssignmentsAccommodationGallery: Boolean = false, $withAccommodationAssignmentsRoomTypes: Boolean = false, $withAccommodationAssignmentsRoomTypesGallery: Boolean = false, $withAccommodations: Boolean = false, $withAccommodationsRoomTypes: Boolean = false, $withAccommodationsRoomTypesGallery: Boolean = false, $withAccommodationsAvailableAddons: Boolean = false, $withAccommodationsAvailableAddonsIcon: Boolean = false, $withAccommodationsGallery: Boolean = false, $withAccommodationsGalleryImages: Boolean = false, $withDestinations: Boolean = false, $withTestimonials: Boolean = false, $withTestimonialsContentBlock: Boolean = false, $withTestimonialsContentBlockImage: Boolean = false, $withMainImage: Boolean = false, $withMainVideo: Boolean = false, $withGallery: Boolean = false, $withGalleryImages: Boolean = false, $withTravelPdf: Boolean = false, $withTravelExtensions: Boolean = false, $withTravelExtensionsHighlights: Boolean = false, $withTravelExtensionsImage: Boolean = false, $withItinerary: Boolean = false, $withItineraryItems: Boolean = false, $withItineraryItemsImage: Boolean = false, $withItineraryItemsMapMarkers: Boolean = false, $withPricing: Boolean = false, $withPricingAgeGroupSettings: Boolean = false, $withPricingAgeGroupSettingsAgeGroups: Boolean = false, $withPricingCustomDataConfig: Boolean = false, $withPricingCustomDataConfigTravellerForm: Boolean = false, $withPricingCustomDataConfigBookingForm: Boolean = false, $withPricingTravels: Boolean = false, $withPricingTravelsRatioCatalogBundle: Boolean = false, $withPricingTravelsDates: Boolean = false, $withPricingTravelsAccommodations: Boolean = false, $withPricingTravelsExtensionAccommodations: Boolean = false, $withPricingTravelsFamilyPackages: Boolean = false, $withPricingTravelsPersonalAddons: Boolean = false, $withPricingTravelsAccommodationAddons: Boolean = false, $withPricingTravelsBookingAddons: Boolean = false, $withPricingTravelsCollectiveAddons: Boolean = false, $withPricingTravelsExtensions: Boolean = false, $withPricingTravelsPersonalDiscounts: Boolean = false, $withPricingWebhookConfig: Boolean = false, $withPricingBranding: Boolean = false, $withPricingBrandingLogo: Boolean = false, $withPricingBargainSettings: Boolean = false, $withPricingBargainSettingsBargainTier: Boolean = false, $withPricingEsimSettings: Boolean = false, $withPricingEsimSettingsRegions: Boolean = false, $withPricingPassportConfig: Boolean = false, $withPricingTourOperator: Boolean = false, $withPricingTourOperatorLogo: Boolean = false, $withPricingTourOperatorGtcPdf: Boolean = false) {\n    travel: updateTravel(input: $input) {\n      id\n      name\n      isBestseller\n      startDate\n      endDate\n      availabilityStatus @include(if: $withAvailabilityStatus) {\n        id\n        label\n        status\n        isDefaultStatus\n        isDefaultWaitlistFallback\n        tenantSettings @include(if: $withAvailabilityStatusTenantSettings) {\n          id\n          tenant @include(if: $withAvailabilityStatusTenantSettingsTenant) {\n            id\n            name\n            slug\n            domain\n            externalReference\n          }\n          label\n          info\n          switchToStatusInfo\n          submitButtonLabel\n        }\n      }\n      executionStatus\n      travelConsultant @include(if: $withTravelConsultant) {\n        id\n        firstName\n        lastName\n        jobTitle\n        description\n        email\n        image @include(if: $withTravelConsultantImage) {\n          id\n          assetId\n          publicId\n          url\n          resourceType\n          format\n          width\n          height\n          caption\n          title\n          description\n        }\n        phone\n      }\n      label @include(if: $withLabel) {\n        id\n        label\n      }\n      title\n      description\n      includedServices\n      excludedServices\n      pricingTable\n      priceCalculationInfo\n      seoSettings @include(if: $withSeoSettings) {\n        id\n        urlSlug\n        metaTitle\n        metaDescription\n        ogTitle\n        ogDescription\n        ogImage @include(if: $withSeoSettingsOgImage) {\n          id\n          assetId\n          publicId\n          url\n          resourceType\n          format\n          width\n          height\n          caption\n          title\n          description\n        }\n      }\n      tenantSettings @include(if: $withTenantSettings) {\n        id\n        tenant @include(if: $withTenantSettingsTenant) {\n          id\n          name\n          slug\n          domain\n          externalReference\n          cms @include(if: $withTenantSettingsTenantCms) {\n            id\n          }\n          travelTypes @include(if: $withTenantSettingsTenantTravelTypes) {\n            id\n            name\n            description\n          }\n          employees @include(if: $withTenantSettingsTenantEmployees) {\n            id\n            firstName\n            lastName\n            jobTitle\n            description\n            email\n            phone\n          }\n          emailConfig @include(if: $withTenantSettingsTenantEmailConfig) {\n            id\n            defaultInternalRecipientEmail\n            internalBookingRecipientEmails\n            bookingConfirmationTemplateId\n            bookingConfirmationInternalTemplateId\n            bookingRequestConfirmationTemplateId\n            bookingWaitlistConfirmationTemplateId\n            bookingWaitlistContingentCheckConfirmationTemplateId\n            bookingCustomRequestTemplateId\n            bookingPassportDataReminderTemplateId\n            contactFormTemplateId\n            esimInstallationInfoTemplateId\n          }\n          newsletterProvider @include(if: $withTenantSettingsTenantNewsletterProvider) {\n            id\n            provider\n          }\n          redirects @include(if: $withTenantSettingsTenantRedirects) {\n            id\n            fromType\n            fromUrl\n            toType\n            toUrl\n          }\n          onlinePaymentConfig @include(if: $withTenantSettingsTenantOnlinePaymentConfig) {\n            id\n            enabled\n            ratioFibuAccountNo\n            infoText\n            datatransThemeConfig\n          }\n          ratioConfig @include(if: $withTenantSettingsTenantRatioConfig) {\n            id\n            adressgruppe\n          }\n          content @include(if: $withTenantSettingsTenantContent) {\n            id\n            bookingInsuranceInfo\n          }\n          partnerTenants @include(if: $withTenantSettingsTenantPartnerTenants) {\n            id\n            filterCrossLinking\n          }\n        }\n        onlineStatus\n        redirectToBooking\n        useTiming\n        startDate\n        endDate\n        travelTypes @include(if: $withTenantSettingsTravelTypes) {\n          id\n          name\n          description\n          image @include(if: $withTenantSettingsTravelTypesImage) {\n            id\n            assetId\n            publicId\n            url\n            resourceType\n            format\n            width\n            height\n            caption\n            title\n            description\n          }\n        }\n      }\n      highlights @include(if: $withHighlights) {\n        id\n        text\n      }\n      partners @include(if: $withPartners) {\n        id\n        name\n        url\n        logo @include(if: $withPartnersLogo) {\n          id\n          assetId\n          publicId\n          url\n          resourceType\n          format\n          width\n          height\n          caption\n          title\n          description\n        }\n        logoWidth\n        gtcPdf @include(if: $withPartnersGtcPdf) {\n          id\n          assetId\n          publicId\n          url\n          resourceType\n          format\n          width\n          height\n          caption\n          title\n          description\n        }\n      }\n      travelGuides @include(if: $withTravelGuides) {\n        id\n        firstName\n        lastName\n        description\n        image @include(if: $withTravelGuidesImage) {\n          id\n          assetId\n          publicId\n          url\n          resourceType\n          format\n          width\n          height\n          caption\n          title\n          description\n        }\n      }\n      teams @include(if: $withTeams) {\n        id\n        name\n        members @include(if: $withTeamsMembers) {\n          id\n          firstName\n          lastName\n          description\n          image @include(if: $withTeamsMembersImage) {\n            id\n            assetId\n            publicId\n            url\n            resourceType\n            format\n            width\n            height\n            caption\n            title\n            description\n          }\n        }\n      }\n      accommodationAssignments @include(if: $withAccommodationAssignments) {\n        id\n        accommodation @include(if: $withAccommodationAssignmentsAccommodation) {\n          id\n          label\n          name\n          stars\n          description\n          roomTypes @include(if: $withAccommodationAssignmentsAccommodationRoomTypes) {\n            id\n            name\n            description\n          }\n          availableAddons @include(if: $withAccommodationAssignmentsAccommodationAvailableAddons) {\n            id\n            name\n            description\n          }\n          gallery @include(if: $withAccommodationAssignmentsAccommodationGallery) {\n            id\n          }\n        }\n        roomTypes @include(if: $withAccommodationAssignmentsRoomTypes) {\n          id\n          name\n          description\n          gallery @include(if: $withAccommodationAssignmentsRoomTypesGallery) {\n            id\n          }\n        }\n        useCustomRoomTypeSelection\n      }\n      accommodations @include(if: $withAccommodations) {\n        id\n        label\n        name\n        stars\n        description\n        roomTypes @include(if: $withAccommodationsRoomTypes) {\n          id\n          name\n          description\n          gallery @include(if: $withAccommodationsRoomTypesGallery) {\n            id\n          }\n        }\n        availableAddons @include(if: $withAccommodationsAvailableAddons) {\n          id\n          name\n          description\n          icon @include(if: $withAccommodationsAvailableAddonsIcon) {\n            id\n            assetId\n            publicId\n            url\n            resourceType\n            format\n            width\n            height\n            caption\n            title\n            description\n          }\n        }\n        gallery @include(if: $withAccommodationsGallery) {\n          id\n          images @include(if: $withAccommodationsGalleryImages) {\n            id\n            assetId\n            publicId\n            url\n            resourceType\n            format\n            width\n            height\n            caption\n            title\n            description\n          }\n        }\n      }\n      destinations @include(if: $withDestinations) {\n        id\n        name\n        entryRequirements\n        medicalInformation\n        language\n        timeShift\n        climate\n        currency\n      }\n      testimonials @include(if: $withTestimonials) {\n        id\n        contentBlock @include(if: $withTestimonialsContentBlock) {\n          id\n          title\n          text\n          image @include(if: $withTestimonialsContentBlockImage) {\n            id\n            assetId\n            publicId\n            url\n            resourceType\n            format\n            width\n            height\n            caption\n            title\n            description\n          }\n          imagePosition\n        }\n      }\n      mainImage @include(if: $withMainImage) {\n        id\n        assetId\n        publicId\n        url\n        resourceType\n        format\n        width\n        height\n        caption\n        title\n        description\n      }\n      mainVideo @include(if: $withMainVideo) {\n        id\n        assetId\n        publicId\n        url\n        resourceType\n        format\n        width\n        height\n        caption\n        title\n        description\n      }\n      gallery @include(if: $withGallery) {\n        id\n        images @include(if: $withGalleryImages) {\n          id\n          assetId\n          publicId\n          url\n          resourceType\n          format\n          width\n          height\n          caption\n          title\n          description\n        }\n      }\n      travelPdf @include(if: $withTravelPdf) {\n        id\n        assetId\n        publicId\n        url\n        resourceType\n        format\n        width\n        height\n        caption\n        title\n        description\n      }\n      travelExtensions @include(if: $withTravelExtensions) {\n        id\n        duration\n        name\n        description\n        highlights @include(if: $withTravelExtensionsHighlights) {\n          id\n          text\n        }\n        image @include(if: $withTravelExtensionsImage) {\n          id\n          assetId\n          publicId\n          url\n          resourceType\n          format\n          width\n          height\n          caption\n          title\n          description\n        }\n      }\n      programType\n      itinerary @include(if: $withItinerary) {\n        id\n        items @include(if: $withItineraryItems) {\n          id\n          duration\n          title\n          text\n          image @include(if: $withItineraryItemsImage) {\n            id\n            assetId\n            publicId\n            url\n            resourceType\n            format\n            width\n            height\n            caption\n            title\n            description\n          }\n          mapMarkers @include(if: $withItineraryItemsMapMarkers) {\n            id\n            lat\n            lng\n          }\n        }\n      }\n      programText\n      pricing @include(if: $withPricing) {\n        id\n        ageGroupSettings @include(if: $withPricingAgeGroupSettings) {\n          id\n          freeUntilAge\n          ageGroups @include(if: $withPricingAgeGroupSettingsAgeGroups) {\n            id\n            name\n            type\n            icon\n            minAge\n            maxAge\n          }\n        }\n        isTravelDocumentationAvailable\n        customDataConfig @include(if: $withPricingCustomDataConfig) {\n          id\n          useTravellerForm\n          travellerForm @include(if: $withPricingCustomDataConfigTravellerForm) {\n            id\n          }\n          useBookingForm\n          bookingForm @include(if: $withPricingCustomDataConfigBookingForm) {\n            id\n          }\n        }\n        travels @include(if: $withPricingTravels) {\n          id\n          ratioCatalogBundle @include(if: $withPricingTravelsRatioCatalogBundle) {\n            id\n            catalogCode\n            travelCode\n            json\n          }\n          catalogCode\n          travelCode\n          destination\n          name\n          transportType\n          transportTypeLabel\n          dates @include(if: $withPricingTravelsDates) {\n            id\n            dateNo\n            startDate\n            endDate\n            includesExtension\n            json\n          }\n          accommodations @include(if: $withPricingTravelsAccommodations) {\n            id\n            ratioPackageNo\n            name\n            label\n            info\n            isFamilyPackageAccommodation\n            isBabyPackage\n          }\n          extensionAccommodations @include(if: $withPricingTravelsExtensionAccommodations) {\n            id\n            ratioPackageNo\n            name\n            label\n            info\n            extensionAccommodationServiceNo\n          }\n          familyPackages @include(if: $withPricingTravelsFamilyPackages) {\n            id\n            ratioServiceNo\n            name\n            label\n            info\n          }\n          personalAddons @include(if: $withPricingTravelsPersonalAddons) {\n            id\n            ratioServiceNo\n            name\n            label\n            info\n          }\n          accommodationAddons @include(if: $withPricingTravelsAccommodationAddons) {\n            id\n            ratioServiceNo\n            name\n            label\n            info\n          }\n          bookingAddons @include(if: $withPricingTravelsBookingAddons) {\n            id\n            ratioServiceNo\n            name\n            label\n            info\n          }\n          collectiveAddons @include(if: $withPricingTravelsCollectiveAddons) {\n            id\n            label\n            info\n          }\n          extensions @include(if: $withPricingTravelsExtensions) {\n            id\n            label\n            info\n          }\n          personalDiscounts @include(if: $withPricingTravelsPersonalDiscounts) {\n            id\n            ratioServiceNo\n            name\n            label\n            info\n          }\n          importDateTime\n          importStatus\n        }\n        webhookConfig @include(if: $withPricingWebhookConfig) {\n          id\n          enabled\n          url\n        }\n        branding @include(if: $withPricingBranding) {\n          id\n          logo @include(if: $withPricingBrandingLogo) {\n            id\n            assetId\n            publicId\n            url\n            resourceType\n            format\n            width\n            height\n            caption\n            title\n            description\n          }\n          logoWidth\n        }\n        bargainSettings @include(if: $withPricingBargainSettings) {\n          id\n          active\n          untilDaysBeforeStart\n          bargainTier @include(if: $withPricingBargainSettingsBargainTier) {\n            id\n            fromPrice\n            discount\n          }\n        }\n        esimSettings @include(if: $withPricingEsimSettings) {\n          id\n          enabled\n          regions @include(if: $withPricingEsimSettingsRegions) {\n            id\n            name\n            serviceCodePrefix\n          }\n        }\n        passportConfig @include(if: $withPricingPassportConfig) {\n          id\n          passportOnly\n        }\n        tourOperator @include(if: $withPricingTourOperator) {\n          id\n          name\n          url\n          logo @include(if: $withPricingTourOperatorLogo) {\n            id\n            assetId\n            publicId\n            url\n            resourceType\n            format\n            width\n            height\n            caption\n            title\n            description\n          }\n          logoWidth\n          gtcPdf @include(if: $withPricingTourOperatorGtcPdf) {\n            id\n            assetId\n            publicId\n            url\n            resourceType\n            format\n            width\n            height\n            caption\n            title\n            description\n          }\n        }\n      }\n      minPrice\n      minPriceManualOverride\n      currency\n    }\n  }";
// language=GraphQL
var DELETE_TRAVEL_MUTATION = "\n  mutation Mutation($input: DeleteTravelInput) {\n    deleteTravel(input: $input) {\n      success\n    }\n  }";
// language=GraphQL
var FORCE_DELETE_TRAVEL_MUTATION = "\n  mutation Mutation($input: DeleteTravelInput) {\n    forceDeleteTravel(input: $input) {\n      success\n    }\n  }";
// language=GraphQL
var ADD_TRAVEL_TENANT_SETTINGS_MUTATION = "\n  mutation Mutation($input: addTravelTenantSettingsInput) {\n    addTravelTenantSettings(input: $input) {\n      id\n      tenantSettingsIds\n    }\n  }";
// language=GraphQL
var REMOVE_TRAVEL_TENANT_SETTINGS_MUTATION = "\n  mutation Mutation($input: removeTravelTenantSettingsInput) {\n    removeTravelTenantSettings(input: $input) {\n      id\n      tenantSettingsIds\n    }\n  }";
// language=GraphQL
var CREATE_TRAVEL_TENANT_SETTINGS_MUTATION = "\n  mutation Mutation($input: createTravelTenantSettingsInput) {\n    createTravelTenantSettings(input: $input) {\n      id\n      tenantSettingsIds\n    }\n  }";
// language=GraphQL
var DELETE_TRAVEL_TENANT_SETTINGS_MUTATION = "\n  mutation Mutation($input: deleteTravelTenantSettingsInput) {\n    deleteTravelTenantSettings(input: $input) {\n      id\n      tenantSettingsIds\n    }\n  }";
// language=GraphQL
var UPDATE_TRAVEL_TENANT_SETTINGS_ORDER_MUTATION = "\n  mutation Mutation($input: updateTravelTenantSettingsOrderInput) {\n    updateTravelTenantSettingsOrder(input: $input) {\n      id\n      tenantSettingsIds\n    }\n  }";
// language=GraphQL
var ADD_TRAVEL_HIGHLIGHTS_MUTATION = "\n  mutation Mutation($input: addTravelHighlightsInput) {\n    addTravelHighlights(input: $input) {\n      id\n      highlightIds\n    }\n  }";
// language=GraphQL
var REMOVE_TRAVEL_HIGHLIGHTS_MUTATION = "\n  mutation Mutation($input: removeTravelHighlightsInput) {\n    removeTravelHighlights(input: $input) {\n      id\n      highlightIds\n    }\n  }";
// language=GraphQL
var CREATE_TRAVEL_HIGHLIGHTS_MUTATION = "\n  mutation Mutation($input: createTravelHighlightsInput) {\n    createTravelHighlights(input: $input) {\n      id\n      highlightIds\n    }\n  }";
// language=GraphQL
var DELETE_TRAVEL_HIGHLIGHTS_MUTATION = "\n  mutation Mutation($input: deleteTravelHighlightsInput) {\n    deleteTravelHighlights(input: $input) {\n      id\n      highlightIds\n    }\n  }";
// language=GraphQL
var UPDATE_TRAVEL_HIGHLIGHTS_ORDER_MUTATION = "\n  mutation Mutation($input: updateTravelHighlightsOrderInput) {\n    updateTravelHighlightsOrder(input: $input) {\n      id\n      highlightIds\n    }\n  }";
// language=GraphQL
var ADD_TRAVEL_PARTNERS_MUTATION = "\n  mutation Mutation($input: addTravelPartnersInput) {\n    addTravelPartners(input: $input) {\n      id\n      partnerIds\n    }\n  }";
// language=GraphQL
var REMOVE_TRAVEL_PARTNERS_MUTATION = "\n  mutation Mutation($input: removeTravelPartnersInput) {\n    removeTravelPartners(input: $input) {\n      id\n      partnerIds\n    }\n  }";
// language=GraphQL
var CREATE_TRAVEL_PARTNERS_MUTATION = "\n  mutation Mutation($input: createTravelPartnersInput) {\n    createTravelPartners(input: $input) {\n      id\n      partnerIds\n    }\n  }";
// language=GraphQL
var DELETE_TRAVEL_PARTNERS_MUTATION = "\n  mutation Mutation($input: deleteTravelPartnersInput) {\n    deleteTravelPartners(input: $input) {\n      id\n      partnerIds\n    }\n  }";
// language=GraphQL
var UPDATE_TRAVEL_PARTNERS_ORDER_MUTATION = "\n  mutation Mutation($input: updateTravelPartnersOrderInput) {\n    updateTravelPartnersOrder(input: $input) {\n      id\n      partnerIds\n    }\n  }";
// language=GraphQL
var ADD_TRAVEL_TRAVEL_GUIDES_MUTATION = "\n  mutation Mutation($input: addTravelTravelGuidesInput) {\n    addTravelTravelGuides(input: $input) {\n      id\n      travelGuideIds\n    }\n  }";
// language=GraphQL
var REMOVE_TRAVEL_TRAVEL_GUIDES_MUTATION = "\n  mutation Mutation($input: removeTravelTravelGuidesInput) {\n    removeTravelTravelGuides(input: $input) {\n      id\n      travelGuideIds\n    }\n  }";
// language=GraphQL
var CREATE_TRAVEL_TRAVEL_GUIDES_MUTATION = "\n  mutation Mutation($input: createTravelTravelGuidesInput) {\n    createTravelTravelGuides(input: $input) {\n      id\n      travelGuideIds\n    }\n  }";
// language=GraphQL
var DELETE_TRAVEL_TRAVEL_GUIDES_MUTATION = "\n  mutation Mutation($input: deleteTravelTravelGuidesInput) {\n    deleteTravelTravelGuides(input: $input) {\n      id\n      travelGuideIds\n    }\n  }";
// language=GraphQL
var UPDATE_TRAVEL_TRAVEL_GUIDES_ORDER_MUTATION = "\n  mutation Mutation($input: updateTravelTravelGuidesOrderInput) {\n    updateTravelTravelGuidesOrder(input: $input) {\n      id\n      travelGuideIds\n    }\n  }";
// language=GraphQL
var ADD_TRAVEL_TEAMS_MUTATION = "\n  mutation Mutation($input: addTravelTeamsInput) {\n    addTravelTeams(input: $input) {\n      id\n      teamIds\n    }\n  }";
// language=GraphQL
var REMOVE_TRAVEL_TEAMS_MUTATION = "\n  mutation Mutation($input: removeTravelTeamsInput) {\n    removeTravelTeams(input: $input) {\n      id\n      teamIds\n    }\n  }";
// language=GraphQL
var CREATE_TRAVEL_TEAMS_MUTATION = "\n  mutation Mutation($input: createTravelTeamsInput) {\n    createTravelTeams(input: $input) {\n      id\n      teamIds\n    }\n  }";
// language=GraphQL
var DELETE_TRAVEL_TEAMS_MUTATION = "\n  mutation Mutation($input: deleteTravelTeamsInput) {\n    deleteTravelTeams(input: $input) {\n      id\n      teamIds\n    }\n  }";
// language=GraphQL
var UPDATE_TRAVEL_TEAMS_ORDER_MUTATION = "\n  mutation Mutation($input: updateTravelTeamsOrderInput) {\n    updateTravelTeamsOrder(input: $input) {\n      id\n      teamIds\n    }\n  }";
// language=GraphQL
var ADD_TRAVEL_ACCOMMODATION_ASSIGNMENTS_MUTATION = "\n  mutation Mutation($input: addTravelAccommodationAssignmentsInput) {\n    addTravelAccommodationAssignments(input: $input) {\n      id\n      accommodationAssignmentIds\n    }\n  }";
// language=GraphQL
var REMOVE_TRAVEL_ACCOMMODATION_ASSIGNMENTS_MUTATION = "\n  mutation Mutation($input: removeTravelAccommodationAssignmentsInput) {\n    removeTravelAccommodationAssignments(input: $input) {\n      id\n      accommodationAssignmentIds\n    }\n  }";
// language=GraphQL
var CREATE_TRAVEL_ACCOMMODATION_ASSIGNMENTS_MUTATION = "\n  mutation Mutation($input: createTravelAccommodationAssignmentsInput) {\n    createTravelAccommodationAssignments(input: $input) {\n      id\n      accommodationAssignmentIds\n    }\n  }";
// language=GraphQL
var DELETE_TRAVEL_ACCOMMODATION_ASSIGNMENTS_MUTATION = "\n  mutation Mutation($input: deleteTravelAccommodationAssignmentsInput) {\n    deleteTravelAccommodationAssignments(input: $input) {\n      id\n      accommodationAssignmentIds\n    }\n  }";
// language=GraphQL
var UPDATE_TRAVEL_ACCOMMODATION_ASSIGNMENTS_ORDER_MUTATION = "\n  mutation Mutation($input: updateTravelAccommodationAssignmentsOrderInput) {\n    updateTravelAccommodationAssignmentsOrder(input: $input) {\n      id\n      accommodationAssignmentIds\n    }\n  }";
// language=GraphQL
var ADD_TRAVEL_ACCOMMODATIONS_MUTATION = "\n  mutation Mutation($input: addTravelAccommodationsInput) {\n    addTravelAccommodations(input: $input) {\n      id\n      accommodationIds\n    }\n  }";
// language=GraphQL
var REMOVE_TRAVEL_ACCOMMODATIONS_MUTATION = "\n  mutation Mutation($input: removeTravelAccommodationsInput) {\n    removeTravelAccommodations(input: $input) {\n      id\n      accommodationIds\n    }\n  }";
// language=GraphQL
var CREATE_TRAVEL_ACCOMMODATIONS_MUTATION = "\n  mutation Mutation($input: createTravelAccommodationsInput) {\n    createTravelAccommodations(input: $input) {\n      id\n      accommodationIds\n    }\n  }";
// language=GraphQL
var DELETE_TRAVEL_ACCOMMODATIONS_MUTATION = "\n  mutation Mutation($input: deleteTravelAccommodationsInput) {\n    deleteTravelAccommodations(input: $input) {\n      id\n      accommodationIds\n    }\n  }";
// language=GraphQL
var UPDATE_TRAVEL_ACCOMMODATIONS_ORDER_MUTATION = "\n  mutation Mutation($input: updateTravelAccommodationsOrderInput) {\n    updateTravelAccommodationsOrder(input: $input) {\n      id\n      accommodationIds\n    }\n  }";
// language=GraphQL
var ADD_TRAVEL_DESTINATIONS_MUTATION = "\n  mutation Mutation($input: addTravelDestinationsInput) {\n    addTravelDestinations(input: $input) {\n      id\n      destinationIds\n    }\n  }";
// language=GraphQL
var REMOVE_TRAVEL_DESTINATIONS_MUTATION = "\n  mutation Mutation($input: removeTravelDestinationsInput) {\n    removeTravelDestinations(input: $input) {\n      id\n      destinationIds\n    }\n  }";
// language=GraphQL
var CREATE_TRAVEL_DESTINATIONS_MUTATION = "\n  mutation Mutation($input: createTravelDestinationsInput) {\n    createTravelDestinations(input: $input) {\n      id\n      destinationIds\n    }\n  }";
// language=GraphQL
var DELETE_TRAVEL_DESTINATIONS_MUTATION = "\n  mutation Mutation($input: deleteTravelDestinationsInput) {\n    deleteTravelDestinations(input: $input) {\n      id\n      destinationIds\n    }\n  }";
// language=GraphQL
var UPDATE_TRAVEL_DESTINATIONS_ORDER_MUTATION = "\n  mutation Mutation($input: updateTravelDestinationsOrderInput) {\n    updateTravelDestinationsOrder(input: $input) {\n      id\n      destinationIds\n    }\n  }";
// language=GraphQL
var ADD_TRAVEL_TESTIMONIALS_MUTATION = "\n  mutation Mutation($input: addTravelTestimonialsInput) {\n    addTravelTestimonials(input: $input) {\n      id\n      testimonialIds\n    }\n  }";
// language=GraphQL
var REMOVE_TRAVEL_TESTIMONIALS_MUTATION = "\n  mutation Mutation($input: removeTravelTestimonialsInput) {\n    removeTravelTestimonials(input: $input) {\n      id\n      testimonialIds\n    }\n  }";
// language=GraphQL
var CREATE_TRAVEL_TESTIMONIALS_MUTATION = "\n  mutation Mutation($input: createTravelTestimonialsInput) {\n    createTravelTestimonials(input: $input) {\n      id\n      testimonialIds\n    }\n  }";
// language=GraphQL
var DELETE_TRAVEL_TESTIMONIALS_MUTATION = "\n  mutation Mutation($input: deleteTravelTestimonialsInput) {\n    deleteTravelTestimonials(input: $input) {\n      id\n      testimonialIds\n    }\n  }";
// language=GraphQL
var UPDATE_TRAVEL_TESTIMONIALS_ORDER_MUTATION = "\n  mutation Mutation($input: updateTravelTestimonialsOrderInput) {\n    updateTravelTestimonialsOrder(input: $input) {\n      id\n      testimonialIds\n    }\n  }";
// language=GraphQL
var ADD_TRAVEL_TRAVEL_EXTENSIONS_MUTATION = "\n  mutation Mutation($input: addTravelTravelExtensionsInput) {\n    addTravelTravelExtensions(input: $input) {\n      id\n      travelExtensionIds\n    }\n  }";
// language=GraphQL
var REMOVE_TRAVEL_TRAVEL_EXTENSIONS_MUTATION = "\n  mutation Mutation($input: removeTravelTravelExtensionsInput) {\n    removeTravelTravelExtensions(input: $input) {\n      id\n      travelExtensionIds\n    }\n  }";
// language=GraphQL
var CREATE_TRAVEL_TRAVEL_EXTENSIONS_MUTATION = "\n  mutation Mutation($input: createTravelTravelExtensionsInput) {\n    createTravelTravelExtensions(input: $input) {\n      id\n      travelExtensionIds\n    }\n  }";
// language=GraphQL
var DELETE_TRAVEL_TRAVEL_EXTENSIONS_MUTATION = "\n  mutation Mutation($input: deleteTravelTravelExtensionsInput) {\n    deleteTravelTravelExtensions(input: $input) {\n      id\n      travelExtensionIds\n    }\n  }";
// language=GraphQL
var UPDATE_TRAVEL_TRAVEL_EXTENSIONS_ORDER_MUTATION = "\n  mutation Mutation($input: updateTravelTravelExtensionsOrderInput) {\n    updateTravelTravelExtensionsOrder(input: $input) {\n      id\n      travelExtensionIds\n    }\n  }";
// language=GraphQL
var TRAVELS_DEPENDENTS_QUERY = "query Query($id: ID!, $withBookings: Boolean = false, $withRedirects: Boolean = false, $withLinks: Boolean = false, $withCmsHeaderSliderBlocks: Boolean = false, $withCmsTravelSelectionBlocks: Boolean = false) {\n  groupedDependents: travelDependents(id: $id) {\n    bookings @include(if: $withBookings) {\n      id\n      referenceNo\n      travellerRemarks\n      travellerDataCorrectnessConfirmation\n      localState\n      backofficePayload\n      backofficeResponse\n      transmissionStatus\n      webhookStatus\n      webhookResponse\n      webhookDuration\n      confirmationEmailSent\n      isPassportDataRequired\n      passportDataReminderEmailSent\n      passportDataReceived    }\n    redirects @include(if: $withRedirects) {\n      id\n      fromType\n      fromUrl\n      toType\n      toUrl\n    }\n    links @include(if: $withLinks) {\n      id\n      label\n      targetBlank\n      type\n      url\n    }\n    cmsHeaderSliderBlocks @include(if: $withCmsHeaderSliderBlocks) {\n      id\n    }\n    cmsTravelSelectionBlocks @include(if: $withCmsTravelSelectionBlocks) {\n      id\n    }\n  }\n}";

// EXTERNAL MODULE: ./src/entities/travelAvailabilityStatus/entity.ts + 3 modules
var entity = __webpack_require__(47041);
// EXTERNAL MODULE: ./src/entities/employee/entity.ts + 3 modules
var employee_entity = __webpack_require__(4383);
// EXTERNAL MODULE: ./src/entities/travelLabel/entity.ts + 3 modules
var travelLabel_entity = __webpack_require__(46714);
// EXTERNAL MODULE: ./src/entities/elementSeoSettings/entity.ts + 3 modules
var elementSeoSettings_entity = __webpack_require__(64750);
// EXTERNAL MODULE: ./src/entities/travelObjectTenantSettings/entity.ts + 3 modules
var travelObjectTenantSettings_entity = __webpack_require__(91687);
// EXTERNAL MODULE: ./src/entities/travelHighlight/entity.ts + 3 modules
var travelHighlight_entity = __webpack_require__(60328);
// EXTERNAL MODULE: ./src/entities/travelPartner/entity.ts + 3 modules
var travelPartner_entity = __webpack_require__(52889);
// EXTERNAL MODULE: ./src/entities/travelGuide/entity.ts + 3 modules
var travelGuide_entity = __webpack_require__(36687);
// EXTERNAL MODULE: ./src/entities/travelTeam/entity.ts + 3 modules
var travelTeam_entity = __webpack_require__(541);
// EXTERNAL MODULE: ./src/entities/travelAccommodationAssignment/entity.ts + 3 modules
var travelAccommodationAssignment_entity = __webpack_require__(88939);
// EXTERNAL MODULE: ./src/entities/accommodation/entity.ts + 3 modules
var accommodation_entity = __webpack_require__(92043);
// EXTERNAL MODULE: ./src/entities/travelDestination/entity.ts + 3 modules
var travelDestination_entity = __webpack_require__(22546);
// EXTERNAL MODULE: ./src/entities/travelTestimonial/entity.ts + 3 modules
var travelTestimonial_entity = __webpack_require__(48716);
// EXTERNAL MODULE: ./src/entities/mediaFile/entity.ts + 3 modules
var mediaFile_entity = __webpack_require__(24180);
// EXTERNAL MODULE: ./src/entities/imageGallery/entity.ts + 3 modules
var imageGallery_entity = __webpack_require__(41);
// EXTERNAL MODULE: ./src/entities/travelExtension/entity.ts + 3 modules
var travelExtension_entity = __webpack_require__(14585);
// EXTERNAL MODULE: ./src/entities/itinerary/entity.ts + 3 modules
var itinerary_entity = __webpack_require__(80231);
// EXTERNAL MODULE: ./src/entities/travelPricing/entity.ts + 3 modules
var travelPricing_entity = __webpack_require__(60090);
;// CONCATENATED MODULE: ./src/entities/travel/model.ts



















var travelModel = {
    name: "travel",
    namePlural: "travels",
    uniqueName: "travel",
    uniqueNamePlural: "travels",
    path: "travel/travel",
    baseUrl: "/travels",
    translationPrefix: "entities:travel.",
    getDisplayName: function(values) {
        return values.name;
    },
    gql: {
        getAll: ALL_TRAVELS_QUERY,
        getSingle: SINGLE_TRAVEL_QUERY,
        create: CREATE_TRAVEL_MUTATION,
        update: UPDATE_TRAVEL_MUTATION,
        delete: DELETE_TRAVEL_MUTATION,
        forceDelete: FORCE_DELETE_TRAVEL_MUTATION
    },
    attributes: {
        name: {
            name: "name",
            label: "entities:travel.attributes.name.label",
            type: "value",
            dataType: "string",
            defaultInput: true,
            inputType: "text",
            validationType: "string",
            validations: [
                {
                    type: "required"
                }, 
            ]
        },
        isBestseller: {
            name: "isBestseller",
            label: "entities:travel.attributes.isBestseller.label",
            type: "value",
            dataType: "boolean",
            defaultInput: true,
            inputType: "switch",
            validationType: "string",
            validations: []
        },
        startDate: {
            name: "startDate",
            label: "entities:travel.attributes.startDate.label",
            type: "value",
            dataType: "Date",
            defaultInput: false,
            inputType: "date",
            isStartDate: true,
            endDateAttribute: "endDate",
            validationType: "string",
            validations: []
        },
        endDate: {
            name: "endDate",
            label: "entities:travel.attributes.endDate.label",
            type: "value",
            dataType: "Date",
            defaultInput: false,
            inputType: "date",
            isEndDate: true,
            startDateAttribute: "startDate",
            validationType: "string",
            validations: []
        },
        availabilityStatus: {
            name: "availabilityStatus",
            label: "entities:travel.attributes.availabilityStatus.label",
            type: "entityObject",
            dataType: "any",
            getEntity: function() {
                return entity/* default */.Z;
            },
            defaultInput: true,
            inputType: "select",
            validationType: "string",
            validations: []
        },
        executionStatus: {
            name: "executionStatus",
            label: "entities:travel.attributes.executionStatus.label",
            type: "value",
            dataType: "string",
            defaultValue: "open",
            defaultInput: false,
            inputType: "select",
            selectOptions: [
                {
                    label: "entities:travel.attributes.executionStatus.selectOptions.open.label",
                    value: "open"
                },
                {
                    label: "entities:travel.attributes.executionStatus.selectOptions.executed.label",
                    value: "executed"
                },
                {
                    label: "entities:travel.attributes.executionStatus.selectOptions.cancelled.label",
                    value: "cancelled"
                }, 
            ],
            validationType: "string",
            validations: []
        },
        travelConsultant: {
            name: "travelConsultant",
            label: "entities:travel.attributes.travelConsultant.label",
            type: "entityObject",
            dataType: "any",
            getEntity: function() {
                return employee_entity/* default */.Z;
            },
            defaultInput: true,
            inputType: "select",
            validationType: "string",
            validations: []
        },
        label: {
            name: "label",
            label: "entities:travel.attributes.label.label",
            type: "entityObject",
            dataType: "any",
            getEntity: function() {
                return travelLabel_entity/* default */.Z;
            },
            defaultInput: true,
            inputType: "select",
            validationType: "string",
            validations: []
        },
        title: {
            name: "title",
            label: "entities:travel.attributes.title.label",
            type: "value",
            dataType: "string",
            defaultInput: true,
            inputType: "text",
            validationType: "string",
            validations: []
        },
        description: {
            name: "description",
            label: "entities:travel.attributes.description.label",
            type: "value",
            dataType: "string",
            defaultInput: true,
            inputType: "wysiwyg",
            validationType: "string",
            validations: []
        },
        includedServices: {
            name: "includedServices",
            label: "entities:travel.attributes.includedServices.label",
            type: "value",
            dataType: "string",
            defaultInput: true,
            inputType: "wysiwyg",
            validationType: "string",
            validations: []
        },
        excludedServices: {
            name: "excludedServices",
            label: "entities:travel.attributes.excludedServices.label",
            type: "value",
            dataType: "string",
            defaultInput: true,
            inputType: "wysiwyg",
            validationType: "string",
            validations: []
        },
        pricingTable: {
            name: "pricingTable",
            label: "entities:travel.attributes.pricingTable.label",
            type: "value",
            dataType: "string",
            defaultInput: true,
            inputType: "wysiwyg",
            validationType: "string",
            validations: []
        },
        priceCalculationInfo: {
            name: "priceCalculationInfo",
            label: "entities:travel.attributes.priceCalculationInfo.label",
            type: "value",
            dataType: "string",
            defaultInput: true,
            inputType: "textarea",
            validationType: "string",
            validations: []
        },
        seoSettings: {
            name: "seoSettings",
            label: "entities:travel.attributes.seoSettings.label",
            type: "entityObject",
            dataType: "any",
            getEntity: function() {
                return elementSeoSettings_entity/* default */.Z;
            },
            defaultInput: false,
            inputType: "select",
            validationType: "string",
            validations: []
        },
        tenantSettings: {
            name: "tenantSettings",
            label: "entities:travel.attributes.tenantSettings.label",
            type: "entityCollection",
            dataType: "[any]",
            getEntity: function() {
                return travelObjectTenantSettings_entity/* default */.Z;
            },
            defaultInput: false,
            inputType: "text",
            validationType: "string",
            validations: []
        },
        highlights: {
            name: "highlights",
            label: "entities:travel.attributes.highlights.label",
            type: "entityCollection",
            dataType: "[any]",
            getEntity: function() {
                return travelHighlight_entity/* default */.Z;
            },
            defaultInput: false,
            inputType: "text",
            validationType: "string",
            validations: []
        },
        partners: {
            name: "partners",
            label: "entities:travel.attributes.partners.label",
            type: "entityCollection",
            dataType: "[any]",
            getEntity: function() {
                return travelPartner_entity/* default */.Z;
            },
            defaultInput: false,
            inputType: "text",
            validationType: "string",
            validations: []
        },
        travelGuides: {
            name: "travelGuides",
            label: "entities:travel.attributes.travelGuides.label",
            type: "entityCollection",
            dataType: "[any]",
            getEntity: function() {
                return travelGuide_entity/* default */.Z;
            },
            defaultInput: false,
            inputType: "text",
            validationType: "string",
            validations: []
        },
        teams: {
            name: "teams",
            label: "entities:travel.attributes.teams.label",
            type: "entityCollection",
            dataType: "[any]",
            getEntity: function() {
                return travelTeam_entity/* default */.Z;
            },
            defaultInput: false,
            inputType: "text",
            validationType: "string",
            validations: []
        },
        accommodationAssignments: {
            name: "accommodationAssignments",
            label: "entities:travel.attributes.accommodationAssignments.label",
            type: "entityCollection",
            dataType: "[any]",
            getEntity: function() {
                return travelAccommodationAssignment_entity/* default */.Z;
            },
            defaultInput: false,
            inputType: "text",
            validationType: "string",
            validations: []
        },
        accommodations: {
            name: "accommodations",
            label: "entities:travel.attributes.accommodations.label",
            type: "entityCollection",
            dataType: "[any]",
            getEntity: function() {
                return accommodation_entity/* default */.Z;
            },
            defaultInput: false,
            inputType: "text",
            validationType: "string",
            validations: []
        },
        destinations: {
            name: "destinations",
            label: "entities:travel.attributes.destinations.label",
            type: "entityCollection",
            dataType: "[any]",
            getEntity: function() {
                return travelDestination_entity/* default */.Z;
            },
            defaultInput: false,
            inputType: "text",
            validationType: "string",
            validations: []
        },
        testimonials: {
            name: "testimonials",
            label: "entities:travel.attributes.testimonials.label",
            type: "entityCollection",
            dataType: "[any]",
            getEntity: function() {
                return travelTestimonial_entity/* default */.Z;
            },
            defaultInput: false,
            inputType: "text",
            validationType: "string",
            validations: []
        },
        mainImage: {
            name: "mainImage",
            label: "entities:travel.attributes.mainImage.label",
            type: "entityObject",
            dataType: "any",
            getEntity: function() {
                return mediaFile_entity/* default */.Z;
            },
            defaultInput: false,
            inputType: "select",
            validationType: "string",
            validations: []
        },
        mainVideo: {
            name: "mainVideo",
            label: "entities:travel.attributes.mainVideo.label",
            type: "entityObject",
            dataType: "any",
            getEntity: function() {
                return mediaFile_entity/* default */.Z;
            },
            defaultInput: false,
            inputType: "select",
            validationType: "string",
            validations: []
        },
        gallery: {
            name: "gallery",
            label: "entities:travel.attributes.gallery.label",
            type: "entityObject",
            dataType: "any",
            getEntity: function() {
                return imageGallery_entity/* default */.Z;
            },
            defaultInput: false,
            inputType: "select",
            validationType: "string",
            validations: []
        },
        travelPdf: {
            name: "travelPdf",
            label: "entities:travel.attributes.travelPdf.label",
            type: "entityObject",
            dataType: "any",
            getEntity: function() {
                return mediaFile_entity/* default */.Z;
            },
            defaultInput: false,
            inputType: "select",
            validationType: "string",
            validations: []
        },
        travelExtensions: {
            name: "travelExtensions",
            label: "entities:travel.attributes.travelExtensions.label",
            type: "entityCollection",
            dataType: "[any]",
            getEntity: function() {
                return travelExtension_entity/* default */.Z;
            },
            defaultInput: false,
            inputType: "text",
            validationType: "string",
            validations: []
        },
        programType: {
            name: "programType",
            label: "entities:travel.attributes.programType.label",
            type: "value",
            dataType: "string",
            defaultValue: "ITINERARY",
            defaultInput: false,
            inputType: "select",
            selectOptions: [
                {
                    label: "entities:travel.attributes.programType.selectOptions.ITINERARY.label",
                    value: "ITINERARY"
                },
                {
                    label: "entities:travel.attributes.programType.selectOptions.TEXT.label",
                    value: "TEXT"
                }, 
            ],
            validationType: "string",
            validations: []
        },
        itinerary: {
            name: "itinerary",
            label: "entities:travel.attributes.itinerary.label",
            type: "entityObject",
            dataType: "any",
            getEntity: function() {
                return itinerary_entity/* default */.Z;
            },
            defaultInput: false,
            inputType: "select",
            validationType: "string",
            validations: []
        },
        programText: {
            name: "programText",
            label: "entities:travel.attributes.programText.label",
            type: "value",
            dataType: "string",
            defaultInput: false,
            inputType: "wysiwyg",
            validationType: "string",
            validations: []
        },
        pricing: {
            name: "pricing",
            label: "entities:travel.attributes.pricing.label",
            type: "entityObject",
            dataType: "any",
            getEntity: function() {
                return travelPricing_entity/* default */.Z;
            },
            defaultInput: false,
            inputType: "select",
            validationType: "string",
            validations: []
        },
        minPrice: {
            name: "minPrice",
            label: "entities:travel.attributes.minPrice.label",
            type: "value",
            dataType: "number",
            defaultInput: false,
            inputType: "hidden",
            validationType: "string",
            validations: []
        },
        minPriceManualOverride: {
            name: "minPriceManualOverride",
            label: "entities:travel.attributes.minPriceManualOverride.label",
            type: "value",
            dataType: "boolean",
            defaultInput: false,
            inputType: "switch",
            validationType: "string",
            validations: []
        },
        currency: {
            name: "currency",
            label: "entities:travel.attributes.currency.label",
            type: "value",
            dataType: "string",
            defaultInput: false,
            inputType: "text",
            validationType: "string",
            validations: []
        }
    }
};
/* harmony default export */ var model = (travelModel);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(20414);
// EXTERNAL MODULE: ./src/entities/lib.ts
var lib = __webpack_require__(23480);
// EXTERNAL MODULE: ./src/lib/api/graphQLClient.ts
var graphQLClient = __webpack_require__(40112);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/swr/dist/index.mjs
var dist = __webpack_require__(8100);
// EXTERNAL MODULE: ./src/lib/helpers/helpers.ts
var helpers = __webpack_require__(15778);
;// CONCATENATED MODULE: ./src/entities/travel/repository.ts










var hydrateObjects = function(objects) {
    return objects.map(function(object) {
        return (0,lib/* hydrateEntityObject */.b)(model, object);
    });
};
var hydrateObject = function(object) {
    return (0,lib/* hydrateEntityObject */.b)(model, object);
};
var travelRepository = {
    getObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    id: id
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(SINGLE_TRAVEL_QUERY, variables).then(function(data) {
                        return hydrateObject(data.travel);
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }(),
    getObjects: /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        var includes;
        var _arguments = arguments;
        return (0,tslib_es6.__generator)(this, function(_state) {
            includes = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : {};
            return [
                2,
                graphQLClient/* default.request */.Z.request(ALL_TRAVELS_QUERY, includes).then(function(data) {
                    return hydrateObjects(data.travels);
                })
            ];
        });
    }),
    useObject: function(id) {
        var includes = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        // eslint-disable-next-line react-hooks/exhaustive-deps
        var variables = (0,react.useMemo)(function() {
            return (0,_object_spread/* default */.Z)({
                id: id
            }, includes);
        }, [
            id
        ]);
        var ref = (0,dist/* default */.ZP)([
            SINGLE_TRAVEL_QUERY,
            variables
        ], {
            revalidateOnFocus: false
        }), data = ref.data, error = ref.error, mutate = ref.mutate;
        return {
            object: !data ? data : hydrateObject(data.travel),
            isLoading: !error && !data,
            isError: error,
            mutate: mutate
        };
    },
    useObjects: function() {
        var includes = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        // eslint-disable-next-line react-hooks/exhaustive-deps
        var variables = (0,react.useMemo)(function() {
            return includes;
        }, []);
        var ref = (0,dist/* default */.ZP)([
            ALL_TRAVELS_QUERY,
            variables
        ]), data = ref.data, error = ref.error, mutate = ref.mutate;
        return {
            objects: !data ? data : hydrateObjects(data.travels),
            isLoading: !error && !data,
            isError: error,
            mutate: mutate
        };
    },
    getDependents: function(id, includes) {
        var includeVars = {};
        includes.forEach(function(include) {
            includeVars["with".concat((0,helpers/* uppercaseFirst */.AB)(include))] = true;
        });
        var variables = (0,_object_spread/* default */.Z)({
            id: id
        }, includeVars);
        return graphQLClient/* default.request */.Z.request(TRAVELS_DEPENDENTS_QUERY, variables).then(function(data) {
            return data.groupedDependents;
        });
    },
    useDependents: function(id, includes) {
        var includeVars = {};
        includes.forEach(function(include) {
            includeVars["with".concat((0,helpers/* uppercaseFirst */.AB)(include))] = true;
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
        var variables = (0,react.useMemo)(function() {
            return (0,_object_spread/* default */.Z)({
                id: id
            }, includeVars);
        }, [
            id
        ]);
        var ref = (0,dist/* default */.ZP)([
            TRAVELS_DEPENDENTS_QUERY,
            variables
        ], {
            revalidateOnFocus: false
        }), data = ref.data, error = ref.error, mutate = ref.mutate;
        return {
            data: !data ? data : data.groupedDependents,
            isLoading: !error && !data,
            isError: error,
            mutate: mutate
        };
    },
    createObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(data) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    input: data
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(CREATE_TRAVEL_MUTATION, variables).then(function(data) {
                        return hydrateObject(data.travel);
                    })
                ];
            });
        });
        return function(data) {
            return _ref.apply(this, arguments);
        };
    }(),
    updateObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(data) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    input: data
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(UPDATE_TRAVEL_MUTATION, variables).then(function(data) {
                        return hydrateObject(data.travel);
                    })
                ];
            });
        });
        return function(data) {
            return _ref.apply(this, arguments);
        };
    }(),
    deleteObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(DELETE_TRAVEL_MUTATION, variables).then(function(data) {
                        return data.deleteTravel;
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }(),
    forceDeleteObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(FORCE_DELETE_TRAVEL_MUTATION, variables).then(function(data) {
                        return data.forceDeleteTravel;
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }(),
    assignTenantSettings: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, itemIds) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        tenantSettingsIds: itemIds
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(ADD_TRAVEL_TENANT_SETTINGS_MUTATION, variables)
                ];
            });
        });
        return function(id, itemIds) {
            return _ref.apply(this, arguments);
        };
    }(),
    unassignTenantSettings: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, itemIds) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        tenantSettingsIds: itemIds
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(REMOVE_TRAVEL_TENANT_SETTINGS_MUTATION, variables)
                ];
            });
        });
        return function(id, itemIds) {
            return _ref.apply(this, arguments);
        };
    }(),
    createTenantSettings: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, items) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        tenantSettings: items
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(CREATE_TRAVEL_TENANT_SETTINGS_MUTATION, variables)
                ];
            });
        });
        return function(id, items) {
            return _ref.apply(this, arguments);
        };
    }(),
    deleteTenantSettings: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, itemIds) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        tenantSettingsIds: itemIds
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(DELETE_TRAVEL_TENANT_SETTINGS_MUTATION, variables)
                ];
            });
        });
        return function(id, itemIds) {
            return _ref.apply(this, arguments);
        };
    }(),
    updateTenantSettingsOrder: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, itemIds) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        tenantSettingsIds: itemIds
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(UPDATE_TRAVEL_TENANT_SETTINGS_ORDER_MUTATION, variables)
                ];
            });
        });
        return function(id, itemIds) {
            return _ref.apply(this, arguments);
        };
    }(),
    assignHighlights: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, itemIds) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        highlightIds: itemIds
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(ADD_TRAVEL_HIGHLIGHTS_MUTATION, variables)
                ];
            });
        });
        return function(id, itemIds) {
            return _ref.apply(this, arguments);
        };
    }(),
    unassignHighlights: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, itemIds) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        highlightIds: itemIds
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(REMOVE_TRAVEL_HIGHLIGHTS_MUTATION, variables)
                ];
            });
        });
        return function(id, itemIds) {
            return _ref.apply(this, arguments);
        };
    }(),
    createHighlights: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, items) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        highlights: items
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(CREATE_TRAVEL_HIGHLIGHTS_MUTATION, variables)
                ];
            });
        });
        return function(id, items) {
            return _ref.apply(this, arguments);
        };
    }(),
    deleteHighlights: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, itemIds) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        highlightIds: itemIds
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(DELETE_TRAVEL_HIGHLIGHTS_MUTATION, variables)
                ];
            });
        });
        return function(id, itemIds) {
            return _ref.apply(this, arguments);
        };
    }(),
    updateHighlightsOrder: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, itemIds) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        highlightIds: itemIds
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(UPDATE_TRAVEL_HIGHLIGHTS_ORDER_MUTATION, variables)
                ];
            });
        });
        return function(id, itemIds) {
            return _ref.apply(this, arguments);
        };
    }(),
    assignPartners: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, itemIds) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        partnerIds: itemIds
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(ADD_TRAVEL_PARTNERS_MUTATION, variables)
                ];
            });
        });
        return function(id, itemIds) {
            return _ref.apply(this, arguments);
        };
    }(),
    unassignPartners: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, itemIds) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        partnerIds: itemIds
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(REMOVE_TRAVEL_PARTNERS_MUTATION, variables)
                ];
            });
        });
        return function(id, itemIds) {
            return _ref.apply(this, arguments);
        };
    }(),
    createPartners: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, items) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        partners: items
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(CREATE_TRAVEL_PARTNERS_MUTATION, variables)
                ];
            });
        });
        return function(id, items) {
            return _ref.apply(this, arguments);
        };
    }(),
    deletePartners: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, itemIds) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        partnerIds: itemIds
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(DELETE_TRAVEL_PARTNERS_MUTATION, variables)
                ];
            });
        });
        return function(id, itemIds) {
            return _ref.apply(this, arguments);
        };
    }(),
    updatePartnersOrder: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, itemIds) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        partnerIds: itemIds
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(UPDATE_TRAVEL_PARTNERS_ORDER_MUTATION, variables)
                ];
            });
        });
        return function(id, itemIds) {
            return _ref.apply(this, arguments);
        };
    }(),
    assignTravelGuides: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, itemIds) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        travelGuideIds: itemIds
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(ADD_TRAVEL_TRAVEL_GUIDES_MUTATION, variables)
                ];
            });
        });
        return function(id, itemIds) {
            return _ref.apply(this, arguments);
        };
    }(),
    unassignTravelGuides: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, itemIds) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        travelGuideIds: itemIds
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(REMOVE_TRAVEL_TRAVEL_GUIDES_MUTATION, variables)
                ];
            });
        });
        return function(id, itemIds) {
            return _ref.apply(this, arguments);
        };
    }(),
    createTravelGuides: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, items) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        travelGuides: items
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(CREATE_TRAVEL_TRAVEL_GUIDES_MUTATION, variables)
                ];
            });
        });
        return function(id, items) {
            return _ref.apply(this, arguments);
        };
    }(),
    deleteTravelGuides: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, itemIds) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        travelGuideIds: itemIds
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(DELETE_TRAVEL_TRAVEL_GUIDES_MUTATION, variables)
                ];
            });
        });
        return function(id, itemIds) {
            return _ref.apply(this, arguments);
        };
    }(),
    updateTravelGuidesOrder: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, itemIds) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        travelGuideIds: itemIds
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(UPDATE_TRAVEL_TRAVEL_GUIDES_ORDER_MUTATION, variables)
                ];
            });
        });
        return function(id, itemIds) {
            return _ref.apply(this, arguments);
        };
    }(),
    assignTeams: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, itemIds) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        teamIds: itemIds
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(ADD_TRAVEL_TEAMS_MUTATION, variables)
                ];
            });
        });
        return function(id, itemIds) {
            return _ref.apply(this, arguments);
        };
    }(),
    unassignTeams: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, itemIds) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        teamIds: itemIds
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(REMOVE_TRAVEL_TEAMS_MUTATION, variables)
                ];
            });
        });
        return function(id, itemIds) {
            return _ref.apply(this, arguments);
        };
    }(),
    createTeams: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, items) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        teams: items
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(CREATE_TRAVEL_TEAMS_MUTATION, variables)
                ];
            });
        });
        return function(id, items) {
            return _ref.apply(this, arguments);
        };
    }(),
    deleteTeams: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, itemIds) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        teamIds: itemIds
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(DELETE_TRAVEL_TEAMS_MUTATION, variables)
                ];
            });
        });
        return function(id, itemIds) {
            return _ref.apply(this, arguments);
        };
    }(),
    updateTeamsOrder: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, itemIds) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        teamIds: itemIds
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(UPDATE_TRAVEL_TEAMS_ORDER_MUTATION, variables)
                ];
            });
        });
        return function(id, itemIds) {
            return _ref.apply(this, arguments);
        };
    }(),
    assignAccommodationAssignments: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, itemIds) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        accommodationAssignmentIds: itemIds
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(ADD_TRAVEL_ACCOMMODATION_ASSIGNMENTS_MUTATION, variables)
                ];
            });
        });
        return function(id, itemIds) {
            return _ref.apply(this, arguments);
        };
    }(),
    unassignAccommodationAssignments: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, itemIds) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        accommodationAssignmentIds: itemIds
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(REMOVE_TRAVEL_ACCOMMODATION_ASSIGNMENTS_MUTATION, variables)
                ];
            });
        });
        return function(id, itemIds) {
            return _ref.apply(this, arguments);
        };
    }(),
    createAccommodationAssignments: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, items) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        accommodationAssignments: items
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(CREATE_TRAVEL_ACCOMMODATION_ASSIGNMENTS_MUTATION, variables)
                ];
            });
        });
        return function(id, items) {
            return _ref.apply(this, arguments);
        };
    }(),
    deleteAccommodationAssignments: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, itemIds) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        accommodationAssignmentIds: itemIds
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(DELETE_TRAVEL_ACCOMMODATION_ASSIGNMENTS_MUTATION, variables)
                ];
            });
        });
        return function(id, itemIds) {
            return _ref.apply(this, arguments);
        };
    }(),
    updateAccommodationAssignmentsOrder: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, itemIds) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        accommodationAssignmentIds: itemIds
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(UPDATE_TRAVEL_ACCOMMODATION_ASSIGNMENTS_ORDER_MUTATION, variables)
                ];
            });
        });
        return function(id, itemIds) {
            return _ref.apply(this, arguments);
        };
    }(),
    assignAccommodations: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, itemIds) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        accommodationIds: itemIds
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(ADD_TRAVEL_ACCOMMODATIONS_MUTATION, variables)
                ];
            });
        });
        return function(id, itemIds) {
            return _ref.apply(this, arguments);
        };
    }(),
    unassignAccommodations: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, itemIds) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        accommodationIds: itemIds
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(REMOVE_TRAVEL_ACCOMMODATIONS_MUTATION, variables)
                ];
            });
        });
        return function(id, itemIds) {
            return _ref.apply(this, arguments);
        };
    }(),
    createAccommodations: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, items) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        accommodations: items
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(CREATE_TRAVEL_ACCOMMODATIONS_MUTATION, variables)
                ];
            });
        });
        return function(id, items) {
            return _ref.apply(this, arguments);
        };
    }(),
    deleteAccommodations: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, itemIds) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        accommodationIds: itemIds
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(DELETE_TRAVEL_ACCOMMODATIONS_MUTATION, variables)
                ];
            });
        });
        return function(id, itemIds) {
            return _ref.apply(this, arguments);
        };
    }(),
    updateAccommodationsOrder: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, itemIds) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        accommodationIds: itemIds
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(UPDATE_TRAVEL_ACCOMMODATIONS_ORDER_MUTATION, variables)
                ];
            });
        });
        return function(id, itemIds) {
            return _ref.apply(this, arguments);
        };
    }(),
    assignDestinations: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, itemIds) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        destinationIds: itemIds
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(ADD_TRAVEL_DESTINATIONS_MUTATION, variables)
                ];
            });
        });
        return function(id, itemIds) {
            return _ref.apply(this, arguments);
        };
    }(),
    unassignDestinations: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, itemIds) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        destinationIds: itemIds
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(REMOVE_TRAVEL_DESTINATIONS_MUTATION, variables)
                ];
            });
        });
        return function(id, itemIds) {
            return _ref.apply(this, arguments);
        };
    }(),
    createDestinations: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, items) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        destinations: items
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(CREATE_TRAVEL_DESTINATIONS_MUTATION, variables)
                ];
            });
        });
        return function(id, items) {
            return _ref.apply(this, arguments);
        };
    }(),
    deleteDestinations: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, itemIds) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        destinationIds: itemIds
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(DELETE_TRAVEL_DESTINATIONS_MUTATION, variables)
                ];
            });
        });
        return function(id, itemIds) {
            return _ref.apply(this, arguments);
        };
    }(),
    updateDestinationsOrder: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, itemIds) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        destinationIds: itemIds
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(UPDATE_TRAVEL_DESTINATIONS_ORDER_MUTATION, variables)
                ];
            });
        });
        return function(id, itemIds) {
            return _ref.apply(this, arguments);
        };
    }(),
    assignTestimonials: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, itemIds) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        testimonialIds: itemIds
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(ADD_TRAVEL_TESTIMONIALS_MUTATION, variables)
                ];
            });
        });
        return function(id, itemIds) {
            return _ref.apply(this, arguments);
        };
    }(),
    unassignTestimonials: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, itemIds) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        testimonialIds: itemIds
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(REMOVE_TRAVEL_TESTIMONIALS_MUTATION, variables)
                ];
            });
        });
        return function(id, itemIds) {
            return _ref.apply(this, arguments);
        };
    }(),
    createTestimonials: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, items) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        testimonials: items
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(CREATE_TRAVEL_TESTIMONIALS_MUTATION, variables)
                ];
            });
        });
        return function(id, items) {
            return _ref.apply(this, arguments);
        };
    }(),
    deleteTestimonials: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, itemIds) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        testimonialIds: itemIds
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(DELETE_TRAVEL_TESTIMONIALS_MUTATION, variables)
                ];
            });
        });
        return function(id, itemIds) {
            return _ref.apply(this, arguments);
        };
    }(),
    updateTestimonialsOrder: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, itemIds) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        testimonialIds: itemIds
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(UPDATE_TRAVEL_TESTIMONIALS_ORDER_MUTATION, variables)
                ];
            });
        });
        return function(id, itemIds) {
            return _ref.apply(this, arguments);
        };
    }(),
    assignTravelExtensions: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, itemIds) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        travelExtensionIds: itemIds
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(ADD_TRAVEL_TRAVEL_EXTENSIONS_MUTATION, variables)
                ];
            });
        });
        return function(id, itemIds) {
            return _ref.apply(this, arguments);
        };
    }(),
    unassignTravelExtensions: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, itemIds) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        travelExtensionIds: itemIds
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(REMOVE_TRAVEL_TRAVEL_EXTENSIONS_MUTATION, variables)
                ];
            });
        });
        return function(id, itemIds) {
            return _ref.apply(this, arguments);
        };
    }(),
    createTravelExtensions: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, items) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        travelExtensions: items
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(CREATE_TRAVEL_TRAVEL_EXTENSIONS_MUTATION, variables)
                ];
            });
        });
        return function(id, items) {
            return _ref.apply(this, arguments);
        };
    }(),
    deleteTravelExtensions: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, itemIds) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        travelExtensionIds: itemIds
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(DELETE_TRAVEL_TRAVEL_EXTENSIONS_MUTATION, variables)
                ];
            });
        });
        return function(id, itemIds) {
            return _ref.apply(this, arguments);
        };
    }(),
    updateTravelExtensionsOrder: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, itemIds) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        travelExtensionIds: itemIds
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(UPDATE_TRAVEL_TRAVEL_EXTENSIONS_ORDER_MUTATION, variables)
                ];
            });
        });
        return function(id, itemIds) {
            return _ref.apply(this, arguments);
        };
    }()
};
/* harmony default export */ var repository = (travelRepository);

;// CONCATENATED MODULE: ./src/entities/travel/entity.ts


var travelEntity = {
    model: model,
    repository: repository
};
/* harmony default export */ var travel_entity = (travelEntity);


/***/ }),

/***/ 88939:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ travelAccommodationAssignment_entity; }
});

;// CONCATENATED MODULE: ./src/entities/travelAccommodationAssignment/graphql.ts
// language=GraphQL
var ALL_ACCOMMODATION_ASSIGNMENTS_QUERY = "query Query($withAccommodation: Boolean = false, $withAccommodationRoomTypes: Boolean = false, $withAccommodationRoomTypesGallery: Boolean = false, $withAccommodationAvailableAddons: Boolean = false, $withAccommodationAvailableAddonsIcon: Boolean = false, $withAccommodationGallery: Boolean = false, $withAccommodationGalleryImages: Boolean = false, $withRoomTypes: Boolean = false, $withRoomTypesGallery: Boolean = false, $withRoomTypesGalleryImages: Boolean = false) {\n  accommodationAssignments: travelAccommodationAssignments {\n    id\n    accommodation @include(if: $withAccommodation) {\n      id\n      label\n      name\n      stars\n      description\n      roomTypes @include(if: $withAccommodationRoomTypes) {\n        id\n        name\n        description\n        gallery @include(if: $withAccommodationRoomTypesGallery) {\n          id\n        }\n      }\n      availableAddons @include(if: $withAccommodationAvailableAddons) {\n        id\n        name\n        description\n        icon @include(if: $withAccommodationAvailableAddonsIcon) {\n          id\n          assetId\n          publicId\n          url\n          resourceType\n          format\n          width\n          height\n          caption\n          title\n          description\n        }\n      }\n      gallery @include(if: $withAccommodationGallery) {\n        id\n        images @include(if: $withAccommodationGalleryImages) {\n          id\n          assetId\n          publicId\n          url\n          resourceType\n          format\n          width\n          height\n          caption\n          title\n          description\n        }\n      }\n    }\n    roomTypes @include(if: $withRoomTypes) {\n      id\n      name\n      description\n      gallery @include(if: $withRoomTypesGallery) {\n        id\n        images @include(if: $withRoomTypesGalleryImages) {\n          id\n          assetId\n          publicId\n          url\n          resourceType\n          format\n          width\n          height\n          caption\n          title\n          description\n        }\n      }\n    }\n    useCustomRoomTypeSelection\n  }\n}";
// language=GraphQL
var SINGLE_ACCOMMODATION_ASSIGNMENT_QUERY = "query Query($id: ID!, $withAccommodation: Boolean = false, $withAccommodationRoomTypes: Boolean = false, $withAccommodationRoomTypesGallery: Boolean = false, $withAccommodationAvailableAddons: Boolean = false, $withAccommodationAvailableAddonsIcon: Boolean = false, $withAccommodationGallery: Boolean = false, $withAccommodationGalleryImages: Boolean = false, $withRoomTypes: Boolean = false, $withRoomTypesGallery: Boolean = false, $withRoomTypesGalleryImages: Boolean = false) {\n  accommodationAssignment: travelAccommodationAssignment(id: $id) {\n    id\n    accommodation @include(if: $withAccommodation) {\n      id\n      label\n      name\n      stars\n      description\n      roomTypes @include(if: $withAccommodationRoomTypes) {\n        id\n        name\n        description\n        gallery @include(if: $withAccommodationRoomTypesGallery) {\n          id\n        }\n      }\n      availableAddons @include(if: $withAccommodationAvailableAddons) {\n        id\n        name\n        description\n        icon @include(if: $withAccommodationAvailableAddonsIcon) {\n          id\n          assetId\n          publicId\n          url\n          resourceType\n          format\n          width\n          height\n          caption\n          title\n          description\n        }\n      }\n      gallery @include(if: $withAccommodationGallery) {\n        id\n        images @include(if: $withAccommodationGalleryImages) {\n          id\n          assetId\n          publicId\n          url\n          resourceType\n          format\n          width\n          height\n          caption\n          title\n          description\n        }\n      }\n    }\n    roomTypes @include(if: $withRoomTypes) {\n      id\n      name\n      description\n      gallery @include(if: $withRoomTypesGallery) {\n        id\n        images @include(if: $withRoomTypesGalleryImages) {\n          id\n          assetId\n          publicId\n          url\n          resourceType\n          format\n          width\n          height\n          caption\n          title\n          description\n        }\n      }\n    }\n    useCustomRoomTypeSelection\n  }\n}";
// language=GraphQL
var CREATE_ACCOMMODATION_ASSIGNMENT_MUTATION = "\n  mutation Mutation($input: CreateTravelAccommodationAssignmentInput, $withAccommodation: Boolean = false, $withAccommodationRoomTypes: Boolean = false, $withAccommodationRoomTypesGallery: Boolean = false, $withAccommodationAvailableAddons: Boolean = false, $withAccommodationAvailableAddonsIcon: Boolean = false, $withAccommodationGallery: Boolean = false, $withAccommodationGalleryImages: Boolean = false, $withRoomTypes: Boolean = false, $withRoomTypesGallery: Boolean = false, $withRoomTypesGalleryImages: Boolean = false) {\n    accommodationAssignment: createTravelAccommodationAssignment(input: $input) {\n      id\n      accommodation @include(if: $withAccommodation) {\n        id\n        label\n        name\n        stars\n        description\n        roomTypes @include(if: $withAccommodationRoomTypes) {\n          id\n          name\n          description\n          gallery @include(if: $withAccommodationRoomTypesGallery) {\n            id\n          }\n        }\n        availableAddons @include(if: $withAccommodationAvailableAddons) {\n          id\n          name\n          description\n          icon @include(if: $withAccommodationAvailableAddonsIcon) {\n            id\n            assetId\n            publicId\n            url\n            resourceType\n            format\n            width\n            height\n            caption\n            title\n            description\n          }\n        }\n        gallery @include(if: $withAccommodationGallery) {\n          id\n          images @include(if: $withAccommodationGalleryImages) {\n            id\n            assetId\n            publicId\n            url\n            resourceType\n            format\n            width\n            height\n            caption\n            title\n            description\n          }\n        }\n      }\n      roomTypes @include(if: $withRoomTypes) {\n        id\n        name\n        description\n        gallery @include(if: $withRoomTypesGallery) {\n          id\n          images @include(if: $withRoomTypesGalleryImages) {\n            id\n            assetId\n            publicId\n            url\n            resourceType\n            format\n            width\n            height\n            caption\n            title\n            description\n          }\n        }\n      }\n      useCustomRoomTypeSelection\n    }\n  }";
// language=GraphQL
var UPDATE_ACCOMMODATION_ASSIGNMENT_MUTATION = "\n  mutation Mutation($input: UpdateTravelAccommodationAssignmentInput, $withAccommodation: Boolean = false, $withAccommodationRoomTypes: Boolean = false, $withAccommodationRoomTypesGallery: Boolean = false, $withAccommodationAvailableAddons: Boolean = false, $withAccommodationAvailableAddonsIcon: Boolean = false, $withAccommodationGallery: Boolean = false, $withAccommodationGalleryImages: Boolean = false, $withRoomTypes: Boolean = false, $withRoomTypesGallery: Boolean = false, $withRoomTypesGalleryImages: Boolean = false) {\n    accommodationAssignment: updateTravelAccommodationAssignment(input: $input) {\n      id\n      accommodation @include(if: $withAccommodation) {\n        id\n        label\n        name\n        stars\n        description\n        roomTypes @include(if: $withAccommodationRoomTypes) {\n          id\n          name\n          description\n          gallery @include(if: $withAccommodationRoomTypesGallery) {\n            id\n          }\n        }\n        availableAddons @include(if: $withAccommodationAvailableAddons) {\n          id\n          name\n          description\n          icon @include(if: $withAccommodationAvailableAddonsIcon) {\n            id\n            assetId\n            publicId\n            url\n            resourceType\n            format\n            width\n            height\n            caption\n            title\n            description\n          }\n        }\n        gallery @include(if: $withAccommodationGallery) {\n          id\n          images @include(if: $withAccommodationGalleryImages) {\n            id\n            assetId\n            publicId\n            url\n            resourceType\n            format\n            width\n            height\n            caption\n            title\n            description\n          }\n        }\n      }\n      roomTypes @include(if: $withRoomTypes) {\n        id\n        name\n        description\n        gallery @include(if: $withRoomTypesGallery) {\n          id\n          images @include(if: $withRoomTypesGalleryImages) {\n            id\n            assetId\n            publicId\n            url\n            resourceType\n            format\n            width\n            height\n            caption\n            title\n            description\n          }\n        }\n      }\n      useCustomRoomTypeSelection\n    }\n  }";
// language=GraphQL
var DELETE_ACCOMMODATION_ASSIGNMENT_MUTATION = "\n  mutation Mutation($input: DeleteTravelAccommodationAssignmentInput) {\n    deleteTravelAccommodationAssignment(input: $input) {\n      success\n    }\n  }";
// language=GraphQL
var FORCE_DELETE_ACCOMMODATION_ASSIGNMENT_MUTATION = "\n  mutation Mutation($input: DeleteTravelAccommodationAssignmentInput) {\n    forceDeleteTravelAccommodationAssignment(input: $input) {\n      success\n    }\n  }";
// language=GraphQL
var ADD_ACCOMMODATION_ASSIGNMENT_ROOM_TYPES_MUTATION = "\n  mutation Mutation($input: addTravelAccommodationAssignmentRoomTypesInput) {\n    addTravelAccommodationAssignmentRoomTypes(input: $input) {\n      id\n      roomTypeIds\n    }\n  }";
// language=GraphQL
var REMOVE_ACCOMMODATION_ASSIGNMENT_ROOM_TYPES_MUTATION = "\n  mutation Mutation($input: removeTravelAccommodationAssignmentRoomTypesInput) {\n    removeTravelAccommodationAssignmentRoomTypes(input: $input) {\n      id\n      roomTypeIds\n    }\n  }";
// language=GraphQL
var CREATE_ACCOMMODATION_ASSIGNMENT_ROOM_TYPES_MUTATION = "\n  mutation Mutation($input: createTravelAccommodationAssignmentRoomTypesInput) {\n    createTravelAccommodationAssignmentRoomTypes(input: $input) {\n      id\n      roomTypeIds\n    }\n  }";
// language=GraphQL
var DELETE_ACCOMMODATION_ASSIGNMENT_ROOM_TYPES_MUTATION = "\n  mutation Mutation($input: deleteTravelAccommodationAssignmentRoomTypesInput) {\n    deleteTravelAccommodationAssignmentRoomTypes(input: $input) {\n      id\n      roomTypeIds\n    }\n  }";
// language=GraphQL
var UPDATE_ACCOMMODATION_ASSIGNMENT_ROOM_TYPES_ORDER_MUTATION = "\n  mutation Mutation($input: updateTravelAccommodationAssignmentRoomTypesOrderInput) {\n    updateTravelAccommodationAssignmentRoomTypesOrder(input: $input) {\n      id\n      roomTypeIds\n    }\n  }";
// language=GraphQL
var ACCOMMODATION_ASSIGNMENTS_DEPENDENTS_QUERY = "query Query($id: ID!, $withTravels: Boolean = false) {\n  groupedDependents: travelAccommodationAssignmentDependents(id: $id) {\n    travels @include(if: $withTravels) {\n      id\n      name\n      isBestseller\n      startDate\n      endDate\n      executionStatus\n      title\n      description\n      includedServices\n      excludedServices\n      pricingTable\n      priceCalculationInfo\n      programType\n      programText\n      minPrice\n      minPriceManualOverride\n      currency    }\n  }\n}";

// EXTERNAL MODULE: ./src/entities/accommodation/entity.ts + 3 modules
var entity = __webpack_require__(92043);
// EXTERNAL MODULE: ./src/entities/accommodationRoomType/entity.ts + 3 modules
var accommodationRoomType_entity = __webpack_require__(94529);
;// CONCATENATED MODULE: ./src/entities/travelAccommodationAssignment/model.ts



var travelAccommodationAssignmentModel = {
    name: "accommodationAssignment",
    namePlural: "accommodationAssignments",
    uniqueName: "travelAccommodationAssignment",
    uniqueNamePlural: "travelAccommodationAssignments",
    path: "travel/accommodation_assignment",
    baseUrl: "/travel/accommodation_assignments",
    translationPrefix: "entities:travelAccommodationAssignment.",
    getDisplayName: function(values) {
        return "";
    },
    gql: {
        getAll: ALL_ACCOMMODATION_ASSIGNMENTS_QUERY,
        getSingle: SINGLE_ACCOMMODATION_ASSIGNMENT_QUERY,
        create: CREATE_ACCOMMODATION_ASSIGNMENT_MUTATION,
        update: UPDATE_ACCOMMODATION_ASSIGNMENT_MUTATION,
        delete: DELETE_ACCOMMODATION_ASSIGNMENT_MUTATION,
        forceDelete: FORCE_DELETE_ACCOMMODATION_ASSIGNMENT_MUTATION
    },
    attributes: {
        accommodation: {
            name: "accommodation",
            label: "entities:travelAccommodationAssignment.attributes.accommodation.label",
            type: "entityObject",
            dataType: "any",
            getEntity: function() {
                return entity/* default */.Z;
            },
            defaultInput: true,
            inputType: "select",
            validationType: "string",
            validations: []
        },
        roomTypes: {
            name: "roomTypes",
            label: "entities:travelAccommodationAssignment.attributes.roomTypes.label",
            type: "entityCollection",
            dataType: "[any]",
            getEntity: function() {
                return accommodationRoomType_entity/* default */.Z;
            },
            defaultInput: false,
            inputType: "text",
            validationType: "string",
            validations: []
        },
        useCustomRoomTypeSelection: {
            name: "useCustomRoomTypeSelection",
            label: "entities:travelAccommodationAssignment.attributes.useCustomRoomTypeSelection.label",
            type: "value",
            dataType: "boolean",
            defaultInput: false,
            inputType: "switch",
            validationType: "string",
            validations: []
        }
    }
};
/* harmony default export */ var model = (travelAccommodationAssignmentModel);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(20414);
// EXTERNAL MODULE: ./src/entities/lib.ts
var lib = __webpack_require__(23480);
// EXTERNAL MODULE: ./src/lib/api/graphQLClient.ts
var graphQLClient = __webpack_require__(40112);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/swr/dist/index.mjs
var dist = __webpack_require__(8100);
// EXTERNAL MODULE: ./src/lib/helpers/helpers.ts
var helpers = __webpack_require__(15778);
;// CONCATENATED MODULE: ./src/entities/travelAccommodationAssignment/repository.ts










var hydrateObjects = function(objects) {
    return objects.map(function(object) {
        return (0,lib/* hydrateEntityObject */.b)(model, object);
    });
};
var hydrateObject = function(object) {
    return (0,lib/* hydrateEntityObject */.b)(model, object);
};
var travelAccommodationAssignmentRepository = {
    getObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    id: id
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(SINGLE_ACCOMMODATION_ASSIGNMENT_QUERY, variables).then(function(data) {
                        return hydrateObject(data.accommodationAssignment);
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }(),
    getObjects: /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        var includes;
        var _arguments = arguments;
        return (0,tslib_es6.__generator)(this, function(_state) {
            includes = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : {};
            return [
                2,
                graphQLClient/* default.request */.Z.request(ALL_ACCOMMODATION_ASSIGNMENTS_QUERY, includes).then(function(data) {
                    return hydrateObjects(data.accommodationAssignments);
                })
            ];
        });
    }),
    useObject: function(id) {
        var includes = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        // eslint-disable-next-line react-hooks/exhaustive-deps
        var variables = (0,react.useMemo)(function() {
            return (0,_object_spread/* default */.Z)({
                id: id
            }, includes);
        }, [
            id
        ]);
        var ref = (0,dist/* default */.ZP)([
            SINGLE_ACCOMMODATION_ASSIGNMENT_QUERY,
            variables
        ], {
            revalidateOnFocus: false
        }), data = ref.data, error = ref.error, mutate = ref.mutate;
        return {
            object: !data ? data : hydrateObject(data.accommodationAssignment),
            isLoading: !error && !data,
            isError: error,
            mutate: mutate
        };
    },
    useObjects: function() {
        var includes = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        // eslint-disable-next-line react-hooks/exhaustive-deps
        var variables = (0,react.useMemo)(function() {
            return includes;
        }, []);
        var ref = (0,dist/* default */.ZP)([
            ALL_ACCOMMODATION_ASSIGNMENTS_QUERY,
            variables
        ]), data = ref.data, error = ref.error, mutate = ref.mutate;
        return {
            objects: !data ? data : hydrateObjects(data.accommodationAssignments),
            isLoading: !error && !data,
            isError: error,
            mutate: mutate
        };
    },
    getDependents: function(id, includes) {
        var includeVars = {};
        includes.forEach(function(include) {
            includeVars["with".concat((0,helpers/* uppercaseFirst */.AB)(include))] = true;
        });
        var variables = (0,_object_spread/* default */.Z)({
            id: id
        }, includeVars);
        return graphQLClient/* default.request */.Z.request(ACCOMMODATION_ASSIGNMENTS_DEPENDENTS_QUERY, variables).then(function(data) {
            return data.groupedDependents;
        });
    },
    useDependents: function(id, includes) {
        var includeVars = {};
        includes.forEach(function(include) {
            includeVars["with".concat((0,helpers/* uppercaseFirst */.AB)(include))] = true;
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
        var variables = (0,react.useMemo)(function() {
            return (0,_object_spread/* default */.Z)({
                id: id
            }, includeVars);
        }, [
            id
        ]);
        var ref = (0,dist/* default */.ZP)([
            ACCOMMODATION_ASSIGNMENTS_DEPENDENTS_QUERY,
            variables
        ], {
            revalidateOnFocus: false
        }), data = ref.data, error = ref.error, mutate = ref.mutate;
        return {
            data: !data ? data : data.groupedDependents,
            isLoading: !error && !data,
            isError: error,
            mutate: mutate
        };
    },
    createObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(data) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    input: data
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(CREATE_ACCOMMODATION_ASSIGNMENT_MUTATION, variables).then(function(data) {
                        return hydrateObject(data.accommodationAssignment);
                    })
                ];
            });
        });
        return function(data) {
            return _ref.apply(this, arguments);
        };
    }(),
    updateObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(data) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    input: data
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(UPDATE_ACCOMMODATION_ASSIGNMENT_MUTATION, variables).then(function(data) {
                        return hydrateObject(data.accommodationAssignment);
                    })
                ];
            });
        });
        return function(data) {
            return _ref.apply(this, arguments);
        };
    }(),
    deleteObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(DELETE_ACCOMMODATION_ASSIGNMENT_MUTATION, variables).then(function(data) {
                        return data.deleteTravelAccommodationAssignment;
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }(),
    forceDeleteObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(FORCE_DELETE_ACCOMMODATION_ASSIGNMENT_MUTATION, variables).then(function(data) {
                        return data.forceDeleteTravelAccommodationAssignment;
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }(),
    assignRoomTypes: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, itemIds) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        roomTypeIds: itemIds
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(ADD_ACCOMMODATION_ASSIGNMENT_ROOM_TYPES_MUTATION, variables)
                ];
            });
        });
        return function(id, itemIds) {
            return _ref.apply(this, arguments);
        };
    }(),
    unassignRoomTypes: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, itemIds) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        roomTypeIds: itemIds
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(REMOVE_ACCOMMODATION_ASSIGNMENT_ROOM_TYPES_MUTATION, variables)
                ];
            });
        });
        return function(id, itemIds) {
            return _ref.apply(this, arguments);
        };
    }(),
    createRoomTypes: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, items) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        roomTypes: items
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(CREATE_ACCOMMODATION_ASSIGNMENT_ROOM_TYPES_MUTATION, variables)
                ];
            });
        });
        return function(id, items) {
            return _ref.apply(this, arguments);
        };
    }(),
    deleteRoomTypes: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, itemIds) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        roomTypeIds: itemIds
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(DELETE_ACCOMMODATION_ASSIGNMENT_ROOM_TYPES_MUTATION, variables)
                ];
            });
        });
        return function(id, itemIds) {
            return _ref.apply(this, arguments);
        };
    }(),
    updateRoomTypesOrder: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, itemIds) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        roomTypeIds: itemIds
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(UPDATE_ACCOMMODATION_ASSIGNMENT_ROOM_TYPES_ORDER_MUTATION, variables)
                ];
            });
        });
        return function(id, itemIds) {
            return _ref.apply(this, arguments);
        };
    }()
};
/* harmony default export */ var repository = (travelAccommodationAssignmentRepository);

;// CONCATENATED MODULE: ./src/entities/travelAccommodationAssignment/entity.ts


var travelAccommodationAssignmentEntity = {
    model: model,
    repository: repository
};
/* harmony default export */ var travelAccommodationAssignment_entity = (travelAccommodationAssignmentEntity);


/***/ }),

/***/ 47041:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ travelAvailabilityStatus_entity; }
});

;// CONCATENATED MODULE: ./src/entities/travelAvailabilityStatus/graphql.ts
// language=GraphQL
var ALL_AVAILABILITY_STATUS_QUERY = "query Query($withTenantSettings: Boolean = false, $withTenantSettingsTenant: Boolean = false, $withTenantSettingsTenantCms: Boolean = false, $withTenantSettingsTenantTravelTypes: Boolean = false, $withTenantSettingsTenantEmployees: Boolean = false, $withTenantSettingsTenantEmailConfig: Boolean = false, $withTenantSettingsTenantNewsletterProvider: Boolean = false, $withTenantSettingsTenantRedirects: Boolean = false, $withTenantSettingsTenantOnlinePaymentConfig: Boolean = false, $withTenantSettingsTenantRatioConfig: Boolean = false, $withTenantSettingsTenantContent: Boolean = false, $withTenantSettingsTenantPartnerTenants: Boolean = false) {\n  availabilityStatus: allTravelAvailabilityStatus {\n    id\n    label\n    status\n    isDefaultStatus\n    isDefaultWaitlistFallback\n    tenantSettings @include(if: $withTenantSettings) {\n      id\n      tenant @include(if: $withTenantSettingsTenant) {\n        id\n        name\n        slug\n        domain\n        externalReference\n        cms @include(if: $withTenantSettingsTenantCms) {\n          id\n        }\n        travelTypes @include(if: $withTenantSettingsTenantTravelTypes) {\n          id\n          name\n          description\n        }\n        employees @include(if: $withTenantSettingsTenantEmployees) {\n          id\n          firstName\n          lastName\n          jobTitle\n          description\n          email\n          phone\n        }\n        emailConfig @include(if: $withTenantSettingsTenantEmailConfig) {\n          id\n          defaultInternalRecipientEmail\n          internalBookingRecipientEmails\n          bookingConfirmationTemplateId\n          bookingConfirmationInternalTemplateId\n          bookingRequestConfirmationTemplateId\n          bookingWaitlistConfirmationTemplateId\n          bookingWaitlistContingentCheckConfirmationTemplateId\n          bookingCustomRequestTemplateId\n          bookingPassportDataReminderTemplateId\n          contactFormTemplateId\n          esimInstallationInfoTemplateId\n        }\n        newsletterProvider @include(if: $withTenantSettingsTenantNewsletterProvider) {\n          id\n          provider\n        }\n        redirects @include(if: $withTenantSettingsTenantRedirects) {\n          id\n          fromType\n          fromUrl\n          toType\n          toUrl\n        }\n        onlinePaymentConfig @include(if: $withTenantSettingsTenantOnlinePaymentConfig) {\n          id\n          enabled\n          ratioFibuAccountNo\n          infoText\n          datatransThemeConfig\n        }\n        ratioConfig @include(if: $withTenantSettingsTenantRatioConfig) {\n          id\n          adressgruppe\n        }\n        content @include(if: $withTenantSettingsTenantContent) {\n          id\n          bookingInsuranceInfo\n        }\n        partnerTenants @include(if: $withTenantSettingsTenantPartnerTenants) {\n          id\n          filterCrossLinking\n        }\n      }\n      label\n      info\n      switchToStatusInfo\n      submitButtonLabel\n    }\n  }\n}";
// language=GraphQL
var SINGLE_AVAILABILITY_STATUS_QUERY = "query Query($id: ID!, $withTenantSettings: Boolean = false, $withTenantSettingsTenant: Boolean = false, $withTenantSettingsTenantCms: Boolean = false, $withTenantSettingsTenantTravelTypes: Boolean = false, $withTenantSettingsTenantEmployees: Boolean = false, $withTenantSettingsTenantEmailConfig: Boolean = false, $withTenantSettingsTenantNewsletterProvider: Boolean = false, $withTenantSettingsTenantRedirects: Boolean = false, $withTenantSettingsTenantOnlinePaymentConfig: Boolean = false, $withTenantSettingsTenantRatioConfig: Boolean = false, $withTenantSettingsTenantContent: Boolean = false, $withTenantSettingsTenantPartnerTenants: Boolean = false) {\n  availabilityStatus: travelAvailabilityStatus(id: $id) {\n    id\n    label\n    status\n    isDefaultStatus\n    isDefaultWaitlistFallback\n    tenantSettings @include(if: $withTenantSettings) {\n      id\n      tenant @include(if: $withTenantSettingsTenant) {\n        id\n        name\n        slug\n        domain\n        externalReference\n        cms @include(if: $withTenantSettingsTenantCms) {\n          id\n        }\n        travelTypes @include(if: $withTenantSettingsTenantTravelTypes) {\n          id\n          name\n          description\n        }\n        employees @include(if: $withTenantSettingsTenantEmployees) {\n          id\n          firstName\n          lastName\n          jobTitle\n          description\n          email\n          phone\n        }\n        emailConfig @include(if: $withTenantSettingsTenantEmailConfig) {\n          id\n          defaultInternalRecipientEmail\n          internalBookingRecipientEmails\n          bookingConfirmationTemplateId\n          bookingConfirmationInternalTemplateId\n          bookingRequestConfirmationTemplateId\n          bookingWaitlistConfirmationTemplateId\n          bookingWaitlistContingentCheckConfirmationTemplateId\n          bookingCustomRequestTemplateId\n          bookingPassportDataReminderTemplateId\n          contactFormTemplateId\n          esimInstallationInfoTemplateId\n        }\n        newsletterProvider @include(if: $withTenantSettingsTenantNewsletterProvider) {\n          id\n          provider\n        }\n        redirects @include(if: $withTenantSettingsTenantRedirects) {\n          id\n          fromType\n          fromUrl\n          toType\n          toUrl\n        }\n        onlinePaymentConfig @include(if: $withTenantSettingsTenantOnlinePaymentConfig) {\n          id\n          enabled\n          ratioFibuAccountNo\n          infoText\n          datatransThemeConfig\n        }\n        ratioConfig @include(if: $withTenantSettingsTenantRatioConfig) {\n          id\n          adressgruppe\n        }\n        content @include(if: $withTenantSettingsTenantContent) {\n          id\n          bookingInsuranceInfo\n        }\n        partnerTenants @include(if: $withTenantSettingsTenantPartnerTenants) {\n          id\n          filterCrossLinking\n        }\n      }\n      label\n      info\n      switchToStatusInfo\n      submitButtonLabel\n    }\n  }\n}";
// language=GraphQL
var CREATE_AVAILABILITY_STATUS_MUTATION = "\n  mutation Mutation($input: CreateTravelAvailabilityStatusInput, $withTenantSettings: Boolean = false, $withTenantSettingsTenant: Boolean = false, $withTenantSettingsTenantCms: Boolean = false, $withTenantSettingsTenantTravelTypes: Boolean = false, $withTenantSettingsTenantEmployees: Boolean = false, $withTenantSettingsTenantEmailConfig: Boolean = false, $withTenantSettingsTenantNewsletterProvider: Boolean = false, $withTenantSettingsTenantRedirects: Boolean = false, $withTenantSettingsTenantOnlinePaymentConfig: Boolean = false, $withTenantSettingsTenantRatioConfig: Boolean = false, $withTenantSettingsTenantContent: Boolean = false, $withTenantSettingsTenantPartnerTenants: Boolean = false) {\n    availabilityStatus: createTravelAvailabilityStatus(input: $input) {\n      id\n      label\n      status\n      isDefaultStatus\n      isDefaultWaitlistFallback\n      tenantSettings @include(if: $withTenantSettings) {\n        id\n        tenant @include(if: $withTenantSettingsTenant) {\n          id\n          name\n          slug\n          domain\n          externalReference\n          cms @include(if: $withTenantSettingsTenantCms) {\n            id\n          }\n          travelTypes @include(if: $withTenantSettingsTenantTravelTypes) {\n            id\n            name\n            description\n          }\n          employees @include(if: $withTenantSettingsTenantEmployees) {\n            id\n            firstName\n            lastName\n            jobTitle\n            description\n            email\n            phone\n          }\n          emailConfig @include(if: $withTenantSettingsTenantEmailConfig) {\n            id\n            defaultInternalRecipientEmail\n            internalBookingRecipientEmails\n            bookingConfirmationTemplateId\n            bookingConfirmationInternalTemplateId\n            bookingRequestConfirmationTemplateId\n            bookingWaitlistConfirmationTemplateId\n            bookingWaitlistContingentCheckConfirmationTemplateId\n            bookingCustomRequestTemplateId\n            bookingPassportDataReminderTemplateId\n            contactFormTemplateId\n            esimInstallationInfoTemplateId\n          }\n          newsletterProvider @include(if: $withTenantSettingsTenantNewsletterProvider) {\n            id\n            provider\n          }\n          redirects @include(if: $withTenantSettingsTenantRedirects) {\n            id\n            fromType\n            fromUrl\n            toType\n            toUrl\n          }\n          onlinePaymentConfig @include(if: $withTenantSettingsTenantOnlinePaymentConfig) {\n            id\n            enabled\n            ratioFibuAccountNo\n            infoText\n            datatransThemeConfig\n          }\n          ratioConfig @include(if: $withTenantSettingsTenantRatioConfig) {\n            id\n            adressgruppe\n          }\n          content @include(if: $withTenantSettingsTenantContent) {\n            id\n            bookingInsuranceInfo\n          }\n          partnerTenants @include(if: $withTenantSettingsTenantPartnerTenants) {\n            id\n            filterCrossLinking\n          }\n        }\n        label\n        info\n        switchToStatusInfo\n        submitButtonLabel\n      }\n    }\n  }";
// language=GraphQL
var UPDATE_AVAILABILITY_STATUS_MUTATION = "\n  mutation Mutation($input: UpdateTravelAvailabilityStatusInput, $withTenantSettings: Boolean = false, $withTenantSettingsTenant: Boolean = false, $withTenantSettingsTenantCms: Boolean = false, $withTenantSettingsTenantTravelTypes: Boolean = false, $withTenantSettingsTenantEmployees: Boolean = false, $withTenantSettingsTenantEmailConfig: Boolean = false, $withTenantSettingsTenantNewsletterProvider: Boolean = false, $withTenantSettingsTenantRedirects: Boolean = false, $withTenantSettingsTenantOnlinePaymentConfig: Boolean = false, $withTenantSettingsTenantRatioConfig: Boolean = false, $withTenantSettingsTenantContent: Boolean = false, $withTenantSettingsTenantPartnerTenants: Boolean = false) {\n    availabilityStatus: updateTravelAvailabilityStatus(input: $input) {\n      id\n      label\n      status\n      isDefaultStatus\n      isDefaultWaitlistFallback\n      tenantSettings @include(if: $withTenantSettings) {\n        id\n        tenant @include(if: $withTenantSettingsTenant) {\n          id\n          name\n          slug\n          domain\n          externalReference\n          cms @include(if: $withTenantSettingsTenantCms) {\n            id\n          }\n          travelTypes @include(if: $withTenantSettingsTenantTravelTypes) {\n            id\n            name\n            description\n          }\n          employees @include(if: $withTenantSettingsTenantEmployees) {\n            id\n            firstName\n            lastName\n            jobTitle\n            description\n            email\n            phone\n          }\n          emailConfig @include(if: $withTenantSettingsTenantEmailConfig) {\n            id\n            defaultInternalRecipientEmail\n            internalBookingRecipientEmails\n            bookingConfirmationTemplateId\n            bookingConfirmationInternalTemplateId\n            bookingRequestConfirmationTemplateId\n            bookingWaitlistConfirmationTemplateId\n            bookingWaitlistContingentCheckConfirmationTemplateId\n            bookingCustomRequestTemplateId\n            bookingPassportDataReminderTemplateId\n            contactFormTemplateId\n            esimInstallationInfoTemplateId\n          }\n          newsletterProvider @include(if: $withTenantSettingsTenantNewsletterProvider) {\n            id\n            provider\n          }\n          redirects @include(if: $withTenantSettingsTenantRedirects) {\n            id\n            fromType\n            fromUrl\n            toType\n            toUrl\n          }\n          onlinePaymentConfig @include(if: $withTenantSettingsTenantOnlinePaymentConfig) {\n            id\n            enabled\n            ratioFibuAccountNo\n            infoText\n            datatransThemeConfig\n          }\n          ratioConfig @include(if: $withTenantSettingsTenantRatioConfig) {\n            id\n            adressgruppe\n          }\n          content @include(if: $withTenantSettingsTenantContent) {\n            id\n            bookingInsuranceInfo\n          }\n          partnerTenants @include(if: $withTenantSettingsTenantPartnerTenants) {\n            id\n            filterCrossLinking\n          }\n        }\n        label\n        info\n        switchToStatusInfo\n        submitButtonLabel\n      }\n    }\n  }";
// language=GraphQL
var DELETE_AVAILABILITY_STATUS_MUTATION = "\n  mutation Mutation($input: DeleteTravelAvailabilityStatusInput) {\n    deleteTravelAvailabilityStatus(input: $input) {\n      success\n    }\n  }";
// language=GraphQL
var FORCE_DELETE_AVAILABILITY_STATUS_MUTATION = "\n  mutation Mutation($input: DeleteTravelAvailabilityStatusInput) {\n    forceDeleteTravelAvailabilityStatus(input: $input) {\n      success\n    }\n  }";
// language=GraphQL
var ADD_AVAILABILITY_STATUS_TENANT_SETTINGS_MUTATION = "\n  mutation Mutation($input: addTravelAvailabilityStatusTenantSettingsInput) {\n    addTravelAvailabilityStatusTenantSettings(input: $input) {\n      id\n      tenantSettingsIds\n    }\n  }";
// language=GraphQL
var REMOVE_AVAILABILITY_STATUS_TENANT_SETTINGS_MUTATION = "\n  mutation Mutation($input: removeTravelAvailabilityStatusTenantSettingsInput) {\n    removeTravelAvailabilityStatusTenantSettings(input: $input) {\n      id\n      tenantSettingsIds\n    }\n  }";
// language=GraphQL
var CREATE_AVAILABILITY_STATUS_TENANT_SETTINGS_MUTATION = "\n  mutation Mutation($input: createTravelAvailabilityStatusTenantSettingsInput) {\n    createTravelAvailabilityStatusTenantSettings(input: $input) {\n      id\n      tenantSettingsIds\n    }\n  }";
// language=GraphQL
var DELETE_AVAILABILITY_STATUS_TENANT_SETTINGS_MUTATION = "\n  mutation Mutation($input: deleteTravelAvailabilityStatusTenantSettingsInput) {\n    deleteTravelAvailabilityStatusTenantSettings(input: $input) {\n      id\n      tenantSettingsIds\n    }\n  }";
// language=GraphQL
var UPDATE_AVAILABILITY_STATUS_TENANT_SETTINGS_ORDER_MUTATION = "\n  mutation Mutation($input: updateTravelAvailabilityStatusTenantSettingsOrderInput) {\n    updateTravelAvailabilityStatusTenantSettingsOrder(input: $input) {\n      id\n      tenantSettingsIds\n    }\n  }";
// language=GraphQL
var AVAILABILITY_STATUS_DEPENDENTS_QUERY = "query Query($id: ID!, $withTravels: Boolean = false, $withRatioTravelDates: Boolean = false) {\n  groupedDependents: travelAvailabilityStatusDependents(id: $id) {\n    travels @include(if: $withTravels) {\n      id\n      name\n      isBestseller\n      startDate\n      endDate\n      executionStatus\n      title\n      description\n      includedServices\n      excludedServices\n      pricingTable\n      priceCalculationInfo\n      programType\n      programText\n      minPrice\n      minPriceManualOverride\n      currency    }\n    ratioTravelDates @include(if: $withRatioTravelDates) {\n      id\n      dateNo\n      startDate\n      endDate\n      includesExtension\n      json\n    }\n  }\n}";

// EXTERNAL MODULE: ./src/entities/availabilityStatusTenantSettings/entity.ts + 3 modules
var entity = __webpack_require__(18334);
;// CONCATENATED MODULE: ./src/entities/travelAvailabilityStatus/model.ts


var travelAvailabilityStatusModel = {
    name: "availabilityStatus",
    namePlural: "availabilityStatus",
    uniqueName: "travelAvailabilityStatus",
    uniqueNamePlural: "travelAvailabilityStatus",
    path: "travel/availability_status",
    baseUrl: "/travel/availability-status",
    translationPrefix: "entities:travelAvailabilityStatus.",
    getDisplayName: function(values) {
        return values.label;
    },
    gql: {
        getAll: ALL_AVAILABILITY_STATUS_QUERY,
        getSingle: SINGLE_AVAILABILITY_STATUS_QUERY,
        create: CREATE_AVAILABILITY_STATUS_MUTATION,
        update: UPDATE_AVAILABILITY_STATUS_MUTATION,
        delete: DELETE_AVAILABILITY_STATUS_MUTATION,
        forceDelete: FORCE_DELETE_AVAILABILITY_STATUS_MUTATION
    },
    attributes: {
        label: {
            name: "label",
            label: "entities:travelAvailabilityStatus.attributes.label.label",
            type: "value",
            dataType: "string",
            defaultInput: true,
            inputType: "text",
            validationType: "string",
            validations: [
                {
                    type: "required"
                }, 
            ]
        },
        status: {
            name: "status",
            label: "entities:travelAvailabilityStatus.attributes.status.label",
            type: "value",
            dataType: "string",
            defaultValue: "BOOKABLE",
            defaultInput: true,
            inputType: "select",
            selectOptions: [
                {
                    label: "entities:travelAvailabilityStatus.attributes.status.selectOptions.BOOKABLE.label",
                    value: "BOOKABLE"
                },
                {
                    label: "entities:travelAvailabilityStatus.attributes.status.selectOptions.REQUEST.label",
                    value: "REQUEST"
                },
                {
                    label: "entities:travelAvailabilityStatus.attributes.status.selectOptions.WAITLIST.label",
                    value: "WAITLIST"
                },
                {
                    label: "entities:travelAvailabilityStatus.attributes.status.selectOptions.WAITLIST_CONTINGENT_CHECK.label",
                    value: "WAITLIST_CONTINGENT_CHECK"
                },
                {
                    label: "entities:travelAvailabilityStatus.attributes.status.selectOptions.CLOSED.label",
                    value: "CLOSED"
                }, 
            ],
            validationType: "string",
            validations: []
        },
        isDefaultStatus: {
            name: "isDefaultStatus",
            label: "entities:travelAvailabilityStatus.attributes.isDefaultStatus.label",
            type: "value",
            dataType: "boolean",
            defaultInput: true,
            inputType: "switch",
            validationType: "string",
            validations: []
        },
        isDefaultWaitlistFallback: {
            name: "isDefaultWaitlistFallback",
            label: "entities:travelAvailabilityStatus.attributes.isDefaultWaitlistFallback.label",
            type: "value",
            dataType: "boolean",
            defaultInput: true,
            inputType: "switch",
            validationType: "string",
            validations: []
        },
        tenantSettings: {
            name: "tenantSettings",
            label: "entities:travelAvailabilityStatus.attributes.tenantSettings.label",
            type: "entityCollection",
            dataType: "[any]",
            getEntity: function() {
                return entity/* default */.Z;
            },
            defaultInput: false,
            inputType: "text",
            validationType: "string",
            validations: []
        }
    }
};
/* harmony default export */ var model = (travelAvailabilityStatusModel);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(20414);
// EXTERNAL MODULE: ./src/entities/lib.ts
var lib = __webpack_require__(23480);
// EXTERNAL MODULE: ./src/lib/api/graphQLClient.ts
var graphQLClient = __webpack_require__(40112);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/swr/dist/index.mjs
var dist = __webpack_require__(8100);
// EXTERNAL MODULE: ./src/lib/helpers/helpers.ts
var helpers = __webpack_require__(15778);
;// CONCATENATED MODULE: ./src/entities/travelAvailabilityStatus/repository.ts










var hydrateObjects = function(objects) {
    return objects.map(function(object) {
        return (0,lib/* hydrateEntityObject */.b)(model, object);
    });
};
var hydrateObject = function(object) {
    return (0,lib/* hydrateEntityObject */.b)(model, object);
};
var travelAvailabilityStatusRepository = {
    getObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    id: id
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(SINGLE_AVAILABILITY_STATUS_QUERY, variables).then(function(data) {
                        return hydrateObject(data.availabilityStatus);
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }(),
    getObjects: /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        var includes;
        var _arguments = arguments;
        return (0,tslib_es6.__generator)(this, function(_state) {
            includes = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : {};
            return [
                2,
                graphQLClient/* default.request */.Z.request(ALL_AVAILABILITY_STATUS_QUERY, includes).then(function(data) {
                    return hydrateObjects(data.availabilityStatus);
                })
            ];
        });
    }),
    useObject: function(id) {
        var includes = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        // eslint-disable-next-line react-hooks/exhaustive-deps
        var variables = (0,react.useMemo)(function() {
            return (0,_object_spread/* default */.Z)({
                id: id
            }, includes);
        }, [
            id
        ]);
        var ref = (0,dist/* default */.ZP)([
            SINGLE_AVAILABILITY_STATUS_QUERY,
            variables
        ], {
            revalidateOnFocus: false
        }), data = ref.data, error = ref.error, mutate = ref.mutate;
        return {
            object: !data ? data : hydrateObject(data.availabilityStatus),
            isLoading: !error && !data,
            isError: error,
            mutate: mutate
        };
    },
    useObjects: function() {
        var includes = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        // eslint-disable-next-line react-hooks/exhaustive-deps
        var variables = (0,react.useMemo)(function() {
            return includes;
        }, []);
        var ref = (0,dist/* default */.ZP)([
            ALL_AVAILABILITY_STATUS_QUERY,
            variables
        ]), data = ref.data, error = ref.error, mutate = ref.mutate;
        return {
            objects: !data ? data : hydrateObjects(data.availabilityStatus),
            isLoading: !error && !data,
            isError: error,
            mutate: mutate
        };
    },
    getDependents: function(id, includes) {
        var includeVars = {};
        includes.forEach(function(include) {
            includeVars["with".concat((0,helpers/* uppercaseFirst */.AB)(include))] = true;
        });
        var variables = (0,_object_spread/* default */.Z)({
            id: id
        }, includeVars);
        return graphQLClient/* default.request */.Z.request(AVAILABILITY_STATUS_DEPENDENTS_QUERY, variables).then(function(data) {
            return data.groupedDependents;
        });
    },
    useDependents: function(id, includes) {
        var includeVars = {};
        includes.forEach(function(include) {
            includeVars["with".concat((0,helpers/* uppercaseFirst */.AB)(include))] = true;
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
        var variables = (0,react.useMemo)(function() {
            return (0,_object_spread/* default */.Z)({
                id: id
            }, includeVars);
        }, [
            id
        ]);
        var ref = (0,dist/* default */.ZP)([
            AVAILABILITY_STATUS_DEPENDENTS_QUERY,
            variables
        ], {
            revalidateOnFocus: false
        }), data = ref.data, error = ref.error, mutate = ref.mutate;
        return {
            data: !data ? data : data.groupedDependents,
            isLoading: !error && !data,
            isError: error,
            mutate: mutate
        };
    },
    createObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(data) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    input: data
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(CREATE_AVAILABILITY_STATUS_MUTATION, variables).then(function(data) {
                        return hydrateObject(data.availabilityStatus);
                    })
                ];
            });
        });
        return function(data) {
            return _ref.apply(this, arguments);
        };
    }(),
    updateObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(data) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    input: data
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(UPDATE_AVAILABILITY_STATUS_MUTATION, variables).then(function(data) {
                        return hydrateObject(data.availabilityStatus);
                    })
                ];
            });
        });
        return function(data) {
            return _ref.apply(this, arguments);
        };
    }(),
    deleteObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(DELETE_AVAILABILITY_STATUS_MUTATION, variables).then(function(data) {
                        return data.deleteTravelAvailabilityStatus;
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }(),
    forceDeleteObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(FORCE_DELETE_AVAILABILITY_STATUS_MUTATION, variables).then(function(data) {
                        return data.forceDeleteTravelAvailabilityStatus;
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }(),
    assignTenantSettings: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, itemIds) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        tenantSettingsIds: itemIds
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(ADD_AVAILABILITY_STATUS_TENANT_SETTINGS_MUTATION, variables)
                ];
            });
        });
        return function(id, itemIds) {
            return _ref.apply(this, arguments);
        };
    }(),
    unassignTenantSettings: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, itemIds) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        tenantSettingsIds: itemIds
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(REMOVE_AVAILABILITY_STATUS_TENANT_SETTINGS_MUTATION, variables)
                ];
            });
        });
        return function(id, itemIds) {
            return _ref.apply(this, arguments);
        };
    }(),
    createTenantSettings: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, items) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        tenantSettings: items
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(CREATE_AVAILABILITY_STATUS_TENANT_SETTINGS_MUTATION, variables)
                ];
            });
        });
        return function(id, items) {
            return _ref.apply(this, arguments);
        };
    }(),
    deleteTenantSettings: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, itemIds) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        tenantSettingsIds: itemIds
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(DELETE_AVAILABILITY_STATUS_TENANT_SETTINGS_MUTATION, variables)
                ];
            });
        });
        return function(id, itemIds) {
            return _ref.apply(this, arguments);
        };
    }(),
    updateTenantSettingsOrder: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, itemIds) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        tenantSettingsIds: itemIds
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(UPDATE_AVAILABILITY_STATUS_TENANT_SETTINGS_ORDER_MUTATION, variables)
                ];
            });
        });
        return function(id, itemIds) {
            return _ref.apply(this, arguments);
        };
    }()
};
/* harmony default export */ var repository = (travelAvailabilityStatusRepository);

;// CONCATENATED MODULE: ./src/entities/travelAvailabilityStatus/entity.ts


var travelAvailabilityStatusEntity = {
    model: model,
    repository: repository
};
/* harmony default export */ var travelAvailabilityStatus_entity = (travelAvailabilityStatusEntity);


/***/ }),

/***/ 58824:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ travelBargainSettings_entity; }
});

;// CONCATENATED MODULE: ./src/entities/travelBargainSettings/graphql.ts
// language=GraphQL
var ALL_BARGAIN_SETTINGS_QUERY = "query Query($withBargainTier: Boolean = false) {\n  bargainSettings: allTravelBargainSettings {\n    id\n    active\n    untilDaysBeforeStart\n    bargainTier @include(if: $withBargainTier) {\n      id\n      fromPrice\n      discount\n    }\n  }\n}";
// language=GraphQL
var SINGLE_BARGAIN_SETTINGS_QUERY = "query Query($id: ID!, $withBargainTier: Boolean = false) {\n  bargainSettings: travelBargainSettings(id: $id) {\n    id\n    active\n    untilDaysBeforeStart\n    bargainTier @include(if: $withBargainTier) {\n      id\n      fromPrice\n      discount\n    }\n  }\n}";
// language=GraphQL
var CREATE_BARGAIN_SETTINGS_MUTATION = "\n  mutation Mutation($input: CreateTravelBargainSettingsInput, $withBargainTier: Boolean = false) {\n    bargainSettings: createTravelBargainSettings(input: $input) {\n      id\n      active\n      untilDaysBeforeStart\n      bargainTier @include(if: $withBargainTier) {\n        id\n        fromPrice\n        discount\n      }\n    }\n  }";
// language=GraphQL
var UPDATE_BARGAIN_SETTINGS_MUTATION = "\n  mutation Mutation($input: UpdateTravelBargainSettingsInput, $withBargainTier: Boolean = false) {\n    bargainSettings: updateTravelBargainSettings(input: $input) {\n      id\n      active\n      untilDaysBeforeStart\n      bargainTier @include(if: $withBargainTier) {\n        id\n        fromPrice\n        discount\n      }\n    }\n  }";
// language=GraphQL
var DELETE_BARGAIN_SETTINGS_MUTATION = "\n  mutation Mutation($input: DeleteTravelBargainSettingsInput) {\n    deleteTravelBargainSettings(input: $input) {\n      success\n    }\n  }";
// language=GraphQL
var FORCE_DELETE_BARGAIN_SETTINGS_MUTATION = "\n  mutation Mutation($input: DeleteTravelBargainSettingsInput) {\n    forceDeleteTravelBargainSettings(input: $input) {\n      success\n    }\n  }";
// language=GraphQL
var BARGAIN_SETTINGS_DEPENDENTS_QUERY = "query Query($id: ID!, $withTravelPricings: Boolean = false) {\n  groupedDependents: travelBargainSettingsDependents(id: $id) {\n    travelPricings @include(if: $withTravelPricings) {\n      id\n      isTravelDocumentationAvailable\n    }\n  }\n}";

// EXTERNAL MODULE: ./src/entities/bargainTier/entity.ts + 3 modules
var entity = __webpack_require__(90101);
;// CONCATENATED MODULE: ./src/entities/travelBargainSettings/model.ts


var travelBargainSettingsModel = {
    name: "bargainSettings",
    namePlural: "bargainSettings",
    uniqueName: "travelBargainSettings",
    uniqueNamePlural: "travelBargainSettings",
    path: "travel/pricing/bargain_settings",
    baseUrl: "/travel/pricing/bargain_settings",
    translationPrefix: "entities:travelBargainSettings.",
    getDisplayName: function(values) {
        return "BARGAIN SETTINGS";
    },
    gql: {
        getAll: ALL_BARGAIN_SETTINGS_QUERY,
        getSingle: SINGLE_BARGAIN_SETTINGS_QUERY,
        create: CREATE_BARGAIN_SETTINGS_MUTATION,
        update: UPDATE_BARGAIN_SETTINGS_MUTATION,
        delete: DELETE_BARGAIN_SETTINGS_MUTATION,
        forceDelete: FORCE_DELETE_BARGAIN_SETTINGS_MUTATION
    },
    attributes: {
        active: {
            name: "active",
            label: "entities:travelBargainSettings.attributes.active.label",
            type: "value",
            dataType: "number",
            defaultInput: true,
            inputType: "switch",
            validationType: "string",
            validations: []
        },
        untilDaysBeforeStart: {
            name: "untilDaysBeforeStart",
            label: "entities:travelBargainSettings.attributes.untilDaysBeforeStart.label",
            type: "value",
            dataType: "number",
            defaultValue: 90,
            defaultInput: true,
            inputType: "number",
            validationType: "string",
            validations: [
                {
                    type: "required"
                },
                {
                    type: "number"
                }, 
            ]
        },
        bargainTier: {
            name: "bargainTier",
            label: "entities:travelBargainSettings.attributes.bargainTier.label",
            type: "entityObject",
            dataType: "any",
            getEntity: function() {
                return entity/* default */.Z;
            },
            defaultInput: false,
            inputType: "select",
            validationType: "string",
            validations: []
        }
    }
};
/* harmony default export */ var model = (travelBargainSettingsModel);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(20414);
// EXTERNAL MODULE: ./src/entities/lib.ts
var lib = __webpack_require__(23480);
// EXTERNAL MODULE: ./src/lib/api/graphQLClient.ts
var graphQLClient = __webpack_require__(40112);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/swr/dist/index.mjs
var dist = __webpack_require__(8100);
// EXTERNAL MODULE: ./src/lib/helpers/helpers.ts
var helpers = __webpack_require__(15778);
;// CONCATENATED MODULE: ./src/entities/travelBargainSettings/repository.ts










var hydrateObjects = function(objects) {
    return objects.map(function(object) {
        return (0,lib/* hydrateEntityObject */.b)(model, object);
    });
};
var hydrateObject = function(object) {
    return (0,lib/* hydrateEntityObject */.b)(model, object);
};
var travelBargainSettingsRepository = {
    getObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    id: id
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(SINGLE_BARGAIN_SETTINGS_QUERY, variables).then(function(data) {
                        return hydrateObject(data.bargainSettings);
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }(),
    getObjects: /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        var includes;
        var _arguments = arguments;
        return (0,tslib_es6.__generator)(this, function(_state) {
            includes = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : {};
            return [
                2,
                graphQLClient/* default.request */.Z.request(ALL_BARGAIN_SETTINGS_QUERY, includes).then(function(data) {
                    return hydrateObjects(data.bargainSettings);
                })
            ];
        });
    }),
    useObject: function(id) {
        var includes = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        // eslint-disable-next-line react-hooks/exhaustive-deps
        var variables = (0,react.useMemo)(function() {
            return (0,_object_spread/* default */.Z)({
                id: id
            }, includes);
        }, [
            id
        ]);
        var ref = (0,dist/* default */.ZP)([
            SINGLE_BARGAIN_SETTINGS_QUERY,
            variables
        ], {
            revalidateOnFocus: false
        }), data = ref.data, error = ref.error, mutate = ref.mutate;
        return {
            object: !data ? data : hydrateObject(data.bargainSettings),
            isLoading: !error && !data,
            isError: error,
            mutate: mutate
        };
    },
    useObjects: function() {
        var includes = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        // eslint-disable-next-line react-hooks/exhaustive-deps
        var variables = (0,react.useMemo)(function() {
            return includes;
        }, []);
        var ref = (0,dist/* default */.ZP)([
            ALL_BARGAIN_SETTINGS_QUERY,
            variables
        ]), data = ref.data, error = ref.error, mutate = ref.mutate;
        return {
            objects: !data ? data : hydrateObjects(data.bargainSettings),
            isLoading: !error && !data,
            isError: error,
            mutate: mutate
        };
    },
    getDependents: function(id, includes) {
        var includeVars = {};
        includes.forEach(function(include) {
            includeVars["with".concat((0,helpers/* uppercaseFirst */.AB)(include))] = true;
        });
        var variables = (0,_object_spread/* default */.Z)({
            id: id
        }, includeVars);
        return graphQLClient/* default.request */.Z.request(BARGAIN_SETTINGS_DEPENDENTS_QUERY, variables).then(function(data) {
            return data.groupedDependents;
        });
    },
    useDependents: function(id, includes) {
        var includeVars = {};
        includes.forEach(function(include) {
            includeVars["with".concat((0,helpers/* uppercaseFirst */.AB)(include))] = true;
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
        var variables = (0,react.useMemo)(function() {
            return (0,_object_spread/* default */.Z)({
                id: id
            }, includeVars);
        }, [
            id
        ]);
        var ref = (0,dist/* default */.ZP)([
            BARGAIN_SETTINGS_DEPENDENTS_QUERY,
            variables
        ], {
            revalidateOnFocus: false
        }), data = ref.data, error = ref.error, mutate = ref.mutate;
        return {
            data: !data ? data : data.groupedDependents,
            isLoading: !error && !data,
            isError: error,
            mutate: mutate
        };
    },
    createObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(data) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    input: data
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(CREATE_BARGAIN_SETTINGS_MUTATION, variables).then(function(data) {
                        return hydrateObject(data.bargainSettings);
                    })
                ];
            });
        });
        return function(data) {
            return _ref.apply(this, arguments);
        };
    }(),
    updateObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(data) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    input: data
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(UPDATE_BARGAIN_SETTINGS_MUTATION, variables).then(function(data) {
                        return hydrateObject(data.bargainSettings);
                    })
                ];
            });
        });
        return function(data) {
            return _ref.apply(this, arguments);
        };
    }(),
    deleteObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(DELETE_BARGAIN_SETTINGS_MUTATION, variables).then(function(data) {
                        return data.deleteTravelBargainSettings;
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }(),
    forceDeleteObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(FORCE_DELETE_BARGAIN_SETTINGS_MUTATION, variables).then(function(data) {
                        return data.forceDeleteTravelBargainSettings;
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }()
};
/* harmony default export */ var repository = (travelBargainSettingsRepository);

;// CONCATENATED MODULE: ./src/entities/travelBargainSettings/entity.ts


var travelBargainSettingsEntity = {
    model: model,
    repository: repository
};
/* harmony default export */ var travelBargainSettings_entity = (travelBargainSettingsEntity);


/***/ }),

/***/ 22546:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ entity; }
});

;// CONCATENATED MODULE: ./src/entities/travelDestination/graphql.ts
// language=GraphQL
var ALL_DESTINATIONS_QUERY = "query Query {\n  destinations: travelDestinations {\n    id\n    name\n    entryRequirements\n    medicalInformation\n    language\n    timeShift\n    climate\n    currency\n  }\n}";
// language=GraphQL
var SINGLE_DESTINATION_QUERY = "query Query($id: ID!) {\n  destination: travelDestination(id: $id) {\n    id\n    name\n    entryRequirements\n    medicalInformation\n    language\n    timeShift\n    climate\n    currency\n  }\n}";
// language=GraphQL
var CREATE_DESTINATION_MUTATION = "\n  mutation Mutation($input: CreateTravelDestinationInput) {\n    destination: createTravelDestination(input: $input) {\n      id\n      name\n      entryRequirements\n      medicalInformation\n      language\n      timeShift\n      climate\n      currency\n    }\n  }";
// language=GraphQL
var UPDATE_DESTINATION_MUTATION = "\n  mutation Mutation($input: UpdateTravelDestinationInput) {\n    destination: updateTravelDestination(input: $input) {\n      id\n      name\n      entryRequirements\n      medicalInformation\n      language\n      timeShift\n      climate\n      currency\n    }\n  }";
// language=GraphQL
var DELETE_DESTINATION_MUTATION = "\n  mutation Mutation($input: DeleteTravelDestinationInput) {\n    deleteTravelDestination(input: $input) {\n      success\n    }\n  }";
// language=GraphQL
var FORCE_DELETE_DESTINATION_MUTATION = "\n  mutation Mutation($input: DeleteTravelDestinationInput) {\n    forceDeleteTravelDestination(input: $input) {\n      success\n    }\n  }";
// language=GraphQL
var DESTINATIONS_DEPENDENTS_QUERY = "query Query($id: ID!, $withTravels: Boolean = false, $withCmsPrefilteredTravelsBlocks: Boolean = false, $withCmsDestinationsBlocks: Boolean = false) {\n  groupedDependents: travelDestinationDependents(id: $id) {\n    travels @include(if: $withTravels) {\n      id\n      name\n      isBestseller\n      startDate\n      endDate\n      executionStatus\n      title\n      description\n      includedServices\n      excludedServices\n      pricingTable\n      priceCalculationInfo\n      programType\n      programText\n      minPrice\n      minPriceManualOverride\n      currency    }\n    cmsPrefilteredTravelsBlocks @include(if: $withCmsPrefilteredTravelsBlocks) {\n      id\n      maxResults    }\n    cmsDestinationsBlocks @include(if: $withCmsDestinationsBlocks) {\n      id\n    }\n  }\n}";

;// CONCATENATED MODULE: ./src/entities/travelDestination/model.ts

var travelDestinationModel = {
    name: "destination",
    namePlural: "destinations",
    uniqueName: "travelDestination",
    uniqueNamePlural: "travelDestinations",
    path: "travel/destination",
    baseUrl: "/travel/destinations",
    translationPrefix: "entities:travelDestination.",
    getDisplayName: function(values) {
        return values.name;
    },
    gql: {
        getAll: ALL_DESTINATIONS_QUERY,
        getSingle: SINGLE_DESTINATION_QUERY,
        create: CREATE_DESTINATION_MUTATION,
        update: UPDATE_DESTINATION_MUTATION,
        delete: DELETE_DESTINATION_MUTATION,
        forceDelete: FORCE_DELETE_DESTINATION_MUTATION
    },
    attributes: {
        name: {
            name: "name",
            label: "entities:travelDestination.attributes.name.label",
            type: "value",
            dataType: "string",
            defaultInput: true,
            inputType: "text",
            validationType: "string",
            validations: [
                {
                    type: "required"
                }, 
            ]
        },
        entryRequirements: {
            name: "entryRequirements",
            label: "entities:travelDestination.attributes.entryRequirements.label",
            type: "value",
            dataType: "string",
            defaultInput: true,
            inputType: "textarea",
            validationType: "string",
            validations: [
                {
                    type: "required"
                }, 
            ]
        },
        medicalInformation: {
            name: "medicalInformation",
            label: "entities:travelDestination.attributes.medicalInformation.label",
            type: "value",
            dataType: "string",
            defaultInput: true,
            inputType: "textarea",
            validationType: "string",
            validations: [
                {
                    type: "required"
                }, 
            ]
        },
        language: {
            name: "language",
            label: "entities:travelDestination.attributes.language.label",
            type: "value",
            dataType: "string",
            defaultInput: true,
            inputType: "textarea",
            validationType: "string",
            validations: [
                {
                    type: "required"
                }, 
            ]
        },
        timeShift: {
            name: "timeShift",
            label: "entities:travelDestination.attributes.timeShift.label",
            type: "value",
            dataType: "string",
            defaultInput: true,
            inputType: "textarea",
            validationType: "string",
            validations: [
                {
                    type: "required"
                }, 
            ]
        },
        climate: {
            name: "climate",
            label: "entities:travelDestination.attributes.climate.label",
            type: "value",
            dataType: "string",
            defaultInput: true,
            inputType: "textarea",
            validationType: "string",
            validations: [
                {
                    type: "required"
                }, 
            ]
        },
        currency: {
            name: "currency",
            label: "entities:travelDestination.attributes.currency.label",
            type: "value",
            dataType: "string",
            defaultInput: true,
            inputType: "textarea",
            validationType: "string",
            validations: [
                {
                    type: "required"
                }, 
            ]
        }
    }
};
/* harmony default export */ var model = (travelDestinationModel);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(20414);
// EXTERNAL MODULE: ./src/entities/lib.ts
var lib = __webpack_require__(23480);
// EXTERNAL MODULE: ./src/lib/api/graphQLClient.ts
var graphQLClient = __webpack_require__(40112);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/swr/dist/index.mjs
var dist = __webpack_require__(8100);
// EXTERNAL MODULE: ./src/lib/helpers/helpers.ts
var helpers = __webpack_require__(15778);
;// CONCATENATED MODULE: ./src/entities/travelDestination/repository.ts










var hydrateObjects = function(objects) {
    return objects.map(function(object) {
        return (0,lib/* hydrateEntityObject */.b)(model, object);
    });
};
var hydrateObject = function(object) {
    return (0,lib/* hydrateEntityObject */.b)(model, object);
};
var travelDestinationRepository = {
    getObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    id: id
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(SINGLE_DESTINATION_QUERY, variables).then(function(data) {
                        return hydrateObject(data.destination);
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }(),
    getObjects: /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        var includes;
        var _arguments = arguments;
        return (0,tslib_es6.__generator)(this, function(_state) {
            includes = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : {};
            return [
                2,
                graphQLClient/* default.request */.Z.request(ALL_DESTINATIONS_QUERY, includes).then(function(data) {
                    return hydrateObjects(data.destinations);
                })
            ];
        });
    }),
    useObject: function(id) {
        var includes = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        // eslint-disable-next-line react-hooks/exhaustive-deps
        var variables = (0,react.useMemo)(function() {
            return (0,_object_spread/* default */.Z)({
                id: id
            }, includes);
        }, [
            id
        ]);
        var ref = (0,dist/* default */.ZP)([
            SINGLE_DESTINATION_QUERY,
            variables
        ], {
            revalidateOnFocus: false
        }), data = ref.data, error = ref.error, mutate = ref.mutate;
        return {
            object: !data ? data : hydrateObject(data.destination),
            isLoading: !error && !data,
            isError: error,
            mutate: mutate
        };
    },
    useObjects: function() {
        var includes = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        // eslint-disable-next-line react-hooks/exhaustive-deps
        var variables = (0,react.useMemo)(function() {
            return includes;
        }, []);
        var ref = (0,dist/* default */.ZP)([
            ALL_DESTINATIONS_QUERY,
            variables
        ]), data = ref.data, error = ref.error, mutate = ref.mutate;
        return {
            objects: !data ? data : hydrateObjects(data.destinations),
            isLoading: !error && !data,
            isError: error,
            mutate: mutate
        };
    },
    getDependents: function(id, includes) {
        var includeVars = {};
        includes.forEach(function(include) {
            includeVars["with".concat((0,helpers/* uppercaseFirst */.AB)(include))] = true;
        });
        var variables = (0,_object_spread/* default */.Z)({
            id: id
        }, includeVars);
        return graphQLClient/* default.request */.Z.request(DESTINATIONS_DEPENDENTS_QUERY, variables).then(function(data) {
            return data.groupedDependents;
        });
    },
    useDependents: function(id, includes) {
        var includeVars = {};
        includes.forEach(function(include) {
            includeVars["with".concat((0,helpers/* uppercaseFirst */.AB)(include))] = true;
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
        var variables = (0,react.useMemo)(function() {
            return (0,_object_spread/* default */.Z)({
                id: id
            }, includeVars);
        }, [
            id
        ]);
        var ref = (0,dist/* default */.ZP)([
            DESTINATIONS_DEPENDENTS_QUERY,
            variables
        ], {
            revalidateOnFocus: false
        }), data = ref.data, error = ref.error, mutate = ref.mutate;
        return {
            data: !data ? data : data.groupedDependents,
            isLoading: !error && !data,
            isError: error,
            mutate: mutate
        };
    },
    createObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(data) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    input: data
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(CREATE_DESTINATION_MUTATION, variables).then(function(data) {
                        return hydrateObject(data.destination);
                    })
                ];
            });
        });
        return function(data) {
            return _ref.apply(this, arguments);
        };
    }(),
    updateObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(data) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    input: data
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(UPDATE_DESTINATION_MUTATION, variables).then(function(data) {
                        return hydrateObject(data.destination);
                    })
                ];
            });
        });
        return function(data) {
            return _ref.apply(this, arguments);
        };
    }(),
    deleteObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(DELETE_DESTINATION_MUTATION, variables).then(function(data) {
                        return data.deleteTravelDestination;
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }(),
    forceDeleteObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(FORCE_DELETE_DESTINATION_MUTATION, variables).then(function(data) {
                        return data.forceDeleteTravelDestination;
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }()
};
/* harmony default export */ var repository = (travelDestinationRepository);

;// CONCATENATED MODULE: ./src/entities/travelDestination/entity.ts


var travelDestinationEntity = {
    model: model,
    repository: repository
};
/* harmony default export */ var entity = (travelDestinationEntity);


/***/ }),

/***/ 80447:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ travelEsimSettings_entity; }
});

;// CONCATENATED MODULE: ./src/entities/travelEsimSettings/graphql.ts
// language=GraphQL
var ALL_ESIM_SETTINGS_QUERY = "query Query($withRegions: Boolean = false) {\n  esimSettings: allTravelEsimSettings {\n    id\n    enabled\n    regions @include(if: $withRegions) {\n      id\n      name\n      serviceCodePrefix\n    }\n  }\n}";
// language=GraphQL
var SINGLE_ESIM_SETTINGS_QUERY = "query Query($id: ID!, $withRegions: Boolean = false) {\n  esimSettings: travelEsimSettings(id: $id) {\n    id\n    enabled\n    regions @include(if: $withRegions) {\n      id\n      name\n      serviceCodePrefix\n    }\n  }\n}";
// language=GraphQL
var CREATE_ESIM_SETTINGS_MUTATION = "\n  mutation Mutation($input: CreateTravelEsimSettingsInput, $withRegions: Boolean = false) {\n    esimSettings: createTravelEsimSettings(input: $input) {\n      id\n      enabled\n      regions @include(if: $withRegions) {\n        id\n        name\n        serviceCodePrefix\n      }\n    }\n  }";
// language=GraphQL
var UPDATE_ESIM_SETTINGS_MUTATION = "\n  mutation Mutation($input: UpdateTravelEsimSettingsInput, $withRegions: Boolean = false) {\n    esimSettings: updateTravelEsimSettings(input: $input) {\n      id\n      enabled\n      regions @include(if: $withRegions) {\n        id\n        name\n        serviceCodePrefix\n      }\n    }\n  }";
// language=GraphQL
var DELETE_ESIM_SETTINGS_MUTATION = "\n  mutation Mutation($input: DeleteTravelEsimSettingsInput) {\n    deleteTravelEsimSettings(input: $input) {\n      success\n    }\n  }";
// language=GraphQL
var FORCE_DELETE_ESIM_SETTINGS_MUTATION = "\n  mutation Mutation($input: DeleteTravelEsimSettingsInput) {\n    forceDeleteTravelEsimSettings(input: $input) {\n      success\n    }\n  }";
// language=GraphQL
var ADD_ESIM_SETTINGS_REGIONS_MUTATION = "\n  mutation Mutation($input: addTravelEsimSettingsRegionsInput) {\n    addTravelEsimSettingsRegions(input: $input) {\n      id\n      regionIds\n    }\n  }";
// language=GraphQL
var REMOVE_ESIM_SETTINGS_REGIONS_MUTATION = "\n  mutation Mutation($input: removeTravelEsimSettingsRegionsInput) {\n    removeTravelEsimSettingsRegions(input: $input) {\n      id\n      regionIds\n    }\n  }";
// language=GraphQL
var CREATE_ESIM_SETTINGS_REGIONS_MUTATION = "\n  mutation Mutation($input: createTravelEsimSettingsRegionsInput) {\n    createTravelEsimSettingsRegions(input: $input) {\n      id\n      regionIds\n    }\n  }";
// language=GraphQL
var DELETE_ESIM_SETTINGS_REGIONS_MUTATION = "\n  mutation Mutation($input: deleteTravelEsimSettingsRegionsInput) {\n    deleteTravelEsimSettingsRegions(input: $input) {\n      id\n      regionIds\n    }\n  }";
// language=GraphQL
var UPDATE_ESIM_SETTINGS_REGIONS_ORDER_MUTATION = "\n  mutation Mutation($input: updateTravelEsimSettingsRegionsOrderInput) {\n    updateTravelEsimSettingsRegionsOrder(input: $input) {\n      id\n      regionIds\n    }\n  }";
// language=GraphQL
var ESIM_SETTINGS_DEPENDENTS_QUERY = "query Query($id: ID!, $withTravelPricings: Boolean = false) {\n  groupedDependents: travelEsimSettingsDependents(id: $id) {\n    travelPricings @include(if: $withTravelPricings) {\n      id\n      isTravelDocumentationAvailable\n    }\n  }\n}";

// EXTERNAL MODULE: ./src/entities/ratioEsimRegion/entity.ts + 3 modules
var entity = __webpack_require__(66819);
;// CONCATENATED MODULE: ./src/entities/travelEsimSettings/model.ts


var travelEsimSettingsModel = {
    name: "esimSettings",
    namePlural: "esimSettings",
    uniqueName: "travelEsimSettings",
    uniqueNamePlural: "travelEsimSettings",
    path: "travel/pricing/esim_settings",
    baseUrl: "/travel/pricing/esim_settings",
    translationPrefix: "entities:travelEsimSettings.",
    getDisplayName: function(values) {
        return "ESIM SETTINGS";
    },
    gql: {
        getAll: ALL_ESIM_SETTINGS_QUERY,
        getSingle: SINGLE_ESIM_SETTINGS_QUERY,
        create: CREATE_ESIM_SETTINGS_MUTATION,
        update: UPDATE_ESIM_SETTINGS_MUTATION,
        delete: DELETE_ESIM_SETTINGS_MUTATION,
        forceDelete: FORCE_DELETE_ESIM_SETTINGS_MUTATION
    },
    attributes: {
        enabled: {
            name: "enabled",
            label: "entities:travelEsimSettings.attributes.enabled.label",
            type: "value",
            dataType: "boolean",
            defaultInput: true,
            inputType: "switch",
            validationType: "string",
            validations: []
        },
        regions: {
            name: "regions",
            label: "entities:travelEsimSettings.attributes.regions.label",
            type: "entityCollection",
            dataType: "[any]",
            getEntity: function() {
                return entity/* default */.Z;
            },
            defaultInput: false,
            inputType: "text",
            validationType: "string",
            validations: []
        }
    }
};
/* harmony default export */ var model = (travelEsimSettingsModel);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(20414);
// EXTERNAL MODULE: ./src/entities/lib.ts
var lib = __webpack_require__(23480);
// EXTERNAL MODULE: ./src/lib/api/graphQLClient.ts
var graphQLClient = __webpack_require__(40112);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/swr/dist/index.mjs
var dist = __webpack_require__(8100);
// EXTERNAL MODULE: ./src/lib/helpers/helpers.ts
var helpers = __webpack_require__(15778);
;// CONCATENATED MODULE: ./src/entities/travelEsimSettings/repository.ts










var hydrateObjects = function(objects) {
    return objects.map(function(object) {
        return (0,lib/* hydrateEntityObject */.b)(model, object);
    });
};
var hydrateObject = function(object) {
    return (0,lib/* hydrateEntityObject */.b)(model, object);
};
var travelEsimSettingsRepository = {
    getObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    id: id
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(SINGLE_ESIM_SETTINGS_QUERY, variables).then(function(data) {
                        return hydrateObject(data.esimSettings);
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }(),
    getObjects: /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        var includes;
        var _arguments = arguments;
        return (0,tslib_es6.__generator)(this, function(_state) {
            includes = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : {};
            return [
                2,
                graphQLClient/* default.request */.Z.request(ALL_ESIM_SETTINGS_QUERY, includes).then(function(data) {
                    return hydrateObjects(data.esimSettings);
                })
            ];
        });
    }),
    useObject: function(id) {
        var includes = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        // eslint-disable-next-line react-hooks/exhaustive-deps
        var variables = (0,react.useMemo)(function() {
            return (0,_object_spread/* default */.Z)({
                id: id
            }, includes);
        }, [
            id
        ]);
        var ref = (0,dist/* default */.ZP)([
            SINGLE_ESIM_SETTINGS_QUERY,
            variables
        ], {
            revalidateOnFocus: false
        }), data = ref.data, error = ref.error, mutate = ref.mutate;
        return {
            object: !data ? data : hydrateObject(data.esimSettings),
            isLoading: !error && !data,
            isError: error,
            mutate: mutate
        };
    },
    useObjects: function() {
        var includes = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        // eslint-disable-next-line react-hooks/exhaustive-deps
        var variables = (0,react.useMemo)(function() {
            return includes;
        }, []);
        var ref = (0,dist/* default */.ZP)([
            ALL_ESIM_SETTINGS_QUERY,
            variables
        ]), data = ref.data, error = ref.error, mutate = ref.mutate;
        return {
            objects: !data ? data : hydrateObjects(data.esimSettings),
            isLoading: !error && !data,
            isError: error,
            mutate: mutate
        };
    },
    getDependents: function(id, includes) {
        var includeVars = {};
        includes.forEach(function(include) {
            includeVars["with".concat((0,helpers/* uppercaseFirst */.AB)(include))] = true;
        });
        var variables = (0,_object_spread/* default */.Z)({
            id: id
        }, includeVars);
        return graphQLClient/* default.request */.Z.request(ESIM_SETTINGS_DEPENDENTS_QUERY, variables).then(function(data) {
            return data.groupedDependents;
        });
    },
    useDependents: function(id, includes) {
        var includeVars = {};
        includes.forEach(function(include) {
            includeVars["with".concat((0,helpers/* uppercaseFirst */.AB)(include))] = true;
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
        var variables = (0,react.useMemo)(function() {
            return (0,_object_spread/* default */.Z)({
                id: id
            }, includeVars);
        }, [
            id
        ]);
        var ref = (0,dist/* default */.ZP)([
            ESIM_SETTINGS_DEPENDENTS_QUERY,
            variables
        ], {
            revalidateOnFocus: false
        }), data = ref.data, error = ref.error, mutate = ref.mutate;
        return {
            data: !data ? data : data.groupedDependents,
            isLoading: !error && !data,
            isError: error,
            mutate: mutate
        };
    },
    createObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(data) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    input: data
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(CREATE_ESIM_SETTINGS_MUTATION, variables).then(function(data) {
                        return hydrateObject(data.esimSettings);
                    })
                ];
            });
        });
        return function(data) {
            return _ref.apply(this, arguments);
        };
    }(),
    updateObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(data) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    input: data
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(UPDATE_ESIM_SETTINGS_MUTATION, variables).then(function(data) {
                        return hydrateObject(data.esimSettings);
                    })
                ];
            });
        });
        return function(data) {
            return _ref.apply(this, arguments);
        };
    }(),
    deleteObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(DELETE_ESIM_SETTINGS_MUTATION, variables).then(function(data) {
                        return data.deleteTravelEsimSettings;
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }(),
    forceDeleteObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(FORCE_DELETE_ESIM_SETTINGS_MUTATION, variables).then(function(data) {
                        return data.forceDeleteTravelEsimSettings;
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }(),
    assignRegions: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, itemIds) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        regionIds: itemIds
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(ADD_ESIM_SETTINGS_REGIONS_MUTATION, variables)
                ];
            });
        });
        return function(id, itemIds) {
            return _ref.apply(this, arguments);
        };
    }(),
    unassignRegions: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, itemIds) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        regionIds: itemIds
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(REMOVE_ESIM_SETTINGS_REGIONS_MUTATION, variables)
                ];
            });
        });
        return function(id, itemIds) {
            return _ref.apply(this, arguments);
        };
    }(),
    createRegions: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, items) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        regions: items
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(CREATE_ESIM_SETTINGS_REGIONS_MUTATION, variables)
                ];
            });
        });
        return function(id, items) {
            return _ref.apply(this, arguments);
        };
    }(),
    deleteRegions: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, itemIds) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        regionIds: itemIds
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(DELETE_ESIM_SETTINGS_REGIONS_MUTATION, variables)
                ];
            });
        });
        return function(id, itemIds) {
            return _ref.apply(this, arguments);
        };
    }(),
    updateRegionsOrder: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, itemIds) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        regionIds: itemIds
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(UPDATE_ESIM_SETTINGS_REGIONS_ORDER_MUTATION, variables)
                ];
            });
        });
        return function(id, itemIds) {
            return _ref.apply(this, arguments);
        };
    }()
};
/* harmony default export */ var repository = (travelEsimSettingsRepository);

;// CONCATENATED MODULE: ./src/entities/travelEsimSettings/entity.ts


var travelEsimSettingsEntity = {
    model: model,
    repository: repository
};
/* harmony default export */ var travelEsimSettings_entity = (travelEsimSettingsEntity);


/***/ }),

/***/ 14585:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ travelExtension_entity; }
});

;// CONCATENATED MODULE: ./src/entities/travelExtension/graphql.ts
// language=GraphQL
var ALL_TRAVEL_EXTENSIONS_QUERY = "query Query($withHighlights: Boolean = false, $withImage: Boolean = false) {\n  travelExtensions: travelExtensions {\n    id\n    duration\n    name\n    description\n    highlights @include(if: $withHighlights) {\n      id\n      text\n    }\n    image @include(if: $withImage) {\n      id\n      assetId\n      publicId\n      url\n      resourceType\n      format\n      width\n      height\n      caption\n      title\n      description\n    }\n  }\n}";
// language=GraphQL
var SINGLE_TRAVEL_EXTENSION_QUERY = "query Query($id: ID!, $withHighlights: Boolean = false, $withImage: Boolean = false) {\n  travelExtension: travelExtension(id: $id) {\n    id\n    duration\n    name\n    description\n    highlights @include(if: $withHighlights) {\n      id\n      text\n    }\n    image @include(if: $withImage) {\n      id\n      assetId\n      publicId\n      url\n      resourceType\n      format\n      width\n      height\n      caption\n      title\n      description\n    }\n  }\n}";
// language=GraphQL
var CREATE_TRAVEL_EXTENSION_MUTATION = "\n  mutation Mutation($input: CreateTravelExtensionInput, $withHighlights: Boolean = false, $withImage: Boolean = false) {\n    travelExtension: createTravelExtension(input: $input) {\n      id\n      duration\n      name\n      description\n      highlights @include(if: $withHighlights) {\n        id\n        text\n      }\n      image @include(if: $withImage) {\n        id\n        assetId\n        publicId\n        url\n        resourceType\n        format\n        width\n        height\n        caption\n        title\n        description\n      }\n    }\n  }";
// language=GraphQL
var UPDATE_TRAVEL_EXTENSION_MUTATION = "\n  mutation Mutation($input: UpdateTravelExtensionInput, $withHighlights: Boolean = false, $withImage: Boolean = false) {\n    travelExtension: updateTravelExtension(input: $input) {\n      id\n      duration\n      name\n      description\n      highlights @include(if: $withHighlights) {\n        id\n        text\n      }\n      image @include(if: $withImage) {\n        id\n        assetId\n        publicId\n        url\n        resourceType\n        format\n        width\n        height\n        caption\n        title\n        description\n      }\n    }\n  }";
// language=GraphQL
var DELETE_TRAVEL_EXTENSION_MUTATION = "\n  mutation Mutation($input: DeleteTravelExtensionInput) {\n    deleteTravelExtension(input: $input) {\n      success\n    }\n  }";
// language=GraphQL
var FORCE_DELETE_TRAVEL_EXTENSION_MUTATION = "\n  mutation Mutation($input: DeleteTravelExtensionInput) {\n    forceDeleteTravelExtension(input: $input) {\n      success\n    }\n  }";
// language=GraphQL
var ADD_TRAVEL_EXTENSION_HIGHLIGHTS_MUTATION = "\n  mutation Mutation($input: addTravelExtensionHighlightsInput) {\n    addTravelExtensionHighlights(input: $input) {\n      id\n      highlightIds\n    }\n  }";
// language=GraphQL
var REMOVE_TRAVEL_EXTENSION_HIGHLIGHTS_MUTATION = "\n  mutation Mutation($input: removeTravelExtensionHighlightsInput) {\n    removeTravelExtensionHighlights(input: $input) {\n      id\n      highlightIds\n    }\n  }";
// language=GraphQL
var CREATE_TRAVEL_EXTENSION_HIGHLIGHTS_MUTATION = "\n  mutation Mutation($input: createTravelExtensionHighlightsInput) {\n    createTravelExtensionHighlights(input: $input) {\n      id\n      highlightIds\n    }\n  }";
// language=GraphQL
var DELETE_TRAVEL_EXTENSION_HIGHLIGHTS_MUTATION = "\n  mutation Mutation($input: deleteTravelExtensionHighlightsInput) {\n    deleteTravelExtensionHighlights(input: $input) {\n      id\n      highlightIds\n    }\n  }";
// language=GraphQL
var UPDATE_TRAVEL_EXTENSION_HIGHLIGHTS_ORDER_MUTATION = "\n  mutation Mutation($input: updateTravelExtensionHighlightsOrderInput) {\n    updateTravelExtensionHighlightsOrder(input: $input) {\n      id\n      highlightIds\n    }\n  }";
// language=GraphQL
var TRAVEL_EXTENSIONS_DEPENDENTS_QUERY = "query Query($id: ID!, $withRatioTravelExtensions: Boolean = false, $withTravels: Boolean = false) {\n  groupedDependents: travelExtensionDependents(id: $id) {\n    ratioTravelExtensions @include(if: $withRatioTravelExtensions) {\n      id\n      label\n      info\n    }\n    travels @include(if: $withTravels) {\n      id\n      name\n      isBestseller\n      startDate\n      endDate\n      executionStatus\n      title\n      description\n      includedServices\n      excludedServices\n      pricingTable\n      priceCalculationInfo\n      programType\n      programText\n      minPrice\n      minPriceManualOverride\n      currency    }\n  }\n}";

// EXTERNAL MODULE: ./src/entities/travelHighlight/entity.ts + 3 modules
var entity = __webpack_require__(60328);
// EXTERNAL MODULE: ./src/entities/mediaFile/entity.ts + 3 modules
var mediaFile_entity = __webpack_require__(24180);
;// CONCATENATED MODULE: ./src/entities/travelExtension/model.ts



var travelExtensionModel = {
    name: "travelExtension",
    namePlural: "travelExtensions",
    uniqueName: "travelExtension",
    uniqueNamePlural: "travelExtensions",
    path: "travel/travel_extension",
    baseUrl: "/travel/travel_extensions",
    translationPrefix: "entities:travelExtension.",
    getDisplayName: function(values) {
        return values.name;
    },
    gql: {
        getAll: ALL_TRAVEL_EXTENSIONS_QUERY,
        getSingle: SINGLE_TRAVEL_EXTENSION_QUERY,
        create: CREATE_TRAVEL_EXTENSION_MUTATION,
        update: UPDATE_TRAVEL_EXTENSION_MUTATION,
        delete: DELETE_TRAVEL_EXTENSION_MUTATION,
        forceDelete: FORCE_DELETE_TRAVEL_EXTENSION_MUTATION
    },
    attributes: {
        duration: {
            name: "duration",
            label: "entities:travelExtension.attributes.duration.label",
            type: "value",
            dataType: "number",
            defaultInput: true,
            inputType: "text",
            validationType: "string",
            validations: [
                {
                    type: "required"
                }, 
            ]
        },
        name: {
            name: "name",
            label: "entities:travelExtension.attributes.name.label",
            type: "value",
            dataType: "string",
            defaultInput: true,
            inputType: "text",
            validationType: "string",
            validations: [
                {
                    type: "required"
                }, 
            ]
        },
        description: {
            name: "description",
            label: "entities:travelExtension.attributes.description.label",
            type: "value",
            dataType: "string",
            defaultInput: true,
            inputType: "wysiwyg",
            validationType: "string",
            validations: [
                {
                    type: "required"
                }, 
            ]
        },
        highlights: {
            name: "highlights",
            label: "entities:travelExtension.attributes.highlights.label",
            type: "entityCollection",
            dataType: "[any]",
            getEntity: function() {
                return entity/* default */.Z;
            },
            defaultInput: false,
            inputType: "text",
            validationType: "string",
            validations: []
        },
        image: {
            name: "image",
            label: "entities:travelExtension.attributes.image.label",
            type: "entityObject",
            dataType: "any",
            getEntity: function() {
                return mediaFile_entity/* default */.Z;
            },
            defaultInput: false,
            inputType: "select",
            validationType: "string",
            validations: []
        }
    }
};
/* harmony default export */ var model = (travelExtensionModel);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(20414);
// EXTERNAL MODULE: ./src/entities/lib.ts
var lib = __webpack_require__(23480);
// EXTERNAL MODULE: ./src/lib/api/graphQLClient.ts
var graphQLClient = __webpack_require__(40112);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/swr/dist/index.mjs
var dist = __webpack_require__(8100);
// EXTERNAL MODULE: ./src/lib/helpers/helpers.ts
var helpers = __webpack_require__(15778);
;// CONCATENATED MODULE: ./src/entities/travelExtension/repository.ts










var hydrateObjects = function(objects) {
    return objects.map(function(object) {
        return (0,lib/* hydrateEntityObject */.b)(model, object);
    });
};
var hydrateObject = function(object) {
    return (0,lib/* hydrateEntityObject */.b)(model, object);
};
var travelExtensionRepository = {
    getObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    id: id
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(SINGLE_TRAVEL_EXTENSION_QUERY, variables).then(function(data) {
                        return hydrateObject(data.travelExtension);
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }(),
    getObjects: /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        var includes;
        var _arguments = arguments;
        return (0,tslib_es6.__generator)(this, function(_state) {
            includes = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : {};
            return [
                2,
                graphQLClient/* default.request */.Z.request(ALL_TRAVEL_EXTENSIONS_QUERY, includes).then(function(data) {
                    return hydrateObjects(data.travelExtensions);
                })
            ];
        });
    }),
    useObject: function(id) {
        var includes = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        // eslint-disable-next-line react-hooks/exhaustive-deps
        var variables = (0,react.useMemo)(function() {
            return (0,_object_spread/* default */.Z)({
                id: id
            }, includes);
        }, [
            id
        ]);
        var ref = (0,dist/* default */.ZP)([
            SINGLE_TRAVEL_EXTENSION_QUERY,
            variables
        ], {
            revalidateOnFocus: false
        }), data = ref.data, error = ref.error, mutate = ref.mutate;
        return {
            object: !data ? data : hydrateObject(data.travelExtension),
            isLoading: !error && !data,
            isError: error,
            mutate: mutate
        };
    },
    useObjects: function() {
        var includes = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        // eslint-disable-next-line react-hooks/exhaustive-deps
        var variables = (0,react.useMemo)(function() {
            return includes;
        }, []);
        var ref = (0,dist/* default */.ZP)([
            ALL_TRAVEL_EXTENSIONS_QUERY,
            variables
        ]), data = ref.data, error = ref.error, mutate = ref.mutate;
        return {
            objects: !data ? data : hydrateObjects(data.travelExtensions),
            isLoading: !error && !data,
            isError: error,
            mutate: mutate
        };
    },
    getDependents: function(id, includes) {
        var includeVars = {};
        includes.forEach(function(include) {
            includeVars["with".concat((0,helpers/* uppercaseFirst */.AB)(include))] = true;
        });
        var variables = (0,_object_spread/* default */.Z)({
            id: id
        }, includeVars);
        return graphQLClient/* default.request */.Z.request(TRAVEL_EXTENSIONS_DEPENDENTS_QUERY, variables).then(function(data) {
            return data.groupedDependents;
        });
    },
    useDependents: function(id, includes) {
        var includeVars = {};
        includes.forEach(function(include) {
            includeVars["with".concat((0,helpers/* uppercaseFirst */.AB)(include))] = true;
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
        var variables = (0,react.useMemo)(function() {
            return (0,_object_spread/* default */.Z)({
                id: id
            }, includeVars);
        }, [
            id
        ]);
        var ref = (0,dist/* default */.ZP)([
            TRAVEL_EXTENSIONS_DEPENDENTS_QUERY,
            variables
        ], {
            revalidateOnFocus: false
        }), data = ref.data, error = ref.error, mutate = ref.mutate;
        return {
            data: !data ? data : data.groupedDependents,
            isLoading: !error && !data,
            isError: error,
            mutate: mutate
        };
    },
    createObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(data) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    input: data
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(CREATE_TRAVEL_EXTENSION_MUTATION, variables).then(function(data) {
                        return hydrateObject(data.travelExtension);
                    })
                ];
            });
        });
        return function(data) {
            return _ref.apply(this, arguments);
        };
    }(),
    updateObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(data) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    input: data
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(UPDATE_TRAVEL_EXTENSION_MUTATION, variables).then(function(data) {
                        return hydrateObject(data.travelExtension);
                    })
                ];
            });
        });
        return function(data) {
            return _ref.apply(this, arguments);
        };
    }(),
    deleteObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(DELETE_TRAVEL_EXTENSION_MUTATION, variables).then(function(data) {
                        return data.deleteTravelExtension;
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }(),
    forceDeleteObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(FORCE_DELETE_TRAVEL_EXTENSION_MUTATION, variables).then(function(data) {
                        return data.forceDeleteTravelExtension;
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }(),
    assignHighlights: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, itemIds) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        highlightIds: itemIds
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(ADD_TRAVEL_EXTENSION_HIGHLIGHTS_MUTATION, variables)
                ];
            });
        });
        return function(id, itemIds) {
            return _ref.apply(this, arguments);
        };
    }(),
    unassignHighlights: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, itemIds) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        highlightIds: itemIds
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(REMOVE_TRAVEL_EXTENSION_HIGHLIGHTS_MUTATION, variables)
                ];
            });
        });
        return function(id, itemIds) {
            return _ref.apply(this, arguments);
        };
    }(),
    createHighlights: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, items) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        highlights: items
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(CREATE_TRAVEL_EXTENSION_HIGHLIGHTS_MUTATION, variables)
                ];
            });
        });
        return function(id, items) {
            return _ref.apply(this, arguments);
        };
    }(),
    deleteHighlights: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, itemIds) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        highlightIds: itemIds
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(DELETE_TRAVEL_EXTENSION_HIGHLIGHTS_MUTATION, variables)
                ];
            });
        });
        return function(id, itemIds) {
            return _ref.apply(this, arguments);
        };
    }(),
    updateHighlightsOrder: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, itemIds) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        highlightIds: itemIds
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(UPDATE_TRAVEL_EXTENSION_HIGHLIGHTS_ORDER_MUTATION, variables)
                ];
            });
        });
        return function(id, itemIds) {
            return _ref.apply(this, arguments);
        };
    }()
};
/* harmony default export */ var repository = (travelExtensionRepository);

;// CONCATENATED MODULE: ./src/entities/travelExtension/entity.ts


var travelExtensionEntity = {
    model: model,
    repository: repository
};
/* harmony default export */ var travelExtension_entity = (travelExtensionEntity);


/***/ }),

/***/ 36687:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ travelGuide_entity; }
});

;// CONCATENATED MODULE: ./src/entities/travelGuide/graphql.ts
// language=GraphQL
var ALL_TRAVEL_GUIDES_QUERY = "query Query($withImage: Boolean = false) {\n  travelGuides: travelGuides {\n    id\n    firstName\n    lastName\n    description\n    image @include(if: $withImage) {\n      id\n      assetId\n      publicId\n      url\n      resourceType\n      format\n      width\n      height\n      caption\n      title\n      description\n    }\n  }\n}";
// language=GraphQL
var SINGLE_TRAVEL_GUIDE_QUERY = "query Query($id: ID!, $withImage: Boolean = false) {\n  travelGuide: travelGuide(id: $id) {\n    id\n    firstName\n    lastName\n    description\n    image @include(if: $withImage) {\n      id\n      assetId\n      publicId\n      url\n      resourceType\n      format\n      width\n      height\n      caption\n      title\n      description\n    }\n  }\n}";
// language=GraphQL
var CREATE_TRAVEL_GUIDE_MUTATION = "\n  mutation Mutation($input: CreateTravelGuideInput, $withImage: Boolean = false) {\n    travelGuide: createTravelGuide(input: $input) {\n      id\n      firstName\n      lastName\n      description\n      image @include(if: $withImage) {\n        id\n        assetId\n        publicId\n        url\n        resourceType\n        format\n        width\n        height\n        caption\n        title\n        description\n      }\n    }\n  }";
// language=GraphQL
var UPDATE_TRAVEL_GUIDE_MUTATION = "\n  mutation Mutation($input: UpdateTravelGuideInput, $withImage: Boolean = false) {\n    travelGuide: updateTravelGuide(input: $input) {\n      id\n      firstName\n      lastName\n      description\n      image @include(if: $withImage) {\n        id\n        assetId\n        publicId\n        url\n        resourceType\n        format\n        width\n        height\n        caption\n        title\n        description\n      }\n    }\n  }";
// language=GraphQL
var DELETE_TRAVEL_GUIDE_MUTATION = "\n  mutation Mutation($input: DeleteTravelGuideInput) {\n    deleteTravelGuide(input: $input) {\n      success\n    }\n  }";
// language=GraphQL
var FORCE_DELETE_TRAVEL_GUIDE_MUTATION = "\n  mutation Mutation($input: DeleteTravelGuideInput) {\n    forceDeleteTravelGuide(input: $input) {\n      success\n    }\n  }";
// language=GraphQL
var TRAVEL_GUIDES_DEPENDENTS_QUERY = "query Query($id: ID!, $withTravelTeams: Boolean = false, $withTravels: Boolean = false, $withCmsTravelGuidesBlocks: Boolean = false) {\n  groupedDependents: travelGuideDependents(id: $id) {\n    travelTeams @include(if: $withTravelTeams) {\n      id\n      name\n    }\n    travels @include(if: $withTravels) {\n      id\n      name\n      isBestseller\n      startDate\n      endDate\n      executionStatus\n      title\n      description\n      includedServices\n      excludedServices\n      pricingTable\n      priceCalculationInfo\n      programType\n      programText\n      minPrice\n      minPriceManualOverride\n      currency    }\n    cmsTravelGuidesBlocks @include(if: $withCmsTravelGuidesBlocks) {\n      id\n    }\n  }\n}";

// EXTERNAL MODULE: ./src/entities/mediaFile/entity.ts + 3 modules
var entity = __webpack_require__(24180);
;// CONCATENATED MODULE: ./src/entities/travelGuide/model.ts


var travelGuideModel = {
    name: "travelGuide",
    namePlural: "travelGuides",
    uniqueName: "travelGuide",
    uniqueNamePlural: "travelGuides",
    path: "travel/travel_guide",
    baseUrl: "/travel/travel-guides",
    translationPrefix: "entities:travelGuide.",
    getDisplayName: function(values) {
        return "".concat(values.firstName, " ").concat(values.lastName);
    },
    gql: {
        getAll: ALL_TRAVEL_GUIDES_QUERY,
        getSingle: SINGLE_TRAVEL_GUIDE_QUERY,
        create: CREATE_TRAVEL_GUIDE_MUTATION,
        update: UPDATE_TRAVEL_GUIDE_MUTATION,
        delete: DELETE_TRAVEL_GUIDE_MUTATION,
        forceDelete: FORCE_DELETE_TRAVEL_GUIDE_MUTATION
    },
    attributes: {
        firstName: {
            name: "firstName",
            label: "entities:travelGuide.attributes.firstName.label",
            type: "value",
            dataType: "string",
            defaultInput: true,
            inputType: "text",
            validationType: "string",
            validations: [
                {
                    type: "required"
                }, 
            ]
        },
        lastName: {
            name: "lastName",
            label: "entities:travelGuide.attributes.lastName.label",
            type: "value",
            dataType: "string",
            defaultInput: true,
            inputType: "text",
            validationType: "string",
            validations: [
                {
                    type: "required"
                }, 
            ]
        },
        description: {
            name: "description",
            label: "entities:travelGuide.attributes.description.label",
            type: "value",
            dataType: "string",
            defaultInput: true,
            inputType: "wysiwyg",
            validationType: "string",
            validations: [
                {
                    type: "required"
                }, 
            ]
        },
        image: {
            name: "image",
            label: "entities:travelGuide.attributes.image.label",
            type: "entityObject",
            dataType: "any",
            getEntity: function() {
                return entity/* default */.Z;
            },
            defaultInput: false,
            inputType: "select",
            validationType: "string",
            validations: []
        }
    }
};
/* harmony default export */ var model = (travelGuideModel);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(20414);
// EXTERNAL MODULE: ./src/entities/lib.ts
var lib = __webpack_require__(23480);
// EXTERNAL MODULE: ./src/lib/api/graphQLClient.ts
var graphQLClient = __webpack_require__(40112);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/swr/dist/index.mjs
var dist = __webpack_require__(8100);
// EXTERNAL MODULE: ./src/lib/helpers/helpers.ts
var helpers = __webpack_require__(15778);
;// CONCATENATED MODULE: ./src/entities/travelGuide/repository.ts










var hydrateObjects = function(objects) {
    return objects.map(function(object) {
        return (0,lib/* hydrateEntityObject */.b)(model, object);
    });
};
var hydrateObject = function(object) {
    return (0,lib/* hydrateEntityObject */.b)(model, object);
};
var travelGuideRepository = {
    getObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    id: id
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(SINGLE_TRAVEL_GUIDE_QUERY, variables).then(function(data) {
                        return hydrateObject(data.travelGuide);
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }(),
    getObjects: /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        var includes;
        var _arguments = arguments;
        return (0,tslib_es6.__generator)(this, function(_state) {
            includes = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : {};
            return [
                2,
                graphQLClient/* default.request */.Z.request(ALL_TRAVEL_GUIDES_QUERY, includes).then(function(data) {
                    return hydrateObjects(data.travelGuides);
                })
            ];
        });
    }),
    useObject: function(id) {
        var includes = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        // eslint-disable-next-line react-hooks/exhaustive-deps
        var variables = (0,react.useMemo)(function() {
            return (0,_object_spread/* default */.Z)({
                id: id
            }, includes);
        }, [
            id
        ]);
        var ref = (0,dist/* default */.ZP)([
            SINGLE_TRAVEL_GUIDE_QUERY,
            variables
        ], {
            revalidateOnFocus: false
        }), data = ref.data, error = ref.error, mutate = ref.mutate;
        return {
            object: !data ? data : hydrateObject(data.travelGuide),
            isLoading: !error && !data,
            isError: error,
            mutate: mutate
        };
    },
    useObjects: function() {
        var includes = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        // eslint-disable-next-line react-hooks/exhaustive-deps
        var variables = (0,react.useMemo)(function() {
            return includes;
        }, []);
        var ref = (0,dist/* default */.ZP)([
            ALL_TRAVEL_GUIDES_QUERY,
            variables
        ]), data = ref.data, error = ref.error, mutate = ref.mutate;
        return {
            objects: !data ? data : hydrateObjects(data.travelGuides),
            isLoading: !error && !data,
            isError: error,
            mutate: mutate
        };
    },
    getDependents: function(id, includes) {
        var includeVars = {};
        includes.forEach(function(include) {
            includeVars["with".concat((0,helpers/* uppercaseFirst */.AB)(include))] = true;
        });
        var variables = (0,_object_spread/* default */.Z)({
            id: id
        }, includeVars);
        return graphQLClient/* default.request */.Z.request(TRAVEL_GUIDES_DEPENDENTS_QUERY, variables).then(function(data) {
            return data.groupedDependents;
        });
    },
    useDependents: function(id, includes) {
        var includeVars = {};
        includes.forEach(function(include) {
            includeVars["with".concat((0,helpers/* uppercaseFirst */.AB)(include))] = true;
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
        var variables = (0,react.useMemo)(function() {
            return (0,_object_spread/* default */.Z)({
                id: id
            }, includeVars);
        }, [
            id
        ]);
        var ref = (0,dist/* default */.ZP)([
            TRAVEL_GUIDES_DEPENDENTS_QUERY,
            variables
        ], {
            revalidateOnFocus: false
        }), data = ref.data, error = ref.error, mutate = ref.mutate;
        return {
            data: !data ? data : data.groupedDependents,
            isLoading: !error && !data,
            isError: error,
            mutate: mutate
        };
    },
    createObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(data) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    input: data
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(CREATE_TRAVEL_GUIDE_MUTATION, variables).then(function(data) {
                        return hydrateObject(data.travelGuide);
                    })
                ];
            });
        });
        return function(data) {
            return _ref.apply(this, arguments);
        };
    }(),
    updateObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(data) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    input: data
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(UPDATE_TRAVEL_GUIDE_MUTATION, variables).then(function(data) {
                        return hydrateObject(data.travelGuide);
                    })
                ];
            });
        });
        return function(data) {
            return _ref.apply(this, arguments);
        };
    }(),
    deleteObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(DELETE_TRAVEL_GUIDE_MUTATION, variables).then(function(data) {
                        return data.deleteTravelGuide;
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }(),
    forceDeleteObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(FORCE_DELETE_TRAVEL_GUIDE_MUTATION, variables).then(function(data) {
                        return data.forceDeleteTravelGuide;
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }()
};
/* harmony default export */ var repository = (travelGuideRepository);

;// CONCATENATED MODULE: ./src/entities/travelGuide/entity.ts


var travelGuideEntity = {
    model: model,
    repository: repository
};
/* harmony default export */ var travelGuide_entity = (travelGuideEntity);


/***/ }),

/***/ 60328:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ entity; }
});

;// CONCATENATED MODULE: ./src/entities/travelHighlight/graphql.ts
// language=GraphQL
var ALL_HIGHLIGHTS_QUERY = "query Query {\n  highlights: travelHighlights {\n    id\n    text\n  }\n}";
// language=GraphQL
var SINGLE_HIGHLIGHT_QUERY = "query Query($id: ID!) {\n  highlight: travelHighlight(id: $id) {\n    id\n    text\n  }\n}";
// language=GraphQL
var CREATE_HIGHLIGHT_MUTATION = "\n  mutation Mutation($input: CreateTravelHighlightInput) {\n    highlight: createTravelHighlight(input: $input) {\n      id\n      text\n    }\n  }";
// language=GraphQL
var UPDATE_HIGHLIGHT_MUTATION = "\n  mutation Mutation($input: UpdateTravelHighlightInput) {\n    highlight: updateTravelHighlight(input: $input) {\n      id\n      text\n    }\n  }";
// language=GraphQL
var DELETE_HIGHLIGHT_MUTATION = "\n  mutation Mutation($input: DeleteTravelHighlightInput) {\n    deleteTravelHighlight(input: $input) {\n      success\n    }\n  }";
// language=GraphQL
var FORCE_DELETE_HIGHLIGHT_MUTATION = "\n  mutation Mutation($input: DeleteTravelHighlightInput) {\n    forceDeleteTravelHighlight(input: $input) {\n      success\n    }\n  }";
// language=GraphQL
var HIGHLIGHTS_DEPENDENTS_QUERY = "query Query($id: ID!, $withTravels: Boolean = false, $withTravelExtensions: Boolean = false) {\n  groupedDependents: travelHighlightDependents(id: $id) {\n    travels @include(if: $withTravels) {\n      id\n      name\n      isBestseller\n      startDate\n      endDate\n      executionStatus\n      title\n      description\n      includedServices\n      excludedServices\n      pricingTable\n      priceCalculationInfo\n      programType\n      programText\n      minPrice\n      minPriceManualOverride\n      currency    }\n    travelExtensions @include(if: $withTravelExtensions) {\n      id\n      duration\n      name\n      description\n    }\n  }\n}";

;// CONCATENATED MODULE: ./src/entities/travelHighlight/model.ts

var travelHighlightModel = {
    name: "highlight",
    namePlural: "highlights",
    uniqueName: "travelHighlight",
    uniqueNamePlural: "travelHighlights",
    path: "travel/highlight",
    baseUrl: "/travel/highlights",
    translationPrefix: "entities:travelHighlight.",
    getDisplayName: function(values) {
        return values.text;
    },
    gql: {
        getAll: ALL_HIGHLIGHTS_QUERY,
        getSingle: SINGLE_HIGHLIGHT_QUERY,
        create: CREATE_HIGHLIGHT_MUTATION,
        update: UPDATE_HIGHLIGHT_MUTATION,
        delete: DELETE_HIGHLIGHT_MUTATION,
        forceDelete: FORCE_DELETE_HIGHLIGHT_MUTATION
    },
    attributes: {
        text: {
            name: "text",
            label: "entities:travelHighlight.attributes.text.label",
            type: "value",
            dataType: "string",
            defaultInput: true,
            inputType: "text",
            validationType: "string",
            validations: [
                {
                    type: "required"
                }, 
            ]
        }
    }
};
/* harmony default export */ var model = (travelHighlightModel);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(20414);
// EXTERNAL MODULE: ./src/entities/lib.ts
var lib = __webpack_require__(23480);
// EXTERNAL MODULE: ./src/lib/api/graphQLClient.ts
var graphQLClient = __webpack_require__(40112);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/swr/dist/index.mjs
var dist = __webpack_require__(8100);
// EXTERNAL MODULE: ./src/lib/helpers/helpers.ts
var helpers = __webpack_require__(15778);
;// CONCATENATED MODULE: ./src/entities/travelHighlight/repository.ts










var hydrateObjects = function(objects) {
    return objects.map(function(object) {
        return (0,lib/* hydrateEntityObject */.b)(model, object);
    });
};
var hydrateObject = function(object) {
    return (0,lib/* hydrateEntityObject */.b)(model, object);
};
var travelHighlightRepository = {
    getObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    id: id
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(SINGLE_HIGHLIGHT_QUERY, variables).then(function(data) {
                        return hydrateObject(data.highlight);
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }(),
    getObjects: /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        var includes;
        var _arguments = arguments;
        return (0,tslib_es6.__generator)(this, function(_state) {
            includes = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : {};
            return [
                2,
                graphQLClient/* default.request */.Z.request(ALL_HIGHLIGHTS_QUERY, includes).then(function(data) {
                    return hydrateObjects(data.highlights);
                })
            ];
        });
    }),
    useObject: function(id) {
        var includes = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        // eslint-disable-next-line react-hooks/exhaustive-deps
        var variables = (0,react.useMemo)(function() {
            return (0,_object_spread/* default */.Z)({
                id: id
            }, includes);
        }, [
            id
        ]);
        var ref = (0,dist/* default */.ZP)([
            SINGLE_HIGHLIGHT_QUERY,
            variables
        ], {
            revalidateOnFocus: false
        }), data = ref.data, error = ref.error, mutate = ref.mutate;
        return {
            object: !data ? data : hydrateObject(data.highlight),
            isLoading: !error && !data,
            isError: error,
            mutate: mutate
        };
    },
    useObjects: function() {
        var includes = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        // eslint-disable-next-line react-hooks/exhaustive-deps
        var variables = (0,react.useMemo)(function() {
            return includes;
        }, []);
        var ref = (0,dist/* default */.ZP)([
            ALL_HIGHLIGHTS_QUERY,
            variables
        ]), data = ref.data, error = ref.error, mutate = ref.mutate;
        return {
            objects: !data ? data : hydrateObjects(data.highlights),
            isLoading: !error && !data,
            isError: error,
            mutate: mutate
        };
    },
    getDependents: function(id, includes) {
        var includeVars = {};
        includes.forEach(function(include) {
            includeVars["with".concat((0,helpers/* uppercaseFirst */.AB)(include))] = true;
        });
        var variables = (0,_object_spread/* default */.Z)({
            id: id
        }, includeVars);
        return graphQLClient/* default.request */.Z.request(HIGHLIGHTS_DEPENDENTS_QUERY, variables).then(function(data) {
            return data.groupedDependents;
        });
    },
    useDependents: function(id, includes) {
        var includeVars = {};
        includes.forEach(function(include) {
            includeVars["with".concat((0,helpers/* uppercaseFirst */.AB)(include))] = true;
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
        var variables = (0,react.useMemo)(function() {
            return (0,_object_spread/* default */.Z)({
                id: id
            }, includeVars);
        }, [
            id
        ]);
        var ref = (0,dist/* default */.ZP)([
            HIGHLIGHTS_DEPENDENTS_QUERY,
            variables
        ], {
            revalidateOnFocus: false
        }), data = ref.data, error = ref.error, mutate = ref.mutate;
        return {
            data: !data ? data : data.groupedDependents,
            isLoading: !error && !data,
            isError: error,
            mutate: mutate
        };
    },
    createObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(data) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    input: data
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(CREATE_HIGHLIGHT_MUTATION, variables).then(function(data) {
                        return hydrateObject(data.highlight);
                    })
                ];
            });
        });
        return function(data) {
            return _ref.apply(this, arguments);
        };
    }(),
    updateObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(data) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    input: data
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(UPDATE_HIGHLIGHT_MUTATION, variables).then(function(data) {
                        return hydrateObject(data.highlight);
                    })
                ];
            });
        });
        return function(data) {
            return _ref.apply(this, arguments);
        };
    }(),
    deleteObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(DELETE_HIGHLIGHT_MUTATION, variables).then(function(data) {
                        return data.deleteTravelHighlight;
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }(),
    forceDeleteObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(FORCE_DELETE_HIGHLIGHT_MUTATION, variables).then(function(data) {
                        return data.forceDeleteTravelHighlight;
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }()
};
/* harmony default export */ var repository = (travelHighlightRepository);

;// CONCATENATED MODULE: ./src/entities/travelHighlight/entity.ts


var travelHighlightEntity = {
    model: model,
    repository: repository
};
/* harmony default export */ var entity = (travelHighlightEntity);


/***/ }),

/***/ 46714:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ entity; }
});

;// CONCATENATED MODULE: ./src/entities/travelLabel/graphql.ts
// language=GraphQL
var ALL_LABELS_QUERY = "query Query {\n  labels: travelLabels {\n    id\n    label\n  }\n}";
// language=GraphQL
var SINGLE_LABEL_QUERY = "query Query($id: ID!) {\n  label: travelLabel(id: $id) {\n    id\n    label\n  }\n}";
// language=GraphQL
var CREATE_LABEL_MUTATION = "\n  mutation Mutation($input: CreateTravelLabelInput) {\n    label: createTravelLabel(input: $input) {\n      id\n      label\n    }\n  }";
// language=GraphQL
var UPDATE_LABEL_MUTATION = "\n  mutation Mutation($input: UpdateTravelLabelInput) {\n    label: updateTravelLabel(input: $input) {\n      id\n      label\n    }\n  }";
// language=GraphQL
var DELETE_LABEL_MUTATION = "\n  mutation Mutation($input: DeleteTravelLabelInput) {\n    deleteTravelLabel(input: $input) {\n      success\n    }\n  }";
// language=GraphQL
var FORCE_DELETE_LABEL_MUTATION = "\n  mutation Mutation($input: DeleteTravelLabelInput) {\n    forceDeleteTravelLabel(input: $input) {\n      success\n    }\n  }";
// language=GraphQL
var LABELS_DEPENDENTS_QUERY = "query Query($id: ID!, $withTravels: Boolean = false) {\n  groupedDependents: travelLabelDependents(id: $id) {\n    travels @include(if: $withTravels) {\n      id\n      name\n      isBestseller\n      startDate\n      endDate\n      executionStatus\n      title\n      description\n      includedServices\n      excludedServices\n      pricingTable\n      priceCalculationInfo\n      programType\n      programText\n      minPrice\n      minPriceManualOverride\n      currency    }\n  }\n}";

;// CONCATENATED MODULE: ./src/entities/travelLabel/model.ts

var travelLabelModel = {
    name: "label",
    namePlural: "labels",
    uniqueName: "travelLabel",
    uniqueNamePlural: "travelLabels",
    path: "travel/label",
    baseUrl: "/travel/labels",
    translationPrefix: "entities:travelLabel.",
    getDisplayName: function(values) {
        return values.label;
    },
    gql: {
        getAll: ALL_LABELS_QUERY,
        getSingle: SINGLE_LABEL_QUERY,
        create: CREATE_LABEL_MUTATION,
        update: UPDATE_LABEL_MUTATION,
        delete: DELETE_LABEL_MUTATION,
        forceDelete: FORCE_DELETE_LABEL_MUTATION
    },
    attributes: {
        label: {
            name: "label",
            label: "entities:travelLabel.attributes.label.label",
            type: "value",
            dataType: "string",
            defaultInput: true,
            inputType: "text",
            validationType: "string",
            validations: [
                {
                    type: "required"
                }, 
            ]
        }
    }
};
/* harmony default export */ var model = (travelLabelModel);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(20414);
// EXTERNAL MODULE: ./src/entities/lib.ts
var lib = __webpack_require__(23480);
// EXTERNAL MODULE: ./src/lib/api/graphQLClient.ts
var graphQLClient = __webpack_require__(40112);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/swr/dist/index.mjs
var dist = __webpack_require__(8100);
// EXTERNAL MODULE: ./src/lib/helpers/helpers.ts
var helpers = __webpack_require__(15778);
;// CONCATENATED MODULE: ./src/entities/travelLabel/repository.ts










var hydrateObjects = function(objects) {
    return objects.map(function(object) {
        return (0,lib/* hydrateEntityObject */.b)(model, object);
    });
};
var hydrateObject = function(object) {
    return (0,lib/* hydrateEntityObject */.b)(model, object);
};
var travelLabelRepository = {
    getObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    id: id
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(SINGLE_LABEL_QUERY, variables).then(function(data) {
                        return hydrateObject(data.label);
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }(),
    getObjects: /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        var includes;
        var _arguments = arguments;
        return (0,tslib_es6.__generator)(this, function(_state) {
            includes = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : {};
            return [
                2,
                graphQLClient/* default.request */.Z.request(ALL_LABELS_QUERY, includes).then(function(data) {
                    return hydrateObjects(data.labels);
                })
            ];
        });
    }),
    useObject: function(id) {
        var includes = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        // eslint-disable-next-line react-hooks/exhaustive-deps
        var variables = (0,react.useMemo)(function() {
            return (0,_object_spread/* default */.Z)({
                id: id
            }, includes);
        }, [
            id
        ]);
        var ref = (0,dist/* default */.ZP)([
            SINGLE_LABEL_QUERY,
            variables
        ], {
            revalidateOnFocus: false
        }), data = ref.data, error = ref.error, mutate = ref.mutate;
        return {
            object: !data ? data : hydrateObject(data.label),
            isLoading: !error && !data,
            isError: error,
            mutate: mutate
        };
    },
    useObjects: function() {
        var includes = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        // eslint-disable-next-line react-hooks/exhaustive-deps
        var variables = (0,react.useMemo)(function() {
            return includes;
        }, []);
        var ref = (0,dist/* default */.ZP)([
            ALL_LABELS_QUERY,
            variables
        ]), data = ref.data, error = ref.error, mutate = ref.mutate;
        return {
            objects: !data ? data : hydrateObjects(data.labels),
            isLoading: !error && !data,
            isError: error,
            mutate: mutate
        };
    },
    getDependents: function(id, includes) {
        var includeVars = {};
        includes.forEach(function(include) {
            includeVars["with".concat((0,helpers/* uppercaseFirst */.AB)(include))] = true;
        });
        var variables = (0,_object_spread/* default */.Z)({
            id: id
        }, includeVars);
        return graphQLClient/* default.request */.Z.request(LABELS_DEPENDENTS_QUERY, variables).then(function(data) {
            return data.groupedDependents;
        });
    },
    useDependents: function(id, includes) {
        var includeVars = {};
        includes.forEach(function(include) {
            includeVars["with".concat((0,helpers/* uppercaseFirst */.AB)(include))] = true;
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
        var variables = (0,react.useMemo)(function() {
            return (0,_object_spread/* default */.Z)({
                id: id
            }, includeVars);
        }, [
            id
        ]);
        var ref = (0,dist/* default */.ZP)([
            LABELS_DEPENDENTS_QUERY,
            variables
        ], {
            revalidateOnFocus: false
        }), data = ref.data, error = ref.error, mutate = ref.mutate;
        return {
            data: !data ? data : data.groupedDependents,
            isLoading: !error && !data,
            isError: error,
            mutate: mutate
        };
    },
    createObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(data) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    input: data
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(CREATE_LABEL_MUTATION, variables).then(function(data) {
                        return hydrateObject(data.label);
                    })
                ];
            });
        });
        return function(data) {
            return _ref.apply(this, arguments);
        };
    }(),
    updateObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(data) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    input: data
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(UPDATE_LABEL_MUTATION, variables).then(function(data) {
                        return hydrateObject(data.label);
                    })
                ];
            });
        });
        return function(data) {
            return _ref.apply(this, arguments);
        };
    }(),
    deleteObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(DELETE_LABEL_MUTATION, variables).then(function(data) {
                        return data.deleteTravelLabel;
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }(),
    forceDeleteObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(FORCE_DELETE_LABEL_MUTATION, variables).then(function(data) {
                        return data.forceDeleteTravelLabel;
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }()
};
/* harmony default export */ var repository = (travelLabelRepository);

;// CONCATENATED MODULE: ./src/entities/travelLabel/entity.ts


var travelLabelEntity = {
    model: model,
    repository: repository
};
/* harmony default export */ var entity = (travelLabelEntity);


/***/ }),

/***/ 91687:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ travelObjectTenantSettings_entity; }
});

;// CONCATENATED MODULE: ./src/entities/travelObjectTenantSettings/graphql.ts
// language=GraphQL
var ALL_TENANT_SETTINGS_QUERY = "query Query($withTenant: Boolean = false, $withTenantCms: Boolean = false, $withTenantCmsHomepage: Boolean = false, $withTenantCmsCategories: Boolean = false, $withTenantCmsPages: Boolean = false, $withTenantCmsErrorPage404: Boolean = false, $withTenantCmsErrorPage500: Boolean = false, $withTenantCmsConfig: Boolean = false, $withTenantTravelTypes: Boolean = false, $withTenantTravelTypesImage: Boolean = false, $withTenantEmployees: Boolean = false, $withTenantEmployeesImage: Boolean = false, $withTenantEmailConfig: Boolean = false, $withTenantNewsletterProvider: Boolean = false, $withTenantNewsletterProviderConfig: Boolean = false, $withTenantRedirects: Boolean = false, $withTenantRedirectsFromPage: Boolean = false, $withTenantRedirectsFromTravel: Boolean = false, $withTenantRedirectsToPage: Boolean = false, $withTenantRedirectsToTravel: Boolean = false, $withTenantOnlinePaymentConfig: Boolean = false, $withTenantRatioConfig: Boolean = false, $withTenantContent: Boolean = false, $withTenantPartnerTenants: Boolean = false, $withTenantPartnerTenantsTenant: Boolean = false, $withTravelTypes: Boolean = false, $withTravelTypesImage: Boolean = false) {\n  tenantSettings: allTravelObjectTenantSettings {\n    id\n    tenant @include(if: $withTenant) {\n      id\n      name\n      slug\n      domain\n      externalReference\n      cms @include(if: $withTenantCms) {\n        id\n        homepage @include(if: $withTenantCmsHomepage) {\n          id\n          name\n          onlineStatus\n        }\n        categories @include(if: $withTenantCmsCategories) {\n          id\n          name\n        }\n        pages @include(if: $withTenantCmsPages) {\n          id\n          name\n          onlineStatus\n        }\n        errorPage404 @include(if: $withTenantCmsErrorPage404) {\n          id\n          name\n          onlineStatus\n        }\n        errorPage500 @include(if: $withTenantCmsErrorPage500) {\n          id\n          name\n          onlineStatus\n        }\n        config @include(if: $withTenantCmsConfig) {\n          id\n        }\n      }\n      travelTypes @include(if: $withTenantTravelTypes) {\n        id\n        name\n        description\n        image @include(if: $withTenantTravelTypesImage) {\n          id\n          assetId\n          publicId\n          url\n          resourceType\n          format\n          width\n          height\n          caption\n          title\n          description\n        }\n      }\n      employees @include(if: $withTenantEmployees) {\n        id\n        firstName\n        lastName\n        jobTitle\n        description\n        email\n        image @include(if: $withTenantEmployeesImage) {\n          id\n          assetId\n          publicId\n          url\n          resourceType\n          format\n          width\n          height\n          caption\n          title\n          description\n        }\n        phone\n      }\n      emailConfig @include(if: $withTenantEmailConfig) {\n        id\n        defaultInternalRecipientEmail\n        internalBookingRecipientEmails\n        bookingConfirmationTemplateId\n        bookingConfirmationInternalTemplateId\n        bookingRequestConfirmationTemplateId\n        bookingWaitlistConfirmationTemplateId\n        bookingWaitlistContingentCheckConfirmationTemplateId\n        bookingCustomRequestTemplateId\n        bookingPassportDataReminderTemplateId\n        contactFormTemplateId\n        esimInstallationInfoTemplateId\n      }\n      newsletterProvider @include(if: $withTenantNewsletterProvider) {\n        id\n        provider\n        config @include(if: $withTenantNewsletterProviderConfig) {\n          __typename\n          ... on MailchimpConfig {\n            id\n            apiKey\n            serverPrefix\n            listId\n\n          }\n        }\n      }\n      redirects @include(if: $withTenantRedirects) {\n        id\n        fromType\n        fromUrl\n        fromPage @include(if: $withTenantRedirectsFromPage) {\n          id\n          name\n          onlineStatus\n        }\n        fromTravel @include(if: $withTenantRedirectsFromTravel) {\n          id\n          name\n          isBestseller\n          startDate\n          endDate\n          executionStatus\n          title\n          description\n          includedServices\n          excludedServices\n          pricingTable\n          priceCalculationInfo\n          programType\n          programText\n          minPrice\n          minPriceManualOverride\n          currency\n        }\n        toType\n        toUrl\n        toPage @include(if: $withTenantRedirectsToPage) {\n          id\n          name\n          onlineStatus\n        }\n        toTravel @include(if: $withTenantRedirectsToTravel) {\n          id\n          name\n          isBestseller\n          startDate\n          endDate\n          executionStatus\n          title\n          description\n          includedServices\n          excludedServices\n          pricingTable\n          priceCalculationInfo\n          programType\n          programText\n          minPrice\n          minPriceManualOverride\n          currency\n        }\n      }\n      onlinePaymentConfig @include(if: $withTenantOnlinePaymentConfig) {\n        id\n        enabled\n        ratioFibuAccountNo\n        infoText\n        datatransThemeConfig\n      }\n      ratioConfig @include(if: $withTenantRatioConfig) {\n        id\n        adressgruppe\n      }\n      content @include(if: $withTenantContent) {\n        id\n        bookingInsuranceInfo\n      }\n      partnerTenants @include(if: $withTenantPartnerTenants) {\n        id\n        tenant @include(if: $withTenantPartnerTenantsTenant) {\n          id\n          name\n          slug\n          domain\n          externalReference\n        }\n        filterCrossLinking\n      }\n    }\n    onlineStatus\n    redirectToBooking\n    useTiming\n    startDate\n    endDate\n    travelTypes @include(if: $withTravelTypes) {\n      id\n      name\n      description\n      image @include(if: $withTravelTypesImage) {\n        id\n        assetId\n        publicId\n        url\n        resourceType\n        format\n        width\n        height\n        caption\n        title\n        description\n      }\n    }\n  }\n}";
// language=GraphQL
var SINGLE_TENANT_SETTINGS_QUERY = "query Query($id: ID!, $withTenant: Boolean = false, $withTenantCms: Boolean = false, $withTenantCmsHomepage: Boolean = false, $withTenantCmsCategories: Boolean = false, $withTenantCmsPages: Boolean = false, $withTenantCmsErrorPage404: Boolean = false, $withTenantCmsErrorPage500: Boolean = false, $withTenantCmsConfig: Boolean = false, $withTenantTravelTypes: Boolean = false, $withTenantTravelTypesImage: Boolean = false, $withTenantEmployees: Boolean = false, $withTenantEmployeesImage: Boolean = false, $withTenantEmailConfig: Boolean = false, $withTenantNewsletterProvider: Boolean = false, $withTenantNewsletterProviderConfig: Boolean = false, $withTenantRedirects: Boolean = false, $withTenantRedirectsFromPage: Boolean = false, $withTenantRedirectsFromTravel: Boolean = false, $withTenantRedirectsToPage: Boolean = false, $withTenantRedirectsToTravel: Boolean = false, $withTenantOnlinePaymentConfig: Boolean = false, $withTenantRatioConfig: Boolean = false, $withTenantContent: Boolean = false, $withTenantPartnerTenants: Boolean = false, $withTenantPartnerTenantsTenant: Boolean = false, $withTravelTypes: Boolean = false, $withTravelTypesImage: Boolean = false) {\n  tenantSettings: travelObjectTenantSettings(id: $id) {\n    id\n    tenant @include(if: $withTenant) {\n      id\n      name\n      slug\n      domain\n      externalReference\n      cms @include(if: $withTenantCms) {\n        id\n        homepage @include(if: $withTenantCmsHomepage) {\n          id\n          name\n          onlineStatus\n        }\n        categories @include(if: $withTenantCmsCategories) {\n          id\n          name\n        }\n        pages @include(if: $withTenantCmsPages) {\n          id\n          name\n          onlineStatus\n        }\n        errorPage404 @include(if: $withTenantCmsErrorPage404) {\n          id\n          name\n          onlineStatus\n        }\n        errorPage500 @include(if: $withTenantCmsErrorPage500) {\n          id\n          name\n          onlineStatus\n        }\n        config @include(if: $withTenantCmsConfig) {\n          id\n        }\n      }\n      travelTypes @include(if: $withTenantTravelTypes) {\n        id\n        name\n        description\n        image @include(if: $withTenantTravelTypesImage) {\n          id\n          assetId\n          publicId\n          url\n          resourceType\n          format\n          width\n          height\n          caption\n          title\n          description\n        }\n      }\n      employees @include(if: $withTenantEmployees) {\n        id\n        firstName\n        lastName\n        jobTitle\n        description\n        email\n        image @include(if: $withTenantEmployeesImage) {\n          id\n          assetId\n          publicId\n          url\n          resourceType\n          format\n          width\n          height\n          caption\n          title\n          description\n        }\n        phone\n      }\n      emailConfig @include(if: $withTenantEmailConfig) {\n        id\n        defaultInternalRecipientEmail\n        internalBookingRecipientEmails\n        bookingConfirmationTemplateId\n        bookingConfirmationInternalTemplateId\n        bookingRequestConfirmationTemplateId\n        bookingWaitlistConfirmationTemplateId\n        bookingWaitlistContingentCheckConfirmationTemplateId\n        bookingCustomRequestTemplateId\n        bookingPassportDataReminderTemplateId\n        contactFormTemplateId\n        esimInstallationInfoTemplateId\n      }\n      newsletterProvider @include(if: $withTenantNewsletterProvider) {\n        id\n        provider\n        config @include(if: $withTenantNewsletterProviderConfig) {\n          __typename\n          ... on MailchimpConfig {\n            id\n            apiKey\n            serverPrefix\n            listId\n\n          }\n        }\n      }\n      redirects @include(if: $withTenantRedirects) {\n        id\n        fromType\n        fromUrl\n        fromPage @include(if: $withTenantRedirectsFromPage) {\n          id\n          name\n          onlineStatus\n        }\n        fromTravel @include(if: $withTenantRedirectsFromTravel) {\n          id\n          name\n          isBestseller\n          startDate\n          endDate\n          executionStatus\n          title\n          description\n          includedServices\n          excludedServices\n          pricingTable\n          priceCalculationInfo\n          programType\n          programText\n          minPrice\n          minPriceManualOverride\n          currency\n        }\n        toType\n        toUrl\n        toPage @include(if: $withTenantRedirectsToPage) {\n          id\n          name\n          onlineStatus\n        }\n        toTravel @include(if: $withTenantRedirectsToTravel) {\n          id\n          name\n          isBestseller\n          startDate\n          endDate\n          executionStatus\n          title\n          description\n          includedServices\n          excludedServices\n          pricingTable\n          priceCalculationInfo\n          programType\n          programText\n          minPrice\n          minPriceManualOverride\n          currency\n        }\n      }\n      onlinePaymentConfig @include(if: $withTenantOnlinePaymentConfig) {\n        id\n        enabled\n        ratioFibuAccountNo\n        infoText\n        datatransThemeConfig\n      }\n      ratioConfig @include(if: $withTenantRatioConfig) {\n        id\n        adressgruppe\n      }\n      content @include(if: $withTenantContent) {\n        id\n        bookingInsuranceInfo\n      }\n      partnerTenants @include(if: $withTenantPartnerTenants) {\n        id\n        tenant @include(if: $withTenantPartnerTenantsTenant) {\n          id\n          name\n          slug\n          domain\n          externalReference\n        }\n        filterCrossLinking\n      }\n    }\n    onlineStatus\n    redirectToBooking\n    useTiming\n    startDate\n    endDate\n    travelTypes @include(if: $withTravelTypes) {\n      id\n      name\n      description\n      image @include(if: $withTravelTypesImage) {\n        id\n        assetId\n        publicId\n        url\n        resourceType\n        format\n        width\n        height\n        caption\n        title\n        description\n      }\n    }\n  }\n}";
// language=GraphQL
var CREATE_TENANT_SETTINGS_MUTATION = "\n  mutation Mutation($input: CreateTravelObjectTenantSettingsInput, $withTenant: Boolean = false, $withTenantCms: Boolean = false, $withTenantCmsHomepage: Boolean = false, $withTenantCmsCategories: Boolean = false, $withTenantCmsPages: Boolean = false, $withTenantCmsErrorPage404: Boolean = false, $withTenantCmsErrorPage500: Boolean = false, $withTenantCmsConfig: Boolean = false, $withTenantTravelTypes: Boolean = false, $withTenantTravelTypesImage: Boolean = false, $withTenantEmployees: Boolean = false, $withTenantEmployeesImage: Boolean = false, $withTenantEmailConfig: Boolean = false, $withTenantNewsletterProvider: Boolean = false, $withTenantNewsletterProviderConfig: Boolean = false, $withTenantRedirects: Boolean = false, $withTenantRedirectsFromPage: Boolean = false, $withTenantRedirectsFromTravel: Boolean = false, $withTenantRedirectsToPage: Boolean = false, $withTenantRedirectsToTravel: Boolean = false, $withTenantOnlinePaymentConfig: Boolean = false, $withTenantRatioConfig: Boolean = false, $withTenantContent: Boolean = false, $withTenantPartnerTenants: Boolean = false, $withTenantPartnerTenantsTenant: Boolean = false, $withTravelTypes: Boolean = false, $withTravelTypesImage: Boolean = false) {\n    tenantSettings: createTravelObjectTenantSettings(input: $input) {\n      id\n      tenant @include(if: $withTenant) {\n        id\n        name\n        slug\n        domain\n        externalReference\n        cms @include(if: $withTenantCms) {\n          id\n          homepage @include(if: $withTenantCmsHomepage) {\n            id\n            name\n            onlineStatus\n          }\n          categories @include(if: $withTenantCmsCategories) {\n            id\n            name\n          }\n          pages @include(if: $withTenantCmsPages) {\n            id\n            name\n            onlineStatus\n          }\n          errorPage404 @include(if: $withTenantCmsErrorPage404) {\n            id\n            name\n            onlineStatus\n          }\n          errorPage500 @include(if: $withTenantCmsErrorPage500) {\n            id\n            name\n            onlineStatus\n          }\n          config @include(if: $withTenantCmsConfig) {\n            id\n          }\n        }\n        travelTypes @include(if: $withTenantTravelTypes) {\n          id\n          name\n          description\n          image @include(if: $withTenantTravelTypesImage) {\n            id\n            assetId\n            publicId\n            url\n            resourceType\n            format\n            width\n            height\n            caption\n            title\n            description\n          }\n        }\n        employees @include(if: $withTenantEmployees) {\n          id\n          firstName\n          lastName\n          jobTitle\n          description\n          email\n          image @include(if: $withTenantEmployeesImage) {\n            id\n            assetId\n            publicId\n            url\n            resourceType\n            format\n            width\n            height\n            caption\n            title\n            description\n          }\n          phone\n        }\n        emailConfig @include(if: $withTenantEmailConfig) {\n          id\n          defaultInternalRecipientEmail\n          internalBookingRecipientEmails\n          bookingConfirmationTemplateId\n          bookingConfirmationInternalTemplateId\n          bookingRequestConfirmationTemplateId\n          bookingWaitlistConfirmationTemplateId\n          bookingWaitlistContingentCheckConfirmationTemplateId\n          bookingCustomRequestTemplateId\n          bookingPassportDataReminderTemplateId\n          contactFormTemplateId\n          esimInstallationInfoTemplateId\n        }\n        newsletterProvider @include(if: $withTenantNewsletterProvider) {\n          id\n          provider\n          config @include(if: $withTenantNewsletterProviderConfig) {\n            __typename\n            ... on MailchimpConfig {\n              id\n              apiKey\n              serverPrefix\n              listId\n\n            }\n          }\n        }\n        redirects @include(if: $withTenantRedirects) {\n          id\n          fromType\n          fromUrl\n          fromPage @include(if: $withTenantRedirectsFromPage) {\n            id\n            name\n            onlineStatus\n          }\n          fromTravel @include(if: $withTenantRedirectsFromTravel) {\n            id\n            name\n            isBestseller\n            startDate\n            endDate\n            executionStatus\n            title\n            description\n            includedServices\n            excludedServices\n            pricingTable\n            priceCalculationInfo\n            programType\n            programText\n            minPrice\n            minPriceManualOverride\n            currency\n          }\n          toType\n          toUrl\n          toPage @include(if: $withTenantRedirectsToPage) {\n            id\n            name\n            onlineStatus\n          }\n          toTravel @include(if: $withTenantRedirectsToTravel) {\n            id\n            name\n            isBestseller\n            startDate\n            endDate\n            executionStatus\n            title\n            description\n            includedServices\n            excludedServices\n            pricingTable\n            priceCalculationInfo\n            programType\n            programText\n            minPrice\n            minPriceManualOverride\n            currency\n          }\n        }\n        onlinePaymentConfig @include(if: $withTenantOnlinePaymentConfig) {\n          id\n          enabled\n          ratioFibuAccountNo\n          infoText\n          datatransThemeConfig\n        }\n        ratioConfig @include(if: $withTenantRatioConfig) {\n          id\n          adressgruppe\n        }\n        content @include(if: $withTenantContent) {\n          id\n          bookingInsuranceInfo\n        }\n        partnerTenants @include(if: $withTenantPartnerTenants) {\n          id\n          tenant @include(if: $withTenantPartnerTenantsTenant) {\n            id\n            name\n            slug\n            domain\n            externalReference\n          }\n          filterCrossLinking\n        }\n      }\n      onlineStatus\n      redirectToBooking\n      useTiming\n      startDate\n      endDate\n      travelTypes @include(if: $withTravelTypes) {\n        id\n        name\n        description\n        image @include(if: $withTravelTypesImage) {\n          id\n          assetId\n          publicId\n          url\n          resourceType\n          format\n          width\n          height\n          caption\n          title\n          description\n        }\n      }\n    }\n  }";
// language=GraphQL
var UPDATE_TENANT_SETTINGS_MUTATION = "\n  mutation Mutation($input: UpdateTravelObjectTenantSettingsInput, $withTenant: Boolean = false, $withTenantCms: Boolean = false, $withTenantCmsHomepage: Boolean = false, $withTenantCmsCategories: Boolean = false, $withTenantCmsPages: Boolean = false, $withTenantCmsErrorPage404: Boolean = false, $withTenantCmsErrorPage500: Boolean = false, $withTenantCmsConfig: Boolean = false, $withTenantTravelTypes: Boolean = false, $withTenantTravelTypesImage: Boolean = false, $withTenantEmployees: Boolean = false, $withTenantEmployeesImage: Boolean = false, $withTenantEmailConfig: Boolean = false, $withTenantNewsletterProvider: Boolean = false, $withTenantNewsletterProviderConfig: Boolean = false, $withTenantRedirects: Boolean = false, $withTenantRedirectsFromPage: Boolean = false, $withTenantRedirectsFromTravel: Boolean = false, $withTenantRedirectsToPage: Boolean = false, $withTenantRedirectsToTravel: Boolean = false, $withTenantOnlinePaymentConfig: Boolean = false, $withTenantRatioConfig: Boolean = false, $withTenantContent: Boolean = false, $withTenantPartnerTenants: Boolean = false, $withTenantPartnerTenantsTenant: Boolean = false, $withTravelTypes: Boolean = false, $withTravelTypesImage: Boolean = false) {\n    tenantSettings: updateTravelObjectTenantSettings(input: $input) {\n      id\n      tenant @include(if: $withTenant) {\n        id\n        name\n        slug\n        domain\n        externalReference\n        cms @include(if: $withTenantCms) {\n          id\n          homepage @include(if: $withTenantCmsHomepage) {\n            id\n            name\n            onlineStatus\n          }\n          categories @include(if: $withTenantCmsCategories) {\n            id\n            name\n          }\n          pages @include(if: $withTenantCmsPages) {\n            id\n            name\n            onlineStatus\n          }\n          errorPage404 @include(if: $withTenantCmsErrorPage404) {\n            id\n            name\n            onlineStatus\n          }\n          errorPage500 @include(if: $withTenantCmsErrorPage500) {\n            id\n            name\n            onlineStatus\n          }\n          config @include(if: $withTenantCmsConfig) {\n            id\n          }\n        }\n        travelTypes @include(if: $withTenantTravelTypes) {\n          id\n          name\n          description\n          image @include(if: $withTenantTravelTypesImage) {\n            id\n            assetId\n            publicId\n            url\n            resourceType\n            format\n            width\n            height\n            caption\n            title\n            description\n          }\n        }\n        employees @include(if: $withTenantEmployees) {\n          id\n          firstName\n          lastName\n          jobTitle\n          description\n          email\n          image @include(if: $withTenantEmployeesImage) {\n            id\n            assetId\n            publicId\n            url\n            resourceType\n            format\n            width\n            height\n            caption\n            title\n            description\n          }\n          phone\n        }\n        emailConfig @include(if: $withTenantEmailConfig) {\n          id\n          defaultInternalRecipientEmail\n          internalBookingRecipientEmails\n          bookingConfirmationTemplateId\n          bookingConfirmationInternalTemplateId\n          bookingRequestConfirmationTemplateId\n          bookingWaitlistConfirmationTemplateId\n          bookingWaitlistContingentCheckConfirmationTemplateId\n          bookingCustomRequestTemplateId\n          bookingPassportDataReminderTemplateId\n          contactFormTemplateId\n          esimInstallationInfoTemplateId\n        }\n        newsletterProvider @include(if: $withTenantNewsletterProvider) {\n          id\n          provider\n          config @include(if: $withTenantNewsletterProviderConfig) {\n            __typename\n            ... on MailchimpConfig {\n              id\n              apiKey\n              serverPrefix\n              listId\n\n            }\n          }\n        }\n        redirects @include(if: $withTenantRedirects) {\n          id\n          fromType\n          fromUrl\n          fromPage @include(if: $withTenantRedirectsFromPage) {\n            id\n            name\n            onlineStatus\n          }\n          fromTravel @include(if: $withTenantRedirectsFromTravel) {\n            id\n            name\n            isBestseller\n            startDate\n            endDate\n            executionStatus\n            title\n            description\n            includedServices\n            excludedServices\n            pricingTable\n            priceCalculationInfo\n            programType\n            programText\n            minPrice\n            minPriceManualOverride\n            currency\n          }\n          toType\n          toUrl\n          toPage @include(if: $withTenantRedirectsToPage) {\n            id\n            name\n            onlineStatus\n          }\n          toTravel @include(if: $withTenantRedirectsToTravel) {\n            id\n            name\n            isBestseller\n            startDate\n            endDate\n            executionStatus\n            title\n            description\n            includedServices\n            excludedServices\n            pricingTable\n            priceCalculationInfo\n            programType\n            programText\n            minPrice\n            minPriceManualOverride\n            currency\n          }\n        }\n        onlinePaymentConfig @include(if: $withTenantOnlinePaymentConfig) {\n          id\n          enabled\n          ratioFibuAccountNo\n          infoText\n          datatransThemeConfig\n        }\n        ratioConfig @include(if: $withTenantRatioConfig) {\n          id\n          adressgruppe\n        }\n        content @include(if: $withTenantContent) {\n          id\n          bookingInsuranceInfo\n        }\n        partnerTenants @include(if: $withTenantPartnerTenants) {\n          id\n          tenant @include(if: $withTenantPartnerTenantsTenant) {\n            id\n            name\n            slug\n            domain\n            externalReference\n          }\n          filterCrossLinking\n        }\n      }\n      onlineStatus\n      redirectToBooking\n      useTiming\n      startDate\n      endDate\n      travelTypes @include(if: $withTravelTypes) {\n        id\n        name\n        description\n        image @include(if: $withTravelTypesImage) {\n          id\n          assetId\n          publicId\n          url\n          resourceType\n          format\n          width\n          height\n          caption\n          title\n          description\n        }\n      }\n    }\n  }";
// language=GraphQL
var DELETE_TENANT_SETTINGS_MUTATION = "\n  mutation Mutation($input: DeleteTravelObjectTenantSettingsInput) {\n    deleteTravelObjectTenantSettings(input: $input) {\n      success\n    }\n  }";
// language=GraphQL
var FORCE_DELETE_TENANT_SETTINGS_MUTATION = "\n  mutation Mutation($input: DeleteTravelObjectTenantSettingsInput) {\n    forceDeleteTravelObjectTenantSettings(input: $input) {\n      success\n    }\n  }";
// language=GraphQL
var ADD_TENANT_SETTINGS_TRAVEL_TYPES_MUTATION = "\n  mutation Mutation($input: addTravelObjectTenantSettingsTravelTypesInput) {\n    addTravelObjectTenantSettingsTravelTypes(input: $input) {\n      id\n      travelTypeIds\n    }\n  }";
// language=GraphQL
var REMOVE_TENANT_SETTINGS_TRAVEL_TYPES_MUTATION = "\n  mutation Mutation($input: removeTravelObjectTenantSettingsTravelTypesInput) {\n    removeTravelObjectTenantSettingsTravelTypes(input: $input) {\n      id\n      travelTypeIds\n    }\n  }";
// language=GraphQL
var CREATE_TENANT_SETTINGS_TRAVEL_TYPES_MUTATION = "\n  mutation Mutation($input: createTravelObjectTenantSettingsTravelTypesInput) {\n    createTravelObjectTenantSettingsTravelTypes(input: $input) {\n      id\n      travelTypeIds\n    }\n  }";
// language=GraphQL
var DELETE_TENANT_SETTINGS_TRAVEL_TYPES_MUTATION = "\n  mutation Mutation($input: deleteTravelObjectTenantSettingsTravelTypesInput) {\n    deleteTravelObjectTenantSettingsTravelTypes(input: $input) {\n      id\n      travelTypeIds\n    }\n  }";
// language=GraphQL
var UPDATE_TENANT_SETTINGS_TRAVEL_TYPES_ORDER_MUTATION = "\n  mutation Mutation($input: updateTravelObjectTenantSettingsTravelTypesOrderInput) {\n    updateTravelObjectTenantSettingsTravelTypesOrder(input: $input) {\n      id\n      travelTypeIds\n    }\n  }";
// language=GraphQL
var TENANT_SETTINGS_DEPENDENTS_QUERY = "query Query($id: ID!, $withTravels: Boolean = false) {\n  groupedDependents: travelObjectTenantSettingsDependents(id: $id) {\n    travels @include(if: $withTravels) {\n      id\n      name\n      isBestseller\n      startDate\n      endDate\n      executionStatus\n      title\n      description\n      includedServices\n      excludedServices\n      pricingTable\n      priceCalculationInfo\n      programType\n      programText\n      minPrice\n      minPriceManualOverride\n      currency    }\n  }\n}";

// EXTERNAL MODULE: ./src/entities/tenant/entity.ts + 3 modules
var entity = __webpack_require__(57850);
// EXTERNAL MODULE: ./src/entities/travelType/entity.ts + 3 modules
var travelType_entity = __webpack_require__(31250);
;// CONCATENATED MODULE: ./src/entities/travelObjectTenantSettings/model.ts



var travelObjectTenantSettingsModel = {
    name: "tenantSettings",
    namePlural: "tenantSettings",
    uniqueName: "travelObjectTenantSettings",
    uniqueNamePlural: "travelObjectTenantSettings",
    path: "travel/tenant_settings",
    baseUrl: "/travel/tenant_settings",
    translationPrefix: "entities:travelObjectTenantSettings.",
    getDisplayName: function(values) {
        return "Travel Tenant Settings";
    },
    gql: {
        getAll: ALL_TENANT_SETTINGS_QUERY,
        getSingle: SINGLE_TENANT_SETTINGS_QUERY,
        create: CREATE_TENANT_SETTINGS_MUTATION,
        update: UPDATE_TENANT_SETTINGS_MUTATION,
        delete: DELETE_TENANT_SETTINGS_MUTATION,
        forceDelete: FORCE_DELETE_TENANT_SETTINGS_MUTATION
    },
    attributes: {
        tenant: {
            name: "tenant",
            label: "entities:travelObjectTenantSettings.attributes.tenant.label",
            type: "entityObject",
            dataType: "any",
            getEntity: function() {
                return entity/* default */.Z;
            },
            defaultInput: false,
            inputType: "select",
            validationType: "string",
            validations: [
                {
                    type: "required"
                }, 
            ]
        },
        onlineStatus: {
            name: "onlineStatus",
            label: "entities:travelObjectTenantSettings.attributes.onlineStatus.label",
            type: "value",
            dataType: "string",
            defaultInput: true,
            inputType: "select",
            selectOptions: [
                {
                    label: "entities:travelObjectTenantSettings.attributes.onlineStatus.selectOptions.OFFLINE.label",
                    value: "OFFLINE"
                },
                {
                    label: "entities:travelObjectTenantSettings.attributes.onlineStatus.selectOptions.ONLINE.label",
                    value: "ONLINE"
                },
                {
                    label: "entities:travelObjectTenantSettings.attributes.onlineStatus.selectOptions.HIDDEN.label",
                    value: "HIDDEN"
                }, 
            ],
            validationType: "string",
            validations: [
                {
                    type: "required"
                }, 
            ]
        },
        redirectToBooking: {
            name: "redirectToBooking",
            label: "entities:travelObjectTenantSettings.attributes.redirectToBooking.label",
            type: "value",
            dataType: "boolean",
            defaultInput: true,
            inputType: "switch",
            validationType: "string",
            validations: []
        },
        useTiming: {
            name: "useTiming",
            label: "entities:travelObjectTenantSettings.attributes.useTiming.label",
            type: "value",
            dataType: "boolean",
            defaultInput: true,
            inputType: "switch",
            validationType: "string",
            validations: []
        },
        startDate: {
            name: "startDate",
            label: "entities:travelObjectTenantSettings.attributes.startDate.label",
            type: "value",
            dataType: "Date",
            defaultInput: true,
            inputType: "text",
            isStartDate: true,
            endDateAttribute: "endDate",
            validationType: "string",
            validations: []
        },
        endDate: {
            name: "endDate",
            label: "entities:travelObjectTenantSettings.attributes.endDate.label",
            type: "value",
            dataType: "Date",
            defaultInput: true,
            inputType: "text",
            isEndDate: true,
            startDateAttribute: "startDate",
            validationType: "string",
            validations: []
        },
        travelTypes: {
            name: "travelTypes",
            label: "entities:travelObjectTenantSettings.attributes.travelTypes.label",
            type: "entityCollection",
            dataType: "[any]",
            getEntity: function() {
                return travelType_entity/* default */.Z;
            },
            defaultInput: false,
            inputType: "text",
            validationType: "string",
            validations: []
        }
    }
};
/* harmony default export */ var model = (travelObjectTenantSettingsModel);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(20414);
// EXTERNAL MODULE: ./src/entities/lib.ts
var lib = __webpack_require__(23480);
// EXTERNAL MODULE: ./src/lib/api/graphQLClient.ts
var graphQLClient = __webpack_require__(40112);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/swr/dist/index.mjs
var dist = __webpack_require__(8100);
// EXTERNAL MODULE: ./src/lib/helpers/helpers.ts
var helpers = __webpack_require__(15778);
;// CONCATENATED MODULE: ./src/entities/travelObjectTenantSettings/repository.ts










var hydrateObjects = function(objects) {
    return objects.map(function(object) {
        return (0,lib/* hydrateEntityObject */.b)(model, object);
    });
};
var hydrateObject = function(object) {
    return (0,lib/* hydrateEntityObject */.b)(model, object);
};
var travelObjectTenantSettingsRepository = {
    getObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    id: id
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(SINGLE_TENANT_SETTINGS_QUERY, variables).then(function(data) {
                        return hydrateObject(data.tenantSettings);
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }(),
    getObjects: /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        var includes;
        var _arguments = arguments;
        return (0,tslib_es6.__generator)(this, function(_state) {
            includes = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : {};
            return [
                2,
                graphQLClient/* default.request */.Z.request(ALL_TENANT_SETTINGS_QUERY, includes).then(function(data) {
                    return hydrateObjects(data.tenantSettings);
                })
            ];
        });
    }),
    useObject: function(id) {
        var includes = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        // eslint-disable-next-line react-hooks/exhaustive-deps
        var variables = (0,react.useMemo)(function() {
            return (0,_object_spread/* default */.Z)({
                id: id
            }, includes);
        }, [
            id
        ]);
        var ref = (0,dist/* default */.ZP)([
            SINGLE_TENANT_SETTINGS_QUERY,
            variables
        ], {
            revalidateOnFocus: false
        }), data = ref.data, error = ref.error, mutate = ref.mutate;
        return {
            object: !data ? data : hydrateObject(data.tenantSettings),
            isLoading: !error && !data,
            isError: error,
            mutate: mutate
        };
    },
    useObjects: function() {
        var includes = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        // eslint-disable-next-line react-hooks/exhaustive-deps
        var variables = (0,react.useMemo)(function() {
            return includes;
        }, []);
        var ref = (0,dist/* default */.ZP)([
            ALL_TENANT_SETTINGS_QUERY,
            variables
        ]), data = ref.data, error = ref.error, mutate = ref.mutate;
        return {
            objects: !data ? data : hydrateObjects(data.tenantSettings),
            isLoading: !error && !data,
            isError: error,
            mutate: mutate
        };
    },
    getDependents: function(id, includes) {
        var includeVars = {};
        includes.forEach(function(include) {
            includeVars["with".concat((0,helpers/* uppercaseFirst */.AB)(include))] = true;
        });
        var variables = (0,_object_spread/* default */.Z)({
            id: id
        }, includeVars);
        return graphQLClient/* default.request */.Z.request(TENANT_SETTINGS_DEPENDENTS_QUERY, variables).then(function(data) {
            return data.groupedDependents;
        });
    },
    useDependents: function(id, includes) {
        var includeVars = {};
        includes.forEach(function(include) {
            includeVars["with".concat((0,helpers/* uppercaseFirst */.AB)(include))] = true;
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
        var variables = (0,react.useMemo)(function() {
            return (0,_object_spread/* default */.Z)({
                id: id
            }, includeVars);
        }, [
            id
        ]);
        var ref = (0,dist/* default */.ZP)([
            TENANT_SETTINGS_DEPENDENTS_QUERY,
            variables
        ], {
            revalidateOnFocus: false
        }), data = ref.data, error = ref.error, mutate = ref.mutate;
        return {
            data: !data ? data : data.groupedDependents,
            isLoading: !error && !data,
            isError: error,
            mutate: mutate
        };
    },
    createObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(data) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    input: data
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(CREATE_TENANT_SETTINGS_MUTATION, variables).then(function(data) {
                        return hydrateObject(data.tenantSettings);
                    })
                ];
            });
        });
        return function(data) {
            return _ref.apply(this, arguments);
        };
    }(),
    updateObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(data) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    input: data
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(UPDATE_TENANT_SETTINGS_MUTATION, variables).then(function(data) {
                        return hydrateObject(data.tenantSettings);
                    })
                ];
            });
        });
        return function(data) {
            return _ref.apply(this, arguments);
        };
    }(),
    deleteObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(DELETE_TENANT_SETTINGS_MUTATION, variables).then(function(data) {
                        return data.deleteTravelObjectTenantSettings;
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }(),
    forceDeleteObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(FORCE_DELETE_TENANT_SETTINGS_MUTATION, variables).then(function(data) {
                        return data.forceDeleteTravelObjectTenantSettings;
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }(),
    assignTravelTypes: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, itemIds) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        travelTypeIds: itemIds
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(ADD_TENANT_SETTINGS_TRAVEL_TYPES_MUTATION, variables)
                ];
            });
        });
        return function(id, itemIds) {
            return _ref.apply(this, arguments);
        };
    }(),
    unassignTravelTypes: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, itemIds) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        travelTypeIds: itemIds
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(REMOVE_TENANT_SETTINGS_TRAVEL_TYPES_MUTATION, variables)
                ];
            });
        });
        return function(id, itemIds) {
            return _ref.apply(this, arguments);
        };
    }(),
    createTravelTypes: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, items) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        travelTypes: items
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(CREATE_TENANT_SETTINGS_TRAVEL_TYPES_MUTATION, variables)
                ];
            });
        });
        return function(id, items) {
            return _ref.apply(this, arguments);
        };
    }(),
    deleteTravelTypes: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, itemIds) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        travelTypeIds: itemIds
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(DELETE_TENANT_SETTINGS_TRAVEL_TYPES_MUTATION, variables)
                ];
            });
        });
        return function(id, itemIds) {
            return _ref.apply(this, arguments);
        };
    }(),
    updateTravelTypesOrder: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, itemIds) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        travelTypeIds: itemIds
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(UPDATE_TENANT_SETTINGS_TRAVEL_TYPES_ORDER_MUTATION, variables)
                ];
            });
        });
        return function(id, itemIds) {
            return _ref.apply(this, arguments);
        };
    }()
};
/* harmony default export */ var repository = (travelObjectTenantSettingsRepository);

;// CONCATENATED MODULE: ./src/entities/travelObjectTenantSettings/entity.ts


var travelObjectTenantSettingsEntity = {
    model: model,
    repository: repository
};
/* harmony default export */ var travelObjectTenantSettings_entity = (travelObjectTenantSettingsEntity);


/***/ }),

/***/ 52889:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ travelPartner_entity; }
});

;// CONCATENATED MODULE: ./src/entities/travelPartner/graphql.ts
// language=GraphQL
var ALL_PARTNERS_QUERY = "query Query($withLogo: Boolean = false, $withGtcPdf: Boolean = false) {\n  partners: travelPartners {\n    id\n    name\n    url\n    logo @include(if: $withLogo) {\n      id\n      assetId\n      publicId\n      url\n      resourceType\n      format\n      width\n      height\n      caption\n      title\n      description\n    }\n    logoWidth\n    gtcPdf @include(if: $withGtcPdf) {\n      id\n      assetId\n      publicId\n      url\n      resourceType\n      format\n      width\n      height\n      caption\n      title\n      description\n    }\n  }\n}";
// language=GraphQL
var SINGLE_PARTNER_QUERY = "query Query($id: ID!, $withLogo: Boolean = false, $withGtcPdf: Boolean = false) {\n  partner: travelPartner(id: $id) {\n    id\n    name\n    url\n    logo @include(if: $withLogo) {\n      id\n      assetId\n      publicId\n      url\n      resourceType\n      format\n      width\n      height\n      caption\n      title\n      description\n    }\n    logoWidth\n    gtcPdf @include(if: $withGtcPdf) {\n      id\n      assetId\n      publicId\n      url\n      resourceType\n      format\n      width\n      height\n      caption\n      title\n      description\n    }\n  }\n}";
// language=GraphQL
var CREATE_PARTNER_MUTATION = "\n  mutation Mutation($input: CreateTravelPartnerInput, $withLogo: Boolean = false, $withGtcPdf: Boolean = false) {\n    partner: createTravelPartner(input: $input) {\n      id\n      name\n      url\n      logo @include(if: $withLogo) {\n        id\n        assetId\n        publicId\n        url\n        resourceType\n        format\n        width\n        height\n        caption\n        title\n        description\n      }\n      logoWidth\n      gtcPdf @include(if: $withGtcPdf) {\n        id\n        assetId\n        publicId\n        url\n        resourceType\n        format\n        width\n        height\n        caption\n        title\n        description\n      }\n    }\n  }";
// language=GraphQL
var UPDATE_PARTNER_MUTATION = "\n  mutation Mutation($input: UpdateTravelPartnerInput, $withLogo: Boolean = false, $withGtcPdf: Boolean = false) {\n    partner: updateTravelPartner(input: $input) {\n      id\n      name\n      url\n      logo @include(if: $withLogo) {\n        id\n        assetId\n        publicId\n        url\n        resourceType\n        format\n        width\n        height\n        caption\n        title\n        description\n      }\n      logoWidth\n      gtcPdf @include(if: $withGtcPdf) {\n        id\n        assetId\n        publicId\n        url\n        resourceType\n        format\n        width\n        height\n        caption\n        title\n        description\n      }\n    }\n  }";
// language=GraphQL
var DELETE_PARTNER_MUTATION = "\n  mutation Mutation($input: DeleteTravelPartnerInput) {\n    deleteTravelPartner(input: $input) {\n      success\n    }\n  }";
// language=GraphQL
var FORCE_DELETE_PARTNER_MUTATION = "\n  mutation Mutation($input: DeleteTravelPartnerInput) {\n    forceDeleteTravelPartner(input: $input) {\n      success\n    }\n  }";
// language=GraphQL
var PARTNERS_DEPENDENTS_QUERY = "query Query($id: ID!, $withTravelPricings: Boolean = false, $withTravels: Boolean = false) {\n  groupedDependents: travelPartnerDependents(id: $id) {\n    travelPricings @include(if: $withTravelPricings) {\n      id\n      isTravelDocumentationAvailable\n    }\n    travels @include(if: $withTravels) {\n      id\n      name\n      isBestseller\n      startDate\n      endDate\n      executionStatus\n      title\n      description\n      includedServices\n      excludedServices\n      pricingTable\n      priceCalculationInfo\n      programType\n      programText\n      minPrice\n      minPriceManualOverride\n      currency    }\n  }\n}";

// EXTERNAL MODULE: ./src/entities/mediaFile/entity.ts + 3 modules
var entity = __webpack_require__(24180);
;// CONCATENATED MODULE: ./src/entities/travelPartner/model.ts


var travelPartnerModel = {
    name: "partner",
    namePlural: "partners",
    uniqueName: "travelPartner",
    uniqueNamePlural: "travelPartners",
    path: "travel/partner",
    baseUrl: "/travel/partners",
    translationPrefix: "entities:travelPartner.",
    getDisplayName: function(values) {
        return values.name;
    },
    gql: {
        getAll: ALL_PARTNERS_QUERY,
        getSingle: SINGLE_PARTNER_QUERY,
        create: CREATE_PARTNER_MUTATION,
        update: UPDATE_PARTNER_MUTATION,
        delete: DELETE_PARTNER_MUTATION,
        forceDelete: FORCE_DELETE_PARTNER_MUTATION
    },
    attributes: {
        name: {
            name: "name",
            label: "entities:travelPartner.attributes.name.label",
            type: "value",
            dataType: "string",
            defaultInput: true,
            inputType: "text",
            validationType: "string",
            validations: [
                {
                    type: "required"
                }, 
            ]
        },
        url: {
            name: "url",
            label: "entities:travelPartner.attributes.url.label",
            type: "value",
            dataType: "string",
            defaultInput: true,
            inputType: "text",
            validationType: "string",
            validations: [
                {
                    type: "regex",
                    pattern: /https?:\/\/(www.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&\/\/=]*)/
                }, 
            ]
        },
        logo: {
            name: "logo",
            label: "entities:travelPartner.attributes.logo.label",
            type: "entityObject",
            dataType: "any",
            getEntity: function() {
                return entity/* default */.Z;
            },
            defaultInput: false,
            inputType: "select",
            validationType: "string",
            validations: []
        },
        logoWidth: {
            name: "logoWidth",
            label: "entities:travelPartner.attributes.logoWidth.label",
            type: "value",
            dataType: "number",
            defaultInput: true,
            inputType: "number",
            validationType: "string",
            validations: []
        },
        gtcPdf: {
            name: "gtcPdf",
            label: "entities:travelPartner.attributes.gtcPdf.label",
            type: "entityObject",
            dataType: "any",
            getEntity: function() {
                return entity/* default */.Z;
            },
            defaultInput: false,
            inputType: "select",
            validationType: "string",
            validations: []
        }
    }
};
/* harmony default export */ var model = (travelPartnerModel);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(20414);
// EXTERNAL MODULE: ./src/entities/lib.ts
var lib = __webpack_require__(23480);
// EXTERNAL MODULE: ./src/lib/api/graphQLClient.ts
var graphQLClient = __webpack_require__(40112);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/swr/dist/index.mjs
var dist = __webpack_require__(8100);
// EXTERNAL MODULE: ./src/lib/helpers/helpers.ts
var helpers = __webpack_require__(15778);
;// CONCATENATED MODULE: ./src/entities/travelPartner/repository.ts










var hydrateObjects = function(objects) {
    return objects.map(function(object) {
        return (0,lib/* hydrateEntityObject */.b)(model, object);
    });
};
var hydrateObject = function(object) {
    return (0,lib/* hydrateEntityObject */.b)(model, object);
};
var travelPartnerRepository = {
    getObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    id: id
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(SINGLE_PARTNER_QUERY, variables).then(function(data) {
                        return hydrateObject(data.partner);
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }(),
    getObjects: /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        var includes;
        var _arguments = arguments;
        return (0,tslib_es6.__generator)(this, function(_state) {
            includes = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : {};
            return [
                2,
                graphQLClient/* default.request */.Z.request(ALL_PARTNERS_QUERY, includes).then(function(data) {
                    return hydrateObjects(data.partners);
                })
            ];
        });
    }),
    useObject: function(id) {
        var includes = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        // eslint-disable-next-line react-hooks/exhaustive-deps
        var variables = (0,react.useMemo)(function() {
            return (0,_object_spread/* default */.Z)({
                id: id
            }, includes);
        }, [
            id
        ]);
        var ref = (0,dist/* default */.ZP)([
            SINGLE_PARTNER_QUERY,
            variables
        ], {
            revalidateOnFocus: false
        }), data = ref.data, error = ref.error, mutate = ref.mutate;
        return {
            object: !data ? data : hydrateObject(data.partner),
            isLoading: !error && !data,
            isError: error,
            mutate: mutate
        };
    },
    useObjects: function() {
        var includes = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        // eslint-disable-next-line react-hooks/exhaustive-deps
        var variables = (0,react.useMemo)(function() {
            return includes;
        }, []);
        var ref = (0,dist/* default */.ZP)([
            ALL_PARTNERS_QUERY,
            variables
        ]), data = ref.data, error = ref.error, mutate = ref.mutate;
        return {
            objects: !data ? data : hydrateObjects(data.partners),
            isLoading: !error && !data,
            isError: error,
            mutate: mutate
        };
    },
    getDependents: function(id, includes) {
        var includeVars = {};
        includes.forEach(function(include) {
            includeVars["with".concat((0,helpers/* uppercaseFirst */.AB)(include))] = true;
        });
        var variables = (0,_object_spread/* default */.Z)({
            id: id
        }, includeVars);
        return graphQLClient/* default.request */.Z.request(PARTNERS_DEPENDENTS_QUERY, variables).then(function(data) {
            return data.groupedDependents;
        });
    },
    useDependents: function(id, includes) {
        var includeVars = {};
        includes.forEach(function(include) {
            includeVars["with".concat((0,helpers/* uppercaseFirst */.AB)(include))] = true;
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
        var variables = (0,react.useMemo)(function() {
            return (0,_object_spread/* default */.Z)({
                id: id
            }, includeVars);
        }, [
            id
        ]);
        var ref = (0,dist/* default */.ZP)([
            PARTNERS_DEPENDENTS_QUERY,
            variables
        ], {
            revalidateOnFocus: false
        }), data = ref.data, error = ref.error, mutate = ref.mutate;
        return {
            data: !data ? data : data.groupedDependents,
            isLoading: !error && !data,
            isError: error,
            mutate: mutate
        };
    },
    createObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(data) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    input: data
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(CREATE_PARTNER_MUTATION, variables).then(function(data) {
                        return hydrateObject(data.partner);
                    })
                ];
            });
        });
        return function(data) {
            return _ref.apply(this, arguments);
        };
    }(),
    updateObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(data) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    input: data
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(UPDATE_PARTNER_MUTATION, variables).then(function(data) {
                        return hydrateObject(data.partner);
                    })
                ];
            });
        });
        return function(data) {
            return _ref.apply(this, arguments);
        };
    }(),
    deleteObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(DELETE_PARTNER_MUTATION, variables).then(function(data) {
                        return data.deleteTravelPartner;
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }(),
    forceDeleteObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(FORCE_DELETE_PARTNER_MUTATION, variables).then(function(data) {
                        return data.forceDeleteTravelPartner;
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }()
};
/* harmony default export */ var repository = (travelPartnerRepository);

;// CONCATENATED MODULE: ./src/entities/travelPartner/entity.ts


var travelPartnerEntity = {
    model: model,
    repository: repository
};
/* harmony default export */ var travelPartner_entity = (travelPartnerEntity);


/***/ }),

/***/ 60090:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ travelPricing_entity; }
});

;// CONCATENATED MODULE: ./src/entities/travelPricing/graphql.ts
// language=GraphQL
var ALL_PRICINGS_QUERY = "query Query($withAgeGroupSettings: Boolean = false, $withAgeGroupSettingsAgeGroups: Boolean = false, $withCustomDataConfig: Boolean = false, $withCustomDataConfigTravellerForm: Boolean = false, $withCustomDataConfigTravellerFormFields: Boolean = false, $withCustomDataConfigBookingForm: Boolean = false, $withCustomDataConfigBookingFormFields: Boolean = false, $withTravels: Boolean = false, $withTravelsRatioCatalogBundle: Boolean = false, $withTravelsDates: Boolean = false, $withTravelsDatesAvailabilityStatus: Boolean = false, $withTravelsDatesExtensionBaseDate: Boolean = false, $withTravelsDatesExtension: Boolean = false, $withTravelsDatesPackageSettings: Boolean = false, $withTravelsDatesExtensions: Boolean = false, $withTravelsAccommodations: Boolean = false, $withTravelsAccommodationsCapacitySettings: Boolean = false, $withTravelsAccommodationsAddons: Boolean = false, $withTravelsExtensionAccommodations: Boolean = false, $withTravelsFamilyPackages: Boolean = false, $withTravelsFamilyPackagesAccommodation: Boolean = false, $withTravelsFamilyPackagesCapacitySettings: Boolean = false, $withTravelsFamilyPackagesAddons: Boolean = false, $withTravelsPersonalAddons: Boolean = false, $withTravelsPersonalAddonsAllowedAgeGroups: Boolean = false, $withTravelsPersonalAddonsCalculationSettings: Boolean = false, $withTravelsPersonalAddonsMandatorySettings: Boolean = false, $withTravelsAccommodationAddons: Boolean = false, $withTravelsAccommodationAddonsCalculationSettings: Boolean = false, $withTravelsAccommodationAddonsMandatorySettings: Boolean = false, $withTravelsBookingAddons: Boolean = false, $withTravelsBookingAddonsCalculationSettings: Boolean = false, $withTravelsBookingAddonsMandatorySettings: Boolean = false, $withTravelsCollectiveAddons: Boolean = false, $withTravelsCollectiveAddonsAgeGroupServices: Boolean = false, $withTravelsCollectiveAddonsCalculationSettings: Boolean = false, $withTravelsCollectiveAddonsMandatorySettings: Boolean = false, $withTravelsExtensions: Boolean = false, $withTravelsExtensionsTravelExtension: Boolean = false, $withTravelsExtensionsAccommodationMapItems: Boolean = false, $withTravelsPersonalDiscounts: Boolean = false, $withTravelsPersonalDiscountsMandatorySettings: Boolean = false, $withWebhookConfig: Boolean = false, $withBranding: Boolean = false, $withBrandingLogo: Boolean = false, $withBargainSettings: Boolean = false, $withBargainSettingsBargainTier: Boolean = false, $withEsimSettings: Boolean = false, $withEsimSettingsRegions: Boolean = false, $withPassportConfig: Boolean = false, $withTourOperator: Boolean = false, $withTourOperatorLogo: Boolean = false, $withTourOperatorGtcPdf: Boolean = false) {\n  pricings: travelPricings {\n    id\n    ageGroupSettings @include(if: $withAgeGroupSettings) {\n      id\n      freeUntilAge\n      ageGroups @include(if: $withAgeGroupSettingsAgeGroups) {\n        id\n        name\n        type\n        icon\n        minAge\n        maxAge\n      }\n    }\n    isTravelDocumentationAvailable\n    customDataConfig @include(if: $withCustomDataConfig) {\n      id\n      useTravellerForm\n      travellerForm @include(if: $withCustomDataConfigTravellerForm) {\n        id\n        fields @include(if: $withCustomDataConfigTravellerFormFields) {\n          id\n          inputType\n          name\n          label\n          info\n          value\n          required\n        }\n      }\n      useBookingForm\n      bookingForm @include(if: $withCustomDataConfigBookingForm) {\n        id\n        fields @include(if: $withCustomDataConfigBookingFormFields) {\n          id\n          inputType\n          name\n          label\n          info\n          value\n          required\n        }\n      }\n    }\n    travels @include(if: $withTravels) {\n      id\n      ratioCatalogBundle @include(if: $withTravelsRatioCatalogBundle) {\n        id\n        catalogCode\n        travelCode\n        json\n      }\n      catalogCode\n      travelCode\n      destination\n      name\n      transportType\n      transportTypeLabel\n      dates @include(if: $withTravelsDates) {\n        id\n        dateNo\n        startDate\n        endDate\n        availabilityStatus @include(if: $withTravelsDatesAvailabilityStatus) {\n          id\n          label\n          status\n          isDefaultStatus\n          isDefaultWaitlistFallback\n        }\n        includesExtension\n        extensionBaseDate @include(if: $withTravelsDatesExtensionBaseDate) {\n          id\n          dateNo\n          startDate\n          endDate\n          includesExtension\n          json\n        }\n        extension @include(if: $withTravelsDatesExtension) {\n          id\n          label\n          info\n        }\n        packageSettings @include(if: $withTravelsDatesPackageSettings) {\n          id\n          ratioPackageNo\n          price\n          availabilityStatus\n        }\n        json\n        extensions @include(if: $withTravelsDatesExtensions) {\n          id\n          label\n          info\n        }\n      }\n      accommodations @include(if: $withTravelsAccommodations) {\n        id\n        ratioPackageNo\n        name\n        label\n        info\n        isFamilyPackageAccommodation\n        isBabyPackage\n        capacitySettings @include(if: $withTravelsAccommodationsCapacitySettings) {\n          id\n          totalCapacity\n          rangesAllowed\n          partialOccupancyAllowed\n        }\n        addons @include(if: $withTravelsAccommodationsAddons) {\n          id\n          ratioServiceNo\n          name\n          label\n          info\n        }\n      }\n      extensionAccommodations @include(if: $withTravelsExtensionAccommodations) {\n        id\n        ratioPackageNo\n        name\n        label\n        info\n        extensionAccommodationServiceNo\n      }\n      familyPackages @include(if: $withTravelsFamilyPackages) {\n        id\n        ratioServiceNo\n        accommodation @include(if: $withTravelsFamilyPackagesAccommodation) {\n          id\n          ratioPackageNo\n          name\n          label\n          info\n          isFamilyPackageAccommodation\n          isBabyPackage\n        }\n        name\n        label\n        info\n        capacitySettings @include(if: $withTravelsFamilyPackagesCapacitySettings) {\n          id\n          totalCapacity\n          rangesAllowed\n          partialOccupancyAllowed\n        }\n        addons @include(if: $withTravelsFamilyPackagesAddons) {\n          id\n          ratioServiceNo\n          name\n          label\n          info\n        }\n      }\n      personalAddons @include(if: $withTravelsPersonalAddons) {\n        id\n        ratioServiceNo\n        name\n        label\n        info\n        allowedAgeGroups @include(if: $withTravelsPersonalAddonsAllowedAgeGroups) {\n          id\n          name\n          type\n          icon\n          minAge\n          maxAge\n        }\n        calculationSettings @include(if: $withTravelsPersonalAddonsCalculationSettings) {\n          id\n          type\n          considerHotelNights\n        }\n        mandatorySettings @include(if: $withTravelsPersonalAddonsMandatorySettings) {\n          id\n          isMandatory\n          useRules\n        }\n      }\n      accommodationAddons @include(if: $withTravelsAccommodationAddons) {\n        id\n        ratioServiceNo\n        name\n        label\n        info\n        calculationSettings @include(if: $withTravelsAccommodationAddonsCalculationSettings) {\n          id\n          type\n          considerHotelNights\n        }\n        mandatorySettings @include(if: $withTravelsAccommodationAddonsMandatorySettings) {\n          id\n          isMandatory\n          useRules\n        }\n      }\n      bookingAddons @include(if: $withTravelsBookingAddons) {\n        id\n        ratioServiceNo\n        name\n        label\n        info\n        calculationSettings @include(if: $withTravelsBookingAddonsCalculationSettings) {\n          id\n          type\n          considerHotelNights\n        }\n        mandatorySettings @include(if: $withTravelsBookingAddonsMandatorySettings) {\n          id\n          isMandatory\n          useRules\n        }\n      }\n      collectiveAddons @include(if: $withTravelsCollectiveAddons) {\n        id\n        label\n        info\n        ageGroupServices @include(if: $withTravelsCollectiveAddonsAgeGroupServices) {\n          id\n          ratioServiceNo\n        }\n        calculationSettings @include(if: $withTravelsCollectiveAddonsCalculationSettings) {\n          id\n          type\n          considerHotelNights\n        }\n        mandatorySettings @include(if: $withTravelsCollectiveAddonsMandatorySettings) {\n          id\n          isMandatory\n          useRules\n        }\n      }\n      extensions @include(if: $withTravelsExtensions) {\n        id\n        label\n        info\n        travelExtension @include(if: $withTravelsExtensionsTravelExtension) {\n          id\n          duration\n          name\n          description\n        }\n        accommodationMapItems @include(if: $withTravelsExtensionsAccommodationMapItems) {\n          id\n        }\n      }\n      personalDiscounts @include(if: $withTravelsPersonalDiscounts) {\n        id\n        ratioServiceNo\n        name\n        label\n        info\n        mandatorySettings @include(if: $withTravelsPersonalDiscountsMandatorySettings) {\n          id\n          isMandatory\n          useRules\n        }\n      }\n      importDateTime\n      importStatus\n    }\n    webhookConfig @include(if: $withWebhookConfig) {\n      id\n      enabled\n      url\n    }\n    branding @include(if: $withBranding) {\n      id\n      logo @include(if: $withBrandingLogo) {\n        id\n        assetId\n        publicId\n        url\n        resourceType\n        format\n        width\n        height\n        caption\n        title\n        description\n      }\n      logoWidth\n    }\n    bargainSettings @include(if: $withBargainSettings) {\n      id\n      active\n      untilDaysBeforeStart\n      bargainTier @include(if: $withBargainSettingsBargainTier) {\n        id\n        fromPrice\n        discount\n      }\n    }\n    esimSettings @include(if: $withEsimSettings) {\n      id\n      enabled\n      regions @include(if: $withEsimSettingsRegions) {\n        id\n        name\n        serviceCodePrefix\n      }\n    }\n    passportConfig @include(if: $withPassportConfig) {\n      id\n      passportOnly\n    }\n    tourOperator @include(if: $withTourOperator) {\n      id\n      name\n      url\n      logo @include(if: $withTourOperatorLogo) {\n        id\n        assetId\n        publicId\n        url\n        resourceType\n        format\n        width\n        height\n        caption\n        title\n        description\n      }\n      logoWidth\n      gtcPdf @include(if: $withTourOperatorGtcPdf) {\n        id\n        assetId\n        publicId\n        url\n        resourceType\n        format\n        width\n        height\n        caption\n        title\n        description\n      }\n    }\n  }\n}";
// language=GraphQL
var SINGLE_PRICING_QUERY = "query Query($id: ID!, $withAgeGroupSettings: Boolean = false, $withAgeGroupSettingsAgeGroups: Boolean = false, $withCustomDataConfig: Boolean = false, $withCustomDataConfigTravellerForm: Boolean = false, $withCustomDataConfigTravellerFormFields: Boolean = false, $withCustomDataConfigBookingForm: Boolean = false, $withCustomDataConfigBookingFormFields: Boolean = false, $withTravels: Boolean = false, $withTravelsRatioCatalogBundle: Boolean = false, $withTravelsDates: Boolean = false, $withTravelsDatesAvailabilityStatus: Boolean = false, $withTravelsDatesExtensionBaseDate: Boolean = false, $withTravelsDatesExtension: Boolean = false, $withTravelsDatesPackageSettings: Boolean = false, $withTravelsDatesExtensions: Boolean = false, $withTravelsAccommodations: Boolean = false, $withTravelsAccommodationsCapacitySettings: Boolean = false, $withTravelsAccommodationsAddons: Boolean = false, $withTravelsExtensionAccommodations: Boolean = false, $withTravelsFamilyPackages: Boolean = false, $withTravelsFamilyPackagesAccommodation: Boolean = false, $withTravelsFamilyPackagesCapacitySettings: Boolean = false, $withTravelsFamilyPackagesAddons: Boolean = false, $withTravelsPersonalAddons: Boolean = false, $withTravelsPersonalAddonsAllowedAgeGroups: Boolean = false, $withTravelsPersonalAddonsCalculationSettings: Boolean = false, $withTravelsPersonalAddonsMandatorySettings: Boolean = false, $withTravelsAccommodationAddons: Boolean = false, $withTravelsAccommodationAddonsCalculationSettings: Boolean = false, $withTravelsAccommodationAddonsMandatorySettings: Boolean = false, $withTravelsBookingAddons: Boolean = false, $withTravelsBookingAddonsCalculationSettings: Boolean = false, $withTravelsBookingAddonsMandatorySettings: Boolean = false, $withTravelsCollectiveAddons: Boolean = false, $withTravelsCollectiveAddonsAgeGroupServices: Boolean = false, $withTravelsCollectiveAddonsCalculationSettings: Boolean = false, $withTravelsCollectiveAddonsMandatorySettings: Boolean = false, $withTravelsExtensions: Boolean = false, $withTravelsExtensionsTravelExtension: Boolean = false, $withTravelsExtensionsAccommodationMapItems: Boolean = false, $withTravelsPersonalDiscounts: Boolean = false, $withTravelsPersonalDiscountsMandatorySettings: Boolean = false, $withWebhookConfig: Boolean = false, $withBranding: Boolean = false, $withBrandingLogo: Boolean = false, $withBargainSettings: Boolean = false, $withBargainSettingsBargainTier: Boolean = false, $withEsimSettings: Boolean = false, $withEsimSettingsRegions: Boolean = false, $withPassportConfig: Boolean = false, $withTourOperator: Boolean = false, $withTourOperatorLogo: Boolean = false, $withTourOperatorGtcPdf: Boolean = false) {\n  pricing: travelPricing(id: $id) {\n    id\n    ageGroupSettings @include(if: $withAgeGroupSettings) {\n      id\n      freeUntilAge\n      ageGroups @include(if: $withAgeGroupSettingsAgeGroups) {\n        id\n        name\n        type\n        icon\n        minAge\n        maxAge\n      }\n    }\n    isTravelDocumentationAvailable\n    customDataConfig @include(if: $withCustomDataConfig) {\n      id\n      useTravellerForm\n      travellerForm @include(if: $withCustomDataConfigTravellerForm) {\n        id\n        fields @include(if: $withCustomDataConfigTravellerFormFields) {\n          id\n          inputType\n          name\n          label\n          info\n          value\n          required\n        }\n      }\n      useBookingForm\n      bookingForm @include(if: $withCustomDataConfigBookingForm) {\n        id\n        fields @include(if: $withCustomDataConfigBookingFormFields) {\n          id\n          inputType\n          name\n          label\n          info\n          value\n          required\n        }\n      }\n    }\n    travels @include(if: $withTravels) {\n      id\n      ratioCatalogBundle @include(if: $withTravelsRatioCatalogBundle) {\n        id\n        catalogCode\n        travelCode\n        json\n      }\n      catalogCode\n      travelCode\n      destination\n      name\n      transportType\n      transportTypeLabel\n      dates @include(if: $withTravelsDates) {\n        id\n        dateNo\n        startDate\n        endDate\n        availabilityStatus @include(if: $withTravelsDatesAvailabilityStatus) {\n          id\n          label\n          status\n          isDefaultStatus\n          isDefaultWaitlistFallback\n        }\n        includesExtension\n        extensionBaseDate @include(if: $withTravelsDatesExtensionBaseDate) {\n          id\n          dateNo\n          startDate\n          endDate\n          includesExtension\n          json\n        }\n        extension @include(if: $withTravelsDatesExtension) {\n          id\n          label\n          info\n        }\n        packageSettings @include(if: $withTravelsDatesPackageSettings) {\n          id\n          ratioPackageNo\n          price\n          availabilityStatus\n        }\n        json\n        extensions @include(if: $withTravelsDatesExtensions) {\n          id\n          label\n          info\n        }\n      }\n      accommodations @include(if: $withTravelsAccommodations) {\n        id\n        ratioPackageNo\n        name\n        label\n        info\n        isFamilyPackageAccommodation\n        isBabyPackage\n        capacitySettings @include(if: $withTravelsAccommodationsCapacitySettings) {\n          id\n          totalCapacity\n          rangesAllowed\n          partialOccupancyAllowed\n        }\n        addons @include(if: $withTravelsAccommodationsAddons) {\n          id\n          ratioServiceNo\n          name\n          label\n          info\n        }\n      }\n      extensionAccommodations @include(if: $withTravelsExtensionAccommodations) {\n        id\n        ratioPackageNo\n        name\n        label\n        info\n        extensionAccommodationServiceNo\n      }\n      familyPackages @include(if: $withTravelsFamilyPackages) {\n        id\n        ratioServiceNo\n        accommodation @include(if: $withTravelsFamilyPackagesAccommodation) {\n          id\n          ratioPackageNo\n          name\n          label\n          info\n          isFamilyPackageAccommodation\n          isBabyPackage\n        }\n        name\n        label\n        info\n        capacitySettings @include(if: $withTravelsFamilyPackagesCapacitySettings) {\n          id\n          totalCapacity\n          rangesAllowed\n          partialOccupancyAllowed\n        }\n        addons @include(if: $withTravelsFamilyPackagesAddons) {\n          id\n          ratioServiceNo\n          name\n          label\n          info\n        }\n      }\n      personalAddons @include(if: $withTravelsPersonalAddons) {\n        id\n        ratioServiceNo\n        name\n        label\n        info\n        allowedAgeGroups @include(if: $withTravelsPersonalAddonsAllowedAgeGroups) {\n          id\n          name\n          type\n          icon\n          minAge\n          maxAge\n        }\n        calculationSettings @include(if: $withTravelsPersonalAddonsCalculationSettings) {\n          id\n          type\n          considerHotelNights\n        }\n        mandatorySettings @include(if: $withTravelsPersonalAddonsMandatorySettings) {\n          id\n          isMandatory\n          useRules\n        }\n      }\n      accommodationAddons @include(if: $withTravelsAccommodationAddons) {\n        id\n        ratioServiceNo\n        name\n        label\n        info\n        calculationSettings @include(if: $withTravelsAccommodationAddonsCalculationSettings) {\n          id\n          type\n          considerHotelNights\n        }\n        mandatorySettings @include(if: $withTravelsAccommodationAddonsMandatorySettings) {\n          id\n          isMandatory\n          useRules\n        }\n      }\n      bookingAddons @include(if: $withTravelsBookingAddons) {\n        id\n        ratioServiceNo\n        name\n        label\n        info\n        calculationSettings @include(if: $withTravelsBookingAddonsCalculationSettings) {\n          id\n          type\n          considerHotelNights\n        }\n        mandatorySettings @include(if: $withTravelsBookingAddonsMandatorySettings) {\n          id\n          isMandatory\n          useRules\n        }\n      }\n      collectiveAddons @include(if: $withTravelsCollectiveAddons) {\n        id\n        label\n        info\n        ageGroupServices @include(if: $withTravelsCollectiveAddonsAgeGroupServices) {\n          id\n          ratioServiceNo\n        }\n        calculationSettings @include(if: $withTravelsCollectiveAddonsCalculationSettings) {\n          id\n          type\n          considerHotelNights\n        }\n        mandatorySettings @include(if: $withTravelsCollectiveAddonsMandatorySettings) {\n          id\n          isMandatory\n          useRules\n        }\n      }\n      extensions @include(if: $withTravelsExtensions) {\n        id\n        label\n        info\n        travelExtension @include(if: $withTravelsExtensionsTravelExtension) {\n          id\n          duration\n          name\n          description\n        }\n        accommodationMapItems @include(if: $withTravelsExtensionsAccommodationMapItems) {\n          id\n        }\n      }\n      personalDiscounts @include(if: $withTravelsPersonalDiscounts) {\n        id\n        ratioServiceNo\n        name\n        label\n        info\n        mandatorySettings @include(if: $withTravelsPersonalDiscountsMandatorySettings) {\n          id\n          isMandatory\n          useRules\n        }\n      }\n      importDateTime\n      importStatus\n    }\n    webhookConfig @include(if: $withWebhookConfig) {\n      id\n      enabled\n      url\n    }\n    branding @include(if: $withBranding) {\n      id\n      logo @include(if: $withBrandingLogo) {\n        id\n        assetId\n        publicId\n        url\n        resourceType\n        format\n        width\n        height\n        caption\n        title\n        description\n      }\n      logoWidth\n    }\n    bargainSettings @include(if: $withBargainSettings) {\n      id\n      active\n      untilDaysBeforeStart\n      bargainTier @include(if: $withBargainSettingsBargainTier) {\n        id\n        fromPrice\n        discount\n      }\n    }\n    esimSettings @include(if: $withEsimSettings) {\n      id\n      enabled\n      regions @include(if: $withEsimSettingsRegions) {\n        id\n        name\n        serviceCodePrefix\n      }\n    }\n    passportConfig @include(if: $withPassportConfig) {\n      id\n      passportOnly\n    }\n    tourOperator @include(if: $withTourOperator) {\n      id\n      name\n      url\n      logo @include(if: $withTourOperatorLogo) {\n        id\n        assetId\n        publicId\n        url\n        resourceType\n        format\n        width\n        height\n        caption\n        title\n        description\n      }\n      logoWidth\n      gtcPdf @include(if: $withTourOperatorGtcPdf) {\n        id\n        assetId\n        publicId\n        url\n        resourceType\n        format\n        width\n        height\n        caption\n        title\n        description\n      }\n    }\n  }\n}";
// language=GraphQL
var CREATE_PRICING_MUTATION = "\n  mutation Mutation($input: CreateTravelPricingInput, $withAgeGroupSettings: Boolean = false, $withAgeGroupSettingsAgeGroups: Boolean = false, $withCustomDataConfig: Boolean = false, $withCustomDataConfigTravellerForm: Boolean = false, $withCustomDataConfigTravellerFormFields: Boolean = false, $withCustomDataConfigBookingForm: Boolean = false, $withCustomDataConfigBookingFormFields: Boolean = false, $withTravels: Boolean = false, $withTravelsRatioCatalogBundle: Boolean = false, $withTravelsDates: Boolean = false, $withTravelsDatesAvailabilityStatus: Boolean = false, $withTravelsDatesExtensionBaseDate: Boolean = false, $withTravelsDatesExtension: Boolean = false, $withTravelsDatesPackageSettings: Boolean = false, $withTravelsDatesExtensions: Boolean = false, $withTravelsAccommodations: Boolean = false, $withTravelsAccommodationsCapacitySettings: Boolean = false, $withTravelsAccommodationsAddons: Boolean = false, $withTravelsExtensionAccommodations: Boolean = false, $withTravelsFamilyPackages: Boolean = false, $withTravelsFamilyPackagesAccommodation: Boolean = false, $withTravelsFamilyPackagesCapacitySettings: Boolean = false, $withTravelsFamilyPackagesAddons: Boolean = false, $withTravelsPersonalAddons: Boolean = false, $withTravelsPersonalAddonsAllowedAgeGroups: Boolean = false, $withTravelsPersonalAddonsCalculationSettings: Boolean = false, $withTravelsPersonalAddonsMandatorySettings: Boolean = false, $withTravelsAccommodationAddons: Boolean = false, $withTravelsAccommodationAddonsCalculationSettings: Boolean = false, $withTravelsAccommodationAddonsMandatorySettings: Boolean = false, $withTravelsBookingAddons: Boolean = false, $withTravelsBookingAddonsCalculationSettings: Boolean = false, $withTravelsBookingAddonsMandatorySettings: Boolean = false, $withTravelsCollectiveAddons: Boolean = false, $withTravelsCollectiveAddonsAgeGroupServices: Boolean = false, $withTravelsCollectiveAddonsCalculationSettings: Boolean = false, $withTravelsCollectiveAddonsMandatorySettings: Boolean = false, $withTravelsExtensions: Boolean = false, $withTravelsExtensionsTravelExtension: Boolean = false, $withTravelsExtensionsAccommodationMapItems: Boolean = false, $withTravelsPersonalDiscounts: Boolean = false, $withTravelsPersonalDiscountsMandatorySettings: Boolean = false, $withWebhookConfig: Boolean = false, $withBranding: Boolean = false, $withBrandingLogo: Boolean = false, $withBargainSettings: Boolean = false, $withBargainSettingsBargainTier: Boolean = false, $withEsimSettings: Boolean = false, $withEsimSettingsRegions: Boolean = false, $withPassportConfig: Boolean = false, $withTourOperator: Boolean = false, $withTourOperatorLogo: Boolean = false, $withTourOperatorGtcPdf: Boolean = false) {\n    pricing: createTravelPricing(input: $input) {\n      id\n      ageGroupSettings @include(if: $withAgeGroupSettings) {\n        id\n        freeUntilAge\n        ageGroups @include(if: $withAgeGroupSettingsAgeGroups) {\n          id\n          name\n          type\n          icon\n          minAge\n          maxAge\n        }\n      }\n      isTravelDocumentationAvailable\n      customDataConfig @include(if: $withCustomDataConfig) {\n        id\n        useTravellerForm\n        travellerForm @include(if: $withCustomDataConfigTravellerForm) {\n          id\n          fields @include(if: $withCustomDataConfigTravellerFormFields) {\n            id\n            inputType\n            name\n            label\n            info\n            value\n            required\n          }\n        }\n        useBookingForm\n        bookingForm @include(if: $withCustomDataConfigBookingForm) {\n          id\n          fields @include(if: $withCustomDataConfigBookingFormFields) {\n            id\n            inputType\n            name\n            label\n            info\n            value\n            required\n          }\n        }\n      }\n      travels @include(if: $withTravels) {\n        id\n        ratioCatalogBundle @include(if: $withTravelsRatioCatalogBundle) {\n          id\n          catalogCode\n          travelCode\n          json\n        }\n        catalogCode\n        travelCode\n        destination\n        name\n        transportType\n        transportTypeLabel\n        dates @include(if: $withTravelsDates) {\n          id\n          dateNo\n          startDate\n          endDate\n          availabilityStatus @include(if: $withTravelsDatesAvailabilityStatus) {\n            id\n            label\n            status\n            isDefaultStatus\n            isDefaultWaitlistFallback\n          }\n          includesExtension\n          extensionBaseDate @include(if: $withTravelsDatesExtensionBaseDate) {\n            id\n            dateNo\n            startDate\n            endDate\n            includesExtension\n            json\n          }\n          extension @include(if: $withTravelsDatesExtension) {\n            id\n            label\n            info\n          }\n          packageSettings @include(if: $withTravelsDatesPackageSettings) {\n            id\n            ratioPackageNo\n            price\n            availabilityStatus\n          }\n          json\n          extensions @include(if: $withTravelsDatesExtensions) {\n            id\n            label\n            info\n          }\n        }\n        accommodations @include(if: $withTravelsAccommodations) {\n          id\n          ratioPackageNo\n          name\n          label\n          info\n          isFamilyPackageAccommodation\n          isBabyPackage\n          capacitySettings @include(if: $withTravelsAccommodationsCapacitySettings) {\n            id\n            totalCapacity\n            rangesAllowed\n            partialOccupancyAllowed\n          }\n          addons @include(if: $withTravelsAccommodationsAddons) {\n            id\n            ratioServiceNo\n            name\n            label\n            info\n          }\n        }\n        extensionAccommodations @include(if: $withTravelsExtensionAccommodations) {\n          id\n          ratioPackageNo\n          name\n          label\n          info\n          extensionAccommodationServiceNo\n        }\n        familyPackages @include(if: $withTravelsFamilyPackages) {\n          id\n          ratioServiceNo\n          accommodation @include(if: $withTravelsFamilyPackagesAccommodation) {\n            id\n            ratioPackageNo\n            name\n            label\n            info\n            isFamilyPackageAccommodation\n            isBabyPackage\n          }\n          name\n          label\n          info\n          capacitySettings @include(if: $withTravelsFamilyPackagesCapacitySettings) {\n            id\n            totalCapacity\n            rangesAllowed\n            partialOccupancyAllowed\n          }\n          addons @include(if: $withTravelsFamilyPackagesAddons) {\n            id\n            ratioServiceNo\n            name\n            label\n            info\n          }\n        }\n        personalAddons @include(if: $withTravelsPersonalAddons) {\n          id\n          ratioServiceNo\n          name\n          label\n          info\n          allowedAgeGroups @include(if: $withTravelsPersonalAddonsAllowedAgeGroups) {\n            id\n            name\n            type\n            icon\n            minAge\n            maxAge\n          }\n          calculationSettings @include(if: $withTravelsPersonalAddonsCalculationSettings) {\n            id\n            type\n            considerHotelNights\n          }\n          mandatorySettings @include(if: $withTravelsPersonalAddonsMandatorySettings) {\n            id\n            isMandatory\n            useRules\n          }\n        }\n        accommodationAddons @include(if: $withTravelsAccommodationAddons) {\n          id\n          ratioServiceNo\n          name\n          label\n          info\n          calculationSettings @include(if: $withTravelsAccommodationAddonsCalculationSettings) {\n            id\n            type\n            considerHotelNights\n          }\n          mandatorySettings @include(if: $withTravelsAccommodationAddonsMandatorySettings) {\n            id\n            isMandatory\n            useRules\n          }\n        }\n        bookingAddons @include(if: $withTravelsBookingAddons) {\n          id\n          ratioServiceNo\n          name\n          label\n          info\n          calculationSettings @include(if: $withTravelsBookingAddonsCalculationSettings) {\n            id\n            type\n            considerHotelNights\n          }\n          mandatorySettings @include(if: $withTravelsBookingAddonsMandatorySettings) {\n            id\n            isMandatory\n            useRules\n          }\n        }\n        collectiveAddons @include(if: $withTravelsCollectiveAddons) {\n          id\n          label\n          info\n          ageGroupServices @include(if: $withTravelsCollectiveAddonsAgeGroupServices) {\n            id\n            ratioServiceNo\n          }\n          calculationSettings @include(if: $withTravelsCollectiveAddonsCalculationSettings) {\n            id\n            type\n            considerHotelNights\n          }\n          mandatorySettings @include(if: $withTravelsCollectiveAddonsMandatorySettings) {\n            id\n            isMandatory\n            useRules\n          }\n        }\n        extensions @include(if: $withTravelsExtensions) {\n          id\n          label\n          info\n          travelExtension @include(if: $withTravelsExtensionsTravelExtension) {\n            id\n            duration\n            name\n            description\n          }\n          accommodationMapItems @include(if: $withTravelsExtensionsAccommodationMapItems) {\n            id\n          }\n        }\n        personalDiscounts @include(if: $withTravelsPersonalDiscounts) {\n          id\n          ratioServiceNo\n          name\n          label\n          info\n          mandatorySettings @include(if: $withTravelsPersonalDiscountsMandatorySettings) {\n            id\n            isMandatory\n            useRules\n          }\n        }\n        importDateTime\n        importStatus\n      }\n      webhookConfig @include(if: $withWebhookConfig) {\n        id\n        enabled\n        url\n      }\n      branding @include(if: $withBranding) {\n        id\n        logo @include(if: $withBrandingLogo) {\n          id\n          assetId\n          publicId\n          url\n          resourceType\n          format\n          width\n          height\n          caption\n          title\n          description\n        }\n        logoWidth\n      }\n      bargainSettings @include(if: $withBargainSettings) {\n        id\n        active\n        untilDaysBeforeStart\n        bargainTier @include(if: $withBargainSettingsBargainTier) {\n          id\n          fromPrice\n          discount\n        }\n      }\n      esimSettings @include(if: $withEsimSettings) {\n        id\n        enabled\n        regions @include(if: $withEsimSettingsRegions) {\n          id\n          name\n          serviceCodePrefix\n        }\n      }\n      passportConfig @include(if: $withPassportConfig) {\n        id\n        passportOnly\n      }\n      tourOperator @include(if: $withTourOperator) {\n        id\n        name\n        url\n        logo @include(if: $withTourOperatorLogo) {\n          id\n          assetId\n          publicId\n          url\n          resourceType\n          format\n          width\n          height\n          caption\n          title\n          description\n        }\n        logoWidth\n        gtcPdf @include(if: $withTourOperatorGtcPdf) {\n          id\n          assetId\n          publicId\n          url\n          resourceType\n          format\n          width\n          height\n          caption\n          title\n          description\n        }\n      }\n    }\n  }";
// language=GraphQL
var UPDATE_PRICING_MUTATION = "\n  mutation Mutation($input: UpdateTravelPricingInput, $withAgeGroupSettings: Boolean = false, $withAgeGroupSettingsAgeGroups: Boolean = false, $withCustomDataConfig: Boolean = false, $withCustomDataConfigTravellerForm: Boolean = false, $withCustomDataConfigTravellerFormFields: Boolean = false, $withCustomDataConfigBookingForm: Boolean = false, $withCustomDataConfigBookingFormFields: Boolean = false, $withTravels: Boolean = false, $withTravelsRatioCatalogBundle: Boolean = false, $withTravelsDates: Boolean = false, $withTravelsDatesAvailabilityStatus: Boolean = false, $withTravelsDatesExtensionBaseDate: Boolean = false, $withTravelsDatesExtension: Boolean = false, $withTravelsDatesPackageSettings: Boolean = false, $withTravelsDatesExtensions: Boolean = false, $withTravelsAccommodations: Boolean = false, $withTravelsAccommodationsCapacitySettings: Boolean = false, $withTravelsAccommodationsAddons: Boolean = false, $withTravelsExtensionAccommodations: Boolean = false, $withTravelsFamilyPackages: Boolean = false, $withTravelsFamilyPackagesAccommodation: Boolean = false, $withTravelsFamilyPackagesCapacitySettings: Boolean = false, $withTravelsFamilyPackagesAddons: Boolean = false, $withTravelsPersonalAddons: Boolean = false, $withTravelsPersonalAddonsAllowedAgeGroups: Boolean = false, $withTravelsPersonalAddonsCalculationSettings: Boolean = false, $withTravelsPersonalAddonsMandatorySettings: Boolean = false, $withTravelsAccommodationAddons: Boolean = false, $withTravelsAccommodationAddonsCalculationSettings: Boolean = false, $withTravelsAccommodationAddonsMandatorySettings: Boolean = false, $withTravelsBookingAddons: Boolean = false, $withTravelsBookingAddonsCalculationSettings: Boolean = false, $withTravelsBookingAddonsMandatorySettings: Boolean = false, $withTravelsCollectiveAddons: Boolean = false, $withTravelsCollectiveAddonsAgeGroupServices: Boolean = false, $withTravelsCollectiveAddonsCalculationSettings: Boolean = false, $withTravelsCollectiveAddonsMandatorySettings: Boolean = false, $withTravelsExtensions: Boolean = false, $withTravelsExtensionsTravelExtension: Boolean = false, $withTravelsExtensionsAccommodationMapItems: Boolean = false, $withTravelsPersonalDiscounts: Boolean = false, $withTravelsPersonalDiscountsMandatorySettings: Boolean = false, $withWebhookConfig: Boolean = false, $withBranding: Boolean = false, $withBrandingLogo: Boolean = false, $withBargainSettings: Boolean = false, $withBargainSettingsBargainTier: Boolean = false, $withEsimSettings: Boolean = false, $withEsimSettingsRegions: Boolean = false, $withPassportConfig: Boolean = false, $withTourOperator: Boolean = false, $withTourOperatorLogo: Boolean = false, $withTourOperatorGtcPdf: Boolean = false) {\n    pricing: updateTravelPricing(input: $input) {\n      id\n      ageGroupSettings @include(if: $withAgeGroupSettings) {\n        id\n        freeUntilAge\n        ageGroups @include(if: $withAgeGroupSettingsAgeGroups) {\n          id\n          name\n          type\n          icon\n          minAge\n          maxAge\n        }\n      }\n      isTravelDocumentationAvailable\n      customDataConfig @include(if: $withCustomDataConfig) {\n        id\n        useTravellerForm\n        travellerForm @include(if: $withCustomDataConfigTravellerForm) {\n          id\n          fields @include(if: $withCustomDataConfigTravellerFormFields) {\n            id\n            inputType\n            name\n            label\n            info\n            value\n            required\n          }\n        }\n        useBookingForm\n        bookingForm @include(if: $withCustomDataConfigBookingForm) {\n          id\n          fields @include(if: $withCustomDataConfigBookingFormFields) {\n            id\n            inputType\n            name\n            label\n            info\n            value\n            required\n          }\n        }\n      }\n      travels @include(if: $withTravels) {\n        id\n        ratioCatalogBundle @include(if: $withTravelsRatioCatalogBundle) {\n          id\n          catalogCode\n          travelCode\n          json\n        }\n        catalogCode\n        travelCode\n        destination\n        name\n        transportType\n        transportTypeLabel\n        dates @include(if: $withTravelsDates) {\n          id\n          dateNo\n          startDate\n          endDate\n          availabilityStatus @include(if: $withTravelsDatesAvailabilityStatus) {\n            id\n            label\n            status\n            isDefaultStatus\n            isDefaultWaitlistFallback\n          }\n          includesExtension\n          extensionBaseDate @include(if: $withTravelsDatesExtensionBaseDate) {\n            id\n            dateNo\n            startDate\n            endDate\n            includesExtension\n            json\n          }\n          extension @include(if: $withTravelsDatesExtension) {\n            id\n            label\n            info\n          }\n          packageSettings @include(if: $withTravelsDatesPackageSettings) {\n            id\n            ratioPackageNo\n            price\n            availabilityStatus\n          }\n          json\n          extensions @include(if: $withTravelsDatesExtensions) {\n            id\n            label\n            info\n          }\n        }\n        accommodations @include(if: $withTravelsAccommodations) {\n          id\n          ratioPackageNo\n          name\n          label\n          info\n          isFamilyPackageAccommodation\n          isBabyPackage\n          capacitySettings @include(if: $withTravelsAccommodationsCapacitySettings) {\n            id\n            totalCapacity\n            rangesAllowed\n            partialOccupancyAllowed\n          }\n          addons @include(if: $withTravelsAccommodationsAddons) {\n            id\n            ratioServiceNo\n            name\n            label\n            info\n          }\n        }\n        extensionAccommodations @include(if: $withTravelsExtensionAccommodations) {\n          id\n          ratioPackageNo\n          name\n          label\n          info\n          extensionAccommodationServiceNo\n        }\n        familyPackages @include(if: $withTravelsFamilyPackages) {\n          id\n          ratioServiceNo\n          accommodation @include(if: $withTravelsFamilyPackagesAccommodation) {\n            id\n            ratioPackageNo\n            name\n            label\n            info\n            isFamilyPackageAccommodation\n            isBabyPackage\n          }\n          name\n          label\n          info\n          capacitySettings @include(if: $withTravelsFamilyPackagesCapacitySettings) {\n            id\n            totalCapacity\n            rangesAllowed\n            partialOccupancyAllowed\n          }\n          addons @include(if: $withTravelsFamilyPackagesAddons) {\n            id\n            ratioServiceNo\n            name\n            label\n            info\n          }\n        }\n        personalAddons @include(if: $withTravelsPersonalAddons) {\n          id\n          ratioServiceNo\n          name\n          label\n          info\n          allowedAgeGroups @include(if: $withTravelsPersonalAddonsAllowedAgeGroups) {\n            id\n            name\n            type\n            icon\n            minAge\n            maxAge\n          }\n          calculationSettings @include(if: $withTravelsPersonalAddonsCalculationSettings) {\n            id\n            type\n            considerHotelNights\n          }\n          mandatorySettings @include(if: $withTravelsPersonalAddonsMandatorySettings) {\n            id\n            isMandatory\n            useRules\n          }\n        }\n        accommodationAddons @include(if: $withTravelsAccommodationAddons) {\n          id\n          ratioServiceNo\n          name\n          label\n          info\n          calculationSettings @include(if: $withTravelsAccommodationAddonsCalculationSettings) {\n            id\n            type\n            considerHotelNights\n          }\n          mandatorySettings @include(if: $withTravelsAccommodationAddonsMandatorySettings) {\n            id\n            isMandatory\n            useRules\n          }\n        }\n        bookingAddons @include(if: $withTravelsBookingAddons) {\n          id\n          ratioServiceNo\n          name\n          label\n          info\n          calculationSettings @include(if: $withTravelsBookingAddonsCalculationSettings) {\n            id\n            type\n            considerHotelNights\n          }\n          mandatorySettings @include(if: $withTravelsBookingAddonsMandatorySettings) {\n            id\n            isMandatory\n            useRules\n          }\n        }\n        collectiveAddons @include(if: $withTravelsCollectiveAddons) {\n          id\n          label\n          info\n          ageGroupServices @include(if: $withTravelsCollectiveAddonsAgeGroupServices) {\n            id\n            ratioServiceNo\n          }\n          calculationSettings @include(if: $withTravelsCollectiveAddonsCalculationSettings) {\n            id\n            type\n            considerHotelNights\n          }\n          mandatorySettings @include(if: $withTravelsCollectiveAddonsMandatorySettings) {\n            id\n            isMandatory\n            useRules\n          }\n        }\n        extensions @include(if: $withTravelsExtensions) {\n          id\n          label\n          info\n          travelExtension @include(if: $withTravelsExtensionsTravelExtension) {\n            id\n            duration\n            name\n            description\n          }\n          accommodationMapItems @include(if: $withTravelsExtensionsAccommodationMapItems) {\n            id\n          }\n        }\n        personalDiscounts @include(if: $withTravelsPersonalDiscounts) {\n          id\n          ratioServiceNo\n          name\n          label\n          info\n          mandatorySettings @include(if: $withTravelsPersonalDiscountsMandatorySettings) {\n            id\n            isMandatory\n            useRules\n          }\n        }\n        importDateTime\n        importStatus\n      }\n      webhookConfig @include(if: $withWebhookConfig) {\n        id\n        enabled\n        url\n      }\n      branding @include(if: $withBranding) {\n        id\n        logo @include(if: $withBrandingLogo) {\n          id\n          assetId\n          publicId\n          url\n          resourceType\n          format\n          width\n          height\n          caption\n          title\n          description\n        }\n        logoWidth\n      }\n      bargainSettings @include(if: $withBargainSettings) {\n        id\n        active\n        untilDaysBeforeStart\n        bargainTier @include(if: $withBargainSettingsBargainTier) {\n          id\n          fromPrice\n          discount\n        }\n      }\n      esimSettings @include(if: $withEsimSettings) {\n        id\n        enabled\n        regions @include(if: $withEsimSettingsRegions) {\n          id\n          name\n          serviceCodePrefix\n        }\n      }\n      passportConfig @include(if: $withPassportConfig) {\n        id\n        passportOnly\n      }\n      tourOperator @include(if: $withTourOperator) {\n        id\n        name\n        url\n        logo @include(if: $withTourOperatorLogo) {\n          id\n          assetId\n          publicId\n          url\n          resourceType\n          format\n          width\n          height\n          caption\n          title\n          description\n        }\n        logoWidth\n        gtcPdf @include(if: $withTourOperatorGtcPdf) {\n          id\n          assetId\n          publicId\n          url\n          resourceType\n          format\n          width\n          height\n          caption\n          title\n          description\n        }\n      }\n    }\n  }";
// language=GraphQL
var DELETE_PRICING_MUTATION = "\n  mutation Mutation($input: DeleteTravelPricingInput) {\n    deleteTravelPricing(input: $input) {\n      success\n    }\n  }";
// language=GraphQL
var FORCE_DELETE_PRICING_MUTATION = "\n  mutation Mutation($input: DeleteTravelPricingInput) {\n    forceDeleteTravelPricing(input: $input) {\n      success\n    }\n  }";
// language=GraphQL
var ADD_PRICING_TRAVELS_MUTATION = "\n  mutation Mutation($input: addTravelPricingTravelsInput) {\n    addTravelPricingTravels(input: $input) {\n      id\n      travelIds\n    }\n  }";
// language=GraphQL
var REMOVE_PRICING_TRAVELS_MUTATION = "\n  mutation Mutation($input: removeTravelPricingTravelsInput) {\n    removeTravelPricingTravels(input: $input) {\n      id\n      travelIds\n    }\n  }";
// language=GraphQL
var CREATE_PRICING_TRAVELS_MUTATION = "\n  mutation Mutation($input: createTravelPricingTravelsInput) {\n    createTravelPricingTravels(input: $input) {\n      id\n      travelIds\n    }\n  }";
// language=GraphQL
var DELETE_PRICING_TRAVELS_MUTATION = "\n  mutation Mutation($input: deleteTravelPricingTravelsInput) {\n    deleteTravelPricingTravels(input: $input) {\n      id\n      travelIds\n    }\n  }";
// language=GraphQL
var PRICINGS_DEPENDENTS_QUERY = "query Query($id: ID!, $withTravels: Boolean = false) {\n  groupedDependents: travelPricingDependents(id: $id) {\n    travels @include(if: $withTravels) {\n      id\n      name\n      isBestseller\n      startDate\n      endDate\n      executionStatus\n      title\n      description\n      includedServices\n      excludedServices\n      pricingTable\n      priceCalculationInfo\n      programType\n      programText\n      minPrice\n      minPriceManualOverride\n      currency    }\n  }\n}";

// EXTERNAL MODULE: ./src/entities/travelPricingAgeGroupSettings/entity.ts + 3 modules
var entity = __webpack_require__(26189);
// EXTERNAL MODULE: ./src/entities/travelPricingCustomDataConfig/entity.ts + 3 modules
var travelPricingCustomDataConfig_entity = __webpack_require__(43347);
// EXTERNAL MODULE: ./src/entities/ratioTravel/entity.ts + 3 modules
var ratioTravel_entity = __webpack_require__(81065);
// EXTERNAL MODULE: ./src/entities/travelWebhookConfig/entity.ts + 3 modules
var travelWebhookConfig_entity = __webpack_require__(39393);
// EXTERNAL MODULE: ./src/entities/travelPricingBranding/entity.ts + 3 modules
var travelPricingBranding_entity = __webpack_require__(12978);
// EXTERNAL MODULE: ./src/entities/travelBargainSettings/entity.ts + 3 modules
var travelBargainSettings_entity = __webpack_require__(58824);
// EXTERNAL MODULE: ./src/entities/travelEsimSettings/entity.ts + 3 modules
var travelEsimSettings_entity = __webpack_require__(80447);
// EXTERNAL MODULE: ./src/entities/travelPricingPassportConfig/entity.ts + 3 modules
var travelPricingPassportConfig_entity = __webpack_require__(38339);
// EXTERNAL MODULE: ./src/entities/travelPartner/entity.ts + 3 modules
var travelPartner_entity = __webpack_require__(52889);
;// CONCATENATED MODULE: ./src/entities/travelPricing/model.ts










var travelPricingModel = {
    name: "pricing",
    namePlural: "pricings",
    uniqueName: "travelPricing",
    uniqueNamePlural: "travelPricings",
    path: "travel/pricing/pricing",
    baseUrl: "/travel/pricing/pricings",
    translationPrefix: "entities:travelPricing.",
    getDisplayName: function(values) {
        return "Pricing";
    },
    gql: {
        getAll: ALL_PRICINGS_QUERY,
        getSingle: SINGLE_PRICING_QUERY,
        create: CREATE_PRICING_MUTATION,
        update: UPDATE_PRICING_MUTATION,
        delete: DELETE_PRICING_MUTATION,
        forceDelete: FORCE_DELETE_PRICING_MUTATION
    },
    attributes: {
        ageGroupSettings: {
            name: "ageGroupSettings",
            label: "entities:travelPricing.attributes.ageGroupSettings.label",
            type: "entityObject",
            dataType: "any",
            getEntity: function() {
                return entity/* default */.Z;
            },
            defaultInput: false,
            inputType: "select",
            validationType: "string",
            validations: []
        },
        isTravelDocumentationAvailable: {
            name: "isTravelDocumentationAvailable",
            label: "entities:travelPricing.attributes.isTravelDocumentationAvailable.label",
            type: "value",
            dataType: "boolean",
            defaultInput: true,
            inputType: "switch",
            validationType: "string",
            validations: []
        },
        customDataConfig: {
            name: "customDataConfig",
            label: "entities:travelPricing.attributes.customDataConfig.label",
            type: "entityObject",
            dataType: "any",
            getEntity: function() {
                return travelPricingCustomDataConfig_entity/* default */.Z;
            },
            defaultInput: false,
            inputType: "select",
            validationType: "string",
            validations: []
        },
        travels: {
            name: "travels",
            label: "entities:travelPricing.attributes.travels.label",
            type: "entityCollection",
            dataType: "[any]",
            getEntity: function() {
                return ratioTravel_entity/* default */.Z;
            },
            defaultInput: false,
            inputType: "text",
            validationType: "string",
            validations: []
        },
        webhookConfig: {
            name: "webhookConfig",
            label: "entities:travelPricing.attributes.webhookConfig.label",
            type: "entityObject",
            dataType: "any",
            getEntity: function() {
                return travelWebhookConfig_entity/* default */.Z;
            },
            defaultInput: true,
            inputType: "select",
            validationType: "string",
            validations: []
        },
        branding: {
            name: "branding",
            label: "entities:travelPricing.attributes.branding.label",
            type: "entityObject",
            dataType: "any",
            getEntity: function() {
                return travelPricingBranding_entity/* default */.Z;
            },
            defaultInput: false,
            inputType: "select",
            validationType: "string",
            validations: []
        },
        bargainSettings: {
            name: "bargainSettings",
            label: "entities:travelPricing.attributes.bargainSettings.label",
            type: "entityObject",
            dataType: "any",
            getEntity: function() {
                return travelBargainSettings_entity/* default */.Z;
            },
            defaultInput: false,
            inputType: "select",
            validationType: "string",
            validations: []
        },
        esimSettings: {
            name: "esimSettings",
            label: "entities:travelPricing.attributes.esimSettings.label",
            type: "entityObject",
            dataType: "any",
            getEntity: function() {
                return travelEsimSettings_entity/* default */.Z;
            },
            defaultInput: false,
            inputType: "select",
            validationType: "string",
            validations: []
        },
        passportConfig: {
            name: "passportConfig",
            label: "entities:travelPricing.attributes.passportConfig.label",
            type: "entityObject",
            dataType: "any",
            getEntity: function() {
                return travelPricingPassportConfig_entity/* default */.Z;
            },
            defaultInput: true,
            inputType: "select",
            validationType: "string",
            validations: []
        },
        tourOperator: {
            name: "tourOperator",
            label: "entities:travelPricing.attributes.tourOperator.label",
            type: "entityObject",
            dataType: "any",
            getEntity: function() {
                return travelPartner_entity/* default */.Z;
            },
            defaultInput: false,
            inputType: "select",
            validationType: "string",
            validations: []
        }
    }
};
/* harmony default export */ var model = (travelPricingModel);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(20414);
// EXTERNAL MODULE: ./src/entities/lib.ts
var lib = __webpack_require__(23480);
// EXTERNAL MODULE: ./src/lib/api/graphQLClient.ts
var graphQLClient = __webpack_require__(40112);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/swr/dist/index.mjs
var dist = __webpack_require__(8100);
// EXTERNAL MODULE: ./src/lib/helpers/helpers.ts
var helpers = __webpack_require__(15778);
;// CONCATENATED MODULE: ./src/entities/travelPricing/repository.ts










var hydrateObjects = function(objects) {
    return objects.map(function(object) {
        return (0,lib/* hydrateEntityObject */.b)(model, object);
    });
};
var hydrateObject = function(object) {
    return (0,lib/* hydrateEntityObject */.b)(model, object);
};
var travelPricingRepository = {
    getObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    id: id
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(SINGLE_PRICING_QUERY, variables).then(function(data) {
                        return hydrateObject(data.pricing);
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }(),
    getObjects: /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        var includes;
        var _arguments = arguments;
        return (0,tslib_es6.__generator)(this, function(_state) {
            includes = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : {};
            return [
                2,
                graphQLClient/* default.request */.Z.request(ALL_PRICINGS_QUERY, includes).then(function(data) {
                    return hydrateObjects(data.pricings);
                })
            ];
        });
    }),
    useObject: function(id) {
        var includes = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        // eslint-disable-next-line react-hooks/exhaustive-deps
        var variables = (0,react.useMemo)(function() {
            return (0,_object_spread/* default */.Z)({
                id: id
            }, includes);
        }, [
            id
        ]);
        var ref = (0,dist/* default */.ZP)([
            SINGLE_PRICING_QUERY,
            variables
        ], {
            revalidateOnFocus: false
        }), data = ref.data, error = ref.error, mutate = ref.mutate;
        return {
            object: !data ? data : hydrateObject(data.pricing),
            isLoading: !error && !data,
            isError: error,
            mutate: mutate
        };
    },
    useObjects: function() {
        var includes = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        // eslint-disable-next-line react-hooks/exhaustive-deps
        var variables = (0,react.useMemo)(function() {
            return includes;
        }, []);
        var ref = (0,dist/* default */.ZP)([
            ALL_PRICINGS_QUERY,
            variables
        ]), data = ref.data, error = ref.error, mutate = ref.mutate;
        return {
            objects: !data ? data : hydrateObjects(data.pricings),
            isLoading: !error && !data,
            isError: error,
            mutate: mutate
        };
    },
    getDependents: function(id, includes) {
        var includeVars = {};
        includes.forEach(function(include) {
            includeVars["with".concat((0,helpers/* uppercaseFirst */.AB)(include))] = true;
        });
        var variables = (0,_object_spread/* default */.Z)({
            id: id
        }, includeVars);
        return graphQLClient/* default.request */.Z.request(PRICINGS_DEPENDENTS_QUERY, variables).then(function(data) {
            return data.groupedDependents;
        });
    },
    useDependents: function(id, includes) {
        var includeVars = {};
        includes.forEach(function(include) {
            includeVars["with".concat((0,helpers/* uppercaseFirst */.AB)(include))] = true;
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
        var variables = (0,react.useMemo)(function() {
            return (0,_object_spread/* default */.Z)({
                id: id
            }, includeVars);
        }, [
            id
        ]);
        var ref = (0,dist/* default */.ZP)([
            PRICINGS_DEPENDENTS_QUERY,
            variables
        ], {
            revalidateOnFocus: false
        }), data = ref.data, error = ref.error, mutate = ref.mutate;
        return {
            data: !data ? data : data.groupedDependents,
            isLoading: !error && !data,
            isError: error,
            mutate: mutate
        };
    },
    createObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(data) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    input: data
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(CREATE_PRICING_MUTATION, variables).then(function(data) {
                        return hydrateObject(data.pricing);
                    })
                ];
            });
        });
        return function(data) {
            return _ref.apply(this, arguments);
        };
    }(),
    updateObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(data) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    input: data
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(UPDATE_PRICING_MUTATION, variables).then(function(data) {
                        return hydrateObject(data.pricing);
                    })
                ];
            });
        });
        return function(data) {
            return _ref.apply(this, arguments);
        };
    }(),
    deleteObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(DELETE_PRICING_MUTATION, variables).then(function(data) {
                        return data.deleteTravelPricing;
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }(),
    forceDeleteObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(FORCE_DELETE_PRICING_MUTATION, variables).then(function(data) {
                        return data.forceDeleteTravelPricing;
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }(),
    assignTravels: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, itemIds) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        travelIds: itemIds
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(ADD_PRICING_TRAVELS_MUTATION, variables)
                ];
            });
        });
        return function(id, itemIds) {
            return _ref.apply(this, arguments);
        };
    }(),
    unassignTravels: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, itemIds) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        travelIds: itemIds
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(REMOVE_PRICING_TRAVELS_MUTATION, variables)
                ];
            });
        });
        return function(id, itemIds) {
            return _ref.apply(this, arguments);
        };
    }(),
    createTravels: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, items) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        travels: items
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(CREATE_PRICING_TRAVELS_MUTATION, variables)
                ];
            });
        });
        return function(id, items) {
            return _ref.apply(this, arguments);
        };
    }(),
    deleteTravels: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, itemIds) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        travelIds: itemIds
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(DELETE_PRICING_TRAVELS_MUTATION, variables)
                ];
            });
        });
        return function(id, itemIds) {
            return _ref.apply(this, arguments);
        };
    }()
};
/* harmony default export */ var repository = (travelPricingRepository);

;// CONCATENATED MODULE: ./src/entities/travelPricing/entity.ts


var travelPricingEntity = {
    model: model,
    repository: repository
};
/* harmony default export */ var travelPricing_entity = (travelPricingEntity);


/***/ }),

/***/ 86791:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ entity; }
});

;// CONCATENATED MODULE: ./src/entities/travelPricingAgeFilter/graphql.ts
// language=GraphQL
var ALL_AGE_FILTERS_QUERY = "query Query {\n  ageFilters: travelPricingAgeFilters {\n    id\n    minAge\n    maxAge\n  }\n}";
// language=GraphQL
var SINGLE_AGE_FILTER_QUERY = "query Query($id: ID!) {\n  ageFilter: travelPricingAgeFilter(id: $id) {\n    id\n    minAge\n    maxAge\n  }\n}";
// language=GraphQL
var CREATE_AGE_FILTER_MUTATION = "\n  mutation Mutation($input: CreateTravelPricingAgeFilterInput) {\n    ageFilter: createTravelPricingAgeFilter(input: $input) {\n      id\n      minAge\n      maxAge\n    }\n  }";
// language=GraphQL
var UPDATE_AGE_FILTER_MUTATION = "\n  mutation Mutation($input: UpdateTravelPricingAgeFilterInput) {\n    ageFilter: updateTravelPricingAgeFilter(input: $input) {\n      id\n      minAge\n      maxAge\n    }\n  }";
// language=GraphQL
var DELETE_AGE_FILTER_MUTATION = "\n  mutation Mutation($input: DeleteTravelPricingAgeFilterInput) {\n    deleteTravelPricingAgeFilter(input: $input) {\n      success\n    }\n  }";
// language=GraphQL
var FORCE_DELETE_AGE_FILTER_MUTATION = "\n  mutation Mutation($input: DeleteTravelPricingAgeFilterInput) {\n    forceDeleteTravelPricingAgeFilter(input: $input) {\n      success\n    }\n  }";
// language=GraphQL
var AGE_FILTERS_DEPENDENTS_QUERY = "query Query($id: ID!, $withTravelPricingRules: Boolean = false) {\n  groupedDependents: travelPricingAgeFilterDependents(id: $id) {\n    travelPricingRules @include(if: $withTravelPricingRules) {\n      id\n      checkAccommodationTypes\n      checkAccommodationAddons\n      checkAgeGroups\n      useAgeFilter\n      checkDateRange\n      startDate\n      endDate\n      checkTravelDate\n    }\n  }\n}";

;// CONCATENATED MODULE: ./src/entities/travelPricingAgeFilter/model.ts

var travelPricingAgeFilterModel = {
    name: "ageFilter",
    namePlural: "ageFilters",
    uniqueName: "travelPricingAgeFilter",
    uniqueNamePlural: "travelPricingAgeFilters",
    path: "travel/pricing/age_filter",
    baseUrl: "/travel/pricing/age_filters",
    translationPrefix: "entities:travelPricingAgeFilter.",
    getDisplayName: function(values) {
        return "Age Filter";
    },
    gql: {
        getAll: ALL_AGE_FILTERS_QUERY,
        getSingle: SINGLE_AGE_FILTER_QUERY,
        create: CREATE_AGE_FILTER_MUTATION,
        update: UPDATE_AGE_FILTER_MUTATION,
        delete: DELETE_AGE_FILTER_MUTATION,
        forceDelete: FORCE_DELETE_AGE_FILTER_MUTATION
    },
    attributes: {
        minAge: {
            name: "minAge",
            label: "entities:travelPricingAgeFilter.attributes.minAge.label",
            type: "value",
            dataType: "number",
            defaultInput: true,
            inputType: "text",
            validationType: "string",
            validations: [
                {
                    type: "required"
                },
                {
                    type: "number"
                }, 
            ]
        },
        maxAge: {
            name: "maxAge",
            label: "entities:travelPricingAgeFilter.attributes.maxAge.label",
            type: "value",
            dataType: "number",
            defaultInput: true,
            inputType: "text",
            validationType: "string",
            validations: [
                {
                    type: "required"
                },
                {
                    type: "number"
                }, 
            ]
        }
    }
};
/* harmony default export */ var model = (travelPricingAgeFilterModel);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(20414);
// EXTERNAL MODULE: ./src/entities/lib.ts
var lib = __webpack_require__(23480);
// EXTERNAL MODULE: ./src/lib/api/graphQLClient.ts
var graphQLClient = __webpack_require__(40112);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/swr/dist/index.mjs
var dist = __webpack_require__(8100);
// EXTERNAL MODULE: ./src/lib/helpers/helpers.ts
var helpers = __webpack_require__(15778);
;// CONCATENATED MODULE: ./src/entities/travelPricingAgeFilter/repository.ts










var hydrateObjects = function(objects) {
    return objects.map(function(object) {
        return (0,lib/* hydrateEntityObject */.b)(model, object);
    });
};
var hydrateObject = function(object) {
    return (0,lib/* hydrateEntityObject */.b)(model, object);
};
var travelPricingAgeFilterRepository = {
    getObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    id: id
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(SINGLE_AGE_FILTER_QUERY, variables).then(function(data) {
                        return hydrateObject(data.ageFilter);
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }(),
    getObjects: /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        var includes;
        var _arguments = arguments;
        return (0,tslib_es6.__generator)(this, function(_state) {
            includes = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : {};
            return [
                2,
                graphQLClient/* default.request */.Z.request(ALL_AGE_FILTERS_QUERY, includes).then(function(data) {
                    return hydrateObjects(data.ageFilters);
                })
            ];
        });
    }),
    useObject: function(id) {
        var includes = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        // eslint-disable-next-line react-hooks/exhaustive-deps
        var variables = (0,react.useMemo)(function() {
            return (0,_object_spread/* default */.Z)({
                id: id
            }, includes);
        }, [
            id
        ]);
        var ref = (0,dist/* default */.ZP)([
            SINGLE_AGE_FILTER_QUERY,
            variables
        ], {
            revalidateOnFocus: false
        }), data = ref.data, error = ref.error, mutate = ref.mutate;
        return {
            object: !data ? data : hydrateObject(data.ageFilter),
            isLoading: !error && !data,
            isError: error,
            mutate: mutate
        };
    },
    useObjects: function() {
        var includes = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        // eslint-disable-next-line react-hooks/exhaustive-deps
        var variables = (0,react.useMemo)(function() {
            return includes;
        }, []);
        var ref = (0,dist/* default */.ZP)([
            ALL_AGE_FILTERS_QUERY,
            variables
        ]), data = ref.data, error = ref.error, mutate = ref.mutate;
        return {
            objects: !data ? data : hydrateObjects(data.ageFilters),
            isLoading: !error && !data,
            isError: error,
            mutate: mutate
        };
    },
    getDependents: function(id, includes) {
        var includeVars = {};
        includes.forEach(function(include) {
            includeVars["with".concat((0,helpers/* uppercaseFirst */.AB)(include))] = true;
        });
        var variables = (0,_object_spread/* default */.Z)({
            id: id
        }, includeVars);
        return graphQLClient/* default.request */.Z.request(AGE_FILTERS_DEPENDENTS_QUERY, variables).then(function(data) {
            return data.groupedDependents;
        });
    },
    useDependents: function(id, includes) {
        var includeVars = {};
        includes.forEach(function(include) {
            includeVars["with".concat((0,helpers/* uppercaseFirst */.AB)(include))] = true;
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
        var variables = (0,react.useMemo)(function() {
            return (0,_object_spread/* default */.Z)({
                id: id
            }, includeVars);
        }, [
            id
        ]);
        var ref = (0,dist/* default */.ZP)([
            AGE_FILTERS_DEPENDENTS_QUERY,
            variables
        ], {
            revalidateOnFocus: false
        }), data = ref.data, error = ref.error, mutate = ref.mutate;
        return {
            data: !data ? data : data.groupedDependents,
            isLoading: !error && !data,
            isError: error,
            mutate: mutate
        };
    },
    createObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(data) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    input: data
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(CREATE_AGE_FILTER_MUTATION, variables).then(function(data) {
                        return hydrateObject(data.ageFilter);
                    })
                ];
            });
        });
        return function(data) {
            return _ref.apply(this, arguments);
        };
    }(),
    updateObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(data) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    input: data
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(UPDATE_AGE_FILTER_MUTATION, variables).then(function(data) {
                        return hydrateObject(data.ageFilter);
                    })
                ];
            });
        });
        return function(data) {
            return _ref.apply(this, arguments);
        };
    }(),
    deleteObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(DELETE_AGE_FILTER_MUTATION, variables).then(function(data) {
                        return data.deleteTravelPricingAgeFilter;
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }(),
    forceDeleteObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(FORCE_DELETE_AGE_FILTER_MUTATION, variables).then(function(data) {
                        return data.forceDeleteTravelPricingAgeFilter;
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }()
};
/* harmony default export */ var repository = (travelPricingAgeFilterRepository);

;// CONCATENATED MODULE: ./src/entities/travelPricingAgeFilter/entity.ts


var travelPricingAgeFilterEntity = {
    model: model,
    repository: repository
};
/* harmony default export */ var entity = (travelPricingAgeFilterEntity);


/***/ }),

/***/ 65966:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ entity; }
});

;// CONCATENATED MODULE: ./src/entities/travelPricingAgeGroup/graphql.ts
// language=GraphQL
var ALL_AGE_GROUPS_QUERY = "query Query {\n  ageGroups: travelPricingAgeGroups {\n    id\n    name\n    type\n    icon\n    minAge\n    maxAge\n  }\n}";
// language=GraphQL
var SINGLE_AGE_GROUP_QUERY = "query Query($id: ID!) {\n  ageGroup: travelPricingAgeGroup(id: $id) {\n    id\n    name\n    type\n    icon\n    minAge\n    maxAge\n  }\n}";
// language=GraphQL
var CREATE_AGE_GROUP_MUTATION = "\n  mutation Mutation($input: CreateTravelPricingAgeGroupInput) {\n    ageGroup: createTravelPricingAgeGroup(input: $input) {\n      id\n      name\n      type\n      icon\n      minAge\n      maxAge\n    }\n  }";
// language=GraphQL
var UPDATE_AGE_GROUP_MUTATION = "\n  mutation Mutation($input: UpdateTravelPricingAgeGroupInput) {\n    ageGroup: updateTravelPricingAgeGroup(input: $input) {\n      id\n      name\n      type\n      icon\n      minAge\n      maxAge\n    }\n  }";
// language=GraphQL
var DELETE_AGE_GROUP_MUTATION = "\n  mutation Mutation($input: DeleteTravelPricingAgeGroupInput) {\n    deleteTravelPricingAgeGroup(input: $input) {\n      success\n    }\n  }";
// language=GraphQL
var FORCE_DELETE_AGE_GROUP_MUTATION = "\n  mutation Mutation($input: DeleteTravelPricingAgeGroupInput) {\n    forceDeleteTravelPricingAgeGroup(input: $input) {\n      success\n    }\n  }";
// language=GraphQL
var AGE_GROUPS_DEPENDENTS_QUERY = "query Query($id: ID!, $withAccommodationAgeGroupCapacities: Boolean = false, $withRatioAgeGroupServices: Boolean = false, $withTravellers: Boolean = false, $withTravelPricingAgeGroupSettings: Boolean = false, $withAccommodationAgeGroupedTotalCapacities: Boolean = false, $withAccommodationCapacitySettings: Boolean = false, $withRatioPersonalAddons: Boolean = false, $withTravelPricingRules: Boolean = false) {\n  groupedDependents: travelPricingAgeGroupDependents(id: $id) {\n    accommodationAgeGroupCapacities @include(if: $withAccommodationAgeGroupCapacities) {\n      id\n      minCapacity\n      maxCapacity    }\n    ratioAgeGroupServices @include(if: $withRatioAgeGroupServices) {\n      id\n      ratioServiceNo    }\n    travellers @include(if: $withTravellers) {\n      id\n      salutation\n      firstName\n      lastName\n      birthday\n      nationality\n      email\n      phone\n      address\n      addressNumber\n      addressAddition\n      zip\n      city\n      country\n    }\n    travelPricingAgeGroupSettings @include(if: $withTravelPricingAgeGroupSettings) {\n      id\n      freeUntilAge\n    }\n    accommodationAgeGroupedTotalCapacities @include(if: $withAccommodationAgeGroupedTotalCapacities) {\n      id\n      capacity    }\n    accommodationCapacitySettings @include(if: $withAccommodationCapacitySettings) {\n      id\n      totalCapacity\n      rangesAllowed\n      partialOccupancyAllowed\n    }\n    ratioPersonalAddons @include(if: $withRatioPersonalAddons) {\n      id\n      ratioServiceNo\n      name\n      label\n      info\n    }\n    travelPricingRules @include(if: $withTravelPricingRules) {\n      id\n      checkAccommodationTypes\n      checkAccommodationAddons\n      checkAgeGroups\n      useAgeFilter\n      checkDateRange\n      startDate\n      endDate\n      checkTravelDate\n    }\n  }\n}";

;// CONCATENATED MODULE: ./src/entities/travelPricingAgeGroup/model.ts

var travelPricingAgeGroupModel = {
    name: "ageGroup",
    namePlural: "ageGroups",
    uniqueName: "travelPricingAgeGroup",
    uniqueNamePlural: "travelPricingAgeGroups",
    path: "travel/pricing/age_group",
    baseUrl: "/travel/pricing/age_groups",
    translationPrefix: "entities:travelPricingAgeGroup.",
    getDisplayName: function(values) {
        return "".concat(values.name, " (").concat(values.minAge, "-").concat(values.maxAge, ")");
    },
    gql: {
        getAll: ALL_AGE_GROUPS_QUERY,
        getSingle: SINGLE_AGE_GROUP_QUERY,
        create: CREATE_AGE_GROUP_MUTATION,
        update: UPDATE_AGE_GROUP_MUTATION,
        delete: DELETE_AGE_GROUP_MUTATION,
        forceDelete: FORCE_DELETE_AGE_GROUP_MUTATION
    },
    attributes: {
        name: {
            name: "name",
            label: "entities:travelPricingAgeGroup.attributes.name.label",
            type: "value",
            dataType: "string",
            defaultInput: true,
            inputType: "text",
            validationType: "string",
            validations: [
                {
                    type: "required"
                }, 
            ]
        },
        type: {
            name: "type",
            label: "entities:travelPricingAgeGroup.attributes.type.label",
            type: "value",
            dataType: "string",
            defaultInput: true,
            inputType: "select",
            selectOptions: [
                {
                    label: "entities:travelPricingAgeGroup.attributes.type.selectOptions.ADULT.label",
                    value: "ADULT"
                },
                {
                    label: "entities:travelPricingAgeGroup.attributes.type.selectOptions.MINOR.label",
                    value: "MINOR"
                }, 
            ],
            validationType: "string",
            validations: [
                {
                    type: "required"
                }, 
            ]
        },
        icon: {
            name: "icon",
            label: "entities:travelPricingAgeGroup.attributes.icon.label",
            type: "value",
            dataType: "string",
            defaultInput: false,
            inputType: "text",
            validationType: "string",
            validations: []
        },
        minAge: {
            name: "minAge",
            label: "entities:travelPricingAgeGroup.attributes.minAge.label",
            type: "value",
            dataType: "number",
            defaultInput: true,
            inputType: "text",
            validationType: "string",
            validations: [
                {
                    type: "required"
                }, 
            ]
        },
        maxAge: {
            name: "maxAge",
            label: "entities:travelPricingAgeGroup.attributes.maxAge.label",
            type: "value",
            dataType: "number",
            defaultInput: true,
            inputType: "text",
            validationType: "string",
            validations: [
                {
                    type: "required"
                }, 
            ]
        }
    }
};
/* harmony default export */ var model = (travelPricingAgeGroupModel);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(20414);
// EXTERNAL MODULE: ./src/entities/lib.ts
var lib = __webpack_require__(23480);
// EXTERNAL MODULE: ./src/lib/api/graphQLClient.ts
var graphQLClient = __webpack_require__(40112);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/swr/dist/index.mjs
var dist = __webpack_require__(8100);
// EXTERNAL MODULE: ./src/lib/helpers/helpers.ts
var helpers = __webpack_require__(15778);
;// CONCATENATED MODULE: ./src/entities/travelPricingAgeGroup/repository.ts










var hydrateObjects = function(objects) {
    return objects.map(function(object) {
        return (0,lib/* hydrateEntityObject */.b)(model, object);
    });
};
var hydrateObject = function(object) {
    return (0,lib/* hydrateEntityObject */.b)(model, object);
};
var travelPricingAgeGroupRepository = {
    getObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    id: id
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(SINGLE_AGE_GROUP_QUERY, variables).then(function(data) {
                        return hydrateObject(data.ageGroup);
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }(),
    getObjects: /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        var includes;
        var _arguments = arguments;
        return (0,tslib_es6.__generator)(this, function(_state) {
            includes = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : {};
            return [
                2,
                graphQLClient/* default.request */.Z.request(ALL_AGE_GROUPS_QUERY, includes).then(function(data) {
                    return hydrateObjects(data.ageGroups);
                })
            ];
        });
    }),
    useObject: function(id) {
        var includes = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        // eslint-disable-next-line react-hooks/exhaustive-deps
        var variables = (0,react.useMemo)(function() {
            return (0,_object_spread/* default */.Z)({
                id: id
            }, includes);
        }, [
            id
        ]);
        var ref = (0,dist/* default */.ZP)([
            SINGLE_AGE_GROUP_QUERY,
            variables
        ], {
            revalidateOnFocus: false
        }), data = ref.data, error = ref.error, mutate = ref.mutate;
        return {
            object: !data ? data : hydrateObject(data.ageGroup),
            isLoading: !error && !data,
            isError: error,
            mutate: mutate
        };
    },
    useObjects: function() {
        var includes = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        // eslint-disable-next-line react-hooks/exhaustive-deps
        var variables = (0,react.useMemo)(function() {
            return includes;
        }, []);
        var ref = (0,dist/* default */.ZP)([
            ALL_AGE_GROUPS_QUERY,
            variables
        ]), data = ref.data, error = ref.error, mutate = ref.mutate;
        return {
            objects: !data ? data : hydrateObjects(data.ageGroups),
            isLoading: !error && !data,
            isError: error,
            mutate: mutate
        };
    },
    getDependents: function(id, includes) {
        var includeVars = {};
        includes.forEach(function(include) {
            includeVars["with".concat((0,helpers/* uppercaseFirst */.AB)(include))] = true;
        });
        var variables = (0,_object_spread/* default */.Z)({
            id: id
        }, includeVars);
        return graphQLClient/* default.request */.Z.request(AGE_GROUPS_DEPENDENTS_QUERY, variables).then(function(data) {
            return data.groupedDependents;
        });
    },
    useDependents: function(id, includes) {
        var includeVars = {};
        includes.forEach(function(include) {
            includeVars["with".concat((0,helpers/* uppercaseFirst */.AB)(include))] = true;
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
        var variables = (0,react.useMemo)(function() {
            return (0,_object_spread/* default */.Z)({
                id: id
            }, includeVars);
        }, [
            id
        ]);
        var ref = (0,dist/* default */.ZP)([
            AGE_GROUPS_DEPENDENTS_QUERY,
            variables
        ], {
            revalidateOnFocus: false
        }), data = ref.data, error = ref.error, mutate = ref.mutate;
        return {
            data: !data ? data : data.groupedDependents,
            isLoading: !error && !data,
            isError: error,
            mutate: mutate
        };
    },
    createObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(data) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    input: data
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(CREATE_AGE_GROUP_MUTATION, variables).then(function(data) {
                        return hydrateObject(data.ageGroup);
                    })
                ];
            });
        });
        return function(data) {
            return _ref.apply(this, arguments);
        };
    }(),
    updateObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(data) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    input: data
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(UPDATE_AGE_GROUP_MUTATION, variables).then(function(data) {
                        return hydrateObject(data.ageGroup);
                    })
                ];
            });
        });
        return function(data) {
            return _ref.apply(this, arguments);
        };
    }(),
    deleteObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(DELETE_AGE_GROUP_MUTATION, variables).then(function(data) {
                        return data.deleteTravelPricingAgeGroup;
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }(),
    forceDeleteObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(FORCE_DELETE_AGE_GROUP_MUTATION, variables).then(function(data) {
                        return data.forceDeleteTravelPricingAgeGroup;
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }()
};
/* harmony default export */ var repository = (travelPricingAgeGroupRepository);

;// CONCATENATED MODULE: ./src/entities/travelPricingAgeGroup/entity.ts


var travelPricingAgeGroupEntity = {
    model: model,
    repository: repository
};
/* harmony default export */ var entity = (travelPricingAgeGroupEntity);


/***/ }),

/***/ 26189:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ travelPricingAgeGroupSettings_entity; }
});

;// CONCATENATED MODULE: ./src/entities/travelPricingAgeGroupSettings/graphql.ts
// language=GraphQL
var ALL_AGE_GROUP_SETTINGS_QUERY = "query Query($withAgeGroups: Boolean = false) {\n  ageGroupSettings: allTravelPricingAgeGroupSettings {\n    id\n    freeUntilAge\n    ageGroups @include(if: $withAgeGroups) {\n      id\n      name\n      type\n      icon\n      minAge\n      maxAge\n    }\n  }\n}";
// language=GraphQL
var SINGLE_AGE_GROUP_SETTINGS_QUERY = "query Query($id: ID!, $withAgeGroups: Boolean = false) {\n  ageGroupSettings: travelPricingAgeGroupSettings(id: $id) {\n    id\n    freeUntilAge\n    ageGroups @include(if: $withAgeGroups) {\n      id\n      name\n      type\n      icon\n      minAge\n      maxAge\n    }\n  }\n}";
// language=GraphQL
var CREATE_AGE_GROUP_SETTINGS_MUTATION = "\n  mutation Mutation($input: CreateTravelPricingAgeGroupSettingsInput, $withAgeGroups: Boolean = false) {\n    ageGroupSettings: createTravelPricingAgeGroupSettings(input: $input) {\n      id\n      freeUntilAge\n      ageGroups @include(if: $withAgeGroups) {\n        id\n        name\n        type\n        icon\n        minAge\n        maxAge\n      }\n    }\n  }";
// language=GraphQL
var UPDATE_AGE_GROUP_SETTINGS_MUTATION = "\n  mutation Mutation($input: UpdateTravelPricingAgeGroupSettingsInput, $withAgeGroups: Boolean = false) {\n    ageGroupSettings: updateTravelPricingAgeGroupSettings(input: $input) {\n      id\n      freeUntilAge\n      ageGroups @include(if: $withAgeGroups) {\n        id\n        name\n        type\n        icon\n        minAge\n        maxAge\n      }\n    }\n  }";
// language=GraphQL
var DELETE_AGE_GROUP_SETTINGS_MUTATION = "\n  mutation Mutation($input: DeleteTravelPricingAgeGroupSettingsInput) {\n    deleteTravelPricingAgeGroupSettings(input: $input) {\n      success\n    }\n  }";
// language=GraphQL
var FORCE_DELETE_AGE_GROUP_SETTINGS_MUTATION = "\n  mutation Mutation($input: DeleteTravelPricingAgeGroupSettingsInput) {\n    forceDeleteTravelPricingAgeGroupSettings(input: $input) {\n      success\n    }\n  }";
// language=GraphQL
var ADD_AGE_GROUP_SETTINGS_AGE_GROUPS_MUTATION = "\n  mutation Mutation($input: addTravelPricingAgeGroupSettingsAgeGroupsInput) {\n    addTravelPricingAgeGroupSettingsAgeGroups(input: $input) {\n      id\n      ageGroupIds\n    }\n  }";
// language=GraphQL
var REMOVE_AGE_GROUP_SETTINGS_AGE_GROUPS_MUTATION = "\n  mutation Mutation($input: removeTravelPricingAgeGroupSettingsAgeGroupsInput) {\n    removeTravelPricingAgeGroupSettingsAgeGroups(input: $input) {\n      id\n      ageGroupIds\n    }\n  }";
// language=GraphQL
var CREATE_AGE_GROUP_SETTINGS_AGE_GROUPS_MUTATION = "\n  mutation Mutation($input: createTravelPricingAgeGroupSettingsAgeGroupsInput) {\n    createTravelPricingAgeGroupSettingsAgeGroups(input: $input) {\n      id\n      ageGroupIds\n    }\n  }";
// language=GraphQL
var DELETE_AGE_GROUP_SETTINGS_AGE_GROUPS_MUTATION = "\n  mutation Mutation($input: deleteTravelPricingAgeGroupSettingsAgeGroupsInput) {\n    deleteTravelPricingAgeGroupSettingsAgeGroups(input: $input) {\n      id\n      ageGroupIds\n    }\n  }";
// language=GraphQL
var UPDATE_AGE_GROUP_SETTINGS_AGE_GROUPS_ORDER_MUTATION = "\n  mutation Mutation($input: updateTravelPricingAgeGroupSettingsAgeGroupsOrderInput) {\n    updateTravelPricingAgeGroupSettingsAgeGroupsOrder(input: $input) {\n      id\n      ageGroupIds\n    }\n  }";
// language=GraphQL
var AGE_GROUP_SETTINGS_DEPENDENTS_QUERY = "query Query($id: ID!, $withTravelPricings: Boolean = false) {\n  groupedDependents: travelPricingAgeGroupSettingsDependents(id: $id) {\n    travelPricings @include(if: $withTravelPricings) {\n      id\n      isTravelDocumentationAvailable\n    }\n  }\n}";

// EXTERNAL MODULE: ./src/entities/travelPricingAgeGroup/entity.ts + 3 modules
var entity = __webpack_require__(65966);
;// CONCATENATED MODULE: ./src/entities/travelPricingAgeGroupSettings/model.ts


var travelPricingAgeGroupSettingsModel = {
    name: "ageGroupSettings",
    namePlural: "ageGroupSettings",
    uniqueName: "travelPricingAgeGroupSettings",
    uniqueNamePlural: "travelPricingAgeGroupSettings",
    path: "travel/pricing/age_group_settings",
    baseUrl: "/travel/pricing/age_group_settings",
    translationPrefix: "entities:travelPricingAgeGroupSettings.",
    getDisplayName: function(values) {
        return "Age Group Settings";
    },
    gql: {
        getAll: ALL_AGE_GROUP_SETTINGS_QUERY,
        getSingle: SINGLE_AGE_GROUP_SETTINGS_QUERY,
        create: CREATE_AGE_GROUP_SETTINGS_MUTATION,
        update: UPDATE_AGE_GROUP_SETTINGS_MUTATION,
        delete: DELETE_AGE_GROUP_SETTINGS_MUTATION,
        forceDelete: FORCE_DELETE_AGE_GROUP_SETTINGS_MUTATION
    },
    attributes: {
        freeUntilAge: {
            name: "freeUntilAge",
            label: "entities:travelPricingAgeGroupSettings.attributes.freeUntilAge.label",
            type: "value",
            dataType: "number",
            defaultInput: true,
            inputType: "text",
            validationType: "string",
            validations: [
                {
                    type: "required"
                }, 
            ]
        },
        ageGroups: {
            name: "ageGroups",
            label: "entities:travelPricingAgeGroupSettings.attributes.ageGroups.label",
            type: "entityCollection",
            dataType: "[any]",
            getEntity: function() {
                return entity/* default */.Z;
            },
            defaultInput: false,
            inputType: "text",
            validationType: "string",
            validations: []
        }
    }
};
/* harmony default export */ var model = (travelPricingAgeGroupSettingsModel);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(20414);
// EXTERNAL MODULE: ./src/entities/lib.ts
var lib = __webpack_require__(23480);
// EXTERNAL MODULE: ./src/lib/api/graphQLClient.ts
var graphQLClient = __webpack_require__(40112);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/swr/dist/index.mjs
var dist = __webpack_require__(8100);
// EXTERNAL MODULE: ./src/lib/helpers/helpers.ts
var helpers = __webpack_require__(15778);
;// CONCATENATED MODULE: ./src/entities/travelPricingAgeGroupSettings/repository.ts










var hydrateObjects = function(objects) {
    return objects.map(function(object) {
        return (0,lib/* hydrateEntityObject */.b)(model, object);
    });
};
var hydrateObject = function(object) {
    return (0,lib/* hydrateEntityObject */.b)(model, object);
};
var travelPricingAgeGroupSettingsRepository = {
    getObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    id: id
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(SINGLE_AGE_GROUP_SETTINGS_QUERY, variables).then(function(data) {
                        return hydrateObject(data.ageGroupSettings);
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }(),
    getObjects: /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        var includes;
        var _arguments = arguments;
        return (0,tslib_es6.__generator)(this, function(_state) {
            includes = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : {};
            return [
                2,
                graphQLClient/* default.request */.Z.request(ALL_AGE_GROUP_SETTINGS_QUERY, includes).then(function(data) {
                    return hydrateObjects(data.ageGroupSettings);
                })
            ];
        });
    }),
    useObject: function(id) {
        var includes = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        // eslint-disable-next-line react-hooks/exhaustive-deps
        var variables = (0,react.useMemo)(function() {
            return (0,_object_spread/* default */.Z)({
                id: id
            }, includes);
        }, [
            id
        ]);
        var ref = (0,dist/* default */.ZP)([
            SINGLE_AGE_GROUP_SETTINGS_QUERY,
            variables
        ], {
            revalidateOnFocus: false
        }), data = ref.data, error = ref.error, mutate = ref.mutate;
        return {
            object: !data ? data : hydrateObject(data.ageGroupSettings),
            isLoading: !error && !data,
            isError: error,
            mutate: mutate
        };
    },
    useObjects: function() {
        var includes = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        // eslint-disable-next-line react-hooks/exhaustive-deps
        var variables = (0,react.useMemo)(function() {
            return includes;
        }, []);
        var ref = (0,dist/* default */.ZP)([
            ALL_AGE_GROUP_SETTINGS_QUERY,
            variables
        ]), data = ref.data, error = ref.error, mutate = ref.mutate;
        return {
            objects: !data ? data : hydrateObjects(data.ageGroupSettings),
            isLoading: !error && !data,
            isError: error,
            mutate: mutate
        };
    },
    getDependents: function(id, includes) {
        var includeVars = {};
        includes.forEach(function(include) {
            includeVars["with".concat((0,helpers/* uppercaseFirst */.AB)(include))] = true;
        });
        var variables = (0,_object_spread/* default */.Z)({
            id: id
        }, includeVars);
        return graphQLClient/* default.request */.Z.request(AGE_GROUP_SETTINGS_DEPENDENTS_QUERY, variables).then(function(data) {
            return data.groupedDependents;
        });
    },
    useDependents: function(id, includes) {
        var includeVars = {};
        includes.forEach(function(include) {
            includeVars["with".concat((0,helpers/* uppercaseFirst */.AB)(include))] = true;
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
        var variables = (0,react.useMemo)(function() {
            return (0,_object_spread/* default */.Z)({
                id: id
            }, includeVars);
        }, [
            id
        ]);
        var ref = (0,dist/* default */.ZP)([
            AGE_GROUP_SETTINGS_DEPENDENTS_QUERY,
            variables
        ], {
            revalidateOnFocus: false
        }), data = ref.data, error = ref.error, mutate = ref.mutate;
        return {
            data: !data ? data : data.groupedDependents,
            isLoading: !error && !data,
            isError: error,
            mutate: mutate
        };
    },
    createObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(data) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    input: data
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(CREATE_AGE_GROUP_SETTINGS_MUTATION, variables).then(function(data) {
                        return hydrateObject(data.ageGroupSettings);
                    })
                ];
            });
        });
        return function(data) {
            return _ref.apply(this, arguments);
        };
    }(),
    updateObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(data) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    input: data
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(UPDATE_AGE_GROUP_SETTINGS_MUTATION, variables).then(function(data) {
                        return hydrateObject(data.ageGroupSettings);
                    })
                ];
            });
        });
        return function(data) {
            return _ref.apply(this, arguments);
        };
    }(),
    deleteObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(DELETE_AGE_GROUP_SETTINGS_MUTATION, variables).then(function(data) {
                        return data.deleteTravelPricingAgeGroupSettings;
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }(),
    forceDeleteObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(FORCE_DELETE_AGE_GROUP_SETTINGS_MUTATION, variables).then(function(data) {
                        return data.forceDeleteTravelPricingAgeGroupSettings;
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }(),
    assignAgeGroups: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, itemIds) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        ageGroupIds: itemIds
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(ADD_AGE_GROUP_SETTINGS_AGE_GROUPS_MUTATION, variables)
                ];
            });
        });
        return function(id, itemIds) {
            return _ref.apply(this, arguments);
        };
    }(),
    unassignAgeGroups: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, itemIds) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        ageGroupIds: itemIds
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(REMOVE_AGE_GROUP_SETTINGS_AGE_GROUPS_MUTATION, variables)
                ];
            });
        });
        return function(id, itemIds) {
            return _ref.apply(this, arguments);
        };
    }(),
    createAgeGroups: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, items) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        ageGroups: items
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(CREATE_AGE_GROUP_SETTINGS_AGE_GROUPS_MUTATION, variables)
                ];
            });
        });
        return function(id, items) {
            return _ref.apply(this, arguments);
        };
    }(),
    deleteAgeGroups: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, itemIds) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        ageGroupIds: itemIds
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(DELETE_AGE_GROUP_SETTINGS_AGE_GROUPS_MUTATION, variables)
                ];
            });
        });
        return function(id, itemIds) {
            return _ref.apply(this, arguments);
        };
    }(),
    updateAgeGroupsOrder: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, itemIds) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        ageGroupIds: itemIds
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(UPDATE_AGE_GROUP_SETTINGS_AGE_GROUPS_ORDER_MUTATION, variables)
                ];
            });
        });
        return function(id, itemIds) {
            return _ref.apply(this, arguments);
        };
    }()
};
/* harmony default export */ var repository = (travelPricingAgeGroupSettingsRepository);

;// CONCATENATED MODULE: ./src/entities/travelPricingAgeGroupSettings/entity.ts


var travelPricingAgeGroupSettingsEntity = {
    model: model,
    repository: repository
};
/* harmony default export */ var travelPricingAgeGroupSettings_entity = (travelPricingAgeGroupSettingsEntity);


/***/ }),

/***/ 12978:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ travelPricingBranding_entity; }
});

;// CONCATENATED MODULE: ./src/entities/travelPricingBranding/graphql.ts
// language=GraphQL
var ALL_BRANDINGS_QUERY = "query Query($withLogo: Boolean = false) {\n  brandings: travelPricingBrandings {\n    id\n    logo @include(if: $withLogo) {\n      id\n      assetId\n      publicId\n      url\n      resourceType\n      format\n      width\n      height\n      caption\n      title\n      description\n    }\n    logoWidth\n  }\n}";
// language=GraphQL
var SINGLE_BRANDING_QUERY = "query Query($id: ID!, $withLogo: Boolean = false) {\n  branding: travelPricingBranding(id: $id) {\n    id\n    logo @include(if: $withLogo) {\n      id\n      assetId\n      publicId\n      url\n      resourceType\n      format\n      width\n      height\n      caption\n      title\n      description\n    }\n    logoWidth\n  }\n}";
// language=GraphQL
var CREATE_BRANDING_MUTATION = "\n  mutation Mutation($input: CreateTravelPricingBrandingInput, $withLogo: Boolean = false) {\n    branding: createTravelPricingBranding(input: $input) {\n      id\n      logo @include(if: $withLogo) {\n        id\n        assetId\n        publicId\n        url\n        resourceType\n        format\n        width\n        height\n        caption\n        title\n        description\n      }\n      logoWidth\n    }\n  }";
// language=GraphQL
var UPDATE_BRANDING_MUTATION = "\n  mutation Mutation($input: UpdateTravelPricingBrandingInput, $withLogo: Boolean = false) {\n    branding: updateTravelPricingBranding(input: $input) {\n      id\n      logo @include(if: $withLogo) {\n        id\n        assetId\n        publicId\n        url\n        resourceType\n        format\n        width\n        height\n        caption\n        title\n        description\n      }\n      logoWidth\n    }\n  }";
// language=GraphQL
var DELETE_BRANDING_MUTATION = "\n  mutation Mutation($input: DeleteTravelPricingBrandingInput) {\n    deleteTravelPricingBranding(input: $input) {\n      success\n    }\n  }";
// language=GraphQL
var FORCE_DELETE_BRANDING_MUTATION = "\n  mutation Mutation($input: DeleteTravelPricingBrandingInput) {\n    forceDeleteTravelPricingBranding(input: $input) {\n      success\n    }\n  }";
// language=GraphQL
var BRANDINGS_DEPENDENTS_QUERY = "query Query($id: ID!, $withTravelPricings: Boolean = false) {\n  groupedDependents: travelPricingBrandingDependents(id: $id) {\n    travelPricings @include(if: $withTravelPricings) {\n      id\n      isTravelDocumentationAvailable\n    }\n  }\n}";

// EXTERNAL MODULE: ./src/entities/mediaFile/entity.ts + 3 modules
var entity = __webpack_require__(24180);
;// CONCATENATED MODULE: ./src/entities/travelPricingBranding/model.ts


var travelPricingBrandingModel = {
    name: "branding",
    namePlural: "brandings",
    uniqueName: "travelPricingBranding",
    uniqueNamePlural: "travelPricingBrandings",
    path: "travel/pricing/branding",
    baseUrl: "/travel/pricing/brandings",
    translationPrefix: "entities:travelPricingBranding.",
    getDisplayName: function(values) {
        return "BRANDING";
    },
    gql: {
        getAll: ALL_BRANDINGS_QUERY,
        getSingle: SINGLE_BRANDING_QUERY,
        create: CREATE_BRANDING_MUTATION,
        update: UPDATE_BRANDING_MUTATION,
        delete: DELETE_BRANDING_MUTATION,
        forceDelete: FORCE_DELETE_BRANDING_MUTATION
    },
    attributes: {
        logo: {
            name: "logo",
            label: "entities:travelPricingBranding.attributes.logo.label",
            type: "entityObject",
            dataType: "any",
            getEntity: function() {
                return entity/* default */.Z;
            },
            defaultInput: false,
            inputType: "select",
            validationType: "string",
            validations: []
        },
        logoWidth: {
            name: "logoWidth",
            label: "entities:travelPricingBranding.attributes.logoWidth.label",
            type: "value",
            dataType: "number",
            defaultValue: 130,
            defaultInput: true,
            inputType: "number",
            validationType: "string",
            validations: [
                {
                    type: "required"
                }, 
            ]
        }
    }
};
/* harmony default export */ var model = (travelPricingBrandingModel);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(20414);
// EXTERNAL MODULE: ./src/entities/lib.ts
var lib = __webpack_require__(23480);
// EXTERNAL MODULE: ./src/lib/api/graphQLClient.ts
var graphQLClient = __webpack_require__(40112);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/swr/dist/index.mjs
var dist = __webpack_require__(8100);
// EXTERNAL MODULE: ./src/lib/helpers/helpers.ts
var helpers = __webpack_require__(15778);
;// CONCATENATED MODULE: ./src/entities/travelPricingBranding/repository.ts










var hydrateObjects = function(objects) {
    return objects.map(function(object) {
        return (0,lib/* hydrateEntityObject */.b)(model, object);
    });
};
var hydrateObject = function(object) {
    return (0,lib/* hydrateEntityObject */.b)(model, object);
};
var travelPricingBrandingRepository = {
    getObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    id: id
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(SINGLE_BRANDING_QUERY, variables).then(function(data) {
                        return hydrateObject(data.branding);
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }(),
    getObjects: /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        var includes;
        var _arguments = arguments;
        return (0,tslib_es6.__generator)(this, function(_state) {
            includes = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : {};
            return [
                2,
                graphQLClient/* default.request */.Z.request(ALL_BRANDINGS_QUERY, includes).then(function(data) {
                    return hydrateObjects(data.brandings);
                })
            ];
        });
    }),
    useObject: function(id) {
        var includes = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        // eslint-disable-next-line react-hooks/exhaustive-deps
        var variables = (0,react.useMemo)(function() {
            return (0,_object_spread/* default */.Z)({
                id: id
            }, includes);
        }, [
            id
        ]);
        var ref = (0,dist/* default */.ZP)([
            SINGLE_BRANDING_QUERY,
            variables
        ], {
            revalidateOnFocus: false
        }), data = ref.data, error = ref.error, mutate = ref.mutate;
        return {
            object: !data ? data : hydrateObject(data.branding),
            isLoading: !error && !data,
            isError: error,
            mutate: mutate
        };
    },
    useObjects: function() {
        var includes = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        // eslint-disable-next-line react-hooks/exhaustive-deps
        var variables = (0,react.useMemo)(function() {
            return includes;
        }, []);
        var ref = (0,dist/* default */.ZP)([
            ALL_BRANDINGS_QUERY,
            variables
        ]), data = ref.data, error = ref.error, mutate = ref.mutate;
        return {
            objects: !data ? data : hydrateObjects(data.brandings),
            isLoading: !error && !data,
            isError: error,
            mutate: mutate
        };
    },
    getDependents: function(id, includes) {
        var includeVars = {};
        includes.forEach(function(include) {
            includeVars["with".concat((0,helpers/* uppercaseFirst */.AB)(include))] = true;
        });
        var variables = (0,_object_spread/* default */.Z)({
            id: id
        }, includeVars);
        return graphQLClient/* default.request */.Z.request(BRANDINGS_DEPENDENTS_QUERY, variables).then(function(data) {
            return data.groupedDependents;
        });
    },
    useDependents: function(id, includes) {
        var includeVars = {};
        includes.forEach(function(include) {
            includeVars["with".concat((0,helpers/* uppercaseFirst */.AB)(include))] = true;
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
        var variables = (0,react.useMemo)(function() {
            return (0,_object_spread/* default */.Z)({
                id: id
            }, includeVars);
        }, [
            id
        ]);
        var ref = (0,dist/* default */.ZP)([
            BRANDINGS_DEPENDENTS_QUERY,
            variables
        ], {
            revalidateOnFocus: false
        }), data = ref.data, error = ref.error, mutate = ref.mutate;
        return {
            data: !data ? data : data.groupedDependents,
            isLoading: !error && !data,
            isError: error,
            mutate: mutate
        };
    },
    createObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(data) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    input: data
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(CREATE_BRANDING_MUTATION, variables).then(function(data) {
                        return hydrateObject(data.branding);
                    })
                ];
            });
        });
        return function(data) {
            return _ref.apply(this, arguments);
        };
    }(),
    updateObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(data) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    input: data
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(UPDATE_BRANDING_MUTATION, variables).then(function(data) {
                        return hydrateObject(data.branding);
                    })
                ];
            });
        });
        return function(data) {
            return _ref.apply(this, arguments);
        };
    }(),
    deleteObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(DELETE_BRANDING_MUTATION, variables).then(function(data) {
                        return data.deleteTravelPricingBranding;
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }(),
    forceDeleteObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(FORCE_DELETE_BRANDING_MUTATION, variables).then(function(data) {
                        return data.forceDeleteTravelPricingBranding;
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }()
};
/* harmony default export */ var repository = (travelPricingBrandingRepository);

;// CONCATENATED MODULE: ./src/entities/travelPricingBranding/entity.ts


var travelPricingBrandingEntity = {
    model: model,
    repository: repository
};
/* harmony default export */ var travelPricingBranding_entity = (travelPricingBrandingEntity);


/***/ }),

/***/ 43347:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ travelPricingCustomDataConfig_entity; }
});

;// CONCATENATED MODULE: ./src/entities/travelPricingCustomDataConfig/graphql.ts
// language=GraphQL
var ALL_CUSTOM_DATA_CONFIGS_QUERY = "query Query($withTravellerForm: Boolean = false, $withTravellerFormFields: Boolean = false, $withTravellerFormFieldsOptions: Boolean = false, $withTravellerFormFieldsVisibilityConfig: Boolean = false, $withBookingForm: Boolean = false, $withBookingFormFields: Boolean = false, $withBookingFormFieldsOptions: Boolean = false, $withBookingFormFieldsVisibilityConfig: Boolean = false) {\n  customDataConfigs: travelPricingCustomDataConfigs {\n    id\n    useTravellerForm\n    travellerForm @include(if: $withTravellerForm) {\n      id\n      fields @include(if: $withTravellerFormFields) {\n        id\n        inputType\n        name\n        label\n        info\n        value\n        required\n        options @include(if: $withTravellerFormFieldsOptions) {\n          id\n          value\n          label\n        }\n        visibilityConfig @include(if: $withTravellerFormFieldsVisibilityConfig) {\n          id\n        }\n      }\n    }\n    useBookingForm\n    bookingForm @include(if: $withBookingForm) {\n      id\n      fields @include(if: $withBookingFormFields) {\n        id\n        inputType\n        name\n        label\n        info\n        value\n        required\n        options @include(if: $withBookingFormFieldsOptions) {\n          id\n          value\n          label\n        }\n        visibilityConfig @include(if: $withBookingFormFieldsVisibilityConfig) {\n          id\n        }\n      }\n    }\n  }\n}";
// language=GraphQL
var SINGLE_CUSTOM_DATA_CONFIG_QUERY = "query Query($id: ID!, $withTravellerForm: Boolean = false, $withTravellerFormFields: Boolean = false, $withTravellerFormFieldsOptions: Boolean = false, $withTravellerFormFieldsVisibilityConfig: Boolean = false, $withBookingForm: Boolean = false, $withBookingFormFields: Boolean = false, $withBookingFormFieldsOptions: Boolean = false, $withBookingFormFieldsVisibilityConfig: Boolean = false) {\n  customDataConfig: travelPricingCustomDataConfig(id: $id) {\n    id\n    useTravellerForm\n    travellerForm @include(if: $withTravellerForm) {\n      id\n      fields @include(if: $withTravellerFormFields) {\n        id\n        inputType\n        name\n        label\n        info\n        value\n        required\n        options @include(if: $withTravellerFormFieldsOptions) {\n          id\n          value\n          label\n        }\n        visibilityConfig @include(if: $withTravellerFormFieldsVisibilityConfig) {\n          id\n        }\n      }\n    }\n    useBookingForm\n    bookingForm @include(if: $withBookingForm) {\n      id\n      fields @include(if: $withBookingFormFields) {\n        id\n        inputType\n        name\n        label\n        info\n        value\n        required\n        options @include(if: $withBookingFormFieldsOptions) {\n          id\n          value\n          label\n        }\n        visibilityConfig @include(if: $withBookingFormFieldsVisibilityConfig) {\n          id\n        }\n      }\n    }\n  }\n}";
// language=GraphQL
var CREATE_CUSTOM_DATA_CONFIG_MUTATION = "\n  mutation Mutation($input: CreateTravelPricingCustomDataConfigInput, $withTravellerForm: Boolean = false, $withTravellerFormFields: Boolean = false, $withTravellerFormFieldsOptions: Boolean = false, $withTravellerFormFieldsVisibilityConfig: Boolean = false, $withBookingForm: Boolean = false, $withBookingFormFields: Boolean = false, $withBookingFormFieldsOptions: Boolean = false, $withBookingFormFieldsVisibilityConfig: Boolean = false) {\n    customDataConfig: createTravelPricingCustomDataConfig(input: $input) {\n      id\n      useTravellerForm\n      travellerForm @include(if: $withTravellerForm) {\n        id\n        fields @include(if: $withTravellerFormFields) {\n          id\n          inputType\n          name\n          label\n          info\n          value\n          required\n          options @include(if: $withTravellerFormFieldsOptions) {\n            id\n            value\n            label\n          }\n          visibilityConfig @include(if: $withTravellerFormFieldsVisibilityConfig) {\n            id\n          }\n        }\n      }\n      useBookingForm\n      bookingForm @include(if: $withBookingForm) {\n        id\n        fields @include(if: $withBookingFormFields) {\n          id\n          inputType\n          name\n          label\n          info\n          value\n          required\n          options @include(if: $withBookingFormFieldsOptions) {\n            id\n            value\n            label\n          }\n          visibilityConfig @include(if: $withBookingFormFieldsVisibilityConfig) {\n            id\n          }\n        }\n      }\n    }\n  }";
// language=GraphQL
var UPDATE_CUSTOM_DATA_CONFIG_MUTATION = "\n  mutation Mutation($input: UpdateTravelPricingCustomDataConfigInput, $withTravellerForm: Boolean = false, $withTravellerFormFields: Boolean = false, $withTravellerFormFieldsOptions: Boolean = false, $withTravellerFormFieldsVisibilityConfig: Boolean = false, $withBookingForm: Boolean = false, $withBookingFormFields: Boolean = false, $withBookingFormFieldsOptions: Boolean = false, $withBookingFormFieldsVisibilityConfig: Boolean = false) {\n    customDataConfig: updateTravelPricingCustomDataConfig(input: $input) {\n      id\n      useTravellerForm\n      travellerForm @include(if: $withTravellerForm) {\n        id\n        fields @include(if: $withTravellerFormFields) {\n          id\n          inputType\n          name\n          label\n          info\n          value\n          required\n          options @include(if: $withTravellerFormFieldsOptions) {\n            id\n            value\n            label\n          }\n          visibilityConfig @include(if: $withTravellerFormFieldsVisibilityConfig) {\n            id\n          }\n        }\n      }\n      useBookingForm\n      bookingForm @include(if: $withBookingForm) {\n        id\n        fields @include(if: $withBookingFormFields) {\n          id\n          inputType\n          name\n          label\n          info\n          value\n          required\n          options @include(if: $withBookingFormFieldsOptions) {\n            id\n            value\n            label\n          }\n          visibilityConfig @include(if: $withBookingFormFieldsVisibilityConfig) {\n            id\n          }\n        }\n      }\n    }\n  }";
// language=GraphQL
var DELETE_CUSTOM_DATA_CONFIG_MUTATION = "\n  mutation Mutation($input: DeleteTravelPricingCustomDataConfigInput) {\n    deleteTravelPricingCustomDataConfig(input: $input) {\n      success\n    }\n  }";
// language=GraphQL
var FORCE_DELETE_CUSTOM_DATA_CONFIG_MUTATION = "\n  mutation Mutation($input: DeleteTravelPricingCustomDataConfigInput) {\n    forceDeleteTravelPricingCustomDataConfig(input: $input) {\n      success\n    }\n  }";
// language=GraphQL
var CUSTOM_DATA_CONFIGS_DEPENDENTS_QUERY = "query Query($id: ID!, $withTravelPricings: Boolean = false) {\n  groupedDependents: travelPricingCustomDataConfigDependents(id: $id) {\n    travelPricings @include(if: $withTravelPricings) {\n      id\n      isTravelDocumentationAvailable\n    }\n  }\n}";

// EXTERNAL MODULE: ./src/entities/customBookingForm/entity.ts + 3 modules
var entity = __webpack_require__(26584);
;// CONCATENATED MODULE: ./src/entities/travelPricingCustomDataConfig/model.ts


var travelPricingCustomDataConfigModel = {
    name: "customDataConfig",
    namePlural: "customDataConfigs",
    uniqueName: "travelPricingCustomDataConfig",
    uniqueNamePlural: "travelPricingCustomDataConfigs",
    path: "travel/pricing/custom_data_config",
    baseUrl: "/travel/pricing/custom_data_configs",
    translationPrefix: "entities:travelPricingCustomDataConfig.",
    getDisplayName: function(values) {
        return "CUSTOM DATA CONFIG";
    },
    gql: {
        getAll: ALL_CUSTOM_DATA_CONFIGS_QUERY,
        getSingle: SINGLE_CUSTOM_DATA_CONFIG_QUERY,
        create: CREATE_CUSTOM_DATA_CONFIG_MUTATION,
        update: UPDATE_CUSTOM_DATA_CONFIG_MUTATION,
        delete: DELETE_CUSTOM_DATA_CONFIG_MUTATION,
        forceDelete: FORCE_DELETE_CUSTOM_DATA_CONFIG_MUTATION
    },
    attributes: {
        useTravellerForm: {
            name: "useTravellerForm",
            label: "entities:travelPricingCustomDataConfig.attributes.useTravellerForm.label",
            type: "value",
            dataType: "boolean",
            defaultInput: true,
            inputType: "switch",
            validationType: "string",
            validations: []
        },
        travellerForm: {
            name: "travellerForm",
            label: "entities:travelPricingCustomDataConfig.attributes.travellerForm.label",
            type: "entityObject",
            dataType: "any",
            getEntity: function() {
                return entity/* default */.Z;
            },
            defaultInput: false,
            inputType: "select",
            validationType: "string",
            validations: []
        },
        useBookingForm: {
            name: "useBookingForm",
            label: "entities:travelPricingCustomDataConfig.attributes.useBookingForm.label",
            type: "value",
            dataType: "boolean",
            defaultInput: true,
            inputType: "switch",
            validationType: "string",
            validations: []
        },
        bookingForm: {
            name: "bookingForm",
            label: "entities:travelPricingCustomDataConfig.attributes.bookingForm.label",
            type: "entityObject",
            dataType: "any",
            getEntity: function() {
                return entity/* default */.Z;
            },
            defaultInput: false,
            inputType: "select",
            validationType: "string",
            validations: []
        }
    }
};
/* harmony default export */ var model = (travelPricingCustomDataConfigModel);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(20414);
// EXTERNAL MODULE: ./src/entities/lib.ts
var lib = __webpack_require__(23480);
// EXTERNAL MODULE: ./src/lib/api/graphQLClient.ts
var graphQLClient = __webpack_require__(40112);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/swr/dist/index.mjs
var dist = __webpack_require__(8100);
// EXTERNAL MODULE: ./src/lib/helpers/helpers.ts
var helpers = __webpack_require__(15778);
;// CONCATENATED MODULE: ./src/entities/travelPricingCustomDataConfig/repository.ts










var hydrateObjects = function(objects) {
    return objects.map(function(object) {
        return (0,lib/* hydrateEntityObject */.b)(model, object);
    });
};
var hydrateObject = function(object) {
    return (0,lib/* hydrateEntityObject */.b)(model, object);
};
var travelPricingCustomDataConfigRepository = {
    getObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    id: id
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(SINGLE_CUSTOM_DATA_CONFIG_QUERY, variables).then(function(data) {
                        return hydrateObject(data.customDataConfig);
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }(),
    getObjects: /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        var includes;
        var _arguments = arguments;
        return (0,tslib_es6.__generator)(this, function(_state) {
            includes = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : {};
            return [
                2,
                graphQLClient/* default.request */.Z.request(ALL_CUSTOM_DATA_CONFIGS_QUERY, includes).then(function(data) {
                    return hydrateObjects(data.customDataConfigs);
                })
            ];
        });
    }),
    useObject: function(id) {
        var includes = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        // eslint-disable-next-line react-hooks/exhaustive-deps
        var variables = (0,react.useMemo)(function() {
            return (0,_object_spread/* default */.Z)({
                id: id
            }, includes);
        }, [
            id
        ]);
        var ref = (0,dist/* default */.ZP)([
            SINGLE_CUSTOM_DATA_CONFIG_QUERY,
            variables
        ], {
            revalidateOnFocus: false
        }), data = ref.data, error = ref.error, mutate = ref.mutate;
        return {
            object: !data ? data : hydrateObject(data.customDataConfig),
            isLoading: !error && !data,
            isError: error,
            mutate: mutate
        };
    },
    useObjects: function() {
        var includes = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        // eslint-disable-next-line react-hooks/exhaustive-deps
        var variables = (0,react.useMemo)(function() {
            return includes;
        }, []);
        var ref = (0,dist/* default */.ZP)([
            ALL_CUSTOM_DATA_CONFIGS_QUERY,
            variables
        ]), data = ref.data, error = ref.error, mutate = ref.mutate;
        return {
            objects: !data ? data : hydrateObjects(data.customDataConfigs),
            isLoading: !error && !data,
            isError: error,
            mutate: mutate
        };
    },
    getDependents: function(id, includes) {
        var includeVars = {};
        includes.forEach(function(include) {
            includeVars["with".concat((0,helpers/* uppercaseFirst */.AB)(include))] = true;
        });
        var variables = (0,_object_spread/* default */.Z)({
            id: id
        }, includeVars);
        return graphQLClient/* default.request */.Z.request(CUSTOM_DATA_CONFIGS_DEPENDENTS_QUERY, variables).then(function(data) {
            return data.groupedDependents;
        });
    },
    useDependents: function(id, includes) {
        var includeVars = {};
        includes.forEach(function(include) {
            includeVars["with".concat((0,helpers/* uppercaseFirst */.AB)(include))] = true;
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
        var variables = (0,react.useMemo)(function() {
            return (0,_object_spread/* default */.Z)({
                id: id
            }, includeVars);
        }, [
            id
        ]);
        var ref = (0,dist/* default */.ZP)([
            CUSTOM_DATA_CONFIGS_DEPENDENTS_QUERY,
            variables
        ], {
            revalidateOnFocus: false
        }), data = ref.data, error = ref.error, mutate = ref.mutate;
        return {
            data: !data ? data : data.groupedDependents,
            isLoading: !error && !data,
            isError: error,
            mutate: mutate
        };
    },
    createObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(data) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    input: data
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(CREATE_CUSTOM_DATA_CONFIG_MUTATION, variables).then(function(data) {
                        return hydrateObject(data.customDataConfig);
                    })
                ];
            });
        });
        return function(data) {
            return _ref.apply(this, arguments);
        };
    }(),
    updateObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(data) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    input: data
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(UPDATE_CUSTOM_DATA_CONFIG_MUTATION, variables).then(function(data) {
                        return hydrateObject(data.customDataConfig);
                    })
                ];
            });
        });
        return function(data) {
            return _ref.apply(this, arguments);
        };
    }(),
    deleteObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(DELETE_CUSTOM_DATA_CONFIG_MUTATION, variables).then(function(data) {
                        return data.deleteTravelPricingCustomDataConfig;
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }(),
    forceDeleteObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(FORCE_DELETE_CUSTOM_DATA_CONFIG_MUTATION, variables).then(function(data) {
                        return data.forceDeleteTravelPricingCustomDataConfig;
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }()
};
/* harmony default export */ var repository = (travelPricingCustomDataConfigRepository);

;// CONCATENATED MODULE: ./src/entities/travelPricingCustomDataConfig/entity.ts


var travelPricingCustomDataConfigEntity = {
    model: model,
    repository: repository
};
/* harmony default export */ var travelPricingCustomDataConfig_entity = (travelPricingCustomDataConfigEntity);


/***/ }),

/***/ 28967:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ travelPricingMandatorySettings_entity; }
});

;// CONCATENATED MODULE: ./src/entities/travelPricingMandatorySettings/graphql.ts
// language=GraphQL
var ALL_MANDATORY_SETTINGS_QUERY = "query Query($withRules: Boolean = false, $withRulesAccommodations: Boolean = false, $withRulesAccommodationsCapacitySettings: Boolean = false, $withRulesAccommodationsAddons: Boolean = false, $withRulesFamilyPackages: Boolean = false, $withRulesFamilyPackagesAccommodation: Boolean = false, $withRulesFamilyPackagesCapacitySettings: Boolean = false, $withRulesFamilyPackagesAddons: Boolean = false, $withRulesAccommodationAddons: Boolean = false, $withRulesAccommodationAddonsCalculationSettings: Boolean = false, $withRulesAccommodationAddonsMandatorySettings: Boolean = false, $withRulesAgeGroups: Boolean = false, $withRulesAgeFilter: Boolean = false, $withRulesTravelDates: Boolean = false, $withRulesTravelDatesAvailabilityStatus: Boolean = false, $withRulesTravelDatesExtensionBaseDate: Boolean = false, $withRulesTravelDatesExtension: Boolean = false, $withRulesTravelDatesPackageSettings: Boolean = false, $withRulesTravelDatesExtensions: Boolean = false) {\n  mandatorySettings: allTravelPricingMandatorySettings {\n    id\n    isMandatory\n    useRules\n    rules @include(if: $withRules) {\n      id\n      checkAccommodationTypes\n      accommodations @include(if: $withRulesAccommodations) {\n        id\n        ratioPackageNo\n        name\n        label\n        info\n        isFamilyPackageAccommodation\n        isBabyPackage\n        capacitySettings @include(if: $withRulesAccommodationsCapacitySettings) {\n          id\n          totalCapacity\n          rangesAllowed\n          partialOccupancyAllowed\n        }\n        addons @include(if: $withRulesAccommodationsAddons) {\n          id\n          ratioServiceNo\n          name\n          label\n          info\n        }\n      }\n      familyPackages @include(if: $withRulesFamilyPackages) {\n        id\n        ratioServiceNo\n        accommodation @include(if: $withRulesFamilyPackagesAccommodation) {\n          id\n          ratioPackageNo\n          name\n          label\n          info\n          isFamilyPackageAccommodation\n          isBabyPackage\n        }\n        name\n        label\n        info\n        capacitySettings @include(if: $withRulesFamilyPackagesCapacitySettings) {\n          id\n          totalCapacity\n          rangesAllowed\n          partialOccupancyAllowed\n        }\n        addons @include(if: $withRulesFamilyPackagesAddons) {\n          id\n          ratioServiceNo\n          name\n          label\n          info\n        }\n      }\n      checkAccommodationAddons\n      accommodationAddons @include(if: $withRulesAccommodationAddons) {\n        id\n        ratioServiceNo\n        name\n        label\n        info\n        calculationSettings @include(if: $withRulesAccommodationAddonsCalculationSettings) {\n          id\n          type\n          considerHotelNights\n        }\n        mandatorySettings @include(if: $withRulesAccommodationAddonsMandatorySettings) {\n          id\n          isMandatory\n          useRules\n        }\n      }\n      checkAgeGroups\n      ageGroups @include(if: $withRulesAgeGroups) {\n        id\n        name\n        type\n        icon\n        minAge\n        maxAge\n      }\n      useAgeFilter\n      ageFilter @include(if: $withRulesAgeFilter) {\n        id\n        minAge\n        maxAge\n      }\n      checkDateRange\n      startDate\n      endDate\n      checkTravelDate\n      travelDates @include(if: $withRulesTravelDates) {\n        id\n        dateNo\n        startDate\n        endDate\n        availabilityStatus @include(if: $withRulesTravelDatesAvailabilityStatus) {\n          id\n          label\n          status\n          isDefaultStatus\n          isDefaultWaitlistFallback\n        }\n        includesExtension\n        extensionBaseDate @include(if: $withRulesTravelDatesExtensionBaseDate) {\n          id\n          dateNo\n          startDate\n          endDate\n          includesExtension\n          json\n        }\n        extension @include(if: $withRulesTravelDatesExtension) {\n          id\n          label\n          info\n        }\n        packageSettings @include(if: $withRulesTravelDatesPackageSettings) {\n          id\n          ratioPackageNo\n          price\n          availabilityStatus\n        }\n        json\n        extensions @include(if: $withRulesTravelDatesExtensions) {\n          id\n          label\n          info\n        }\n      }\n    }\n  }\n}";
// language=GraphQL
var SINGLE_MANDATORY_SETTINGS_QUERY = "query Query($id: ID!, $withRules: Boolean = false, $withRulesAccommodations: Boolean = false, $withRulesAccommodationsCapacitySettings: Boolean = false, $withRulesAccommodationsAddons: Boolean = false, $withRulesFamilyPackages: Boolean = false, $withRulesFamilyPackagesAccommodation: Boolean = false, $withRulesFamilyPackagesCapacitySettings: Boolean = false, $withRulesFamilyPackagesAddons: Boolean = false, $withRulesAccommodationAddons: Boolean = false, $withRulesAccommodationAddonsCalculationSettings: Boolean = false, $withRulesAccommodationAddonsMandatorySettings: Boolean = false, $withRulesAgeGroups: Boolean = false, $withRulesAgeFilter: Boolean = false, $withRulesTravelDates: Boolean = false, $withRulesTravelDatesAvailabilityStatus: Boolean = false, $withRulesTravelDatesExtensionBaseDate: Boolean = false, $withRulesTravelDatesExtension: Boolean = false, $withRulesTravelDatesPackageSettings: Boolean = false, $withRulesTravelDatesExtensions: Boolean = false) {\n  mandatorySettings: travelPricingMandatorySettings(id: $id) {\n    id\n    isMandatory\n    useRules\n    rules @include(if: $withRules) {\n      id\n      checkAccommodationTypes\n      accommodations @include(if: $withRulesAccommodations) {\n        id\n        ratioPackageNo\n        name\n        label\n        info\n        isFamilyPackageAccommodation\n        isBabyPackage\n        capacitySettings @include(if: $withRulesAccommodationsCapacitySettings) {\n          id\n          totalCapacity\n          rangesAllowed\n          partialOccupancyAllowed\n        }\n        addons @include(if: $withRulesAccommodationsAddons) {\n          id\n          ratioServiceNo\n          name\n          label\n          info\n        }\n      }\n      familyPackages @include(if: $withRulesFamilyPackages) {\n        id\n        ratioServiceNo\n        accommodation @include(if: $withRulesFamilyPackagesAccommodation) {\n          id\n          ratioPackageNo\n          name\n          label\n          info\n          isFamilyPackageAccommodation\n          isBabyPackage\n        }\n        name\n        label\n        info\n        capacitySettings @include(if: $withRulesFamilyPackagesCapacitySettings) {\n          id\n          totalCapacity\n          rangesAllowed\n          partialOccupancyAllowed\n        }\n        addons @include(if: $withRulesFamilyPackagesAddons) {\n          id\n          ratioServiceNo\n          name\n          label\n          info\n        }\n      }\n      checkAccommodationAddons\n      accommodationAddons @include(if: $withRulesAccommodationAddons) {\n        id\n        ratioServiceNo\n        name\n        label\n        info\n        calculationSettings @include(if: $withRulesAccommodationAddonsCalculationSettings) {\n          id\n          type\n          considerHotelNights\n        }\n        mandatorySettings @include(if: $withRulesAccommodationAddonsMandatorySettings) {\n          id\n          isMandatory\n          useRules\n        }\n      }\n      checkAgeGroups\n      ageGroups @include(if: $withRulesAgeGroups) {\n        id\n        name\n        type\n        icon\n        minAge\n        maxAge\n      }\n      useAgeFilter\n      ageFilter @include(if: $withRulesAgeFilter) {\n        id\n        minAge\n        maxAge\n      }\n      checkDateRange\n      startDate\n      endDate\n      checkTravelDate\n      travelDates @include(if: $withRulesTravelDates) {\n        id\n        dateNo\n        startDate\n        endDate\n        availabilityStatus @include(if: $withRulesTravelDatesAvailabilityStatus) {\n          id\n          label\n          status\n          isDefaultStatus\n          isDefaultWaitlistFallback\n        }\n        includesExtension\n        extensionBaseDate @include(if: $withRulesTravelDatesExtensionBaseDate) {\n          id\n          dateNo\n          startDate\n          endDate\n          includesExtension\n          json\n        }\n        extension @include(if: $withRulesTravelDatesExtension) {\n          id\n          label\n          info\n        }\n        packageSettings @include(if: $withRulesTravelDatesPackageSettings) {\n          id\n          ratioPackageNo\n          price\n          availabilityStatus\n        }\n        json\n        extensions @include(if: $withRulesTravelDatesExtensions) {\n          id\n          label\n          info\n        }\n      }\n    }\n  }\n}";
// language=GraphQL
var CREATE_MANDATORY_SETTINGS_MUTATION = "\n  mutation Mutation($input: CreateTravelPricingMandatorySettingsInput, $withRules: Boolean = false, $withRulesAccommodations: Boolean = false, $withRulesAccommodationsCapacitySettings: Boolean = false, $withRulesAccommodationsAddons: Boolean = false, $withRulesFamilyPackages: Boolean = false, $withRulesFamilyPackagesAccommodation: Boolean = false, $withRulesFamilyPackagesCapacitySettings: Boolean = false, $withRulesFamilyPackagesAddons: Boolean = false, $withRulesAccommodationAddons: Boolean = false, $withRulesAccommodationAddonsCalculationSettings: Boolean = false, $withRulesAccommodationAddonsMandatorySettings: Boolean = false, $withRulesAgeGroups: Boolean = false, $withRulesAgeFilter: Boolean = false, $withRulesTravelDates: Boolean = false, $withRulesTravelDatesAvailabilityStatus: Boolean = false, $withRulesTravelDatesExtensionBaseDate: Boolean = false, $withRulesTravelDatesExtension: Boolean = false, $withRulesTravelDatesPackageSettings: Boolean = false, $withRulesTravelDatesExtensions: Boolean = false) {\n    mandatorySettings: createTravelPricingMandatorySettings(input: $input) {\n      id\n      isMandatory\n      useRules\n      rules @include(if: $withRules) {\n        id\n        checkAccommodationTypes\n        accommodations @include(if: $withRulesAccommodations) {\n          id\n          ratioPackageNo\n          name\n          label\n          info\n          isFamilyPackageAccommodation\n          isBabyPackage\n          capacitySettings @include(if: $withRulesAccommodationsCapacitySettings) {\n            id\n            totalCapacity\n            rangesAllowed\n            partialOccupancyAllowed\n          }\n          addons @include(if: $withRulesAccommodationsAddons) {\n            id\n            ratioServiceNo\n            name\n            label\n            info\n          }\n        }\n        familyPackages @include(if: $withRulesFamilyPackages) {\n          id\n          ratioServiceNo\n          accommodation @include(if: $withRulesFamilyPackagesAccommodation) {\n            id\n            ratioPackageNo\n            name\n            label\n            info\n            isFamilyPackageAccommodation\n            isBabyPackage\n          }\n          name\n          label\n          info\n          capacitySettings @include(if: $withRulesFamilyPackagesCapacitySettings) {\n            id\n            totalCapacity\n            rangesAllowed\n            partialOccupancyAllowed\n          }\n          addons @include(if: $withRulesFamilyPackagesAddons) {\n            id\n            ratioServiceNo\n            name\n            label\n            info\n          }\n        }\n        checkAccommodationAddons\n        accommodationAddons @include(if: $withRulesAccommodationAddons) {\n          id\n          ratioServiceNo\n          name\n          label\n          info\n          calculationSettings @include(if: $withRulesAccommodationAddonsCalculationSettings) {\n            id\n            type\n            considerHotelNights\n          }\n          mandatorySettings @include(if: $withRulesAccommodationAddonsMandatorySettings) {\n            id\n            isMandatory\n            useRules\n          }\n        }\n        checkAgeGroups\n        ageGroups @include(if: $withRulesAgeGroups) {\n          id\n          name\n          type\n          icon\n          minAge\n          maxAge\n        }\n        useAgeFilter\n        ageFilter @include(if: $withRulesAgeFilter) {\n          id\n          minAge\n          maxAge\n        }\n        checkDateRange\n        startDate\n        endDate\n        checkTravelDate\n        travelDates @include(if: $withRulesTravelDates) {\n          id\n          dateNo\n          startDate\n          endDate\n          availabilityStatus @include(if: $withRulesTravelDatesAvailabilityStatus) {\n            id\n            label\n            status\n            isDefaultStatus\n            isDefaultWaitlistFallback\n          }\n          includesExtension\n          extensionBaseDate @include(if: $withRulesTravelDatesExtensionBaseDate) {\n            id\n            dateNo\n            startDate\n            endDate\n            includesExtension\n            json\n          }\n          extension @include(if: $withRulesTravelDatesExtension) {\n            id\n            label\n            info\n          }\n          packageSettings @include(if: $withRulesTravelDatesPackageSettings) {\n            id\n            ratioPackageNo\n            price\n            availabilityStatus\n          }\n          json\n          extensions @include(if: $withRulesTravelDatesExtensions) {\n            id\n            label\n            info\n          }\n        }\n      }\n    }\n  }";
// language=GraphQL
var UPDATE_MANDATORY_SETTINGS_MUTATION = "\n  mutation Mutation($input: UpdateTravelPricingMandatorySettingsInput, $withRules: Boolean = false, $withRulesAccommodations: Boolean = false, $withRulesAccommodationsCapacitySettings: Boolean = false, $withRulesAccommodationsAddons: Boolean = false, $withRulesFamilyPackages: Boolean = false, $withRulesFamilyPackagesAccommodation: Boolean = false, $withRulesFamilyPackagesCapacitySettings: Boolean = false, $withRulesFamilyPackagesAddons: Boolean = false, $withRulesAccommodationAddons: Boolean = false, $withRulesAccommodationAddonsCalculationSettings: Boolean = false, $withRulesAccommodationAddonsMandatorySettings: Boolean = false, $withRulesAgeGroups: Boolean = false, $withRulesAgeFilter: Boolean = false, $withRulesTravelDates: Boolean = false, $withRulesTravelDatesAvailabilityStatus: Boolean = false, $withRulesTravelDatesExtensionBaseDate: Boolean = false, $withRulesTravelDatesExtension: Boolean = false, $withRulesTravelDatesPackageSettings: Boolean = false, $withRulesTravelDatesExtensions: Boolean = false) {\n    mandatorySettings: updateTravelPricingMandatorySettings(input: $input) {\n      id\n      isMandatory\n      useRules\n      rules @include(if: $withRules) {\n        id\n        checkAccommodationTypes\n        accommodations @include(if: $withRulesAccommodations) {\n          id\n          ratioPackageNo\n          name\n          label\n          info\n          isFamilyPackageAccommodation\n          isBabyPackage\n          capacitySettings @include(if: $withRulesAccommodationsCapacitySettings) {\n            id\n            totalCapacity\n            rangesAllowed\n            partialOccupancyAllowed\n          }\n          addons @include(if: $withRulesAccommodationsAddons) {\n            id\n            ratioServiceNo\n            name\n            label\n            info\n          }\n        }\n        familyPackages @include(if: $withRulesFamilyPackages) {\n          id\n          ratioServiceNo\n          accommodation @include(if: $withRulesFamilyPackagesAccommodation) {\n            id\n            ratioPackageNo\n            name\n            label\n            info\n            isFamilyPackageAccommodation\n            isBabyPackage\n          }\n          name\n          label\n          info\n          capacitySettings @include(if: $withRulesFamilyPackagesCapacitySettings) {\n            id\n            totalCapacity\n            rangesAllowed\n            partialOccupancyAllowed\n          }\n          addons @include(if: $withRulesFamilyPackagesAddons) {\n            id\n            ratioServiceNo\n            name\n            label\n            info\n          }\n        }\n        checkAccommodationAddons\n        accommodationAddons @include(if: $withRulesAccommodationAddons) {\n          id\n          ratioServiceNo\n          name\n          label\n          info\n          calculationSettings @include(if: $withRulesAccommodationAddonsCalculationSettings) {\n            id\n            type\n            considerHotelNights\n          }\n          mandatorySettings @include(if: $withRulesAccommodationAddonsMandatorySettings) {\n            id\n            isMandatory\n            useRules\n          }\n        }\n        checkAgeGroups\n        ageGroups @include(if: $withRulesAgeGroups) {\n          id\n          name\n          type\n          icon\n          minAge\n          maxAge\n        }\n        useAgeFilter\n        ageFilter @include(if: $withRulesAgeFilter) {\n          id\n          minAge\n          maxAge\n        }\n        checkDateRange\n        startDate\n        endDate\n        checkTravelDate\n        travelDates @include(if: $withRulesTravelDates) {\n          id\n          dateNo\n          startDate\n          endDate\n          availabilityStatus @include(if: $withRulesTravelDatesAvailabilityStatus) {\n            id\n            label\n            status\n            isDefaultStatus\n            isDefaultWaitlistFallback\n          }\n          includesExtension\n          extensionBaseDate @include(if: $withRulesTravelDatesExtensionBaseDate) {\n            id\n            dateNo\n            startDate\n            endDate\n            includesExtension\n            json\n          }\n          extension @include(if: $withRulesTravelDatesExtension) {\n            id\n            label\n            info\n          }\n          packageSettings @include(if: $withRulesTravelDatesPackageSettings) {\n            id\n            ratioPackageNo\n            price\n            availabilityStatus\n          }\n          json\n          extensions @include(if: $withRulesTravelDatesExtensions) {\n            id\n            label\n            info\n          }\n        }\n      }\n    }\n  }";
// language=GraphQL
var DELETE_MANDATORY_SETTINGS_MUTATION = "\n  mutation Mutation($input: DeleteTravelPricingMandatorySettingsInput) {\n    deleteTravelPricingMandatorySettings(input: $input) {\n      success\n    }\n  }";
// language=GraphQL
var FORCE_DELETE_MANDATORY_SETTINGS_MUTATION = "\n  mutation Mutation($input: DeleteTravelPricingMandatorySettingsInput) {\n    forceDeleteTravelPricingMandatorySettings(input: $input) {\n      success\n    }\n  }";
// language=GraphQL
var MANDATORY_SETTINGS_DEPENDENTS_QUERY = "query Query($id: ID!, $withRatioPersonalAddons: Boolean = false, $withRatioBookingAddons: Boolean = false, $withRatioCollectiveAddons: Boolean = false, $withRatioPersonalDiscounts: Boolean = false, $withRatioAccommodationAddons: Boolean = false) {\n  groupedDependents: travelPricingMandatorySettingsDependents(id: $id) {\n    ratioPersonalAddons @include(if: $withRatioPersonalAddons) {\n      id\n      ratioServiceNo\n      name\n      label\n      info\n    }\n    ratioBookingAddons @include(if: $withRatioBookingAddons) {\n      id\n      ratioServiceNo\n      name\n      label\n      info\n    }\n    ratioCollectiveAddons @include(if: $withRatioCollectiveAddons) {\n      id\n      label\n      info\n    }\n    ratioPersonalDiscounts @include(if: $withRatioPersonalDiscounts) {\n      id\n      ratioServiceNo\n      name\n      label\n      info\n    }\n    ratioAccommodationAddons @include(if: $withRatioAccommodationAddons) {\n      id\n      ratioServiceNo\n      name\n      label\n      info\n    }\n  }\n}";

// EXTERNAL MODULE: ./src/entities/travelPricingRules/entity.ts + 3 modules
var entity = __webpack_require__(39704);
;// CONCATENATED MODULE: ./src/entities/travelPricingMandatorySettings/model.ts


var travelPricingMandatorySettingsModel = {
    name: "mandatorySettings",
    namePlural: "mandatorySettings",
    uniqueName: "travelPricingMandatorySettings",
    uniqueNamePlural: "travelPricingMandatorySettings",
    path: "travel/pricing/mandatory_settings",
    baseUrl: "/travel/pricing/mandatory_settings",
    translationPrefix: "entities:travelPricingMandatorySettings.",
    getDisplayName: function(values) {
        return "Mandatory Settings";
    },
    gql: {
        getAll: ALL_MANDATORY_SETTINGS_QUERY,
        getSingle: SINGLE_MANDATORY_SETTINGS_QUERY,
        create: CREATE_MANDATORY_SETTINGS_MUTATION,
        update: UPDATE_MANDATORY_SETTINGS_MUTATION,
        delete: DELETE_MANDATORY_SETTINGS_MUTATION,
        forceDelete: FORCE_DELETE_MANDATORY_SETTINGS_MUTATION
    },
    attributes: {
        isMandatory: {
            name: "isMandatory",
            label: "entities:travelPricingMandatorySettings.attributes.isMandatory.label",
            type: "value",
            dataType: "boolean",
            defaultInput: true,
            inputType: "switch",
            validationType: "string",
            validations: []
        },
        useRules: {
            name: "useRules",
            label: "entities:travelPricingMandatorySettings.attributes.useRules.label",
            type: "value",
            dataType: "boolean",
            defaultInput: true,
            inputType: "switch",
            validationType: "string",
            validations: []
        },
        rules: {
            name: "rules",
            label: "entities:travelPricingMandatorySettings.attributes.rules.label",
            type: "entityObject",
            dataType: "any",
            getEntity: function() {
                return entity/* default */.Z;
            },
            defaultInput: false,
            inputType: "select",
            validationType: "string",
            validations: []
        }
    }
};
/* harmony default export */ var model = (travelPricingMandatorySettingsModel);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(20414);
// EXTERNAL MODULE: ./src/entities/lib.ts
var lib = __webpack_require__(23480);
// EXTERNAL MODULE: ./src/lib/api/graphQLClient.ts
var graphQLClient = __webpack_require__(40112);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/swr/dist/index.mjs
var dist = __webpack_require__(8100);
// EXTERNAL MODULE: ./src/lib/helpers/helpers.ts
var helpers = __webpack_require__(15778);
;// CONCATENATED MODULE: ./src/entities/travelPricingMandatorySettings/repository.ts










var hydrateObjects = function(objects) {
    return objects.map(function(object) {
        return (0,lib/* hydrateEntityObject */.b)(model, object);
    });
};
var hydrateObject = function(object) {
    return (0,lib/* hydrateEntityObject */.b)(model, object);
};
var travelPricingMandatorySettingsRepository = {
    getObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    id: id
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(SINGLE_MANDATORY_SETTINGS_QUERY, variables).then(function(data) {
                        return hydrateObject(data.mandatorySettings);
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }(),
    getObjects: /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        var includes;
        var _arguments = arguments;
        return (0,tslib_es6.__generator)(this, function(_state) {
            includes = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : {};
            return [
                2,
                graphQLClient/* default.request */.Z.request(ALL_MANDATORY_SETTINGS_QUERY, includes).then(function(data) {
                    return hydrateObjects(data.mandatorySettings);
                })
            ];
        });
    }),
    useObject: function(id) {
        var includes = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        // eslint-disable-next-line react-hooks/exhaustive-deps
        var variables = (0,react.useMemo)(function() {
            return (0,_object_spread/* default */.Z)({
                id: id
            }, includes);
        }, [
            id
        ]);
        var ref = (0,dist/* default */.ZP)([
            SINGLE_MANDATORY_SETTINGS_QUERY,
            variables
        ], {
            revalidateOnFocus: false
        }), data = ref.data, error = ref.error, mutate = ref.mutate;
        return {
            object: !data ? data : hydrateObject(data.mandatorySettings),
            isLoading: !error && !data,
            isError: error,
            mutate: mutate
        };
    },
    useObjects: function() {
        var includes = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        // eslint-disable-next-line react-hooks/exhaustive-deps
        var variables = (0,react.useMemo)(function() {
            return includes;
        }, []);
        var ref = (0,dist/* default */.ZP)([
            ALL_MANDATORY_SETTINGS_QUERY,
            variables
        ]), data = ref.data, error = ref.error, mutate = ref.mutate;
        return {
            objects: !data ? data : hydrateObjects(data.mandatorySettings),
            isLoading: !error && !data,
            isError: error,
            mutate: mutate
        };
    },
    getDependents: function(id, includes) {
        var includeVars = {};
        includes.forEach(function(include) {
            includeVars["with".concat((0,helpers/* uppercaseFirst */.AB)(include))] = true;
        });
        var variables = (0,_object_spread/* default */.Z)({
            id: id
        }, includeVars);
        return graphQLClient/* default.request */.Z.request(MANDATORY_SETTINGS_DEPENDENTS_QUERY, variables).then(function(data) {
            return data.groupedDependents;
        });
    },
    useDependents: function(id, includes) {
        var includeVars = {};
        includes.forEach(function(include) {
            includeVars["with".concat((0,helpers/* uppercaseFirst */.AB)(include))] = true;
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
        var variables = (0,react.useMemo)(function() {
            return (0,_object_spread/* default */.Z)({
                id: id
            }, includeVars);
        }, [
            id
        ]);
        var ref = (0,dist/* default */.ZP)([
            MANDATORY_SETTINGS_DEPENDENTS_QUERY,
            variables
        ], {
            revalidateOnFocus: false
        }), data = ref.data, error = ref.error, mutate = ref.mutate;
        return {
            data: !data ? data : data.groupedDependents,
            isLoading: !error && !data,
            isError: error,
            mutate: mutate
        };
    },
    createObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(data) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    input: data
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(CREATE_MANDATORY_SETTINGS_MUTATION, variables).then(function(data) {
                        return hydrateObject(data.mandatorySettings);
                    })
                ];
            });
        });
        return function(data) {
            return _ref.apply(this, arguments);
        };
    }(),
    updateObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(data) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    input: data
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(UPDATE_MANDATORY_SETTINGS_MUTATION, variables).then(function(data) {
                        return hydrateObject(data.mandatorySettings);
                    })
                ];
            });
        });
        return function(data) {
            return _ref.apply(this, arguments);
        };
    }(),
    deleteObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(DELETE_MANDATORY_SETTINGS_MUTATION, variables).then(function(data) {
                        return data.deleteTravelPricingMandatorySettings;
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }(),
    forceDeleteObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(FORCE_DELETE_MANDATORY_SETTINGS_MUTATION, variables).then(function(data) {
                        return data.forceDeleteTravelPricingMandatorySettings;
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }()
};
/* harmony default export */ var repository = (travelPricingMandatorySettingsRepository);

;// CONCATENATED MODULE: ./src/entities/travelPricingMandatorySettings/entity.ts


var travelPricingMandatorySettingsEntity = {
    model: model,
    repository: repository
};
/* harmony default export */ var travelPricingMandatorySettings_entity = (travelPricingMandatorySettingsEntity);


/***/ }),

/***/ 38339:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ entity; }
});

;// CONCATENATED MODULE: ./src/entities/travelPricingPassportConfig/graphql.ts
// language=GraphQL
var ALL_PASSPORT_CONFIGS_QUERY = "query Query {\n  passportConfigs: travelPricingPassportConfigs {\n    id\n    passportOnly\n  }\n}";
// language=GraphQL
var SINGLE_PASSPORT_CONFIG_QUERY = "query Query($id: ID!) {\n  passportConfig: travelPricingPassportConfig(id: $id) {\n    id\n    passportOnly\n  }\n}";
// language=GraphQL
var CREATE_PASSPORT_CONFIG_MUTATION = "\n  mutation Mutation($input: CreateTravelPricingPassportConfigInput) {\n    passportConfig: createTravelPricingPassportConfig(input: $input) {\n      id\n      passportOnly\n    }\n  }";
// language=GraphQL
var UPDATE_PASSPORT_CONFIG_MUTATION = "\n  mutation Mutation($input: UpdateTravelPricingPassportConfigInput) {\n    passportConfig: updateTravelPricingPassportConfig(input: $input) {\n      id\n      passportOnly\n    }\n  }";
// language=GraphQL
var DELETE_PASSPORT_CONFIG_MUTATION = "\n  mutation Mutation($input: DeleteTravelPricingPassportConfigInput) {\n    deleteTravelPricingPassportConfig(input: $input) {\n      success\n    }\n  }";
// language=GraphQL
var FORCE_DELETE_PASSPORT_CONFIG_MUTATION = "\n  mutation Mutation($input: DeleteTravelPricingPassportConfigInput) {\n    forceDeleteTravelPricingPassportConfig(input: $input) {\n      success\n    }\n  }";
// language=GraphQL
var PASSPORT_CONFIGS_DEPENDENTS_QUERY = "query Query($id: ID!, $withTravelPricings: Boolean = false) {\n  groupedDependents: travelPricingPassportConfigDependents(id: $id) {\n    travelPricings @include(if: $withTravelPricings) {\n      id\n      isTravelDocumentationAvailable\n    }\n  }\n}";

;// CONCATENATED MODULE: ./src/entities/travelPricingPassportConfig/model.ts

var travelPricingPassportConfigModel = {
    name: "passportConfig",
    namePlural: "passportConfigs",
    uniqueName: "travelPricingPassportConfig",
    uniqueNamePlural: "travelPricingPassportConfigs",
    path: "travel/pricing/passport_config",
    baseUrl: "/travel/pricing/passport_configs",
    translationPrefix: "entities:travelPricingPassportConfig.",
    getDisplayName: function(values) {
        return "PASSPORT CONFIG";
    },
    gql: {
        getAll: ALL_PASSPORT_CONFIGS_QUERY,
        getSingle: SINGLE_PASSPORT_CONFIG_QUERY,
        create: CREATE_PASSPORT_CONFIG_MUTATION,
        update: UPDATE_PASSPORT_CONFIG_MUTATION,
        delete: DELETE_PASSPORT_CONFIG_MUTATION,
        forceDelete: FORCE_DELETE_PASSPORT_CONFIG_MUTATION
    },
    attributes: {
        passportOnly: {
            name: "passportOnly",
            label: "entities:travelPricingPassportConfig.attributes.passportOnly.label",
            type: "value",
            dataType: "boolean",
            defaultInput: true,
            inputType: "switch",
            validationType: "string",
            validations: []
        }
    }
};
/* harmony default export */ var model = (travelPricingPassportConfigModel);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(20414);
// EXTERNAL MODULE: ./src/entities/lib.ts
var lib = __webpack_require__(23480);
// EXTERNAL MODULE: ./src/lib/api/graphQLClient.ts
var graphQLClient = __webpack_require__(40112);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/swr/dist/index.mjs
var dist = __webpack_require__(8100);
// EXTERNAL MODULE: ./src/lib/helpers/helpers.ts
var helpers = __webpack_require__(15778);
;// CONCATENATED MODULE: ./src/entities/travelPricingPassportConfig/repository.ts










var hydrateObjects = function(objects) {
    return objects.map(function(object) {
        return (0,lib/* hydrateEntityObject */.b)(model, object);
    });
};
var hydrateObject = function(object) {
    return (0,lib/* hydrateEntityObject */.b)(model, object);
};
var travelPricingPassportConfigRepository = {
    getObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    id: id
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(SINGLE_PASSPORT_CONFIG_QUERY, variables).then(function(data) {
                        return hydrateObject(data.passportConfig);
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }(),
    getObjects: /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        var includes;
        var _arguments = arguments;
        return (0,tslib_es6.__generator)(this, function(_state) {
            includes = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : {};
            return [
                2,
                graphQLClient/* default.request */.Z.request(ALL_PASSPORT_CONFIGS_QUERY, includes).then(function(data) {
                    return hydrateObjects(data.passportConfigs);
                })
            ];
        });
    }),
    useObject: function(id) {
        var includes = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        // eslint-disable-next-line react-hooks/exhaustive-deps
        var variables = (0,react.useMemo)(function() {
            return (0,_object_spread/* default */.Z)({
                id: id
            }, includes);
        }, [
            id
        ]);
        var ref = (0,dist/* default */.ZP)([
            SINGLE_PASSPORT_CONFIG_QUERY,
            variables
        ], {
            revalidateOnFocus: false
        }), data = ref.data, error = ref.error, mutate = ref.mutate;
        return {
            object: !data ? data : hydrateObject(data.passportConfig),
            isLoading: !error && !data,
            isError: error,
            mutate: mutate
        };
    },
    useObjects: function() {
        var includes = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        // eslint-disable-next-line react-hooks/exhaustive-deps
        var variables = (0,react.useMemo)(function() {
            return includes;
        }, []);
        var ref = (0,dist/* default */.ZP)([
            ALL_PASSPORT_CONFIGS_QUERY,
            variables
        ]), data = ref.data, error = ref.error, mutate = ref.mutate;
        return {
            objects: !data ? data : hydrateObjects(data.passportConfigs),
            isLoading: !error && !data,
            isError: error,
            mutate: mutate
        };
    },
    getDependents: function(id, includes) {
        var includeVars = {};
        includes.forEach(function(include) {
            includeVars["with".concat((0,helpers/* uppercaseFirst */.AB)(include))] = true;
        });
        var variables = (0,_object_spread/* default */.Z)({
            id: id
        }, includeVars);
        return graphQLClient/* default.request */.Z.request(PASSPORT_CONFIGS_DEPENDENTS_QUERY, variables).then(function(data) {
            return data.groupedDependents;
        });
    },
    useDependents: function(id, includes) {
        var includeVars = {};
        includes.forEach(function(include) {
            includeVars["with".concat((0,helpers/* uppercaseFirst */.AB)(include))] = true;
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
        var variables = (0,react.useMemo)(function() {
            return (0,_object_spread/* default */.Z)({
                id: id
            }, includeVars);
        }, [
            id
        ]);
        var ref = (0,dist/* default */.ZP)([
            PASSPORT_CONFIGS_DEPENDENTS_QUERY,
            variables
        ], {
            revalidateOnFocus: false
        }), data = ref.data, error = ref.error, mutate = ref.mutate;
        return {
            data: !data ? data : data.groupedDependents,
            isLoading: !error && !data,
            isError: error,
            mutate: mutate
        };
    },
    createObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(data) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    input: data
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(CREATE_PASSPORT_CONFIG_MUTATION, variables).then(function(data) {
                        return hydrateObject(data.passportConfig);
                    })
                ];
            });
        });
        return function(data) {
            return _ref.apply(this, arguments);
        };
    }(),
    updateObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(data) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    input: data
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(UPDATE_PASSPORT_CONFIG_MUTATION, variables).then(function(data) {
                        return hydrateObject(data.passportConfig);
                    })
                ];
            });
        });
        return function(data) {
            return _ref.apply(this, arguments);
        };
    }(),
    deleteObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(DELETE_PASSPORT_CONFIG_MUTATION, variables).then(function(data) {
                        return data.deleteTravelPricingPassportConfig;
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }(),
    forceDeleteObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(FORCE_DELETE_PASSPORT_CONFIG_MUTATION, variables).then(function(data) {
                        return data.forceDeleteTravelPricingPassportConfig;
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }()
};
/* harmony default export */ var repository = (travelPricingPassportConfigRepository);

;// CONCATENATED MODULE: ./src/entities/travelPricingPassportConfig/entity.ts


var travelPricingPassportConfigEntity = {
    model: model,
    repository: repository
};
/* harmony default export */ var entity = (travelPricingPassportConfigEntity);


/***/ }),

/***/ 39704:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ travelPricingRules_entity; }
});

;// CONCATENATED MODULE: ./src/entities/travelPricingRules/graphql.ts
// language=GraphQL
var ALL_PRICING_RULES_QUERY = "query Query($withAccommodations: Boolean = false, $withAccommodationsCapacitySettings: Boolean = false, $withAccommodationsCapacitySettingsAgeGroupCapacities: Boolean = false, $withAccommodationsCapacitySettingsAgeGroupedTotalCapacities: Boolean = false, $withAccommodationsCapacitySettingsPartialOccupancyAllowedAgeGroups: Boolean = false, $withAccommodationsAddons: Boolean = false, $withAccommodationsAddonsCalculationSettings: Boolean = false, $withAccommodationsAddonsMandatorySettings: Boolean = false, $withFamilyPackages: Boolean = false, $withFamilyPackagesAccommodation: Boolean = false, $withFamilyPackagesAccommodationCapacitySettings: Boolean = false, $withFamilyPackagesAccommodationAddons: Boolean = false, $withFamilyPackagesCapacitySettings: Boolean = false, $withFamilyPackagesCapacitySettingsAgeGroupCapacities: Boolean = false, $withFamilyPackagesCapacitySettingsAgeGroupedTotalCapacities: Boolean = false, $withFamilyPackagesCapacitySettingsPartialOccupancyAllowedAgeGroups: Boolean = false, $withFamilyPackagesAddons: Boolean = false, $withFamilyPackagesAddonsCalculationSettings: Boolean = false, $withFamilyPackagesAddonsMandatorySettings: Boolean = false, $withAccommodationAddons: Boolean = false, $withAccommodationAddonsCalculationSettings: Boolean = false, $withAccommodationAddonsMandatorySettings: Boolean = false, $withAccommodationAddonsMandatorySettingsRules: Boolean = false, $withAgeGroups: Boolean = false, $withAgeFilter: Boolean = false, $withTravelDates: Boolean = false, $withTravelDatesAvailabilityStatus: Boolean = false, $withTravelDatesAvailabilityStatusTenantSettings: Boolean = false, $withTravelDatesExtensionBaseDate: Boolean = false, $withTravelDatesExtensionBaseDateAvailabilityStatus: Boolean = false, $withTravelDatesExtensionBaseDateExtensionBaseDate: Boolean = false, $withTravelDatesExtensionBaseDateExtension: Boolean = false, $withTravelDatesExtensionBaseDatePackageSettings: Boolean = false, $withTravelDatesExtensionBaseDateExtensions: Boolean = false, $withTravelDatesExtension: Boolean = false, $withTravelDatesExtensionTravelExtension: Boolean = false, $withTravelDatesExtensionAccommodationMapItems: Boolean = false, $withTravelDatesPackageSettings: Boolean = false, $withTravelDatesExtensions: Boolean = false, $withTravelDatesExtensionsTravelExtension: Boolean = false, $withTravelDatesExtensionsAccommodationMapItems: Boolean = false) {\n  pricingRules: allTravelPricingRules {\n    id\n    checkAccommodationTypes\n    accommodations @include(if: $withAccommodations) {\n      id\n      ratioPackageNo\n      name\n      label\n      info\n      isFamilyPackageAccommodation\n      isBabyPackage\n      capacitySettings @include(if: $withAccommodationsCapacitySettings) {\n        id\n        totalCapacity\n        rangesAllowed\n        ageGroupCapacities @include(if: $withAccommodationsCapacitySettingsAgeGroupCapacities) {\n          id\n          minCapacity\n          maxCapacity\n        }\n        ageGroupedTotalCapacities @include(if: $withAccommodationsCapacitySettingsAgeGroupedTotalCapacities) {\n          id\n          capacity\n        }\n        partialOccupancyAllowed\n        partialOccupancyAllowedAgeGroups @include(if: $withAccommodationsCapacitySettingsPartialOccupancyAllowedAgeGroups) {\n          id\n          name\n          type\n          icon\n          minAge\n          maxAge\n        }\n      }\n      addons @include(if: $withAccommodationsAddons) {\n        id\n        ratioServiceNo\n        name\n        label\n        info\n        calculationSettings @include(if: $withAccommodationsAddonsCalculationSettings) {\n          id\n          type\n          considerHotelNights\n        }\n        mandatorySettings @include(if: $withAccommodationsAddonsMandatorySettings) {\n          id\n          isMandatory\n          useRules\n        }\n      }\n    }\n    familyPackages @include(if: $withFamilyPackages) {\n      id\n      ratioServiceNo\n      accommodation @include(if: $withFamilyPackagesAccommodation) {\n        id\n        ratioPackageNo\n        name\n        label\n        info\n        isFamilyPackageAccommodation\n        isBabyPackage\n        capacitySettings @include(if: $withFamilyPackagesAccommodationCapacitySettings) {\n          id\n          totalCapacity\n          rangesAllowed\n          partialOccupancyAllowed\n        }\n        addons @include(if: $withFamilyPackagesAccommodationAddons) {\n          id\n          ratioServiceNo\n          name\n          label\n          info\n        }\n      }\n      name\n      label\n      info\n      capacitySettings @include(if: $withFamilyPackagesCapacitySettings) {\n        id\n        totalCapacity\n        rangesAllowed\n        ageGroupCapacities @include(if: $withFamilyPackagesCapacitySettingsAgeGroupCapacities) {\n          id\n          minCapacity\n          maxCapacity\n        }\n        ageGroupedTotalCapacities @include(if: $withFamilyPackagesCapacitySettingsAgeGroupedTotalCapacities) {\n          id\n          capacity\n        }\n        partialOccupancyAllowed\n        partialOccupancyAllowedAgeGroups @include(if: $withFamilyPackagesCapacitySettingsPartialOccupancyAllowedAgeGroups) {\n          id\n          name\n          type\n          icon\n          minAge\n          maxAge\n        }\n      }\n      addons @include(if: $withFamilyPackagesAddons) {\n        id\n        ratioServiceNo\n        name\n        label\n        info\n        calculationSettings @include(if: $withFamilyPackagesAddonsCalculationSettings) {\n          id\n          type\n          considerHotelNights\n        }\n        mandatorySettings @include(if: $withFamilyPackagesAddonsMandatorySettings) {\n          id\n          isMandatory\n          useRules\n        }\n      }\n    }\n    checkAccommodationAddons\n    accommodationAddons @include(if: $withAccommodationAddons) {\n      id\n      ratioServiceNo\n      name\n      label\n      info\n      calculationSettings @include(if: $withAccommodationAddonsCalculationSettings) {\n        id\n        type\n        considerHotelNights\n      }\n      mandatorySettings @include(if: $withAccommodationAddonsMandatorySettings) {\n        id\n        isMandatory\n        useRules\n        rules @include(if: $withAccommodationAddonsMandatorySettingsRules) {\n          id\n          checkAccommodationTypes\n          checkAccommodationAddons\n          checkAgeGroups\n          useAgeFilter\n          checkDateRange\n          startDate\n          endDate\n          checkTravelDate\n        }\n      }\n    }\n    checkAgeGroups\n    ageGroups @include(if: $withAgeGroups) {\n      id\n      name\n      type\n      icon\n      minAge\n      maxAge\n    }\n    useAgeFilter\n    ageFilter @include(if: $withAgeFilter) {\n      id\n      minAge\n      maxAge\n    }\n    checkDateRange\n    startDate\n    endDate\n    checkTravelDate\n    travelDates @include(if: $withTravelDates) {\n      id\n      dateNo\n      startDate\n      endDate\n      availabilityStatus @include(if: $withTravelDatesAvailabilityStatus) {\n        id\n        label\n        status\n        isDefaultStatus\n        isDefaultWaitlistFallback\n        tenantSettings @include(if: $withTravelDatesAvailabilityStatusTenantSettings) {\n          id\n          label\n          info\n          switchToStatusInfo\n          submitButtonLabel\n        }\n      }\n      includesExtension\n      extensionBaseDate @include(if: $withTravelDatesExtensionBaseDate) {\n        id\n        dateNo\n        startDate\n        endDate\n        availabilityStatus @include(if: $withTravelDatesExtensionBaseDateAvailabilityStatus) {\n          id\n          label\n          status\n          isDefaultStatus\n          isDefaultWaitlistFallback\n        }\n        includesExtension\n        extensionBaseDate @include(if: $withTravelDatesExtensionBaseDateExtensionBaseDate) {\n          id\n          dateNo\n          startDate\n          endDate\n          includesExtension\n          json\n        }\n        extension @include(if: $withTravelDatesExtensionBaseDateExtension) {\n          id\n          label\n          info\n        }\n        packageSettings @include(if: $withTravelDatesExtensionBaseDatePackageSettings) {\n          id\n          ratioPackageNo\n          price\n          availabilityStatus\n        }\n        json\n        extensions @include(if: $withTravelDatesExtensionBaseDateExtensions) {\n          id\n          label\n          info\n        }\n      }\n      extension @include(if: $withTravelDatesExtension) {\n        id\n        label\n        info\n        travelExtension @include(if: $withTravelDatesExtensionTravelExtension) {\n          id\n          duration\n          name\n          description\n        }\n        accommodationMapItems @include(if: $withTravelDatesExtensionAccommodationMapItems) {\n          id\n        }\n      }\n      packageSettings @include(if: $withTravelDatesPackageSettings) {\n        id\n        ratioPackageNo\n        price\n        availabilityStatus\n      }\n      json\n      extensions @include(if: $withTravelDatesExtensions) {\n        id\n        label\n        info\n        travelExtension @include(if: $withTravelDatesExtensionsTravelExtension) {\n          id\n          duration\n          name\n          description\n        }\n        accommodationMapItems @include(if: $withTravelDatesExtensionsAccommodationMapItems) {\n          id\n        }\n      }\n    }\n  }\n}";
// language=GraphQL
var SINGLE_PRICING_RULES_QUERY = "query Query($id: ID!, $withAccommodations: Boolean = false, $withAccommodationsCapacitySettings: Boolean = false, $withAccommodationsCapacitySettingsAgeGroupCapacities: Boolean = false, $withAccommodationsCapacitySettingsAgeGroupedTotalCapacities: Boolean = false, $withAccommodationsCapacitySettingsPartialOccupancyAllowedAgeGroups: Boolean = false, $withAccommodationsAddons: Boolean = false, $withAccommodationsAddonsCalculationSettings: Boolean = false, $withAccommodationsAddonsMandatorySettings: Boolean = false, $withFamilyPackages: Boolean = false, $withFamilyPackagesAccommodation: Boolean = false, $withFamilyPackagesAccommodationCapacitySettings: Boolean = false, $withFamilyPackagesAccommodationAddons: Boolean = false, $withFamilyPackagesCapacitySettings: Boolean = false, $withFamilyPackagesCapacitySettingsAgeGroupCapacities: Boolean = false, $withFamilyPackagesCapacitySettingsAgeGroupedTotalCapacities: Boolean = false, $withFamilyPackagesCapacitySettingsPartialOccupancyAllowedAgeGroups: Boolean = false, $withFamilyPackagesAddons: Boolean = false, $withFamilyPackagesAddonsCalculationSettings: Boolean = false, $withFamilyPackagesAddonsMandatorySettings: Boolean = false, $withAccommodationAddons: Boolean = false, $withAccommodationAddonsCalculationSettings: Boolean = false, $withAccommodationAddonsMandatorySettings: Boolean = false, $withAccommodationAddonsMandatorySettingsRules: Boolean = false, $withAgeGroups: Boolean = false, $withAgeFilter: Boolean = false, $withTravelDates: Boolean = false, $withTravelDatesAvailabilityStatus: Boolean = false, $withTravelDatesAvailabilityStatusTenantSettings: Boolean = false, $withTravelDatesExtensionBaseDate: Boolean = false, $withTravelDatesExtensionBaseDateAvailabilityStatus: Boolean = false, $withTravelDatesExtensionBaseDateExtensionBaseDate: Boolean = false, $withTravelDatesExtensionBaseDateExtension: Boolean = false, $withTravelDatesExtensionBaseDatePackageSettings: Boolean = false, $withTravelDatesExtensionBaseDateExtensions: Boolean = false, $withTravelDatesExtension: Boolean = false, $withTravelDatesExtensionTravelExtension: Boolean = false, $withTravelDatesExtensionAccommodationMapItems: Boolean = false, $withTravelDatesPackageSettings: Boolean = false, $withTravelDatesExtensions: Boolean = false, $withTravelDatesExtensionsTravelExtension: Boolean = false, $withTravelDatesExtensionsAccommodationMapItems: Boolean = false) {\n  pricingRules: travelPricingRules(id: $id) {\n    id\n    checkAccommodationTypes\n    accommodations @include(if: $withAccommodations) {\n      id\n      ratioPackageNo\n      name\n      label\n      info\n      isFamilyPackageAccommodation\n      isBabyPackage\n      capacitySettings @include(if: $withAccommodationsCapacitySettings) {\n        id\n        totalCapacity\n        rangesAllowed\n        ageGroupCapacities @include(if: $withAccommodationsCapacitySettingsAgeGroupCapacities) {\n          id\n          minCapacity\n          maxCapacity\n        }\n        ageGroupedTotalCapacities @include(if: $withAccommodationsCapacitySettingsAgeGroupedTotalCapacities) {\n          id\n          capacity\n        }\n        partialOccupancyAllowed\n        partialOccupancyAllowedAgeGroups @include(if: $withAccommodationsCapacitySettingsPartialOccupancyAllowedAgeGroups) {\n          id\n          name\n          type\n          icon\n          minAge\n          maxAge\n        }\n      }\n      addons @include(if: $withAccommodationsAddons) {\n        id\n        ratioServiceNo\n        name\n        label\n        info\n        calculationSettings @include(if: $withAccommodationsAddonsCalculationSettings) {\n          id\n          type\n          considerHotelNights\n        }\n        mandatorySettings @include(if: $withAccommodationsAddonsMandatorySettings) {\n          id\n          isMandatory\n          useRules\n        }\n      }\n    }\n    familyPackages @include(if: $withFamilyPackages) {\n      id\n      ratioServiceNo\n      accommodation @include(if: $withFamilyPackagesAccommodation) {\n        id\n        ratioPackageNo\n        name\n        label\n        info\n        isFamilyPackageAccommodation\n        isBabyPackage\n        capacitySettings @include(if: $withFamilyPackagesAccommodationCapacitySettings) {\n          id\n          totalCapacity\n          rangesAllowed\n          partialOccupancyAllowed\n        }\n        addons @include(if: $withFamilyPackagesAccommodationAddons) {\n          id\n          ratioServiceNo\n          name\n          label\n          info\n        }\n      }\n      name\n      label\n      info\n      capacitySettings @include(if: $withFamilyPackagesCapacitySettings) {\n        id\n        totalCapacity\n        rangesAllowed\n        ageGroupCapacities @include(if: $withFamilyPackagesCapacitySettingsAgeGroupCapacities) {\n          id\n          minCapacity\n          maxCapacity\n        }\n        ageGroupedTotalCapacities @include(if: $withFamilyPackagesCapacitySettingsAgeGroupedTotalCapacities) {\n          id\n          capacity\n        }\n        partialOccupancyAllowed\n        partialOccupancyAllowedAgeGroups @include(if: $withFamilyPackagesCapacitySettingsPartialOccupancyAllowedAgeGroups) {\n          id\n          name\n          type\n          icon\n          minAge\n          maxAge\n        }\n      }\n      addons @include(if: $withFamilyPackagesAddons) {\n        id\n        ratioServiceNo\n        name\n        label\n        info\n        calculationSettings @include(if: $withFamilyPackagesAddonsCalculationSettings) {\n          id\n          type\n          considerHotelNights\n        }\n        mandatorySettings @include(if: $withFamilyPackagesAddonsMandatorySettings) {\n          id\n          isMandatory\n          useRules\n        }\n      }\n    }\n    checkAccommodationAddons\n    accommodationAddons @include(if: $withAccommodationAddons) {\n      id\n      ratioServiceNo\n      name\n      label\n      info\n      calculationSettings @include(if: $withAccommodationAddonsCalculationSettings) {\n        id\n        type\n        considerHotelNights\n      }\n      mandatorySettings @include(if: $withAccommodationAddonsMandatorySettings) {\n        id\n        isMandatory\n        useRules\n        rules @include(if: $withAccommodationAddonsMandatorySettingsRules) {\n          id\n          checkAccommodationTypes\n          checkAccommodationAddons\n          checkAgeGroups\n          useAgeFilter\n          checkDateRange\n          startDate\n          endDate\n          checkTravelDate\n        }\n      }\n    }\n    checkAgeGroups\n    ageGroups @include(if: $withAgeGroups) {\n      id\n      name\n      type\n      icon\n      minAge\n      maxAge\n    }\n    useAgeFilter\n    ageFilter @include(if: $withAgeFilter) {\n      id\n      minAge\n      maxAge\n    }\n    checkDateRange\n    startDate\n    endDate\n    checkTravelDate\n    travelDates @include(if: $withTravelDates) {\n      id\n      dateNo\n      startDate\n      endDate\n      availabilityStatus @include(if: $withTravelDatesAvailabilityStatus) {\n        id\n        label\n        status\n        isDefaultStatus\n        isDefaultWaitlistFallback\n        tenantSettings @include(if: $withTravelDatesAvailabilityStatusTenantSettings) {\n          id\n          label\n          info\n          switchToStatusInfo\n          submitButtonLabel\n        }\n      }\n      includesExtension\n      extensionBaseDate @include(if: $withTravelDatesExtensionBaseDate) {\n        id\n        dateNo\n        startDate\n        endDate\n        availabilityStatus @include(if: $withTravelDatesExtensionBaseDateAvailabilityStatus) {\n          id\n          label\n          status\n          isDefaultStatus\n          isDefaultWaitlistFallback\n        }\n        includesExtension\n        extensionBaseDate @include(if: $withTravelDatesExtensionBaseDateExtensionBaseDate) {\n          id\n          dateNo\n          startDate\n          endDate\n          includesExtension\n          json\n        }\n        extension @include(if: $withTravelDatesExtensionBaseDateExtension) {\n          id\n          label\n          info\n        }\n        packageSettings @include(if: $withTravelDatesExtensionBaseDatePackageSettings) {\n          id\n          ratioPackageNo\n          price\n          availabilityStatus\n        }\n        json\n        extensions @include(if: $withTravelDatesExtensionBaseDateExtensions) {\n          id\n          label\n          info\n        }\n      }\n      extension @include(if: $withTravelDatesExtension) {\n        id\n        label\n        info\n        travelExtension @include(if: $withTravelDatesExtensionTravelExtension) {\n          id\n          duration\n          name\n          description\n        }\n        accommodationMapItems @include(if: $withTravelDatesExtensionAccommodationMapItems) {\n          id\n        }\n      }\n      packageSettings @include(if: $withTravelDatesPackageSettings) {\n        id\n        ratioPackageNo\n        price\n        availabilityStatus\n      }\n      json\n      extensions @include(if: $withTravelDatesExtensions) {\n        id\n        label\n        info\n        travelExtension @include(if: $withTravelDatesExtensionsTravelExtension) {\n          id\n          duration\n          name\n          description\n        }\n        accommodationMapItems @include(if: $withTravelDatesExtensionsAccommodationMapItems) {\n          id\n        }\n      }\n    }\n  }\n}";
// language=GraphQL
var CREATE_PRICING_RULES_MUTATION = "\n  mutation Mutation($input: CreateTravelPricingRulesInput, $withAccommodations: Boolean = false, $withAccommodationsCapacitySettings: Boolean = false, $withAccommodationsCapacitySettingsAgeGroupCapacities: Boolean = false, $withAccommodationsCapacitySettingsAgeGroupedTotalCapacities: Boolean = false, $withAccommodationsCapacitySettingsPartialOccupancyAllowedAgeGroups: Boolean = false, $withAccommodationsAddons: Boolean = false, $withAccommodationsAddonsCalculationSettings: Boolean = false, $withAccommodationsAddonsMandatorySettings: Boolean = false, $withFamilyPackages: Boolean = false, $withFamilyPackagesAccommodation: Boolean = false, $withFamilyPackagesAccommodationCapacitySettings: Boolean = false, $withFamilyPackagesAccommodationAddons: Boolean = false, $withFamilyPackagesCapacitySettings: Boolean = false, $withFamilyPackagesCapacitySettingsAgeGroupCapacities: Boolean = false, $withFamilyPackagesCapacitySettingsAgeGroupedTotalCapacities: Boolean = false, $withFamilyPackagesCapacitySettingsPartialOccupancyAllowedAgeGroups: Boolean = false, $withFamilyPackagesAddons: Boolean = false, $withFamilyPackagesAddonsCalculationSettings: Boolean = false, $withFamilyPackagesAddonsMandatorySettings: Boolean = false, $withAccommodationAddons: Boolean = false, $withAccommodationAddonsCalculationSettings: Boolean = false, $withAccommodationAddonsMandatorySettings: Boolean = false, $withAccommodationAddonsMandatorySettingsRules: Boolean = false, $withAgeGroups: Boolean = false, $withAgeFilter: Boolean = false, $withTravelDates: Boolean = false, $withTravelDatesAvailabilityStatus: Boolean = false, $withTravelDatesAvailabilityStatusTenantSettings: Boolean = false, $withTravelDatesExtensionBaseDate: Boolean = false, $withTravelDatesExtensionBaseDateAvailabilityStatus: Boolean = false, $withTravelDatesExtensionBaseDateExtensionBaseDate: Boolean = false, $withTravelDatesExtensionBaseDateExtension: Boolean = false, $withTravelDatesExtensionBaseDatePackageSettings: Boolean = false, $withTravelDatesExtensionBaseDateExtensions: Boolean = false, $withTravelDatesExtension: Boolean = false, $withTravelDatesExtensionTravelExtension: Boolean = false, $withTravelDatesExtensionAccommodationMapItems: Boolean = false, $withTravelDatesPackageSettings: Boolean = false, $withTravelDatesExtensions: Boolean = false, $withTravelDatesExtensionsTravelExtension: Boolean = false, $withTravelDatesExtensionsAccommodationMapItems: Boolean = false) {\n    pricingRules: createTravelPricingRules(input: $input) {\n      id\n      checkAccommodationTypes\n      accommodations @include(if: $withAccommodations) {\n        id\n        ratioPackageNo\n        name\n        label\n        info\n        isFamilyPackageAccommodation\n        isBabyPackage\n        capacitySettings @include(if: $withAccommodationsCapacitySettings) {\n          id\n          totalCapacity\n          rangesAllowed\n          ageGroupCapacities @include(if: $withAccommodationsCapacitySettingsAgeGroupCapacities) {\n            id\n            minCapacity\n            maxCapacity\n          }\n          ageGroupedTotalCapacities @include(if: $withAccommodationsCapacitySettingsAgeGroupedTotalCapacities) {\n            id\n            capacity\n          }\n          partialOccupancyAllowed\n          partialOccupancyAllowedAgeGroups @include(if: $withAccommodationsCapacitySettingsPartialOccupancyAllowedAgeGroups) {\n            id\n            name\n            type\n            icon\n            minAge\n            maxAge\n          }\n        }\n        addons @include(if: $withAccommodationsAddons) {\n          id\n          ratioServiceNo\n          name\n          label\n          info\n          calculationSettings @include(if: $withAccommodationsAddonsCalculationSettings) {\n            id\n            type\n            considerHotelNights\n          }\n          mandatorySettings @include(if: $withAccommodationsAddonsMandatorySettings) {\n            id\n            isMandatory\n            useRules\n          }\n        }\n      }\n      familyPackages @include(if: $withFamilyPackages) {\n        id\n        ratioServiceNo\n        accommodation @include(if: $withFamilyPackagesAccommodation) {\n          id\n          ratioPackageNo\n          name\n          label\n          info\n          isFamilyPackageAccommodation\n          isBabyPackage\n          capacitySettings @include(if: $withFamilyPackagesAccommodationCapacitySettings) {\n            id\n            totalCapacity\n            rangesAllowed\n            partialOccupancyAllowed\n          }\n          addons @include(if: $withFamilyPackagesAccommodationAddons) {\n            id\n            ratioServiceNo\n            name\n            label\n            info\n          }\n        }\n        name\n        label\n        info\n        capacitySettings @include(if: $withFamilyPackagesCapacitySettings) {\n          id\n          totalCapacity\n          rangesAllowed\n          ageGroupCapacities @include(if: $withFamilyPackagesCapacitySettingsAgeGroupCapacities) {\n            id\n            minCapacity\n            maxCapacity\n          }\n          ageGroupedTotalCapacities @include(if: $withFamilyPackagesCapacitySettingsAgeGroupedTotalCapacities) {\n            id\n            capacity\n          }\n          partialOccupancyAllowed\n          partialOccupancyAllowedAgeGroups @include(if: $withFamilyPackagesCapacitySettingsPartialOccupancyAllowedAgeGroups) {\n            id\n            name\n            type\n            icon\n            minAge\n            maxAge\n          }\n        }\n        addons @include(if: $withFamilyPackagesAddons) {\n          id\n          ratioServiceNo\n          name\n          label\n          info\n          calculationSettings @include(if: $withFamilyPackagesAddonsCalculationSettings) {\n            id\n            type\n            considerHotelNights\n          }\n          mandatorySettings @include(if: $withFamilyPackagesAddonsMandatorySettings) {\n            id\n            isMandatory\n            useRules\n          }\n        }\n      }\n      checkAccommodationAddons\n      accommodationAddons @include(if: $withAccommodationAddons) {\n        id\n        ratioServiceNo\n        name\n        label\n        info\n        calculationSettings @include(if: $withAccommodationAddonsCalculationSettings) {\n          id\n          type\n          considerHotelNights\n        }\n        mandatorySettings @include(if: $withAccommodationAddonsMandatorySettings) {\n          id\n          isMandatory\n          useRules\n          rules @include(if: $withAccommodationAddonsMandatorySettingsRules) {\n            id\n            checkAccommodationTypes\n            checkAccommodationAddons\n            checkAgeGroups\n            useAgeFilter\n            checkDateRange\n            startDate\n            endDate\n            checkTravelDate\n          }\n        }\n      }\n      checkAgeGroups\n      ageGroups @include(if: $withAgeGroups) {\n        id\n        name\n        type\n        icon\n        minAge\n        maxAge\n      }\n      useAgeFilter\n      ageFilter @include(if: $withAgeFilter) {\n        id\n        minAge\n        maxAge\n      }\n      checkDateRange\n      startDate\n      endDate\n      checkTravelDate\n      travelDates @include(if: $withTravelDates) {\n        id\n        dateNo\n        startDate\n        endDate\n        availabilityStatus @include(if: $withTravelDatesAvailabilityStatus) {\n          id\n          label\n          status\n          isDefaultStatus\n          isDefaultWaitlistFallback\n          tenantSettings @include(if: $withTravelDatesAvailabilityStatusTenantSettings) {\n            id\n            label\n            info\n            switchToStatusInfo\n            submitButtonLabel\n          }\n        }\n        includesExtension\n        extensionBaseDate @include(if: $withTravelDatesExtensionBaseDate) {\n          id\n          dateNo\n          startDate\n          endDate\n          availabilityStatus @include(if: $withTravelDatesExtensionBaseDateAvailabilityStatus) {\n            id\n            label\n            status\n            isDefaultStatus\n            isDefaultWaitlistFallback\n          }\n          includesExtension\n          extensionBaseDate @include(if: $withTravelDatesExtensionBaseDateExtensionBaseDate) {\n            id\n            dateNo\n            startDate\n            endDate\n            includesExtension\n            json\n          }\n          extension @include(if: $withTravelDatesExtensionBaseDateExtension) {\n            id\n            label\n            info\n          }\n          packageSettings @include(if: $withTravelDatesExtensionBaseDatePackageSettings) {\n            id\n            ratioPackageNo\n            price\n            availabilityStatus\n          }\n          json\n          extensions @include(if: $withTravelDatesExtensionBaseDateExtensions) {\n            id\n            label\n            info\n          }\n        }\n        extension @include(if: $withTravelDatesExtension) {\n          id\n          label\n          info\n          travelExtension @include(if: $withTravelDatesExtensionTravelExtension) {\n            id\n            duration\n            name\n            description\n          }\n          accommodationMapItems @include(if: $withTravelDatesExtensionAccommodationMapItems) {\n            id\n          }\n        }\n        packageSettings @include(if: $withTravelDatesPackageSettings) {\n          id\n          ratioPackageNo\n          price\n          availabilityStatus\n        }\n        json\n        extensions @include(if: $withTravelDatesExtensions) {\n          id\n          label\n          info\n          travelExtension @include(if: $withTravelDatesExtensionsTravelExtension) {\n            id\n            duration\n            name\n            description\n          }\n          accommodationMapItems @include(if: $withTravelDatesExtensionsAccommodationMapItems) {\n            id\n          }\n        }\n      }\n    }\n  }";
// language=GraphQL
var UPDATE_PRICING_RULES_MUTATION = "\n  mutation Mutation($input: UpdateTravelPricingRulesInput, $withAccommodations: Boolean = false, $withAccommodationsCapacitySettings: Boolean = false, $withAccommodationsCapacitySettingsAgeGroupCapacities: Boolean = false, $withAccommodationsCapacitySettingsAgeGroupedTotalCapacities: Boolean = false, $withAccommodationsCapacitySettingsPartialOccupancyAllowedAgeGroups: Boolean = false, $withAccommodationsAddons: Boolean = false, $withAccommodationsAddonsCalculationSettings: Boolean = false, $withAccommodationsAddonsMandatorySettings: Boolean = false, $withFamilyPackages: Boolean = false, $withFamilyPackagesAccommodation: Boolean = false, $withFamilyPackagesAccommodationCapacitySettings: Boolean = false, $withFamilyPackagesAccommodationAddons: Boolean = false, $withFamilyPackagesCapacitySettings: Boolean = false, $withFamilyPackagesCapacitySettingsAgeGroupCapacities: Boolean = false, $withFamilyPackagesCapacitySettingsAgeGroupedTotalCapacities: Boolean = false, $withFamilyPackagesCapacitySettingsPartialOccupancyAllowedAgeGroups: Boolean = false, $withFamilyPackagesAddons: Boolean = false, $withFamilyPackagesAddonsCalculationSettings: Boolean = false, $withFamilyPackagesAddonsMandatorySettings: Boolean = false, $withAccommodationAddons: Boolean = false, $withAccommodationAddonsCalculationSettings: Boolean = false, $withAccommodationAddonsMandatorySettings: Boolean = false, $withAccommodationAddonsMandatorySettingsRules: Boolean = false, $withAgeGroups: Boolean = false, $withAgeFilter: Boolean = false, $withTravelDates: Boolean = false, $withTravelDatesAvailabilityStatus: Boolean = false, $withTravelDatesAvailabilityStatusTenantSettings: Boolean = false, $withTravelDatesExtensionBaseDate: Boolean = false, $withTravelDatesExtensionBaseDateAvailabilityStatus: Boolean = false, $withTravelDatesExtensionBaseDateExtensionBaseDate: Boolean = false, $withTravelDatesExtensionBaseDateExtension: Boolean = false, $withTravelDatesExtensionBaseDatePackageSettings: Boolean = false, $withTravelDatesExtensionBaseDateExtensions: Boolean = false, $withTravelDatesExtension: Boolean = false, $withTravelDatesExtensionTravelExtension: Boolean = false, $withTravelDatesExtensionAccommodationMapItems: Boolean = false, $withTravelDatesPackageSettings: Boolean = false, $withTravelDatesExtensions: Boolean = false, $withTravelDatesExtensionsTravelExtension: Boolean = false, $withTravelDatesExtensionsAccommodationMapItems: Boolean = false) {\n    pricingRules: updateTravelPricingRules(input: $input) {\n      id\n      checkAccommodationTypes\n      accommodations @include(if: $withAccommodations) {\n        id\n        ratioPackageNo\n        name\n        label\n        info\n        isFamilyPackageAccommodation\n        isBabyPackage\n        capacitySettings @include(if: $withAccommodationsCapacitySettings) {\n          id\n          totalCapacity\n          rangesAllowed\n          ageGroupCapacities @include(if: $withAccommodationsCapacitySettingsAgeGroupCapacities) {\n            id\n            minCapacity\n            maxCapacity\n          }\n          ageGroupedTotalCapacities @include(if: $withAccommodationsCapacitySettingsAgeGroupedTotalCapacities) {\n            id\n            capacity\n          }\n          partialOccupancyAllowed\n          partialOccupancyAllowedAgeGroups @include(if: $withAccommodationsCapacitySettingsPartialOccupancyAllowedAgeGroups) {\n            id\n            name\n            type\n            icon\n            minAge\n            maxAge\n          }\n        }\n        addons @include(if: $withAccommodationsAddons) {\n          id\n          ratioServiceNo\n          name\n          label\n          info\n          calculationSettings @include(if: $withAccommodationsAddonsCalculationSettings) {\n            id\n            type\n            considerHotelNights\n          }\n          mandatorySettings @include(if: $withAccommodationsAddonsMandatorySettings) {\n            id\n            isMandatory\n            useRules\n          }\n        }\n      }\n      familyPackages @include(if: $withFamilyPackages) {\n        id\n        ratioServiceNo\n        accommodation @include(if: $withFamilyPackagesAccommodation) {\n          id\n          ratioPackageNo\n          name\n          label\n          info\n          isFamilyPackageAccommodation\n          isBabyPackage\n          capacitySettings @include(if: $withFamilyPackagesAccommodationCapacitySettings) {\n            id\n            totalCapacity\n            rangesAllowed\n            partialOccupancyAllowed\n          }\n          addons @include(if: $withFamilyPackagesAccommodationAddons) {\n            id\n            ratioServiceNo\n            name\n            label\n            info\n          }\n        }\n        name\n        label\n        info\n        capacitySettings @include(if: $withFamilyPackagesCapacitySettings) {\n          id\n          totalCapacity\n          rangesAllowed\n          ageGroupCapacities @include(if: $withFamilyPackagesCapacitySettingsAgeGroupCapacities) {\n            id\n            minCapacity\n            maxCapacity\n          }\n          ageGroupedTotalCapacities @include(if: $withFamilyPackagesCapacitySettingsAgeGroupedTotalCapacities) {\n            id\n            capacity\n          }\n          partialOccupancyAllowed\n          partialOccupancyAllowedAgeGroups @include(if: $withFamilyPackagesCapacitySettingsPartialOccupancyAllowedAgeGroups) {\n            id\n            name\n            type\n            icon\n            minAge\n            maxAge\n          }\n        }\n        addons @include(if: $withFamilyPackagesAddons) {\n          id\n          ratioServiceNo\n          name\n          label\n          info\n          calculationSettings @include(if: $withFamilyPackagesAddonsCalculationSettings) {\n            id\n            type\n            considerHotelNights\n          }\n          mandatorySettings @include(if: $withFamilyPackagesAddonsMandatorySettings) {\n            id\n            isMandatory\n            useRules\n          }\n        }\n      }\n      checkAccommodationAddons\n      accommodationAddons @include(if: $withAccommodationAddons) {\n        id\n        ratioServiceNo\n        name\n        label\n        info\n        calculationSettings @include(if: $withAccommodationAddonsCalculationSettings) {\n          id\n          type\n          considerHotelNights\n        }\n        mandatorySettings @include(if: $withAccommodationAddonsMandatorySettings) {\n          id\n          isMandatory\n          useRules\n          rules @include(if: $withAccommodationAddonsMandatorySettingsRules) {\n            id\n            checkAccommodationTypes\n            checkAccommodationAddons\n            checkAgeGroups\n            useAgeFilter\n            checkDateRange\n            startDate\n            endDate\n            checkTravelDate\n          }\n        }\n      }\n      checkAgeGroups\n      ageGroups @include(if: $withAgeGroups) {\n        id\n        name\n        type\n        icon\n        minAge\n        maxAge\n      }\n      useAgeFilter\n      ageFilter @include(if: $withAgeFilter) {\n        id\n        minAge\n        maxAge\n      }\n      checkDateRange\n      startDate\n      endDate\n      checkTravelDate\n      travelDates @include(if: $withTravelDates) {\n        id\n        dateNo\n        startDate\n        endDate\n        availabilityStatus @include(if: $withTravelDatesAvailabilityStatus) {\n          id\n          label\n          status\n          isDefaultStatus\n          isDefaultWaitlistFallback\n          tenantSettings @include(if: $withTravelDatesAvailabilityStatusTenantSettings) {\n            id\n            label\n            info\n            switchToStatusInfo\n            submitButtonLabel\n          }\n        }\n        includesExtension\n        extensionBaseDate @include(if: $withTravelDatesExtensionBaseDate) {\n          id\n          dateNo\n          startDate\n          endDate\n          availabilityStatus @include(if: $withTravelDatesExtensionBaseDateAvailabilityStatus) {\n            id\n            label\n            status\n            isDefaultStatus\n            isDefaultWaitlistFallback\n          }\n          includesExtension\n          extensionBaseDate @include(if: $withTravelDatesExtensionBaseDateExtensionBaseDate) {\n            id\n            dateNo\n            startDate\n            endDate\n            includesExtension\n            json\n          }\n          extension @include(if: $withTravelDatesExtensionBaseDateExtension) {\n            id\n            label\n            info\n          }\n          packageSettings @include(if: $withTravelDatesExtensionBaseDatePackageSettings) {\n            id\n            ratioPackageNo\n            price\n            availabilityStatus\n          }\n          json\n          extensions @include(if: $withTravelDatesExtensionBaseDateExtensions) {\n            id\n            label\n            info\n          }\n        }\n        extension @include(if: $withTravelDatesExtension) {\n          id\n          label\n          info\n          travelExtension @include(if: $withTravelDatesExtensionTravelExtension) {\n            id\n            duration\n            name\n            description\n          }\n          accommodationMapItems @include(if: $withTravelDatesExtensionAccommodationMapItems) {\n            id\n          }\n        }\n        packageSettings @include(if: $withTravelDatesPackageSettings) {\n          id\n          ratioPackageNo\n          price\n          availabilityStatus\n        }\n        json\n        extensions @include(if: $withTravelDatesExtensions) {\n          id\n          label\n          info\n          travelExtension @include(if: $withTravelDatesExtensionsTravelExtension) {\n            id\n            duration\n            name\n            description\n          }\n          accommodationMapItems @include(if: $withTravelDatesExtensionsAccommodationMapItems) {\n            id\n          }\n        }\n      }\n    }\n  }";
// language=GraphQL
var DELETE_PRICING_RULES_MUTATION = "\n  mutation Mutation($input: DeleteTravelPricingRulesInput) {\n    deleteTravelPricingRules(input: $input) {\n      success\n    }\n  }";
// language=GraphQL
var FORCE_DELETE_PRICING_RULES_MUTATION = "\n  mutation Mutation($input: DeleteTravelPricingRulesInput) {\n    forceDeleteTravelPricingRules(input: $input) {\n      success\n    }\n  }";
// language=GraphQL
var ADD_PRICING_RULES_ACCOMMODATIONS_MUTATION = "\n  mutation Mutation($input: addTravelPricingRulesAccommodationsInput) {\n    addTravelPricingRulesAccommodations(input: $input) {\n      id\n      accommodationIds\n    }\n  }";
// language=GraphQL
var REMOVE_PRICING_RULES_ACCOMMODATIONS_MUTATION = "\n  mutation Mutation($input: removeTravelPricingRulesAccommodationsInput) {\n    removeTravelPricingRulesAccommodations(input: $input) {\n      id\n      accommodationIds\n    }\n  }";
// language=GraphQL
var CREATE_PRICING_RULES_ACCOMMODATIONS_MUTATION = "\n  mutation Mutation($input: createTravelPricingRulesAccommodationsInput) {\n    createTravelPricingRulesAccommodations(input: $input) {\n      id\n      accommodationIds\n    }\n  }";
// language=GraphQL
var DELETE_PRICING_RULES_ACCOMMODATIONS_MUTATION = "\n  mutation Mutation($input: deleteTravelPricingRulesAccommodationsInput) {\n    deleteTravelPricingRulesAccommodations(input: $input) {\n      id\n      accommodationIds\n    }\n  }";
// language=GraphQL
var ADD_PRICING_RULES_FAMILY_PACKAGES_MUTATION = "\n  mutation Mutation($input: addTravelPricingRulesFamilyPackagesInput) {\n    addTravelPricingRulesFamilyPackages(input: $input) {\n      id\n      familyPackageIds\n    }\n  }";
// language=GraphQL
var REMOVE_PRICING_RULES_FAMILY_PACKAGES_MUTATION = "\n  mutation Mutation($input: removeTravelPricingRulesFamilyPackagesInput) {\n    removeTravelPricingRulesFamilyPackages(input: $input) {\n      id\n      familyPackageIds\n    }\n  }";
// language=GraphQL
var CREATE_PRICING_RULES_FAMILY_PACKAGES_MUTATION = "\n  mutation Mutation($input: createTravelPricingRulesFamilyPackagesInput) {\n    createTravelPricingRulesFamilyPackages(input: $input) {\n      id\n      familyPackageIds\n    }\n  }";
// language=GraphQL
var DELETE_PRICING_RULES_FAMILY_PACKAGES_MUTATION = "\n  mutation Mutation($input: deleteTravelPricingRulesFamilyPackagesInput) {\n    deleteTravelPricingRulesFamilyPackages(input: $input) {\n      id\n      familyPackageIds\n    }\n  }";
// language=GraphQL
var ADD_PRICING_RULES_ACCOMMODATION_ADDONS_MUTATION = "\n  mutation Mutation($input: addTravelPricingRulesAccommodationAddonsInput) {\n    addTravelPricingRulesAccommodationAddons(input: $input) {\n      id\n      accommodationAddonIds\n    }\n  }";
// language=GraphQL
var REMOVE_PRICING_RULES_ACCOMMODATION_ADDONS_MUTATION = "\n  mutation Mutation($input: removeTravelPricingRulesAccommodationAddonsInput) {\n    removeTravelPricingRulesAccommodationAddons(input: $input) {\n      id\n      accommodationAddonIds\n    }\n  }";
// language=GraphQL
var CREATE_PRICING_RULES_ACCOMMODATION_ADDONS_MUTATION = "\n  mutation Mutation($input: createTravelPricingRulesAccommodationAddonsInput) {\n    createTravelPricingRulesAccommodationAddons(input: $input) {\n      id\n      accommodationAddonIds\n    }\n  }";
// language=GraphQL
var DELETE_PRICING_RULES_ACCOMMODATION_ADDONS_MUTATION = "\n  mutation Mutation($input: deleteTravelPricingRulesAccommodationAddonsInput) {\n    deleteTravelPricingRulesAccommodationAddons(input: $input) {\n      id\n      accommodationAddonIds\n    }\n  }";
// language=GraphQL
var ADD_PRICING_RULES_AGE_GROUPS_MUTATION = "\n  mutation Mutation($input: addTravelPricingRulesAgeGroupsInput) {\n    addTravelPricingRulesAgeGroups(input: $input) {\n      id\n      ageGroupIds\n    }\n  }";
// language=GraphQL
var REMOVE_PRICING_RULES_AGE_GROUPS_MUTATION = "\n  mutation Mutation($input: removeTravelPricingRulesAgeGroupsInput) {\n    removeTravelPricingRulesAgeGroups(input: $input) {\n      id\n      ageGroupIds\n    }\n  }";
// language=GraphQL
var CREATE_PRICING_RULES_AGE_GROUPS_MUTATION = "\n  mutation Mutation($input: createTravelPricingRulesAgeGroupsInput) {\n    createTravelPricingRulesAgeGroups(input: $input) {\n      id\n      ageGroupIds\n    }\n  }";
// language=GraphQL
var DELETE_PRICING_RULES_AGE_GROUPS_MUTATION = "\n  mutation Mutation($input: deleteTravelPricingRulesAgeGroupsInput) {\n    deleteTravelPricingRulesAgeGroups(input: $input) {\n      id\n      ageGroupIds\n    }\n  }";
// language=GraphQL
var ADD_PRICING_RULES_TRAVEL_DATES_MUTATION = "\n  mutation Mutation($input: addTravelPricingRulesTravelDatesInput) {\n    addTravelPricingRulesTravelDates(input: $input) {\n      id\n      travelDateIds\n    }\n  }";
// language=GraphQL
var REMOVE_PRICING_RULES_TRAVEL_DATES_MUTATION = "\n  mutation Mutation($input: removeTravelPricingRulesTravelDatesInput) {\n    removeTravelPricingRulesTravelDates(input: $input) {\n      id\n      travelDateIds\n    }\n  }";
// language=GraphQL
var CREATE_PRICING_RULES_TRAVEL_DATES_MUTATION = "\n  mutation Mutation($input: createTravelPricingRulesTravelDatesInput) {\n    createTravelPricingRulesTravelDates(input: $input) {\n      id\n      travelDateIds\n    }\n  }";
// language=GraphQL
var DELETE_PRICING_RULES_TRAVEL_DATES_MUTATION = "\n  mutation Mutation($input: deleteTravelPricingRulesTravelDatesInput) {\n    deleteTravelPricingRulesTravelDates(input: $input) {\n      id\n      travelDateIds\n    }\n  }";
// language=GraphQL
var UPDATE_PRICING_RULES_TRAVEL_DATES_ORDER_MUTATION = "\n  mutation Mutation($input: updateTravelPricingRulesTravelDatesOrderInput) {\n    updateTravelPricingRulesTravelDatesOrder(input: $input) {\n      id\n      travelDateIds\n    }\n  }";
// language=GraphQL
var PRICING_RULES_DEPENDENTS_QUERY = "query Query($id: ID!, $withTravelPricingMandatorySettings: Boolean = false) {\n  groupedDependents: travelPricingRulesDependents(id: $id) {\n    travelPricingMandatorySettings @include(if: $withTravelPricingMandatorySettings) {\n      id\n      isMandatory\n      useRules\n    }\n  }\n}";

// EXTERNAL MODULE: ./src/entities/ratioAccommodation/entity.ts + 3 modules
var entity = __webpack_require__(53656);
// EXTERNAL MODULE: ./src/entities/ratioFamilyPackage/entity.ts + 3 modules
var ratioFamilyPackage_entity = __webpack_require__(79028);
// EXTERNAL MODULE: ./src/entities/ratioAccommodationAddon/entity.ts + 3 modules
var ratioAccommodationAddon_entity = __webpack_require__(88646);
// EXTERNAL MODULE: ./src/entities/travelPricingAgeGroup/entity.ts + 3 modules
var travelPricingAgeGroup_entity = __webpack_require__(65966);
// EXTERNAL MODULE: ./src/entities/travelPricingAgeFilter/entity.ts + 3 modules
var travelPricingAgeFilter_entity = __webpack_require__(86791);
// EXTERNAL MODULE: ./src/entities/ratioTravelDate/entity.ts + 3 modules
var ratioTravelDate_entity = __webpack_require__(48086);
;// CONCATENATED MODULE: ./src/entities/travelPricingRules/model.ts







var travelPricingRulesModel = {
    name: "pricingRules",
    namePlural: "pricingRules",
    uniqueName: "travelPricingRules",
    uniqueNamePlural: "travelPricingRules",
    path: "travel/pricing/pricing_rules",
    baseUrl: "/travel/pricing/pricing_rules",
    translationPrefix: "entities:travelPricingRules.",
    getDisplayName: function(values) {
        return "Pricing Rules";
    },
    gql: {
        getAll: ALL_PRICING_RULES_QUERY,
        getSingle: SINGLE_PRICING_RULES_QUERY,
        create: CREATE_PRICING_RULES_MUTATION,
        update: UPDATE_PRICING_RULES_MUTATION,
        delete: DELETE_PRICING_RULES_MUTATION,
        forceDelete: FORCE_DELETE_PRICING_RULES_MUTATION
    },
    attributes: {
        checkAccommodationTypes: {
            name: "checkAccommodationTypes",
            label: "entities:travelPricingRules.attributes.checkAccommodationTypes.label",
            type: "value",
            dataType: "boolean",
            defaultInput: true,
            inputType: "switch",
            validationType: "string",
            validations: []
        },
        accommodations: {
            name: "accommodations",
            label: "entities:travelPricingRules.attributes.accommodations.label",
            type: "entityCollection",
            dataType: "[any]",
            getEntity: function() {
                return entity/* default */.Z;
            },
            defaultInput: true,
            inputType: "text",
            validationType: "string",
            validations: []
        },
        familyPackages: {
            name: "familyPackages",
            label: "entities:travelPricingRules.attributes.familyPackages.label",
            type: "entityCollection",
            dataType: "[any]",
            getEntity: function() {
                return ratioFamilyPackage_entity/* default */.Z;
            },
            defaultInput: true,
            inputType: "text",
            validationType: "string",
            validations: []
        },
        checkAccommodationAddons: {
            name: "checkAccommodationAddons",
            label: "entities:travelPricingRules.attributes.checkAccommodationAddons.label",
            type: "value",
            dataType: "boolean",
            defaultInput: true,
            inputType: "switch",
            validationType: "string",
            validations: []
        },
        accommodationAddons: {
            name: "accommodationAddons",
            label: "entities:travelPricingRules.attributes.accommodationAddons.label",
            type: "entityCollection",
            dataType: "[any]",
            getEntity: function() {
                return ratioAccommodationAddon_entity/* default */.Z;
            },
            defaultInput: false,
            inputType: "text",
            validationType: "string",
            validations: []
        },
        checkAgeGroups: {
            name: "checkAgeGroups",
            label: "entities:travelPricingRules.attributes.checkAgeGroups.label",
            type: "value",
            dataType: "boolean",
            defaultInput: true,
            inputType: "switch",
            validationType: "string",
            validations: []
        },
        ageGroups: {
            name: "ageGroups",
            label: "entities:travelPricingRules.attributes.ageGroups.label",
            type: "entityCollection",
            dataType: "[any]",
            getEntity: function() {
                return travelPricingAgeGroup_entity/* default */.Z;
            },
            defaultInput: true,
            inputType: "text",
            validationType: "string",
            validations: []
        },
        useAgeFilter: {
            name: "useAgeFilter",
            label: "entities:travelPricingRules.attributes.useAgeFilter.label",
            type: "value",
            dataType: "boolean",
            defaultInput: true,
            inputType: "switch",
            validationType: "string",
            validations: [
                {
                    type: "required"
                }, 
            ]
        },
        ageFilter: {
            name: "ageFilter",
            label: "entities:travelPricingRules.attributes.ageFilter.label",
            type: "entityObject",
            dataType: "any",
            getEntity: function() {
                return travelPricingAgeFilter_entity/* default */.Z;
            },
            defaultInput: false,
            inputType: "select",
            validationType: "string",
            validations: []
        },
        checkDateRange: {
            name: "checkDateRange",
            label: "entities:travelPricingRules.attributes.checkDateRange.label",
            type: "value",
            dataType: "boolean",
            defaultInput: true,
            inputType: "switch",
            validationType: "string",
            validations: []
        },
        startDate: {
            name: "startDate",
            label: "entities:travelPricingRules.attributes.startDate.label",
            type: "value",
            dataType: "Date",
            defaultInput: true,
            inputType: "text",
            isStartDate: true,
            endDateAttribute: "endDate",
            validationType: "string",
            validations: []
        },
        endDate: {
            name: "endDate",
            label: "entities:travelPricingRules.attributes.endDate.label",
            type: "value",
            dataType: "Date",
            defaultInput: true,
            inputType: "text",
            isEndDate: true,
            startDateAttribute: "startDate",
            validationType: "string",
            validations: []
        },
        checkTravelDate: {
            name: "checkTravelDate",
            label: "entities:travelPricingRules.attributes.checkTravelDate.label",
            type: "value",
            dataType: "boolean",
            defaultInput: true,
            inputType: "switch",
            validationType: "string",
            validations: []
        },
        travelDates: {
            name: "travelDates",
            label: "entities:travelPricingRules.attributes.travelDates.label",
            type: "entityCollection",
            dataType: "[any]",
            getEntity: function() {
                return ratioTravelDate_entity/* default */.Z;
            },
            defaultInput: false,
            inputType: "text",
            validationType: "string",
            validations: []
        }
    }
};
/* harmony default export */ var model = (travelPricingRulesModel);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(20414);
// EXTERNAL MODULE: ./src/entities/lib.ts
var lib = __webpack_require__(23480);
// EXTERNAL MODULE: ./src/lib/api/graphQLClient.ts
var graphQLClient = __webpack_require__(40112);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/swr/dist/index.mjs
var dist = __webpack_require__(8100);
// EXTERNAL MODULE: ./src/lib/helpers/helpers.ts
var helpers = __webpack_require__(15778);
;// CONCATENATED MODULE: ./src/entities/travelPricingRules/repository.ts










var hydrateObjects = function(objects) {
    return objects.map(function(object) {
        return (0,lib/* hydrateEntityObject */.b)(model, object);
    });
};
var hydrateObject = function(object) {
    return (0,lib/* hydrateEntityObject */.b)(model, object);
};
var travelPricingRulesRepository = {
    getObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    id: id
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(SINGLE_PRICING_RULES_QUERY, variables).then(function(data) {
                        return hydrateObject(data.pricingRules);
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }(),
    getObjects: /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        var includes;
        var _arguments = arguments;
        return (0,tslib_es6.__generator)(this, function(_state) {
            includes = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : {};
            return [
                2,
                graphQLClient/* default.request */.Z.request(ALL_PRICING_RULES_QUERY, includes).then(function(data) {
                    return hydrateObjects(data.pricingRules);
                })
            ];
        });
    }),
    useObject: function(id) {
        var includes = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        // eslint-disable-next-line react-hooks/exhaustive-deps
        var variables = (0,react.useMemo)(function() {
            return (0,_object_spread/* default */.Z)({
                id: id
            }, includes);
        }, [
            id
        ]);
        var ref = (0,dist/* default */.ZP)([
            SINGLE_PRICING_RULES_QUERY,
            variables
        ], {
            revalidateOnFocus: false
        }), data = ref.data, error = ref.error, mutate = ref.mutate;
        return {
            object: !data ? data : hydrateObject(data.pricingRules),
            isLoading: !error && !data,
            isError: error,
            mutate: mutate
        };
    },
    useObjects: function() {
        var includes = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        // eslint-disable-next-line react-hooks/exhaustive-deps
        var variables = (0,react.useMemo)(function() {
            return includes;
        }, []);
        var ref = (0,dist/* default */.ZP)([
            ALL_PRICING_RULES_QUERY,
            variables
        ]), data = ref.data, error = ref.error, mutate = ref.mutate;
        return {
            objects: !data ? data : hydrateObjects(data.pricingRules),
            isLoading: !error && !data,
            isError: error,
            mutate: mutate
        };
    },
    getDependents: function(id, includes) {
        var includeVars = {};
        includes.forEach(function(include) {
            includeVars["with".concat((0,helpers/* uppercaseFirst */.AB)(include))] = true;
        });
        var variables = (0,_object_spread/* default */.Z)({
            id: id
        }, includeVars);
        return graphQLClient/* default.request */.Z.request(PRICING_RULES_DEPENDENTS_QUERY, variables).then(function(data) {
            return data.groupedDependents;
        });
    },
    useDependents: function(id, includes) {
        var includeVars = {};
        includes.forEach(function(include) {
            includeVars["with".concat((0,helpers/* uppercaseFirst */.AB)(include))] = true;
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
        var variables = (0,react.useMemo)(function() {
            return (0,_object_spread/* default */.Z)({
                id: id
            }, includeVars);
        }, [
            id
        ]);
        var ref = (0,dist/* default */.ZP)([
            PRICING_RULES_DEPENDENTS_QUERY,
            variables
        ], {
            revalidateOnFocus: false
        }), data = ref.data, error = ref.error, mutate = ref.mutate;
        return {
            data: !data ? data : data.groupedDependents,
            isLoading: !error && !data,
            isError: error,
            mutate: mutate
        };
    },
    createObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(data) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    input: data
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(CREATE_PRICING_RULES_MUTATION, variables).then(function(data) {
                        return hydrateObject(data.pricingRules);
                    })
                ];
            });
        });
        return function(data) {
            return _ref.apply(this, arguments);
        };
    }(),
    updateObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(data) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    input: data
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(UPDATE_PRICING_RULES_MUTATION, variables).then(function(data) {
                        return hydrateObject(data.pricingRules);
                    })
                ];
            });
        });
        return function(data) {
            return _ref.apply(this, arguments);
        };
    }(),
    deleteObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(DELETE_PRICING_RULES_MUTATION, variables).then(function(data) {
                        return data.deleteTravelPricingRules;
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }(),
    forceDeleteObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(FORCE_DELETE_PRICING_RULES_MUTATION, variables).then(function(data) {
                        return data.forceDeleteTravelPricingRules;
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }(),
    assignAccommodations: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, itemIds) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        accommodationIds: itemIds
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(ADD_PRICING_RULES_ACCOMMODATIONS_MUTATION, variables)
                ];
            });
        });
        return function(id, itemIds) {
            return _ref.apply(this, arguments);
        };
    }(),
    unassignAccommodations: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, itemIds) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        accommodationIds: itemIds
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(REMOVE_PRICING_RULES_ACCOMMODATIONS_MUTATION, variables)
                ];
            });
        });
        return function(id, itemIds) {
            return _ref.apply(this, arguments);
        };
    }(),
    createAccommodations: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, items) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        accommodations: items
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(CREATE_PRICING_RULES_ACCOMMODATIONS_MUTATION, variables)
                ];
            });
        });
        return function(id, items) {
            return _ref.apply(this, arguments);
        };
    }(),
    deleteAccommodations: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, itemIds) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        accommodationIds: itemIds
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(DELETE_PRICING_RULES_ACCOMMODATIONS_MUTATION, variables)
                ];
            });
        });
        return function(id, itemIds) {
            return _ref.apply(this, arguments);
        };
    }(),
    assignFamilyPackages: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, itemIds) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        familyPackageIds: itemIds
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(ADD_PRICING_RULES_FAMILY_PACKAGES_MUTATION, variables)
                ];
            });
        });
        return function(id, itemIds) {
            return _ref.apply(this, arguments);
        };
    }(),
    unassignFamilyPackages: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, itemIds) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        familyPackageIds: itemIds
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(REMOVE_PRICING_RULES_FAMILY_PACKAGES_MUTATION, variables)
                ];
            });
        });
        return function(id, itemIds) {
            return _ref.apply(this, arguments);
        };
    }(),
    createFamilyPackages: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, items) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        familyPackages: items
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(CREATE_PRICING_RULES_FAMILY_PACKAGES_MUTATION, variables)
                ];
            });
        });
        return function(id, items) {
            return _ref.apply(this, arguments);
        };
    }(),
    deleteFamilyPackages: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, itemIds) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        familyPackageIds: itemIds
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(DELETE_PRICING_RULES_FAMILY_PACKAGES_MUTATION, variables)
                ];
            });
        });
        return function(id, itemIds) {
            return _ref.apply(this, arguments);
        };
    }(),
    assignAccommodationAddons: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, itemIds) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        accommodationAddonIds: itemIds
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(ADD_PRICING_RULES_ACCOMMODATION_ADDONS_MUTATION, variables)
                ];
            });
        });
        return function(id, itemIds) {
            return _ref.apply(this, arguments);
        };
    }(),
    unassignAccommodationAddons: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, itemIds) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        accommodationAddonIds: itemIds
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(REMOVE_PRICING_RULES_ACCOMMODATION_ADDONS_MUTATION, variables)
                ];
            });
        });
        return function(id, itemIds) {
            return _ref.apply(this, arguments);
        };
    }(),
    createAccommodationAddons: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, items) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        accommodationAddons: items
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(CREATE_PRICING_RULES_ACCOMMODATION_ADDONS_MUTATION, variables)
                ];
            });
        });
        return function(id, items) {
            return _ref.apply(this, arguments);
        };
    }(),
    deleteAccommodationAddons: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, itemIds) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        accommodationAddonIds: itemIds
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(DELETE_PRICING_RULES_ACCOMMODATION_ADDONS_MUTATION, variables)
                ];
            });
        });
        return function(id, itemIds) {
            return _ref.apply(this, arguments);
        };
    }(),
    assignAgeGroups: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, itemIds) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        ageGroupIds: itemIds
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(ADD_PRICING_RULES_AGE_GROUPS_MUTATION, variables)
                ];
            });
        });
        return function(id, itemIds) {
            return _ref.apply(this, arguments);
        };
    }(),
    unassignAgeGroups: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, itemIds) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        ageGroupIds: itemIds
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(REMOVE_PRICING_RULES_AGE_GROUPS_MUTATION, variables)
                ];
            });
        });
        return function(id, itemIds) {
            return _ref.apply(this, arguments);
        };
    }(),
    createAgeGroups: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, items) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        ageGroups: items
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(CREATE_PRICING_RULES_AGE_GROUPS_MUTATION, variables)
                ];
            });
        });
        return function(id, items) {
            return _ref.apply(this, arguments);
        };
    }(),
    deleteAgeGroups: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, itemIds) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        ageGroupIds: itemIds
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(DELETE_PRICING_RULES_AGE_GROUPS_MUTATION, variables)
                ];
            });
        });
        return function(id, itemIds) {
            return _ref.apply(this, arguments);
        };
    }(),
    assignTravelDates: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, itemIds) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        travelDateIds: itemIds
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(ADD_PRICING_RULES_TRAVEL_DATES_MUTATION, variables)
                ];
            });
        });
        return function(id, itemIds) {
            return _ref.apply(this, arguments);
        };
    }(),
    unassignTravelDates: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, itemIds) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        travelDateIds: itemIds
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(REMOVE_PRICING_RULES_TRAVEL_DATES_MUTATION, variables)
                ];
            });
        });
        return function(id, itemIds) {
            return _ref.apply(this, arguments);
        };
    }(),
    createTravelDates: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, items) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        travelDates: items
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(CREATE_PRICING_RULES_TRAVEL_DATES_MUTATION, variables)
                ];
            });
        });
        return function(id, items) {
            return _ref.apply(this, arguments);
        };
    }(),
    deleteTravelDates: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, itemIds) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        travelDateIds: itemIds
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(DELETE_PRICING_RULES_TRAVEL_DATES_MUTATION, variables)
                ];
            });
        });
        return function(id, itemIds) {
            return _ref.apply(this, arguments);
        };
    }(),
    updateTravelDatesOrder: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, itemIds) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        travelDateIds: itemIds
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(UPDATE_PRICING_RULES_TRAVEL_DATES_ORDER_MUTATION, variables)
                ];
            });
        });
        return function(id, itemIds) {
            return _ref.apply(this, arguments);
        };
    }()
};
/* harmony default export */ var repository = (travelPricingRulesRepository);

;// CONCATENATED MODULE: ./src/entities/travelPricingRules/entity.ts


var travelPricingRulesEntity = {
    model: model,
    repository: repository
};
/* harmony default export */ var travelPricingRules_entity = (travelPricingRulesEntity);


/***/ }),

/***/ 49005:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ entity; }
});

;// CONCATENATED MODULE: ./src/entities/travelPricingServiceCalculationSettings/graphql.ts
// language=GraphQL
var ALL_CALCULATION_SETTINGS_QUERY = "query Query {\n  calculationSettings: allTravelPricingServiceCalculationSettings {\n    id\n    type\n    considerHotelNights\n  }\n}";
// language=GraphQL
var SINGLE_CALCULATION_SETTINGS_QUERY = "query Query($id: ID!) {\n  calculationSettings: travelPricingServiceCalculationSettings(id: $id) {\n    id\n    type\n    considerHotelNights\n  }\n}";
// language=GraphQL
var CREATE_CALCULATION_SETTINGS_MUTATION = "\n  mutation Mutation($input: CreateTravelPricingServiceCalculationSettingsInput) {\n    calculationSettings: createTravelPricingServiceCalculationSettings(input: $input) {\n      id\n      type\n      considerHotelNights\n    }\n  }";
// language=GraphQL
var UPDATE_CALCULATION_SETTINGS_MUTATION = "\n  mutation Mutation($input: UpdateTravelPricingServiceCalculationSettingsInput) {\n    calculationSettings: updateTravelPricingServiceCalculationSettings(input: $input) {\n      id\n      type\n      considerHotelNights\n    }\n  }";
// language=GraphQL
var DELETE_CALCULATION_SETTINGS_MUTATION = "\n  mutation Mutation($input: DeleteTravelPricingServiceCalculationSettingsInput) {\n    deleteTravelPricingServiceCalculationSettings(input: $input) {\n      success\n    }\n  }";
// language=GraphQL
var FORCE_DELETE_CALCULATION_SETTINGS_MUTATION = "\n  mutation Mutation($input: DeleteTravelPricingServiceCalculationSettingsInput) {\n    forceDeleteTravelPricingServiceCalculationSettings(input: $input) {\n      success\n    }\n  }";
// language=GraphQL
var CALCULATION_SETTINGS_DEPENDENTS_QUERY = "query Query($id: ID!, $withRatioPersonalAddons: Boolean = false, $withRatioAccommodationAddons: Boolean = false, $withRatioBookingAddons: Boolean = false, $withRatioCollectiveAddons: Boolean = false) {\n  groupedDependents: travelPricingServiceCalculationSettingsDependents(id: $id) {\n    ratioPersonalAddons @include(if: $withRatioPersonalAddons) {\n      id\n      ratioServiceNo\n      name\n      label\n      info\n    }\n    ratioAccommodationAddons @include(if: $withRatioAccommodationAddons) {\n      id\n      ratioServiceNo\n      name\n      label\n      info\n    }\n    ratioBookingAddons @include(if: $withRatioBookingAddons) {\n      id\n      ratioServiceNo\n      name\n      label\n      info\n    }\n    ratioCollectiveAddons @include(if: $withRatioCollectiveAddons) {\n      id\n      label\n      info\n    }\n  }\n}";

;// CONCATENATED MODULE: ./src/entities/travelPricingServiceCalculationSettings/model.ts

var travelPricingServiceCalculationSettingsModel = {
    name: "calculationSettings",
    namePlural: "calculationSettings",
    uniqueName: "travelPricingServiceCalculationSettings",
    uniqueNamePlural: "travelPricingServiceCalculationSettings",
    path: "travel/pricing/calculation_settings",
    baseUrl: "/travel/pricing/calculation_settings",
    translationPrefix: "entities:travelPricingServiceCalculationSettings.",
    getDisplayName: function(values) {
        return "Calculation Settings";
    },
    gql: {
        getAll: ALL_CALCULATION_SETTINGS_QUERY,
        getSingle: SINGLE_CALCULATION_SETTINGS_QUERY,
        create: CREATE_CALCULATION_SETTINGS_MUTATION,
        update: UPDATE_CALCULATION_SETTINGS_MUTATION,
        delete: DELETE_CALCULATION_SETTINGS_MUTATION,
        forceDelete: FORCE_DELETE_CALCULATION_SETTINGS_MUTATION
    },
    attributes: {
        type: {
            name: "type",
            label: "entities:travelPricingServiceCalculationSettings.attributes.type.label",
            type: "value",
            dataType: "string",
            defaultInput: true,
            inputType: "select",
            selectOptions: [
                {
                    label: "entities:travelPricingServiceCalculationSettings.attributes.type.selectOptions.once.label",
                    value: "once"
                },
                {
                    label: "entities:travelPricingServiceCalculationSettings.attributes.type.selectOptions.nights.label",
                    value: "nights"
                },
                {
                    label: "entities:travelPricingServiceCalculationSettings.attributes.type.selectOptions.days.label",
                    value: "days"
                }, 
            ],
            validationType: "string",
            validations: [
                {
                    type: "required"
                }, 
            ]
        },
        considerHotelNights: {
            name: "considerHotelNights",
            label: "entities:travelPricingServiceCalculationSettings.attributes.considerHotelNights.label",
            type: "value",
            dataType: "boolean",
            defaultInput: true,
            inputType: "switch",
            validationType: "string",
            validations: []
        }
    }
};
/* harmony default export */ var model = (travelPricingServiceCalculationSettingsModel);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(20414);
// EXTERNAL MODULE: ./src/entities/lib.ts
var lib = __webpack_require__(23480);
// EXTERNAL MODULE: ./src/lib/api/graphQLClient.ts
var graphQLClient = __webpack_require__(40112);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/swr/dist/index.mjs
var dist = __webpack_require__(8100);
// EXTERNAL MODULE: ./src/lib/helpers/helpers.ts
var helpers = __webpack_require__(15778);
;// CONCATENATED MODULE: ./src/entities/travelPricingServiceCalculationSettings/repository.ts










var hydrateObjects = function(objects) {
    return objects.map(function(object) {
        return (0,lib/* hydrateEntityObject */.b)(model, object);
    });
};
var hydrateObject = function(object) {
    return (0,lib/* hydrateEntityObject */.b)(model, object);
};
var travelPricingServiceCalculationSettingsRepository = {
    getObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    id: id
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(SINGLE_CALCULATION_SETTINGS_QUERY, variables).then(function(data) {
                        return hydrateObject(data.calculationSettings);
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }(),
    getObjects: /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        var includes;
        var _arguments = arguments;
        return (0,tslib_es6.__generator)(this, function(_state) {
            includes = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : {};
            return [
                2,
                graphQLClient/* default.request */.Z.request(ALL_CALCULATION_SETTINGS_QUERY, includes).then(function(data) {
                    return hydrateObjects(data.calculationSettings);
                })
            ];
        });
    }),
    useObject: function(id) {
        var includes = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        // eslint-disable-next-line react-hooks/exhaustive-deps
        var variables = (0,react.useMemo)(function() {
            return (0,_object_spread/* default */.Z)({
                id: id
            }, includes);
        }, [
            id
        ]);
        var ref = (0,dist/* default */.ZP)([
            SINGLE_CALCULATION_SETTINGS_QUERY,
            variables
        ], {
            revalidateOnFocus: false
        }), data = ref.data, error = ref.error, mutate = ref.mutate;
        return {
            object: !data ? data : hydrateObject(data.calculationSettings),
            isLoading: !error && !data,
            isError: error,
            mutate: mutate
        };
    },
    useObjects: function() {
        var includes = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        // eslint-disable-next-line react-hooks/exhaustive-deps
        var variables = (0,react.useMemo)(function() {
            return includes;
        }, []);
        var ref = (0,dist/* default */.ZP)([
            ALL_CALCULATION_SETTINGS_QUERY,
            variables
        ]), data = ref.data, error = ref.error, mutate = ref.mutate;
        return {
            objects: !data ? data : hydrateObjects(data.calculationSettings),
            isLoading: !error && !data,
            isError: error,
            mutate: mutate
        };
    },
    getDependents: function(id, includes) {
        var includeVars = {};
        includes.forEach(function(include) {
            includeVars["with".concat((0,helpers/* uppercaseFirst */.AB)(include))] = true;
        });
        var variables = (0,_object_spread/* default */.Z)({
            id: id
        }, includeVars);
        return graphQLClient/* default.request */.Z.request(CALCULATION_SETTINGS_DEPENDENTS_QUERY, variables).then(function(data) {
            return data.groupedDependents;
        });
    },
    useDependents: function(id, includes) {
        var includeVars = {};
        includes.forEach(function(include) {
            includeVars["with".concat((0,helpers/* uppercaseFirst */.AB)(include))] = true;
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
        var variables = (0,react.useMemo)(function() {
            return (0,_object_spread/* default */.Z)({
                id: id
            }, includeVars);
        }, [
            id
        ]);
        var ref = (0,dist/* default */.ZP)([
            CALCULATION_SETTINGS_DEPENDENTS_QUERY,
            variables
        ], {
            revalidateOnFocus: false
        }), data = ref.data, error = ref.error, mutate = ref.mutate;
        return {
            data: !data ? data : data.groupedDependents,
            isLoading: !error && !data,
            isError: error,
            mutate: mutate
        };
    },
    createObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(data) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    input: data
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(CREATE_CALCULATION_SETTINGS_MUTATION, variables).then(function(data) {
                        return hydrateObject(data.calculationSettings);
                    })
                ];
            });
        });
        return function(data) {
            return _ref.apply(this, arguments);
        };
    }(),
    updateObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(data) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    input: data
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(UPDATE_CALCULATION_SETTINGS_MUTATION, variables).then(function(data) {
                        return hydrateObject(data.calculationSettings);
                    })
                ];
            });
        });
        return function(data) {
            return _ref.apply(this, arguments);
        };
    }(),
    deleteObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(DELETE_CALCULATION_SETTINGS_MUTATION, variables).then(function(data) {
                        return data.deleteTravelPricingServiceCalculationSettings;
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }(),
    forceDeleteObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(FORCE_DELETE_CALCULATION_SETTINGS_MUTATION, variables).then(function(data) {
                        return data.forceDeleteTravelPricingServiceCalculationSettings;
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }()
};
/* harmony default export */ var repository = (travelPricingServiceCalculationSettingsRepository);

;// CONCATENATED MODULE: ./src/entities/travelPricingServiceCalculationSettings/entity.ts


var travelPricingServiceCalculationSettingsEntity = {
    model: model,
    repository: repository
};
/* harmony default export */ var entity = (travelPricingServiceCalculationSettingsEntity);


/***/ }),

/***/ 541:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ travelTeam_entity; }
});

;// CONCATENATED MODULE: ./src/entities/travelTeam/graphql.ts
// language=GraphQL
var ALL_TEAMS_QUERY = "query Query($withMembers: Boolean = false, $withMembersImage: Boolean = false) {\n  teams: travelTeams {\n    id\n    name\n    members @include(if: $withMembers) {\n      id\n      firstName\n      lastName\n      description\n      image @include(if: $withMembersImage) {\n        id\n        assetId\n        publicId\n        url\n        resourceType\n        format\n        width\n        height\n        caption\n        title\n        description\n      }\n    }\n  }\n}";
// language=GraphQL
var SINGLE_TEAM_QUERY = "query Query($id: ID!, $withMembers: Boolean = false, $withMembersImage: Boolean = false) {\n  team: travelTeam(id: $id) {\n    id\n    name\n    members @include(if: $withMembers) {\n      id\n      firstName\n      lastName\n      description\n      image @include(if: $withMembersImage) {\n        id\n        assetId\n        publicId\n        url\n        resourceType\n        format\n        width\n        height\n        caption\n        title\n        description\n      }\n    }\n  }\n}";
// language=GraphQL
var CREATE_TEAM_MUTATION = "\n  mutation Mutation($input: CreateTravelTeamInput, $withMembers: Boolean = false, $withMembersImage: Boolean = false) {\n    team: createTravelTeam(input: $input) {\n      id\n      name\n      members @include(if: $withMembers) {\n        id\n        firstName\n        lastName\n        description\n        image @include(if: $withMembersImage) {\n          id\n          assetId\n          publicId\n          url\n          resourceType\n          format\n          width\n          height\n          caption\n          title\n          description\n        }\n      }\n    }\n  }";
// language=GraphQL
var UPDATE_TEAM_MUTATION = "\n  mutation Mutation($input: UpdateTravelTeamInput, $withMembers: Boolean = false, $withMembersImage: Boolean = false) {\n    team: updateTravelTeam(input: $input) {\n      id\n      name\n      members @include(if: $withMembers) {\n        id\n        firstName\n        lastName\n        description\n        image @include(if: $withMembersImage) {\n          id\n          assetId\n          publicId\n          url\n          resourceType\n          format\n          width\n          height\n          caption\n          title\n          description\n        }\n      }\n    }\n  }";
// language=GraphQL
var DELETE_TEAM_MUTATION = "\n  mutation Mutation($input: DeleteTravelTeamInput) {\n    deleteTravelTeam(input: $input) {\n      success\n    }\n  }";
// language=GraphQL
var FORCE_DELETE_TEAM_MUTATION = "\n  mutation Mutation($input: DeleteTravelTeamInput) {\n    forceDeleteTravelTeam(input: $input) {\n      success\n    }\n  }";
// language=GraphQL
var ADD_TEAM_MEMBERS_MUTATION = "\n  mutation Mutation($input: addTravelTeamMembersInput) {\n    addTravelTeamMembers(input: $input) {\n      id\n      memberIds\n    }\n  }";
// language=GraphQL
var REMOVE_TEAM_MEMBERS_MUTATION = "\n  mutation Mutation($input: removeTravelTeamMembersInput) {\n    removeTravelTeamMembers(input: $input) {\n      id\n      memberIds\n    }\n  }";
// language=GraphQL
var CREATE_TEAM_MEMBERS_MUTATION = "\n  mutation Mutation($input: createTravelTeamMembersInput) {\n    createTravelTeamMembers(input: $input) {\n      id\n      memberIds\n    }\n  }";
// language=GraphQL
var DELETE_TEAM_MEMBERS_MUTATION = "\n  mutation Mutation($input: deleteTravelTeamMembersInput) {\n    deleteTravelTeamMembers(input: $input) {\n      id\n      memberIds\n    }\n  }";
// language=GraphQL
var UPDATE_TEAM_MEMBERS_ORDER_MUTATION = "\n  mutation Mutation($input: updateTravelTeamMembersOrderInput) {\n    updateTravelTeamMembersOrder(input: $input) {\n      id\n      memberIds\n    }\n  }";
// language=GraphQL
var TEAMS_DEPENDENTS_QUERY = "query Query($id: ID!, $withTravels: Boolean = false) {\n  groupedDependents: travelTeamDependents(id: $id) {\n    travels @include(if: $withTravels) {\n      id\n      name\n      isBestseller\n      startDate\n      endDate\n      executionStatus\n      title\n      description\n      includedServices\n      excludedServices\n      pricingTable\n      priceCalculationInfo\n      programType\n      programText\n      minPrice\n      minPriceManualOverride\n      currency    }\n  }\n}";

// EXTERNAL MODULE: ./src/entities/travelGuide/entity.ts + 3 modules
var entity = __webpack_require__(36687);
;// CONCATENATED MODULE: ./src/entities/travelTeam/model.ts


var travelTeamModel = {
    name: "team",
    namePlural: "teams",
    uniqueName: "travelTeam",
    uniqueNamePlural: "travelTeams",
    path: "travel/team",
    baseUrl: "/travel/teams",
    translationPrefix: "entities:travelTeam.",
    getDisplayName: function(values) {
        return values.name;
    },
    gql: {
        getAll: ALL_TEAMS_QUERY,
        getSingle: SINGLE_TEAM_QUERY,
        create: CREATE_TEAM_MUTATION,
        update: UPDATE_TEAM_MUTATION,
        delete: DELETE_TEAM_MUTATION,
        forceDelete: FORCE_DELETE_TEAM_MUTATION
    },
    attributes: {
        name: {
            name: "name",
            label: "entities:travelTeam.attributes.name.label",
            type: "value",
            dataType: "string",
            defaultInput: true,
            inputType: "text",
            validationType: "string",
            validations: [
                {
                    type: "required"
                }, 
            ]
        },
        members: {
            name: "members",
            label: "entities:travelTeam.attributes.members.label",
            type: "entityCollection",
            dataType: "[any]",
            getEntity: function() {
                return entity/* default */.Z;
            },
            defaultInput: false,
            inputType: "text",
            validationType: "string",
            validations: []
        }
    }
};
/* harmony default export */ var model = (travelTeamModel);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(20414);
// EXTERNAL MODULE: ./src/entities/lib.ts
var lib = __webpack_require__(23480);
// EXTERNAL MODULE: ./src/lib/api/graphQLClient.ts
var graphQLClient = __webpack_require__(40112);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/swr/dist/index.mjs
var dist = __webpack_require__(8100);
// EXTERNAL MODULE: ./src/lib/helpers/helpers.ts
var helpers = __webpack_require__(15778);
;// CONCATENATED MODULE: ./src/entities/travelTeam/repository.ts










var hydrateObjects = function(objects) {
    return objects.map(function(object) {
        return (0,lib/* hydrateEntityObject */.b)(model, object);
    });
};
var hydrateObject = function(object) {
    return (0,lib/* hydrateEntityObject */.b)(model, object);
};
var travelTeamRepository = {
    getObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    id: id
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(SINGLE_TEAM_QUERY, variables).then(function(data) {
                        return hydrateObject(data.team);
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }(),
    getObjects: /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        var includes;
        var _arguments = arguments;
        return (0,tslib_es6.__generator)(this, function(_state) {
            includes = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : {};
            return [
                2,
                graphQLClient/* default.request */.Z.request(ALL_TEAMS_QUERY, includes).then(function(data) {
                    return hydrateObjects(data.teams);
                })
            ];
        });
    }),
    useObject: function(id) {
        var includes = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        // eslint-disable-next-line react-hooks/exhaustive-deps
        var variables = (0,react.useMemo)(function() {
            return (0,_object_spread/* default */.Z)({
                id: id
            }, includes);
        }, [
            id
        ]);
        var ref = (0,dist/* default */.ZP)([
            SINGLE_TEAM_QUERY,
            variables
        ], {
            revalidateOnFocus: false
        }), data = ref.data, error = ref.error, mutate = ref.mutate;
        return {
            object: !data ? data : hydrateObject(data.team),
            isLoading: !error && !data,
            isError: error,
            mutate: mutate
        };
    },
    useObjects: function() {
        var includes = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        // eslint-disable-next-line react-hooks/exhaustive-deps
        var variables = (0,react.useMemo)(function() {
            return includes;
        }, []);
        var ref = (0,dist/* default */.ZP)([
            ALL_TEAMS_QUERY,
            variables
        ]), data = ref.data, error = ref.error, mutate = ref.mutate;
        return {
            objects: !data ? data : hydrateObjects(data.teams),
            isLoading: !error && !data,
            isError: error,
            mutate: mutate
        };
    },
    getDependents: function(id, includes) {
        var includeVars = {};
        includes.forEach(function(include) {
            includeVars["with".concat((0,helpers/* uppercaseFirst */.AB)(include))] = true;
        });
        var variables = (0,_object_spread/* default */.Z)({
            id: id
        }, includeVars);
        return graphQLClient/* default.request */.Z.request(TEAMS_DEPENDENTS_QUERY, variables).then(function(data) {
            return data.groupedDependents;
        });
    },
    useDependents: function(id, includes) {
        var includeVars = {};
        includes.forEach(function(include) {
            includeVars["with".concat((0,helpers/* uppercaseFirst */.AB)(include))] = true;
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
        var variables = (0,react.useMemo)(function() {
            return (0,_object_spread/* default */.Z)({
                id: id
            }, includeVars);
        }, [
            id
        ]);
        var ref = (0,dist/* default */.ZP)([
            TEAMS_DEPENDENTS_QUERY,
            variables
        ], {
            revalidateOnFocus: false
        }), data = ref.data, error = ref.error, mutate = ref.mutate;
        return {
            data: !data ? data : data.groupedDependents,
            isLoading: !error && !data,
            isError: error,
            mutate: mutate
        };
    },
    createObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(data) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    input: data
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(CREATE_TEAM_MUTATION, variables).then(function(data) {
                        return hydrateObject(data.team);
                    })
                ];
            });
        });
        return function(data) {
            return _ref.apply(this, arguments);
        };
    }(),
    updateObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(data) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    input: data
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(UPDATE_TEAM_MUTATION, variables).then(function(data) {
                        return hydrateObject(data.team);
                    })
                ];
            });
        });
        return function(data) {
            return _ref.apply(this, arguments);
        };
    }(),
    deleteObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(DELETE_TEAM_MUTATION, variables).then(function(data) {
                        return data.deleteTravelTeam;
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }(),
    forceDeleteObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(FORCE_DELETE_TEAM_MUTATION, variables).then(function(data) {
                        return data.forceDeleteTravelTeam;
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }(),
    assignMembers: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, itemIds) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        memberIds: itemIds
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(ADD_TEAM_MEMBERS_MUTATION, variables)
                ];
            });
        });
        return function(id, itemIds) {
            return _ref.apply(this, arguments);
        };
    }(),
    unassignMembers: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, itemIds) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        memberIds: itemIds
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(REMOVE_TEAM_MEMBERS_MUTATION, variables)
                ];
            });
        });
        return function(id, itemIds) {
            return _ref.apply(this, arguments);
        };
    }(),
    createMembers: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, items) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        members: items
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(CREATE_TEAM_MEMBERS_MUTATION, variables)
                ];
            });
        });
        return function(id, items) {
            return _ref.apply(this, arguments);
        };
    }(),
    deleteMembers: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, itemIds) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        memberIds: itemIds
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(DELETE_TEAM_MEMBERS_MUTATION, variables)
                ];
            });
        });
        return function(id, itemIds) {
            return _ref.apply(this, arguments);
        };
    }(),
    updateMembersOrder: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, itemIds) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        memberIds: itemIds
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(UPDATE_TEAM_MEMBERS_ORDER_MUTATION, variables)
                ];
            });
        });
        return function(id, itemIds) {
            return _ref.apply(this, arguments);
        };
    }()
};
/* harmony default export */ var repository = (travelTeamRepository);

;// CONCATENATED MODULE: ./src/entities/travelTeam/entity.ts


var travelTeamEntity = {
    model: model,
    repository: repository
};
/* harmony default export */ var travelTeam_entity = (travelTeamEntity);


/***/ }),

/***/ 48716:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ travelTestimonial_entity; }
});

;// CONCATENATED MODULE: ./src/entities/travelTestimonial/graphql.ts
// language=GraphQL
var ALL_TESTIMONIALS_QUERY = "query Query($withContentBlock: Boolean = false, $withContentBlockImage: Boolean = false) {\n  testimonials: travelTestimonials {\n    id\n    contentBlock @include(if: $withContentBlock) {\n      id\n      title\n      text\n      image @include(if: $withContentBlockImage) {\n        id\n        assetId\n        publicId\n        url\n        resourceType\n        format\n        width\n        height\n        caption\n        title\n        description\n      }\n      imagePosition\n    }\n  }\n}";
// language=GraphQL
var SINGLE_TESTIMONIAL_QUERY = "query Query($id: ID!, $withContentBlock: Boolean = false, $withContentBlockImage: Boolean = false) {\n  testimonial: travelTestimonial(id: $id) {\n    id\n    contentBlock @include(if: $withContentBlock) {\n      id\n      title\n      text\n      image @include(if: $withContentBlockImage) {\n        id\n        assetId\n        publicId\n        url\n        resourceType\n        format\n        width\n        height\n        caption\n        title\n        description\n      }\n      imagePosition\n    }\n  }\n}";
// language=GraphQL
var CREATE_TESTIMONIAL_MUTATION = "\n  mutation Mutation($input: CreateTravelTestimonialInput, $withContentBlock: Boolean = false, $withContentBlockImage: Boolean = false) {\n    testimonial: createTravelTestimonial(input: $input) {\n      id\n      contentBlock @include(if: $withContentBlock) {\n        id\n        title\n        text\n        image @include(if: $withContentBlockImage) {\n          id\n          assetId\n          publicId\n          url\n          resourceType\n          format\n          width\n          height\n          caption\n          title\n          description\n        }\n        imagePosition\n      }\n    }\n  }";
// language=GraphQL
var UPDATE_TESTIMONIAL_MUTATION = "\n  mutation Mutation($input: UpdateTravelTestimonialInput, $withContentBlock: Boolean = false, $withContentBlockImage: Boolean = false) {\n    testimonial: updateTravelTestimonial(input: $input) {\n      id\n      contentBlock @include(if: $withContentBlock) {\n        id\n        title\n        text\n        image @include(if: $withContentBlockImage) {\n          id\n          assetId\n          publicId\n          url\n          resourceType\n          format\n          width\n          height\n          caption\n          title\n          description\n        }\n        imagePosition\n      }\n    }\n  }";
// language=GraphQL
var DELETE_TESTIMONIAL_MUTATION = "\n  mutation Mutation($input: DeleteTravelTestimonialInput) {\n    deleteTravelTestimonial(input: $input) {\n      success\n    }\n  }";
// language=GraphQL
var FORCE_DELETE_TESTIMONIAL_MUTATION = "\n  mutation Mutation($input: DeleteTravelTestimonialInput) {\n    forceDeleteTravelTestimonial(input: $input) {\n      success\n    }\n  }";
// language=GraphQL
var TESTIMONIALS_DEPENDENTS_QUERY = "query Query($id: ID!, $withTravels: Boolean = false) {\n  groupedDependents: travelTestimonialDependents(id: $id) {\n    travels @include(if: $withTravels) {\n      id\n      name\n      isBestseller\n      startDate\n      endDate\n      executionStatus\n      title\n      description\n      includedServices\n      excludedServices\n      pricingTable\n      priceCalculationInfo\n      programType\n      programText\n      minPrice\n      minPriceManualOverride\n      currency    }\n  }\n}";

// EXTERNAL MODULE: ./src/entities/cmsTextWithIconBlock/entity.ts + 3 modules
var entity = __webpack_require__(3572);
;// CONCATENATED MODULE: ./src/entities/travelTestimonial/model.ts


var travelTestimonialModel = {
    name: "testimonial",
    namePlural: "testimonials",
    uniqueName: "travelTestimonial",
    uniqueNamePlural: "travelTestimonials",
    path: "travel/testimonial",
    baseUrl: "/travel/testimonials",
    translationPrefix: "entities:travelTestimonial.",
    getDisplayName: function(values) {
        return "";
    },
    gql: {
        getAll: ALL_TESTIMONIALS_QUERY,
        getSingle: SINGLE_TESTIMONIAL_QUERY,
        create: CREATE_TESTIMONIAL_MUTATION,
        update: UPDATE_TESTIMONIAL_MUTATION,
        delete: DELETE_TESTIMONIAL_MUTATION,
        forceDelete: FORCE_DELETE_TESTIMONIAL_MUTATION
    },
    attributes: {
        contentBlock: {
            name: "contentBlock",
            label: "entities:travelTestimonial.attributes.contentBlock.label",
            type: "entityObject",
            dataType: "any",
            getEntity: function() {
                return entity/* default */.Z;
            },
            defaultInput: false,
            inputType: "select",
            validationType: "string",
            validations: []
        }
    }
};
/* harmony default export */ var model = (travelTestimonialModel);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(20414);
// EXTERNAL MODULE: ./src/entities/lib.ts
var lib = __webpack_require__(23480);
// EXTERNAL MODULE: ./src/lib/api/graphQLClient.ts
var graphQLClient = __webpack_require__(40112);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/swr/dist/index.mjs
var dist = __webpack_require__(8100);
// EXTERNAL MODULE: ./src/lib/helpers/helpers.ts
var helpers = __webpack_require__(15778);
;// CONCATENATED MODULE: ./src/entities/travelTestimonial/repository.ts










var hydrateObjects = function(objects) {
    return objects.map(function(object) {
        return (0,lib/* hydrateEntityObject */.b)(model, object);
    });
};
var hydrateObject = function(object) {
    return (0,lib/* hydrateEntityObject */.b)(model, object);
};
var travelTestimonialRepository = {
    getObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    id: id
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(SINGLE_TESTIMONIAL_QUERY, variables).then(function(data) {
                        return hydrateObject(data.testimonial);
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }(),
    getObjects: /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        var includes;
        var _arguments = arguments;
        return (0,tslib_es6.__generator)(this, function(_state) {
            includes = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : {};
            return [
                2,
                graphQLClient/* default.request */.Z.request(ALL_TESTIMONIALS_QUERY, includes).then(function(data) {
                    return hydrateObjects(data.testimonials);
                })
            ];
        });
    }),
    useObject: function(id) {
        var includes = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        // eslint-disable-next-line react-hooks/exhaustive-deps
        var variables = (0,react.useMemo)(function() {
            return (0,_object_spread/* default */.Z)({
                id: id
            }, includes);
        }, [
            id
        ]);
        var ref = (0,dist/* default */.ZP)([
            SINGLE_TESTIMONIAL_QUERY,
            variables
        ], {
            revalidateOnFocus: false
        }), data = ref.data, error = ref.error, mutate = ref.mutate;
        return {
            object: !data ? data : hydrateObject(data.testimonial),
            isLoading: !error && !data,
            isError: error,
            mutate: mutate
        };
    },
    useObjects: function() {
        var includes = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        // eslint-disable-next-line react-hooks/exhaustive-deps
        var variables = (0,react.useMemo)(function() {
            return includes;
        }, []);
        var ref = (0,dist/* default */.ZP)([
            ALL_TESTIMONIALS_QUERY,
            variables
        ]), data = ref.data, error = ref.error, mutate = ref.mutate;
        return {
            objects: !data ? data : hydrateObjects(data.testimonials),
            isLoading: !error && !data,
            isError: error,
            mutate: mutate
        };
    },
    getDependents: function(id, includes) {
        var includeVars = {};
        includes.forEach(function(include) {
            includeVars["with".concat((0,helpers/* uppercaseFirst */.AB)(include))] = true;
        });
        var variables = (0,_object_spread/* default */.Z)({
            id: id
        }, includeVars);
        return graphQLClient/* default.request */.Z.request(TESTIMONIALS_DEPENDENTS_QUERY, variables).then(function(data) {
            return data.groupedDependents;
        });
    },
    useDependents: function(id, includes) {
        var includeVars = {};
        includes.forEach(function(include) {
            includeVars["with".concat((0,helpers/* uppercaseFirst */.AB)(include))] = true;
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
        var variables = (0,react.useMemo)(function() {
            return (0,_object_spread/* default */.Z)({
                id: id
            }, includeVars);
        }, [
            id
        ]);
        var ref = (0,dist/* default */.ZP)([
            TESTIMONIALS_DEPENDENTS_QUERY,
            variables
        ], {
            revalidateOnFocus: false
        }), data = ref.data, error = ref.error, mutate = ref.mutate;
        return {
            data: !data ? data : data.groupedDependents,
            isLoading: !error && !data,
            isError: error,
            mutate: mutate
        };
    },
    createObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(data) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    input: data
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(CREATE_TESTIMONIAL_MUTATION, variables).then(function(data) {
                        return hydrateObject(data.testimonial);
                    })
                ];
            });
        });
        return function(data) {
            return _ref.apply(this, arguments);
        };
    }(),
    updateObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(data) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    input: data
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(UPDATE_TESTIMONIAL_MUTATION, variables).then(function(data) {
                        return hydrateObject(data.testimonial);
                    })
                ];
            });
        });
        return function(data) {
            return _ref.apply(this, arguments);
        };
    }(),
    deleteObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(DELETE_TESTIMONIAL_MUTATION, variables).then(function(data) {
                        return data.deleteTravelTestimonial;
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }(),
    forceDeleteObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(FORCE_DELETE_TESTIMONIAL_MUTATION, variables).then(function(data) {
                        return data.forceDeleteTravelTestimonial;
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }()
};
/* harmony default export */ var repository = (travelTestimonialRepository);

;// CONCATENATED MODULE: ./src/entities/travelTestimonial/entity.ts


var travelTestimonialEntity = {
    model: model,
    repository: repository
};
/* harmony default export */ var travelTestimonial_entity = (travelTestimonialEntity);


/***/ }),

/***/ 31250:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ travelType_entity; }
});

;// CONCATENATED MODULE: ./src/entities/travelType/graphql.ts
// language=GraphQL
var ALL_TRAVEL_TYPES_QUERY = "query Query($withImage: Boolean = false) {\n  travelTypes: travelTypes {\n    id\n    name\n    description\n    image @include(if: $withImage) {\n      id\n      assetId\n      publicId\n      url\n      resourceType\n      format\n      width\n      height\n      caption\n      title\n      description\n    }\n  }\n}";
// language=GraphQL
var SINGLE_TRAVEL_TYPE_QUERY = "query Query($id: ID!, $withImage: Boolean = false) {\n  travelType: travelType(id: $id) {\n    id\n    name\n    description\n    image @include(if: $withImage) {\n      id\n      assetId\n      publicId\n      url\n      resourceType\n      format\n      width\n      height\n      caption\n      title\n      description\n    }\n  }\n}";
// language=GraphQL
var CREATE_TRAVEL_TYPE_MUTATION = "\n  mutation Mutation($input: CreateTravelTypeInput, $withImage: Boolean = false) {\n    travelType: createTravelType(input: $input) {\n      id\n      name\n      description\n      image @include(if: $withImage) {\n        id\n        assetId\n        publicId\n        url\n        resourceType\n        format\n        width\n        height\n        caption\n        title\n        description\n      }\n    }\n  }";
// language=GraphQL
var UPDATE_TRAVEL_TYPE_MUTATION = "\n  mutation Mutation($input: UpdateTravelTypeInput, $withImage: Boolean = false) {\n    travelType: updateTravelType(input: $input) {\n      id\n      name\n      description\n      image @include(if: $withImage) {\n        id\n        assetId\n        publicId\n        url\n        resourceType\n        format\n        width\n        height\n        caption\n        title\n        description\n      }\n    }\n  }";
// language=GraphQL
var DELETE_TRAVEL_TYPE_MUTATION = "\n  mutation Mutation($input: DeleteTravelTypeInput) {\n    deleteTravelType(input: $input) {\n      success\n    }\n  }";
// language=GraphQL
var FORCE_DELETE_TRAVEL_TYPE_MUTATION = "\n  mutation Mutation($input: DeleteTravelTypeInput) {\n    forceDeleteTravelType(input: $input) {\n      success\n    }\n  }";
// language=GraphQL
var TRAVEL_TYPES_DEPENDENTS_QUERY = "query Query($id: ID!, $withTenants: Boolean = false, $withCmsPrefilteredTravelsBlocks: Boolean = false, $withTravelObjectTenantSettings: Boolean = false) {\n  groupedDependents: travelTypeDependents(id: $id) {\n    tenants @include(if: $withTenants) {\n      id\n      name\n      slug\n      domain\n      externalReference\n    }\n    cmsPrefilteredTravelsBlocks @include(if: $withCmsPrefilteredTravelsBlocks) {\n      id\n      maxResults    }\n    travelObjectTenantSettings @include(if: $withTravelObjectTenantSettings) {\n      id\n      onlineStatus\n      redirectToBooking\n      useTiming\n      startDate\n      endDate\n    }\n  }\n}";

// EXTERNAL MODULE: ./src/entities/mediaFile/entity.ts + 3 modules
var entity = __webpack_require__(24180);
;// CONCATENATED MODULE: ./src/entities/travelType/model.ts


var travelTypeModel = {
    name: "travelType",
    namePlural: "travelTypes",
    uniqueName: "travelType",
    uniqueNamePlural: "travelTypes",
    path: "travel/travel_type",
    baseUrl: "/travel/travel_types",
    translationPrefix: "entities:travelType.",
    getDisplayName: function(values) {
        return values.name;
    },
    gql: {
        getAll: ALL_TRAVEL_TYPES_QUERY,
        getSingle: SINGLE_TRAVEL_TYPE_QUERY,
        create: CREATE_TRAVEL_TYPE_MUTATION,
        update: UPDATE_TRAVEL_TYPE_MUTATION,
        delete: DELETE_TRAVEL_TYPE_MUTATION,
        forceDelete: FORCE_DELETE_TRAVEL_TYPE_MUTATION
    },
    attributes: {
        name: {
            name: "name",
            label: "entities:travelType.attributes.name.label",
            type: "value",
            dataType: "string",
            defaultInput: true,
            inputType: "text",
            validationType: "string",
            validations: [
                {
                    type: "required"
                }, 
            ]
        },
        description: {
            name: "description",
            label: "entities:travelType.attributes.description.label",
            type: "value",
            dataType: "string",
            defaultInput: true,
            inputType: "textarea",
            validationType: "string",
            validations: [
                {
                    type: "required"
                }, 
            ]
        },
        image: {
            name: "image",
            label: "entities:travelType.attributes.image.label",
            type: "entityObject",
            dataType: "any",
            getEntity: function() {
                return entity/* default */.Z;
            },
            defaultInput: false,
            inputType: "select",
            validationType: "string",
            validations: []
        }
    }
};
/* harmony default export */ var model = (travelTypeModel);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(20414);
// EXTERNAL MODULE: ./src/entities/lib.ts
var lib = __webpack_require__(23480);
// EXTERNAL MODULE: ./src/lib/api/graphQLClient.ts
var graphQLClient = __webpack_require__(40112);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/swr/dist/index.mjs
var dist = __webpack_require__(8100);
// EXTERNAL MODULE: ./src/lib/helpers/helpers.ts
var helpers = __webpack_require__(15778);
;// CONCATENATED MODULE: ./src/entities/travelType/repository.ts










var hydrateObjects = function(objects) {
    return objects.map(function(object) {
        return (0,lib/* hydrateEntityObject */.b)(model, object);
    });
};
var hydrateObject = function(object) {
    return (0,lib/* hydrateEntityObject */.b)(model, object);
};
var travelTypeRepository = {
    getObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    id: id
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(SINGLE_TRAVEL_TYPE_QUERY, variables).then(function(data) {
                        return hydrateObject(data.travelType);
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }(),
    getObjects: /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        var includes;
        var _arguments = arguments;
        return (0,tslib_es6.__generator)(this, function(_state) {
            includes = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : {};
            return [
                2,
                graphQLClient/* default.request */.Z.request(ALL_TRAVEL_TYPES_QUERY, includes).then(function(data) {
                    return hydrateObjects(data.travelTypes);
                })
            ];
        });
    }),
    useObject: function(id) {
        var includes = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        // eslint-disable-next-line react-hooks/exhaustive-deps
        var variables = (0,react.useMemo)(function() {
            return (0,_object_spread/* default */.Z)({
                id: id
            }, includes);
        }, [
            id
        ]);
        var ref = (0,dist/* default */.ZP)([
            SINGLE_TRAVEL_TYPE_QUERY,
            variables
        ], {
            revalidateOnFocus: false
        }), data = ref.data, error = ref.error, mutate = ref.mutate;
        return {
            object: !data ? data : hydrateObject(data.travelType),
            isLoading: !error && !data,
            isError: error,
            mutate: mutate
        };
    },
    useObjects: function() {
        var includes = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        // eslint-disable-next-line react-hooks/exhaustive-deps
        var variables = (0,react.useMemo)(function() {
            return includes;
        }, []);
        var ref = (0,dist/* default */.ZP)([
            ALL_TRAVEL_TYPES_QUERY,
            variables
        ]), data = ref.data, error = ref.error, mutate = ref.mutate;
        return {
            objects: !data ? data : hydrateObjects(data.travelTypes),
            isLoading: !error && !data,
            isError: error,
            mutate: mutate
        };
    },
    getDependents: function(id, includes) {
        var includeVars = {};
        includes.forEach(function(include) {
            includeVars["with".concat((0,helpers/* uppercaseFirst */.AB)(include))] = true;
        });
        var variables = (0,_object_spread/* default */.Z)({
            id: id
        }, includeVars);
        return graphQLClient/* default.request */.Z.request(TRAVEL_TYPES_DEPENDENTS_QUERY, variables).then(function(data) {
            return data.groupedDependents;
        });
    },
    useDependents: function(id, includes) {
        var includeVars = {};
        includes.forEach(function(include) {
            includeVars["with".concat((0,helpers/* uppercaseFirst */.AB)(include))] = true;
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
        var variables = (0,react.useMemo)(function() {
            return (0,_object_spread/* default */.Z)({
                id: id
            }, includeVars);
        }, [
            id
        ]);
        var ref = (0,dist/* default */.ZP)([
            TRAVEL_TYPES_DEPENDENTS_QUERY,
            variables
        ], {
            revalidateOnFocus: false
        }), data = ref.data, error = ref.error, mutate = ref.mutate;
        return {
            data: !data ? data : data.groupedDependents,
            isLoading: !error && !data,
            isError: error,
            mutate: mutate
        };
    },
    createObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(data) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    input: data
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(CREATE_TRAVEL_TYPE_MUTATION, variables).then(function(data) {
                        return hydrateObject(data.travelType);
                    })
                ];
            });
        });
        return function(data) {
            return _ref.apply(this, arguments);
        };
    }(),
    updateObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(data) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    input: data
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(UPDATE_TRAVEL_TYPE_MUTATION, variables).then(function(data) {
                        return hydrateObject(data.travelType);
                    })
                ];
            });
        });
        return function(data) {
            return _ref.apply(this, arguments);
        };
    }(),
    deleteObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(DELETE_TRAVEL_TYPE_MUTATION, variables).then(function(data) {
                        return data.deleteTravelType;
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }(),
    forceDeleteObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(FORCE_DELETE_TRAVEL_TYPE_MUTATION, variables).then(function(data) {
                        return data.forceDeleteTravelType;
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }()
};
/* harmony default export */ var repository = (travelTypeRepository);

;// CONCATENATED MODULE: ./src/entities/travelType/entity.ts


var travelTypeEntity = {
    model: model,
    repository: repository
};
/* harmony default export */ var travelType_entity = (travelTypeEntity);


/***/ }),

/***/ 39393:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ entity; }
});

;// CONCATENATED MODULE: ./src/entities/travelWebhookConfig/graphql.ts
// language=GraphQL
var ALL_WEBHOOK_CONFIGS_QUERY = "query Query {\n  webhookConfigs: travelWebhookConfigs {\n    id\n    enabled\n    url\n  }\n}";
// language=GraphQL
var SINGLE_WEBHOOK_CONFIG_QUERY = "query Query($id: ID!) {\n  webhookConfig: travelWebhookConfig(id: $id) {\n    id\n    enabled\n    url\n  }\n}";
// language=GraphQL
var CREATE_WEBHOOK_CONFIG_MUTATION = "\n  mutation Mutation($input: CreateTravelWebhookConfigInput) {\n    webhookConfig: createTravelWebhookConfig(input: $input) {\n      id\n      enabled\n      url\n    }\n  }";
// language=GraphQL
var UPDATE_WEBHOOK_CONFIG_MUTATION = "\n  mutation Mutation($input: UpdateTravelWebhookConfigInput) {\n    webhookConfig: updateTravelWebhookConfig(input: $input) {\n      id\n      enabled\n      url\n    }\n  }";
// language=GraphQL
var DELETE_WEBHOOK_CONFIG_MUTATION = "\n  mutation Mutation($input: DeleteTravelWebhookConfigInput) {\n    deleteTravelWebhookConfig(input: $input) {\n      success\n    }\n  }";
// language=GraphQL
var FORCE_DELETE_WEBHOOK_CONFIG_MUTATION = "\n  mutation Mutation($input: DeleteTravelWebhookConfigInput) {\n    forceDeleteTravelWebhookConfig(input: $input) {\n      success\n    }\n  }";
// language=GraphQL
var WEBHOOK_CONFIGS_DEPENDENTS_QUERY = "query Query($id: ID!, $withTravelPricings: Boolean = false) {\n  groupedDependents: travelWebhookConfigDependents(id: $id) {\n    travelPricings @include(if: $withTravelPricings) {\n      id\n      isTravelDocumentationAvailable\n    }\n  }\n}";

;// CONCATENATED MODULE: ./src/entities/travelWebhookConfig/model.ts

var travelWebhookConfigModel = {
    name: "webhookConfig",
    namePlural: "webhookConfigs",
    uniqueName: "travelWebhookConfig",
    uniqueNamePlural: "travelWebhookConfigs",
    path: "travel/pricing/webhook_config",
    baseUrl: "/travel/pricing/webhook_configs",
    translationPrefix: "entities:travelWebhookConfig.",
    getDisplayName: function(values) {
        return "";
    },
    gql: {
        getAll: ALL_WEBHOOK_CONFIGS_QUERY,
        getSingle: SINGLE_WEBHOOK_CONFIG_QUERY,
        create: CREATE_WEBHOOK_CONFIG_MUTATION,
        update: UPDATE_WEBHOOK_CONFIG_MUTATION,
        delete: DELETE_WEBHOOK_CONFIG_MUTATION,
        forceDelete: FORCE_DELETE_WEBHOOK_CONFIG_MUTATION
    },
    attributes: {
        enabled: {
            name: "enabled",
            label: "entities:travelWebhookConfig.attributes.enabled.label",
            type: "value",
            dataType: "boolean",
            defaultInput: true,
            inputType: "switch",
            validationType: "string",
            validations: []
        },
        url: {
            name: "url",
            label: "entities:travelWebhookConfig.attributes.url.label",
            type: "value",
            dataType: "string",
            defaultInput: true,
            inputType: "text",
            validationType: "string",
            validations: [
                {
                    type: "url"
                }, 
            ]
        }
    }
};
/* harmony default export */ var model = (travelWebhookConfigModel);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(20414);
// EXTERNAL MODULE: ./src/entities/lib.ts
var lib = __webpack_require__(23480);
// EXTERNAL MODULE: ./src/lib/api/graphQLClient.ts
var graphQLClient = __webpack_require__(40112);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/swr/dist/index.mjs
var dist = __webpack_require__(8100);
// EXTERNAL MODULE: ./src/lib/helpers/helpers.ts
var helpers = __webpack_require__(15778);
;// CONCATENATED MODULE: ./src/entities/travelWebhookConfig/repository.ts










var hydrateObjects = function(objects) {
    return objects.map(function(object) {
        return (0,lib/* hydrateEntityObject */.b)(model, object);
    });
};
var hydrateObject = function(object) {
    return (0,lib/* hydrateEntityObject */.b)(model, object);
};
var travelWebhookConfigRepository = {
    getObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    id: id
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(SINGLE_WEBHOOK_CONFIG_QUERY, variables).then(function(data) {
                        return hydrateObject(data.webhookConfig);
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }(),
    getObjects: /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        var includes;
        var _arguments = arguments;
        return (0,tslib_es6.__generator)(this, function(_state) {
            includes = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : {};
            return [
                2,
                graphQLClient/* default.request */.Z.request(ALL_WEBHOOK_CONFIGS_QUERY, includes).then(function(data) {
                    return hydrateObjects(data.webhookConfigs);
                })
            ];
        });
    }),
    useObject: function(id) {
        var includes = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        // eslint-disable-next-line react-hooks/exhaustive-deps
        var variables = (0,react.useMemo)(function() {
            return (0,_object_spread/* default */.Z)({
                id: id
            }, includes);
        }, [
            id
        ]);
        var ref = (0,dist/* default */.ZP)([
            SINGLE_WEBHOOK_CONFIG_QUERY,
            variables
        ], {
            revalidateOnFocus: false
        }), data = ref.data, error = ref.error, mutate = ref.mutate;
        return {
            object: !data ? data : hydrateObject(data.webhookConfig),
            isLoading: !error && !data,
            isError: error,
            mutate: mutate
        };
    },
    useObjects: function() {
        var includes = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        // eslint-disable-next-line react-hooks/exhaustive-deps
        var variables = (0,react.useMemo)(function() {
            return includes;
        }, []);
        var ref = (0,dist/* default */.ZP)([
            ALL_WEBHOOK_CONFIGS_QUERY,
            variables
        ]), data = ref.data, error = ref.error, mutate = ref.mutate;
        return {
            objects: !data ? data : hydrateObjects(data.webhookConfigs),
            isLoading: !error && !data,
            isError: error,
            mutate: mutate
        };
    },
    getDependents: function(id, includes) {
        var includeVars = {};
        includes.forEach(function(include) {
            includeVars["with".concat((0,helpers/* uppercaseFirst */.AB)(include))] = true;
        });
        var variables = (0,_object_spread/* default */.Z)({
            id: id
        }, includeVars);
        return graphQLClient/* default.request */.Z.request(WEBHOOK_CONFIGS_DEPENDENTS_QUERY, variables).then(function(data) {
            return data.groupedDependents;
        });
    },
    useDependents: function(id, includes) {
        var includeVars = {};
        includes.forEach(function(include) {
            includeVars["with".concat((0,helpers/* uppercaseFirst */.AB)(include))] = true;
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
        var variables = (0,react.useMemo)(function() {
            return (0,_object_spread/* default */.Z)({
                id: id
            }, includeVars);
        }, [
            id
        ]);
        var ref = (0,dist/* default */.ZP)([
            WEBHOOK_CONFIGS_DEPENDENTS_QUERY,
            variables
        ], {
            revalidateOnFocus: false
        }), data = ref.data, error = ref.error, mutate = ref.mutate;
        return {
            data: !data ? data : data.groupedDependents,
            isLoading: !error && !data,
            isError: error,
            mutate: mutate
        };
    },
    createObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(data) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    input: data
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(CREATE_WEBHOOK_CONFIG_MUTATION, variables).then(function(data) {
                        return hydrateObject(data.webhookConfig);
                    })
                ];
            });
        });
        return function(data) {
            return _ref.apply(this, arguments);
        };
    }(),
    updateObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(data) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    input: data
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(UPDATE_WEBHOOK_CONFIG_MUTATION, variables).then(function(data) {
                        return hydrateObject(data.webhookConfig);
                    })
                ];
            });
        });
        return function(data) {
            return _ref.apply(this, arguments);
        };
    }(),
    deleteObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(DELETE_WEBHOOK_CONFIG_MUTATION, variables).then(function(data) {
                        return data.deleteTravelWebhookConfig;
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }(),
    forceDeleteObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(FORCE_DELETE_WEBHOOK_CONFIG_MUTATION, variables).then(function(data) {
                        return data.forceDeleteTravelWebhookConfig;
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }()
};
/* harmony default export */ var repository = (travelWebhookConfigRepository);

;// CONCATENATED MODULE: ./src/entities/travelWebhookConfig/entity.ts


var travelWebhookConfigEntity = {
    model: model,
    repository: repository
};
/* harmony default export */ var entity = (travelWebhookConfigEntity);


/***/ }),

/***/ 53079:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ traveller_entity; }
});

;// CONCATENATED MODULE: ./src/entities/traveller/graphql.ts
// language=GraphQL
var ALL_TRAVELLERS_QUERY = "query Query($withAgeGroup: Boolean = false, $withAccommodation: Boolean = false, $withAccommodationCapacitySettings: Boolean = false, $withAccommodationCapacitySettingsAgeGroupCapacities: Boolean = false, $withAccommodationCapacitySettingsAgeGroupedTotalCapacities: Boolean = false, $withAccommodationCapacitySettingsPartialOccupancyAllowedAgeGroups: Boolean = false, $withAccommodationAddons: Boolean = false, $withAccommodationAddonsCalculationSettings: Boolean = false, $withAccommodationAddonsMandatorySettings: Boolean = false, $withFamilyPackage: Boolean = false, $withFamilyPackageAccommodation: Boolean = false, $withFamilyPackageAccommodationCapacitySettings: Boolean = false, $withFamilyPackageAccommodationAddons: Boolean = false, $withFamilyPackageCapacitySettings: Boolean = false, $withFamilyPackageCapacitySettingsAgeGroupCapacities: Boolean = false, $withFamilyPackageCapacitySettingsAgeGroupedTotalCapacities: Boolean = false, $withFamilyPackageCapacitySettingsPartialOccupancyAllowedAgeGroups: Boolean = false, $withFamilyPackageAddons: Boolean = false, $withFamilyPackageAddonsCalculationSettings: Boolean = false, $withFamilyPackageAddonsMandatorySettings: Boolean = false, $withAccommodationAddons: Boolean = false, $withAccommodationAddonsCalculationSettings: Boolean = false, $withAccommodationAddonsMandatorySettings: Boolean = false, $withAccommodationAddonsMandatorySettingsRules: Boolean = false, $withPersonalAddons: Boolean = false, $withPersonalAddonsAllowedAgeGroups: Boolean = false, $withPersonalAddonsCalculationSettings: Boolean = false, $withPersonalAddonsMandatorySettings: Boolean = false, $withPersonalAddonsMandatorySettingsRules: Boolean = false, $withBookingAddons: Boolean = false, $withBookingAddonsCalculationSettings: Boolean = false, $withBookingAddonsMandatorySettings: Boolean = false, $withBookingAddonsMandatorySettingsRules: Boolean = false, $withExtensions: Boolean = false, $withExtensionsTravelExtension: Boolean = false, $withExtensionsTravelExtensionHighlights: Boolean = false, $withExtensionsTravelExtensionImage: Boolean = false, $withExtensionsAccommodationMapItems: Boolean = false, $withExtensionsAccommodationMapItemsBaseAccommodation: Boolean = false, $withExtensionsAccommodationMapItemsExtensionAccommodation: Boolean = false, $withPassportData: Boolean = false) {\n  travellers: travellers {\n    id\n    salutation\n    firstName\n    lastName\n    birthday\n    nationality\n    email\n    phone\n    address\n    addressNumber\n    addressAddition\n    zip\n    city\n    country\n    ageGroup @include(if: $withAgeGroup) {\n      id\n      name\n      type\n      icon\n      minAge\n      maxAge\n    }\n    accommodation @include(if: $withAccommodation) {\n      id\n      ratioPackageNo\n      name\n      label\n      info\n      isFamilyPackageAccommodation\n      isBabyPackage\n      capacitySettings @include(if: $withAccommodationCapacitySettings) {\n        id\n        totalCapacity\n        rangesAllowed\n        ageGroupCapacities @include(if: $withAccommodationCapacitySettingsAgeGroupCapacities) {\n          id\n          minCapacity\n          maxCapacity\n        }\n        ageGroupedTotalCapacities @include(if: $withAccommodationCapacitySettingsAgeGroupedTotalCapacities) {\n          id\n          capacity\n        }\n        partialOccupancyAllowed\n        partialOccupancyAllowedAgeGroups @include(if: $withAccommodationCapacitySettingsPartialOccupancyAllowedAgeGroups) {\n          id\n          name\n          type\n          icon\n          minAge\n          maxAge\n        }\n      }\n      addons @include(if: $withAccommodationAddons) {\n        id\n        ratioServiceNo\n        name\n        label\n        info\n        calculationSettings @include(if: $withAccommodationAddonsCalculationSettings) {\n          id\n          type\n          considerHotelNights\n        }\n        mandatorySettings @include(if: $withAccommodationAddonsMandatorySettings) {\n          id\n          isMandatory\n          useRules\n        }\n      }\n    }\n    familyPackage @include(if: $withFamilyPackage) {\n      id\n      ratioServiceNo\n      accommodation @include(if: $withFamilyPackageAccommodation) {\n        id\n        ratioPackageNo\n        name\n        label\n        info\n        isFamilyPackageAccommodation\n        isBabyPackage\n        capacitySettings @include(if: $withFamilyPackageAccommodationCapacitySettings) {\n          id\n          totalCapacity\n          rangesAllowed\n          partialOccupancyAllowed\n        }\n        addons @include(if: $withFamilyPackageAccommodationAddons) {\n          id\n          ratioServiceNo\n          name\n          label\n          info\n        }\n      }\n      name\n      label\n      info\n      capacitySettings @include(if: $withFamilyPackageCapacitySettings) {\n        id\n        totalCapacity\n        rangesAllowed\n        ageGroupCapacities @include(if: $withFamilyPackageCapacitySettingsAgeGroupCapacities) {\n          id\n          minCapacity\n          maxCapacity\n        }\n        ageGroupedTotalCapacities @include(if: $withFamilyPackageCapacitySettingsAgeGroupedTotalCapacities) {\n          id\n          capacity\n        }\n        partialOccupancyAllowed\n        partialOccupancyAllowedAgeGroups @include(if: $withFamilyPackageCapacitySettingsPartialOccupancyAllowedAgeGroups) {\n          id\n          name\n          type\n          icon\n          minAge\n          maxAge\n        }\n      }\n      addons @include(if: $withFamilyPackageAddons) {\n        id\n        ratioServiceNo\n        name\n        label\n        info\n        calculationSettings @include(if: $withFamilyPackageAddonsCalculationSettings) {\n          id\n          type\n          considerHotelNights\n        }\n        mandatorySettings @include(if: $withFamilyPackageAddonsMandatorySettings) {\n          id\n          isMandatory\n          useRules\n        }\n      }\n    }\n    accommodationAddons @include(if: $withAccommodationAddons) {\n      id\n      ratioServiceNo\n      name\n      label\n      info\n      calculationSettings @include(if: $withAccommodationAddonsCalculationSettings) {\n        id\n        type\n        considerHotelNights\n      }\n      mandatorySettings @include(if: $withAccommodationAddonsMandatorySettings) {\n        id\n        isMandatory\n        useRules\n        rules @include(if: $withAccommodationAddonsMandatorySettingsRules) {\n          id\n          checkAccommodationTypes\n          checkAccommodationAddons\n          checkAgeGroups\n          useAgeFilter\n          checkDateRange\n          startDate\n          endDate\n          checkTravelDate\n        }\n      }\n    }\n    personalAddons @include(if: $withPersonalAddons) {\n      id\n      ratioServiceNo\n      name\n      label\n      info\n      allowedAgeGroups @include(if: $withPersonalAddonsAllowedAgeGroups) {\n        id\n        name\n        type\n        icon\n        minAge\n        maxAge\n      }\n      calculationSettings @include(if: $withPersonalAddonsCalculationSettings) {\n        id\n        type\n        considerHotelNights\n      }\n      mandatorySettings @include(if: $withPersonalAddonsMandatorySettings) {\n        id\n        isMandatory\n        useRules\n        rules @include(if: $withPersonalAddonsMandatorySettingsRules) {\n          id\n          checkAccommodationTypes\n          checkAccommodationAddons\n          checkAgeGroups\n          useAgeFilter\n          checkDateRange\n          startDate\n          endDate\n          checkTravelDate\n        }\n      }\n    }\n    bookingAddons @include(if: $withBookingAddons) {\n      id\n      ratioServiceNo\n      name\n      label\n      info\n      calculationSettings @include(if: $withBookingAddonsCalculationSettings) {\n        id\n        type\n        considerHotelNights\n      }\n      mandatorySettings @include(if: $withBookingAddonsMandatorySettings) {\n        id\n        isMandatory\n        useRules\n        rules @include(if: $withBookingAddonsMandatorySettingsRules) {\n          id\n          checkAccommodationTypes\n          checkAccommodationAddons\n          checkAgeGroups\n          useAgeFilter\n          checkDateRange\n          startDate\n          endDate\n          checkTravelDate\n        }\n      }\n    }\n    extensions @include(if: $withExtensions) {\n      id\n      label\n      info\n      travelExtension @include(if: $withExtensionsTravelExtension) {\n        id\n        duration\n        name\n        description\n        highlights @include(if: $withExtensionsTravelExtensionHighlights) {\n          id\n          text\n        }\n        image @include(if: $withExtensionsTravelExtensionImage) {\n          id\n          assetId\n          publicId\n          url\n          resourceType\n          format\n          width\n          height\n          caption\n          title\n          description\n        }\n      }\n      accommodationMapItems @include(if: $withExtensionsAccommodationMapItems) {\n        id\n        baseAccommodation @include(if: $withExtensionsAccommodationMapItemsBaseAccommodation) {\n          id\n          ratioPackageNo\n          name\n          label\n          info\n          isFamilyPackageAccommodation\n          isBabyPackage\n        }\n        extensionAccommodation @include(if: $withExtensionsAccommodationMapItemsExtensionAccommodation) {\n          id\n          ratioPackageNo\n          name\n          label\n          info\n          extensionAccommodationServiceNo\n        }\n      }\n    }\n    passportData @include(if: $withPassportData) {\n      id\n      type\n      number\n      birthPlace\n      issuePlace\n      issueDate\n      validUntil\n    }\n  }\n}";
// language=GraphQL
var SINGLE_TRAVELLER_QUERY = "query Query($id: ID!, $withAgeGroup: Boolean = false, $withAccommodation: Boolean = false, $withAccommodationCapacitySettings: Boolean = false, $withAccommodationCapacitySettingsAgeGroupCapacities: Boolean = false, $withAccommodationCapacitySettingsAgeGroupedTotalCapacities: Boolean = false, $withAccommodationCapacitySettingsPartialOccupancyAllowedAgeGroups: Boolean = false, $withAccommodationAddons: Boolean = false, $withAccommodationAddonsCalculationSettings: Boolean = false, $withAccommodationAddonsMandatorySettings: Boolean = false, $withFamilyPackage: Boolean = false, $withFamilyPackageAccommodation: Boolean = false, $withFamilyPackageAccommodationCapacitySettings: Boolean = false, $withFamilyPackageAccommodationAddons: Boolean = false, $withFamilyPackageCapacitySettings: Boolean = false, $withFamilyPackageCapacitySettingsAgeGroupCapacities: Boolean = false, $withFamilyPackageCapacitySettingsAgeGroupedTotalCapacities: Boolean = false, $withFamilyPackageCapacitySettingsPartialOccupancyAllowedAgeGroups: Boolean = false, $withFamilyPackageAddons: Boolean = false, $withFamilyPackageAddonsCalculationSettings: Boolean = false, $withFamilyPackageAddonsMandatorySettings: Boolean = false, $withAccommodationAddons: Boolean = false, $withAccommodationAddonsCalculationSettings: Boolean = false, $withAccommodationAddonsMandatorySettings: Boolean = false, $withAccommodationAddonsMandatorySettingsRules: Boolean = false, $withPersonalAddons: Boolean = false, $withPersonalAddonsAllowedAgeGroups: Boolean = false, $withPersonalAddonsCalculationSettings: Boolean = false, $withPersonalAddonsMandatorySettings: Boolean = false, $withPersonalAddonsMandatorySettingsRules: Boolean = false, $withBookingAddons: Boolean = false, $withBookingAddonsCalculationSettings: Boolean = false, $withBookingAddonsMandatorySettings: Boolean = false, $withBookingAddonsMandatorySettingsRules: Boolean = false, $withExtensions: Boolean = false, $withExtensionsTravelExtension: Boolean = false, $withExtensionsTravelExtensionHighlights: Boolean = false, $withExtensionsTravelExtensionImage: Boolean = false, $withExtensionsAccommodationMapItems: Boolean = false, $withExtensionsAccommodationMapItemsBaseAccommodation: Boolean = false, $withExtensionsAccommodationMapItemsExtensionAccommodation: Boolean = false, $withPassportData: Boolean = false) {\n  traveller: traveller(id: $id) {\n    id\n    salutation\n    firstName\n    lastName\n    birthday\n    nationality\n    email\n    phone\n    address\n    addressNumber\n    addressAddition\n    zip\n    city\n    country\n    ageGroup @include(if: $withAgeGroup) {\n      id\n      name\n      type\n      icon\n      minAge\n      maxAge\n    }\n    accommodation @include(if: $withAccommodation) {\n      id\n      ratioPackageNo\n      name\n      label\n      info\n      isFamilyPackageAccommodation\n      isBabyPackage\n      capacitySettings @include(if: $withAccommodationCapacitySettings) {\n        id\n        totalCapacity\n        rangesAllowed\n        ageGroupCapacities @include(if: $withAccommodationCapacitySettingsAgeGroupCapacities) {\n          id\n          minCapacity\n          maxCapacity\n        }\n        ageGroupedTotalCapacities @include(if: $withAccommodationCapacitySettingsAgeGroupedTotalCapacities) {\n          id\n          capacity\n        }\n        partialOccupancyAllowed\n        partialOccupancyAllowedAgeGroups @include(if: $withAccommodationCapacitySettingsPartialOccupancyAllowedAgeGroups) {\n          id\n          name\n          type\n          icon\n          minAge\n          maxAge\n        }\n      }\n      addons @include(if: $withAccommodationAddons) {\n        id\n        ratioServiceNo\n        name\n        label\n        info\n        calculationSettings @include(if: $withAccommodationAddonsCalculationSettings) {\n          id\n          type\n          considerHotelNights\n        }\n        mandatorySettings @include(if: $withAccommodationAddonsMandatorySettings) {\n          id\n          isMandatory\n          useRules\n        }\n      }\n    }\n    familyPackage @include(if: $withFamilyPackage) {\n      id\n      ratioServiceNo\n      accommodation @include(if: $withFamilyPackageAccommodation) {\n        id\n        ratioPackageNo\n        name\n        label\n        info\n        isFamilyPackageAccommodation\n        isBabyPackage\n        capacitySettings @include(if: $withFamilyPackageAccommodationCapacitySettings) {\n          id\n          totalCapacity\n          rangesAllowed\n          partialOccupancyAllowed\n        }\n        addons @include(if: $withFamilyPackageAccommodationAddons) {\n          id\n          ratioServiceNo\n          name\n          label\n          info\n        }\n      }\n      name\n      label\n      info\n      capacitySettings @include(if: $withFamilyPackageCapacitySettings) {\n        id\n        totalCapacity\n        rangesAllowed\n        ageGroupCapacities @include(if: $withFamilyPackageCapacitySettingsAgeGroupCapacities) {\n          id\n          minCapacity\n          maxCapacity\n        }\n        ageGroupedTotalCapacities @include(if: $withFamilyPackageCapacitySettingsAgeGroupedTotalCapacities) {\n          id\n          capacity\n        }\n        partialOccupancyAllowed\n        partialOccupancyAllowedAgeGroups @include(if: $withFamilyPackageCapacitySettingsPartialOccupancyAllowedAgeGroups) {\n          id\n          name\n          type\n          icon\n          minAge\n          maxAge\n        }\n      }\n      addons @include(if: $withFamilyPackageAddons) {\n        id\n        ratioServiceNo\n        name\n        label\n        info\n        calculationSettings @include(if: $withFamilyPackageAddonsCalculationSettings) {\n          id\n          type\n          considerHotelNights\n        }\n        mandatorySettings @include(if: $withFamilyPackageAddonsMandatorySettings) {\n          id\n          isMandatory\n          useRules\n        }\n      }\n    }\n    accommodationAddons @include(if: $withAccommodationAddons) {\n      id\n      ratioServiceNo\n      name\n      label\n      info\n      calculationSettings @include(if: $withAccommodationAddonsCalculationSettings) {\n        id\n        type\n        considerHotelNights\n      }\n      mandatorySettings @include(if: $withAccommodationAddonsMandatorySettings) {\n        id\n        isMandatory\n        useRules\n        rules @include(if: $withAccommodationAddonsMandatorySettingsRules) {\n          id\n          checkAccommodationTypes\n          checkAccommodationAddons\n          checkAgeGroups\n          useAgeFilter\n          checkDateRange\n          startDate\n          endDate\n          checkTravelDate\n        }\n      }\n    }\n    personalAddons @include(if: $withPersonalAddons) {\n      id\n      ratioServiceNo\n      name\n      label\n      info\n      allowedAgeGroups @include(if: $withPersonalAddonsAllowedAgeGroups) {\n        id\n        name\n        type\n        icon\n        minAge\n        maxAge\n      }\n      calculationSettings @include(if: $withPersonalAddonsCalculationSettings) {\n        id\n        type\n        considerHotelNights\n      }\n      mandatorySettings @include(if: $withPersonalAddonsMandatorySettings) {\n        id\n        isMandatory\n        useRules\n        rules @include(if: $withPersonalAddonsMandatorySettingsRules) {\n          id\n          checkAccommodationTypes\n          checkAccommodationAddons\n          checkAgeGroups\n          useAgeFilter\n          checkDateRange\n          startDate\n          endDate\n          checkTravelDate\n        }\n      }\n    }\n    bookingAddons @include(if: $withBookingAddons) {\n      id\n      ratioServiceNo\n      name\n      label\n      info\n      calculationSettings @include(if: $withBookingAddonsCalculationSettings) {\n        id\n        type\n        considerHotelNights\n      }\n      mandatorySettings @include(if: $withBookingAddonsMandatorySettings) {\n        id\n        isMandatory\n        useRules\n        rules @include(if: $withBookingAddonsMandatorySettingsRules) {\n          id\n          checkAccommodationTypes\n          checkAccommodationAddons\n          checkAgeGroups\n          useAgeFilter\n          checkDateRange\n          startDate\n          endDate\n          checkTravelDate\n        }\n      }\n    }\n    extensions @include(if: $withExtensions) {\n      id\n      label\n      info\n      travelExtension @include(if: $withExtensionsTravelExtension) {\n        id\n        duration\n        name\n        description\n        highlights @include(if: $withExtensionsTravelExtensionHighlights) {\n          id\n          text\n        }\n        image @include(if: $withExtensionsTravelExtensionImage) {\n          id\n          assetId\n          publicId\n          url\n          resourceType\n          format\n          width\n          height\n          caption\n          title\n          description\n        }\n      }\n      accommodationMapItems @include(if: $withExtensionsAccommodationMapItems) {\n        id\n        baseAccommodation @include(if: $withExtensionsAccommodationMapItemsBaseAccommodation) {\n          id\n          ratioPackageNo\n          name\n          label\n          info\n          isFamilyPackageAccommodation\n          isBabyPackage\n        }\n        extensionAccommodation @include(if: $withExtensionsAccommodationMapItemsExtensionAccommodation) {\n          id\n          ratioPackageNo\n          name\n          label\n          info\n          extensionAccommodationServiceNo\n        }\n      }\n    }\n    passportData @include(if: $withPassportData) {\n      id\n      type\n      number\n      birthPlace\n      issuePlace\n      issueDate\n      validUntil\n    }\n  }\n}";
// language=GraphQL
var CREATE_TRAVELLER_MUTATION = "\n  mutation Mutation($input: CreateTravellerInput, $withAgeGroup: Boolean = false, $withAccommodation: Boolean = false, $withAccommodationCapacitySettings: Boolean = false, $withAccommodationCapacitySettingsAgeGroupCapacities: Boolean = false, $withAccommodationCapacitySettingsAgeGroupedTotalCapacities: Boolean = false, $withAccommodationCapacitySettingsPartialOccupancyAllowedAgeGroups: Boolean = false, $withAccommodationAddons: Boolean = false, $withAccommodationAddonsCalculationSettings: Boolean = false, $withAccommodationAddonsMandatorySettings: Boolean = false, $withFamilyPackage: Boolean = false, $withFamilyPackageAccommodation: Boolean = false, $withFamilyPackageAccommodationCapacitySettings: Boolean = false, $withFamilyPackageAccommodationAddons: Boolean = false, $withFamilyPackageCapacitySettings: Boolean = false, $withFamilyPackageCapacitySettingsAgeGroupCapacities: Boolean = false, $withFamilyPackageCapacitySettingsAgeGroupedTotalCapacities: Boolean = false, $withFamilyPackageCapacitySettingsPartialOccupancyAllowedAgeGroups: Boolean = false, $withFamilyPackageAddons: Boolean = false, $withFamilyPackageAddonsCalculationSettings: Boolean = false, $withFamilyPackageAddonsMandatorySettings: Boolean = false, $withAccommodationAddons: Boolean = false, $withAccommodationAddonsCalculationSettings: Boolean = false, $withAccommodationAddonsMandatorySettings: Boolean = false, $withAccommodationAddonsMandatorySettingsRules: Boolean = false, $withPersonalAddons: Boolean = false, $withPersonalAddonsAllowedAgeGroups: Boolean = false, $withPersonalAddonsCalculationSettings: Boolean = false, $withPersonalAddonsMandatorySettings: Boolean = false, $withPersonalAddonsMandatorySettingsRules: Boolean = false, $withBookingAddons: Boolean = false, $withBookingAddonsCalculationSettings: Boolean = false, $withBookingAddonsMandatorySettings: Boolean = false, $withBookingAddonsMandatorySettingsRules: Boolean = false, $withExtensions: Boolean = false, $withExtensionsTravelExtension: Boolean = false, $withExtensionsTravelExtensionHighlights: Boolean = false, $withExtensionsTravelExtensionImage: Boolean = false, $withExtensionsAccommodationMapItems: Boolean = false, $withExtensionsAccommodationMapItemsBaseAccommodation: Boolean = false, $withExtensionsAccommodationMapItemsExtensionAccommodation: Boolean = false, $withPassportData: Boolean = false) {\n    traveller: createTraveller(input: $input) {\n      id\n      salutation\n      firstName\n      lastName\n      birthday\n      nationality\n      email\n      phone\n      address\n      addressNumber\n      addressAddition\n      zip\n      city\n      country\n      ageGroup @include(if: $withAgeGroup) {\n        id\n        name\n        type\n        icon\n        minAge\n        maxAge\n      }\n      accommodation @include(if: $withAccommodation) {\n        id\n        ratioPackageNo\n        name\n        label\n        info\n        isFamilyPackageAccommodation\n        isBabyPackage\n        capacitySettings @include(if: $withAccommodationCapacitySettings) {\n          id\n          totalCapacity\n          rangesAllowed\n          ageGroupCapacities @include(if: $withAccommodationCapacitySettingsAgeGroupCapacities) {\n            id\n            minCapacity\n            maxCapacity\n          }\n          ageGroupedTotalCapacities @include(if: $withAccommodationCapacitySettingsAgeGroupedTotalCapacities) {\n            id\n            capacity\n          }\n          partialOccupancyAllowed\n          partialOccupancyAllowedAgeGroups @include(if: $withAccommodationCapacitySettingsPartialOccupancyAllowedAgeGroups) {\n            id\n            name\n            type\n            icon\n            minAge\n            maxAge\n          }\n        }\n        addons @include(if: $withAccommodationAddons) {\n          id\n          ratioServiceNo\n          name\n          label\n          info\n          calculationSettings @include(if: $withAccommodationAddonsCalculationSettings) {\n            id\n            type\n            considerHotelNights\n          }\n          mandatorySettings @include(if: $withAccommodationAddonsMandatorySettings) {\n            id\n            isMandatory\n            useRules\n          }\n        }\n      }\n      familyPackage @include(if: $withFamilyPackage) {\n        id\n        ratioServiceNo\n        accommodation @include(if: $withFamilyPackageAccommodation) {\n          id\n          ratioPackageNo\n          name\n          label\n          info\n          isFamilyPackageAccommodation\n          isBabyPackage\n          capacitySettings @include(if: $withFamilyPackageAccommodationCapacitySettings) {\n            id\n            totalCapacity\n            rangesAllowed\n            partialOccupancyAllowed\n          }\n          addons @include(if: $withFamilyPackageAccommodationAddons) {\n            id\n            ratioServiceNo\n            name\n            label\n            info\n          }\n        }\n        name\n        label\n        info\n        capacitySettings @include(if: $withFamilyPackageCapacitySettings) {\n          id\n          totalCapacity\n          rangesAllowed\n          ageGroupCapacities @include(if: $withFamilyPackageCapacitySettingsAgeGroupCapacities) {\n            id\n            minCapacity\n            maxCapacity\n          }\n          ageGroupedTotalCapacities @include(if: $withFamilyPackageCapacitySettingsAgeGroupedTotalCapacities) {\n            id\n            capacity\n          }\n          partialOccupancyAllowed\n          partialOccupancyAllowedAgeGroups @include(if: $withFamilyPackageCapacitySettingsPartialOccupancyAllowedAgeGroups) {\n            id\n            name\n            type\n            icon\n            minAge\n            maxAge\n          }\n        }\n        addons @include(if: $withFamilyPackageAddons) {\n          id\n          ratioServiceNo\n          name\n          label\n          info\n          calculationSettings @include(if: $withFamilyPackageAddonsCalculationSettings) {\n            id\n            type\n            considerHotelNights\n          }\n          mandatorySettings @include(if: $withFamilyPackageAddonsMandatorySettings) {\n            id\n            isMandatory\n            useRules\n          }\n        }\n      }\n      accommodationAddons @include(if: $withAccommodationAddons) {\n        id\n        ratioServiceNo\n        name\n        label\n        info\n        calculationSettings @include(if: $withAccommodationAddonsCalculationSettings) {\n          id\n          type\n          considerHotelNights\n        }\n        mandatorySettings @include(if: $withAccommodationAddonsMandatorySettings) {\n          id\n          isMandatory\n          useRules\n          rules @include(if: $withAccommodationAddonsMandatorySettingsRules) {\n            id\n            checkAccommodationTypes\n            checkAccommodationAddons\n            checkAgeGroups\n            useAgeFilter\n            checkDateRange\n            startDate\n            endDate\n            checkTravelDate\n          }\n        }\n      }\n      personalAddons @include(if: $withPersonalAddons) {\n        id\n        ratioServiceNo\n        name\n        label\n        info\n        allowedAgeGroups @include(if: $withPersonalAddonsAllowedAgeGroups) {\n          id\n          name\n          type\n          icon\n          minAge\n          maxAge\n        }\n        calculationSettings @include(if: $withPersonalAddonsCalculationSettings) {\n          id\n          type\n          considerHotelNights\n        }\n        mandatorySettings @include(if: $withPersonalAddonsMandatorySettings) {\n          id\n          isMandatory\n          useRules\n          rules @include(if: $withPersonalAddonsMandatorySettingsRules) {\n            id\n            checkAccommodationTypes\n            checkAccommodationAddons\n            checkAgeGroups\n            useAgeFilter\n            checkDateRange\n            startDate\n            endDate\n            checkTravelDate\n          }\n        }\n      }\n      bookingAddons @include(if: $withBookingAddons) {\n        id\n        ratioServiceNo\n        name\n        label\n        info\n        calculationSettings @include(if: $withBookingAddonsCalculationSettings) {\n          id\n          type\n          considerHotelNights\n        }\n        mandatorySettings @include(if: $withBookingAddonsMandatorySettings) {\n          id\n          isMandatory\n          useRules\n          rules @include(if: $withBookingAddonsMandatorySettingsRules) {\n            id\n            checkAccommodationTypes\n            checkAccommodationAddons\n            checkAgeGroups\n            useAgeFilter\n            checkDateRange\n            startDate\n            endDate\n            checkTravelDate\n          }\n        }\n      }\n      extensions @include(if: $withExtensions) {\n        id\n        label\n        info\n        travelExtension @include(if: $withExtensionsTravelExtension) {\n          id\n          duration\n          name\n          description\n          highlights @include(if: $withExtensionsTravelExtensionHighlights) {\n            id\n            text\n          }\n          image @include(if: $withExtensionsTravelExtensionImage) {\n            id\n            assetId\n            publicId\n            url\n            resourceType\n            format\n            width\n            height\n            caption\n            title\n            description\n          }\n        }\n        accommodationMapItems @include(if: $withExtensionsAccommodationMapItems) {\n          id\n          baseAccommodation @include(if: $withExtensionsAccommodationMapItemsBaseAccommodation) {\n            id\n            ratioPackageNo\n            name\n            label\n            info\n            isFamilyPackageAccommodation\n            isBabyPackage\n          }\n          extensionAccommodation @include(if: $withExtensionsAccommodationMapItemsExtensionAccommodation) {\n            id\n            ratioPackageNo\n            name\n            label\n            info\n            extensionAccommodationServiceNo\n          }\n        }\n      }\n      passportData @include(if: $withPassportData) {\n        id\n        type\n        number\n        birthPlace\n        issuePlace\n        issueDate\n        validUntil\n      }\n    }\n  }";
// language=GraphQL
var UPDATE_TRAVELLER_MUTATION = "\n  mutation Mutation($input: UpdateTravellerInput, $withAgeGroup: Boolean = false, $withAccommodation: Boolean = false, $withAccommodationCapacitySettings: Boolean = false, $withAccommodationCapacitySettingsAgeGroupCapacities: Boolean = false, $withAccommodationCapacitySettingsAgeGroupedTotalCapacities: Boolean = false, $withAccommodationCapacitySettingsPartialOccupancyAllowedAgeGroups: Boolean = false, $withAccommodationAddons: Boolean = false, $withAccommodationAddonsCalculationSettings: Boolean = false, $withAccommodationAddonsMandatorySettings: Boolean = false, $withFamilyPackage: Boolean = false, $withFamilyPackageAccommodation: Boolean = false, $withFamilyPackageAccommodationCapacitySettings: Boolean = false, $withFamilyPackageAccommodationAddons: Boolean = false, $withFamilyPackageCapacitySettings: Boolean = false, $withFamilyPackageCapacitySettingsAgeGroupCapacities: Boolean = false, $withFamilyPackageCapacitySettingsAgeGroupedTotalCapacities: Boolean = false, $withFamilyPackageCapacitySettingsPartialOccupancyAllowedAgeGroups: Boolean = false, $withFamilyPackageAddons: Boolean = false, $withFamilyPackageAddonsCalculationSettings: Boolean = false, $withFamilyPackageAddonsMandatorySettings: Boolean = false, $withAccommodationAddons: Boolean = false, $withAccommodationAddonsCalculationSettings: Boolean = false, $withAccommodationAddonsMandatorySettings: Boolean = false, $withAccommodationAddonsMandatorySettingsRules: Boolean = false, $withPersonalAddons: Boolean = false, $withPersonalAddonsAllowedAgeGroups: Boolean = false, $withPersonalAddonsCalculationSettings: Boolean = false, $withPersonalAddonsMandatorySettings: Boolean = false, $withPersonalAddonsMandatorySettingsRules: Boolean = false, $withBookingAddons: Boolean = false, $withBookingAddonsCalculationSettings: Boolean = false, $withBookingAddonsMandatorySettings: Boolean = false, $withBookingAddonsMandatorySettingsRules: Boolean = false, $withExtensions: Boolean = false, $withExtensionsTravelExtension: Boolean = false, $withExtensionsTravelExtensionHighlights: Boolean = false, $withExtensionsTravelExtensionImage: Boolean = false, $withExtensionsAccommodationMapItems: Boolean = false, $withExtensionsAccommodationMapItemsBaseAccommodation: Boolean = false, $withExtensionsAccommodationMapItemsExtensionAccommodation: Boolean = false, $withPassportData: Boolean = false) {\n    traveller: updateTraveller(input: $input) {\n      id\n      salutation\n      firstName\n      lastName\n      birthday\n      nationality\n      email\n      phone\n      address\n      addressNumber\n      addressAddition\n      zip\n      city\n      country\n      ageGroup @include(if: $withAgeGroup) {\n        id\n        name\n        type\n        icon\n        minAge\n        maxAge\n      }\n      accommodation @include(if: $withAccommodation) {\n        id\n        ratioPackageNo\n        name\n        label\n        info\n        isFamilyPackageAccommodation\n        isBabyPackage\n        capacitySettings @include(if: $withAccommodationCapacitySettings) {\n          id\n          totalCapacity\n          rangesAllowed\n          ageGroupCapacities @include(if: $withAccommodationCapacitySettingsAgeGroupCapacities) {\n            id\n            minCapacity\n            maxCapacity\n          }\n          ageGroupedTotalCapacities @include(if: $withAccommodationCapacitySettingsAgeGroupedTotalCapacities) {\n            id\n            capacity\n          }\n          partialOccupancyAllowed\n          partialOccupancyAllowedAgeGroups @include(if: $withAccommodationCapacitySettingsPartialOccupancyAllowedAgeGroups) {\n            id\n            name\n            type\n            icon\n            minAge\n            maxAge\n          }\n        }\n        addons @include(if: $withAccommodationAddons) {\n          id\n          ratioServiceNo\n          name\n          label\n          info\n          calculationSettings @include(if: $withAccommodationAddonsCalculationSettings) {\n            id\n            type\n            considerHotelNights\n          }\n          mandatorySettings @include(if: $withAccommodationAddonsMandatorySettings) {\n            id\n            isMandatory\n            useRules\n          }\n        }\n      }\n      familyPackage @include(if: $withFamilyPackage) {\n        id\n        ratioServiceNo\n        accommodation @include(if: $withFamilyPackageAccommodation) {\n          id\n          ratioPackageNo\n          name\n          label\n          info\n          isFamilyPackageAccommodation\n          isBabyPackage\n          capacitySettings @include(if: $withFamilyPackageAccommodationCapacitySettings) {\n            id\n            totalCapacity\n            rangesAllowed\n            partialOccupancyAllowed\n          }\n          addons @include(if: $withFamilyPackageAccommodationAddons) {\n            id\n            ratioServiceNo\n            name\n            label\n            info\n          }\n        }\n        name\n        label\n        info\n        capacitySettings @include(if: $withFamilyPackageCapacitySettings) {\n          id\n          totalCapacity\n          rangesAllowed\n          ageGroupCapacities @include(if: $withFamilyPackageCapacitySettingsAgeGroupCapacities) {\n            id\n            minCapacity\n            maxCapacity\n          }\n          ageGroupedTotalCapacities @include(if: $withFamilyPackageCapacitySettingsAgeGroupedTotalCapacities) {\n            id\n            capacity\n          }\n          partialOccupancyAllowed\n          partialOccupancyAllowedAgeGroups @include(if: $withFamilyPackageCapacitySettingsPartialOccupancyAllowedAgeGroups) {\n            id\n            name\n            type\n            icon\n            minAge\n            maxAge\n          }\n        }\n        addons @include(if: $withFamilyPackageAddons) {\n          id\n          ratioServiceNo\n          name\n          label\n          info\n          calculationSettings @include(if: $withFamilyPackageAddonsCalculationSettings) {\n            id\n            type\n            considerHotelNights\n          }\n          mandatorySettings @include(if: $withFamilyPackageAddonsMandatorySettings) {\n            id\n            isMandatory\n            useRules\n          }\n        }\n      }\n      accommodationAddons @include(if: $withAccommodationAddons) {\n        id\n        ratioServiceNo\n        name\n        label\n        info\n        calculationSettings @include(if: $withAccommodationAddonsCalculationSettings) {\n          id\n          type\n          considerHotelNights\n        }\n        mandatorySettings @include(if: $withAccommodationAddonsMandatorySettings) {\n          id\n          isMandatory\n          useRules\n          rules @include(if: $withAccommodationAddonsMandatorySettingsRules) {\n            id\n            checkAccommodationTypes\n            checkAccommodationAddons\n            checkAgeGroups\n            useAgeFilter\n            checkDateRange\n            startDate\n            endDate\n            checkTravelDate\n          }\n        }\n      }\n      personalAddons @include(if: $withPersonalAddons) {\n        id\n        ratioServiceNo\n        name\n        label\n        info\n        allowedAgeGroups @include(if: $withPersonalAddonsAllowedAgeGroups) {\n          id\n          name\n          type\n          icon\n          minAge\n          maxAge\n        }\n        calculationSettings @include(if: $withPersonalAddonsCalculationSettings) {\n          id\n          type\n          considerHotelNights\n        }\n        mandatorySettings @include(if: $withPersonalAddonsMandatorySettings) {\n          id\n          isMandatory\n          useRules\n          rules @include(if: $withPersonalAddonsMandatorySettingsRules) {\n            id\n            checkAccommodationTypes\n            checkAccommodationAddons\n            checkAgeGroups\n            useAgeFilter\n            checkDateRange\n            startDate\n            endDate\n            checkTravelDate\n          }\n        }\n      }\n      bookingAddons @include(if: $withBookingAddons) {\n        id\n        ratioServiceNo\n        name\n        label\n        info\n        calculationSettings @include(if: $withBookingAddonsCalculationSettings) {\n          id\n          type\n          considerHotelNights\n        }\n        mandatorySettings @include(if: $withBookingAddonsMandatorySettings) {\n          id\n          isMandatory\n          useRules\n          rules @include(if: $withBookingAddonsMandatorySettingsRules) {\n            id\n            checkAccommodationTypes\n            checkAccommodationAddons\n            checkAgeGroups\n            useAgeFilter\n            checkDateRange\n            startDate\n            endDate\n            checkTravelDate\n          }\n        }\n      }\n      extensions @include(if: $withExtensions) {\n        id\n        label\n        info\n        travelExtension @include(if: $withExtensionsTravelExtension) {\n          id\n          duration\n          name\n          description\n          highlights @include(if: $withExtensionsTravelExtensionHighlights) {\n            id\n            text\n          }\n          image @include(if: $withExtensionsTravelExtensionImage) {\n            id\n            assetId\n            publicId\n            url\n            resourceType\n            format\n            width\n            height\n            caption\n            title\n            description\n          }\n        }\n        accommodationMapItems @include(if: $withExtensionsAccommodationMapItems) {\n          id\n          baseAccommodation @include(if: $withExtensionsAccommodationMapItemsBaseAccommodation) {\n            id\n            ratioPackageNo\n            name\n            label\n            info\n            isFamilyPackageAccommodation\n            isBabyPackage\n          }\n          extensionAccommodation @include(if: $withExtensionsAccommodationMapItemsExtensionAccommodation) {\n            id\n            ratioPackageNo\n            name\n            label\n            info\n            extensionAccommodationServiceNo\n          }\n        }\n      }\n      passportData @include(if: $withPassportData) {\n        id\n        type\n        number\n        birthPlace\n        issuePlace\n        issueDate\n        validUntil\n      }\n    }\n  }";
// language=GraphQL
var DELETE_TRAVELLER_MUTATION = "\n  mutation Mutation($input: DeleteTravellerInput) {\n    deleteTraveller(input: $input) {\n      success\n    }\n  }";
// language=GraphQL
var FORCE_DELETE_TRAVELLER_MUTATION = "\n  mutation Mutation($input: DeleteTravellerInput) {\n    forceDeleteTraveller(input: $input) {\n      success\n    }\n  }";
// language=GraphQL
var ADD_TRAVELLER_ACCOMMODATION_ADDONS_MUTATION = "\n  mutation Mutation($input: addTravellerAccommodationAddonsInput) {\n    addTravellerAccommodationAddons(input: $input) {\n      id\n      accommodationAddonIds\n    }\n  }";
// language=GraphQL
var REMOVE_TRAVELLER_ACCOMMODATION_ADDONS_MUTATION = "\n  mutation Mutation($input: removeTravellerAccommodationAddonsInput) {\n    removeTravellerAccommodationAddons(input: $input) {\n      id\n      accommodationAddonIds\n    }\n  }";
// language=GraphQL
var CREATE_TRAVELLER_ACCOMMODATION_ADDONS_MUTATION = "\n  mutation Mutation($input: createTravellerAccommodationAddonsInput) {\n    createTravellerAccommodationAddons(input: $input) {\n      id\n      accommodationAddonIds\n    }\n  }";
// language=GraphQL
var DELETE_TRAVELLER_ACCOMMODATION_ADDONS_MUTATION = "\n  mutation Mutation($input: deleteTravellerAccommodationAddonsInput) {\n    deleteTravellerAccommodationAddons(input: $input) {\n      id\n      accommodationAddonIds\n    }\n  }";
// language=GraphQL
var UPDATE_TRAVELLER_ACCOMMODATION_ADDONS_ORDER_MUTATION = "\n  mutation Mutation($input: updateTravellerAccommodationAddonsOrderInput) {\n    updateTravellerAccommodationAddonsOrder(input: $input) {\n      id\n      accommodationAddonIds\n    }\n  }";
// language=GraphQL
var ADD_TRAVELLER_PERSONAL_ADDONS_MUTATION = "\n  mutation Mutation($input: addTravellerPersonalAddonsInput) {\n    addTravellerPersonalAddons(input: $input) {\n      id\n      personalAddonIds\n    }\n  }";
// language=GraphQL
var REMOVE_TRAVELLER_PERSONAL_ADDONS_MUTATION = "\n  mutation Mutation($input: removeTravellerPersonalAddonsInput) {\n    removeTravellerPersonalAddons(input: $input) {\n      id\n      personalAddonIds\n    }\n  }";
// language=GraphQL
var CREATE_TRAVELLER_PERSONAL_ADDONS_MUTATION = "\n  mutation Mutation($input: createTravellerPersonalAddonsInput) {\n    createTravellerPersonalAddons(input: $input) {\n      id\n      personalAddonIds\n    }\n  }";
// language=GraphQL
var DELETE_TRAVELLER_PERSONAL_ADDONS_MUTATION = "\n  mutation Mutation($input: deleteTravellerPersonalAddonsInput) {\n    deleteTravellerPersonalAddons(input: $input) {\n      id\n      personalAddonIds\n    }\n  }";
// language=GraphQL
var UPDATE_TRAVELLER_PERSONAL_ADDONS_ORDER_MUTATION = "\n  mutation Mutation($input: updateTravellerPersonalAddonsOrderInput) {\n    updateTravellerPersonalAddonsOrder(input: $input) {\n      id\n      personalAddonIds\n    }\n  }";
// language=GraphQL
var ADD_TRAVELLER_BOOKING_ADDONS_MUTATION = "\n  mutation Mutation($input: addTravellerBookingAddonsInput) {\n    addTravellerBookingAddons(input: $input) {\n      id\n      bookingAddonIds\n    }\n  }";
// language=GraphQL
var REMOVE_TRAVELLER_BOOKING_ADDONS_MUTATION = "\n  mutation Mutation($input: removeTravellerBookingAddonsInput) {\n    removeTravellerBookingAddons(input: $input) {\n      id\n      bookingAddonIds\n    }\n  }";
// language=GraphQL
var CREATE_TRAVELLER_BOOKING_ADDONS_MUTATION = "\n  mutation Mutation($input: createTravellerBookingAddonsInput) {\n    createTravellerBookingAddons(input: $input) {\n      id\n      bookingAddonIds\n    }\n  }";
// language=GraphQL
var DELETE_TRAVELLER_BOOKING_ADDONS_MUTATION = "\n  mutation Mutation($input: deleteTravellerBookingAddonsInput) {\n    deleteTravellerBookingAddons(input: $input) {\n      id\n      bookingAddonIds\n    }\n  }";
// language=GraphQL
var UPDATE_TRAVELLER_BOOKING_ADDONS_ORDER_MUTATION = "\n  mutation Mutation($input: updateTravellerBookingAddonsOrderInput) {\n    updateTravellerBookingAddonsOrder(input: $input) {\n      id\n      bookingAddonIds\n    }\n  }";
// language=GraphQL
var ADD_TRAVELLER_EXTENSIONS_MUTATION = "\n  mutation Mutation($input: addTravellerExtensionsInput) {\n    addTravellerExtensions(input: $input) {\n      id\n      extensionIds\n    }\n  }";
// language=GraphQL
var REMOVE_TRAVELLER_EXTENSIONS_MUTATION = "\n  mutation Mutation($input: removeTravellerExtensionsInput) {\n    removeTravellerExtensions(input: $input) {\n      id\n      extensionIds\n    }\n  }";
// language=GraphQL
var CREATE_TRAVELLER_EXTENSIONS_MUTATION = "\n  mutation Mutation($input: createTravellerExtensionsInput) {\n    createTravellerExtensions(input: $input) {\n      id\n      extensionIds\n    }\n  }";
// language=GraphQL
var DELETE_TRAVELLER_EXTENSIONS_MUTATION = "\n  mutation Mutation($input: deleteTravellerExtensionsInput) {\n    deleteTravellerExtensions(input: $input) {\n      id\n      extensionIds\n    }\n  }";
// language=GraphQL
var UPDATE_TRAVELLER_EXTENSIONS_ORDER_MUTATION = "\n  mutation Mutation($input: updateTravellerExtensionsOrderInput) {\n    updateTravellerExtensionsOrder(input: $input) {\n      id\n      extensionIds\n    }\n  }";
// language=GraphQL
var TRAVELLERS_DEPENDENTS_QUERY = "query Query($id: ID!, $withBookings: Boolean = false) {\n  groupedDependents: travellerDependents(id: $id) {\n    bookings @include(if: $withBookings) {\n      id\n      referenceNo\n      travellerRemarks\n      travellerDataCorrectnessConfirmation\n      localState\n      backofficePayload\n      backofficeResponse\n      transmissionStatus\n      webhookStatus\n      webhookResponse\n      webhookDuration\n      confirmationEmailSent\n      isPassportDataRequired\n      passportDataReminderEmailSent\n      passportDataReceived    }\n  }\n}";

// EXTERNAL MODULE: ./src/entities/travelPricingAgeGroup/entity.ts + 3 modules
var entity = __webpack_require__(65966);
// EXTERNAL MODULE: ./src/entities/ratioAccommodation/entity.ts + 3 modules
var ratioAccommodation_entity = __webpack_require__(53656);
// EXTERNAL MODULE: ./src/entities/ratioFamilyPackage/entity.ts + 3 modules
var ratioFamilyPackage_entity = __webpack_require__(79028);
// EXTERNAL MODULE: ./src/entities/ratioAccommodationAddon/entity.ts + 3 modules
var ratioAccommodationAddon_entity = __webpack_require__(88646);
// EXTERNAL MODULE: ./src/entities/ratioPersonalAddon/entity.ts + 3 modules
var ratioPersonalAddon_entity = __webpack_require__(34722);
// EXTERNAL MODULE: ./src/entities/ratioBookingAddon/entity.ts + 3 modules
var ratioBookingAddon_entity = __webpack_require__(30250);
// EXTERNAL MODULE: ./src/entities/ratioTravelExtension/entity.ts + 3 modules
var ratioTravelExtension_entity = __webpack_require__(6607);
// EXTERNAL MODULE: ./src/entities/passportData/entity.ts + 3 modules
var passportData_entity = __webpack_require__(41953);
;// CONCATENATED MODULE: ./src/entities/traveller/model.ts









var travellerModel = {
    name: "traveller",
    namePlural: "travellers",
    uniqueName: "traveller",
    uniqueNamePlural: "travellers",
    path: "travel/booking/traveller",
    baseUrl: "/travel/booking/travellers",
    translationPrefix: "entities:traveller.",
    getDisplayName: function(values) {
        return "".concat(values.firstName, " ").concat(values.lastName);
    },
    gql: {
        getAll: ALL_TRAVELLERS_QUERY,
        getSingle: SINGLE_TRAVELLER_QUERY,
        create: CREATE_TRAVELLER_MUTATION,
        update: UPDATE_TRAVELLER_MUTATION,
        delete: DELETE_TRAVELLER_MUTATION,
        forceDelete: FORCE_DELETE_TRAVELLER_MUTATION
    },
    attributes: {
        salutation: {
            name: "salutation",
            label: "entities:traveller.attributes.salutation.label",
            type: "value",
            dataType: "string",
            defaultInput: true,
            inputType: "select",
            selectOptions: [
                {
                    label: "entities:traveller.attributes.salutation.selectOptions.MR.label",
                    value: "MR"
                },
                {
                    label: "entities:traveller.attributes.salutation.selectOptions.MRS.label",
                    value: "MRS"
                }, 
            ],
            validationType: "string",
            validations: []
        },
        firstName: {
            name: "firstName",
            label: "entities:traveller.attributes.firstName.label",
            type: "value",
            dataType: "string",
            defaultInput: true,
            inputType: "text",
            validationType: "string",
            validations: [
                {
                    type: "required"
                }, 
            ]
        },
        lastName: {
            name: "lastName",
            label: "entities:traveller.attributes.lastName.label",
            type: "value",
            dataType: "string",
            defaultInput: true,
            inputType: "text",
            validationType: "string",
            validations: [
                {
                    type: "required"
                }, 
            ]
        },
        birthday: {
            name: "birthday",
            label: "entities:traveller.attributes.birthday.label",
            type: "value",
            dataType: "Date",
            defaultInput: true,
            inputType: "date",
            validationType: "string",
            validations: [
                {
                    type: "required"
                }, 
            ]
        },
        nationality: {
            name: "nationality",
            label: "entities:traveller.attributes.nationality.label",
            type: "value",
            dataType: "string",
            defaultInput: true,
            inputType: "text",
            validationType: "string",
            validations: []
        },
        email: {
            name: "email",
            label: "entities:traveller.attributes.email.label",
            type: "value",
            dataType: "string",
            defaultInput: true,
            inputType: "text",
            validationType: "string",
            validations: [
                {
                    type: "email"
                }, 
            ]
        },
        phone: {
            name: "phone",
            label: "entities:traveller.attributes.phone.label",
            type: "value",
            dataType: "string",
            defaultInput: true,
            inputType: "text",
            maxLength: 25,
            validationType: "string",
            validations: []
        },
        address: {
            name: "address",
            label: "entities:traveller.attributes.address.label",
            type: "value",
            dataType: "string",
            defaultInput: true,
            inputType: "text",
            validationType: "string",
            validations: []
        },
        addressNumber: {
            name: "addressNumber",
            label: "entities:traveller.attributes.addressNumber.label",
            type: "value",
            dataType: "string",
            defaultInput: true,
            inputType: "text",
            validationType: "string",
            validations: []
        },
        addressAddition: {
            name: "addressAddition",
            label: "entities:traveller.attributes.addressAddition.label",
            type: "value",
            dataType: "string",
            defaultInput: true,
            inputType: "text",
            validationType: "string",
            validations: []
        },
        zip: {
            name: "zip",
            label: "entities:traveller.attributes.zip.label",
            type: "value",
            dataType: "string",
            defaultInput: true,
            inputType: "text",
            validationType: "string",
            validations: []
        },
        city: {
            name: "city",
            label: "entities:traveller.attributes.city.label",
            type: "value",
            dataType: "string",
            defaultInput: true,
            inputType: "text",
            validationType: "string",
            validations: []
        },
        country: {
            name: "country",
            label: "entities:traveller.attributes.country.label",
            type: "value",
            dataType: "string",
            defaultInput: true,
            inputType: "text",
            validationType: "string",
            validations: []
        },
        ageGroup: {
            name: "ageGroup",
            label: "entities:traveller.attributes.ageGroup.label",
            type: "entityObject",
            dataType: "any",
            getEntity: function() {
                return entity/* default */.Z;
            },
            defaultInput: false,
            inputType: "select",
            validationType: "string",
            validations: [
                {
                    type: "required"
                }, 
            ]
        },
        accommodation: {
            name: "accommodation",
            label: "entities:traveller.attributes.accommodation.label",
            type: "entityObject",
            dataType: "any",
            getEntity: function() {
                return ratioAccommodation_entity/* default */.Z;
            },
            defaultInput: false,
            inputType: "select",
            validationType: "string",
            validations: [
                {
                    type: "required"
                }, 
            ]
        },
        familyPackage: {
            name: "familyPackage",
            label: "entities:traveller.attributes.familyPackage.label",
            type: "entityObject",
            dataType: "any",
            getEntity: function() {
                return ratioFamilyPackage_entity/* default */.Z;
            },
            defaultInput: false,
            inputType: "select",
            validationType: "string",
            validations: []
        },
        accommodationAddons: {
            name: "accommodationAddons",
            label: "entities:traveller.attributes.accommodationAddons.label",
            type: "entityCollection",
            dataType: "[any]",
            getEntity: function() {
                return ratioAccommodationAddon_entity/* default */.Z;
            },
            defaultInput: false,
            inputType: "text",
            validationType: "string",
            validations: []
        },
        personalAddons: {
            name: "personalAddons",
            label: "entities:traveller.attributes.personalAddons.label",
            type: "entityCollection",
            dataType: "[any]",
            getEntity: function() {
                return ratioPersonalAddon_entity/* default */.Z;
            },
            defaultInput: false,
            inputType: "text",
            validationType: "string",
            validations: []
        },
        bookingAddons: {
            name: "bookingAddons",
            label: "entities:traveller.attributes.bookingAddons.label",
            type: "entityCollection",
            dataType: "[any]",
            getEntity: function() {
                return ratioBookingAddon_entity/* default */.Z;
            },
            defaultInput: false,
            inputType: "text",
            validationType: "string",
            validations: []
        },
        extensions: {
            name: "extensions",
            label: "entities:traveller.attributes.extensions.label",
            type: "entityCollection",
            dataType: "[any]",
            getEntity: function() {
                return ratioTravelExtension_entity/* default */.Z;
            },
            defaultInput: false,
            inputType: "text",
            validationType: "string",
            validations: []
        },
        passportData: {
            name: "passportData",
            label: "entities:traveller.attributes.passportData.label",
            type: "entityObject",
            dataType: "any",
            getEntity: function() {
                return passportData_entity/* default */.Z;
            },
            defaultInput: true,
            inputType: "select",
            validationType: "string",
            validations: []
        }
    }
};
/* harmony default export */ var model = (travellerModel);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(20414);
// EXTERNAL MODULE: ./src/entities/lib.ts
var lib = __webpack_require__(23480);
// EXTERNAL MODULE: ./src/lib/api/graphQLClient.ts
var graphQLClient = __webpack_require__(40112);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/swr/dist/index.mjs
var dist = __webpack_require__(8100);
// EXTERNAL MODULE: ./src/lib/helpers/helpers.ts
var helpers = __webpack_require__(15778);
;// CONCATENATED MODULE: ./src/entities/traveller/repository.ts










var hydrateObjects = function(objects) {
    return objects.map(function(object) {
        return (0,lib/* hydrateEntityObject */.b)(model, object);
    });
};
var hydrateObject = function(object) {
    return (0,lib/* hydrateEntityObject */.b)(model, object);
};
var travellerRepository = {
    getObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    id: id
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(SINGLE_TRAVELLER_QUERY, variables).then(function(data) {
                        return hydrateObject(data.traveller);
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }(),
    getObjects: /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        var includes;
        var _arguments = arguments;
        return (0,tslib_es6.__generator)(this, function(_state) {
            includes = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : {};
            return [
                2,
                graphQLClient/* default.request */.Z.request(ALL_TRAVELLERS_QUERY, includes).then(function(data) {
                    return hydrateObjects(data.travellers);
                })
            ];
        });
    }),
    useObject: function(id) {
        var includes = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        // eslint-disable-next-line react-hooks/exhaustive-deps
        var variables = (0,react.useMemo)(function() {
            return (0,_object_spread/* default */.Z)({
                id: id
            }, includes);
        }, [
            id
        ]);
        var ref = (0,dist/* default */.ZP)([
            SINGLE_TRAVELLER_QUERY,
            variables
        ], {
            revalidateOnFocus: false
        }), data = ref.data, error = ref.error, mutate = ref.mutate;
        return {
            object: !data ? data : hydrateObject(data.traveller),
            isLoading: !error && !data,
            isError: error,
            mutate: mutate
        };
    },
    useObjects: function() {
        var includes = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        // eslint-disable-next-line react-hooks/exhaustive-deps
        var variables = (0,react.useMemo)(function() {
            return includes;
        }, []);
        var ref = (0,dist/* default */.ZP)([
            ALL_TRAVELLERS_QUERY,
            variables
        ]), data = ref.data, error = ref.error, mutate = ref.mutate;
        return {
            objects: !data ? data : hydrateObjects(data.travellers),
            isLoading: !error && !data,
            isError: error,
            mutate: mutate
        };
    },
    getDependents: function(id, includes) {
        var includeVars = {};
        includes.forEach(function(include) {
            includeVars["with".concat((0,helpers/* uppercaseFirst */.AB)(include))] = true;
        });
        var variables = (0,_object_spread/* default */.Z)({
            id: id
        }, includeVars);
        return graphQLClient/* default.request */.Z.request(TRAVELLERS_DEPENDENTS_QUERY, variables).then(function(data) {
            return data.groupedDependents;
        });
    },
    useDependents: function(id, includes) {
        var includeVars = {};
        includes.forEach(function(include) {
            includeVars["with".concat((0,helpers/* uppercaseFirst */.AB)(include))] = true;
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
        var variables = (0,react.useMemo)(function() {
            return (0,_object_spread/* default */.Z)({
                id: id
            }, includeVars);
        }, [
            id
        ]);
        var ref = (0,dist/* default */.ZP)([
            TRAVELLERS_DEPENDENTS_QUERY,
            variables
        ], {
            revalidateOnFocus: false
        }), data = ref.data, error = ref.error, mutate = ref.mutate;
        return {
            data: !data ? data : data.groupedDependents,
            isLoading: !error && !data,
            isError: error,
            mutate: mutate
        };
    },
    createObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(data) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    input: data
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(CREATE_TRAVELLER_MUTATION, variables).then(function(data) {
                        return hydrateObject(data.traveller);
                    })
                ];
            });
        });
        return function(data) {
            return _ref.apply(this, arguments);
        };
    }(),
    updateObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(data) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    input: data
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(UPDATE_TRAVELLER_MUTATION, variables).then(function(data) {
                        return hydrateObject(data.traveller);
                    })
                ];
            });
        });
        return function(data) {
            return _ref.apply(this, arguments);
        };
    }(),
    deleteObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(DELETE_TRAVELLER_MUTATION, variables).then(function(data) {
                        return data.deleteTraveller;
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }(),
    forceDeleteObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(FORCE_DELETE_TRAVELLER_MUTATION, variables).then(function(data) {
                        return data.forceDeleteTraveller;
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }(),
    assignAccommodationAddons: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, itemIds) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        accommodationAddonIds: itemIds
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(ADD_TRAVELLER_ACCOMMODATION_ADDONS_MUTATION, variables)
                ];
            });
        });
        return function(id, itemIds) {
            return _ref.apply(this, arguments);
        };
    }(),
    unassignAccommodationAddons: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, itemIds) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        accommodationAddonIds: itemIds
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(REMOVE_TRAVELLER_ACCOMMODATION_ADDONS_MUTATION, variables)
                ];
            });
        });
        return function(id, itemIds) {
            return _ref.apply(this, arguments);
        };
    }(),
    createAccommodationAddons: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, items) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        accommodationAddons: items
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(CREATE_TRAVELLER_ACCOMMODATION_ADDONS_MUTATION, variables)
                ];
            });
        });
        return function(id, items) {
            return _ref.apply(this, arguments);
        };
    }(),
    deleteAccommodationAddons: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, itemIds) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        accommodationAddonIds: itemIds
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(DELETE_TRAVELLER_ACCOMMODATION_ADDONS_MUTATION, variables)
                ];
            });
        });
        return function(id, itemIds) {
            return _ref.apply(this, arguments);
        };
    }(),
    updateAccommodationAddonsOrder: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, itemIds) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        accommodationAddonIds: itemIds
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(UPDATE_TRAVELLER_ACCOMMODATION_ADDONS_ORDER_MUTATION, variables)
                ];
            });
        });
        return function(id, itemIds) {
            return _ref.apply(this, arguments);
        };
    }(),
    assignPersonalAddons: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, itemIds) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        personalAddonIds: itemIds
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(ADD_TRAVELLER_PERSONAL_ADDONS_MUTATION, variables)
                ];
            });
        });
        return function(id, itemIds) {
            return _ref.apply(this, arguments);
        };
    }(),
    unassignPersonalAddons: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, itemIds) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        personalAddonIds: itemIds
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(REMOVE_TRAVELLER_PERSONAL_ADDONS_MUTATION, variables)
                ];
            });
        });
        return function(id, itemIds) {
            return _ref.apply(this, arguments);
        };
    }(),
    createPersonalAddons: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, items) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        personalAddons: items
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(CREATE_TRAVELLER_PERSONAL_ADDONS_MUTATION, variables)
                ];
            });
        });
        return function(id, items) {
            return _ref.apply(this, arguments);
        };
    }(),
    deletePersonalAddons: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, itemIds) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        personalAddonIds: itemIds
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(DELETE_TRAVELLER_PERSONAL_ADDONS_MUTATION, variables)
                ];
            });
        });
        return function(id, itemIds) {
            return _ref.apply(this, arguments);
        };
    }(),
    updatePersonalAddonsOrder: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, itemIds) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        personalAddonIds: itemIds
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(UPDATE_TRAVELLER_PERSONAL_ADDONS_ORDER_MUTATION, variables)
                ];
            });
        });
        return function(id, itemIds) {
            return _ref.apply(this, arguments);
        };
    }(),
    assignBookingAddons: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, itemIds) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        bookingAddonIds: itemIds
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(ADD_TRAVELLER_BOOKING_ADDONS_MUTATION, variables)
                ];
            });
        });
        return function(id, itemIds) {
            return _ref.apply(this, arguments);
        };
    }(),
    unassignBookingAddons: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, itemIds) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        bookingAddonIds: itemIds
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(REMOVE_TRAVELLER_BOOKING_ADDONS_MUTATION, variables)
                ];
            });
        });
        return function(id, itemIds) {
            return _ref.apply(this, arguments);
        };
    }(),
    createBookingAddons: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, items) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        bookingAddons: items
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(CREATE_TRAVELLER_BOOKING_ADDONS_MUTATION, variables)
                ];
            });
        });
        return function(id, items) {
            return _ref.apply(this, arguments);
        };
    }(),
    deleteBookingAddons: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, itemIds) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        bookingAddonIds: itemIds
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(DELETE_TRAVELLER_BOOKING_ADDONS_MUTATION, variables)
                ];
            });
        });
        return function(id, itemIds) {
            return _ref.apply(this, arguments);
        };
    }(),
    updateBookingAddonsOrder: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, itemIds) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        bookingAddonIds: itemIds
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(UPDATE_TRAVELLER_BOOKING_ADDONS_ORDER_MUTATION, variables)
                ];
            });
        });
        return function(id, itemIds) {
            return _ref.apply(this, arguments);
        };
    }(),
    assignExtensions: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, itemIds) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        extensionIds: itemIds
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(ADD_TRAVELLER_EXTENSIONS_MUTATION, variables)
                ];
            });
        });
        return function(id, itemIds) {
            return _ref.apply(this, arguments);
        };
    }(),
    unassignExtensions: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, itemIds) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        extensionIds: itemIds
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(REMOVE_TRAVELLER_EXTENSIONS_MUTATION, variables)
                ];
            });
        });
        return function(id, itemIds) {
            return _ref.apply(this, arguments);
        };
    }(),
    createExtensions: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, items) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        extensions: items
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(CREATE_TRAVELLER_EXTENSIONS_MUTATION, variables)
                ];
            });
        });
        return function(id, items) {
            return _ref.apply(this, arguments);
        };
    }(),
    deleteExtensions: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, itemIds) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        extensionIds: itemIds
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(DELETE_TRAVELLER_EXTENSIONS_MUTATION, variables)
                ];
            });
        });
        return function(id, itemIds) {
            return _ref.apply(this, arguments);
        };
    }(),
    updateExtensionsOrder: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, itemIds) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        extensionIds: itemIds
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(UPDATE_TRAVELLER_EXTENSIONS_ORDER_MUTATION, variables)
                ];
            });
        });
        return function(id, itemIds) {
            return _ref.apply(this, arguments);
        };
    }()
};
/* harmony default export */ var repository = (travellerRepository);

;// CONCATENATED MODULE: ./src/entities/traveller/entity.ts


var travellerEntity = {
    model: model,
    repository: repository
};
/* harmony default export */ var traveller_entity = (travellerEntity);


/***/ })

}]);